/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 39);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function() {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		var result = [];
		for(var i = 0; i < this.length; i++) {
			var item = this[i];
			if(item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};


/***/ }),
/* 1 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(86)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction) {
  isProduction = _isProduction

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[data-vue-ssr-id~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!function(t,e){ true?!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return e()}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof module?module.exports=e():t.Tone=e()}(this,function(){"use strict";function t(t){t(e)}var e;/**
	 *  Tone.js
	 *  @author Yotam Mann
	 *  @license http://opensource.org/licenses/MIT MIT License
	 *  @copyright 2014-2018 Yotam Mann
	 */
return function(t){e=t()}(function(){var t,e=function(){if(!(this instanceof e))throw new Error("constructor needs to be called with the 'new' keyword")};return e.prototype.toString=function(){var t,i,n;for(t in e)if(i=t[0].match(/^[A-Z]$/),n=e[t]===this.constructor,e.isFunction(e[t])&&i&&n)return t;return"Tone"},e.prototype.dispose=function(){return this},e.prototype.set=function(t,i,n){var s,o,r,a,h,l,u;e.isObject(t)?n=i:e.isString(t)&&(s={},s[t]=i,t=s);t:for(o in t){if(i=t[o],r=this,-1!==o.indexOf(".")){for(a=o.split("."),h=0;h<a.length-1;h++)if((r=r[a[h]])instanceof e){a.splice(0,h+1),l=a.join("."),r.set(l,i);continue t}o=a[a.length-1]}u=r[o],e.isUndef(u)||(e.Signal&&u instanceof e.Signal||e.Param&&u instanceof e.Param?u.value!==i&&(e.isUndef(n)?u.value=i:u.rampTo(i,n)):u instanceof AudioParam?u.value!==i&&(u.value=i):e.TimeBase&&u instanceof e.TimeBase?r[o]=i:u instanceof e?u.set(i):u!==i&&(r[o]=i))}return this},e.prototype.get=function(t){var i,n,s,o,r,a,h,l,u;for(e.isUndef(t)?t=this._collectDefaults(this.constructor):e.isString(t)&&(t=[t]),i={},n=0;n<t.length;n++){if(s=t[n],o=this,r=i,-1!==s.indexOf(".")){for(a=s.split("."),h=0;h<a.length-1;h++)l=a[h],r[l]=r[l]||{},r=r[l],o=o[l];s=a[a.length-1]}u=o[s],e.isObject(t[s])?r[s]=u.get():e.Signal&&u instanceof e.Signal?r[s]=u.value:e.Param&&u instanceof e.Param?r[s]=u.value:u instanceof AudioParam?r[s]=u.value:u instanceof e?r[s]=u.get():!e.isFunction(u)&&e.isDefined(u)&&(r[s]=u)}return i},e.prototype._collectDefaults=function(t){var i,n,s=[];if(e.isDefined(t.defaults)&&(s=Object.keys(t.defaults)),e.isDefined(t._super))for(i=this._collectDefaults(t._super),n=0;n<i.length;n++)-1===s.indexOf(i[n])&&s.push(i[n]);return s},e.defaults=function(t,i,n){var s,o={};if(1===t.length&&e.isObject(t[0]))o=t[0];else for(s=0;s<i.length;s++)o[i[s]]=t[s];return e.isDefined(n.defaults)?e.defaultArg(o,n.defaults):e.isObject(n)?e.defaultArg(o,n):o},e.defaultArg=function(t,i){var n,s,o;if(e.isObject(t)&&e.isObject(i)){n={};for(s in t)n[s]=e.defaultArg(i[s],t[s]);for(o in i)n[o]=e.defaultArg(t[o],i[o]);return n}return e.isUndef(t)?i:t},e.connectSeries=function(){var t,i,n=arguments[0];for(t=1;t<arguments.length;t++)i=arguments[t],n.connect(i),n=i;return e},e.isUndef=function(t){return void 0===t},e.isDefined=function(t){return!e.isUndef(t)},e.isFunction=function(t){return"function"==typeof t},e.isNumber=function(t){return"number"==typeof t},e.isObject=function(t){return"[object Object]"===Object.prototype.toString.call(t)&&t.constructor===Object},e.isBoolean=function(t){return"boolean"==typeof t},e.isArray=function(t){return Array.isArray(t)},e.isString=function(t){return"string"==typeof t},e.isNote=function(t){return e.isString(t)&&/^([a-g]{1}(?:b|#|x|bb)?)(-?[0-9]+)/i.test(t)},e.noOp=function(){},e.prototype._readOnly=function(t){if(Array.isArray(t))for(var e=0;e<t.length;e++)this._readOnly(t[e]);else Object.defineProperty(this,t,{writable:!1,enumerable:!0})},e.prototype._writable=function(t){if(Array.isArray(t))for(var e=0;e<t.length;e++)this._writable(t[e]);else Object.defineProperty(this,t,{writable:!0})},e.State={Started:"started",Stopped:"stopped",Paused:"paused"},e.equalPowerScale=function(t){var e=.5*Math.PI;return Math.sin(t*e)},e.dbToGain=function(t){return Math.pow(10,t/20)},e.gainToDb=function(t){return Math.log(t)/Math.LN10*20},e.intervalToFrequencyRatio=function(t){return Math.pow(2,t/12)},e.prototype.now=function(){return e.context.now()},e.now=function(){return e.context.now()},e.extend=function(t,i){function n(){}e.isUndef(i)&&(i=e),n.prototype=i.prototype,t.prototype=new n,t.prototype.constructor=t,t._super=i},t=null,Object.defineProperty(e,"context",{get:function(){return t},set:function(i){t=e.Context&&i instanceof e.Context?i:new e.Context(i),e.Context.emit("init",t)}}),Object.defineProperty(e.prototype,"context",{get:function(){return e.context}}),e.setContext=function(t){e.context=t},Object.defineProperty(e.prototype,"blockTime",{get:function(){return 128/this.context.sampleRate}}),Object.defineProperty(e.prototype,"sampleTime",{get:function(){return 1/this.context.sampleRate}}),Object.defineProperty(e,"supported",{get:function(){var t=window.hasOwnProperty("AudioContext")||window.hasOwnProperty("webkitAudioContext"),e=window.hasOwnProperty("Promise"),i=window.hasOwnProperty("Worker");return t&&e&&i}}),Object.defineProperty(e,"initialized",{get:function(){return null!==t}}),e.getContext=function(t){if(e.initialized)t(e.context);else{var i=function(){t(e.context),e.Context.off("init",i)};e.Context.on("init",i)}return e},e.version="r12",e}),t(function(t){return t.Emitter=function(){t.call(this),this._events={}},t.extend(t.Emitter),t.Emitter.prototype.on=function(t,e){var i,n,s=t.split(/\W+/);for(i=0;i<s.length;i++)n=s[i],this._events.hasOwnProperty(n)||(this._events[n]=[]),this._events[n].push(e);return this},t.Emitter.prototype.once=function(t,e){var i=function(){e.apply(this,arguments),this.off(t,i)}.bind(this);return this.on(t,i),this},t.Emitter.prototype.off=function(e,i){var n,s,o,r=e.split(/\W+/);for(n=0;n<r.length;n++)if(e=r[n],this._events.hasOwnProperty(e))if(t.isUndef(i))this._events[e]=[];else for(s=this._events[e],o=0;o<s.length;o++)s[o]===i&&s.splice(o,1);return this},t.Emitter.prototype.emit=function(t){var e,i,n,s;if(this._events&&(e=Array.apply(null,arguments).slice(1),this._events.hasOwnProperty(t)))for(i=this._events[t].slice(0),n=0,s=i.length;n<s;n++)i[n].apply(this,e);return this},t.Emitter.mixin=function(e){var i,n,s,o=["on","once","off","emit"];for(e._events={},i=0;i<o.length;i++)n=o[i],s=t.Emitter.prototype[n],e[n]=s;return t.Emitter},t.Emitter.prototype.dispose=function(){return t.prototype.dispose.call(this),this._events=null,this},t.Emitter}),t(function(t){return t.Timeline=function(){var e=t.defaults(arguments,["memory"],t.Timeline);t.call(this),this._timeline=[],this.memory=e.memory},t.extend(t.Timeline),t.Timeline.defaults={memory:1/0},Object.defineProperty(t.Timeline.prototype,"length",{get:function(){return this._timeline.length}}),t.Timeline.prototype.add=function(e){var i,n;if(t.isUndef(e.time))throw new Error("Tone.Timeline: events must have a time attribute");return e.time=e.time.valueOf(),i=this._search(e.time),this._timeline.splice(i+1,0,e),this.length>this.memory&&(n=this.length-this.memory,this._timeline.splice(0,n)),this},t.Timeline.prototype.remove=function(t){var e=this._timeline.indexOf(t);return-1!==e&&this._timeline.splice(e,1),this},t.Timeline.prototype.get=function(e,i){i=t.defaultArg(i,"time");var n=this._search(e,i);return-1!==n?this._timeline[n]:null},t.Timeline.prototype.peek=function(){return this._timeline[0]},t.Timeline.prototype.shift=function(){return this._timeline.shift()},t.Timeline.prototype.getAfter=function(e,i){i=t.defaultArg(i,"time");var n=this._search(e,i);return n+1<this._timeline.length?this._timeline[n+1]:null},t.Timeline.prototype.getBefore=function(e,i){var n,s;return i=t.defaultArg(i,"time"),(n=this._timeline.length)>0&&this._timeline[n-1][i]<e?this._timeline[n-1]:(s=this._search(e,i),s-1>=0?this._timeline[s-1]:null)},t.Timeline.prototype.cancel=function(t){var e,i;if(this._timeline.length>1)if((e=this._search(t))>=0)if(this._timeline[e].time===t){for(i=e;i>=0&&this._timeline[i].time===t;i--)e=i;this._timeline=this._timeline.slice(0,e)}else this._timeline=this._timeline.slice(0,e+1);else this._timeline=[];else 1===this._timeline.length&&this._timeline[0].time>=t&&(this._timeline=[]);return this},t.Timeline.prototype.cancelBefore=function(t){var e=this._search(t);return e>=0&&(this._timeline=this._timeline.slice(e+1)),this},t.Timeline.prototype.previousEvent=function(t){var e=this._timeline.indexOf(t);return e>0?this._timeline[e-1]:null},t.Timeline.prototype._search=function(e,i){var n,s,o,r,a,h,l,u;if(0===this._timeline.length)return-1;if(i=t.defaultArg(i,"time"),n=0,s=this._timeline.length,o=s,s>0&&this._timeline[s-1][i]<=e)return s-1;for(;n<o;){if(r=Math.floor(n+(o-n)/2),a=this._timeline[r],h=this._timeline[r+1],a[i]===e){for(l=r;l<this._timeline.length;l++)u=this._timeline[l],u[i]===e&&(r=l);return r}if(a[i]<e&&h[i]>e)return r;a[i]>e?o=r:n=r+1}return-1},t.Timeline.prototype._iterate=function(e,i,n){i=t.defaultArg(i,0),n=t.defaultArg(n,this._timeline.length-1),this._timeline.slice(i,n+1).forEach(function(t){e.call(this,t)}.bind(this))},t.Timeline.prototype.forEach=function(t){return this._iterate(t),this},t.Timeline.prototype.forEachBefore=function(t,e){var i=this._search(t);return-1!==i&&this._iterate(e,0,i),this},t.Timeline.prototype.forEachAfter=function(t,e){var i=this._search(t);return this._iterate(e,i+1),this},t.Timeline.prototype.forEachBetween=function(t,e,i){var n=this._search(t),s=this._search(e);return-1!==n&&-1!==s?(this._timeline[n].time!==t&&(n+=1),this._timeline[s].time===e&&(s-=1),this._iterate(i,n,s)):-1===n&&this._iterate(i,0,s),this},t.Timeline.prototype.forEachFrom=function(t,e){for(var i=this._search(t);i>=0&&this._timeline[i].time>=t;)i--;return this._iterate(e,i+1),this},t.Timeline.prototype.forEachAtTime=function(t,e){var i=this._search(t);return-1!==i&&this._iterate(function(i){i.time===t&&e.call(this,i)},0,i),this},t.Timeline.prototype.dispose=function(){return t.prototype.dispose.call(this),this._timeline=null,this},t.Timeline}),t(function(t){var e;t.supported&&(!window.hasOwnProperty("OfflineAudioContext")&&window.hasOwnProperty("webkitOfflineAudioContext")&&(window.OfflineAudioContext=window.webkitOfflineAudioContext),e=new OfflineAudioContext(1,1,44100),e.startRendering()instanceof Promise||(OfflineAudioContext.prototype._native_startRendering=OfflineAudioContext.prototype.startRendering,OfflineAudioContext.prototype.startRendering=function(){return new Promise(function(t){this.oncomplete=function(e){t(e.renderedBuffer)},this._native_startRendering()}.bind(this))}))}),t(function(t){var e,i,n,s;if(t.supported){!window.hasOwnProperty("AudioContext")&&window.hasOwnProperty("webkitAudioContext")&&(window.AudioContext=window.webkitAudioContext),AudioContext.prototype.close||(AudioContext.prototype.close=function(){return t.isFunction(this.suspend)&&this.suspend(),Promise.resolve()}),AudioContext.prototype.resume||(AudioContext.prototype.resume=function(){return Promise.resolve()}),!AudioContext.prototype.createGain&&AudioContext.prototype.createGainNode&&(AudioContext.prototype.createGain=AudioContext.prototype.createGainNode),!AudioContext.prototype.createDelay&&AudioContext.prototype.createDelayNode&&(AudioContext.prototype.createDelay=AudioContext.prototype.createDelayNode),e=!1,i=new OfflineAudioContext(1,1,44100),n=new Uint32Array([1179011410,48,1163280727,544501094,16,131073,44100,176400,1048580,1635017060,8,0,0,0,0]).buffer;try{s=i.decodeAudioData(n),s instanceof Promise&&(e=!0)}catch(t){e=!1}e||(AudioContext.prototype._native_decodeAudioData=AudioContext.prototype.decodeAudioData,AudioContext.prototype.decodeAudioData=function(t){return new Promise(function(e,i){this._native_decodeAudioData(t,e,i)}.bind(this))})}}),t(function(t){t.Context=function(){var i,n;if(t.Emitter.call(this),i=t.defaults(arguments,["context"],t.Context),!i.context&&(i.context=new window.AudioContext,!i.context))throw new Error("could not create AudioContext. Possibly too many AudioContexts running already.");this._context=i.context;for(n in this._context)this._defineProperty(this._context,n);this._latencyHint=i.latencyHint,this._constants={},this.lookAhead=i.lookAhead,this._computedUpdateInterval=0,this._ticker=new e(this.emit.bind(this,"tick"),i.clockSource,i.updateInterval),this._timeouts=new t.Timeline,this._timeoutIds=0,this.on("tick",this._timeoutLoop.bind(this))},t.extend(t.Context,t.Emitter),t.Emitter.mixin(t.Context),t.Context.defaults={clockSource:"worker",latencyHint:"interactive",lookAhead:.1,updateInterval:.03},t.Context.prototype._defineProperty=function(e,i){t.isUndef(this[i])&&Object.defineProperty(this,i,{get:function(){return"function"==typeof e[i]?e[i].bind(e):e[i]},set:function(t){e[i]=t}})},t.Context.prototype.now=function(){return this._context.currentTime+this.lookAhead},t.Context.prototype.ready=function(){return new Promise(function(t){"running"===this._context.state?t():this._context.resume().then(function(){t()})}.bind(this))},t.Context.prototype.close=function(){return this._context.close().then(function(){t.Context.emit("close",this)}.bind(this))},t.Context.prototype.getConstant=function(t){var e,i,n,s;if(this._constants[t])return this._constants[t];for(e=this._context.createBuffer(1,128,this._context.sampleRate),i=e.getChannelData(0),n=0;n<i.length;n++)i[n]=t;return s=this._context.createBufferSource(),s.channelCount=1,s.channelCountMode="explicit",s.buffer=e,s.loop=!0,s.start(0),this._constants[t]=s,s},t.Context.prototype._timeoutLoop=function(){for(var t=this.now();this._timeouts&&this._timeouts.length&&this._timeouts.peek().time<=t;)this._timeouts.shift().callback()},t.Context.prototype.setTimeout=function(t,e){this._timeoutIds++;var i=this.now();return this._timeouts.add({callback:t,time:i+e,id:this._timeoutIds}),this._timeoutIds},t.Context.prototype.clearTimeout=function(t){return this._timeouts.forEach(function(e){e.id===t&&this.remove(e)}),this},Object.defineProperty(t.Context.prototype,"updateInterval",{get:function(){return this._ticker.updateInterval},set:function(t){this._ticker.updateInterval=t}}),Object.defineProperty(t.Context.prototype,"clockSource",{get:function(){return this._ticker.type},set:function(t){this._ticker.type=t}}),Object.defineProperty(t.Context.prototype,"latencyHint",{get:function(){return this._latencyHint},set:function(e){var i=e;if(this._latencyHint=e,t.isString(e))switch(e){case"interactive":i=.1,this._context.latencyHint=e;break;case"playback":i=.8,this._context.latencyHint=e;break;case"balanced":i=.25,this._context.latencyHint=e;break;case"fastest":this._context.latencyHint="interactive",i=.01}this.lookAhead=i,this.updateInterval=i/3}}),t.Context.prototype.dispose=function(){return this.close().then(function(){t.Emitter.prototype.dispose.call(this),this._ticker.dispose(),this._ticker=null,this._timeouts.dispose(),this._timeouts=null;for(var e in this._constants)this._constants[e].disconnect();this._constants=null}.bind(this))};var e=function(e,i,n){this._type=i,this._updateInterval=n,this._callback=t.defaultArg(e,t.noOp),this._createClock()};return e.Type={Worker:"worker",Timeout:"timeout",Offline:"offline"},e.prototype._createWorker=function(){var t,e,i;window.URL=window.URL||window.webkitURL,t=new Blob(["var timeoutTime = "+(1e3*this._updateInterval).toFixed(1)+";self.onmessage = function(msg){\ttimeoutTime = parseInt(msg.data);};function tick(){\tsetTimeout(tick, timeoutTime);\tself.postMessage('tick');}tick();"]),e=URL.createObjectURL(t),i=new Worker(e),i.onmessage=this._callback.bind(this),this._worker=i},e.prototype._createTimeout=function(){this._timeout=setTimeout(function(){this._createTimeout(),this._callback()}.bind(this),1e3*this._updateInterval)},e.prototype._createClock=function(){if(this._type===e.Type.Worker)try{this._createWorker()}catch(t){this._type=e.Type.Timeout,this._createClock()}else this._type===e.Type.Timeout&&this._createTimeout()},Object.defineProperty(e.prototype,"updateInterval",{get:function(){return this._updateInterval},set:function(t){this._updateInterval=Math.max(t,128/44100),this._type===e.Type.Worker&&this._worker.postMessage(Math.max(1e3*t,1))}}),Object.defineProperty(e.prototype,"type",{get:function(){return this._type},set:function(t){this._disposeClock(),this._type=t,this._createClock()}}),e.prototype._disposeClock=function(){this._timeout&&(clearTimeout(this._timeout),this._timeout=null),this._worker&&(this._worker.terminate(),this._worker.onmessage=null,this._worker=null)},e.prototype.dispose=function(){this._disposeClock(),this._callback=null},t.getContext(function(){function e(e,i,s){if(e.input)return s=t.defaultArg(s,0),t.isArray(e.input)?this.connect(e.input[s]):this.connect(e.input,i,s);try{return e instanceof AudioNode?(n.call(this,e,i,s),e):(n.call(this,e,i),e)}catch(t){throw new Error("error connecting to node: "+e+"\n"+t)}}function i(e,i,n){if(e&&e.input&&t.isArray(e.input))n=t.defaultArg(n,0),this.disconnect(e.input[n],i,0);else if(e&&e.input)this.disconnect(e.input,i,n);else try{s.apply(this,arguments)}catch(t){throw new Error("error disconnecting node: "+e+"\n"+t)}}var n=AudioNode.prototype.connect,s=AudioNode.prototype.disconnect;AudioNode.prototype.connect!==e&&(AudioNode.prototype.connect=e,AudioNode.prototype.disconnect=i)}),t.supported&&!t.initialized?(t.context=new t.Context,window.TONE_SILENCE_VERSION_LOGGING||console.log("%c * Tone.js "+t.version+" * ","background: #000; color: #fff")):t.supported||console.warn("This browser does not support Tone.js"),t.Context}),t(function(t){return t.AudioNode=function(){t.call(this);var e=t.defaults(arguments,["context"],{context:t.context});this._context=e.context},t.extend(t.AudioNode),Object.defineProperty(t.AudioNode.prototype,"context",{get:function(){return this._context}}),t.AudioNode.prototype.createInsOuts=function(t,e){1===t?this.input=this.context.createGain():t>1&&(this.input=new Array(t)),1===e?this.output=this.context.createGain():e>1&&(this.output=new Array(e))},Object.defineProperty(t.AudioNode.prototype,"channelCount",{get:function(){return this.output.channelCount},set:function(t){return this.output.channelCount=t}}),Object.defineProperty(t.AudioNode.prototype,"channelCountMode",{get:function(){return this.output.channelCountMode},set:function(t){return this.output.channelCountMode=t}}),Object.defineProperty(t.AudioNode.prototype,"channelInterpretation",{get:function(){return this.output.channelInterpretation},set:function(t){return this.output.channelInterpretation=t}}),Object.defineProperty(t.AudioNode.prototype,"numberOfInputs",{get:function(){return this.input?t.isArray(this.input)?this.input.length:1:0}}),Object.defineProperty(t.AudioNode.prototype,"numberOfOutputs",{get:function(){return this.output?t.isArray(this.output)?this.output.length:1:0}}),t.AudioNode.prototype._onConnect=function(){},t.AudioNode.prototype.connect=function(e,i,n){return e._onConnect&&e._onConnect(this),t.isArray(this.output)?(i=t.defaultArg(i,0),this.output[i].connect(e,0,n)):this.output.connect(e,i,n),this},t.AudioNode.prototype.disconnect=function(e,i,n){t.isArray(this.output)?t.isNumber(e)?this.output[e].disconnect():(i=t.defaultArg(i,0),this.output[i].disconnect(e,0,n)):this.output.disconnect.apply(this.output,arguments)},t.AudioNode.prototype.chain=function(){var t,e,i=this;for(t=0;t<arguments.length;t++)e=arguments[t],i.connect(e),i=e;return this},t.AudioNode.prototype.fan=function(){for(var t=0;t<arguments.length;t++)this.connect(arguments[t]);return this},window.AudioNode&&(AudioNode.prototype.chain=t.AudioNode.prototype.chain,AudioNode.prototype.fan=t.AudioNode.prototype.fan),t.AudioNode.prototype.dispose=function(){return t.isDefined(this.input)&&(this.input instanceof AudioNode&&this.input.disconnect(),this.input=null),t.isDefined(this.output)&&(this.output instanceof AudioNode&&this.output.disconnect(),this.output=null),this._context=null,this},t.AudioNode}),t(function(t){return t.SignalBase=function(){t.AudioNode.call(this)},t.extend(t.SignalBase,t.AudioNode),t.SignalBase.prototype.connect=function(e,i,n){return t.Signal&&t.Signal===e.constructor||t.Param&&t.Param===e.constructor?(e._param.cancelScheduledValues(0),e._param.value=0,e.overridden=!0):e instanceof AudioParam&&(e.cancelScheduledValues(0),e.value=0),t.AudioNode.prototype.connect.call(this,e,i,n),this},t.SignalBase}),t(function(t){var e,i;t.supported&&(e=navigator.userAgent.toLowerCase(),e.includes("safari")&&!e.includes("chrome")&&(i=function(t){this._internalNode=this.input=this.output=t._native_createWaveShaper(),this._curve=null;for(var e in this._internalNode)this._defineProperty(this._internalNode,e)},Object.defineProperty(i.prototype,"curve",{get:function(){return this._curve},set:function(t){this._curve=t;var e=new Float32Array(t.length+1);e.set(t,1),e[0]=t[0],this._internalNode.curve=e}}),i.prototype._defineProperty=function(e,i){t.isUndef(this[i])&&Object.defineProperty(this,i,{get:function(){return"function"==typeof e[i]?e[i].bind(e):e[i]},set:function(t){e[i]=t}})},AudioContext.prototype._native_createWaveShaper=AudioContext.prototype.createWaveShaper,AudioContext.prototype.createWaveShaper=function(){return new i(this)}))}),t(function(t){return t.WaveShaper=function(e,i){t.SignalBase.call(this),this._shaper=this.input=this.output=this.context.createWaveShaper(),this._curve=null,Array.isArray(e)?this.curve=e:isFinite(e)||t.isUndef(e)?this._curve=new Float32Array(t.defaultArg(e,1024)):t.isFunction(e)&&(this._curve=new Float32Array(t.defaultArg(i,1024)),this.setMap(e))},t.extend(t.WaveShaper,t.SignalBase),t.WaveShaper.prototype.setMap=function(t){var e,i,n,s=new Array(this._curve.length);for(e=0,i=this._curve.length;e<i;e++)n=e/(i-1)*2-1,s[e]=t(n,e);return this.curve=s,this},Object.defineProperty(t.WaveShaper.prototype,"curve",{get:function(){return this._shaper.curve},set:function(t){this._curve=new Float32Array(t),this._shaper.curve=this._curve}}),Object.defineProperty(t.WaveShaper.prototype,"oversample",{get:function(){return this._shaper.oversample},set:function(t){if(!["none","2x","4x"].includes(t))throw new RangeError("Tone.WaveShaper: oversampling must be either 'none', '2x', or '4x'");this._shaper.oversample=t}}),t.WaveShaper.prototype.dispose=function(){return t.SignalBase.prototype.dispose.call(this),this._shaper.disconnect(),this._shaper=null,this._curve=null,this},t.WaveShaper}),t(function(t){return t.TimeBase=function(e,i){if(!(this instanceof t.TimeBase))return new t.TimeBase(e,i);if(this._val=e,this._units=i,t.isUndef(this._units)&&t.isString(this._val)&&parseFloat(this._val)==this._val&&"+"!==this._val.charAt(0))this._val=parseFloat(this._val),this._units=this._defaultUnits;else if(e&&e.constructor===this.constructor)this._val=e._val,this._units=e._units;else if(e instanceof t.TimeBase)switch(this._defaultUnits){case"s":this._val=e.toSeconds();break;case"i":this._val=e.toTicks();break;case"hz":this._val=e.toFrequency();break;case"midi":this._val=e.toMidi();break;default:throw new Error("Unrecognized default units "+this._defaultUnits)}},t.extend(t.TimeBase),t.TimeBase.prototype._expressions={n:{regexp:/^(\d+)n(\.?)$/i,method:function(t,e){t=parseInt(t);var i="."===e?1.5:1;return 1===t?this._beatsToUnits(this._getTimeSignature())*i:this._beatsToUnits(4/t)*i}},t:{regexp:/^(\d+)t$/i,method:function(t){return t=parseInt(t),this._beatsToUnits(8/(3*parseInt(t)))}},m:{regexp:/^(\d+)m$/i,method:function(t){return this._beatsToUnits(parseInt(t)*this._getTimeSignature())}},i:{regexp:/^(\d+)i$/i,method:function(t){return this._ticksToUnits(parseInt(t))}},hz:{regexp:/^(\d+(?:\.\d+)?)hz$/i,method:function(t){return this._frequencyToUnits(parseFloat(t))}},tr:{regexp:/^(\d+(?:\.\d+)?):(\d+(?:\.\d+)?):?(\d+(?:\.\d+)?)?$/,method:function(t,e,i){var n=0;return t&&"0"!==t&&(n+=this._beatsToUnits(this._getTimeSignature()*parseFloat(t))),e&&"0"!==e&&(n+=this._beatsToUnits(parseFloat(e))),i&&"0"!==i&&(n+=this._beatsToUnits(parseFloat(i)/4)),n}},s:{regexp:/^(\d+(?:\.\d+)?)s$/,method:function(t){return this._secondsToUnits(parseFloat(t))}},samples:{regexp:/^(\d+)samples$/,method:function(t){return parseInt(t)/this.context.sampleRate}},default:{regexp:/^(\d+(?:\.\d+)?)$/,method:function(t){return this._expressions[this._defaultUnits].method.call(this,t)}}},t.TimeBase.prototype._defaultUnits="s",t.TimeBase.prototype._getBpm=function(){return t.Transport?t.Transport.bpm.value:120},t.TimeBase.prototype._getTimeSignature=function(){return t.Transport?t.Transport.timeSignature:4},t.TimeBase.prototype._getPPQ=function(){return t.Transport?t.Transport.PPQ:192},t.TimeBase.prototype._now=function(){return this.now()},t.TimeBase.prototype._frequencyToUnits=function(t){return 1/t},t.TimeBase.prototype._beatsToUnits=function(t){return 60/this._getBpm()*t},t.TimeBase.prototype._secondsToUnits=function(t){return t},t.TimeBase.prototype._ticksToUnits=function(t){return t*(this._beatsToUnits(1)/this._getPPQ())},t.TimeBase.prototype._noArg=function(){return this._now()},t.TimeBase.prototype.valueOf=function(){var e,i,n;if(t.isUndef(this._val))return this._noArg();if(t.isString(this._val)&&t.isUndef(this._units))for(e in this._expressions)if(this._expressions[e].regexp.test(this._val.trim())){this._units=e;break}return t.isDefined(this._units)?(i=this._expressions[this._units],n=this._val.toString().trim().match(i.regexp),n?i.method.apply(this,n.slice(1)):i.method.call(this,parseFloat(this._val))):this._val},t.TimeBase.prototype.toSeconds=function(){return this.valueOf()},t.TimeBase.prototype.toFrequency=function(){return 1/this.toSeconds()},t.TimeBase.prototype.toSamples=function(){return this.toSeconds()*this.context.sampleRate},t.TimeBase.prototype.toMilliseconds=function(){return 1e3*this.toSeconds()},t.TimeBase.prototype.dispose=function(){this._val=null,this._units=null},t.TimeBase}),t(function(t){var e,i;return t.Frequency=function(e,i){if(!(this instanceof t.Frequency))return new t.Frequency(e,i);t.TimeBase.call(this,e,i)},t.extend(t.Frequency,t.TimeBase),t.Frequency.prototype._expressions=Object.assign({},t.TimeBase.prototype._expressions,{midi:{regexp:/^(\d+(?:\.\d+)?midi)/,method:function(e){return"midi"===this._defaultUnits?e:t.Frequency.mtof(e)}},note:{regexp:/^([a-g]{1}(?:b|#|x|bb)?)(-?[0-9]+)/i,method:function(i,n){var s=e[i.toLowerCase()],o=s+12*(parseInt(n)+1);return"midi"===this._defaultUnits?o:t.Frequency.mtof(o)}},tr:{regexp:/^(\d+(?:\.\d+)?):(\d+(?:\.\d+)?):?(\d+(?:\.\d+)?)?/,method:function(t,e,i){var n=1;return t&&"0"!==t&&(n*=this._beatsToUnits(this._getTimeSignature()*parseFloat(t))),e&&"0"!==e&&(n*=this._beatsToUnits(parseFloat(e))),i&&"0"!==i&&(n*=this._beatsToUnits(parseFloat(i)/4)),n}}}),t.Frequency.prototype.transpose=function(e){return new this.constructor(this.valueOf()*t.intervalToFrequencyRatio(e))},t.Frequency.prototype.harmonize=function(t){return t.map(function(t){return this.transpose(t)}.bind(this))},t.Frequency.prototype.toMidi=function(){return t.Frequency.ftom(this.valueOf())},t.Frequency.prototype.toNote=function(){var e=this.toFrequency(),n=Math.log2(e/t.Frequency.A4),s=Math.round(12*n)+57,o=Math.floor(s/12);return o<0&&(s+=-12*o),i[s%12]+o.toString()},t.Frequency.prototype.toSeconds=function(){return 1/t.TimeBase.prototype.toSeconds.call(this)},t.Frequency.prototype.toFrequency=function(){return t.TimeBase.prototype.toFrequency.call(this)},t.Frequency.prototype.toTicks=function(){var e=this._beatsToUnits(1),i=this.valueOf()/e;return Math.floor(i*t.Transport.PPQ)},t.Frequency.prototype._noArg=function(){return 0},t.Frequency.prototype._frequencyToUnits=function(t){return t},t.Frequency.prototype._ticksToUnits=function(e){return 1/(60*e/(t.Transport.bpm.value*t.Transport.PPQ))},t.Frequency.prototype._beatsToUnits=function(e){return 1/t.TimeBase.prototype._beatsToUnits.call(this,e)},t.Frequency.prototype._secondsToUnits=function(t){return 1/t},t.Frequency.prototype._defaultUnits="hz",e={cbb:-2,cb:-1,c:0,"c#":1,cx:2,dbb:0,db:1,d:2,"d#":3,dx:4,ebb:2,eb:3,e:4,"e#":5,ex:6,fbb:3,fb:4,f:5,"f#":6,fx:7,gbb:5,gb:6,g:7,"g#":8,gx:9,abb:7,ab:8,a:9,"a#":10,ax:11,bbb:9,bb:10,b:11,"b#":12,bx:13},i=["C","C#","D","D#","E","F","F#","G","G#","A","A#","B"],t.Frequency.A4=440,t.Frequency.mtof=function(e){return t.Frequency.A4*Math.pow(2,(e-69)/12)},t.Frequency.ftom=function(e){return 69+Math.round(12*Math.log2(e/t.Frequency.A4))},t.Frequency}),t(function(t){return t.Time=function(e,i){if(!(this instanceof t.Time))return new t.Time(e,i);t.TimeBase.call(this,e,i)},t.extend(t.Time,t.TimeBase),t.Time.prototype._expressions=Object.assign({},t.TimeBase.prototype._expressions,{quantize:{regexp:/^@(.+)/,method:function(e){if(t.Transport){var i=new this.constructor(e);return t.Transport.nextSubdivision(i)}return 0}},now:{regexp:/^\+(.+)/,method:function(t){return this._now()+new this.constructor(t)}}}),t.Time.prototype.quantize=function(e,i){var n,s,o,r,a;return i=t.defaultArg(i,1),n=new this.constructor(e),s=this.valueOf(),o=Math.round(s/n),r=o*n,a=r-s,s+a*i},t.Time.prototype.toNotation=function(){var e,i,n,s,o=this.toSeconds(),r=["1m"];for(e=1;e<8;e++)i=Math.pow(2,e),r.push(i+"n."),r.push(i+"n"),r.push(i+"t");return r.push("0"),n=r[0],s=t.Time(r[0]).toSeconds(),r.forEach(function(e){var i=t.Time(e).toSeconds();Math.abs(i-o)<Math.abs(s-o)&&(n=e,s=i)}),n},t.Time.prototype.toBarsBeatsSixteenths=function(){var t,e=this._beatsToUnits(1),i=this.valueOf()/e,n=Math.floor(i/this._getTimeSignature()),s=i%1*4;return i=Math.floor(i)%this._getTimeSignature(),s=s.toString(),s.length>3&&(s=parseFloat(parseFloat(s).toFixed(3))),t=[n,i,s],t.join(":")},t.Time.prototype.toTicks=function(){var t=this._beatsToUnits(1),e=this.valueOf()/t;return Math.round(e*this._getPPQ())},t.Time.prototype.toSeconds=function(){return this.valueOf()},t.Time.prototype.toMidi=function(){return t.Frequency.ftom(this.toFrequency())},t.Time}),t(function(t){return t.TransportTime=function(e,i){if(!(this instanceof t.TransportTime))return new t.TransportTime(e,i);t.Time.call(this,e,i)},t.extend(t.TransportTime,t.Time),t.TransportTime.prototype._now=function(){return t.Transport.seconds},t.TransportTime}),t(function(t){return t.Type={Default:"number",Time:"time",Frequency:"frequency",TransportTime:"transportTime",Ticks:"ticks",NormalRange:"normalRange",AudioRange:"audioRange",Decibels:"db",Interval:"interval",BPM:"bpm",Positive:"positive",Gain:"gain",Cents:"cents",Degrees:"degrees",MIDI:"midi",BarsBeatsSixteenths:"barsBeatsSixteenths",Samples:"samples",Hertz:"hertz",Note:"note",Milliseconds:"milliseconds",Seconds:"seconds",Notation:"notation"},t.prototype.toSeconds=function(e){return t.isNumber(e)?e:t.isUndef(e)?this.now():t.isString(e)?new t.Time(e).toSeconds():e instanceof t.TimeBase?e.toSeconds():void 0},t.prototype.toFrequency=function(e){return t.isNumber(e)?e:t.isString(e)||t.isUndef(e)?new t.Frequency(e).valueOf():e instanceof t.TimeBase?e.toFrequency():void 0},t.prototype.toTicks=function(e){return t.isNumber(e)||t.isString(e)?new t.TransportTime(e).toTicks():t.isUndef(e)?t.Transport.ticks:e instanceof t.TimeBase?e.toTicks():void 0},t}),t(function(t){return t.Param=function(){var e=t.defaults(arguments,["param","units","convert"],t.Param);t.AudioNode.call(this),this._param=this.input=e.param,this.units=e.units,this.convert=e.convert,this.overridden=!1,this._events=new t.Timeline(1e3),t.isDefined(e.value)&&this._param&&(this.value=e.value)},t.extend(t.Param,t.AudioNode),t.Param.defaults={units:t.Type.Default,convert:!0,param:void 0},Object.defineProperty(t.Param.prototype,"value",{get:function(){var t=this.now();return this._toUnits(this.getValueAtTime(t))},set:function(t){this._initialValue=this._fromUnits(t),this.cancelScheduledValues(this.context.currentTime),this.setValueAtTime(t,this.context.currentTime)}}),Object.defineProperty(t.Param.prototype,"minValue",{get:function(){return this.units===t.Type.Time||this.units===t.Type.Frequency||this.units===t.Type.NormalRange||this.units===t.Type.Positive||this.units===t.Type.BPM?0:this.units===t.Type.AudioRange?-1:this.units===t.Type.Decibels?-1/0:this._param.minValue}}),Object.defineProperty(t.Param.prototype,"maxValue",{get:function(){return this.units===t.Type.NormalRange||this.units===t.Type.AudioRange?1:this._param.maxValue}}),t.Param.prototype._fromUnits=function(e){if(!this.convert&&!t.isUndef(this.convert)||this.overridden)return e;switch(this.units){case t.Type.Time:return this.toSeconds(e);case t.Type.Frequency:return this.toFrequency(e);case t.Type.Decibels:return t.dbToGain(e);case t.Type.NormalRange:return Math.min(Math.max(e,0),1);case t.Type.AudioRange:return Math.min(Math.max(e,-1),1);case t.Type.Positive:return Math.max(e,0);default:return e}},t.Param.prototype._toUnits=function(e){if(!this.convert&&!t.isUndef(this.convert))return e;switch(this.units){case t.Type.Decibels:return t.gainToDb(e)
;default:return e}},t.Param.prototype._minOutput=1e-5,t.Param.AutomationType={Linear:"linearRampToValueAtTime",Exponential:"exponentialRampToValueAtTime",Target:"setTargetAtTime",SetValue:"setValueAtTime"},t.Param.prototype.setValueAtTime=function(e,i){return i=this.toSeconds(i),e=this._fromUnits(e),this._events.add({type:t.Param.AutomationType.SetValue,value:e,time:i}),this._param.setValueAtTime(e,i),this},t.Param.prototype.getValueAtTime=function(e){var i,n,s,o,r,a;return e=this.toSeconds(e),i=this._events.getAfter(e),n=this._events.get(e),s=t.defaultArg(this._initialValue,this._param.defaultValue),o=s,null===n?o=s:n.type===t.Param.AutomationType.Target?(r=this._events.getBefore(n.time),a=null===r?s:r.value,o=this._exponentialApproach(n.time,a,n.value,n.constant,e)):o=null===i?n.value:i.type===t.Param.AutomationType.Linear?this._linearInterpolate(n.time,n.value,i.time,i.value,e):i.type===t.Param.AutomationType.Exponential?this._exponentialInterpolate(n.time,n.value,i.time,i.value,e):n.value,o},t.Param.prototype.setRampPoint=function(t){t=this.toSeconds(t);var e=this.getValueAtTime(t);return this.cancelAndHoldAtTime(t),0===e&&(e=this._minOutput),this.setValueAtTime(this._toUnits(e),t),this},t.Param.prototype.linearRampToValueAtTime=function(e,i){return e=this._fromUnits(e),i=this.toSeconds(i),this._events.add({type:t.Param.AutomationType.Linear,value:e,time:i}),this._param.linearRampToValueAtTime(e,i),this},t.Param.prototype.exponentialRampToValueAtTime=function(e,i){return e=this._fromUnits(e),e=Math.max(this._minOutput,e),i=this.toSeconds(i),this._events.add({type:t.Param.AutomationType.Exponential,time:i,value:e}),this._param.exponentialRampToValueAtTime(e,i),this},t.Param.prototype.exponentialRampTo=function(t,e,i){return i=this.toSeconds(i),this.setRampPoint(i),this.exponentialRampToValueAtTime(t,i+this.toSeconds(e)),this},t.Param.prototype.linearRampTo=function(t,e,i){return i=this.toSeconds(i),this.setRampPoint(i),this.linearRampToValueAtTime(t,i+this.toSeconds(e)),this},t.Param.prototype.targetRampTo=function(t,e,i){return i=this.toSeconds(i),this.setRampPoint(i),this.exponentialApproachValueAtTime(t,i,e),this},t.Param.prototype.exponentialApproachValueAtTime=function(t,e,i){var n=Math.log(this.toSeconds(i)+1)/Math.log(200);return e=this.toSeconds(e),this.setTargetAtTime(t,e,n)},t.Param.prototype.setTargetAtTime=function(e,i,n){if(e=this._fromUnits(e),n<=0)throw new Error("timeConstant must be greater than 0");return i=this.toSeconds(i),this._events.add({type:t.Param.AutomationType.Target,value:e,time:i,constant:n}),this._param.setTargetAtTime(e,i,n),this},t.Param.prototype.setValueCurveAtTime=function(e,i,n,s){var o,r;for(s=t.defaultArg(s,1),n=this.toSeconds(n),i=this.toSeconds(i),this.setValueAtTime(e[0]*s,i),o=n/(e.length-1),r=1;r<e.length;r++)this.linearRampToValueAtTime(e[r]*s,i+r*o);return this},t.Param.prototype.cancelScheduledValues=function(t){return t=this.toSeconds(t),this._events.cancel(t),this._param.cancelScheduledValues(t),this},t.Param.prototype.cancelAndHoldAtTime=function(e){var i=this.getValueAtTime(e),n=this._events.get(e),s=this._events.getAfter(e);return n&&n.time===e?s?this._events.cancel(s.time):this._events.cancel(e+1e-6):s&&(this._events.cancel(s.time),this._param.cancelAndHoldAtTime||this._param.cancelScheduledValues(e),s.type===t.Param.AutomationType.Linear?this._param.cancelAndHoldAtTime?this._events.add({type:t.Param.AutomationType.Linear,value:i,time:e}):this.linearRampToValueAtTime(i,e):s.type===t.Param.AutomationType.Exponential&&(this._param.cancelAndHoldAtTime?this._events.add({type:t.Param.AutomationType.Exponential,value:i,time:e}):this.exponentialRampToValueAtTime(i,e))),this._events.add({type:t.Param.AutomationType.SetValue,value:i,time:e}),this._param.cancelAndHoldAtTime?this._param.cancelAndHoldAtTime(e):this._param.setValueAtTime(i,e),this},t.Param.prototype.rampTo=function(e,i,n){return i=t.defaultArg(i,.1),this.units===t.Type.Frequency||this.units===t.Type.BPM||this.units===t.Type.Decibels?this.exponentialRampTo(e,i,n):this.linearRampTo(e,i,n),this},t.Param.prototype._exponentialApproach=function(t,e,i,n,s){return i+(e-i)*Math.exp(-(s-t)/n)},t.Param.prototype._linearInterpolate=function(t,e,i,n,s){return e+(s-t)/(i-t)*(n-e)},t.Param.prototype._exponentialInterpolate=function(t,e,i,n,s){return e*Math.pow(n/e,(s-t)/(i-t))},t.Param.prototype.dispose=function(){return t.AudioNode.prototype.dispose.call(this),this._param=null,this._events=null,this},t.Param}),t(function(t){return t.OfflineContext=function(e,i,n){var s=new OfflineAudioContext(e,i*n,n);t.Context.call(this,{context:s,clockSource:"offline",lookAhead:0,updateInterval:128/n}),this._duration=i,this._currentTime=0},t.extend(t.OfflineContext,t.Context),t.OfflineContext.prototype.now=function(){return this._currentTime},t.OfflineContext.prototype.render=function(){for(;this._duration-this._currentTime>=0;)this.emit("tick"),this._currentTime+=this.blockTime;return this._context.startRendering()},t.OfflineContext.prototype.close=function(){return this._context=null,Promise.resolve()},t.OfflineContext}),t(function(t){var e;t.supported&&(e=navigator.userAgent.toLowerCase(),e.includes("safari")&&!e.includes("chrome")&&e.includes("mobile")&&(t.OfflineContext.prototype.createBufferSource=function(){var t=this._context.createBufferSource(),e=t.start;return t.start=function(i){this.setTimeout(function(){e.call(t,i)}.bind(this),0)}.bind(this),t}))}),t(function(t){return t.Gain=function(){var e=t.defaults(arguments,["gain","units"],t.Gain);t.AudioNode.call(this),this.input=this.output=this._gainNode=this.context.createGain(),this.gain=new t.Param({param:this._gainNode.gain,units:e.units,value:e.gain,convert:e.convert}),this._readOnly("gain")},t.extend(t.Gain,t.AudioNode),t.Gain.defaults={gain:1,convert:!0},t.Gain.prototype.dispose=function(){t.AudioNode.prototype.dispose.call(this),this._gainNode.disconnect(),this._gainNode=null,this._writable("gain"),this.gain.dispose(),this.gain=null},t.Gain}),t(function(t){if(t.supported&&!AudioContext.prototype.createConstantSource){var e=function(t){var e,i,n,s;for(this.context=t,e=t.createBuffer(1,128,t.sampleRate),i=e.getChannelData(0),n=0;n<i.length;n++)i[n]=1;this._bufferSource=t.createBufferSource(),this._bufferSource.channelCount=1,this._bufferSource.channelCountMode="explicit",this._bufferSource.buffer=e,this._bufferSource.loop=!0,s=this._output=t.createGain(),this.offset=s.gain,this._bufferSource.connect(s)};e.prototype.start=function(t){return this._bufferSource.start(t),this},e.prototype.stop=function(t){return this._bufferSource.stop(t),this},e.prototype.connect=function(){return this._output.connect.apply(this._output,arguments),this},e.prototype.disconnect=function(){return this._output.disconnect.apply(this._output,arguments),this},AudioContext.prototype.createConstantSource=function(){return new e(this)},t.Context.prototype.createConstantSource=function(){return new e(this)}}}),t(function(t){return t.Signal=function(){var e=t.defaults(arguments,["value","units"],t.Signal);t.Param.call(this,e),this._proxies=[],this._sourceStarted=!1,this._constantSource=this.context.createConstantSource(),this._param=this._constantSource.offset,this.value=e.value,this.output=this._constantSource,this.input=this._param=this.output.offset},t.extend(t.Signal,t.Param),t.Signal.defaults={value:0,units:t.Type.Default,convert:!0},t.Signal.prototype.connect=function(e){return this._isParam(e)&&!this._sourceStarted?(this._proxies.push(e),e.overridden=!0,this._applyAutomations(e)):(t.SignalBase.prototype.connect.apply(this,arguments),this._sourceStarted||(this._sourceStarted=!0,this._constantSource.start(0))),this},t.Signal.prototype._isParam=function(e){return t.Param&&t.Param===e.constructor||e instanceof AudioParam},t.Signal.prototype._connectProxies=function(){this._sourceStarted||(this._sourceStarted=!0,this._constantSource.start(0)),this._proxies.forEach(function(e){t.SignalBase.prototype.connect.call(this,e),e._proxies&&e._connectProxies()}.bind(this))},t.Signal.prototype._onConnect=function(t){this._isParam(t)||this._connectProxies()},t.Signal.prototype._applyAutomations=function(t){var e,i=this.context.currentTime;t.cancelScheduledValues(i),e=this.getValueAtTime(i),t.setValueAtTime(e,i),this._events.forEachFrom(i,function(e){t[e.type](e.value,e.time,e.constant)})},t.Signal.prototype.disconnect=function(e){if(this._proxies.includes(e)){var i=this._proxies.indexOf(e);this._proxies.splice(i,1)}else e||(this._proxies=[]);return t.SignalBase.prototype.disconnect.apply(this,arguments)},t.Signal.prototype.getValueAtTime=function(e){return this._param.getValueAtTime?this._param.getValueAtTime(e):t.Param.prototype.getValueAtTime.call(this,e)},["setValueAtTime","linearRampToValueAtTime","exponentialRampToValueAtTime","setTargetAtTime"].forEach(function(e){var i=t.Signal.prototype[e];t.Signal.prototype[e]=function(){var t=arguments;i.apply(this,arguments),t[0]=this._fromUnits(t[0]),t[1]=this.toSeconds(t[1]),this._proxies.forEach(function(i){i[e].apply(i,t)})}}),["cancelScheduledValues","cancelAndHoldAtTime"].forEach(function(e){var i=t.Signal.prototype[e];t.Signal.prototype[e]=function(){var t=arguments;i.apply(this,arguments),t[0]=this.toSeconds(t[0]),this._proxies.forEach(function(i){i[e].apply(i,t)})}}),t.Signal.prototype.dispose=function(){return t.Param.prototype.dispose.call(this),this._constantSource.disconnect(),this._constantSource=null,this._proxies=null,this},t.Signal}),t(function(t){return t.Pow=function(e){t.SignalBase.call(this),this._exp=t.defaultArg(e,1),this._expScaler=this.input=this.output=new t.WaveShaper(this._expFunc(this._exp),8192)},t.extend(t.Pow,t.SignalBase),Object.defineProperty(t.Pow.prototype,"value",{get:function(){return this._exp},set:function(t){this._exp=t,this._expScaler.setMap(this._expFunc(this._exp))}}),t.Pow.prototype._expFunc=function(t){return function(e){return Math.pow(Math.abs(e),t)}},t.Pow.prototype.dispose=function(){return t.SignalBase.prototype.dispose.call(this),this._expScaler.dispose(),this._expScaler=null,this},t.Pow}),t(function(t){return t.Envelope=function(){var e=t.defaults(arguments,["attack","decay","sustain","release"],t.Envelope);t.AudioNode.call(this),this.attack=e.attack,this.decay=e.decay,this.sustain=e.sustain,this.release=e.release,this._attackCurve="linear",this._releaseCurve="exponential",this._sig=this.output=new t.Signal(0),this.attackCurve=e.attackCurve,this.releaseCurve=e.releaseCurve},t.extend(t.Envelope,t.AudioNode),t.Envelope.defaults={attack:.01,decay:.1,sustain:.5,release:1,attackCurve:"linear",releaseCurve:"exponential"},Object.defineProperty(t.Envelope.prototype,"value",{get:function(){return this.getValueAtTime(this.now())}}),Object.defineProperty(t.Envelope.prototype,"attackCurve",{get:function(){if(t.isString(this._attackCurve))return this._attackCurve;if(t.isArray(this._attackCurve)){for(var e in t.Envelope.Type)if(t.Envelope.Type[e].In===this._attackCurve)return e;return this._attackCurve}},set:function(e){if(t.Envelope.Type.hasOwnProperty(e)){var i=t.Envelope.Type[e];t.isObject(i)?this._attackCurve=i.In:this._attackCurve=i}else{if(!t.isArray(e))throw new Error("Tone.Envelope: invalid curve: "+e);this._attackCurve=e}}}),Object.defineProperty(t.Envelope.prototype,"releaseCurve",{get:function(){if(t.isString(this._releaseCurve))return this._releaseCurve;if(t.isArray(this._releaseCurve)){for(var e in t.Envelope.Type)if(t.Envelope.Type[e].Out===this._releaseCurve)return e;return this._releaseCurve}},set:function(e){if(t.Envelope.Type.hasOwnProperty(e)){var i=t.Envelope.Type[e];t.isObject(i)?this._releaseCurve=i.Out:this._releaseCurve=i}else{if(!t.isArray(e))throw new Error("Tone.Envelope: invalid curve: "+e);this._releaseCurve=e}}}),t.Envelope.prototype.triggerAttack=function(e,i){var n,s,o,r,a,h,l,u,c;return e=this.toSeconds(e),n=this.toSeconds(this.attack),s=n,o=this.toSeconds(this.decay),i=t.defaultArg(i,1),r=this.getValueAtTime(e),r>0&&(a=1/s,h=1-r,s=h/a),"linear"===this._attackCurve?this._sig.linearRampTo(i,s,e):"exponential"===this._attackCurve?this._sig.targetRampTo(i,s,e):s>0&&(this._sig.cancelAndHoldAtTime(e),l=this._attackCurve,s<n&&(u=1-s/n,c=Math.floor(u*this._attackCurve.length),l=this._attackCurve.slice(c),l[0]=r),this._sig.setValueCurveAtTime(l,e,s,i)),o&&this._sig.targetRampTo(i*this.sustain,o,s+e),this},t.Envelope.prototype.triggerRelease=function(e){var i,n,s;return e=this.toSeconds(e),i=this.getValueAtTime(e),i>0&&(n=this.toSeconds(this.release),"linear"===this._releaseCurve?this._sig.linearRampTo(0,n,e):"exponential"===this._releaseCurve?this._sig.targetRampTo(0,n,e):(s=this._releaseCurve,t.isArray(s)&&(this._sig.cancelAndHoldAtTime(e),this._sig.setValueCurveAtTime(s,e,n,i)))),this},t.Envelope.prototype.getValueAtTime=function(t){return this._sig.getValueAtTime(t)},t.Envelope.prototype.triggerAttackRelease=function(t,e,i){return e=this.toSeconds(e),this.triggerAttack(e,i),this.triggerRelease(e+this.toSeconds(t)),this},t.Envelope.prototype.cancel=function(t){return this._sig.cancelScheduledValues(t),this},t.Envelope.prototype.connect=t.SignalBase.prototype.connect,function(){function e(t){var e,i=new Array(t.length);for(e=0;e<t.length;e++)i[e]=1-t[e];return i}var i,n,s,o,r,a,h,l,u,c,p,d=128,f=[];for(i=0;i<d;i++)f[i]=Math.sin(i/(d-1)*(Math.PI/2));for(s=[],o=6.4,i=0;i<d-1;i++)n=i/(d-1),r=Math.sin(n*(2*Math.PI)*o-Math.PI/2)+1,s[i]=r/10+.83*n;for(s[d-1]=1,a=[],h=5,i=0;i<d;i++)a[i]=Math.ceil(i/(d-1)*h)/h;for(l=[],i=0;i<d;i++)n=i/(d-1),l[i]=.5*(1-Math.cos(Math.PI*n));for(u=[],i=0;i<d;i++)n=i/(d-1),c=4*Math.pow(n,3)+.2,p=Math.cos(c*Math.PI*2*n),u[i]=Math.abs(p*(1-n));t.Envelope.Type={linear:"linear",exponential:"exponential",bounce:{In:e(u),Out:u},cosine:{In:f,Out:function(t){return t.slice(0).reverse()}(f)},step:{In:a,Out:e(a)},ripple:{In:s,Out:e(s)},sine:{In:l,Out:e(l)}}}(),t.Envelope.prototype.dispose=function(){return t.AudioNode.prototype.dispose.call(this),this._sig.dispose(),this._sig=null,this._attackCurve=null,this._releaseCurve=null,this},t.Envelope}),t(function(t){return t.AmplitudeEnvelope=function(){t.Envelope.apply(this,arguments),this.input=this.output=new t.Gain,this._sig.connect(this.output.gain)},t.extend(t.AmplitudeEnvelope,t.Envelope),t.AmplitudeEnvelope.prototype.dispose=function(){return t.Envelope.prototype.dispose.call(this),this},t.AmplitudeEnvelope}),t(function(t){t.supported&&(AnalyserNode.prototype.getFloatTimeDomainData||(AnalyserNode.prototype.getFloatTimeDomainData=function(t){var e,i=new Uint8Array(t.length);for(this.getByteTimeDomainData(i),e=0;e<i.length;e++)t[e]=(i[e]-128)/128}))}),t(function(t){return t.Analyser=function(){var e=t.defaults(arguments,["type","size"],t.Analyser);t.AudioNode.call(this),this._analyser=this.input=this.output=this.context.createAnalyser(),this._type=e.type,this._buffer=null,this.size=e.size,this.type=e.type},t.extend(t.Analyser,t.AudioNode),t.Analyser.defaults={size:1024,type:"fft",smoothing:.8},t.Analyser.Type={Waveform:"waveform",FFT:"fft"},t.Analyser.prototype.getValue=function(){return this._type===t.Analyser.Type.FFT?this._analyser.getFloatFrequencyData(this._buffer):this._type===t.Analyser.Type.Waveform&&this._analyser.getFloatTimeDomainData(this._buffer),this._buffer},Object.defineProperty(t.Analyser.prototype,"size",{get:function(){return this._analyser.frequencyBinCount},set:function(t){this._analyser.fftSize=2*t,this._buffer=new Float32Array(t)}}),Object.defineProperty(t.Analyser.prototype,"type",{get:function(){return this._type},set:function(e){if(e!==t.Analyser.Type.Waveform&&e!==t.Analyser.Type.FFT)throw new TypeError("Tone.Analyser: invalid type: "+e);this._type=e}}),Object.defineProperty(t.Analyser.prototype,"smoothing",{get:function(){return this._analyser.smoothingTimeConstant},set:function(t){this._analyser.smoothingTimeConstant=t}}),t.Analyser.prototype.dispose=function(){t.AudioNode.prototype.dispose.call(this),this._analyser.disconnect(),this._analyser=null,this._buffer=null},t.Analyser}),t(function(t){return t.Compressor=function(){var e=t.defaults(arguments,["threshold","ratio"],t.Compressor);t.AudioNode.call(this),this._compressor=this.input=this.output=this.context.createDynamicsCompressor(),this.threshold=new t.Param({param:this._compressor.threshold,units:t.Type.Decibels,convert:!1}),this.attack=new t.Param(this._compressor.attack,t.Type.Time),this.release=new t.Param(this._compressor.release,t.Type.Time),this.knee=new t.Param({param:this._compressor.knee,units:t.Type.Decibels,convert:!1}),this.ratio=new t.Param({param:this._compressor.ratio,convert:!1}),this._readOnly(["knee","release","attack","ratio","threshold"]),this.set(e)},t.extend(t.Compressor,t.AudioNode),t.Compressor.defaults={ratio:12,threshold:-24,release:.25,attack:.003,knee:30},t.Compressor.prototype.dispose=function(){return t.AudioNode.prototype.dispose.call(this),this._writable(["knee","release","attack","ratio","threshold"]),this._compressor.disconnect(),this._compressor=null,this.attack.dispose(),this.attack=null,this.release.dispose(),this.release=null,this.threshold.dispose(),this.threshold=null,this.ratio.dispose(),this.ratio=null,this.knee.dispose(),this.knee=null,this},t.Compressor}),t(function(t){return t.Add=function(e){t.Signal.call(this),this.createInsOuts(2,0),this._sum=this.input[0]=this.input[1]=this.output=new t.Gain,this._param=this.input[1]=new t.Signal(e),this._param.connect(this._sum)},t.extend(t.Add,t.Signal),t.Add.prototype.dispose=function(){return t.Signal.prototype.dispose.call(this),this._sum.dispose(),this._sum=null,this},t.Add}),t(function(t){return t.Multiply=function(e){t.Signal.call(this),this.createInsOuts(2,0),this._mult=this.input[0]=this.output=new t.Gain,this._param=this.input[1]=this.output.gain,this.value=t.defaultArg(e,0)},t.extend(t.Multiply,t.Signal),t.Multiply.prototype.dispose=function(){return t.Signal.prototype.dispose.call(this),this._mult.dispose(),this._mult=null,this._param=null,this},t.Multiply}),t(function(t){return t.Negate=function(){t.SignalBase.call(this),this._multiply=this.input=this.output=new t.Multiply(-1)},t.extend(t.Negate,t.SignalBase),t.Negate.prototype.dispose=function(){return t.SignalBase.prototype.dispose.call(this),this._multiply.dispose(),this._multiply=null,this},t.Negate}),t(function(t){return t.Subtract=function(e){t.Signal.call(this),this.createInsOuts(2,0),this._sum=this.input[0]=this.output=new t.Gain,this._neg=new t.Negate,this._param=this.input[1]=new t.Signal(e),this._param.chain(this._neg,this._sum)},t.extend(t.Subtract,t.Signal),t.Subtract.prototype.dispose=function(){return t.Signal.prototype.dispose.call(this),this._neg.dispose(),this._neg=null,this._sum.disconnect(),this._sum=null,this},t.Subtract}),t(function(t){return t.EqualPowerGain=function(){t.SignalBase.call(this),this._eqPower=this.input=this.output=new t.WaveShaper(function(e){return Math.abs(e)<.001?0:t.equalPowerScale(e)}.bind(this),4096)},t.extend(t.EqualPowerGain,t.SignalBase),t.EqualPowerGain.prototype.dispose=function(){return t.SignalBase.prototype.dispose.call(this),this._eqPower.dispose(),this._eqPower=null,this},t.EqualPowerGain}),t(function(t){return t.CrossFade=function(e){t.AudioNode.call(this),this.createInsOuts(2,1),this.a=this.input[0]=new t.Gain,this.b=this.input[1]=new t.Gain,this.fade=new t.Signal(t.defaultArg(e,.5),t.Type.NormalRange),this._equalPowerA=new t.EqualPowerGain,this._equalPowerB=new t.EqualPowerGain,this._one=this.context.getConstant(1),this._invert=new t.Subtract,this.a.connect(this.output),this.b.connect(this.output),this.fade.chain(this._equalPowerB,this.b.gain),this._one.connect(this._invert,0,0),this.fade.connect(this._invert,0,1),this._invert.chain(this._equalPowerA,this.a.gain),this._readOnly("fade")},t.extend(t.CrossFade,t.AudioNode),t.CrossFade.prototype.dispose=function(){return t.AudioNode.prototype.dispose.call(this),this._writable("fade"),this._equalPowerA.dispose(),this._equalPowerA=null,this._equalPowerB.dispose(),this._equalPowerB=null,this.fade.dispose(),this.fade=null,this._invert.dispose(),this._invert=null,this._one=null,this.a.dispose(),this.a=null,this.b.dispose(),this.b=null,this},t.CrossFade}),t(function(t){return t.Filter=function(){var e=t.defaults(arguments,["frequency","type","rolloff"],t.Filter);t.AudioNode.call(this),this.createInsOuts(1,1),this._filters=[],this.frequency=new t.Signal(e.frequency,t.Type.Frequency),this.detune=new t.Signal(0,t.Type.Cents),this.gain=new t.Signal({value:e.gain,convert:!1}),this.Q=new t.Signal(e.Q),this._type=e.type,this._rolloff=e.rolloff,this.rolloff=e.rolloff,this._readOnly(["detune","frequency","gain","Q"])},t.extend(t.Filter,t.AudioNode),t.Filter.defaults={type:"lowpass",frequency:350,rolloff:-12,Q:1,gain:0},Object.defineProperty(t.Filter.prototype,"type",{get:function(){return this._type},set:function(t){var e;if(-1===["lowpass","highpass","bandpass","lowshelf","highshelf","notch","allpass","peaking"].indexOf(t))throw new TypeError("Tone.Filter: invalid type "+t);for(this._type=t,e=0;e<this._filters.length;e++)this._filters[e].type=t}}),Object.defineProperty(t.Filter.prototype,"rolloff",{get:function(){return this._rolloff},set:function(e){var i,n,s,o,r,a;if(e=parseInt(e,10),i=[-12,-24,-48,-96],-1===(n=i.indexOf(e)))throw new RangeError("Tone.Filter: rolloff can only be -12, -24, -48 or -96");for(n+=1,this._rolloff=e,this.input.disconnect(),s=0;s<this._filters.length;s++)this._filters[s].disconnect(),this._filters[s]=null;for(this._filters=new Array(n),o=0;o<n;o++)r=this.context.createBiquadFilter(),r.type=this._type,this.frequency.connect(r.frequency),this.detune.connect(r.detune),this.Q.connect(r.Q),this.gain.connect(r.gain),this._filters[o]=r;a=[this.input].concat(this._filters).concat([this.output]),t.connectSeries.apply(t,a)}}),t.Filter.prototype.dispose=function(){t.AudioNode.prototype.dispose.call(this);for(var e=0;e<this._filters.length;e++)this._filters[e].disconnect(),this._filters[e]=null;return this._filters=null,this._writable(["detune","frequency","gain","Q"]),this.frequency.dispose(),this.Q.dispose(),this.frequency=null,this.Q=null,this.detune.dispose(),this.detune=null,this.gain.dispose(),this.gain=null,this},t.Filter}),t(function(t){return t.MultibandSplit=function(){var e=t.defaults(arguments,["lowFrequency","highFrequency"],t.MultibandSplit);t.AudioNode.call(this),this.input=new t.Gain,this.output=new Array(3),this.low=this.output[0]=new t.Filter(0,"lowpass"),this._lowMidFilter=new t.Filter(0,"highpass"),this.mid=this.output[1]=new t.Filter(0,"lowpass"),this.high=this.output[2]=new t.Filter(0,"highpass"),this.lowFrequency=new t.Signal(e.lowFrequency,t.Type.Frequency),this.highFrequency=new t.Signal(e.highFrequency,t.Type.Frequency),this.Q=new t.Signal(e.Q),this.input.fan(this.low,this.high),this.input.chain(this._lowMidFilter,this.mid),this.lowFrequency.connect(this.low.frequency),this.lowFrequency.connect(this._lowMidFilter.frequency),this.highFrequency.connect(this.mid.frequency),this.highFrequency.connect(this.high.frequency),this.Q.connect(this.low.Q),this.Q.connect(this._lowMidFilter.Q),this.Q.connect(this.mid.Q),this.Q.connect(this.high.Q),this._readOnly(["high","mid","low","highFrequency","lowFrequency"])},t.extend(t.MultibandSplit,t.AudioNode),t.MultibandSplit.defaults={lowFrequency:400,highFrequency:2500,Q:1},t.MultibandSplit.prototype.dispose=function(){return t.AudioNode.prototype.dispose.call(this),this._writable(["high","mid","low","highFrequency","lowFrequency"]),this.low.dispose(),this.low=null,this._lowMidFilter.dispose(),this._lowMidFilter=null,this.mid.dispose(),this.mid=null,this.high.dispose(),this.high=null,this.lowFrequency.dispose(),this.lowFrequency=null,this.highFrequency.dispose(),this.highFrequency=null,this.Q.dispose(),this.Q=null,this},t.MultibandSplit}),t(function(t){return t.EQ3=function(){var e=t.defaults(arguments,["low","mid","high"],t.EQ3);t.AudioNode.call(this),this.output=new t.Gain,this._multibandSplit=this.input=new t.MultibandSplit({lowFrequency:e.lowFrequency,highFrequency:e.highFrequency}),this._lowGain=new t.Gain(e.low,t.Type.Decibels),this._midGain=new t.Gain(e.mid,t.Type.Decibels),this._highGain=new t.Gain(e.high,t.Type.Decibels),this.low=this._lowGain.gain,this.mid=this._midGain.gain,this.high=this._highGain.gain,this.Q=this._multibandSplit.Q,this.lowFrequency=this._multibandSplit.lowFrequency,this.highFrequency=this._multibandSplit.highFrequency,this._multibandSplit.low.chain(this._lowGain,this.output),this._multibandSplit.mid.chain(this._midGain,this.output),this._multibandSplit.high.chain(this._highGain,this.output),this._readOnly(["low","mid","high","lowFrequency","highFrequency"])},t.extend(t.EQ3,t.AudioNode),t.EQ3.defaults={low:0,mid:0,high:0,lowFrequency:400,highFrequency:2500},t.EQ3.prototype.dispose=function(){return t.AudioNode.prototype.dispose.call(this),this._writable(["low","mid","high","lowFrequency","highFrequency"]),this._multibandSplit.dispose(),this._multibandSplit=null,this.lowFrequency=null,this.highFrequency=null,this._lowGain.dispose(),this._lowGain=null,this._midGain.dispose(),this._midGain=null,this._highGain.dispose(),this._highGain=null,this.low=null,this.mid=null,this.high=null,this.Q=null,this},t.EQ3}),t(function(t){return t.Scale=function(e,i){t.SignalBase.call(this),this._outputMin=t.defaultArg(e,0),this._outputMax=t.defaultArg(i,1),this._scale=this.input=new t.Multiply(1),this._add=this.output=new t.Add(0),this._scale.connect(this._add),this._setRange()},t.extend(t.Scale,t.SignalBase),Object.defineProperty(t.Scale.prototype,"min",{get:function(){return this._outputMin},set:function(t){this._outputMin=t,this._setRange()}}),Object.defineProperty(t.Scale.prototype,"max",{get:function(){return this._outputMax},set:function(t){this._outputMax=t,this._setRange()}}),t.Scale.prototype._setRange=function(){this._add.value=this._outputMin,this._scale.value=this._outputMax-this._outputMin},t.Scale.prototype.dispose=function(){return t.SignalBase.prototype.dispose.call(this),this._add.dispose(),this._add=null,this._scale.dispose(),this._scale=null,this},t.Scale}),t(function(t){return t.ScaleExp=function(e,i,n){t.SignalBase.call(this),this._scale=this.output=new t.Scale(e,i),this._exp=this.input=new t.Pow(t.defaultArg(n,2)),this._exp.connect(this._scale)},t.extend(t.ScaleExp,t.SignalBase),Object.defineProperty(t.ScaleExp.prototype,"exponent",{get:function(){return this._exp.value},set:function(t){this._exp.value=t}}),Object.defineProperty(t.ScaleExp.prototype,"min",{get:function(){return this._scale.min},set:function(t){this._scale.min=t}}),Object.defineProperty(t.ScaleExp.prototype,"max",{get:function(){return this._scale.max},set:function(t){this._scale.max=t}}),t.ScaleExp.prototype.dispose=function(){return t.SignalBase.prototype.dispose.call(this),this._scale.dispose(),this._scale=null,this._exp.dispose(),this._exp=null,this},t.ScaleExp}),t(function(t){return t.Delay=function(){var e=t.defaults(arguments,["delayTime","maxDelay"],t.Delay);t.AudioNode.call(this),this._maxDelay=Math.max(this.toSeconds(e.maxDelay),this.toSeconds(e.delayTime)),this._delayNode=this.input=this.output=this.context.createDelay(this._maxDelay),this.delayTime=new t.Param({param:this._delayNode.delayTime,units:t.Type.Time,value:e.delayTime}),this._readOnly("delayTime")},t.extend(t.Delay,t.AudioNode),t.Delay.defaults={maxDelay:1,delayTime:0},Object.defineProperty(t.Delay.prototype,"maxDelay",{get:function(){return this._maxDelay}}),t.Delay.prototype.dispose=function(){return t.AudioNode.prototype.dispose.call(this),this._delayNode.disconnect(),this._delayNode=null,this._writable("delayTime"),this.delayTime=null,this},t.Delay}),t(function(t){return t.FeedbackCombFilter=function(){var e=t.defaults(arguments,["delayTime","resonance"],t.FeedbackCombFilter);t.AudioNode.call(this),this._delay=this.input=this.output=new t.Delay(e.delayTime),this.delayTime=this._delay.delayTime,this._feedback=new t.Gain(e.resonance,t.Type.NormalRange),this.resonance=this._feedback.gain,this._delay.chain(this._feedback,this._delay),this._readOnly(["resonance","delayTime"])},t.extend(t.FeedbackCombFilter,t.AudioNode),t.FeedbackCombFilter.defaults={delayTime:.1,resonance:.5},t.FeedbackCombFilter.prototype.dispose=function(){return t.AudioNode.prototype.dispose.call(this),this._writable(["resonance","delayTime"]),this._delay.dispose(),this._delay=null,this.delayTime=null,this._feedback.dispose(),this._feedback=null,this.resonance=null,this},t.FeedbackCombFilter}),t(function(t){return t.FFT=function(){var e=t.defaults(arguments,["size"],t.FFT);e.type=t.Analyser.Type.FFT,t.AudioNode.call(this),this._analyser=this.input=this.output=new t.Analyser(e)},t.extend(t.FFT,t.AudioNode),t.FFT.defaults={size:1024},t.FFT.prototype.getValue=function(){return this._analyser.getValue()},Object.defineProperty(t.FFT.prototype,"size",{get:function(){return this._analyser.size},set:function(t){this._analyser.size=t}}),t.FFT.prototype.dispose=function(){t.AudioNode.prototype.dispose.call(this),this._analyser.dispose(),this._analyser=null},t.FFT}),t(function(t){return t.Abs=function(){t.SignalBase.call(this),this._abs=this.input=this.output=new t.WaveShaper(function(t){return Math.abs(t)<.001?0:Math.abs(t)},1024)},t.extend(t.Abs,t.SignalBase),t.Abs.prototype.dispose=function(){return t.SignalBase.prototype.dispose.call(this),this._abs.dispose(),this._abs=null,this},t.Abs}),t(function(t){return t.Follower=function(){var e=t.defaults(arguments,["attack","release"],t.Follower);t.AudioNode.call(this),this.createInsOuts(1,1),this._abs=new t.Abs,this._filter=this.context.createBiquadFilter(),this._filter.type="lowpass",this._filter.frequency.value=0,this._filter.Q.value=-100,this._frequencyValues=new t.WaveShaper,this._sub=new t.Subtract,this._delay=new t.Delay(this.blockTime),this._mult=new t.Multiply(1e4),this._attack=e.attack,this._release=e.release,this.input.chain(this._abs,this._filter,this.output),this._abs.connect(this._sub,0,1),this._filter.chain(this._delay,this._sub),this._sub.chain(this._mult,this._frequencyValues,this._filter.frequency),this._setAttackRelease(this._attack,this._release)},t.extend(t.Follower,t.AudioNode),t.Follower.defaults={attack:.05,release:.5},t.Follower.prototype._setAttackRelease=function(e,i){var n=this.blockTime;e=t.Time(e).toFrequency(),i=t.Time(i).toFrequency(),e=Math.max(e,n),i=Math.max(i,n),this._frequencyValues.setMap(function(t){return t<=0?e:i})},Object.defineProperty(t.Follower.prototype,"attack",{get:function(){return this._attack},set:function(t){this._attack=t,this._setAttackRelease(this._attack,this._release)}}),Object.defineProperty(t.Follower.prototype,"release",{get:function(){return this._release},set:function(t){this._release=t,this._setAttackRelease(this._attack,this._release)}}),t.Follower.prototype.connect=t.SignalBase.prototype.connect,t.Follower.prototype.dispose=function(){return t.AudioNode.prototype.dispose.call(this),this._filter.disconnect(),this._filter=null,this._frequencyValues.disconnect(),this._frequencyValues=null,this._delay.dispose(),this._delay=null,this._sub.disconnect(),this._sub=null,this._abs.dispose(),this._abs=null,this._mult.dispose(),this._mult=null,this._curve=null,this},t.Follower}),t(function(t){return t.ScaledEnvelope=function(){var e=t.defaults(arguments,["attack","decay","sustain","release"],t.Envelope);t.Envelope.call(this,e),e=t.defaultArg(e,t.ScaledEnvelope.defaults),this._exp=this.output=new t.Pow(e.exponent),this._scale=this.output=new t.Scale(e.min,e.max),this._sig.chain(this._exp,this._scale)},t.extend(t.ScaledEnvelope,t.Envelope),t.ScaledEnvelope.defaults={min:0,max:1,exponent:1},Object.defineProperty(t.ScaledEnvelope.prototype,"min",{get:function(){return this._scale.min},set:function(t){this._scale.min=t}}),Object.defineProperty(t.ScaledEnvelope.prototype,"max",{get:function(){return this._scale.max},set:function(t){this._scale.max=t}}),Object.defineProperty(t.ScaledEnvelope.prototype,"exponent",{get:function(){return this._exp.value},set:function(t){this._exp.value=t}}),
t.ScaledEnvelope.prototype.dispose=function(){return t.Envelope.prototype.dispose.call(this),this._scale.dispose(),this._scale=null,this._exp.dispose(),this._exp=null,this},t.ScaledEnvelope}),t(function(t){return t.FrequencyEnvelope=function(){var e=t.defaults(arguments,["attack","decay","sustain","release"],t.Envelope);t.ScaledEnvelope.call(this,e),e=t.defaultArg(e,t.FrequencyEnvelope.defaults),this._octaves=e.octaves,this.baseFrequency=e.baseFrequency,this.octaves=e.octaves},t.extend(t.FrequencyEnvelope,t.Envelope),t.FrequencyEnvelope.defaults={baseFrequency:200,octaves:4,exponent:2},Object.defineProperty(t.FrequencyEnvelope.prototype,"baseFrequency",{get:function(){return this._scale.min},set:function(t){this._scale.min=this.toFrequency(t),this.octaves=this._octaves}}),Object.defineProperty(t.FrequencyEnvelope.prototype,"octaves",{get:function(){return this._octaves},set:function(t){this._octaves=t,this._scale.max=this.baseFrequency*Math.pow(2,t)}}),Object.defineProperty(t.FrequencyEnvelope.prototype,"exponent",{get:function(){return this._exp.value},set:function(t){this._exp.value=t}}),t.FrequencyEnvelope.prototype.dispose=function(){return t.ScaledEnvelope.prototype.dispose.call(this),this},t.FrequencyEnvelope}),t(function(t){return t.GreaterThanZero=function(){t.SignalBase.call(this),this._thresh=this.output=new t.WaveShaper(function(t){return t<=0?0:1},127),this._scale=this.input=new t.Multiply(1e4),this._scale.connect(this._thresh)},t.extend(t.GreaterThanZero,t.SignalBase),t.GreaterThanZero.prototype.dispose=function(){return t.SignalBase.prototype.dispose.call(this),this._scale.dispose(),this._scale=null,this._thresh.dispose(),this._thresh=null,this},t.GreaterThanZero}),t(function(t){return t.GreaterThan=function(e){t.Signal.call(this),this.createInsOuts(2,0),this._param=this.input[0]=new t.Subtract(e),this.input[1]=this._param.input[1],this._gtz=this.output=new t.GreaterThanZero,this._param.connect(this._gtz)},t.extend(t.GreaterThan,t.Signal),t.GreaterThan.prototype.dispose=function(){return t.Signal.prototype.dispose.call(this),this._gtz.dispose(),this._gtz=null,this},t.GreaterThan}),t(function(t){return t.Gate=function(){var e=t.defaults(arguments,["threshold","attack","release"],t.Gate);t.AudioNode.call(this),this.createInsOuts(1,1),this._follower=new t.Follower(e.attack,e.release),this._gt=new t.GreaterThan(t.dbToGain(e.threshold)),this.input.connect(this.output),this.input.chain(this._gt,this._follower,this.output.gain)},t.extend(t.Gate,t.AudioNode),t.Gate.defaults={attack:.1,release:.1,threshold:-40},Object.defineProperty(t.Gate.prototype,"threshold",{get:function(){return t.gainToDb(this._gt.value)},set:function(e){this._gt.value=t.dbToGain(e)}}),Object.defineProperty(t.Gate.prototype,"attack",{get:function(){return this._follower.attack},set:function(t){this._follower.attack=t}}),Object.defineProperty(t.Gate.prototype,"release",{get:function(){return this._follower.release},set:function(t){this._follower.release=t}}),t.Gate.prototype.dispose=function(){return t.AudioNode.prototype.dispose.call(this),this._follower.dispose(),this._gt.dispose(),this._follower=null,this._gt=null,this},t.Gate}),t(function(t){function e(t){return function(e,i){var n,s,o;return i=this.toSeconds(i),t.apply(this,arguments),n=this._events.get(i),s=this._events.previousEvent(n),o=this._getTicksUntilEvent(s,i),n.ticks=Math.max(o,0),this}}return t.TickSignal=function(e){e=t.defaultArg(e,1),t.Signal.call(this,{units:t.Type.Ticks,value:e}),this._events.memory=1/0,this.cancelScheduledValues(0),this._events.add({type:t.Param.AutomationType.SetValue,time:0,value:e})},t.extend(t.TickSignal,t.Signal),t.TickSignal.prototype.setValueAtTime=e(t.Signal.prototype.setValueAtTime),t.TickSignal.prototype.linearRampToValueAtTime=e(t.Signal.prototype.linearRampToValueAtTime),t.TickSignal.prototype.setTargetAtTime=function(t,e,i){var n,s,o,r,a;for(e=this.toSeconds(e),this.setRampPoint(e),t=this._fromUnits(t),n=this._events.get(e),s=Math.round(Math.max(1/i,1)),o=0;o<=s;o++)r=i*o+e,a=this._exponentialApproach(n.time,n.value,t,i,r),this.linearRampToValueAtTime(this._toUnits(a),r);return this},t.TickSignal.prototype.exponentialRampToValueAtTime=function(t,e){var i,n,s,o,r,a;for(e=this.toSeconds(e),t=this._fromUnits(t),i=this._events.get(e),null===i&&(i={value:this._initialValue,time:0}),n=Math.round(Math.max(10*(e-i.time),1)),s=(e-i.time)/n,o=0;o<=n;o++)r=s*o+i.time,a=this._exponentialInterpolate(i.time,i.value,e,t,r),this.linearRampToValueAtTime(this._toUnits(a),r);return this},t.TickSignal.prototype._getTicksUntilEvent=function(e,i){var n,s,o;return null===e?e={ticks:0,time:0}:t.isUndef(e.ticks)&&(n=this._events.previousEvent(e),e.ticks=this._getTicksUntilEvent(n,e.time)),s=this.getValueAtTime(e.time),o=this.getValueAtTime(i),this._events.get(i).time===i&&this._events.get(i).type===t.Param.AutomationType.SetValue&&(o=this.getValueAtTime(i-this.sampleTime)),.5*(i-e.time)*(s+o)+e.ticks},t.TickSignal.prototype.getTicksAtTime=function(t){t=this.toSeconds(t);var e=this._events.get(t);return Math.max(this._getTicksUntilEvent(e,t),0)},t.TickSignal.prototype.getDurationOfTicks=function(t,e){e=this.toSeconds(e);var i=this.getTicksAtTime(e);return this.getTimeOfTick(i+t)-e},t.TickSignal.prototype.getTimeOfTick=function(e){var i,n,s,o,r,a,h=this._events.get(e,"ticks"),l=this._events.getAfter(e,"ticks");return h&&h.ticks===e?h.time:h&&l&&l.type===t.Param.AutomationType.Linear&&h.value!==l.value?(i=this.getValueAtTime(h.time),n=this.getValueAtTime(l.time),s=(n-i)/(l.time-h.time),o=Math.sqrt(Math.pow(i,2)-2*s*(h.ticks-e)),r=(-i+o)/s,a=(-i-o)/s,(r>0?r:a)+h.time):h?0===h.value?1/0:h.time+(e-h.ticks)/h.value:e/this._initialValue},t.TickSignal.prototype.ticksToTime=function(e,i){return i=this.toSeconds(i),new t.Time(this.getDurationOfTicks(e,i))},t.TickSignal.prototype.timeToTicks=function(e,i){var n,s;return i=this.toSeconds(i),e=this.toSeconds(e),n=this.getTicksAtTime(i),s=this.getTicksAtTime(i+e),new t.Ticks(s-n)},t.TickSignal}),t(function(t){return t.TimelineState=function(e){t.Timeline.call(this),this._initial=e},t.extend(t.TimelineState,t.Timeline),t.TimelineState.prototype.getValueAtTime=function(t){var e=this.get(t);return null!==e?e.state:this._initial},t.TimelineState.prototype.setStateAtTime=function(t,e){return this.add({state:t,time:e}),this},t.TimelineState.prototype.getLastState=function(t,e){var i,n,s;for(e=this.toSeconds(e),i=this._search(e),n=i;n>=0;n--)if(s=this._timeline[n],s.state===t)return s},t.TimelineState.prototype.getNextState=function(t,e){var i,n,s;if(e=this.toSeconds(e),-1!==(i=this._search(e)))for(n=i;n<this._timeline.length;n++)if(s=this._timeline[n],s.state===t)return s},t.TimelineState}),t(function(t){return t.TickSource=function(){var e=t.defaults(arguments,["frequency"],t.TickSource);this.frequency=new t.TickSignal(e.frequency,t.Type.Frequency),this._readOnly("frequency"),this._state=new t.TimelineState(t.State.Stopped),this._state.setStateAtTime(t.State.Stopped,0),this._tickOffset=new t.Timeline,this.setTicksAtTime(0,0)},t.extend(t.TickSource),t.TickSource.defaults={frequency:1},Object.defineProperty(t.TickSource.prototype,"state",{get:function(){return this._state.getValueAtTime(this.now())}}),t.TickSource.prototype.start=function(e,i){return e=this.toSeconds(e),this._state.getValueAtTime(e)!==t.State.Started&&(this._state.setStateAtTime(t.State.Started,e),t.isDefined(i)&&this.setTicksAtTime(i,e)),this},t.TickSource.prototype.stop=function(e){if(e=this.toSeconds(e),this._state.getValueAtTime(e)===t.State.Stopped){var i=this._state.get(e);i.time>0&&(this._tickOffset.cancel(i.time),this._state.cancel(i.time))}return this._state.cancel(e),this._state.setStateAtTime(t.State.Stopped,e),this.setTicksAtTime(0,e),this},t.TickSource.prototype.pause=function(e){return e=this.toSeconds(e),this._state.getValueAtTime(e)===t.State.Started&&this._state.setStateAtTime(t.State.Paused,e),this},t.TickSource.prototype.cancel=function(t){return t=this.toSeconds(t),this._state.cancel(t),this._tickOffset.cancel(t),this},t.TickSource.prototype.getTicksAtTime=function(e){var i,n,s,o;return e=this.toSeconds(e),i=this._state.getLastState(t.State.Stopped,e),n={state:t.State.Paused,time:e},this._state.add(n),s=i,o=0,this._state.forEachBetween(i.time,e+this.sampleTime,function(e){var i=s.time,n=this._tickOffset.get(e.time);n.time>=s.time&&(o=n.ticks,i=n.time),s.state===t.State.Started&&e.state!==t.State.Started&&(o+=this.frequency.getTicksAtTime(e.time)-this.frequency.getTicksAtTime(i)),s=e}.bind(this)),this._state.remove(n),o},Object.defineProperty(t.TickSource.prototype,"ticks",{get:function(){return this.getTicksAtTime(this.now())},set:function(t){this.setTicksAtTime(t,this.now())}}),Object.defineProperty(t.TickSource.prototype,"seconds",{get:function(){return this.getSecondsAtTime(this.now())},set:function(t){var e=this.now(),i=this.frequency.timeToTicks(t,e);this.setTicksAtTime(i,e)}}),t.TickSource.prototype.getSecondsAtTime=function(e){var i,n,s,o;return e=this.toSeconds(e),i=this._state.getLastState(t.State.Stopped,e),n={state:t.State.Paused,time:e},this._state.add(n),s=i,o=0,this._state.forEachBetween(i.time,e+this.sampleTime,function(e){var i=s.time,n=this._tickOffset.get(e.time);n.time>=s.time&&(o=n.seconds,i=n.time),s.state===t.State.Started&&e.state!==t.State.Started&&(o+=e.time-i),s=e}.bind(this)),this._state.remove(n),o},t.TickSource.prototype.setTicksAtTime=function(t,e){return e=this.toSeconds(e),this._tickOffset.cancel(e),this._tickOffset.add({time:e,ticks:t,seconds:this.frequency.getDurationOfTicks(t,e)}),this},t.TickSource.prototype.getStateAtTime=function(t){return t=this.toSeconds(t),this._state.getValueAtTime(t)},t.TickSource.prototype.getTimeOfTick=function(e,i){var n,s,o,r;return i=t.defaultArg(i,this.now()),n=this._tickOffset.get(i),s=this._state.get(i),o=Math.max(n.time,s.time),r=this.frequency.getTicksAtTime(o)+e-n.ticks,this.frequency.getTimeOfTick(r)},t.TickSource.prototype.forEachTickBetween=function(e,i,n){var s,o,r,a,h,l,u=this._state.get(e);if(this._state.forEachBetween(e,i,function(i){u.state===t.State.Started&&i.state!==t.State.Started&&this.forEachTickBetween(Math.max(u.time,e),i.time-this.sampleTime,n),u=i}.bind(this)),e=Math.max(u.time,e),u.state===t.State.Started&&this._state)for(s=this.frequency.getTicksAtTime(e),o=this.frequency.getTicksAtTime(u.time),r=s-o,a=r%1,0!==a&&(a=1-a),h=this.frequency.getTimeOfTick(s+a),l=null;h<i&&this._state;){try{n(h,Math.round(this.getTicksAtTime(h)))}catch(t){l=t;break}this._state&&(h+=this.frequency.getDurationOfTicks(1,h))}if(l)throw l;return this},t.TickSource.prototype.dispose=function(){return t.Param.prototype.dispose.call(this),this._state.dispose(),this._state=null,this._tickOffset.dispose(),this._tickOffset=null,this._writable("frequency"),this.frequency.dispose(),this.frequency=null,this},t.TickSource}),t(function(t){return t.Clock=function(){var e=t.defaults(arguments,["callback","frequency"],t.Clock);t.Emitter.call(this),this.callback=e.callback,this._nextTick=0,this._tickSource=new t.TickSource(e.frequency),this._lastUpdate=0,this.frequency=this._tickSource.frequency,this._readOnly("frequency"),this._state=new t.TimelineState(t.State.Stopped),this._state.setStateAtTime(t.State.Stopped,0),this._boundLoop=this._loop.bind(this),this.context.on("tick",this._boundLoop)},t.extend(t.Clock,t.Emitter),t.Clock.defaults={callback:t.noOp,frequency:1},Object.defineProperty(t.Clock.prototype,"state",{get:function(){return this._state.getValueAtTime(this.now())}}),t.Clock.prototype.start=function(e,i){return e=this.toSeconds(e),this._state.getValueAtTime(e)!==t.State.Started&&(this._state.setStateAtTime(t.State.Started,e),this._tickSource.start(e,i),e<this._lastUpdate&&this.emit("start",e,i)),this},t.Clock.prototype.stop=function(e){return e=this.toSeconds(e),this._state.cancel(e),this._state.setStateAtTime(t.State.Stopped,e),this._tickSource.stop(e),e<this._lastUpdate&&this.emit("stop",e),this},t.Clock.prototype.pause=function(e){return e=this.toSeconds(e),this._state.getValueAtTime(e)===t.State.Started&&(this._state.setStateAtTime(t.State.Paused,e),this._tickSource.pause(e),e<this._lastUpdate&&this.emit("pause",e)),this},Object.defineProperty(t.Clock.prototype,"ticks",{get:function(){return Math.ceil(this.getTicksAtTime(this.now()))},set:function(t){this._tickSource.ticks=t}}),Object.defineProperty(t.Clock.prototype,"seconds",{get:function(){return this._tickSource.seconds},set:function(t){this._tickSource.seconds=t}}),t.Clock.prototype.getSecondsAtTime=function(t){return this._tickSource.getSecondsAtTime(t)},t.Clock.prototype.setTicksAtTime=function(t,e){return this._tickSource.setTicksAtTime(t,e),this},t.Clock.prototype.getTicksAtTime=function(t){return this._tickSource.getTicksAtTime(t)},t.Clock.prototype.nextTickTime=function(t,e){e=this.toSeconds(e);var i=this.getTicksAtTime(e);return this._tickSource.getTimeOfTick(i+t,e)},t.Clock.prototype._loop=function(){var e=this._lastUpdate,i=this.now();this._lastUpdate=i,e!==i&&(this._state.forEachBetween(e,i,function(e){switch(e.state){case t.State.Started:var i=this._tickSource.getTicksAtTime(e.time);this.emit("start",e.time,i);break;case t.State.Stopped:0!==e.time&&this.emit("stop",e.time);break;case t.State.Paused:this.emit("pause",e.time)}}.bind(this)),this._tickSource.forEachTickBetween(e,i,function(t,e){this.callback(t,e)}.bind(this)))},t.Clock.prototype.getStateAtTime=function(t){return t=this.toSeconds(t),this._state.getValueAtTime(t)},t.Clock.prototype.dispose=function(){t.Emitter.prototype.dispose.call(this),this.context.off("tick",this._boundLoop),this._writable("frequency"),this._tickSource.dispose(),this._tickSource=null,this.frequency=null,this._boundLoop=null,this._nextTick=1/0,this.callback=null,this._state.dispose(),this._state=null},t.Clock}),t(function(t){t.IntervalTimeline=function(){t.call(this),this._root=null,this._length=0},t.extend(t.IntervalTimeline),t.IntervalTimeline.prototype.add=function(i){if(t.isUndef(i.time)||t.isUndef(i.duration))throw new Error("Tone.IntervalTimeline: events must have time and duration parameters");i.time=i.time.valueOf();var n=new e(i.time,i.time+i.duration,i);for(null===this._root?this._root=n:this._root.insert(n),this._length++;null!==n;)n.updateHeight(),n.updateMax(),this._rebalance(n),n=n.parent;return this},t.IntervalTimeline.prototype.remove=function(t){var e,i,n;if(null!==this._root)for(e=[],this._root.search(t.time,e),i=0;i<e.length;i++)if(n=e[i],n.event===t){this._removeNode(n),this._length--;break}return this},Object.defineProperty(t.IntervalTimeline.prototype,"length",{get:function(){return this._length}}),t.IntervalTimeline.prototype.cancel=function(t){return this.forEachFrom(t,function(t){this.remove(t)}.bind(this)),this},t.IntervalTimeline.prototype._setRoot=function(t){this._root=t,null!==this._root&&(this._root.parent=null)},t.IntervalTimeline.prototype._replaceNodeInParent=function(t,e){null!==t.parent?(t.isLeftChild()?t.parent.left=e:t.parent.right=e,this._rebalance(t.parent)):this._setRoot(e)},t.IntervalTimeline.prototype._removeNode=function(t){var e,i;if(null===t.left&&null===t.right)this._replaceNodeInParent(t,null);else if(null===t.right)this._replaceNodeInParent(t,t.left);else if(null===t.left)this._replaceNodeInParent(t,t.right);else{if(t.getBalance()>0)if(null===t.left.right)e=t.left,e.right=t.right,i=e;else{for(e=t.left.right;null!==e.right;)e=e.right;e.parent.right=e.left,i=e.parent,e.left=t.left,e.right=t.right}else if(null===t.right.left)e=t.right,e.left=t.left,i=e;else{for(e=t.right.left;null!==e.left;)e=e.left;e.parent=e.parent,e.parent.left=e.right,i=e.parent,e.left=t.left,e.right=t.right}null!==t.parent?t.isLeftChild()?t.parent.left=e:t.parent.right=e:this._setRoot(e),this._rebalance(i)}t.dispose()},t.IntervalTimeline.prototype._rotateLeft=function(t){var e=t.parent,i=t.isLeftChild(),n=t.right;t.right=n.left,n.left=t,null!==e?i?e.left=n:e.right=n:this._setRoot(n)},t.IntervalTimeline.prototype._rotateRight=function(t){var e=t.parent,i=t.isLeftChild(),n=t.left;t.left=n.right,n.right=t,null!==e?i?e.left=n:e.right=n:this._setRoot(n)},t.IntervalTimeline.prototype._rebalance=function(t){var e=t.getBalance();e>1?t.left.getBalance()<0?this._rotateLeft(t.left):this._rotateRight(t):e<-1&&(t.right.getBalance()>0?this._rotateRight(t.right):this._rotateLeft(t))},t.IntervalTimeline.prototype.get=function(t){var e,i,n;if(null!==this._root&&(e=[],this._root.search(t,e),e.length>0)){for(i=e[0],n=1;n<e.length;n++)e[n].low>i.low&&(i=e[n]);return i.event}return null},t.IntervalTimeline.prototype.forEach=function(t){var e,i,n;if(null!==this._root)for(e=[],this._root.traverse(function(t){e.push(t)}),i=0;i<e.length;i++)(n=e[i].event)&&t(n);return this},t.IntervalTimeline.prototype.forEachAtTime=function(t,e){var i,n,s;if(null!==this._root)for(i=[],this._root.search(t,i),n=i.length-1;n>=0;n--)(s=i[n].event)&&e(s);return this},t.IntervalTimeline.prototype.forEachFrom=function(t,e){var i,n,s;if(null!==this._root)for(i=[],this._root.searchAfter(t,i),n=i.length-1;n>=0;n--)s=i[n].event,e(s);return this},t.IntervalTimeline.prototype.dispose=function(){var t,e=[];for(null!==this._root&&this._root.traverse(function(t){e.push(t)}),t=0;t<e.length;t++)e[t].dispose();return e=null,this._root=null,this};var e=function(t,e,i){this.event=i,this.low=t,this.high=e,this.max=this.high,this._left=null,this._right=null,this.parent=null,this.height=0};return e.prototype.insert=function(t){t.low<=this.low?null===this.left?this.left=t:this.left.insert(t):null===this.right?this.right=t:this.right.insert(t)},e.prototype.search=function(t,e){t>this.max||(null!==this.left&&this.left.search(t,e),this.low<=t&&this.high>t&&e.push(this),this.low>t||null!==this.right&&this.right.search(t,e))},e.prototype.searchAfter=function(t,e){this.low>=t&&(e.push(this),null!==this.left&&this.left.searchAfter(t,e)),null!==this.right&&this.right.searchAfter(t,e)},e.prototype.traverse=function(t){t(this),null!==this.left&&this.left.traverse(t),null!==this.right&&this.right.traverse(t)},e.prototype.updateHeight=function(){null!==this.left&&null!==this.right?this.height=Math.max(this.left.height,this.right.height)+1:null!==this.right?this.height=this.right.height+1:null!==this.left?this.height=this.left.height+1:this.height=0},e.prototype.updateMax=function(){this.max=this.high,null!==this.left&&(this.max=Math.max(this.max,this.left.max)),null!==this.right&&(this.max=Math.max(this.max,this.right.max))},e.prototype.getBalance=function(){var t=0;return null!==this.left&&null!==this.right?t=this.left.height-this.right.height:null!==this.left?t=this.left.height+1:null!==this.right&&(t=-(this.right.height+1)),t},e.prototype.isLeftChild=function(){return null!==this.parent&&this.parent.left===this},Object.defineProperty(e.prototype,"left",{get:function(){return this._left},set:function(t){this._left=t,null!==t&&(t.parent=this),this.updateHeight(),this.updateMax()}}),Object.defineProperty(e.prototype,"right",{get:function(){return this._right},set:function(t){this._right=t,null!==t&&(t.parent=this),this.updateHeight(),this.updateMax()}}),e.prototype.dispose=function(){this.parent=null,this._left=null,this._right=null,this.event=null},t.IntervalTimeline}),t(function(t){return t.Ticks=function(e,i){if(!(this instanceof t.Ticks))return new t.Ticks(e,i);t.TransportTime.call(this,e,i)},t.extend(t.Ticks,t.TransportTime),t.Ticks.prototype._defaultUnits="i",t.Ticks.prototype._now=function(){return t.Transport.ticks},t.Ticks.prototype._beatsToUnits=function(t){return this._getPPQ()*t},t.Ticks.prototype._secondsToUnits=function(t){return t/(60/this._getBpm())*this._getPPQ()},t.Ticks.prototype._ticksToUnits=function(t){return t},t.Ticks.prototype.toTicks=function(){return this.valueOf()},t.Ticks.prototype.toSeconds=function(){return this.valueOf()/this._getPPQ()*(60/this._getBpm())},t.Ticks}),t(function(t){return t.TransportEvent=function(e,i){i=t.defaultArg(i,t.TransportEvent.defaults),t.call(this),this.Transport=e,this.id=t.TransportEvent._eventId++,this.time=t.Ticks(i.time),this.callback=i.callback,this._once=i.once},t.extend(t.TransportEvent),t.TransportEvent.defaults={once:!1,callback:t.noOp},t.TransportEvent._eventId=0,t.TransportEvent.prototype.invoke=function(t){this.callback&&(this.callback(t),this._once&&this.Transport&&this.Transport.clear(this.id))},t.TransportEvent.prototype.dispose=function(){return t.prototype.dispose.call(this),this.Transport=null,this.callback=null,this.time=null,this},t.TransportEvent}),t(function(t){return t.TransportRepeatEvent=function(e,i){t.TransportEvent.call(this,e,i),i=t.defaultArg(i,t.TransportRepeatEvent.defaults),this.duration=t.Ticks(i.duration),this._interval=t.Ticks(i.interval),this._currentId=-1,this._nextId=-1,this._nextTick=this.time,this._boundRestart=this._restart.bind(this),this.Transport.on("start loopStart",this._boundRestart),this._restart()},t.extend(t.TransportRepeatEvent,t.TransportEvent),t.TransportRepeatEvent.defaults={duration:1/0,interval:1},t.TransportRepeatEvent.prototype.invoke=function(e){this._createEvents(e),t.TransportEvent.prototype.invoke.call(this,e)},t.TransportRepeatEvent.prototype._createEvents=function(e){var i=this.Transport.getTicksAtTime(e);i>=this.time&&i>=this._nextTick&&this._nextTick+this._interval<this.time+this.duration&&(this._nextTick+=this._interval,this._currentId=this._nextId,this._nextId=this.Transport.scheduleOnce(this.invoke.bind(this),t.Ticks(this._nextTick)))},t.TransportRepeatEvent.prototype._restart=function(e){this.Transport.clear(this._currentId),this.Transport.clear(this._nextId),this._nextTick=this.time;var i=this.Transport.getTicksAtTime(e);i>this.time&&(this._nextTick=this.time+Math.ceil((i-this.time)/this._interval)*this._interval),this._currentId=this.Transport.scheduleOnce(this.invoke.bind(this),t.Ticks(this._nextTick)),this._nextTick+=this._interval,this._nextId=this.Transport.scheduleOnce(this.invoke.bind(this),t.Ticks(this._nextTick))},t.TransportRepeatEvent.prototype.dispose=function(){return this.Transport.clear(this._currentId),this.Transport.clear(this._nextId),this.Transport.off("start loopStart",this._boundRestart),this._boundCreateEvents=null,t.TransportEvent.prototype.dispose.call(this),this.duration=null,this._interval=null,this},t.TransportRepeatEvent}),t(function(t){t.Transport=function(){t.Emitter.call(this),t.getContext(function(){this.loop=!1,this._loopStart=0,this._loopEnd=0,this._ppq=e.defaults.PPQ,this._clock=new t.Clock({callback:this._processTick.bind(this),frequency:0}),this._bindClockEvents(),this.bpm=this._clock.frequency,this.bpm._toUnits=this._toUnits.bind(this),this.bpm._fromUnits=this._fromUnits.bind(this),this.bpm.units=t.Type.BPM,this.bpm.value=e.defaults.bpm,this._readOnly("bpm"),this._timeSignature=e.defaults.timeSignature,this._scheduledEvents={},this._timeline=new t.Timeline,this._repeatedEvents=new t.IntervalTimeline,this._syncedSignals=[],this._swingTicks=e.defaults.PPQ/2,this._swingAmount=0}.bind(this))},t.extend(t.Transport,t.Emitter),t.Transport.defaults={bpm:120,swing:0,swingSubdivision:"8n",timeSignature:4,loopStart:0,loopEnd:"4m",PPQ:192},t.Transport.prototype._processTick=function(e,i){var n,s;this._swingAmount>0&&i%this._ppq!=0&&i%(2*this._swingTicks)!=0&&(n=i%(2*this._swingTicks)/(2*this._swingTicks),s=Math.sin(n*Math.PI)*this._swingAmount,e+=t.Ticks(2*this._swingTicks/3).toSeconds()*s),this.loop&&i>=this._loopEnd&&(this.emit("loopEnd",e),this._clock.setTicksAtTime(this._loopStart,e),i=this._loopStart,this.emit("loopStart",e,this._clock.getSecondsAtTime(e)),this.emit("loop",e)),this._timeline.forEachAtTime(i,function(t){t.invoke(e)})},t.Transport.prototype.schedule=function(e,i){var n=new t.TransportEvent(this,{time:t.TransportTime(i),callback:e});return this._addEvent(n,this._timeline)},t.Transport.prototype.scheduleRepeat=function(e,i,n,s){var o=new t.TransportRepeatEvent(this,{callback:e,interval:t.Time(i),time:t.TransportTime(n),duration:t.Time(t.defaultArg(s,1/0))});return this._addEvent(o,this._repeatedEvents)},t.Transport.prototype.scheduleOnce=function(e,i){var n=new t.TransportEvent(this,{time:t.TransportTime(i),callback:e,once:!0});return this._addEvent(n,this._timeline)},t.Transport.prototype.clear=function(t){if(this._scheduledEvents.hasOwnProperty(t)){var e=this._scheduledEvents[t.toString()];e.timeline.remove(e.event),e.event.dispose(),delete this._scheduledEvents[t.toString()]}return this},t.Transport.prototype._addEvent=function(t,e){return this._scheduledEvents[t.id.toString()]={event:t,timeline:e},e.add(t),t.id},t.Transport.prototype.cancel=function(e){return e=t.defaultArg(e,0),e=this.toTicks(e),this._timeline.forEachFrom(e,function(t){this.clear(t.id)}.bind(this)),this._repeatedEvents.forEachFrom(e,function(t){this.clear(t.id)}.bind(this)),this},t.Transport.prototype._bindClockEvents=function(){this._clock.on("start",function(e,i){i=t.Ticks(i).toSeconds(),this.emit("start",e,i)}.bind(this)),this._clock.on("stop",function(t){this.emit("stop",t)}.bind(this)),this._clock.on("pause",function(t){this.emit("pause",t)}.bind(this))},Object.defineProperty(t.Transport.prototype,"state",{get:function(){return this._clock.getStateAtTime(this.now())}}),t.Transport.prototype.start=function(e,i){return t.isDefined(i)&&(i=this.toTicks(i)),this._clock.start(e,i),this},t.Transport.prototype.stop=function(t){return this._clock.stop(t),this},t.Transport.prototype.pause=function(t){return this._clock.pause(t),this},t.Transport.prototype.toggle=function(e){return e=this.toSeconds(e),this._clock.getStateAtTime(e)!==t.State.Started?this.start(e):this.stop(e),this},Object.defineProperty(t.Transport.prototype,"timeSignature",{get:function(){return this._timeSignature},set:function(e){t.isArray(e)&&(e=e[0]/e[1]*4),this._timeSignature=e}}),Object.defineProperty(t.Transport.prototype,"loopStart",{get:function(){return t.Ticks(this._loopStart).toSeconds()},set:function(t){this._loopStart=this.toTicks(t)}}),Object.defineProperty(t.Transport.prototype,"loopEnd",{get:function(){return t.Ticks(this._loopEnd).toSeconds()},set:function(t){this._loopEnd=this.toTicks(t)}}),t.Transport.prototype.setLoopPoints=function(t,e){return this.loopStart=t,this.loopEnd=e,this},Object.defineProperty(t.Transport.prototype,"swing",{get:function(){return this._swingAmount},set:function(t){this._swingAmount=t}}),Object.defineProperty(t.Transport.prototype,"swingSubdivision",{get:function(){return t.Ticks(this._swingTicks).toNotation()},set:function(t){this._swingTicks=this.toTicks(t)}}),Object.defineProperty(t.Transport.prototype,"position",{get:function(){var e=this.now(),i=this._clock.getTicksAtTime(e);return t.Ticks(i).toBarsBeatsSixteenths()},set:function(t){var e=this.toTicks(t);this.ticks=e}}),Object.defineProperty(t.Transport.prototype,"seconds",{get:function(){return this._clock.seconds},set:function(t){var e=this.now(),i=this.bpm.timeToTicks(t,e);this.ticks=i}}),Object.defineProperty(t.Transport.prototype,"progress",{get:function(){var t;return this.loop?(t=this.now(),(this._clock.getTicksAtTime(t)-this._loopStart)/(this._loopEnd-this._loopStart)):0}}),Object.defineProperty(t.Transport.prototype,"ticks",{get:function(){return this._clock.ticks},set:function(e){if(this._clock.ticks!==e){var i=this.now();this.state===t.State.Started?(this.emit("stop",i),this._clock.setTicksAtTime(e,i),this.emit("start",i,this.seconds)):this._clock.setTicksAtTime(e,i)}}}),t.Transport.prototype.getTicksAtTime=function(t){return Math.round(this._clock.getTicksAtTime(t))},t.Transport.prototype.getSecondsAtTime=function(t){return this._clock.getSecondsAtTime(t)},Object.defineProperty(t.Transport.prototype,"PPQ",{get:function(){return this._ppq},set:function(t){var e=this.bpm.value;this._ppq=t,this.bpm.value=e}}),t.Transport.prototype._fromUnits=function(t){return 1/(60/t/this.PPQ)},t.Transport.prototype._toUnits=function(t){return t/this.PPQ*60},t.Transport.prototype.nextSubdivision=function(e){var i,n,s;return e=this.toTicks(e),this.state!==t.State.Started?0:(i=this.now(),n=this.getTicksAtTime(i),s=e-n%e,this._clock.nextTickTime(s,i))},t.Transport.prototype.syncSignal=function(e,i){var n,s;return i||(n=this.now(),i=0!==e.getValueAtTime(n)?e.getValueAtTime(n)/this.bpm.getValueAtTime(n):0),s=new t.Gain(i),this.bpm.chain(s,e._param),this._syncedSignals.push({ratio:s,signal:e,initial:e.value}),e.value=0,this},t.Transport.prototype.unsyncSignal=function(t){var e,i;for(e=this._syncedSignals.length-1;e>=0;e--)i=this._syncedSignals[e],i.signal===t&&(i.ratio.dispose(),i.signal.value=i.initial,this._syncedSignals.splice(e,1));return this},t.Transport.prototype.dispose=function(){return t.Emitter.prototype.dispose.call(this),this._clock.dispose(),this._clock=null,this._writable("bpm"),this.bpm=null,this._timeline.dispose(),this._timeline=null,this._repeatedEvents.dispose(),this._repeatedEvents=null,this};var e=t.Transport;return t.Transport=new e,t.Context.on("init",function(i){i.Transport instanceof e?t.Transport=i.Transport:t.Transport=new e,i.Transport=t.Transport}),t.Context.on("close",function(t){t.Transport instanceof e&&t.Transport.dispose()}),t.Transport}),t(function(t){return t.Volume=function(){var e=t.defaults(arguments,["volume"],t.Volume);t.AudioNode.call(this),this.output=this.input=new t.Gain(e.volume,t.Type.Decibels),this._unmutedVolume=e.volume,this.volume=this.output.gain,this._readOnly("volume"),this.mute=e.mute},t.extend(t.Volume,t.AudioNode),t.Volume.defaults={volume:0,mute:!1},Object.defineProperty(t.Volume.prototype,"mute",{get:function(){return this.volume.value===-1/0},set:function(t){!this.mute&&t?(this._unmutedVolume=this.volume.value,this.volume.value=-1/0):this.mute&&!t&&(this.volume.value=this._unmutedVolume)}}),t.Volume.prototype.dispose=function(){return this.input.dispose(),t.AudioNode.prototype.dispose.call(this),this._writable("volume"),this.volume.dispose(),this.volume=null,this},t.Volume}),t(function(t){t.Master=function(){t.AudioNode.call(this),t.getContext(function(){this.createInsOuts(1,0),this._volume=this.output=new t.Volume,this.volume=this._volume.volume,this._readOnly("volume"),this.input.chain(this.output,this.context.destination)}.bind(this))},t.extend(t.Master,t.AudioNode),t.Master.defaults={volume:0,mute:!1},Object.defineProperty(t.Master.prototype,"mute",{get:function(){return this._volume.mute},set:function(t){this._volume.mute=t}}),t.Master.prototype.chain=function(){this.input.disconnect(),this.input.chain.apply(this.input,arguments),arguments[arguments.length-1].connect(this.output)},t.Master.prototype.dispose=function(){t.AudioNode.prototype.dispose.call(this),this._writable("volume"),this._volume.dispose(),this._volume=null,this.volume=null},t.AudioNode.prototype.toMaster=function(){return this.connect(t.Master),this},window.AudioNode&&(AudioNode.prototype.toMaster=function(){return this.connect(t.Master),this});var e=t.Master;return t.Master=new e,t.Context.on("init",function(i){i.Master instanceof e?t.Master=i.Master:t.Master=new e,i.Master=t.Master}),t.Context.on("close",function(t){t.Master instanceof e&&t.Master.dispose()}),t.Master}),t(function(t){return t.Source=function(e){e=t.defaultArg(e,t.Source.defaults),t.AudioNode.call(this),this._volume=this.output=new t.Volume(e.volume),this.volume=this._volume.volume,this._readOnly("volume"),this._state=new t.TimelineState(t.State.Stopped),this._state.memory=100,this._synced=!1,this._scheduled=[],this._volume.output.output.channelCount=2,this._volume.output.output.channelCountMode="explicit",this.mute=e.mute},t.extend(t.Source,t.AudioNode),t.Source.defaults={volume:0,mute:!1},Object.defineProperty(t.Source.prototype,"state",{get:function(){return this._synced?t.Transport.state===t.State.Started?this._state.getValueAtTime(t.Transport.seconds):t.State.Stopped:this._state.getValueAtTime(this.now())}}),Object.defineProperty(t.Source.prototype,"mute",{get:function(){return this._volume.mute},set:function(t){this._volume.mute=t}}),t.Source.prototype._start=t.noOp,t.Source.prototype.restart=t.noOp,
t.Source.prototype._stop=t.noOp,t.Source.prototype.start=function(e,i,n){var s,o;return e=t.isUndef(e)&&this._synced?t.Transport.seconds:this.toSeconds(e),this._state.getValueAtTime(e)===t.State.Started?(this._state.cancel(e),this._state.setStateAtTime(t.State.Started,e),this.restart(e,i,n)):(this._state.setStateAtTime(t.State.Started,e),this._synced?(s=this._state.get(e),s.offset=t.defaultArg(i,0),s.duration=n,o=t.Transport.schedule(function(t){this._start(t,i,n)}.bind(this),e),this._scheduled.push(o),t.Transport.state===t.State.Started&&this._syncedStart(this.now(),t.Transport.seconds)):this._start.apply(this,arguments)),this},t.Source.prototype.stop=function(e){if(e=t.isUndef(e)&&this._synced?t.Transport.seconds:this.toSeconds(e),this._synced){var i=t.Transport.schedule(this._stop.bind(this),e);this._scheduled.push(i)}else this._stop.apply(this,arguments);return this._state.cancel(e),this._state.setStateAtTime(t.State.Stopped,e),this},t.Source.prototype.sync=function(){return this._synced=!0,this._syncedStart=function(e,i){var n,s,o;i>0&&(n=this._state.get(i))&&n.state===t.State.Started&&n.time!==i&&(s=i-this.toSeconds(n.time),n.duration&&(o=this.toSeconds(n.duration)-s),this._start(e,this.toSeconds(n.offset)+s,o))}.bind(this),this._syncedStop=function(e){var i=t.Transport.getSecondsAtTime(Math.max(e-this.sampleTime,0));this._state.getValueAtTime(i)===t.State.Started&&this._stop(e)}.bind(this),t.Transport.on("start loopStart",this._syncedStart),t.Transport.on("stop pause loopEnd",this._syncedStop),this},t.Source.prototype.unsync=function(){var e,i;for(this._synced&&(t.Transport.off("stop pause loopEnd",this._syncedStop),t.Transport.off("start loopStart",this._syncedStart)),this._synced=!1,e=0;e<this._scheduled.length;e++)i=this._scheduled[e],t.Transport.clear(i);return this._scheduled=[],this._state.cancel(0),this},t.Source.prototype.dispose=function(){t.AudioNode.prototype.dispose.call(this),this.unsync(),this._scheduled=null,this._writable("volume"),this._volume.dispose(),this._volume=null,this.volume=null,this._state.dispose(),this._state=null},t.Source}),t(function(t){t.supported&&(AudioBuffer.prototype.copyToChannel||(AudioBuffer.prototype.copyToChannel=function(t,e,i){var n,s=this.getChannelData(e);for(i=i||0,n=0;n<s.length;n++)s[n+i]=t[n]},AudioBuffer.prototype.copyFromChannel=function(t,e,i){var n,s=this.getChannelData(e);for(i=i||0,n=0;n<t.length;n++)t[n]=s[n+i]}))}),t(function(t){return t.Buffer=function(){var e=t.defaults(arguments,["url","onload","onerror"],t.Buffer);t.call(this),this._buffer=null,this._reversed=e.reverse,this._xhr=null,this._onload=t.noOp,e.url instanceof AudioBuffer||e.url instanceof t.Buffer?(this.set(e.url),e.onload&&(this.loaded?e.onload(this):this._onload=e.onload)):t.isString(e.url)&&this.load(e.url).then(e.onload).catch(e.onerror)},t.extend(t.Buffer),t.Buffer.defaults={url:void 0,reverse:!1,onload:t.noOp,onerror:t.noOp},t.Buffer.prototype.set=function(e){return e instanceof t.Buffer?e.loaded?this._buffer=e.get():e._onload=function(){this.set(e),this._onload(this)}.bind(this):this._buffer=e,this},t.Buffer.prototype.get=function(){return this._buffer},t.Buffer.prototype.load=function(e,i,n){return new Promise(function(s,o){this._xhr=t.Buffer.load(e,function(t){this._xhr=null,this.set(t),s(this),this._onload(this),i&&i(this)}.bind(this),function(t){this._xhr=null,o(t),n&&n(t)}.bind(this))}.bind(this))},t.Buffer.prototype.dispose=function(){return t.prototype.dispose.call(this),this._buffer=null,this._xhr&&(t.Buffer._removeFromDownloadQueue(this._xhr),this._xhr.abort(),this._xhr=null),this},Object.defineProperty(t.Buffer.prototype,"loaded",{get:function(){return this.length>0}}),Object.defineProperty(t.Buffer.prototype,"duration",{get:function(){return this._buffer?this._buffer.duration:0}}),Object.defineProperty(t.Buffer.prototype,"length",{get:function(){return this._buffer?this._buffer.length:0}}),Object.defineProperty(t.Buffer.prototype,"numberOfChannels",{get:function(){return this._buffer?this._buffer.numberOfChannels:0}}),t.Buffer.prototype.fromArray=function(t){var e,i=t[0].length>0,n=i?t.length:1,s=i?t[0].length:t.length,o=this.context.createBuffer(n,s,this.context.sampleRate);for(i||1!==n||(t=[t]),e=0;e<n;e++)o.copyToChannel(t[e],e);return this._buffer=o,this},t.Buffer.prototype.toMono=function(e){var i,n,s,o,r;if(t.isNumber(e))this.fromArray(this.toArray(e));else{for(i=new Float32Array(this.length),n=this.numberOfChannels,s=0;s<n;s++)for(o=this.toArray(s),r=0;r<o.length;r++)i[r]+=o[r];i=i.map(function(t){return t/n}),this.fromArray(i)}return this},t.Buffer.prototype.toArray=function(e){var i,n;if(t.isNumber(e))return this.getChannelData(e);if(1===this.numberOfChannels)return this.toArray(0);for(i=[],n=0;n<this.numberOfChannels;n++)i[n]=this.getChannelData(n);return i},t.Buffer.prototype.getChannelData=function(t){return this._buffer.getChannelData(t)},t.Buffer.prototype.slice=function(e,i){var n,s,o,r;for(i=t.defaultArg(i,this.duration),n=Math.floor(this.context.sampleRate*this.toSeconds(e)),s=Math.floor(this.context.sampleRate*this.toSeconds(i)),o=[],r=0;r<this.numberOfChannels;r++)o[r]=this.toArray(r).slice(n,s);return(new t.Buffer).fromArray(o)},t.Buffer.prototype._reverse=function(){if(this.loaded)for(var t=0;t<this.numberOfChannels;t++)Array.prototype.reverse.call(this.getChannelData(t));return this},Object.defineProperty(t.Buffer.prototype,"reverse",{get:function(){return this._reversed},set:function(t){this._reversed!==t&&(this._reversed=t,this._reverse())}}),t.Emitter.mixin(t.Buffer),t.Buffer._downloadQueue=[],t.Buffer.baseUrl="",t.Buffer.fromArray=function(e){return(new t.Buffer).fromArray(e)},t.Buffer.fromUrl=function(e){var i=new t.Buffer;return i.load(e).then(function(){return i})},t.Buffer._removeFromDownloadQueue=function(e){var i=t.Buffer._downloadQueue.indexOf(e);-1!==i&&t.Buffer._downloadQueue.splice(i,1)},t.Buffer.load=function(e,i,n){function s(e){if(t.Buffer._removeFromDownloadQueue(u),t.Buffer.emit("error",e),!n)throw e;n(e)}function o(){var e,i=0;for(e=0;e<t.Buffer._downloadQueue.length;e++)i+=t.Buffer._downloadQueue[e].progress;t.Buffer.emit("progress",i/t.Buffer._downloadQueue.length)}var r,a,h,l,u;if(i=t.defaultArg(i,t.noOp),r=e.match(/\[(.+\|?)+\]$/)){for(a=r[1].split("|"),h=a[0],l=0;l<a.length;l++)if(t.Buffer.supportsType(a[l])){h=a[l];break}e=e.replace(r[0],h)}return u=new XMLHttpRequest,u.open("GET",t.Buffer.baseUrl+e,!0),u.responseType="arraybuffer",u.progress=0,t.Buffer._downloadQueue.push(u),u.addEventListener("load",function(){200===u.status?t.context.decodeAudioData(u.response).then(function(e){u.progress=1,o(),i(e),t.Buffer._removeFromDownloadQueue(u),0===t.Buffer._downloadQueue.length&&t.Buffer.emit("load")}).catch(function(){t.Buffer._removeFromDownloadQueue(u),s("Tone.Buffer: could not decode audio data: "+e)}):s("Tone.Buffer: could not locate file: "+e)}),u.addEventListener("error",s),u.addEventListener("progress",function(t){t.lengthComputable&&(u.progress=t.loaded/t.total*.95,o())}),u.send(),u},t.Buffer.cancelDownloads=function(){return t.Buffer._downloadQueue.slice().forEach(function(e){t.Buffer._removeFromDownloadQueue(e),e.abort()}),t.Buffer},t.Buffer.supportsType=function(t){var e=t.split(".");return e=e[e.length-1],""!==document.createElement("audio").canPlayType("audio/"+e)},t.loaded=function(){function e(){t.Buffer.off("load",i),t.Buffer.off("error",n)}var i,n;return new Promise(function(e,s){i=function(){e()},n=function(){s()},t.Buffer.on("load",i),t.Buffer.on("error",n)}).then(e).catch(function(t){throw e(),new Error(t)})},t.Buffer}),t(function(t){return t.OscillatorNode=function(){var e=t.defaults(arguments,["frequency","type"],t.OscillatorNode);t.AudioNode.call(this,e),this.onended=e.onended,this._startTime=-1,this._stopTime=-1,this._gainNode=this.output=new t.Gain,this._gainNode.gain.setValueAtTime(0,this.context.currentTime),this._oscillator=this.context.createOscillator(),this._oscillator.connect(this._gainNode),this.type=e.type,this.frequency=new t.Param(this._oscillator.frequency,t.Type.Frequency),this.frequency.value=e.frequency,this.detune=new t.Param(this._oscillator.detune,t.Type.Cents),this.detune.value=e.detune,this._gain=1},t.extend(t.OscillatorNode,t.AudioNode),t.OscillatorNode.defaults={frequency:440,detune:0,type:"sine",onended:t.noOp},Object.defineProperty(t.OscillatorNode.prototype,"state",{get:function(){return this.getStateAtTime(this.now())}}),t.OscillatorNode.prototype.getStateAtTime=function(e){return e=this.toSeconds(e),-1!==this._startTime&&e>=this._startTime&&(-1===this._stopTime||e<=this._stopTime)?t.State.Started:t.State.Stopped},t.OscillatorNode.prototype.start=function(t){if(-1!==this._startTime)throw new Error("cannot call OscillatorNode.start more than once");this._startTime=this.toSeconds(t),this._oscillator.start(this._startTime);var e=this.context.currentTime;return this._gainNode.gain.cancelScheduledValues(e),this._gainNode.gain.setValueAtTime(0,e),this._gainNode.gain.setValueAtTime(1,this._startTime),this},t.OscillatorNode.prototype.setPeriodicWave=function(t){return this._oscillator.setPeriodicWave(t),this},t.OscillatorNode.prototype.stop=function(t){return this.cancelStop(),this._stopTime=this.toSeconds(t),this._gainNode.gain.setValueAtTime(0,this._stopTime),this.context.clearTimeout(this._timeout),this._timeout=this.context.setTimeout(function(){this._oscillator.stop(this.now()),this.onended()}.bind(this),this._stopTime-this.now()),this},t.OscillatorNode.prototype.cancelStop=function(){return-1!==this._startTime&&(this._gainNode.gain.cancelScheduledValues(this._startTime+this.sampleTime),this._gainNode.gain.setValueAtTime(1,Math.max(this.now(),this._startTime)),this.context.clearTimeout(this._timeout),this._stopTime=-1),this},Object.defineProperty(t.OscillatorNode.prototype,"type",{get:function(){return this._oscillator.type},set:function(t){this._oscillator.type=t}}),t.OscillatorNode.prototype.dispose=function(){return this.context.clearTimeout(this._timeout),t.AudioNode.prototype.dispose.call(this),this.onended=null,this._oscillator.disconnect(),this._oscillator=null,this._gainNode.dispose(),this._gainNode=null,this.frequency.dispose(),this.frequency=null,this.detune.dispose(),this.detune=null,this},t.OscillatorNode}),t(function(t){return t.Oscillator=function(){var e=t.defaults(arguments,["frequency","type"],t.Oscillator);t.Source.call(this,e),this._oscillator=null,this.frequency=new t.Signal(e.frequency,t.Type.Frequency),this.detune=new t.Signal(e.detune,t.Type.Cents),this._wave=null,this._partials=t.defaultArg(e.partials,[1]),this._phase=e.phase,this._type=null,this.type=e.type,this.phase=this._phase,this._readOnly(["frequency","detune"])},t.extend(t.Oscillator,t.Source),t.Oscillator.defaults={type:"sine",frequency:440,detune:0,phase:0,partials:[]},t.Oscillator.Type={Sine:"sine",Triangle:"triangle",Sawtooth:"sawtooth",Square:"square",Custom:"custom"},t.Oscillator.prototype._start=function(e){this._oscillator=new t.OscillatorNode,this._wave?this._oscillator.setPeriodicWave(this._wave):this._oscillator.type=this._type,this._oscillator.connect(this.output),this.frequency.connect(this._oscillator.frequency),this.detune.connect(this._oscillator.detune),e=this.toSeconds(e),this._oscillator.start(e)},t.Oscillator.prototype._stop=function(t){return this._oscillator&&(t=this.toSeconds(t),this._oscillator.stop(t)),this},t.Oscillator.prototype.restart=function(t){return this._oscillator.cancelStop(),this._state.cancel(this.toSeconds(t)),this},t.Oscillator.prototype.syncFrequency=function(){return t.Transport.syncSignal(this.frequency),this},t.Oscillator.prototype.unsyncFrequency=function(){return t.Transport.unsyncSignal(this.frequency),this},Object.defineProperty(t.Oscillator.prototype,"type",{get:function(){return this._type},set:function(e){var i,n,s=[t.Oscillator.Type.Sine,t.Oscillator.Type.Square,t.Oscillator.Type.Triangle,t.Oscillator.Type.Sawtooth].includes(e);0===this._phase&&s?(this._wave=null,null!==this._oscillator&&this._oscillator.type):(i=this._getRealImaginary(e,this._phase),n=this.context.createPeriodicWave(i[0],i[1]),this._wave=n,null!==this._oscillator&&this._oscillator.setPeriodicWave(this._wave)),this._type=e}}),t.Oscillator.prototype._getRealImaginary=function(e,i){var n,s,o,r,a=4096,h=a/2,l=new Float32Array(h),u=new Float32Array(h),c=1;for(e===t.Oscillator.Type.Custom?(c=this._partials.length+1,h=c):(n=/^(sine|triangle|square|sawtooth)(\d+)$/.exec(e))&&(c=parseInt(n[2])+1,e=n[1],c=Math.max(c,2),h=c),s=1;s<h;++s){switch(o=2/(s*Math.PI),e){case t.Oscillator.Type.Sine:r=s<=c?1:0;break;case t.Oscillator.Type.Square:r=1&s?2*o:0;break;case t.Oscillator.Type.Sawtooth:r=o*(1&s?1:-1);break;case t.Oscillator.Type.Triangle:r=1&s?o*o*2*(s-1>>1&1?-1:1):0;break;case t.Oscillator.Type.Custom:r=this._partials[s-1];break;default:throw new TypeError("Tone.Oscillator: invalid type: "+e)}0!==r?(l[s]=-r*Math.sin(i*s),u[s]=r*Math.cos(i*s)):(l[s]=0,u[s]=0)}return[l,u]},t.Oscillator.prototype._inverseFFT=function(t,e,i){var n,s=0,o=t.length;for(n=0;n<o;n++)s+=t[n]*Math.cos(n*i)+e[n]*Math.sin(n*i);return s},t.Oscillator.prototype._getInitialValue=function(){var t,e=this._getRealImaginary(this._type,0),i=e[0],n=e[1],s=0,o=2*Math.PI;for(t=0;t<8;t++)s=Math.max(this._inverseFFT(i,n,t/8*o),s);return-this._inverseFFT(i,n,this._phase)/s},Object.defineProperty(t.Oscillator.prototype,"partials",{get:function(){return this._type!==t.Oscillator.Type.Custom?[]:this._partials},set:function(e){this._partials=e,this.type=t.Oscillator.Type.Custom}}),Object.defineProperty(t.Oscillator.prototype,"phase",{get:function(){return this._phase*(180/Math.PI)},set:function(t){this._phase=t*Math.PI/180,this.type=this._type}}),t.Oscillator.prototype.dispose=function(){return t.Source.prototype.dispose.call(this),null!==this._oscillator&&(this._oscillator.dispose(),this._oscillator=null),this._wave=null,this._writable(["frequency","detune"]),this.frequency.dispose(),this.frequency=null,this.detune.dispose(),this.detune=null,this._partials=null,this},t.Oscillator}),t(function(t){return t.AudioToGain=function(){t.SignalBase.call(this),this._norm=this.input=this.output=new t.WaveShaper(function(t){return(t+1)/2})},t.extend(t.AudioToGain,t.SignalBase),t.AudioToGain.prototype.dispose=function(){return t.SignalBase.prototype.dispose.call(this),this._norm.dispose(),this._norm=null,this},t.AudioToGain}),t(function(t){return t.Zero=function(){t.SignalBase.call(this),this._gain=this.input=this.output=new t.Gain,this.context.getConstant(0).connect(this._gain)},t.extend(t.Zero,t.SignalBase),t.Zero.prototype.dispose=function(){return t.SignalBase.prototype.dispose.call(this),this._gain.dispose(),this._gain=null,this},t.Zero}),t(function(t){return t.LFO=function(){var e=t.defaults(arguments,["frequency","min","max"],t.LFO);t.AudioNode.call(this),this._oscillator=new t.Oscillator({frequency:e.frequency,type:e.type}),this.frequency=this._oscillator.frequency,this.amplitude=this._oscillator.volume,this.amplitude.units=t.Type.NormalRange,this.amplitude.value=e.amplitude,this._stoppedSignal=new t.Signal(0,t.Type.AudioRange),this._zeros=new t.Zero,this._stoppedValue=0,this._a2g=new t.AudioToGain,this._scaler=this.output=new t.Scale(e.min,e.max),this._units=t.Type.Default,this.units=e.units,this._oscillator.chain(this._a2g,this._scaler),this._zeros.connect(this._a2g),this._stoppedSignal.connect(this._a2g),this._readOnly(["amplitude","frequency"]),this.phase=e.phase},t.extend(t.LFO,t.AudioNode),t.LFO.defaults={type:"sine",min:0,max:1,phase:0,frequency:"4n",amplitude:1,units:t.Type.Default},t.LFO.prototype.start=function(t){return t=this.toSeconds(t),this._stoppedSignal.setValueAtTime(0,t),this._oscillator.start(t),this},t.LFO.prototype.stop=function(t){return t=this.toSeconds(t),this._stoppedSignal.setValueAtTime(this._stoppedValue,t),this._oscillator.stop(t),this},t.LFO.prototype.sync=function(){return this._oscillator.sync(),this._oscillator.syncFrequency(),this},t.LFO.prototype.unsync=function(){return this._oscillator.unsync(),this._oscillator.unsyncFrequency(),this},Object.defineProperty(t.LFO.prototype,"min",{get:function(){return this._toUnits(this._scaler.min)},set:function(t){t=this._fromUnits(t),this._scaler.min=t}}),Object.defineProperty(t.LFO.prototype,"max",{get:function(){return this._toUnits(this._scaler.max)},set:function(t){t=this._fromUnits(t),this._scaler.max=t}}),Object.defineProperty(t.LFO.prototype,"type",{get:function(){return this._oscillator.type},set:function(t){this._oscillator.type=t,this._stoppedValue=this._oscillator._getInitialValue(),this._stoppedSignal.value=this._stoppedValue}}),Object.defineProperty(t.LFO.prototype,"phase",{get:function(){return this._oscillator.phase},set:function(t){this._oscillator.phase=t,this._stoppedValue=this._oscillator._getInitialValue(),this._stoppedSignal.value=this._stoppedValue}}),Object.defineProperty(t.LFO.prototype,"units",{get:function(){return this._units},set:function(t){var e=this.min,i=this.max;this._units=t,this.min=e,this.max=i}}),Object.defineProperty(t.LFO.prototype,"mute",{get:function(){return this._oscillator.mute},set:function(t){this._oscillator.mute=t}}),Object.defineProperty(t.LFO.prototype,"state",{get:function(){return this._oscillator.state}}),t.LFO.prototype.connect=function(e){return e.constructor!==t.Signal&&e.constructor!==t.Param||(this.convert=e.convert,this.units=e.units),t.SignalBase.prototype.connect.apply(this,arguments),this},t.LFO.prototype._fromUnits=t.Param.prototype._fromUnits,t.LFO.prototype._toUnits=t.Param.prototype._toUnits,t.LFO.prototype.dispose=function(){return t.AudioNode.prototype.dispose.call(this),this._writable(["amplitude","frequency"]),this._oscillator.dispose(),this._oscillator=null,this._stoppedSignal.dispose(),this._stoppedSignal=null,this._zeros.dispose(),this._zeros=null,this._scaler.dispose(),this._scaler=null,this._a2g.dispose(),this._a2g=null,this.frequency=null,this.amplitude=null,this},t.LFO}),t(function(t){return t.Limiter=function(){var e=t.defaults(arguments,["threshold"],t.Limiter);t.AudioNode.call(this),this._compressor=this.input=this.output=new t.Compressor({attack:.001,decay:.001,threshold:e.threshold}),this.threshold=this._compressor.threshold,this._readOnly("threshold")},t.extend(t.Limiter,t.AudioNode),t.Limiter.defaults={threshold:-12},t.Limiter.prototype.dispose=function(){return t.AudioNode.prototype.dispose.call(this),this._compressor.dispose(),this._compressor=null,this._writable("threshold"),this.threshold=null,this},t.Limiter}),t(function(t){return t.LowpassCombFilter=function(){var e=t.defaults(arguments,["delayTime","resonance","dampening"],t.LowpassCombFilter);t.AudioNode.call(this),this.createInsOuts(1,1),this._delay=this.input=new t.Delay(e.delayTime),this.delayTime=this._delay.delayTime,this._lowpass=this.output=this.context.createBiquadFilter(),this._lowpass.Q.value=-3.0102999566398125,this._lowpass.type="lowpass",this.dampening=new t.Param({param:this._lowpass.frequency,units:t.Type.Frequency,value:e.dampening}),this._feedback=new t.Gain(e.resonance,t.Type.NormalRange),this.resonance=this._feedback.gain,this._delay.chain(this._lowpass,this._feedback,this._delay),this._readOnly(["dampening","resonance","delayTime"])},t.extend(t.LowpassCombFilter,t.AudioNode),t.LowpassCombFilter.defaults={delayTime:.1,resonance:.5,dampening:3e3},t.LowpassCombFilter.prototype.dispose=function(){return t.AudioNode.prototype.dispose.call(this),this._writable(["dampening","resonance","delayTime"]),this.dampening.dispose(),this.dampening=null,this.resonance.dispose(),this.resonance=null,this._delay.dispose(),this._delay=null,this.delayTime=null,this._lowpass.disconnect(),this._lowpass=null,this._feedback.disconnect(),this._feedback=null,this},t.LowpassCombFilter}),t(function(t){return t.Merge=function(){t.AudioNode.call(this),this.createInsOuts(2,0),this.left=this.input[0]=new t.Gain,this.right=this.input[1]=new t.Gain,this._merger=this.output=this.context.createChannelMerger(2),this.left.connect(this._merger,0,0),this.right.connect(this._merger,0,1),this.left.channelCount=1,this.right.channelCount=1,this.left.channelCountMode="explicit",this.right.channelCountMode="explicit"},t.extend(t.Merge,t.AudioNode),t.Merge.prototype.dispose=function(){return t.AudioNode.prototype.dispose.call(this),this.left.dispose(),this.left=null,this.right.dispose(),this.right=null,this._merger.disconnect(),this._merger=null,this},t.Merge}),t(function(t){return t.Meter=function(){var e=t.defaults(arguments,["smoothing"],t.Meter);t.AudioNode.call(this),this.input=this.output=this._analyser=new t.Analyser("waveform",1024),this.smoothing=e.smoothing},t.extend(t.Meter,t.AudioNode),t.Meter.defaults={smoothing:.8},t.Meter.prototype.getLevel=function(){var t,e;return this._analyser.type="fft",t=this._analyser.getValue(),e=28,Math.max.apply(this,t)+e},t.Meter.prototype.getValue=function(){return this._analyser.type="waveform",this._analyser.getValue()[0]},Object.defineProperty(t.Meter.prototype,"smoothing",{get:function(){return this._analyser.smoothing},set:function(t){this._analyser.smoothing=t}}),t.Meter.prototype.dispose=function(){return t.AudioNode.prototype.dispose.call(this),this._analyser.dispose(),this._analyser=null,this},t.Meter}),t(function(t){return t.Split=function(){t.AudioNode.call(this),this.createInsOuts(0,2),this._splitter=this.input=this.context.createChannelSplitter(2),this._splitter.channelCount=2,this._splitter.channelCountMode="explicit",this.left=this.output[0]=new t.Gain,this.right=this.output[1]=new t.Gain,this._splitter.connect(this.left,0,0),this._splitter.connect(this.right,1,0)},t.extend(t.Split,t.AudioNode),t.Split.prototype.dispose=function(){return t.AudioNode.prototype.dispose.call(this),this._splitter.disconnect(),this.left.dispose(),this.left=null,this.right.dispose(),this.right=null,this._splitter=null,this},t.Split}),t(function(t){return t.MidSideSplit=function(){t.AudioNode.call(this),this.createInsOuts(0,2),this._split=this.input=new t.Split,this._midAdd=new t.Add,this.mid=this.output[0]=new t.Multiply(Math.SQRT1_2),this._sideSubtract=new t.Subtract,this.side=this.output[1]=new t.Multiply(Math.SQRT1_2),this._split.connect(this._midAdd,0,0),this._split.connect(this._midAdd,1,1),this._split.connect(this._sideSubtract,0,0),this._split.connect(this._sideSubtract,1,1),this._midAdd.connect(this.mid),this._sideSubtract.connect(this.side)},t.extend(t.MidSideSplit,t.AudioNode),t.MidSideSplit.prototype.dispose=function(){return t.AudioNode.prototype.dispose.call(this),this.mid.dispose(),this.mid=null,this.side.dispose(),this.side=null,this._midAdd.dispose(),this._midAdd=null,this._sideSubtract.dispose(),this._sideSubtract=null,this._split.dispose(),this._split=null,this},t.MidSideSplit}),t(function(t){return t.MidSideMerge=function(){t.AudioNode.call(this),this.createInsOuts(2,0),this.mid=this.input[0]=new t.Gain,this._left=new t.Add,this._timesTwoLeft=new t.Multiply(Math.SQRT1_2),this.side=this.input[1]=new t.Gain,this._right=new t.Subtract,this._timesTwoRight=new t.Multiply(Math.SQRT1_2),this._merge=this.output=new t.Merge,this.mid.connect(this._left,0,0),this.side.connect(this._left,0,1),this.mid.connect(this._right,0,0),this.side.connect(this._right,0,1),this._left.connect(this._timesTwoLeft),this._right.connect(this._timesTwoRight),this._timesTwoLeft.connect(this._merge,0,0),this._timesTwoRight.connect(this._merge,0,1)},t.extend(t.MidSideMerge,t.AudioNode),t.MidSideMerge.prototype.dispose=function(){return t.AudioNode.prototype.dispose.call(this),this.mid.dispose(),this.mid=null,this.side.dispose(),this.side=null,this._left.dispose(),this._left=null,this._timesTwoLeft.dispose(),this._timesTwoLeft=null,this._right.dispose(),this._right=null,this._timesTwoRight.dispose(),this._timesTwoRight=null,this._merge.dispose(),this._merge=null,this},t.MidSideMerge}),t(function(t){return t.MidSideCompressor=function(e){t.AudioNode.call(this),e=t.defaultArg(e,t.MidSideCompressor.defaults),this._midSideSplit=this.input=new t.MidSideSplit,this._midSideMerge=this.output=new t.MidSideMerge,this.mid=new t.Compressor(e.mid),this.side=new t.Compressor(e.side),this._midSideSplit.mid.chain(this.mid,this._midSideMerge.mid),this._midSideSplit.side.chain(this.side,this._midSideMerge.side),this._readOnly(["mid","side"])},t.extend(t.MidSideCompressor,t.AudioNode),t.MidSideCompressor.defaults={mid:{ratio:3,threshold:-24,release:.03,attack:.02,knee:16},side:{ratio:6,threshold:-30,release:.25,attack:.03,knee:10}},t.MidSideCompressor.prototype.dispose=function(){return t.AudioNode.prototype.dispose.call(this),this._writable(["mid","side"]),this.mid.dispose(),this.mid=null,this.side.dispose(),this.side=null,this._midSideSplit.dispose(),this._midSideSplit=null,this._midSideMerge.dispose(),this._midSideMerge=null,this},t.MidSideCompressor}),t(function(t){return t.Mono=function(){t.AudioNode.call(this),this.createInsOuts(1,0),this._merge=this.output=new t.Merge,this.input.connect(this._merge,0,0),this.input.connect(this._merge,0,1)},t.extend(t.Mono,t.AudioNode),t.Mono.prototype.dispose=function(){return t.AudioNode.prototype.dispose.call(this),this._merge.dispose(),this._merge=null,this},t.Mono}),t(function(t){return t.MultibandCompressor=function(e){t.AudioNode.call(this),e=t.defaultArg(arguments,t.MultibandCompressor.defaults),this._splitter=this.input=new t.MultibandSplit({lowFrequency:e.lowFrequency,highFrequency:e.highFrequency}),this.lowFrequency=this._splitter.lowFrequency,this.highFrequency=this._splitter.highFrequency,this.output=new t.Gain,this.low=new t.Compressor(e.low),this.mid=new t.Compressor(e.mid),this.high=new t.Compressor(e.high),this._splitter.low.chain(this.low,this.output),this._splitter.mid.chain(this.mid,this.output),this._splitter.high.chain(this.high,this.output),this._readOnly(["high","mid","low","highFrequency","lowFrequency"])},t.extend(t.MultibandCompressor,t.AudioNode),t.MultibandCompressor.defaults={low:t.Compressor.defaults,mid:t.Compressor.defaults,high:t.Compressor.defaults,lowFrequency:250,highFrequency:2e3},t.MultibandCompressor.prototype.dispose=function(){return t.AudioNode.prototype.dispose.call(this),this._splitter.dispose(),this._writable(["high","mid","low","highFrequency","lowFrequency"]),this.low.dispose(),this.mid.dispose(),this.high.dispose(),this._splitter=null,this.low=null,this.mid=null,this.high=null,this.lowFrequency=null,this.highFrequency=null,this},t.MultibandCompressor}),t(function(t){if(t.supported&&!window.StereoPannerNode){var e=function(e){var i,n,s,o,r,a,h;this.context=e,this.pan=new t.Signal(0,t.Type.AudioRange),i=new t.WaveShaper(function(e){return t.equalPowerScale((e+1)/2)},4096),n=new t.WaveShaper(function(e){return t.equalPowerScale(1-(e+1)/2)},4096),s=new t.Gain,o=new t.Gain,r=this.input=new t.Split,a=new t.Zero,a.fan(i,n),h=this.output=new t.Merge,r.left.chain(s,h.left),r.right.chain(o,h.right),this.pan.chain(n,s.gain),this.pan.chain(i,o.gain)};e.prototype.disconnect=function(){this.output.disconnect.apply(this.output,arguments)},e.prototype.connect=function(){this.output.connect.apply(this.output,arguments)},AudioContext.prototype.createStereoPanner=function(){return new e(this)},t.Context.prototype.createStereoPanner=function(){return new e(this)}}}),t(function(t){return t.Panner=function(e){t.AudioNode.call(this),this._panner=this.input=this.output=this.context.createStereoPanner(),this.pan=this._panner.pan,this.pan.value=t.defaultArg(e,0),this._readOnly("pan")},t.extend(t.Panner,t.AudioNode),t.Panner.prototype.dispose=function(){return t.AudioNode.prototype.dispose.call(this),this._writable("pan"),this._panner.disconnect(),this._panner=null,this.pan=null,this},t.Panner}),t(function(t){return t.Panner3D=function(){var e=t.defaults(arguments,["positionX","positionY","positionZ"],t.Panner3D);t.AudioNode.call(this),this._panner=this.input=this.output=this.context.createPanner(),this._panner.panningModel=e.panningModel,this._panner.maxDistance=e.maxDistance,this._panner.distanceModel=e.distanceModel,this._panner.coneOuterGain=e.coneOuterGain,this._panner.coneOuterAngle=e.coneOuterAngle,this._panner.coneInnerAngle=e.coneInnerAngle,this._panner.refDistance=e.refDistance,this._panner.rolloffFactor=e.rolloffFactor,this._orientation=[e.orientationX,e.orientationY,e.orientationZ],this._position=[e.positionX,e.positionY,e.positionZ],this.orientationX=e.orientationX,this.orientationY=e.orientationY,this.orientationZ=e.orientationZ,this.positionX=e.positionX,this.positionY=e.positionY,this.positionZ=e.positionZ},t.extend(t.Panner3D,t.AudioNode),t.Panner3D.defaults={positionX:0,positionY:0,positionZ:0,orientationX:0,orientationY:0,orientationZ:0,panningModel:"equalpower",maxDistance:1e4,distanceModel:"inverse",coneOuterGain:0,coneOuterAngle:360,coneInnerAngle:360,refDistance:1,rolloffFactor:1},t.Panner3D.prototype._rampTimeConstant=.01,t.Panner3D.prototype.setPosition=function(t,e,i){if(this._panner.positionX){var n=this.now();this._panner.positionX.setTargetAtTime(t,n,this._rampTimeConstant),this._panner.positionY.setTargetAtTime(e,n,this._rampTimeConstant),this._panner.positionZ.setTargetAtTime(i,n,this._rampTimeConstant)}else this._panner.setPosition(t,e,i);return this._position=Array.prototype.slice.call(arguments),this},t.Panner3D.prototype.setOrientation=function(t,e,i){if(this._panner.orientationX){var n=this.now();this._panner.orientationX.setTargetAtTime(t,n,this._rampTimeConstant),this._panner.orientationY.setTargetAtTime(e,n,this._rampTimeConstant),this._panner.orientationZ.setTargetAtTime(i,n,this._rampTimeConstant)}else this._panner.setOrientation(t,e,i);return this._orientation=Array.prototype.slice.call(arguments),this},Object.defineProperty(t.Panner3D.prototype,"positionX",{set:function(t){this._position[0]=t,this.setPosition.apply(this,this._position)},get:function(){return this._position[0]}}),Object.defineProperty(t.Panner3D.prototype,"positionY",{set:function(t){this._position[1]=t,this.setPosition.apply(this,this._position)},get:function(){return this._position[1]}}),Object.defineProperty(t.Panner3D.prototype,"positionZ",{set:function(t){this._position[2]=t,this.setPosition.apply(this,this._position)},get:function(){return this._position[2]}}),Object.defineProperty(t.Panner3D.prototype,"orientationX",{set:function(t){this._orientation[0]=t,this.setOrientation.apply(this,this._orientation)},get:function(){return this._orientation[0]}}),Object.defineProperty(t.Panner3D.prototype,"orientationY",{set:function(t){this._orientation[1]=t,this.setOrientation.apply(this,this._orientation)},get:function(){return this._orientation[1]}}),Object.defineProperty(t.Panner3D.prototype,"orientationZ",{set:function(t){this._orientation[2]=t,this.setOrientation.apply(this,this._orientation)},get:function(){return this._orientation[2]}}),t.Panner3D._aliasProperty=function(e){Object.defineProperty(t.Panner3D.prototype,e,{set:function(t){this._panner[e]=t},get:function(){return this._panner[e]}})},t.Panner3D._aliasProperty("panningModel"),t.Panner3D._aliasProperty("refDistance"),t.Panner3D._aliasProperty("rolloffFactor"),t.Panner3D._aliasProperty("distanceModel"),t.Panner3D._aliasProperty("coneInnerAngle"),t.Panner3D._aliasProperty("coneOuterAngle"),t.Panner3D._aliasProperty("coneOuterGain"),t.Panner3D._aliasProperty("maxDistance"),t.Panner3D.prototype.dispose=function(){return t.AudioNode.prototype.dispose.call(this),this._panner.disconnect(),this._panner=null,this._orientation=null,this._position=null,this},t.Panner3D}),t(function(t){return t.PanVol=function(){var e=t.defaults(arguments,["pan","volume"],t.PanVol);t.AudioNode.call(this),this._panner=this.input=new t.Panner(e.pan),this.pan=this._panner.pan,this._volume=this.output=new t.Volume(e.volume),this.volume=this._volume.volume,this._panner.connect(this._volume),this.mute=e.mute,this._readOnly(["pan","volume"])},t.extend(t.PanVol,t.AudioNode),t.PanVol.defaults={pan:0,volume:0,mute:!1},Object.defineProperty(t.PanVol.prototype,"mute",{get:function(){return this._volume.mute},set:function(t){
this._volume.mute=t}}),t.PanVol.prototype.dispose=function(){return t.AudioNode.prototype.dispose.call(this),this._writable(["pan","volume"]),this._panner.dispose(),this._panner=null,this.pan=null,this._volume.dispose(),this._volume=null,this.volume=null,this},t.PanVol}),t(function(t){return t.Solo=function(){var e=t.defaults(arguments,["solo"],t.Solo);t.AudioNode.call(this),this.input=this.output=new t.Gain,this._soloBind=this._soloed.bind(this),this.context.on("solo",this._soloBind),this.solo=e.solo},t.extend(t.Solo,t.AudioNode),t.Solo.defaults={solo:!1},Object.defineProperty(t.Solo.prototype,"solo",{get:function(){return this._isSoloed()},set:function(t){t?this._addSolo():this._removeSolo(),this.context.emit("solo",this)}}),Object.defineProperty(t.Solo.prototype,"muted",{get:function(){return 0===this.input.gain.value}}),t.Solo.prototype._addSolo=function(){t.isArray(this.context._currentSolo)||(this.context._currentSolo=[]),this._isSoloed()||this.context._currentSolo.push(this)},t.Solo.prototype._removeSolo=function(){if(this._isSoloed()){var t=this.context._currentSolo.indexOf(this);this.context._currentSolo.splice(t,1)}},t.Solo.prototype._isSoloed=function(){return!!t.isArray(this.context._currentSolo)&&(0!==this.context._currentSolo.length&&-1!==this.context._currentSolo.indexOf(this))},t.Solo.prototype._noSolos=function(){return!t.isArray(this.context._currentSolo)||0===this.context._currentSolo.length},t.Solo.prototype._soloed=function(){this._isSoloed()?this.input.gain.value=1:this._noSolos()?this.input.gain.value=1:this.input.gain.value=0},t.Solo.prototype.dispose=function(){return this.context.off("solo",this._soloBind),this._removeSolo(),this._soloBind=null,t.AudioNode.prototype.dispose.call(this),this},t.Solo}),t(function(t){return t.Waveform=function(){var e=t.defaults(arguments,["size"],t.Waveform);e.type=t.Analyser.Type.Waveform,t.AudioNode.call(this),this._analyser=this.input=this.output=new t.Analyser(e)},t.extend(t.Waveform,t.AudioNode),t.Waveform.defaults={size:1024},t.Waveform.prototype.getValue=function(){return this._analyser.getValue()},Object.defineProperty(t.Waveform.prototype,"size",{get:function(){return this._analyser.size},set:function(t){this._analyser.size=t}}),t.Waveform.prototype.dispose=function(){t.AudioNode.prototype.dispose.call(this),this._analyser.dispose(),this._analyser=null},t.Waveform}),t(function(t){return t.CtrlInterpolate=function(){var e=t.defaults(arguments,["values","index"],t.CtrlInterpolate);t.call(this),this.values=e.values,this.index=e.index},t.extend(t.CtrlInterpolate),t.CtrlInterpolate.defaults={index:0,values:[]},Object.defineProperty(t.CtrlInterpolate.prototype,"value",{get:function(){var t,e,i,n=this.index;return n=Math.min(n,this.values.length-1),t=Math.floor(n),e=this.values[t],i=this.values[Math.ceil(n)],this._interpolate(n-t,e,i)}}),t.CtrlInterpolate.prototype._interpolate=function(e,i,n){var s,o,r,a;if(t.isArray(i)){for(s=[],o=0;o<i.length;o++)s[o]=this._interpolate(e,i[o],n[o]);return s}if(t.isObject(i)){r={};for(a in i)r[a]=this._interpolate(e,i[a],n[a]);return r}return i=this._toNumber(i),n=this._toNumber(n),(1-e)*i+e*n},t.CtrlInterpolate.prototype._toNumber=function(e){return t.isNumber(e)?e:this.toSeconds(e)},t.CtrlInterpolate.prototype.dispose=function(){this.values=null},t.CtrlInterpolate}),t(function(t){return t.CtrlMarkov=function(e,i){t.call(this),this.values=t.defaultArg(e,{}),this.value=t.defaultArg(i,Object.keys(this.values)[0])},t.extend(t.CtrlMarkov),t.CtrlMarkov.prototype.next=function(){var e,i,n,s,o,r,a;if(this.values.hasOwnProperty(this.value))if(e=this.values[this.value],t.isArray(e))for(i=this._getProbDistribution(e),n=Math.random(),s=0,o=0;o<i.length;o++)r=i[o],n>s&&n<s+r&&(a=e[o],t.isObject(a)?this.value=a.value:this.value=a),s+=r;else this.value=e;return this.value},t.CtrlMarkov.prototype._getProbDistribution=function(e){var i,n,s,o=[],r=0,a=!1;for(i=0;i<e.length;i++)n=e[i],t.isObject(n)?(a=!0,o[i]=n.probability):o[i]=1/e.length,r+=o[i];if(a)for(s=0;s<o.length;s++)o[s]=o[s]/r;return o},t.CtrlMarkov.prototype.dispose=function(){this.values=null},t.CtrlMarkov}),t(function(t){return t.CtrlPattern=function(){var e=t.defaults(arguments,["values","type"],t.CtrlPattern);t.call(this),this.values=e.values,this.index=0,this._type=null,this._shuffled=null,this._direction=null,this.type=e.type},t.extend(t.CtrlPattern),t.CtrlPattern.Type={Up:"up",Down:"down",UpDown:"upDown",DownUp:"downUp",AlternateUp:"alternateUp",AlternateDown:"alternateDown",Random:"random",RandomWalk:"randomWalk",RandomOnce:"randomOnce"},t.CtrlPattern.defaults={type:t.CtrlPattern.Type.Up,values:[]},Object.defineProperty(t.CtrlPattern.prototype,"value",{get:function(){if(0!==this.values.length){if(1===this.values.length)return this.values[0];this.index=Math.min(this.index,this.values.length-1);var e=this.values[this.index];return this.type===t.CtrlPattern.Type.RandomOnce&&(this.values.length!==this._shuffled.length&&this._shuffleValues(),e=this.values[this._shuffled[this.index]]),e}}}),Object.defineProperty(t.CtrlPattern.prototype,"type",{get:function(){return this._type},set:function(e){this._type=e,this._shuffled=null,this._type===t.CtrlPattern.Type.Up||this._type===t.CtrlPattern.Type.UpDown||this._type===t.CtrlPattern.Type.RandomOnce||this._type===t.CtrlPattern.Type.AlternateUp?this.index=0:this._type!==t.CtrlPattern.Type.Down&&this._type!==t.CtrlPattern.Type.DownUp&&this._type!==t.CtrlPattern.Type.AlternateDown||(this.index=this.values.length-1),this._type===t.CtrlPattern.Type.UpDown||this._type===t.CtrlPattern.Type.AlternateUp?this._direction=t.CtrlPattern.Type.Up:this._type!==t.CtrlPattern.Type.DownUp&&this._type!==t.CtrlPattern.Type.AlternateDown||(this._direction=t.CtrlPattern.Type.Down),this._type===t.CtrlPattern.Type.RandomOnce?this._shuffleValues():this._type===t.CtrlPattern.Random&&(this.index=Math.floor(Math.random()*this.values.length))}}),t.CtrlPattern.prototype.next=function(){var e=this.type;return e===t.CtrlPattern.Type.Up?++this.index>=this.values.length&&(this.index=0):e===t.CtrlPattern.Type.Down?--this.index<0&&(this.index=this.values.length-1):e===t.CtrlPattern.Type.UpDown||e===t.CtrlPattern.Type.DownUp?(this._direction===t.CtrlPattern.Type.Up?this.index++:this.index--,this.index<0?(this.index=1,this._direction=t.CtrlPattern.Type.Up):this.index>=this.values.length&&(this.index=this.values.length-2,this._direction=t.CtrlPattern.Type.Down)):e===t.CtrlPattern.Type.Random?this.index=Math.floor(Math.random()*this.values.length):e===t.CtrlPattern.Type.RandomWalk?Math.random()<.5?(this.index--,this.index=Math.max(this.index,0)):(this.index++,this.index=Math.min(this.index,this.values.length-1)):e===t.CtrlPattern.Type.RandomOnce?++this.index>=this.values.length&&(this.index=0,this._shuffleValues()):e===t.CtrlPattern.Type.AlternateUp?(this._direction===t.CtrlPattern.Type.Up?(this.index+=2,this._direction=t.CtrlPattern.Type.Down):(this.index-=1,this._direction=t.CtrlPattern.Type.Up),this.index>=this.values.length&&(this.index=0,this._direction=t.CtrlPattern.Type.Up)):e===t.CtrlPattern.Type.AlternateDown&&(this._direction===t.CtrlPattern.Type.Up?(this.index+=1,this._direction=t.CtrlPattern.Type.Down):(this.index-=2,this._direction=t.CtrlPattern.Type.Up),this.index<0&&(this.index=this.values.length-1,this._direction=t.CtrlPattern.Type.Down)),this.value},t.CtrlPattern.prototype._shuffleValues=function(){var t,e,i=[];for(this._shuffled=[],t=0;t<this.values.length;t++)i[t]=t;for(;i.length>0;)e=i.splice(Math.floor(i.length*Math.random()),1),this._shuffled.push(e[0])},t.CtrlPattern.prototype.dispose=function(){this._shuffled=null,this.values=null},t.CtrlPattern}),t(function(t){return t.CtrlRandom=function(){var e=t.defaults(arguments,["min","max"],t.CtrlRandom);t.call(this),this.min=e.min,this.max=e.max,this.integer=e.integer},t.extend(t.CtrlRandom),t.CtrlRandom.defaults={min:0,max:1,integer:!1},Object.defineProperty(t.CtrlRandom.prototype,"value",{get:function(){var t=this.toSeconds(this.min),e=this.toSeconds(this.max),i=Math.random(),n=i*t+(1-i)*e;return this.integer&&(n=Math.floor(n)),n}}),t.CtrlRandom}),t(function(t){return t.Buffers=function(e){var i,n,s=Array.prototype.slice.call(arguments);s.shift(),i=t.defaults(s,["onload","baseUrl"],t.Buffers),t.call(this),this._buffers={},this.baseUrl=i.baseUrl,this._loadingCount=0;for(n in e)this._loadingCount++,this.add(n,e[n],this._bufferLoaded.bind(this,i.onload))},t.extend(t.Buffers),t.Buffers.defaults={onload:t.noOp,baseUrl:""},t.Buffers.prototype.has=function(t){return this._buffers.hasOwnProperty(t)},t.Buffers.prototype.get=function(t){if(this.has(t))return this._buffers[t];throw new Error("Tone.Buffers: no buffer named "+t)},t.Buffers.prototype._bufferLoaded=function(t){0===--this._loadingCount&&t&&t(this)},Object.defineProperty(t.Buffers.prototype,"loaded",{get:function(){var t,e,i=!0;for(t in this._buffers)e=this.get(t),i=i&&e.loaded;return i}}),t.Buffers.prototype.add=function(e,i,n){return n=t.defaultArg(n,t.noOp),i instanceof t.Buffer?(this._buffers[e]=i,n(this)):i instanceof AudioBuffer?(this._buffers[e]=new t.Buffer(i),n(this)):t.isString(i)&&(this._buffers[e]=new t.Buffer(this.baseUrl+i,n)),this},t.Buffers.prototype.dispose=function(){t.prototype.dispose.call(this);for(var e in this._buffers)this._buffers[e].dispose();return this._buffers=null,this},t.Buffers}),t(function(t){var e={};return t.prototype.send=function(i,n){e.hasOwnProperty(i)||(e[i]=this.context.createGain()),n=t.defaultArg(n,0);var s=new t.Gain(n,t.Type.Decibels);return this.connect(s),s.connect(e[i]),s},t.prototype.receive=function(t,i){return e.hasOwnProperty(t)||(e[t]=this.context.createGain()),e[t].connect(this,0,i),this},t.Context.on("init",function(t){t.Buses?e=t.Buses:(e={},t.Buses=e)}),t}),t(function(t){return t.Draw=function(){t.call(this),this._events=new t.Timeline,this.expiration=.25,this.anticipation=.008,this._boundDrawLoop=this._drawLoop.bind(this)},t.extend(t.Draw),t.Draw.prototype.schedule=function(t,e){return this._events.add({callback:t,time:this.toSeconds(e)}),1===this._events.length&&requestAnimationFrame(this._boundDrawLoop),this},t.Draw.prototype.cancel=function(t){return this._events.cancel(this.toSeconds(t)),this},t.Draw.prototype._drawLoop=function(){for(var e,i=t.now();this._events.length&&this._events.peek().time-this.anticipation<=i;)e=this._events.shift(),i-e.time<=this.expiration&&e.callback();this._events.length>0&&requestAnimationFrame(this._boundDrawLoop)},t.Draw=new t.Draw,t.Draw}),t(function(t){t.Listener=function(){t.call(this),this._orientation=[0,0,0,0,0,0],this._position=[0,0,0],t.getContext(function(){this.set(e.defaults)}.bind(this))},t.extend(t.Listener),t.Listener.defaults={positionX:0,positionY:0,positionZ:0,forwardX:0,forwardY:0,forwardZ:1,upX:0,upY:1,upZ:0},t.Listener.prototype._rampTimeConstant=.01,t.Listener.prototype.setPosition=function(t,e,i){if(this.context.listener.positionX){var n=this.now();this.context.listener.positionX.setTargetAtTime(t,n,this._rampTimeConstant),this.context.listener.positionY.setTargetAtTime(e,n,this._rampTimeConstant),this.context.listener.positionZ.setTargetAtTime(i,n,this._rampTimeConstant)}else this.context.listener.setPosition(t,e,i);return this._position=Array.prototype.slice.call(arguments),this},t.Listener.prototype.setOrientation=function(t,e,i,n,s,o){if(this.context.listener.forwardX){var r=this.now();this.context.listener.forwardX.setTargetAtTime(t,r,this._rampTimeConstant),this.context.listener.forwardY.setTargetAtTime(e,r,this._rampTimeConstant),this.context.listener.forwardZ.setTargetAtTime(i,r,this._rampTimeConstant),this.context.listener.upX.setTargetAtTime(n,r,this._rampTimeConstant),this.context.listener.upY.setTargetAtTime(s,r,this._rampTimeConstant),this.context.listener.upZ.setTargetAtTime(o,r,this._rampTimeConstant)}else this.context.listener.setOrientation(t,e,i,n,s,o);return this._orientation=Array.prototype.slice.call(arguments),this},Object.defineProperty(t.Listener.prototype,"positionX",{set:function(t){this._position[0]=t,this.setPosition.apply(this,this._position)},get:function(){return this._position[0]}}),Object.defineProperty(t.Listener.prototype,"positionY",{set:function(t){this._position[1]=t,this.setPosition.apply(this,this._position)},get:function(){return this._position[1]}}),Object.defineProperty(t.Listener.prototype,"positionZ",{set:function(t){this._position[2]=t,this.setPosition.apply(this,this._position)},get:function(){return this._position[2]}}),Object.defineProperty(t.Listener.prototype,"forwardX",{set:function(t){this._orientation[0]=t,this.setOrientation.apply(this,this._orientation)},get:function(){return this._orientation[0]}}),Object.defineProperty(t.Listener.prototype,"forwardY",{set:function(t){this._orientation[1]=t,this.setOrientation.apply(this,this._orientation)},get:function(){return this._orientation[1]}}),Object.defineProperty(t.Listener.prototype,"forwardZ",{set:function(t){this._orientation[2]=t,this.setOrientation.apply(this,this._orientation)},get:function(){return this._orientation[2]}}),Object.defineProperty(t.Listener.prototype,"upX",{set:function(t){this._orientation[3]=t,this.setOrientation.apply(this,this._orientation)},get:function(){return this._orientation[3]}}),Object.defineProperty(t.Listener.prototype,"upY",{set:function(t){this._orientation[4]=t,this.setOrientation.apply(this,this._orientation)},get:function(){return this._orientation[4]}}),Object.defineProperty(t.Listener.prototype,"upZ",{set:function(t){this._orientation[5]=t,this.setOrientation.apply(this,this._orientation)},get:function(){return this._orientation[5]}}),t.Listener.prototype.dispose=function(){return this._orientation=null,this._position=null,this};var e=t.Listener;return t.Listener=new e,t.Context.on("init",function(i){i.Listener instanceof e?t.Listener=i.Listener:t.Listener=new e,i.Listener=t.Listener}),t.Listener}),t(function(t){function e(i,n,s,o){var r,a;return o=t.defaultArg(o,0),r=new t.OfflineContext(2,n,s),t.context=r,a=i(t.Transport),r.currentTime>0&&o<1e3?e(i,n,s,++o):{response:a,context:r}}return t.Offline=function(i,n){var s,o=t.context.sampleRate,r=t.context,a=e(i,n,o),h=a.response,l=a.context;return s=h instanceof Promise?h.then(function(){return l.render()}):l.render(),t.context=r,s.then(function(e){return new t.Buffer(e)})},t.Offline}),t(function(t){return t.Effect=function(){var e=t.defaults(arguments,["wet"],t.Effect);t.AudioNode.call(this),this.createInsOuts(1,1),this._dryWet=new t.CrossFade(e.wet),this.wet=this._dryWet.fade,this.effectSend=new t.Gain,this.effectReturn=new t.Gain,this.input.connect(this._dryWet.a),this.input.connect(this.effectSend),this.effectReturn.connect(this._dryWet.b),this._dryWet.connect(this.output),this._readOnly(["wet"])},t.extend(t.Effect,t.AudioNode),t.Effect.defaults={wet:1},t.Effect.prototype.connectEffect=function(t){return this.effectSend.chain(t,this.effectReturn),this},t.Effect.prototype.dispose=function(){return t.AudioNode.prototype.dispose.call(this),this._dryWet.dispose(),this._dryWet=null,this.effectSend.dispose(),this.effectSend=null,this.effectReturn.dispose(),this.effectReturn=null,this._writable(["wet"]),this.wet=null,this},t.Effect}),t(function(t){return t.AutoFilter=function(){var e=t.defaults(arguments,["frequency","baseFrequency","octaves"],t.AutoFilter);t.Effect.call(this,e),this._lfo=new t.LFO({frequency:e.frequency,amplitude:e.depth}),this.depth=this._lfo.amplitude,this.frequency=this._lfo.frequency,this.filter=new t.Filter(e.filter),this._octaves=0,this.connectEffect(this.filter),this._lfo.connect(this.filter.frequency),this.type=e.type,this._readOnly(["frequency","depth"]),this.octaves=e.octaves,this.baseFrequency=e.baseFrequency},t.extend(t.AutoFilter,t.Effect),t.AutoFilter.defaults={frequency:1,type:"sine",depth:1,baseFrequency:200,octaves:2.6,filter:{type:"lowpass",rolloff:-12,Q:1}},t.AutoFilter.prototype.start=function(t){return this._lfo.start(t),this},t.AutoFilter.prototype.stop=function(t){return this._lfo.stop(t),this},t.AutoFilter.prototype.sync=function(t){return this._lfo.sync(t),this},t.AutoFilter.prototype.unsync=function(){return this._lfo.unsync(),this},Object.defineProperty(t.AutoFilter.prototype,"type",{get:function(){return this._lfo.type},set:function(t){this._lfo.type=t}}),Object.defineProperty(t.AutoFilter.prototype,"baseFrequency",{get:function(){return this._lfo.min},set:function(t){this._lfo.min=this.toFrequency(t),this.octaves=this._octaves}}),Object.defineProperty(t.AutoFilter.prototype,"octaves",{get:function(){return this._octaves},set:function(t){this._octaves=t,this._lfo.max=this.baseFrequency*Math.pow(2,t)}}),t.AutoFilter.prototype.dispose=function(){return t.Effect.prototype.dispose.call(this),this._lfo.dispose(),this._lfo=null,this.filter.dispose(),this.filter=null,this._writable(["frequency","depth"]),this.frequency=null,this.depth=null,this},t.AutoFilter}),t(function(t){return t.AutoPanner=function(){var e=t.defaults(arguments,["frequency"],t.AutoPanner);t.Effect.call(this,e),this._lfo=new t.LFO({frequency:e.frequency,amplitude:e.depth,min:-1,max:1}),this.depth=this._lfo.amplitude,this._panner=new t.Panner,this.frequency=this._lfo.frequency,this.connectEffect(this._panner),this._lfo.connect(this._panner.pan),this.type=e.type,this._readOnly(["depth","frequency"])},t.extend(t.AutoPanner,t.Effect),t.AutoPanner.defaults={frequency:1,type:"sine",depth:1},t.AutoPanner.prototype.start=function(t){return this._lfo.start(t),this},t.AutoPanner.prototype.stop=function(t){return this._lfo.stop(t),this},t.AutoPanner.prototype.sync=function(t){return this._lfo.sync(t),this},t.AutoPanner.prototype.unsync=function(){return this._lfo.unsync(),this},Object.defineProperty(t.AutoPanner.prototype,"type",{get:function(){return this._lfo.type},set:function(t){this._lfo.type=t}}),t.AutoPanner.prototype.dispose=function(){return t.Effect.prototype.dispose.call(this),this._lfo.dispose(),this._lfo=null,this._panner.dispose(),this._panner=null,this._writable(["depth","frequency"]),this.frequency=null,this.depth=null,this},t.AutoPanner}),t(function(t){return t.AutoWah=function(){var e=t.defaults(arguments,["baseFrequency","octaves","sensitivity"],t.AutoWah);t.Effect.call(this,e),this.follower=new t.Follower(e.follower),this._sweepRange=new t.ScaleExp(0,1,.5),this._baseFrequency=e.baseFrequency,this._octaves=e.octaves,this._inputBoost=new t.Gain,this._bandpass=new t.Filter({rolloff:-48,frequency:0,Q:e.Q}),this._peaking=new t.Filter(0,"peaking"),this._peaking.gain.value=e.gain,this.gain=this._peaking.gain,this.Q=this._bandpass.Q,this.effectSend.chain(this._inputBoost,this.follower,this._sweepRange),this._sweepRange.connect(this._bandpass.frequency),this._sweepRange.connect(this._peaking.frequency),this.effectSend.chain(this._bandpass,this._peaking,this.effectReturn),this._setSweepRange(),this.sensitivity=e.sensitivity,this._readOnly(["gain","Q"])},t.extend(t.AutoWah,t.Effect),t.AutoWah.defaults={baseFrequency:100,octaves:6,sensitivity:0,Q:2,gain:2,follower:{attack:.3,release:.5}},Object.defineProperty(t.AutoWah.prototype,"octaves",{get:function(){return this._octaves},set:function(t){this._octaves=t,this._setSweepRange()}}),Object.defineProperty(t.AutoWah.prototype,"baseFrequency",{get:function(){return this._baseFrequency},set:function(t){this._baseFrequency=t,this._setSweepRange()}}),Object.defineProperty(t.AutoWah.prototype,"sensitivity",{get:function(){return t.gainToDb(1/this._inputBoost.gain.value)},set:function(e){this._inputBoost.gain.value=1/t.dbToGain(e)}}),t.AutoWah.prototype._setSweepRange=function(){this._sweepRange.min=this._baseFrequency,this._sweepRange.max=Math.min(this._baseFrequency*Math.pow(2,this._octaves),this.context.sampleRate/2)},t.AutoWah.prototype.dispose=function(){return t.Effect.prototype.dispose.call(this),this.follower.dispose(),this.follower=null,this._sweepRange.dispose(),this._sweepRange=null,this._bandpass.dispose(),this._bandpass=null,this._peaking.dispose(),this._peaking=null,this._inputBoost.dispose(),this._inputBoost=null,this._writable(["gain","Q"]),this.gain=null,this.Q=null,this},t.AutoWah}),t(function(t){return t.Modulo=function(e){t.SignalBase.call(this),this.createInsOuts(1,0),this._shaper=new t.WaveShaper(Math.pow(2,16)),this._multiply=new t.Multiply,this._subtract=this.output=new t.Subtract,this._modSignal=new t.Signal(e),this.input.fan(this._shaper,this._subtract),this._modSignal.connect(this._multiply,0,0),this._shaper.connect(this._multiply,0,1),this._multiply.connect(this._subtract,0,1),this._setWaveShaper(e)},t.extend(t.Modulo,t.SignalBase),t.Modulo.prototype._setWaveShaper=function(t){this._shaper.setMap(function(e){return Math.floor((e+1e-4)/t)})},Object.defineProperty(t.Modulo.prototype,"value",{get:function(){return this._modSignal.value},set:function(t){this._modSignal.value=t,this._setWaveShaper(t)}}),t.Modulo.prototype.dispose=function(){return t.SignalBase.prototype.dispose.call(this),this._shaper.dispose(),this._shaper=null,this._multiply.dispose(),this._multiply=null,this._subtract.dispose(),this._subtract=null,this._modSignal.dispose(),this._modSignal=null,this},t.Modulo}),t(function(t){return t.BitCrusher=function(){var e,i=t.defaults(arguments,["bits"],t.BitCrusher);t.Effect.call(this,i),e=1/Math.pow(2,i.bits-1),this._subtract=new t.Subtract,this._modulo=new t.Modulo(e),this._bits=i.bits,this.effectSend.fan(this._subtract,this._modulo),this._modulo.connect(this._subtract,0,1),this._subtract.connect(this.effectReturn)},t.extend(t.BitCrusher,t.Effect),t.BitCrusher.defaults={bits:4},Object.defineProperty(t.BitCrusher.prototype,"bits",{get:function(){return this._bits},set:function(t){this._bits=t;var e=1/Math.pow(2,t-1);this._modulo.value=e}}),t.BitCrusher.prototype.dispose=function(){return t.Effect.prototype.dispose.call(this),this._subtract.dispose(),this._subtract=null,this._modulo.dispose(),this._modulo=null,this},t.BitCrusher}),t(function(t){return t.Chebyshev=function(){var e=t.defaults(arguments,["order"],t.Chebyshev);t.Effect.call(this,e),this._shaper=new t.WaveShaper(4096),this._order=e.order,this.connectEffect(this._shaper),this.order=e.order,this.oversample=e.oversample},t.extend(t.Chebyshev,t.Effect),t.Chebyshev.defaults={order:1,oversample:"none"},t.Chebyshev.prototype._getCoefficient=function(t,e,i){return i.hasOwnProperty(e)?i[e]:(i[e]=0===e?0:1===e?t:2*t*this._getCoefficient(t,e-1,i)-this._getCoefficient(t,e-2,i),i[e])},Object.defineProperty(t.Chebyshev.prototype,"order",{get:function(){return this._order},set:function(t){var e,i,n,s;for(this._order=t,e=new Array(4096),i=e.length,n=0;n<i;++n)s=2*n/i-1,e[n]=0===s?0:this._getCoefficient(s,t,{});this._shaper.curve=e}}),Object.defineProperty(t.Chebyshev.prototype,"oversample",{get:function(){return this._shaper.oversample},set:function(t){this._shaper.oversample=t}}),t.Chebyshev.prototype.dispose=function(){return t.Effect.prototype.dispose.call(this),this._shaper.dispose(),this._shaper=null,this},t.Chebyshev}),t(function(t){return t.StereoEffect=function(){t.AudioNode.call(this);var e=t.defaults(arguments,["wet"],t.Effect);this.createInsOuts(1,1),this._dryWet=new t.CrossFade(e.wet),this.wet=this._dryWet.fade,this._split=new t.Split,this.effectSendL=this._split.left,this.effectSendR=this._split.right,this._merge=new t.Merge,this.effectReturnL=this._merge.left,this.effectReturnR=this._merge.right,this.input.connect(this._split),this.input.connect(this._dryWet,0,0),this._merge.connect(this._dryWet,0,1),this._dryWet.connect(this.output),this._readOnly(["wet"])},t.extend(t.StereoEffect,t.Effect),t.StereoEffect.prototype.dispose=function(){return t.AudioNode.prototype.dispose.call(this),this._dryWet.dispose(),this._dryWet=null,this._split.dispose(),this._split=null,this._merge.dispose(),this._merge=null,this.effectSendL=null,this.effectSendR=null,this.effectReturnL=null,this.effectReturnR=null,this._writable(["wet"]),this.wet=null,this},t.StereoEffect}),t(function(t){return t.Chorus=function(){var e=t.defaults(arguments,["frequency","delayTime","depth"],t.Chorus);t.StereoEffect.call(this,e),this._depth=e.depth,this._delayTime=e.delayTime/1e3,this._lfoL=new t.LFO({frequency:e.frequency,min:0,max:1}),this._lfoR=new t.LFO({frequency:e.frequency,min:0,max:1,phase:180}),this._delayNodeL=new t.Delay,this._delayNodeR=new t.Delay,this.frequency=this._lfoL.frequency,this.effectSendL.chain(this._delayNodeL,this.effectReturnL),this.effectSendR.chain(this._delayNodeR,this.effectReturnR),this.effectSendL.connect(this.effectReturnL),this.effectSendR.connect(this.effectReturnR),this._lfoL.connect(this._delayNodeL.delayTime),this._lfoR.connect(this._delayNodeR.delayTime),this._lfoL.start(),this._lfoR.start(),this._lfoL.frequency.connect(this._lfoR.frequency),this.depth=this._depth,this.frequency.value=e.frequency,this.type=e.type,this._readOnly(["frequency"]),this.spread=e.spread},t.extend(t.Chorus,t.StereoEffect),t.Chorus.defaults={frequency:1.5,delayTime:3.5,depth:.7,type:"sine",spread:180},Object.defineProperty(t.Chorus.prototype,"depth",{get:function(){return this._depth},set:function(t){this._depth=t;var e=this._delayTime*t;this._lfoL.min=Math.max(this._delayTime-e,0),this._lfoL.max=this._delayTime+e,this._lfoR.min=Math.max(this._delayTime-e,0),this._lfoR.max=this._delayTime+e}}),Object.defineProperty(t.Chorus.prototype,"delayTime",{get:function(){return 1e3*this._delayTime},set:function(t){this._delayTime=t/1e3,this.depth=this._depth}}),Object.defineProperty(t.Chorus.prototype,"type",{get:function(){return this._lfoL.type},set:function(t){this._lfoL.type=t,this._lfoR.type=t}}),Object.defineProperty(t.Chorus.prototype,"spread",{get:function(){return this._lfoR.phase-this._lfoL.phase},set:function(t){this._lfoL.phase=90-t/2,this._lfoR.phase=t/2+90}}),t.Chorus.prototype.dispose=function(){return t.StereoEffect.prototype.dispose.call(this),this._lfoL.dispose(),this._lfoL=null,this._lfoR.dispose(),this._lfoR=null,this._delayNodeL.dispose(),this._delayNodeL=null,this._delayNodeR.dispose(),this._delayNodeR=null,this._writable("frequency"),this.frequency=null,this},t.Chorus}),t(function(t){return t.Convolver=function(){var e=t.defaults(arguments,["url","onload"],t.Convolver);t.Effect.call(this,e),this._convolver=this.context.createConvolver(),this._buffer=new t.Buffer(e.url,function(t){this._convolver.buffer=t.get(),e.onload()}.bind(this)),this.connectEffect(this._convolver)},t.extend(t.Convolver,t.Effect),t.Convolver.defaults={onload:t.noOp},Object.defineProperty(t.Convolver.prototype,"buffer",{get:function(){return this._buffer.get()},set:function(t){this._buffer.set(t),this._convolver.buffer=this._buffer.get()}}),t.Convolver.prototype.load=function(t,e){return this._buffer.load(t,function(t){this.buffer=t,e&&e()}.bind(this))},t.Convolver.prototype.dispose=function(){return t.Effect.prototype.dispose.call(this),this._convolver.disconnect(),this._convolver=null,this._buffer.dispose(),this._buffer=null,this},t.Convolver}),t(function(t){return t.Distortion=function(){var e=t.defaults(arguments,["distortion"],t.Distortion);t.Effect.call(this,e),this._shaper=new t.WaveShaper(4096),this._distortion=e.distortion,this.connectEffect(this._shaper),this.distortion=e.distortion,this.oversample=e.oversample},t.extend(t.Distortion,t.Effect),t.Distortion.defaults={distortion:.4,oversample:"none"},Object.defineProperty(t.Distortion.prototype,"distortion",{get:function(){return this._distortion},set:function(t){var e,i;this._distortion=t,e=100*t,i=Math.PI/180,this._shaper.setMap(function(t){return Math.abs(t)<.001?0:(3+e)*t*20*i/(Math.PI+e*Math.abs(t))})}}),Object.defineProperty(t.Distortion.prototype,"oversample",{get:function(){return this._shaper.oversample},set:function(t){this._shaper.oversample=t}}),t.Distortion.prototype.dispose=function(){return t.Effect.prototype.dispose.call(this),this._shaper.dispose(),this._shaper=null,this},t.Distortion}),t(function(t){return t.FeedbackEffect=function(){var e=t.defaults(arguments,["feedback"],t.FeedbackEffect);t.Effect.call(this,e),this._feedbackGain=new t.Gain(e.feedback,t.Type.NormalRange),this.feedback=this._feedbackGain.gain,this.effectReturn.chain(this._feedbackGain,this.effectSend),this._readOnly(["feedback"])},t.extend(t.FeedbackEffect,t.Effect),t.FeedbackEffect.defaults={feedback:.125},t.FeedbackEffect.prototype.dispose=function(){return t.Effect.prototype.dispose.call(this),this._writable(["feedback"]),this._feedbackGain.dispose(),this._feedbackGain=null,this.feedback=null,this},t.FeedbackEffect}),t(function(t){return t.FeedbackDelay=function(){var e=t.defaults(arguments,["delayTime","feedback"],t.FeedbackDelay);t.FeedbackEffect.call(this,e),this._delayNode=new t.Delay(e.delayTime,e.maxDelay),this.delayTime=this._delayNode.delayTime,this.connectEffect(this._delayNode),this._readOnly(["delayTime"])},t.extend(t.FeedbackDelay,t.FeedbackEffect),t.FeedbackDelay.defaults={delayTime:.25,maxDelay:1},t.FeedbackDelay.prototype.dispose=function(){return t.FeedbackEffect.prototype.dispose.call(this),this._delayNode.dispose(),this._delayNode=null,this._writable(["delayTime"]),this.delayTime=null,this},t.FeedbackDelay}),t(function(t){var e=[1557/44100,1617/44100,1491/44100,1422/44100,1277/44100,1356/44100,1188/44100,1116/44100],i=[225,556,441,341];return t.Freeverb=function(){var n,s,o,r,a,h,l=t.defaults(arguments,["roomSize","dampening"],t.Freeverb);for(t.StereoEffect.call(this,l),this.roomSize=new t.Signal(l.roomSize,t.Type.NormalRange),this.dampening=new t.Signal(l.dampening,t.Type.Frequency),this._combFilters=[],this._allpassFiltersL=[],this._allpassFiltersR=[],n=0;n<i.length;n++)s=this.context.createBiquadFilter(),s.type="allpass",s.frequency.value=i[n],this._allpassFiltersL.push(s);for(o=0;o<i.length;o++)r=this.context.createBiquadFilter(),r.type="allpass",r.frequency.value=i[o],this._allpassFiltersR.push(r);for(a=0;a<e.length;a++)h=new t.LowpassCombFilter(e[a]),a<e.length/2?this.effectSendL.chain(h,this._allpassFiltersL[0]):this.effectSendR.chain(h,this._allpassFiltersR[0]),this.roomSize.connect(h.resonance),this.dampening.connect(h.dampening),this._combFilters.push(h);t.connectSeries.apply(t,this._allpassFiltersL),t.connectSeries.apply(t,this._allpassFiltersR),this._allpassFiltersL[this._allpassFiltersL.length-1].connect(this.effectReturnL),this._allpassFiltersR[this._allpassFiltersR.length-1].connect(this.effectReturnR),this._readOnly(["roomSize","dampening"])},t.extend(t.Freeverb,t.StereoEffect),t.Freeverb.defaults={roomSize:.7,dampening:3e3},t.Freeverb.prototype.dispose=function(){var e,i,n;for(t.StereoEffect.prototype.dispose.call(this),e=0;e<this._allpassFiltersL.length;e++)this._allpassFiltersL[e].disconnect(),this._allpassFiltersL[e]=null;for(this._allpassFiltersL=null,i=0;i<this._allpassFiltersR.length;i++)this._allpassFiltersR[i].disconnect(),this._allpassFiltersR[i]=null;for(this._allpassFiltersR=null,n=0;n<this._combFilters.length;n++)this._combFilters[n].dispose(),this._combFilters[n]=null;return this._combFilters=null,this._writable(["roomSize","dampening"]),this.roomSize.dispose(),this.roomSize=null,this.dampening.dispose(),this.dampening=null,this},t.Freeverb}),t(function(t){var e=[.06748,.06404,.08212,.09004],i=[.773,.802,.753,.733],n=[347,113,37];return t.JCReverb=function(){var s,o,r,a,h=t.defaults(arguments,["roomSize"],t.JCReverb);for(t.StereoEffect.call(this,h),this.roomSize=new t.Signal(h.roomSize,t.Type.NormalRange),this._scaleRoomSize=new t.Scale(-.733,.197),this._allpassFilters=[],this._feedbackCombFilters=[],s=0;s<n.length;s++)o=this.context.createBiquadFilter(),o.type="allpass",o.frequency.value=n[s],this._allpassFilters.push(o);for(r=0;r<e.length;r++)a=new t.FeedbackCombFilter(e[r],.1),this._scaleRoomSize.connect(a.resonance),a.resonance.value=i[r],this._allpassFilters[this._allpassFilters.length-1].connect(a),r<e.length/2?a.connect(this.effectReturnL):a.connect(this.effectReturnR),this._feedbackCombFilters.push(a);this.roomSize.connect(this._scaleRoomSize),t.connectSeries.apply(t,this._allpassFilters),
this.effectSendL.connect(this._allpassFilters[0]),this.effectSendR.connect(this._allpassFilters[0]),this._readOnly(["roomSize"])},t.extend(t.JCReverb,t.StereoEffect),t.JCReverb.defaults={roomSize:.5},t.JCReverb.prototype.dispose=function(){var e,i;for(t.StereoEffect.prototype.dispose.call(this),e=0;e<this._allpassFilters.length;e++)this._allpassFilters[e].disconnect(),this._allpassFilters[e]=null;for(this._allpassFilters=null,i=0;i<this._feedbackCombFilters.length;i++)this._feedbackCombFilters[i].dispose(),this._feedbackCombFilters[i]=null;return this._feedbackCombFilters=null,this._writable(["roomSize"]),this.roomSize.dispose(),this.roomSize=null,this._scaleRoomSize.dispose(),this._scaleRoomSize=null,this},t.JCReverb}),t(function(t){return t.MidSideEffect=function(){t.Effect.apply(this,arguments),this._midSideSplit=new t.MidSideSplit,this._midSideMerge=new t.MidSideMerge,this.midSend=this._midSideSplit.mid,this.sideSend=this._midSideSplit.side,this.midReturn=this._midSideMerge.mid,this.sideReturn=this._midSideMerge.side,this.effectSend.connect(this._midSideSplit),this._midSideMerge.connect(this.effectReturn)},t.extend(t.MidSideEffect,t.Effect),t.MidSideEffect.prototype.dispose=function(){return t.Effect.prototype.dispose.call(this),this._midSideSplit.dispose(),this._midSideSplit=null,this._midSideMerge.dispose(),this._midSideMerge=null,this.midSend=null,this.sideSend=null,this.midReturn=null,this.sideReturn=null,this},t.MidSideEffect}),t(function(t){return t.Phaser=function(){var e=t.defaults(arguments,["frequency","octaves","baseFrequency"],t.Phaser);t.StereoEffect.call(this,e),this._lfoL=new t.LFO(e.frequency,0,1),this._lfoR=new t.LFO(e.frequency,0,1),this._lfoR.phase=180,this._baseFrequency=e.baseFrequency,this._octaves=e.octaves,this.Q=new t.Signal(e.Q,t.Type.Positive),this._filtersL=this._makeFilters(e.stages,this._lfoL,this.Q),this._filtersR=this._makeFilters(e.stages,this._lfoR,this.Q),this.frequency=this._lfoL.frequency,this.frequency.value=e.frequency,this.effectSendL.connect(this._filtersL[0]),this.effectSendR.connect(this._filtersR[0]),this._filtersL[e.stages-1].connect(this.effectReturnL),this._filtersR[e.stages-1].connect(this.effectReturnR),this._lfoL.frequency.connect(this._lfoR.frequency),this.baseFrequency=e.baseFrequency,this.octaves=e.octaves,this._lfoL.start(),this._lfoR.start(),this._readOnly(["frequency","Q"])},t.extend(t.Phaser,t.StereoEffect),t.Phaser.defaults={frequency:.5,octaves:3,stages:10,Q:10,baseFrequency:350},t.Phaser.prototype._makeFilters=function(e,i,n){var s,o,r=new Array(e);for(s=0;s<e;s++)o=this.context.createBiquadFilter(),o.type="allpass",n.connect(o.Q),i.connect(o.frequency),r[s]=o;return t.connectSeries.apply(t,r),r},Object.defineProperty(t.Phaser.prototype,"octaves",{get:function(){return this._octaves},set:function(t){this._octaves=t;var e=this._baseFrequency*Math.pow(2,t);this._lfoL.max=e,this._lfoR.max=e}}),Object.defineProperty(t.Phaser.prototype,"baseFrequency",{get:function(){return this._baseFrequency},set:function(t){this._baseFrequency=t,this._lfoL.min=t,this._lfoR.min=t,this.octaves=this._octaves}}),t.Phaser.prototype.dispose=function(){var e,i;for(t.StereoEffect.prototype.dispose.call(this),this._writable(["frequency","Q"]),this.Q.dispose(),this.Q=null,this._lfoL.dispose(),this._lfoL=null,this._lfoR.dispose(),this._lfoR=null,e=0;e<this._filtersL.length;e++)this._filtersL[e].disconnect(),this._filtersL[e]=null;for(this._filtersL=null,i=0;i<this._filtersR.length;i++)this._filtersR[i].disconnect(),this._filtersR[i]=null;return this._filtersR=null,this.frequency=null,this},t.Phaser}),t(function(t){return t.StereoXFeedbackEffect=function(){var e=t.defaults(arguments,["feedback"],t.FeedbackEffect);t.StereoEffect.call(this,e),this.feedback=new t.Signal(e.feedback,t.Type.NormalRange),this._feedbackLR=new t.Gain,this._feedbackRL=new t.Gain,this.effectReturnL.chain(this._feedbackLR,this.effectSendR),this.effectReturnR.chain(this._feedbackRL,this.effectSendL),this.feedback.fan(this._feedbackLR.gain,this._feedbackRL.gain),this._readOnly(["feedback"])},t.extend(t.StereoXFeedbackEffect,t.StereoEffect),t.StereoXFeedbackEffect.prototype.dispose=function(){return t.StereoEffect.prototype.dispose.call(this),this._writable(["feedback"]),this.feedback.dispose(),this.feedback=null,this._feedbackLR.dispose(),this._feedbackLR=null,this._feedbackRL.dispose(),this._feedbackRL=null,this},t.StereoXFeedbackEffect}),t(function(t){return t.PingPongDelay=function(){var e=t.defaults(arguments,["delayTime","feedback"],t.PingPongDelay);t.StereoXFeedbackEffect.call(this,e),this._leftDelay=new t.Delay(0,e.maxDelayTime),this._rightDelay=new t.Delay(0,e.maxDelayTime),this._rightPreDelay=new t.Delay(0,e.maxDelayTime),this.delayTime=new t.Signal(e.delayTime,t.Type.Time),this.effectSendL.chain(this._leftDelay,this.effectReturnL),this.effectSendR.chain(this._rightPreDelay,this._rightDelay,this.effectReturnR),this.delayTime.fan(this._leftDelay.delayTime,this._rightDelay.delayTime,this._rightPreDelay.delayTime),this._feedbackLR.disconnect(),this._feedbackLR.connect(this._rightDelay),this._readOnly(["delayTime"])},t.extend(t.PingPongDelay,t.StereoXFeedbackEffect),t.PingPongDelay.defaults={delayTime:.25,maxDelayTime:1},t.PingPongDelay.prototype.dispose=function(){return t.StereoXFeedbackEffect.prototype.dispose.call(this),this._leftDelay.dispose(),this._leftDelay=null,this._rightDelay.dispose(),this._rightDelay=null,this._rightPreDelay.dispose(),this._rightPreDelay=null,this._writable(["delayTime"]),this.delayTime.dispose(),this.delayTime=null,this},t.PingPongDelay}),t(function(t){return t.PitchShift=function(){var e,i=t.defaults(arguments,["pitch"],t.PitchShift);t.FeedbackEffect.call(this,i),this._frequency=new t.Signal(0),this._delayA=new t.Delay(0,1),this._lfoA=new t.LFO({min:0,max:.1,type:"sawtooth"}).connect(this._delayA.delayTime),this._delayB=new t.Delay(0,1),this._lfoB=new t.LFO({min:0,max:.1,type:"sawtooth",phase:180}).connect(this._delayB.delayTime),this._crossFade=new t.CrossFade,this._crossFadeLFO=new t.LFO({min:0,max:1,type:"triangle",phase:90}).connect(this._crossFade.fade),this._feedbackDelay=new t.Delay(i.delayTime),this.delayTime=this._feedbackDelay.delayTime,this._readOnly("delayTime"),this._pitch=i.pitch,this._windowSize=i.windowSize,this._delayA.connect(this._crossFade.a),this._delayB.connect(this._crossFade.b),this._frequency.fan(this._lfoA.frequency,this._lfoB.frequency,this._crossFadeLFO.frequency),this.effectSend.fan(this._delayA,this._delayB),this._crossFade.chain(this._feedbackDelay,this.effectReturn),e=this.now(),this._lfoA.start(e),this._lfoB.start(e),this._crossFadeLFO.start(e),this.windowSize=this._windowSize},t.extend(t.PitchShift,t.FeedbackEffect),t.PitchShift.defaults={pitch:0,windowSize:.1,delayTime:0,feedback:0},Object.defineProperty(t.PitchShift.prototype,"pitch",{get:function(){return this._pitch},set:function(e){this._pitch=e;var i=0;e<0?(this._lfoA.min=0,this._lfoA.max=this._windowSize,this._lfoB.min=0,this._lfoB.max=this._windowSize,i=t.intervalToFrequencyRatio(e-1)+1):(this._lfoA.min=this._windowSize,this._lfoA.max=0,this._lfoB.min=this._windowSize,this._lfoB.max=0,i=t.intervalToFrequencyRatio(e)-1),this._frequency.value=i*(1.2/this._windowSize)}}),Object.defineProperty(t.PitchShift.prototype,"windowSize",{get:function(){return this._windowSize},set:function(t){this._windowSize=this.toSeconds(t),this.pitch=this._pitch}}),t.PitchShift.prototype.dispose=function(){return t.FeedbackEffect.prototype.dispose.call(this),this._frequency.dispose(),this._frequency=null,this._delayA.disconnect(),this._delayA=null,this._delayB.disconnect(),this._delayB=null,this._lfoA.dispose(),this._lfoA=null,this._lfoB.dispose(),this._lfoB=null,this._crossFade.dispose(),this._crossFade=null,this._crossFadeLFO.dispose(),this._crossFadeLFO=null,this._writable("delayTime"),this._feedbackDelay.dispose(),this._feedbackDelay=null,this.delayTime=null,this},t.PitchShift}),t(function(t){return t.BufferSource=function(){var e=t.defaults(arguments,["buffer","onload"],t.BufferSource);t.AudioNode.call(this,e),this.onended=e.onended,this._startTime=-1,this._sourceStarted=!1,this._sourceStopped=!1,this._stopTime=-1,this._gainNode=this.output=new t.Gain,this._source=this.context.createBufferSource(),this._source.connect(this._gainNode),this._source.onended=this._onended.bind(this),this._buffer=new t.Buffer(e.buffer,e.onload),this.playbackRate=new t.Param(this._source.playbackRate,t.Type.Positive),this.fadeIn=e.fadeIn,this.fadeOut=e.fadeOut,this.curve=e.curve,this._gain=1,this._onendedTimeout=-1,this.loop=e.loop,this.loopStart=e.loopStart,this.loopEnd=e.loopEnd,this.playbackRate.value=e.playbackRate},t.extend(t.BufferSource,t.AudioNode),t.BufferSource.defaults={onended:t.noOp,onload:t.noOp,loop:!1,loopStart:0,loopEnd:0,fadeIn:0,fadeOut:0,curve:"linear",playbackRate:1},Object.defineProperty(t.BufferSource.prototype,"state",{get:function(){return this.getStateAtTime(this.now())}}),t.BufferSource.prototype.getStateAtTime=function(e){return e=this.toSeconds(e),-1!==this._startTime&&e>=this._startTime&&!this._sourceStopped?t.State.Started:t.State.Stopped},t.BufferSource.prototype.start=function(e,i,n,s,o){var r,a,h,l;if(-1!==this._startTime)throw new Error("Tone.BufferSource can only be started once.");if(!this.buffer.loaded)throw new Error("Tone.BufferSource: buffer is either not set or not loaded.");return e=this.toSeconds(e),i=this.loop?t.defaultArg(i,this.loopStart):t.defaultArg(i,0),i=this.toSeconds(i),s=t.defaultArg(s,1),this._gain=s,o=this.toSeconds(t.defaultArg(o,this.fadeIn)),this.fadeIn=o,o>0?(this._gainNode.gain.setValueAtTime(0,e),"linear"===this.curve?this._gainNode.gain.linearRampToValueAtTime(this._gain,e+o):this._gainNode.gain.exponentialApproachValueAtTime(this._gain,e,o)):this._gainNode.gain.setValueAtTime(s,e),this._startTime=e,r=this.toSeconds(t.defaultArg(n,this.buffer.duration-i%this.buffer.duration)),r=Math.max(r,0),t.isDefined(n)&&(this.loop||(r=Math.min(r,this.buffer.duration-i%this.buffer.duration)),this.stop(e+r,this.fadeOut)),this.loop&&(a=this.loopEnd||this.buffer.duration,h=this.loopStart,l=a-h,i>=a&&(i=(i-h)%l+h)),this._source.buffer=this.buffer.get(),this._source.loopEnd=this.loopEnd||this.buffer.duration,i<this.buffer.duration&&(this._sourceStarted=!0,this._source.start(e,i)),this},t.BufferSource.prototype.stop=function(e,i){var n,s;if(!this.buffer.loaded)throw new Error("Tone.BufferSource: buffer is either not set or not loaded.");if(!this._sourceStopped)return e=this.toSeconds(e),-1!==this._stopTime&&this.cancelStop(),e<=this._startTime?(this._gainNode.gain.cancelScheduledValues(e),this._gainNode.gain.value=0,this):(e=Math.max(this._startTime+this.fadeIn+this.sampleTime,e),this._gainNode.gain.cancelScheduledValues(e),this._stopTime=e,i=this.toSeconds(t.defaultArg(i,this.fadeOut)),n=e-this._startTime-this.fadeIn-this.sampleTime,this.loop||(n=Math.min(n,this.buffer.duration)),i=Math.min(n,i),s=e-i,i>this.sampleTime?(this._gainNode.gain.setValueAtTime(this._gain,s),"linear"===this.curve?this._gainNode.gain.linearRampToValueAtTime(0,e):this._gainNode.gain.exponentialApproachValueAtTime(0,s,i)):this._gainNode.gain.setValueAtTime(0,e),t.context.clearTimeout(this._onendedTimeout),this._onendedTimeout=t.context.setTimeout(this._onended.bind(this),this._stopTime-this.now()),this)},t.BufferSource.prototype.cancelStop=function(){if(-1!==this._startTime&&!this._sourceStopped){var t=this.toSeconds(this.fadeIn);this._gainNode.gain.cancelScheduledValues(this._startTime+t+this.sampleTime),this._gainNode.gain.setValueAtTime(1,Math.max(this.now(),this._startTime+t+this.sampleTime)),this.context.clearTimeout(this._onendedTimeout),this._stopTime=-1}return this},t.BufferSource.prototype._onended=function(){if(!this._sourceStopped){this._sourceStopped=!0;var t="exponential"===this.curve?2*this.fadeOut:0;this._sourceStarted&&-1!==this._stopTime&&this._source.stop(this._stopTime+t),this.onended(this)}},Object.defineProperty(t.BufferSource.prototype,"loopStart",{get:function(){return this._source.loopStart},set:function(t){this._source.loopStart=this.toSeconds(t)}}),Object.defineProperty(t.BufferSource.prototype,"loopEnd",{get:function(){return this._source.loopEnd},set:function(t){this._source.loopEnd=this.toSeconds(t)}}),Object.defineProperty(t.BufferSource.prototype,"buffer",{get:function(){return this._buffer},set:function(t){this._buffer.set(t)}}),Object.defineProperty(t.BufferSource.prototype,"loop",{get:function(){return this._source.loop},set:function(t){this._source.loop=t,this.cancelStop()}}),t.BufferSource.prototype.dispose=function(){return t.AudioNode.prototype.dispose.call(this),this.onended=null,this._source.onended=null,this._source.disconnect(),this._source=null,this._gainNode.dispose(),this._gainNode=null,this._buffer.dispose(),this._buffer=null,this._startTime=-1,this.playbackRate=null,t.context.clearTimeout(this._onendedTimeout),this},t.BufferSource}),t(function(t){function e(){for(var e in s)o[e]=(new t.Buffer).fromArray(s[e])}var i,n,s,o;return t.Noise=function(){var e=t.defaults(arguments,["type"],t.Noise);t.Source.call(this,e),this._source=null,this._type=e.type,this._playbackRate=e.playbackRate},t.extend(t.Noise,t.Source),t.Noise.defaults={type:"white",playbackRate:1},Object.defineProperty(t.Noise.prototype,"type",{get:function(){return this._type},set:function(e){if(this._type!==e){if(!(e in o))throw new TypeError("Tone.Noise: invalid type: "+e);if(this._type=e,this.state===t.State.Started){var i=this.now();this._stop(i),this._start(i)}}}}),Object.defineProperty(t.Noise.prototype,"playbackRate",{get:function(){return this._playbackRate},set:function(t){this._playbackRate=t,this._source&&(this._source.playbackRate.value=t)}}),t.Noise.prototype._start=function(e){var i=o[this._type];this._source=new t.BufferSource(i).connect(this.output),this._source.loop=!0,this._source.playbackRate.value=this._playbackRate,this._source.start(this.toSeconds(e),Math.random()*(i.duration-.001))},t.Noise.prototype._stop=function(t){this._source&&(this._source.stop(this.toSeconds(t)),this._source=null)},t.Noise.prototype.restart=function(t){this._stop(t),this._start(t)},t.Noise.prototype.dispose=function(){return t.Source.prototype.dispose.call(this),null!==this._source&&(this._source.disconnect(),this._source=null),this._buffer=null,this},i=220500,n=2,s={pink:function(){var t,e,s,o,r,a,h,l,u,c,p,d=[];for(t=0;t<n;t++)for(e=new Float32Array(i),d[t]=e,s=o=r=a=h=l=u=0,c=0;c<i;c++)p=2*Math.random()-1,s=.99886*s+.0555179*p,o=.99332*o+.0750759*p,r=.969*r+.153852*p,a=.8665*a+.3104856*p,h=.55*h+.5329522*p,l=-.7616*l-.016898*p,e[c]=s+o+r+a+h+l+u+.5362*p,e[c]*=.11,u=.115926*p;return d}(),brown:function(){var t,e,s,o,r,a=[];for(t=0;t<n;t++)for(e=new Float32Array(i),a[t]=e,s=0,o=0;o<i;o++)r=2*Math.random()-1,e[o]=(s+.02*r)/1.02,s=e[o],e[o]*=3.5;return a}(),white:function(){var t,e,s,o=[];for(t=0;t<n;t++)for(e=new Float32Array(i),o[t]=e,s=0;s<i;s++)e[s]=2*Math.random()-1;return o}()},o={},t.getContext(e),t.Context.on("init",e),t.Noise}),t(function(t){return t.Reverb=function(){var e=t.defaults(arguments,["decay"],t.Reverb);t.Effect.call(this,e),this._convolver=this.context.createConvolver(),this.decay=e.decay,this.preDelay=e.preDelay,this.connectEffect(this._convolver)},t.extend(t.Reverb,t.Effect),t.Reverb.defaults={decay:1.5,preDelay:.01},t.Reverb.prototype.generate=function(){return t.Offline(function(){var e,i=new t.Noise,n=new t.Noise,s=new t.Merge;i.connect(s.left),n.connect(s.right),e=(new t.Gain).toMaster(),s.connect(e),i.start(0),n.start(0),e.gain.setValueAtTime(0,0),e.gain.linearRampToValueAtTime(1,this.preDelay),e.gain.exponentialApproachValueAtTime(0,this.preDelay,this.decay-this.preDelay)}.bind(this),this.decay).then(function(t){return this._convolver.buffer=t.get(),this}.bind(this))},t.Reverb.prototype.dispose=function(){return t.Effect.prototype.dispose.call(this),this._convolver.disconnect(),this._convolver=null,this},t.Reverb}),t(function(t){return t.StereoFeedbackEffect=function(){var e=t.defaults(arguments,["feedback"],t.FeedbackEffect);t.StereoEffect.call(this,e),this.feedback=new t.Signal(e.feedback,t.Type.NormalRange),this._feedbackL=new t.Gain,this._feedbackR=new t.Gain,this.effectReturnL.chain(this._feedbackL,this.effectSendL),this.effectReturnR.chain(this._feedbackR,this.effectSendR),this.feedback.fan(this._feedbackL.gain,this._feedbackR.gain),this._readOnly(["feedback"])},t.extend(t.StereoFeedbackEffect,t.StereoEffect),t.StereoFeedbackEffect.prototype.dispose=function(){return t.StereoEffect.prototype.dispose.call(this),this._writable(["feedback"]),this.feedback.dispose(),this.feedback=null,this._feedbackL.dispose(),this._feedbackL=null,this._feedbackR.dispose(),this._feedbackR=null,this},t.StereoFeedbackEffect}),t(function(t){return t.StereoWidener=function(){var e=t.defaults(arguments,["width"],t.StereoWidener);t.MidSideEffect.call(this,e),this.width=new t.Signal(e.width,t.Type.NormalRange),this._readOnly(["width"]),this._twoTimesWidthMid=new t.Multiply(2),this._twoTimesWidthSide=new t.Multiply(2),this._midMult=new t.Multiply,this._twoTimesWidthMid.connect(this._midMult,0,1),this.midSend.chain(this._midMult,this.midReturn),this._oneMinusWidth=new t.Subtract,this._oneMinusWidth.connect(this._twoTimesWidthMid),this.context.getConstant(1).connect(this._oneMinusWidth,0,0),this.width.connect(this._oneMinusWidth,0,1),this._sideMult=new t.Multiply,this.width.connect(this._twoTimesWidthSide),this._twoTimesWidthSide.connect(this._sideMult,0,1),this.sideSend.chain(this._sideMult,this.sideReturn)},t.extend(t.StereoWidener,t.MidSideEffect),t.StereoWidener.defaults={width:.5},t.StereoWidener.prototype.dispose=function(){return t.MidSideEffect.prototype.dispose.call(this),this._writable(["width"]),this.width.dispose(),this.width=null,this._midMult.dispose(),this._midMult=null,this._sideMult.dispose(),this._sideMult=null,this._twoTimesWidthMid.dispose(),this._twoTimesWidthMid=null,this._twoTimesWidthSide.dispose(),this._twoTimesWidthSide=null,this._oneMinusWidth.dispose(),this._oneMinusWidth=null,this},t.StereoWidener}),t(function(t){return t.Tremolo=function(){var e=t.defaults(arguments,["frequency","depth"],t.Tremolo);t.StereoEffect.call(this,e),this._lfoL=new t.LFO({phase:e.spread,min:1,max:0}),this._lfoR=new t.LFO({phase:e.spread,min:1,max:0}),this._amplitudeL=new t.Gain,this._amplitudeR=new t.Gain,this.frequency=new t.Signal(e.frequency,t.Type.Frequency),this.depth=new t.Signal(e.depth,t.Type.NormalRange),this._readOnly(["frequency","depth"]),this.effectSendL.chain(this._amplitudeL,this.effectReturnL),this.effectSendR.chain(this._amplitudeR,this.effectReturnR),this._lfoL.connect(this._amplitudeL.gain),this._lfoR.connect(this._amplitudeR.gain),this.frequency.fan(this._lfoL.frequency,this._lfoR.frequency),this.depth.fan(this._lfoR.amplitude,this._lfoL.amplitude),this.type=e.type,this.spread=e.spread},t.extend(t.Tremolo,t.StereoEffect),t.Tremolo.defaults={frequency:10,type:"sine",depth:.5,spread:180},t.Tremolo.prototype.start=function(t){return this._lfoL.start(t),this._lfoR.start(t),this},t.Tremolo.prototype.stop=function(t){return this._lfoL.stop(t),this._lfoR.stop(t),this},t.Tremolo.prototype.sync=function(e){return this._lfoL.sync(e),this._lfoR.sync(e),t.Transport.syncSignal(this.frequency),this},t.Tremolo.prototype.unsync=function(){return this._lfoL.unsync(),this._lfoR.unsync(),t.Transport.unsyncSignal(this.frequency),this},Object.defineProperty(t.Tremolo.prototype,"type",{get:function(){return this._lfoL.type},set:function(t){this._lfoL.type=t,this._lfoR.type=t}}),Object.defineProperty(t.Tremolo.prototype,"spread",{get:function(){return this._lfoR.phase-this._lfoL.phase},set:function(t){this._lfoL.phase=90-t/2,this._lfoR.phase=t/2+90}}),t.Tremolo.prototype.dispose=function(){return t.StereoEffect.prototype.dispose.call(this),this._writable(["frequency","depth"]),this._lfoL.dispose(),this._lfoL=null,this._lfoR.dispose(),this._lfoR=null,this._amplitudeL.dispose(),this._amplitudeL=null,this._amplitudeR.dispose(),this._amplitudeR=null,this.frequency=null,this.depth=null,this},t.Tremolo}),t(function(t){return t.Vibrato=function(){var e=t.defaults(arguments,["frequency","depth"],t.Vibrato);t.Effect.call(this,e),this._delayNode=new t.Delay(0,e.maxDelay),this._lfo=new t.LFO({type:e.type,min:0,max:e.maxDelay,frequency:e.frequency,phase:-90}).start().connect(this._delayNode.delayTime),this.frequency=this._lfo.frequency,this.depth=this._lfo.amplitude,this.depth.value=e.depth,this._readOnly(["frequency","depth"]),this.effectSend.chain(this._delayNode,this.effectReturn)},t.extend(t.Vibrato,t.Effect),t.Vibrato.defaults={maxDelay:.005,frequency:5,depth:.1,type:"sine"},Object.defineProperty(t.Vibrato.prototype,"type",{get:function(){return this._lfo.type},set:function(t){this._lfo.type=t}}),t.Vibrato.prototype.dispose=function(){t.Effect.prototype.dispose.call(this),this._delayNode.dispose(),this._delayNode=null,this._lfo.dispose(),this._lfo=null,this._writable(["frequency","depth"]),this.frequency=null,this.depth=null},t.Vibrato}),t(function(t){return t.Event=function(){var e=t.defaults(arguments,["callback","value"],t.Event);t.call(this),this._loop=e.loop,this.callback=e.callback,this.value=e.value,this._loopStart=this.toTicks(e.loopStart),this._loopEnd=this.toTicks(e.loopEnd),this._state=new t.TimelineState(t.State.Stopped),this._playbackRate=1,this._startOffset=0,this._probability=e.probability,this._humanize=e.humanize,this.mute=e.mute,this.playbackRate=e.playbackRate},t.extend(t.Event),t.Event.defaults={callback:t.noOp,loop:!1,loopEnd:"1m",loopStart:0,playbackRate:1,value:null,probability:1,mute:!1,humanize:!1},t.Event.prototype._rescheduleEvents=function(e){return e=t.defaultArg(e,-1),this._state.forEachFrom(e,function(e){var i,n,s,o;e.state===t.State.Started&&(t.isDefined(e.id)&&t.Transport.clear(e.id),n=e.time+Math.round(this.startOffset/this._playbackRate),this._loop?(i=1/0,t.isNumber(this._loop)&&(i=this._loop*this._getLoopDuration()),s=this._state.getAfter(n),null!==s&&(i=Math.min(i,s.time-n)),i!==1/0&&(this._state.setStateAtTime(t.State.Stopped,n+i+1),i=t.Ticks(i)),o=t.Ticks(this._getLoopDuration()),e.id=t.Transport.scheduleRepeat(this._tick.bind(this),o,t.Ticks(n),i)):e.id=t.Transport.schedule(this._tick.bind(this),t.Ticks(n)))}.bind(this)),this},Object.defineProperty(t.Event.prototype,"state",{get:function(){return this._state.getValueAtTime(t.Transport.ticks)}}),Object.defineProperty(t.Event.prototype,"startOffset",{get:function(){return this._startOffset},set:function(t){this._startOffset=t}}),Object.defineProperty(t.Event.prototype,"probability",{get:function(){return this._probability},set:function(t){this._probability=t}}),Object.defineProperty(t.Event.prototype,"humanize",{get:function(){return this._humanize},set:function(t){this._humanize=t}}),t.Event.prototype.start=function(e){return e=this.toTicks(e),this._state.getValueAtTime(e)===t.State.Stopped&&(this._state.add({state:t.State.Started,time:e,id:void 0}),this._rescheduleEvents(e)),this},t.Event.prototype.stop=function(e){var i,n;return this.cancel(e),e=this.toTicks(e),this._state.getValueAtTime(e)===t.State.Started&&(this._state.setStateAtTime(t.State.Stopped,e),i=this._state.getBefore(e),n=e,null!==i&&(n=i.time),this._rescheduleEvents(n)),this},t.Event.prototype.cancel=function(e){return e=t.defaultArg(e,-1/0),e=this.toTicks(e),this._state.forEachFrom(e,function(e){t.Transport.clear(e.id)}),this._state.cancel(e),this},t.Event.prototype._tick=function(e){var i,n=t.Transport.getTicksAtTime(e);if(!this.mute&&this._state.getValueAtTime(n)===t.State.Started){if(this.probability<1&&Math.random()>this.probability)return;this.humanize&&(i=.02,t.isBoolean(this.humanize)||(i=this.toSeconds(this.humanize)),e+=(2*Math.random()-1)*i),this.callback(e,this.value)}},t.Event.prototype._getLoopDuration=function(){return Math.round((this._loopEnd-this._loopStart)/this._playbackRate)},Object.defineProperty(t.Event.prototype,"loop",{get:function(){return this._loop},set:function(t){this._loop=t,this._rescheduleEvents()}}),Object.defineProperty(t.Event.prototype,"playbackRate",{get:function(){return this._playbackRate},set:function(t){this._playbackRate=t,this._rescheduleEvents()}}),Object.defineProperty(t.Event.prototype,"loopEnd",{get:function(){return t.Ticks(this._loopEnd).toSeconds()},set:function(t){this._loopEnd=this.toTicks(t),this._loop&&this._rescheduleEvents()}}),Object.defineProperty(t.Event.prototype,"loopStart",{get:function(){return t.Ticks(this._loopStart).toSeconds()},set:function(t){this._loopStart=this.toTicks(t),this._loop&&this._rescheduleEvents()}}),Object.defineProperty(t.Event.prototype,"progress",{get:function(){var e,i,n;return this._loop?(e=t.Transport.ticks,i=this._state.get(e),null!==i&&i.state===t.State.Started?(n=this._getLoopDuration(),(e-i.time)%n/n):0):0}}),t.Event.prototype.dispose=function(){this.cancel(),this._state.dispose(),this._state=null,this.callback=null,this.value=null},t.Event}),t(function(t){return t.Loop=function(){var e=t.defaults(arguments,["callback","interval"],t.Loop);t.call(this),this._event=new t.Event({callback:this._tick.bind(this),loop:!0,loopEnd:e.interval,playbackRate:e.playbackRate,probability:e.probability}),this.callback=e.callback,this.iterations=e.iterations},t.extend(t.Loop),t.Loop.defaults={interval:"4n",callback:t.noOp,playbackRate:1,iterations:1/0,probability:!0,mute:!1},t.Loop.prototype.start=function(t){return this._event.start(t),this},t.Loop.prototype.stop=function(t){return this._event.stop(t),this},t.Loop.prototype.cancel=function(t){return this._event.cancel(t),this},t.Loop.prototype._tick=function(t){this.callback(t)},Object.defineProperty(t.Loop.prototype,"state",{get:function(){return this._event.state}}),Object.defineProperty(t.Loop.prototype,"progress",{get:function(){return this._event.progress}}),Object.defineProperty(t.Loop.prototype,"interval",{get:function(){return this._event.loopEnd},set:function(t){this._event.loopEnd=t}}),Object.defineProperty(t.Loop.prototype,"playbackRate",{get:function(){return this._event.playbackRate},set:function(t){this._event.playbackRate=t}}),Object.defineProperty(t.Loop.prototype,"humanize",{get:function(){return this._event.humanize},set:function(t){this._event.humanize=t}}),Object.defineProperty(t.Loop.prototype,"probability",{get:function(){return this._event.probability},set:function(t){this._event.probability=t}}),Object.defineProperty(t.Loop.prototype,"mute",{get:function(){return this._event.mute},set:function(t){this._event.mute=t}}),Object.defineProperty(t.Loop.prototype,"iterations",{get:function(){return!0===this._event.loop?1/0:this._event.loop},set:function(t){this._event.loop=t===1/0||t}}),t.Loop.prototype.dispose=function(){this._event.dispose(),this._event=null,this.callback=null},t.Loop}),t(function(t){return t.Part=function(){var e,i=t.defaults(arguments,["callback","events"],t.Part);for(t.Event.call(this,i),this._events=[],e=0;e<i.events.length;e++)Array.isArray(i.events[e])?this.add(i.events[e][0],i.events[e][1]):this.add(i.events[e])},t.extend(t.Part,t.Event),t.Part.defaults={callback:t.noOp,loop:!1,loopEnd:"1m",loopStart:0,playbackRate:1,probability:1,humanize:!1,mute:!1,events:[]},t.Part.prototype.start=function(e,i){var n=this.toTicks(e);return this._state.getValueAtTime(n)!==t.State.Started&&(i=this._loop?t.defaultArg(i,this._loopStart):t.defaultArg(i,0),i=this.toTicks(i),this._state.add({state:t.State.Started,time:n,offset:i}),this._forEach(function(t){this._startNote(t,n,i)})),this},t.Part.prototype._startNote=function(e,i,n){i-=n,this._loop?e.startOffset>=this._loopStart&&e.startOffset<this._loopEnd?(e.startOffset<n&&(i+=this._getLoopDuration()),e.start(t.Ticks(i))):e.startOffset<this._loopStart&&e.startOffset>=n&&(e.loop=!1,e.start(t.Ticks(i))):e.startOffset>=n&&e.start(t.Ticks(i))},Object.defineProperty(t.Part.prototype,"startOffset",{get:function(){return this._startOffset},set:function(t){this._startOffset=t,this._forEach(function(t){t.startOffset+=this._startOffset})}}),t.Part.prototype.stop=function(e){var i=this.toTicks(e);return this._state.cancel(i),this._state.setStateAtTime(t.State.Stopped,i),this._forEach(function(t){t.stop(e)}),this},t.Part.prototype.at=function(e,i){var n,s,o;for(e=t.TransportTime(e),n=t.Ticks(1).toSeconds(),s=0;s<this._events.length;s++)if(o=this._events[s],Math.abs(e.toTicks()-o.startOffset)<n)return t.isDefined(i)&&(o.value=i),o;return t.isDefined(i)?(this.add(e,i),this._events[this._events.length-1]):null},t.Part.prototype.add=function(e,i){e.hasOwnProperty("time")&&(i=e,e=i.time),e=this.toTicks(e);var n;return i instanceof t.Event?(n=i,n.callback=this._tick.bind(this)):n=new t.Event({callback:this._tick.bind(this),value:i}),n.startOffset=e,n.set({loopEnd:this.loopEnd,loopStart:this.loopStart,loop:this.loop,humanize:this.humanize,playbackRate:this.playbackRate,probability:this.probability}),this._events.push(n),this._restartEvent(n),this},t.Part.prototype._restartEvent=function(e){this._state.forEach(function(i){i.state===t.State.Started?this._startNote(e,i.time,i.offset):e.stop(t.Ticks(i.time))}.bind(this))},t.Part.prototype.remove=function(e,i){var n,s;for(e.hasOwnProperty("time")&&(i=e,e=i.time),e=this.toTicks(e),n=this._events.length-1;n>=0;n--)s=this._events[n],s instanceof t.Part?s.remove(e,i):s.startOffset===e&&(t.isUndef(i)||t.isDefined(i)&&s.value===i)&&(this._events.splice(n,1),s.dispose());return this},t.Part.prototype.removeAll=function(){return this._forEach(function(t){t.dispose()}),this._events=[],this},t.Part.prototype.cancel=function(t){return this._forEach(function(e){e.cancel(t)}),this._state.cancel(this.toTicks(t)),this},t.Part.prototype._forEach=function(e,i){var n,s;if(this._events)for(i=t.defaultArg(i,this),n=this._events.length-1;n>=0;n--)s=this._events[n],s instanceof t.Part?s._forEach(e,i):e.call(i,s);return this},t.Part.prototype._setAll=function(t,e){this._forEach(function(i){i[t]=e})},t.Part.prototype._tick=function(t,e){this.mute||this.callback(t,e)},t.Part.prototype._testLoopBoundries=function(e){e.startOffset<this._loopStart||e.startOffset>=this._loopEnd?e.cancel(0):e.state===t.State.Stopped&&this._restartEvent(e)},Object.defineProperty(t.Part.prototype,"probability",{get:function(){return this._probability},set:function(t){this._probability=t,this._setAll("probability",t)}}),Object.defineProperty(t.Part.prototype,"humanize",{get:function(){return this._humanize},set:function(t){this._humanize=t,this._setAll("humanize",t)}}),Object.defineProperty(t.Part.prototype,"loop",{get:function(){return this._loop},set:function(t){this._loop=t,this._forEach(function(e){e._loopStart=this._loopStart,e._loopEnd=this._loopEnd,e.loop=t,this._testLoopBoundries(e)})}}),Object.defineProperty(t.Part.prototype,"loopEnd",{get:function(){return t.Ticks(this._loopEnd).toSeconds()},set:function(t){this._loopEnd=this.toTicks(t),this._loop&&this._forEach(function(e){e.loopEnd=t,this._testLoopBoundries(e)})}}),Object.defineProperty(t.Part.prototype,"loopStart",{get:function(){return t.Ticks(this._loopStart).toSeconds()},set:function(t){this._loopStart=this.toTicks(t),this._loop&&this._forEach(function(t){t.loopStart=this.loopStart,this._testLoopBoundries(t)})}}),Object.defineProperty(t.Part.prototype,"playbackRate",{get:function(){return this._playbackRate},set:function(t){this._playbackRate=t,this._setAll("playbackRate",t)}}),Object.defineProperty(t.Part.prototype,"length",{get:function(){return this._events.length}}),t.Part.prototype.dispose=function(){return this.removeAll(),this._state.dispose(),this._state=null,this.callback=null,this._events=null,this},t.Part}),t(function(t){return t.Pattern=function(){var e=t.defaults(arguments,["callback","values","pattern"],t.Pattern);t.Loop.call(this,e),this._pattern=new t.CtrlPattern({values:e.values,type:e.pattern,index:e.index})},t.extend(t.Pattern,t.Loop),t.Pattern.defaults={pattern:t.CtrlPattern.Type.Up,callback:t.noOp,values:[]},t.Pattern.prototype._tick=function(t){
this.callback(t,this._pattern.value),this._pattern.next()},Object.defineProperty(t.Pattern.prototype,"index",{get:function(){return this._pattern.index},set:function(t){this._pattern.index=t}}),Object.defineProperty(t.Pattern.prototype,"values",{get:function(){return this._pattern.values},set:function(t){this._pattern.values=t}}),Object.defineProperty(t.Pattern.prototype,"value",{get:function(){return this._pattern.value}}),Object.defineProperty(t.Pattern.prototype,"pattern",{get:function(){return this._pattern.type},set:function(t){this._pattern.type=t}}),t.Pattern.prototype.dispose=function(){t.Loop.prototype.dispose.call(this),this._pattern.dispose(),this._pattern=null},t.Pattern}),t(function(t){return t.Sequence=function(){var e,i=t.defaults(arguments,["callback","events","subdivision"],t.Sequence),n=i.events;if(delete i.events,t.Part.call(this,i),this._subdivision=this.toTicks(i.subdivision),t.isUndef(i.loopEnd)&&t.isDefined(n)&&(this._loopEnd=n.length*this._subdivision),this._loop=!0,t.isDefined(n))for(e=0;e<n.length;e++)this.add(e,n[e])},t.extend(t.Sequence,t.Part),t.Sequence.defaults={subdivision:"4n"},Object.defineProperty(t.Sequence.prototype,"subdivision",{get:function(){return t.Ticks(this._subdivision).toSeconds()}}),t.Sequence.prototype.at=function(e,i){return t.isArray(i)&&this.remove(e),t.Part.prototype.at.call(this,this._indexTime(e),i)},t.Sequence.prototype.add=function(e,i){if(null===i)return this;if(t.isArray(i)){var n=Math.round(this._subdivision/i.length);i=new t.Sequence(this._tick.bind(this),i,t.Ticks(n))}return t.Part.prototype.add.call(this,this._indexTime(e),i),this},t.Sequence.prototype.remove=function(e,i){return t.Part.prototype.remove.call(this,this._indexTime(e),i),this},t.Sequence.prototype._indexTime=function(e){return e instanceof t.TransportTime?e:t.Ticks(e*this._subdivision+this.startOffset).toSeconds()},t.Sequence.prototype.dispose=function(){return t.Part.prototype.dispose.call(this),this},t.Sequence}),t(function(t){return t.PulseOscillator=function(){var e=t.defaults(arguments,["frequency","width"],t.Oscillator);t.Source.call(this,e),this.width=new t.Signal(e.width,t.Type.NormalRange),this._widthGate=new t.Gain,this._sawtooth=new t.Oscillator({frequency:e.frequency,detune:e.detune,type:"sawtooth",phase:e.phase}),this.frequency=this._sawtooth.frequency,this.detune=this._sawtooth.detune,this._thresh=new t.WaveShaper(function(t){return t<0?-1:1}),this._sawtooth.chain(this._thresh,this.output),this.width.chain(this._widthGate,this._thresh),this._readOnly(["width","frequency","detune"])},t.extend(t.PulseOscillator,t.Source),t.PulseOscillator.defaults={frequency:440,detune:0,phase:0,width:.2},t.PulseOscillator.prototype._start=function(t){t=this.toSeconds(t),this._sawtooth.start(t),this._widthGate.gain.setValueAtTime(1,t)},t.PulseOscillator.prototype._stop=function(t){t=this.toSeconds(t),this._sawtooth.stop(t),this._widthGate.gain.setValueAtTime(0,t)},t.PulseOscillator.prototype.restart=function(t){this._sawtooth.restart(t)},Object.defineProperty(t.PulseOscillator.prototype,"phase",{get:function(){return this._sawtooth.phase},set:function(t){this._sawtooth.phase=t}}),Object.defineProperty(t.PulseOscillator.prototype,"type",{get:function(){return"pulse"}}),Object.defineProperty(t.PulseOscillator.prototype,"partials",{get:function(){return[]}}),t.PulseOscillator.prototype.dispose=function(){return t.Source.prototype.dispose.call(this),this._sawtooth.dispose(),this._sawtooth=null,this._writable(["width","frequency","detune"]),this.width.dispose(),this.width=null,this._widthGate.dispose(),this._widthGate=null,this._thresh.dispose(),this._thresh=null,this.frequency=null,this.detune=null,this},t.PulseOscillator}),t(function(t){return t.PWMOscillator=function(){var e=t.defaults(arguments,["frequency","modulationFrequency"],t.PWMOscillator);t.Source.call(this,e),this._pulse=new t.PulseOscillator(e.modulationFrequency),this._pulse._sawtooth.type="sine",this._modulator=new t.Oscillator({frequency:e.frequency,detune:e.detune,phase:e.phase}),this._scale=new t.Multiply(2),this.frequency=this._modulator.frequency,this.detune=this._modulator.detune,this.modulationFrequency=this._pulse.frequency,this._modulator.chain(this._scale,this._pulse.width),this._pulse.connect(this.output),this._readOnly(["modulationFrequency","frequency","detune"])},t.extend(t.PWMOscillator,t.Source),t.PWMOscillator.defaults={frequency:440,detune:0,phase:0,modulationFrequency:.4},t.PWMOscillator.prototype._start=function(t){t=this.toSeconds(t),this._modulator.start(t),this._pulse.start(t)},t.PWMOscillator.prototype._stop=function(t){t=this.toSeconds(t),this._modulator.stop(t),this._pulse.stop(t)},t.PWMOscillator.prototype.restart=function(t){this._modulator.restart(t),this._pulse.restart(t)},Object.defineProperty(t.PWMOscillator.prototype,"type",{get:function(){return"pwm"}}),Object.defineProperty(t.PWMOscillator.prototype,"partials",{get:function(){return[]}}),Object.defineProperty(t.PWMOscillator.prototype,"phase",{get:function(){return this._modulator.phase},set:function(t){this._modulator.phase=t}}),t.PWMOscillator.prototype.dispose=function(){return t.Source.prototype.dispose.call(this),this._pulse.dispose(),this._pulse=null,this._scale.dispose(),this._scale=null,this._modulator.dispose(),this._modulator=null,this._writable(["modulationFrequency","frequency","detune"]),this.frequency=null,this.detune=null,this.modulationFrequency=null,this},t.PWMOscillator}),t(function(t){return t.FMOscillator=function(){var e=t.defaults(arguments,["frequency","type","modulationType"],t.FMOscillator);t.Source.call(this,e),this._carrier=new t.Oscillator(e.frequency,e.type),this.frequency=new t.Signal(e.frequency,t.Type.Frequency),this.detune=this._carrier.detune,this.detune.value=e.detune,this.modulationIndex=new t.Multiply(e.modulationIndex),this.modulationIndex.units=t.Type.Positive,this._modulator=new t.Oscillator(e.frequency,e.modulationType),this.harmonicity=new t.Multiply(e.harmonicity),this.harmonicity.units=t.Type.Positive,this._modulationNode=new t.Gain(0),this.frequency.connect(this._carrier.frequency),this.frequency.chain(this.harmonicity,this._modulator.frequency),this.frequency.chain(this.modulationIndex,this._modulationNode),this._modulator.connect(this._modulationNode.gain),this._modulationNode.connect(this._carrier.frequency),this._carrier.connect(this.output),this.detune.connect(this._modulator.detune),this.phase=e.phase,this._readOnly(["modulationIndex","frequency","detune","harmonicity"])},t.extend(t.FMOscillator,t.Source),t.FMOscillator.defaults={frequency:440,detune:0,phase:0,modulationIndex:2,modulationType:"square",harmonicity:1},t.FMOscillator.prototype._start=function(t){this._modulator.start(t),this._carrier.start(t)},t.FMOscillator.prototype._stop=function(t){this._modulator.stop(t),this._carrier.stop(t)},t.FMOscillator.prototype.restart=function(t){this._modulator.restart(t),this._carrier.restart(t)},Object.defineProperty(t.FMOscillator.prototype,"type",{get:function(){return this._carrier.type},set:function(t){this._carrier.type=t}}),Object.defineProperty(t.FMOscillator.prototype,"modulationType",{get:function(){return this._modulator.type},set:function(t){this._modulator.type=t}}),Object.defineProperty(t.FMOscillator.prototype,"phase",{get:function(){return this._carrier.phase},set:function(t){this._carrier.phase=t,this._modulator.phase=t}}),Object.defineProperty(t.FMOscillator.prototype,"partials",{get:function(){return this._carrier.partials},set:function(t){this._carrier.partials=t}}),t.FMOscillator.prototype.dispose=function(){return t.Source.prototype.dispose.call(this),this._writable(["modulationIndex","frequency","detune","harmonicity"]),this.frequency.dispose(),this.frequency=null,this.detune=null,this.harmonicity.dispose(),this.harmonicity=null,this._carrier.dispose(),this._carrier=null,this._modulator.dispose(),this._modulator=null,this._modulationNode.dispose(),this._modulationNode=null,this.modulationIndex.dispose(),this.modulationIndex=null,this},t.FMOscillator}),t(function(t){return t.AMOscillator=function(){var e=t.defaults(arguments,["frequency","type","modulationType"],t.AMOscillator);t.Source.call(this,e),this._carrier=new t.Oscillator(e.frequency,e.type),this.frequency=this._carrier.frequency,this.detune=this._carrier.detune,this.detune.value=e.detune,this._modulator=new t.Oscillator(e.frequency,e.modulationType),this._modulationScale=new t.AudioToGain,this.harmonicity=new t.Multiply(e.harmonicity),this.harmonicity.units=t.Type.Positive,this._modulationNode=new t.Gain(0),this.frequency.chain(this.harmonicity,this._modulator.frequency),this.detune.connect(this._modulator.detune),this._modulator.chain(this._modulationScale,this._modulationNode.gain),this._carrier.chain(this._modulationNode,this.output),this.phase=e.phase,this._readOnly(["frequency","detune","harmonicity"])},t.extend(t.AMOscillator,t.Oscillator),t.AMOscillator.defaults={frequency:440,detune:0,phase:0,modulationType:"square",harmonicity:1},t.AMOscillator.prototype._start=function(t){this._modulator.start(t),this._carrier.start(t)},t.AMOscillator.prototype._stop=function(t){this._modulator.stop(t),this._carrier.stop(t)},t.AMOscillator.prototype.restart=function(t){this._modulator.restart(t),this._carrier.restart(t)},Object.defineProperty(t.AMOscillator.prototype,"type",{get:function(){return this._carrier.type},set:function(t){this._carrier.type=t}}),Object.defineProperty(t.AMOscillator.prototype,"modulationType",{get:function(){return this._modulator.type},set:function(t){this._modulator.type=t}}),Object.defineProperty(t.AMOscillator.prototype,"phase",{get:function(){return this._carrier.phase},set:function(t){this._carrier.phase=t,this._modulator.phase=t}}),Object.defineProperty(t.AMOscillator.prototype,"partials",{get:function(){return this._carrier.partials},set:function(t){this._carrier.partials=t}}),t.AMOscillator.prototype.dispose=function(){return t.Source.prototype.dispose.call(this),this._writable(["frequency","detune","harmonicity"]),this.frequency=null,this.detune=null,this.harmonicity.dispose(),this.harmonicity=null,this._carrier.dispose(),this._carrier=null,this._modulator.dispose(),this._modulator=null,this._modulationNode.dispose(),this._modulationNode=null,this._modulationScale.dispose(),this._modulationScale=null,this},t.AMOscillator}),t(function(t){return t.FatOscillator=function(){var e=t.defaults(arguments,["frequency","type","spread"],t.FatOscillator);t.Source.call(this,e),this.frequency=new t.Signal(e.frequency,t.Type.Frequency),this.detune=new t.Signal(e.detune,t.Type.Cents),this._oscillators=[],this._spread=e.spread,this._type=e.type,this._phase=e.phase,this._partials=t.defaultArg(e.partials,[]),this.count=e.count,this._readOnly(["frequency","detune"])},t.extend(t.FatOscillator,t.Source),t.FatOscillator.defaults={frequency:440,detune:0,phase:0,spread:20,count:3,type:"sawtooth"},t.FatOscillator.prototype._start=function(t){t=this.toSeconds(t),this._forEach(function(e){e.start(t)})},t.FatOscillator.prototype._stop=function(t){t=this.toSeconds(t),this._forEach(function(e){e.stop(t)})},t.FatOscillator.prototype.restart=function(t){t=this.toSeconds(t),this._forEach(function(e){e.restart(t)})},t.FatOscillator.prototype._forEach=function(t){for(var e=0;e<this._oscillators.length;e++)t.call(this,this._oscillators[e],e)},Object.defineProperty(t.FatOscillator.prototype,"type",{get:function(){return this._type},set:function(t){this._type=t,this._forEach(function(e){e.type=t})}}),Object.defineProperty(t.FatOscillator.prototype,"spread",{get:function(){return this._spread},set:function(t){var e,i;this._spread=t,this._oscillators.length>1&&(e=-t/2,i=t/(this._oscillators.length-1),this._forEach(function(t,n){t.detune.value=e+i*n}))}}),Object.defineProperty(t.FatOscillator.prototype,"count",{get:function(){return this._oscillators.length},set:function(e){var i,n;if(e=Math.max(e,1),this._oscillators.length!==e){for(this._forEach(function(t){t.dispose()}),this._oscillators=[],i=0;i<e;i++)n=new t.Oscillator,this.type===t.Oscillator.Type.Custom?n.partials=this._partials:n.type=this._type,n.phase=this._phase,n.volume.value=-6-1.1*e,this.frequency.connect(n.frequency),this.detune.connect(n.detune),n.connect(this.output),this._oscillators[i]=n;this.spread=this._spread,this.state===t.State.Started&&this._forEach(function(t){t.start()})}}}),Object.defineProperty(t.FatOscillator.prototype,"phase",{get:function(){return this._phase},set:function(t){this._phase=t,this._forEach(function(e){e.phase=t})}}),Object.defineProperty(t.FatOscillator.prototype,"partials",{get:function(){return this._partials},set:function(e){this._partials=e,this._type=t.Oscillator.Type.Custom,this._forEach(function(t){t.partials=e})}}),t.FatOscillator.prototype.dispose=function(){return t.Source.prototype.dispose.call(this),this._writable(["frequency","detune"]),this.frequency.dispose(),this.frequency=null,this.detune.dispose(),this.detune=null,this._forEach(function(t){t.dispose()}),this._oscillators=null,this._partials=null,this},t.FatOscillator}),t(function(t){t.OmniOscillator=function(){var e=t.defaults(arguments,["frequency","type"],t.OmniOscillator);t.Source.call(this,e),this.frequency=new t.Signal(e.frequency,t.Type.Frequency),this.detune=new t.Signal(e.detune,t.Type.Cents),this._sourceType=void 0,this._oscillator=null,this.type=e.type,this._readOnly(["frequency","detune"]),this.set(e)},t.extend(t.OmniOscillator,t.Source),t.OmniOscillator.defaults={frequency:440,detune:0,type:"sine",phase:0};var e={Pulse:"PulseOscillator",PWM:"PWMOscillator",Osc:"Oscillator",FM:"FMOscillator",AM:"AMOscillator",Fat:"FatOscillator"};return t.OmniOscillator.prototype._start=function(t){this._oscillator.start(t)},t.OmniOscillator.prototype._stop=function(t){this._oscillator.stop(t)},t.OmniOscillator.prototype.restart=function(t){this._oscillator.restart(t)},Object.defineProperty(t.OmniOscillator.prototype,"type",{get:function(){var t="";return this._sourceType===e.FM?t="fm":this._sourceType===e.AM?t="am":this._sourceType===e.Fat&&(t="fat"),t+this._oscillator.type},set:function(t){"fm"===t.substr(0,2)?(this._createNewOscillator(e.FM),this._oscillator.type=t.substr(2)):"am"===t.substr(0,2)?(this._createNewOscillator(e.AM),this._oscillator.type=t.substr(2)):"fat"===t.substr(0,3)?(this._createNewOscillator(e.Fat),this._oscillator.type=t.substr(3)):"pwm"===t?this._createNewOscillator(e.PWM):"pulse"===t?this._createNewOscillator(e.Pulse):(this._createNewOscillator(e.Osc),this._oscillator.type=t)}}),Object.defineProperty(t.OmniOscillator.prototype,"partials",{get:function(){return this._oscillator.partials},set:function(t){this._oscillator.partials=t}}),t.OmniOscillator.prototype.set=function(e,i){return"type"===e?this.type=i:t.isObject(e)&&e.hasOwnProperty("type")&&(this.type=e.type),t.prototype.set.apply(this,arguments),this},t.OmniOscillator.prototype._createNewOscillator=function(e){var i,n,s;e!==this._sourceType&&(this._sourceType=e,i=t[e],n=this.now(),null!==this._oscillator&&(s=this._oscillator,s.stop(n),this.context.setTimeout(function(){s.dispose(),s=null},this.blockTime)),this._oscillator=new i,this.frequency.connect(this._oscillator.frequency),this.detune.connect(this._oscillator.detune),this._oscillator.connect(this.output),this.state===t.State.Started&&this._oscillator.start(n))},Object.defineProperty(t.OmniOscillator.prototype,"phase",{get:function(){return this._oscillator.phase},set:function(t){this._oscillator.phase=t}}),Object.defineProperty(t.OmniOscillator.prototype,"width",{get:function(){if(this._sourceType===e.Pulse)return this._oscillator.width}}),Object.defineProperty(t.OmniOscillator.prototype,"count",{get:function(){if(this._sourceType===e.Fat)return this._oscillator.count},set:function(t){this._sourceType===e.Fat&&(this._oscillator.count=t)}}),Object.defineProperty(t.OmniOscillator.prototype,"spread",{get:function(){if(this._sourceType===e.Fat)return this._oscillator.spread},set:function(t){this._sourceType===e.Fat&&(this._oscillator.spread=t)}}),Object.defineProperty(t.OmniOscillator.prototype,"modulationType",{get:function(){if(this._sourceType===e.FM||this._sourceType===e.AM)return this._oscillator.modulationType},set:function(t){this._sourceType!==e.FM&&this._sourceType!==e.AM||(this._oscillator.modulationType=t)}}),Object.defineProperty(t.OmniOscillator.prototype,"modulationIndex",{get:function(){if(this._sourceType===e.FM)return this._oscillator.modulationIndex}}),Object.defineProperty(t.OmniOscillator.prototype,"harmonicity",{get:function(){if(this._sourceType===e.FM||this._sourceType===e.AM)return this._oscillator.harmonicity}}),Object.defineProperty(t.OmniOscillator.prototype,"modulationFrequency",{get:function(){if(this._sourceType===e.PWM)return this._oscillator.modulationFrequency}}),t.OmniOscillator.prototype.dispose=function(){return t.Source.prototype.dispose.call(this),this._writable(["frequency","detune"]),this.detune.dispose(),this.detune=null,this.frequency.dispose(),this.frequency=null,this._oscillator.dispose(),this._oscillator=null,this._sourceType=null,this},t.OmniOscillator}),t(function(t){return t.Instrument=function(e){e=t.defaultArg(e,t.Instrument.defaults),t.AudioNode.call(this),this._volume=this.output=new t.Volume(e.volume),this.volume=this._volume.volume,this._readOnly("volume"),this._scheduledEvents=[]},t.extend(t.Instrument,t.AudioNode),t.Instrument.defaults={volume:0},t.Instrument.prototype.triggerAttack=t.noOp,t.Instrument.prototype.triggerRelease=t.noOp,t.Instrument.prototype.sync=function(){return this._syncMethod("triggerAttack",1),this._syncMethod("triggerRelease",0),this},t.Instrument.prototype._syncMethod=function(e,i){var n=this["_original_"+e]=this[e];this[e]=function(){var e=Array.prototype.slice.call(arguments),s=e[i],o=t.Transport.schedule(function(t){e[i]=t,n.apply(this,e)}.bind(this),s);this._scheduledEvents.push(o)}.bind(this)},t.Instrument.prototype.unsync=function(){return this._scheduledEvents.forEach(function(e){t.Transport.clear(e)}),this._scheduledEvents=[],this._original_triggerAttack&&(this.triggerAttack=this._original_triggerAttack,this.triggerRelease=this._original_triggerRelease),this},t.Instrument.prototype.triggerAttackRelease=function(t,e,i,n){return i=this.toSeconds(i),e=this.toSeconds(e),this.triggerAttack(t,i,n),this.triggerRelease(i+e),this},t.Instrument.prototype.dispose=function(){return t.AudioNode.prototype.dispose.call(this),this._volume.dispose(),this._volume=null,this._writable(["volume"]),this.volume=null,this.unsync(),this._scheduledEvents=null,this},t.Instrument}),t(function(t){return t.Monophonic=function(e){e=t.defaultArg(e,t.Monophonic.defaults),t.Instrument.call(this,e),this.portamento=e.portamento},t.extend(t.Monophonic,t.Instrument),t.Monophonic.defaults={portamento:0},t.Monophonic.prototype.triggerAttack=function(t,e,i){return e=this.toSeconds(e),this._triggerEnvelopeAttack(e,i),this.setNote(t,e),this},t.Monophonic.prototype.triggerRelease=function(t){return t=this.toSeconds(t),this._triggerEnvelopeRelease(t),this},t.Monophonic.prototype._triggerEnvelopeAttack=function(){},t.Monophonic.prototype._triggerEnvelopeRelease=function(){},t.Monophonic.prototype.getLevelAtTime=function(t){return t=this.toSeconds(t),this.envelope.getValueAtTime(t)},t.Monophonic.prototype.setNote=function(t,e){if(e=this.toSeconds(e),this.portamento>0&&this.getLevelAtTime(e)>.05){var i=this.toSeconds(this.portamento);this.frequency.exponentialRampTo(t,i,e)}else this.frequency.setValueAtTime(t,e);return this},t.Monophonic}),t(function(t){return t.Synth=function(e){e=t.defaultArg(e,t.Synth.defaults),t.Monophonic.call(this,e),this.oscillator=new t.OmniOscillator(e.oscillator),this.frequency=this.oscillator.frequency,this.detune=this.oscillator.detune,this.envelope=new t.AmplitudeEnvelope(e.envelope),this.oscillator.chain(this.envelope,this.output),this._readOnly(["oscillator","frequency","detune","envelope"])},t.extend(t.Synth,t.Monophonic),t.Synth.defaults={oscillator:{type:"triangle"},envelope:{attack:.005,decay:.1,sustain:.3,release:1}},t.Synth.prototype._triggerEnvelopeAttack=function(t,e){return this.envelope.triggerAttack(t,e),this.oscillator.start(t),0===this.envelope.sustain&&this.oscillator.stop(t+this.envelope.attack+this.envelope.decay),this},t.Synth.prototype._triggerEnvelopeRelease=function(t){return t=this.toSeconds(t),this.envelope.triggerRelease(t),this.oscillator.stop(t+this.envelope.release),this},t.Synth.prototype.dispose=function(){return t.Monophonic.prototype.dispose.call(this),this._writable(["oscillator","frequency","detune","envelope"]),this.oscillator.dispose(),this.oscillator=null,this.envelope.dispose(),this.envelope=null,this.frequency=null,this.detune=null,this},t.Synth}),t(function(t){return t.AMSynth=function(e){e=t.defaultArg(e,t.AMSynth.defaults),t.Monophonic.call(this,e),this._carrier=new t.Synth,this._carrier.volume.value=-10,this.oscillator=this._carrier.oscillator,this.envelope=this._carrier.envelope.set(e.envelope),this._modulator=new t.Synth,this._modulator.volume.value=-10,this.modulation=this._modulator.oscillator.set(e.modulation),this.modulationEnvelope=this._modulator.envelope.set(e.modulationEnvelope),this.frequency=new t.Signal(440,t.Type.Frequency),this.detune=new t.Signal(e.detune,t.Type.Cents),this.harmonicity=new t.Multiply(e.harmonicity),this.harmonicity.units=t.Type.Positive,this._modulationScale=new t.AudioToGain,this._modulationNode=new t.Gain,this.frequency.connect(this._carrier.frequency),this.frequency.chain(this.harmonicity,this._modulator.frequency),this.detune.fan(this._carrier.detune,this._modulator.detune),this._modulator.chain(this._modulationScale,this._modulationNode.gain),this._carrier.chain(this._modulationNode,this.output),this._readOnly(["frequency","harmonicity","oscillator","envelope","modulation","modulationEnvelope","detune"])},t.extend(t.AMSynth,t.Monophonic),t.AMSynth.defaults={harmonicity:3,detune:0,oscillator:{type:"sine"},envelope:{attack:.01,decay:.01,sustain:1,release:.5},modulation:{type:"square"},modulationEnvelope:{attack:.5,decay:0,sustain:1,release:.5}},t.AMSynth.prototype._triggerEnvelopeAttack=function(t,e){return t=this.toSeconds(t),this._carrier._triggerEnvelopeAttack(t,e),this._modulator._triggerEnvelopeAttack(t),this},t.AMSynth.prototype._triggerEnvelopeRelease=function(t){return this._carrier._triggerEnvelopeRelease(t),this._modulator._triggerEnvelopeRelease(t),this},t.AMSynth.prototype.dispose=function(){return t.Monophonic.prototype.dispose.call(this),this._writable(["frequency","harmonicity","oscillator","envelope","modulation","modulationEnvelope","detune"]),this._carrier.dispose(),this._carrier=null,this._modulator.dispose(),this._modulator=null,this.frequency.dispose(),this.frequency=null,this.detune.dispose(),this.detune=null,this.harmonicity.dispose(),this.harmonicity=null,this._modulationScale.dispose(),this._modulationScale=null,this._modulationNode.dispose(),this._modulationNode=null,this.oscillator=null,this.envelope=null,this.modulationEnvelope=null,this.modulation=null,this},t.AMSynth}),t(function(t){return t.MonoSynth=function(e){e=t.defaultArg(e,t.MonoSynth.defaults),t.Monophonic.call(this,e),this.oscillator=new t.OmniOscillator(e.oscillator),this.frequency=this.oscillator.frequency,this.detune=this.oscillator.detune,this.filter=new t.Filter(e.filter),this.filterEnvelope=new t.FrequencyEnvelope(e.filterEnvelope),this.envelope=new t.AmplitudeEnvelope(e.envelope),this.oscillator.chain(this.filter,this.envelope,this.output),this.filterEnvelope.connect(this.filter.frequency),this._readOnly(["oscillator","frequency","detune","filter","filterEnvelope","envelope"])},t.extend(t.MonoSynth,t.Monophonic),t.MonoSynth.defaults={frequency:"C4",detune:0,oscillator:{type:"square"},filter:{Q:6,type:"lowpass",rolloff:-24},envelope:{attack:.005,decay:.1,sustain:.9,release:1},filterEnvelope:{attack:.06,decay:.2,sustain:.5,release:2,baseFrequency:200,octaves:7,exponent:2}},t.MonoSynth.prototype._triggerEnvelopeAttack=function(t,e){return t=this.toSeconds(t),this.envelope.triggerAttack(t,e),this.filterEnvelope.triggerAttack(t),this.oscillator.start(t),0===this.envelope.sustain&&this.oscillator.stop(t+this.envelope.attack+this.envelope.decay),this},t.MonoSynth.prototype._triggerEnvelopeRelease=function(t){return this.envelope.triggerRelease(t),this.filterEnvelope.triggerRelease(t),this.oscillator.stop(t+this.envelope.release),this},t.MonoSynth.prototype.dispose=function(){return t.Monophonic.prototype.dispose.call(this),this._writable(["oscillator","frequency","detune","filter","filterEnvelope","envelope"]),this.oscillator.dispose(),this.oscillator=null,this.envelope.dispose(),this.envelope=null,this.filterEnvelope.dispose(),this.filterEnvelope=null,this.filter.dispose(),this.filter=null,this.frequency=null,this.detune=null,this},t.MonoSynth}),t(function(t){return t.DuoSynth=function(e){e=t.defaultArg(e,t.DuoSynth.defaults),t.Monophonic.call(this,e),this.voice0=new t.MonoSynth(e.voice0),this.voice0.volume.value=-10,this.voice1=new t.MonoSynth(e.voice1),this.voice1.volume.value=-10,this._vibrato=new t.LFO(e.vibratoRate,-50,50),this._vibrato.start(),this.vibratoRate=this._vibrato.frequency,this._vibratoGain=new t.Gain(e.vibratoAmount,t.Type.Positive),this.vibratoAmount=this._vibratoGain.gain,this.frequency=new t.Signal(440,t.Type.Frequency),this.harmonicity=new t.Multiply(e.harmonicity),this.harmonicity.units=t.Type.Positive,this.frequency.connect(this.voice0.frequency),this.frequency.chain(this.harmonicity,this.voice1.frequency),this._vibrato.connect(this._vibratoGain),this._vibratoGain.fan(this.voice0.detune,this.voice1.detune),this.voice0.connect(this.output),this.voice1.connect(this.output),this._readOnly(["voice0","voice1","frequency","vibratoAmount","vibratoRate"])},t.extend(t.DuoSynth,t.Monophonic),t.DuoSynth.defaults={vibratoAmount:.5,vibratoRate:5,harmonicity:1.5,voice0:{volume:-10,portamento:0,oscillator:{type:"sine"},filterEnvelope:{attack:.01,decay:0,sustain:1,release:.5},envelope:{attack:.01,decay:0,sustain:1,release:.5}},voice1:{volume:-10,portamento:0,oscillator:{type:"sine"},filterEnvelope:{attack:.01,decay:0,sustain:1,release:.5},envelope:{attack:.01,decay:0,sustain:1,release:.5}}},t.DuoSynth.prototype._triggerEnvelopeAttack=function(t,e){return t=this.toSeconds(t),this.voice0._triggerEnvelopeAttack(t,e),this.voice1._triggerEnvelopeAttack(t,e),this},t.DuoSynth.prototype._triggerEnvelopeRelease=function(t){return this.voice0._triggerEnvelopeRelease(t),this.voice1._triggerEnvelopeRelease(t),this},t.DuoSynth.prototype.getLevelAtTime=function(t){return(this.voice0.getLevelAtTime(t)+this.voice1.getLevelAtTime(t))/2},t.DuoSynth.prototype.dispose=function(){return t.Monophonic.prototype.dispose.call(this),this._writable(["voice0","voice1","frequency","vibratoAmount","vibratoRate"]),this.voice0.dispose(),this.voice0=null,this.voice1.dispose(),this.voice1=null,this.frequency.dispose(),this.frequency=null,this._vibratoGain.dispose(),this._vibratoGain=null,this._vibrato=null,this.harmonicity.dispose(),this.harmonicity=null,this.vibratoAmount.dispose(),this.vibratoAmount=null,this.vibratoRate=null,this},t.DuoSynth}),t(function(t){return t.FMSynth=function(e){e=t.defaultArg(e,t.FMSynth.defaults),t.Monophonic.call(this,e),this._carrier=new t.Synth(e.carrier),this._carrier.volume.value=-10,this.oscillator=this._carrier.oscillator,this.envelope=this._carrier.envelope.set(e.envelope),this._modulator=new t.Synth(e.modulator),this._modulator.volume.value=-10,this.modulation=this._modulator.oscillator.set(e.modulation),this.modulationEnvelope=this._modulator.envelope.set(e.modulationEnvelope),this.frequency=new t.Signal(440,t.Type.Frequency),this.detune=new t.Signal(e.detune,t.Type.Cents),this.harmonicity=new t.Multiply(e.harmonicity),this.harmonicity.units=t.Type.Positive,this.modulationIndex=new t.Multiply(e.modulationIndex),this.modulationIndex.units=t.Type.Positive,this._modulationNode=new t.Gain(0),this.frequency.connect(this._carrier.frequency),this.frequency.chain(this.harmonicity,this._modulator.frequency),this.frequency.chain(this.modulationIndex,this._modulationNode),this.detune.fan(this._carrier.detune,this._modulator.detune),this._modulator.connect(this._modulationNode.gain),this._modulationNode.connect(this._carrier.frequency),this._carrier.connect(this.output),this._readOnly(["frequency","harmonicity","modulationIndex","oscillator","envelope","modulation","modulationEnvelope","detune"])},t.extend(t.FMSynth,t.Monophonic),t.FMSynth.defaults={harmonicity:3,modulationIndex:10,detune:0,oscillator:{type:"sine"},envelope:{attack:.01,decay:.01,sustain:1,release:.5},modulation:{type:"square"},modulationEnvelope:{attack:.5,decay:0,sustain:1,release:.5}},t.FMSynth.prototype._triggerEnvelopeAttack=function(t,e){return t=this.toSeconds(t),this._carrier._triggerEnvelopeAttack(t,e),this._modulator._triggerEnvelopeAttack(t),this},t.FMSynth.prototype._triggerEnvelopeRelease=function(t){return t=this.toSeconds(t),this._carrier._triggerEnvelopeRelease(t),this._modulator._triggerEnvelopeRelease(t),this},t.FMSynth.prototype.dispose=function(){return t.Monophonic.prototype.dispose.call(this),this._writable(["frequency","harmonicity","modulationIndex","oscillator","envelope","modulation","modulationEnvelope","detune"]),this._carrier.dispose(),this._carrier=null,this._modulator.dispose(),this._modulator=null,this.frequency.dispose(),this.frequency=null,this.detune.dispose(),this.detune=null,this.modulationIndex.dispose(),this.modulationIndex=null,this.harmonicity.dispose(),this.harmonicity=null,this._modulationNode.dispose(),this._modulationNode=null,this.oscillator=null,this.envelope=null,this.modulationEnvelope=null,this.modulation=null,this},t.FMSynth}),t(function(t){return t.MembraneSynth=function(e){e=t.defaultArg(e,t.MembraneSynth.defaults),t.Instrument.call(this,e),this.oscillator=new t.OmniOscillator(e.oscillator),this.envelope=new t.AmplitudeEnvelope(e.envelope),this.octaves=e.octaves,this.pitchDecay=e.pitchDecay,this.oscillator.chain(this.envelope,this.output),this._readOnly(["oscillator","envelope"])},t.extend(t.MembraneSynth,t.Instrument),t.MembraneSynth.defaults={pitchDecay:.05,octaves:10,oscillator:{type:"sine"},envelope:{attack:.001,decay:.4,sustain:.01,release:1.4,attackCurve:"exponential"}},t.MembraneSynth.prototype.triggerAttack=function(t,e,i){e=this.toSeconds(e),t=this.toFrequency(t);var n=t*this.octaves;return this.oscillator.frequency.setValueAtTime(n,e),this.oscillator.frequency.exponentialRampToValueAtTime(t,e+this.toSeconds(this.pitchDecay)),this.envelope.triggerAttack(e,i),this.oscillator.start(e),this},t.MembraneSynth.prototype.triggerRelease=function(t){return t=this.toSeconds(t),this.envelope.triggerRelease(t),this.oscillator.stop(t+this.envelope.release),this},t.MembraneSynth.prototype.dispose=function(){return t.Instrument.prototype.dispose.call(this),this._writable(["oscillator","envelope"]),this.oscillator.dispose(),this.oscillator=null,this.envelope.dispose(),this.envelope=null,this},t.MembraneSynth}),t(function(t){var e=[1,1.483,1.932,2.546,2.63,3.897];return t.MetalSynth=function(i){var n,s,o;for(i=t.defaultArg(i,t.MetalSynth.defaults),t.Instrument.call(this,i),this.frequency=new t.Signal(i.frequency,t.Type.Frequency),this._oscillators=[],this._freqMultipliers=[],this._amplitue=new t.Gain(0).connect(this.output),this._highpass=new t.Filter({type:"highpass",Q:-3.0102999566398125}).connect(this._amplitue),this._octaves=i.octaves,this._filterFreqScaler=new t.Scale(i.resonance,7e3),this.envelope=new t.Envelope({attack:i.envelope.attack,attackCurve:"linear",decay:i.envelope.decay,sustain:0,release:i.envelope.release}).chain(this._filterFreqScaler,this._highpass.frequency),this.envelope.connect(this._amplitue.gain),n=0;n<e.length;n++)s=new t.FMOscillator({type:"square",modulationType:"square",harmonicity:i.harmonicity,modulationIndex:i.modulationIndex}),s.connect(this._highpass),this._oscillators[n]=s,o=new t.Multiply(e[n]),this._freqMultipliers[n]=o,
this.frequency.chain(o,s.frequency);this.octaves=i.octaves},t.extend(t.MetalSynth,t.Instrument),t.MetalSynth.defaults={frequency:200,envelope:{attack:.001,decay:1.4,release:.2},harmonicity:5.1,modulationIndex:32,resonance:4e3,octaves:1.5},t.MetalSynth.prototype.triggerAttack=function(e,i){return e=this.toSeconds(e),i=t.defaultArg(i,1),this.envelope.triggerAttack(e,i),this._oscillators.forEach(function(t){t.start(e)}),0===this.envelope.sustain&&this._oscillators.forEach(function(t){t.stop(e+this.envelope.attack+this.envelope.decay)}.bind(this)),this},t.MetalSynth.prototype.triggerRelease=function(t){return t=this.toSeconds(t),this.envelope.triggerRelease(t),this._oscillators.forEach(function(e){e.stop(t+this.envelope.release)}.bind(this)),this},t.MetalSynth.prototype.sync=function(){return this._syncMethod("triggerAttack",0),this._syncMethod("triggerRelease",0),this},t.MetalSynth.prototype.triggerAttackRelease=function(t,e,i){return e=this.toSeconds(e),t=this.toSeconds(t),this.triggerAttack(e,i),this.triggerRelease(e+t),this},Object.defineProperty(t.MetalSynth.prototype,"modulationIndex",{get:function(){return this._oscillators[0].modulationIndex.value},set:function(t){for(var e=0;e<this._oscillators.length;e++)this._oscillators[e].modulationIndex.value=t}}),Object.defineProperty(t.MetalSynth.prototype,"harmonicity",{get:function(){return this._oscillators[0].harmonicity.value},set:function(t){for(var e=0;e<this._oscillators.length;e++)this._oscillators[e].harmonicity.value=t}}),Object.defineProperty(t.MetalSynth.prototype,"resonance",{get:function(){return this._filterFreqScaler.min},set:function(t){this._filterFreqScaler.min=t,this.octaves=this._octaves}}),Object.defineProperty(t.MetalSynth.prototype,"octaves",{get:function(){return this._octaves},set:function(t){this._octaves=t,this._filterFreqScaler.max=this._filterFreqScaler.min*Math.pow(2,t)}}),t.MetalSynth.prototype.dispose=function(){t.Instrument.prototype.dispose.call(this);for(var e=0;e<this._oscillators.length;e++)this._oscillators[e].dispose(),this._freqMultipliers[e].dispose();this._oscillators=null,this._freqMultipliers=null,this.frequency.dispose(),this.frequency=null,this._filterFreqScaler.dispose(),this._filterFreqScaler=null,this._amplitue.dispose(),this._amplitue=null,this.envelope.dispose(),this.envelope=null,this._highpass.dispose(),this._highpass=null},t.MetalSynth}),t(function(t){return t.NoiseSynth=function(e){e=t.defaultArg(e,t.NoiseSynth.defaults),t.Instrument.call(this,e),this.noise=new t.Noise,this.envelope=new t.AmplitudeEnvelope(e.envelope),this.noise.chain(this.envelope,this.output),this._readOnly(["noise","envelope"])},t.extend(t.NoiseSynth,t.Instrument),t.NoiseSynth.defaults={noise:{type:"white"},envelope:{attack:.005,decay:.1,sustain:0}},t.NoiseSynth.prototype.triggerAttack=function(t,e){return this.envelope.triggerAttack(t,e),this.noise.start(t),0===this.envelope.sustain&&this.noise.stop(t=this.envelope.attack+this.envelope.decay),this},t.NoiseSynth.prototype.triggerRelease=function(t){return this.envelope.triggerRelease(t),this.noise.stop(t+this.envelope.release),this},t.NoiseSynth.prototype.sync=function(){return this._syncMethod("triggerAttack",0),this._syncMethod("triggerRelease",0),this},t.NoiseSynth.prototype.triggerAttackRelease=function(t,e,i){return e=this.toSeconds(e),t=this.toSeconds(t),this.triggerAttack(e,i),this.triggerRelease(e+t),this},t.NoiseSynth.prototype.dispose=function(){return t.Instrument.prototype.dispose.call(this),this._writable(["noise","envelope"]),this.noise.dispose(),this.noise=null,this.envelope.dispose(),this.envelope=null,this},t.NoiseSynth}),t(function(t){return t.PluckSynth=function(e){e=t.defaultArg(e,t.PluckSynth.defaults),t.Instrument.call(this,e),this._noise=new t.Noise("pink"),this.attackNoise=e.attackNoise,this._lfcf=new t.LowpassCombFilter({resonance:e.resonance,dampening:e.dampening}),this.resonance=this._lfcf.resonance,this.dampening=this._lfcf.dampening,this._noise.connect(this._lfcf),this._lfcf.connect(this.output),this._readOnly(["resonance","dampening"])},t.extend(t.PluckSynth,t.Instrument),t.PluckSynth.defaults={attackNoise:1,dampening:4e3,resonance:.7},t.PluckSynth.prototype.triggerAttack=function(t,e){t=this.toFrequency(t),e=this.toSeconds(e);var i=1/t;return this._lfcf.delayTime.setValueAtTime(i,e),this._noise.start(e),this._noise.stop(e+i*this.attackNoise),this},t.PluckSynth.prototype.dispose=function(){return t.Instrument.prototype.dispose.call(this),this._noise.dispose(),this._lfcf.dispose(),this._noise=null,this._lfcf=null,this._writable(["resonance","dampening"]),this.dampening=null,this.resonance=null,this},t.PluckSynth}),t(function(t){return t.PolySynth=function(){var e,i,n=t.defaults(arguments,["polyphony","voice"],t.PolySynth);for(t.Instrument.call(this,n),n=t.defaultArg(n,t.Instrument.defaults),n.polyphony=Math.min(t.PolySynth.MAX_POLYPHONY,n.polyphony),this.voices=new Array(n.polyphony),this._triggers=new Array(n.polyphony),this.detune=new t.Signal(n.detune,t.Type.Cents),this._readOnly("detune"),e=0;e<n.polyphony;e++){if(!((i=new n.voice(arguments[2],arguments[3]))instanceof t.Monophonic))throw new Error("Synth constructor must be instance of Tone.Monophonic");this.voices[e]=i,i.connect(this.output),i.hasOwnProperty("detune")&&this.detune.connect(i.detune),this._triggers[e]={release:-1,note:null,voice:i}}},t.extend(t.PolySynth,t.Instrument),t.PolySynth.defaults={polyphony:4,volume:0,detune:0,voice:t.Synth},t.PolySynth.prototype.triggerAttack=function(t,e,i){var n,s,o,r;for(Array.isArray(t)||(t=[t]),e=this.toSeconds(e),n=0;n<t.length;n++){for(s=t[n],o=this._triggers[0],r=1;r<this._triggers.length;r++)this._triggers[r].release<o.release&&(o=this._triggers[r]);o.release=1/0,o.note=JSON.stringify(s),o.voice.triggerAttack(s,e,i)}return this},t.PolySynth.prototype.triggerAttackRelease=function(e,i,n,s){var o,r;if(n=this.toSeconds(n),this.triggerAttack(e,n,s),t.isArray(i)&&t.isArray(e))for(o=0;o<e.length;o++)r=i[Math.min(o,i.length-1)],this.triggerRelease(e[o],n+this.toSeconds(r));else this.triggerRelease(e,n+this.toSeconds(i));return this},t.PolySynth.prototype.triggerRelease=function(t,e){var i,n,s,o;for(Array.isArray(t)||(t=[t]),e=this.toSeconds(e),i=0;i<t.length;i++)for(n=JSON.stringify(t[i]),s=0;s<this._triggers.length;s++)o=this._triggers[s],o.note===n&&o.release>e&&(o.voice.triggerRelease(e),o.release=e);return this},t.PolySynth.prototype.sync=function(){return this._syncMethod("triggerAttack",1),this._syncMethod("triggerRelease",1),this},t.PolySynth.prototype.set=function(t,e,i){for(var n=0;n<this.voices.length;n++)this.voices[n].set(t,e,i);return this},t.PolySynth.prototype.get=function(t){return this.voices[0].get(t)},t.PolySynth.prototype.releaseAll=function(t){var e,i;for(t=this.toSeconds(t),e=0;e<this._triggers.length;e++)i=this._triggers[e],i.release>t&&(i.release=t,i.voice.triggerRelease(t));return this},t.PolySynth.prototype.dispose=function(){t.Instrument.prototype.dispose.call(this);for(var e=0;e<this.voices.length;e++)this.voices[e].dispose(),this.voices[e]=null;return this._writable("detune"),this.detune.dispose(),this.detune=null,this.voices=null,this._triggers=null,this},t.PolySynth.MAX_POLYPHONY=20,t.PolySynth}),t(function(t){return t.Sampler=function(e){var i,n,s,o,r=Array.prototype.slice.call(arguments);r.shift(),i=t.defaults(r,["onload","baseUrl"],t.Sampler),t.Instrument.call(this,i),n={};for(s in e)if(t.isNote(s))o=t.Frequency(s).toMidi(),n[o]=e[s];else{if(isNaN(parseFloat(s)))throw new Error("Tone.Sampler: url keys must be the note's pitch");n[s]=e[s]}this._buffers=new t.Buffers(n,i.onload,i.baseUrl),this._activeSources={},this.attack=i.attack,this.release=i.release},t.extend(t.Sampler,t.Instrument),t.Sampler.defaults={attack:0,release:.1,onload:t.noOp,baseUrl:""},t.Sampler.prototype._findClosest=function(t){for(var e=96,i=0;i<e;){if(this._buffers.has(t+i))return-i;if(this._buffers.has(t-i))return i;i++}return null},t.Sampler.prototype.triggerAttack=function(e,i,n){var s,o,r,a=t.Frequency(e).toMidi(),h=this._findClosest(a);return null!==h&&(s=a-h,o=this._buffers.get(s),r=new t.BufferSource({buffer:o,playbackRate:t.intervalToFrequencyRatio(h),fadeIn:this.attack,fadeOut:this.release,curve:"exponential"}).connect(this.output),r.start(i,0,o.duration,n),t.isArray(this._activeSources[a])||(this._activeSources[a]=[]),this._activeSources[a].push({note:a,source:r})),this},t.Sampler.prototype.triggerRelease=function(e,i){var n,s=t.Frequency(e).toMidi();return this._activeSources[s]&&this._activeSources[s].length&&(n=this._activeSources[s].shift().source,i=this.toSeconds(i),n.stop(i+this.release,this.release)),this},t.Sampler.prototype.releaseAll=function(t){var e,i,n;t=this.toSeconds(t);for(e in this._activeSources)for(i=this._activeSources[e];i.length;)n=i.shift().source,n.stop(t+this.release,this.release);return this},t.Sampler.prototype.sync=function(){return this._syncMethod("triggerAttack",1),this._syncMethod("triggerRelease",1),this},t.Sampler.prototype.triggerAttackRelease=function(t,e,i,n){return i=this.toSeconds(i),e=this.toSeconds(e),this.triggerAttack(t,i,n),this.triggerRelease(t,i+e),this},t.Sampler.prototype.add=function(e,i,n){if(t.isNote(e)){var s=t.Frequency(e).toMidi();this._buffers.add(s,i,n)}else{if(isNaN(parseFloat(e)))throw new Error("Tone.Sampler: note must be the note's pitch. Instead got "+e);this._buffers.add(e,i,n)}},Object.defineProperty(t.Sampler.prototype,"loaded",{get:function(){return this._buffers.loaded}}),t.Sampler.prototype.dispose=function(){t.Instrument.prototype.dispose.call(this),this._buffers.dispose(),this._buffers=null;for(var e in this._activeSources)this._activeSources[e].forEach(function(t){t.source.dispose()});return this._activeSources=null,this},t.Sampler}),t(function(t){t.supported&&(OscillatorNode.prototype.setPeriodicWave||(OscillatorNode.prototype.setPeriodicWave=OscillatorNode.prototype.setWaveTable),AudioContext.prototype.createPeriodicWave||(AudioContext.prototype.createPeriodicWave=AudioContext.prototype.createWaveTable))}),t(function(t){return t.GainToAudio=function(){t.SignalBase.call(this),this._norm=this.input=this.output=new t.WaveShaper(function(t){return 2*Math.abs(t)-1})},t.extend(t.GainToAudio,t.SignalBase),t.GainToAudio.prototype.dispose=function(){return t.SignalBase.prototype.dispose.call(this),this._norm.dispose(),this._norm=null,this},t.GainToAudio}),t(function(t){return t.Normalize=function(e,i){t.SignalBase.call(this),this._inputMin=t.defaultArg(e,0),this._inputMax=t.defaultArg(i,1),this._sub=this.input=new t.Add(0),this._div=this.output=new t.Multiply(1),this._sub.connect(this._div),this._setRange()},t.extend(t.Normalize,t.SignalBase),Object.defineProperty(t.Normalize.prototype,"min",{get:function(){return this._inputMin},set:function(t){this._inputMin=t,this._setRange()}}),Object.defineProperty(t.Normalize.prototype,"max",{get:function(){return this._inputMax},set:function(t){this._inputMax=t,this._setRange()}}),t.Normalize.prototype._setRange=function(){this._sub.value=-this._inputMin,this._div.value=1/(this._inputMax-this._inputMin)},t.Normalize.prototype.dispose=function(){return t.SignalBase.prototype.dispose.call(this),this._sub.dispose(),this._sub=null,this._div.dispose(),this._div=null,this},t.Normalize}),t(function(t){return t.TransportTimelineSignal=function(){t.Signal.apply(this,arguments),this.output=this._outputSig=new t.Signal(this._initialValue),this._lastVal=this.value,this._synced=t.Transport.scheduleRepeat(this._onTick.bind(this),"1i"),this._bindAnchorValue=this._anchorValue.bind(this),t.Transport.on("start stop pause",this._bindAnchorValue),this._events.memory=1/0},t.extend(t.TransportTimelineSignal,t.Signal),t.TransportTimelineSignal.prototype._onTick=function(e){var i=this.getValueAtTime(t.Transport.seconds);this._lastVal!==i&&(this._lastVal=i,this._outputSig.linearRampToValueAtTime(i,e))},t.TransportTimelineSignal.prototype._anchorValue=function(e){var i=this.getValueAtTime(t.Transport.seconds);return this._lastVal=i,this._outputSig.cancelScheduledValues(e),this._outputSig.setValueAtTime(i,e),this},t.TransportTimelineSignal.prototype.getValueAtTime=function(e){return e=t.TransportTime(e),t.Signal.prototype.getValueAtTime.call(this,e)},t.TransportTimelineSignal.prototype.setValueAtTime=function(e,i){return i=t.TransportTime(i),t.Signal.prototype.setValueAtTime.call(this,e,i),this},t.TransportTimelineSignal.prototype.linearRampToValueAtTime=function(e,i){return i=t.TransportTime(i),t.Signal.prototype.linearRampToValueAtTime.call(this,e,i),this},t.TransportTimelineSignal.prototype.exponentialRampToValueAtTime=function(e,i){return i=t.TransportTime(i),t.Signal.prototype.exponentialRampToValueAtTime.call(this,e,i),this},t.TransportTimelineSignal.prototype.setTargetAtTime=function(e,i,n){return i=t.TransportTime(i),t.Signal.prototype.setTargetAtTime.call(this,e,i,n),this},t.TransportTimelineSignal.prototype.cancelScheduledValues=function(e){return e=t.TransportTime(e),t.Signal.prototype.cancelScheduledValues.call(this,e),this},t.TransportTimelineSignal.prototype.setValueCurveAtTime=function(e,i,n,s){return i=t.TransportTime(i),n=t.TransportTime(n),t.Signal.prototype.setValueCurveAtTime.call(this,e,i,n,s),this},t.TransportTimelineSignal.prototype.cancelAndHoldAtTime=function(e){return t.Signal.prototype.cancelAndHoldAtTime.call(this,t.TransportTime(e))},t.TransportTimelineSignal.prototype.dispose=function(){t.Transport.clear(this._synced),t.Transport.off("start stop pause",this._syncedCallback),this._events.cancel(0),t.Signal.prototype.dispose.call(this),this._outputSig.dispose(),this._outputSig=null},t.TransportTimelineSignal}),t(function(t){return t.GrainPlayer=function(){var e=t.defaults(arguments,["url","onload"],t.GrainPlayer);t.Source.call(this,e),this.buffer=new t.Buffer(e.url,e.onload),this._clock=new t.Clock(this._tick.bind(this),e.grainSize),this._loopStart=0,this._loopEnd=0,this._activeSources=[],this._playbackRate=e.playbackRate,this._grainSize=e.grainSize,this._overlap=e.overlap,this.detune=e.detune,this.overlap=e.overlap,this.loop=e.loop,this.playbackRate=e.playbackRate,this.grainSize=e.grainSize,this.loopStart=e.loopStart,this.loopEnd=e.loopEnd,this.reverse=e.reverse,this._clock.on("stop",this._onstop.bind(this))},t.extend(t.GrainPlayer,t.Source),t.GrainPlayer.defaults={onload:t.noOp,overlap:.1,grainSize:.2,playbackRate:1,detune:0,loop:!1,loopStart:0,loopEnd:0,reverse:!1},t.GrainPlayer.prototype._start=function(e,i,n){i=t.defaultArg(i,0),i=this.toSeconds(i),e=this.toSeconds(e),this._offset=i,this._clock.start(e),n&&this.stop(e+this.toSeconds(n))},t.GrainPlayer.prototype._stop=function(t){this._clock.stop(t)},t.GrainPlayer.prototype._onstop=function(t){this._activeSources.forEach(function(e){e.stop(t,0)})},t.GrainPlayer.prototype._tick=function(e){var i=this._offset<this._overlap?0:this._overlap,n=new t.BufferSource({buffer:this.buffer,fadeIn:i,fadeOut:this._overlap,loop:this.loop,loopStart:this._loopStart,loopEnd:this._loopEnd,playbackRate:t.intervalToFrequencyRatio(this.detune/100)}).connect(this.output);n.start(e,this._offset),this._offset+=this.grainSize,n.stop(e+this.grainSize),this._activeSources.push(n),n.onended=function(){var t=this._activeSources.indexOf(n);-1!==t&&this._activeSources.splice(t,1)}.bind(this)},t.GrainPlayer.prototype.seek=function(t,e){return this._offset=this.toSeconds(t),this._tick(this.toSeconds(e)),this},Object.defineProperty(t.GrainPlayer.prototype,"playbackRate",{get:function(){return this._playbackRate},set:function(t){this._playbackRate=t,this.grainSize=this._grainSize}}),Object.defineProperty(t.GrainPlayer.prototype,"loopStart",{get:function(){return this._loopStart},set:function(t){this._loopStart=this.toSeconds(t)}}),Object.defineProperty(t.GrainPlayer.prototype,"loopEnd",{get:function(){return this._loopEnd},set:function(t){this._loopEnd=this.toSeconds(t)}}),Object.defineProperty(t.GrainPlayer.prototype,"reverse",{get:function(){return this.buffer.reverse},set:function(t){this.buffer.reverse=t}}),Object.defineProperty(t.GrainPlayer.prototype,"grainSize",{get:function(){return this._grainSize},set:function(t){this._grainSize=this.toSeconds(t),this._clock.frequency.value=this._playbackRate/this._grainSize}}),Object.defineProperty(t.GrainPlayer.prototype,"overlap",{get:function(){return this._overlap},set:function(t){this._overlap=this.toSeconds(t)}}),t.GrainPlayer.prototype.dispose=function(){return t.Source.prototype.dispose.call(this),this.buffer.dispose(),this.buffer=null,this._clock.dispose(),this._clock=null,this._activeSources.forEach(function(t){t.dispose()}),this._activeSources=null,this},t.GrainPlayer}),t(function(t){return t.Player=function(e){var i;e instanceof t.Buffer&&e.loaded?(e=e.get(),i=t.Player.defaults):i=t.defaults(arguments,["url","onload"],t.Player),t.Source.call(this,i),this.autostart=i.autostart,this._buffer=new t.Buffer({url:i.url,onload:this._onload.bind(this,i.onload),reverse:i.reverse}),e instanceof AudioBuffer&&this._buffer.set(e),this._loop=i.loop,this._loopStart=i.loopStart,this._loopEnd=i.loopEnd,this._playbackRate=i.playbackRate,this._activeSources=[],this._elapsedTime=new t.TickSource(i.playbackRate),this.fadeIn=i.fadeIn,this.fadeOut=i.fadeOut},t.extend(t.Player,t.Source),t.Player.defaults={onload:t.noOp,playbackRate:1,loop:!1,autostart:!1,loopStart:0,loopEnd:0,retrigger:!1,reverse:!1,fadeIn:0,fadeOut:0},t.Player.prototype.load=function(t,e){return this._buffer.load(t,this._onload.bind(this,e))},t.Player.prototype._onload=function(e){e=t.defaultArg(e,t.noOp),e(this),this.autostart&&this.start()},t.Player.prototype._onSourceEnd=function(t){var e=this._activeSources.indexOf(t);this._activeSources.splice(e,1)},t.Player.prototype._start=function(e,i,n){var s,o;return i=this._loop?t.defaultArg(i,this._loopStart):t.defaultArg(i,0),i=this.toSeconds(i),s=t.defaultArg(n,Math.max(this._buffer.duration-i,0)),s=this.toSeconds(s),e=this.toSeconds(e),this._elapsedTime.start(e,i),o=new t.BufferSource({buffer:this._buffer,loop:this._loop,loopStart:this._loopStart,loopEnd:this._loopEnd,onended:this._onSourceEnd.bind(this),playbackRate:this._playbackRate,fadeIn:this.fadeIn,fadeOut:this.fadeOut}).connect(this.output),this._loop||this._synced||this._state.setStateAtTime(t.State.Stopped,e+s/this._playbackRate),this._activeSources.push(o),this._loop&&t.isUndef(n)?o.start(e,i):o.start(e,i,s),this},t.Player.prototype._stop=function(t){return t=this.toSeconds(t),this._elapsedTime.stop(t),this._activeSources.forEach(function(e){e.stop(t)}),this},t.Player.prototype.restart=function(t,e,i){return this._stop(t),this._start(t,e,i),this},t.Player.prototype.seek=function(e,i){return i=this.toSeconds(i),this._state.getValueAtTime(i)===t.State.Started&&(e=this.toSeconds(e),this._stop(i),this._start(i,e)),this},t.Player.prototype.setLoopPoints=function(t,e){return this.loopStart=t,this.loopEnd=e,this},Object.defineProperty(t.Player.prototype,"loopStart",{get:function(){return this._loopStart},set:function(t){this._loopStart=t,this._activeSources.forEach(function(e){e.loopStart=t})}}),Object.defineProperty(t.Player.prototype,"loopEnd",{get:function(){return this._loopEnd},set:function(t){this._loopEnd=t,this._activeSources.forEach(function(e){e.loopEnd=t})}}),Object.defineProperty(t.Player.prototype,"buffer",{get:function(){return this._buffer},set:function(t){this._buffer.set(t)}}),Object.defineProperty(t.Player.prototype,"loop",{get:function(){return this._loop},set:function(e){var i,n;this._loop!==e&&(this._loop=e,i=this.now(),e?(n=this._state.getNextState(t.State.Stopped,i))&&(this._activeSources.forEach(function(t){t.loop=e}),this._state.cancel(n.time),this._elapsedTime.cancel(n.time)):this._stopAtNextIteration(i))}}),t.Player.prototype._stopAtNextIteration=function(e){var i,n,s,o;this._state.getValueAtTime(e)===t.State.Started&&(i=this._state.getNextState(t.State.Stopped,e),n=this._elapsedTime.getTicksAtTime(e),s=Math.max(Math.ceil(n/this.buffer.duration),1),o=this._elapsedTime.getTimeOfTick(s*this.buffer.duration,i?i.time-this.sampleTime:1/0),this.stop(o))},Object.defineProperty(t.Player.prototype,"playbackRate",{get:function(){return this._playbackRate},set:function(t){this._playbackRate=t;var e=this.now();this._elapsedTime.frequency.setValueAtTime(t,e),this._loop||this._stopAtNextIteration(e),this._activeSources.forEach(function(i){i.playbackRate.setValueAtTime(t,e)})}}),Object.defineProperty(t.Player.prototype,"position",{get:function(){var e,i=this.now();return this._state.getValueAtTime(i)===t.State.Started&&this.loaded?(e=this.buffer.duration,this._elapsedTime.getTicksAtTime(i)%e):0}}),Object.defineProperty(t.Player.prototype,"reverse",{get:function(){return this._buffer.reverse},set:function(t){this._buffer.reverse=t}}),Object.defineProperty(t.Player.prototype,"loaded",{get:function(){return this._buffer.loaded}}),t.Player.prototype.dispose=function(){return this._activeSources.forEach(function(t){t.dispose()}),this._activeSources=null,t.Source.prototype.dispose.call(this),this._buffer.dispose(),this._buffer=null,this._elapsedTime.dispose(),this._elapsedTime=null,this},t.Player}),t(function(t){return t.Players=function(e){var i,n,s=Array.prototype.slice.call(arguments);s.shift(),i=t.defaults(s,["onload"],t.Players),t.call(this),this._volume=this.output=new t.Volume(i.volume),this.volume=this._volume.volume,this._readOnly("volume"),this._volume.output.output.channelCount=2,this._volume.output.output.channelCountMode="explicit",this.mute=i.mute,this._players={},this._loadingCount=0,this._fadeIn=i.fadeIn,this._fadeOut=i.fadeOut;for(n in e)this._loadingCount++,this.add(n,e[n],this._bufferLoaded.bind(this,i.onload))},t.extend(t.Players,t.AudioNode),t.Players.defaults={volume:0,mute:!1,onload:t.noOp,fadeIn:0,fadeOut:0},t.Players.prototype._bufferLoaded=function(t){0===--this._loadingCount&&t&&t(this)},Object.defineProperty(t.Players.prototype,"mute",{get:function(){return this._volume.mute},set:function(t){this._volume.mute=t}}),Object.defineProperty(t.Players.prototype,"fadeIn",{get:function(){return this._fadeIn},set:function(t){this._fadeIn=t,this._forEach(function(e){e.fadeIn=t})}}),Object.defineProperty(t.Players.prototype,"fadeOut",{get:function(){return this._fadeOut},set:function(t){this._fadeOut=t,this._forEach(function(e){e.fadeOut=t})}}),Object.defineProperty(t.Players.prototype,"state",{get:function(){var e=!1;return this._forEach(function(i){e=e||i.state===t.State.Started}),e?t.State.Started:t.State.Stopped}}),t.Players.prototype.has=function(t){return this._players.hasOwnProperty(t)},t.Players.prototype.get=function(t){if(this.has(t))return this._players[t];throw new Error("Tone.Players: no player named "+t)},t.Players.prototype._forEach=function(t){for(var e in this._players)t(this._players[e],e);return this},Object.defineProperty(t.Players.prototype,"loaded",{get:function(){var t=!0;return this._forEach(function(e){t=t&&e.loaded}),t}}),t.Players.prototype.add=function(e,i,n){return this._players[e]=new t.Player(i,n).connect(this.output),this._players[e].fadeIn=this._fadeIn,this._players[e].fadeOut=this._fadeOut,this},t.Players.prototype.stopAll=function(t){this._forEach(function(e){e.stop(t)})},t.Players.prototype.dispose=function(){return t.AudioNode.prototype.dispose.call(this),this._volume.dispose(),this._volume=null,this._writable("volume"),this.volume=null,this.output=null,this._forEach(function(t){t.dispose()}),this._players=null,this},t.Players}),t(function(t){return t.UserMedia=function(){var e=t.defaults(arguments,["volume"],t.UserMedia);t.AudioNode.call(this),this._mediaStream=null,this._stream=null,this._device=null,this._volume=this.output=new t.Volume(e.volume),this.volume=this._volume.volume,this._readOnly("volume"),this.mute=e.mute},t.extend(t.UserMedia,t.AudioNode),t.UserMedia.defaults={volume:0,mute:!1},t.UserMedia.prototype.open=function(e){return t.UserMedia.enumerateDevices().then(function(i){var n,s;if(t.isNumber(e))n=i[e];else if(!(n=i.find(function(t){return t.label===e||t.deviceId===e}))&&i.length>0)n=i[0];else if(!n&&t.isDefined(e))throw new Error("Tone.UserMedia: no matching device: "+e);return this._device=n,s={audio:{echoCancellation:!1,sampleRate:this.context.sampleRate}},n&&(s.audio.deviceId=n.deviceId),navigator.mediaDevices.getUserMedia(s).then(function(t){return this._stream||(this._stream=t,this._mediaStream=this.context.createMediaStreamSource(t),this._mediaStream.connect(this.output)),this}.bind(this))}.bind(this))},t.UserMedia.prototype.close=function(){return this._stream&&(this._stream.getAudioTracks().forEach(function(t){t.stop()}),this._stream=null,this._mediaStream.disconnect(),this._mediaStream=null),this._device=null,this},t.UserMedia.enumerateDevices=function(){return navigator.mediaDevices.enumerateDevices().then(function(t){return t.filter(function(t){return"audioinput"===t.kind})})},Object.defineProperty(t.UserMedia.prototype,"state",{get:function(){return this._stream&&this._stream.active?t.State.Started:t.State.Stopped}}),Object.defineProperty(t.UserMedia.prototype,"deviceId",{get:function(){if(this._device)return this._device.deviceId}}),Object.defineProperty(t.UserMedia.prototype,"groupId",{get:function(){if(this._device)return this._device.groupId}}),Object.defineProperty(t.UserMedia.prototype,"label",{get:function(){if(this._device)return this._device.label}}),Object.defineProperty(t.UserMedia.prototype,"mute",{get:function(){return this._volume.mute},set:function(t){this._volume.mute=t}}),t.UserMedia.prototype.dispose=function(){return t.AudioNode.prototype.dispose.call(this),this.close(),this._writable("volume"),this._volume.dispose(),this._volume=null,this.volume=null,this},Object.defineProperty(t.UserMedia,"supported",{get:function(){return t.isDefined(navigator.mediaDevices)&&t.isFunction(navigator.mediaDevices.getUserMedia)}}),t.UserMedia}),t(function(t){return t.Midi=function(e,i){if(!(this instanceof t.Midi))return new t.Midi(e,i);t.Frequency.call(this,e,i)},t.extend(t.Midi,t.Frequency),t.Midi.prototype._defaultUnits="midi",t.Midi.prototype._frequencyToUnits=function(e){return t.Frequency.ftom(t.Frequency.prototype._frequencyToUnits.call(this,e))},t.Midi.prototype._ticksToUnits=function(e){return t.Frequency.ftom(t.Frequency.prototype._ticksToUnits.call(this,e))},t.Midi.prototype._beatsToUnits=function(e){return t.Frequency.ftom(t.Frequency.prototype._beatsToUnits.call(this,e))},t.Midi.prototype._secondsToUnits=function(e){return t.Frequency.ftom(t.Frequency.prototype._secondsToUnits.call(this,e))},t.Midi.prototype.toMidi=function(){return this.valueOf()},t.Midi.prototype.toFrequency=function(){return t.Frequency.mtof(this.toMidi())},t.Midi.prototype.transpose=function(t){return new this.constructor(this.toMidi()+t)},t.Midi}),e});

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 *  StartAudioContext.js
 *  @author Yotam Mann
 *  @license http://opensource.org/licenses/MIT MIT License
 *  @copyright 2016 Yotam Mann
 */
(function (root, factory) {
	if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
	 } else if (typeof module === "object" && module.exports) {
        module.exports = factory()
	} else {
		root.StartAudioContext = factory()
  }
}(this, function () {

	//TAP LISTENER/////////////////////////////////////////////////////////////

	/**
	 * @class  Listens for non-dragging tap ends on the given element
	 * @param {Element} element
	 * @internal
	 */
	var TapListener = function(element, context){

		this._dragged = false

		this._element = element

		this._bindedMove = this._moved.bind(this)
		this._bindedEnd = this._ended.bind(this, context)

		element.addEventListener("touchstart", this._bindedEnd)
		element.addEventListener("touchmove", this._bindedMove)
		element.addEventListener("touchend", this._bindedEnd)
		element.addEventListener("mouseup", this._bindedEnd)
	}

	/**
	 * drag move event
	 */
	TapListener.prototype._moved = function(e){
		this._dragged = true
	};

	/**
	 * tap ended listener
	 */
	TapListener.prototype._ended = function(context){
		if (!this._dragged){
			startContext(context)
		}
		this._dragged = false
	};

	/**
	 * remove all the bound events
	 */
	TapListener.prototype.dispose = function(){
		this._element.removeEventListener("touchstart", this._bindedEnd)
		this._element.removeEventListener("touchmove", this._bindedMove)
		this._element.removeEventListener("touchend", this._bindedEnd)
		this._element.removeEventListener("mouseup", this._bindedEnd)
		this._bindedMove = null
		this._bindedEnd = null
		this._element = null
	};

	//END TAP LISTENER/////////////////////////////////////////////////////////

	/**
	 * Plays a silent sound and also invoke the "resume" method
	 * @param {AudioContext} context
	 * @private
	 */
	function startContext(context){
		// this accomplishes the iOS specific requirement
		var buffer = context.createBuffer(1, 1, context.sampleRate)
		var source = context.createBufferSource()
		source.buffer = buffer
		source.connect(context.destination)
		source.start(0)

		// resume the audio context
		if (context.resume){
			context.resume()
		}
	}

	/**
	 * Returns true if the audio context is started
	 * @param  {AudioContext}  context
	 * @return {Boolean}
	 * @private
	 */
	function isStarted(context){
		 return context.state === "running"
	}

	/**
	 * Invokes the callback as soon as the AudioContext
	 * is started
	 * @param  {AudioContext}   context
	 * @param  {Function} callback
	 */
	function onStarted(context, callback){

		function checkLoop(){
			if (isStarted(context)){
				callback()
			} else {
				requestAnimationFrame(checkLoop)
				if (context.resume){
					context.resume()
				}
			}
		}

		if (isStarted(context)){
			callback()
		} else {
			checkLoop()
		}
	}

	/**
	 * Add a tap listener to the audio context
	 * @param  {Array|Element|String|jQuery} element
	 * @param {Array} tapListeners
	 */
	function bindTapListener(element, tapListeners, context){
		if (Array.isArray(element) || (NodeList && element instanceof NodeList)){
			for (var i = 0; i < element.length; i++){
				bindTapListener(element[i], tapListeners, context)
			}
		} else if (typeof element === "string"){
			bindTapListener(document.querySelectorAll(element), tapListeners, context)
		} else if (element.jquery && typeof element.toArray === "function"){
			bindTapListener(element.toArray(), tapListeners, context)
		} else if (Element && element instanceof Element){
			//if it's an element, create a TapListener
			var tap = new TapListener(element, context)
			tapListeners.push(tap)
		} 
	}

	/**
	 * @param {AudioContext} context The AudioContext to start.
	 * @param {Array|String|Element|jQuery=} elements For iOS, the list of elements
	 *                                               to bind tap event listeners
	 *                                               which will start the AudioContext. If
	 *                                               no elements are given, it will bind
	 *                                               to the document.body.
	 * @param {Function=} callback The callback to invoke when the AudioContext is started.
	 * @return {Promise} The promise is invoked when the AudioContext
	 *                       is started.
	 */
	function StartAudioContext(context, elements, callback){

		//the promise is invoked when the AudioContext is started
		var promise = new Promise(function(success) {
			onStarted(context, success)
		})

		// The TapListeners bound to the elements
		var tapListeners = []

		// add all the tap listeners
		if (!elements){
			elements = document.body
		}
		bindTapListener(elements, tapListeners, context)

		//dispose all these tap listeners when the context is started
		promise.then(function(){
			for (var i = 0; i < tapListeners.length; i++){
				tapListeners[i].dispose()
			}
			tapListeners = null

			if (callback){
				callback()
			}
		})

		return promise
	}

	return StartAudioContext
}))

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _xregexp = __webpack_require__(95);

var _xregexp2 = _interopRequireDefault(_xregexp);

var _build = __webpack_require__(88);

var _build2 = _interopRequireDefault(_build);

var _matchrecursive = __webpack_require__(89);

var _matchrecursive2 = _interopRequireDefault(_matchrecursive);

var _unicodeBase = __webpack_require__(90);

var _unicodeBase2 = _interopRequireDefault(_unicodeBase);

var _unicodeBlocks = __webpack_require__(91);

var _unicodeBlocks2 = _interopRequireDefault(_unicodeBlocks);

var _unicodeCategories = __webpack_require__(92);

var _unicodeCategories2 = _interopRequireDefault(_unicodeCategories);

var _unicodeProperties = __webpack_require__(93);

var _unicodeProperties2 = _interopRequireDefault(_unicodeProperties);

var _unicodeScripts = __webpack_require__(94);

var _unicodeScripts2 = _interopRequireDefault(_unicodeScripts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _build2.default)(_xregexp2.default);
(0, _matchrecursive2.default)(_xregexp2.default);
(0, _unicodeBase2.default)(_xregexp2.default);
(0, _unicodeBlocks2.default)(_xregexp2.default);
(0, _unicodeCategories2.default)(_xregexp2.default);
(0, _unicodeProperties2.default)(_xregexp2.default);
(0, _unicodeScripts2.default)(_xregexp2.default);

exports.default = _xregexp2.default;
module.exports = exports['default'];

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(83)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(69),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(75)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(27),
  /* template */
  __webpack_require__(61),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(73)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(28),
  /* template */
  __webpack_require__(59),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(74)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(29),
  /* template */
  __webpack_require__(60),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(80)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(30),
  /* template */
  __webpack_require__(66),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(81)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(31),
  /* template */
  __webpack_require__(67),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(79)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(32),
  /* template */
  __webpack_require__(65),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(85)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(33),
  /* template */
  __webpack_require__(71),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(82)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(34),
  /* template */
  __webpack_require__(68),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(72)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(35),
  /* template */
  __webpack_require__(58),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(78)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(36),
  /* template */
  __webpack_require__(64),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(76)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(37),
  /* template */
  __webpack_require__(62),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(84)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(38),
  /* template */
  __webpack_require__(70),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.5.16
 * (c) 2014-2018 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// these helpers produces better vm code in JS engines due to their
// explicitness and function inlining
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value e.g. [object Object]
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : typeof val === 'object'
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert a input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if a attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether the object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it... e.g.
 * PhantomJS 1.x. Technically we don't need this anymore since native bind is
 * now more performant in most browsers, but removing it would be breaking for
 * code that was able to run in PhantomJS 1.x, so this must be kept for
 * backwards compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/)
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/**
 * Return same value
 */
var identity = function (_) { return _; };

/**
 * Generate a static keys string from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured'
];

/*  */

var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
})

/*  */

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = /[^\w.$]/;
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = (function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm || {};
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */


var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// the current target watcher being evaluated.
// this is globally unique because there could be only one
// watcher being evaluated at any time.
Dep.target = null;
var targetStack = [];

function pushTarget (_target) {
  if (Dep.target) { targetStack.push(Dep.target); }
  Dep.target = _target;
}

function popTarget () {
  Dep.target = targetStack.pop();
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    vnode.children,
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    var augment = hasProto
      ? protoAugment
      : copyAugment;
    augment(value, arrayMethods, arrayKeys);
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through each property and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment an target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src, keys) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment an target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  if (!getter && arguments.length === 2) {
    val = obj[key];
  }
  var setter = property && property.set;

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;
  var keys = Object.keys(from);
  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (isPlainObject(toVal) && isPlainObject(fromVal)) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  return childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!/^[a-zA-Z][\w-]*$/.test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'can only contain alphanumeric characters and the hyphen, ' +
      'and must start with a letter.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def = dirs[key];
      if (typeof def === 'function') {
        dirs[key] = { bind: def, update: def };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);
  var extendsFrom = child.extends;
  if (extendsFrom) {
    parent = mergeOptions(parent, extendsFrom, vm);
  }
  if (child.mixins) {
    for (var i = 0, l = child.mixins.length; i < l; i++) {
      parent = mergeOptions(parent, child.mixins[i], vm);
    }
  }
  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */

function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }
  if (!valid) {
    warn(
      "Invalid prop: type check failed for prop \"" + name + "\"." +
      " Expected " + (expectedTypes.map(capitalize).join(', ')) +
      ", got " + (toRawType(value)) + ".",
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

/*  */

function handleError (err, vm, info) {
  if (vm) {
    var cur = vm;
    while ((cur = cur.$parent)) {
      var hooks = cur.$options.errorCaptured;
      if (hooks) {
        for (var i = 0; i < hooks.length; i++) {
          try {
            var capture = hooks[i].call(cur, err, vm, info) === false;
            if (capture) { return }
          } catch (e) {
            globalHandleError(e, cur, 'errorCaptured hook');
          }
        }
      }
    }
  }
  globalHandleError(err, vm, info);
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      logError(e, null, 'config.errorHandler');
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */
/* globals MessageChannel */

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using both microtasks and (macro) tasks.
// In < 2.4 we used microtasks everywhere, but there are some scenarios where
// microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690) or even between bubbling of the same
// event (#6566). However, using (macro) tasks everywhere also has subtle problems
// when state is changed right before repaint (e.g. #6813, out-in transitions).
// Here we use microtask by default, but expose a way to force (macro) task when
// needed (e.g. in event handlers attached by v-on).
var microTimerFunc;
var macroTimerFunc;
var useMacroTask = false;

// Determine (macro) task defer implementation.
// Technically setImmediate should be the ideal choice, but it's only available
// in IE. The only polyfill that consistently queues the callback after all DOM
// events triggered in the same loop is by using MessageChannel.
/* istanbul ignore if */
if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  macroTimerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else if (typeof MessageChannel !== 'undefined' && (
  isNative(MessageChannel) ||
  // PhantomJS
  MessageChannel.toString() === '[object MessageChannelConstructor]'
)) {
  var channel = new MessageChannel();
  var port = channel.port2;
  channel.port1.onmessage = flushCallbacks;
  macroTimerFunc = function () {
    port.postMessage(1);
  };
} else {
  /* istanbul ignore next */
  macroTimerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

// Determine microtask defer implementation.
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  microTimerFunc = function () {
    p.then(flushCallbacks);
    // in problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
} else {
  // fallback to macro
  microTimerFunc = macroTimerFunc;
}

/**
 * Wrap a function so that if any code inside triggers state change,
 * the changes are queued using a (macro) task instead of a microtask.
 */
function withMacroTask (fn) {
  return fn._withTask || (fn._withTask = function () {
    useMacroTask = true;
    var res = fn.apply(null, arguments);
    useMacroTask = false;
    return res
  })
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    if (useMacroTask) {
      macroTimerFunc();
    } else {
      microTimerFunc();
    }
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      perf.clearMeasures(name);
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) || key.charAt(0) === '_';
      if (!has && !isAllowed) {
        warnNonPresent(target, key);
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        warnNonPresent(target, key);
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        cloned[i].apply(null, arguments$1);
      }
    } else {
      // return handler return value for single handlers
      return fns.apply(null, arguments)
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  vm
) {
  var name, def, cur, old, event;
  for (name in on) {
    def = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    /* istanbul ignore if */
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur);
      }
      add(event.name, cur, event.once, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor,
  context
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (isDef(factory.contexts)) {
    // already pending
    factory.contexts.push(context);
  } else {
    var contexts = factory.contexts = [context];
    var sync = true;

    var forceRender = function () {
      for (var i = 0, l = contexts.length; i < l; i++) {
        contexts[i].$forceUpdate();
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender();
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender();
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (typeof res.then === 'function') {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isDef(res.component) && typeof res.component.then === 'function') {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            setTimeout(function () {
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender();
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          setTimeout(function () {
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn, once) {
  if (once) {
    target.$once(event, fn);
  } else {
    target.$on(event, fn);
  }
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var this$1 = this;

    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        this$1.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var this$1 = this;

    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        this$1.$off(event[i], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    if (fn) {
      // specific handler
      var cb;
      var i$1 = cbs.length;
      while (i$1--) {
        cb = cbs[i$1];
        if (cb === fn || cb.fn === fn) {
          cbs.splice(i$1, 1);
          break
        }
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      for (var i = 0, l = cbs.length; i < l; i++) {
        try {
          cbs[i].apply(vm, args);
        } catch (e) {
          handleError(e, vm, ("event handler for \"" + event + "\""));
        }
      }
    }
    return vm
  };
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  var slots = {};
  if (!children) {
    return slots
  }
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

function resolveScopedSlots (
  fns, // see flow/vnode
  res
) {
  res = res || {};
  for (var i = 0; i < fns.length; i++) {
    if (Array.isArray(fns[i])) {
      resolveScopedSlots(fns[i], res);
    } else {
      res[fns[i].key] = fns[i].fn;
    }
  }
  return res
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    if (vm._isMounted) {
      callHook(vm, 'beforeUpdate');
    }
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var prevActiveInstance = activeInstance;
    activeInstance = vm;
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(
        vm.$el, vnode, hydrating, false /* removeOnly */,
        vm.$options._parentElm,
        vm.$options._refElm
      );
      // no need for the ref nodes after initial patch
      // this prevents keeping a detached DOM tree in memory (#5851)
      vm.$options._parentElm = vm.$options._refElm = null;
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    activeInstance = prevActiveInstance;
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, null, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren
  var hasChildren = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    parentVnode.data.scopedSlots || // has new scoped slots
    vm.$scopedSlots !== emptyObject // has old scoped slots
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (hasChildren) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      try {
        handlers[i].call(vm);
      } catch (e) {
        handleError(e, vm, (hook + " hook"));
      }
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */


var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */

var uid$1 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$1; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = function () {};
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
    var this$1 = this;

  var i = this.deps.length;
  while (i--) {
    var dep = this$1.deps[i];
    if (!this$1.newDepIds.has(dep.id)) {
      dep.removeSub(this$1);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
    var this$1 = this;

  var i = this.deps.length;
  while (i--) {
    this$1.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
    var this$1 = this;

  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this$1.deps[i].removeSub(this$1);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive(props, key, value, function () {
        if (vm.$parent && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : userDef;
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : userDef.get
      : noop;
    sharedPropertyDefinition.set = userDef.set
      ? userDef.set
      : noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (methods[key] == null) {
        warn(
          "Method \"" + key + "\" has an undefined value in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = methods[key] == null ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function (newData) {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      cb.call(vm, watcher.value);
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject).filter(function (key) {
        /* istanbul ignore next */
        return Object.getOwnPropertyDescriptor(inject, key).enumerable
      })
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    keys = Object.keys(val);
    ret = new Array(keys.length);
    for (i = 0, l = keys.length; i < l; i++) {
      key = keys[i];
      ret[i] = render(val[key], key, i);
    }
  }
  if (isDef(ret)) {
    (ret)._isVList = true;
  }
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    var slotNodes = this.$slots[name];
    // warn duplicate slot usage
    if (slotNodes) {
      if (false) {
        warn(
          "Duplicate presence of slot \"" + name + "\" found in the same render tree " +
          "- this will likely cause render errors.",
          this
        );
      }
      slotNodes._rendered = true;
    }
    nodes = slotNodes || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        if (!(key in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () { return resolveSlots(children, parent); };

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = data.scopedSlots || emptyObject;
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */




// Register the component hook to weex native render engine.
// The hook will be triggered by native, not javascript.


// Updates the state of the component to weex native render engine.

/*  */

// https://github.com/Hanks10100/weex-native-directive/tree/master/component

// listening on native callback

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (
    vnode,
    hydrating,
    parentElm,
    refElm
  ) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance,
        parentElm,
        refElm
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor, context);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  // Weex specific: invoke recycle-list optimized @render function for
  // extracting cell-slot template.
  // https://github.com/Hanks10100/weex-native-directive/tree/master/component
  /* istanbul ignore if */
  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent, // activeInstance in lifecycle state
  parentElm,
  refElm
) {
  var options = {
    _isComponent: true,
    parent: parent,
    _parentVnode: vnode,
    _parentElm: parentElm || null,
    _refElm: refElm || null
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    hooks[key] = componentVNodeHooks[key];
  }
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input';(data.props || (data.props = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  if (isDef(on[event])) {
    on[event] = [data.model.callback].concat(on[event]);
  } else {
    on[event] = data.model.callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if (isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    // reset _rendered flag on slots for duplicate slot check
    if (false) {
      for (var key in vm.$slots) {
        // $flow-disable-line
        vm.$slots[key]._rendered = false;
      }
    }

    if (_parentVnode) {
      vm.$scopedSlots = _parentVnode.data.scopedSlots || emptyObject;
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        if (vm.$options.renderError) {
          try {
            vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
          } catch (e) {
            handleError(e, vm, "renderError");
            vnode = vm._vnode;
          }
        } else {
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;
  opts._parentElm = options._parentElm;
  opts._refElm = options._refElm;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var extended = Ctor.extendOptions;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = dedupe(latest[key], extended[key], sealed[key]);
    }
  }
  return modified
}

function dedupe (latest, extended, sealed) {
  // compare latest and sealed to ensure lifecycle hooks won't be duplicated
  // between merges
  if (Array.isArray(latest)) {
    var res = [];
    sealed = Array.isArray(sealed) ? sealed : [sealed];
    extended = Array.isArray(extended) ? extended : [extended];
    for (var i = 0; i < latest.length; i++) {
      // push original options and not sealed options to exclude duplicated options
      if (extended.indexOf(latest[i]) >= 0 || sealed.indexOf(latest[i]) < 0) {
        res.push(latest[i]);
      }
    }
    return res
  } else {
    return latest
  }
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */

function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    var this$1 = this;

    for (var key in this$1.cache) {
      pruneCacheEntry(this$1.cache, key, this$1.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
}

var builtInComponents = {
  KeepAlive: KeepAlive
}

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.5.16';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}


var nodeOps = Object.freeze({
	createElement: createElement$1,
	createElementNS: createElementNS,
	createTextNode: createTextNode,
	createComment: createComment,
	insertBefore: insertBefore,
	removeChild: removeChild,
	appendChild: appendChild,
	parentNode: parentNode,
	nextSibling: nextSibling,
	tagName: tagName,
	setTextContent: setTextContent,
	setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
}

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove () {
      if (--remove.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove.listeners = listeners;
    return remove
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */, parentElm, refElm);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (ref$$1.parentNode === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (oldVnode, vnode, insertedVnodeQueue, removeOnly) {
    if (oldVnode === vnode) {
      return
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly, parentElm, refElm) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue, parentElm, refElm);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm$1 = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm$1,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm$1)) {
          removeVnodes(parentElm$1, [oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
}

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
]

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, isFalsyAttrValue(value) || value === 'false' ? 'false' : 'true');
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
}

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
}

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */

function baseWarn (msg) {
  console.error(("[Vue compiler]: " + msg));
}

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value) {
  (el.props || (el.props = [])).push({ name: name, value: value });
  el.plain = false;
}

function addAttr (el, name, value) {
  (el.attrs || (el.attrs = [])).push({ name: name, value: value });
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value) {
  el.attrsMap[name] = value;
  el.attrsList.push({ name: name, value: value });
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  modifiers
) {
  (el.directives || (el.directives = [])).push({ name: name, rawName: rawName, value: value, arg: arg, modifiers: modifiers });
  el.plain = false;
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.'
    );
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = '!' + name; // mark the event as captured
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = '~' + name; // mark the event as once
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = '&' + name; // mark the event as passive
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (name === 'click') {
    if (modifiers.right) {
      name = 'contextmenu';
      delete modifiers.right;
    } else if (modifiers.middle) {
      name = 'mouseup';
    }
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = {
    value: value.trim()
  };
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: ("\"" + value + "\""),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len;
var str;
var chr;
var index$1;
var expressionPos;
var expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead."
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.'
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally'
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler (handler, event, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

function add$1 (
  event,
  handler,
  once$$1,
  capture,
  passive
) {
  handler = withMacroTask(handler);
  if (once$$1) { handler = createOnceHandler(handler, event, capture); }
  target$1.addEventListener(
    event,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  event,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    event,
    handler._withTask || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
}

/*  */

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (isUndef(props[key])) {
      elm[key] = '';
    }
  }
  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else {
      elm[key] = cur;
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.lazy) {
      // inputs with lazy should only be updated when not in focus
      return false
    }
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
}

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(name, val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
}

/*  */

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(/\s+/).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(/\s+/).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def) {
  if (!def) {
    return
  }
  /* istanbul ignore else */
  if (typeof def === 'object') {
    var res = {};
    if (def.css !== false) {
      extend(res, autoCssTransition(def.name || 'v'));
    }
    extend(res, def);
    return res
  } else if (typeof def === 'string') {
    return autoCssTransition(def)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  var transitionDelays = styles[transitionProp + 'Delay'].split(', ');
  var transitionDurations = styles[transitionProp + 'Duration'].split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = styles[animationProp + 'Delay'].split(', ');
  var animationDurations = styles[animationProp + 'Duration'].split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

function toMs (s) {
  return Number(s.slice(0, -1)) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    transitionNode = transitionNode.parent;
    context = transitionNode.context;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {}

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
]

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
}

var platformDirectives = {
  model: directive,
  show: show
}

/*  */

// Provides transition support for a single element/component.
// supports transition mode (out-in / in-out)

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(function (c) { return c.tag || isAsyncPlaceholder(c); });
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(function (d) { return d.name === 'show'; })) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
}

/*  */

// Provides transition support for list items.
// supports move transitions using the FLIP technique.

// Because the vdom's children update algorithm is "unstable" - i.e.
// it doesn't guarantee the relative positioning of removed elements,
// we force transition-group to update its children into two passes:
// in the first pass, we remove all nodes that need to be removed,
// triggering their leaving transition; in the second pass, we insert/move
// into the final desired state. This way in the second pass removed
// nodes will remain where they should be.

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  beforeUpdate: function beforeUpdate () {
    // force removing pass
    this.__patch__(
      this._vnode,
      this.kept,
      false, // hydrating
      true // removeOnly (!important, avoids unnecessary moves)
    );
    this._vnode = this.kept;
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
}

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
}

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.'
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
}

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.'
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
}

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
}

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

/*!
 * HTML Parser By John Resig (ejohn.org)
 * Modified by Juriy "kangax" Zaytsev
 * Original code by Erik Arvidsson, Mozilla Public License
 * http://erik.eae.net/simplehtmlparser/simplehtmlparser.js
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
// could use https://www.w3.org/TR/1999/REC-xml-names-19990114/#NT-QName
// but for Vue templates we can enforce a simple charset
var ncname = '[a-zA-Z_][\\w\\-\\.]*';
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being pased as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

var IS_REGEX_CAPTURING_BROKEN = false;
'x'.replace(/x(.)?/g, function (m, g) {
  IS_REGEX_CAPTURING_BROKEN = g === '';
});

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t'
};
var encodedAttr = /&(?:lt|gt|quot|amp);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd));
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(lastTag, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
        advance(textEnd);
      }

      if (textEnd < 0) {
        text = html;
        html = '';
      }

      if (options.chars && text) {
        options.chars(text);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""));
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(attribute))) {
        advance(attr[0].length);
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      // hackish work around FF bug https://bugzilla.mozilla.org/show_bug.cgi?id=369778
      if (IS_REGEX_CAPTURING_BROKEN && args[0].indexOf('""') === -1) {
        if (args[3] === '') { delete args[3]; }
        if (args[4] === '') { delete args[4]; }
        if (args[5] === '') { delete args[5]; }
      }
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
    }

    // Find the closest opened tag of the same type
    if (tagName) {
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag.")
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:/;
var forAliasRE = /([^]*?)\s+(?:in|of)\s+([^]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;

var argRE = /:(.*)$/;
var bindRE = /^:|^v-bind:/;
var modifierRE = /\.[^.]+/g;

var decodeHTMLCached = cached(he.decode);

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;



function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg) {
    if (!warned) {
      warned = true;
      warn$2(msg);
    }
  }

  function closeElement (element) {
    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    start: function start (tag, attrs, unary) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.'
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
        // element-scope stuff
        processElement(element, options);
      }

      function checkRootConstraints (el) {
        if (false) {
          if (el.tag === 'slot' || el.tag === 'template') {
            warnOnce(
              "Cannot use <" + (el.tag) + "> as component root element because it may " +
              'contain multiple nodes.'
            );
          }
          if (el.attrsMap.hasOwnProperty('v-for')) {
            warnOnce(
              'Cannot use v-for on stateful component root element because ' +
              'it renders multiple elements.'
            );
          }
        }
      }

      // tree management
      if (!root) {
        root = element;
        checkRootConstraints(root);
      } else if (!stack.length) {
        // allow root elements with v-if, v-else-if and v-else
        if (root.if && (element.elseif || element.else)) {
          checkRootConstraints(element);
          addIfCondition(root, {
            exp: element.elseif,
            block: element
          });
        } else if (false) {
          warnOnce(
            "Component template should contain exactly one root element. " +
            "If you are using v-if on multiple elements, " +
            "use v-else-if to chain them instead."
          );
        }
      }
      if (currentParent && !element.forbidden) {
        if (element.elseif || element.else) {
          processIfConditions(element, currentParent);
        } else if (element.slotScope) { // scoped slot
          currentParent.plain = false;
          var name = element.slotTarget || '"default"';(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        } else {
          currentParent.children.push(element);
          element.parent = currentParent;
        }
      }
      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end () {
      // remove trailing whitespace
      var element = stack[stack.length - 1];
      var lastNode = element.children[element.children.length - 1];
      if (lastNode && lastNode.type === 3 && lastNode.text === ' ' && !inPre) {
        element.children.pop();
      }
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      closeElement(element);
    },

    chars: function chars (text) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.'
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored.")
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      text = inPre || text.trim()
        ? isTextTag(currentParent) ? text : decodeHTMLCached(text)
        // only preserve whitespace if its not right after a starting tag
        : preserveWhitespace && children.length ? ' ' : '';
      if (text) {
        var res;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          children.push({
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          });
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          children.push({
            type: 3,
            text: text
          });
        }
      }
    },
    comment: function comment (text) {
      currentParent.children.push({
        type: 3,
        text: text,
        isComment: true
      });
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var l = el.attrsList.length;
  if (l) {
    var attrs = el.attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      attrs[i] = {
        name: el.attrsList[i].name,
        value: JSON.stringify(el.attrsList[i].value)
      };
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (element, options) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = !element.key && !element.attrsList.length;

  processRef(element);
  processSlot(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      warn$2("<template> cannot be keyed. Place the key on real elements instead.");
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp)
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '');
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if."
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored."
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

function processSlot (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead."
      );
    }
  } else {
    var slotScope;
    if (el.tag === 'template') {
      slotScope = getAndRemoveAttr(el, 'scope');
      /* istanbul ignore if */
      if (false) {
        warn$2(
          "the \"scope\" attribute for scoped slots have been deprecated and " +
          "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
          "can also be used on plain elements in addition to <template> to " +
          "denote scoped slots.",
          true
        );
      }
      el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
    } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
      /* istanbul ignore if */
      if (false) {
        warn$2(
          "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
          "(v-for takes higher priority). Use a wrapper <template> for the " +
          "scoped slot to make it clearer.",
          true
        );
      }
      el.slotScope = slotScope;
    }
    var slotTarget = getBindingAttr(el, 'slot');
    if (slotTarget) {
      el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
      // preserve slot as an attribute for native shadow DOM compat
      // only for non-scoped slots.
      if (el.tag !== 'template' && !el.slotScope) {
        addAttr(el, 'slot', slotTarget);
      }
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, isProp;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name);
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isProp = false;
        if (modifiers) {
          if (modifiers.prop) {
            isProp = true;
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            addHandler(
              el,
              ("update:" + (camelize(name))),
              genAssignmentCode(value, "$event")
            );
          }
        }
        if (isProp || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value);
        } else {
          addAttr(el, name, value);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        addHandler(el, name, value, modifiers, false, warn$2);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
        }
        addDirective(el, name, rawName, value, arg, modifiers);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.'
          );
        }
      }
      addAttr(el, name, JSON.stringify(value));
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true');
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead."
      );
    }
    _el = _el.parent;
  }
}

/*  */

/**
 * Expand input[v-model] with dyanmic type bindings into v-if-else chains
 * Turn this:
 *   <input v-model="data[type]" :type="type">
 * into this:
 *   <input v-if="type === 'checkbox'" type="checkbox" v-model="data[type]">
 *   <input v-else-if="type === 'radio'" type="radio" v-model="data[type]">
 *   <input v-else :type="type" v-model="data[type]">
 */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$2 = {
  preTransformNode: preTransformNode
}

var modules$1 = [
  klass$1,
  style$1,
  model$2
]

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"));
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"));
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
}

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function\s*\(/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  esc: 'Escape',
  tab: 'Tab',
  enter: 'Enter',
  space: ' ',
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  'delete': ['Backspace', 'Delete']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative,
  warn
) {
  var res = isNative ? 'nativeOn:{' : 'on:{';
  for (var name in events) {
    res += "\"" + name + "\":" + (genHandler(name, events[name])) + ",";
  }
  return res.slice(0, -1) + '}'
}

function genHandler (
  name,
  handler
) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(name, handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    /* istanbul ignore if */
    return ("function($event){" + (handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : handler.value;
    /* istanbul ignore if */
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return ("if(!('button' in $event)&&" + (keys.map(genFilterCode).join('&&')) + ")return null;")
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
}

/*  */

var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data = el.plain ? undefined : genData$2(el, state);

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. "
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:{" + (genProps(el.attrs)) + "},";
  }
  // DOM props
  if (el.props) {
    data += "domProps:{" + (genProps(el.props)) + "},";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false, state.warn)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true, state.warn)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:\"" + (dir.arg) + "\"") : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn('Inline-template components must have exactly one child element.');
  }
  if (ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  slots,
  state
) {
  return ("scopedSlots:_u([" + (Object.keys(slots).map(function (key) {
      return genScopedSlot(key, slots[key], state)
    }).join(',')) + "])")
}

function genScopedSlot (
  key,
  el,
  state
) {
  if (el.for && !el.forProcessed) {
    return genForScopedSlot(key, el, state)
  }
  var fn = "function(" + (String(el.slotScope)) + "){" +
    "return " + (el.tag === 'template'
      ? el.if
        ? ((el.if) + "?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  return ("{key:" + key + ",fn:" + fn + "}")
}

function genForScopedSlot (
  key,
  el,
  state
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';
  el.forProcessed = true; // avoid recursion
  return "_l((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + (genScopedSlot(key, el, state)) +
    '})'
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      return (altGenElement || genElement)(el$1, state)
    }
    var normalizationType = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType ? ("," + normalizationType) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs && ("{" + (el.attrs.map(function (a) { return ((camelize(a.name)) + ":" + (a.value)); }).join(',')) + "}");
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var res = '';
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    /* istanbul ignore if */
    {
      res += "\"" + (prop.name) + "\":" + (transformSpecialNewlines(prop.value)) + ",";
    }
  }
  return res.slice(0, -1)
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */

// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast) {
  var errors = [];
  if (ast) {
    checkNode(ast, errors);
  }
  return errors
}

function checkNode (node, errors) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), errors);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), errors);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), errors);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], errors);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, errors);
  }
}

function checkEvent (exp, text, errors) {
  var stipped = exp.replace(stripStringRE, '');
  var keywordMatch = stipped.match(unaryOperatorsRE);
  if (keywordMatch && stipped.charAt(keywordMatch.index - 1) !== '$') {
    errors.push(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim())
    );
  }
  checkExpression(exp, text, errors);
}

function checkFor (node, text, errors) {
  checkExpression(node.for || '', text, errors);
  checkIdentifier(node.alias, 'v-for alias', text, errors);
  checkIdentifier(node.iterator1, 'v-for iterator', text, errors);
  checkIdentifier(node.iterator2, 'v-for iterator', text, errors);
}

function checkIdentifier (
  ident,
  type,
  text,
  errors
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      errors.push(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())));
    }
  }
}

function checkExpression (exp, text, errors) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      errors.push(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim())
      );
    } else {
      errors.push(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n"
      );
    }
  }
}

/*  */

function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        warn$$1(
          "Error compiling template:\n\n" + template + "\n\n" +
          compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
          vm
        );
      }
      if (compiled.tips && compiled.tips.length) {
        compiled.tips.forEach(function (msg) { return tip(msg, vm); });
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];
      finalOptions.warn = function (msg, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      var compiled = baseCompile(template, finalOptions);
      if (false) {
        errors.push.apply(errors, detectErrors(compiled.ast));
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(20), __webpack_require__(57).setImmediate))

/***/ }),
/* 20 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return routes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_mobile_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_mobile_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_mobile_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_welcome_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_welcome_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_welcome_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plains_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plains_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_plains_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ocean_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ocean_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_ocean_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_amazon_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_amazon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_amazon_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_forest_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_forest_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_forest_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_desert_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_desert_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_desert_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_beach_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_beach_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_beach_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_nyc_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_nyc_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_nyc_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_rural_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_rural_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_rural_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_ice_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_ice_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_ice_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_fire_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_fire_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_fire_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_tutorial_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_tutorial_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_tutorial_vue__);














var routes = [{ name: 'welcome', path: '/', component: __WEBPACK_IMPORTED_MODULE_1__components_welcome_vue___default.a, meta: { title: 'Soundscape.cloud' } }, { name: 'mobile', path: '/mobile', component: __WEBPACK_IMPORTED_MODULE_0__components_mobile_vue___default.a, meta: { title: 'Soundscape.cloud' } }, { name: 'plains', path: '/grasslands', component: __WEBPACK_IMPORTED_MODULE_2__components_plains_vue___default.a, meta: { title: 'Grasslands' } }, { name: 'ocean', path: '/ocean', component: __WEBPACK_IMPORTED_MODULE_3__components_ocean_vue___default.a, meta: { title: 'Pacific Ocean' } }, { name: 'amazon', path: '/amazon', component: __WEBPACK_IMPORTED_MODULE_4__components_amazon_vue___default.a, meta: { title: 'Amazon Rainforest' } }, { name: 'forest', path: '/woodlands', component: __WEBPACK_IMPORTED_MODULE_5__components_forest_vue___default.a, meta: { title: 'Deciduous Forest' } }, { name: 'desert', path: '/desert', component: __WEBPACK_IMPORTED_MODULE_6__components_desert_vue___default.a, meta: { title: 'Mojave Desert' } }, { name: 'beach', path: '/seaside', component: __WEBPACK_IMPORTED_MODULE_7__components_beach_vue___default.a, meta: { title: 'Beach Vibes' } }, { name: 'nyc', path: '/nyc', component: __WEBPACK_IMPORTED_MODULE_8__components_nyc_vue___default.a, meta: { title: 'New York City' } }, { name: 'rural', path: '/smalltown', component: __WEBPACK_IMPORTED_MODULE_9__components_rural_vue___default.a, meta: { title: 'Small Town' } }, { name: 'Ice', path: '/ice', component: __WEBPACK_IMPORTED_MODULE_10__components_ice_vue___default.a, meta: { title: 'Subzero Sounds' } }, { name: 'Fire', path: '/fire', component: __WEBPACK_IMPORTED_MODULE_11__components_fire_vue___default.a, meta: { title: 'Sizzling Sounds' } }, { name: 'tutorial', path: '/tutorial', component: __WEBPACK_IMPORTED_MODULE_12__components_tutorial_vue___default.a, meta: { title: 'Tutorial' } }];

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(87);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
	state: {
		//AUDIO CONTEXT IS ACTIVE
		hasAudioContextTriggered: false,
		//IS VOICE CONTROL CURRENTLY ACTIVE
		isVoiceControlled: false,
		//DOES BROWSER SUPPORT VOICE CONTROL
		allowSpeechControl: false,
		//DOES BROWSER SUPPORT MEDIA RTC
		// allowMediaRecording: false
		//IF BEING VOICE CONTROLLED DON'T PLAY THE NICE, TELL ME WHERE YOU WANT TO GO PROMPT
		doNotAddress: false,
		isFirstLoad: true
	}
});

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(77)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(63),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v2.8.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '2.8.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mousetrap__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mousetrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mousetrap__);
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
      name: 'app',
      data: function data() {
            return {
                  //WHAT DEVICE
                  isChrome: Boolean,
                  isFirefox: Boolean,
                  isSafari: Boolean,
                  isOpera: Boolean,
                  isIE: Boolean,
                  isEdge: Boolean,
                  isBlink: Boolean,
                  iOS: Boolean,
                  AndroidMobile: Boolean,
                  engageVoice: false
            };
      },
      created: function created() {
            var ua = window.navigator.userAgent;
            this.isChrome = !!window.chrome && !!window.chrome.webstore;
            this.isFirefox = typeof InstallTrigger !== 'undefined';
            this.isSafari = /constructor/i.test(window.HTMLElement) || function (p) {
                  return p.toString() === "[object SafariRemoteNotification]";
            }(!window['safari'] || safari.pushNotification);
            this.isOpera = !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
            this.isIE = /*@cc_on!@*/false || !!document.documentMode;
            this.isEdge = !this.isIE && !!window.StyleMedia;
            this.isBlink = (this.isChrome || this.isOpera) && !!window.CSS, this.iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
            this.AndroidMobile = /Android/i.test(navigator.userAgent);

            if (this.isChrome === true) {
                  // this.$store.state.allowSpeechControl = true;
                  this.$router.push('/mobile');
            } else if (this.isFirefox === true) {
                  this.$router.push('/mobile');
            } else if (this.AndroidMobile === true || this.iOS) {
                  this.$router.push('/mobile');
            } else if (this.isSafari === true || this.isOpera === true || this.isBlink === true || this.isEdge === true || this.isIE === true) {}

            // this.$router.push('/mobile');
            console.log('%c App Created by Matt McCorkle ', 'background: black; color: gold', '=> www.mattmccorkle.com');
      },

      computed: {
            keyboardTriggering: function keyboardTriggering() {
                  var _this = this;

                  Mousetrap.bind('up', function () {
                        _this.engageVoice = !_this.engageVoice;
                        if (_this.isChrome) {
                              if (_this.engageVoice) {

                                    _this.$store.state.allowSpeechControl = true;
                                    _this.$store.state.isVoiceControlled = true;
                              } else if (!_this.engageVoice) {
                                    _this.$store.state.allowSpeechControl = false;
                                    _this.$store.state.isVoiceControlled = false;
                              }
                        }
                  });
            }
      }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_startaudiocontext_StartAudioContext_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_startaudiocontext_StartAudioContext_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_startaudiocontext_StartAudioContext_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js__);
var _methods;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var XRegExp = __webpack_require__(5);
/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			//RANDOMIZE BOOLEANS
			randomizeBoolean: false,
			showFlask1: true,
			showFlask2: false,
			showFlask3: false,
			showFlask4: false,
			showFlask5: false,
			showFlask6: false,
			//CONTROLS
			reverbChecker: undefined,
			loadingBoolean: true,
			userMobile: Boolean,
			mailingListBtn: false,
			textTiming: 500,
			startStopTrigger: true,
			playColor: "#F0CB50",
			stopColor: "#1E9BFC",
			//SCREEN DIMENSIONS
			screenHeight: undefined,
			screenWidth: undefined,
			ogWidth: undefined,
			//BACKGROUND COLORS
			plungeDepth: 1,
			backgroundColor1: true,
			backgroundColor2: false,
			backgroundColor3: false,
			backgroundColor4: false,
			backgroundColor5: false,
			backgroundColor6: false,
			backgroundColor7: false,
			backgroundColor8: false,
			backgroundColor9: false,
			backgroundColor10: false,
			//REACTIVE SUN
			sunReactiveColor1: true,
			sunReactiveColor2: false,
			sunReactiveColor3: false,
			sunReactiveColor4: false,
			sunReactiveColor5: false,
			sunReactiveColor6: false,
			sunReactiveColor7: false,
			sunReactiveColor8: false,
			sunReactiveColor9: false,
			sunReactiveColor10: false,
			//SHOW AND HIDE
			helpTrigger: false,
			showHelpOverlay: false,
			showAboutPage: false,

			bellBoolean: false,
			//PLAY SUN DRAGGIE
			activeSun: false,
			//V-SHOWS
			showEnterContainer: true,
			showLoading: true,
			showEnterBtn: false,
			showNavBar: false,
			showAllControls: false,
			showSpeechBtns: false,
			//AMBIENCE BOOLEANS
			ambience1Boolean: false,
			ambience2Boolean: false,
			ambience3Boolean: false,
			ambience4Boolean: false,
			ambience5Boolean: false,
			ambience6Boolean: false,
			//AMBIENCE DATA
			whatIsLoading: "Rainforest",
			amazonFX: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": false,
				"volume": -5
			}).toMaster(),
			changeFX: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": false,
				"volume": -6
			}).toMaster(),
			ambience1Vol: -10,
			ambience2Vol: -10,
			ambience3Vol: -10,
			ambience4Vol: -25,
			ambience5Vol: 0,
			ambience6Vol: -4,
			ambience1Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": 0
			}),
			ambience2Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": 0
			}),
			ambience3Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": 0
			}),
			ambience4Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": 0
			}),
			ambience5Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": 0
			}),
			ambience6Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": 0
			}),
			//AUDIO ROUTING & EFFECTS
			playBackSpeed: 1,
			fxDecay: 2.5,
			// masterVolume:     		0,
			loadingSoundID: undefined,
			audioLoading: undefined,
			fxConvolverAmt: 0,
			fxChorusAmt: 0,
			fxDelayAmt: 0,
			fxAutoFilterAmt: 3500,
			mattChill: false,
			fxConvolver: undefined,
			fxChorus: undefined,
			fxDistort: undefined,
			fxDelay: undefined,
			fxAutoFilter: undefined,

			speedToggle: true,
			fxDelayToggle: true,
			fxConvolverToggle: true,
			fxChorusToggle: true,
			fxFilterToggle: false,

			masterMeter: undefined,
			masterLevel: 0,
			masterVolumeSub: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Volume(0),
			//SPEECH
			//FOR SPEECH FORM INPUT
			submitSpeechTxttoVoice: false,
			userVoiceToText: "",
			//IF SPEECH IS ALLOWED SHOW SPEECH ACTIVATE BUTTON (SET VIA APP.js)
			allowSpeechControl: false,
			//GLOBAL COMMAND TRIGGERING VOICE COMMANDS ON AND OFF
			isVoiceControl: false,
			//COMMAND FOR CSS CONTROL WHEN VOICE IS ACTIVE OR NOT
			recognizing: undefined,
			recognitionAmazon: undefined,
			//HOLDS ALL OF SPEECHRECONGNITION JSON
			voiceCommandArray: undefined,
			speechRecognitionList: undefined,
			voiceCommandConfidence: undefined,
			//STRING LINE TO TEST FOR VOICE COMMAND ACTIONS
			testObjectVUI: "",
			//BUTTON SWITCHING & TEXT
			initSpeech: true,
			speechBtnTxt: "Say A Command",
			speechStartTopBtnTrigger: true,
			//SHOWS LIST OF COMMANDS
			showVoiceCommandList: false,
			//DISABLE WHILE RECORDING
			isDisableListening: false,
			//TRUE WHEN STOPPING ALL SPEECH FUNCTIONS TO GO HOME
			stopModuleSpeech: false,
			//IF USER ENGAGES VOICE CONTROL BUT GOES HOME VIA MOUSE BUTTON THIS TRIGGERS MODULE SPEECH DISPOSE
			//EXPLORE
			isExploreFuncRunning: false,
			didWeAdventure: false,
			exploreSound1: undefined,
			exploreSound2: undefined,
			exploreSound3: undefined,
			//WHAT DEVICE
			isChrome: Boolean,
			isFirefox: Boolean,
			isSafari: Boolean,
			isOpera: Boolean,
			isIE: Boolean,
			isEdge: Boolean,
			isBlink: Boolean,
			iOS: Boolean,
			AndroidMobile: Boolean,
			//EXPLORE TIMES OUTS
			exploreTxt: "Explore!",
			exploreTimeout1: undefined,
			exploreTimeout2: undefined,
			exploreTimeout3: undefined,
			exploreTimeout4: undefined,
			exploreTimeout5: undefined,
			exploreTimeout6: undefined,
			exploreTimeout7: undefined,
			exploreTimeout8: undefined,
			exploreTimeout9: undefined,
			exploreTimeout10: undefined,
			exploreTimeout11: undefined,
			exploreTimeout12: undefined,
			exploreTimeout13: undefined,
			exploreTimeout14: undefined,
			//START AUDIO CONTEXT BOOLEAN
			startAudioBoolean: true,
			//LOCAL STORAGE
			isCacheSaved: false,
			firstLoad: false,
			saveTrigger: false,
			loadTrigger: false
		};
	},
	created: function created() {
		var _this = this;

		this.isVoiceControl = this.$store.state.isVoiceControlled;
		if (this.isVoiceControl) {
			this.$store.state.doNotAddress = true;
		}

		window.onpopstate = function () {
			document.body.className = 'default';
			_this.goHome();
		};
		var ua = window.navigator.userAgent;
		this.isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
		this.isFirefox = typeof InstallTrigger !== 'undefined';
		this.isSafari = /constructor/i.test(window.HTMLElement) || function (p) {
			return p.toString() === "[object SafariRemoteNotification]";
		}(!window['safari'] || safari.pushNotification);
		this.isOpera = !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
		this.isIE = /*@cc_on!@*/false || !!document.documentMode;
		this.isEdge = !this.isIE && !!window.StyleMedia;
		this.isBlink = (this.isChrome || this.isOpera) && !!window.CSS, this.iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
		this.AndroidMobile = /Android/i.test(navigator.userAgent);
		//CHROME ALLOWS SPEECH AND MEDIA RECORDING
		if (this.isChrome === true) {
			this.userMobile = false;
			//FIREFOX ONLY ALLOWS MEDIA RECORDING
		} else if (this.isFirefox === true) {
			this.userMobile = false;
			//NO SPEECH AND NO MEDIA RECORDING FOR THE FOLLOWING
		} else if (this.AndroidMobile === true || this.iOS) {
			this.userMobile = true;
		} else if (this.isSafari === true || this.isOpera === true || this.isBlink === true || this.isEdge === true || this.isIE === true) {
			this.userMobile = false;
		}
		this.firstAudioLoadFunc();
		this.bufferLoading();
		this.audioRouting();
	},

	computed: {
		//THE PLUNGE BACKGROUND CHANGE
		plungeClass: function plungeClass() {
			if (this.activeSun === false) {
				if (this.plungeDepth === 1) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = true;
				} else if (this.plungeDepth === 2) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = true;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 3) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = true;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 4) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = true;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 5) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = true;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 6) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = true;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 7) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = true;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 8) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = true;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 9) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = true;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 10) {
					this.backgroundColor10 = true;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				}
				return {
					"backgroundColorAmazon10": this.backgroundColor10,
					"backgroundColorAmazon9": this.backgroundColor9,
					"backgroundColorAmazon8": this.backgroundColor8,
					"backgroundColorAmazon7": this.backgroundColor7,
					"backgroundColorAmazon6": this.backgroundColor6,
					"backgroundColorAmazon5": this.backgroundColor5,
					"backgroundColorAmazon4": this.backgroundColor4,
					"backgroundColorAmazon3": this.backgroundColor3,
					"backgroundColorAmazon2": this.backgroundColor2,
					"backgroundColorAmazon1": this.backgroundColor1
				};
			} else if (this.activeSun === true) {
				if (this.masterLevel < -46) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = true;
				} else if (this.masterLevel < -42) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = true;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -40) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = true;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -38) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = true;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -34) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = true;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -29) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = true;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -24) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = true;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -18) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = true;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -13) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = true;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel > -8) {
					this.sunReactiveColor10 = true;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				}
				return {
					"sunReactiveColorClassAmazon10": this.sunReactiveColor10,
					"sunReactiveColorClassAmazon9": this.sunReactiveColor9,
					"sunReactiveColorClassAmazon8": this.sunReactiveColor8,
					"sunReactiveColorClassAmazon7": this.sunReactiveColor7,
					"sunReactiveColorClassAmazon6": this.sunReactiveColor6,
					"sunReactiveColorClassAmazon5": this.sunReactiveColor5,
					"sunReactiveColorClassAmazon4": this.sunReactiveColor4,
					"sunReactiveColorClassAmazon3": this.sunReactiveColor3,
					"sunReactiveColorClassAmazon2": this.sunReactiveColor2,
					"sunReactiveColorClassAmazon1": this.sunReactiveColor1
				};
			}
		},

		//SHOW AND HIDE CLASS CHANGES
		helpClass: function helpClass() {
			return {
				"btn btn-helpBtn1Amazon": this.helpTrigger,
				"btn btn-helpBtn2Amazon": !this.helpTrigger
			};
		},
		mailingListBtnClass: function mailingListBtnClass() {
			return {
				"btn btn-transparent": this.mailingListBtn,
				"btn btn-info": !this.mailingListBtn
			};
		},

		//AMBIENCE CLASS CHANGES
		ambience1Class: function ambience1Class() {
			return {
				"btn btn-playAmazon": this.ambience1Boolean,
				"btn btn-stopAmazon": !this.ambience1Boolean
			};
		},
		ambience2Class: function ambience2Class() {
			return {
				"btn btn-playAmazon": this.ambience2Boolean,
				"btn btn-stopAmazon": !this.ambience2Boolean
			};
		},
		ambience3Class: function ambience3Class() {
			return {
				"btn btn-playAmazon": this.ambience3Boolean,
				"btn btn-stopAmazon": !this.ambience3Boolean
			};
		},
		ambience4Class: function ambience4Class() {
			return {
				"btn btn-playAmazon": this.ambience4Boolean,
				"btn btn-stopAmazon": !this.ambience4Boolean
			};
		},
		ambience5Class: function ambience5Class() {
			return {
				"btn btn-playAmazon": this.ambience5Boolean,
				"btn btn-stopAmazon": !this.ambience5Boolean
			};
		},
		ambience6Class: function ambience6Class() {
			return {
				"btn btn-playAmazon": this.ambience6Boolean,
				"btn btn-stopAmazon": !this.ambience6Boolean
			};
		},
		mattChillClass: function mattChillClass() {
			return {
				"btn btn-mattChillOnAmazon": this.mattChill,
				"btn btn-mattChillOffAmazon": !this.mattChill
			};
		},

		//AMBIENCE ICON CSS
		ambience1Icon: function ambience1Icon() {
			return {
				"fal fa-times-circle": !this.ambience1Boolean,
				"fal fa-check-circle": this.ambience1Boolean
			};
		},
		ambience2Icon: function ambience2Icon() {
			return {
				"fal fa-times-circle": !this.ambience2Boolean,
				"fal fa-check-circle": this.ambience2Boolean
			};
		},
		ambience3Icon: function ambience3Icon() {
			return {
				"fal fa-times-circle": !this.ambience3Boolean,
				"fal fa-check-circle": this.ambience3Boolean
			};
		},
		ambience4Icon: function ambience4Icon() {
			return {
				"fal fa-times-circle": !this.ambience4Boolean,
				"fal fa-check-circle": this.ambience4Boolean
			};
		},
		ambience5Icon: function ambience5Icon() {
			return {
				"fal fa-times-circle": !this.ambience5Boolean,
				"fal fa-check-circle": this.ambience5Boolean
			};
		},
		ambience6Icon: function ambience6Icon() {
			return {
				"fal fa-times-circle": !this.ambience6Boolean,
				"fal fa-check-circle": this.ambience6Boolean
			};
		},

		//AMBIANCE CLASS CHANGES
		ambiance1RangerClass: function ambiance1RangerClass() {
			return {
				"ambianceRangerPlayAmazon": this.ambience1Boolean,
				"ambianceRangerStopAmazon": !this.ambience1Boolean
			};
		},
		ambiance2RangerClass: function ambiance2RangerClass() {
			return {
				"ambianceRangerPlayAmazon": this.ambience2Boolean,
				"ambianceRangerStopAmazon": !this.ambience2Boolean
			};
		},
		ambiance3RangerClass: function ambiance3RangerClass() {
			return {
				"ambianceRangerPlayAmazon": this.ambience3Boolean,
				"ambianceRangerStopAmazon": !this.ambience3Boolean
			};
		},
		ambiance4RangerClass: function ambiance4RangerClass() {
			return {
				"ambianceRangerPlayAmazon": this.ambience4Boolean,
				"ambianceRangerStopAmazon": !this.ambience4Boolean
			};
		},
		ambiance5RangerClass: function ambiance5RangerClass() {
			return {
				"ambianceRangerPlayAmazon": this.ambience5Boolean,
				"ambianceRangerStopAmazon": !this.ambience5Boolean
			};
		},
		ambiance6RangerClass: function ambiance6RangerClass() {
			return {
				"ambianceRangerPlayAmazon": this.ambience6Boolean,
				"ambianceRangerStopAmazon": !this.ambience6Boolean
			};
		},

		//AUDIO MIXING
		adjustInputVolume: function adjustInputVolume() {
			this.userMic.volume.value = this.userMicInputLevel;
		},
		fxConvolverMix: function fxConvolverMix() {
			if (this.userMobile === false) {
				if (this.fxConvolverToggle === true) {
					this.fxConvolver.wet.setTargetAtTime(this.fxConvolverAmt / 100, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				} else if (this.fxConvolverToggle === false) {
					this.fxConvolver.wet.setTargetAtTime(0, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				}
			}
		},
		fxDelayMix: function fxDelayMix() {
			if (this.userMobile === false) {
				if (this.fxDelayToggle === true) {
					this.fxDelay.wet.setTargetAtTime(this.fxDelayAmt / 100, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +1);
				} else if (this.fxDelayToggle === false) {
					this.fxDelay.wet.setTargetAtTime(0, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +1);
				}
			}
		},
		fxChorusMix: function fxChorusMix() {
			if (this.userMobile === false) {
				if (this.fxChorusToggle === true) {
					this.fxChorus.wet.setTargetAtTime(this.fxChorusAmt / 100, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				} else if (this.fxChorusToggle === false) {
					this.fxChorus.wet.setTargetAtTime(0, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				}
			}
		},
		fxAutoFilterMix: function fxAutoFilterMix() {
			if (this.userMobile === false) {
				if (this.fxFilterToggle === true) {
					this.fxAutoFilter.frequency.setTargetAtTime(this.fxAutoFilterAmt, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				} else if (this.fxFilterToggle === false) {
					this.fxAutoFilter.frequency.setTargetAtTime(20000, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				}
			}
		},
		playbackSpeedFunc: function playbackSpeedFunc() {
			if (this.speedToggle === true) {
				this.ambience1Player.playbackRate = this.playBackSpeed;
				this.ambience2Player.playbackRate = this.playBackSpeed;
				this.ambience3Player.playbackRate = this.playBackSpeed;
				this.ambience4Player.playbackRate = this.playBackSpeed;
				this.ambience5Player.playbackRate = this.playBackSpeed;
				this.ambience6Player.playbackRate = this.playBackSpeed;
			} else if (this.speedToggle === false) {
				this.ambience1Player.playbackRate = 1;
				this.ambience2Player.playbackRate = 1;
				this.ambience3Player.playbackRate = 1;
				this.ambience4Player.playbackRate = 1;
				this.ambience5Player.playbackRate = 1;
				this.ambience6Player.playbackRate = 1;
			}
		},

		//SPEECH
		speechStartStopClass: function speechStartStopClass() {
			return {
				"recordingClassEngagedAmazon": this.recognizing,
				"recordingClassDisengagedAmazon": !this.recognizing
			};
		},
		speechIconClass: function speechIconClass() {
			return {
				"fa fa-microphone-alt fa-spin": this.recognizing,
				"fa fa-microphone-alt": !this.recognizing
			};
		},
		speechShowListClass: function speechShowListClass() {
			return {
				"recordingClassEngagedAmazon": this.showVoiceCommandList,
				"recordingClassDisengagedAmazon": !this.showVoiceCommandList
			};
		},
		speechSubmitClass: function speechSubmitClass() {
			return {
				"btn btn-speechSubmitOn mb-2": this.submitSpeechTxttoVoice,
				"btn btn-speechSubmitOff mb-2": !this.submitSpeechTxttoVoice
			};
		},

		//EXPLORE
		exploreFuncClass: function exploreFuncClass() {
			return {
				"recordingClassDisengagedAmazon": !this.isExploreFuncRunning,
				"recordingClassEngagedAmazon": this.isExploreFuncRunning
			};
		},
		exploreIconClass: function exploreIconClass() {
			return {
				"fab fa-wpexplorer": !this.isExploreFuncRunning,
				"fab fa-wpexplorer fa-spin": this.isExploreFuncRunning
			};
		},

		//AMBIENCE PLAY AND STOPS
		ambience1Func: function ambience1Func() {
			if (this.ambience1Boolean === true) {
				this.ambience1Player.volume.value = this.ambience1Vol;
			} else if (this.ambience1Boolean === false) {
				this.ambience1Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},
		ambience2Func: function ambience2Func() {
			if (this.ambience2Boolean === true) {
				this.ambience2Player.volume.value = this.ambience2Vol;
			} else if (this.ambience2Boolean === false) {
				this.ambience2Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},
		ambience3Func: function ambience3Func() {
			if (this.ambience3Boolean === true) {
				this.ambience3Player.volume.value = this.ambience3Vol;
			} else if (this.ambience3Boolean === false) {
				this.ambience3Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},
		ambience4Func: function ambience4Func() {
			if (this.ambience4Boolean === true) {
				this.ambience4Player.volume.value = this.ambience4Vol;
			} else if (this.ambience4Boolean === false) {
				this.ambience4Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},
		ambience5Func: function ambience5Func() {
			if (this.ambience5Boolean === true) {
				this.ambience5Player.volume.value = this.ambience5Vol;
			} else if (this.ambience5Boolean === false) {
				this.ambience5Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},
		ambience6Func: function ambience6Func() {
			if (this.ambience6Boolean === true) {
				this.ambience6Player.volume.value = this.ambience6Vol;
			} else if (this.ambience6Boolean === false) {
				this.ambience6Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},

		//LOCAL STORAGE
		saveClass: function saveClass() {
			return { "btn btn-playAmazon": this.saveTrigger,
				"btn btn-stopAmazon": !this.saveTrigger };
		},
		loadClass: function loadClass() {
			return { "btn btn-playAmazon": this.loadTrigger,
				"btn btn-stopAmazon": !this.loadTrigger };
		}
	},
	methods: (_methods = {
		//LOCAL STORAGE
		setLocalStorage: function setLocalStorage() {
			var _this2 = this;

			this.saveTrigger = true;
			setTimeout(function () {
				_this2.saveTrigger = false;
			}, 250);

			this.removeLocalStorage();

			localStorage.setItem('isCacheSavedAmazon', JSON.stringify(true));

			localStorage.setItem('ambience1VolAmazon', JSON.stringify(this.ambience1Vol));
			localStorage.setItem('ambience2VolAmazon', JSON.stringify(this.ambience2Vol));
			localStorage.setItem('ambience3VolAmazon', JSON.stringify(this.ambience3Vol));
			localStorage.setItem('ambience4VolAmazon', JSON.stringify(this.ambience4Vol));
			localStorage.setItem('ambience5VolAmazon', JSON.stringify(this.ambience5Vol));
			localStorage.setItem('ambience6VolAmazon', JSON.stringify(this.ambience6Vol));

			localStorage.setItem('ambience1BooleanAmazon', JSON.stringify(this.ambience1Boolean));
			localStorage.setItem('ambience2BooleanAmazon', JSON.stringify(this.ambience2Boolean));
			localStorage.setItem('ambience3BooleanAmazon', JSON.stringify(this.ambience3Boolean));
			localStorage.setItem('ambience4BooleanAmazon', JSON.stringify(this.ambience4Boolean));
			localStorage.setItem('ambience5BooleanAmazon', JSON.stringify(this.ambience5Boolean));
			localStorage.setItem('ambience6BooleanAmazon', JSON.stringify(this.ambience6Boolean));

			localStorage.setItem('speedToggleAmazon', JSON.stringify(this.speedToggle));
			localStorage.setItem('fxDelayToggleAmazon', JSON.stringify(this.fxDelayToggle));
			localStorage.setItem('fxConvolverToggleAmazon', JSON.stringify(this.fxConvolverToggle));
			localStorage.setItem('fxChorusToggleAmazon', JSON.stringify(this.fxChorusToggle));
			localStorage.setItem('fxFilterToggleAmazon', JSON.stringify(this.fxFilterToggle));

			localStorage.setItem('playBackSpeed', JSON.stringify(this.playBackSpeed));
			localStorage.setItem('fxConvolverAmtAmazon', JSON.stringify(this.fxConvolverAmt));
			localStorage.setItem('fxChorusAmtAmazon', JSON.stringify(this.fxChorusAmt));
			localStorage.setItem('fxDelayAmtAmazon', JSON.stringify(this.fxDelayAmt));
			localStorage.setItem('fxAutoFilterAmtAmazon', JSON.stringify(this.fxAutoFilterAmt));
		},
		getLocalStorage: function getLocalStorage() {
			var _this3 = this;

			this.isCacheSaved = JSON.parse(localStorage.getItem('isCacheSavedAmazon'));
			if (this.isCacheSaved) {
				this.loadTrigger = true;
				setTimeout(function () {
					_this3.loadTrigger = false;
				}, 250);

				this.ambience1Vol = JSON.parse(localStorage.getItem('ambience1VolAmazon'));
				this.ambience2Vol = JSON.parse(localStorage.getItem('ambience2VolAmazon'));
				this.ambience3Vol = JSON.parse(localStorage.getItem('ambience3VolAmazon'));
				this.ambience4Vol = JSON.parse(localStorage.getItem('ambience4VolAmazon'));
				this.ambience5Vol = JSON.parse(localStorage.getItem('ambience5VolAmazon'));
				this.ambience6Vol = JSON.parse(localStorage.getItem('ambience6VolAmazon'));

				this.ambience1Boolean = JSON.parse(localStorage.getItem('ambience1BooleanAmazon'));
				this.ambience2Boolean = JSON.parse(localStorage.getItem('ambience2BooleanAmazon'));
				this.ambience3Boolean = JSON.parse(localStorage.getItem('ambience3BooleanAmazon'));
				this.ambience4Boolean = JSON.parse(localStorage.getItem('ambience4BooleanAmazon'));
				this.ambience5Boolean = JSON.parse(localStorage.getItem('ambience5BooleanAmazon'));
				this.ambience6Boolean = JSON.parse(localStorage.getItem('ambience6BooleanAmazon'));

				this.speedToggle = JSON.parse(localStorage.getItem('speedToggleAmazon'));
				this.fxDelayToggle = JSON.parse(localStorage.getItem('fxDelayToggleAmazon'));
				this.fxConvolverToggle = JSON.parse(localStorage.getItem('fxConvolverToggleAmazon'));
				this.fxChorusToggle = JSON.parse(localStorage.getItem('fxChorusToggleAmazon'));
				this.fxFilterToggle = JSON.parse(localStorage.getItem('fxFilterToggleAmazon'));

				this.playBackSpeed = JSON.parse(localStorage.getItem('playBackSpeed'));;
				this.fxConvolverAmt = JSON.parse(localStorage.getItem('fxConvolverAmtAmazon'));
				this.fxChorusAmt = JSON.parse(localStorage.getItem('fxChorusAmtAmazon'));
				this.fxDelayAmt = JSON.parse(localStorage.getItem('fxDelayAmtAmazon'));
				this.fxAutoFilterAmt = JSON.parse(localStorage.getItem('fxAutoFilterAmtAmazon'));
			}
		},
		removeLocalStorage: function removeLocalStorage() {
			localStorage.removeItem('isCacheSavedAmazon');

			localStorage.removeItem('ambience1VolAmazon');
			localStorage.removeItem('ambience2VolAmazon');
			localStorage.removeItem('ambience3VolAmazon');
			localStorage.removeItem('ambience4VolAmazon');
			localStorage.removeItem('ambience5VolAmazon');
			localStorage.removeItem('ambience6VolAmazon');

			localStorage.removeItem('ambience1BooleanAmazon');
			localStorage.removeItem('ambience2BooleanAmazon');
			localStorage.removeItem('ambience3BooleanAmazon');
			localStorage.removeItem('ambience4BooleanAmazon');
			localStorage.removeItem('ambience5BooleanAmazon');
			localStorage.removeItem('ambience6BooleanAmazon');

			localStorage.removeItem('speedToggleAmazon');
			localStorage.removeItem('fxDelayToggleAmazon');
			localStorage.removeItem('fxConvolverToggleAmazon');
			localStorage.removeItem('fxChorusToggleAmazon');
			localStorage.removeItem('fxFilterToggleAmazon');

			localStorage.removeItem('playBackSpeedAmazon');
			localStorage.removeItem('fxConvolverAmtAmazon');
			localStorage.removeItem('fxChorusAmtAmazon');
			localStorage.removeItem('fxDelayAmtAmazon');
			localStorage.removeItem('fxAutoFilterAmtAmazon');
		},

		//START AUDIO
		startAudio: function startAudio() {
			if (this.firstLoad) {
				this.firstLoad = false;
				__WEBPACK_IMPORTED_MODULE_0__node_modules_startaudiocontext_StartAudioContext_js___default()(__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.context, "#enterFuncBtn");
				this.$store.state.hasAudioContextTriggered = true;
			}
			this.ambience1Player.volume.value = -100;
			this.ambience2Player.volume.value = -100;
			this.ambience3Player.volume.value = -100;
			this.ambience4Player.volume.value = -100;
			this.ambience5Player.volume.value = -100;
			this.ambience6Player.volume.value = -100;

			this.ambience1Player.start();
			this.ambience2Player.start();
			this.ambience3Player.start();
			this.ambience4Player.start();
			this.ambience5Player.start();
			this.ambience6Player.start();
		},
		stopAudio: function stopAudio() {
			this.ambience1Player.stop();
			this.ambience2Player.stop();
			this.ambience3Player.stop();
			this.ambience4Player.stop();
			this.ambience5Player.stop();
			this.ambience6Player.stop();
		},

		//SPEECH
		userVoiceToTextFunc: function userVoiceToTextFunc() {
			var _this4 = this;

			this.submitSpeechTxttoVoice = true;
			this.testObjectVUI = this.userVoiceToText;
			console.log(this.testObjectVUI);
			this.sourceSortingVUI();
			setTimeout(function () {
				_this4.submitSpeechTxttoVoice = false;
			}, 250);
		},
		speechFunc: function speechFunc() {
			var _this5 = this;

			if (this.initSpeech === true) {
				this.recognitionAmazon = new webkitSpeechRecognition();
				this.recognizing;
				this.recognitionAmazon.continuous = false;
				this.recognitionAmazon.interimResults = true;

				this.recognitionAmazon.onresult = function (event) {
					for (var i = event.resultIndex; i < event.results.length; ++i) {
						if (event.results[i].isFinal) {
							if (!_this5.isDisableListening) {
								_this5.testObjectVUI += event.results[i][0].transcript;
								console.log('Speech String Command: ' + event.results[i][0].transcript);
								_this5.sourceSortingVUI();
							}
						}
					}
				};
				this.recognitionAmazon.onspeechend = function () {
					console.log('%c Amazon Module SPEECH Ended', 'background: red; color: black');
					// setTimeout(this.sourceSortingVUI, 500);
					_this5.recognizing = false;
					_this5.speechBtnTxt = "Say A Command";
					__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master.volume.setTargetAtTime(0, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.context.currentTime, +0.5);
				};
				this.recognitionAmazon.onspeechstart = function () {
					console.log('%c Amazon Module SPEECH Began', 'background: green; color: white');
					_this5.recognizing = true;
					_this5.speechBtnTxt = "Listening For Command";
					__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master.volume.setTargetAtTime(-10, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.context.currentTime, +1);
				};
				this.recognitionAmazon.onsoundstart = function () {
					console.log('%c Amazon Module LISTENING Began', 'background: green; color: white');
				};
				this.recognitionAmazon.onaudioend = function () {
					console.log('%c Amazon Module LISTENING Ended', 'background: green; color: white');
					// setTimeout(this.sourceSortingVUI, 500);
					_this5.recognizing = false;
					_this5.speechBtnTxt = "Say A Command";
				};
				this.recognitionAmazon.onend = function () {
					console.log('%c Amazon Module SPEECH SESSION ENDED', 'background: green; color: white');
					if (_this5.stopModuleSpeech === false) {
						_this5.recognitionAmazon.start();
					}
				};
				this.recognizing = true;
				//MAKE SURE SPEECH IS NOT RE-ENGAGED
				this.initSpeech = false;
				//GLOBAL VOICE COMMAND IS SET TO TRUE
				this.$store.state.isVoiceControlled = true;
				this.recognitionAmazon.start();
				//IF USER ENGAGES VOICE CONTROL BUT GOES HOME VIA MOUSE BUTTON THIS TRIGGERS MODULE SPEECH DISPOSE
				this.goingHomeNotViaVoiceCommand = true;
				//CONTROLS recognition.onend TO RESTART LISTENING
				this.stopModuleSpeech = false;
				//TURN LISTENING BACK ON
				this.isDisableListening = false;
				//IF BEING VOICE CONTROLLED DON'T PLAY THE NICE, TELL ME WHERE YOU WANT TO GO PROMPT ON WELCOME PAGE
				this.$store.state.doNotAddress = true;
			} else if (this.initSpeech === false) {}
		},
		resetFunc: function resetFunc() {
			this.recognizing = false;
		},
		speechStartStopFunc: function speechStartStopFunc() {
			this.speechStartTopBtnTrigger = !this.speechStartTopBtnTrigger;

			if (this.speechStartTopBtnTrigger === true) {
				this.speechFunc();
			} else if (this.speechStartTopBtnTrigger === false) {
				this.initSpeech = true;
				this.stopModuleSpeech = true;
				this.recognizing = false;
				this.recognitionAmazon.stop();
				this.$store.state.isVoiceControlled = false;
			}
		},
		sourceSortingVUI: function sourceSortingVUI() {
			//FOR VISUAL REFERENCE
			this.userVoiceToText = this.testObjectVUI;

			var source1RegEx = XRegExp.build('(?x) {{source1Name}} | {{label1Name}}', {
				source1Name: XRegExp.build('{{source1Name1}} | {{source1Name2}}', {
					source1Name1: /source\sone/,
					source1Name2: /source\s1/
				}),
				label1Name: XRegExp.build('{{label1Name1}}', {
					label1Name1: /forest\sfloor|floors?/
				})
			}, 'xgi');

			var source2RegEx = XRegExp.build('(?x) {{source2Name}} | {{label2Name}}', {
				source2Name: XRegExp.build('{{source2Name1}} | {{source2Name2}}', {
					source2Name1: /source\stw?o?o/,
					source2Name2: /source\s2/
				}),
				label2Name: XRegExp.build('{{label2Name1}}', {
					label2Name1: /trees?/
				})
			}, 'xgi');

			var source3RegEx = XRegExp.build('(?x) {{source3Name}} | {{label3Name}}', {
				source3Name: XRegExp.build('{{source3Name1}} | {{source3Name2}}', {
					source3Name1: /source\sthree/,
					source3Name2: /source\s3/
				}),
				label3Name: XRegExp.build('{{label3Name1}}', {
					label3Name1: /canopy/
				})
			}, 'xgi');

			var source4RegEx = XRegExp.build('(?x) {{source4Name}} | {{label4Name}}', {
				source4Name: XRegExp.build('{{source4Name1}} | {{source4Name2}}', {
					source4Name1: /source\sfou?re?/,
					source4Name2: /source\s4/
				}),
				label4Name: XRegExp.build('{{label4Name1}} | {{label4Name2}}', {
					label4Name1: /peccary/,
					label4Name2: /pigs?/
				})
			}, 'xgi');

			var source5RegEx = XRegExp.build('(?x) {{source5Name}} | {{label5Name}}', {
				source5Name: XRegExp.build('{{source5Name1}} | {{source5Name2}}', {
					source5Name1: /source\sfive/,
					source5Name2: /source\s5/
				}),
				label5Name: XRegExp.build('{{label5Name1}} | {{label5Name2}}', {
					label5Name1: /storm|monsoon|rain/,
					label5Name2: /thunder/
				})
			}, 'xgi');

			var source6RegEx = XRegExp.build('(?x) {{source6Name}} | {{label6Name}}', {
				source6Name: XRegExp.build('{{source6Name1}} | {{source6Name2}}', {
					source6Name1: /source\ss[ei]x/,
					source6Name2: /source\s6/
				}),
				label6Name: XRegExp.build('{{label6Name1}} | {{label6Name2}}', {
					label6Name1: /frogs?/,
					label6Name2: /ribbits?/
				})
			}, 'xgi');
			//ALL SOUNDS
			var allSoundRegEx = XRegExp.build('(?x) {{allSoundName}}', {
				allSoundName: XRegExp.build('{{allSoundName1}} | {{allSoundName2}}', {
					allSoundName1: /all\ssounds?/,
					allSoundName2: /all\saudios?/
				})
			}, 'xgi');
			//SPEED
			var speedRegEx = XRegExp.build('(?x) {{speedName}}', {
				speedName: XRegExp.build('{{speedName1}} | {{speedName2}}', {
					speedName1: /speeds?/,
					speedName2: /slow|faster/
				})
			}, 'xgi');
			//DELAY
			var delayRegEx = XRegExp.build('(?x) {{delayName}}', {
				delayName: XRegExp.build('{{delayName1}} | {{delayName2}}', {
					delayName1: /delay/,
					delayName2: /lay/
				})
			}, 'xgi');
			//CHORUS
			var chorusRegEx = XRegExp.build('(?x) {{chorusName}}', {
				chorusName: XRegExp.build('{{chorusName1}} | {{chorusName2}}', {
					chorusName1: /chorus?/,
					chorusName2: /course/
				})
			}, 'xgi');
			//FILTER
			var filterRegEx = XRegExp.build('(?x) {{filterName}}', {
				filterName: XRegExp.build('{{filterName1}} | {{filterName2}}', {
					filterName1: /filter/,
					filterName2: /filter/
				})
			}, 'xgi');
			//REVERB
			var reverbRegEx = XRegExp.build('(?x) {{reverbName}}', {
				reverbName: XRegExp.build('{{reverbName1}} | {{reverbName2}}', {
					reverbName1: /verb/,
					reverbName2: /reverb/
				})
			}, 'xgi');
			//SHOW
			var infoRegEx = XRegExp.build('(?x) {{showName}}', {
				showName: XRegExp.build('{{showName1}} | {{showName2}}', {
					showName1: /info/,
					showName2: /information/
				})
			}, 'xgi');
			// console.log(infoRegEx);
			//HIDE
			var listRegEx = XRegExp.build('(?x) {{hideName}}', {
				hideName: XRegExp.build('{{hideName1}} | {{hideName2}}', {
					hideName1: /lists?/,
					hideName2: /menu/
				})
			}, 'xgi');
			// console.log(listRegEx);			

			var source1Boolean = source1RegEx.test(this.testObjectVUI);
			var source2Boolean = source2RegEx.test(this.testObjectVUI);
			var source3Boolean = source3RegEx.test(this.testObjectVUI);
			var source4Boolean = source4RegEx.test(this.testObjectVUI);
			var source5Boolean = source5RegEx.test(this.testObjectVUI);
			var source6Boolean = source6RegEx.test(this.testObjectVUI);
			var allSoundBoolean = allSoundRegEx.test(this.testObjectVUI);
			var speedBoolean = speedRegEx.test(this.testObjectVUI);
			var delayBoolean = delayRegEx.test(this.testObjectVUI);
			var chorusBoolean = chorusRegEx.test(this.testObjectVUI);
			var filterBoolean = filterRegEx.test(this.testObjectVUI);
			var reverbBoolean = reverbRegEx.test(this.testObjectVUI);
			var infoBoolean = infoRegEx.test(this.testObjectVUI);
			var listBoolean = listRegEx.test(this.testObjectVUI);

			if (source1Boolean) {
				this.source1VUI();
			} else if (source2Boolean) {
				this.source2VUI();
			} else if (source3Boolean) {
				this.source3VUI();
			} else if (source4Boolean) {
				this.source4VUI();
			} else if (source5Boolean) {
				this.source5VUI();
			} else if (source6Boolean) {
				this.source6VUI();
			} else if (allSoundBoolean) {
				this.allSoundVUI();
			} else if (speedBoolean) {
				this.speedVUI();
			} else if (delayBoolean) {
				this.delayVUI();
			} else if (chorusBoolean) {
				this.chorusVUI();
			} else if (filterBoolean) {
				this.filterVUI();
			} else if (reverbBoolean) {
				this.reverbVUI();
			} else if (infoBoolean) {
				this.infoVUI();
			} else if (listBoolean) {
				this.listVUI();
			} else {
				this.miscVUI();
			}
		},
		source1VUI: function source1VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience1Player.start();
				this.ambience1Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience1Player.stop();
				this.ambience1Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience1Vol < 0) {
						this.ambience1Vol += 12;
					}
				} else {
					if (this.ambience1Vol < 0) {
						this.ambience1Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience1Vol > -30) {
						this.ambience1Vol -= 12;
					}
				} else {
					if (this.ambience1Vol > -30) {
						this.ambience1Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		source2VUI: function source2VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience2Player.start();
				this.ambience2Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience2Player.stop();
				this.ambience2Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience2Vol < 0) {
						this.ambience2Vol += 12;
					}
				} else {
					if (this.ambience2Vol < 0) {
						this.ambience2Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience2Vol > -30) {
						this.ambience2Vol -= 12;
					}
				} else {
					if (this.ambience2Vol > -30) {
						this.ambience2Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		source3VUI: function source3VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience3Player.start();
				this.ambience3Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience3Player.stop();
				this.ambience3Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience3Vol < 0) {
						this.ambience3Vol += 12;
					}
				} else {
					if (this.ambience3Vol < 0) {
						this.ambience3Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience3Vol > -30) {
						this.ambience3Vol -= 12;
					}
				} else {
					if (this.ambience3Vol > -30) {
						this.ambience3Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		source4VUI: function source4VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience4Player.start();
				this.ambience4Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience4Player.stop();
				this.ambience4Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience4Vol < 0) {
						this.ambience4Vol += 12;
					}
				} else {
					if (this.ambience4Vol < 0) {
						this.ambience4Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience4Vol > -30) {
						this.ambience4Vol -= 12;
					}
				} else {
					if (this.ambience4Vol > -30) {
						this.ambience4Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		source5VUI: function source5VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience5Player.start();
				this.ambience5Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience5Player.stop();
				this.ambience5Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience5Vol < 0) {
						this.ambience5Vol += 12;
					}
				} else {
					if (this.ambience5Vol < 0) {
						this.ambience5Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience5Vol > -30) {
						this.ambience5Vol -= 12;
					}
				} else {
					if (this.ambience5Vol > -30) {
						this.ambience5Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		source6VUI: function source6VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience6Player.start();
				this.ambience6Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience6Player.stop();
				this.ambience6Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience6Vol < 0) {
						this.ambience6Vol += 12;
					}
				} else {
					if (this.ambience6Vol < 0) {
						this.ambience6Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience6Vol > -30) {
						this.ambience6Vol -= 12;
					}
				} else {
					if (this.ambience6Vol > -30) {
						this.ambience6Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		allSoundVUI: function allSoundVUI() {
			//STOP ALL 
			if (RegExp(/stop/gi).test(this.testObjectVUI)) {
				this.ambience1Player.stop();
				this.ambience1Boolean = false;
				this.ambience2Player.stop();
				this.ambience2Boolean = false;
				this.ambience3Player.stop();
				this.ambience3Boolean = false;
				this.ambience4Player.stop();
				this.ambience4Boolean = false;
				this.ambience5Player.stop();
				this.ambience5Boolean = false;
				this.ambience6Player.stop();
				this.ambience6Boolean = false;
				if (this.didWeAdventure) {
					this.exploreSound1.stop();
					this.isExploreFuncRunning = false;
				}
			} else if (RegExp(/play/gi).test(this.testObjectVUI)) {
				this.ambience1Player.start();
				this.ambience1Boolean = true;
				this.ambience2Player.start();
				this.ambience2Boolean = true;
				this.ambience3Player.start();
				this.ambience3Boolean = true;
				this.ambience4Player.start();
				this.ambience4Boolean = true;
				this.ambience5Player.start();
				this.ambience5Boolean = true;
				this.ambience6Player.start();
				this.ambience6Boolean = true;
			}
			this.testObjectVUI = "";
		},
		speedVUI: function speedVUI() {
			if (RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI)) {
				this.speedToggle = true;
			} else if (RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI)) {
				this.speedToggle = false;
			}
			if (RegExp(/\bfaste?r?\b|up/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.playBackSpeed <= 1.6) {
						this.playBackSpeed += 0.4;
					}
				} else {
					if (this.playBackSpeed <= 1.8) {
						this.playBackSpeed += 0.2;
					}
				}
			} else if (RegExp(/slowe?r?|down/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.playBackSpeed >= 0.5) {
						this.playBackSpeed -= 0.4;
					}
				} else {
					if (this.playBackSpeed >= 0.2) {
						this.playBackSpeed -= 0.2;
					}
				}
			}
			this.testObjectVUI = "";
		},
		delayVUI: function delayVUI() {
			if (RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI)) {
				this.fxDelayToggle = true;
			} else if (RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI)) {
				this.fxDelayToggle = false;
			}
			if (RegExp(/\bmore\b|\bup\b|loude?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxDelayAmt <= 80) {
						this.fxDelayAmt += 10;
					}
				} else {
					if (this.fxDelayAmt <= 95) {
						this.fxDelayAmt += 5;
					}
				}
			} else if (RegExp(/less|\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxDelayAmt >= 20) {
						this.fxDelayAmt -= 10;
					} else if (this.fxDelayAmt >= 5) {
						this.fxDelayAmt -= 5;
					}
				} else {
					if (this.fxDelayAmt >= 5) {
						this.fxDelayAmt -= 5;
					} else if (this.fxDelayAmt >= 15) {
						this.fxDelayAmt -= 2;
					}
				}
			}
			this.testObjectVUI = "";
		},
		chorusVUI: function chorusVUI() {
			if (RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI)) {
				this.fxChorusToggle = true;
			} else if (RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI)) {
				this.fxChorusToggle = false;
			}
			if (RegExp(/\bmore\b|\bup\b|loude?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxChorusAmt <= 80) {
						this.fxChorusAmt += 10;
					}
				} else {
					if (this.fxChorusAmt <= 95) {
						this.fxChorusAmt += 5;
					}
				}
			} else if (RegExp(/less|\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxChorusAmt >= 20) {
						this.fxChorusAmt -= 10;
					} else if (this.fxChorusAmt >= 5) {
						this.fxChorusAmt -= 5;
					}
				} else {
					if (this.fxChorusAmt >= 5) {
						this.fxChorusAmt -= 5;
					} else if (this.fxChorusAmt >= 15) {
						this.fxChorusAmt -= 2;
					}
				}
			}
			this.testObjectVUI = "";
		},
		reverbVUI: function reverbVUI() {
			if (RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI)) {
				this.fxConvolverToggle = true;
			} else if (RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI)) {
				this.fxConvolverToggle = false;
			}
			if (RegExp(/\bmore\b|\bup\b|loude?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxConvolverAmt <= 45) {
						this.fxConvolverAmt += 5;
					}
				} else {
					if (this.fxConvolverAmt <= 48) {
						this.fxConvolverAmt += 2;
					}
				}
			} else if (RegExp(/less|\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxConvolverAmt >= 10) {
						this.fxConvolverAmt -= 5;
					} else if (this.fxConvolverAmt >= 2) {
						this.fxConvolverAmt -= 1;
					}
				} else {
					if (this.fxConvolverAmt >= 10) {
						this.fxConvolverAmt -= 2;
					} else if (this.fxConvolverAmt >= 2) {
						this.fxConvolverAmt -= 1;
					}
				}
			}
			this.testObjectVUI = "";
		},
		filterVUI: function filterVUI() {
			if (RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI)) {
				this.fxFilterToggle = true;
			} else if (RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI)) {
				this.fxFilterToggle = false;
			}
			if (RegExp(/\bmore\b|\blower\b/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxAutoFilterAmt > 1500) {
						this.fxAutoFilterAmt -= 1500;
					} else if (this.fxAutoFilterAmt >= 300) {
						this.fxAutoFilterAmt -= 200;
					}
				} else {
					if (this.fxAutoFilterAmt >= 500) {
						this.fxAutoFilterAmt -= 250;
					} else if (this.fxAutoFilterAmt >= 100) {
						this.fxAutoFilterAmt -= 100;
					}
				}
			} else if (RegExp(/less|higher|hire/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxAutoFilterAmt <= 10000) {
						this.fxAutoFilterAmt += 1500;
					} else if (this.fxAutoFilterAmt <= 1000) {
						this.fxAutoFilterAmt += 200;
					}
				} else {
					if (this.fxAutoFilterAmt <= 10000) {
						this.fxAutoFilterAmt += 250;
					} else if (this.fxAutoFilterAmt <= 1000) {
						this.fxAutoFilterAmt += 100;
					}
				}
			}
			this.testObjectVUI = "";
		},
		infoVUI: function infoVUI() {
			var _this6 = this;

			if (RegExp(/show|display/gi).test(this.testObjectVUI)) {
				this.showHelpOverlay = true;
				setTimeout(function () {
					_this6.showNavBar = false;
					if (_this6.$store.state.allowSpeechControl) {
						_this6.showSpeechBtns = false;
					}
				}, 0);
				setTimeout(function () {
					_this6.showAllControls = false;
				}, 500);
				setTimeout(function () {
					_this6.showAboutPage = true;
				}, 1500);
				console.log('SHOW INFO');
			} else if (RegExp(/hide|minimize/gi).test(this.testObjectVUI)) {
				this.showHelpOverlay = false;
				this.showAboutPage = false;
				setTimeout(function () {
					_this6.showAllControls = true;
				}, 800);
				setTimeout(function () {
					_this6.showNavBar = true;
					if (_this6.$store.state.allowSpeechControl) {
						_this6.showSpeechBtns = true;
					}
				}, 850);
				console.log('HIDE INFO');
			}
			this.testObjectVUI = "";
			setTimeout(function () {
				_this6.userVoiceToText = "";
			}, 3000);
		},
		listVUI: function listVUI() {
			var _this7 = this;

			if (RegExp(/show|display/gi).test(this.testObjectVUI)) {
				this.showVoiceCommandList = true;
				setTimeout(function () {
					document.getElementById('voiceControlListTxt').scrollIntoView({ behavior: "smooth" });
				}, 250);
				console.log('SHOW LIST');
			} else if (RegExp(/hide|minimize/gi).test(this.testObjectVUI)) {
				this.showVoiceCommandList = false;
				setTimeout(function () {
					document.getElementById('controlsContainer').scrollIntoView({ behavior: "smooth" });
				}, 250);
				console.log('HIDE LIST');
			}
			this.testObjectVUI = "";
			setTimeout(function () {
				_this7.userVoiceToText = "";
			}, 3000);
		},
		miscVUI: function miscVUI() {
			//RANDOMIZE
			if (RegExp(/new\s?scenes?|randomi?z?e?|shift\s?soundscapes?/gi).test(this.testObjectVUI)) {
				this.mattChillMethod();
				//EXPLORE
			} else if (RegExp(/\bexplorer?\b|\badventure\b/gi).test(this.testObjectVUI)) {
				if (RegExp(/stop/gi).test(this.testObjectVUI)) {
					this.stopExplore();
				} else {
					this.exploreFunc();
				}
				//STOP VOICE COMMANDS & GO HOME FUNCTIONS
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) && RegExp(/voice\s?controls?/gi).test(this.testObjectVUI) || RegExp(/stop/gi).test(this.testObjectVUI) && RegExp(/voice\s?commands?/gi).test(this.testObjectVUI)) {
				//DISABLES LISTENING IMMEDITATLY
				this.initSpeech = true;
				this.stopModuleSpeech = true;
				this.recognizing = false;
				this.recognitionAmazon.stop();
				this.$store.state.isVoiceControlled = false;
			} else if (RegExp(/home/gi).test(this.testObjectVUI)) {
				this.goingHomeNotViaVoiceCommand = false;
				this.stopModuleSpeech = true;
				this.recognitionAmazon.abort();
				this.recognitionAmazon = undefined;
				setTimeout(this.goHome, 50);
			}
			this.testObjectVUI = "";
		},
		voiceCommandListFunc: function voiceCommandListFunc() {
			this.showVoiceCommandList = !this.showVoiceCommandList;
			if (this.showVoiceCommandList) {
				setTimeout(function () {
					document.getElementById('voiceControlListTxt').scrollIntoView({ behavior: "smooth" });
				}, 250);
			} else if (!this.showVoiceCommandList) {
				document.getElementById('controlsContainer').scrollIntoView({ behavior: "smooth" });
			}
		},

		//ENTER FUNC
		exploreBtnFunc: function exploreBtnFunc() {
			this.exploreBtnBoolean = !this.exploreBtnBoolean;
			if (this.exploreBtnBoolean) {
				this.exploreFunc();
			} else if (!this.exploreBtnBoolean) {
				this.stopExplore();
			}
		},
		enterFunc: function enterFunc() {
			var _this8 = this;

			if (this.startAudioBoolean) {
				this.startAudio();
				this.startAudioBoolean = false;
			}

			this.showEnterBtn = false;

			setTimeout(function () {
				_this8.showEnterContainer = false;
			}, 1000);

			this.amazonFX.start();

			var changeTiming = 50;

			setTimeout(function () {
				_this8.plungeDepth = 1;
			}, changeTiming * 2);

			setTimeout(function () {
				_this8.plungeDepth = 2;
			}, changeTiming * 3);

			setTimeout(function () {
				_this8.plungeDepth = 3;
			}, changeTiming * 4);

			setTimeout(function () {
				_this8.plungeDepth = 4;
			}, changeTiming * 5);

			setTimeout(function () {
				_this8.plungeDepth = 5;
			}, changeTiming * 8.5);

			setTimeout(function () {
				_this8.plungeDepth = 6;
			}, changeTiming * 9);

			setTimeout(function () {
				_this8.plungeDepth = 7;
			}, changeTiming * 9.5);

			setTimeout(function () {
				_this8.plungeDepth = 8;
			}, changeTiming * 10);

			setTimeout(function () {
				_this8.plungeDepth = 9;
			}, changeTiming * 10.5);

			setTimeout(function () {
				_this8.plungeDepth = 10;
			}, changeTiming * 11);

			setTimeout(function () {
				if (_this8.userMobile === false) {
					_this8.activeSun = true;
				}
			}, 600);

			setTimeout(function () {
				_this8.showAllControls = true;
			}, 1000);

			setTimeout(function () {
				_this8.showNavBar = true;
			}, 1200);

			setTimeout(function () {
				_this8.showMicRecording = true;
			}, 1000);

			setTimeout(function () {
				_this8.showSpeechBtns = true;
			}, 1100);

			setTimeout(function () {
				// this.ambience1Player.start();
				_this8.ambience1Boolean = true;

				// this.ambience2Player.start();
				_this8.ambience2Boolean = true;
			}, 1700);

			setTimeout(function () {
				_this8.ambience1Vol = -38;
				_this8.ambience2Vol = -38;
			}, 1100);

			setTimeout(function () {
				_this8.ambience1Vol = -36;
				_this8.ambience2Vol = -36;
			}, 1200);

			setTimeout(function () {
				_this8.ambience1Vol = -34;
				_this8.ambience2Vol = -34;
			}, 1300);

			setTimeout(function () {
				_this8.ambience1Vol = -32;
				_this8.ambience2Vol = -32;
			}, 1400);

			setTimeout(function () {
				_this8.ambience1Vol = -30;
				_this8.ambience2Vol = -30;
			}, 1490);

			setTimeout(function () {
				_this8.ambience1Vol = -24;
				_this8.ambience2Vol = -24;
			}, 1550);

			setTimeout(function () {
				_this8.ambience1Vol = -22;
				_this8.ambience2Vol = -22;
			}, 1600);

			setTimeout(function () {
				_this8.ambience1Vol = -20;
				_this8.ambience2Vol = -20;
			}, 1650);

			setTimeout(function () {
				_this8.ambience1Vol = -17;
				_this8.ambience2Vol = -17;
			}, 1700);

			setTimeout(function () {
				_this8.ambience1Vol = -12;
				_this8.ambience2Vol = -8;
			}, 1750);
		},

		//RANDOMIZE (MATT CHILL) PRESET
		mattChillMethod: function mattChillMethod() {

			if (this.didWeAdventure) {
				this.stopExplore();
			}

			if (this.randomizeBoolean === false) {
				this.randomizeBoolean = true;
			}

			this.mattChill = !this.mattChill;

			this.ambience1Vol = Math.floor(Math.random() * 30 - 30);
			this.ambience2Vol = Math.floor(Math.random() * 30 - 30);
			this.ambience3Vol = Math.floor(Math.random() * 30 - 30);
			this.ambience4Vol = Math.floor(Math.random() * 20 - 20);
			this.ambience5Vol = Math.floor(Math.random() * 30 - 30);
			this.ambience6Vol = Math.floor(Math.random() * 30 - 30);

			// let fx1boolean 		= Math.random() >= 0.5,
			// 	fx2boolean 		= Math.random() >= 0.5,
			// 	fx3boolean 		= Math.random() >= 0.5,
			// 	fx4boolean 		= Math.random() >= 0.5,
			// 	fx5boolean 		= Math.random() >= 0.5;

			var amb1boolean = Math.random() >= 0.5,
			    amb2boolean = Math.random() >= 0.5,
			    amb3boolean = Math.random() >= 0.65,
			    amb4boolean = Math.random() >= 0.80,
			    amb5boolean = Math.random() >= 0.4,
			    amb6boolean = Math.random() >= 0.5;

			// if (this.mattChill === true){
			//DON'T CALCULATE ON MOBILE
			if (this.userMobile === false) {
				var
				// randomVerb 		= Math.floor((Math.random() * 40) + 0),
				randomDelay = Math.floor(Math.random() * 15 + 0),
				    randomChorus = Math.floor(Math.random() * 10 + 0),
				    randomFilter = Math.floor(Math.random() * 10000 + 2500);

				// this.fxConvolverAmt 	= randomVerb;
				this.fxDelayAmt = randomDelay;
				this.fxChorusAmt = randomChorus;
				this.fxAutoFilterAmt = randomFilter;

				this.fxDecay = Math.random() * 10 + 1.5;
				var fxPreDelay = Math.random() * 0.1 + 0.03;
				this.fxConvolver.decay = this.fxDecay;
				this.fxConvolver.preDelay = fxPreDelay;
				this.fxConvolver.generate();
			}
			//CALCULATE ON MOBILE & DESKTOP
			var randomSpeed = Math.random() * (1.10 - 0.9) + 0.9;
			this.playBackSpeed = randomSpeed;

			if (amb1boolean === true) {
				this.ambience1Boolean = true;
				this.showFlask1 = true;
			} else {
				this.ambience1Boolean = false;
				this.showFlask1 = false;
			}

			if (amb2boolean === true) {
				this.ambience2Boolean = true;
				this.showFlask2 = true;
			} else {
				this.ambience2Boolean = false;
				this.showFlask2 = false;
			}

			if (amb3boolean === true) {
				this.ambience3Boolean = true;
				this.showFlask3 = true;

				this.ambience1Vol = Math.floor(Math.random() * 1 - 20);
				this.ambience2Vol = Math.floor(Math.random() * 1 - 20);
				this.ambience3Vol = Math.floor(Math.random() * 5 - 10);
				this.ambience4Vol = Math.floor(Math.random() * 1 - 20);
			} else {
				this.ambience3Boolean = false;
				this.showFlask3 = false;
			}

			if (amb4boolean === true) {
				this.ambience4Boolean = true;
				this.showFlask4 = true;
			} else {
				this.ambience4Boolean = false;
				this.showFlask4 = false;
			}

			if (amb5boolean === true) {
				this.ambience5Boolean = true;
				this.showFlask5 = true;
			} else {
				this.ambience5Boolean = false;
				this.showFlask5 = false;
			}

			if (amb6boolean === true) {
				this.ambience6Boolean = true;
				this.showFlask6 = true;
			} else {
				this.ambience6Boolean = false;
				this.showFlask6 = false;
			}

			if (amb1boolean === false && amb2boolean === false && amb3boolean === false && amb4boolean === false && amb5boolean === false && amb6boolean === false) {
				this.ambience6Boolean = true;
				this.showFlask6 = true;
			}

			// } else if (this.mattChill === false){
			// this.fxDelayToggle = false;
			// this.fxConvolverToggle = false;
			// this.fxChorusToggle = false;
			// this.fxFilterToggle = false;
			// this.speedToggle = false;
			// } 
		}
	}, _defineProperty(_methods, 'exploreBtnFunc', function exploreBtnFunc() {
		this.exploreBtnBoolean = !this.exploreBtnBoolean;
		if (this.exploreBtnBoolean) {
			this.exploreFunc();
		} else if (!this.exploreBtnBoolean) {
			this.stopExplore();
		}
	}), _defineProperty(_methods, 'exploreFunc', function exploreFunc() {
		var _this9 = this;

		//AUDIO MIXING FUNCTION
		var int = 1250;
		var runExplore = function runExplore() {
			_this9.exploreSound1.start();
			_this9.exploreTxt = "Exploring";
			_this9.exploreTimeout1 = setTimeout(function () {
				_this9.ambience1Vol = -10;
				_this9.ambience4Vol = -25;
				_this9.ambience6Vol = -30;
			}, int * 1);
			_this9.exploreTimeout2 = setTimeout(function () {
				_this9.ambience1Vol = -12;
				_this9.ambience4Vol = -23;
				_this9.ambience6Vol = -28;
			}, int * 2);
			_this9.exploreTimeout3 = setTimeout(function () {
				_this9.ambience1Vol = -12;
				_this9.ambience4Vol = -20;
				_this9.ambience6Vol = -26;
			}, int * 3);
			_this9.exploreTimeout4 = setTimeout(function () {
				_this9.ambience1Vol = -12;
				_this9.ambience4Vol = -18;
				_this9.ambience6Vol = -24;
			}, int * 4);
			_this9.exploreTimeout5 = setTimeout(function () {
				_this9.ambience1Vol = -14;
				_this9.ambience4Vol = -20;
				_this9.ambience6Vol = -22;
			}, int * 5);
			_this9.exploreTimeout6 = setTimeout(function () {
				_this9.ambience1Vol = -16;
				_this9.ambience4Vol = -14;
				_this9.ambience6Vol = -20;
			}, int * 6);
			_this9.exploreTimeout7 = setTimeout(function () {
				_this9.ambience1Vol = -18;
				_this9.ambience4Vol = -15;
				_this9.ambience6Vol = -18;
			}, int * 7);
			_this9.exploreTimeout8 = setTimeout(function () {
				_this9.ambience1Vol = -20;
				_this9.ambience4Vol = -15;
				_this9.ambience6Vol = -13;
			}, int * 8);
			_this9.exploreTimeout9 = setTimeout(function () {
				_this9.ambience1Vol = -22;
				_this9.ambience4Vol = -15;
				_this9.ambience6Vol = -12;
			}, int * 9);
			_this9.exploreTimeout10 = setTimeout(function () {
				_this9.ambience1Vol = -24;
				_this9.ambience4Vol = -18;
				_this9.ambience6Vol = -8;
			}, int * 10);
			_this9.exploreTimeout11 = setTimeout(function () {
				_this9.ambience1Vol = -26;
				_this9.ambience4Vol = -20;
				_this9.ambience6Vol = -4;
			}, int * 11);
			_this9.exploreTimeout12 = setTimeout(function () {
				_this9.ambience1Vol = -30;
				_this9.ambience1Player.stop();
				_this9.ambience1Boolean = false;
				_this9.ambience4Vol = -24;
				_this9.ambience4Player.stop();
				_this9.ambience4Boolean = false;
				_this9.ambience6Vol = -2;
			}, int * 12);
			_this9.exploreTimeout13 = setTimeout(function () {
				_this9.ambience6Vol = 0;
			}, int * 13);
			_this9.exploreTimeout14 = setTimeout(function () {
				_this9.ambience6Vol = 2;
				_this9.isExploreFuncRunning = false;
			}, int * 14);
		};
		if (this.isExploreFuncRunning === false) {
			this.isExploreFuncRunning = true;
			//INIT EXPORE SCENE
			//GENERATE REVERB
			if (!this.userMobile) {
				this.fxDecay = 4.5;
				this.fxConvolver.decay = this.fxDecay;
				this.fxConvolver.preDelay = 0.4;
				this.fxConvolver.generate();
			}

			this.ambience1Boolean = true;
			this.ambience1Vol = -10;

			this.ambience2Boolean = false;
			this.ambience2Vol = -30;

			this.ambience3Boolean = false;
			this.ambience3Vol = -30;

			this.ambience4Boolean = true;
			this.ambience4Vol = -30;

			this.ambience5Boolean = false;
			this.ambience5Vol = -30;

			this.ambience6Boolean = true;
			this.ambience6Vol = -30;

			if (!this.didWeAdventure) {
				this.exploreSound1 = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
					"playbackRate": 1,
					"loop": false,
					"volume": 0
				}).connect(this.masterVolumeSub);
				//LOADING FOR BROWSER TYPE
				if (this.isChrome === true || this.isOpera === true || this.isFirefox === true || this.isBlink === true) {

					this.exploreSound1.load("../src/assets/sounds/modules/amazon/hiogg/exporeSound1Amazon.ogg", function () {
						runExplore();
					});
				} else if (this.AndroidMobile === true) {
					this.exploreSound1.load("../src/assets/sounds/modules/amazon/lowogg/exporeSound1Amazon.ogg", function () {
						runExplore();
					});
				} else if (this.isSafari === true || this.isEdge === true || this.isIE === true) {
					this.exploreSound1.load("../src/assets/sounds/modules/amazon/320/exporeSound1Amazon.m4a", function () {
						runExplore();
					});
				} else if (this.iOS === true) {
					this.exploreSound1.load("../src/assets/sounds/modules/amazon/192/exporeSound1Amazon.m4a", function () {
						runExplore();
					});
				}
				//CLEANS UP AND DISPOSES THESE PLAYERS WHEN GOING HOME
				this.didWeAdventure = true;
			} else if (this.didWeAdventure) {
				runExplore();
			}
		} else {}
	}), _defineProperty(_methods, 'stopExplore', function stopExplore() {
		this.exploreTxt = "Explore!";
		this.exploreSound1.stop();
		this.isExploreFuncRunning = false;
		clearInterval(this.exploreTimeout1);
		clearInterval(this.exploreTimeout2);
		clearInterval(this.exploreTimeout3);
		clearInterval(this.exploreTimeout4);
		clearInterval(this.exploreTimeout5);
		clearInterval(this.exploreTimeout6);
		clearInterval(this.exploreTimeout7);
		clearInterval(this.exploreTimeout8);
		clearInterval(this.exploreTimeout9);
		clearInterval(this.exploreTimeout10);
		clearInterval(this.exploreTimeout11);
		clearInterval(this.exploreTimeout12);
		clearInterval(this.exploreTimeout13);
		clearInterval(this.exploreTimeout14);
	}), _defineProperty(_methods, 'masterMetering', function masterMetering() {
		this.masterLevel = this.masterMeter.getLevel();
	}), _defineProperty(_methods, 'goToHelp', function goToHelp() {
		var _this10 = this;

		this.showHelpOverlay = !this.showHelpOverlay;
		this.helpTrigger = !this.helpTrigger;

		if (this.showHelpOverlay === true) {

			setTimeout(function () {
				_this10.showNavBar = false;
				if (_this10.$store.state.allowSpeechControl) {
					_this10.showSpeechBtns = false;
				}
			}, 100);

			setTimeout(function () {
				_this10.showAllControls = false;
			}, 250);

			setTimeout(function () {
				_this10.showAboutPage = true;
			}, 1000);
		} else if (this.showHelpOverlay === false) {

			this.showAboutPage = false;

			setTimeout(function () {
				_this10.showAllControls = true;
			}, 800);

			setTimeout(function () {
				_this10.showNavBar = true;
				if (_this10.$store.state.allowSpeechControl) {
					_this10.showSpeechBtns = true;
				}
			}, 850);
		}
	}), _defineProperty(_methods, 'ogScreenSize', function ogScreenSize() {
		this.ogWidth = window.innerWidth;
	}), _defineProperty(_methods, 'screenSizing', function screenSizing() {
		this.screenHeight = window.innerHeight;
		this.screenWidth = window.innerWidth;

		var currentWidth = window.innerWidth;

		if (currentWidth === this.ogWidth) {} else if (currentWidth != this.ogWidth) {
			this.sliderRangeSet();
			// this.mobileCheck();
			this.ogWidth = currentWidth;
		}
	}), _defineProperty(_methods, 'bufferLoading', function bufferLoading() {
		var _this11 = this;

		// Tone.Buffer.on('progress', ()=>{
		// });
		__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Buffer.on('load', function () {
			//HIDE LOADING ITEMS
			_this11.showLoading = false;
			//SHOW ENTER BUTTON
			setTimeout(function () {
				_this11.showEnterBtn = true;
			}, 1000);
			//AUTO OPEN MODULE IF VOICE CONTROLLED & DO NOT REPLAY WHEN EXPLORE AUDIO LOADS 
			//ADDITIONALLY DO NOT REPLAY IF USER MIC HAS BEEN ACTIVATED FOR RECORDING
			if (_this11.isVoiceControl) {
				if (!_this11.didWeAdventure) {
					setTimeout(_this11.enterFunc, 2000);
				}
			}
			//IF VOICE CONTROL IS ACTIVE GLOBALLY ACTIVATE IN THIS MODULE
			if (_this11.isVoiceControl === true) {
				_this11.speechFunc();
			}
		});
	}), _defineProperty(_methods, 'audioRouting', function audioRouting() {
		if (this.isChrome === true || this.AndroidMobile === true || this.isOpera === true || this.isFirefox === true || this.isBlink === true) {
			if (this.userMobile === false) {

				this.fxConvolver = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Reverb({
					"decay": 1.5,
					"preDelay": 0.01
				});
				this.fxConvolver.decay = 2.5;
				this.fxConvolver.generate();
				this.fxAutoFilter = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Filter({
					"type": "lowpass",
					"frequency": 20000,
					"rolloff": -24,
					"Q": 1,
					"gain": 0
				});
				this.fxDelay = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.PingPongDelay(0.5, 0.35);
				this.fxChorus = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Chorus({
					"frequency": 3.5,
					"delayTime": 10,
					"depth": 0.85,
					"type": "sine",
					"spread": 180
				});
				this.masterMeter = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Meter({
					"smoothing": .4
				});
				this.ambience1Player.connect(this.masterVolumeSub);
				this.ambience2Player.connect(this.masterVolumeSub);
				this.ambience3Player.connect(this.masterVolumeSub);
				this.ambience4Player.connect(this.masterVolumeSub);
				this.ambience5Player.connect(this.masterVolumeSub);
				this.ambience6Player.connect(this.masterVolumeSub);

				this.masterVolumeSub.chain(this.fxAutoFilter, this.fxConvolver, this.fxDelay, this.fxChorus, this.masterMeter, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master);
				console.log('Chrome/Opera/FireFox Desktop');
				setInterval(this.masterMetering, 60);
			} else if (this.userMobile === true) {
				this.ambience1Player.connect(this.masterVolumeSub);
				this.ambience2Player.connect(this.masterVolumeSub);
				this.ambience3Player.connect(this.masterVolumeSub);
				this.ambience4Player.connect(this.masterVolumeSub);
				this.ambience5Player.connect(this.masterVolumeSub);
				this.ambience6Player.connect(this.masterVolumeSub);

				this.masterVolumeSub.connect(__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master);

				console.log('Chrome/Opera/FireFox Mobile');
			}
		} else if (this.isSafari === true || this.iOS === true || this.isEdge === true || this.isIE === true) {
			if (this.userMobile === false) {
				this.fxConvolver = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Reverb({
					"decay": 1.5,
					"preDelay": 0.01
				});
				this.fxConvolver.decay = 2.5;
				this.fxConvolver.generate();
				this.fxAutoFilter = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Filter({
					"type": "lowpass",
					"frequency": 20000,
					"rolloff": -24,
					"Q": 1,
					"gain": 0
				});
				this.fxDelay = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.PingPongDelay(0.5, 0.35);
				this.fxChorus = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Chorus({
					"frequency": 3.5,
					"delayTime": 10,
					"depth": 0.85,
					"type": "sine",
					"spread": 180
				});
				this.masterMeter = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Meter({
					"smoothing": .4
				});
				this.ambience1Player.connect(this.masterVolumeSub);
				this.ambience2Player.connect(this.masterVolumeSub);
				this.ambience3Player.connect(this.masterVolumeSub);
				this.ambience4Player.connect(this.masterVolumeSub);
				this.ambience5Player.connect(this.masterVolumeSub);
				this.ambience6Player.connect(this.masterVolumeSub);

				this.masterVolumeSub.chain(this.fxAutoFilter, this.fxConvolver, this.fxDelay, this.fxChorus, this.masterMeter, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master);
				console.log('Safari/Edge/iOS Desktop');
				setInterval(this.masterMetering, 60);
			} else if (this.userMobile === true) {
				this.ambience1Player.connect(this.masterVolumeSub);
				this.ambience2Player.connect(this.masterVolumeSub);
				this.ambience3Player.connect(this.masterVolumeSub);
				this.ambience4Player.connect(this.masterVolumeSub);
				this.ambience5Player.connect(this.masterVolumeSub);
				this.ambience6Player.connect(this.masterVolumeSub);

				this.masterVolumeSub.connect(__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master);
				console.log('Safari/Edge/iOS Mobile');
			}
		} else {}
	}), _defineProperty(_methods, 'firstAudioLoadFunc', function firstAudioLoadFunc() {
		var _this12 = this;

		// this.changeFX.load("../src/assets/sounds/blinks/change.wav", 
		// 	()=>{
		// 	this.whatIsLoading = "Fauna";
		// });

		// this.amazonFX.load("../src/assets/sounds/modules/amazon/amazonFX.wav", 
		// 	()=>{
		// 	this.whatIsLoading = "RainAmazon";
		// });

		// this.ambience1Player.load("../src/assets/sounds/modules/amazon/insects.wav", 
		// 	()=>{
		// 	this.whatIsLoading = "Insects";
		// });

		// this.ambience2Player.load("../src/assets/sounds/modules/amazon/lightbed.wav", 
		// 	()=>{
		// 	this.whatIsLoading = "Soil";
		// });

		// this.ambience3Player.load("../src/assets/sounds/modules/amazon/heavybed.wav", 
		// 	()=>{
		// 	this.whatIsLoading = "Canopy";
		// });

		// this.ambience4Player.load("../src/assets/sounds/modules/amazon/peccary.wav", 
		// 	()=>{
		// 	this.whatIsLoading = "Peccary";
		// });

		// this.ambience5Player.load("../src/assets/sounds/modules/amazon/monsoon.wav", 
		// 	()=>{
		// 	this.whatIsLoading = "Monsoon";
		// });

		// this.ambience6Player.load("../src/assets/sounds/modules/amazon/frogs.wav", 
		// 	()=>{
		// 	this.whatIsLoading = "Frogs";
		// });

		if (this.isChrome === true || this.isOpera === true || this.isFirefox === true || this.isBlink === true) {

			this.changeFX.load("../src/assets/sounds/blinks/change.ogg", function () {
				_this12.whatIsLoading = "Fauna";
			});

			this.amazonFX.load("../src/assets/sounds/modules/amazon/hiogg/amazonFX.ogg", function () {
				_this12.whatIsLoading = "Critters";
			});

			this.ambience1Player.load("../src/assets/sounds/modules/amazon/hiogg/insects.ogg", function () {
				_this12.whatIsLoading = "Insects";
			});

			this.ambience2Player.load("../src/assets/sounds/modules/amazon/hiogg/lightbed.ogg", function () {
				_this12.whatIsLoading = "Soil";
			});

			this.ambience3Player.load("../src/assets/sounds/modules/amazon/hiogg/heavybed.ogg", function () {
				_this12.whatIsLoading = "Canopy";
			});

			this.ambience4Player.load("../src/assets/sounds/modules/amazon/hiogg/peccary.ogg", function () {
				_this12.whatIsLoading = "Peccary";
			});

			this.ambience5Player.load("../src/assets/sounds/modules/amazon/hiogg/monsoon.ogg", function () {
				_this12.whatIsLoading = "Monsoon";
			});

			this.ambience6Player.load("../src/assets/sounds/modules/amazon/hiogg/frogs.ogg", function () {
				_this12.whatIsLoading = "Frogs";
			});
		} else if (this.AndroidMobile === true) {
			this.changeFX.load("../src/assets/sounds/blinks/change.ogg", function () {
				_this12.whatIsLoading = "Fauna";
			});

			this.amazonFX.load("../src/assets/sounds/modules/amazon/lowogg/amazonFX.ogg", function () {
				_this12.whatIsLoading = "Critters";
			});

			this.ambience1Player.load("../src/assets/sounds/modules/amazon/lowogg/insects.ogg", function () {
				_this12.whatIsLoading = "Insects";
			});

			this.ambience2Player.load("../src/assets/sounds/modules/amazon/lowogg/lightbed.ogg", function () {
				_this12.whatIsLoading = "Soil";
			});

			this.ambience3Player.load("../src/assets/sounds/modules/amazon/lowogg/heavybed.ogg", function () {
				_this12.whatIsLoading = "Canopy";
			});

			this.ambience4Player.load("../src/assets/sounds/modules/amazon/lowogg/peccary.ogg", function () {
				_this12.whatIsLoading = "Peccary";
			});

			this.ambience5Player.load("../src/assets/sounds/modules/amazon/lowogg/monsoon.ogg", function () {
				_this12.whatIsLoading = "Monsoon";
			});

			this.ambience6Player.load("../src/assets/sounds/modules/amazon/lowogg/frogs.ogg", function () {
				_this12.whatIsLoading = "Frogs";
			});
		} else if (this.isSafari === true || this.isEdge === true || this.isIE === true) {

			this.changeFX.load("../src/assets/sounds/blinks/change.m4a", function () {
				_this12.whatIsLoading = "Fauna";
			});

			this.amazonFX.load("../src/assets/sounds/modules/amazon/320/amazonFX.m4a", function () {
				_this12.whatIsLoading = "Critters";
			});

			this.ambience1Player.load("../src/assets/sounds/modules/amazon/320/insects.m4a", function () {
				_this12.whatIsLoading = "Insects";
			});

			this.ambience2Player.load("../src/assets/sounds/modules/amazon/320/lightbed.m4a", function () {
				_this12.whatIsLoading = "Soil";
			});

			this.ambience3Player.load("../src/assets/sounds/modules/amazon/320/heavybed.m4a", function () {
				_this12.whatIsLoading = "Canopy";
			});

			this.ambience4Player.load("../src/assets/sounds/modules/amazon/320/peccary.m4a", function () {
				_this12.whatIsLoading = "Peccary";
			});

			this.ambience5Player.load("../src/assets/sounds/modules/amazon/320/monsoon.m4a", function () {
				_this12.whatIsLoading = "Monsoon";
			});

			this.ambience6Player.load("../src/assets/sounds/modules/amazon/320/frogs.m4a", function () {
				_this12.whatIsLoading = "Frogs";
			});
		} else if (this.iOS === true) {
			this.changeFX.load("../src/assets/sounds/blinks/change.m4a", function () {
				_this12.whatIsLoading = "Fauna";
			});

			this.amazonFX.load("../src/assets/sounds/modules/amazon/192/amazonFX.m4a", function () {
				_this12.whatIsLoading = "Critters";
			});

			this.ambience1Player.load("../src/assets/sounds/modules/amazon/192/insects.m4a", function () {
				_this12.whatIsLoading = "Insects";
			});

			this.ambience2Player.load("../src/assets/sounds/modules/amazon/192/lightbed.m4a", function () {
				_this12.whatIsLoading = "Soil";
			});

			this.ambience3Player.load("../src/assets/sounds/modules/amazon/192/heavybed.m4a", function () {
				_this12.whatIsLoading = "Canopy";
			});

			this.ambience4Player.load("../src/assets/sounds/modules/amazon/192/peccary.m4a", function () {
				_this12.whatIsLoading = "Peccary";
			});

			this.ambience5Player.load("../src/assets/sounds/modules/amazon/192/monsoon.m4a", function () {
				_this12.whatIsLoading = "Monsoon";
			});

			this.ambience6Player.load("../src/assets/sounds/modules/amazon/192/frogs.m4a", function () {
				_this12.whatIsLoading = "Frogs";
			});
		}
	}), _defineProperty(_methods, 'goHome', function goHome() {
		var _this13 = this;

		this.changeFX.start();

		//IF USER ENGAGES VOICE CONTROL BUT GOES HOME VIA 
		//MOUSE BUTTON THIS TRIGGERS MODULE SPEECH DISPOSE
		if (this.goingHomeNotViaVoiceCommand && !this.initSpeech) {
			this.stopModuleSpeech = true;
			this.recognitionAmazon.stop();
			this.recognitionAmazon.abort();
			this.recognitionAmazon = undefined;
		};

		if (this.didWeAdventure === true) {
			this.exploreSound1.disconnect();
			// this.exploreSound2.disconnect();
			// this.exploreSound3.disconnect();
		}

		setTimeout(function () {
			__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.2);
		}, 400);

		setTimeout(function () {
			_this13.ambience1Player.disconnect();
			_this13.ambience2Player.disconnect();
			_this13.ambience3Player.disconnect();
			_this13.ambience4Player.disconnect();
			_this13.ambience5Player.disconnect();
			_this13.ambience6Player.disconnect();
			_this13.amazonFX.disconnect();
			_this13.changeFX.disconnect();
			_this13.masterVolumeSub.disconnect();
			if (_this13.userMobile === false) {
				_this13.fxConvolver.disconnect();
				_this13.fxAutoFilter.disconnect();
				_this13.fxDelay.disconnect();
				_this13.fxChorus.disconnect();
				_this13.masterMeter.disconnect();
			}
		}, 1000);

		setTimeout(function () {
			document.body.className = 'default';
			_this13.$router.push('/');
			__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master.volume.value = 0;
		}, 1100);
	}), _methods)
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_startaudiocontext_StartAudioContext_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_startaudiocontext_StartAudioContext_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_startaudiocontext_StartAudioContext_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var XRegExp = __webpack_require__(5);
/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			//RANDOMIZE BOOLEANS
			randomizeBoolean: false,
			showFlask1: true,
			showFlask2: false,
			showFlask3: false,
			showFlask4: false,
			showFlask5: false,
			showFlask6: false,
			//CONTROLS
			reverbChecker: undefined,
			loadingBoolean: true,
			userMobile: Boolean,
			mailingListBtn: false,
			textTiming: 500,
			startStopTrigger: true,
			playColor: "#F0CB50",
			stopColor: "#1E9BFC",
			//SCREEN DIMENSIONS
			screenHeight: undefined,
			screenWidth: undefined,
			ogWidth: undefined,
			//BACKGROUND COLORS
			plungeDepth: 1,
			backgroundColor1: true,
			backgroundColor2: false,
			backgroundColor3: false,
			backgroundColor4: false,
			backgroundColor5: false,
			backgroundColor6: false,
			backgroundColor7: false,
			backgroundColor8: false,
			backgroundColor9: false,
			backgroundColor10: false,
			//REACTIVE SUN
			sunReactiveColor1: true,
			sunReactiveColor2: false,
			sunReactiveColor3: false,
			sunReactiveColor4: false,
			sunReactiveColor5: false,
			sunReactiveColor6: false,
			sunReactiveColor7: false,
			sunReactiveColor8: false,
			sunReactiveColor9: false,
			sunReactiveColor10: false,
			//SHOW AND HIDE
			helpTrigger: false,
			showHelpOverlay: false,
			showAboutPage: false,

			bellBoolean: false,
			//PLAY SUN DRAGGIE
			activeSun: false,
			//V-SHOWS
			showEnterContainer: true,
			showLoading: true,
			showEnterBtn: false,
			showNavBar: false,
			showAllControls: false,
			showSpeechBtns: false,
			//AMBIENCE BOOLEANS
			ambience1Boolean: false,
			ambience2Boolean: false,
			ambience3Boolean: false,
			ambience4Boolean: false,
			ambience5Boolean: false,
			ambience6Boolean: false,
			//AMBIENCE DATA
			whatIsLoading: "Beach",
			BeachFX: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": false,
				"volume": -5
			}).toMaster(),
			changeFX: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": false,
				"volume": -6
			}).toMaster(),
			ambience1Vol: -18,
			ambience2Vol: -15,
			ambience3Vol: -15,
			ambience4Vol: -15,
			ambience5Vol: -15,
			ambience6Vol: -10,
			ambience1Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": 0
			}),
			ambience2Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": 0
			}),
			ambience3Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": 0
			}),
			ambience4Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"retrigger": false,
				"volume": 0
			}),
			ambience5Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"retrigger": false,
				"volume": 0
			}),
			ambience6Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"retrigger": true,
				"volume": 0
			}),
			//AUDIO ROUTING & EFFECTS
			playBackSpeed: 1,
			fxDecay: 2.5,
			// masterVolume:     		0,
			loadingSoundID: undefined,
			audioLoading: undefined,
			fxConvolverAmt: 0,
			fxChorusAmt: 0,
			fxDelayAmt: 0,
			fxAutoFilterAmt: 3500,
			mattChill: false,
			fxConvolver: undefined,
			fxChorus: undefined,
			fxDelay: undefined,
			fxAutoFilter: undefined,

			speedToggle: true,
			fxDelayToggle: true,
			fxConvolverToggle: true,
			fxChorusToggle: true,
			fxFilterToggle: false,

			masterMeter: undefined,
			masterLevel: 0,
			masterVolumeSub: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Volume(0),
			//SPEECH
			//FOR SPEECH FORM INPUT
			submitSpeechTxttoVoice: false,
			userVoiceToText: "",
			//IF SPEECH IS ALLOWED SHOW SPEECH ACTIVATE BUTTON (SET VIA APP.js)
			allowSpeechControl: false,
			//GLOBAL COMMAND TRIGGERING VOICE COMMANDS ON AND OFF
			isVoiceControl: false,
			//COMMAND FOR CSS CONTROL WHEN VOICE IS ACTIVE OR NOT
			recognizing: undefined,
			recognitionBeach: undefined,
			//HOLDS ALL OF SPEECHRECONGNITION JSON
			voiceCommandArray: undefined,
			speechRecognitionList: undefined,
			voiceCommandConfidence: undefined,
			//STRING LINE TO TEST FOR VOICE COMMAND ACTIONS
			testObjectVUI: "",
			//BUTTON SWITCHING & TEXT
			initSpeech: true,
			speechBtnTxt: "Say A Command",
			speechStartTopBtnTrigger: true,
			//SHOWS LIST OF COMMANDS
			showVoiceCommandList: false,
			//DISABLE WHILE RECORDING
			isDisableListening: false,
			//TRUE WHEN STOPPING ALL SPEECH FUNCTIONS TO GO HOME
			stopModuleSpeech: false,
			//IF USER ENGAGES VOICE CONTROL BUT GOES HOME VIA MOUSE BUTTON THIS TRIGGERS MODULE SPEECH DISPOSE
			//EXPLORE
			isExploreFuncRunning: false,
			didWeAdventure: false,
			exploreSound1: undefined,
			exploreBtnBoolean: false,
			//WHAT DEVICE
			isChrome: Boolean,
			isFirefox: Boolean,
			isSafari: Boolean,
			isOpera: Boolean,
			isIE: Boolean,
			isEdge: Boolean,
			isBlink: Boolean,
			iOS: Boolean,
			AndroidMobile: Boolean,
			//EXPLORE TIMES OUTS
			exploreTxt: "Explore!",
			exploreTimeout1: undefined,
			exploreTimeout2: undefined,
			exploreTimeout3: undefined,
			exploreTimeout4: undefined,
			exploreTimeout5: undefined,
			exploreTimeout6: undefined,
			exploreTimeout7: undefined,
			exploreTimeout8: undefined,
			exploreTimeout9: undefined,
			exploreTimeout10: undefined,
			exploreTimeout11: undefined,
			exploreTimeout12: undefined,
			exploreTimeout13: undefined,
			exploreTimeout14: undefined,
			//START AUDIO CONTEXT BOOLEAN
			startAudioBoolean: true,
			//LOCAL STORAGE
			isCacheSaved: false,
			firstLoad: false,
			saveTrigger: false,
			loadTrigger: false
		};
	},
	created: function created() {
		var _this = this;

		this.isVoiceControl = this.$store.state.isVoiceControlled;
		if (this.isVoiceControl) {
			this.$store.state.doNotAddress = true;
		}

		window.onpopstate = function () {
			document.body.className = 'default';
			_this.goHome();
		};
		var ua = window.navigator.userAgent;
		this.isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
		this.isFirefox = typeof InstallTrigger !== 'undefined';
		this.isSafari = /constructor/i.test(window.HTMLElement) || function (p) {
			return p.toString() === "[object SafariRemoteNotification]";
		}(!window['safari'] || safari.pushNotification);
		this.isOpera = !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
		this.isIE = /*@cc_on!@*/false || !!document.documentMode;
		this.isEdge = !this.isIE && !!window.StyleMedia;
		this.isBlink = (this.isChrome || this.isOpera) && !!window.CSS, this.iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
		this.AndroidMobile = /Android/i.test(navigator.userAgent);
		//CHROME ALLOWS SPEECH AND MEDIA RECORDING
		if (this.isChrome === true) {
			this.userMobile = false;
			//FIREFOX ONLY ALLOWS MEDIA RECORDING
		} else if (this.isFirefox === true) {
			this.userMobile = false;
			//NO SPEECH AND NO MEDIA RECORDING FOR THE FOLLOWING
		} else if (this.AndroidMobile === true || this.iOS) {
			this.userMobile = true;
		} else if (this.isSafari === true || this.isOpera === true || this.isBlink === true || this.isEdge === true || this.isIE === true) {
			this.userMobile = false;
		}
		this.firstAudioLoadFunc();
		this.bufferLoading();
		this.audioRouting();
	},

	computed: {
		//THE PLUNGE BACKGROUND CHANGE
		plungeClass: function plungeClass() {
			if (this.activeSun === false) {
				if (this.plungeDepth === 1) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = true;
				} else if (this.plungeDepth === 2) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = true;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 3) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = true;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 4) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = true;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 5) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = true;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 6) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = true;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 7) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = true;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 8) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = true;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 9) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = true;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 10) {
					this.backgroundColor10 = true;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				}
				return {
					"backgroundColorBeach10": this.backgroundColor10,
					"backgroundColorBeach9": this.backgroundColor9,
					"backgroundColorBeach8": this.backgroundColor8,
					"backgroundColorBeach7": this.backgroundColor7,
					"backgroundColorBeach6": this.backgroundColor6,
					"backgroundColorBeach5": this.backgroundColor5,
					"backgroundColorBeach4": this.backgroundColor4,
					"backgroundColorBeach3": this.backgroundColor3,
					"backgroundColorBeach2": this.backgroundColor2,
					"backgroundColorBeach1": this.backgroundColor1
				};
			} else if (this.activeSun === true) {
				if (this.masterLevel < -36) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = true;
				} else if (this.masterLevel < -32) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = true;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -28) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = true;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -26) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = true;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -24) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = true;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -22) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = true;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -20) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = true;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -18) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = true;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -16) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = true;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel > -14) {
					this.sunReactiveColor10 = true;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				}
				return {
					"sunReactiveColorClassBeach10": this.sunReactiveColor10,
					"sunReactiveColorClassBeach9": this.sunReactiveColor9,
					"sunReactiveColorClassBeach8": this.sunReactiveColor8,
					"sunReactiveColorClassBeach7": this.sunReactiveColor7,
					"sunReactiveColorClassBeach6": this.sunReactiveColor6,
					"sunReactiveColorClassBeach5": this.sunReactiveColor5,
					"sunReactiveColorClassBeach4": this.sunReactiveColor4,
					"sunReactiveColorClassBeach3": this.sunReactiveColor3,
					"sunReactiveColorClassBeach2": this.sunReactiveColor2,
					"sunReactiveColorClassBeach1": this.sunReactiveColor1
				};
			}
		},

		//SHOW AND HIDE CLASS CHANGES
		helpClass: function helpClass() {
			return {
				"btn btn-helpBtn1Beach": this.helpTrigger,
				"btn btn-helpBtn2Beach": !this.helpTrigger
			};
		},
		mailingListBtnClass: function mailingListBtnClass() {
			return {
				"btn btn-transparent": this.mailingListBtn,
				"btn btn-info": !this.mailingListBtn
			};
		},

		//AMBIENCE CLASS CHANGES
		ambience1Class: function ambience1Class() {
			return {
				"btn btn-playBeach": this.ambience1Boolean,
				"btn btn-stopBeach": !this.ambience1Boolean
			};
		},
		ambience2Class: function ambience2Class() {
			return {
				"btn btn-playBeach": this.ambience2Boolean,
				"btn btn-stopBeach": !this.ambience2Boolean
			};
		},
		ambience3Class: function ambience3Class() {
			return {
				"btn btn-playBeach": this.ambience3Boolean,
				"btn btn-stopBeach": !this.ambience3Boolean
			};
		},
		ambience4Class: function ambience4Class() {
			return {
				"btn btn-playBeach": this.ambience4Boolean,
				"btn btn-stopBeach": !this.ambience4Boolean
			};
		},
		ambience5Class: function ambience5Class() {
			return {
				"btn btn-playBeach": this.ambience5Boolean,
				"btn btn-stopBeach": !this.ambience5Boolean
			};
		},
		ambience6Class: function ambience6Class() {
			return {
				"btn btn-playBeach": this.ambience6Boolean,
				"btn btn-stopBeach": !this.ambience6Boolean
			};
		},
		mattChillClass: function mattChillClass() {
			return {
				"btn btn-mattChillOnBeach": this.mattChill,
				"btn btn-mattChillOffBeach": !this.mattChill
			};
		},

		//AMBIENCE ICON CSS
		ambience1Icon: function ambience1Icon() {
			return {
				"fal fa-times-circle": !this.ambience1Boolean,
				"fal fa-check-circle": this.ambience1Boolean
			};
		},
		ambience2Icon: function ambience2Icon() {
			return {
				"fal fa-times-circle": !this.ambience2Boolean,
				"fal fa-check-circle": this.ambience2Boolean
			};
		},
		ambience3Icon: function ambience3Icon() {
			return {
				"fal fa-times-circle": !this.ambience3Boolean,
				"fal fa-check-circle": this.ambience3Boolean
			};
		},
		ambience4Icon: function ambience4Icon() {
			return {
				"fal fa-times-circle": !this.ambience4Boolean,
				"fal fa-check-circle": this.ambience4Boolean
			};
		},
		ambience5Icon: function ambience5Icon() {
			return {
				"fal fa-times-circle": !this.ambience5Boolean,
				"fal fa-check-circle": this.ambience5Boolean
			};
		},
		ambience6Icon: function ambience6Icon() {
			return {
				"fal fa-times-circle": !this.ambience6Boolean,
				"fal fa-check-circle": this.ambience6Boolean
			};
		},

		//AMBIANCE CLASS CHANGES
		ambiance1RangerClass: function ambiance1RangerClass() {
			return {
				"ambianceRangerPlayBeach": this.ambience1Boolean,
				"ambianceRangerStopBeach": !this.ambience1Boolean
			};
		},
		ambiance2RangerClass: function ambiance2RangerClass() {
			return {
				"ambianceRangerPlayBeach": this.ambience2Boolean,
				"ambianceRangerStopBeach": !this.ambience2Boolean
			};
		},
		ambiance3RangerClass: function ambiance3RangerClass() {
			return {
				"ambianceRangerPlayBeach": this.ambience3Boolean,
				"ambianceRangerStopBeach": !this.ambience3Boolean
			};
		},
		ambiance4RangerClass: function ambiance4RangerClass() {
			return {
				"ambianceRangerPlayBeach": this.ambience4Boolean,
				"ambianceRangerStopBeach": !this.ambience4Boolean
			};
		},
		ambiance5RangerClass: function ambiance5RangerClass() {
			return {
				"ambianceRangerPlayBeach": this.ambience5Boolean,
				"ambianceRangerStopBeach": !this.ambience5Boolean
			};
		},
		ambiance6RangerClass: function ambiance6RangerClass() {
			return {
				"ambianceRangerPlayBeach": this.ambience6Boolean,
				"ambianceRangerStopBeach": !this.ambience6Boolean
			};
		},

		//AUDIO MIXING
		adjustInputVolume: function adjustInputVolume() {
			this.userMic.volume.value = this.userMicInputLevel;
		},
		fxConvolverMix: function fxConvolverMix() {
			if (this.userMobile === false) {
				if (this.fxConvolverToggle === true) {
					this.fxConvolver.wet.setTargetAtTime(this.fxConvolverAmt / 100, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				} else if (this.fxConvolverToggle === false) {
					this.fxConvolver.wet.setTargetAtTime(0, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				}
			}
		},
		fxDelayMix: function fxDelayMix() {
			if (this.userMobile === false) {
				if (this.fxDelayToggle === true) {
					this.fxDelay.wet.setTargetAtTime(this.fxDelayAmt / 100, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +1);
				} else if (this.fxDelayToggle === false) {
					this.fxDelay.wet.setTargetAtTime(0, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +1);
				}
			}
		},
		fxChorusMix: function fxChorusMix() {
			if (this.userMobile === false) {
				if (this.fxChorusToggle === true) {
					this.fxChorus.wet.setTargetAtTime(this.fxChorusAmt / 100, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				} else if (this.fxChorusToggle === false) {
					this.fxChorus.wet.setTargetAtTime(0, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				}
			}
		},
		fxAutoFilterMix: function fxAutoFilterMix() {
			if (this.userMobile === false) {
				if (this.fxFilterToggle === true) {
					this.fxAutoFilter.frequency.setTargetAtTime(this.fxAutoFilterAmt, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				} else if (this.fxFilterToggle === false) {
					this.fxAutoFilter.frequency.setTargetAtTime(20000, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				}
			}
		},
		playbackSpeedFunc: function playbackSpeedFunc() {
			if (this.speedToggle === true) {
				this.ambience1Player.playbackRate = this.playBackSpeed;
				this.ambience2Player.playbackRate = this.playBackSpeed;
				this.ambience3Player.playbackRate = this.playBackSpeed;
				this.ambience4Player.playbackRate = this.playBackSpeed;
				this.ambience5Player.playbackRate = this.playBackSpeed;
				this.ambience6Player.playbackRate = this.playBackSpeed;
			} else if (this.speedToggle === false) {
				this.ambience1Player.playbackRate = 1;
				this.ambience2Player.playbackRate = 1;
				this.ambience3Player.playbackRate = 1;
				this.ambience4Player.playbackRate = 1;
				this.ambience5Player.playbackRate = 1;
				this.ambience6Player.playbackRate = 1;
			}
		},

		//SPEECH
		speechStartStopClass: function speechStartStopClass() {
			return {
				"recordingClassEngagedBeach": this.recognizing,
				"recordingClassDisengagedBeach": !this.recognizing
			};
		},
		speechIconClass: function speechIconClass() {
			return {
				"fa fa-microphone-alt fa-spin": this.recognizing,
				"fa fa-microphone-alt": !this.recognizing
			};
		},
		speechShowListClass: function speechShowListClass() {
			return {
				"recordingClassEngagedBeach": this.showVoiceCommandList,
				"recordingClassDisengagedBeach": !this.showVoiceCommandList
			};
		},
		speechSubmitClass: function speechSubmitClass() {
			return {
				"btn btn-speechSubmitOn mb-2": this.submitSpeechTxttoVoice,
				"btn btn-speechSubmitOff mb-2": !this.submitSpeechTxttoVoice
			};
		},

		//EXPLORE
		exploreFuncClass: function exploreFuncClass() {
			return {
				"recordingClassDisengagedBeach": !this.isExploreFuncRunning,
				"recordingClassEngagedBeach": this.isExploreFuncRunning
			};
		},
		exploreIconClass: function exploreIconClass() {
			return {
				"fab fa-wpexplorer": !this.isExploreFuncRunning,
				"fab fa-wpexplorer fa-spin": this.isExploreFuncRunning
			};
		},

		//AMBIENCE PLAY AND STOPS
		ambience1Func: function ambience1Func() {
			if (this.ambience1Boolean === true) {
				this.ambience1Player.volume.value = this.ambience1Vol;
			} else if (this.ambience1Boolean === false) {
				this.ambience1Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},
		ambience2Func: function ambience2Func() {
			if (this.ambience2Boolean === true) {
				this.ambience2Player.volume.value = this.ambience2Vol;
			} else if (this.ambience2Boolean === false) {
				this.ambience2Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},
		ambience3Func: function ambience3Func() {
			if (this.ambience3Boolean === true) {
				this.ambience3Player.volume.value = this.ambience3Vol;
			} else if (this.ambience3Boolean === false) {
				this.ambience3Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},
		ambience4Func: function ambience4Func() {
			if (this.ambience4Boolean === true) {
				this.ambience4Player.volume.value = this.ambience4Vol;
			} else if (this.ambience4Boolean === false) {
				this.ambience4Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},
		ambience5Func: function ambience5Func() {
			if (this.ambience5Boolean === true) {
				this.ambience5Player.volume.value = this.ambience5Vol;
			} else if (this.ambience5Boolean === false) {
				this.ambience5Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},
		ambience6Func: function ambience6Func() {
			if (this.ambience6Boolean === true) {
				this.ambience6Player.volume.value = this.ambience6Vol;
			} else if (this.ambience6Boolean === false) {
				this.ambience6Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},

		//LOCAL STORAGE
		saveClass: function saveClass() {
			return { "btn btn-playBeach": this.saveTrigger,
				"btn btn-stopBeach": !this.saveTrigger };
		},
		loadClass: function loadClass() {
			return { "btn btn-playBeach": this.loadTrigger,
				"btn btn-stopBeach": !this.loadTrigger };
		}
	},
	methods: {
		//LOCAL STORAGE
		setLocalStorage: function setLocalStorage() {
			var _this2 = this;

			this.saveTrigger = true;
			setTimeout(function () {
				_this2.saveTrigger = false;
			}, 250);

			this.removeLocalStorage();

			localStorage.setItem('isCacheSavedBeach', JSON.stringify(true));

			localStorage.setItem('ambience1VolBeach', JSON.stringify(this.ambience1Vol));
			localStorage.setItem('ambience2VolBeach', JSON.stringify(this.ambience2Vol));
			localStorage.setItem('ambience3VolBeach', JSON.stringify(this.ambience3Vol));
			localStorage.setItem('ambience4VolBeach', JSON.stringify(this.ambience4Vol));
			localStorage.setItem('ambience5VolBeach', JSON.stringify(this.ambience5Vol));
			localStorage.setItem('ambience6VolBeach', JSON.stringify(this.ambience6Vol));

			localStorage.setItem('ambience1BooleanBeach', JSON.stringify(this.ambience1Boolean));
			localStorage.setItem('ambience2BooleanBeach', JSON.stringify(this.ambience2Boolean));
			localStorage.setItem('ambience3BooleanBeach', JSON.stringify(this.ambience3Boolean));
			localStorage.setItem('ambience4BooleanBeach', JSON.stringify(this.ambience4Boolean));
			localStorage.setItem('ambience5BooleanBeach', JSON.stringify(this.ambience5Boolean));
			localStorage.setItem('ambience6BooleanBeach', JSON.stringify(this.ambience6Boolean));

			localStorage.setItem('speedToggleBeach', JSON.stringify(this.speedToggle));
			localStorage.setItem('fxDelayToggleBeach', JSON.stringify(this.fxDelayToggle));
			localStorage.setItem('fxConvolverToggleBeach', JSON.stringify(this.fxConvolverToggle));
			localStorage.setItem('fxChorusToggleBeach', JSON.stringify(this.fxChorusToggle));
			localStorage.setItem('fxFilterToggleBeach', JSON.stringify(this.fxFilterToggle));

			localStorage.setItem('playBackSpeed', JSON.stringify(this.playBackSpeed));
			localStorage.setItem('fxConvolverAmtBeach', JSON.stringify(this.fxConvolverAmt));
			localStorage.setItem('fxChorusAmtBeach', JSON.stringify(this.fxChorusAmt));
			localStorage.setItem('fxDelayAmtBeach', JSON.stringify(this.fxDelayAmt));
			localStorage.setItem('fxAutoFilterAmtBeach', JSON.stringify(this.fxAutoFilterAmt));
		},
		getLocalStorage: function getLocalStorage() {
			var _this3 = this;

			this.isCacheSaved = JSON.parse(localStorage.getItem('isCacheSavedBeach'));
			if (this.isCacheSaved) {
				this.loadTrigger = true;
				setTimeout(function () {
					_this3.loadTrigger = false;
				}, 250);

				this.ambience1Vol = JSON.parse(localStorage.getItem('ambience1VolBeach'));
				this.ambience2Vol = JSON.parse(localStorage.getItem('ambience2VolBeach'));
				this.ambience3Vol = JSON.parse(localStorage.getItem('ambience3VolBeach'));
				this.ambience4Vol = JSON.parse(localStorage.getItem('ambience4VolBeach'));
				this.ambience5Vol = JSON.parse(localStorage.getItem('ambience5VolBeach'));
				this.ambience6Vol = JSON.parse(localStorage.getItem('ambience6VolBeach'));

				this.ambience1Boolean = JSON.parse(localStorage.getItem('ambience1BooleanBeach'));
				this.ambience2Boolean = JSON.parse(localStorage.getItem('ambience2BooleanBeach'));
				this.ambience3Boolean = JSON.parse(localStorage.getItem('ambience3BooleanBeach'));
				this.ambience4Boolean = JSON.parse(localStorage.getItem('ambience4BooleanBeach'));
				this.ambience5Boolean = JSON.parse(localStorage.getItem('ambience5BooleanBeach'));
				this.ambience6Boolean = JSON.parse(localStorage.getItem('ambience6BooleanBeach'));

				this.speedToggle = JSON.parse(localStorage.getItem('speedToggleBeach'));
				this.fxDelayToggle = JSON.parse(localStorage.getItem('fxDelayToggleBeach'));
				this.fxConvolverToggle = JSON.parse(localStorage.getItem('fxConvolverToggleBeach'));
				this.fxChorusToggle = JSON.parse(localStorage.getItem('fxChorusToggleBeach'));
				this.fxFilterToggle = JSON.parse(localStorage.getItem('fxFilterToggleBeach'));

				this.playBackSpeed = JSON.parse(localStorage.getItem('playBackSpeed'));;
				this.fxConvolverAmt = JSON.parse(localStorage.getItem('fxConvolverAmtBeach'));
				this.fxChorusAmt = JSON.parse(localStorage.getItem('fxChorusAmtBeach'));
				this.fxDelayAmt = JSON.parse(localStorage.getItem('fxDelayAmtBeach'));
				this.fxAutoFilterAmt = JSON.parse(localStorage.getItem('fxAutoFilterAmtBeach'));
			}
		},
		removeLocalStorage: function removeLocalStorage() {
			localStorage.removeItem('isCacheSavedBeach');

			localStorage.removeItem('ambience1VolBeach');
			localStorage.removeItem('ambience2VolBeach');
			localStorage.removeItem('ambience3VolBeach');
			localStorage.removeItem('ambience4VolBeach');
			localStorage.removeItem('ambience5VolBeach');
			localStorage.removeItem('ambience6VolBeach');

			localStorage.removeItem('ambience1BooleanBeach');
			localStorage.removeItem('ambience2BooleanBeach');
			localStorage.removeItem('ambience3BooleanBeach');
			localStorage.removeItem('ambience4BooleanBeach');
			localStorage.removeItem('ambience5BooleanBeach');
			localStorage.removeItem('ambience6BooleanBeach');

			localStorage.removeItem('speedToggleBeach');
			localStorage.removeItem('fxDelayToggleBeach');
			localStorage.removeItem('fxConvolverToggleBeach');
			localStorage.removeItem('fxChorusToggleBeach');
			localStorage.removeItem('fxFilterToggleBeach');

			localStorage.removeItem('playBackSpeedBeach');
			localStorage.removeItem('fxConvolverAmtBeach');
			localStorage.removeItem('fxChorusAmtBeach');
			localStorage.removeItem('fxDelayAmtBeach');
			localStorage.removeItem('fxAutoFilterAmtBeach');
		},

		//START AUDIO
		startAudio: function startAudio() {
			if (this.firstLoad) {
				this.firstLoad = false;
				__WEBPACK_IMPORTED_MODULE_0__node_modules_startaudiocontext_StartAudioContext_js___default()(__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.context, "#enterFuncBtn");
				this.$store.state.hasAudioContextTriggered = true;
			}
			this.ambience1Player.volume.value = -100;
			this.ambience2Player.volume.value = -100;
			this.ambience3Player.volume.value = -100;
			this.ambience4Player.volume.value = -100;
			this.ambience5Player.volume.value = -100;
			this.ambience6Player.volume.value = -100;

			this.ambience1Player.start();
			this.ambience2Player.start();
			this.ambience3Player.start();
			this.ambience4Player.start();
			this.ambience5Player.start();
			this.ambience6Player.start();
		},
		stopAudio: function stopAudio() {
			this.ambience1Player.stop();
			this.ambience2Player.stop();
			this.ambience3Player.stop();
			this.ambience4Player.stop();
			this.ambience5Player.stop();
			this.ambience6Player.stop();
		},

		//SPEECH
		userVoiceToTextFunc: function userVoiceToTextFunc() {
			var _this4 = this;

			this.submitSpeechTxttoVoice = true;
			this.testObjectVUI = this.userVoiceToText;
			console.log(this.testObjectVUI);
			this.sourceSortingVUI();
			setTimeout(function () {
				_this4.submitSpeechTxttoVoice = false;
			}, 250);
		},
		speechFunc: function speechFunc() {
			var _this5 = this;

			if (this.initSpeech === true) {
				this.recognitionBeach = new webkitSpeechRecognition();
				this.recognizing;
				this.recognitionBeach.continuous = false;
				this.recognitionBeach.interimResults = true;

				this.recognitionBeach.onresult = function (event) {
					for (var i = event.resultIndex; i < event.results.length; ++i) {
						if (event.results[i].isFinal) {
							if (!_this5.isDisableListening) {
								_this5.testObjectVUI += event.results[i][0].transcript;
								console.log('Speech String Command: ' + event.results[i][0].transcript);
								_this5.sourceSortingVUI();
							}
						}
					}
				};
				this.recognitionBeach.onspeechend = function () {
					console.log('%c Beach Module SPEECH Ended', 'background: red; color: black');
					// setTimeout(this.sourceSortingVUI, 500);
					_this5.recognizing = false;
					_this5.speechBtnTxt = "Say A Command";
					__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master.volume.setTargetAtTime(0, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.context.currentTime, +0.5);
				};
				this.recognitionBeach.onspeechstart = function () {
					console.log('%c Beach Module SPEECH Began', 'background: green; color: white');
					_this5.recognizing = true;
					_this5.speechBtnTxt = "Listening For Command";
					__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master.volume.setTargetAtTime(-10, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.context.currentTime, +1);
				};
				this.recognitionBeach.onsoundstart = function () {
					console.log('%c Beach Module LISTENING Began', 'background: green; color: white');
				};
				this.recognitionBeach.onaudioend = function () {
					console.log('%c Beach Module LISTENING Ended', 'background: green; color: white');
					// setTimeout(this.sourceSortingVUI, 500);
					_this5.recognizing = false;
					_this5.speechBtnTxt = "Say A Command";
				};
				this.recognitionBeach.onend = function () {
					console.log('%c Beach Module SPEECH SESSION ENDED', 'background: green; color: white');
					if (_this5.stopModuleSpeech === false) {
						_this5.recognitionBeach.start();
					}
				};
				this.recognizing = true;
				//MAKE SURE SPEECH IS NOT RE-ENGAGED
				this.initSpeech = false;
				//GLOBAL VOICE COMMAND IS SET TO TRUE
				this.$store.state.isVoiceControlled = true;
				this.recognitionBeach.start();
				//IF USER ENGAGES VOICE CONTROL BUT GOES HOME VIA MOUSE BUTTON THIS TRIGGERS MODULE SPEECH DISPOSE
				this.goingHomeNotViaVoiceCommand = true;
				//CONTROLS recognition.onend TO RESTART LISTENING
				this.stopModuleSpeech = false;
				//TURN LISTENING BACK ON
				this.isDisableListening = false;
				//IF BEING VOICE CONTROLLED DON'T PLAY THE NICE, TELL ME WHERE YOU WANT TO GO PROMPT ON WELCOME PAGE
				this.$store.state.doNotAddress = true;
			} else if (this.initSpeech === false) {}
		},
		resetFunc: function resetFunc() {
			this.recognizing = false;
		},
		speechStartStopFunc: function speechStartStopFunc() {
			this.speechStartTopBtnTrigger = !this.speechStartTopBtnTrigger;

			if (this.speechStartTopBtnTrigger === true) {
				this.speechFunc();
			} else if (this.speechStartTopBtnTrigger === false) {
				this.initSpeech = true;
				this.stopModuleSpeech = true;
				this.recognizing = false;
				this.recognitionBeach.stop();
				this.$store.state.isVoiceControlled = false;
			}
		},
		sourceSortingVUI: function sourceSortingVUI() {
			//FOR VISUAL REFERENCE
			this.userVoiceToText = this.testObjectVUI;

			var source1RegEx = XRegExp.build('(?x) {{source1Name}} | {{label1Name}}', {
				source1Name: XRegExp.build('{{source1Name1}} | {{source1Name2}}', {
					source1Name1: /source\sone/,
					source1Name2: /source\s1/
				}),
				label1Name: XRegExp.build('{{label1Name1}}', {
					label1Name1: /stormy?|rain/
				})
			}, 'xgi');

			var source2RegEx = XRegExp.build('(?x) {{source2Name}} | {{label2Name}}', {
				source2Name: XRegExp.build('{{source2Name1}} | {{source2Name2}}', {
					source2Name1: /source\stw?o?o/,
					source2Name2: /source\s2/
				}),
				label2Name: XRegExp.build('{{label2Name1}}', {
					label2Name1: /cliff\s?side|\bside\b/
				})
			}, 'xgi');

			var source3RegEx = XRegExp.build('(?x) {{source3Name}} | {{label3Name}}', {
				source3Name: XRegExp.build('{{source3Name1}} | {{source3Name2}}', {
					source3Name1: /source\sthree/,
					source3Name2: /source\s3/
				}),
				label3Name: XRegExp.build('{{label3Name1}} | {{label3Name2}}', {
					label3Name1: /venice/,
					label3Name2: /los\s?angeles?|\bla\b/
				})
			}, 'xgi');

			var source4RegEx = XRegExp.build('(?x) {{source4Name}} | {{label4Name}}', {
				source4Name: XRegExp.build('{{source4Name1}} | {{source4Name2}}', {
					source4Name1: /source\sfou?re?/,
					source4Name2: /source\s4/
				}),
				label4Name: XRegExp.build('{{label4Name1}} | {{label4Name2}}', {
					label4Name1: /\blava\b/,
					label4Name2: /hawaii/
				})
			}, 'xgi');

			var source5RegEx = XRegExp.build('(?x) {{source5Name}} | {{label5Name}}', {
				source5Name: XRegExp.build('{{source5Name1}} | {{source5Name2}}', {
					source5Name1: /source\sfive/,
					source5Name2: /source\s5/
				}),
				label5Name: XRegExp.build('{{label5Name1}} | {{label5Name2}}', {
					label5Name1: /new\s?york\s?city|nyc|new\syork/,
					label5Name2: /co[nm]ey|islands?/
				})
			}, 'xgi');

			var source6RegEx = XRegExp.build('(?x) {{source6Name}} | {{label6Name}}', {
				source6Name: XRegExp.build('{{source6Name1}} | {{source6Name2}}', {
					source6Name1: /source\ss[ei]x/,
					source6Name2: /source\s6/
				}),
				label6Name: XRegExp.build('{{label6Name1}} | {{label6Name2}}', {
					label6Name1: /serene|scene/,
					label6Name2: /blissful/
				})
			}, 'xgi');
			//ALL SOUNDS
			var allSoundRegEx = XRegExp.build('(?x) {{allSoundName}}', {
				allSoundName: XRegExp.build('{{allSoundName1}} | {{allSoundName2}}', {
					allSoundName1: /all\ssounds?/,
					allSoundName2: /all\saudios?/
				})
			}, 'xgi');
			//SPEED
			var speedRegEx = XRegExp.build('(?x) {{speedName}}', {
				speedName: XRegExp.build('{{speedName1}} | {{speedName2}}', {
					speedName1: /speeds?/,
					speedName2: /slow|faster/
				})
			}, 'xgi');
			//DELAY
			var delayRegEx = XRegExp.build('(?x) {{delayName}}', {
				delayName: XRegExp.build('{{delayName1}} | {{delayName2}}', {
					delayName1: /delay/,
					delayName2: /lay/
				})
			}, 'xgi');
			//CHORUS
			var chorusRegEx = XRegExp.build('(?x) {{chorusName}}', {
				chorusName: XRegExp.build('{{chorusName1}} | {{chorusName2}}', {
					chorusName1: /chorus?/,
					chorusName2: /course/
				})
			}, 'xgi');
			//FILTER
			var filterRegEx = XRegExp.build('(?x) {{filterName}}', {
				filterName: XRegExp.build('{{filterName1}} | {{filterName2}}', {
					filterName1: /filter/,
					filterName2: /filter/
				})
			}, 'xgi');
			//REVERB
			var reverbRegEx = XRegExp.build('(?x) {{reverbName}}', {
				reverbName: XRegExp.build('{{reverbName1}} | {{reverbName2}}', {
					reverbName1: /verb/,
					reverbName2: /reverb/
				})
			}, 'xgi');
			//SHOW
			var infoRegEx = XRegExp.build('(?x) {{showName}}', {
				showName: XRegExp.build('{{showName1}} | {{showName2}}', {
					showName1: /info/,
					showName2: /information/
				})
			}, 'xgi');
			// console.log(infoRegEx);
			//HIDE
			var listRegEx = XRegExp.build('(?x) {{hideName}}', {
				hideName: XRegExp.build('{{hideName1}} | {{hideName2}}', {
					hideName1: /lists?/,
					hideName2: /menu/
				})
			}, 'xgi');
			// console.log(listRegEx);			

			var source1Boolean = source1RegEx.test(this.testObjectVUI);
			var source2Boolean = source2RegEx.test(this.testObjectVUI);
			var source3Boolean = source3RegEx.test(this.testObjectVUI);
			var source4Boolean = source4RegEx.test(this.testObjectVUI);
			var source5Boolean = source5RegEx.test(this.testObjectVUI);
			var source6Boolean = source6RegEx.test(this.testObjectVUI);
			var allSoundBoolean = allSoundRegEx.test(this.testObjectVUI);
			var speedBoolean = speedRegEx.test(this.testObjectVUI);
			var delayBoolean = delayRegEx.test(this.testObjectVUI);
			var chorusBoolean = chorusRegEx.test(this.testObjectVUI);
			var filterBoolean = filterRegEx.test(this.testObjectVUI);
			var reverbBoolean = reverbRegEx.test(this.testObjectVUI);
			var infoBoolean = infoRegEx.test(this.testObjectVUI);
			var listBoolean = listRegEx.test(this.testObjectVUI);

			if (source1Boolean) {
				this.source1VUI();
			} else if (source2Boolean) {
				this.source2VUI();
			} else if (source3Boolean) {
				this.source3VUI();
			} else if (source4Boolean) {
				this.source4VUI();
			} else if (source5Boolean) {
				this.source5VUI();
			} else if (source6Boolean) {
				this.source6VUI();
			} else if (allSoundBoolean) {
				this.allSoundVUI();
			} else if (speedBoolean) {
				this.speedVUI();
			} else if (delayBoolean) {
				this.delayVUI();
			} else if (chorusBoolean) {
				this.chorusVUI();
			} else if (filterBoolean) {
				this.filterVUI();
			} else if (reverbBoolean) {
				this.reverbVUI();
			} else if (infoBoolean) {
				this.infoVUI();
			} else if (listBoolean) {
				this.listVUI();
			} else {
				this.miscVUI();
			}
		},
		source1VUI: function source1VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience1Player.start();
				this.ambience1Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience1Player.stop();
				this.ambience1Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience1Vol < 0) {
						this.ambience1Vol += 12;
					}
				} else {
					if (this.ambience1Vol < 0) {
						this.ambience1Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience1Vol > -30) {
						this.ambience1Vol -= 12;
					}
				} else {
					if (this.ambience1Vol > -30) {
						this.ambience1Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		source2VUI: function source2VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience2Player.start();
				this.ambience2Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience2Player.stop();
				this.ambience2Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience2Vol < 0) {
						this.ambience2Vol += 12;
					}
				} else {
					if (this.ambience2Vol < 0) {
						this.ambience2Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience2Vol > -30) {
						this.ambience2Vol -= 12;
					}
				} else {
					if (this.ambience2Vol > -30) {
						this.ambience2Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		source3VUI: function source3VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience3Player.start();
				this.ambience3Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience3Player.stop();
				this.ambience3Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience3Vol < 0) {
						this.ambience3Vol += 12;
					}
				} else {
					if (this.ambience3Vol < 0) {
						this.ambience3Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience3Vol > -30) {
						this.ambience3Vol -= 12;
					}
				} else {
					if (this.ambience3Vol > -30) {
						this.ambience3Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		source4VUI: function source4VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience4Player.start();
				this.ambience4Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience4Player.stop();
				this.ambience4Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience4Vol < 0) {
						this.ambience4Vol += 12;
					}
				} else {
					if (this.ambience4Vol < 0) {
						this.ambience4Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience4Vol > -30) {
						this.ambience4Vol -= 12;
					}
				} else {
					if (this.ambience4Vol > -30) {
						this.ambience4Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		source5VUI: function source5VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience5Player.start();
				this.ambience5Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience5Player.stop();
				this.ambience5Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience5Vol < 0) {
						this.ambience5Vol += 12;
					}
				} else {
					if (this.ambience5Vol < 0) {
						this.ambience5Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience5Vol > -30) {
						this.ambience5Vol -= 12;
					}
				} else {
					if (this.ambience5Vol > -30) {
						this.ambience5Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		source6VUI: function source6VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience6Player.start();
				this.ambience6Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience6Player.stop();
				this.ambience6Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience6Vol < 0) {
						this.ambience6Vol += 12;
					}
				} else {
					if (this.ambience6Vol < 0) {
						this.ambience6Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience6Vol > -30) {
						this.ambience6Vol -= 12;
					}
				} else {
					if (this.ambience6Vol > -30) {
						this.ambience6Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		allSoundVUI: function allSoundVUI() {
			//STOP ALL 
			if (RegExp(/stop/gi).test(this.testObjectVUI)) {
				this.ambience1Player.stop();
				this.ambience1Boolean = false;
				this.ambience2Player.stop();
				this.ambience2Boolean = false;
				this.ambience3Player.stop();
				this.ambience3Boolean = false;
				this.ambience4Player.stop();
				this.ambience4Boolean = false;
				this.ambience5Player.stop();
				this.ambience5Boolean = false;
				this.ambience6Player.stop();
				this.ambience6Boolean = false;
				if (this.didWeAdventure) {
					this.exploreSound1.stop();
					this.isExploreFuncRunning = false;
				}
			} else if (RegExp(/play/gi).test(this.testObjectVUI)) {
				this.ambience1Player.start();
				this.ambience1Boolean = true;
				this.ambience2Player.start();
				this.ambience2Boolean = true;
				this.ambience3Player.start();
				this.ambience3Boolean = true;
				this.ambience4Player.start();
				this.ambience4Boolean = true;
				this.ambience5Player.start();
				this.ambience5Boolean = true;
				this.ambience6Player.start();
				this.ambience6Boolean = true;
			}
			this.testObjectVUI = "";
		},
		speedVUI: function speedVUI() {
			if (RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI)) {
				this.speedToggle = true;
			} else if (RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI)) {
				this.speedToggle = false;
			}
			if (RegExp(/\bfaste?r?\b|up/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.playBackSpeed <= 1.6) {
						this.playBackSpeed += 0.4;
					}
				} else {
					if (this.playBackSpeed <= 1.8) {
						this.playBackSpeed += 0.2;
					}
				}
			} else if (RegExp(/slowe?r?|down/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.playBackSpeed >= 0.5) {
						this.playBackSpeed -= 0.4;
					}
				} else {
					if (this.playBackSpeed >= 0.2) {
						this.playBackSpeed -= 0.2;
					}
				}
			}
			this.testObjectVUI = "";
		},
		delayVUI: function delayVUI() {
			if (RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI)) {
				this.fxDelayToggle = true;
			} else if (RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI)) {
				this.fxDelayToggle = false;
			}
			if (RegExp(/\bmore\b|\bup\b|loude?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxDelayAmt <= 80) {
						this.fxDelayAmt += 10;
					}
				} else {
					if (this.fxDelayAmt <= 95) {
						this.fxDelayAmt += 5;
					}
				}
			} else if (RegExp(/less|\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxDelayAmt >= 20) {
						this.fxDelayAmt -= 10;
					} else if (this.fxDelayAmt >= 5) {
						this.fxDelayAmt -= 5;
					}
				} else {
					if (this.fxDelayAmt >= 5) {
						this.fxDelayAmt -= 5;
					} else if (this.fxDelayAmt >= 15) {
						this.fxDelayAmt -= 2;
					}
				}
			}
			this.testObjectVUI = "";
		},
		chorusVUI: function chorusVUI() {
			if (RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI)) {
				this.fxChorusToggle = true;
			} else if (RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI)) {
				this.fxChorusToggle = false;
			}
			if (RegExp(/\bmore\b|\bup\b|loude?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxChorusAmt <= 80) {
						this.fxChorusAmt += 10;
					}
				} else {
					if (this.fxChorusAmt <= 95) {
						this.fxChorusAmt += 5;
					}
				}
			} else if (RegExp(/less|\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxChorusAmt >= 20) {
						this.fxChorusAmt -= 10;
					} else if (this.fxChorusAmt >= 5) {
						this.fxChorusAmt -= 5;
					}
				} else {
					if (this.fxChorusAmt >= 5) {
						this.fxChorusAmt -= 5;
					} else if (this.fxChorusAmt >= 15) {
						this.fxChorusAmt -= 2;
					}
				}
			}
			this.testObjectVUI = "";
		},
		reverbVUI: function reverbVUI() {
			if (RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI)) {
				this.fxConvolverToggle = true;
			} else if (RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI)) {
				this.fxConvolverToggle = false;
			}
			if (RegExp(/\bmore\b|\bup\b|loude?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxConvolverAmt <= 45) {
						this.fxConvolverAmt += 5;
					}
				} else {
					if (this.fxConvolverAmt <= 48) {
						this.fxConvolverAmt += 2;
					}
				}
			} else if (RegExp(/less|\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxConvolverAmt >= 10) {
						this.fxConvolverAmt -= 5;
					} else if (this.fxConvolverAmt >= 2) {
						this.fxConvolverAmt -= 1;
					}
				} else {
					if (this.fxConvolverAmt >= 10) {
						this.fxConvolverAmt -= 2;
					} else if (this.fxConvolverAmt >= 2) {
						this.fxConvolverAmt -= 1;
					}
				}
			}
			this.testObjectVUI = "";
		},
		filterVUI: function filterVUI() {
			if (RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI)) {
				this.fxFilterToggle = true;
			} else if (RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI)) {
				this.fxFilterToggle = false;
			}
			if (RegExp(/\bmore\b|\blower\b/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxAutoFilterAmt > 1500) {
						this.fxAutoFilterAmt -= 1500;
					} else if (this.fxAutoFilterAmt >= 300) {
						this.fxAutoFilterAmt -= 200;
					}
				} else {
					if (this.fxAutoFilterAmt >= 500) {
						this.fxAutoFilterAmt -= 250;
					} else if (this.fxAutoFilterAmt >= 100) {
						this.fxAutoFilterAmt -= 100;
					}
				}
			} else if (RegExp(/less|higher|hire/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxAutoFilterAmt <= 10000) {
						this.fxAutoFilterAmt += 1500;
					} else if (this.fxAutoFilterAmt <= 1000) {
						this.fxAutoFilterAmt += 200;
					}
				} else {
					if (this.fxAutoFilterAmt <= 10000) {
						this.fxAutoFilterAmt += 250;
					} else if (this.fxAutoFilterAmt <= 1000) {
						this.fxAutoFilterAmt += 100;
					}
				}
			}
			this.testObjectVUI = "";
		},
		infoVUI: function infoVUI() {
			var _this6 = this;

			if (RegExp(/show|display/gi).test(this.testObjectVUI)) {
				this.showHelpOverlay = true;
				setTimeout(function () {
					_this6.showNavBar = false;
					if (_this6.$store.state.allowSpeechControl) {
						_this6.showSpeechBtns = false;
					}
				}, 0);
				setTimeout(function () {
					_this6.showAllControls = false;
				}, 500);
				setTimeout(function () {
					_this6.showAboutPage = true;
				}, 1500);
				console.log('SHOW INFO');
			} else if (RegExp(/hide|minimize/gi).test(this.testObjectVUI)) {
				this.showHelpOverlay = false;
				this.showAboutPage = false;
				setTimeout(function () {
					_this6.showAllControls = true;
				}, 800);
				setTimeout(function () {
					_this6.showNavBar = true;
					if (_this6.$store.state.allowSpeechControl) {
						_this6.showSpeechBtns = true;
					}
				}, 850);
				console.log('HIDE INFO');
			}
			this.testObjectVUI = "";
			setTimeout(function () {
				_this6.userVoiceToText = "";
			}, 3000);
		},
		listVUI: function listVUI() {
			var _this7 = this;

			if (RegExp(/show|display/gi).test(this.testObjectVUI)) {
				this.showVoiceCommandList = true;
				setTimeout(function () {
					document.getElementById('voiceControlListTxt').scrollIntoView({ behavior: "smooth" });
				}, 250);
				console.log('SHOW LIST');
			} else if (RegExp(/hide|minimize/gi).test(this.testObjectVUI)) {
				this.showVoiceCommandList = false;
				setTimeout(function () {
					document.getElementById('controlsContainer').scrollIntoView({ behavior: "smooth" });
				}, 250);
				console.log('HIDE LIST');
			}
			this.testObjectVUI = "";
			setTimeout(function () {
				_this7.userVoiceToText = "";
			}, 3000);
		},
		miscVUI: function miscVUI() {
			//RANDOMIZE
			if (RegExp(/new\s?scenes?|randomi?z?e?|shift\s?soundscapes?/gi).test(this.testObjectVUI)) {
				this.mattChillMethod();
				//EXPLORE
			} else if (RegExp(/\bexplorer?\b|\badventure\b/gi).test(this.testObjectVUI)) {
				if (RegExp(/stop/gi).test(this.testObjectVUI)) {
					this.stopExplore();
				} else {
					this.exploreFunc();
				}
				//STOP VOICE COMMANDS & GO HOME FUNCTIONS
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) && RegExp(/voice\s?controls?/gi).test(this.testObjectVUI) || RegExp(/stop/gi).test(this.testObjectVUI) && RegExp(/voice\s?commands?/gi).test(this.testObjectVUI)) {
				//DISABLES LISTENING IMMEDITATLY
				this.initSpeech = true;
				this.stopModuleSpeech = true;
				this.recognizing = false;
				this.recognitionBeach.stop();
				this.$store.state.isVoiceControlled = false;
			} else if (RegExp(/home/gi).test(this.testObjectVUI)) {
				this.goingHomeNotViaVoiceCommand = false;
				this.stopModuleSpeech = true;
				this.recognitionBeach.abort();
				this.recognitionBeach = undefined;
				setTimeout(this.goHome, 50);
			}
			this.testObjectVUI = "";
		},
		voiceCommandListFunc: function voiceCommandListFunc() {
			this.showVoiceCommandList = !this.showVoiceCommandList;
			if (this.showVoiceCommandList) {
				setTimeout(function () {
					document.getElementById('voiceControlListTxt').scrollIntoView({ behavior: "smooth" });
				}, 250);
			} else if (!this.showVoiceCommandList) {
				document.getElementById('controlsContainer').scrollIntoView({ behavior: "smooth" });
			}
		},

		//ENTER FUNC
		enterFunc: function enterFunc() {
			var _this8 = this;

			if (this.startAudioBoolean) {
				this.startAudio();
				this.startAudioBoolean = false;
			}

			this.showEnterBtn = false;

			this.BeachFX.start();

			var changeTiming = 50;

			setTimeout(function () {
				_this8.plungeDepth = 1;
			}, changeTiming * 1);

			setTimeout(function () {
				_this8.plungeDepth = 2;
			}, changeTiming * 2);

			setTimeout(function () {
				_this8.plungeDepth = 3;
			}, changeTiming * 3);

			setTimeout(function () {
				_this8.plungeDepth = 4;
			}, changeTiming * 4);

			setTimeout(function () {
				_this8.plungeDepth = 5;
			}, changeTiming * 5);

			setTimeout(function () {
				_this8.plungeDepth = 6;
			}, changeTiming * 6);

			setTimeout(function () {
				_this8.plungeDepth = 7;
			}, changeTiming * 7);

			setTimeout(function () {
				_this8.plungeDepth = 8;
			}, changeTiming * 8);

			setTimeout(function () {
				_this8.plungeDepth = 9;
			}, changeTiming * 8);

			setTimeout(function () {
				_this8.plungeDepth = 10;
			}, changeTiming * 10);

			setTimeout(function () {
				_this8.showEnterContainer = false;
			}, 2200);

			setTimeout(function () {
				_this8.showAllControls = true;
			}, 2200);

			setTimeout(function () {
				_this8.showNavBar = true;
			}, 2400);

			setTimeout(function () {
				_this8.showMicRecording = true;
			}, 2200);

			setTimeout(function () {
				_this8.showSpeechBtns = true;
			}, 2300);

			setTimeout(function () {
				_this8.ambience6Boolean = true;
			}, 1000);

			setTimeout(function () {
				if (_this8.userMobile === false) {
					_this8.activeSun = true;
				}
			}, 2000);
		},

		//RANDOMIZE (MATT CHILL) PRESET
		mattChillMethod: function mattChillMethod() {
			if (this.didWeAdventure) {
				this.stopExplore();
			}

			if (this.randomizeBoolean === false) {
				this.randomizeBoolean = true;
			}

			this.mattChill = !this.mattChill;

			this.ambience1Vol = Math.floor(Math.random() * 30 - 30);
			this.ambience2Vol = Math.floor(Math.random() * 30 - 30);
			this.ambience3Vol = Math.floor(Math.random() * 20 - 20);
			this.ambience4Vol = Math.floor(Math.random() * 30 - 30);
			this.ambience5Vol = Math.floor(Math.random() * 20 - 20);
			this.ambience6Vol = Math.floor(Math.random() * 30 - 30);

			// let fx1boolean 		= Math.random() >= 0.5,
			// 	fx2boolean 		= Math.random() >= 0.5,
			// 	fx3boolean 		= Math.random() >= 0.5,
			// 	fx4boolean 		= Math.random() >= 0.5,
			// 	fx5boolean 		= Math.random() >= 0.5;

			var amb1boolean = Math.random() >= 0.5,
			    amb2boolean = Math.random() >= 0.5,
			    amb3boolean = Math.random() >= 0.5,
			    amb4boolean = Math.random() >= 0.5,
			    amb5boolean = Math.random() >= 0.5,
			    amb6boolean = Math.random() >= 0.5;

			// if (this.mattChill === true){
			//DON'T CALCULATE ON MOBILE
			if (this.userMobile === false) {
				var
				// randomVerb 		= Math.floor((Math.random() * 40) + 0),
				randomDelay = Math.floor(Math.random() * 20 + 0),
				    randomChorus = Math.floor(Math.random() * 30 + 0),
				    randomFilter = Math.floor(Math.random() * 20000 + 500);

				// this.fxConvolverAmt 	= randomVerb;
				this.fxDelayAmt = randomDelay;
				this.fxChorusAmt = randomChorus;
				this.fxAutoFilterAmt = randomFilter;

				this.fxDecay = Math.random() * 10 + 1.5;
				var fxPreDelay = Math.random() * 0.1 + 0.03;
				this.fxConvolver.decay = this.fxDecay;
				this.fxConvolver.preDelay = fxPreDelay;
				this.fxConvolver.generate();
			}
			//CALCULATE ON MOBILE & DESKTOP
			var randomSpeed = Math.random() * (1.5 - 0.5) + 0.5;
			this.playBackSpeed = randomSpeed;

			if (amb3boolean === true) {
				this.ambience3Boolean = true;
				this.showFlask3 = true;
			} else {
				this.ambience3Boolean = false;
				this.showFlask3 = false;
			}

			if (amb4boolean === true) {
				this.ambience4Boolean = true;
				this.showFlask4 = true;
			} else {
				this.ambience4Boolean = false;
				this.showFlask4 = false;
			}

			if (amb5boolean === true) {
				this.ambience5Boolean = true;
				this.showFlask5 = true;
			} else {
				this.ambience5Boolean = false;
				this.showFlask5 = false;
			}

			if (amb6boolean === true) {
				this.ambience6Boolean = true;
				this.showFlask6 = true;
			} else {
				this.ambience6Boolean = false;
				this.showFlask6 = false;
			}
			//IF STORMY BEACH PLAY NO HUMAN BEACHES
			if (amb1boolean === true) {
				this.ambience1Boolean = true;
				this.showFlask1 = true;

				this.ambience3Boolean = false;
				this.showFlask3 = false;

				this.ambience4Boolean = false;
				this.showFlask4 = false;

				this.ambience5Boolean = false;
				this.showFlask5 = false;
			} else {
				this.ambience1Boolean = false;
				this.showFlask1 = false;
			}

			//IF CLIFF SIDE PLAY NO HUMAN BEACHES
			if (amb2boolean === true) {
				this.ambience2Boolean = true;
				this.showFlask2 = true;

				this.ambience3Boolean = false;
				this.showFlask3 = false;

				this.ambience4Boolean = false;
				this.showFlask4 = false;

				this.ambience5Boolean = false;
				this.showFlask5 = false;

				this.ambience6Boolean = false;
				this.showFlask6 = false;
			} else {
				this.ambience2Boolean = false;
				this.showFlask2 = false;
			}

			if (amb1boolean === false && amb2boolean === false && amb3boolean === false && amb4boolean === false && amb5boolean === false && amb6boolean === false) {
				this.ambience6Boolean = true;
				this.showFlask6 = true;
			}

			// } else if (this.mattChill === false){
			// this.fxDelayToggle = false;
			// this.fxConvolverToggle = false;
			// this.fxChorusToggle = false;
			// this.fxFilterToggle = false;
			// this.speedToggle = false;
			// } 
		},

		//EXPLORE 
		exploreBtnFunc: function exploreBtnFunc() {
			this.exploreBtnBoolean = !this.exploreBtnBoolean;
			if (this.exploreBtnBoolean) {
				this.exploreFunc();
			} else if (!this.exploreBtnBoolean) {
				this.stopExplore();
			}
		},
		exploreFunc: function exploreFunc() {
			var _this9 = this;

			//AUDIO MIXING FUNCTION
			var int = 2000;
			var runExplore = function runExplore() {
				_this9.exploreSound1.start();
				_this9.exploreTxt = "Exploring";
				_this9.ambience2Boolean = true;
				_this9.exploreTimeout1 = setTimeout(function () {
					_this9.ambience2Vol = -10;
				}, int * 1);
				_this9.exploreTimeout2 = setTimeout(function () {
					_this9.ambience2Vol = -9;
				}, int * 2);
				_this9.exploreTimeout3 = setTimeout(function () {
					_this9.ambience2Vol = -8;
				}, int * 3);
				_this9.exploreTimeout4 = setTimeout(function () {
					_this9.ambience2Vol = -7;
				}, int * 4);
				_this9.exploreTimeout5 = setTimeout(function () {
					_this9.ambience2Vol = -6;
				}, int * 5);
				_this9.exploreTimeout6 = setTimeout(function () {
					_this9.ambience2Vol = -5;
				}, int * 6);
				_this9.exploreTimeout7 = setTimeout(function () {
					_this9.ambience2Vol = -4;
				}, int * 7);
				_this9.exploreTimeout8 = setTimeout(function () {
					_this9.ambience2Vol = -3;
				}, int * 8);
				_this9.exploreTimeout9 = setTimeout(function () {
					_this9.ambience2Vol = -2;
				}, int * 9);
				_this9.exploreTimeout10 = setTimeout(function () {
					_this9.ambience2Vol = -1;
				}, int * 10);
				_this9.exploreTimeout11 = setTimeout(function () {
					_this9.ambience2Vol = 0;
				}, int * 11);
				_this9.exploreTimeout12 = setTimeout(function () {
					_this9.ambience2Vol = 2;
					_this9.isExploreFuncRunning = false;
					_this9.exploreTxt = "Explore!";
				}, int * 12);
			};
			if (this.isExploreFuncRunning === false) {
				this.isExploreFuncRunning = true;
				//INIT EXPORE SCENE
				//GENERATE REVERB
				if (!this.userMobile) {
					this.fxDecay = 2.5;
					this.fxConvolver.decay = this.fxDecay;
					this.fxConvolver.preDelay = 0.4;
					this.fxConvolver.generate();
				}
				if (this.ambience1Player.state === "started") {
					this.ambience1Player.stop();
					this.ambience1Boolean = false;
					this.ambience1Vol = -30;
				} else {
					this.ambience1Vol = -30;
				}

				if (this.ambience2Player.state === "stopped") {
					this.ambience2Player.start();
					this.ambience2Boolean = true;
					this.ambience2Vol = -10;
				} else {
					this.ambience2Vol = -10;
				}

				if (this.ambience3Player.state === "started") {
					this.ambience3Player.stop();
					this.ambience3Boolean = false;
					this.ambience3Vol = -30;
				} else {
					this.ambience3Vol = -30;
				}

				if (this.ambience4Player.state === "started") {
					this.ambience4Player.stop();
					this.ambience4Boolean = false;
					this.ambience4Vol = -30;
				} else {
					this.ambience4Vol = -30;
				}

				if (this.ambience5Player.state === "started") {
					this.ambience5Player.stop();
					this.ambience5Boolean = false;
					this.ambience5Vol = -30;
				} else {
					this.ambience5Vol = -30;
				}

				if (this.ambience6Player.state === "started") {
					this.ambience6Player.stop();
					this.ambience6Boolean = false;
					this.ambience6Vol = -30;
				} else {
					this.ambience6Vol = -30;
				}

				if (!this.didWeAdventure) {
					this.exploreSound1 = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
						"playbackRate": 1,
						"loop": false,
						"volume": 0
					}).connect(this.masterVolumeSub);

					//LOADING FOR BROWSER TYPE
					if (this.isChrome === true || this.isOpera === true || this.isFirefox === true || this.isBlink === true) {

						this.exploreSound1.load("../src/assets/sounds/modules/beach/hiogg/exporeSound1Beach.ogg", function () {
							runExplore();
						});
					} else if (this.AndroidMobile === true) {
						this.exploreSound1.load("../src/assets/sounds/modules/beach/lowogg/exporeSound1Beach.ogg", function () {
							runExplore();
						});
					} else if (this.isSafari === true || this.isEdge === true || this.isIE === true) {
						this.exploreSound1.load("../src/assets/sounds/modules/beach/320/exporeSound1Beach.m4a", function () {
							runExplore();
						});
					} else if (this.iOS === true) {
						this.exploreSound1.load("../src/assets/sounds/modules/beach/192/exporeSound1Beach.m4a", function () {
							runExplore();
						});
					}
					//CLEANS UP AND DISPOSES THESE PLAYERS WHEN GOING HOME
					this.didWeAdventure = true;
				} else if (this.didWeAdventure) {
					runExplore();
				}
			} else {}
		},
		stopExplore: function stopExplore() {
			this.exploreTxt = "Explore!";
			this.exploreSound1.stop();
			this.isExploreFuncRunning = false;
			clearInterval(this.exploreTimeout1);
			clearInterval(this.exploreTimeout2);
			clearInterval(this.exploreTimeout3);
			clearInterval(this.exploreTimeout4);
			clearInterval(this.exploreTimeout5);
			clearInterval(this.exploreTimeout6);
			clearInterval(this.exploreTimeout7);
			clearInterval(this.exploreTimeout8);
			clearInterval(this.exploreTimeout9);
			clearInterval(this.exploreTimeout10);
			clearInterval(this.exploreTimeout11);
			clearInterval(this.exploreTimeout12);
		},

		//MASTER METERING
		masterMetering: function masterMetering() {
			this.masterLevel = this.masterMeter.getLevel();
		},

		//MAIN SHOW AND HIDE
		goToHelp: function goToHelp() {
			var _this10 = this;

			this.showHelpOverlay = !this.showHelpOverlay;
			this.helpTrigger = !this.helpTrigger;

			if (this.showHelpOverlay === true) {

				setTimeout(function () {
					_this10.showNavBar = false;
					if (_this10.$store.state.allowSpeechControl) {
						_this10.showSpeechBtns = false;
					}
				}, 100);

				setTimeout(function () {
					_this10.showAllControls = false;
				}, 250);

				setTimeout(function () {
					_this10.showAboutPage = true;
				}, 1000);
			} else if (this.showHelpOverlay === false) {

				this.showAboutPage = false;

				setTimeout(function () {
					_this10.showAllControls = true;
				}, 800);

				setTimeout(function () {
					_this10.showNavBar = true;
					if (_this10.$store.state.allowSpeechControl) {
						_this10.showSpeechBtns = true;
					}
				}, 850);
			}
		},

		//BUFFER LOADING
		bufferLoading: function bufferLoading() {
			var _this11 = this;

			// Tone.Buffer.on('progress', ()=>{
			// });
			__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Buffer.on('load', function () {
				//HIDE LOADING ITEMS
				_this11.showLoading = false;
				//SHOW ENTER BUTTON
				setTimeout(function () {
					_this11.showEnterBtn = true;
				}, 1000);
				//AUTO OPEN MODULE IF VOICE CONTROLLED & DO NOT REPLAY WHEN EXPLORE AUDIO LOADS 
				//ADDITIONALLY DO NOT REPLAY IF USER MIC HAS BEEN ACTIVATED FOR RECORDING
				if (_this11.isVoiceControl) {
					if (!_this11.didWeAdventure) {
						setTimeout(_this11.enterFunc, 2000);
					}
				}
				//IF VOICE CONTROL IS ACTIVE GLOBALLY ACTIVATE IN THIS MODULE
				if (_this11.isVoiceControl === true) {
					_this11.speechFunc();
				}
			});
		},

		//AUDIO ROUTING
		audioRouting: function audioRouting() {
			if (this.isChrome === true || this.AndroidMobile === true || this.isOpera === true || this.isFirefox === true || this.isBlink === true) {
				if (this.userMobile === false) {

					this.fxConvolver = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Reverb({
						"decay": 1.5,
						"preDelay": 0.01
					});
					this.fxConvolver.decay = 2.5;
					this.fxConvolver.generate();
					this.fxAutoFilter = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Filter({
						"type": "lowpass",
						"frequency": 20000,
						"rolloff": -24,
						"Q": 1,
						"gain": 0
					});
					this.fxDelay = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.PingPongDelay(0.55, 0.45);
					this.fxChorus = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Chorus(1.3, 9.4, 0.35);
					this.masterMeter = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Meter({
						"smoothing": .4
					});
					this.ambience1Player.connect(this.masterVolumeSub);
					this.ambience2Player.connect(this.masterVolumeSub);
					this.ambience3Player.connect(this.masterVolumeSub);
					this.ambience4Player.connect(this.masterVolumeSub);
					this.ambience5Player.connect(this.masterVolumeSub);
					this.ambience6Player.connect(this.masterVolumeSub);

					this.masterVolumeSub.chain(this.fxAutoFilter, this.fxConvolver, this.fxDelay, this.fxChorus, this.masterMeter, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master);
					console.log('Chrome/Opera/FireFox Desktop');
					setInterval(this.masterMetering, 60);
				} else if (this.userMobile === true) {
					this.ambience1Player.connect(this.masterVolumeSub);
					this.ambience2Player.connect(this.masterVolumeSub);
					this.ambience3Player.connect(this.masterVolumeSub);
					this.ambience4Player.connect(this.masterVolumeSub);
					this.ambience5Player.connect(this.masterVolumeSub);
					this.ambience6Player.connect(this.masterVolumeSub);

					this.masterVolumeSub.connect(__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master);

					console.log('Chrome/Opera/FireFox Mobile');
				}
			} else if (this.isSafari === true || this.iOS === true || this.isEdge === true || this.isIE === true) {
				if (this.userMobile === false) {
					this.fxConvolver = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Reverb({
						"decay": 1.5,
						"preDelay": 0.01
					});
					this.fxConvolver.decay = 2.5;
					this.fxConvolver.generate();
					this.fxAutoFilter = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Filter({
						"type": "lowpass",
						"frequency": 20000,
						"rolloff": -24,
						"Q": 1,
						"gain": 0
					});
					this.fxDelay = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.PingPongDelay(0.55, 0.45);
					this.fxChorus = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Chorus(1.3, 9.4, 0.35);
					this.masterMeter = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Meter({
						"smoothing": .4
					});
					this.ambience1Player.connect(this.masterVolumeSub);
					this.ambience2Player.connect(this.masterVolumeSub);
					this.ambience3Player.connect(this.masterVolumeSub);
					this.ambience4Player.connect(this.masterVolumeSub);
					this.ambience5Player.connect(this.masterVolumeSub);
					this.ambience6Player.connect(this.masterVolumeSub);

					this.masterVolumeSub.chain(this.fxAutoFilter, this.fxConvolver, this.fxDelay, this.fxChorus, this.masterMeter, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master);
					console.log('Safari/Edge/iOS Desktop');
					setInterval(this.masterMetering, 60);
				} else if (this.userMobile === true) {
					this.ambience1Player.connect(this.masterVolumeSub);
					this.ambience2Player.connect(this.masterVolumeSub);
					this.ambience3Player.connect(this.masterVolumeSub);
					this.ambience4Player.connect(this.masterVolumeSub);
					this.ambience5Player.connect(this.masterVolumeSub);
					this.ambience6Player.connect(this.masterVolumeSub);

					this.masterVolumeSub.connect(__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master);
					console.log('Safari/Edge/iOS Mobile');
				}
			} else {}
		},

		//AUDIO LOADING
		firstAudioLoadFunc: function firstAudioLoadFunc() {
			var _this12 = this;

			// this.changeFX.load("../src/assets/sounds/blinks/change.wav", 
			// 	()=>{
			// 	this.whatIsLoading = "Sand";
			// });

			// this.BeachFX.load("../src/assets/sounds/modules/beach/beachFX.wav", 
			// 	()=>{
			// 	this.whatIsLoading = "Beach Vibes";
			// });

			// this.ambience1Player.load("../src/assets/sounds/modules/beach/cavebeach.wav", 
			// 	()=>{
			// 	this.whatIsLoading = "Cave Beach";
			// });

			// this.ambience2Player.load("../src/assets/sounds/modules/beach/cliffbeach.wav", 
			// 	()=>{
			// 	this.whatIsLoading = "Cliff Beach";
			// });

			// this.ambience3Player.load("../src/assets/sounds/modules/beach/venicebeach.wav", 
			// 	()=>{
			// 	this.whatIsLoading = "Venice Beach";
			// });

			// this.ambience4Player.load("../src/assets/sounds/modules/beach/lavabeach.wav", 
			// 	()=>{
			// 	this.whatIsLoading = "Lava Beach";
			// });

			// this.ambience5Player.load("../src/assets/sounds/modules/beach/coneyisland.wav", 
			// 	()=>{
			// 	this.whatIsLoading = "Coney Island";
			// });

			// this.ambience6Player.load("../src/assets/sounds/modules/beach/serenebeach.wav", 
			// 	()=>{
			// 	this.whatIsLoading = "Serene Beach";
			// });

			if (this.isChrome === true || this.isOpera === true || this.isFirefox === true || this.isBlink === true) {

				this.changeFX.load("../src/assets/sounds/blinks/change.ogg", function () {
					_this12.whatIsLoading = "Sand";
				});

				this.BeachFX.load("../src/assets/sounds/modules/beach/hiogg/beachFX.ogg", function () {
					_this12.whatIsLoading = "Beach Vibes";
				});

				this.ambience1Player.load("../src/assets/sounds/modules/beach/hiogg/umbrella.ogg", function () {
					_this12.whatIsLoading = "Stormy Beach";
				});

				this.ambience2Player.load("../src/assets/sounds/modules/beach/hiogg/thunderhole.ogg", function () {
					_this12.whatIsLoading = "Cliff Side";
				});

				this.ambience3Player.load("../src/assets/sounds/modules/beach/hiogg/venicebeach.ogg", function () {
					_this12.whatIsLoading = "Venice Beach";
				});

				this.ambience4Player.load("../src/assets/sounds/modules/beach/hiogg/lavabeach.ogg", function () {
					_this12.whatIsLoading = "Lava Beach";
				});

				this.ambience5Player.load("../src/assets/sounds/modules/beach/hiogg/coneyisland.ogg", function () {
					_this12.whatIsLoading = "Coney Island";
				});

				this.ambience6Player.load("../src/assets/sounds/modules/beach/hiogg/serenebeach.ogg", function () {
					_this12.whatIsLoading = "Serene Beach";
				});
			} else if (this.AndroidMobile === true) {
				this.changeFX.load("../src/assets/sounds/blinks/change.ogg", function () {
					_this12.whatIsLoading = "Sand";
				});

				this.BeachFX.load("../src/assets/sounds/modules/beach/lowogg/beachFX.ogg", function () {
					_this12.whatIsLoading = "Beach Vibes";
				});

				this.ambience1Player.load("../src/assets/sounds/modules/beach/lowogg/umbrella.ogg", function () {
					_this12.whatIsLoading = "Stormy Beach";
				});

				this.ambience2Player.load("../src/assets/sounds/modules/beach/lowogg/thunderhole.ogg", function () {
					_this12.whatIsLoading = "Cliff Side";
				});

				this.ambience3Player.load("../src/assets/sounds/modules/beach/lowogg/venicebeach.ogg", function () {
					_this12.whatIsLoading = "Venice Beach";
				});

				this.ambience4Player.load("../src/assets/sounds/modules/beach/lowogg/lavabeach.ogg", function () {
					_this12.whatIsLoading = "Lava Beach";
				});

				this.ambience5Player.load("../src/assets/sounds/modules/beach/lowogg/coneyisland.ogg", function () {
					_this12.whatIsLoading = "Coney Island";
				});

				this.ambience6Player.load("../src/assets/sounds/modules/beach/lowogg/serenebeach.ogg", function () {
					_this12.whatIsLoading = "Serene Beach";
				});
			} else if (this.isSafari === true || this.isEdge === true || this.isIE === true) {

				this.changeFX.load("../src/assets/sounds/blinks/change.m4a", function () {
					_this12.whatIsLoading = "Sand";
				});

				this.BeachFX.load("../src/assets/sounds/modules/beach/320/beachFX.m4a", function () {
					_this12.whatIsLoading = "Beach Vibes";
				});

				this.ambience1Player.load("../src/assets/sounds/modules/beach/320/umbrella.m4a", function () {
					_this12.whatIsLoading = "Stormy Beach";
				});

				this.ambience2Player.load("../src/assets/sounds/modules/beach/320/thunderhole.m4a", function () {
					_this12.whatIsLoading = "Cliff Side";
				});

				this.ambience3Player.load("../src/assets/sounds/modules/beach/320/venicebeach.m4a", function () {
					_this12.whatIsLoading = "Venice Beach";
				});

				this.ambience4Player.load("../src/assets/sounds/modules/beach/320/lavabeach.m4a", function () {
					_this12.whatIsLoading = "Lava Beach";
				});

				this.ambience5Player.load("../src/assets/sounds/modules/beach/320/coneyisland.m4a", function () {
					_this12.whatIsLoading = "Coney Island";
				});

				this.ambience6Player.load("../src/assets/sounds/modules/beach/320/serenebeach.m4a", function () {
					_this12.whatIsLoading = "Serene Beach";
				});
			} else if (this.iOS === true) {
				this.changeFX.load("../src/assets/sounds/blinks/change.m4a", function () {
					_this12.whatIsLoading = "Sand";
				});

				this.BeachFX.load("../src/assets/sounds/modules/beach/192/beachFX.m4a", function () {
					_this12.whatIsLoading = "Beach Vibes";
				});

				this.ambience1Player.load("../src/assets/sounds/modules/beach/192/umbrella.m4a", function () {
					_this12.whatIsLoading = "Stormy Beach";
				});

				this.ambience2Player.load("../src/assets/sounds/modules/beach/192/thunderhole.m4a", function () {
					_this12.whatIsLoading = "Cliff Side";
				});

				this.ambience3Player.load("../src/assets/sounds/modules/beach/192/venicebeach.m4a", function () {
					_this12.whatIsLoading = "Venice Beach";
				});

				this.ambience4Player.load("../src/assets/sounds/modules/beach/192/lavabeach.m4a", function () {
					_this12.whatIsLoading = "Lava Beach";
				});

				this.ambience5Player.load("../src/assets/sounds/modules/beach/192/coneyisland.m4a", function () {
					_this12.whatIsLoading = "Coney Island";
				});

				this.ambience6Player.load("../src/assets/sounds/modules/beach/192/serenebeach.m4a", function () {
					_this12.whatIsLoading = "Serene Beach";
				});
			}
		},

		//GO HOME
		goHome: function goHome() {
			var _this13 = this;

			this.changeFX.start();

			//IF USER ENGAGES VOICE CONTROL BUT GOES HOME VIA 
			//MOUSE BUTTON THIS TRIGGERS MODULE SPEECH DISPOSE
			if (this.goingHomeNotViaVoiceCommand && !this.initSpeech) {
				this.stopModuleSpeech = true;
				this.recognitionBeach.stop();
				this.recognitionBeach.abort();
				this.recognitionBeach = undefined;
			};

			if (this.didWeAdventure === true) {
				this.exploreSound1.disconnect();
				// this.exploreSound2.disconnect();
				// this.exploreSound3.disconnect();
			}

			setTimeout(function () {
				__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.2);
			}, 400);

			setTimeout(function () {
				_this13.ambience1Player.disconnect();
				_this13.ambience2Player.disconnect();
				_this13.ambience3Player.disconnect();
				_this13.ambience4Player.disconnect();
				_this13.ambience5Player.disconnect();
				_this13.ambience6Player.disconnect();
				_this13.BeachFX.disconnect();
				_this13.changeFX.disconnect();
				_this13.masterVolumeSub.disconnect();
				if (_this13.userMobile === false) {
					_this13.fxConvolver.disconnect();
					_this13.fxAutoFilter.disconnect();
					_this13.fxDelay.disconnect();
					_this13.fxChorus.disconnect();
					_this13.masterMeter.disconnect();
				}
			}, 1000);

			setTimeout(function () {
				document.body.className = 'default';
				_this13.$router.push('/');
				__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master.volume.value = 0;
			}, 1100);
		}
	}
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_startaudiocontext_StartAudioContext_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_startaudiocontext_StartAudioContext_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_startaudiocontext_StartAudioContext_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var XRegExp = __webpack_require__(5);
/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			//RANDOMIZE BOOLEANS
			randomizeBoolean: false,
			showFlask1: true,
			showFlask2: false,
			showFlask3: false,
			showFlask4: false,
			showFlask5: false,
			showFlask6: false,
			//CONTROLS
			reverbChecker: undefined,
			loadingBoolean: true,
			userMobile: Boolean,
			mailingListBtn: false,
			textTiming: 500,
			startStopTrigger: true,
			playColor: "#F0CB50",
			stopColor: "#1E9BFC",
			//SCREEN DIMENSIONS
			screenHeight: undefined,
			screenWidth: undefined,
			ogWidth: undefined,
			//BACKGROUND COLORS
			plungeDepth: 1,
			backgroundColor1: true,
			backgroundColor2: false,
			backgroundColor3: false,
			backgroundColor4: false,
			backgroundColor5: false,
			backgroundColor6: false,
			backgroundColor7: false,
			backgroundColor8: false,
			backgroundColor9: false,
			backgroundColor10: false,
			//REACTIVE SUN
			sunReactiveColor1: true,
			sunReactiveColor2: false,
			sunReactiveColor3: false,
			sunReactiveColor4: false,
			sunReactiveColor5: false,
			sunReactiveColor6: false,
			sunReactiveColor7: false,
			sunReactiveColor8: false,
			sunReactiveColor9: false,
			sunReactiveColor10: false,
			//SHOW AND HIDE
			helpTrigger: false,
			showHelpOverlay: false,
			showAboutPage: false,
			//PLAY SUN DRAGGIE
			activeSun: false,
			//V-SHOWS
			showEnterContainer: true,
			showLoading: true,
			showEnterBtn: false,
			showNavBar: false,
			showAllControls: false,
			showSpeechBtns: false,
			//AMBIENCE BOOLEANS
			ambience1Boolean: false,
			ambience2Boolean: false,
			ambience3Boolean: false,
			ambience4Boolean: false,
			ambience5Boolean: false,
			ambience6Boolean: false,
			//AMBIENCE DATA
			whatIsLoading: "Desert",
			DesertFX: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": false,
				"volume": -5
			}).toMaster(),
			changeFX: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": false,
				"volume": -6
			}).toMaster(),
			ambience1Vol: -20,
			ambience2Vol: -15,
			ambience3Vol: -15,
			ambience4Vol: -15,
			ambience5Vol: -15,
			ambience6Vol: -17,
			ambience1Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": 0
			}),
			ambience2Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": 0
			}),
			ambience3Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": 0
			}),
			ambience4Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": 0
			}),
			ambience5Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": 0
			}),
			ambience6Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": 0
			}),
			//AUDIO ROUTING & EFFECTS
			playBackSpeed: 1,
			fxDecay: 2.5,
			// masterVolume:     		0,
			loadingSoundID: undefined,
			audioLoading: undefined,
			fxConvolverAmt: 0,
			fxChorusAmt: 0,
			fxDelayAmt: 0,
			fxAutoFilterAmt: 3500,
			mattChill: false,
			fxConvolver: undefined,
			fxChorus: undefined,
			fxDelay: undefined,
			fxAutoFilter: undefined,

			speedToggle: true,
			fxDelayToggle: true,
			fxConvolverToggle: true,
			fxChorusToggle: true,
			fxFilterToggle: false,

			masterMeter: undefined,
			masterLevel: 0,
			masterVolumeSub: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Volume(0),
			//SPEECH
			//FOR SPEECH FORM INPUT
			submitSpeechTxttoVoice: false,
			userVoiceToText: "",
			//EQ THAT COMES ON TO CUT 3kHZ WHEN SPEECH IS DETECTED
			voiceAdjustEQ: undefined,
			//IF SPEECH IS ALLOWED SHOW SPEECH ACTIVATE BUTTON (SET VIA APP.js)
			allowSpeechControl: false,
			//GLOBAL COMMAND TRIGGERING VOICE COMMANDS ON AND OFF
			isVoiceControl: false,
			//COMMAND FOR CSS CONTROL WHEN VOICE IS ACTIVE <br> NOT
			recognizing: undefined,
			recognitionDesert: undefined,
			//HOLDS ALL OF SPEECHRECONGNITION JSON
			voiceCommandArray: undefined,
			speechRecognitionList: undefined,
			voiceCommandConfidence: undefined,
			//STRING LINE TO TEST FOR VOICE COMMAND ACTIONS
			testObjectVUI: "",
			//BUTTON SWITCHING & TEXT
			initSpeech: true,
			speechBtnTxt: "Say A Command",
			speechStartTopBtnTrigger: true,
			//SHOWS LIST OF COMMANDS
			showVoiceCommandList: false,
			//DISABLE WHILE RECORDING
			isDisableListening: false,
			//TRUE WHEN STOPPING ALL SPEECH FUNCTIONS TO GO HOME
			stopModuleSpeech: false,
			//IF USER ENGAGES VOICE CONTROL BUT GOES HOME VIA MOUSE BUTTON THIS TRIGGERS MODULE SPEECH DISPOSE
			//EXPLORE
			isExploreFuncRunning: false,
			didWeAdventure: false,
			exploreSound1: undefined,
			exploreBtnBoolean: false,
			//WHAT DEVICE
			isChrome: Boolean,
			isFirefox: Boolean,
			isSafari: Boolean,
			isOpera: Boolean,
			isIE: Boolean,
			isEdge: Boolean,
			isBlink: Boolean,
			iOS: Boolean,
			AndroidMobile: Boolean,
			//EXPLORE TIMES OUTS
			exploreTxt: "Explore!",
			exploreTimeout1: undefined,
			exploreTimeout2: undefined,
			exploreTimeout3: undefined,
			exploreTimeout4: undefined,
			exploreTimeout5: undefined,
			exploreTimeout6: undefined,
			exploreTimeout7: undefined,
			exploreTimeout8: undefined,
			exploreTimeout9: undefined,
			exploreTimeout10: undefined,
			exploreTimeout11: undefined,
			exploreTimeout12: undefined,
			exploreTimeout13: undefined,
			exploreTimeout14: undefined,
			//START AUDIO CONTEXT BOOLEAN
			startAudioBoolean: true,
			//LOCAL STORAGE
			isCacheSaved: false,
			firstLoad: false,
			saveTrigger: false,
			loadTrigger: false
		};
	},
	created: function created() {
		var _this = this;

		this.isVoiceControl = this.$store.state.isVoiceControlled;
		if (this.isVoiceControl) {
			this.$store.state.doNotAddress = true;
		}

		window.onpopstate = function () {
			document.body.className = 'default';
			_this.goHome();
		};
		var ua = window.navigator.userAgent;
		this.isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
		this.isFirefox = typeof InstallTrigger !== 'undefined';
		this.isSafari = /constructor/i.test(window.HTMLElement) || function (p) {
			return p.toString() === "[object SafariRemoteNotification]";
		}(!window['safari'] || safari.pushNotification);
		this.isOpera = !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
		this.isIE = /*@cc_on!@*/false || !!document.documentMode;
		this.isEdge = !this.isIE && !!window.StyleMedia;
		this.isBlink = (this.isChrome || this.isOpera) && !!window.CSS, this.iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
		this.AndroidMobile = /Android/i.test(navigator.userAgent);
		//CHROME ALLOWS SPEECH AND MEDIA RECORDING
		if (this.isChrome === true) {
			this.userMobile = false;
			//FIREFOX ONLY ALLOWS MEDIA RECORDING
		} else if (this.isFirefox === true) {
			this.userMobile = false;
			//NO SPEECH AND NO MEDIA RECORDING FOR THE FOLLOWING
		} else if (this.AndroidMobile === true || this.iOS) {
			this.userMobile = true;
		} else if (this.isSafari === true || this.isOpera === true || this.isBlink === true || this.isEdge === true || this.isIE === true) {
			this.userMobile = false;
		}
		this.firstAudioLoadFunc();
		this.bufferLoading();
		this.audioRouting();
	},

	computed: {
		//THE PLUNGE BACKGROUND CHANGE
		plungeClass: function plungeClass() {
			if (this.activeSun === false) {
				if (this.plungeDepth === 1) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = true;
				} else if (this.plungeDepth === 2) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = true;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 3) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = true;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 4) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = true;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 5) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = true;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 6) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = true;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 7) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = true;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 8) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = true;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 9) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = true;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 10) {
					this.backgroundColor10 = true;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				}
				return {
					"backgroundColorDesert10": this.backgroundColor10,
					"backgroundColorDesert9": this.backgroundColor9,
					"backgroundColorDesert8": this.backgroundColor8,
					"backgroundColorDesert7": this.backgroundColor7,
					"backgroundColorDesert6": this.backgroundColor6,
					"backgroundColorDesert5": this.backgroundColor5,
					"backgroundColorDesert4": this.backgroundColor4,
					"backgroundColorDesert3": this.backgroundColor3,
					"backgroundColorDesert2": this.backgroundColor2,
					"backgroundColorDesert1": this.backgroundColor1
				};
			} else if (this.activeSun === true) {
				if (this.masterLevel < -44) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = true;
				} else if (this.masterLevel < -42) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = true;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -38) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = true;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -34) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = true;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -30) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = true;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -26) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = true;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -22) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = true;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -18) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = true;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -14) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = true;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel > -10) {
					this.sunReactiveColor10 = true;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				}
				return {
					"sunReactiveColorClassDesert10": this.sunReactiveColor10,
					"sunReactiveColorClassDesert9": this.sunReactiveColor9,
					"sunReactiveColorClassDesert8": this.sunReactiveColor8,
					"sunReactiveColorClassDesert7": this.sunReactiveColor7,
					"sunReactiveColorClassDesert6": this.sunReactiveColor6,
					"sunReactiveColorClassDesert5": this.sunReactiveColor5,
					"sunReactiveColorClassDesert4": this.sunReactiveColor4,
					"sunReactiveColorClassDesert3": this.sunReactiveColor3,
					"sunReactiveColorClassDesert2": this.sunReactiveColor2,
					"sunReactiveColorClassDesert1": this.sunReactiveColor1
				};
			}
		},

		//SHOW AND HIDE CLASS CHANGES
		helpClass: function helpClass() {
			return {
				"btn btn-helpBtn1Desert": this.helpTrigger,
				"btn btn-helpBtn2Desert": !this.helpTrigger
			};
		},
		mailingListBtnClass: function mailingListBtnClass() {
			return {
				"btn btn-transparent": this.mailingListBtn,
				"btn btn-info": !this.mailingListBtn
			};
		},

		//AMBIENCE CLASS CHANGES
		ambience1Class: function ambience1Class() {
			return {
				"btn btn-playDesert": this.ambience1Boolean,
				"btn btn-stopDesert": !this.ambience1Boolean
			};
		},
		ambience2Class: function ambience2Class() {
			return {
				"btn btn-playDesert": this.ambience2Boolean,
				"btn btn-stopDesert": !this.ambience2Boolean
			};
		},
		ambience3Class: function ambience3Class() {
			return {
				"btn btn-playDesert": this.ambience3Boolean,
				"btn btn-stopDesert": !this.ambience3Boolean
			};
		},
		ambience4Class: function ambience4Class() {
			return {
				"btn btn-playDesert": this.ambience4Boolean,
				"btn btn-stopDesert": !this.ambience4Boolean
			};
		},
		ambience5Class: function ambience5Class() {
			return {
				"btn btn-playDesert": this.ambience5Boolean,
				"btn btn-stopDesert": !this.ambience5Boolean
			};
		},
		ambience6Class: function ambience6Class() {
			return {
				"btn btn-playDesert": this.ambience6Boolean,
				"btn btn-stopDesert": !this.ambience6Boolean
			};
		},
		mattChillClass: function mattChillClass() {
			return {
				"btn btn-mattChillOnDesert": this.mattChill,
				"btn btn-mattChillOffDesert": !this.mattChill
			};
		},

		//AMBIENCE ICON CSS
		ambience1Icon: function ambience1Icon() {
			return {
				"fal fa-times-circle": !this.ambience1Boolean,
				"fal fa-check-circle": this.ambience1Boolean
			};
		},
		ambience2Icon: function ambience2Icon() {
			return {
				"fal fa-times-circle": !this.ambience2Boolean,
				"fal fa-check-circle": this.ambience2Boolean
			};
		},
		ambience3Icon: function ambience3Icon() {
			return {
				"fal fa-times-circle": !this.ambience3Boolean,
				"fal fa-check-circle": this.ambience3Boolean
			};
		},
		ambience4Icon: function ambience4Icon() {
			return {
				"fal fa-times-circle": !this.ambience4Boolean,
				"fal fa-check-circle": this.ambience4Boolean
			};
		},
		ambience5Icon: function ambience5Icon() {
			return {
				"fal fa-times-circle": !this.ambience5Boolean,
				"fal fa-check-circle": this.ambience5Boolean
			};
		},
		ambience6Icon: function ambience6Icon() {
			return {
				"fal fa-times-circle": !this.ambience6Boolean,
				"fal fa-check-circle": this.ambience6Boolean
			};
		},

		//AMBIANCE CLASS CHANGES
		ambiance1RangerClass: function ambiance1RangerClass() {
			return {
				"ambianceRangerPlayDesert": this.ambience1Boolean,
				"ambianceRangerStopDesert": !this.ambience1Boolean
			};
		},
		ambiance2RangerClass: function ambiance2RangerClass() {
			return {
				"ambianceRangerPlayDesert": this.ambience2Boolean,
				"ambianceRangerStopDesert": !this.ambience2Boolean
			};
		},
		ambiance3RangerClass: function ambiance3RangerClass() {
			return {
				"ambianceRangerPlayDesert": this.ambience3Boolean,
				"ambianceRangerStopDesert": !this.ambience3Boolean
			};
		},
		ambiance4RangerClass: function ambiance4RangerClass() {
			return {
				"ambianceRangerPlayDesert": this.ambience4Boolean,
				"ambianceRangerStopDesert": !this.ambience4Boolean
			};
		},
		ambiance5RangerClass: function ambiance5RangerClass() {
			return {
				"ambianceRangerPlayDesert": this.ambience5Boolean,
				"ambianceRangerStopDesert": !this.ambience5Boolean
			};
		},
		ambiance6RangerClass: function ambiance6RangerClass() {
			return {
				"ambianceRangerPlayDesert": this.ambience6Boolean,
				"ambianceRangerStopDesert": !this.ambience6Boolean
			};
		},

		//AUDIO MIXING
		adjustInputVolume: function adjustInputVolume() {
			this.userMic.volume.value = this.userMicInputLevel;
		},
		fxConvolverMix: function fxConvolverMix() {
			if (this.userMobile === false) {
				if (this.fxConvolverToggle === true) {
					this.fxConvolver.wet.setTargetAtTime(this.fxConvolverAmt / 100, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				} else if (this.fxConvolverToggle === false) {
					this.fxConvolver.wet.setTargetAtTime(0, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				}
			}
		},
		fxDelayMix: function fxDelayMix() {
			if (this.userMobile === false) {
				if (this.fxDelayToggle === true) {
					this.fxDelay.wet.setTargetAtTime(this.fxDelayAmt / 100, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +1);
				} else if (this.fxDelayToggle === false) {
					this.fxDelay.wet.setTargetAtTime(0, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +1);
				}
			}
		},
		fxChorusMix: function fxChorusMix() {
			if (this.userMobile === false) {
				if (this.fxChorusToggle === true) {
					this.fxChorus.wet.setTargetAtTime(this.fxChorusAmt / 100, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				} else if (this.fxChorusToggle === false) {
					this.fxChorus.wet.setTargetAtTime(0, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				}
			}
		},
		fxAutoFilterMix: function fxAutoFilterMix() {
			if (this.userMobile === false) {
				if (this.fxFilterToggle === true) {
					this.fxAutoFilter.frequency.setTargetAtTime(this.fxAutoFilterAmt, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				} else if (this.fxFilterToggle === false) {
					this.fxAutoFilter.frequency.setTargetAtTime(20000, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				}
			}
		},
		playbackSpeedFunc: function playbackSpeedFunc() {
			if (this.speedToggle === true) {
				this.ambience1Player.playbackRate = this.playBackSpeed;
				this.ambience2Player.playbackRate = this.playBackSpeed;
				this.ambience3Player.playbackRate = this.playBackSpeed;
				this.ambience4Player.playbackRate = this.playBackSpeed;
				this.ambience5Player.playbackRate = this.playBackSpeed;
				this.ambience6Player.playbackRate = this.playBackSpeed;
			} else if (this.speedToggle === false) {
				this.ambience1Player.playbackRate = 1;
				this.ambience2Player.playbackRate = 1;
				this.ambience3Player.playbackRate = 1;
				this.ambience4Player.playbackRate = 1;
				this.ambience5Player.playbackRate = 1;
				this.ambience6Player.playbackRate = 1;
			}
		},

		//SPEECH
		speechStartStopClass: function speechStartStopClass() {
			return {
				"recordingClassEngagedDesert": this.recognizing,
				"recordingClassDisengagedDesert": !this.recognizing
			};
		},
		speechIconClass: function speechIconClass() {
			return {
				"fa fa-microphone-alt fa-spin": this.recognizing,
				"fa fa-microphone-alt": !this.recognizing
			};
		},
		speechShowListClass: function speechShowListClass() {
			return {
				"recordingClassEngagedDesert": this.showVoiceCommandList,
				"recordingClassDisengagedDesert": !this.showVoiceCommandList
			};
		},
		speechSubmitClass: function speechSubmitClass() {
			return {
				"btn btn-speechSubmitOn mb-2": this.submitSpeechTxttoVoice,
				"btn btn-speechSubmitOff mb-2": !this.submitSpeechTxttoVoice
			};
		},

		//EXPLORE
		exploreFuncClass: function exploreFuncClass() {
			return {
				"recordingClassDisengagedDesert": !this.isExploreFuncRunning,
				"recordingClassEngagedDesert": this.isExploreFuncRunning
			};
		},
		exploreIconClass: function exploreIconClass() {
			return {
				"fab fa-wpexplorer": !this.isExploreFuncRunning,
				"fab fa-wpexplorer fa-spin": this.isExploreFuncRunning
			};
		},

		//AMBIENCE PLAY AND STOPS
		ambience1Func: function ambience1Func() {
			if (this.ambience1Boolean === true) {
				this.ambience1Player.volume.value = this.ambience1Vol;
			} else if (this.ambience1Boolean === false) {
				this.ambience1Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},
		ambience2Func: function ambience2Func() {
			if (this.ambience2Boolean === true) {
				this.ambience2Player.volume.value = this.ambience2Vol;
			} else if (this.ambience2Boolean === false) {
				this.ambience2Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},
		ambience3Func: function ambience3Func() {
			if (this.ambience3Boolean === true) {
				this.ambience3Player.volume.value = this.ambience3Vol;
			} else if (this.ambience3Boolean === false) {
				this.ambience3Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},
		ambience4Func: function ambience4Func() {
			if (this.ambience4Boolean === true) {
				this.ambience4Player.volume.value = this.ambience4Vol;
			} else if (this.ambience4Boolean === false) {
				this.ambience4Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},
		ambience5Func: function ambience5Func() {
			if (this.ambience5Boolean === true) {
				this.ambience5Player.volume.value = this.ambience5Vol;
			} else if (this.ambience5Boolean === false) {
				this.ambience5Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},
		ambience6Func: function ambience6Func() {
			if (this.ambience6Boolean === true) {
				this.ambience6Player.volume.value = this.ambience6Vol;
			} else if (this.ambience6Boolean === false) {
				this.ambience6Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},

		//LOCAL STORAGE
		saveClass: function saveClass() {
			return { "btn btn-playDesert": this.saveTrigger,
				"btn btn-stopDesert": !this.saveTrigger };
		},
		loadClass: function loadClass() {
			return { "btn btn-playDesert": this.loadTrigger,
				"btn btn-stopDesert": !this.loadTrigger };
		}
	},
	methods: {
		//LOCAL STORAGE
		setLocalStorage: function setLocalStorage() {
			var _this2 = this;

			this.saveTrigger = true;
			setTimeout(function () {
				_this2.saveTrigger = false;
			}, 250);

			this.removeLocalStorage();

			localStorage.setItem('isCacheSavedDesert', JSON.stringify(true));

			localStorage.setItem('ambience1VolDesert', JSON.stringify(this.ambience1Vol));
			localStorage.setItem('ambience2VolDesert', JSON.stringify(this.ambience2Vol));
			localStorage.setItem('ambience3VolDesert', JSON.stringify(this.ambience3Vol));
			localStorage.setItem('ambience4VolDesert', JSON.stringify(this.ambience4Vol));
			localStorage.setItem('ambience5VolDesert', JSON.stringify(this.ambience5Vol));
			localStorage.setItem('ambience6VolDesert', JSON.stringify(this.ambience6Vol));

			localStorage.setItem('ambience1BooleanDesert', JSON.stringify(this.ambience1Boolean));
			localStorage.setItem('ambience2BooleanDesert', JSON.stringify(this.ambience2Boolean));
			localStorage.setItem('ambience3BooleanDesert', JSON.stringify(this.ambience3Boolean));
			localStorage.setItem('ambience4BooleanDesert', JSON.stringify(this.ambience4Boolean));
			localStorage.setItem('ambience5BooleanDesert', JSON.stringify(this.ambience5Boolean));
			localStorage.setItem('ambience6BooleanDesert', JSON.stringify(this.ambience6Boolean));

			localStorage.setItem('speedToggleDesert', JSON.stringify(this.speedToggle));
			localStorage.setItem('fxDelayToggleDesert', JSON.stringify(this.fxDelayToggle));
			localStorage.setItem('fxConvolverToggleDesert', JSON.stringify(this.fxConvolverToggle));
			localStorage.setItem('fxChorusToggleDesert', JSON.stringify(this.fxChorusToggle));
			localStorage.setItem('fxFilterToggleDesert', JSON.stringify(this.fxFilterToggle));

			localStorage.setItem('playBackSpeed', JSON.stringify(this.playBackSpeed));
			localStorage.setItem('fxConvolverAmtDesert', JSON.stringify(this.fxConvolverAmt));
			localStorage.setItem('fxChorusAmtDesert', JSON.stringify(this.fxChorusAmt));
			localStorage.setItem('fxDelayAmtDesert', JSON.stringify(this.fxDelayAmt));
			localStorage.setItem('fxAutoFilterAmtDesert', JSON.stringify(this.fxAutoFilterAmt));
		},
		getLocalStorage: function getLocalStorage() {
			var _this3 = this;

			this.isCacheSaved = JSON.parse(localStorage.getItem('isCacheSavedDesert'));
			if (this.isCacheSaved) {
				this.loadTrigger = true;
				setTimeout(function () {
					_this3.loadTrigger = false;
				}, 250);

				this.ambience1Vol = JSON.parse(localStorage.getItem('ambience1VolDesert'));
				this.ambience2Vol = JSON.parse(localStorage.getItem('ambience2VolDesert'));
				this.ambience3Vol = JSON.parse(localStorage.getItem('ambience3VolDesert'));
				this.ambience4Vol = JSON.parse(localStorage.getItem('ambience4VolDesert'));
				this.ambience5Vol = JSON.parse(localStorage.getItem('ambience5VolDesert'));
				this.ambience6Vol = JSON.parse(localStorage.getItem('ambience6VolDesert'));

				this.ambience1Boolean = JSON.parse(localStorage.getItem('ambience1BooleanDesert'));
				this.ambience2Boolean = JSON.parse(localStorage.getItem('ambience2BooleanDesert'));
				this.ambience3Boolean = JSON.parse(localStorage.getItem('ambience3BooleanDesert'));
				this.ambience4Boolean = JSON.parse(localStorage.getItem('ambience4BooleanDesert'));
				this.ambience5Boolean = JSON.parse(localStorage.getItem('ambience5BooleanDesert'));
				this.ambience6Boolean = JSON.parse(localStorage.getItem('ambience6BooleanDesert'));

				this.speedToggle = JSON.parse(localStorage.getItem('speedToggleDesert'));
				this.fxDelayToggle = JSON.parse(localStorage.getItem('fxDelayToggleDesert'));
				this.fxConvolverToggle = JSON.parse(localStorage.getItem('fxConvolverToggleDesert'));
				this.fxChorusToggle = JSON.parse(localStorage.getItem('fxChorusToggleDesert'));
				this.fxFilterToggle = JSON.parse(localStorage.getItem('fxFilterToggleDesert'));

				this.playBackSpeed = JSON.parse(localStorage.getItem('playBackSpeed'));;
				this.fxConvolverAmt = JSON.parse(localStorage.getItem('fxConvolverAmtDesert'));
				this.fxChorusAmt = JSON.parse(localStorage.getItem('fxChorusAmtDesert'));
				this.fxDelayAmt = JSON.parse(localStorage.getItem('fxDelayAmtDesert'));
				this.fxAutoFilterAmt = JSON.parse(localStorage.getItem('fxAutoFilterAmtDesert'));
			}
		},
		removeLocalStorage: function removeLocalStorage() {
			localStorage.removeItem('isCacheSavedDesert');

			localStorage.removeItem('ambience1VolDesert');
			localStorage.removeItem('ambience2VolDesert');
			localStorage.removeItem('ambience3VolDesert');
			localStorage.removeItem('ambience4VolDesert');
			localStorage.removeItem('ambience5VolDesert');
			localStorage.removeItem('ambience6VolDesert');

			localStorage.removeItem('ambience1BooleanDesert');
			localStorage.removeItem('ambience2BooleanDesert');
			localStorage.removeItem('ambience3BooleanDesert');
			localStorage.removeItem('ambience4BooleanDesert');
			localStorage.removeItem('ambience5BooleanDesert');
			localStorage.removeItem('ambience6BooleanDesert');

			localStorage.removeItem('speedToggleDesert');
			localStorage.removeItem('fxDelayToggleDesert');
			localStorage.removeItem('fxConvolverToggleDesert');
			localStorage.removeItem('fxChorusToggleDesert');
			localStorage.removeItem('fxFilterToggleDesert');

			localStorage.removeItem('playBackSpeedDesert');
			localStorage.removeItem('fxConvolverAmtDesert');
			localStorage.removeItem('fxChorusAmtDesert');
			localStorage.removeItem('fxDelayAmtDesert');
			localStorage.removeItem('fxAutoFilterAmtDesert');
		},

		//START AUDIO
		startAudio: function startAudio() {
			if (this.firstLoad) {
				this.firstLoad = false;
				__WEBPACK_IMPORTED_MODULE_0__node_modules_startaudiocontext_StartAudioContext_js___default()(__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.context, "#enterFuncBtn");
				this.$store.state.hasAudioContextTriggered = true;
			}
			this.ambience1Player.volume.value = -100;
			this.ambience2Player.volume.value = -100;
			this.ambience3Player.volume.value = -100;
			this.ambience4Player.volume.value = -100;
			this.ambience5Player.volume.value = -100;
			this.ambience6Player.volume.value = -100;

			this.ambience1Player.start();
			this.ambience2Player.start();
			this.ambience3Player.start();
			this.ambience4Player.start();
			this.ambience5Player.start();
			this.ambience6Player.start();
		},
		stopAudio: function stopAudio() {
			this.ambience1Player.stop();
			this.ambience2Player.stop();
			this.ambience3Player.stop();
			this.ambience4Player.stop();
			this.ambience5Player.stop();
			this.ambience6Player.stop();
		},

		//SPEECH
		userVoiceToTextFunc: function userVoiceToTextFunc() {
			var _this4 = this;

			this.submitSpeechTxttoVoice = true;
			this.testObjectVUI = this.userVoiceToText;
			console.log(this.testObjectVUI);
			this.sourceSortingVUI();
			setTimeout(function () {
				_this4.submitSpeechTxttoVoice = false;
			}, 250);
		},
		speechFunc: function speechFunc() {
			var _this5 = this;

			if (this.initSpeech === true) {
				this.recognitionDesert = new webkitSpeechRecognition();
				this.recognizing;
				this.recognitionDesert.continuous = false;
				this.recognitionDesert.interimResults = true;

				this.recognitionDesert.onresult = function (event) {
					for (var i = event.resultIndex; i < event.results.length; ++i) {
						if (event.results[i].isFinal) {
							if (!_this5.isDisableListening) {
								_this5.testObjectVUI += event.results[i][0].transcript;
								console.log('Speech String Command: ' + event.results[i][0].transcript);
								_this5.sourceSortingVUI();
							}
						}
					}
				};
				this.recognitionDesert.onspeechend = function () {
					console.log('%c Desert Module SPEECH Ended', 'background: red; color: black');
					// setTimeout(this.sourceSortingVUI, 500);
					_this5.recognizing = false;
					_this5.speechBtnTxt = "Say A Command";
					__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master.volume.setTargetAtTime(0, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.context.currentTime, +0.5);
				};
				this.recognitionDesert.onspeechstart = function () {
					console.log('%c Desert Module SPEECH Began', 'background: green; color: white');
					_this5.recognizing = true;
					_this5.speechBtnTxt = "Listening For Command";
					__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master.volume.setTargetAtTime(-10, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.context.currentTime, +1);
				};
				this.recognitionDesert.onsoundstart = function () {
					console.log('%c Desert Module LISTENING Began', 'background: green; color: white');
				};
				this.recognitionDesert.onaudioend = function () {
					console.log('%c Desert Module LISTENING Ended', 'background: green; color: white');
					// setTimeout(this.sourceSortingVUI, 500);
					_this5.recognizing = false;
					_this5.speechBtnTxt = "Say A Command";
				};
				this.recognitionDesert.onend = function () {
					console.log('%c Desert Module SPEECH SESSION ENDED', 'background: green; color: white');
					if (_this5.stopModuleSpeech === false) {
						_this5.recognitionDesert.start();
					}
				};
				this.recognizing = true;
				//MAKE SURE SPEECH IS NOT RE-ENGAGED
				this.initSpeech = false;
				//GLOBAL VOICE COMMAND IS SET TO TRUE
				this.$store.state.isVoiceControlled = true;
				this.recognitionDesert.start();
				//IF USER ENGAGES VOICE CONTROL BUT GOES HOME VIA MOUSE BUTTON THIS TRIGGERS MODULE SPEECH DISPOSE
				this.goingHomeNotViaVoiceCommand = true;
				//CONTROLS recognition.onend TO RESTART LISTENING
				this.stopModuleSpeech = false;
				//TURN LISTENING BACK ON
				this.isDisableListening = false;
				//IF BEING VOICE CONTROLLED DON'T PLAY THE NICE, TELL ME WHERE YOU WANT TO GO PROMPT ON WELCOME PAGE
				this.$store.state.doNotAddress = true;
			} else if (this.initSpeech === false) {}
		},
		resetFunc: function resetFunc() {
			this.recognizing = false;
		},
		speechStartStopFunc: function speechStartStopFunc() {
			this.speechStartTopBtnTrigger = !this.speechStartTopBtnTrigger;

			if (this.speechStartTopBtnTrigger === true) {
				this.speechFunc();
			} else if (this.speechStartTopBtnTrigger === false) {
				this.initSpeech = true;
				this.stopModuleSpeech = true;
				this.recognizing = false;
				this.recognitionDesert.stop();
				this.$store.state.isVoiceControlled = false;
			}
		},
		sourceSortingVUI: function sourceSortingVUI() {
			//FOR VISUAL REFERENCE
			this.userVoiceToText = this.testObjectVUI;

			var source1RegEx = XRegExp.build('(?x) {{source1Name}} | {{label1Name}}', {
				source1Name: XRegExp.build('{{source1Name1}} | {{source1Name2}}', {
					source1Name1: /source\sone/,
					source1Name2: /source\s1/
				}),
				label1Name: XRegExp.build('{{label1Name1}}', {
					label1Name1: /oasise?s?|oases|water/
				})
			}, 'xgi');

			var source2RegEx = XRegExp.build('(?x) {{source2Name}} | {{label2Name}}', {
				source2Name: XRegExp.build('{{source2Name1}} | {{source2Name2}}', {
					source2Name1: /source\stw?o?o/,
					source2Name2: /source\s2/
				}),
				label2Name: XRegExp.build('{{label2Name1}}', {
					label2Name1: /carcass|decay|crow|fly/
				})
			}, 'xgi');

			var source3RegEx = XRegExp.build('(?x) {{source3Name}} | {{label3Name}}', {
				source3Name: XRegExp.build('{{source3Name1}} | {{source3Name2}}', {
					source3Name1: /source\sthree/,
					source3Name2: /source\s3/
				}),
				label3Name: XRegExp.build('{{label3Name1}}', {
					label3Name1: /coyotes?|song\s?dog/
				})
			}, 'xgi');

			var source4RegEx = XRegExp.build('(?x) {{source4Name}} | {{label4Name}}', {
				source4Name: XRegExp.build('{{source4Name1}} | {{source4Name2}}', {
					source4Name1: /source\sfou?re?/,
					source4Name2: /source\s4/
				}),
				label4Name: XRegExp.build('{{label4Name1}} | {{label4Name2}}', {
					label4Name1: /desert\s?winds?/,
					label4Name2: /blusters?/
				})
			}, 'xgi');

			var source5RegEx = XRegExp.build('(?x) {{source5Name}} | {{label5Name}}', {
				source5Name: XRegExp.build('{{source5Name1}} | {{source5Name2}}', {
					source5Name1: /source\sfive/,
					source5Name2: /source\s5/
				}),
				label5Name: XRegExp.build('{{label5Name1}} | {{label5Name2}}', {
					label5Name1: /airplanes?|prop\splanes?/,
					label5Name2: /pollution/
				})
			}, 'xgi');

			var source6RegEx = XRegExp.build('(?x) {{source6Name}} | {{label6Name}}', {
				source6Name: XRegExp.build('{{source6Name1}} | {{source6Name2}}', {
					source6Name1: /source\ss[ei]x/,
					source6Name2: /source\s6/
				}),
				label6Name: XRegExp.build('{{label6Name1}}', {
					label6Name1: /walk|stroll|steps|feet/
				})
			}, 'xgi');
			//ALL SOUNDS
			var allSoundRegEx = XRegExp.build('(?x) {{allSoundName}}', {
				allSoundName: XRegExp.build('{{allSoundName1}} | {{allSoundName2}}', {
					allSoundName1: /all\ssounds?/,
					allSoundName2: /all\saudios?/
				})
			}, 'xgi');
			//SPEED
			var speedRegEx = XRegExp.build('(?x) {{speedName}}', {
				speedName: XRegExp.build('{{speedName1}} | {{speedName2}}', {
					speedName1: /speeds?/,
					speedName2: /slow|faster/
				})
			}, 'xgi');
			//DELAY
			var delayRegEx = XRegExp.build('(?x) {{delayName}}', {
				delayName: XRegExp.build('{{delayName1}} | {{delayName2}}', {
					delayName1: /delay/,
					delayName2: /lay/
				})
			}, 'xgi');
			//CHORUS
			var chorusRegEx = XRegExp.build('(?x) {{chorusName}}', {
				chorusName: XRegExp.build('{{chorusName1}} | {{chorusName2}}', {
					chorusName1: /chorus?/,
					chorusName2: /course/
				})
			}, 'xgi');
			//FILTER
			var filterRegEx = XRegExp.build('(?x) {{filterName}}', {
				filterName: XRegExp.build('{{filterName1}} | {{filterName2}}', {
					filterName1: /filter/,
					filterName2: /filter/
				})
			}, 'xgi');
			//REVERB
			var reverbRegEx = XRegExp.build('(?x) {{reverbName}}', {
				reverbName: XRegExp.build('{{reverbName1}} | {{reverbName2}}', {
					reverbName1: /verb/,
					reverbName2: /reverb/
				})
			}, 'xgi');
			//SHOW
			var infoRegEx = XRegExp.build('(?x) {{showName}}', {
				showName: XRegExp.build('{{showName1}} | {{showName2}}', {
					showName1: /info/,
					showName2: /information/
				})
			}, 'xgi');
			// console.log(infoRegEx);
			//HIDE
			var listRegEx = XRegExp.build('(?x) {{hideName}}', {
				hideName: XRegExp.build('{{hideName1}} | {{hideName2}}', {
					hideName1: /lists?/,
					hideName2: /menu/
				})
			}, 'xgi');
			// console.log(listRegEx);			

			var source1Boolean = source1RegEx.test(this.testObjectVUI);
			var source2Boolean = source2RegEx.test(this.testObjectVUI);
			var source3Boolean = source3RegEx.test(this.testObjectVUI);
			var source4Boolean = source4RegEx.test(this.testObjectVUI);
			var source5Boolean = source5RegEx.test(this.testObjectVUI);
			var source6Boolean = source6RegEx.test(this.testObjectVUI);
			var allSoundBoolean = allSoundRegEx.test(this.testObjectVUI);
			var speedBoolean = speedRegEx.test(this.testObjectVUI);
			var delayBoolean = delayRegEx.test(this.testObjectVUI);
			var chorusBoolean = chorusRegEx.test(this.testObjectVUI);
			var filterBoolean = filterRegEx.test(this.testObjectVUI);
			var reverbBoolean = reverbRegEx.test(this.testObjectVUI);
			var infoBoolean = infoRegEx.test(this.testObjectVUI);
			var listBoolean = listRegEx.test(this.testObjectVUI);

			if (source1Boolean) {
				this.source1VUI();
			} else if (source2Boolean) {
				this.source2VUI();
			} else if (source3Boolean) {
				this.source3VUI();
			} else if (source4Boolean) {
				this.source4VUI();
			} else if (source5Boolean) {
				this.source5VUI();
			} else if (source6Boolean) {
				this.source6VUI();
			} else if (allSoundBoolean) {
				this.allSoundVUI();
			} else if (speedBoolean) {
				this.speedVUI();
			} else if (delayBoolean) {
				this.delayVUI();
			} else if (chorusBoolean) {
				this.chorusVUI();
			} else if (filterBoolean) {
				this.filterVUI();
			} else if (reverbBoolean) {
				this.reverbVUI();
			} else if (infoBoolean) {
				this.infoVUI();
			} else if (listBoolean) {
				this.listVUI();
			} else {
				this.miscVUI();
			}
		},
		source1VUI: function source1VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience1Player.start();
				this.ambience1Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience1Player.stop();
				this.ambience1Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience1Vol < 0) {
						this.ambience1Vol += 12;
					}
				} else {
					if (this.ambience1Vol < 0) {
						this.ambience1Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience1Vol > -30) {
						this.ambience1Vol -= 12;
					}
				} else {
					if (this.ambience1Vol > -30) {
						this.ambience1Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		source2VUI: function source2VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience2Player.start();
				this.ambience2Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience2Player.stop();
				this.ambience2Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience2Vol < 0) {
						this.ambience2Vol += 12;
					}
				} else {
					if (this.ambience2Vol < 0) {
						this.ambience2Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience2Vol > -30) {
						this.ambience2Vol -= 12;
					}
				} else {
					if (this.ambience2Vol > -30) {
						this.ambience2Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		source3VUI: function source3VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience3Player.start();
				this.ambience3Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience3Player.stop();
				this.ambience3Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience3Vol < 0) {
						this.ambience3Vol += 12;
					}
				} else {
					if (this.ambience3Vol < 0) {
						this.ambience3Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience3Vol > -30) {
						this.ambience3Vol -= 12;
					}
				} else {
					if (this.ambience3Vol > -30) {
						this.ambience3Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		source4VUI: function source4VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience4Player.start();
				this.ambience4Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience4Player.stop();
				this.ambience4Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience4Vol < 0) {
						this.ambience4Vol += 12;
					}
				} else {
					if (this.ambience4Vol < 0) {
						this.ambience4Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience4Vol > -30) {
						this.ambience4Vol -= 12;
					}
				} else {
					if (this.ambience4Vol > -30) {
						this.ambience4Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		source5VUI: function source5VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience5Player.start();
				this.ambience5Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience5Player.stop();
				this.ambience5Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience5Vol < 0) {
						this.ambience5Vol += 12;
					}
				} else {
					if (this.ambience5Vol < 0) {
						this.ambience5Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience5Vol > -30) {
						this.ambience5Vol -= 12;
					}
				} else {
					if (this.ambience5Vol > -30) {
						this.ambience5Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		source6VUI: function source6VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience6Player.start();
				this.ambience6Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience6Player.stop();
				this.ambience6Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience6Vol < 0) {
						this.ambience6Vol += 12;
					}
				} else {
					if (this.ambience6Vol < 0) {
						this.ambience6Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience6Vol > -30) {
						this.ambience6Vol -= 12;
					}
				} else {
					if (this.ambience6Vol > -30) {
						this.ambience6Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		allSoundVUI: function allSoundVUI() {
			//STOP ALL 
			if (RegExp(/stop/gi).test(this.testObjectVUI)) {
				this.ambience1Player.stop();
				this.ambience1Boolean = false;
				this.ambience2Player.stop();
				this.ambience2Boolean = false;
				this.ambience3Player.stop();
				this.ambience3Boolean = false;
				this.ambience4Player.stop();
				this.ambience4Boolean = false;
				this.ambience5Player.stop();
				this.ambience5Boolean = false;
				this.ambience6Player.stop();
				this.ambience6Boolean = false;
				if (this.didWeAdventure) {
					this.exploreSound1.stop();
					this.isExploreFuncRunning = false;
				}
			} else if (RegExp(/play/gi).test(this.testObjectVUI)) {
				this.ambience1Player.start();
				this.ambience1Boolean = true;
				this.ambience2Player.start();
				this.ambience2Boolean = true;
				this.ambience3Player.start();
				this.ambience3Boolean = true;
				this.ambience4Player.start();
				this.ambience4Boolean = true;
				this.ambience5Player.start();
				this.ambience5Boolean = true;
				this.ambience6Player.start();
				this.ambience6Boolean = true;
			}
			this.testObjectVUI = "";
		},
		speedVUI: function speedVUI() {
			if (RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI)) {
				this.speedToggle = true;
			} else if (RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI)) {
				this.speedToggle = false;
			}
			if (RegExp(/\bfaste?r?\b|up/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.playBackSpeed <= 1.6) {
						this.playBackSpeed += 0.4;
					}
				} else {
					if (this.playBackSpeed <= 1.8) {
						this.playBackSpeed += 0.2;
					}
				}
			} else if (RegExp(/slowe?r?|down/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.playBackSpeed >= 0.5) {
						this.playBackSpeed -= 0.4;
					}
				} else {
					if (this.playBackSpeed >= 0.2) {
						this.playBackSpeed -= 0.2;
					}
				}
			}
			this.testObjectVUI = "";
		},
		delayVUI: function delayVUI() {
			if (RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI)) {
				this.fxDelayToggle = true;
			} else if (RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI)) {
				this.fxDelayToggle = false;
			}
			if (RegExp(/\bmore\b|\bup\b|loude?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxDelayAmt <= 80) {
						this.fxDelayAmt += 10;
					}
				} else {
					if (this.fxDelayAmt <= 95) {
						this.fxDelayAmt += 5;
					}
				}
			} else if (RegExp(/less|\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxDelayAmt >= 20) {
						this.fxDelayAmt -= 10;
					} else if (this.fxDelayAmt >= 5) {
						this.fxDelayAmt -= 5;
					}
				} else {
					if (this.fxDelayAmt >= 5) {
						this.fxDelayAmt -= 5;
					} else if (this.fxDelayAmt >= 15) {
						this.fxDelayAmt -= 2;
					}
				}
			}
			this.testObjectVUI = "";
		},
		chorusVUI: function chorusVUI() {
			if (RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI)) {
				this.fxChorusToggle = true;
			} else if (RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI)) {
				this.fxChorusToggle = false;
			}
			if (RegExp(/\bmore\b|\bup\b|loude?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxChorusAmt <= 80) {
						this.fxChorusAmt += 10;
					}
				} else {
					if (this.fxChorusAmt <= 95) {
						this.fxChorusAmt += 5;
					}
				}
			} else if (RegExp(/less|\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxChorusAmt >= 20) {
						this.fxChorusAmt -= 10;
					} else if (this.fxChorusAmt >= 5) {
						this.fxChorusAmt -= 5;
					}
				} else {
					if (this.fxChorusAmt >= 5) {
						this.fxChorusAmt -= 5;
					} else if (this.fxChorusAmt >= 15) {
						this.fxChorusAmt -= 2;
					}
				}
			}
			this.testObjectVUI = "";
		},
		reverbVUI: function reverbVUI() {
			if (RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI)) {
				this.fxConvolverToggle = true;
			} else if (RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI)) {
				this.fxConvolverToggle = false;
			}
			if (RegExp(/\bmore\b|\bup\b|loude?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxConvolverAmt <= 45) {
						this.fxConvolverAmt += 5;
					}
				} else {
					if (this.fxConvolverAmt <= 48) {
						this.fxConvolverAmt += 2;
					}
				}
			} else if (RegExp(/less|\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxConvolverAmt >= 10) {
						this.fxConvolverAmt -= 5;
					} else if (this.fxConvolverAmt >= 2) {
						this.fxConvolverAmt -= 1;
					}
				} else {
					if (this.fxConvolverAmt >= 10) {
						this.fxConvolverAmt -= 2;
					} else if (this.fxConvolverAmt >= 2) {
						this.fxConvolverAmt -= 1;
					}
				}
			}
			this.testObjectVUI = "";
		},
		filterVUI: function filterVUI() {
			if (RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI)) {
				this.fxFilterToggle = true;
			} else if (RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI)) {
				this.fxFilterToggle = false;
			}
			if (RegExp(/\bmore\b|\blower\b/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxAutoFilterAmt > 1500) {
						this.fxAutoFilterAmt -= 1500;
					} else if (this.fxAutoFilterAmt >= 300) {
						this.fxAutoFilterAmt -= 200;
					}
				} else {
					if (this.fxAutoFilterAmt >= 500) {
						this.fxAutoFilterAmt -= 250;
					} else if (this.fxAutoFilterAmt >= 100) {
						this.fxAutoFilterAmt -= 100;
					}
				}
			} else if (RegExp(/less|higher|hire/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxAutoFilterAmt <= 10000) {
						this.fxAutoFilterAmt += 1500;
					} else if (this.fxAutoFilterAmt <= 1000) {
						this.fxAutoFilterAmt += 200;
					}
				} else {
					if (this.fxAutoFilterAmt <= 10000) {
						this.fxAutoFilterAmt += 250;
					} else if (this.fxAutoFilterAmt <= 1000) {
						this.fxAutoFilterAmt += 100;
					}
				}
			}
			this.testObjectVUI = "";
		},
		infoVUI: function infoVUI() {
			var _this6 = this;

			if (RegExp(/show|display/gi).test(this.testObjectVUI)) {
				this.showHelpOverlay = true;
				setTimeout(function () {
					_this6.showNavBar = false;
					if (_this6.$store.state.allowSpeechControl) {
						_this6.showSpeechBtns = false;
					}
				}, 0);
				setTimeout(function () {
					_this6.showAllControls = false;
				}, 500);
				setTimeout(function () {
					_this6.showAboutPage = true;
				}, 1500);
				console.log('SHOW INFO');
			} else if (RegExp(/hide|minimize/gi).test(this.testObjectVUI)) {
				this.showHelpOverlay = false;
				this.showAboutPage = false;
				setTimeout(function () {
					_this6.showAllControls = true;
				}, 800);
				setTimeout(function () {
					_this6.showNavBar = true;
					if (_this6.$store.state.allowSpeechControl) {
						_this6.showSpeechBtns = true;
					}
				}, 850);
				console.log('HIDE INFO');
			}
			this.testObjectVUI = "";
			setTimeout(function () {
				_this6.userVoiceToText = "";
			}, 3000);
		},
		listVUI: function listVUI() {
			var _this7 = this;

			if (RegExp(/show|display/gi).test(this.testObjectVUI)) {
				this.showVoiceCommandList = true;
				setTimeout(function () {
					document.getElementById('voiceControlListTxt').scrollIntoView({ behavior: "smooth" });
				}, 250);
				console.log('SHOW LIST');
			} else if (RegExp(/hide|minimize/gi).test(this.testObjectVUI)) {
				this.showVoiceCommandList = false;
				setTimeout(function () {
					document.getElementById('controlsContainer').scrollIntoView({ behavior: "smooth" });
				}, 250);
				console.log('HIDE LIST');
			}
			this.testObjectVUI = "";
			setTimeout(function () {
				_this7.userVoiceToText = "";
			}, 3000);
		},
		miscVUI: function miscVUI() {
			//RANDOMIZE
			if (RegExp(/new\s?scenes?|randomi?z?e?|shift\s?soundscapes?/gi).test(this.testObjectVUI)) {
				this.mattChillMethod();
				//EXPLORE
			} else if (RegExp(/\bexplorer?\b|\badventure\b/gi).test(this.testObjectVUI)) {
				if (RegExp(/stop/gi).test(this.testObjectVUI)) {
					this.stopExplore();
				} else {
					this.exploreFunc();
				}
				//STOP VOICE COMMANDS & GO HOME FUNCTIONS
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) && RegExp(/voice\s?controls?/gi).test(this.testObjectVUI) || RegExp(/stop/gi).test(this.testObjectVUI) && RegExp(/voice\s?commands?/gi).test(this.testObjectVUI)) {
				//DISABLES LISTENING IMMEDITATLY
				this.initSpeech = true;
				this.stopModuleSpeech = true;
				this.recognizing = false;
				this.recognitionDesert.stop();
				this.$store.state.isVoiceControlled = false;
			} else if (RegExp(/home/gi).test(this.testObjectVUI)) {
				this.goingHomeNotViaVoiceCommand = false;
				this.stopModuleSpeech = true;
				this.recognitionDesert.abort();
				this.recognitionDesert = undefined;
				setTimeout(this.goHome, 50);
			}
			this.testObjectVUI = "";
		},
		voiceCommandListFunc: function voiceCommandListFunc() {
			this.showVoiceCommandList = !this.showVoiceCommandList;
			if (this.showVoiceCommandList) {
				setTimeout(function () {
					document.getElementById('voiceControlListTxt').scrollIntoView({ behavior: "smooth" });
				}, 250);
			} else if (!this.showVoiceCommandList) {
				document.getElementById('controlsContainer').scrollIntoView({ behavior: "smooth" });
			}
		},

		//ENTER FUNC
		enterFunc: function enterFunc() {
			var _this8 = this;

			if (this.startAudioBoolean) {
				this.startAudio();
				this.startAudioBoolean = false;
			}

			this.showEnterBtn = false;

			setTimeout(function () {
				_this8.showEnterContainer = false;
			}, 2200);

			this.DesertFX.start();

			var changeTiming = 50;

			setTimeout(function () {
				_this8.plungeDepth = 1;
			}, changeTiming * 1);

			setTimeout(function () {
				_this8.plungeDepth = 2;
			}, changeTiming * 2);

			setTimeout(function () {
				_this8.plungeDepth = 3;
			}, changeTiming * 3);

			setTimeout(function () {
				_this8.plungeDepth = 4;
			}, changeTiming * 4);

			setTimeout(function () {
				_this8.plungeDepth = 5;
			}, changeTiming * 5);

			setTimeout(function () {
				_this8.plungeDepth = 6;
			}, changeTiming * 6);

			setTimeout(function () {
				_this8.plungeDepth = 7;
			}, changeTiming * 7);

			setTimeout(function () {
				_this8.plungeDepth = 8;
			}, changeTiming * 8);

			setTimeout(function () {
				_this8.plungeDepth = 9;
			}, changeTiming * 8);

			setTimeout(function () {
				_this8.plungeDepth = 10;
			}, changeTiming * 10);

			setTimeout(function () {
				_this8.showAllControls = true;
			}, 2500);

			setTimeout(function () {
				_this8.showNavBar = true;
			}, 2500);

			setTimeout(function () {
				_this8.showMicRecording = true;
			}, 2300);

			setTimeout(function () {
				_this8.showSpeechBtns = true;
			}, 2400);

			setTimeout(function () {
				_this8.ambience1Boolean = true;
				_this8.ambience6Boolean = true;
			}, 2000);

			setTimeout(function () {
				if (_this8.userMobile === false) {
					_this8.activeSun = true;
				}
			}, 2000);
		},

		//RANDOMIZE (MATT CHILL) PRESET
		mattChillMethod: function mattChillMethod() {
			if (this.didWeAdventure) {
				this.stopExplore();
			}

			if (this.randomizeBoolean === false) {
				this.randomizeBoolean = true;
			}

			this.mattChill = !this.mattChill;

			this.ambience1Vol = Math.floor(Math.random() * 30 - 30);
			this.ambience2Vol = Math.floor(Math.random() * 30 - 30);
			this.ambience3Vol = Math.floor(Math.random() * 30 - 30);
			this.ambience4Vol = Math.floor(Math.random() * 30 - 30);
			this.ambience5Vol = Math.floor(Math.random() * 30 - 30);
			this.ambience6Vol = Math.floor(Math.random() * 30 - 30);

			// let fx1boolean 		= Math.random() >= 0.5,
			// 	fx2boolean 		= Math.random() >= 0.5,
			// 	fx3boolean 		= Math.random() >= 0.5,
			// 	fx4boolean 		= Math.random() >= 0.5,
			// 	fx5boolean 		= Math.random() >= 0.5;

			var amb1boolean = Math.random() >= 0.5,
			    amb2boolean = Math.random() >= 0.5,
			    amb3boolean = Math.random() >= 0.5,
			    amb4boolean = Math.random() >= 0.5,
			    amb5boolean = Math.random() >= 0.5,
			    amb6boolean = Math.random() >= 0.5;

			// if (this.mattChill === true){
			//DON'T CALCULATE ON MOBILE
			if (this.userMobile === false) {
				var
				// randomVerb 		= Math.floor((Math.random() * 30) + 0),
				randomDelay = Math.floor(Math.random() * 25 + 0),
				    randomChorus = Math.floor(Math.random() * 10 + 0),
				    randomFilter = Math.floor(Math.random() * 10000 + 500);

				// this.fxConvolverAmt 	= randomVerb;
				this.fxDelayAmt = randomDelay;
				this.fxChorusAmt = randomChorus;
				this.fxAutoFilterAmt = randomFilter;

				this.fxDecay = Math.random() * 10 + 1.5;
				var fxPreDelay = Math.random() * 0.1 + 0.03;
				this.fxConvolver.decay = this.fxDecay;
				this.fxConvolver.preDelay = fxPreDelay;
				this.fxConvolver.generate();
			}
			//CALCULATE ON MOBILE & DESKTOP
			var randomSpeed = Math.random() * (1.15 - 0.75) + 0.75;
			this.playBackSpeed = randomSpeed;

			if (amb1boolean === true) {
				this.ambience1Boolean = true;
				this.showFlask1 = true;

				this.ambience3Boolean = false;
				this.showFlask3 = false;
			} else {
				this.ambience1Boolean = false;
				this.showFlask1 = false;
			}

			if (amb2boolean === true) {
				this.ambience2Boolean = true;
				this.showFlask2 = true;
			} else {
				this.ambience2Boolean = false;
				this.showFlask2 = false;
			}

			if (amb3boolean === true) {
				this.ambience3Boolean = true;
				this.showFlask3 = true;

				this.ambience1Boolean = false;
				this.showFlask1 = false;
			} else {
				this.ambience3Boolean = false;
				this.showFlask3 = false;
			}

			if (amb4boolean === true) {
				this.ambience4Boolean = true;
				this.showFlask4 = true;
			} else {
				this.ambience4Boolean = false;
				this.showFlask4 = false;
			}

			if (amb5boolean === true) {
				this.ambience5Boolean = true;
				this.showFlask5 = true;
			} else {
				this.ambience5Boolean = false;
				this.showFlask5 = false;
			}

			if (amb6boolean === true) {
				this.ambience6Boolean = true;
				this.showFlask6 = true;
			} else {
				this.ambience6Boolean = false;
				this.showFlask6 = false;
			}

			if (amb1boolean === false && amb2boolean === false && amb3boolean === false && amb4boolean === false && amb5boolean === false && amb6boolean === false) {
				this.ambience6Boolean = true;
				this.showFlask6 = true;
			}

			// } else if (this.mattChill === false){
			// this.fxDelayToggle = false;
			// this.fxConvolverToggle = false;
			// this.fxChorusToggle = false;
			// this.fxFilterToggle = false;
			// this.speedToggle = false;
			// } 
		},

		//EXPLORE 
		exploreBtnFunc: function exploreBtnFunc() {
			this.exploreBtnBoolean = !this.exploreBtnBoolean;
			if (this.exploreBtnBoolean) {
				this.exploreFunc();
			} else if (!this.exploreBtnBoolean) {
				this.stopExplore();
			}
		},
		exploreFunc: function exploreFunc() {
			var _this9 = this;

			//AUDIO MIXING FUNCTION
			var int = 1250;
			var runExplore = function runExplore() {
				_this9.exploreSound1.start();
				_this9.exploreTxt = "Exploring";

				_this9.exploreTimeout1 = setTimeout(function () {
					_this9.ambience4Player.start();
					_this9.ambience4Boolean = true;
					_this9.ambience4Vol = -12;
				}, int * 1);
				_this9.exploreTimeout2 = setTimeout(function () {
					_this9.ambience4Vol = -10;
				}, int * 2);
				_this9.exploreTimeout3 = setTimeout(function () {
					_this9.ambience4Vol = -8;
				}, int * 3);
				_this9.exploreTimeout4 = setTimeout(function () {
					_this9.ambience4Vol = -6;
				}, int * 4);
				_this9.exploreTimeout5 = setTimeout(function () {
					_this9.ambience4Vol = -8;
				}, int * 5);
				_this9.exploreTimeout6 = setTimeout(function () {
					_this9.ambience4Vol = -10;
				}, int * 6);
				_this9.exploreTimeout7 = setTimeout(function () {
					_this9.ambience4Vol = -12;
				}, int * 7);
				_this9.exploreTimeout8 = setTimeout(function () {
					_this9.ambience4Vol = -14;
				}, int * 8);
				_this9.exploreTimeout9 = setTimeout(function () {
					_this9.ambience4Vol = -18;
				}, int * 9);
				_this9.exploreTimeout10 = setTimeout(function () {
					_this9.ambience4Vol = -20;
				}, int * 10);
				_this9.exploreTimeout11 = setTimeout(function () {
					_this9.ambience4Vol = -22;
				}, int * 11);
				_this9.exploreTimeout12 = setTimeout(function () {
					_this9.ambience4Vol = -23;
					_this9.ambience3Boolean = true;
				}, int * 12);
				_this9.exploreTimeout13 = setTimeout(function () {
					_this9.ambience3Vol = -20;
				}, int * 13);
				_this9.exploreTimeout14 = setTimeout(function () {
					_this9.ambience3Vol = -18;
				}, int * 14);
				_this9.exploreTimeout15 = setTimeout(function () {
					_this9.ambience3Vol = -16;
				}, int * 15);
				_this9.exploreTimeout16 = setTimeout(function () {
					_this9.ambience3Vol = -14;
				}, int * 16);
				_this9.exploreTimeout17 = setTimeout(function () {
					_this9.ambience3Vol = -12;
					_this9.isExploreFuncRunning = false;
					_this9.fxConvolverAmt = 5;
					// this.fxDelayAmt = 2.5;
				}, int * 17);
			};
			if (this.isExploreFuncRunning === false) {
				this.isExploreFuncRunning = true;

				this.ambience1Boolean = false;
				this.ambience1Vol = -10;

				this.ambience2Boolean = false;
				this.ambience2Vol = -30;

				this.ambience3Boolean = false;
				this.ambience3Vol = -22;

				this.ambience4Boolean = false;
				this.ambience4Player.stop();
				this.ambience4Vol = -12;

				this.ambience5Boolean = false;
				this.ambience5Vol = -30;

				this.ambience6Boolean = false;
				this.ambience6Vol = -15;

				if (!this.didWeAdventure) {
					this.exploreSound1 = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
						"playbackRate": 1,
						"loop": false,
						"volume": -2
					}).connect(this.masterVolumeSub);

					//LOADING FOR BROWSER TYPE
					if (this.isChrome === true || this.isOpera === true || this.isFirefox === true || this.isBlink === true) {

						this.exploreSound1.load("../src/assets/sounds/modules/desert/hiogg/exporeSound1Desert.ogg", function () {
							runExplore();
						});
					} else if (this.AndroidMobile === true) {
						this.exploreSound1.load("../src/assets/sounds/modules/desert/lowogg/exporeSound1Desert.ogg", function () {
							runExplore();
						});
					} else if (this.isSafari === true || this.isEdge === true || this.isIE === true) {
						this.exploreSound1.load("../src/assets/sounds/modules/desert/320/exporeSound1Desert.m4a", function () {
							runExplore();
						});
					} else if (this.iOS === true) {
						this.exploreSound1.load("../src/assets/sounds/modules/desert/192/exporeSound1Desert.m4a", function () {
							runExplore();
						});
					}
					//CLEANS UP AND DISPOSES THESE PLAYERS WHEN GOING HOME
					this.didWeAdventure = true;
				} else if (this.didWeAdventure) {
					runExplore();
				}
			} else {}
		},
		stopExplore: function stopExplore() {
			this.exploreTxt = "Explore!";
			this.exploreSound1.stop();
			this.isExploreFuncRunning = false;
			clearInterval(this.exploreTimeout1);
			clearInterval(this.exploreTimeout2);
			clearInterval(this.exploreTimeout3);
			clearInterval(this.exploreTimeout4);
			clearInterval(this.exploreTimeout5);
			clearInterval(this.exploreTimeout6);
			clearInterval(this.exploreTimeout7);
			clearInterval(this.exploreTimeout8);
			clearInterval(this.exploreTimeout9);
			clearInterval(this.exploreTimeout10);
			clearInterval(this.exploreTimeout11);
			clearInterval(this.exploreTimeout12);
			clearInterval(this.exploreTimeout13);
			clearInterval(this.exploreTimeout14);
			clearInterval(this.exploreTimeout15);
			clearInterval(this.exploreTimeout16);
			clearInterval(this.exploreTimeout17);
		},

		//MASTER METERING
		masterMetering: function masterMetering() {
			this.masterLevel = this.masterMeter.getLevel();
		},

		//MAIN SHOW AND HIDE
		goToHelp: function goToHelp() {
			var _this10 = this;

			this.showHelpOverlay = !this.showHelpOverlay;
			this.helpTrigger = !this.helpTrigger;

			if (this.showHelpOverlay === true) {

				setTimeout(function () {
					_this10.showNavBar = false;
					if (_this10.$store.state.allowSpeechControl) {
						_this10.showSpeechBtns = false;
					}
				}, 100);

				setTimeout(function () {
					_this10.showAllControls = false;
				}, 250);

				setTimeout(function () {
					_this10.showAboutPage = true;
				}, 1000);
			} else if (this.showHelpOverlay === false) {

				this.showAboutPage = false;

				setTimeout(function () {
					_this10.showAllControls = true;
				}, 800);

				setTimeout(function () {
					_this10.showNavBar = true;
					if (_this10.$store.state.allowSpeechControl) {
						_this10.showSpeechBtns = true;
					}
				}, 850);
			}
		},

		//BUFFER LOADING
		bufferLoading: function bufferLoading() {
			var _this11 = this;

			// Tone.Buffer.on('progress', ()=>{
			// });
			__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Buffer.on('load', function () {
				//HIDE LOADING ITEMS
				_this11.showLoading = false;
				//SHOW ENTER BUTTON
				setTimeout(function () {
					_this11.showEnterBtn = true;
				}, 1000);
				//AUTO OPEN MODULE IF VOICE CONTROLLED & DO NOT REPLAY WHEN EXPLORE AUDIO LOADS 
				//ADDITIONALLY DO NOT REPLAY IF USER MIC HAS BEEN ACTIVATED FOR RECORDING
				if (_this11.isVoiceControl) {
					if (!_this11.didWeAdventure) {
						setTimeout(_this11.enterFunc, 2000);
					}
				}
				//IF VOICE CONTROL IS ACTIVE GLOBALLY ACTIVATE IN THIS MODULE
				if (_this11.isVoiceControl === true) {
					_this11.speechFunc();
				}
			});
		},

		//AUDIO ROUTING
		audioRouting: function audioRouting() {
			if (this.isChrome === true || this.AndroidMobile === true || this.isOpera === true || this.isFirefox === true || this.isBlink === true) {
				if (this.userMobile === false) {

					this.fxConvolver = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Reverb({
						"decay": 1.5,
						"preDelay": 0.01
					});
					this.fxConvolver.decay = 2.5;
					this.fxConvolver.generate();
					this.fxAutoFilter = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Filter({
						"type": "lowpass",
						"frequency": 20000,
						"rolloff": -24,
						"Q": 1,
						"gain": 0
					});
					this.fxDelay = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.PingPongDelay(0.85, 0.12);
					this.fxChorus = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Chorus(1.5, 8.5, .75);
					this.masterMeter = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Meter({
						"smoothing": .4
					});
					// this.voiceAdjustEQ = new Tone.EQ3({
					// 							"low"  : 0 ,
					// 							"mid"  : 0 ,
					// 							"high"  : 0 ,
					// 							"lowFrequency"  : 400 ,
					// 							"highFrequency"  : 2500
					// 							});
					this.ambience1Player.connect(this.masterVolumeSub);
					this.ambience2Player.connect(this.masterVolumeSub);
					this.ambience3Player.connect(this.masterVolumeSub);
					this.ambience4Player.connect(this.masterVolumeSub);
					this.ambience5Player.connect(this.masterVolumeSub);
					this.ambience6Player.connect(this.masterVolumeSub);

					this.masterVolumeSub.chain(this.fxAutoFilter, this.fxConvolver, this.fxDelay, this.fxChorus, this.masterMeter,
					// this.voiceAdjustEQ,
					__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master);
					console.log('Chrome/Opera/FireFox Desktop');
					setInterval(this.masterMetering, 60);
				} else if (this.userMobile === true) {
					this.ambience1Player.connect(this.masterVolumeSub);
					this.ambience2Player.connect(this.masterVolumeSub);
					this.ambience3Player.connect(this.masterVolumeSub);
					this.ambience4Player.connect(this.masterVolumeSub);
					this.ambience5Player.connect(this.masterVolumeSub);
					this.ambience6Player.connect(this.masterVolumeSub);

					this.masterVolumeSub.connect(__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master);

					console.log('Chrome/Opera/FireFox Mobile');
				}
			} else if (this.isSafari === true || this.iOS === true || this.isEdge === true || this.isIE === true) {
				if (this.userMobile === false) {
					this.fxConvolver = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Reverb({
						"decay": 1.5,
						"preDelay": 0.01
					});
					this.fxConvolver.decay = 2.5;
					this.fxConvolver.generate();
					this.fxAutoFilter = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Filter({
						"type": "lowpass",
						"frequency": 20000,
						"rolloff": -24,
						"Q": 1,
						"gain": 0
					});
					this.fxDelay = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.PingPongDelay(0.85, 0.12);
					this.fxChorus = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Chorus(1.5, 8.5, .75);
					this.masterMeter = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Meter({
						"smoothing": .4
					});
					this.ambience1Player.connect(this.masterVolumeSub);
					this.ambience2Player.connect(this.masterVolumeSub);
					this.ambience3Player.connect(this.masterVolumeSub);
					this.ambience4Player.connect(this.masterVolumeSub);
					this.ambience5Player.connect(this.masterVolumeSub);
					this.ambience6Player.connect(this.masterVolumeSub);

					this.masterVolumeSub.chain(this.fxAutoFilter, this.fxConvolver, this.fxDelay, this.fxChorus, this.masterMeter, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master);
					console.log('Safari/Edge/iOS Desktop');
					setInterval(this.masterMetering, 60);
				} else if (this.userMobile === true) {
					this.ambience1Player.connect(this.masterVolumeSub);
					this.ambience2Player.connect(this.masterVolumeSub);
					this.ambience3Player.connect(this.masterVolumeSub);
					this.ambience4Player.connect(this.masterVolumeSub);
					this.ambience5Player.connect(this.masterVolumeSub);
					this.ambience6Player.connect(this.masterVolumeSub);

					this.masterVolumeSub.connect(__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master);
					console.log('Safari/Edge/iOS Mobile');
				}
			} else {}
		},

		//AUDIO LOADING
		firstAudioLoadFunc: function firstAudioLoadFunc() {
			var _this12 = this;

			// this.changeFX.load("../src/assets/sounds/blinks/change.wav", 
			// 	()=>{
			// 	this.whatIsLoading = "Fauna";
			// });

			// this.DesertFX.load("../src/assets/sounds/modules/desert/desertFX.wav", 
			// 	()=>{
			// 	this.whatIsLoading = "Sand";
			// });

			// this.ambience1Player.load("../src/assets/sounds/modules/desert/oasis.wav", 
			// 	()=>{
			// 	this.whatIsLoading = "Rocks";
			// });

			// this.ambience2Player.load("../src/assets/sounds/modules/desert/crowfly.wav", 
			// 	()=>{
			// 	this.whatIsLoading = "Birds";
			// });

			// this.ambience3Player.load("../src/assets/sounds/modules/desert/coyotes.wav", 
			// 	()=>{
			// 	this.whatIsLoading = "Coyotes";
			// });

			// this.ambience4Player.load("../src/assets/sounds/modules/desert/winds.wav", 
			// 	()=>{
			// 	this.whatIsLoading = "Winds";
			// });

			// this.ambience5Player.load("../src/assets/sounds/modules/desert/airplane.wav", 
			// 	()=>{
			// 	this.whatIsLoading = "Airplane";
			// });

			// this.ambience6Player.load("../src/assets/sounds/modules/desert/desertwalk.wav", 
			// 	()=>{
			// 	this.whatIsLoading = "Walkabout";
			// });


			if (this.isChrome === true || this.isOpera === true || this.isFirefox === true || this.isBlink === true) {

				this.changeFX.load("../src/assets/sounds/blinks/change.ogg", function () {
					_this12.whatIsLoading = "Fauna";
				});

				this.DesertFX.load("../src/assets/sounds/modules/desert/hiogg/desertFX.ogg", function () {
					_this12.whatIsLoading = "Sand";
				});

				this.ambience1Player.load("../src/assets/sounds/modules/desert/hiogg/oasis.ogg", function () {
					_this12.whatIsLoading = "Rocks";
				});

				this.ambience2Player.load("../src/assets/sounds/modules/desert/hiogg/crowfly.ogg", function () {
					_this12.whatIsLoading = "Birds";
				});

				this.ambience3Player.load("../src/assets/sounds/modules/desert/hiogg/coyotes.ogg", function () {
					_this12.whatIsLoading = "Coyotes";
				});

				this.ambience4Player.load("../src/assets/sounds/modules/desert/hiogg/winds.ogg", function () {
					_this12.whatIsLoading = "Winds";
				});

				this.ambience5Player.load("../src/assets/sounds/modules/desert/hiogg/airplane.ogg", function () {
					_this12.whatIsLoading = "Airplane";
				});

				this.ambience6Player.load("../src/assets/sounds/modules/desert/hiogg/desertwalk.ogg", function () {
					_this12.whatIsLoading = "Walkabout";
				});
			} else if (this.AndroidMobile === true) {
				this.changeFX.load("../src/assets/sounds/blinks/change.ogg", function () {
					_this12.whatIsLoading = "Fauna";
				});

				this.DesertFX.load("../src/assets/sounds/modules/desert/lowogg/desertFX.ogg", function () {
					_this12.whatIsLoading = "Sand";
				});

				this.ambience1Player.load("../src/assets/sounds/modules/desert/lowogg/oasis.ogg", function () {
					_this12.whatIsLoading = "Rocks";
				});

				this.ambience2Player.load("../src/assets/sounds/modules/desert/lowogg/crowfly.ogg", function () {
					_this12.whatIsLoading = "Birds";
				});

				this.ambience3Player.load("../src/assets/sounds/modules/desert/lowogg/coyotes.ogg", function () {
					_this12.whatIsLoading = "Coyotes";
				});

				this.ambience4Player.load("../src/assets/sounds/modules/desert/lowogg/winds.ogg", function () {
					_this12.whatIsLoading = "Winds";
				});

				this.ambience5Player.load("../src/assets/sounds/modules/desert/lowogg/airplane.ogg", function () {
					_this12.whatIsLoading = "Airplane";
				});

				this.ambience6Player.load("../src/assets/sounds/modules/desert/lowogg/desertwalk.ogg", function () {
					_this12.whatIsLoading = "Walkabout";
				});
			} else if (this.isSafari === true || this.isEdge === true || this.isIE === true) {

				this.changeFX.load("../src/assets/sounds/blinks/change.m4a", function () {
					_this12.whatIsLoading = "Fauna";
				});

				this.DesertFX.load("../src/assets/sounds/modules/desert/320/desertFX.m4a", function () {
					_this12.whatIsLoading = "Sand";
				});

				this.ambience1Player.load("../src/assets/sounds/modules/desert/320/oasis.m4a", function () {
					_this12.whatIsLoading = "Rocks";
				});

				this.ambience2Player.load("../src/assets/sounds/modules/desert/320/crowfly.m4a", function () {
					_this12.whatIsLoading = "Birds";
				});

				this.ambience3Player.load("../src/assets/sounds/modules/desert/320/coyotes.m4a", function () {
					_this12.whatIsLoading = "Coyotes";
				});

				this.ambience4Player.load("../src/assets/sounds/modules/desert/320/winds.m4a", function () {
					_this12.whatIsLoading = "Winds";
				});

				this.ambience5Player.load("../src/assets/sounds/modules/desert/320/airplane.m4a", function () {
					_this12.whatIsLoading = "Airplane";
				});

				this.ambience6Player.load("../src/assets/sounds/modules/desert/320/desertwalk.m4a", function () {
					_this12.whatIsLoading = "Walkabout";
				});
			} else if (this.iOS === true) {

				this.changeFX.load("../src/assets/sounds/blinks/change.m4a", function () {
					_this12.whatIsLoading = "Fauna";
				});

				this.DesertFX.load("../src/assets/sounds/modules/desert/192/desertFX.m4a", function () {
					_this12.whatIsLoading = "Sand";
				});

				this.ambience1Player.load("../src/assets/sounds/modules/desert/192/oasis.m4a", function () {
					_this12.whatIsLoading = "Rocks";
				});

				this.ambience2Player.load("../src/assets/sounds/modules/desert/192/crowfly.m4a", function () {
					_this12.whatIsLoading = "Birds";
				});

				this.ambience3Player.load("../src/assets/sounds/modules/desert/192/coyotes.m4a", function () {
					_this12.whatIsLoading = "Coyotes";
				});

				this.ambience4Player.load("../src/assets/sounds/modules/desert/192/winds.m4a", function () {
					_this12.whatIsLoading = "Winds";
				});

				this.ambience5Player.load("../src/assets/sounds/modules/desert/192/airplane.m4a", function () {
					_this12.whatIsLoading = "Airplane";
				});

				this.ambience6Player.load("../src/assets/sounds/modules/desert/192/desertwalk.m4a", function () {
					_this12.whatIsLoading = "Walkabout";
				});
			}
		},

		//GO HOME
		goHome: function goHome() {
			var _this13 = this;

			this.changeFX.start();

			//IF USER ENGAGES VOICE CONTROL BUT GOES HOME VIA 
			//MOUSE BUTTON THIS TRIGGERS MODULE SPEECH DISPOSE
			if (this.goingHomeNotViaVoiceCommand && !this.initSpeech) {
				this.stopModuleSpeech = true;
				this.recognitionDesert.stop();
				this.recognitionDesert.abort();
				this.recognitionDesert = undefined;
			};

			if (this.didWeAdventure === true) {
				this.exploreSound1.disconnect();
				// this.exploreSound2.disconnect();
				// this.exploreSound3.disconnect();
			}

			setTimeout(function () {
				__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.2);
			}, 400);

			setTimeout(function () {
				_this13.ambience1Player.disconnect();
				_this13.ambience2Player.disconnect();
				_this13.ambience3Player.disconnect();
				_this13.ambience4Player.disconnect();
				_this13.ambience5Player.disconnect();
				_this13.ambience6Player.disconnect();
				_this13.DesertFX.disconnect();
				_this13.changeFX.disconnect();
				_this13.masterVolumeSub.disconnect();
				if (_this13.userMobile === false) {
					_this13.fxConvolver.disconnect();
					_this13.fxAutoFilter.disconnect();
					_this13.fxDelay.disconnect();
					_this13.fxChorus.disconnect();
					_this13.masterMeter.disconnect();
				}
			}, 1000);

			setTimeout(function () {
				document.body.className = 'default';
				_this13.$router.push('/');
				__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master.volume.value = 0;
			}, 1100);
		}
	}
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_startaudiocontext_StartAudioContext_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_startaudiocontext_StartAudioContext_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_startaudiocontext_StartAudioContext_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var XRegExp = __webpack_require__(5);
/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			//RANDOMIZE BOOLEANS
			randomizeBoolean: false,
			showFlask1: true,
			showFlask2: false,
			showFlask3: false,
			showFlask4: false,
			showFlask5: false,
			showFlask6: false,
			//CONTROLS
			reverbChecker: undefined,
			loadingBoolean: true,
			userMobile: Boolean,
			mailingListBtn: false,
			textTiming: 500,
			startStopTrigger: true,
			playColor: "#F0CB50",
			stopColor: "#1E9BFC",
			//SCREEN DIMENSIONS
			screenHeight: undefined,
			screenWidth: undefined,
			ogWidth: undefined,
			//BACKGROUND COLORS
			plungeDepth: 1,
			backgroundColor1: true,
			backgroundColor2: false,
			backgroundColor3: false,
			backgroundColor4: false,
			backgroundColor5: false,
			backgroundColor6: false,
			backgroundColor7: false,
			backgroundColor8: false,
			backgroundColor9: false,
			backgroundColor10: false,
			//REACTIVE SUN
			sunReactiveColor1: true,
			sunReactiveColor2: false,
			sunReactiveColor3: false,
			sunReactiveColor4: false,
			sunReactiveColor5: false,
			sunReactiveColor6: false,
			sunReactiveColor7: false,
			sunReactiveColor8: false,
			sunReactiveColor9: false,
			sunReactiveColor10: false,
			//SHOW AND HIDE
			helpTrigger: false,
			showHelpOverlay: false,
			showAboutPage: false,

			bellBoolean: false,
			//PLAY SUN DRAGGIE
			activeSun: false,
			//V-SHOWS
			showEnterContainer: true,
			showLoading: true,
			showEnterBtn: false,
			showNavBar: false,
			showAllControls: false,
			showSpeechBtns: false,
			//AMBIENCE BOOLEANS
			ambience1Boolean: false,
			ambience2Boolean: false,
			ambience3Boolean: false,
			ambience4Boolean: false,
			ambience5Boolean: false,
			ambience6Boolean: false,
			//AMBIENCE DATA
			whatIsLoading: "Fire",
			fireFX: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": false,
				"volume": 0
			}).toMaster(),
			changeFX: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": false,
				"volume": -6
			}).toMaster(),
			ambience1Vol: -17,
			ambience2Vol: -17,
			ambience3Vol: -10,
			ambience4Vol: -10,
			ambience5Vol: -10,
			ambience6Vol: -10,
			ambience1Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": 0
			}),
			ambience2Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": 0
			}),
			ambience3Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": 0
			}),
			ambience4Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": 0
			}),
			ambience5Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": 0
			}),
			ambience6Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": 0
			}),
			//AUDIO ROUTING & EFFECTS
			playBackSpeed: 1,
			fxDecay: 4.5,
			// masterVolume:     		0,
			loadingSoundID: undefined,
			audioLoading: undefined,
			fxConvolverAmt: 0,
			fxDistortAmt: 0,
			fxChorusAmt: 0,
			fxDelayAmt: 0,
			fxAutoFilterAmt: 3500,
			mattChill: false,
			fxConvolver: undefined,
			fxChorus: undefined,
			fxDelay: undefined,
			fxAutoFilter: undefined,

			speedToggle: true,
			fxDelayToggle: true,
			fxConvolverToggle: true,
			fxChorusToggle: true,
			fxFilterToggle: false,

			masterLevel: 0,
			masterVolumeSub: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Volume(0),
			//SPEECH
			//FOR SPEECH FORM INPUT
			submitSpeechTxttoVoice: false,
			userVoiceToText: "",
			//IF SPEECH IS ALLOWED SHOW SPEECH ACTIVATE BUTTON (SET VIA APP.js)
			allowSpeechControl: false,
			//GLOBAL COMMAND TRIGGERING VOICE COMMANDS ON AND OFF
			isVoiceControl: false,
			//COMMAND FOR CSS CONTROL WHEN VOICE IS ACTIVE OR NOT
			recognizing: undefined,
			recognitionFire: undefined,
			//HOLDS ALL OF SPEECHRECONGNITION JSON
			voiceCommandArray: undefined,
			speechRecognitionList: undefined,
			voiceCommandConfidence: undefined,
			//STRING LINE TO TEST FOR VOICE COMMAND ACTIONS
			testObjectVUI: "",
			//BUTTON SWITCHING & TEXT
			initSpeech: true,
			speechBtnTxt: "Say A Command",
			speechStartTopBtnTrigger: true,
			//SHOWS LIST OF COMMANDS
			showVoiceCommandList: false,
			//DISABLE WHILE RECORDING
			isDisableListening: false,
			//TRUE WHEN STOPPING ALL SPEECH FUNCTIONS TO GO HOME
			stopModuleSpeech: false,
			//IF USER ENGAGES VOICE CONTROL BUT GOES HOME VIA MOUSE BUTTON THIS TRIGGERS MODULE SPEECH DISPOSE
			//EXPLORE
			isExploreFuncRunning: false,
			didWeAdventure: false,
			exploreSound1: undefined,
			exploreBtnBoolean: false,
			//WHAT DEVICE
			isChrome: Boolean,
			isFirefox: Boolean,
			isSafari: Boolean,
			isOpera: Boolean,
			isIE: Boolean,
			isEdge: Boolean,
			isBlink: Boolean,
			iOS: Boolean,
			AndroidMobile: Boolean,
			//EXPLORE TIMES OUTS
			exploreTxt: "Explore!",
			exploreTimeout1: undefined,
			exploreTimeout2: undefined,
			exploreTimeout3: undefined,
			exploreTimeout4: undefined,
			exploreTimeout5: undefined,
			exploreTimeout6: undefined,
			exploreTimeout7: undefined,
			exploreTimeout8: undefined,
			exploreTimeout9: undefined,
			exploreTimeout10: undefined,
			exploreTimeout11: undefined,
			exploreTimeout12: undefined,
			exploreTimeout13: undefined,
			//START AUDIO CONTEXT BOOLEAN
			startAudioBoolean: true,
			//LOCAL STORAGE
			isCacheSaved: false,
			firstLoad: false,
			saveTrigger: false,
			loadTrigger: false
		};
	},
	created: function created() {
		var _this = this;

		this.isVoiceControl = this.$store.state.isVoiceControlled;

		if (this.isVoiceControl) {
			this.$store.state.doNotAddress = true;
		}
		window.onpopstate = function () {
			document.body.className = 'default';
			_this.goHome();
		};
		var ua = window.navigator.userAgent;
		this.isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
		this.isFirefox = typeof InstallTrigger !== 'undefined';
		this.isSafari = /constructor/i.test(window.HTMLElement) || function (p) {
			return p.toString() === "[object SafariRemoteNotification]";
		}(!window['safari'] || safari.pushNotification);
		this.isOpera = !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
		this.isIE = /*@cc_on!@*/false || !!document.documentMode;
		this.isEdge = !this.isIE && !!window.StyleMedia;
		this.isBlink = (this.isChrome || this.isOpera) && !!window.CSS, this.iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
		this.AndroidMobile = /Android/i.test(navigator.userAgent);
		//CHROME ALLOWS SPEECH AND MEDIA RECORDING
		if (this.isChrome === true) {
			this.userMobile = false;
			//FIREFOX ONLY ALLOWS MEDIA RECORDING
		} else if (this.isFirefox === true) {
			this.userMobile = false;
			//NO SPEECH AND NO MEDIA RECORDING FOR THE FOLLOWING
		} else if (this.AndroidMobile === true || this.iOS) {
			this.userMobile = true;
		} else if (this.isSafari === true || this.isOpera === true || this.isBlink === true || this.isEdge === true || this.isIE === true) {
			this.userMobile = false;
		}
		this.firstAudioLoadFunc();
		this.bufferLoading();
		this.audioRouting();
	},

	computed: {
		//THE PLUNGE BACKGROUND CHANGE
		plungeClass: function plungeClass() {
			if (this.activeSun === false) {
				if (this.plungeDepth === 1) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = true;
				} else if (this.plungeDepth === 2) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = true;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 3) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = true;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 4) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = true;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 5) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = true;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 6) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = true;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 7) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = true;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 8) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = true;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 9) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = true;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 10) {
					this.backgroundColor10 = true;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				}
				return {
					"backgroundColorFire10": this.backgroundColor10,
					"backgroundColorFire9": this.backgroundColor9,
					"backgroundColorFire8": this.backgroundColor8,
					"backgroundColorFire7": this.backgroundColor7,
					"backgroundColorFire6": this.backgroundColor6,
					"backgroundColorFire5": this.backgroundColor5,
					"backgroundColorFire4": this.backgroundColor4,
					"backgroundColorFire3": this.backgroundColor3,
					"backgroundColorFire2": this.backgroundColor2,
					"backgroundColorFire1": this.backgroundColor1
				};
			} else if (this.activeSun === true) {
				if (this.masterLevel < -40) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = true;
				} else if (this.masterLevel < -36) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = true;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -32) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = true;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -28) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = true;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -24) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = true;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -20) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = true;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -16) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = true;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -12) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = true;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -8) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = true;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel > -4) {
					this.sunReactiveColor10 = true;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				}
				return {
					"sunReactiveColorClassFire10": this.sunReactiveColor10,
					"sunReactiveColorClassFire9": this.sunReactiveColor9,
					"sunReactiveColorClassFire8": this.sunReactiveColor8,
					"sunReactiveColorClassFire7": this.sunReactiveColor7,
					"sunReactiveColorClassFire6": this.sunReactiveColor6,
					"sunReactiveColorClassFire5": this.sunReactiveColor5,
					"sunReactiveColorClassFire4": this.sunReactiveColor4,
					"sunReactiveColorClassFire3": this.sunReactiveColor3,
					"sunReactiveColorClassFire2": this.sunReactiveColor2,
					"sunReactiveColorClassFire1": this.sunReactiveColor1
				};
			}
		},

		//SHOW AND HIDE CLASS CHANGES
		// harmoFirelass(){
		// 	return{
		// 		"btn btn-transparent": this.missionTrigger,
		// 		"btn btn-info": !this.missionTrigger,
		// 	}
		// },
		// ambianceClass(){
		// 	return{
		// 		"btn btn-transparent": this.ambianceTrigger,
		// 		"btn btn-info": !this.ambianceTrigger,
		// 	}
		// },
		helpClass: function helpClass() {
			return {
				"btn btn-helpBtn1Fire": this.helpTrigger,
				"btn btn-helpBtn2Fire": !this.helpTrigger
			};
		},
		promptButtonClass: function promptButtonClass() {
			return {
				"btn btn-transparent": this.promptTrigger,
				"btn btn-info": !this.promptTrigger
			};
		},
		mailingListBtnClass: function mailingListBtnClass() {
			return {
				"btn btn-transparent": this.mailingListBtn,
				"btn btn-info": !this.mailingListBtn
			};
		},

		//AMBIENCE CLASS CHANGES
		ambience1Class: function ambience1Class() {
			return {
				"btn btn-playFire": this.ambience1Boolean,
				"btn btn-stopFire": !this.ambience1Boolean
			};
		},
		ambience2Class: function ambience2Class() {
			return {
				"btn btn-playFire": this.ambience2Boolean,
				"btn btn-stopFire": !this.ambience2Boolean
			};
		},
		ambience3Class: function ambience3Class() {
			return {
				"btn btn-playFire": this.ambience3Boolean,
				"btn btn-stopFire": !this.ambience3Boolean
			};
		},
		ambience4Class: function ambience4Class() {
			return {
				"btn btn-playFire": this.ambience4Boolean,
				"btn btn-stopFire": !this.ambience4Boolean
			};
		},
		ambience5Class: function ambience5Class() {
			return {
				"btn btn-playFire": this.ambience5Boolean,
				"btn btn-stopFire": !this.ambience5Boolean
			};
		},
		ambience6Class: function ambience6Class() {
			return {
				"btn btn-playFire": this.ambience6Boolean,
				"btn btn-stopFire": !this.ambience6Boolean
			};
		},
		mattChillClass: function mattChillClass() {
			return {
				"btn btn-mattChillOnFire": this.mattChill,
				"btn btn-mattChillOffFire": !this.mattChill
			};
		},

		//AMBIENCE ICON CSS
		ambience1Icon: function ambience1Icon() {
			return {
				"fal fa-times-circle": !this.ambience1Boolean,
				"fal fa-check-circle": this.ambience1Boolean
			};
		},
		ambience2Icon: function ambience2Icon() {
			return {
				"fal fa-times-circle": !this.ambience2Boolean,
				"fal fa-check-circle": this.ambience2Boolean
			};
		},
		ambience3Icon: function ambience3Icon() {
			return {
				"fal fa-times-circle": !this.ambience3Boolean,
				"fal fa-check-circle": this.ambience3Boolean
			};
		},
		ambience4Icon: function ambience4Icon() {
			return {
				"fal fa-times-circle": !this.ambience4Boolean,
				"fal fa-check-circle": this.ambience4Boolean
			};
		},
		ambience5Icon: function ambience5Icon() {
			return {
				"fal fa-times-circle": !this.ambience5Boolean,
				"fal fa-check-circle": this.ambience5Boolean
			};
		},
		ambience6Icon: function ambience6Icon() {
			return {
				"fal fa-times-circle": !this.ambience6Boolean,
				"fal fa-check-circle": this.ambience6Boolean
			};
		},

		//AMBIANCE CLASS CHANGES
		ambiance1RangerClass: function ambiance1RangerClass() {
			return {
				"ambianceRangerPlayFire": this.ambience1Boolean,
				"ambianceRangerStopFire": !this.ambience1Boolean
			};
		},
		ambiance2RangerClass: function ambiance2RangerClass() {
			return {
				"ambianceRangerPlayFire": this.ambience2Boolean,
				"ambianceRangerStopFire": !this.ambience2Boolean
			};
		},
		ambiance3RangerClass: function ambiance3RangerClass() {
			return {
				"ambianceRangerPlayFire": this.ambience3Boolean,
				"ambianceRangerStopFire": !this.ambience3Boolean
			};
		},
		ambiance4RangerClass: function ambiance4RangerClass() {
			return {
				"ambianceRangerPlayFire": this.ambience4Boolean,
				"ambianceRangerStopFire": !this.ambience4Boolean
			};
		},
		ambiance5RangerClass: function ambiance5RangerClass() {
			return {
				"ambianceRangerPlayFire": this.ambience5Boolean,
				"ambianceRangerStopFire": !this.ambience5Boolean
			};
		},
		ambiance6RangerClass: function ambiance6RangerClass() {
			return {
				"ambianceRangerPlayFire": this.ambience6Boolean,
				"ambianceRangerStopFire": !this.ambience6Boolean
			};
		},

		//AUDIO MIXING
		adjustInputVolume: function adjustInputVolume() {
			this.userMic.volume.value = this.userMicInputLevel;
		},
		fxConvolverMix: function fxConvolverMix() {
			if (this.userMobile === false) {
				if (this.fxConvolverToggle === true) {
					this.fxConvolver.wet.setTargetAtTime(this.fxConvolverAmt / 100, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				} else if (this.fxConvolverToggle === false) {
					this.fxConvolver.wet.setTargetAtTime(0, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				}
			}
		},
		fxDelayMix: function fxDelayMix() {
			if (this.userMobile === false) {
				if (this.fxDelayToggle === true) {
					this.fxDelay.wet.setTargetAtTime(this.fxDelayAmt / 100, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +1);
				} else if (this.fxDelayToggle === false) {
					this.fxDelay.wet.setTargetAtTime(0, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +1);
				}
			}
		},
		fxChorusMix: function fxChorusMix() {
			if (this.userMobile === false) {
				if (this.fxChorusToggle === true) {
					this.fxChorus.wet.setTargetAtTime(this.fxChorusAmt / 100, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				} else if (this.fxChorusToggle === false) {
					this.fxChorus.wet.setTargetAtTime(0, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				}
			}
		},
		fxAutoFilterMix: function fxAutoFilterMix() {
			if (this.userMobile === false) {
				if (this.fxFilterToggle === true) {
					this.fxAutoFilter.frequency.setTargetAtTime(this.fxAutoFilterAmt, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				} else if (this.fxFilterToggle === false) {
					this.fxAutoFilter.frequency.setTargetAtTime(20000, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				}
			}
		},
		playbackSpeedFunc: function playbackSpeedFunc() {
			if (this.speedToggle === true) {
				this.ambience1Player.playbackRate = this.playBackSpeed;
				this.ambience2Player.playbackRate = this.playBackSpeed;
				this.ambience3Player.playbackRate = this.playBackSpeed;
				this.ambience4Player.playbackRate = this.playBackSpeed;
				this.ambience5Player.playbackRate = this.playBackSpeed;
				this.ambience6Player.playbackRate = this.playBackSpeed;
			} else if (this.speedToggle === false) {
				this.ambience1Player.playbackRate = 1;
				this.ambience2Player.playbackRate = 1;
				this.ambience3Player.playbackRate = 1;
				this.ambience4Player.playbackRate = 1;
				this.ambience5Player.playbackRate = 1;
				this.ambience6Player.playbackRate = 1;
			}
		},

		//SPEECH
		speechStartStopClass: function speechStartStopClass() {
			return {
				"recordingClassEngagedFire": this.recognizing,
				"recordingClassDisengagedFire": !this.recognizing
			};
		},
		speechIconClass: function speechIconClass() {
			return {
				"fa fa-microphone-alt fa-spin": this.recognizing,
				"fa fa-microphone-alt": !this.recognizing
			};
		},
		speechShowListClass: function speechShowListClass() {
			return {
				"recordingClassEngagedFire": this.showVoiceCommandList,
				"recordingClassDisengagedFire": !this.showVoiceCommandList
			};
		},
		speechSubmitClass: function speechSubmitClass() {
			return {
				"btn btn-speechSubmitOn mb-2": this.submitSpeechTxttoVoice,
				"btn btn-speechSubmitOff mb-2": !this.submitSpeechTxttoVoice
			};
		},

		//EXPLORE
		exploreFuncClass: function exploreFuncClass() {
			return {
				"recordingClassDisengagedFire": !this.isExploreFuncRunning,
				"recordingClassEngagedFire": this.isExploreFuncRunning
			};
		},
		exploreIconClass: function exploreIconClass() {
			return {
				"fab fa-wpexplorer": !this.isExploreFuncRunning,
				"fab fa-wpexplorer fa-spin": this.isExploreFuncRunning
			};
		},

		//AMBIENCE PLAY AND STOPS
		ambience1Func: function ambience1Func() {
			if (this.ambience1Boolean === true) {
				this.ambience1Player.volume.value = this.ambience1Vol;
			} else if (this.ambience1Boolean === false) {
				this.ambience1Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},
		ambience2Func: function ambience2Func() {
			if (this.ambience2Boolean === true) {
				this.ambience2Player.volume.value = this.ambience2Vol;
			} else if (this.ambience2Boolean === false) {
				this.ambience2Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},
		ambience3Func: function ambience3Func() {
			if (this.ambience3Boolean === true) {
				this.ambience3Player.volume.value = this.ambience3Vol;
			} else if (this.ambience3Boolean === false) {
				this.ambience3Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},
		ambience4Func: function ambience4Func() {
			if (this.ambience4Boolean === true) {
				this.ambience4Player.volume.value = this.ambience4Vol;
			} else if (this.ambience4Boolean === false) {
				this.ambience4Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},
		ambience5Func: function ambience5Func() {
			if (this.ambience5Boolean === true) {
				this.ambience5Player.volume.value = this.ambience5Vol;
			} else if (this.ambience5Boolean === false) {
				this.ambience5Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},
		ambience6Func: function ambience6Func() {
			if (this.ambience6Boolean === true) {
				this.ambience6Player.volume.value = this.ambience6Vol;
			} else if (this.ambience6Boolean === false) {
				this.ambience6Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},

		//LOCAL STORAGE
		saveClass: function saveClass() {
			return { "btn btn-playFire": this.saveTrigger,
				"btn btn-stopFire": !this.saveTrigger };
		},
		loadClass: function loadClass() {
			return { "btn btn-playFire": this.loadTrigger,
				"btn btn-stopFire": !this.loadTrigger };
		}
	},
	methods: {
		//LOCAL STORAGE
		setLocalStorage: function setLocalStorage() {
			var _this2 = this;

			this.saveTrigger = true;
			setTimeout(function () {
				_this2.saveTrigger = false;
			}, 250);

			this.removeLocalStorage();

			localStorage.setItem('isCacheSavedFire', JSON.stringify(true));

			localStorage.setItem('ambience1VolFire', JSON.stringify(this.ambience1Vol));
			localStorage.setItem('ambience2VolFire', JSON.stringify(this.ambience2Vol));
			localStorage.setItem('ambience3VolFire', JSON.stringify(this.ambience3Vol));
			localStorage.setItem('ambience4VolFire', JSON.stringify(this.ambience4Vol));
			localStorage.setItem('ambience5VolFire', JSON.stringify(this.ambience5Vol));
			localStorage.setItem('ambience6VolFire', JSON.stringify(this.ambience6Vol));

			localStorage.setItem('ambience1BooleanFire', JSON.stringify(this.ambience1Boolean));
			localStorage.setItem('ambience2BooleanFire', JSON.stringify(this.ambience2Boolean));
			localStorage.setItem('ambience3BooleanFire', JSON.stringify(this.ambience3Boolean));
			localStorage.setItem('ambience4BooleanFire', JSON.stringify(this.ambience4Boolean));
			localStorage.setItem('ambience5BooleanFire', JSON.stringify(this.ambience5Boolean));
			localStorage.setItem('ambience6BooleanFire', JSON.stringify(this.ambience6Boolean));

			localStorage.setItem('speedToggleFire', JSON.stringify(this.speedToggle));
			localStorage.setItem('fxDelayToggleFire', JSON.stringify(this.fxDelayToggle));
			localStorage.setItem('fxConvolverToggleFire', JSON.stringify(this.fxConvolverToggle));
			localStorage.setItem('fxChorusToggleFire', JSON.stringify(this.fxChorusToggle));
			localStorage.setItem('fxFilterToggleFire', JSON.stringify(this.fxFilterToggle));

			localStorage.setItem('playBackSpeed', JSON.stringify(this.playBackSpeed));
			localStorage.setItem('fxConvolverAmtFire', JSON.stringify(this.fxConvolverAmt));
			localStorage.setItem('fxChorusAmtFire', JSON.stringify(this.fxChorusAmt));
			localStorage.setItem('fxDelayAmtFire', JSON.stringify(this.fxDelayAmt));
			localStorage.setItem('fxAutoFilterAmtFire', JSON.stringify(this.fxAutoFilterAmt));
		},
		getLocalStorage: function getLocalStorage() {
			var _this3 = this;

			this.isCacheSaved = JSON.parse(localStorage.getItem('isCacheSavedFire'));
			if (this.isCacheSaved) {
				this.loadTrigger = true;
				setTimeout(function () {
					_this3.loadTrigger = false;
				}, 250);

				this.ambience1Vol = JSON.parse(localStorage.getItem('ambience1VolFire'));
				this.ambience2Vol = JSON.parse(localStorage.getItem('ambience2VolFire'));
				this.ambience3Vol = JSON.parse(localStorage.getItem('ambience3VolFire'));
				this.ambience4Vol = JSON.parse(localStorage.getItem('ambience4VolFire'));
				this.ambience5Vol = JSON.parse(localStorage.getItem('ambience5VolFire'));
				this.ambience6Vol = JSON.parse(localStorage.getItem('ambience6VolFire'));

				this.ambience1Boolean = JSON.parse(localStorage.getItem('ambience1BooleanFire'));
				this.ambience2Boolean = JSON.parse(localStorage.getItem('ambience2BooleanFire'));
				this.ambience3Boolean = JSON.parse(localStorage.getItem('ambience3BooleanFire'));
				this.ambience4Boolean = JSON.parse(localStorage.getItem('ambience4BooleanFire'));
				this.ambience5Boolean = JSON.parse(localStorage.getItem('ambience5BooleanFire'));
				this.ambience6Boolean = JSON.parse(localStorage.getItem('ambience6BooleanFire'));

				this.speedToggle = JSON.parse(localStorage.getItem('speedToggleFire'));
				this.fxDelayToggle = JSON.parse(localStorage.getItem('fxDelayToggleFire'));
				this.fxConvolverToggle = JSON.parse(localStorage.getItem('fxConvolverToggleFire'));
				this.fxChorusToggle = JSON.parse(localStorage.getItem('fxChorusToggleFire'));
				this.fxFilterToggle = JSON.parse(localStorage.getItem('fxFilterToggleFire'));

				this.playBackSpeed = JSON.parse(localStorage.getItem('playBackSpeed'));;
				this.fxConvolverAmt = JSON.parse(localStorage.getItem('fxConvolverAmtFire'));
				this.fxChorusAmt = JSON.parse(localStorage.getItem('fxChorusAmtFire'));
				this.fxDelayAmt = JSON.parse(localStorage.getItem('fxDelayAmtFire'));
				this.fxAutoFilterAmt = JSON.parse(localStorage.getItem('fxAutoFilterAmtFire'));
			}
		},
		removeLocalStorage: function removeLocalStorage() {
			localStorage.removeItem('isCacheSavedFire');

			localStorage.removeItem('ambience1VolFire');
			localStorage.removeItem('ambience2VolFire');
			localStorage.removeItem('ambience3VolFire');
			localStorage.removeItem('ambience4VolFire');
			localStorage.removeItem('ambience5VolFire');
			localStorage.removeItem('ambience6VolFire');

			localStorage.removeItem('ambience1BooleanFire');
			localStorage.removeItem('ambience2BooleanFire');
			localStorage.removeItem('ambience3BooleanFire');
			localStorage.removeItem('ambience4BooleanFire');
			localStorage.removeItem('ambience5BooleanFire');
			localStorage.removeItem('ambience6BooleanFire');

			localStorage.removeItem('speedToggleFire');
			localStorage.removeItem('fxDelayToggleFire');
			localStorage.removeItem('fxConvolverToggleFire');
			localStorage.removeItem('fxChorusToggleFire');
			localStorage.removeItem('fxFilterToggleFire');

			localStorage.removeItem('playBackSpeedFire');
			localStorage.removeItem('fxConvolverAmtFire');
			localStorage.removeItem('fxChorusAmtFire');
			localStorage.removeItem('fxDelayAmtFire');
			localStorage.removeItem('fxAutoFilterAmtFire');
		},

		//START AUDIO
		startAudio: function startAudio() {
			if (this.firstLoad) {
				this.firstLoad = false;
				__WEBPACK_IMPORTED_MODULE_0__node_modules_startaudiocontext_StartAudioContext_js___default()(__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.context, "#enterFuncBtn");
				this.$store.state.hasAudioContextTriggered = true;
			}
			this.ambience1Player.volume.value = -100;
			this.ambience2Player.volume.value = -100;
			this.ambience3Player.volume.value = -100;
			this.ambience4Player.volume.value = -100;
			this.ambience5Player.volume.value = -100;
			this.ambience6Player.volume.value = -100;

			this.ambience1Player.start();
			this.ambience2Player.start();
			this.ambience3Player.start();
			this.ambience4Player.start();
			this.ambience5Player.start();
			this.ambience6Player.start();
		},
		stopAudio: function stopAudio() {
			this.ambience1Player.stop();
			this.ambience2Player.stop();
			this.ambience3Player.stop();
			this.ambience4Player.stop();
			this.ambience5Player.stop();
			this.ambience6Player.stop();
		},

		//SPEECH
		userVoiceToTextFunc: function userVoiceToTextFunc() {
			var _this4 = this;

			this.submitSpeechTxttoVoice = true;
			this.testObjectVUI = this.userVoiceToText;
			console.log(this.testObjectVUI);
			this.sourceSortingVUI();
			setTimeout(function () {
				_this4.submitSpeechTxttoVoice = false;
			}, 250);
		},
		speechFunc: function speechFunc() {
			var _this5 = this;

			if (this.initSpeech === true) {
				this.recognitionFire = new webkitSpeechRecognition();
				this.recognizing;
				this.recognitionFire.continuous = false;
				this.recognitionFire.interimResults = true;

				this.recognitionFire.onresult = function (event) {
					for (var i = event.resultIndex; i < event.results.length; ++i) {
						if (event.results[i].isFinal) {
							if (!_this5.isDisableListening) {
								_this5.testObjectVUI += event.results[i][0].transcript;
								console.log('Speech String Command: ' + event.results[i][0].transcript);
								_this5.sourceSortingVUI();
							}
						}
					}
				};
				this.recognitionFire.onspeechend = function () {
					console.log('%c Fire Module SPEECH Ended', 'background: red; color: black');
					// setTimeout(this.sourceSortingVUI, 500);
					_this5.recognizing = false;
					_this5.speechBtnTxt = "Say A Command";
					__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master.volume.setTargetAtTime(0, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.context.currentTime, +0.5);
				};
				this.recognitionFire.onspeechstart = function () {
					console.log('%c Fire Module SPEECH Began', 'background: green; color: white');
					_this5.recognizing = true;
					_this5.speechBtnTxt = "Listening For Command";
					__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master.volume.setTargetAtTime(-10, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.context.currentTime, +1);
				};
				this.recognitionFire.onsoundstart = function () {
					console.log('%c Fire Module LISTENING Began', 'background: green; color: white');
				};
				this.recognitionFire.onaudioend = function () {
					console.log('%c Fire Module LISTENING Ended', 'background: green; color: white');
					// setTimeout(this.sourceSortingVUI, 500);
					_this5.recognizing = false;
					_this5.speechBtnTxt = "Say A Command";
				};
				this.recognitionFire.onend = function () {
					console.log('%c Fire Module SPEECH SESSION ENDED', 'background: green; color: white');
					if (_this5.stopModuleSpeech === false) {
						_this5.recognitionFire.start();
					}
				};
				this.recognizing = true;
				//MAKE SURE SPEECH IS NOT RE-ENGAGED
				this.initSpeech = false;
				//GLOBAL VOICE COMMAND IS SET TO TRUE
				this.$store.state.isVoiceControlled = true;
				this.recognitionFire.start();
				//IF USER ENGAGES VOICE CONTROL BUT GOES HOME VIA MOUSE BUTTON THIS TRIGGERS MODULE SPEECH DISPOSE
				this.goingHomeNotViaVoiceCommand = true;
				//CONTROLS recognition.onend TO RESTART LISTENING
				this.stopModuleSpeech = false;
				//TURN LISTENING BACK ON
				this.isDisableListening = false;
				//IF BEING VOICE CONTROLLED DON'T PLAY THE NICE, TELL ME WHERE YOU WANT TO GO PROMPT ON WELCOME PAGE
				this.$store.state.doNotAddress = true;
			} else if (this.initSpeech === false) {}
		},
		resetFunc: function resetFunc() {
			this.recognizing = false;
		},
		speechStartStopFunc: function speechStartStopFunc() {
			this.speechStartTopBtnTrigger = !this.speechStartTopBtnTrigger;

			if (this.speechStartTopBtnTrigger === true) {
				this.speechFunc();
			} else if (this.speechStartTopBtnTrigger === false) {
				this.initSpeech = true;
				this.stopModuleSpeech = true;
				this.recognizing = false;
				this.recognitionFire.stop();
				this.$store.state.isVoiceControlled = false;
			}
		},
		sourceSortingVUI: function sourceSortingVUI() {
			//FOR VISUAL REFERENCE
			this.userVoiceToText = this.testObjectVUI;

			var source1RegEx = XRegExp.build('(?x) {{source1Name}} | {{label1Name}}', {
				source1Name: XRegExp.build('{{source1Name1}} | {{source1Name2}}', {
					source1Name1: /source\sone/,
					source1Name2: /source\s1/
				}),
				label1Name: XRegExp.build('{{label1Name1}}', {
					label1Name1: /embers?/
				})
			}, 'xgi');

			var source2RegEx = XRegExp.build('(?x) {{source2Name}} | {{label2Name}}', {
				source2Name: XRegExp.build('{{source2Name1}} | {{source2Name2}}', {
					source2Name1: /source\stw?o?o/,
					source2Name2: /source\s2/
				}),
				label2Name: XRegExp.build('{{label2Name1}}', {
					label2Name1: /camp\s?fires?/
				})
			}, 'xgi');

			var source3RegEx = XRegExp.build('(?x) {{source3Name}} | {{label3Name}}', {
				source3Name: XRegExp.build('{{source3Name1}} | {{source3Name2}}', {
					source3Name1: /source\sthree/,
					source3Name2: /source\s3/
				}),
				label3Name: XRegExp.build('{{label3Name1}}', {
					label3Name1: /fire\s?places?/
				})
			}, 'xgi');

			var source4RegEx = XRegExp.build('(?x) {{source4Name}} | {{label4Name}}', {
				source4Name: XRegExp.build('{{source4Name1}} | {{source4Name2}}', {
					source4Name1: /source\sfou?re?/,
					source4Name2: /source\s4/
				}),
				label4Name: XRegExp.build('{{label4Name1}}', {
					label4Name1: /fields?\sfires?/
				})
			}, 'xgi');

			var source5RegEx = XRegExp.build('(?x) {{source5Name}} | {{label5Name}}', {
				source5Name: XRegExp.build('{{source5Name1}} | {{source5Name2}}', {
					source5Name1: /source\sfive/,
					source5Name2: /source\s5/
				}),
				label5Name: XRegExp.build('{{label5Name1}}', {
					label5Name1: /fireworks?/
				})
			}, 'xgi');

			var source6RegEx = XRegExp.build('(?x) {{source6Name}} | {{label6Name}}', {
				source6Name: XRegExp.build('{{source6Name1}} | {{source6Name2}}', {
					source6Name1: /source\ss[ei]x/,
					source6Name2: /source\s6/
				}),
				label6Name: XRegExp.build('{{label6Name1}}', {
					label6Name1: /match\s?lite?s?|match\s?lights?/
				})
			}, 'xgi');
			//ALL SOUNDS
			var allSoundRegEx = XRegExp.build('(?x) {{allSoundName}}', {
				allSoundName: XRegExp.build('{{allSoundName1}} | {{allSoundName2}}', {
					allSoundName1: /all\ssounds?/,
					allSoundName2: /all\saudios?/
				})
			}, 'xgi');
			//SPEED
			var speedRegEx = XRegExp.build('(?x) {{speedName}}', {
				speedName: XRegExp.build('{{speedName1}} | {{speedName2}}', {
					speedName1: /speeds?/,
					speedName2: /slow|faster/
				})
			}, 'xgi');
			//DELAY
			var delayRegEx = XRegExp.build('(?x) {{delayName}}', {
				delayName: XRegExp.build('{{delayName1}} | {{delayName2}}', {
					delayName1: /delay/,
					delayName2: /lay/
				})
			}, 'xgi');
			//CHORUS
			var chorusRegEx = XRegExp.build('(?x) {{chorusName}}', {
				chorusName: XRegExp.build('{{chorusName1}} | {{chorusName2}}', {
					chorusName1: /chorus?/,
					chorusName2: /course/
				})
			}, 'xgi');
			//FILTER
			var filterRegEx = XRegExp.build('(?x) {{filterName}}', {
				filterName: XRegExp.build('{{filterName1}} | {{filterName2}}', {
					filterName1: /filter/,
					filterName2: /filter/
				})
			}, 'xgi');
			//REVERB
			var reverbRegEx = XRegExp.build('(?x) {{reverbName}}', {
				reverbName: XRegExp.build('{{reverbName1}} | {{reverbName2}}', {
					reverbName1: /verb/,
					reverbName2: /reverb/
				})
			}, 'xgi');
			//SHOW
			var infoRegEx = XRegExp.build('(?x) {{showName}}', {
				showName: XRegExp.build('{{showName1}} | {{showName2}}', {
					showName1: /info/,
					showName2: /information/
				})
			}, 'xgi');
			// console.log(infoRegEx);
			//HIDE
			var listRegEx = XRegExp.build('(?x) {{hideName}}', {
				hideName: XRegExp.build('{{hideName1}} | {{hideName2}}', {
					hideName1: /lists?/,
					hideName2: /menu/
				})
			}, 'xgi');
			// console.log(listRegEx);			

			var source1Boolean = source1RegEx.test(this.testObjectVUI);
			var source2Boolean = source2RegEx.test(this.testObjectVUI);
			var source3Boolean = source3RegEx.test(this.testObjectVUI);
			var source4Boolean = source4RegEx.test(this.testObjectVUI);
			var source5Boolean = source5RegEx.test(this.testObjectVUI);
			var source6Boolean = source6RegEx.test(this.testObjectVUI);
			var allSoundBoolean = allSoundRegEx.test(this.testObjectVUI);
			var speedBoolean = speedRegEx.test(this.testObjectVUI);
			var delayBoolean = delayRegEx.test(this.testObjectVUI);
			var chorusBoolean = chorusRegEx.test(this.testObjectVUI);
			var filterBoolean = filterRegEx.test(this.testObjectVUI);
			var reverbBoolean = reverbRegEx.test(this.testObjectVUI);
			var infoBoolean = infoRegEx.test(this.testObjectVUI);
			var listBoolean = listRegEx.test(this.testObjectVUI);

			if (source1Boolean) {
				this.source1VUI();
			} else if (source2Boolean) {
				this.source2VUI();
			} else if (source3Boolean) {
				this.source3VUI();
			} else if (source4Boolean) {
				this.source4VUI();
			} else if (source5Boolean) {
				this.source5VUI();
			} else if (source6Boolean) {
				this.source6VUI();
			} else if (allSoundBoolean) {
				this.allSoundVUI();
			} else if (speedBoolean) {
				this.speedVUI();
			} else if (delayBoolean) {
				this.delayVUI();
			} else if (chorusBoolean) {
				this.chorusVUI();
			} else if (filterBoolean) {
				this.filterVUI();
			} else if (reverbBoolean) {
				this.reverbVUI();
			} else if (infoBoolean) {
				this.infoVUI();
			} else if (listBoolean) {
				this.listVUI();
			} else {
				this.miscVUI();
			}
		},
		source1VUI: function source1VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience1Player.start();
				this.ambience1Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience1Player.stop();
				this.ambience1Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience1Vol < 0) {
						this.ambience1Vol += 12;
					}
				} else {
					if (this.ambience1Vol < 0) {
						this.ambience1Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience1Vol > -30) {
						this.ambience1Vol -= 12;
					}
				} else {
					if (this.ambience1Vol > -30) {
						this.ambience1Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		source2VUI: function source2VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience2Player.start();
				this.ambience2Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience2Player.stop();
				this.ambience2Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience2Vol < 0) {
						this.ambience2Vol += 12;
					}
				} else {
					if (this.ambience2Vol < 0) {
						this.ambience2Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience2Vol > -30) {
						this.ambience2Vol -= 12;
					}
				} else {
					if (this.ambience2Vol > -30) {
						this.ambience2Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		source3VUI: function source3VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience3Player.start();
				this.ambience3Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience3Player.stop();
				this.ambience3Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience3Vol < 0) {
						this.ambience3Vol += 12;
					}
				} else {
					if (this.ambience3Vol < 0) {
						this.ambience3Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience3Vol > -30) {
						this.ambience3Vol -= 12;
					}
				} else {
					if (this.ambience3Vol > -30) {
						this.ambience3Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		source4VUI: function source4VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience4Player.start();
				this.ambience4Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience4Player.stop();
				this.ambience4Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience4Vol < 0) {
						this.ambience4Vol += 12;
					}
				} else {
					if (this.ambience4Vol < 0) {
						this.ambience4Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience4Vol > -30) {
						this.ambience4Vol -= 12;
					}
				} else {
					if (this.ambience4Vol > -30) {
						this.ambience4Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		source5VUI: function source5VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience5Player.start();
				this.ambience5Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience5Player.stop();
				this.ambience5Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience5Vol < 0) {
						this.ambience5Vol += 12;
					}
				} else {
					if (this.ambience5Vol < 0) {
						this.ambience5Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience5Vol > -30) {
						this.ambience5Vol -= 12;
					}
				} else {
					if (this.ambience5Vol > -30) {
						this.ambience5Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		source6VUI: function source6VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience6Player.start();
				this.ambience6Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience6Player.stop();
				this.ambience6Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience6Vol < 0) {
						this.ambience6Vol += 12;
					}
				} else {
					if (this.ambience6Vol < 0) {
						this.ambience6Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience6Vol > -30) {
						this.ambience6Vol -= 12;
					}
				} else {
					if (this.ambience6Vol > -30) {
						this.ambience6Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		allSoundVUI: function allSoundVUI() {
			//STOP ALL 
			if (RegExp(/stop/gi).test(this.testObjectVUI)) {
				this.ambience1Player.stop();
				this.ambience1Boolean = false;
				this.ambience2Player.stop();
				this.ambience2Boolean = false;
				this.ambience3Player.stop();
				this.ambience3Boolean = false;
				this.ambience4Player.stop();
				this.ambience4Boolean = false;
				this.ambience5Player.stop();
				this.ambience5Boolean = false;
				this.ambience6Player.stop();
				this.ambience6Boolean = false;
				if (this.didWeAdventure) {
					this.exploreSound1.stop();
					this.isExploreFuncRunning = false;
				}
			} else if (RegExp(/play/gi).test(this.testObjectVUI)) {
				this.ambience1Player.start();
				this.ambience1Boolean = true;
				this.ambience2Player.start();
				this.ambience2Boolean = true;
				this.ambience3Player.start();
				this.ambience3Boolean = true;
				this.ambience4Player.start();
				this.ambience4Boolean = true;
				this.ambience5Player.start();
				this.ambience5Boolean = true;
				this.ambience6Player.start();
				this.ambience6Boolean = true;
			}
			this.testObjectVUI = "";
		},
		speedVUI: function speedVUI() {
			if (RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI)) {
				this.speedToggle = true;
			} else if (RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI)) {
				this.speedToggle = false;
			}
			if (RegExp(/\bfaste?r?\b|up/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.playBackSpeed <= 1.6) {
						this.playBackSpeed += 0.4;
					}
				} else {
					if (this.playBackSpeed <= 1.8) {
						this.playBackSpeed += 0.2;
					}
				}
			} else if (RegExp(/slowe?r?|down/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.playBackSpeed >= 0.5) {
						this.playBackSpeed -= 0.4;
					}
				} else {
					if (this.playBackSpeed >= 0.2) {
						this.playBackSpeed -= 0.2;
					}
				}
			}
			this.testObjectVUI = "";
		},
		delayVUI: function delayVUI() {
			if (RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI)) {
				this.fxDelayToggle = true;
			} else if (RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI)) {
				this.fxDelayToggle = false;
			}
			if (RegExp(/\bmore\b|\bup\b|loude?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxDelayAmt <= 80) {
						this.fxDelayAmt += 10;
					}
				} else {
					if (this.fxDelayAmt <= 95) {
						this.fxDelayAmt += 5;
					}
				}
			} else if (RegExp(/less|\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxDelayAmt >= 20) {
						this.fxDelayAmt -= 10;
					} else if (this.fxDelayAmt >= 5) {
						this.fxDelayAmt -= 5;
					}
				} else {
					if (this.fxDelayAmt >= 5) {
						this.fxDelayAmt -= 5;
					} else if (this.fxDelayAmt >= 15) {
						this.fxDelayAmt -= 2;
					}
				}
			}
			this.testObjectVUI = "";
		},
		chorusVUI: function chorusVUI() {
			if (RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI)) {
				this.fxChorusToggle = true;
			} else if (RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI)) {
				this.fxChorusToggle = false;
			}
			if (RegExp(/\bmore\b|\bup\b|loude?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxChorusAmt <= 80) {
						this.fxChorusAmt += 10;
					}
				} else {
					if (this.fxChorusAmt <= 95) {
						this.fxChorusAmt += 5;
					}
				}
			} else if (RegExp(/less|\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxChorusAmt >= 20) {
						this.fxChorusAmt -= 10;
					} else if (this.fxChorusAmt >= 5) {
						this.fxChorusAmt -= 5;
					}
				} else {
					if (this.fxChorusAmt >= 5) {
						this.fxChorusAmt -= 5;
					} else if (this.fxChorusAmt >= 15) {
						this.fxChorusAmt -= 2;
					}
				}
			}
			this.testObjectVUI = "";
		},
		reverbVUI: function reverbVUI() {
			if (RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI)) {
				this.fxConvolverToggle = true;
			} else if (RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI)) {
				this.fxConvolverToggle = false;
			}
			if (RegExp(/\bmore\b|\bup\b|loude?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxConvolverAmt <= 45) {
						this.fxConvolverAmt += 5;
					}
				} else {
					if (this.fxConvolverAmt <= 48) {
						this.fxConvolverAmt += 2;
					}
				}
			} else if (RegExp(/less|\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxConvolverAmt >= 10) {
						this.fxConvolverAmt -= 5;
					} else if (this.fxConvolverAmt >= 2) {
						this.fxConvolverAmt -= 1;
					}
				} else {
					if (this.fxConvolverAmt >= 10) {
						this.fxConvolverAmt -= 2;
					} else if (this.fxConvolverAmt >= 2) {
						this.fxConvolverAmt -= 1;
					}
				}
			}
			this.testObjectVUI = "";
		},
		filterVUI: function filterVUI() {
			if (RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI)) {
				this.fxFilterToggle = true;
			} else if (RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI)) {
				this.fxFilterToggle = false;
			}
			if (RegExp(/\bmore\b|\blower\b/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxAutoFilterAmt > 1500) {
						this.fxAutoFilterAmt -= 1500;
					} else if (this.fxAutoFilterAmt >= 300) {
						this.fxAutoFilterAmt -= 200;
					}
				} else {
					if (this.fxAutoFilterAmt >= 500) {
						this.fxAutoFilterAmt -= 250;
					} else if (this.fxAutoFilterAmt >= 100) {
						this.fxAutoFilterAmt -= 100;
					}
				}
			} else if (RegExp(/less|higher|hire/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxAutoFilterAmt <= 10000) {
						this.fxAutoFilterAmt += 1500;
					} else if (this.fxAutoFilterAmt <= 1000) {
						this.fxAutoFilterAmt += 200;
					}
				} else {
					if (this.fxAutoFilterAmt <= 10000) {
						this.fxAutoFilterAmt += 250;
					} else if (this.fxAutoFilterAmt <= 1000) {
						this.fxAutoFilterAmt += 100;
					}
				}
			}
			this.testObjectVUI = "";
		},
		infoVUI: function infoVUI() {
			var _this6 = this;

			if (RegExp(/show|display/gi).test(this.testObjectVUI)) {
				this.showHelpOverlay = true;
				setTimeout(function () {
					_this6.showNavBar = false;
					if (_this6.$store.state.allowSpeechControl) {
						_this6.showSpeechBtns = false;
					}
				}, 0);
				setTimeout(function () {
					_this6.showAllControls = false;
				}, 500);
				setTimeout(function () {
					_this6.showAboutPage = true;
				}, 1500);
				console.log('SHOW INFO');
			} else if (RegExp(/hide|minimize/gi).test(this.testObjectVUI)) {
				this.showHelpOverlay = false;
				this.showAboutPage = false;
				setTimeout(function () {
					_this6.showAllControls = true;
				}, 800);
				setTimeout(function () {
					_this6.showNavBar = true;
					if (_this6.$store.state.allowSpeechControl) {
						_this6.showSpeechBtns = true;
					}
				}, 850);
				console.log('HIDE INFO');
			}
			this.testObjectVUI = "";
			setTimeout(function () {
				_this6.userVoiceToText = "";
			}, 3000);
		},
		listVUI: function listVUI() {
			var _this7 = this;

			if (RegExp(/show|display/gi).test(this.testObjectVUI)) {
				this.showVoiceCommandList = true;
				setTimeout(function () {
					document.getElementById('voiceControlListTxt').scrollIntoView({ behavior: "smooth" });
				}, 250);
				console.log('SHOW LIST');
			} else if (RegExp(/hide|minimize/gi).test(this.testObjectVUI)) {
				this.showVoiceCommandList = false;
				setTimeout(function () {
					document.getElementById('controlsContainer').scrollIntoView({ behavior: "smooth" });
				}, 250);
				console.log('HIDE LIST');
			}
			this.testObjectVUI = "";
			setTimeout(function () {
				_this7.userVoiceToText = "";
			}, 3000);
		},
		miscVUI: function miscVUI() {
			//RANDOMIZE
			if (RegExp(/new\s?scenes?|randomi?z?e?|shift\s?soundscapes?/gi).test(this.testObjectVUI)) {
				this.mattChillMethod();
				//EXPLORE
			} else if (RegExp(/\bexplorer?\b|\badventure\b/gi).test(this.testObjectVUI)) {
				if (RegExp(/stop/gi).test(this.testObjectVUI)) {
					this.stopExplore();
				} else {
					this.exploreFunc();
				}
				//STOP VOICE COMMANDS & GO HOME FUNCTIONS
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) && RegExp(/voice\s?controls?/gi).test(this.testObjectVUI) || RegExp(/stop/gi).test(this.testObjectVUI) && RegExp(/voice\s?commands?/gi).test(this.testObjectVUI)) {
				//DISABLES LISTENING IMMEDITATLY
				this.initSpeech = true;
				this.stopModuleSpeech = true;
				this.recognizing = false;
				this.recognitionFire.stop();
				this.$store.state.isVoiceControlled = false;
			} else if (RegExp(/home/gi).test(this.testObjectVUI)) {
				this.goingHomeNotViaVoiceCommand = false;
				this.stopModuleSpeech = true;
				this.recognitionFire.abort();
				this.recognitionFire = undefined;
				setTimeout(this.goHome, 50);
			}
			this.testObjectVUI = "";
		},
		voiceCommandListFunc: function voiceCommandListFunc() {
			this.showVoiceCommandList = !this.showVoiceCommandList;
			if (this.showVoiceCommandList) {
				setTimeout(function () {
					document.getElementById('voiceControlListTxt').scrollIntoView({ behavior: "smooth" });
				}, 250);
			} else if (!this.showVoiceCommandList) {
				document.getElementById('controlsContainer').scrollIntoView({ behavior: "smooth" });
			}
		},

		//ENTER FUNC
		enterFunc: function enterFunc() {
			var _this8 = this;

			if (this.startAudioBoolean) {
				this.startAudio();
				this.startAudioBoolean = false;
			}

			this.showEnterBtn = false;

			setTimeout(function () {
				_this8.showEnterContainer = false;
			}, 1000);

			this.fireFX.start();

			var changeTiming = 50;

			setTimeout(function () {
				_this8.plungeDepth = 1;
			}, changeTiming * 1);

			setTimeout(function () {
				_this8.plungeDepth = 2;
			}, changeTiming * 2);

			setTimeout(function () {
				_this8.plungeDepth = 3;
			}, changeTiming * 3);

			setTimeout(function () {
				_this8.plungeDepth = 4;
			}, changeTiming * 4);

			setTimeout(function () {
				_this8.plungeDepth = 5;
			}, changeTiming * 5);

			setTimeout(function () {
				_this8.plungeDepth = 6;
			}, changeTiming * 7);

			setTimeout(function () {
				_this8.plungeDepth = 7;
			}, changeTiming * 7.5);

			setTimeout(function () {
				_this8.plungeDepth = 8;
			}, changeTiming * 8);

			setTimeout(function () {
				_this8.plungeDepth = 9;
			}, changeTiming * 8.5);

			setTimeout(function () {
				_this8.plungeDepth = 10;
			}, changeTiming * 9);

			setTimeout(function () {
				_this8.showAllControls = true;
			}, 1000);

			setTimeout(function () {
				_this8.showNavBar = true;
			}, 1200);

			setTimeout(function () {
				_this8.showSpeechBtns = true;
			}, 1100);

			setTimeout(function () {
				_this8.ambience1Boolean = true;

				_this8.ambience2Boolean = true;
			}, 800);

			setTimeout(function () {
				if (_this8.userMobile === false) {
					_this8.activeSun = true;
				}
			}, 700);

			setTimeout(function () {
				_this8.ambience1Vol = -28;
				_this8.ambience2Vol = -28;
			}, 100);

			setTimeout(function () {
				_this8.ambience1Vol = -26;
				_this8.ambience2Vol = -26;
			}, 200);

			setTimeout(function () {
				_this8.ambience1Vol = -24;
				_this8.ambience2Vol = -24;
			}, 300);

			setTimeout(function () {
				_this8.ambience1Vol = -22;
				_this8.ambience2Vol = -22;
			}, 400);

			setTimeout(function () {
				_this8.ambience1Vol = -20;
				_this8.ambience2Vol = -20;
			}, 490);

			setTimeout(function () {
				_this8.ambience1Vol = -18;
				_this8.ambience2Vol = -18;
			}, 750);

			setTimeout(function () {
				_this8.ambience1Vol = -16;
				_this8.ambience2Vol = -16;
			}, 800);

			setTimeout(function () {
				_this8.ambience1Vol = -14;
				_this8.ambience2Vol = -14;
			}, 950);

			setTimeout(function () {
				_this8.ambience1Vol = -12;
				_this8.ambience2Vol = -12;
			}, 1000);

			setTimeout(function () {
				_this8.ambience1Vol = -10;
				_this8.ambience2Vol = -10;
			}, 1150);
		},

		//RANDOMIZE (MATT CHILL) PRESET
		mattChillMethod: function mattChillMethod() {
			if (this.didWeAdventure) {
				this.stopExplore();
			}

			if (this.randomizeBoolean === false) {
				this.randomizeBoolean = true;
			}

			this.mattChill = !this.mattChill;

			this.ambience1Vol = Math.floor(Math.random() * 30 - 30);
			this.ambience2Vol = Math.floor(Math.random() * 30 - 30);
			this.ambience3Vol = Math.floor(Math.random() * 30 - 30);
			this.ambience4Vol = Math.floor(Math.random() * 30 - 30);
			this.ambience5Vol = Math.floor(Math.random() * 30 - 30);
			this.ambience6Vol = Math.floor(Math.random() * 30 - 30);

			// let fx1boolean 		= Math.random() >= 0.5,
			// 	fx2boolean 		= Math.random() >= 0.5,
			// 	fx3boolean 		= Math.random() >= 0.5,
			// 	fx4boolean 		= Math.random() >= 0.5,
			// 	fx5boolean 		= Math.random() >= 0.5;

			var amb1boolean = Math.random() >= 0.5,
			    amb2boolean = Math.random() >= 0.5,
			    amb3boolean = Math.random() >= 0.5,
			    amb4boolean = Math.random() >= 0.5,
			    amb5boolean = Math.random() >= 0.5,
			    amb6boolean = Math.random() >= 0.95;

			// if (this.mattChill === true){
			//DON'T CALCULATE ON MOBILE
			if (this.userMobile === false) {
				var
				// randomVerb 		= Math.floor((Math.random() * 50) + 0),
				randomDelay = Math.floor(Math.random() * 40 + 0),
				    randomChorus = Math.floor(Math.random() * 60 + 0),
				    randomFilter = Math.floor(Math.random() * 20000 + 500);

				// this.fxConvolverAmt 	= randomVerb;
				this.fxDelayAmt = randomDelay;
				this.fxChorusAmt = randomChorus;
				this.fxAutoFilterAmt = randomFilter;

				this.fxDecay = Math.random() * 10 + 1.5;
				var fxPreDelay = Math.random() * 0.1 + 0.03;
				this.fxConvolver.decay = this.fxDecay;
				this.fxConvolver.preDelay = fxPreDelay;
				this.fxConvolver.generate();
			}
			//CALCULATE ON MOBILE & DESKTOP
			var randomSpeed = Math.random() * (2 - 0.5) + 0.5;
			this.playBackSpeed = randomSpeed;

			if (amb1boolean === true) {
				this.ambience1Boolean = true;
				this.showFlask1 = true;
			} else {
				this.ambience1Boolean = false;
				this.showFlask1 = false;
			}

			if (amb2boolean === true) {
				this.ambience2Boolean = true;
				this.showFlask2 = true;
			} else {
				this.ambience2Boolean = false;
				this.showFlask2 = false;
			}

			if (amb3boolean === true) {
				this.ambience3Boolean = true;
				this.showFlask3 = true;
			} else {
				this.ambience3Boolean = false;
				this.showFlask3 = false;
			}

			if (amb4boolean === true) {
				this.ambience4Boolean = true;
				this.showFlask4 = true;
			} else {
				this.ambience4Boolean = false;
				this.showFlask4 = false;
			}

			if (amb5boolean === true) {
				this.ambience5Boolean = true;
				this.showFlask5 = true;
			} else {
				this.ambience5Boolean = false;
				this.showFlask5 = false;
			}

			if (amb6boolean === true) {
				this.ambience6Boolean = true;
				this.showFlask6 = true;
			} else {
				this.ambience6Boolean = false;
				this.showFlask6 = false;
			}

			if (amb1boolean === false && amb2boolean === false && amb3boolean === false && amb4boolean === false && amb5boolean === false && amb6boolean === false) {
				this.ambience6Boolean = true;
				this.showFlask6 = true;
			}

			// } else if (this.mattChill === false){
			// this.fxDelayToggle = false;
			// this.fxConvolverToggle = false;
			// this.fxChorusToggle = false;
			// this.fxFilterToggle = false;
			// this.speedToggle = false;
			// } 
		},

		//EXPLORE 
		exploreBtnFunc: function exploreBtnFunc() {
			this.exploreBtnBoolean = !this.exploreBtnBoolean;
			if (this.exploreBtnBoolean) {
				this.exploreFunc();
			} else if (!this.exploreBtnBoolean) {
				this.stopExplore();
			}
		},
		exploreFunc: function exploreFunc() {
			var _this9 = this;

			//AUDIO MIXING FUNCTION
			var int = 500;
			var runExplore = function runExplore() {
				_this9.exploreSound1.start();
				_this9.speedToggle = false;

				_this9.exploreTimeout1 = setTimeout(function () {

					_this9.exploreTimeout2 = setTimeout(function () {
						_this9.ambience2Boolean = true;
						_this9.ambience2Vol = -10;
					}, int * 1);

					_this9.exploreTimeout3 = setTimeout(function () {
						_this9.ambience2Vol = -8;
					}, int * 2);

					_this9.exploreTimeout4 = setTimeout(function () {
						_this9.ambience2Vol = -6;
					}, int * 3);

					_this9.exploreTimeout5 = setTimeout(function () {
						_this9.ambience2Vol = -4;
					}, int * 4);

					_this9.exploreTimeout6 = setTimeout(function () {
						_this9.ambience2Vol = -2;
					}, int * 5);

					_this9.exploreTimeout7 = setTimeout(function () {
						_this9.ambience2Vol = 0;
					}, int * 6);

					_this9.exploreTimeout8 = setTimeout(function () {
						_this9.ambience2Vol = 2;
					}, int * 7);

					_this9.exploreTimeout9 = setTimeout(function () {
						_this9.ambience2Vol = 4;
					}, int * 8);

					_this9.exploreTimeout10 = setTimeout(function () {
						_this9.ambience2Vol = 6;
					}, int * 9);

					_this9.exploreTimeout11 = setTimeout(function () {
						_this9.ambience2Vol = 8;
					}, int * 10);

					_this9.exploreTimeout12 = setTimeout(function () {
						_this9.ambience2Vol = 10;
					}, int * 11);

					_this9.exploreTimeout13 = setTimeout(function () {
						_this9.ambience2Vol = 12;
						_this9.isExploreFuncRunning = false;
						_this9.exploreTxt = "Explore!";
					}, int * 12);
				}, 38000);
			};
			if (this.isExploreFuncRunning === false) {
				this.isExploreFuncRunning = true;
				this.exploreTxt = "Exploring";
				//INIT EXPORE SCENE
				//GENERATE REVERB
				if (!this.userMobile) {
					this.fxDecay = 4.5;
					this.fxConvolver.decay = this.fxDecay;
					this.fxConvolver.preDelay = 0.4;
					this.fxConvolver.generate();
				}

				this.ambience1Boolean = false;
				this.ambience1Vol = -10;

				this.ambience2Boolean = false;
				this.ambience2Vol = -10;

				this.ambience3Boolean = false;
				this.ambience3Vol = -30;

				this.ambience4Boolean = false;
				this.ambience4Vol = -10;

				this.ambience5Boolean = false;
				this.ambience5Vol = -30;

				this.ambience6Boolean = false;
				this.ambience6Vol = -15;

				if (!this.didWeAdventure) {
					this.exploreSound1 = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
						"playbackRate": 1,
						"loop": false,
						"volume": -6
					}).connect(this.masterVolumeSub);

					//LOADING FOR BROWSER TYPE
					if (this.isChrome === true || this.isOpera === true || this.isFirefox === true || this.isBlink === true) {

						this.exploreSound1.load("../src/assets/sounds/modules/fire/hiogg/exporeSound1Fire.ogg", function () {
							runExplore();
						});
					} else if (this.AndroidMobile === true) {
						this.exploreSound1.load("../src/assets/sounds/modules/fire/lowogg/exporeSound1Fire.ogg", function () {
							runExplore();
						});
					} else if (this.isSafari === true || this.isEdge === true || this.isIE === true) {
						this.exploreSound1.load("../src/assets/sounds/modules/fire/320/exporeSound1Fire.m4a", function () {
							runExplore();
						});
					} else if (this.iOS === true) {
						this.exploreSound1.load("../src/assets/sounds/modules/fire/192/exporeSound1Fire.m4a", function () {
							runExplore();
						});
					}
					//CLEANS UP AND DISPOSES THESE PLAYERS WHEN GOING HOME
					this.didWeAdventure = true;
				} else if (this.didWeAdventure) {
					runExplore();
				}
			} else {}
		},
		stopExplore: function stopExplore() {
			this.exploreTxt = "Explore!";
			this.exploreSound1.stop();
			this.isExploreFuncRunning = false;
			clearInterval(this.exploreTimeout1);
			clearInterval(this.exploreTimeout2);
			clearInterval(this.exploreTimeout3);
			clearInterval(this.exploreTimeout4);
			clearInterval(this.exploreTimeout5);
			clearInterval(this.exploreTimeout6);
			clearInterval(this.exploreTimeout7);
			clearInterval(this.exploreTimeout8);
			clearInterval(this.exploreTimeout9);
			clearInterval(this.exploreTimeout10);
			clearInterval(this.exploreTimeout11);
			clearInterval(this.exploreTimeout12);
			clearInterval(this.exploreTimeout13);
		},

		//MASTER METERING
		masterMetering: function masterMetering() {
			this.masterLevel = this.masterMeter.getLevel();
		},

		//MAIN SHOWSAND HIDE
		goToHelp: function goToHelp() {
			var _this10 = this;

			this.showHelpOverlay = !this.showHelpOverlay;
			this.helpTrigger = !this.helpTrigger;

			if (this.showHelpOverlay === true) {

				setTimeout(function () {
					_this10.showNavBar = false;
					if (_this10.$store.state.allowSpeechControl) {
						_this10.showSpeechBtns = false;
					}
				}, 100);

				setTimeout(function () {
					_this10.showAllControls = false;
				}, 250);

				setTimeout(function () {
					_this10.showAboutPage = true;
				}, 1000);
			} else if (this.showHelpOverlay === false) {

				this.showAboutPage = false;

				setTimeout(function () {
					_this10.showAllControls = true;
				}, 800);

				setTimeout(function () {
					_this10.showNavBar = true;
					if (_this10.$store.state.allowSpeechControl) {
						_this10.showSpeechBtns = true;
					}
				}, 850);
			}
		},

		//BUFFER LOADING
		bufferLoading: function bufferLoading() {
			var _this11 = this;

			// Tone.Buffer.on('progress', ()=>{
			// });
			__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Buffer.on('load', function () {
				//HIDE LOADING ITEMS
				_this11.showLoading = false;
				//SHOW ENTER BUTTON
				setTimeout(function () {
					_this11.showEnterBtn = true;
				}, 1000);
				//AUTO OPEN MODULE IF VOICE CONTROLLED & DO NOT REPLAY WHEN EXPLORE AUDIO LOADS 
				//ADDITIONALLY DO NOT REPLAY IF USER MIC HAS BEEN ACTIVATED FOR RECORDING
				if (_this11.isVoiceControl) {
					if (!_this11.didWeAdventure) {
						setTimeout(_this11.enterFunc, 2000);
					}
				}
				//IF VOICE CONTROL IS ACTIVE GLOBALLY ACTIVATE IN THIS MODULE
				if (_this11.isVoiceControl === true) {
					_this11.speechFunc();
				}
			});
		},

		//AUDIO ROUTING
		audioRouting: function audioRouting() {
			if (this.isChrome === true || this.AndroidMobile === true || this.isOpera === true || this.isFirefox === true || this.isBlink === true) {
				if (this.userMobile === false) {

					this.fxConvolver = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Reverb({
						"decay": 1.5,
						"preDelay": 0.01
					});
					this.fxConvolver.decay = 4.5;
					this.fxConvolver.generate();
					this.fxAutoFilter = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Filter({
						"type": "lowpass",
						"frequency": 20000,
						"rolloff": -24,
						"Q": 1,
						"gain": 0
					});
					this.fxDelay = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.PingPongDelay(.65, 0.65);
					this.fxChorus = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Chorus(4, 12.5, 1.75);
					this.masterMeter = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Meter({
						"smoothing": .4
					});
					this.ambience1Player.connect(this.masterVolumeSub);
					this.ambience2Player.connect(this.masterVolumeSub);
					this.ambience3Player.connect(this.masterVolumeSub);
					this.ambience4Player.connect(this.masterVolumeSub);
					this.ambience5Player.connect(this.masterVolumeSub);
					this.ambience6Player.connect(this.masterVolumeSub);

					this.masterVolumeSub.chain(this.fxAutoFilter, this.fxConvolver, this.fxDelay, this.fxChorus, this.masterMeter, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master);
					console.log('Chrome/Opera/FireFox Desktop');
					setInterval(this.masterMetering, 60);
				} else if (this.userMobile === true) {
					this.ambience1Player.connect(this.masterVolumeSub);
					this.ambience2Player.connect(this.masterVolumeSub);
					this.ambience3Player.connect(this.masterVolumeSub);
					this.ambience4Player.connect(this.masterVolumeSub);
					this.ambience5Player.connect(this.masterVolumeSub);
					this.ambience6Player.connect(this.masterVolumeSub);

					this.masterVolumeSub.connect(__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master);

					console.log('Chrome/Opera/FireFox Mobile');
				}
			} else if (this.isSafari === true || this.iOS === true || this.isEdge === true || this.isIE === true) {
				if (this.userMobile === false) {
					this.fxConvolver = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Reverb({
						"decay": 1.5,
						"preDelay": 0.01
					});
					this.fxConvolver.decay = 4.5;
					this.fxConvolver.generate();
					this.fxAutoFilter = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Filter({
						"type": "lowpass",
						"frequency": 20000,
						"rolloff": -24,
						"Q": 1,
						"gain": 0
					});
					this.fxDelay = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.PingPongDelay(.65, 0.65);
					this.fxChorus = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Chorus(4, 12.5, 1.75);
					this.masterMeter = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Meter({
						"smoothing": .4
					});
					this.ambience1Player.connect(this.masterVolumeSub);
					this.ambience2Player.connect(this.masterVolumeSub);
					this.ambience3Player.connect(this.masterVolumeSub);
					this.ambience4Player.connect(this.masterVolumeSub);
					this.ambience5Player.connect(this.masterVolumeSub);
					this.ambience6Player.connect(this.masterVolumeSub);

					this.masterVolumeSub.chain(this.fxAutoFilter, this.fxConvolver, this.fxDelay, this.fxChorus, this.masterMeter, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master);
					console.log('Safari/Edge/iOS Desktop');
					setInterval(this.masterMetering, 60);
				} else if (this.userMobile === true) {
					this.ambience1Player.connect(this.masterVolumeSub);
					this.ambience2Player.connect(this.masterVolumeSub);
					this.ambience3Player.connect(this.masterVolumeSub);
					this.ambience4Player.connect(this.masterVolumeSub);
					this.ambience5Player.connect(this.masterVolumeSub);
					this.ambience6Player.connect(this.masterVolumeSub);

					this.masterVolumeSub.connect(__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master);
					console.log('Safari/Edge/iOS Mobile');
				}
			} else {}
		},

		//AUDIO LOADING
		firstAudioLoadFunc: function firstAudioLoadFunc() {
			var _this12 = this;

			// this.fireFX.load("../src/assets/sounds/modules/fire/fireFX.wav", 
			// 	()=>{
			// 	this.whatIsLoading = "Accelerant";
			// });

			// this.changeFX.load("../src/assets/sounds/blinks/change.wav", 
			// 	()=>{
			// 	this.whatIsLoading = "Matches";
			// });

			// this.ambience1Player.load("../src/assets/sounds/modules/fire/campfire.wav", 
			// 	()=>{
			// 	this.whatIsLoading = "Campfire";
			// });

			// this.ambience2Player.load("../src/assets/sounds/modules/fire/field.wav", 
			// 	()=>{
			// 	this.whatIsLoading = "Field on Fire";
			// });

			// this.ambience3Player.load("../src/assets/sounds/modules/fire/fireplace.wav",
			//  ()=>{
			// 	this.whatIsLoading = "Fireplace";
			// });

			// this.ambience4Player.load("../src/assets/sounds/modules/fire/ember.wav", 
			// 	()=>{
			// 	this.whatIsLoading = "Embers";
			// });

			// this.ambience5Player.load("../src/assets/sounds/modules/fire/ember.wav", 
			// 	()=>{
			// 	this.whatIsLoading = "Embers";
			// });

			// this.ambience6Player.load("../src/assets/sounds/modules/fire/ember.wav", 
			// 	()=>{
			// 	this.whatIsLoading = "Embers";
			// });
			if (this.isChrome === true || this.isOpera === true || this.isFirefox === true || this.isBlink === true) {

				this.fireFX.load("../src/assets/sounds/modules/fire/hiogg/fireFX.ogg", function () {
					_this12.whatIsLoading = "Accelerant";
				});

				this.changeFX.load("../src/assets/sounds/blinks/change.ogg", function () {
					_this12.whatIsLoading = "Matches";
				});

				this.ambience1Player.load("../src/assets/sounds/modules/fire/hiogg/campfire.ogg", function () {
					_this12.whatIsLoading = "Campfire";
				});

				this.ambience2Player.load("../src/assets/sounds/modules/fire/hiogg/field.ogg", function () {
					_this12.whatIsLoading = "Field on Fire";
				});

				this.ambience3Player.load("../src/assets/sounds/modules/fire/hiogg/fireplace.ogg", function () {
					_this12.whatIsLoading = "Fireplace";
				});

				this.ambience4Player.load("../src/assets/sounds/modules/fire/hiogg/match.ogg", function () {
					_this12.whatIsLoading = "Tinder";
				});

				this.ambience5Player.load("../src/assets/sounds/modules/fire/hiogg/ember.ogg", function () {
					_this12.whatIsLoading = "Kindling";
				});

				this.ambience6Player.load("../src/assets/sounds/modules/fire/hiogg/fireworks.ogg", function () {
					_this12.whatIsLoading = "Fireworks";
				});
			} else if (this.AndroidMobile === true) {
				this.fireFX.load("../src/assets/sounds/modules/fire/lowogg/fireFX.ogg", function () {
					_this12.whatIsLoading = "Accelerant";
				});

				this.changeFX.load("../src/assets/sounds/blinks/change.ogg", function () {
					_this12.whatIsLoading = "Matches";
				});

				this.ambience1Player.load("../src/assets/sounds/modules/fire/lowogg/campfire.ogg", function () {
					_this12.whatIsLoading = "Campfire";
				});

				this.ambience2Player.load("../src/assets/sounds/modules/fire/lowogg/field.ogg", function () {
					_this12.whatIsLoading = "Field on Fire";
				});

				this.ambience3Player.load("../src/assets/sounds/modules/fire/lowogg/fireplace.ogg", function () {
					_this12.whatIsLoading = "Fireplace";
				});

				this.ambience4Player.load("../src/assets/sounds/modules/fire/lowogg/match.ogg", function () {
					_this12.whatIsLoading = "Tinder";
				});

				this.ambience5Player.load("../src/assets/sounds/modules/fire/lowogg/ember.ogg", function () {
					_this12.whatIsLoading = "Kindling";
				});

				this.ambience6Player.load("../src/assets/sounds/modules/fire/lowogg/fireworks.ogg", function () {
					_this12.whatIsLoading = "Fireworks";
				});
			} else if (this.isSafari === true || this.isEdge === true || this.isIE === true) {

				this.fireFX.load("../src/assets/sounds/modules/fire/320/fireFX.m4a", function () {
					_this12.whatIsLoading = "Accelerant";
				});

				this.changeFX.load("../src/assets/sounds/blinks/change.m4a", function () {
					_this12.whatIsLoading = "Matches";
				});

				this.ambience1Player.load("../src/assets/sounds/modules/fire/320/campfire.m4a", function () {
					_this12.whatIsLoading = "Campfire";
				});

				this.ambience2Player.load("../src/assets/sounds/modules/fire/320/field.m4a", function () {
					_this12.whatIsLoading = "Field on Fire";
				});

				this.ambience3Player.load("../src/assets/sounds/modules/fire/320/fireplace.m4a", function () {
					_this12.whatIsLoading = "Fireplace";
				});

				this.ambience4Player.load("../src/assets/sounds/modules/fire/320/match.m4a", function () {
					_this12.whatIsLoading = "Tinder";
				});

				this.ambience5Player.load("../src/assets/sounds/modules/fire/320/ember.m4a", function () {
					_this12.whatIsLoading = "Kindling";
				});

				this.ambience6Player.load("../src/assets/sounds/modules/fire/320/fireworks.m4a", function () {
					_this12.whatIsLoading = "Fireworks";
				});
			} else if (this.iOS === true) {
				this.fireFX.load("../src/assets/sounds/modules/fire/192/fireFX.m4a", function () {
					_this12.whatIsLoading = "Accelerant";
				});

				this.changeFX.load("../src/assets/sounds/blinks/change.m4a", function () {
					_this12.whatIsLoading = "Matches";
				});

				this.ambience1Player.load("../src/assets/sounds/modules/fire/192/campfire.m4a", function () {
					_this12.whatIsLoading = "Campfire";
				});

				this.ambience2Player.load("../src/assets/sounds/modules/fire/192/field.m4a", function () {
					_this12.whatIsLoading = "Field on Fire";
				});

				this.ambience3Player.load("../src/assets/sounds/modules/fire/192/fireplace.m4a", function () {
					_this12.whatIsLoading = "Fireplace";
				});

				this.ambience4Player.load("../src/assets/sounds/modules/fire/192/match.m4a", function () {
					_this12.whatIsLoading = "Tinder";
				});

				this.ambience5Player.load("../src/assets/sounds/modules/fire/192/ember.m4a", function () {
					_this12.whatIsLoading = "Kindling";
				});

				this.ambience6Player.load("../src/assets/sounds/modules/fire/192/fireworks.m4a", function () {
					_this12.whatIsLoading = "Fireworks";
				});
			}
		},

		//GO HOME
		goHome: function goHome() {
			var _this13 = this;

			this.changeFX.start();

			//IF USER ENGAGES VOICE CONTROL BUT GOES HOME VIA 
			//MOUSE BUTTON THIS TRIGGERS MODULE SPEECH DISPOSE
			if (this.goingHomeNotViaVoiceCommand && !this.initSpeech) {
				this.stopModuleSpeech = true;
				this.recognitionFire.stop();
				this.recognitionFire.abort();
				this.recognitionFire = undefined;
			};

			if (this.didWeAdventure === true) {
				this.exploreSound1.disconnect();
				// this.exploreSound2.disconnect();
				// this.exploreSound3.disconnect();
			}

			setTimeout(function () {
				__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.2);
			}, 400);

			setTimeout(function () {
				_this13.ambience1Player.disconnect();
				_this13.ambience2Player.disconnect();
				_this13.ambience3Player.disconnect();
				_this13.ambience4Player.disconnect();
				_this13.ambience5Player.disconnect();
				_this13.ambience6Player.disconnect();
				_this13.fireFX.disconnect();
				_this13.changeFX.disconnect();
				_this13.masterVolumeSub.disconnect();
				if (_this13.userMobile === false) {
					_this13.fxConvolver.disconnect();
					_this13.fxAutoFilter.disconnect();
					_this13.fxDelay.disconnect();
					_this13.fxChorus.disconnect();
					_this13.masterMeter.disconnect();
				}
			}, 1000);

			setTimeout(function () {
				document.body.className = 'default';
				_this13.$router.push('/');
				__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master.volume.value = 0;
			}, 1100);
		}
	}
});

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_startaudiocontext_StartAudioContext_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_startaudiocontext_StartAudioContext_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_startaudiocontext_StartAudioContext_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var XRegExp = __webpack_require__(5);
/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			//RANDOMIZE BOOLEANS
			randomizeBoolean: false,
			showFlask1: true,
			showFlask2: false,
			showFlask3: false,
			showFlask4: false,
			showFlask5: false,
			showFlask6: false,
			//CONTROLS
			reverbChecker: undefined,
			loadingBoolean: true,
			userMobile: Boolean,
			mailingListBtn: false,
			textTiming: 500,
			startStopTrigger: true,
			playColor: "#F0CB50",
			stopColor: "#1E9BFC",
			//BACKGROUND COLORS
			plungeDepth: 1,
			backgroundColor1: true,
			backgroundColor2: false,
			backgroundColor3: false,
			backgroundColor4: false,
			backgroundColor5: false,
			backgroundColor6: false,
			backgroundColor7: false,
			backgroundColor8: false,
			backgroundColor9: false,
			backgroundColor10: false,
			//REACTIVE SUN
			sunReactiveColor1: true,
			sunReactiveColor2: false,
			sunReactiveColor3: false,
			sunReactiveColor4: false,
			sunReactiveColor5: false,
			sunReactiveColor6: false,
			sunReactiveColor7: false,
			sunReactiveColor8: false,
			sunReactiveColor9: false,
			sunReactiveColor10: false,
			//SHOW AND HIDE
			helpTrigger: false,
			showHelpOverlay: false,
			showAboutPage: false,
			//PLAY SUN DRAGGIE
			activeSun: false,
			//V-SHOWS
			showEnterContainer: true,
			showLoading: true,
			showEnterBtn: false,
			showNavBar: false,
			showAllControls: false,
			showSpeechBtns: false,
			//AMBIENCE BOOLEANS
			ambience1Boolean: false,
			ambience2Boolean: false,
			ambience3Boolean: false,
			ambience4Boolean: false,
			ambience5Boolean: false,
			ambience6Boolean: false,
			//AMBIENCE DATA
			whatIsLoading: "Forest",
			forestFX: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": false,
				"volume": -5
			}).toMaster(),
			changeFX: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": false,
				"volume": -6
			}).toMaster(),
			ambience1Vol: -12,
			ambience2Vol: -15,
			ambience3Vol: -15,
			ambience4Vol: -15,
			ambience5Vol: -15,
			ambience6Vol: -16,
			ambience1Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": 0
			}),
			ambience2Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": 0
			}),
			ambience3Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": 0
			}),
			ambience4Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": 0
			}),
			ambience5Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": 0
			}),
			ambience6Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": 0
			}),
			//AUDIO ROUTING & EFFECTS
			playBackSpeed: 1,
			fxDecay: 2.5,
			// masterVolume:     		0,
			loadingSoundID: undefined,
			audioLoading: undefined,
			fxConvolverAmt: 0,
			fxChorusAmt: 0,
			fxDelayAmt: 0,
			fxAutoFilterAmt: 3500,
			mattChill: false,
			fxConvolver: undefined,
			fxChorus: undefined,
			fxDelay: undefined,
			fxAutoFilter: undefined,

			speedToggle: true,
			fxDelayToggle: true,
			fxConvolverToggle: true,
			fxChorusToggle: true,
			fxFilterToggle: false,

			masterMeter: undefined,
			masterLevel: 0,
			masterVolumeSub: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Volume(0),
			multiChannelMerger: undefined,
			//SPEECH
			//FOR SPEECH FORM INPUT
			submitSpeechTxttoVoice: false,
			userVoiceToText: "",
			//GLOBAL COMMAND TRIGGERING VOICE COMMANDS ON AND OFF
			isVoiceControl: false,
			//COMMAND FOR CSS CONTROL WHEN VOICE IS ACTIVE OR NOT
			recognizing: undefined,
			recognitionForest: undefined,
			//HOLDS ALL OF SPEECHRECONGNITION JSON
			voiceCommandArray: undefined,
			speechRecognitionList: undefined,
			voiceCommandConfidence: undefined,
			//STRING LINE TO TEST FOR VOICE COMMAND ACTIONS
			testObjectVUI: "",
			//BUTTON SWITCHING & TEXT
			initSpeech: true,
			speechBtnTxt: "Say A Command",
			speechStartTopBtnTrigger: true,
			//SHOWS LIST OF COMMANDS
			showVoiceCommandList: false,
			//DISABLE WHILE RECORDING
			isDisableListening: false,
			//TRUE WHEN STOPPING ALL SPEECH FUNCTIONS TO GO HOME
			stopModuleSpeech: false,
			//IF USER ENGAGES VOICE CONTROL BUT GOES HOME VIA MOUSE BUTTON THIS TRIGGERS MODULE SPEECH DISPOSE
			//EXPLORE
			isExploreFuncRunning: false,
			didWeAdventure: false,
			exploreSound1: undefined,
			exploreBtnBoolean: false,
			//WHAT DEVICE
			isChrome: Boolean,
			isFirefox: Boolean,
			isSafari: Boolean,
			isOpera: Boolean,
			isIE: Boolean,
			isEdge: Boolean,
			isBlink: Boolean,
			iOS: Boolean,
			AndroidMobile: Boolean,
			//EXPLORE TIMES OUTS
			exploreTxt: "Explore!",
			exploreTimeout1: undefined,
			exploreTimeout2: undefined,
			exploreTimeout3: undefined,
			exploreTimeout4: undefined,
			exploreTimeout5: undefined,
			exploreTimeout6: undefined,
			exploreTimeout7: undefined,
			exploreTimeout8: undefined,
			exploreTimeout9: undefined,
			exploreTimeout10: undefined,
			exploreTimeout11: undefined,
			exploreTimeout12: undefined,
			exploreTimeout13: undefined,
			exploreTimeout14: undefined,
			//START AUDIO CONTEXT BOOLEAN
			startAudioBoolean: true,
			//LOCAL STORAGE
			isCacheSaved: false,
			firstLoad: false,
			saveTrigger: false,
			loadTrigger: false
		};
	},
	mounted: function mounted() {},
	created: function created() {
		var _this = this;

		this.isVoiceControl = this.$store.state.isVoiceControlled;
		if (this.isVoiceControl) {
			this.$store.state.doNotAddress = true;
		}
		window.onpopstate = function () {
			document.body.className = 'default';
			_this.goHome();
		};
		var ua = window.navigator.userAgent;
		this.isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
		this.isFirefox = typeof InstallTrigger !== 'undefined';
		this.isSafari = /constructor/i.test(window.HTMLElement) || function (p) {
			return p.toString() === "[object SafariRemoteNotification]";
		}(!window['safari'] || safari.pushNotification);
		this.isOpera = !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
		this.isIE = /*@cc_on!@*/false || !!document.documentMode;
		this.isEdge = !this.isIE && !!window.StyleMedia;
		this.isBlink = (this.isChrome || this.isOpera) && !!window.CSS, this.iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
		this.AndroidMobile = /Android/i.test(navigator.userAgent);
		//CHROME ALLOWS SPEECH AND MEDIA RECORDING
		if (this.isChrome === true) {
			this.userMobile = false;
			//FIREFOX ONLY ALLOWS MEDIA RECORDING
		} else if (this.isFirefox === true) {
			this.userMobile = false;
			//NO SPEECH AND NO MEDIA RECORDING FOR THE FOLLOWING
		} else if (this.AndroidMobile === true || this.iOS) {
			this.userMobile = true;
		} else if (this.isSafari === true || this.isOpera === true || this.isBlink === true || this.isEdge === true || this.isIE === true) {
			this.userMobile = false;
		}
		this.firstAudioLoadFunc();
		this.bufferLoading();
		this.audioRouting();
	},

	computed: {
		//THE PLUNGE BACKGROUND CHANGE
		plungeClass: function plungeClass() {
			if (this.activeSun === false) {
				if (this.plungeDepth === 1) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = true;
				} else if (this.plungeDepth === 2) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = true;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 3) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = true;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 4) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = true;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 5) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = true;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 6) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = true;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 7) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = true;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 8) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = true;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 9) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = true;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 10) {
					this.backgroundColor10 = true;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				}
				return {
					"backgroundColorForest10": this.backgroundColor10,
					"backgroundColorForest9": this.backgroundColor9,
					"backgroundColorForest8": this.backgroundColor8,
					"backgroundColorForest7": this.backgroundColor7,
					"backgroundColorForest6": this.backgroundColor6,
					"backgroundColorForest5": this.backgroundColor5,
					"backgroundColorForest4": this.backgroundColor4,
					"backgroundColorForest3": this.backgroundColor3,
					"backgroundColorForest2": this.backgroundColor2,
					"backgroundColorForest1": this.backgroundColor1
				};
			} else if (this.activeSun === true) {
				if (this.masterLevel < -38) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = true;
				} else if (this.masterLevel < -34) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = true;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -30) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = true;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -26) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = true;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -22) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = true;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -18) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = true;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -14) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = true;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -12) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = true;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -8) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = true;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel > -4) {
					this.sunReactiveColor10 = true;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				}
				return {
					"sunReactiveColorClassForest10": this.sunReactiveColor10,
					"sunReactiveColorClassForest9": this.sunReactiveColor9,
					"sunReactiveColorClassForest8": this.sunReactiveColor8,
					"sunReactiveColorClassForest7": this.sunReactiveColor7,
					"sunReactiveColorClassForest6": this.sunReactiveColor6,
					"sunReactiveColorClassForest5": this.sunReactiveColor5,
					"sunReactiveColorClassForest4": this.sunReactiveColor4,
					"sunReactiveColorClassForest3": this.sunReactiveColor3,
					"sunReactiveColorClassForest2": this.sunReactiveColor2,
					"sunReactiveColorClassForest1": this.sunReactiveColor1
				};
			}
		},

		//SHOW AND HIDE CLASS CHANGES
		helpClass: function helpClass() {
			return {
				"btn btn-helpBtn1Forest": this.helpTrigger,
				"btn btn-helpBtn2Forest": !this.helpTrigger
			};
		},
		mailingListBtnClass: function mailingListBtnClass() {
			return {
				"btn btn-transparent": this.mailingListBtn,
				"btn btn-info": !this.mailingListBtn
			};
		},

		//AMBIENCE CLASS CHANGES
		ambience1Class: function ambience1Class() {
			return {
				"btn btn-playForest": this.ambience1Boolean,
				"btn btn-stopForest": !this.ambience1Boolean
			};
		},
		ambience2Class: function ambience2Class() {
			return {
				"btn btn-playForest": this.ambience2Boolean,
				"btn btn-stopForest": !this.ambience2Boolean
			};
		},
		ambience3Class: function ambience3Class() {
			return {
				"btn btn-playForest": this.ambience3Boolean,
				"btn btn-stopForest": !this.ambience3Boolean
			};
		},
		ambience4Class: function ambience4Class() {
			return {
				"btn btn-playForest": this.ambience4Boolean,
				"btn btn-stopForest": !this.ambience4Boolean
			};
		},
		ambience5Class: function ambience5Class() {
			return {
				"btn btn-playForest": this.ambience5Boolean,
				"btn btn-stopForest": !this.ambience5Boolean
			};
		},
		ambience6Class: function ambience6Class() {
			return {
				"btn btn-playForest": this.ambience6Boolean,
				"btn btn-stopForest": !this.ambience6Boolean
			};
		},
		mattChillClass: function mattChillClass() {
			return {
				"btn btn-mattChillOnForest": this.mattChill,
				"btn btn-mattChillOffForest": !this.mattChill
			};
		},

		//AMBIENCE ICON CSS
		ambience1Icon: function ambience1Icon() {
			return {
				"fal fa-times-circle": !this.ambience1Boolean,
				"fal fa-check-circle": this.ambience1Boolean
			};
		},
		ambience2Icon: function ambience2Icon() {
			return {
				"fal fa-times-circle": !this.ambience2Boolean,
				"fal fa-check-circle": this.ambience2Boolean
			};
		},
		ambience3Icon: function ambience3Icon() {
			return {
				"fal fa-times-circle": !this.ambience3Boolean,
				"fal fa-check-circle": this.ambience3Boolean
			};
		},
		ambience4Icon: function ambience4Icon() {
			return {
				"fal fa-times-circle": !this.ambience4Boolean,
				"fal fa-check-circle": this.ambience4Boolean
			};
		},
		ambience5Icon: function ambience5Icon() {
			return {
				"fal fa-times-circle": !this.ambience5Boolean,
				"fal fa-check-circle": this.ambience5Boolean
			};
		},
		ambience6Icon: function ambience6Icon() {
			return {
				"fal fa-times-circle": !this.ambience6Boolean,
				"fal fa-check-circle": this.ambience6Boolean
			};
		},

		//AMBIANCE CLASS CHANGES
		ambiance1RangerClass: function ambiance1RangerClass() {
			return {
				"ambianceRangerPlayForest": this.ambience1Boolean,
				"ambianceRangerStopForest": !this.ambience1Boolean
			};
		},
		ambiance2RangerClass: function ambiance2RangerClass() {
			return {
				"ambianceRangerPlayForest": this.ambience2Boolean,
				"ambianceRangerStopForest": !this.ambience2Boolean
			};
		},
		ambiance3RangerClass: function ambiance3RangerClass() {
			return {
				"ambianceRangerPlayForest": this.ambience3Boolean,
				"ambianceRangerStopForest": !this.ambience3Boolean
			};
		},
		ambiance4RangerClass: function ambiance4RangerClass() {
			return {
				"ambianceRangerPlayForest": this.ambience4Boolean,
				"ambianceRangerStopForest": !this.ambience4Boolean
			};
		},
		ambiance5RangerClass: function ambiance5RangerClass() {
			return {
				"ambianceRangerPlayForest": this.ambience5Boolean,
				"ambianceRangerStopForest": !this.ambience5Boolean
			};
		},
		ambiance6RangerClass: function ambiance6RangerClass() {
			return {
				"ambianceRangerPlayForest": this.ambience6Boolean,
				"ambianceRangerStopForest": !this.ambience6Boolean
			};
		},

		//OPEN MIC CSS CHANGES
		// openMicClass(){
		// 	return {
		// 		"btn btn-micClosedBtnForest": this.isMicOpen,
		// 		"btn btn-micOpenBtnForest": !this.isMicOpen
		// 	}
		// },	
		//AUDIO MIXING
		adjustInputVolume: function adjustInputVolume() {
			this.userMic.volume.value = this.userMicInputLevel;
		},
		fxConvolverMix: function fxConvolverMix() {
			if (this.userMobile === false) {
				if (this.fxConvolverToggle === true) {
					this.fxConvolver.wet.setTargetAtTime(this.fxConvolverAmt / 100, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				} else if (this.fxConvolverToggle === false) {
					this.fxConvolver.wet.setTargetAtTime(0, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				}
			}
		},
		fxDelayMix: function fxDelayMix() {
			if (this.userMobile === false) {
				if (this.fxDelayToggle === true) {
					this.fxDelay.wet.setTargetAtTime(this.fxDelayAmt / 100, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +1);
				} else if (this.fxDelayToggle === false) {
					this.fxDelay.wet.setTargetAtTime(0, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +1);
				}
			}
		},
		fxChorusMix: function fxChorusMix() {
			if (this.userMobile === false) {
				if (this.fxChorusToggle === true) {
					this.fxChorus.wet.setTargetAtTime(this.fxChorusAmt / 100, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				} else if (this.fxChorusToggle === false) {
					this.fxChorus.wet.setTargetAtTime(0, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				}
			}
		},
		fxAutoFilterMix: function fxAutoFilterMix() {
			if (this.userMobile === false) {
				if (this.fxFilterToggle === true) {
					this.fxAutoFilter.frequency.setTargetAtTime(this.fxAutoFilterAmt, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				} else if (this.fxFilterToggle === false) {
					this.fxAutoFilter.frequency.setTargetAtTime(20000, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				}
			}
		},
		playbackSpeedFunc: function playbackSpeedFunc() {
			if (this.speedToggle === true) {
				this.ambience1Player.playbackRate = this.playBackSpeed;
				this.ambience2Player.playbackRate = this.playBackSpeed;
				this.ambience3Player.playbackRate = this.playBackSpeed;
				this.ambience4Player.playbackRate = this.playBackSpeed;
				this.ambience5Player.playbackRate = this.playBackSpeed;
				this.ambience6Player.playbackRate = this.playBackSpeed;
			} else if (this.speedToggle === false) {
				this.ambience1Player.playbackRate = 1;
				this.ambience2Player.playbackRate = 1;
				this.ambience3Player.playbackRate = 1;
				this.ambience4Player.playbackRate = 1;
				this.ambience5Player.playbackRate = 1;
				this.ambience6Player.playbackRate = 1;
			}
		},

		//SPEECH
		speechStartStopClass: function speechStartStopClass() {
			return {
				"recordingClassEngagedForest": this.recognizing,
				"recordingClassDisengagedForest": !this.recognizing
			};
		},
		speechIconClass: function speechIconClass() {
			return {
				"fa fa-microphone-alt fa-spin": this.recognizing,
				"fa fa-microphone-alt": !this.recognizing
			};
		},
		speechShowListClass: function speechShowListClass() {
			return {
				"recordingClassEngagedForest": this.showVoiceCommandList,
				"recordingClassDisengagedForest": !this.showVoiceCommandList
			};
		},
		speechSubmitClass: function speechSubmitClass() {
			return {
				"btn btn-speechSubmitOn mb-2": this.submitSpeechTxttoVoice,
				"btn btn-speechSubmitOff mb-2": !this.submitSpeechTxttoVoice
			};
		},

		//EXPLORE
		exploreFuncClass: function exploreFuncClass() {
			return {
				"recordingClassDisengagedForest": !this.isExploreFuncRunning,
				"recordingClassEngagedForest": this.isExploreFuncRunning
			};
		},
		exploreIconClass: function exploreIconClass() {
			return {
				"fab fa-wpexplorer": !this.isExploreFuncRunning,
				"fab fa-wpexplorer fa-spin": this.isExploreFuncRunning
			};
		},

		//AMBIENCE PLAY AND STOPS
		ambience1Func: function ambience1Func() {
			if (this.ambience1Boolean === true) {
				this.ambience1Player.volume.value = this.ambience1Vol;
			} else if (this.ambience1Boolean === false) {
				this.ambience1Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},
		ambience2Func: function ambience2Func() {
			if (this.ambience2Boolean === true) {
				this.ambience2Player.volume.value = this.ambience2Vol;
			} else if (this.ambience2Boolean === false) {
				this.ambience2Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},
		ambience3Func: function ambience3Func() {
			if (this.ambience3Boolean === true) {
				this.ambience3Player.volume.value = this.ambience3Vol;
			} else if (this.ambience3Boolean === false) {
				this.ambience3Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},
		ambience4Func: function ambience4Func() {
			if (this.ambience4Boolean === true) {
				this.ambience4Player.volume.value = this.ambience4Vol;
			} else if (this.ambience4Boolean === false) {
				this.ambience4Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},
		ambience5Func: function ambience5Func() {
			if (this.ambience5Boolean === true) {
				this.ambience5Player.volume.value = this.ambience5Vol;
			} else if (this.ambience5Boolean === false) {
				this.ambience5Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},
		ambience6Func: function ambience6Func() {
			if (this.ambience6Boolean === true) {
				this.ambience6Player.volume.value = this.ambience6Vol;
			} else if (this.ambience6Boolean === false) {
				this.ambience6Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},

		//LOCAL STORAGE
		saveClass: function saveClass() {
			return { "btn btn-playForest": this.saveTrigger,
				"btn btn-stopForest": !this.saveTrigger };
		},
		loadClass: function loadClass() {
			return { "btn btn-playForest": this.loadTrigger,
				"btn btn-stopForest": !this.loadTrigger };
		}
	},
	methods: {
		//LOCAL STORAGE
		setLocalStorage: function setLocalStorage() {
			var _this2 = this;

			this.saveTrigger = true;
			setTimeout(function () {
				_this2.saveTrigger = false;
			}, 250);

			this.removeLocalStorage();

			localStorage.setItem('isCacheSavedForest', JSON.stringify(true));

			localStorage.setItem('ambience1VolForest', JSON.stringify(this.ambience1Vol));
			localStorage.setItem('ambience2VolForest', JSON.stringify(this.ambience2Vol));
			localStorage.setItem('ambience3VolForest', JSON.stringify(this.ambience3Vol));
			localStorage.setItem('ambience4VolForest', JSON.stringify(this.ambience4Vol));
			localStorage.setItem('ambience5VolForest', JSON.stringify(this.ambience5Vol));
			localStorage.setItem('ambience6VolForest', JSON.stringify(this.ambience6Vol));

			localStorage.setItem('ambience1BooleanForest', JSON.stringify(this.ambience1Boolean));
			localStorage.setItem('ambience2BooleanForest', JSON.stringify(this.ambience2Boolean));
			localStorage.setItem('ambience3BooleanForest', JSON.stringify(this.ambience3Boolean));
			localStorage.setItem('ambience4BooleanForest', JSON.stringify(this.ambience4Boolean));
			localStorage.setItem('ambience5BooleanForest', JSON.stringify(this.ambience5Boolean));
			localStorage.setItem('ambience6BooleanForest', JSON.stringify(this.ambience6Boolean));

			localStorage.setItem('speedToggleForest', JSON.stringify(this.speedToggle));
			localStorage.setItem('fxDelayToggleForest', JSON.stringify(this.fxDelayToggle));
			localStorage.setItem('fxConvolverToggleForest', JSON.stringify(this.fxConvolverToggle));
			localStorage.setItem('fxChorusToggleForest', JSON.stringify(this.fxChorusToggle));
			localStorage.setItem('fxFilterToggleForest', JSON.stringify(this.fxFilterToggle));

			localStorage.setItem('playBackSpeed', JSON.stringify(this.playBackSpeed));
			localStorage.setItem('fxConvolverAmtForest', JSON.stringify(this.fxConvolverAmt));
			localStorage.setItem('fxChorusAmtForest', JSON.stringify(this.fxChorusAmt));
			localStorage.setItem('fxDelayAmtForest', JSON.stringify(this.fxDelayAmt));
			localStorage.setItem('fxAutoFilterAmtForest', JSON.stringify(this.fxAutoFilterAmt));
		},
		getLocalStorage: function getLocalStorage() {
			var _this3 = this;

			this.isCacheSaved = JSON.parse(localStorage.getItem('isCacheSavedForest'));
			if (this.isCacheSaved) {
				this.loadTrigger = true;
				setTimeout(function () {
					_this3.loadTrigger = false;
				}, 250);

				this.ambience1Vol = JSON.parse(localStorage.getItem('ambience1VolForest'));
				this.ambience2Vol = JSON.parse(localStorage.getItem('ambience2VolForest'));
				this.ambience3Vol = JSON.parse(localStorage.getItem('ambience3VolForest'));
				this.ambience4Vol = JSON.parse(localStorage.getItem('ambience4VolForest'));
				this.ambience5Vol = JSON.parse(localStorage.getItem('ambience5VolForest'));
				this.ambience6Vol = JSON.parse(localStorage.getItem('ambience6VolForest'));

				this.ambience1Boolean = JSON.parse(localStorage.getItem('ambience1BooleanForest'));
				this.ambience2Boolean = JSON.parse(localStorage.getItem('ambience2BooleanForest'));
				this.ambience3Boolean = JSON.parse(localStorage.getItem('ambience3BooleanForest'));
				this.ambience4Boolean = JSON.parse(localStorage.getItem('ambience4BooleanForest'));
				this.ambience5Boolean = JSON.parse(localStorage.getItem('ambience5BooleanForest'));
				this.ambience6Boolean = JSON.parse(localStorage.getItem('ambience6BooleanForest'));

				this.speedToggle = JSON.parse(localStorage.getItem('speedToggleForest'));
				this.fxDelayToggle = JSON.parse(localStorage.getItem('fxDelayToggleForest'));
				this.fxConvolverToggle = JSON.parse(localStorage.getItem('fxConvolverToggleForest'));
				this.fxChorusToggle = JSON.parse(localStorage.getItem('fxChorusToggleForest'));
				this.fxFilterToggle = JSON.parse(localStorage.getItem('fxFilterToggleForest'));

				this.playBackSpeed = JSON.parse(localStorage.getItem('playBackSpeed'));;
				this.fxConvolverAmt = JSON.parse(localStorage.getItem('fxConvolverAmtForest'));
				this.fxChorusAmt = JSON.parse(localStorage.getItem('fxChorusAmtForest'));
				this.fxDelayAmt = JSON.parse(localStorage.getItem('fxDelayAmtForest'));
				this.fxAutoFilterAmt = JSON.parse(localStorage.getItem('fxAutoFilterAmtForest'));
			}
		},
		removeLocalStorage: function removeLocalStorage() {
			localStorage.removeItem('isCacheSavedForest');

			localStorage.removeItem('ambience1VolForest');
			localStorage.removeItem('ambience2VolForest');
			localStorage.removeItem('ambience3VolForest');
			localStorage.removeItem('ambience4VolForest');
			localStorage.removeItem('ambience5VolForest');
			localStorage.removeItem('ambience6VolForest');

			localStorage.removeItem('ambience1BooleanForest');
			localStorage.removeItem('ambience2BooleanForest');
			localStorage.removeItem('ambience3BooleanForest');
			localStorage.removeItem('ambience4BooleanForest');
			localStorage.removeItem('ambience5BooleanForest');
			localStorage.removeItem('ambience6BooleanForest');

			localStorage.removeItem('speedToggleForest');
			localStorage.removeItem('fxDelayToggleForest');
			localStorage.removeItem('fxConvolverToggleForest');
			localStorage.removeItem('fxChorusToggleForest');
			localStorage.removeItem('fxFilterToggleForest');

			localStorage.removeItem('playBackSpeedForest');
			localStorage.removeItem('fxConvolverAmtForest');
			localStorage.removeItem('fxChorusAmtForest');
			localStorage.removeItem('fxDelayAmtForest');
			localStorage.removeItem('fxAutoFilterAmtForest');
		},

		//START AUDIO
		startAudio: function startAudio() {
			if (this.firstLoad) {
				this.firstLoad = false;
				__WEBPACK_IMPORTED_MODULE_0__node_modules_startaudiocontext_StartAudioContext_js___default()(__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.context, "#enterFuncBtn");
				this.$store.state.hasAudioContextTriggered = true;
			}
			this.ambience1Player.volume.value = -100;
			this.ambience2Player.volume.value = -100;
			this.ambience3Player.volume.value = -100;
			this.ambience4Player.volume.value = -100;
			this.ambience5Player.volume.value = -100;
			this.ambience6Player.volume.value = -100;

			this.ambience1Player.start();
			this.ambience2Player.start();
			this.ambience3Player.start();
			this.ambience4Player.start();
			this.ambience5Player.start();
			this.ambience6Player.start();
		},
		stopAudio: function stopAudio() {
			this.ambience1Player.stop();
			this.ambience2Player.stop();
			this.ambience3Player.stop();
			this.ambience4Player.stop();
			this.ambience5Player.stop();
			this.ambience6Player.stop();
		},

		//SPEECH
		userVoiceToTextFunc: function userVoiceToTextFunc() {
			var _this4 = this;

			this.submitSpeechTxttoVoice = true;
			this.testObjectVUI = this.userVoiceToText;
			console.log(this.testObjectVUI);
			this.sourceSortingVUI();
			setTimeout(function () {
				_this4.submitSpeechTxttoVoice = false;
			}, 250);
		},
		speechFunc: function speechFunc() {
			var _this5 = this;

			if (this.initSpeech === true) {
				this.recognitionForest = new webkitSpeechRecognition();
				this.recognizing;
				this.recognitionForest.continuous = false;
				this.recognitionForest.interimResults = true;

				this.recognitionForest.onresult = function (event) {
					for (var i = event.resultIndex; i < event.results.length; ++i) {
						if (event.results[i].isFinal) {
							if (!_this5.isDisableListening) {
								_this5.testObjectVUI += event.results[i][0].transcript;
								console.log('Speech String Command: ' + event.results[i][0].transcript);
								_this5.sourceSortingVUI();
							}
						}
					}
				};
				this.recognitionForest.onspeechend = function () {
					console.log('%c Forest Module SPEECH Ended', 'background: red; color: black');
					// setTimeout(this.sourceSortingVUI, 500);
					_this5.recognizing = false;
					_this5.speechBtnTxt = "Say A Command";
					__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master.volume.setTargetAtTime(0, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.context.currentTime, +0.5);
				};
				this.recognitionForest.onspeechstart = function () {
					console.log('%c Forest Module SPEECH Began', 'background: green; color: white');
					_this5.recognizing = true;
					_this5.speechBtnTxt = "Listening For Command";
					__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master.volume.setTargetAtTime(-10, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.context.currentTime, +0.1);
				};
				this.recognitionForest.onsoundstart = function () {
					console.log('%c Forest Module LISTENING Began', 'background: green; color: white');
				};
				this.recognitionForest.onaudioend = function () {
					console.log('%c Forest Module LISTENING Ended', 'background: green; color: white');
					// setTimeout(this.sourceSortingVUI, 500);
					_this5.recognizing = false;
					_this5.speechBtnTxt = "Say A Command";
				};
				this.recognitionForest.onend = function () {
					console.log('%c Forest Module SPEECH SESSION ENDED', 'background: green; color: white');
					if (_this5.stopModuleSpeech === false) {
						_this5.recognitionForest.start();
					}
				};
				this.recognizing = true;
				//MAKE SURE SPEECH IS NOT RE-ENGAGED
				this.initSpeech = false;
				//GLOBAL VOICE COMMAND IS SET TO TRUE
				this.$store.state.isVoiceControlled = true;
				this.recognitionForest.start();
				//IF USER ENGAGES VOICE CONTROL BUT GOES HOME VIA MOUSE BUTTON THIS TRIGGERS MODULE SPEECH DISPOSE
				this.goingHomeNotViaVoiceCommand = true;
				//CONTROLS recognition.onend TO RESTART LISTENING
				this.stopModuleSpeech = false;
				//TURN LISTENING BACK ON
				this.isDisableListening = false;
				//IF BEING VOICE CONTROLLED DON'T PLAY THE NICE, TELL ME WHERE YOU WANT TO GO PROMPT ON WELCOME PAGE
				this.$store.state.doNotAddress = true;
			} else if (this.initSpeech === false) {}
		},
		resetFunc: function resetFunc() {
			this.recognizing = false;
		},
		speechStartStopFunc: function speechStartStopFunc() {
			this.speechStartTopBtnTrigger = !this.speechStartTopBtnTrigger;

			if (this.speechStartTopBtnTrigger === true) {
				this.speechFunc();
			} else if (this.speechStartTopBtnTrigger === false) {
				this.initSpeech = true;
				this.stopModuleSpeech = true;
				this.recognizing = false;
				this.recognitionForest.stop();
				this.$store.state.isVoiceControlled = false;
			}
		},
		sourceSortingVUI: function sourceSortingVUI() {
			//FOR VISUAL REFERENCE
			this.userVoiceToText = this.testObjectVUI;

			var source1RegEx = XRegExp.build('(?x) {{source1Name}} | {{label1Name}}', {
				source1Name: XRegExp.build('{{source1Name1}} | {{source1Name2}}', {
					source1Name1: /source\sone/,
					source1Name2: /source\s1/
				}),
				label1Name: XRegExp.build('{{label1Name1}} | {{label1Name2}}', {
					label1Name1: /in\s?se[cx]ts?/,
					label1Name2: /\bbugs\b/
				})
			}, 'xgi');

			var source2RegEx = XRegExp.build('(?x) {{source2Name}} | {{label2Name}}', {
				source2Name: XRegExp.build('{{source2Name1}} | {{source2Name2}}', {
					source2Name1: /source\stw?o?o/,
					source2Name2: /source\s2/
				}),
				label2Name: XRegExp.build('{{label2Name1}} | {{label2Name2}}', {
					label2Name1: /summer\sbirds?/,
					label2Name2: /summer/
				})
			}, 'xgi');

			var source3RegEx = XRegExp.build('(?x) {{source3Name}} | {{label3Name}}', {
				source3Name: XRegExp.build('{{source3Name1}} | {{source3Name2}}', {
					source3Name1: /source\sthree/,
					source3Name2: /source\s3/
				}),
				label3Name: XRegExp.build('{{label3Name1}} | {{label3Name2}}', {
					label3Name1: /winter\sbirds?/,
					label3Name2: /winter/
				})
			}, 'xgi');

			var source4RegEx = XRegExp.build('(?x) {{source4Name}} | {{label4Name}}', {
				source4Name: XRegExp.build('{{source4Name1}} | {{source4Name2}}', {
					source4Name1: /source\sfou?re?/,
					source4Name2: /source\s4/
				}),
				label4Name: XRegExp.build('{{label4Name1}} | {{label4Name2}}', {
					label4Name1: /mar[sc]hland/,
					label4Name2: /swamp|bog|mississippi/
				})
			}, 'xgi');

			var source5RegEx = XRegExp.build('(?x) {{source5Name}} | {{label5Name}}', {
				source5Name: XRegExp.build('{{source5Name1}} | {{source5Name2}}', {
					source5Name1: /source\sfive/,
					source5Name2: /source\s5/
				}),
				label5Name: XRegExp.build('{{label5Name1}} | {{label5Name2}}', {
					label5Name1: /b?a?l?loo?ns?/,
					label5Name2: /loans?/
				})
			}, 'xgi');

			var source6RegEx = XRegExp.build('(?x) {{source6Name}} | {{label6Name}}', {
				source6Name: XRegExp.build('{{source6Name1}} | {{source6Name2}}', {
					source6Name1: /source\ss[ei]x/,
					source6Name2: /source\s6/
				}),
				label6Name: XRegExp.build('{{label6Name1}}', {
					label6Name1: /stream|water|brook|broke|brooke/
				})
			}, 'xgi');
			//ALL SOUNDS
			var allSoundRegEx = XRegExp.build('(?x) {{allSoundName}}', {
				allSoundName: XRegExp.build('{{allSoundName1}} | {{allSoundName2}}', {
					allSoundName1: /all\ssounds?/,
					allSoundName2: /all\saudios?/
				})
			}, 'xgi');
			//SPEED
			var speedRegEx = XRegExp.build('(?x) {{speedName}}', {
				speedName: XRegExp.build('{{speedName1}} | {{speedName2}}', {
					speedName1: /speeds?/,
					speedName2: /slow|faster/
				})
			}, 'xgi');
			//DELAY
			var delayRegEx = XRegExp.build('(?x) {{delayName}}', {
				delayName: XRegExp.build('{{delayName1}} | {{delayName2}}', {
					delayName1: /delay/,
					delayName2: /lay/
				})
			}, 'xgi');
			//CHORUS
			var chorusRegEx = XRegExp.build('(?x) {{chorusName}}', {
				chorusName: XRegExp.build('{{chorusName1}} | {{chorusName2}}', {
					chorusName1: /chorus?/,
					chorusName2: /course/
				})
			}, 'xgi');
			//FILTER
			var filterRegEx = XRegExp.build('(?x) {{filterName}}', {
				filterName: XRegExp.build('{{filterName1}} | {{filterName2}}', {
					filterName1: /filter/,
					filterName2: /filter/
				})
			}, 'xgi');
			//REVERB
			var reverbRegEx = XRegExp.build('(?x) {{reverbName}}', {
				reverbName: XRegExp.build('{{reverbName1}} | {{reverbName2}}', {
					reverbName1: /r?e?verb/,
					reverbName2: /river/
				})
			}, 'xgi');
			//SHOW
			var infoRegEx = XRegExp.build('(?x) {{showName}}', {
				showName: XRegExp.build('{{showName1}} | {{showName2}}', {
					showName1: /info/,
					showName2: /information/
				})
			}, 'xgi');
			// console.log(infoRegEx);
			//HIDE
			var listRegEx = XRegExp.build('(?x) {{hideName}}', {
				hideName: XRegExp.build('{{hideName1}} | {{hideName2}}', {
					hideName1: /lists?/,
					hideName2: /menu/
				})
			}, 'xgi');
			// console.log(listRegEx);			

			var source1Boolean = source1RegEx.test(this.testObjectVUI);
			var source2Boolean = source2RegEx.test(this.testObjectVUI);
			var source3Boolean = source3RegEx.test(this.testObjectVUI);
			var source4Boolean = source4RegEx.test(this.testObjectVUI);
			var source5Boolean = source5RegEx.test(this.testObjectVUI);
			var source6Boolean = source6RegEx.test(this.testObjectVUI);
			var allSoundBoolean = allSoundRegEx.test(this.testObjectVUI);
			var speedBoolean = speedRegEx.test(this.testObjectVUI);
			var delayBoolean = delayRegEx.test(this.testObjectVUI);
			var chorusBoolean = chorusRegEx.test(this.testObjectVUI);
			var filterBoolean = filterRegEx.test(this.testObjectVUI);
			var reverbBoolean = reverbRegEx.test(this.testObjectVUI);
			var infoBoolean = infoRegEx.test(this.testObjectVUI);
			var listBoolean = listRegEx.test(this.testObjectVUI);

			if (source1Boolean) {
				this.source1VUI();
			} else if (source2Boolean) {
				this.source2VUI();
			} else if (source3Boolean) {
				this.source3VUI();
			} else if (source4Boolean) {
				this.source4VUI();
			} else if (source5Boolean) {
				this.source5VUI();
			} else if (source6Boolean) {
				this.source6VUI();
			} else if (allSoundBoolean) {
				this.allSoundVUI();
			} else if (speedBoolean) {
				this.speedVUI();
			} else if (delayBoolean) {
				this.delayVUI();
			} else if (chorusBoolean) {
				this.chorusVUI();
			} else if (filterBoolean) {
				this.filterVUI();
			} else if (reverbBoolean) {
				this.reverbVUI();
			} else if (infoBoolean) {
				this.infoVUI();
			} else if (listBoolean) {
				this.listVUI();
			} else {
				this.miscVUI();
			}
		},
		source1VUI: function source1VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience1Player.start();
				this.ambience1Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience1Player.stop();
				this.ambience1Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience1Vol < 0) {
						this.ambience1Vol += 12;
					}
				} else {
					if (this.ambience1Vol < 0) {
						this.ambience1Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience1Vol > -30) {
						this.ambience1Vol -= 12;
					}
				} else {
					if (this.ambience1Vol > -30) {
						this.ambience1Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		source2VUI: function source2VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience2Player.start();
				this.ambience2Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience2Player.stop();
				this.ambience2Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience2Vol < 0) {
						this.ambience2Vol += 12;
					}
				} else {
					if (this.ambience2Vol < 0) {
						this.ambience2Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience2Vol > -30) {
						this.ambience2Vol -= 12;
					}
				} else {
					if (this.ambience2Vol > -30) {
						this.ambience2Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		source3VUI: function source3VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience3Player.start();
				this.ambience3Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience3Player.stop();
				this.ambience3Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience3Vol < 0) {
						this.ambience3Vol += 12;
					}
				} else {
					if (this.ambience3Vol < 0) {
						this.ambience3Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience3Vol > -30) {
						this.ambience3Vol -= 12;
					}
				} else {
					if (this.ambience3Vol > -30) {
						this.ambience3Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		source4VUI: function source4VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience4Player.start();
				this.ambience4Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience4Player.stop();
				this.ambience4Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience4Vol < 0) {
						this.ambience4Vol += 12;
					}
				} else {
					if (this.ambience4Vol < 0) {
						this.ambience4Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience4Vol > -30) {
						this.ambience4Vol -= 12;
					}
				} else {
					if (this.ambience4Vol > -30) {
						this.ambience4Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		source5VUI: function source5VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience5Player.start();
				this.ambience5Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience5Player.stop();
				this.ambience5Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience5Vol < 0) {
						this.ambience5Vol += 12;
					}
				} else {
					if (this.ambience5Vol < 0) {
						this.ambience5Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience5Vol > -30) {
						this.ambience5Vol -= 12;
					}
				} else {
					if (this.ambience5Vol > -30) {
						this.ambience5Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		source6VUI: function source6VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience6Player.start();
				this.ambience6Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience6Player.stop();
				this.ambience6Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience6Vol < 0) {
						this.ambience6Vol += 12;
					}
				} else {
					if (this.ambience6Vol < 0) {
						this.ambience6Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience6Vol > -30) {
						this.ambience6Vol -= 12;
					}
				} else {
					if (this.ambience6Vol > -30) {
						this.ambience6Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		allSoundVUI: function allSoundVUI() {
			//STOP ALL 
			if (RegExp(/stop/gi).test(this.testObjectVUI)) {
				this.ambience1Player.stop();
				this.ambience1Boolean = false;
				this.ambience2Player.stop();
				this.ambience2Boolean = false;
				this.ambience3Player.stop();
				this.ambience3Boolean = false;
				this.ambience4Player.stop();
				this.ambience4Boolean = false;
				this.ambience5Player.stop();
				this.ambience5Boolean = false;
				this.ambience6Player.stop();
				this.ambience6Boolean = false;
				if (this.didWeAdventure) {
					this.exploreSound1.stop();
					this.isExploreFuncRunning = false;
				}
			} else if (RegExp(/play/gi).test(this.testObjectVUI)) {
				this.ambience1Player.start();
				this.ambience1Boolean = true;
				this.ambience2Player.start();
				this.ambience2Boolean = true;
				this.ambience3Player.start();
				this.ambience3Boolean = true;
				this.ambience4Player.start();
				this.ambience4Boolean = true;
				this.ambience5Player.start();
				this.ambience5Boolean = true;
				this.ambience6Player.start();
				this.ambience6Boolean = true;
			}
			this.testObjectVUI = "";
		},
		speedVUI: function speedVUI() {
			if (RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI)) {
				this.speedToggle = true;
			} else if (RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI)) {
				this.speedToggle = false;
			}
			if (RegExp(/\bfaste?r?\b|up/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.playBackSpeed <= 1.6) {
						this.playBackSpeed += 0.4;
					}
				} else {
					if (this.playBackSpeed <= 1.8) {
						this.playBackSpeed += 0.2;
					}
				}
			} else if (RegExp(/slowe?r?|down/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.playBackSpeed >= 0.5) {
						this.playBackSpeed -= 0.4;
					}
				} else {
					if (this.playBackSpeed >= 0.2) {
						this.playBackSpeed -= 0.2;
					}
				}
			}
			this.testObjectVUI = "";
		},
		delayVUI: function delayVUI() {
			if (RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI)) {
				this.fxDelayToggle = true;
			} else if (RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI)) {
				this.fxDelayToggle = false;
			}
			if (RegExp(/\bmore\b|\bup\b|loude?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxDelayAmt <= 80) {
						this.fxDelayAmt += 10;
					}
				} else {
					if (this.fxDelayAmt <= 95) {
						this.fxDelayAmt += 5;
					}
				}
			} else if (RegExp(/less|\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxDelayAmt >= 20) {
						this.fxDelayAmt -= 10;
					} else if (this.fxDelayAmt >= 5) {
						this.fxDelayAmt -= 5;
					}
				} else {
					if (this.fxDelayAmt >= 5) {
						this.fxDelayAmt -= 5;
					} else if (this.fxDelayAmt >= 15) {
						this.fxDelayAmt -= 2;
					}
				}
			}
			this.testObjectVUI = "";
		},
		chorusVUI: function chorusVUI() {
			if (RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI)) {
				this.fxChorusToggle = true;
			} else if (RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI)) {
				this.fxChorusToggle = false;
			}
			if (RegExp(/\bmore\b|\bup\b|loude?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxChorusAmt <= 80) {
						this.fxChorusAmt += 10;
					}
				} else {
					if (this.fxChorusAmt <= 95) {
						this.fxChorusAmt += 5;
					}
				}
			} else if (RegExp(/less|\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxChorusAmt >= 20) {
						this.fxChorusAmt -= 10;
					} else if (this.fxChorusAmt >= 5) {
						this.fxChorusAmt -= 5;
					}
				} else {
					if (this.fxChorusAmt >= 5) {
						this.fxChorusAmt -= 5;
					} else if (this.fxChorusAmt >= 15) {
						this.fxChorusAmt -= 2;
					}
				}
			}
			this.testObjectVUI = "";
		},
		reverbVUI: function reverbVUI() {
			if (RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI)) {
				this.fxConvolverToggle = true;
			} else if (RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI)) {
				this.fxConvolverToggle = false;
			}
			if (RegExp(/\bmore\b|\bup\b|loude?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxConvolverAmt <= 45) {
						this.fxConvolverAmt += 5;
					}
				} else {
					if (this.fxConvolverAmt <= 48) {
						this.fxConvolverAmt += 2;
					}
				}
			} else if (RegExp(/less|\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxConvolverAmt >= 10) {
						this.fxConvolverAmt -= 5;
					} else if (this.fxConvolverAmt >= 2) {
						this.fxConvolverAmt -= 1;
					}
				} else {
					if (this.fxConvolverAmt >= 10) {
						this.fxConvolverAmt -= 2;
					} else if (this.fxConvolverAmt >= 2) {
						this.fxConvolverAmt -= 1;
					}
				}
			}
			this.testObjectVUI = "";
		},
		filterVUI: function filterVUI() {
			if (RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI)) {
				this.fxFilterToggle = true;
			} else if (RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI)) {
				this.fxFilterToggle = false;
			}
			if (RegExp(/\bmore\b|\blower\b/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxAutoFilterAmt > 1500) {
						this.fxAutoFilterAmt -= 1500;
					} else if (this.fxAutoFilterAmt >= 300) {
						this.fxAutoFilterAmt -= 200;
					}
				} else {
					if (this.fxAutoFilterAmt >= 500) {
						this.fxAutoFilterAmt -= 250;
					} else if (this.fxAutoFilterAmt >= 100) {
						this.fxAutoFilterAmt -= 100;
					}
				}
			} else if (RegExp(/less|higher|hire/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxAutoFilterAmt <= 10000) {
						this.fxAutoFilterAmt += 1500;
					} else if (this.fxAutoFilterAmt <= 1000) {
						this.fxAutoFilterAmt += 200;
					}
				} else {
					if (this.fxAutoFilterAmt <= 10000) {
						this.fxAutoFilterAmt += 250;
					} else if (this.fxAutoFilterAmt <= 1000) {
						this.fxAutoFilterAmt += 100;
					}
				}
			}
			this.testObjectVUI = "";
		},
		infoVUI: function infoVUI() {
			var _this6 = this;

			if (RegExp(/show|display/gi).test(this.testObjectVUI)) {
				this.showHelpOverlay = true;
				setTimeout(function () {
					_this6.showNavBar = false;
					if (_this6.$store.state.allowSpeechControl) {
						_this6.showSpeechBtns = false;
					}
				}, 0);
				setTimeout(function () {
					_this6.showAllControls = false;
				}, 500);
				setTimeout(function () {
					_this6.showAboutPage = true;
				}, 1500);
				console.log('SHOW INFO');
			} else if (RegExp(/hide|minimize/gi).test(this.testObjectVUI)) {
				this.showHelpOverlay = false;
				this.showAboutPage = false;
				setTimeout(function () {
					_this6.showAllControls = true;
				}, 800);
				setTimeout(function () {
					_this6.showNavBar = true;
					if (_this6.$store.state.allowSpeechControl) {
						_this6.showSpeechBtns = true;
					}
				}, 850);
				console.log('HIDE INFO');
			}
			this.testObjectVUI = "";
			setTimeout(function () {
				_this6.userVoiceToText = "";
			}, 3000);
		},
		listVUI: function listVUI() {
			var _this7 = this;

			if (RegExp(/show|display/gi).test(this.testObjectVUI)) {
				this.showVoiceCommandList = true;
				setTimeout(function () {
					document.getElementById('voiceControlListTxt').scrollIntoView({ behavior: "smooth" });
				}, 250);
				console.log('SHOW LIST');
			} else if (RegExp(/hide|minimize/gi).test(this.testObjectVUI)) {
				this.showVoiceCommandList = false;
				setTimeout(function () {
					document.getElementById('controlsContainer').scrollIntoView({ behavior: "smooth" });
				}, 250);
				console.log('HIDE LIST');
			}
			this.testObjectVUI = "";
			setTimeout(function () {
				_this7.userVoiceToText = "";
			}, 3000);
		},
		miscVUI: function miscVUI() {
			//RANDOMIZE
			if (RegExp(/new\s?scenes?|randomi?z?e?|shift\s?soundscapes?/gi).test(this.testObjectVUI)) {
				this.mattChillMethod();
				//EXPLORE
			} else if (RegExp(/\bexplorer?\b|\badventure\b/gi).test(this.testObjectVUI)) {
				if (RegExp(/stop/gi).test(this.testObjectVUI)) {
					this.stopExplore();
				} else {
					this.exploreFunc();
				}
				//STOP VOICE COMMANDS & GO HOME FUNCTIONS
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) && RegExp(/voice\s?controls?/gi).test(this.testObjectVUI) || RegExp(/stop/gi).test(this.testObjectVUI) && RegExp(/voice\s?commands?/gi).test(this.testObjectVUI)) {
				//DISABLES LISTENING IMMEDITATLY
				this.initSpeech = true;
				this.stopModuleSpeech = true;
				this.recognizing = false;
				this.recognitionForest.stop();
				this.$store.state.isVoiceControlled = false;
			} else if (RegExp(/home/gi).test(this.testObjectVUI)) {
				this.goingHomeNotViaVoiceCommand = false;
				this.stopModuleSpeech = true;
				this.recognitionForest.abort();
				this.recognitionForest = undefined;
				setTimeout(this.goHome, 50);
			}
			this.testObjectVUI = "";
		},

		//ENTER FUNC
		enterFunc: function enterFunc() {
			var _this8 = this;

			if (this.startAudioBoolean) {
				this.startAudio();
				this.startAudioBoolean = false;
			}
			this.showEnterBtn = false;
			setTimeout(function () {
				_this8.showEnterContainer = false;
			}, 1000);
			this.forestFX.start();

			var changeTiming = 50;

			setTimeout(function () {
				_this8.plungeDepth = 1;
			}, changeTiming * 1);

			setTimeout(function () {
				_this8.plungeDepth = 2;
			}, changeTiming * 2);

			setTimeout(function () {
				_this8.plungeDepth = 3;
			}, changeTiming * 3);

			setTimeout(function () {
				_this8.plungeDepth = 4;
			}, changeTiming * 4);

			setTimeout(function () {
				_this8.plungeDepth = 5;
			}, changeTiming * 5);

			setTimeout(function () {
				_this8.plungeDepth = 6;
			}, changeTiming * 6);

			setTimeout(function () {
				_this8.plungeDepth = 7;
			}, changeTiming * 7);

			setTimeout(function () {
				_this8.plungeDepth = 8;
			}, changeTiming * 8);

			setTimeout(function () {
				_this8.plungeDepth = 9;
			}, changeTiming * 8);

			setTimeout(function () {
				_this8.plungeDepth = 10;
			}, changeTiming * 10);

			setTimeout(function () {
				_this8.showAllControls = true;
			}, 1000);

			setTimeout(function () {
				_this8.showNavBar = true;
			}, 1300);

			setTimeout(function () {
				_this8.showSpeechBtns = true;
			}, 1200);

			setTimeout(function () {
				_this8.ambience1Boolean = true;

				_this8.ambience3Boolean = true;

				_this8.ambience6Boolean = true;
			}, 1000);

			setTimeout(function () {
				if (_this8.userMobile === false) {
					_this8.activeSun = true;
				}
			}, 2000);
		},

		//RANDOMIZE (MATT CHILL) PRESET
		mattChillMethod: function mattChillMethod() {
			if (this.didWeAdventure) {
				this.stopExplore();
			}

			if (this.randomizeBoolean === false) {
				this.randomizeBoolean = true;
			}

			this.mattChill = !this.mattChill;

			this.ambience1Vol = Math.floor(Math.random() * 2 - 20);
			this.ambience2Vol = Math.floor(Math.random() * 30 - 30);
			this.ambience3Vol = Math.floor(Math.random() * 2 - 5);
			this.ambience4Vol = Math.floor(Math.random() * 10 - 20);
			this.ambience5Vol = Math.floor(Math.random() * 30 - 30);
			this.ambience6Vol = Math.floor(Math.random() * 30 - 30);

			// let fx1boolean 		= Math.random() >= 0.5,
			// 	fx2boolean 		= Math.random() >= 0.5,
			// 	fx3boolean 		= Math.random() >= 0.5,
			// 	fx4boolean 		= Math.random() >= 0.5,
			// 	fx5boolean 		= Math.random() >= 0.5;

			var amb1boolean = Math.random() >= 0.5,
			    amb2boolean = Math.random() >= 0.5,
			    amb3boolean = Math.random() >= 0.95,
			    amb4boolean = Math.random() >= 0.5,
			    amb5boolean = Math.random() >= 0.85,
			    amb6boolean = Math.random() >= 0.5;

			// if (this.mattChill === true){
			//DON'T CALCULATE ON MOBILE
			if (this.userMobile === false) {
				var
				// randomVerb 		= Math.floor((Math.random() * 30) + 0),
				randomDelay = Math.floor(Math.random() * 20 + 0),
				    randomChorus = Math.floor(Math.random() * 20 + 0),
				    randomFilter = Math.floor(Math.random() * 20000 + 500);

				// this.fxConvolverAmt 	= randomVerb;
				this.fxDelayAmt = randomDelay;
				this.fxChorusAmt = randomChorus;
				this.fxAutoFilterAmt = randomFilter;

				this.fxDecay = Math.random() * 10 + 1.5;
				var fxPreDelay = Math.random() * 0.1 + 0.03;
				this.fxConvolver.decay = this.fxDecay;
				this.fxConvolver.preDelay = fxPreDelay;
				this.fxConvolver.generate();
			}
			//CALCULATE ON MOBILE & DESKTOP
			var randomSpeed = Math.random() * (1.25 - 0.75) + 0.75;
			this.playBackSpeed = randomSpeed;

			if (amb1boolean === true) {
				this.ambience1Boolean = true;
				this.showFlask1 = true;

				this.ambience3Boolean = false;
				this.showFlask3 = false;
			} else {
				this.ambience1Boolean = false;
				this.showFlask1 = false;
			}

			if (amb2boolean === true) {
				this.ambience2Boolean = true;
				this.showFlask2 = true;

				this.ambience3Boolean = false;
				this.showFlask3 = false;
			} else {
				this.ambience2Boolean = false;
				this.showFlask2 = false;
			}

			if (amb4boolean === true) {
				this.ambience4Boolean = true;
				this.showFlask4 = true;

				this.ambience3Boolean = false;
				this.showFlask3 = false;
			} else {
				this.ambience4Boolean = false;
				this.showFlask4 = false;
			}

			if (amb5boolean === true) {
				this.ambience5Boolean = true;
				this.showFlask5 = true;

				this.ambience3Boolean = false;
				this.showFlask3 = false;
			} else {
				this.ambience5Boolean = false;
				this.showFlask5 = false;
			}

			if (amb6boolean === true) {
				this.ambience6Boolean = true;
				this.showFlask6 = true;
			} else {
				this.ambience6Boolean = false;
				this.showFlask6 = false;
			}
			//IF WINTER DO NOT PLAY SUMMER TIME SOUNDS
			if (amb3boolean === true) {
				this.ambience3Boolean = true;
				this.showFlask3 = true;

				this.ambience1Boolean = false;
				this.showFlask1 = false;

				this.ambience2Boolean = false;
				this.showFlask2 = false;

				this.ambience4Boolean = false;
				this.showFlask4 = false;

				this.ambience5Boolean = false;
				this.showFlask5 = false;
			} else {
				this.ambience3Boolean = false;
				this.showFlask3 = false;
			}

			if (amb1boolean === false && amb2boolean === false && amb3boolean === false && amb4boolean === false && amb5boolean === false && amb6boolean === false) {
				this.ambience6Boolean = true;
				this.showFlask6 = true;
			}

			// } else if (this.mattChill === false){
			// this.fxDelayToggle = false;
			// this.fxConvolverToggle = false;
			// this.fxChorusToggle = false;
			// this.fxFilterToggle = false;
			// this.speedToggle = false;
			// } 
		},

		//EXPLORE 
		exploreBtnFunc: function exploreBtnFunc() {
			this.exploreBtnBoolean = !this.exploreBtnBoolean;
			if (this.exploreBtnBoolean) {
				this.exploreFunc();
			} else if (!this.exploreBtnBoolean) {
				this.stopExplore();
			}
		},
		exploreFunc: function exploreFunc() {
			var _this9 = this;

			//AUDIO MIXING FUNCTION
			var int = 1250;
			var runExplore = function runExplore() {
				_this9.exploreSound1.start();

				_this9.exploreTimeout1 = setTimeout(function () {
					_this9.ambience1Vol = -10;
					_this9.ambience4Vol = -12;
					_this9.ambience6Vol = -20;
				}, int * 1);
				_this9.exploreTimeout2 = setTimeout(function () {
					_this9.ambience1Vol = -12;
					_this9.ambience4Vol = -14;
					_this9.ambience6Vol = -16;
				}, int * 2);
				_this9.exploreTimeout3 = setTimeout(function () {
					_this9.ambience1Vol = -14;
					_this9.ambience4Vol = -14;
					_this9.ambience6Vol = -12;
				}, int * 3);
				_this9.exploreTimeout4 = setTimeout(function () {
					_this9.ambience1Vol = -16;
					_this9.ambience4Vol = -16;
					_this9.ambience6Vol = -14;
				}, int * 4);
				_this9.exploreTimeout5 = setTimeout(function () {
					_this9.ambience1Vol = -20;
					_this9.ambience4Vol = -20;
					_this9.ambience5Boolean = true;
					_this9.ambience5Vol = -26;
					_this9.ambience6Vol = -14;
					_this9.fxConvolverAmt = 2.5;
					_this9.fxDelayAmt = 1;
				}, int * 5);
				_this9.exploreTimeout6 = setTimeout(function () {
					_this9.ambience1Vol = -22;
					_this9.ambience4Vol = -22;
					_this9.ambience5Vol = -22;
					_this9.ambience6Vol = -18;
					_this9.fxConvolverAmt = 4;
					_this9.fxDelayAmt = 2;
				}, int * 6);
				_this9.exploreTimeout7 = setTimeout(function () {
					_this9.ambience1Vol = -24;
					_this9.ambience4Vol = -24;
					_this9.ambience5Vol = -18;
					_this9.ambience6Vol = -20;
					_this9.fxConvolverAmt = 6;
					_this9.fxDelayAmt = 3;
				}, int * 7);
				_this9.exploreTimeout8 = setTimeout(function () {
					_this9.ambience1Vol = -26;
					_this9.ambience4Vol = -26;
					_this9.ambience5Vol = -16;
					_this9.ambience6Vol = -25;
					_this9.fxConvolverAmt = 10;
					_this9.fxDelayAmt = 4;
				}, int * 8);
				_this9.exploreTimeout9 = setTimeout(function () {
					_this9.ambience1Vol = -28;
					_this9.ambience4Vol = -28;
					_this9.ambience5Vol = -14;
					_this9.ambience6Vol = -28;
					_this9.fxConvolverAmt = 14;
					_this9.fxDelayAmt = 5;
				}, int * 9);
				_this9.exploreTimeout10 = setTimeout(function () {
					_this9.ambience1Vol = -30;
					_this9.ambience4Vol = -30;
					_this9.ambience5Vol = -12;
					_this9.ambience6Vol = -30;
					_this9.fxConvolverAmt = 16;
					_this9.fxDelayAmt = 6;
				}, int * 10);
				_this9.exploreTimeout11 = setTimeout(function () {
					_this9.ambience1Vol = -32;
					_this9.ambience4Vol = -32;
					_this9.ambience5Vol = -10;
					_this9.ambience6Vol = -32;
					_this9.fxConvolverAmt = 20;
					_this9.fxDelayAmt = 7;
				}, int * 11);
				_this9.exploreTimeout12 = setTimeout(function () {
					_this9.ambience1Vol = -34;
					_this9.ambience4Vol = -34;
					_this9.ambience5Vol = -8;
					_this9.ambience6Vol = -34;
					_this9.ambience1Boolean = false;
					_this9.ambience4Boolean = false;
				}, int * 12);
				_this9.exploreTimeout13 = setTimeout(function () {
					_this9.ambience5Vol = -6;
				}, int * 13);
				_this9.exploreTimeout14 = setTimeout(function () {
					_this9.ambience5Vol = -4;
					_this9.isExploreFuncRunning = false;
				}, int * 14);
			};
			// this.isExploreFuncRunning = !this.isExploreFuncRunning;
			if (!this.isExploreFuncRunning) {
				this.isExploreFuncRunning = true;
				this.exploreTxt = "Exploring";
				//INIT EXPORE SCENE
				//GENERATE REVERB
				if (!this.userMobile) {
					this.fxDecay = 4.5;
					this.fxConvolver.decay = this.fxDecay;
					this.fxConvolver.preDelay = 0.4;
					this.fxConvolver.generate();
				}

				this.ambience1Boolean = true;
				this.ambience1Vol = -10;

				this.ambience2Boolean = false;
				this.ambience2Vol = -30;

				this.ambience3Boolean = false;
				this.ambience3Vol = -30;

				this.ambience4Boolean = true;
				this.ambience4Vol = -12;

				this.ambience5Boolean = false;
				this.ambience5Vol = -30;

				this.ambience6Boolean = true;
				this.ambience6Vol = -15;

				if (!this.didWeAdventure) {
					this.exploreSound1 = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
						"playbackRate": 1,
						"loop": false,
						"volume": 0
					}).connect(this.masterVolumeSub);

					//LOADING FOR BROWSER TYPE
					if (this.isChrome === true || this.isOpera === true || this.isFirefox === true || this.isBlink === true) {

						this.exploreSound1.load("../src/assets/sounds/modules/forest/hiogg/exporeSound1Forest.ogg", function () {
							runExplore();
						});
					} else if (this.AndroidMobile === true) {
						this.exploreSound1.load("../src/assets/sounds/modules/forest/lowogg/exporeSound1Forest.ogg", function () {
							runExplore();
						});
					} else if (this.isSafari === true || this.isEdge === true || this.isIE === true) {
						this.exploreSound1.load("../src/assets/sounds/modules/forest/320/exporeSound1Forest.m4a", function () {
							runExplore();
						});
					} else if (this.iOS === true) {
						this.exploreSound1.load("../src/assets/sounds/modules/forest/192/exporeSound1Forest.m4a", function () {
							runExplore();
						});
					}
					//CLEANS UP AND DISPOSES THESE PLAYERS WHEN GOING HOME
					this.didWeAdventure = true;
				} else if (this.didWeAdventure) {
					runExplore();
				}
			} else {}
		},
		stopExplore: function stopExplore() {
			this.exploreTxt = "Explore!";
			this.exploreSound1.stop();
			this.isExploreFuncRunning = false;
			clearInterval(this.exploreTimeout1);
			clearInterval(this.exploreTimeout2);
			clearInterval(this.exploreTimeout3);
			clearInterval(this.exploreTimeout4);
			clearInterval(this.exploreTimeout5);
			clearInterval(this.exploreTimeout6);
			clearInterval(this.exploreTimeout7);
			clearInterval(this.exploreTimeout8);
			clearInterval(this.exploreTimeout9);
			clearInterval(this.exploreTimeout10);
			clearInterval(this.exploreTimeout11);
			clearInterval(this.exploreTimeout12);
			clearInterval(this.exploreTimeout13);
			clearInterval(this.exploreTimeout14);
		},

		//MASTER METERING
		masterMetering: function masterMetering() {
			this.masterLevel = this.masterMeter.getLevel();
		},

		//MAIN SHOW AND HIDE
		goToHelp: function goToHelp() {
			var _this10 = this;

			this.showHelpOverlay = !this.showHelpOverlay;
			this.helpTrigger = !this.helpTrigger;

			if (this.showHelpOverlay === true) {

				setTimeout(function () {
					_this10.showNavBar = false;
					if (_this10.$store.state.allowSpeechControl) {
						_this10.showSpeechBtns = false;
					}
				}, 100);

				setTimeout(function () {
					_this10.showAllControls = false;
				}, 250);

				setTimeout(function () {
					_this10.showAboutPage = true;
				}, 1000);
			} else if (this.showHelpOverlay === false) {

				this.showAboutPage = false;

				setTimeout(function () {
					_this10.showAllControls = true;
				}, 800);

				setTimeout(function () {
					_this10.showNavBar = true;
					if (_this10.$store.state.allowSpeechControl) {
						_this10.showSpeechBtns = true;
					}
				}, 850);
			}
		},
		voiceCommandListFunc: function voiceCommandListFunc() {
			this.showVoiceCommandList = !this.showVoiceCommandList;
			if (this.showVoiceCommandList) {
				setTimeout(function () {
					document.getElementById('voiceListAnchor').scrollIntoView({ behavior: "smooth" });
				}, 250);
			} else if (!this.showVoiceCommandList) {
				document.getElementById('controlsContainer').scrollIntoView({ behavior: "smooth" });
			}
		},

		//BUFFER LOADING
		bufferLoading: function bufferLoading() {
			var _this11 = this;

			// Tone.Buffer.on('progress', ()=>{
			// });
			__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Buffer.on('load', function () {
				//HIDE LOADING ITEMS
				_this11.showLoading = false;
				//SHOW ENTER BUTTON
				setTimeout(function () {
					_this11.showEnterBtn = true;
				}, 1000);
				//AUTO OPEN MODULE IF VOICE CONTROLLED & DO NOT REPLAY WHEN EXPLORE AUDIO LOADS 
				//ADDITIONALLY DO NOT REPLAY IF USER MIC HAS BEEN ACTIVATED FOR RECORDING
				if (_this11.isVoiceControl) {
					if (!_this11.didWeAdventure) {
						setTimeout(_this11.enterFunc, 2000);
					}
				}
				//IF VOICE CONTROL IS ACTIVE GLOBALLY ACTIVATE IN THIS MODULE
				if (_this11.isVoiceControl === true) {
					_this11.speechFunc();
				}
			});
		},

		//AUDIO ROUTING
		audioRouting: function audioRouting() {

			if (this.isChrome === true || this.AndroidMobile === true || this.isOpera === true || this.isFirefox === true || this.isBlink === true) {
				if (this.userMobile === false) {

					this.fxConvolver = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Reverb({
						"decay": 1.5,
						"preDelay": 0.01
					});
					this.fxConvolver.decay = 2.5;
					this.fxConvolver.generate();
					this.fxAutoFilter = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Filter({
						"type": "lowpass",
						"frequency": 20000,
						"rolloff": -24,
						"Q": 1,
						"gain": 0
					});
					this.fxDelay = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.PingPongDelay(0.65, 0.45);
					this.fxChorus = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Chorus({
						"frequency": 4.5,
						"delayTime": 10,
						"depth": 0.85,
						"type": "sine",
						"spread": 180
					});
					this.masterMeter = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Meter({
						"smoothing": .4
					});
					this.ambience1Player.connect(this.masterVolumeSub);
					this.ambience2Player.connect(this.masterVolumeSub);
					this.ambience3Player.connect(this.masterVolumeSub);
					this.ambience4Player.connect(this.masterVolumeSub);
					this.ambience5Player.connect(this.masterVolumeSub);
					this.ambience6Player.connect(this.masterVolumeSub);

					this.masterVolumeSub.chain(this.fxAutoFilter, this.fxConvolver, this.fxDelay, this.fxChorus, this.masterMeter, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master);
					setInterval(this.masterMetering, 60);
				} else if (this.userMobile === true) {
					this.ambience1Player.connect(this.masterVolumeSub);
					this.ambience2Player.connect(this.masterVolumeSub);
					this.ambience3Player.connect(this.masterVolumeSub);
					this.ambience4Player.connect(this.masterVolumeSub);
					this.ambience5Player.connect(this.masterVolumeSub);
					this.ambience6Player.connect(this.masterVolumeSub);

					this.masterVolumeSub.connect(__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master);
				}
			} else if (this.isSafari === true || this.iOS === true || this.isEdge === true || this.isIE === true) {
				if (this.userMobile === false) {
					this.fxConvolver = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Reverb({
						"decay": 1.5,
						"preDelay": 0.01
					});
					this.fxConvolver.decay = 2.5;
					this.fxConvolver.generate();
					this.fxAutoFilter = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Filter({
						"type": "lowpass",
						"frequency": 20000,
						"rolloff": -24,
						"Q": 1,
						"gain": 0
					});
					this.fxDelay = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.PingPongDelay(0.65, 0.45);
					this.fxChorus = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Chorus({
						"frequency": 4.5,
						"delayTime": 10,
						"depth": 0.85,
						"type": "sine",
						"spread": 180
					});
					this.masterMeter = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Meter({
						"smoothing": .4
					});
					this.ambience1Player.connect(this.masterVolumeSub);
					this.ambience2Player.connect(this.masterVolumeSub);
					this.ambience3Player.connect(this.masterVolumeSub);
					this.ambience4Player.connect(this.masterVolumeSub);
					this.ambience5Player.connect(this.masterVolumeSub);
					this.ambience6Player.connect(this.masterVolumeSub);

					this.masterVolumeSub.chain(this.fxAutoFilter, this.fxConvolver, this.fxDelay, this.fxChorus, this.masterMeter, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master);
					setInterval(this.masterMetering, 60);
				} else if (this.userMobile === true) {
					this.ambience1Player.connect(this.masterVolumeSub);
					this.ambience2Player.connect(this.masterVolumeSub);
					this.ambience3Player.connect(this.masterVolumeSub);
					this.ambience4Player.connect(this.masterVolumeSub);
					this.ambience5Player.connect(this.masterVolumeSub);
					this.ambience6Player.connect(this.masterVolumeSub);

					this.masterVolumeSub.connect(__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master);
				}
			} else {}
		},

		//AUDIO LOADING
		firstAudioLoadFunc: function firstAudioLoadFunc() {
			var _this12 = this;

			// this.changeFX.load("../src/assets/sounds/blinks/change.wav", 
			// 	()=>{
			// 	this.whatIsLoading = "Fauna";
			// });

			// this.forestFX.load("../src/assets/sounds/modules/forest/forestFX.wav", 
			// 	()=>{
			// 	this.whatIsLoading = "Forest";
			// });

			// this.ambience1Player.load("../src/assets/sounds/modules/forest/insects.wav", 
			// 	()=>{
			// 	this.whatIsLoading = "Crickets";
			// });

			// this.ambience2Player.load("../src/assets/sounds/modules/forest/summer.wav", 
			// 	()=>{
			// 	this.whatIsLoading = "Summertime";
			// });

			// this.ambience3Player.load("../src/assets/sounds/modules/forest/winter.wav", 
			// 	()=>{
			// 	this.whatIsLoading = "Wintertime";
			// });

			// this.ambience4Player.load("../src/assets/sounds/modules/forest/marshland.wav", 
			// 	()=>{
			// 	this.whatIsLoading = "Marshland";
			// });

			// this.ambience5Player.load("../src/assets/sounds/modules/forest/loons.wav", 
			// 	()=>{
			// 	this.whatIsLoading = "Loons";
			// });

			// this.ambience6Player.load("../src/assets/sounds/modules/forest/stream.wav", 
			// 	()=>{
			// 	this.whatIsLoading = "Stream";
			// });

			if (this.isChrome === true || this.isOpera === true || this.isFirefox === true || this.isBlink === true) {

				this.changeFX.load("../src/assets/sounds/blinks/change.ogg", function () {
					_this12.whatIsLoading = "Fauna";
				});

				this.forestFX.load("../src/assets/sounds/modules/forest/hiogg/forestFX.ogg", function () {
					_this12.whatIsLoading = "Soil";
				});

				this.ambience1Player.load("../src/assets/sounds/modules/forest/hiogg/insects.ogg", function () {
					_this12.whatIsLoading = "Crickets";
				});

				this.ambience2Player.load("../src/assets/sounds/modules/forest/hiogg/summer.ogg", function () {
					_this12.whatIsLoading = "Summertime";
				});

				this.ambience3Player.load("../src/assets/sounds/modules/forest/hiogg/winter.ogg", function () {
					_this12.whatIsLoading = "Wintertime";
				});

				this.ambience4Player.load("../src/assets/sounds/modules/forest/hiogg/marshland.ogg", function () {
					_this12.whatIsLoading = "Marshland";
				});

				this.ambience5Player.load("../src/assets/sounds/modules/forest/hiogg/loons.ogg", function () {
					_this12.whatIsLoading = "Loons";
				});

				this.ambience6Player.load("../src/assets/sounds/modules/forest/hiogg/stream.ogg", function () {
					_this12.whatIsLoading = "Streams";
				});
			} else if (this.AndroidMobile === true) {
				this.changeFX.load("../src/assets/sounds/blinks/change.ogg", function () {
					_this12.whatIsLoading = "Fauna";
				});

				this.forestFX.load("../src/assets/sounds/modules/forest/lowogg/forestFX.ogg", function () {
					_this12.whatIsLoading = "Soil";
				});

				this.ambience1Player.load("../src/assets/sounds/modules/forest/lowogg/insects.ogg", function () {
					_this12.whatIsLoading = "Crickets";
				});

				this.ambience2Player.load("../src/assets/sounds/modules/forest/lowogg/summer.ogg", function () {
					_this12.whatIsLoading = "Summertime";
				});

				this.ambience3Player.load("../src/assets/sounds/modules/forest/lowogg/winter.ogg", function () {
					_this12.whatIsLoading = "Wintertime";
				});

				this.ambience4Player.load("../src/assets/sounds/modules/forest/lowogg/marshland.ogg", function () {
					_this12.whatIsLoading = "Marshland";
				});

				this.ambience5Player.load("../src/assets/sounds/modules/forest/lowogg/loons.ogg", function () {
					_this12.whatIsLoading = "Loons";
				});

				this.ambience6Player.load("../src/assets/sounds/modules/forest/lowogg/stream.ogg", function () {
					_this12.whatIsLoading = "Streams";
				});
			} else if (this.isSafari === true || this.isEdge === true || this.isIE === true) {

				this.changeFX.load("../src/assets/sounds/blinks/change.m4a", function () {
					_this12.whatIsLoading = "Fauna";
				});

				this.forestFX.load("../src/assets/sounds/modules/forest/320/forestFX.m4a", function () {
					_this12.whatIsLoading = "Soil";
				});

				this.ambience1Player.load("../src/assets/sounds/modules/forest/320/insects.m4a", function () {
					_this12.whatIsLoading = "Crickets";
				});

				this.ambience2Player.load("../src/assets/sounds/modules/forest/320/summer.m4a", function () {
					_this12.whatIsLoading = "Summertime";
				});

				this.ambience3Player.load("../src/assets/sounds/modules/forest/320/winter.m4a", function () {
					_this12.whatIsLoading = "Wintertime";
				});

				this.ambience4Player.load("../src/assets/sounds/modules/forest/320/marshland.m4a", function () {
					_this12.whatIsLoading = "Marshland";
				});

				this.ambience5Player.load("../src/assets/sounds/modules/forest/320/loons.m4a", function () {
					_this12.whatIsLoading = "Loons";
				});

				this.ambience6Player.load("../src/assets/sounds/modules/forest/320/stream.m4a", function () {
					_this12.whatIsLoading = "Streams";
				});
			} else if (this.iOS === true) {
				this.changeFX.load("../src/assets/sounds/blinks/change.m4a", function () {
					_this12.whatIsLoading = "Fauna";
				});

				this.forestFX.load("../src/assets/sounds/modules/forest/192/forestFX.m4a", function () {
					_this12.whatIsLoading = "Soil";
				});

				this.ambience1Player.load("../src/assets/sounds/modules/forest/192/insects.m4a", function () {
					_this12.whatIsLoading = "Crickets";
				});

				this.ambience2Player.load("../src/assets/sounds/modules/forest/192/summer.m4a", function () {
					_this12.whatIsLoading = "Summertime";
				});

				this.ambience3Player.load("../src/assets/sounds/modules/forest/192/winter.m4a", function () {
					_this12.whatIsLoading = "Wintertime";
				});

				this.ambience4Player.load("../src/assets/sounds/modules/forest/192/marshland.m4a", function () {
					_this12.whatIsLoading = "Marshland";
				});

				this.ambience5Player.load("../src/assets/sounds/modules/forest/192/loons.m4a", function () {
					_this12.whatIsLoading = "Loons";
				});

				this.ambience6Player.load("../src/assets/sounds/modules/forest/192/stream.m4a", function () {
					_this12.whatIsLoading = "Streams";
				});
			}
		},

		//AMBIENCE PLAY STOPS
		// ambience1Func(){
		// 	this.randomizeBoolean = false;

		// 	this.ambience1Boolean = !this.ambience1Boolean;
		// 	if (this.ambience1Boolean === true){
		// 		this.ambience1Player.volume.value = this.ambience1Vol;
		// 		this.ambience1Player.start();
		// 	} else if (this.ambience1Boolean === false){
		// 		this.ambience1Player.volume.setTargetAtTime(-70, Tone.Context.currentTime, +0.05);
		// 		setTimeout(()=>{
		// 			this.ambience1Player.stop();
		// 		}, 250);
		// 	}
		// },
		// ambience2Func(){
		// 	this.randomizeBoolean = false;

		// 	this.ambience2Boolean = !this.ambience2Boolean;
		// 	if (this.ambience2Boolean === true){
		// 		this.ambience2Player.volume.value = this.ambience2Vol;
		// 		this.ambience2Player.start();
		// 	} else if (this.ambience2Boolean === false){
		// 		this.ambience2Player.volume.setTargetAtTime(-70, Tone.Context.currentTime, +0.05);
		// 		setTimeout(()=>{
		// 			this.ambience2Player.stop();
		// 		}, 250);
		// 	}
		// },
		// ambience3Func(){
		// 	this.randomizeBoolean = false;

		// 	this.ambience3Boolean = !this.ambience3Boolean;
		// 	if (this.ambience3Boolean === true){
		// 		this.ambience3Player.volume.value = this.ambience3Vol;
		// 		this.ambience3Player.start();
		// 	} else if (this.ambience3Boolean === false){
		// 		this.ambience3Player.volume.setTargetAtTime(-70, Tone.Context.currentTime, +0.05);
		// 		setTimeout(()=>{
		// 			this.ambience3Player.stop();
		// 		}, 250);
		// 	}
		// },
		// ambience4Func(){
		// 	this.randomizeBoolean = false;

		// 	this.ambience4Boolean = !this.ambience4Boolean;
		// 	if (this.ambience4Boolean === true){
		// 		this.ambience4Player.volume.value = this.ambience4Vol;
		// 		this.ambience4Player.start();
		// 	} else if (this.ambience4Boolean === false){
		// 		this.ambience4Player.volume.setTargetAtTime(-70, Tone.Context.currentTime, +0.05);
		// 		setTimeout(()=>{
		// 			this.ambience4Player.stop();
		// 		}, 250);
		// 	}	
		// },
		// ambience5Func(){
		// 	this.randomizeBoolean = false;

		// 	this.ambience5Boolean = !this.ambience5Boolean;
		// 	if (this.ambience5Boolean === true){
		// 		this.ambience5Player.volume.value = this.ambience5Vol;
		// 		this.ambience5Player.start();
		// 	} else if (this.ambience5Boolean === false){
		// 		this.ambience5Player.volume.setTargetAtTime(-70, Tone.Context.currentTime, +0.05);
		// 		setTimeout(()=>{
		// 			this.ambience5Player.stop();
		// 		}, 250);
		// 	}	
		// },
		// ambience6Func(){
		// 	this.randomizeBoolean = false;

		// 	this.ambience6Boolean = !this.ambience6Boolean;
		// 	if (this.ambience6Boolean === true){
		// 		this.ambience6Player.volume.value = this.ambience6Vol;
		// 		this.ambience6Player.start();
		// 	} else if (this.ambience6Boolean === false){
		// 		this.ambience6Player.volume.setTargetAtTime(-70, Tone.Context.currentTime, +0.05);
		// 		setTimeout(()=>{
		// 			this.ambience6Player.stop();
		// 		}, 250);
		// 	}	
		// },
		//GO HOME
		goHome: function goHome() {
			var _this13 = this;

			this.changeFX.start();

			//IF USER ENGAGES VOICE CONTROL BUT GOES HOME VIA 
			//MOUSE BUTTON THIS TRIGGERS MODULE SPEECH DISPOSE
			if (this.goingHomeNotViaVoiceCommand && !this.initSpeech) {
				this.stopModuleSpeech = true;
				this.recognitionForest.stop();
				this.recognitionForest.abort();
				this.recognitionForest = undefined;
			};

			if (this.didWeAdventure === true) {
				this.exploreSound1.disconnect();
				// this.exploreSound2.disconnect();
				// this.exploreSound3.disconnect();
			}

			setTimeout(function () {
				__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.2);
			}, 400);

			setTimeout(function () {
				_this13.ambience1Player.disconnect();
				_this13.ambience2Player.disconnect();
				_this13.ambience3Player.disconnect();
				_this13.ambience4Player.disconnect();
				_this13.ambience5Player.disconnect();
				_this13.ambience6Player.disconnect();
				_this13.forestFX.disconnect();
				_this13.changeFX.disconnect();
				_this13.masterVolumeSub.disconnect();
				if (_this13.userMobile === false) {
					_this13.fxConvolver.disconnect();
					_this13.fxAutoFilter.disconnect();
					_this13.fxDelay.disconnect();
					_this13.fxChorus.disconnect();
					_this13.masterMeter.disconnect();
				}
			}, 1000);

			setTimeout(function () {
				document.body.className = 'default';
				_this13.$router.push('/');
				__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master.volume.value = 0;
			}, 1100);
		}
	}
});

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_startaudiocontext_StartAudioContext_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_startaudiocontext_StartAudioContext_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_startaudiocontext_StartAudioContext_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var XRegExp = __webpack_require__(5);
/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			//RANDOMIZE BOOLEANS
			randomizeBoolean: false,
			showFlask1: true,
			showFlask2: false,
			showFlask3: false,
			showFlask4: false,
			showFlask5: false,
			showFlask6: false,
			//CONTROLS
			reverbChecker: undefined,
			loadingBoolean: true,
			userMobile: Boolean,
			mailingListBtn: false,
			textTiming: 500,
			startStopTrigger: true,
			playColor: "#F0CB50",
			stopColor: "#1E9BFC",
			//SCREEN DIMENSIONS
			screenHeight: undefined,
			screenWidth: undefined,
			ogWidth: undefined,
			//BACKGROUND COLORS
			plungeDepth: 1,
			backgroundColor1: true,
			backgroundColor2: false,
			backgroundColor3: false,
			backgroundColor4: false,
			backgroundColor5: false,
			backgroundColor6: false,
			backgroundColor7: false,
			backgroundColor8: false,
			backgroundColor9: false,
			backgroundColor10: false,
			//REACTIVE SUN
			sunReactiveColor1: true,
			sunReactiveColor2: false,
			sunReactiveColor3: false,
			sunReactiveColor4: false,
			sunReactiveColor5: false,
			sunReactiveColor6: false,
			sunReactiveColor7: false,
			sunReactiveColor8: false,
			sunReactiveColor9: false,
			sunReactiveColor10: false,
			//SHOW AND HIDE
			helpTrigger: false,
			showHelpOverlay: false,
			showAboutPage: false,

			bellBoolean: false,
			//PLAY SUN DRAGGIE
			activeSun: false,
			//V-SHOWS
			showEnterContainer: true,
			showLoading: true,
			showEnterBtn: false,
			showNavBar: false,
			showAllControls: false,
			showSpeechBtns: false,
			//AMBIENCE BOOLEANS
			ambience1Boolean: false,
			ambience2Boolean: false,
			ambience3Boolean: false,
			ambience4Boolean: false,
			ambience5Boolean: false,
			ambience6Boolean: false,
			//AMBIENCE DATA
			whatIsLoading: "Great Ice",
			iceFX: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": false,
				"volume": -4
			}).toMaster(),
			changeFX: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": false,
				"volume": -6
			}).toMaster(),
			ambience1Vol: -10,
			ambience2Vol: -16,
			ambience3Vol: -10,
			ambience4Vol: -10,
			ambience5Vol: -10,
			ambience6Vol: -10,
			ambience1Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": 0
			}),
			ambience2Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": 0
			}),
			ambience3Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": 0
			}),
			ambience4Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": 0
			}),
			ambience5Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": 0
			}),
			ambience6Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": 0
			}),
			//AUDIO ROUTING & EFFECTS
			playBackSpeed: 1,
			fxDecay: 2.5,
			// masterVolume:     		0,
			loadingSoundID: undefined,
			audioLoading: undefined,
			fxConvolverAmt: 0,
			fxDistortAmt: 0,
			fxChorusAmt: 0,
			fxDelayAmt: 0,
			fxAutoFilterAmt: 3500,
			mattChill: false,
			fxConvolver: undefined,
			fxChorus: undefined,
			fxDelay: undefined,
			fxAutoFilter: undefined,

			speedToggle: true,
			fxDelayToggle: true,
			fxConvolverToggle: true,
			fxChorusToggle: true,
			fxFilterToggle: false,

			masterLevel: 0,
			masterVolumeSub: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Volume(0),
			//SPEECH
			//FOR SPEECH FORM INPUT
			submitSpeechTxttoVoice: false,
			userVoiceToText: "",
			//IF SPEECH IS ALLOWED SHOW SPEECH ACTIVATE BUTTON (SET VIA APP.js)
			allowSpeechControl: false,
			//GLOBAL COMMAND TRIGGERING VOICE COMMANDS ON AND OFF
			isVoiceControl: false,
			//COMMAND FOR CSS CONTROL WHEN VOICE IS ACTIVE OR NOT
			recognizing: undefined,
			recognitionIce: undefined,
			//HOLDS ALL OF SPEECHRECONGNITION JSON
			voiceCommandArray: undefined,
			speechRecognitionList: undefined,
			voiceCommandConfidence: undefined,
			//STRING LINE TO TEST FOR VOICE COMMAND ACTIONS
			testObjectVUI: "",
			//BUTTON SWITCHING & TEXT
			initSpeech: true,
			speechBtnTxt: "Say A Command",
			speechStartTopBtnTrigger: true,
			//SHOWS LIST OF COMMANDS
			showVoiceCommandList: false,
			//DISABLE WHILE RECORDING
			isDisableListening: false,
			//TRUE WHEN STOPPING ALL SPEECH FUNCTIONS TO GO HOME
			stopModuleSpeech: false,
			//IF USER ENGAGES VOICE CONTROL BUT GOES HOME VIA MOUSE BUTTON THIS TRIGGERS MODULE SPEECH DISPOSE
			//EXPLORE
			isExploreFuncRunning: false,
			didWeAdventure: false,
			exploreSound1: undefined,
			exploreBtnBoolean: false,
			//WHAT DEVICE
			isChrome: Boolean,
			isFirefox: Boolean,
			isSafari: Boolean,
			isOpera: Boolean,
			isIE: Boolean,
			isEdge: Boolean,
			isBlink: Boolean,
			iOS: Boolean,
			AndroidMobile: Boolean,
			//EXPLORE TIMES OUTS
			exploreTxt: "Explore!",
			exploreTimeout1: undefined,
			exploreTimeout2: undefined,
			exploreTimeout3: undefined,
			exploreTimeout4: undefined,
			exploreTimeout5: undefined,
			exploreTimeout6: undefined,
			exploreTimeout7: undefined,
			exploreTimeout8: undefined,
			exploreTimeout9: undefined,
			exploreTimeout10: undefined,
			exploreTimeout11: undefined,
			exploreTimeout12: undefined,
			exploreTimeout13: undefined,
			exploreTimeout14: undefined,
			//START AUDIO CONTEXT BOOLEAN
			startAudioBoolean: true,
			//LOCAL STORAGE
			isCacheSaved: false,
			firstLoad: false,
			saveTrigger: false,
			loadTrigger: false
		};
	},
	created: function created() {
		var _this = this;

		this.isVoiceControl = this.$store.state.isVoiceControlled;
		if (this.isVoiceControl) {
			this.$store.state.doNotAddress = true;
		}

		window.onpopstate = function () {
			document.body.className = 'default';
			_this.goHome();
		};
		var ua = window.navigator.userAgent;
		this.isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
		this.isFirefox = typeof InstallTrigger !== 'undefined';
		this.isSafari = /constructor/i.test(window.HTMLElement) || function (p) {
			return p.toString() === "[object SafariRemoteNotification]";
		}(!window['safari'] || safari.pushNotification);
		this.isOpera = !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
		this.isIE = /*@cc_on!@*/false || !!document.documentMode;
		this.isEdge = !this.isIE && !!window.StyleMedia;
		this.isBlink = (this.isChrome || this.isOpera) && !!window.CSS, this.iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
		this.AndroidMobile = /Android/i.test(navigator.userAgent);
		//CHROME ALLOWS SPEECH AND MEDIA RECORDING
		if (this.isChrome === true) {
			this.userMobile = false;
			//FIREFOX ONLY ALLOWS MEDIA RECORDING
		} else if (this.isFirefox === true) {
			this.userMobile = false;
			//NO SPEECH AND NO MEDIA RECORDING FOR THE FOLLOWING
		} else if (this.AndroidMobile === true || this.iOS) {
			this.userMobile = true;
		} else if (this.isSafari === true || this.isOpera === true || this.isBlink === true || this.isEdge === true || this.isIE === true) {
			this.userMobile = false;
		}
		this.firstAudioLoadFunc();
		this.bufferLoading();
		this.audioRouting();
	},

	computed: {
		//THE PLUNGE BACKGROUND CHANGE
		plungeClass: function plungeClass() {
			if (this.activeSun === false) {
				if (this.plungeDepth === 1) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = true;
				} else if (this.plungeDepth === 2) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = true;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 3) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = true;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 4) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = true;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 5) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = true;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 6) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = true;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 7) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = true;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 8) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = true;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 9) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = true;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 10) {
					this.backgroundColor10 = true;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				}
				return {
					"backgroundColorIce10": this.backgroundColor10,
					"backgroundColorIce9": this.backgroundColor9,
					"backgroundColorIce8": this.backgroundColor8,
					"backgroundColorIce7": this.backgroundColor7,
					"backgroundColorIce6": this.backgroundColor6,
					"backgroundColorIce5": this.backgroundColor5,
					"backgroundColorIce4": this.backgroundColor4,
					"backgroundColorIce3": this.backgroundColor3,
					"backgroundColorIce2": this.backgroundColor2,
					"backgroundColorIce1": this.backgroundColor1
				};
			} else if (this.activeSun === true) {
				if (this.masterLevel < -40) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = true;
				} else if (this.masterLevel < -38) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = true;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -36) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = true;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -34) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = true;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -32) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = true;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -30) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = true;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -28) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = true;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -26) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = true;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -24) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = true;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel > -22) {
					this.sunReactiveColor10 = true;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				}
				return {
					"sunReactiveColorClassIce10": this.sunReactiveColor10,
					"sunReactiveColorClassIce9": this.sunReactiveColor9,
					"sunReactiveColorClassIce8": this.sunReactiveColor8,
					"sunReactiveColorClassIce7": this.sunReactiveColor7,
					"sunReactiveColorClassIce6": this.sunReactiveColor6,
					"sunReactiveColorClassIce5": this.sunReactiveColor5,
					"sunReactiveColorClassIce4": this.sunReactiveColor4,
					"sunReactiveColorClassIce3": this.sunReactiveColor3,
					"sunReactiveColorClassIce2": this.sunReactiveColor2,
					"sunReactiveColorClassIce1": this.sunReactiveColor1
				};
			}
		},

		//SHOW AND HIDE CLASS CHANGES
		helpClass: function helpClass() {
			return {
				"btn btn-helpBtn1Ice": this.helpTrigger,
				"btn btn-helpBtn2Ice": !this.helpTrigger
			};
		},
		mailingListBtnClass: function mailingListBtnClass() {
			return {
				"btn btn-transparent": this.mailingListBtn,
				"btn btn-info": !this.mailingListBtn
			};
		},

		//AMBIENCE CLASS CHANGES
		ambience1Class: function ambience1Class() {
			return {
				"btn btn-playIce": this.ambience1Boolean,
				"btn btn-stopIce": !this.ambience1Boolean
			};
		},
		ambience2Class: function ambience2Class() {
			return {
				"btn btn-playIce": this.ambience2Boolean,
				"btn btn-stopIce": !this.ambience2Boolean
			};
		},
		ambience3Class: function ambience3Class() {
			return {
				"btn btn-playIce": this.ambience3Boolean,
				"btn btn-stopIce": !this.ambience3Boolean
			};
		},
		ambience4Class: function ambience4Class() {
			return {
				"btn btn-playIce": this.ambience4Boolean,
				"btn btn-stopIce": !this.ambience4Boolean
			};
		},
		ambience5Class: function ambience5Class() {
			return {
				"btn btn-playIce": this.ambience5Boolean,
				"btn btn-stopIce": !this.ambience5Boolean
			};
		},
		ambience6Class: function ambience6Class() {
			return {
				"btn btn-playIce": this.ambience6Boolean,
				"btn btn-stopIce": !this.ambience6Boolean
			};
		},
		mattChillClass: function mattChillClass() {
			return {
				"btn btn-mattChillOnIce": this.mattChill,
				"btn btn-mattChillOffIce": !this.mattChill
			};
		},

		//AMBIENCE ICON CSS
		ambience1Icon: function ambience1Icon() {
			return {
				"fal fa-times-circle": !this.ambience1Boolean,
				"fal fa-check-circle": this.ambience1Boolean
			};
		},
		ambience2Icon: function ambience2Icon() {
			return {
				"fal fa-times-circle": !this.ambience2Boolean,
				"fal fa-check-circle": this.ambience2Boolean
			};
		},
		ambience3Icon: function ambience3Icon() {
			return {
				"fal fa-times-circle": !this.ambience3Boolean,
				"fal fa-check-circle": this.ambience3Boolean
			};
		},
		ambience4Icon: function ambience4Icon() {
			return {
				"fal fa-times-circle": !this.ambience4Boolean,
				"fal fa-check-circle": this.ambience4Boolean
			};
		},
		ambience5Icon: function ambience5Icon() {
			return {
				"fal fa-times-circle": !this.ambience5Boolean,
				"fal fa-check-circle": this.ambience5Boolean
			};
		},
		ambience6Icon: function ambience6Icon() {
			return {
				"fal fa-times-circle": !this.ambience6Boolean,
				"fal fa-check-circle": this.ambience6Boolean
			};
		},

		//CSS START AND STOP CLASS CHANGES (PLAY BUTTON)
		// startStopIcon(){
		// 	return {
		// 		"fa fa-stop": this.startStopTrigger,
		// 		"fa fa-play": !this.startStopTrigger,
		// 	}
		// },
		// startStopClass(){
		// 	return {
		// 		"btn btn-danger": this.startStopTrigger,
		// 		"btn btn-success": !this.startStopTrigger
		// 	}
		// },
		//AMBIANCE CLASS CHANGES
		ambiance1RangerClass: function ambiance1RangerClass() {
			return {
				"ambianceRangerPlayIce": this.ambience1Boolean,
				"ambianceRangerStopIce": !this.ambience1Boolean
			};
		},
		ambiance2RangerClass: function ambiance2RangerClass() {
			return {
				"ambianceRangerPlayIce": this.ambience2Boolean,
				"ambianceRangerStopIce": !this.ambience2Boolean
			};
		},
		ambiance3RangerClass: function ambiance3RangerClass() {
			return {
				"ambianceRangerPlayIce": this.ambience3Boolean,
				"ambianceRangerStopIce": !this.ambience3Boolean
			};
		},
		ambiance4RangerClass: function ambiance4RangerClass() {
			return {
				"ambianceRangerPlayIce": this.ambience4Boolean,
				"ambianceRangerStopIce": !this.ambience4Boolean
			};
		},
		ambiance5RangerClass: function ambiance5RangerClass() {
			return {
				"ambianceRangerPlayIce": this.ambience5Boolean,
				"ambianceRangerStopIce": !this.ambience5Boolean
			};
		},
		ambiance6RangerClass: function ambiance6RangerClass() {
			return {
				"ambianceRangerPlayIce": this.ambience6Boolean,
				"ambianceRangerStopIce": !this.ambience6Boolean
			};
		},

		//AUDIO MIXING
		adjustInputVolume: function adjustInputVolume() {
			this.userMic.volume.value = this.userMicInputLevel;
		},
		fxConvolverMix: function fxConvolverMix() {
			if (this.userMobile === false) {
				if (this.fxConvolverToggle === true) {
					this.fxConvolver.wet.setTargetAtTime(this.fxConvolverAmt / 100, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				} else if (this.fxConvolverToggle === false) {
					this.fxConvolver.wet.setTargetAtTime(0, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				}
			}
		},
		fxDelayMix: function fxDelayMix() {
			if (this.userMobile === false) {
				if (this.fxDelayToggle === true) {
					this.fxDelay.wet.setTargetAtTime(this.fxDelayAmt / 100, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +1);
				} else if (this.fxDelayToggle === false) {
					this.fxDelay.wet.setTargetAtTime(0, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +1);
				}
			}
		},
		fxChorusMix: function fxChorusMix() {
			if (this.userMobile === false) {
				if (this.fxChorusToggle === true) {
					this.fxChorus.wet.setTargetAtTime(this.fxChorusAmt / 100, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				} else if (this.fxChorusToggle === false) {
					this.fxChorus.wet.setTargetAtTime(0, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				}
			}
		},
		fxAutoFilterMix: function fxAutoFilterMix() {
			if (this.userMobile === false) {
				if (this.fxFilterToggle === true) {
					this.fxAutoFilter.frequency.setTargetAtTime(this.fxAutoFilterAmt, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				} else if (this.fxFilterToggle === false) {
					this.fxAutoFilter.frequency.setTargetAtTime(20000, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				}
			}
		},
		playbackSpeedFunc: function playbackSpeedFunc() {
			if (this.speedToggle === true) {
				this.ambience1Player.playbackRate = this.playBackSpeed;
				this.ambience2Player.playbackRate = this.playBackSpeed;
				this.ambience3Player.playbackRate = this.playBackSpeed;
				this.ambience4Player.playbackRate = this.playBackSpeed;
				this.ambience5Player.playbackRate = this.playBackSpeed;
				this.ambience6Player.playbackRate = this.playBackSpeed;
			} else if (this.speedToggle === false) {
				this.ambience1Player.playbackRate = 1;
				this.ambience2Player.playbackRate = 1;
				this.ambience3Player.playbackRate = 1;
				this.ambience4Player.playbackRate = 1;
				this.ambience5Player.playbackRate = 1;
				this.ambience6Player.playbackRate = 1;
			}
		},

		//SPEECH
		speechStartStopClass: function speechStartStopClass() {
			return {
				"recordingClassEngagedIce": this.recognizing,
				"recordingClassDisengagedIce": !this.recognizing
			};
		},
		speechIconClass: function speechIconClass() {
			return {
				"fa fa-microphone-alt fa-spin": this.recognizing,
				"fa fa-microphone-alt": !this.recognizing
			};
		},
		speechShowListClass: function speechShowListClass() {
			return {
				"recordingClassEngagedIce": this.showVoiceCommandList,
				"recordingClassDisengagedIce": !this.showVoiceCommandList
			};
		},
		speechSubmitClass: function speechSubmitClass() {
			return {
				"btn btn-speechSubmitOn mb-2": this.submitSpeechTxttoVoice,
				"btn btn-speechSubmitOff mb-2": !this.submitSpeechTxttoVoice
			};
		},

		//EXPLORE
		exploreFuncClass: function exploreFuncClass() {
			return {
				"recordingClassDisengagedIce": !this.isExploreFuncRunning,
				"recordingClassEngagedIce": this.isExploreFuncRunning
			};
		},
		exploreIconClass: function exploreIconClass() {
			return {
				"fab fa-wpexplorer": !this.isExploreFuncRunning,
				"fab fa-wpexplorer fa-spin": this.isExploreFuncRunning
			};
		},

		//AMBIENCE PLAY AND STOPS
		ambience1Func: function ambience1Func() {
			if (this.ambience1Boolean === true) {
				this.ambience1Player.volume.value = this.ambience1Vol;
			} else if (this.ambience1Boolean === false) {
				this.ambience1Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},
		ambience2Func: function ambience2Func() {
			if (this.ambience2Boolean === true) {
				this.ambience2Player.volume.value = this.ambience2Vol;
			} else if (this.ambience2Boolean === false) {
				this.ambience2Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},
		ambience3Func: function ambience3Func() {
			if (this.ambience3Boolean === true) {
				this.ambience3Player.volume.value = this.ambience3Vol;
			} else if (this.ambience3Boolean === false) {
				this.ambience3Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},
		ambience4Func: function ambience4Func() {
			if (this.ambience4Boolean === true) {
				this.ambience4Player.volume.value = this.ambience4Vol;
			} else if (this.ambience4Boolean === false) {
				this.ambience4Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},
		ambience5Func: function ambience5Func() {
			if (this.ambience5Boolean === true) {
				this.ambience5Player.volume.value = this.ambience5Vol;
			} else if (this.ambience5Boolean === false) {
				this.ambience5Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},
		ambience6Func: function ambience6Func() {
			if (this.ambience6Boolean === true) {
				this.ambience6Player.volume.value = this.ambience6Vol;
			} else if (this.ambience6Boolean === false) {
				this.ambience6Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},

		//LOCAL STORAGE
		saveClass: function saveClass() {
			return { "btn btn-playIce": this.saveTrigger,
				"btn btn-stopIce": !this.saveTrigger };
		},
		loadClass: function loadClass() {
			return { "btn btn-playIce": this.loadTrigger,
				"btn btn-stopIce": !this.loadTrigger };
		}
	},
	methods: {
		//LOCAL STORAGE
		setLocalStorage: function setLocalStorage() {
			var _this2 = this;

			this.saveTrigger = true;
			setTimeout(function () {
				_this2.saveTrigger = false;
			}, 250);

			this.removeLocalStorage();

			localStorage.setItem('isCacheSavedIce', JSON.stringify(true));

			localStorage.setItem('ambience1VolIce', JSON.stringify(this.ambience1Vol));
			localStorage.setItem('ambience2VolIce', JSON.stringify(this.ambience2Vol));
			localStorage.setItem('ambience3VolIce', JSON.stringify(this.ambience3Vol));
			localStorage.setItem('ambience4VolIce', JSON.stringify(this.ambience4Vol));
			localStorage.setItem('ambience5VolIce', JSON.stringify(this.ambience5Vol));
			localStorage.setItem('ambience6VolIce', JSON.stringify(this.ambience6Vol));

			localStorage.setItem('ambience1BooleanIce', JSON.stringify(this.ambience1Boolean));
			localStorage.setItem('ambience2BooleanIce', JSON.stringify(this.ambience2Boolean));
			localStorage.setItem('ambience3BooleanIce', JSON.stringify(this.ambience3Boolean));
			localStorage.setItem('ambience4BooleanIce', JSON.stringify(this.ambience4Boolean));
			localStorage.setItem('ambience5BooleanIce', JSON.stringify(this.ambience5Boolean));
			localStorage.setItem('ambience6BooleanIce', JSON.stringify(this.ambience6Boolean));

			localStorage.setItem('speedToggleIce', JSON.stringify(this.speedToggle));
			localStorage.setItem('fxDelayToggleIce', JSON.stringify(this.fxDelayToggle));
			localStorage.setItem('fxConvolverToggleIce', JSON.stringify(this.fxConvolverToggle));
			localStorage.setItem('fxChorusToggleIce', JSON.stringify(this.fxChorusToggle));
			localStorage.setItem('fxFilterToggleIce', JSON.stringify(this.fxFilterToggle));

			localStorage.setItem('playBackSpeed', JSON.stringify(this.playBackSpeed));
			localStorage.setItem('fxConvolverAmtIce', JSON.stringify(this.fxConvolverAmt));
			localStorage.setItem('fxChorusAmtIce', JSON.stringify(this.fxChorusAmt));
			localStorage.setItem('fxDelayAmtIce', JSON.stringify(this.fxDelayAmt));
			localStorage.setItem('fxAutoFilterAmtIce', JSON.stringify(this.fxAutoFilterAmt));
		},
		getLocalStorage: function getLocalStorage() {
			var _this3 = this;

			this.isCacheSaved = JSON.parse(localStorage.getItem('isCacheSavedIce'));
			if (this.isCacheSaved) {
				this.loadTrigger = true;
				setTimeout(function () {
					_this3.loadTrigger = false;
				}, 250);

				this.ambience1Vol = JSON.parse(localStorage.getItem('ambience1VolIce'));
				this.ambience2Vol = JSON.parse(localStorage.getItem('ambience2VolIce'));
				this.ambience3Vol = JSON.parse(localStorage.getItem('ambience3VolIce'));
				this.ambience4Vol = JSON.parse(localStorage.getItem('ambience4VolIce'));
				this.ambience5Vol = JSON.parse(localStorage.getItem('ambience5VolIce'));
				this.ambience6Vol = JSON.parse(localStorage.getItem('ambience6VolIce'));

				this.ambience1Boolean = JSON.parse(localStorage.getItem('ambience1BooleanIce'));
				this.ambience2Boolean = JSON.parse(localStorage.getItem('ambience2BooleanIce'));
				this.ambience3Boolean = JSON.parse(localStorage.getItem('ambience3BooleanIce'));
				this.ambience4Boolean = JSON.parse(localStorage.getItem('ambience4BooleanIce'));
				this.ambience5Boolean = JSON.parse(localStorage.getItem('ambience5BooleanIce'));
				this.ambience6Boolean = JSON.parse(localStorage.getItem('ambience6BooleanIce'));

				this.speedToggle = JSON.parse(localStorage.getItem('speedToggleIce'));
				this.fxDelayToggle = JSON.parse(localStorage.getItem('fxDelayToggleIce'));
				this.fxConvolverToggle = JSON.parse(localStorage.getItem('fxConvolverToggleIce'));
				this.fxChorusToggle = JSON.parse(localStorage.getItem('fxChorusToggleIce'));
				this.fxFilterToggle = JSON.parse(localStorage.getItem('fxFilterToggleIce'));

				this.playBackSpeed = JSON.parse(localStorage.getItem('playBackSpeed'));;
				this.fxConvolverAmt = JSON.parse(localStorage.getItem('fxConvolverAmtIce'));
				this.fxChorusAmt = JSON.parse(localStorage.getItem('fxChorusAmtIce'));
				this.fxDelayAmt = JSON.parse(localStorage.getItem('fxDelayAmtIce'));
				this.fxAutoFilterAmt = JSON.parse(localStorage.getItem('fxAutoFilterAmtIce'));
			}
		},
		removeLocalStorage: function removeLocalStorage() {
			localStorage.removeItem('isCacheSavedIce');

			localStorage.removeItem('ambience1VolIce');
			localStorage.removeItem('ambience2VolIce');
			localStorage.removeItem('ambience3VolIce');
			localStorage.removeItem('ambience4VolIce');
			localStorage.removeItem('ambience5VolIce');
			localStorage.removeItem('ambience6VolIce');

			localStorage.removeItem('ambience1BooleanIce');
			localStorage.removeItem('ambience2BooleanIce');
			localStorage.removeItem('ambience3BooleanIce');
			localStorage.removeItem('ambience4BooleanIce');
			localStorage.removeItem('ambience5BooleanIce');
			localStorage.removeItem('ambience6BooleanIce');

			localStorage.removeItem('speedToggleIce');
			localStorage.removeItem('fxDelayToggleIce');
			localStorage.removeItem('fxConvolverToggleIce');
			localStorage.removeItem('fxChorusToggleIce');
			localStorage.removeItem('fxFilterToggleIce');

			localStorage.removeItem('playBackSpeedIce');
			localStorage.removeItem('fxConvolverAmtIce');
			localStorage.removeItem('fxChorusAmtIce');
			localStorage.removeItem('fxDelayAmtIce');
			localStorage.removeItem('fxAutoFilterAmtIce');
		},

		//START AUDIO
		startAudio: function startAudio() {
			if (this.firstLoad) {
				this.firstLoad = false;
				__WEBPACK_IMPORTED_MODULE_0__node_modules_startaudiocontext_StartAudioContext_js___default()(__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.context, "#enterFuncBtn");
				this.$store.state.hasAudioContextTriggered = true;
			}
			this.ambience1Player.volume.value = -100;
			this.ambience2Player.volume.value = -100;
			this.ambience3Player.volume.value = -100;
			this.ambience4Player.volume.value = -100;
			this.ambience5Player.volume.value = -100;
			this.ambience6Player.volume.value = -100;

			this.ambience1Player.start();
			this.ambience2Player.start();
			this.ambience3Player.start();
			this.ambience4Player.start();
			this.ambience5Player.start();
			this.ambience6Player.start();
		},
		stopAudio: function stopAudio() {
			this.ambience1Player.stop();
			this.ambience2Player.stop();
			this.ambience3Player.stop();
			this.ambience4Player.stop();
			this.ambience5Player.stop();
			this.ambience6Player.stop();
		},

		//SPEECH
		userVoiceToTextFunc: function userVoiceToTextFunc() {
			var _this4 = this;

			this.submitSpeechTxttoVoice = true;
			this.testObjectVUI = this.userVoiceToText;
			console.log(this.testObjectVUI);
			this.sourceSortingVUI();
			setTimeout(function () {
				_this4.submitSpeechTxttoVoice = false;
			}, 250);
		},
		speechFunc: function speechFunc() {
			var _this5 = this;

			if (this.initSpeech === true) {
				this.recognitionIce = new webkitSpeechRecognition();
				this.recognizing;
				this.recognitionIce.continuous = false;
				this.recognitionIce.interimResults = true;

				this.recognitionIce.onresult = function (event) {
					for (var i = event.resultIndex; i < event.results.length; ++i) {
						if (event.results[i].isFinal) {
							if (!_this5.isDisableListening) {
								_this5.testObjectVUI += event.results[i][0].transcript;
								console.log('Speech String Command: ' + event.results[i][0].transcript);
								_this5.sourceSortingVUI();
							}
						}
					}
				};
				this.recognitionIce.onspeechend = function () {
					console.log('%c Ice Module SPEECH Ended', 'background: red; color: black');
					// setTimeout(this.sourceSortingVUI, 500);
					_this5.recognizing = false;
					_this5.speechBtnTxt = "Say A Command";
					__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master.volume.setTargetAtTime(0, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.context.currentTime, +0.5);
				};
				this.recognitionIce.onspeechstart = function () {
					console.log('%c Ice Module SPEECH Began', 'background: green; color: white');
					_this5.recognizing = true;
					_this5.speechBtnTxt = "Listening For Command";
					__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master.volume.setTargetAtTime(-10, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.context.currentTime, +1);
				};
				this.recognitionIce.onsoundstart = function () {
					console.log('%c Ice Module LISTENING Began', 'background: green; color: white');
				};
				this.recognitionIce.onaudioend = function () {
					console.log('%c Ice Module LISTENING Ended', 'background: green; color: white');
					// setTimeout(this.sourceSortingVUI, 500);
					_this5.recognizing = false;
					_this5.speechBtnTxt = "Say A Command";
				};
				this.recognitionIce.onend = function () {
					console.log('%c Ice Module SPEECH SESSION ENDED', 'background: green; color: white');
					if (_this5.stopModuleSpeech === false) {
						_this5.recognitionIce.start();
					}
				};
				this.recognizing = true;
				//MAKE SURE SPEECH IS NOT RE-ENGAGED
				this.initSpeech = false;
				//GLOBAL VOICE COMMAND IS SET TO TRUE
				this.$store.state.isVoiceControlled = true;
				this.recognitionIce.start();
				//IF USER ENGAGES VOICE CONTROL BUT GOES HOME VIA MOUSE BUTTON THIS TRIGGERS MODULE SPEECH DISPOSE
				this.goingHomeNotViaVoiceCommand = true;
				//CONTROLS recognition.onend TO RESTART LISTENING
				this.stopModuleSpeech = false;
				//TURN LISTENING BACK ON
				this.isDisableListening = false;
				//IF BEING VOICE CONTROLLED DON'T PLAY THE NICE, TELL ME WHERE YOU WANT TO GO PROMPT ON WELCOME PAGE
				this.$store.state.doNotAddress = true;
			} else if (this.initSpeech === false) {}
		},
		resetFunc: function resetFunc() {
			this.recognizing = false;
		},
		speechStartStopFunc: function speechStartStopFunc() {
			this.speechStartTopBtnTrigger = !this.speechStartTopBtnTrigger;

			if (this.speechStartTopBtnTrigger === true) {
				this.speechFunc();
			} else if (this.speechStartTopBtnTrigger === false) {
				this.initSpeech = true;
				this.stopModuleSpeech = true;
				this.recognizing = false;
				this.recognitionIce.stop();
				this.$store.state.isVoiceControlled = false;
			}
		},
		sourceSortingVUI: function sourceSortingVUI() {
			//FOR VISUAL REFERENCE
			this.userVoiceToText = this.testObjectVUI;

			var source1RegEx = XRegExp.build('(?x) {{source1Name}} | {{label1Name}}', {
				source1Name: XRegExp.build('{{source1Name1}} | {{source1Name2}}', {
					source1Name1: /source\sone/,
					source1Name2: /source\s1/
				}),
				label1Name: XRegExp.build('{{label1Name1}} | {{label1Name2}}', {
					label1Name1: /lakes?/,
					label1Name2: /ponds?/
				})
			}, 'xgi');

			var source2RegEx = XRegExp.build('(?x) {{source2Name}} | {{label2Name}}', {
				source2Name: XRegExp.build('{{source2Name1}} | {{source2Name2}}', {
					source2Name1: /source\stw?o?o/,
					source2Name2: /source\s2/
				}),
				label2Name: XRegExp.build('{{label2Name1}} | {{label2Name2}}', {
					label2Name1: /creaki?n?g?|creeki?n?g?/,
					label2Name2: /creeked/
				})
			}, 'xgi');

			var source3RegEx = XRegExp.build('(?x) {{source3Name}} | {{label3Name}}', {
				source3Name: XRegExp.build('{{source3Name1}} | {{source3Name2}}', {
					source3Name1: /source\sthree/,
					source3Name2: /source\s3/
				}),
				label3Name: XRegExp.build('{{label3Name1}} | {{label3Name2}}', {
					label3Name1: /stepp?i?n?g?/,
					label3Name2: /snowshoe|walk|snow/
				})
			}, 'xgi');

			var source4RegEx = XRegExp.build('(?x) {{source4Name}} | {{label4Name}}', {
				source4Name: XRegExp.build('{{source4Name1}} | {{source4Name2}}', {
					source4Name1: /source\sfou?re?/,
					source4Name2: /source\s4/
				}),
				label4Name: XRegExp.build('{{label4Name1}} | {{label4Name2}}', {
					label4Name1: /breaki?n?g?|broke/,
					label4Name2: /crack[sing]/
				})
			}, 'xgi');

			var source5RegEx = XRegExp.build('(?x) {{source5Name}} | {{label5Name}}', {
				source5Name: XRegExp.build('{{source5Name1}} | {{source5Name2}}', {
					source5Name1: /source\sfive/,
					source5Name2: /source\s5/
				}),
				label5Name: XRegExp.build('{{label5Name1}} | {{label5Name2}}', {
					label5Name1: /skii?n?g?/,
					label5Name2: /scrapi?n?g?/
				})
			}, 'xgi');

			var source6RegEx = XRegExp.build('(?x) {{source6Name}} | {{label6Name}}', {
				source6Name: XRegExp.build('{{source6Name1}} | {{source6Name2}}', {
					source6Name1: /source\ss[ei]x/,
					source6Name2: /source\s6/
				}),
				label6Name: XRegExp.build('{{label6Name1}} | {{label6Name2}}', {
					label6Name1: /winds?|win/,
					label6Name2: /bluster/
				})
			}, 'xgi');
			//ALL SOUNDS
			var allSoundRegEx = XRegExp.build('(?x) {{allSoundName}}', {
				allSoundName: XRegExp.build('{{allSoundName1}} | {{allSoundName2}}', {
					allSoundName1: /all\ssounds?/,
					allSoundName2: /all\saudios?/
				})
			}, 'xgi');
			//SPEED
			var speedRegEx = XRegExp.build('(?x) {{speedName}}', {
				speedName: XRegExp.build('{{speedName1}} | {{speedName2}}', {
					speedName1: /speeds?/,
					speedName2: /slow|faster/
				})
			}, 'xgi');
			//DELAY
			var delayRegEx = XRegExp.build('(?x) {{delayName}}', {
				delayName: XRegExp.build('{{delayName1}} | {{delayName2}}', {
					delayName1: /delay/,
					delayName2: /lay/
				})
			}, 'xgi');
			//CHORUS
			var chorusRegEx = XRegExp.build('(?x) {{chorusName}}', {
				chorusName: XRegExp.build('{{chorusName1}} | {{chorusName2}}', {
					chorusName1: /chorus?/,
					chorusName2: /course/
				})
			}, 'xgi');
			//FILTER
			var filterRegEx = XRegExp.build('(?x) {{filterName}}', {
				filterName: XRegExp.build('{{filterName1}} | {{filterName2}}', {
					filterName1: /filter/,
					filterName2: /filter/
				})
			}, 'xgi');
			//REVERB
			var reverbRegEx = XRegExp.build('(?x) {{reverbName}}', {
				reverbName: XRegExp.build('{{reverbName1}} | {{reverbName2}}', {
					reverbName1: /verb/,
					reverbName2: /reverb/
				})
			}, 'xgi');
			//SHOW
			var infoRegEx = XRegExp.build('(?x) {{showName}}', {
				showName: XRegExp.build('{{showName1}} | {{showName2}}', {
					showName1: /info/,
					showName2: /information/
				})
			}, 'xgi');
			// console.log(infoRegEx);
			//HIDE
			var listRegEx = XRegExp.build('(?x) {{hideName}}', {
				hideName: XRegExp.build('{{hideName1}} | {{hideName2}}', {
					hideName1: /lists?/,
					hideName2: /menu/
				})
			}, 'xgi');
			// console.log(listRegEx);			

			var source1Boolean = source1RegEx.test(this.testObjectVUI);
			var source2Boolean = source2RegEx.test(this.testObjectVUI);
			var source3Boolean = source3RegEx.test(this.testObjectVUI);
			var source4Boolean = source4RegEx.test(this.testObjectVUI);
			var source5Boolean = source5RegEx.test(this.testObjectVUI);
			var source6Boolean = source6RegEx.test(this.testObjectVUI);
			var allSoundBoolean = allSoundRegEx.test(this.testObjectVUI);
			var speedBoolean = speedRegEx.test(this.testObjectVUI);
			var delayBoolean = delayRegEx.test(this.testObjectVUI);
			var chorusBoolean = chorusRegEx.test(this.testObjectVUI);
			var filterBoolean = filterRegEx.test(this.testObjectVUI);
			var reverbBoolean = reverbRegEx.test(this.testObjectVUI);
			var infoBoolean = infoRegEx.test(this.testObjectVUI);
			var listBoolean = listRegEx.test(this.testObjectVUI);

			if (source1Boolean) {
				this.source1VUI();
			} else if (source2Boolean) {
				this.source2VUI();
			} else if (source3Boolean) {
				this.source3VUI();
			} else if (source4Boolean) {
				this.source4VUI();
			} else if (source5Boolean) {
				this.source5VUI();
			} else if (source6Boolean) {
				this.source6VUI();
			} else if (allSoundBoolean) {
				this.allSoundVUI();
			} else if (speedBoolean) {
				this.speedVUI();
			} else if (delayBoolean) {
				this.delayVUI();
			} else if (chorusBoolean) {
				this.chorusVUI();
			} else if (filterBoolean) {
				this.filterVUI();
			} else if (reverbBoolean) {
				this.reverbVUI();
			} else if (infoBoolean) {
				this.infoVUI();
			} else if (listBoolean) {
				this.listVUI();
			} else {
				this.miscVUI();
			}
		},
		source1VUI: function source1VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience1Player.start();
				this.ambience1Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience1Player.stop();
				this.ambience1Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience1Vol < 0) {
						this.ambience1Vol += 12;
					}
				} else {
					if (this.ambience1Vol < 0) {
						this.ambience1Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience1Vol > -30) {
						this.ambience1Vol -= 12;
					}
				} else {
					if (this.ambience1Vol > -30) {
						this.ambience1Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		source2VUI: function source2VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience2Player.start();
				this.ambience2Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience2Player.stop();
				this.ambience2Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience2Vol < 0) {
						this.ambience2Vol += 12;
					}
				} else {
					if (this.ambience2Vol < 0) {
						this.ambience2Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience2Vol > -30) {
						this.ambience2Vol -= 12;
					}
				} else {
					if (this.ambience2Vol > -30) {
						this.ambience2Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		source3VUI: function source3VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience3Player.start();
				this.ambience3Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience3Player.stop();
				this.ambience3Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience3Vol < 0) {
						this.ambience3Vol += 12;
					}
				} else {
					if (this.ambience3Vol < 0) {
						this.ambience3Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience3Vol > -30) {
						this.ambience3Vol -= 12;
					}
				} else {
					if (this.ambience3Vol > -30) {
						this.ambience3Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		source4VUI: function source4VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience4Player.start();
				this.ambience4Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience4Player.stop();
				this.ambience4Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience4Vol < 0) {
						this.ambience4Vol += 12;
					}
				} else {
					if (this.ambience4Vol < 0) {
						this.ambience4Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience4Vol > -30) {
						this.ambience4Vol -= 12;
					}
				} else {
					if (this.ambience4Vol > -30) {
						this.ambience4Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		source5VUI: function source5VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience5Player.start();
				this.ambience5Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience5Player.stop();
				this.ambience5Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience5Vol < 0) {
						this.ambience5Vol += 12;
					}
				} else {
					if (this.ambience5Vol < 0) {
						this.ambience5Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience5Vol > -30) {
						this.ambience5Vol -= 12;
					}
				} else {
					if (this.ambience5Vol > -30) {
						this.ambience5Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		source6VUI: function source6VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience6Player.start();
				this.ambience6Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience6Player.stop();
				this.ambience6Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience6Vol < 0) {
						this.ambience6Vol += 12;
					}
				} else {
					if (this.ambience6Vol < 0) {
						this.ambience6Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience6Vol > -30) {
						this.ambience6Vol -= 12;
					}
				} else {
					if (this.ambience6Vol > -30) {
						this.ambience6Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		allSoundVUI: function allSoundVUI() {
			//STOP ALL 
			if (RegExp(/stop/gi).test(this.testObjectVUI)) {
				this.ambience1Player.stop();
				this.ambience1Boolean = false;
				this.ambience2Player.stop();
				this.ambience2Boolean = false;
				this.ambience3Player.stop();
				this.ambience3Boolean = false;
				this.ambience4Player.stop();
				this.ambience4Boolean = false;
				this.ambience5Player.stop();
				this.ambience5Boolean = false;
				this.ambience6Player.stop();
				this.ambience6Boolean = false;
				if (this.didWeAdventure) {
					this.exploreSound1.stop();
					this.isExploreFuncRunning = false;
				}
			} else if (RegExp(/play/gi).test(this.testObjectVUI)) {
				this.ambience1Player.start();
				this.ambience1Boolean = true;
				this.ambience2Player.start();
				this.ambience2Boolean = true;
				this.ambience3Player.start();
				this.ambience3Boolean = true;
				this.ambience4Player.start();
				this.ambience4Boolean = true;
				this.ambience5Player.start();
				this.ambience5Boolean = true;
				this.ambience6Player.start();
				this.ambience6Boolean = true;
			}
			this.testObjectVUI = "";
		},
		speedVUI: function speedVUI() {
			if (RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI)) {
				this.speedToggle = true;
			} else if (RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI)) {
				this.speedToggle = false;
			}
			if (RegExp(/\bfaste?r?\b|up/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.playBackSpeed <= 1.6) {
						this.playBackSpeed += 0.4;
					}
				} else {
					if (this.playBackSpeed <= 1.8) {
						this.playBackSpeed += 0.2;
					}
				}
			} else if (RegExp(/slowe?r?|down/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.playBackSpeed >= 0.5) {
						this.playBackSpeed -= 0.4;
					}
				} else {
					if (this.playBackSpeed >= 0.2) {
						this.playBackSpeed -= 0.2;
					}
				}
			}
			this.testObjectVUI = "";
		},
		delayVUI: function delayVUI() {
			if (RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI)) {
				this.fxDelayToggle = true;
			} else if (RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI)) {
				this.fxDelayToggle = false;
			}
			if (RegExp(/\bmore\b|\bup\b|loude?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxDelayAmt <= 80) {
						this.fxDelayAmt += 10;
					}
				} else {
					if (this.fxDelayAmt <= 95) {
						this.fxDelayAmt += 5;
					}
				}
			} else if (RegExp(/less|\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxDelayAmt >= 20) {
						this.fxDelayAmt -= 10;
					} else if (this.fxDelayAmt >= 5) {
						this.fxDelayAmt -= 5;
					}
				} else {
					if (this.fxDelayAmt >= 5) {
						this.fxDelayAmt -= 5;
					} else if (this.fxDelayAmt >= 15) {
						this.fxDelayAmt -= 2;
					}
				}
			}
			this.testObjectVUI = "";
		},
		chorusVUI: function chorusVUI() {
			if (RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI)) {
				this.fxChorusToggle = true;
			} else if (RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI)) {
				this.fxChorusToggle = false;
			}
			if (RegExp(/\bmore\b|\bup\b|loude?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxChorusAmt <= 80) {
						this.fxChorusAmt += 10;
					}
				} else {
					if (this.fxChorusAmt <= 95) {
						this.fxChorusAmt += 5;
					}
				}
			} else if (RegExp(/less|\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxChorusAmt >= 20) {
						this.fxChorusAmt -= 10;
					} else if (this.fxChorusAmt >= 5) {
						this.fxChorusAmt -= 5;
					}
				} else {
					if (this.fxChorusAmt >= 5) {
						this.fxChorusAmt -= 5;
					} else if (this.fxChorusAmt >= 15) {
						this.fxChorusAmt -= 2;
					}
				}
			}
			this.testObjectVUI = "";
		},
		reverbVUI: function reverbVUI() {
			if (RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI)) {
				this.fxConvolverToggle = true;
			} else if (RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI)) {
				this.fxConvolverToggle = false;
			}
			if (RegExp(/\bmore\b|\bup\b|loude?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxConvolverAmt <= 45) {
						this.fxConvolverAmt += 5;
					}
				} else {
					if (this.fxConvolverAmt <= 48) {
						this.fxConvolverAmt += 2;
					}
				}
			} else if (RegExp(/less|\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxConvolverAmt >= 10) {
						this.fxConvolverAmt -= 5;
					} else if (this.fxConvolverAmt >= 2) {
						this.fxConvolverAmt -= 1;
					}
				} else {
					if (this.fxConvolverAmt >= 10) {
						this.fxConvolverAmt -= 2;
					} else if (this.fxConvolverAmt >= 2) {
						this.fxConvolverAmt -= 1;
					}
				}
			}
			this.testObjectVUI = "";
		},
		filterVUI: function filterVUI() {
			if (RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI)) {
				this.fxFilterToggle = true;
			} else if (RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI)) {
				this.fxFilterToggle = false;
			}
			if (RegExp(/\bmore\b|\blower\b/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxAutoFilterAmt > 1500) {
						this.fxAutoFilterAmt -= 1500;
					} else if (this.fxAutoFilterAmt >= 300) {
						this.fxAutoFilterAmt -= 200;
					}
				} else {
					if (this.fxAutoFilterAmt >= 500) {
						this.fxAutoFilterAmt -= 250;
					} else if (this.fxAutoFilterAmt >= 100) {
						this.fxAutoFilterAmt -= 100;
					}
				}
			} else if (RegExp(/less|higher|hire/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxAutoFilterAmt <= 10000) {
						this.fxAutoFilterAmt += 1500;
					} else if (this.fxAutoFilterAmt <= 1000) {
						this.fxAutoFilterAmt += 200;
					}
				} else {
					if (this.fxAutoFilterAmt <= 10000) {
						this.fxAutoFilterAmt += 250;
					} else if (this.fxAutoFilterAmt <= 1000) {
						this.fxAutoFilterAmt += 100;
					}
				}
			}
			this.testObjectVUI = "";
		},
		infoVUI: function infoVUI() {
			var _this6 = this;

			if (RegExp(/show|display/gi).test(this.testObjectVUI)) {
				this.showHelpOverlay = true;
				setTimeout(function () {
					_this6.showNavBar = false;
					if (_this6.$store.state.allowSpeechControl) {
						_this6.showSpeechBtns = false;
					}
				}, 0);
				setTimeout(function () {
					_this6.showAllControls = false;
				}, 500);
				setTimeout(function () {
					_this6.showAboutPage = true;
				}, 1500);
				console.log('SHOW INFO');
			} else if (RegExp(/hide|minimize/gi).test(this.testObjectVUI)) {
				this.showHelpOverlay = false;
				this.showAboutPage = false;
				setTimeout(function () {
					_this6.showAllControls = true;
				}, 800);
				setTimeout(function () {
					_this6.showNavBar = true;
					if (_this6.$store.state.allowSpeechControl) {
						_this6.showSpeechBtns = true;
					}
				}, 850);
				console.log('HIDE INFO');
			}
			this.testObjectVUI = "";
			setTimeout(function () {
				_this6.userVoiceToText = "";
			}, 3000);
		},
		listVUI: function listVUI() {
			var _this7 = this;

			if (RegExp(/show|display/gi).test(this.testObjectVUI)) {
				this.showVoiceCommandList = true;
				setTimeout(function () {
					document.getElementById('voiceControlListTxt').scrollIntoView({ behavior: "smooth" });
				}, 250);
				console.log('SHOW LIST');
			} else if (RegExp(/hide|minimize/gi).test(this.testObjectVUI)) {
				this.showVoiceCommandList = false;
				setTimeout(function () {
					document.getElementById('controlsContainer').scrollIntoView({ behavior: "smooth" });
				}, 250);
				console.log('HIDE LIST');
			}
			this.testObjectVUI = "";
			setTimeout(function () {
				_this7.userVoiceToText = "";
			}, 3000);
		},
		miscVUI: function miscVUI() {
			//RANDOMIZE
			if (RegExp(/new\s?scenes?|randomi?z?e?|shift\s?soundscapes?/gi).test(this.testObjectVUI)) {
				this.mattChillMethod();
				//EXPLORE
			} else if (RegExp(/\bexplorer?\b|\badventure\b/gi).test(this.testObjectVUI)) {
				if (RegExp(/stop/gi).test(this.testObjectVUI)) {
					this.stopExplore();
				} else {
					this.exploreFunc();
				}
				//STOP VOICE COMMANDS & GO HOME FUNCTIONS
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) && RegExp(/voice\s?controls?/gi).test(this.testObjectVUI) || RegExp(/stop/gi).test(this.testObjectVUI) && RegExp(/voice\s?commands?/gi).test(this.testObjectVUI)) {
				//DISABLES LISTENING IMMEDITATLY
				this.initSpeech = true;
				this.stopModuleSpeech = true;
				this.recognizing = false;
				this.recognitionIce.stop();
				this.$store.state.isVoiceControlled = false;
			} else if (RegExp(/home/gi).test(this.testObjectVUI)) {
				this.goingHomeNotViaVoiceCommand = false;
				this.stopModuleSpeech = true;
				this.recognitionIce.abort();
				this.recognitionIce = undefined;
				setTimeout(this.goHome, 50);
			}
			this.testObjectVUI = "";
		},
		voiceCommandListFunc: function voiceCommandListFunc() {
			this.showVoiceCommandList = !this.showVoiceCommandList;
			if (this.showVoiceCommandList) {
				setTimeout(function () {
					document.getElementById('voiceControlListTxt').scrollIntoView({ behavior: "smooth" });
				}, 250);
			} else if (!this.showVoiceCommandList) {
				document.getElementById('controlsContainer').scrollIntoView({ behavior: "smooth" });
			}
		},

		//ENTER FUNC
		enterFunc: function enterFunc() {
			var _this8 = this;

			if (this.startAudioBoolean) {
				this.startAudio();
				this.startAudioBoolean = false;
			}

			this.showEnterBtn = false;

			setTimeout(function () {
				_this8.showEnterContainer = false;
			}, 1000);

			this.iceFX.start();

			var changeTiming = 50;

			setTimeout(function () {
				_this8.plungeDepth = 1;
			}, changeTiming * 2);

			setTimeout(function () {
				_this8.plungeDepth = 5;
			}, changeTiming * 4);

			setTimeout(function () {
				_this8.plungeDepth = 3;
			}, changeTiming * 5);

			setTimeout(function () {
				_this8.plungeDepth = 6;
			}, changeTiming * 8);

			setTimeout(function () {
				_this8.plungeDepth = 2;
			}, changeTiming * 10);

			setTimeout(function () {
				_this8.plungeDepth = 3;
			}, changeTiming * 12);

			setTimeout(function () {
				_this8.plungeDepth = 6;
			}, changeTiming * 13);

			setTimeout(function () {
				_this8.plungeDepth = 4;
			}, changeTiming * 14);

			setTimeout(function () {
				_this8.plungeDepth = 5;
			}, changeTiming * 15);

			setTimeout(function () {
				_this8.plungeDepth = 6;
			}, changeTiming * 16);

			setTimeout(function () {
				_this8.plungeDepth = 7;
			}, changeTiming * 17);

			setTimeout(function () {
				_this8.plungeDepth = 8;
			}, changeTiming * 18);

			setTimeout(function () {
				_this8.plungeDepth = 9;
			}, changeTiming * 19);

			setTimeout(function () {
				_this8.plungeDepth = 10;
			}, changeTiming * 20);

			setTimeout(function () {
				_this8.showAllControls = true;
			}, 1000);

			setTimeout(function () {
				_this8.showNavBar = true;
			}, 1200);

			setTimeout(function () {
				_this8.showMicRecording = true;
			}, 1000);

			setTimeout(function () {
				_this8.showSpeechBtns = true;
			}, 1100);

			setTimeout(function () {
				_this8.ambience1Boolean = true;

				_this8.ambience2Boolean = true;
			}, 1200);

			setTimeout(function () {
				if (_this8.userMobile === false) {
					_this8.activeSun = true;
				}
			}, 1000);

			setTimeout(function () {
				_this8.ambience1Vol = -28;
				_this8.ambience2Vol = -28;
			}, 1050);

			setTimeout(function () {
				_this8.ambience1Vol = -26;
				_this8.ambience2Vol = -26;
			}, 1100);

			setTimeout(function () {
				_this8.ambience1Vol = -24;
				_this8.ambience2Vol = -24;
			}, 1150);

			setTimeout(function () {
				_this8.ambience1Vol = -22;
				_this8.ambience2Vol = -22;
			}, 1200);

			setTimeout(function () {
				_this8.ambience1Vol = -20;
				_this8.ambience2Vol = -20;
			}, 1250);

			setTimeout(function () {
				_this8.ambience1Vol = -18;
				_this8.ambience2Vol = -18;
			}, 1300);

			setTimeout(function () {
				_this8.ambience1Vol = -16;
				_this8.ambience2Vol = -16;
			}, 1350);

			setTimeout(function () {
				_this8.ambience1Vol = -14;
				_this8.ambience2Vol = -14;
			}, 1400);

			setTimeout(function () {
				_this8.ambience1Vol = -12;
				_this8.ambience2Vol = -12;
			}, 1450);

			setTimeout(function () {
				_this8.ambience1Vol = -10;
				_this8.ambience2Vol = -10;
			}, 1500);
		},

		//RANDOMIZE (MATT CHILL) PRESET
		mattChillMethod: function mattChillMethod() {
			if (this.didWeAdventure) {
				this.stopExplore();
			}

			if (this.randomizeBoolean === false) {
				this.randomizeBoolean = true;
			}

			this.mattChill = !this.mattChill;

			var ambience1Volume = Math.floor(Math.random() * 30 - 30),
			    ambience2Volume = Math.floor(Math.random() * 30 - 30),
			    ambience3Volume = Math.floor(Math.random() * 30 - 30),
			    ambience4Volume = Math.floor(Math.random() * 30 - 30),
			    ambience5Volume = Math.floor(Math.random() * 30 - 30),
			    ambience6Volume = Math.floor(Math.random() * 30 - 30);

			// let fx1boolean 		= Math.random() >= 0.5,
			// 	fx2boolean 		= Math.random() >= 0.5,
			// 	fx3boolean 		= Math.random() >= 0.5,
			// 	fx4boolean 		= Math.random() >= 0.5,
			// 	fx5boolean 		= Math.random() >= 0.5;

			var amb1boolean = Math.random() >= 0.5,
			    amb2boolean = Math.random() >= 0.5,
			    amb3boolean = Math.random() >= 0.5,
			    amb4boolean = Math.random() >= 0.5,
			    amb5boolean = Math.random() >= 0.85,
			    amb6boolean = Math.random() >= 0.5;

			// if (this.mattChill === true){
			//DON'T CALCULATE ON MOBILE
			if (this.userMobile === false) {
				var
				// randomVerb 		= Math.floor((Math.random() * 50) + 0),
				randomDelay = Math.floor(Math.random() * 40 + 0),
				    randomChorus = Math.floor(Math.random() * 60 + 0),
				    randomFilter = Math.floor(Math.random() * 20000 + 500);

				// this.fxConvolverAmt 	= randomVerb;
				this.fxDelayAmt = randomDelay;
				this.fxChorusAmt = randomChorus;
				this.fxAutoFilterAmt = randomFilter;

				this.fxDecay = Math.random() * 10 + 1.5;
				var fxPreDelay = Math.random() * 0.1 + 0.03;
				this.fxConvolver.decay = this.fxDecay;
				this.fxConvolver.preDelay = fxPreDelay;
				this.fxConvolver.generate();
			}
			//CALCULATE ON MOBILE & DESKTOP
			var randomSpeed = Math.random() * (1.75 - 0.5) + 0.5;
			this.playBackSpeed = randomSpeed;

			this.ambience1Vol = ambience1Volume;
			this.ambience2Vol = ambience2Volume;
			this.ambience3Vol = ambience3Volume;
			this.ambience4Vol = ambience4Volume;
			this.ambience5Vol = ambience5Volume;
			this.ambience6Vol = ambience6Volume;

			if (amb1boolean === true) {
				this.ambience1Boolean = true;
				this.showFlask1 = true;
			} else {
				this.ambience1Boolean = false;
				this.showFlask1 = false;
			}

			if (amb2boolean === true) {
				this.ambience2Boolean = true;
				this.showFlask2 = true;
			} else {
				this.ambience2Boolean = false;
				this.showFlask2 = false;
			}

			if (amb3boolean === true) {
				this.ambience3Boolean = true;
				this.showFlask3 = true;
			} else {
				this.ambience3Boolean = false;
				this.showFlask3 = false;
			}

			if (amb4boolean === true) {
				this.ambience4Boolean = true;
				this.showFlask4 = true;
			} else {
				this.ambience4Boolean = false;
				this.showFlask4 = false;
			}

			if (amb5boolean === true) {
				this.ambience5Boolean = true;
				this.showFlask5 = true;
			} else {
				this.ambience5Boolean = false;
				this.showFlask5 = false;
			}

			if (amb6boolean === true) {
				this.ambience6Boolean = true;
				this.showFlask6 = true;
			} else {
				this.ambience6Boolean = false;
				this.showFlask6 = false;
			}

			if (amb1boolean === false && amb2boolean === false && amb3boolean === false && amb4boolean === false && amb5boolean === false && amb6boolean === false) {
				this.ambience6Boolean = true;
				this.showFlask6 = true;
			}

			// } else if (this.mattChill === false){
			// this.fxDelayToggle = false;
			// this.fxConvolverToggle = false;
			// this.fxChorusToggle = false;
			// this.fxFilterToggle = false;
			// this.speedToggle = false;
			// } 
		},

		//EXPLORE 
		exploreBtnFunc: function exploreBtnFunc() {
			this.exploreBtnBoolean = !this.exploreBtnBoolean;
			if (this.exploreBtnBoolean) {
				this.exploreFunc();
			} else if (!this.exploreBtnBoolean) {
				this.stopExplore();
			}
		},
		exploreFunc: function exploreFunc() {
			var _this9 = this;

			//AUDIO MIXING FUNCTION
			var int = 500;
			var runExplore = function runExplore() {
				_this9.exploreSound1.volume.value = -7;
				_this9.exploreSound1.start();
				_this9.exploreTxt = "Exploring";
				_this9.speedToggle = false;
				_this9.exploreTimeout1 = setTimeout(function () {

					_this9.exploreTimeout2 = setTimeout(function () {
						_this9.ambience6Boolean = true;
						_this9.ambience6Vol = -10;
					}, int * 1);

					_this9.exploreTimeout3 = setTimeout(function () {
						_this9.ambience6Vol = -4;
					}, int * 2);

					_this9.exploreTimeout4 = setTimeout(function () {
						_this9.ambience6Vol = -3;
					}, int * 3);

					_this9.exploreTimeout5 = setTimeout(function () {
						_this9.ambience6Vol = -2;
					}, int * 4);

					_this9.exploreTimeout6 = setTimeout(function () {
						_this9.ambience6Vol = -1;
					}, int * 5);

					_this9.exploreTimeout7 = setTimeout(function () {
						_this9.ambience6Vol = 0;
					}, int * 6);

					_this9.exploreTimeout8 = setTimeout(function () {
						_this9.ambience6Vol = 1;
					}, int * 7);

					_this9.exploreTimeout9 = setTimeout(function () {
						_this9.ambience6Vol = 2;
					}, int * 8);

					_this9.exploreTimeout10 = setTimeout(function () {
						_this9.ambience6Vol = 3;
					}, int * 9);

					_this9.exploreTimeout11 = setTimeout(function () {
						_this9.ambience6Vol = 4;
						_this9.exploreSound1.volume.setTargetAtTime(-8, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.context.currentTime, +1.5);
					}, int * 10);

					_this9.exploreTimeout12 = setTimeout(function () {
						_this9.ambience6Vol = 5;
						_this9.ambience3Boolean = true;
						_this9.ambience3Vol = -6;
					}, int * 11);

					_this9.exploreTimeout13 = setTimeout(function () {
						_this9.ambience6Vol = 6;
						_this9.ambience3Vol = -4;
						_this9.isExploreFuncRunning = false;
						_this9.exploreTxt = "Explore!";
					}, int * 12);
				}, 30000);
			};
			if (this.isExploreFuncRunning === false) {
				this.isExploreFuncRunning = true;
				//INIT EXPORE SCENE
				//GENERATE REVERB
				if (!this.userMobile) {
					this.fxDecay = 4.5;
					this.fxConvolver.decay = this.fxDecay;
					this.fxConvolver.preDelay = 0.4;
					this.fxConvolver.generate();
				}

				this.ambience1Boolean = false;
				this.ambience1Vol = -10;

				this.ambience2Boolean = false;
				this.ambience2Vol = -10;

				this.ambience3Boolean = false;
				this.ambience3Vol = -6;

				this.ambience4Boolean = false;
				this.ambience4Vol = -10;

				this.ambience5Boolean = false;
				this.ambience5Vol = -30;

				this.ambience6Boolean = false;
				this.ambience6Vol = -4;

				if (!this.didWeAdventure) {
					this.exploreSound1 = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
						"playbackRate": 1,
						"loop": false,
						"volume": -6
					}).toMaster();

					//LOADING FOR BROWSER TYPE
					if (this.isChrome === true || this.isOpera === true || this.isFirefox === true || this.isBlink === true) {

						this.exploreSound1.load("../src/assets/sounds/modules/ice/hiogg/exporeSound1Ice.ogg", function () {
							runExplore();
						});
					} else if (this.AndroidMobile === true) {
						this.exploreSound1.load("../src/assets/sounds/modules/ice/lowogg/exporeSound1Ice.ogg", function () {
							runExplore();
						});
					} else if (this.isSafari === true || this.isEdge === true || this.isIE === true) {
						this.exploreSound1.load("../src/assets/sounds/modules/ice/320/exporeSound1Ice.m4a", function () {
							runExplore();
						});
					} else if (this.iOS === true) {
						this.exploreSound1.load("../src/assets/sounds/modules/ice/192/exporeSound1Ice.m4a", function () {
							runExplore();
						});
					}
					//CLEANS UP AND DISPOSES THESE PLAYERS WHEN GOING HOME
					this.didWeAdventure = true;
				} else if (this.didWeAdventure) {
					runExplore();
				}
			} else {}
		},
		stopExplore: function stopExplore() {
			this.exploreTxt = "Explore!";
			this.exploreSound1.stop();
			this.isExploreFuncRunning = false;
			clearInterval(this.exploreTimeout1);
			clearInterval(this.exploreTimeout2);
			clearInterval(this.exploreTimeout3);
			clearInterval(this.exploreTimeout4);
			clearInterval(this.exploreTimeout5);
			clearInterval(this.exploreTimeout6);
			clearInterval(this.exploreTimeout7);
			clearInterval(this.exploreTimeout8);
			clearInterval(this.exploreTimeout9);
			clearInterval(this.exploreTimeout10);
			clearInterval(this.exploreTimeout11);
			clearInterval(this.exploreTimeout12);
			clearInterval(this.exploreTimeout13);
		},

		//MASTER METERING
		masterMetering: function masterMetering() {
			this.masterLevel = this.masterMeter.getLevel();
		},

		//MAIN SHOW AND HIDE
		goToHelp: function goToHelp() {
			var _this10 = this;

			this.showHelpOverlay = !this.showHelpOverlay;
			this.helpTrigger = !this.helpTrigger;

			if (this.showHelpOverlay === true) {

				setTimeout(function () {
					_this10.showNavBar = false;
					if (_this10.$store.state.allowSpeechControl) {
						_this10.showSpeechBtns = false;
					}
				}, 100);

				setTimeout(function () {
					_this10.showAllControls = false;
				}, 250);

				setTimeout(function () {
					_this10.showAboutPage = true;
				}, 1000);
			} else if (this.showHelpOverlay === false) {

				this.showAboutPage = false;

				setTimeout(function () {
					_this10.showAllControls = true;
				}, 800);

				setTimeout(function () {
					_this10.showNavBar = true;
					if (_this10.$store.state.allowSpeechControl) {
						_this10.showSpeechBtns = true;
					}
				}, 850);
			}
		},

		//BUFFER LOADING
		bufferLoading: function bufferLoading() {
			var _this11 = this;

			// Tone.Buffer.on('progress', ()=>{
			// });
			__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Buffer.on('load', function () {
				//HIDE LOADING ITEMS
				_this11.showLoading = false;
				//SHOW ENTER BUTTON
				setTimeout(function () {
					_this11.showEnterBtn = true;
				}, 1000);
				//AUTO OPEN MODULE IF VOICE CONTROLLED & DO NOT REPLAY WHEN EXPLORE AUDIO LOADS 
				//ADDITIONALLY DO NOT REPLAY IF USER MIC HAS BEEN ACTIVATED FOR RECORDING
				if (_this11.isVoiceControl) {
					if (!_this11.didWeAdventure) {
						setTimeout(_this11.enterFunc, 2000);
					}
				}
				//IF VOICE CONTROL IS ACTIVE GLOBALLY ACTIVATE IN THIS MODULE
				if (_this11.isVoiceControl === true) {
					_this11.speechFunc();
				}
			});
		},

		//AUDIO ROUTING
		audioRouting: function audioRouting() {
			if (this.isChrome === true || this.AndroidMobile === true || this.isOpera === true || this.isFirefox === true || this.isBlink === true) {
				if (this.userMobile === false) {

					this.fxConvolver = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Reverb({
						"decay": 1.5,
						"preDelay": 0.01
					});
					this.fxConvolver.decay = 2.5;
					this.fxConvolver.generate();
					this.fxAutoFilter = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Filter({
						"type": "lowpass",
						"frequency": 20000,
						"rolloff": -24,
						"Q": 1,
						"gain": 0
					});
					this.fxDelay = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.PingPongDelay(0.8, 0.55);
					this.fxChorus = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Chorus(5, 11.5, 0.9);
					this.masterMeter = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Meter({
						"smoothing": .4
					});
					this.ambience1Player.connect(this.masterVolumeSub);
					this.ambience2Player.connect(this.masterVolumeSub);
					this.ambience3Player.connect(this.masterVolumeSub);
					this.ambience4Player.connect(this.masterVolumeSub);
					this.ambience5Player.connect(this.masterVolumeSub);
					this.ambience6Player.connect(this.masterVolumeSub);

					this.masterVolumeSub.chain(this.fxAutoFilter, this.fxConvolver, this.fxDelay, this.fxChorus, this.masterMeter, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master);
					console.log('Chrome/Opera/FireFox Desktop');
					setInterval(this.masterMetering, 60);
				} else if (this.userMobile === true) {
					this.ambience1Player.connect(this.masterVolumeSub);
					this.ambience2Player.connect(this.masterVolumeSub);
					this.ambience3Player.connect(this.masterVolumeSub);
					this.ambience4Player.connect(this.masterVolumeSub);
					this.ambience5Player.connect(this.masterVolumeSub);
					this.ambience6Player.connect(this.masterVolumeSub);

					this.masterVolumeSub.connect(__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master);

					console.log('Chrome/Opera/FireFox Mobile');
				}
			} else if (this.isSafari === true || this.iOS === true || this.isEdge === true || this.isIE === true) {
				if (this.userMobile === false) {
					this.fxConvolver = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Reverb({
						"decay": 1.5,
						"preDelay": 0.01
					});
					this.fxConvolver.decay = 2.5;
					this.fxConvolver.generate();
					this.fxAutoFilter = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Filter({
						"type": "lowpass",
						"frequency": 20000,
						"rolloff": -24,
						"Q": 1,
						"gain": 0
					});
					this.fxDelay = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.PingPongDelay(0.8, 0.55);
					this.fxChorus = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Chorus(5, 11.5, 0.9);
					this.masterMeter = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Meter({
						"smoothing": .4
					});
					this.ambience1Player.connect(this.masterVolumeSub);
					this.ambience2Player.connect(this.masterVolumeSub);
					this.ambience3Player.connect(this.masterVolumeSub);
					this.ambience4Player.connect(this.masterVolumeSub);
					this.ambience5Player.connect(this.masterVolumeSub);
					this.ambience6Player.connect(this.masterVolumeSub);

					this.masterVolumeSub.chain(this.fxAutoFilter, this.fxConvolver, this.fxDelay, this.fxChorus, this.masterMeter, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master);
					console.log('Safari/Edge/iOS Desktop');
					setInterval(this.masterMetering, 60);
				} else if (this.userMobile === true) {
					this.ambience1Player.connect(this.masterVolumeSub);
					this.ambience2Player.connect(this.masterVolumeSub);
					this.ambience3Player.connect(this.masterVolumeSub);
					this.ambience4Player.connect(this.masterVolumeSub);
					this.ambience5Player.connect(this.masterVolumeSub);
					this.ambience6Player.connect(this.masterVolumeSub);

					this.masterVolumeSub.connect(__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master);
					console.log('Safari/Edge/iOS Mobile');
				}
			} else {}
		},

		//AUDIO LOADING
		firstAudioLoadFunc: function firstAudioLoadFunc() {
			var _this12 = this;

			// this.changeFX.load("../src/assets/sounds/blinks/change.wav", 
			// 	()=>{
			// 	this.whatIsLoading = "Ice Sheet";
			// });

			// this.iceFX.load("../src/assets/sounds/modules/ice/iceFX.wav", 
			// 	()=>{
			// 	this.whatIsLoading = "Ice Cubes";
			// });

			// this.ambience1Player.load("../src/assets/sounds/modules/ice/icebed.wav", 
			// 	()=>{
			// 	this.whatIsLoading = "Icy Lake";
			// });

			// this.ambience2Player.load("../src/assets/sounds/modules/ice/icecracks.wav", 
			// 	()=>{
			// 	this.whatIsLoading = "Ice Cracks";
			// });

			// this.ambience3Player.load("../src/assets/sounds/modules/ice/frozenwalk.wav", 
			// 	()=>{
			// 	this.whatIsLoading = "Frozen Walk";
			// });

			// this.ambience4Player.load("../src/assets/sounds/modules/ice/icebreak.wav", 
			// 	()=>{
			// 	this.whatIsLoading = "Ice Break";
			// });

			// this.ambience5Player.load("../src/assets/sounds/modules/ice/icyski.wav", 
			// 	()=>{
			// 	this.whatIsLoading = "Icy Ski";
			// });

			// this.ambience6Player.load("../src/assets/sounds/modules/ice/frozenwalk.wav", 
			// 	()=>{
			// 	this.whatIsLoading = "Ice Cream";
			// });

			if (this.isChrome === true || this.isOpera === true || this.isFirefox === true || this.isBlink === true) {

				this.changeFX.load("../src/assets/sounds/blinks/change.ogg", function () {
					_this12.whatIsLoading = "Ice Sheets";
				});

				this.iceFX.load("../src/assets/sounds/modules/ice/hiogg/iceFX.ogg", function () {
					_this12.whatIsLoading = "Ice Cubes";
				});

				this.ambience1Player.load("../src/assets/sounds/modules/ice/hiogg/icebed.ogg", function () {
					_this12.whatIsLoading = "Ice Lake";
				});

				this.ambience2Player.load("../src/assets/sounds/modules/ice/hiogg/icecracks.ogg", function () {
					_this12.whatIsLoading = "Ice Cracks";
				});

				this.ambience3Player.load("../src/assets/sounds/modules/ice/hiogg/frozenwalk.ogg", function () {
					_this12.whatIsLoading = "Ice Walk";
				});

				this.ambience4Player.load("../src/assets/sounds/modules/ice/hiogg/icebreak.ogg", function () {
					_this12.whatIsLoading = "Ice Break";
				});

				this.ambience5Player.load("../src/assets/sounds/modules/ice/hiogg/icyski.ogg", function () {
					_this12.whatIsLoading = "Ice Ski";
				});

				this.ambience6Player.load("../src/assets/sounds/modules/ice/hiogg/frozenwinds.ogg", function () {
					_this12.whatIsLoading = "Frozen Winds";
				});
			} else if (this.AndroidMobile === true) {

				this.changeFX.load("../src/assets/sounds/blinks/change.ogg", function () {
					_this12.whatIsLoading = "Ice Sheets";
				});

				this.iceFX.load("../src/assets/sounds/modules/ice/lowogg/iceFX.ogg", function () {
					_this12.whatIsLoading = "Ice Cubes";
				});

				this.ambience1Player.load("../src/assets/sounds/modules/ice/lowogg/icebed.ogg", function () {
					_this12.whatIsLoading = "Ice Lake";
				});

				this.ambience2Player.load("../src/assets/sounds/modules/ice/lowogg/icecracks.ogg", function () {
					_this12.whatIsLoading = "Ice Cracks";
				});

				this.ambience3Player.load("../src/assets/sounds/modules/ice/lowogg/frozenwalk.ogg", function () {
					_this12.whatIsLoading = "Ice Walk";
				});

				this.ambience4Player.load("../src/assets/sounds/modules/ice/lowogg/icebreak.ogg", function () {
					_this12.whatIsLoading = "Ice Break";
				});

				this.ambience5Player.load("../src/assets/sounds/modules/ice/lowogg/icyski.ogg", function () {
					_this12.whatIsLoading = "Ice Ski";
				});

				this.ambience6Player.load("../src/assets/sounds/modules/ice/lowogg/frozenwinds.ogg", function () {
					_this12.whatIsLoading = "Frozen Winds";
				});
			} else if (this.isSafari === true || this.isEdge === true || this.isIE === true) {

				this.changeFX.load("../src/assets/sounds/blinks/change.m4a", function () {
					_this12.whatIsLoading = "Ice Sheets";
				});

				this.iceFX.load("../src/assets/sounds/modules/ice/320/iceFX.m4a", function () {
					_this12.whatIsLoading = "Ice Cubes";
				});

				this.ambience1Player.load("../src/assets/sounds/modules/ice/320/icebed.m4a", function () {
					_this12.whatIsLoading = "Icy Lake";
				});

				this.ambience2Player.load("../src/assets/sounds/modules/ice/320/icecracks.m4a", function () {
					_this12.whatIsLoading = "Ice Cracks";
				});

				this.ambience3Player.load("../src/assets/sounds/modules/ice/320/frozenwalk.m4a", function () {
					_this12.whatIsLoading = "Ice Walk";
				});

				this.ambience4Player.load("../src/assets/sounds/modules/ice/320/icebreak.m4a", function () {
					_this12.whatIsLoading = "Ice Break";
				});

				this.ambience5Player.load("../src/assets/sounds/modules/ice/320/icyski.m4a", function () {
					_this12.whatIsLoading = "Ice Ski";
				});

				this.ambience6Player.load("../src/assets/sounds/modules/ice/320/frozenwinds.m4a", function () {
					_this12.whatIsLoading = "Frozen Winds";
				});
			} else if (this.iOS === true) {
				this.changeFX.load("../src/assets/sounds/blinks/change.m4a", function () {
					_this12.whatIsLoading = "Ice Sheets";
				});

				this.iceFX.load("../src/assets/sounds/modules/ice/192/iceFX.m4a", function () {
					_this12.whatIsLoading = "Ice Cubes";
				});

				this.ambience1Player.load("../src/assets/sounds/modules/ice/192/icebed.m4a", function () {
					_this12.whatIsLoading = "Icy Lake";
				});

				this.ambience2Player.load("../src/assets/sounds/modules/ice/192/icecracks.m4a", function () {
					_this12.whatIsLoading = "Ice Cracks";
				});

				this.ambience3Player.load("../src/assets/sounds/modules/ice/192/frozenwalk.m4a", function () {
					_this12.whatIsLoading = "Ice Walk";
				});

				this.ambience4Player.load("../src/assets/sounds/modules/ice/192/icebreak.m4a", function () {
					_this12.whatIsLoading = "Ice Break";
				});

				this.ambience5Player.load("../src/assets/sounds/modules/ice/192/icyski.m4a", function () {
					_this12.whatIsLoading = "Ice Ski";
				});

				this.ambience6Player.load("../src/assets/sounds/modules/ice/192/frozenwinds.m4a", function () {
					_this12.whatIsLoading = "Frozen Winds";
				});
			}
		},

		//GO HOME
		goHome: function goHome() {
			var _this13 = this;

			this.changeFX.start();

			//IF USER ENGAGES VOICE CONTROL BUT GOES HOME VIA 
			//MOUSE BUTTON THIS TRIGGERS MODULE SPEECH DISPOSE
			if (this.goingHomeNotViaVoiceCommand && !this.initSpeech) {
				this.stopModuleSpeech = true;
				this.recognitionIce.stop();
				this.recognitionIce.abort();
				this.recognitionIce = undefined;
			};

			if (this.didWeAdventure === true) {
				this.exploreSound1.disconnect();
				// this.exploreSound2.disconnect();
				// this.exploreSound3.disconnect();
			}

			setTimeout(function () {
				__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.2);
			}, 400);

			setTimeout(function () {
				_this13.ambience1Player.disconnect();
				_this13.ambience2Player.disconnect();
				_this13.ambience3Player.disconnect();
				_this13.ambience4Player.disconnect();
				_this13.ambience5Player.disconnect();
				_this13.ambience6Player.disconnect();
				_this13.iceFX.disconnect();
				_this13.changeFX.disconnect();
				_this13.masterVolumeSub.disconnect();
				if (_this13.userMobile === false) {
					_this13.fxConvolver.disconnect();
					_this13.fxAutoFilter.disconnect();
					_this13.fxDelay.disconnect();
					_this13.fxChorus.disconnect();
					_this13.masterMeter.disconnect();
				}
			}, 1000);

			setTimeout(function () {
				document.body.className = 'default';
				_this13.$router.push('/');
				__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master.volume.value = 0;
			}, 1100);
		}
	}
});

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_startaudiocontext_StartAudioContext_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_startaudiocontext_StartAudioContext_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_startaudiocontext_StartAudioContext_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({

	data: function data() {
		return {
			onlyBtn: true,
			bellBoolean: false,
			showMobileText: true,
			mobileTxt: "Engage Mobile Audio",
			mobileWelcomeBlink: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": false,
				"volume": -6
			}).toMaster()
		};
	},
	created: function created() {
		var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
		// if (isMobile) 
		// { 
		// this.$router.push('/mobile'); 
		// } else if (!isMobile){
		// this.$router.push('/'); 
		// }
		this.loadAudio();
		setTimeout(this.bellTrue, 1500);
		setTimeout(this.bellFalse, 3000);
		setTimeout(this.bellTrue, 4500);
		setTimeout(this.bellFalse, 6000);
		setTimeout(this.bellTrue, 7500);
		// setTimeout(this.mobileEngage, 500);
	},

	computed: {
		audioEngageClass: function audioEngageClass() {
			return {
				"btn btn-helpBtn1 btn-lg": this.onlyBtn,
				"btn btn-helpBtn2 btn-lg": !this.onlyBtn
			};
		},
		bellSlash: function bellSlash() {
			return {
				"fa fa-bell fa-2x": this.bellBoolean,
				"fa fa-bell-slash fa-2x": !this.bellBoolean,
				"greenBell": this.bellBoolean
			};
		}
	},
	methods: {
		bellTrue: function bellTrue() {
			this.bellBoolean = true;
		},
		bellFalse: function bellFalse() {
			this.bellBoolean = false;
		},
		mobileEngage: function mobileEngage() {
			var _this = this;

			setTimeout(function () {
				_this.mobileWelcomeBlink.start();
			}, 150);
			this.mobileTxt = "Engaged!";
			this.onlyBtn = false;
			this.showMobileText = false;
			// setTimeout(this.startAudio, 300);	
			setTimeout(function () {
				_this.$router.push('/');
			}, 300);

			setTimeout(function () {
				_this.mobileWelcomeBlink.disconnect();
			}, 2000);
		},
		loadAudio: function loadAudio() {
			var ua = window.navigator.userAgent;

			var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor),
			    isFirefox = typeof InstallTrigger !== 'undefined',
			    isSafari = /constructor/i.test(window.HTMLElement) || function (p) {
				return p.toString() === "[object SafariRemoteNotification]";
			}(!window['safari'] || safari.pushNotification),
			    isOpera = !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0,
			    isIE = /*@cc_on!@*/false || !!document.documentMode,
			    isEdge = !isIE && !!window.StyleMedia,
			    isBlink = (isChrome || isOpera) && !!window.CSS,
			    iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i),
			    AndroidMobile = /Android/i.test(navigator.userAgent);

			if (AndroidMobile === true || isChrome === true || isOpera === true || isFirefox === true || isBlink === true) {
				this.mobileWelcomeBlink.load("../src/assets/sounds/blinks/welcomeBlink.ogg");
			} else if (iOS === true || isSafari === true || isEdge === true || isIE === true) {
				this.mobileWelcomeBlink.load("../src/assets/sounds/blinks/welcomeBlink.m4a");
			}
		}
	}
});

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_startaudiocontext_StartAudioContext_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_startaudiocontext_StartAudioContext_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_startaudiocontext_StartAudioContext_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var XRegExp = __webpack_require__(5);
/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			//RANDOMIZE BOOLEANS
			randomizeBoolean: false,
			showFlask1: true,
			showFlask2: false,
			showFlask3: false,
			showFlask4: false,
			showFlask5: false,
			showFlask6: false,
			//CONTROLS
			reverbChecker: undefined,
			loadingBoolean: true,
			userMobile: Boolean,
			mailingListBtn: false,
			textTiming: 500,
			startStopTrigger: true,
			playColor: "#F0CB50",
			stopColor: "#1E9BFC",
			//SCREEN DIMENSIONS
			screenHeight: undefined,
			screenWidth: undefined,
			ogWidth: undefined,
			//BACKGROUND COLORS
			plungeDepth: 1,
			backgroundColor1: true,
			backgroundColor2: false,
			backgroundColor3: false,
			backgroundColor4: false,
			backgroundColor5: false,
			backgroundColor6: false,
			backgroundColor7: false,
			backgroundColor8: false,
			backgroundColor9: false,
			backgroundColor10: false,
			//REACTIVE SUN
			sunReactiveColor1: true,
			sunReactiveColor2: false,
			sunReactiveColor3: false,
			sunReactiveColor4: false,
			sunReactiveColor5: false,
			sunReactiveColor6: false,
			sunReactiveColor7: false,
			sunReactiveColor8: false,
			sunReactiveColor9: false,
			sunReactiveColor10: false,
			//SHOW AND HIDE
			helpTrigger: false,
			showHelpOverlay: false,
			showAboutPage: false,

			bellBoolean: false,
			//PLAY SUN DRAGGIE
			activeSun: false,
			//V-SHOWS
			showEnterContainer: true,
			showLoading: true,
			showEnterBtn: false,
			showNavBar: false,
			showAllControls: false,
			showSpeechBtns: false,
			//AMBIENCE BOOLEANS
			ambience1Boolean: false,
			ambience2Boolean: false,
			ambience3Boolean: false,
			ambience4Boolean: false,
			ambience5Boolean: false,
			ambience6Boolean: false,
			//AMBIENCE DATA
			whatIsLoading: "NYC",
			metroFX: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": false,
				"volume": -5
			}).toMaster(),
			changeFX: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": false,
				"volume": -6
			}).toMaster(),
			ambience1Vol: -10,
			ambience2Vol: -10,
			ambience3Vol: -10,
			ambience4Vol: -2,
			ambience5Vol: -10,
			ambience6Vol: -16,
			ambience1Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": 0
			}),
			ambience2Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": 0
			}),
			ambience3Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": 0
			}),
			ambience4Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": 0
			}),
			ambience5Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": 0
			}),
			ambience6Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": 0
			}),
			//AUDIO ROUTING & EFFECTS
			playBackSpeed: 1,
			fxDecay: 2.5,
			// masterVolume:     		0,
			loadingSoundID: undefined,
			audioLoading: undefined,
			fxConvolverAmt: 0,
			fxChorusAmt: 0,
			fxDelayAmt: 0,
			fxAutoFilterAmt: 3500,
			mattChill: false,
			fxConvolver: undefined,
			fxChorus: undefined,
			fxDistort: undefined,
			fxDelay: undefined,
			fxAutoFilter: undefined,

			subwayFilter: undefined,
			streetFilter: undefined,

			speedToggle: true,
			fxDelayToggle: true,
			fxConvolverToggle: true,
			fxChorusToggle: true,
			fxFilterToggle: false,

			masterMeter: undefined,
			masterLevel: 0,
			masterVolumeSub: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Volume(0),
			//SPEECH
			//FOR SPEECH FORM INPUT
			submitSpeechTxttoVoice: false,
			userVoiceToText: "",
			//IF SPEECH IS ALLOWED SHOW SPEECH ACTIVATE BUTTON (SET VIA APP.js)
			allowSpeechControl: false,
			//GLOBAL COMMAND TRIGGERING VOICE COMMANDS ON AND OFF
			isVoiceControl: false,
			//COMMAND FOR CSS CONTROL WHEN VOICE IS ACTIVE OR NOT
			recognizing: undefined,
			recognitionNYC: undefined,
			//HOLDS ALL OF SPEECHRECONGNITION JSON
			voiceCommandArray: undefined,
			speechRecognitionList: undefined,
			voiceCommandConfidence: undefined,
			//STRING LINE TO TEST FOR VOICE COMMAND ACTIONS
			testObjectVUI: "",
			//BUTTON SWITCHING & TEXT
			initSpeech: true,
			speechBtnTxt: "Say A Command",
			speechStartTopBtnTrigger: true,
			//SHOWS LIST OF COMMANDS
			showVoiceCommandList: false,
			//DISABLE WHILE RECORDING
			isDisableListening: false,
			//TRUE WHEN STOPPING ALL SPEECH FUNCTIONS TO GO HOME
			stopModuleSpeech: false,
			//IF USER ENGAGES VOICE CONTROL BUT GOES HOME VIA MOUSE BUTTON THIS TRIGGERS MODULE SPEECH DISPOSE
			//EXPLORE
			isExploreFuncRunning: false,
			didWeAdventure: false,
			exploreSound1: undefined,
			exploringInterval: undefined,
			exploreBtnBoolean: false,
			//WHAT DEVICE
			isChrome: Boolean,
			isFirefox: Boolean,
			isSafari: Boolean,
			isOpera: Boolean,
			isIE: Boolean,
			isEdge: Boolean,
			isBlink: Boolean,
			iOS: Boolean,
			AndroidMobile: Boolean,
			//EXPLORE TIMES OUTS
			exploreTxt: "Explore!",
			exploreTimeout1: undefined,
			exploreTimeout2: undefined,
			exploreTimeout3: undefined,
			exploreTimeout4: undefined,
			exploreTimeout5: undefined,
			exploreTimeout6: undefined,
			exploreTimeout7: undefined,
			exploreTimeout8: undefined,
			exploreTimeout9: undefined,
			exploreTimeout10: undefined,
			exploreTimeout11: undefined,
			exploreTimeout12: undefined,
			exploreTimeout13: undefined,
			exploreTimeout14: undefined,
			//START AUDIO CONTEXT BOOLEAN
			startAudioBoolean: true,
			//LOCAL STORAGE
			isCacheSaved: false,
			firstLoad: false,
			saveTrigger: false,
			loadTrigger: false
		};
	},
	created: function created() {
		var _this = this;

		this.isVoiceControl = this.$store.state.isVoiceControlled;
		if (this.isVoiceControl) {
			this.$store.state.doNotAddress = true;
		}

		window.onpopstate = function () {
			document.body.className = 'default';
			_this.goHome();
		};
		var ua = window.navigator.userAgent;
		this.isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
		this.isFirefox = typeof InstallTrigger !== 'undefined';
		this.isSafari = /constructor/i.test(window.HTMLElement) || function (p) {
			return p.toString() === "[object SafariRemoteNotification]";
		}(!window['safari'] || safari.pushNotification);
		this.isOpera = !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
		this.isIE = /*@cc_on!@*/false || !!document.documentMode;
		this.isEdge = !this.isIE && !!window.StyleMedia;
		this.isBlink = (this.isChrome || this.isOpera) && !!window.CSS, this.iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
		this.AndroidMobile = /Android/i.test(navigator.userAgent);
		//CHROME ALLOWS SPEECH AND MEDIA RECORDING
		if (this.isChrome === true) {
			this.userMobile = false;
			//FIREFOX ONLY ALLOWS MEDIA RECORDING
		} else if (this.isFirefox === true) {
			this.userMobile = false;
			//NO SPEECH AND NO MEDIA RECORDING FOR THE FOLLOWING
		} else if (this.AndroidMobile === true || this.iOS) {
			this.userMobile = true;
		} else if (this.isSafari === true || this.isOpera === true || this.isBlink === true || this.isEdge === true || this.isIE === true) {
			this.userMobile = false;
		}
		this.firstAudioLoadFunc();
		this.bufferLoading();
		this.audioRouting();
	},

	computed: {
		//THE PLUNGE BACKGROUND CHANGE
		plungeClass: function plungeClass() {
			if (this.activeSun === false) {
				if (this.plungeDepth === 1) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = true;
				} else if (this.plungeDepth === 2) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = true;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 3) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = true;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 4) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = true;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 5) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = true;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 6) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = true;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 7) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = true;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 8) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = true;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 9) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = true;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 10) {
					this.backgroundColor10 = true;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				}
				return {
					"backgroundColorNYC10": this.backgroundColor10,
					"backgroundColorNYC9": this.backgroundColor9,
					"backgroundColorNYC8": this.backgroundColor8,
					"backgroundColorNYC7": this.backgroundColor7,
					"backgroundColorNYC6": this.backgroundColor6,
					"backgroundColorNYC5": this.backgroundColor5,
					"backgroundColorNYC4": this.backgroundColor4,
					"backgroundColorNYC3": this.backgroundColor3,
					"backgroundColorNYC2": this.backgroundColor2,
					"backgroundColorNYC1": this.backgroundColor1
				};
			} else if (this.activeSun === true) {
				if (this.masterLevel < -36) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = true;
				} else if (this.masterLevel < -32) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = true;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -30) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = true;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -28) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = true;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -26) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = true;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -24) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = true;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -22) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = true;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -20) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = true;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -18) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = true;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel > -16) {
					this.sunReactiveColor10 = true;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				}
				return {
					"sunReactiveColorClassNYC10": this.sunReactiveColor10,
					"sunReactiveColorClassNYC9": this.sunReactiveColor9,
					"sunReactiveColorClassNYC8": this.sunReactiveColor8,
					"sunReactiveColorClassNYC7": this.sunReactiveColor7,
					"sunReactiveColorClassNYC6": this.sunReactiveColor6,
					"sunReactiveColorClassNYC5": this.sunReactiveColor5,
					"sunReactiveColorClassNYC4": this.sunReactiveColor4,
					"sunReactiveColorClassNYC3": this.sunReactiveColor3,
					"sunReactiveColorClassNYC2": this.sunReactiveColor2,
					"sunReactiveColorClassNYC1": this.sunReactiveColor1
				};
			}
		},

		//SHOW AND HIDE CLASS CHANGES
		helpClass: function helpClass() {
			return {
				"btn btn-helpBtn1NYC": this.helpTrigger,
				"btn btn-helpBtn2NYC": !this.helpTrigger
			};
		},
		mailingListBtnClass: function mailingListBtnClass() {
			return {
				"btn btn-transparent": this.mailingListBtn,
				"btn btn-info": !this.mailingListBtn
			};
		},

		//AMBIENCE CLASS CHANGES
		ambience1Class: function ambience1Class() {
			return {
				"btn btn-playNYC": this.ambience1Boolean,
				"btn btn-stopNYC": !this.ambience1Boolean
			};
		},
		ambience2Class: function ambience2Class() {
			return {
				"btn btn-playNYC": this.ambience2Boolean,
				"btn btn-stopNYC": !this.ambience2Boolean
			};
		},
		ambience3Class: function ambience3Class() {
			return {
				"btn btn-playNYC": this.ambience3Boolean,
				"btn btn-stopNYC": !this.ambience3Boolean
			};
		},
		ambience4Class: function ambience4Class() {
			return {
				"btn btn-playNYC": this.ambience4Boolean,
				"btn btn-stopNYC": !this.ambience4Boolean
			};
		},
		ambience5Class: function ambience5Class() {
			return {
				"btn btn-playNYC": this.ambience5Boolean,
				"btn btn-stopNYC": !this.ambience5Boolean
			};
		},
		ambience6Class: function ambience6Class() {
			return {
				"btn btn-playNYC": this.ambience6Boolean,
				"btn btn-stopNYC": !this.ambience6Boolean
			};
		},
		mattChillClass: function mattChillClass() {
			return {
				"btn btn-mattChillOnNYC": this.mattChill,
				"btn btn-mattChillOffNYC": !this.mattChill
			};
		},

		//AMBIENCE ICON CSS
		ambience1Icon: function ambience1Icon() {
			return {
				"fal fa-times-circle": !this.ambience1Boolean,
				"fal fa-check-circle": this.ambience1Boolean
			};
		},
		ambience2Icon: function ambience2Icon() {
			return {
				"fal fa-times-circle": !this.ambience2Boolean,
				"fal fa-check-circle": this.ambience2Boolean
			};
		},
		ambience3Icon: function ambience3Icon() {
			return {
				"fal fa-times-circle": !this.ambience3Boolean,
				"fal fa-check-circle": this.ambience3Boolean
			};
		},
		ambience4Icon: function ambience4Icon() {
			return {
				"fal fa-times-circle": !this.ambience4Boolean,
				"fal fa-check-circle": this.ambience4Boolean
			};
		},
		ambience5Icon: function ambience5Icon() {
			return {
				"fal fa-times-circle": !this.ambience5Boolean,
				"fal fa-check-circle": this.ambience5Boolean
			};
		},
		ambience6Icon: function ambience6Icon() {
			return {
				"fal fa-times-circle": !this.ambience6Boolean,
				"fal fa-check-circle": this.ambience6Boolean
			};
		},

		//AMBIANCE CLASS CHANGES
		ambiance1RangerClass: function ambiance1RangerClass() {
			return {
				"ambianceRangerPlayNYC": this.ambience1Boolean,
				"ambianceRangerStopNYC": !this.ambience1Boolean
			};
		},
		ambiance2RangerClass: function ambiance2RangerClass() {
			return {
				"ambianceRangerPlayNYC": this.ambience2Boolean,
				"ambianceRangerStopNYC": !this.ambience2Boolean
			};
		},
		ambiance3RangerClass: function ambiance3RangerClass() {
			return {
				"ambianceRangerPlayNYC": this.ambience3Boolean,
				"ambianceRangerStopNYC": !this.ambience3Boolean
			};
		},
		ambiance4RangerClass: function ambiance4RangerClass() {
			return {
				"ambianceRangerPlayNYC": this.ambience4Boolean,
				"ambianceRangerStopNYC": !this.ambience4Boolean
			};
		},
		ambiance5RangerClass: function ambiance5RangerClass() {
			return {
				"ambianceRangerPlayNYC": this.ambience5Boolean,
				"ambianceRangerStopNYC": !this.ambience5Boolean
			};
		},
		ambiance6RangerClass: function ambiance6RangerClass() {
			return {
				"ambianceRangerPlayNYC": this.ambience6Boolean,
				"ambianceRangerStopNYC": !this.ambience6Boolean
			};
		},

		//AUDIO MIXING
		adjustInputVolume: function adjustInputVolume() {
			this.userMic.volume.value = this.userMicInputLevel;
		},
		fxConvolverMix: function fxConvolverMix() {
			if (this.userMobile === false) {
				if (this.fxConvolverToggle === true) {
					this.fxConvolver.wet.setTargetAtTime(this.fxConvolverAmt / 100, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				} else if (this.fxConvolverToggle === false) {
					this.fxConvolver.wet.setTargetAtTime(0, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				}
			}
		},
		fxDelayMix: function fxDelayMix() {
			if (this.userMobile === false) {
				if (this.fxDelayToggle === true) {
					this.fxDelay.wet.setTargetAtTime(this.fxDelayAmt / 100, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +1);
				} else if (this.fxDelayToggle === false) {
					this.fxDelay.wet.setTargetAtTime(0, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +1);
				}
			}
		},
		fxChorusMix: function fxChorusMix() {
			if (this.userMobile === false) {
				if (this.fxChorusToggle === true) {
					this.fxChorus.wet.setTargetAtTime(this.fxChorusAmt / 100, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				} else if (this.fxChorusToggle === false) {
					this.fxChorus.wet.setTargetAtTime(0, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				}
			}
		},
		fxAutoFilterMix: function fxAutoFilterMix() {
			if (this.userMobile === false) {
				if (this.fxFilterToggle === true) {
					this.fxAutoFilter.frequency.setTargetAtTime(this.fxAutoFilterAmt, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				} else if (this.fxFilterToggle === false) {
					this.fxAutoFilter.frequency.setTargetAtTime(20000, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				}
			}
		},
		playbackSpeedFunc: function playbackSpeedFunc() {
			if (this.speedToggle === true) {
				this.ambience1Player.playbackRate = this.playBackSpeed;
				this.ambience2Player.playbackRate = this.playBackSpeed;
				this.ambience3Player.playbackRate = this.playBackSpeed;
				this.ambience4Player.playbackRate = this.playBackSpeed;
				this.ambience5Player.playbackRate = this.playBackSpeed;
				this.ambience6Player.playbackRate = this.playBackSpeed;
			} else if (this.speedToggle === false) {
				this.ambience1Player.playbackRate = 1;
				this.ambience2Player.playbackRate = 1;
				this.ambience3Player.playbackRate = 1;
				this.ambience4Player.playbackRate = 1;
				this.ambience5Player.playbackRate = 1;
				this.ambience6Player.playbackRate = 1;
			}
		},

		//SPEECH
		speechStartStopClass: function speechStartStopClass() {
			return {
				"recordingClassEngagedNYC": this.recognizing,
				"recordingClassDisengagedNYC": !this.recognizing
			};
		},
		speechIconClass: function speechIconClass() {
			return {
				"fa fa-microphone-alt fa-spin": this.recognizing,
				"fa fa-microphone-alt": !this.recognizing
			};
		},
		speechShowListClass: function speechShowListClass() {
			return {
				"recordingClassEngagedNYC": this.showVoiceCommandList,
				"recordingClassDisengagedNYC": !this.showVoiceCommandList
			};
		},
		speechSubmitClass: function speechSubmitClass() {
			return {
				"btn btn-speechSubmitOn mb-2": this.submitSpeechTxttoVoice,
				"btn btn-speechSubmitOff mb-2": !this.submitSpeechTxttoVoice
			};
		},

		//EXPLORE
		exploreFuncClass: function exploreFuncClass() {
			return {
				"recordingClassDisengagedNYC": !this.isExploreFuncRunning,
				"recordingClassEngagedNYC": this.isExploreFuncRunning
			};
		},
		exploreIconClass: function exploreIconClass() {
			return {
				"fab fa-wpexplorer": !this.isExploreFuncRunning,
				"fab fa-wpexplorer fa-spin": this.isExploreFuncRunning
			};
		},

		//AMBIENCE PLAY AND STOPS
		ambience1Func: function ambience1Func() {
			if (this.ambience1Boolean === true) {
				this.ambience1Player.volume.value = this.ambience1Vol;
			} else if (this.ambience1Boolean === false) {
				this.ambience1Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},
		ambience2Func: function ambience2Func() {
			if (this.ambience2Boolean === true) {
				this.ambience2Player.volume.value = this.ambience2Vol;
			} else if (this.ambience2Boolean === false) {
				this.ambience2Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},
		ambience3Func: function ambience3Func() {
			if (this.ambience3Boolean === true) {
				this.ambience3Player.volume.value = this.ambience3Vol;
			} else if (this.ambience3Boolean === false) {
				this.ambience3Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},
		ambience4Func: function ambience4Func() {
			if (this.ambience4Boolean === true) {
				this.ambience4Player.volume.value = this.ambience4Vol;
			} else if (this.ambience4Boolean === false) {
				this.ambience4Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},
		ambience5Func: function ambience5Func() {
			if (this.ambience5Boolean === true) {
				this.ambience5Player.volume.value = this.ambience5Vol;
			} else if (this.ambience5Boolean === false) {
				this.ambience5Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},
		ambience6Func: function ambience6Func() {
			if (this.ambience6Boolean === true) {
				this.ambience6Player.volume.value = this.ambience6Vol;
			} else if (this.ambience6Boolean === false) {
				this.ambience6Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},

		//LOCAL STORAGE
		saveClass: function saveClass() {
			return { "btn btn-playNYC": this.saveTrigger,
				"btn btn-stopNYC": !this.saveTrigger };
		},
		loadClass: function loadClass() {
			return { "btn btn-playNYC": this.loadTrigger,
				"btn btn-stopNYC": !this.loadTrigger };
		}
	},
	methods: {
		//LOCAL STORAGE
		setLocalStorage: function setLocalStorage() {
			var _this2 = this;

			this.saveTrigger = true;
			setTimeout(function () {
				_this2.saveTrigger = false;
			}, 250);

			this.removeLocalStorage();

			localStorage.setItem('isCacheSavedNYC', JSON.stringify(true));

			localStorage.setItem('ambience1VolNYC', JSON.stringify(this.ambience1Vol));
			localStorage.setItem('ambience2VolNYC', JSON.stringify(this.ambience2Vol));
			localStorage.setItem('ambience3VolNYC', JSON.stringify(this.ambience3Vol));
			localStorage.setItem('ambience4VolNYC', JSON.stringify(this.ambience4Vol));
			localStorage.setItem('ambience5VolNYC', JSON.stringify(this.ambience5Vol));
			localStorage.setItem('ambience6VolNYC', JSON.stringify(this.ambience6Vol));

			localStorage.setItem('ambience1BooleanNYC', JSON.stringify(this.ambience1Boolean));
			localStorage.setItem('ambience2BooleanNYC', JSON.stringify(this.ambience2Boolean));
			localStorage.setItem('ambience3BooleanNYC', JSON.stringify(this.ambience3Boolean));
			localStorage.setItem('ambience4BooleanNYC', JSON.stringify(this.ambience4Boolean));
			localStorage.setItem('ambience5BooleanNYC', JSON.stringify(this.ambience5Boolean));
			localStorage.setItem('ambience6BooleanNYC', JSON.stringify(this.ambience6Boolean));

			localStorage.setItem('speedToggleNYC', JSON.stringify(this.speedToggle));
			localStorage.setItem('fxDelayToggleNYC', JSON.stringify(this.fxDelayToggle));
			localStorage.setItem('fxConvolverToggleNYC', JSON.stringify(this.fxConvolverToggle));
			localStorage.setItem('fxChorusToggleNYC', JSON.stringify(this.fxChorusToggle));
			localStorage.setItem('fxFilterToggleNYC', JSON.stringify(this.fxFilterToggle));

			localStorage.setItem('playBackSpeed', JSON.stringify(this.playBackSpeed));
			localStorage.setItem('fxConvolverAmtNYC', JSON.stringify(this.fxConvolverAmt));
			localStorage.setItem('fxChorusAmtNYC', JSON.stringify(this.fxChorusAmt));
			localStorage.setItem('fxDelayAmtNYC', JSON.stringify(this.fxDelayAmt));
			localStorage.setItem('fxAutoFilterAmtNYC', JSON.stringify(this.fxAutoFilterAmt));
		},
		getLocalStorage: function getLocalStorage() {
			var _this3 = this;

			this.isCacheSaved = JSON.parse(localStorage.getItem('isCacheSavedNYC'));
			if (this.isCacheSaved) {
				this.loadTrigger = true;
				setTimeout(function () {
					_this3.loadTrigger = false;
				}, 250);

				this.ambience1Vol = JSON.parse(localStorage.getItem('ambience1VolNYC'));
				this.ambience2Vol = JSON.parse(localStorage.getItem('ambience2VolNYC'));
				this.ambience3Vol = JSON.parse(localStorage.getItem('ambience3VolNYC'));
				this.ambience4Vol = JSON.parse(localStorage.getItem('ambience4VolNYC'));
				this.ambience5Vol = JSON.parse(localStorage.getItem('ambience5VolNYC'));
				this.ambience6Vol = JSON.parse(localStorage.getItem('ambience6VolNYC'));

				this.ambience1Boolean = JSON.parse(localStorage.getItem('ambience1BooleanNYC'));
				this.ambience2Boolean = JSON.parse(localStorage.getItem('ambience2BooleanNYC'));
				this.ambience3Boolean = JSON.parse(localStorage.getItem('ambience3BooleanNYC'));
				this.ambience4Boolean = JSON.parse(localStorage.getItem('ambience4BooleanNYC'));
				this.ambience5Boolean = JSON.parse(localStorage.getItem('ambience5BooleanNYC'));
				this.ambience6Boolean = JSON.parse(localStorage.getItem('ambience6BooleanNYC'));

				this.speedToggle = JSON.parse(localStorage.getItem('speedToggleNYC'));
				this.fxDelayToggle = JSON.parse(localStorage.getItem('fxDelayToggleNYC'));
				this.fxConvolverToggle = JSON.parse(localStorage.getItem('fxConvolverToggleNYC'));
				this.fxChorusToggle = JSON.parse(localStorage.getItem('fxChorusToggleNYC'));
				this.fxFilterToggle = JSON.parse(localStorage.getItem('fxFilterToggleNYC'));

				this.playBackSpeed = JSON.parse(localStorage.getItem('playBackSpeed'));;
				this.fxConvolverAmt = JSON.parse(localStorage.getItem('fxConvolverAmtNYC'));
				this.fxChorusAmt = JSON.parse(localStorage.getItem('fxChorusAmtNYC'));
				this.fxDelayAmt = JSON.parse(localStorage.getItem('fxDelayAmtNYC'));
				this.fxAutoFilterAmt = JSON.parse(localStorage.getItem('fxAutoFilterAmtNYC'));
			}
		},
		removeLocalStorage: function removeLocalStorage() {
			localStorage.removeItem('isCacheSavedNYC');

			localStorage.removeItem('ambience1VolNYC');
			localStorage.removeItem('ambience2VolNYC');
			localStorage.removeItem('ambience3VolNYC');
			localStorage.removeItem('ambience4VolNYC');
			localStorage.removeItem('ambience5VolNYC');
			localStorage.removeItem('ambience6VolNYC');

			localStorage.removeItem('ambience1BooleanNYC');
			localStorage.removeItem('ambience2BooleanNYC');
			localStorage.removeItem('ambience3BooleanNYC');
			localStorage.removeItem('ambience4BooleanNYC');
			localStorage.removeItem('ambience5BooleanNYC');
			localStorage.removeItem('ambience6BooleanNYC');

			localStorage.removeItem('speedToggleNYC');
			localStorage.removeItem('fxDelayToggleNYC');
			localStorage.removeItem('fxConvolverToggleNYC');
			localStorage.removeItem('fxChorusToggleNYC');
			localStorage.removeItem('fxFilterToggleNYC');

			localStorage.removeItem('playBackSpeedNYC');
			localStorage.removeItem('fxConvolverAmtNYC');
			localStorage.removeItem('fxChorusAmtNYC');
			localStorage.removeItem('fxDelayAmtNYC');
			localStorage.removeItem('fxAutoFilterAmtNYC');
		},

		//START AUDIO
		startAudio: function startAudio() {
			if (this.firstLoad) {
				this.firstLoad = false;
				__WEBPACK_IMPORTED_MODULE_0__node_modules_startaudiocontext_StartAudioContext_js___default()(__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.context, "#enterFuncBtn");
				this.$store.state.hasAudioContextTriggered = true;
			}
			this.ambience1Player.volume.value = -100;
			this.ambience2Player.volume.value = -100;
			this.ambience3Player.volume.value = -100;
			this.ambience4Player.volume.value = -100;
			this.ambience5Player.volume.value = -100;
			this.ambience6Player.volume.value = -100;

			this.ambience1Player.start();
			this.ambience2Player.start();
			this.ambience3Player.start();
			this.ambience4Player.start();
			this.ambience5Player.start();
			this.ambience6Player.start();
		},
		stopAudio: function stopAudio() {
			this.ambience1Player.stop();
			this.ambience2Player.stop();
			this.ambience3Player.stop();
			this.ambience4Player.stop();
			this.ambience5Player.stop();
			this.ambience6Player.stop();
		},

		//SPEECH
		userVoiceToTextFunc: function userVoiceToTextFunc() {
			var _this4 = this;

			this.submitSpeechTxttoVoice = true;
			this.testObjectVUI = this.userVoiceToText;
			console.log(this.testObjectVUI);
			this.sourceSortingVUI();
			setTimeout(function () {
				_this4.submitSpeechTxttoVoice = false;
			}, 250);
		},
		speechFunc: function speechFunc() {
			var _this5 = this;

			if (this.initSpeech === true) {
				this.recognitionNYC = new webkitSpeechRecognition();
				this.recognizing;
				this.recognitionNYC.continuous = false;
				this.recognitionNYC.interimResults = true;

				this.recognitionNYC.onresult = function (event) {
					for (var i = event.resultIndex; i < event.results.length; ++i) {
						if (event.results[i].isFinal) {
							if (!_this5.isDisableListening) {
								_this5.testObjectVUI += event.results[i][0].transcript;
								console.log('Speech String Command: ' + event.results[i][0].transcript);
								_this5.sourceSortingVUI();
							}
						}
					}
				};
				this.recognitionNYC.onspeechend = function () {
					console.log('%c NYC Module SPEECH Ended', 'background: red; color: black');
					// setTimeout(this.sourceSortingVUI, 500);
					_this5.recognizing = false;
					_this5.speechBtnTxt = "Say A Command";
					__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master.volume.setTargetAtTime(0, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.context.currentTime, +0.5);
				};
				this.recognitionNYC.onspeechstart = function () {
					console.log('%c NYC Module SPEECH Began', 'background: green; color: white');
					_this5.recognizing = true;
					_this5.speechBtnTxt = "Listening For Command";
					__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master.volume.setTargetAtTime(-10, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.context.currentTime, +1);
				};
				this.recognitionNYC.onsoundstart = function () {
					console.log('%c NYC Module LISTENING Began', 'background: green; color: white');
				};
				this.recognitionNYC.onaudioend = function () {
					console.log('%c NYC Module LISTENING Ended', 'background: green; color: white');
					// setTimeout(this.sourceSortingVUI, 500);
					_this5.recognizing = false;
					_this5.speechBtnTxt = "Say A Command";
				};
				this.recognitionNYC.onend = function () {
					console.log('%c NYC Module SPEECH SESSION ENDED', 'background: green; color: white');
					if (_this5.stopModuleSpeech === false) {
						_this5.recognitionNYC.start();
					}
				};
				this.recognizing = true;
				//MAKE SURE SPEECH IS NOT RE-ENGAGED
				this.initSpeech = false;
				//GLOBAL VOICE COMMAND IS SET TO TRUE
				this.$store.state.isVoiceControlled = true;
				this.recognitionNYC.start();
				//IF USER ENGAGES VOICE CONTROL BUT GOES HOME VIA MOUSE BUTTON THIS TRIGGERS MODULE SPEECH DISPOSE
				this.goingHomeNotViaVoiceCommand = true;
				//CONTROLS recognition.onend TO RESTART LISTENING
				this.stopModuleSpeech = false;
				//TURN LISTENING BACK ON
				this.isDisableListening = false;
				//IF BEING VOICE CONTROLLED DON'T PLAY THE NICE, TELL ME WHERE YOU WANT TO GO PROMPT ON WELCOME PAGE
				this.$store.state.doNotAddress = true;
			} else if (this.initSpeech === false) {}
		},
		resetFunc: function resetFunc() {
			this.recognizing = false;
		},
		speechStartStopFunc: function speechStartStopFunc() {
			this.speechStartTopBtnTrigger = !this.speechStartTopBtnTrigger;

			if (this.speechStartTopBtnTrigger === true) {
				this.speechFunc();
			} else if (this.speechStartTopBtnTrigger === false) {
				this.initSpeech = true;
				this.stopModuleSpeech = true;
				this.recognizing = false;
				this.recognitionNYC.stop();
				this.$store.state.isVoiceControlled = false;
			}
		},
		sourceSortingVUI: function sourceSortingVUI() {
			//FOR VISUAL REFERENCE
			this.userVoiceToText = this.testObjectVUI;

			var source1RegEx = XRegExp.build('(?x) {{source1Name}} | {{label1Name}}', {
				source1Name: XRegExp.build('{{source1Name1}} | {{source1Name2}}', {
					source1Name1: /source\sone/,
					source1Name2: /source\s1/
				}),
				label1Name: XRegExp.build('{{label1Name1}} | {{label1Name2}}', {
					label1Name1: /streets?/,
					label1Name2: /sidewalk/
				})
			}, 'xgi');

			var source2RegEx = XRegExp.build('(?x) {{source2Name}} | {{label2Name}}', {
				source2Name: XRegExp.build('{{source2Name1}} | {{source2Name2}}', {
					source2Name1: /source\stw?o?o/,
					source2Name2: /source\s2/
				}),
				label2Name: XRegExp.build('{{label2Name1}} | {{label2Name2}}', {
					label2Name1: /humans?|walla/,
					label2Name2: /people|persons?/
				})
			}, 'xgi');

			var source3RegEx = XRegExp.build('(?x) {{source3Name}} | {{label3Name}}', {
				source3Name: XRegExp.build('{{source3Name1}} | {{source3Name2}}', {
					source3Name1: /source\sthree/,
					source3Name2: /source\s3/
				}),
				label3Name: XRegExp.build('{{label3Name1}} | {{label3Name2}}', {
					label3Name1: /subway\sstations?/,
					label3Name2: /station/
				})
			}, 'xgi');

			var source4RegEx = XRegExp.build('(?x) {{source4Name}} | {{label4Name}}', {
				source4Name: XRegExp.build('{{source4Name1}} | {{source4Name2}}', {
					source4Name1: /source\sfou?re?/,
					source4Name2: /source\s4/
				}),
				label4Name: XRegExp.build('{{label4Name1}} | {{label4Name2}}', {
					label4Name1: /subway\scars?/,
					label4Name2: /train\scars?|train/
				})
			}, 'xgi');

			var source5RegEx = XRegExp.build('(?x) {{source5Name}} | {{label5Name}}', {
				source5Name: XRegExp.build('{{source5Name1}} | {{source5Name2}}', {
					source5Name1: /source\sfive/,
					source5Name2: /source\s5/
				}),
				label5Name: XRegExp.build('{{label5Name1}} | {{label5Name2}}', {
					label5Name1: /8th|floor|8|eight|ate/,
					label5Name2: /building/
				})
			}, 'xgi');

			var source6RegEx = XRegExp.build('(?x) {{source6Name}} | {{label6Name}}', {
				source6Name: XRegExp.build('{{source6Name1}} | {{source6Name2}}', {
					source6Name1: /source\ss[ei]x/,
					source6Name2: /source\s6/
				}),
				label6Name: XRegExp.build('{{label6Name1}} | {{label6Name2}}', {
					label6Name1: /skyscraper|penthouse/,
					label6Name2: /top\sfloor/
				})
			}, 'xgi');
			//ALL SOUNDS
			var allSoundRegEx = XRegExp.build('(?x) {{allSoundName}}', {
				allSoundName: XRegExp.build('{{allSoundName1}} | {{allSoundName2}}', {
					allSoundName1: /all\ssounds?/,
					allSoundName2: /all\saudios?/
				})
			}, 'xgi');
			//SPEED
			var speedRegEx = XRegExp.build('(?x) {{speedName}}', {
				speedName: XRegExp.build('{{speedName1}} | {{speedName2}}', {
					speedName1: /speeds?/,
					speedName2: /slow|faster/
				})
			}, 'xgi');
			//DELAY
			var delayRegEx = XRegExp.build('(?x) {{delayName}}', {
				delayName: XRegExp.build('{{delayName1}} | {{delayName2}}', {
					delayName1: /delay/,
					delayName2: /lay/
				})
			}, 'xgi');
			//CHORUS
			var chorusRegEx = XRegExp.build('(?x) {{chorusName}}', {
				chorusName: XRegExp.build('{{chorusName1}} | {{chorusName2}}', {
					chorusName1: /chorus?/,
					chorusName2: /course/
				})
			}, 'xgi');
			//FILTER
			var filterRegEx = XRegExp.build('(?x) {{filterName}}', {
				filterName: XRegExp.build('{{filterName1}} | {{filterName2}}', {
					filterName1: /filter/,
					filterName2: /filter/
				})
			}, 'xgi');
			//REVERB
			var reverbRegEx = XRegExp.build('(?x) {{reverbName}}', {
				reverbName: XRegExp.build('{{reverbName1}} | {{reverbName2}}', {
					reverbName1: /verb/,
					reverbName2: /reverb/
				})
			}, 'xgi');
			//SHOW
			var infoRegEx = XRegExp.build('(?x) {{showName}}', {
				showName: XRegExp.build('{{showName1}} | {{showName2}}', {
					showName1: /info/,
					showName2: /information/
				})
			}, 'xgi');
			// console.log(infoRegEx);
			//HIDE
			var listRegEx = XRegExp.build('(?x) {{hideName}}', {
				hideName: XRegExp.build('{{hideName1}} | {{hideName2}}', {
					hideName1: /lists?/,
					hideName2: /menu/
				})
			}, 'xgi');
			// console.log(listRegEx);			

			var source1Boolean = source1RegEx.test(this.testObjectVUI);
			var source2Boolean = source2RegEx.test(this.testObjectVUI);
			var source3Boolean = source3RegEx.test(this.testObjectVUI);
			var source4Boolean = source4RegEx.test(this.testObjectVUI);
			var source5Boolean = source5RegEx.test(this.testObjectVUI);
			var source6Boolean = source6RegEx.test(this.testObjectVUI);
			var allSoundBoolean = allSoundRegEx.test(this.testObjectVUI);
			var speedBoolean = speedRegEx.test(this.testObjectVUI);
			var delayBoolean = delayRegEx.test(this.testObjectVUI);
			var chorusBoolean = chorusRegEx.test(this.testObjectVUI);
			var filterBoolean = filterRegEx.test(this.testObjectVUI);
			var reverbBoolean = reverbRegEx.test(this.testObjectVUI);
			var infoBoolean = infoRegEx.test(this.testObjectVUI);
			var listBoolean = listRegEx.test(this.testObjectVUI);

			if (source1Boolean) {
				this.source1VUI();
			} else if (source2Boolean) {
				this.source2VUI();
			} else if (source3Boolean) {
				this.source3VUI();
			} else if (source4Boolean) {
				this.source4VUI();
			} else if (source5Boolean) {
				this.source5VUI();
			} else if (source6Boolean) {
				this.source6VUI();
			} else if (allSoundBoolean) {
				this.allSoundVUI();
			} else if (speedBoolean) {
				this.speedVUI();
			} else if (delayBoolean) {
				this.delayVUI();
			} else if (chorusBoolean) {
				this.chorusVUI();
			} else if (filterBoolean) {
				this.filterVUI();
			} else if (reverbBoolean) {
				this.reverbVUI();
			} else if (infoBoolean) {
				this.infoVUI();
			} else if (listBoolean) {
				this.listVUI();
			} else {
				this.miscVUI();
			}
		},
		source1VUI: function source1VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience1Player.start();
				this.ambience1Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience1Player.stop();
				this.ambience1Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience1Vol < 0) {
						this.ambience1Vol += 12;
					}
				} else {
					if (this.ambience1Vol < 0) {
						this.ambience1Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience1Vol > -30) {
						this.ambience1Vol -= 12;
					}
				} else {
					if (this.ambience1Vol > -30) {
						this.ambience1Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		source2VUI: function source2VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience2Player.start();
				this.ambience2Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience2Player.stop();
				this.ambience2Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience2Vol < 0) {
						this.ambience2Vol += 12;
					}
				} else {
					if (this.ambience2Vol < 0) {
						this.ambience2Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience2Vol > -30) {
						this.ambience2Vol -= 12;
					}
				} else {
					if (this.ambience2Vol > -30) {
						this.ambience2Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		source3VUI: function source3VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience3Player.start();
				this.ambience3Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience3Player.stop();
				this.ambience3Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience3Vol < 0) {
						this.ambience3Vol += 12;
					}
				} else {
					if (this.ambience3Vol < 0) {
						this.ambience3Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience3Vol > -30) {
						this.ambience3Vol -= 12;
					}
				} else {
					if (this.ambience3Vol > -30) {
						this.ambience3Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		source4VUI: function source4VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience4Player.start();
				this.ambience4Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience4Player.stop();
				this.ambience4Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience4Vol < 0) {
						this.ambience4Vol += 12;
					}
				} else {
					if (this.ambience4Vol < 0) {
						this.ambience4Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience4Vol > -30) {
						this.ambience4Vol -= 12;
					}
				} else {
					if (this.ambience4Vol > -30) {
						this.ambience4Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		source5VUI: function source5VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience5Player.start();
				this.ambience5Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience5Player.stop();
				this.ambience5Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience5Vol < 0) {
						this.ambience5Vol += 12;
					}
				} else {
					if (this.ambience5Vol < 0) {
						this.ambience5Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience5Vol > -30) {
						this.ambience5Vol -= 12;
					}
				} else {
					if (this.ambience5Vol > -30) {
						this.ambience5Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		source6VUI: function source6VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience6Player.start();
				this.ambience6Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience6Player.stop();
				this.ambience6Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience6Vol < 0) {
						this.ambience6Vol += 12;
					}
				} else {
					if (this.ambience6Vol < 0) {
						this.ambience6Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience6Vol > -30) {
						this.ambience6Vol -= 12;
					}
				} else {
					if (this.ambience6Vol > -30) {
						this.ambience6Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		allSoundVUI: function allSoundVUI() {
			//STOP ALL 
			if (RegExp(/stop/gi).test(this.testObjectVUI)) {
				this.ambience1Player.stop();
				this.ambience1Boolean = false;
				this.ambience2Player.stop();
				this.ambience2Boolean = false;
				this.ambience3Player.stop();
				this.ambience3Boolean = false;
				this.ambience4Player.stop();
				this.ambience4Boolean = false;
				this.ambience5Player.stop();
				this.ambience5Boolean = false;
				this.ambience6Player.stop();
				this.ambience6Boolean = false;
				if (this.didWeAdventure) {
					this.exploreSound1.stop();
					this.isExploreFuncRunning = false;
					this.stopExplore();
				}
			} else if (RegExp(/play/gi).test(this.testObjectVUI)) {
				this.ambience1Player.start();
				this.ambience1Boolean = true;
				this.ambience2Player.start();
				this.ambience2Boolean = true;
				this.ambience3Player.start();
				this.ambience3Boolean = true;
				this.ambience4Player.start();
				this.ambience4Boolean = true;
				this.ambience5Player.start();
				this.ambience5Boolean = true;
				this.ambience6Player.start();
				this.ambience6Boolean = true;
			}
			this.testObjectVUI = "";
		},
		speedVUI: function speedVUI() {
			if (RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI)) {
				this.speedToggle = true;
			} else if (RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI)) {
				this.speedToggle = false;
			}
			if (RegExp(/\bfaste?r?\b|up/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.playBackSpeed <= 1.6) {
						this.playBackSpeed += 0.4;
					}
				} else {
					if (this.playBackSpeed <= 1.8) {
						this.playBackSpeed += 0.2;
					}
				}
			} else if (RegExp(/slowe?r?|down/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.playBackSpeed >= 0.5) {
						this.playBackSpeed -= 0.4;
					}
				} else {
					if (this.playBackSpeed >= 0.2) {
						this.playBackSpeed -= 0.2;
					}
				}
			}
			this.testObjectVUI = "";
		},
		delayVUI: function delayVUI() {
			if (RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI)) {
				this.fxDelayToggle = true;
			} else if (RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI)) {
				this.fxDelayToggle = false;
			}
			if (RegExp(/\bmore\b|\bup\b|loude?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxDelayAmt <= 80) {
						this.fxDelayAmt += 10;
					}
				} else {
					if (this.fxDelayAmt <= 95) {
						this.fxDelayAmt += 5;
					}
				}
			} else if (RegExp(/less|\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxDelayAmt >= 20) {
						this.fxDelayAmt -= 10;
					} else if (this.fxDelayAmt >= 5) {
						this.fxDelayAmt -= 5;
					}
				} else {
					if (this.fxDelayAmt >= 5) {
						this.fxDelayAmt -= 5;
					} else if (this.fxDelayAmt >= 15) {
						this.fxDelayAmt -= 2;
					}
				}
			}
			this.testObjectVUI = "";
		},
		chorusVUI: function chorusVUI() {
			if (RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI)) {
				this.fxChorusToggle = true;
			} else if (RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI)) {
				this.fxChorusToggle = false;
			}
			if (RegExp(/\bmore\b|\bup\b|loude?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxChorusAmt <= 80) {
						this.fxChorusAmt += 10;
					}
				} else {
					if (this.fxChorusAmt <= 95) {
						this.fxChorusAmt += 5;
					}
				}
			} else if (RegExp(/less|\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxChorusAmt >= 20) {
						this.fxChorusAmt -= 10;
					} else if (this.fxChorusAmt >= 5) {
						this.fxChorusAmt -= 5;
					}
				} else {
					if (this.fxChorusAmt >= 5) {
						this.fxChorusAmt -= 5;
					} else if (this.fxChorusAmt >= 15) {
						this.fxChorusAmt -= 2;
					}
				}
			}
			this.testObjectVUI = "";
		},
		reverbVUI: function reverbVUI() {
			if (RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI)) {
				this.fxConvolverToggle = true;
			} else if (RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI)) {
				this.fxConvolverToggle = false;
			}
			if (RegExp(/\bmore\b|\bup\b|loude?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxConvolverAmt <= 45) {
						this.fxConvolverAmt += 5;
					}
				} else {
					if (this.fxConvolverAmt <= 48) {
						this.fxConvolverAmt += 2;
					}
				}
			} else if (RegExp(/less|\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxConvolverAmt >= 10) {
						this.fxConvolverAmt -= 5;
					} else if (this.fxConvolverAmt >= 2) {
						this.fxConvolverAmt -= 1;
					}
				} else {
					if (this.fxConvolverAmt >= 10) {
						this.fxConvolverAmt -= 2;
					} else if (this.fxConvolverAmt >= 2) {
						this.fxConvolverAmt -= 1;
					}
				}
			}
			this.testObjectVUI = "";
		},
		filterVUI: function filterVUI() {
			if (RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI)) {
				this.fxFilterToggle = true;
			} else if (RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI)) {
				this.fxFilterToggle = false;
			}
			if (RegExp(/\bmore\b|\blower\b/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxAutoFilterAmt > 1500) {
						this.fxAutoFilterAmt -= 1500;
					} else if (this.fxAutoFilterAmt >= 300) {
						this.fxAutoFilterAmt -= 200;
					}
				} else {
					if (this.fxAutoFilterAmt >= 500) {
						this.fxAutoFilterAmt -= 250;
					} else if (this.fxAutoFilterAmt >= 100) {
						this.fxAutoFilterAmt -= 100;
					}
				}
			} else if (RegExp(/less|higher|hire/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxAutoFilterAmt <= 10000) {
						this.fxAutoFilterAmt += 1500;
					} else if (this.fxAutoFilterAmt <= 1000) {
						this.fxAutoFilterAmt += 200;
					}
				} else {
					if (this.fxAutoFilterAmt <= 10000) {
						this.fxAutoFilterAmt += 250;
					} else if (this.fxAutoFilterAmt <= 1000) {
						this.fxAutoFilterAmt += 100;
					}
				}
			}
			this.testObjectVUI = "";
		},
		infoVUI: function infoVUI() {
			var _this6 = this;

			if (RegExp(/show|display/gi).test(this.testObjectVUI)) {
				this.showHelpOverlay = true;
				setTimeout(function () {
					_this6.showNavBar = false;
					if (_this6.$store.state.allowSpeechControl) {
						_this6.showSpeechBtns = false;
					}
				}, 0);
				setTimeout(function () {
					_this6.showAllControls = false;
				}, 500);
				setTimeout(function () {
					_this6.showAboutPage = true;
				}, 1500);
				console.log('SHOW INFO');
			} else if (RegExp(/hide|minimize/gi).test(this.testObjectVUI)) {
				this.showHelpOverlay = false;
				this.showAboutPage = false;
				setTimeout(function () {
					_this6.showAllControls = true;
				}, 800);
				setTimeout(function () {
					_this6.showNavBar = true;
					if (_this6.$store.state.allowSpeechControl) {
						_this6.showSpeechBtns = true;
					}
				}, 850);
				console.log('HIDE INFO');
			}
			this.testObjectVUI = "";
			setTimeout(function () {
				_this6.userVoiceToText = "";
			}, 3000);
		},
		listVUI: function listVUI() {
			var _this7 = this;

			if (RegExp(/show|display/gi).test(this.testObjectVUI)) {
				this.showVoiceCommandList = true;
				setTimeout(function () {
					document.getElementById('voiceControlListTxt').scrollIntoView({ behavior: "smooth" });
				}, 250);
				console.log('SHOW LIST');
			} else if (RegExp(/hide|minimize/gi).test(this.testObjectVUI)) {
				this.showVoiceCommandList = false;
				setTimeout(function () {
					document.getElementById('controlsContainer').scrollIntoView({ behavior: "smooth" });
				}, 250);
				console.log('HIDE LIST');
			}
			this.testObjectVUI = "";
			setTimeout(function () {
				_this7.userVoiceToText = "";
			}, 3000);
		},
		miscVUI: function miscVUI() {
			//RANDOMIZE
			if (RegExp(/new\s?scenes?|randomi?z?e?|shift\s?soundscapes?/gi).test(this.testObjectVUI)) {
				this.mattChillMethod();
				//EXPLORE
			} else if (RegExp(/\bexplorer?\b|\badventure\b/gi).test(this.testObjectVUI)) {
				if (RegExp(/stop/gi).test(this.testObjectVUI)) {
					this.stopExplore();
				} else {
					this.exploreFunc();
				}
				//STOP VOICE COMMANDS & GO HOME FUNCTIONS
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) && RegExp(/voice\s?controls?/gi).test(this.testObjectVUI) || RegExp(/stop/gi).test(this.testObjectVUI) && RegExp(/voice\s?commands?/gi).test(this.testObjectVUI)) {
				//DISABLES LISTENING IMMEDITATLY
				this.initSpeech = true;
				this.stopModuleSpeech = true;
				this.recognizing = false;
				this.recognitionNYC.stop();
				this.$store.state.isVoiceControlled = false;
			} else if (RegExp(/home/gi).test(this.testObjectVUI)) {
				this.goingHomeNotViaVoiceCommand = false;
				this.stopModuleSpeech = true;
				this.recognitionNYC.abort();
				this.recognitionNYC = undefined;
				setTimeout(this.goHome, 50);
			}
			this.testObjectVUI = "";
		},
		voiceCommandListFunc: function voiceCommandListFunc() {
			this.showVoiceCommandList = !this.showVoiceCommandList;
			if (this.showVoiceCommandList) {
				setTimeout(function () {
					document.getElementById('voiceControlListTxt').scrollIntoView({ behavior: "smooth" });
				}, 250);
			} else if (!this.showVoiceCommandList) {
				document.getElementById('controlsContainer').scrollIntoView({ behavior: "smooth" });
			}
		},

		//ENTER FUNC
		enterFunc: function enterFunc() {
			var _this8 = this;

			if (this.startAudioBoolean) {
				this.startAudio();
				this.startAudioBoolean = false;
			}

			this.showMutePrompt = false;
			this.showEnterBtn = false;

			setTimeout(function () {
				_this8.showEnterContainer = false;
			}, 1000);

			this.metroFX.start();

			var changeTiming = 50;

			setTimeout(function () {
				_this8.plungeDepth = 1;
			}, changeTiming * 1);

			setTimeout(function () {
				_this8.plungeDepth = 2;
			}, changeTiming * 2);

			setTimeout(function () {
				_this8.plungeDepth = 3;
			}, changeTiming * 3);

			setTimeout(function () {
				_this8.plungeDepth = 4;
			}, changeTiming * 4);

			setTimeout(function () {
				_this8.plungeDepth = 5;
			}, changeTiming * 5);

			setTimeout(function () {
				_this8.plungeDepth = 6;
			}, changeTiming * 6);

			setTimeout(function () {
				_this8.plungeDepth = 7;
			}, changeTiming * 7);

			setTimeout(function () {
				_this8.plungeDepth = 8;
			}, changeTiming * 8);

			setTimeout(function () {
				_this8.plungeDepth = 9;
			}, changeTiming * 8);

			setTimeout(function () {
				_this8.plungeDepth = 10;
			}, changeTiming * 10);

			setTimeout(function () {
				_this8.showAllControls = true;
			}, 1000);

			setTimeout(function () {
				_this8.showNavBar = true;
			}, 1200);

			setTimeout(function () {
				_this8.showMicRecording = true;
			}, 1000);

			setTimeout(function () {
				_this8.showSpeechBtns = true;
			}, 1100);

			setTimeout(function () {
				_this8.ambience4Boolean = true;
			}, 2523);

			setTimeout(function () {
				if (_this8.userMobile === false) {
					_this8.activeSun = true;
				}
			}, 2000);
		},

		//RANDOMIZE (MATT CHILL) PRESET
		mattChillMethod: function mattChillMethod() {
			if (this.didWeAdventure) {
				this.stopExplore();
			}

			if (this.randomizeBoolean === false) {
				this.randomizeBoolean = true;
			}

			this.mattChill = !this.mattChill;

			var ambience1Volume = Math.floor(Math.random() * 30 - 30),
			    ambience2Volume = Math.floor(Math.random() * 30 - 30),
			    ambience3Volume = Math.floor(Math.random() * 30 - 30),
			    ambience4Volume = Math.floor(Math.random() * 30 - 30),
			    ambience5Volume = Math.floor(Math.random() * 30 - 30),
			    ambience6Volume = Math.floor(Math.random() * 5 - 5);

			// let fx1boolean 		= Math.random() >= 0.5,
			// 	fx2boolean 		= Math.random() >= 0.5,
			// 	fx3boolean 		= Math.random() >= 0.5,
			// 	fx4boolean 		= Math.random() >= 0.5,
			// 	fx5boolean 		= Math.random() >= 0.5;

			var amb1boolean = Math.random() >= 0.5,
			    amb2boolean = Math.random() >= 0.5,
			    amb3boolean = Math.random() >= 0.5,
			    amb4boolean = Math.random() >= 0.5,
			    amb5boolean = Math.random() >= 0.5,
			    amb6boolean = Math.random() >= 0.5;

			this.subwayFilter.frequency.value = 20000;

			// if (this.mattChill === true){
			//DON'T CALCULATE ON MOBILE
			if (this.userMobile === false) {
				var
				// randomVerb 		= Math.floor((Math.random() * 30) + 0),
				randomDelay = Math.floor(Math.random() * 15 + 0),
				    randomChorus = Math.floor(Math.random() * 10 + 0),
				    randomFilter = Math.floor(Math.random() * 10000 + 500);

				// this.fxConvolverAmt 	= randomVerb;
				this.fxDelayAmt = randomDelay;
				this.fxChorusAmt = randomChorus;
				this.fxAutoFilterAmt = randomFilter;

				this.fxDecay = Math.random() * 4 + 1;
				var fxPreDelay = Math.random() * 0.1 + 0.03;
				this.fxConvolver.decay = this.fxDecay;
				this.fxConvolver.preDelay = fxPreDelay;
				this.fxConvolver.generate();
			}
			//CALCULATE ON MOBILE & DESKTOP
			var randomSpeed = Math.random() * (1.15 - 0.85) + 0.85;
			this.playBackSpeed = randomSpeed;

			this.ambience1Vol = ambience1Volume;
			this.ambience2Vol = ambience2Volume;
			this.ambience3Vol = ambience3Volume;
			this.ambience4Vol = ambience4Volume;
			this.ambience5Vol = ambience5Volume;
			this.ambience6Vol = ambience6Volume;

			if (amb1boolean === true) {
				this.ambience1Boolean = true;
				this.showFlask1 = true;

				this.subwayFilter.frequency.value = 1500;
			} else {
				this.ambience1Boolean = false;
				this.showFlask1 = false;
			}

			if (amb2boolean === true) {
				this.ambience2Boolean = true;
				this.showFlask2 = true;
			} else {
				this.ambience2Boolean = false;
				this.showFlask2 = false;
			}

			if (amb3boolean === true) {
				this.ambience3Boolean = true;
				this.showFlask3 = true;
			} else {
				this.ambience3Boolean = false;
				this.showFlask3 = false;
			}

			if (amb4boolean === true) {
				this.ambience4Boolean = true;
				this.showFlask4 = true;

				this.subwayFilter.frequency.value = 1500;
			} else {
				this.ambience4Boolean = false;
				this.showFlask4 = false;
			}

			if (amb5boolean === true) {
				this.ambience5Boolean = true;
				this.showFlask5 = true;

				this.ambience2Boolean = false;
				this.showFlask2 = false;

				this.ambience3Boolean = false;
				this.showFlask3 = false;

				this.ambience4Boolean = false;
				this.showFlask4 = false;

				this.streetFilter.frequency.value = 1000;
			} else {
				this.ambience5Boolean = false;
				this.showFlask5 = false;
			}

			if (amb6boolean === true) {
				this.ambience6Boolean = true;
				this.showFlask6 = true;

				this.ambience2Boolean = false;
				this.showFlask2 = false;

				this.ambience3Boolean = false;
				this.showFlask3 = false;

				this.ambience4Boolean = false;
				this.showFlask4 = false;

				this.streetFilter.frequency.value = 250;
			} else {
				this.ambience6Boolean = false;
				this.showFlask6 = false;
			}

			if (amb1boolean === false && amb2boolean === false && amb3boolean === false && amb4boolean === false && amb5boolean === false && amb6boolean === false) {
				this.ambience6Boolean = true;
				this.showFlask6 = true;
			}

			// } else if (this.mattChill === false){
			// this.fxDelayToggle = false;
			// this.fxConvolverToggle = false;
			// this.fxChorusToggle = false;
			// this.fxFilterToggle = false;
			// this.speedToggle = false;
			// } 
		},

		//EXPLORE 
		exploreBtnFunc: function exploreBtnFunc() {
			this.exploreBtnBoolean = !this.exploreBtnBoolean;
			if (this.exploreBtnBoolean) {
				this.exploreFunc();
			} else if (!this.exploreBtnBoolean) {
				this.stopExplore();
			}
		},
		exploreFunc: function exploreFunc() {
			var _this9 = this;

			//AUDIO MIXING FUNCTION
			var int = 250;
			var runExplore = function runExplore() {
				_this9.exploreSound1.start();
				_this9.speedToggle = false;
				_this9.exploreTxt = "Exploring";
				_this9.exploreTimeout1 = setTimeout(function () {

					_this9.exploreTimeout2 = setTimeout(function () {
						_this9.ambience4Boolean = true;
						_this9.ambience4Vol = -10;
					}, int * 1);

					_this9.exploreTimeout3 = setTimeout(function () {
						_this9.ambience4Vol = -4;
					}, int * 2);

					_this9.exploreTimeout4 = setTimeout(function () {
						_this9.ambience4Vol = -2;
					}, int * 3);

					_this9.exploreTimeout5 = setTimeout(function () {
						_this9.ambience4Vol = 0;
					}, int * 4);

					_this9.exploreTimeout6 = setTimeout(function () {
						_this9.ambience4Vol = 2;
					}, int * 5);

					_this9.exploreTimeout7 = setTimeout(function () {
						_this9.ambience4Vol = 3;
					}, int * 6);

					_this9.exploreTimeout8 = setTimeout(function () {
						_this9.ambience4Vol = 4;
					}, int * 7);

					_this9.exploreTimeout9 = setTimeout(function () {
						_this9.ambience4Vol = 5;
					}, int * 8);

					_this9.exploreTimeout10 = setTimeout(function () {
						_this9.ambience4Vol = 6;
					}, int * 9);

					_this9.exploreTimeout11 = setTimeout(function () {
						_this9.ambience4Vol = 7;
						// this.exploreSound1.volume.setTargetAtTime(-8, Tone.context.currentTime, +1.5);
					}, int * 10);

					_this9.exploreTimeout12 = setTimeout(function () {
						_this9.ambience4Vol = 8;
						// this.ambience3Player.start();
						// this.ambience3Boolean = true;
						// this.ambience3Vol = -6;
					}, int * 11);

					_this9.exploreTimeout13 = setTimeout(function () {
						_this9.ambience4Vol = 10;
						// this.ambience3Vol = -4;
						_this9.isExploreFuncRunning = false;
						_this9.exploreTxt = "Explore!";
					}, int * 12);
				}, 121100);
			};
			if (this.isExploreFuncRunning === false) {
				this.isExploreFuncRunning = true;
				//INIT EXPORE SCENE
				//GENERATE REVERB
				// this.fxDecay = 4.5;
				// this.fxConvolver.decay = this.fxDecay;
				// this.fxConvolver.preDelay = 0.4;
				// this.fxConvolver.generate();

				this.ambience1Boolean = false;
				this.ambience2Boolean = false;
				this.ambience3Boolean = false;
				this.ambience4Boolean = false;
				this.ambience5Boolean = false;
				this.ambience6Boolean = false;

				if (!this.didWeAdventure) {
					this.exploreSound1 = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
						"playbackRate": 1,
						"loop": false,
						"volume": -7
					}).connect(this.masterVolumeSub);

					//LOADING FOR BROWSER TYPE
					if (this.isChrome === true || this.isOpera === true || this.isFirefox === true || this.isBlink === true) {

						this.exploreSound1.load("../src/assets/sounds/modules/metro/hiogg/exporeSound1metro.ogg", function () {
							runExplore();
						});
					} else if (this.AndroidMobile === true) {
						this.exploreSound1.load("../src/assets/sounds/modules/metro/lowogg/exporeSound1metro.ogg", function () {
							runExplore();
						});
					} else if (this.isSafari === true || this.isEdge === true || this.isIE === true) {
						this.exploreSound1.load("../src/assets/sounds/modules/metro/320/exporeSound1metro.m4a", function () {
							runExplore();
						});
					} else if (this.iOS === true) {
						this.exploreSound1.load("../src/assets/sounds/modules/metro/192/exporeSound1metro.m4a", function () {
							runExplore();
						});
					}
					//CLEANS UP AND DISPOSES THESE PLAYERS WHEN GOING HOME
					this.didWeAdventure = true;
				} else if (this.didWeAdventure) {
					runExplore();
					this.exploreTxt = "Exploring!";
				}
			} else {}
		},
		stopExplore: function stopExplore() {
			this.exploreTxt = "Explore!";
			this.exploreSound1.stop();
			this.isExploreFuncRunning = false;
			clearInterval(this.exploreTimeout1);
			clearInterval(this.exploreTimeout2);
			clearInterval(this.exploreTimeout3);
			clearInterval(this.exploreTimeout4);
			clearInterval(this.exploreTimeout5);
			clearInterval(this.exploreTimeout6);
			clearInterval(this.exploreTimeout7);
			clearInterval(this.exploreTimeout8);
			clearInterval(this.exploreTimeout9);
			clearInterval(this.exploreTimeout10);
			clearInterval(this.exploreTimeout11);
			clearInterval(this.exploreTimeout12);
			clearInterval(this.exploreTimeout13);
		},

		//MASTER METERING
		masterMetering: function masterMetering() {
			this.masterLevel = this.masterMeter.getLevel();
		},

		//MAIN SHOW AND HIDE
		goToHelp: function goToHelp() {
			var _this10 = this;

			this.showHelpOverlay = !this.showHelpOverlay;
			this.helpTrigger = !this.helpTrigger;

			if (this.showHelpOverlay === true) {

				setTimeout(function () {
					_this10.showNavBar = false;
					if (_this10.$store.state.allowSpeechControl) {
						_this10.showSpeechBtns = false;
					}
				}, 100);

				setTimeout(function () {
					_this10.showAllControls = false;
				}, 250);

				setTimeout(function () {
					_this10.showAboutPage = true;
				}, 1000);
			} else if (this.showHelpOverlay === false) {

				this.showAboutPage = false;

				setTimeout(function () {
					_this10.showAllControls = true;
				}, 800);

				setTimeout(function () {
					_this10.showNavBar = true;
					if (_this10.$store.state.allowSpeechControl) {
						_this10.showSpeechBtns = true;
					}
				}, 850);
			}
		},

		//BUFFER LOADING
		bufferLoading: function bufferLoading() {
			var _this11 = this;

			// Tone.Buffer.on('progress', ()=>{
			// });
			__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Buffer.on('load', function () {
				//HIDE LOADING ITEMS
				_this11.showLoading = false;
				//SHOW ENTER BUTTON
				setTimeout(function () {
					_this11.showEnterBtn = true;
				}, 1000);
				//AUTO OPEN MODULE IF VOICE CONTROLLED & DO NOT REPLAY WHEN EXPLORE AUDIO LOADS 
				//ADDITIONALLY DO NOT REPLAY IF USER MIC HAS BEEN ACTIVATED FOR RECORDING
				if (_this11.isVoiceControl) {
					if (!_this11.didWeAdventure) {
						setTimeout(_this11.enterFunc, 2000);
					}
				}
				//IF VOICE CONTROL IS ACTIVE GLOBALLY ACTIVATE IN THIS MODULE
				if (_this11.isVoiceControl === true) {
					_this11.speechFunc();
				}
			});
		},

		//AUDIO ROUTING
		audioRouting: function audioRouting() {
			if (this.isChrome === true || this.AndroidMobile === true || this.isOpera === true || this.isFirefox === true || this.isBlink === true) {
				if (this.userMobile === false) {

					this.fxConvolver = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Reverb({
						"decay": 1.5,
						"preDelay": 0.01
					});
					this.fxConvolver.decay = 2.5;
					this.fxConvolver.generate();
					this.fxAutoFilter = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Filter({
						"type": "lowpass",
						"frequency": 20000,
						"rolloff": -24,
						"Q": 1,
						"gain": 0
					});
					this.fxDelay = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.PingPongDelay(0.45, 0.45);
					this.fxChorus = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Chorus(1.25, 5.5, 1.25);
					this.masterMeter = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Meter({
						"smoothing": .4
					});
					this.subwayFilter = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Filter({
						"type": "lowpass",
						"frequency": 20000,
						"rolloff": -24,
						"Q": 1,
						"gain": 0
					});
					this.streetFilter = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Filter({
						"type": "lowpass",
						"frequency": 20000,
						"rolloff": -24,
						"Q": 1,
						"gain": 0
					});
					this.ambience1Player.chain(this.streetFilter, this.masterVolumeSub);
					this.ambience2Player.connect(this.masterVolumeSub);
					this.ambience3Player.chain(this.subwayFilter, this.masterVolumeSub);
					this.ambience4Player.connect(this.masterVolumeSub);
					this.ambience5Player.connect(this.masterVolumeSub);
					this.ambience6Player.connect(this.masterVolumeSub);

					this.masterVolumeSub.chain(this.fxAutoFilter, this.fxConvolver, this.fxDelay, this.fxChorus, this.masterMeter, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master);
					console.log('Chrome/Opera/FireFox Desktop');
					setInterval(this.masterMetering, 60);
				} else if (this.userMobile === true) {
					this.subwayFilter = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Filter({
						"type": "lowpass",
						"frequency": 20000,
						"rolloff": -24,
						"Q": 1,
						"gain": 0
					});
					this.streetFilter = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Filter({
						"type": "lowpass",
						"frequency": 20000,
						"rolloff": -24,
						"Q": 1,
						"gain": 0
					});
					this.ambience1Player.chain(this.streetFilter, this.masterVolumeSub);
					this.ambience2Player.connect(this.masterVolumeSub);
					this.ambience3Player.connect(this.masterVolumeSub);
					this.ambience3Player.chain(this.subwayFilter, this.masterVolumeSub);
					this.ambience5Player.connect(this.masterVolumeSub);
					this.ambience6Player.connect(this.masterVolumeSub);

					this.masterVolumeSub.connect(__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master);

					console.log('Chrome/Opera/FireFox Mobile');
				}
			} else if (this.isSafari === true || this.iOS === true || this.isEdge === true || this.isIE === true) {
				if (this.userMobile === false) {
					this.fxConvolver = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Reverb({
						"decay": 1.5,
						"preDelay": 0.01
					});
					this.fxConvolver.decay = 2.5;
					this.fxConvolver.generate();
					this.fxAutoFilter = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Filter({
						"type": "lowpass",
						"frequency": 20000,
						"rolloff": -24,
						"Q": 1,
						"gain": 0
					});
					this.fxDelay = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.PingPongDelay(0.45, 0.45);
					this.fxChorus = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Chorus(1.25, 5.5, 1.25);
					this.masterMeter = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Meter({
						"smoothing": .4
					});
					this.subwayFilter = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Filter({
						"type": "lowpass",
						"frequency": 20000,
						"rolloff": -24,
						"Q": 1,
						"gain": 0
					});
					this.streetFilter = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Filter({
						"type": "lowpass",
						"frequency": 20000,
						"rolloff": -24,
						"Q": 1,
						"gain": 0
					});
					this.ambience1Player.chain(this.streetFilter, this.masterVolumeSub);
					this.ambience2Player.connect(this.masterVolumeSub);
					this.ambience3Player.chain(this.subwayFilter, this.masterVolumeSub);
					this.ambience4Player.connect(this.masterVolumeSub);
					this.ambience5Player.connect(this.masterVolumeSub);
					this.ambience6Player.connect(this.masterVolumeSub);

					this.masterVolumeSub.chain(this.fxAutoFilter, this.fxConvolver, this.fxDelay, this.fxChorus, this.masterMeter, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master);

					setInterval(this.masterMetering, 60);
					console.log('Safari/Edge/iOS Desktop');
				} else if (this.userMobile === true) {
					this.subwayFilter = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Filter({
						"type": "lowpass",
						"frequency": 20000,
						"rolloff": -24,
						"Q": 1,
						"gain": 0
					});
					this.streetFilter = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Filter({
						"type": "lowpass",
						"frequency": 20000,
						"rolloff": -24,
						"Q": 1,
						"gain": 0
					});
					this.ambience1Player.chain(this.streetFilter, this.masterVolumeSub);
					this.ambience2Player.connect(this.masterVolumeSub);
					this.ambience3Player.chain(this.subwayFilter, this.masterVolumeSub);
					this.ambience4Player.connect(this.masterVolumeSub);
					this.ambience5Player.connect(this.masterVolumeSub);
					this.ambience6Player.connect(this.masterVolumeSub);

					this.masterVolumeSub.connect(__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master);
					console.log('Safari/Edge/iOS Mobile');
				}
			} else {}
		},

		//AUDIO LOADING
		firstAudioLoadFunc: function firstAudioLoadFunc() {
			var _this12 = this;

			// this.changeFX.load("../src/assets/sounds/blinks/change.wav", 
			// 	()=>{
			// 	this.whatIsLoading = "Steel";
			// });

			// this.metroFX.load("../src/assets/sounds/modules/metro/metroFX.wav", 
			// 	()=>{
			// 	this.whatIsLoading = "Concrete";
			// });

			// this.ambience1Player.load("../src/assets/sounds/modules/metro/street.wav", 
			// 	()=>{
			// 	this.whatIsLoading = "Streets";
			// });

			// this.ambience2Player.load("../src/assets/sounds/modules/metro/walla.wav", 
			// 	()=>{
			// 	this.whatIsLoading = "Humans";
			// });

			// this.ambience3Player.load("../src/assets/sounds/modules/metro/siren.wav", 
			// 	()=>{
			// 	this.whatIsLoading = "Siren";
			// });

			// this.ambience4Player.load("../src/assets/sounds/modules/metro/subway.wav",
			//  	()=>{
			// 	this.whatIsLoading = "Subway";
			// });

			// this.ambience5Player.load("../src/assets/sounds/modules/metro/subway.wav", 
			// 	()=>{
			// 	this.whatIsLoading = "Subway";
			// });

			// this.ambience6Player.load("../src/assets/sounds/modules/metro/subway.wav", 
			// 	()=>{
			// 	this.whatIsLoading = "Subway";
			// });

			if (this.isChrome === true || this.isOpera === true || this.isFirefox === true || this.isBlink === true) {

				this.changeFX.load("../src/assets/sounds/blinks/change.ogg", function () {
					_this12.whatIsLoading = "Steel";
				});

				this.metroFX.load("../src/assets/sounds/modules/metro/hiogg/metroFX.ogg", function () {
					_this12.whatIsLoading = "Concrete";
				});

				this.ambience1Player.load("../src/assets/sounds/modules/metro/hiogg/street.ogg", function () {
					_this12.whatIsLoading = "Avenues";
				});

				this.ambience2Player.load("../src/assets/sounds/modules/metro/hiogg/walla.ogg", function () {
					_this12.whatIsLoading = "Humans";
				});

				this.ambience3Player.load("../src/assets/sounds/modules/metro/hiogg/subwaystation.ogg", function () {
					_this12.whatIsLoading = "Subway";
				});

				this.ambience4Player.load("../src/assets/sounds/modules/metro/hiogg/subwaycar.ogg", function () {
					_this12.whatIsLoading = "Subway Car";
				});

				this.ambience5Player.load("../src/assets/sounds/modules/metro/hiogg/skyscraper.ogg", function () {
					_this12.whatIsLoading = "Skyscraper";
				});

				this.ambience6Player.load("../src/assets/sounds/modules/metro/hiogg/penthouse.ogg", function () {
					_this12.whatIsLoading = "Penthouse";
				});
			} else if (this.AndroidMobile === true) {
				this.changeFX.load("../src/assets/sounds/blinks/change.ogg", function () {
					_this12.whatIsLoading = "Steel";
				});

				this.metroFX.load("../src/assets/sounds/modules/metro/lowogg/metroFX.ogg", function () {
					_this12.whatIsLoading = "Concrete";
				});

				this.ambience1Player.load("../src/assets/sounds/modules/metro/lowogg/street.ogg", function () {
					_this12.whatIsLoading = "Avenues";
				});

				this.ambience2Player.load("../src/assets/sounds/modules/metro/lowogg/walla.ogg", function () {
					_this12.whatIsLoading = "Humans";
				});

				this.ambience3Player.load("../src/assets/sounds/modules/metro/lowogg/subwaystation.ogg", function () {
					_this12.whatIsLoading = "Subway";
				});

				this.ambience4Player.load("../src/assets/sounds/modules/metro/lowogg/subwaycar.ogg", function () {
					_this12.whatIsLoading = "Subway Car";
				});

				this.ambience5Player.load("../src/assets/sounds/modules/metro/lowogg/skyscraper.ogg", function () {
					_this12.whatIsLoading = "Skyscraper";
				});

				this.ambience6Player.load("../src/assets/sounds/modules/metro/lowogg/penthouse.ogg", function () {
					_this12.whatIsLoading = "Penthouse";
				});
			} else if (this.isSafari === true || this.isEdge === true || this.isIE === true) {

				this.changeFX.load("../src/assets/sounds/blinks/change.m4a", function () {
					_this12.whatIsLoading = "Steel";
				});

				this.metroFX.load("../src/assets/sounds/modules/metro/320/metroFX.m4a", function () {
					_this12.whatIsLoading = "Concrete";
				});

				this.ambience1Player.load("../src/assets/sounds/modules/metro/320/street.m4a", function () {
					_this12.whatIsLoading = "Avenues";
				});

				this.ambience2Player.load("../src/assets/sounds/modules/metro/320/walla.m4a", function () {
					_this12.whatIsLoading = "Humans";
				});

				this.ambience3Player.load("../src/assets/sounds/modules/metro/320/subwaystation.m4a", function () {
					_this12.whatIsLoading = "Subway";
				});

				this.ambience4Player.load("../src/assets/sounds/modules/metro/320/subwaycar.m4a", function () {
					_this12.whatIsLoading = "Subway Car";
				});

				this.ambience5Player.load("../src/assets/sounds/modules/metro/320/skyscraper.m4a", function () {
					_this12.whatIsLoading = "Skyscraper";
				});

				this.ambience6Player.load("../src/assets/sounds/modules/metro/320/penthouse.m4a", function () {
					_this12.whatIsLoading = "Penthouse";
				});
			} else if (this.iOS === true) {
				this.changeFX.load("../src/assets/sounds/blinks/change.m4a", function () {
					_this12.whatIsLoading = "Steel";
				});

				this.metroFX.load("../src/assets/sounds/modules/metro/192/metroFX.m4a", function () {
					_this12.whatIsLoading = "Concrete";
				});

				this.ambience1Player.load("../src/assets/sounds/modules/metro/192/street.m4a", function () {
					_this12.whatIsLoading = "Avenues";
				});

				this.ambience2Player.load("../src/assets/sounds/modules/metro/192/walla.m4a", function () {
					_this12.whatIsLoading = "Humans";
				});

				this.ambience3Player.load("../src/assets/sounds/modules/metro/192/subwaystation.m4a", function () {
					_this12.whatIsLoading = "Subway";
				});

				this.ambience4Player.load("../src/assets/sounds/modules/metro/192/subwaycar.m4a", function () {
					_this12.whatIsLoading = "Subway Car";
				});

				this.ambience5Player.load("../src/assets/sounds/modules/metro/192/skyscraper.m4a", function () {
					_this12.whatIsLoading = "Skyscraper";
				});

				this.ambience6Player.load("../src/assets/sounds/modules/metro/192/penthouse.m4a", function () {
					_this12.whatIsLoading = "Penthouse";
				});
			}
		},

		//GO HOME
		goHome: function goHome() {
			var _this13 = this;

			this.changeFX.start();

			//IF USER ENGAGES VOICE CONTROL BUT GOES HOME VIA 
			//MOUSE BUTTON THIS TRIGGERS MODULE SPEECH DISPOSE
			if (this.goingHomeNotViaVoiceCommand && !this.initSpeech) {
				this.stopModuleSpeech = true;
				this.recognitionNYC.stop();
				this.recognitionNYC.abort();
				this.recognitionNYC = undefined;
			};

			if (this.didWeAdventure === true) {
				this.exploreSound1.disconnect();
				// this.exploreSound2.disconnect();
				// this.exploreSound3.disconnect();
			}

			setTimeout(function () {
				__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.2);
			}, 400);

			setTimeout(function () {
				_this13.ambience1Player.disconnect();
				_this13.ambience2Player.disconnect();
				_this13.ambience3Player.disconnect();
				_this13.ambience4Player.disconnect();
				_this13.ambience5Player.disconnect();
				_this13.ambience6Player.disconnect();
				_this13.metroFX.disconnect();
				_this13.changeFX.disconnect();
				_this13.masterVolumeSub.disconnect();
				if (_this13.userMobile === false) {
					_this13.fxConvolver.disconnect();
					_this13.fxAutoFilter.disconnect();
					_this13.fxDelay.disconnect();
					_this13.fxChorus.disconnect();
					_this13.masterMeter.disconnect();
				}
			}, 1000);

			setTimeout(function () {
				document.body.className = 'default';
				_this13.$router.push('/');
				__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master.volume.value = 0;
			}, 1100);
		}
	}
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_startaudiocontext_StartAudioContext_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_startaudiocontext_StartAudioContext_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_startaudiocontext_StartAudioContext_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var XRegExp = __webpack_require__(5);
/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			//RANDOMIZE BOOLEANS
			randomizeBoolean: false,
			showFlask1: true,
			showFlask2: false,
			showFlask3: false,
			showFlask4: false,
			showFlask5: false,
			showFlask6: false,
			//CONTROLS
			reverbChecker: undefined,
			loadingBoolean: true,
			userMobile: Boolean,
			mailingListBtn: false,
			textTiming: 500,
			startStopTrigger: true,
			playColor: "#F0CB50",
			stopColor: "#1E9BFC",
			//SCREEN DIMENSIONS
			screenHeight: undefined,
			screenWidth: undefined,
			ogWidth: undefined,
			//BACKGROUND COLORS
			plungeDepth: 1,
			backgroundColor1: true,
			backgroundColor2: false,
			backgroundColor3: false,
			backgroundColor4: false,
			backgroundColor5: false,
			backgroundColor6: false,
			backgroundColor7: false,
			backgroundColor8: false,
			backgroundColor9: false,
			backgroundColor10: false,
			//REACTIVE SUN
			sunReactiveColor1: true,
			sunReactiveColor2: false,
			sunReactiveColor3: false,
			sunReactiveColor4: false,
			sunReactiveColor5: false,
			sunReactiveColor6: false,
			sunReactiveColor7: false,
			sunReactiveColor8: false,
			sunReactiveColor9: false,
			sunReactiveColor10: false,
			//SHOW AND HIDE
			helpTrigger: false,
			showHelpOverlay: false,
			showAboutPage: false,

			bellBoolean: false,
			//PLAY SUN DRAGGIE
			activeSun: false,
			//V-SHOWS
			showEnterContainer: true,
			showLoading: true,
			showEnterBtn: false,
			showNavBar: false,
			showAllControls: false,
			showSpeechBtns: false,
			//AMBIENCE BOOLEANS
			ambience1Boolean: false,
			ambience2Boolean: false,
			ambience3Boolean: false,
			ambience4Boolean: false,
			ambience5Boolean: false,
			ambience6Boolean: false,
			//AMBIENCE DATA
			whatIsLoading: "Ocean",
			plungeFX: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": false,
				"volume": -8
			}).toMaster(),
			changeFX: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": false,
				"volume": -6
			}).toMaster(),
			ambience1Vol: -5,
			ambience2Vol: -20,
			ambience3Vol: -5,
			ambience4Vol: -20,
			ambience5Vol: -15,
			ambience6Vol: -15,
			ambience1Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": 0
			}),
			ambience2Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": 0
			}),
			ambience3Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": 0
			}),
			ambience4Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": 0
			}),
			ambience5Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": 0
			}),
			ambience6Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": 0
			}),
			ambience5Panner: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Panner(0),
			ambience6Panner: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Panner(0),
			//AUDIO ROUTING & EFFECTS
			playBackSpeed: 1,
			fxDecay: 2.5,
			// masterVolume:     		0,
			loadingSoundID: undefined,
			audioLoading: undefined,
			fxConvolverAmt: 0,
			fxChorusAmt: 0,
			fxDelayAmt: 0,
			fxAutoFilterAmt: 3500,
			mattChill: false,
			fxConvolver: undefined,
			fxChorus: undefined,
			fxDistort: undefined,
			fxDelay: undefined,
			fxAutoFilter: undefined,

			speedToggle: true,
			fxDelayToggle: true,
			fxConvolverToggle: true,
			fxChorusToggle: true,
			fxFilterToggle: false,

			masterMeter: undefined,
			masterLevel: 0,
			masterVolumeSub: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Volume(0),
			//SPEECH
			//FOR SPEECH FORM INPUT
			submitSpeechTxttoVoice: false,
			userVoiceToText: "",
			//IF SPEECH IS ALLOWED SHOW SPEECH ACTIVATE BUTTON (SET VIA APP.js)
			allowSpeechControl: false,
			//GLOBAL COMMAND TRIGGERING VOICE COMMANDS ON AND OFF
			isVoiceControl: false,
			//COMMAND FOR CSS CONTROL WHEN VOICE IS ACTIVE OR NOT
			recognizing: undefined,
			recognitionOcean: undefined,
			//HOLDS ALL OF SPEECHRECONGNITION JSON
			voiceCommandArray: undefined,
			speechRecognitionList: undefined,
			voiceCommandConfidence: undefined,
			//STRING LINE TO TEST FOR VOICE COMMAND ACTIONS
			testObjectVUI: "",
			//BUTTON SWITCHING & TEXT
			initSpeech: true,
			speechBtnTxt: "Say A Command",
			speechStartTopBtnTrigger: true,
			//SHOWS LIST OF COMMANDS
			showVoiceCommandList: false,
			//DISABLE WHILE RECORDING
			isDisableListening: false,
			//TRUE WHEN STOPPING ALL SPEECH FUNCTIONS TO GO HOME
			stopModuleSpeech: false,
			//IF USER ENGAGES VOICE CONTROL BUT GOES HOME VIA MOUSE BUTTON THIS TRIGGERS MODULE SPEECH DISPOSE
			//EXPLORE
			isExploreFuncRunning: false,
			didWeAdventure: false,
			exploreSound1: undefined,
			exploreBtnBoolean: false,
			//WHAT DEVICE
			isChrome: Boolean,
			isFirefox: Boolean,
			isSafari: Boolean,
			isOpera: Boolean,
			isIE: Boolean,
			isEdge: Boolean,
			isBlink: Boolean,
			iOS: Boolean,
			AndroidMobile: Boolean,
			//EXPLORE TIMES OUTS
			exploreTxt: "Explore!",
			exploreTimeout1: undefined,
			exploreTimeout2: undefined,
			exploreTimeout3: undefined,
			exploreTimeout4: undefined,
			exploreTimeout5: undefined,
			exploreTimeout6: undefined,
			exploreTimeout7: undefined,
			exploreTimeout8: undefined,
			exploreTimeout9: undefined,
			exploreTimeout10: undefined,
			exploreTimeout11: undefined,
			exploreTimeout12: undefined,
			exploreTimeout13: undefined,
			exploreTimeout14: undefined,
			//START AUDIO CONTEXT BOOLEAN
			startAudioBoolean: true,
			//LOCAL STORAGE
			isCacheSaved: false,
			firstLoad: false,
			saveTrigger: false,
			loadTrigger: false
		};
	},
	created: function created() {
		var _this = this;

		this.isVoiceControl = this.$store.state.isVoiceControlled;
		if (this.isVoiceControl) {
			this.$store.state.doNotAddress = true;
		}

		window.onpopstate = function () {
			document.body.className = 'default';
			_this.goHome();
		};
		var ua = window.navigator.userAgent;
		this.isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
		this.isFirefox = typeof InstallTrigger !== 'undefined';
		this.isSafari = /constructor/i.test(window.HTMLElement) || function (p) {
			return p.toString() === "[object SafariRemoteNotification]";
		}(!window['safari'] || safari.pushNotification);
		this.isOpera = !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
		this.isIE = /*@cc_on!@*/false || !!document.documentMode;
		this.isEdge = !this.isIE && !!window.StyleMedia;
		this.isBlink = (this.isChrome || this.isOpera) && !!window.CSS, this.iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
		this.AndroidMobile = /Android/i.test(navigator.userAgent);
		//CHROME ALLOWS SPEECH AND MEDIA RECORDING
		if (this.isChrome === true) {
			this.userMobile = false;
			//FIREFOX ONLY ALLOWS MEDIA RECORDING
		} else if (this.isFirefox === true) {
			this.userMobile = false;
			//NO SPEECH AND NO MEDIA RECORDING FOR THE FOLLOWING
		} else if (this.AndroidMobile === true || this.iOS) {
			this.userMobile = true;
		} else if (this.isSafari === true || this.isOpera === true || this.isBlink === true || this.isEdge === true || this.isIE === true) {
			this.userMobile = false;
		}
		this.firstAudioLoadFunc();
		this.bufferLoading();
		this.audioRouting();
	},

	computed: {
		//THE PLUNGE BACKGROUND CHANGE
		plungeClass: function plungeClass() {
			if (this.activeSun === false) {
				if (this.plungeDepth === 1) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = true;
				} else if (this.plungeDepth === 2) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = true;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 3) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = true;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 4) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = true;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 5) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = true;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 6) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = true;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 7) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = true;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 8) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = true;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 9) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = true;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 10) {
					this.backgroundColor10 = true;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				}
				return {
					"backgroundColorOcean10": this.backgroundColor10,
					"backgroundColorOcean9": this.backgroundColor9,
					"backgroundColorOcean8": this.backgroundColor8,
					"backgroundColorOcean7": this.backgroundColor7,
					"backgroundColorOcean6": this.backgroundColor6,
					"backgroundColorOcean5": this.backgroundColor5,
					"backgroundColorOcean4": this.backgroundColor4,
					"backgroundColorOcean3": this.backgroundColor3,
					"backgroundColorOcean2": this.backgroundColor2,
					"backgroundColorOcean1": this.backgroundColor1
				};
			} else if (this.activeSun === true) {
				if (this.masterLevel < -36) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = true;
				} else if (this.masterLevel < -32) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = true;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -28) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = true;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -24) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = true;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -20) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = true;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -18) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = true;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -16) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = true;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -14) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = true;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -10) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = true;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel > -6) {
					this.sunReactiveColor10 = true;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				}
				return {
					"sunReactiveColorClassOcean10": this.sunReactiveColor10,
					"sunReactiveColorClassOcean9": this.sunReactiveColor9,
					"sunReactiveColorClassOcean8": this.sunReactiveColor8,
					"sunReactiveColorClassOcean7": this.sunReactiveColor7,
					"sunReactiveColorClassOcean6": this.sunReactiveColor6,
					"sunReactiveColorClassOcean5": this.sunReactiveColor5,
					"sunReactiveColorClassOcean4": this.sunReactiveColor4,
					"sunReactiveColorClassOcean3": this.sunReactiveColor3,
					"sunReactiveColorClassOcean2": this.sunReactiveColor2,
					"sunReactiveColorClassOcean1": this.sunReactiveColor1
				};
			}
		},

		//SHOW AND HIDE CLASS CHANGES
		helpClass: function helpClass() {
			return {
				"btn btn-helpBtn1Ocean": this.helpTrigger,
				"btn btn-helpBtn2Ocean": !this.helpTrigger
			};
		},
		mailingListBtnClass: function mailingListBtnClass() {
			return {
				"btn btn-transparent": this.mailingListBtn,
				"btn btn-info": !this.mailingListBtn
			};
		},

		//AMBIENCE CLASS CHANGES
		ambience1Class: function ambience1Class() {
			return {
				"btn btn-playOcean": this.ambience1Boolean,
				"btn btn-stopOcean": !this.ambience1Boolean
			};
		},
		ambience2Class: function ambience2Class() {
			return {
				"btn btn-playOcean": this.ambience2Boolean,
				"btn btn-stopOcean": !this.ambience2Boolean
			};
		},
		ambience3Class: function ambience3Class() {
			return {
				"btn btn-playOcean": this.ambience3Boolean,
				"btn btn-stopOcean": !this.ambience3Boolean
			};
		},
		ambience4Class: function ambience4Class() {
			return {
				"btn btn-playOcean": this.ambience4Boolean,
				"btn btn-stopOcean": !this.ambience4Boolean
			};
		},
		ambience5Class: function ambience5Class() {
			return {
				"btn btn-playOcean": this.ambience5Boolean,
				"btn btn-stopOcean": !this.ambience5Boolean
			};
		},
		ambience6Class: function ambience6Class() {
			return {
				"btn btn-playOcean": this.ambience6Boolean,
				"btn btn-stopOcean": !this.ambience6Boolean
			};
		},
		mattChillClass: function mattChillClass() {
			return {
				"btn btn-mattChillOnOcean": this.mattChill,
				"btn btn-mattChillOffOcean": !this.mattChill
			};
		},

		//AMBIENCE ICON CSS
		ambience1Icon: function ambience1Icon() {
			return {
				"fal fa-times-circle": !this.ambience1Boolean,
				"fal fa-check-circle": this.ambience1Boolean
			};
		},
		ambience2Icon: function ambience2Icon() {
			return {
				"fal fa-times-circle": !this.ambience2Boolean,
				"fal fa-check-circle": this.ambience2Boolean
			};
		},
		ambience3Icon: function ambience3Icon() {
			return {
				"fal fa-times-circle": !this.ambience3Boolean,
				"fal fa-check-circle": this.ambience3Boolean
			};
		},
		ambience4Icon: function ambience4Icon() {
			return {
				"fal fa-times-circle": !this.ambience4Boolean,
				"fal fa-check-circle": this.ambience4Boolean
			};
		},
		ambience5Icon: function ambience5Icon() {
			return {
				"fal fa-times-circle": !this.ambience5Boolean,
				"fal fa-check-circle": this.ambience5Boolean
			};
		},
		ambience6Icon: function ambience6Icon() {
			return {
				"fal fa-times-circle": !this.ambience6Boolean,
				"fal fa-check-circle": this.ambience6Boolean
			};
		},

		//AMBIANCE CLASS CHANGES
		ambiance1RangerClass: function ambiance1RangerClass() {
			return {
				"ambianceRangerPlayOcean": this.ambience1Boolean,
				"ambianceRangerStopOcean": !this.ambience1Boolean
			};
		},
		ambiance2RangerClass: function ambiance2RangerClass() {
			return {
				"ambianceRangerPlayOcean": this.ambience2Boolean,
				"ambianceRangerStopOcean": !this.ambience2Boolean
			};
		},
		ambiance3RangerClass: function ambiance3RangerClass() {
			return {
				"ambianceRangerPlayOcean": this.ambience3Boolean,
				"ambianceRangerStopOcean": !this.ambience3Boolean
			};
		},
		ambiance4RangerClass: function ambiance4RangerClass() {
			return {
				"ambianceRangerPlayOcean": this.ambience4Boolean,
				"ambianceRangerStopOcean": !this.ambience4Boolean
			};
		},
		ambiance5RangerClass: function ambiance5RangerClass() {
			return {
				"ambianceRangerPlayOcean": this.ambience5Boolean,
				"ambianceRangerStopOcean": !this.ambience5Boolean
			};
		},
		ambiance6RangerClass: function ambiance6RangerClass() {
			return {
				"ambianceRangerPlayOcean": this.ambience6Boolean,
				"ambianceRangerStopOcean": !this.ambience6Boolean
			};
		},

		//AUDIO MIXING
		fxConvolverMix: function fxConvolverMix() {
			if (this.userMobile === false) {
				if (this.fxConvolverToggle === true) {
					this.fxConvolver.wet.setTargetAtTime(this.fxConvolverAmt / 100, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				} else if (this.fxConvolverToggle === false) {
					this.fxConvolver.wet.setTargetAtTime(0, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				}
			}
		},
		fxDelayMix: function fxDelayMix() {
			if (this.userMobile === false) {
				if (this.fxDelayToggle === true) {
					this.fxDelay.wet.setTargetAtTime(this.fxDelayAmt / 100, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +1);
				} else if (this.fxDelayToggle === false) {
					this.fxDelay.wet.setTargetAtTime(0, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +1);
				}
			}
		},
		fxChorusMix: function fxChorusMix() {
			if (this.userMobile === false) {
				if (this.fxChorusToggle === true) {
					this.fxChorus.wet.setTargetAtTime(this.fxChorusAmt / 100, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				} else if (this.fxChorusToggle === false) {
					this.fxChorus.wet.setTargetAtTime(0, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				}
			}
		},
		fxAutoFilterMix: function fxAutoFilterMix() {
			if (this.userMobile === false) {
				if (this.fxFilterToggle === true) {
					this.fxAutoFilter.frequency.setTargetAtTime(this.fxAutoFilterAmt, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				} else if (this.fxFilterToggle === false) {
					this.fxAutoFilter.frequency.setTargetAtTime(20000, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				}
			}
		},
		playbackSpeedFunc: function playbackSpeedFunc() {
			if (this.speedToggle === true) {
				this.ambience1Player.playbackRate = this.playBackSpeed;
				this.ambience2Player.playbackRate = this.playBackSpeed;
				this.ambience3Player.playbackRate = this.playBackSpeed;
				this.ambience4Player.playbackRate = this.playBackSpeed;
				this.ambience5Player.playbackRate = this.playBackSpeed;
				this.ambience6Player.playbackRate = this.playBackSpeed;
			} else if (this.speedToggle === false) {
				this.ambience1Player.playbackRate = 1;
				this.ambience2Player.playbackRate = 1;
				this.ambience3Player.playbackRate = 1;
				this.ambience4Player.playbackRate = 1;
				this.ambience5Player.playbackRate = 1;
				this.ambience6Player.playbackRate = 1;
			}
		},

		//SPEECH
		speechStartStopClass: function speechStartStopClass() {
			return {
				"recordingClassEngagedOcean": this.recognizing,
				"recordingClassDisengagedOcean": !this.recognizing
			};
		},
		speechIconClass: function speechIconClass() {
			return {
				"fa fa-microphone-alt fa-spin": this.recognizing,
				"fa fa-microphone-alt": !this.recognizing
			};
		},
		speechShowListClass: function speechShowListClass() {
			return {
				"recordingClassEngagedOcean": this.showVoiceCommandList,
				"recordingClassDisengagedOcean": !this.showVoiceCommandList
			};
		},
		speechSubmitClass: function speechSubmitClass() {
			return {
				"btn btn-speechSubmitOn mb-2": this.submitSpeechTxttoVoice,
				"btn btn-speechSubmitOff mb-2": !this.submitSpeechTxttoVoice
			};
		},

		//EXPLORE
		exploreFuncClass: function exploreFuncClass() {
			return {
				"recordingClassDisengagedOcean": !this.isExploreFuncRunning,
				"recordingClassEngagedOcean": this.isExploreFuncRunning
			};
		},
		exploreIconClass: function exploreIconClass() {
			return {
				"fab fa-wpexplorer": !this.isExploreFuncRunning,
				"fab fa-wpexplorer fa-spin": this.isExploreFuncRunning
			};
		},

		//AMBIENCE PLAY AND STOPS
		ambience1Func: function ambience1Func() {
			if (this.ambience1Boolean === true) {
				this.ambience1Player.volume.value = this.ambience1Vol;
			} else if (this.ambience1Boolean === false) {
				this.ambience1Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},
		ambience2Func: function ambience2Func() {
			if (this.ambience2Boolean === true) {
				this.ambience2Player.volume.value = this.ambience2Vol;
			} else if (this.ambience2Boolean === false) {
				this.ambience2Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},
		ambience3Func: function ambience3Func() {
			if (this.ambience3Boolean === true) {
				this.ambience3Player.volume.value = this.ambience3Vol;
			} else if (this.ambience3Boolean === false) {
				this.ambience3Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},
		ambience4Func: function ambience4Func() {
			if (this.ambience4Boolean === true) {
				this.ambience4Player.volume.value = this.ambience4Vol;
			} else if (this.ambience4Boolean === false) {
				this.ambience4Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},
		ambience5Func: function ambience5Func() {
			if (this.ambience5Boolean === true) {
				this.ambience5Player.volume.value = this.ambience5Vol;
			} else if (this.ambience5Boolean === false) {
				this.ambience5Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},
		ambience6Func: function ambience6Func() {
			if (this.ambience6Boolean === true) {
				this.ambience6Player.volume.value = this.ambience6Vol;
			} else if (this.ambience6Boolean === false) {
				this.ambience6Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},

		//LOCAL STORAGE
		saveClass: function saveClass() {
			return { "btn btn-playOcean": this.saveTrigger,
				"btn btn-stopOcean": !this.saveTrigger };
		},
		loadClass: function loadClass() {
			return { "btn btn-playOcean": this.loadTrigger,
				"btn btn-stopOcean": !this.loadTrigger };
		}
	},
	methods: {
		//LOCAL STORAGE
		setLocalStorage: function setLocalStorage() {
			var _this2 = this;

			this.saveTrigger = true;
			setTimeout(function () {
				_this2.saveTrigger = false;
			}, 250);

			this.removeLocalStorage();

			localStorage.setItem('isCacheSavedOcean', JSON.stringify(true));

			localStorage.setItem('ambience1VolOcean', JSON.stringify(this.ambience1Vol));
			localStorage.setItem('ambience2VolOcean', JSON.stringify(this.ambience2Vol));
			localStorage.setItem('ambience3VolOcean', JSON.stringify(this.ambience3Vol));
			localStorage.setItem('ambience4VolOcean', JSON.stringify(this.ambience4Vol));
			localStorage.setItem('ambience5VolOcean', JSON.stringify(this.ambience5Vol));
			localStorage.setItem('ambience6VolOcean', JSON.stringify(this.ambience6Vol));

			localStorage.setItem('ambience1BooleanOcean', JSON.stringify(this.ambience1Boolean));
			localStorage.setItem('ambience2BooleanOcean', JSON.stringify(this.ambience2Boolean));
			localStorage.setItem('ambience3BooleanOcean', JSON.stringify(this.ambience3Boolean));
			localStorage.setItem('ambience4BooleanOcean', JSON.stringify(this.ambience4Boolean));
			localStorage.setItem('ambience5BooleanOcean', JSON.stringify(this.ambience5Boolean));
			localStorage.setItem('ambience6BooleanOcean', JSON.stringify(this.ambience6Boolean));

			localStorage.setItem('speedToggleOcean', JSON.stringify(this.speedToggle));
			localStorage.setItem('fxDelayToggleOcean', JSON.stringify(this.fxDelayToggle));
			localStorage.setItem('fxConvolverToggleOcean', JSON.stringify(this.fxConvolverToggle));
			localStorage.setItem('fxChorusToggleOcean', JSON.stringify(this.fxChorusToggle));
			localStorage.setItem('fxFilterToggleOcean', JSON.stringify(this.fxFilterToggle));

			localStorage.setItem('playBackSpeed', JSON.stringify(this.playBackSpeed));
			localStorage.setItem('fxConvolverAmtOcean', JSON.stringify(this.fxConvolverAmt));
			localStorage.setItem('fxChorusAmtOcean', JSON.stringify(this.fxChorusAmt));
			localStorage.setItem('fxDelayAmtOcean', JSON.stringify(this.fxDelayAmt));
			localStorage.setItem('fxAutoFilterAmtOcean', JSON.stringify(this.fxAutoFilterAmt));
		},
		getLocalStorage: function getLocalStorage() {
			var _this3 = this;

			this.isCacheSaved = JSON.parse(localStorage.getItem('isCacheSavedOcean'));
			if (this.isCacheSaved) {
				this.loadTrigger = true;
				setTimeout(function () {
					_this3.loadTrigger = false;
				}, 250);

				this.ambience1Vol = JSON.parse(localStorage.getItem('ambience1VolOcean'));
				this.ambience2Vol = JSON.parse(localStorage.getItem('ambience2VolOcean'));
				this.ambience3Vol = JSON.parse(localStorage.getItem('ambience3VolOcean'));
				this.ambience4Vol = JSON.parse(localStorage.getItem('ambience4VolOcean'));
				this.ambience5Vol = JSON.parse(localStorage.getItem('ambience5VolOcean'));
				this.ambience6Vol = JSON.parse(localStorage.getItem('ambience6VolOcean'));

				this.ambience1Boolean = JSON.parse(localStorage.getItem('ambience1BooleanOcean'));
				this.ambience2Boolean = JSON.parse(localStorage.getItem('ambience2BooleanOcean'));
				this.ambience3Boolean = JSON.parse(localStorage.getItem('ambience3BooleanOcean'));
				this.ambience4Boolean = JSON.parse(localStorage.getItem('ambience4BooleanOcean'));
				this.ambience5Boolean = JSON.parse(localStorage.getItem('ambience5BooleanOcean'));
				this.ambience6Boolean = JSON.parse(localStorage.getItem('ambience6BooleanOcean'));

				this.speedToggle = JSON.parse(localStorage.getItem('speedToggleOcean'));
				this.fxDelayToggle = JSON.parse(localStorage.getItem('fxDelayToggleOcean'));
				this.fxConvolverToggle = JSON.parse(localStorage.getItem('fxConvolverToggleOcean'));
				this.fxChorusToggle = JSON.parse(localStorage.getItem('fxChorusToggleOcean'));
				this.fxFilterToggle = JSON.parse(localStorage.getItem('fxFilterToggleOcean'));

				this.playBackSpeed = JSON.parse(localStorage.getItem('playBackSpeed'));;
				this.fxConvolverAmt = JSON.parse(localStorage.getItem('fxConvolverAmtOcean'));
				this.fxChorusAmt = JSON.parse(localStorage.getItem('fxChorusAmtOcean'));
				this.fxDelayAmt = JSON.parse(localStorage.getItem('fxDelayAmtOcean'));
				this.fxAutoFilterAmt = JSON.parse(localStorage.getItem('fxAutoFilterAmtOcean'));
			}
		},
		removeLocalStorage: function removeLocalStorage() {
			localStorage.removeItem('isCacheSavedOcean');

			localStorage.removeItem('ambience1VolOcean');
			localStorage.removeItem('ambience2VolOcean');
			localStorage.removeItem('ambience3VolOcean');
			localStorage.removeItem('ambience4VolOcean');
			localStorage.removeItem('ambience5VolOcean');
			localStorage.removeItem('ambience6VolOcean');

			localStorage.removeItem('ambience1BooleanOcean');
			localStorage.removeItem('ambience2BooleanOcean');
			localStorage.removeItem('ambience3BooleanOcean');
			localStorage.removeItem('ambience4BooleanOcean');
			localStorage.removeItem('ambience5BooleanOcean');
			localStorage.removeItem('ambience6BooleanOcean');

			localStorage.removeItem('speedToggleOcean');
			localStorage.removeItem('fxDelayToggleOcean');
			localStorage.removeItem('fxConvolverToggleOcean');
			localStorage.removeItem('fxChorusToggleOcean');
			localStorage.removeItem('fxFilterToggleOcean');

			localStorage.removeItem('playBackSpeedOcean');
			localStorage.removeItem('fxConvolverAmtOcean');
			localStorage.removeItem('fxChorusAmtOcean');
			localStorage.removeItem('fxDelayAmtOcean');
			localStorage.removeItem('fxAutoFilterAmtOcean');
		},

		//START AUDIO
		startAudio: function startAudio() {
			if (this.firstLoad) {
				this.firstLoad = false;
				__WEBPACK_IMPORTED_MODULE_0__node_modules_startaudiocontext_StartAudioContext_js___default()(__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.context, "#enterFuncBtn");
				this.$store.state.hasAudioContextTriggered = true;
			}
			this.ambience1Player.volume.value = -100;
			this.ambience2Player.volume.value = -100;
			this.ambience3Player.volume.value = -100;
			this.ambience4Player.volume.value = -100;
			this.ambience5Player.volume.value = -100;
			this.ambience6Player.volume.value = -100;

			this.ambience1Player.start();
			this.ambience2Player.start();
			this.ambience3Player.start();
			this.ambience4Player.start();
			this.ambience5Player.start();
			this.ambience6Player.start();
		},
		stopAudio: function stopAudio() {
			this.ambience1Player.stop();
			this.ambience2Player.stop();
			this.ambience3Player.stop();
			this.ambience4Player.stop();
			this.ambience5Player.stop();
			this.ambience6Player.stop();
		},

		//SPEECH
		userVoiceToTextFunc: function userVoiceToTextFunc() {
			var _this4 = this;

			this.submitSpeechTxttoVoice = true;
			this.testObjectVUI = this.userVoiceToText;
			console.log(this.testObjectVUI);
			this.sourceSortingVUI();
			setTimeout(function () {
				_this4.submitSpeechTxttoVoice = false;
			}, 250);
		},
		speechFunc: function speechFunc() {
			var _this5 = this;

			if (this.initSpeech === true) {
				this.recognitionOcean = new webkitSpeechRecognition();
				this.recognizing;
				this.recognitionOcean.continuous = false;
				this.recognitionOcean.interimResults = true;

				this.recognitionOcean.onresult = function (event) {
					for (var i = event.resultIndex; i < event.results.length; ++i) {
						if (event.results[i].isFinal) {
							if (!_this5.isDisableListening) {
								_this5.testObjectVUI += event.results[i][0].transcript;
								console.log('Speech String Command: ' + event.results[i][0].transcript);
								_this5.sourceSortingVUI();
							}
						}
					}
				};
				this.recognitionOcean.onspeechend = function () {
					console.log('%c Ocean Module SPEECH Ended', 'background: red; color: black');
					// setTimeout(this.sourceSortingVUI, 500);
					_this5.recognizing = false;
					_this5.speechBtnTxt = "Say A Command";
					__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master.volume.setTargetAtTime(0, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.context.currentTime, +0.5);
				};
				this.recognitionOcean.onspeechstart = function () {
					console.log('%c Ocean Module SPEECH Began', 'background: green; color: white');
					_this5.recognizing = true;
					_this5.speechBtnTxt = "Listening For Command";
					__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master.volume.setTargetAtTime(-10, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.context.currentTime, +1);
				};
				this.recognitionOcean.onsoundstart = function () {
					console.log('%c Ocean Module LISTENING Began', 'background: green; color: white');
				};
				this.recognitionOcean.onaudioend = function () {
					console.log('%c Ocean Module LISTENING Ended', 'background: green; color: white');
					// setTimeout(this.sourceSortingVUI, 500);
					_this5.recognizing = false;
					_this5.speechBtnTxt = "Say A Command";
				};
				this.recognitionOcean.onend = function () {
					console.log('%c Ocean Module SPEECH SESSION ENDED', 'background: green; color: white');
					if (_this5.stopModuleSpeech === false) {
						_this5.recognitionOcean.start();
					}
				};
				this.recognizing = true;
				//MAKE SURE SPEECH IS NOT RE-ENGAGED
				this.initSpeech = false;
				//GLOBAL VOICE COMMAND IS SET TO TRUE
				this.$store.state.isVoiceControlled = true;
				this.recognitionOcean.start();
				//IF USER ENGAGES VOICE CONTROL BUT GOES HOME VIA MOUSE BUTTON THIS TRIGGERS MODULE SPEECH DISPOSE
				this.goingHomeNotViaVoiceCommand = true;
				//CONTROLS recognition.onend TO RESTART LISTENING
				this.stopModuleSpeech = false;
				//TURN LISTENING BACK ON
				this.isDisableListening = false;
				//IF BEING VOICE CONTROLLED DON'T PLAY THE NICE, TELL ME WHERE YOU WANT TO GO PROMPT ON WELCOME PAGE
				this.$store.state.doNotAddress = true;
			} else if (this.initSpeech === false) {}
		},
		resetFunc: function resetFunc() {
			this.recognizing = false;
		},
		speechStartStopFunc: function speechStartStopFunc() {
			this.speechStartTopBtnTrigger = !this.speechStartTopBtnTrigger;

			if (this.speechStartTopBtnTrigger === true) {
				this.speechFunc();
			} else if (this.speechStartTopBtnTrigger === false) {
				this.initSpeech = true;
				this.stopModuleSpeech = true;
				this.recognizing = false;
				this.recognitionOcean.stop();
				this.$store.state.isVoiceControlled = false;
			}
		},
		sourceSortingVUI: function sourceSortingVUI() {
			//FOR VISUAL REFERENCE
			this.userVoiceToText = this.testObjectVUI;

			var source1RegEx = XRegExp.build('(?x) {{source1Name}} | {{label1Name}}', {
				source1Name: XRegExp.build('{{source1Name1}} | {{source1Name2}}', {
					source1Name1: /source\sone/,
					source1Name2: /source\s1/
				}),
				label1Name: XRegExp.build('{{label1Name1}} | {{label1Name2}}', {
					label1Name1: /coral\sreef|reef/,
					label1Name2: /corals?/
				})
			}, 'xgi');

			var source2RegEx = XRegExp.build('(?x) {{source2Name}} | {{label2Name}}', {
				source2Name: XRegExp.build('{{source2Name1}} | {{source2Name2}}', {
					source2Name1: /source\stw?o?o/,
					source2Name2: /source\s2/
				}),
				label2Name: XRegExp.build('{{label2Name1}} | {{label2Name2}}', {
					label2Name1: /currents?/,
					label2Name2: /source\s1/
				})
			}, 'xgi');

			var source3RegEx = XRegExp.build('(?x) {{source3Name}} | {{label3Name}}', {
				source3Name: XRegExp.build('{{source3Name1}} | {{source3Name2}}', {
					source3Name1: /source\sthree/,
					source3Name2: /source\s3/
				}),
				label3Name: XRegExp.build('{{label3Name1}} | {{label3Name2}}', {
					label3Name1: /deep\ssea/,
					label3Name2: /pressure/
				})
			}, 'xgi');

			var source4RegEx = XRegExp.build('(?x) {{source4Name}} | {{label4Name}}', {
				source4Name: XRegExp.build('{{source4Name1}} | {{source4Name2}}', {
					source4Name1: /source\sfou?re?/,
					source4Name2: /source\s4/
				}),
				label4Name: XRegExp.build('{{label4Name1}} | {{label4Name2}}', {
					label4Name1: /plunge/,
					label4Name2: /dive/
				})
			}, 'xgi');

			var source5RegEx = XRegExp.build('(?x) {{source5Name}} | {{label5Name}}', {
				source5Name: XRegExp.build('{{source5Name1}} | {{source5Name2}}', {
					source5Name1: /source\sfive/,
					source5Name2: /source\s5/
				}),
				label5Name: XRegExp.build('{{label5Name1}} | {{label5Name2}}', {
					label5Name1: /humpbacks?/,
					label5Name2: /1|one/
				})
			}, 'xgi');

			var source6RegEx = XRegExp.build('(?x) {{source6Name}} | {{label6Name}}', {
				source6Name: XRegExp.build('{{source6Name1}} | {{source6Name2}}', {
					source6Name1: /source\ss[ei]x/,
					source6Name2: /source\s6/
				}),
				label6Name: XRegExp.build('{{label6Name1}} | {{label6Name2}}', {
					label6Name1: /whales?/,
					label6Name2: /fami?l?y?|families/
				})
			}, 'xgi');
			//ALL SOUNDS
			var allSoundRegEx = XRegExp.build('(?x) {{allSoundName}}', {
				allSoundName: XRegExp.build('{{allSoundName1}} | {{allSoundName2}}', {
					allSoundName1: /all\ssounds?/,
					allSoundName2: /all\saudios?/
				})
			}, 'xgi');
			//SPEED
			var speedRegEx = XRegExp.build('(?x) {{speedName}}', {
				speedName: XRegExp.build('{{speedName1}} | {{speedName2}}', {
					speedName1: /speeds?/,
					speedName2: /slow|faster/
				})
			}, 'xgi');
			//DELAY
			var delayRegEx = XRegExp.build('(?x) {{delayName}}', {
				delayName: XRegExp.build('{{delayName1}} | {{delayName2}}', {
					delayName1: /delay/,
					delayName2: /lay/
				})
			}, 'xgi');
			//CHORUS
			var chorusRegEx = XRegExp.build('(?x) {{chorusName}}', {
				chorusName: XRegExp.build('{{chorusName1}} | {{chorusName2}}', {
					chorusName1: /chorus?/,
					chorusName2: /course/
				})
			}, 'xgi');
			//FILTER
			var filterRegEx = XRegExp.build('(?x) {{filterName}}', {
				filterName: XRegExp.build('{{filterName1}} | {{filterName2}}', {
					filterName1: /filter/,
					filterName2: /filter/
				})
			}, 'xgi');
			//REVERB
			var reverbRegEx = XRegExp.build('(?x) {{reverbName}}', {
				reverbName: XRegExp.build('{{reverbName1}} | {{reverbName2}}', {
					reverbName1: /verb/,
					reverbName2: /reverb/
				})
			}, 'xgi');
			//SHOW
			var infoRegEx = XRegExp.build('(?x) {{showName}}', {
				showName: XRegExp.build('{{showName1}} | {{showName2}}', {
					showName1: /info/,
					showName2: /information/
				})
			}, 'xgi');
			// console.log(infoRegEx);
			//HIDE
			var listRegEx = XRegExp.build('(?x) {{hideName}}', {
				hideName: XRegExp.build('{{hideName1}} | {{hideName2}}', {
					hideName1: /lists?/,
					hideName2: /menu/
				})
			}, 'xgi');
			// console.log(listRegEx);			

			var source1Boolean = source1RegEx.test(this.testObjectVUI);
			var source2Boolean = source2RegEx.test(this.testObjectVUI);
			var source3Boolean = source3RegEx.test(this.testObjectVUI);
			var source4Boolean = source4RegEx.test(this.testObjectVUI);
			var source5Boolean = source5RegEx.test(this.testObjectVUI);
			var source6Boolean = source6RegEx.test(this.testObjectVUI);
			var allSoundBoolean = allSoundRegEx.test(this.testObjectVUI);
			var speedBoolean = speedRegEx.test(this.testObjectVUI);
			var delayBoolean = delayRegEx.test(this.testObjectVUI);
			var chorusBoolean = chorusRegEx.test(this.testObjectVUI);
			var filterBoolean = filterRegEx.test(this.testObjectVUI);
			var reverbBoolean = reverbRegEx.test(this.testObjectVUI);
			var infoBoolean = infoRegEx.test(this.testObjectVUI);
			var listBoolean = listRegEx.test(this.testObjectVUI);

			if (source1Boolean) {
				this.source1VUI();
			} else if (source2Boolean) {
				this.source2VUI();
			} else if (source3Boolean) {
				this.source3VUI();
			} else if (source4Boolean) {
				this.source4VUI();
			} else if (source5Boolean) {
				this.source5VUI();
			} else if (source6Boolean) {
				this.source6VUI();
			} else if (allSoundBoolean) {
				this.allSoundVUI();
			} else if (speedBoolean) {
				this.speedVUI();
			} else if (delayBoolean) {
				this.delayVUI();
			} else if (chorusBoolean) {
				this.chorusVUI();
			} else if (filterBoolean) {
				this.filterVUI();
			} else if (reverbBoolean) {
				this.reverbVUI();
			} else if (infoBoolean) {
				this.infoVUI();
			} else if (listBoolean) {
				this.listVUI();
			} else {
				this.miscVUI();
			}
		},
		source1VUI: function source1VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience1Player.start();
				this.ambience1Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience1Player.stop();
				this.ambience1Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience1Vol < 0) {
						this.ambience1Vol += 12;
					}
				} else {
					if (this.ambience1Vol < 0) {
						this.ambience1Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience1Vol > -30) {
						this.ambience1Vol -= 12;
					}
				} else {
					if (this.ambience1Vol > -30) {
						this.ambience1Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		source2VUI: function source2VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience2Player.start();
				this.ambience2Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience2Player.stop();
				this.ambience2Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience2Vol < 0) {
						this.ambience2Vol += 12;
					}
				} else {
					if (this.ambience2Vol < 0) {
						this.ambience2Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience2Vol > -30) {
						this.ambience2Vol -= 12;
					}
				} else {
					if (this.ambience2Vol > -30) {
						this.ambience2Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		source3VUI: function source3VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience3Player.start();
				this.ambience3Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience3Player.stop();
				this.ambience3Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience3Vol < 0) {
						this.ambience3Vol += 12;
					}
				} else {
					if (this.ambience3Vol < 0) {
						this.ambience3Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience3Vol > -30) {
						this.ambience3Vol -= 12;
					}
				} else {
					if (this.ambience3Vol > -30) {
						this.ambience3Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		source4VUI: function source4VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience4Player.start();
				this.ambience4Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience4Player.stop();
				this.ambience4Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience4Vol < 0) {
						this.ambience4Vol += 12;
					}
				} else {
					if (this.ambience4Vol < 0) {
						this.ambience4Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience4Vol > -30) {
						this.ambience4Vol -= 12;
					}
				} else {
					if (this.ambience4Vol > -30) {
						this.ambience4Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		source5VUI: function source5VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience5Player.start();
				this.ambience5Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience5Player.stop();
				this.ambience5Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience5Vol < 0) {
						this.ambience5Vol += 12;
					}
				} else {
					if (this.ambience5Vol < 0) {
						this.ambience5Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience5Vol > -30) {
						this.ambience5Vol -= 12;
					}
				} else {
					if (this.ambience5Vol > -30) {
						this.ambience5Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		source6VUI: function source6VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience6Player.start();
				this.ambience6Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience6Player.stop();
				this.ambience6Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience6Vol < 0) {
						this.ambience6Vol += 12;
					}
				} else {
					if (this.ambience6Vol < 0) {
						this.ambience6Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience6Vol > -30) {
						this.ambience6Vol -= 12;
					}
				} else {
					if (this.ambience6Vol > -30) {
						this.ambience6Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		allSoundVUI: function allSoundVUI() {
			//STOP ALL 
			if (RegExp(/stop/gi).test(this.testObjectVUI)) {
				this.ambience1Player.stop();
				this.ambience1Boolean = false;
				this.ambience2Player.stop();
				this.ambience2Boolean = false;
				this.ambience3Player.stop();
				this.ambience3Boolean = false;
				this.ambience4Player.stop();
				this.ambience4Boolean = false;
				this.ambience5Player.stop();
				this.ambience5Boolean = false;
				this.ambience6Player.stop();
				this.ambience6Boolean = false;
				if (this.didWeAdventure) {
					this.exploreSound1.stop();
					this.isExploreFuncRunning = false;
				}
			} else if (RegExp(/play/gi).test(this.testObjectVUI)) {
				this.ambience1Player.start();
				this.ambience1Boolean = true;
				this.ambience2Player.start();
				this.ambience2Boolean = true;
				this.ambience3Player.start();
				this.ambience3Boolean = true;
				this.ambience4Player.start();
				this.ambience4Boolean = true;
				this.ambience5Player.start();
				this.ambience5Boolean = true;
				this.ambience6Player.start();
				this.ambience6Boolean = true;
			}
			this.testObjectVUI = "";
		},
		speedVUI: function speedVUI() {
			if (RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI)) {
				this.speedToggle = true;
			} else if (RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI)) {
				this.speedToggle = false;
			}
			if (RegExp(/\bfaste?r?\b|up/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.playBackSpeed <= 1.6) {
						this.playBackSpeed += 0.4;
					}
				} else {
					if (this.playBackSpeed <= 1.8) {
						this.playBackSpeed += 0.2;
					}
				}
			} else if (RegExp(/slowe?r?|down/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.playBackSpeed >= 0.5) {
						this.playBackSpeed -= 0.4;
					}
				} else {
					if (this.playBackSpeed >= 0.2) {
						this.playBackSpeed -= 0.2;
					}
				}
			}
			this.testObjectVUI = "";
		},
		delayVUI: function delayVUI() {
			if (RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI)) {
				this.fxDelayToggle = true;
			} else if (RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI)) {
				this.fxDelayToggle = false;
			}
			if (RegExp(/\bmore\b|\bup\b|loude?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxDelayAmt <= 80) {
						this.fxDelayAmt += 10;
					}
				} else {
					if (this.fxDelayAmt <= 95) {
						this.fxDelayAmt += 5;
					}
				}
			} else if (RegExp(/less|\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxDelayAmt >= 20) {
						this.fxDelayAmt -= 10;
					} else if (this.fxDelayAmt >= 5) {
						this.fxDelayAmt -= 5;
					}
				} else {
					if (this.fxDelayAmt >= 5) {
						this.fxDelayAmt -= 5;
					} else if (this.fxDelayAmt >= 15) {
						this.fxDelayAmt -= 2;
					}
				}
			}
			this.testObjectVUI = "";
		},
		chorusVUI: function chorusVUI() {
			if (RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI)) {
				this.fxChorusToggle = true;
			} else if (RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI)) {
				this.fxChorusToggle = false;
			}
			if (RegExp(/\bmore\b|\bup\b|loude?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxChorusAmt <= 80) {
						this.fxChorusAmt += 10;
					}
				} else {
					if (this.fxChorusAmt <= 95) {
						this.fxChorusAmt += 5;
					}
				}
			} else if (RegExp(/less|\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxChorusAmt >= 20) {
						this.fxChorusAmt -= 10;
					} else if (this.fxChorusAmt >= 5) {
						this.fxChorusAmt -= 5;
					}
				} else {
					if (this.fxChorusAmt >= 5) {
						this.fxChorusAmt -= 5;
					} else if (this.fxChorusAmt >= 15) {
						this.fxChorusAmt -= 2;
					}
				}
			}
			this.testObjectVUI = "";
		},
		reverbVUI: function reverbVUI() {
			if (RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI)) {
				this.fxConvolverToggle = true;
			} else if (RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI)) {
				this.fxConvolverToggle = false;
			}
			if (RegExp(/\bmore\b|\bup\b|loude?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxConvolverAmt <= 45) {
						this.fxConvolverAmt += 5;
					}
				} else {
					if (this.fxConvolverAmt <= 48) {
						this.fxConvolverAmt += 2;
					}
				}
			} else if (RegExp(/less|\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxConvolverAmt >= 10) {
						this.fxConvolverAmt -= 5;
					} else if (this.fxConvolverAmt >= 2) {
						this.fxConvolverAmt -= 1;
					}
				} else {
					if (this.fxConvolverAmt >= 10) {
						this.fxConvolverAmt -= 2;
					} else if (this.fxConvolverAmt >= 2) {
						this.fxConvolverAmt -= 1;
					}
				}
			}
			this.testObjectVUI = "";
		},
		filterVUI: function filterVUI() {
			if (RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI)) {
				this.fxFilterToggle = true;
			} else if (RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI)) {
				this.fxFilterToggle = false;
			}
			if (RegExp(/\bmore\b|\blower\b/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxAutoFilterAmt > 1500) {
						this.fxAutoFilterAmt -= 1500;
					} else if (this.fxAutoFilterAmt >= 300) {
						this.fxAutoFilterAmt -= 200;
					}
				} else {
					if (this.fxAutoFilterAmt >= 500) {
						this.fxAutoFilterAmt -= 250;
					} else if (this.fxAutoFilterAmt >= 100) {
						this.fxAutoFilterAmt -= 100;
					}
				}
			} else if (RegExp(/less|higher|hire/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxAutoFilterAmt <= 10000) {
						this.fxAutoFilterAmt += 1500;
					} else if (this.fxAutoFilterAmt <= 1000) {
						this.fxAutoFilterAmt += 200;
					}
				} else {
					if (this.fxAutoFilterAmt <= 10000) {
						this.fxAutoFilterAmt += 250;
					} else if (this.fxAutoFilterAmt <= 1000) {
						this.fxAutoFilterAmt += 100;
					}
				}
			}
			this.testObjectVUI = "";
		},
		infoVUI: function infoVUI() {
			var _this6 = this;

			if (RegExp(/show|display/gi).test(this.testObjectVUI)) {
				this.showHelpOverlay = true;
				setTimeout(function () {
					_this6.showNavBar = false;
					if (_this6.$store.state.allowSpeechControl) {
						_this6.showSpeechBtns = false;
					}
				}, 0);
				setTimeout(function () {
					_this6.showAllControls = false;
				}, 500);
				setTimeout(function () {
					_this6.showAboutPage = true;
				}, 1500);
				console.log('SHOW INFO');
			} else if (RegExp(/hide|minimize/gi).test(this.testObjectVUI)) {
				this.showHelpOverlay = false;
				this.showAboutPage = false;
				setTimeout(function () {
					_this6.showAllControls = true;
				}, 800);
				setTimeout(function () {
					_this6.showNavBar = true;
					if (_this6.$store.state.allowSpeechControl) {
						_this6.showSpeechBtns = true;
					}
				}, 850);
				console.log('HIDE INFO');
			}
			this.testObjectVUI = "";
			setTimeout(function () {
				_this6.userVoiceToText = "";
			}, 3000);
		},
		listVUI: function listVUI() {
			var _this7 = this;

			if (RegExp(/show|display/gi).test(this.testObjectVUI)) {
				this.showVoiceCommandList = true;
				setTimeout(function () {
					document.getElementById('voiceControlListTxt').scrollIntoView({ behavior: "smooth" });
				}, 250);
				console.log('SHOW LIST');
			} else if (RegExp(/hide|minimize/gi).test(this.testObjectVUI)) {
				this.showVoiceCommandList = false;
				setTimeout(function () {
					document.getElementById('controlsContainer').scrollIntoView({ behavior: "smooth" });
				}, 250);
				console.log('HIDE LIST');
			}
			this.testObjectVUI = "";
			setTimeout(function () {
				_this7.userVoiceToText = "";
			}, 3000);
		},
		miscVUI: function miscVUI() {
			//RANDOMIZE
			if (RegExp(/new\s?scenes?|randomi?z?e?|shift\s?soundscapes?/gi).test(this.testObjectVUI)) {
				this.mattChillMethod();
				//EXPLORE
			} else if (RegExp(/\bexplorer?\b|\badventure\b/gi).test(this.testObjectVUI)) {
				if (RegExp(/stop/gi).test(this.testObjectVUI)) {
					this.stopExplore();
				} else {
					this.exploreFunc();
				}
				//STOP VOICE COMMANDS & GO HOME FUNCTIONS
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) && RegExp(/voice\s?controls?/gi).test(this.testObjectVUI) || RegExp(/stop/gi).test(this.testObjectVUI) && RegExp(/voice\s?commands?/gi).test(this.testObjectVUI)) {
				//DISABLES LISTENING IMMEDITATLY
				this.initSpeech = true;
				this.stopModuleSpeech = true;
				this.recognizing = false;
				this.recognitionOcean.stop();
				this.$store.state.isVoiceControlled = false;
			} else if (RegExp(/home/gi).test(this.testObjectVUI)) {
				this.goingHomeNotViaVoiceCommand = false;
				this.stopModuleSpeech = true;
				this.recognitionOcean.abort();
				this.recognitionOcean = undefined;
				setTimeout(this.goHome, 50);
			}
			this.testObjectVUI = "";
		},
		voiceCommandListFunc: function voiceCommandListFunc() {
			this.showVoiceCommandList = !this.showVoiceCommandList;
			if (this.showVoiceCommandList) {
				setTimeout(function () {
					document.getElementById('voiceControlListTxt').scrollIntoView({ behavior: "smooth" });
				}, 250);
			} else if (!this.showVoiceCommandList) {
				document.getElementById('controlsContainer').scrollIntoView({ behavior: "smooth" });
			}
		},

		//RANDOMIZE (MATT CHILL) PRESET
		mattChillMethod: function mattChillMethod() {
			if (this.didWeAdventure) {
				this.stopExplore();
			}

			if (this.randomizeBoolean === false) {
				this.randomizeBoolean = true;
			}

			this.mattChill = !this.mattChill;

			this.ambience1Vol = Math.floor(Math.random() * 30 - 30);
			this.ambience2Vol = Math.floor(Math.random() * 30 - 30);
			this.ambience3Vol = Math.floor(Math.random() * 20 - 20);
			this.ambience4Vol = Math.floor(Math.random() * 5 - 15);
			this.ambience5Vol = Math.floor(Math.random() * 30 - 30);
			this.ambience6Vol = Math.floor(Math.random() * 30 - 30);

			// let fx1boolean 		= Math.random() >= 0.5,
			// 	fx2boolean 		= Math.random() >= 0.5,
			// 	fx3boolean 		= Math.random() >= 0.5,
			// 	fx4boolean 		= Math.random() >= 0.5,
			// 	fx5boolean 		= Math.random() >= 0.5;

			var amb1boolean = Math.random() >= 0.5,
			    amb2boolean = Math.random() >= 0.5,
			    amb3boolean = Math.random() >= 0.5,
			    amb4boolean = Math.random() >= 0.4,
			    amb5boolean = Math.random() >= 0.5,
			    amb6boolean = Math.random() >= 0.5;

			// if (this.mattChill === true){
			//DON'T CALCULATE ON MOBILE
			if (this.userMobile === false) {
				var
				// randomVerb 		= Math.floor((Math.random() * 50) + 0),
				randomDelay = Math.floor(Math.random() * 20 + 0),
				    randomChorus = Math.floor(Math.random() * 20 + 0),
				    randomFilter = Math.floor(Math.random() * 3500 + 80);

				// this.fxConvolverAmt 	= randomVerb;
				this.fxDelayAmt = randomDelay;
				this.fxChorusAmt = randomChorus;
				this.fxAutoFilterAmt = randomFilter;

				this.fxDecay = Math.random() * 10 + 1.5;
				var fxPreDelay = Math.random() * 0.1 + 0.03;
				this.fxConvolver.decay = this.fxDecay;
				this.fxConvolver.preDelay = fxPreDelay;
				this.fxConvolver.generate();
			}
			//CALCULATE ON MOBILE & DESKTOP
			var randomSpeed = Math.random() * (1.15 - 0.85) + 0.85;
			this.playBackSpeed = randomSpeed;

			if (amb1boolean === true) {
				this.ambience1Boolean = true;
				this.showFlask1 = true;
				this.ambience3Vol = Math.floor(Math.random() * 10 - 10);
			} else {
				this.ambience1Boolean = false;
				this.showFlask1 = false;
			}

			if (amb2boolean === true) {
				this.ambience2Boolean = true;
				this.showFlask2 = true;
			} else {
				this.ambience2Boolean = false;
				this.showFlask2 = false;
			}

			if (amb3boolean === true) {
				this.ambience3Boolean = true;
				this.showFlask3 = true;
				this.ambience1Vol = Math.floor(Math.random() * 10 - 10);
			} else {
				this.ambience3Boolean = false;
				this.showFlask3 = false;
			}

			if (amb4boolean === true) {
				this.ambience4Boolean = true;
				this.showFlask4 = true;
			} else {
				this.ambience4Boolean = false;
				this.showFlask4 = false;
			}

			if (amb5boolean === true) {
				this.ambience5Boolean = true;
				this.showFlask5 = true;
			} else {
				this.ambience5Boolean = false;
				this.showFlask5 = false;
			}

			if (amb6boolean === true) {
				this.ambience6Boolean = true;
				this.showFlask6 = true;
			} else {
				this.ambience6Boolean = false;
				this.showFlask6 = false;
			}

			if (amb1boolean === false && amb2boolean === false && amb3boolean === false && amb4boolean === false && amb5boolean === false && amb6boolean === false) {
				this.ambience6Boolean = true;
				this.showFlask6 = true;
			}

			// } else if (this.mattChill === false){
			// this.fxDelayToggle = false;
			// this.fxConvolverToggle = false;
			// this.fxChorusToggle = false;
			// this.fxFilterToggle = false;
			// this.speedToggle = false;
			// } 
		},

		//EXPLORE 
		exploreBtnFunc: function exploreBtnFunc() {
			this.exploreBtnBoolean = !this.exploreBtnBoolean;
			if (this.exploreBtnBoolean) {
				this.exploreFunc();
			} else if (!this.exploreBtnBoolean) {
				this.stopExplore();
			}
		},
		exploreFunc: function exploreFunc() {
			var _this8 = this;

			//AUDIO MIXING FUNCTION
			var int = 25;
			var runExplore = function runExplore() {
				_this8.exploreSound1.start();
				_this8.speedToggle = false;
				_this8.exploreTxt = "Exploring";
				_this8.exploreTimeout1 = setTimeout(function () {
					_this8.ambience4Player.start();
					_this8.ambience4Boolean = true;
					_this8.ambience4Vol = -10;
				}, 13000);

				_this8.exploreTimeout14 = setTimeout(function () {
					_this8.ambience4Boolean = false;
				}, 20000);

				_this8.exploreTimeout2 = setTimeout(function () {

					_this8.exploreTimeout3 = setTimeout(function () {
						_this8.ambience5Boolean = true;
						_this8.ambience5Player.start();
						_this8.ambience5Vol = -14;
						_this8.ambience6Boolean = true;
						_this8.ambience6Player.start();
						_this8.ambience6Vol = -14;
					}, int * 1);

					_this8.exploreTimeout4 = setTimeout(function () {
						_this8.ambience5Vol = -13;
						_this8.ambience6Vol = -13;
					}, int * 2);

					_this8.exploreTimeout5 = setTimeout(function () {
						_this8.ambience5Vol = -12;
						_this8.ambience6Vol = -12;
					}, int * 3);

					_this8.exploreTimeout6 = setTimeout(function () {
						_this8.ambience5Vol = -11;
						_this8.ambience6Vol = -11;
					}, int * 4);

					_this8.exploreTimeout7 = setTimeout(function () {
						_this8.ambience5Vol = -10;
						_this8.ambience6Vol = -10;
					}, int * 5);

					_this8.exploreTimeout8 = setTimeout(function () {
						_this8.ambience5Vol = -9;
						_this8.ambience6Vol = -9;
					}, int * 6);

					_this8.exploreTimeout9 = setTimeout(function () {
						_this8.ambience5Vol = -8;
						_this8.ambience6Vol = -8;
					}, int * 7);

					_this8.exploreTimeout10 = setTimeout(function () {
						_this8.ambience5Vol = -7;
						_this8.ambience6Vol = -7;
					}, int * 8);

					_this8.exploreTimeout11 = setTimeout(function () {
						_this8.ambience5Vol = -6;
						_this8.ambience6Vol = -6;
					}, int * 9);

					_this8.exploreTimeout12 = setTimeout(function () {
						_this8.ambience5Vol = -5;
						_this8.ambience6Vol = -5;
					}, int * 10);

					_this8.exploreTimeout13 = setTimeout(function () {
						_this8.ambience5Vol = -4;
						_this8.ambience6Vol = -4;
						_this8.isExploreFuncRunning = false;
						_this8.exploreTxt = "Explore!";
					}, int * 11);
				}, 13500);
			};
			if (this.isExploreFuncRunning === false) {
				this.isExploreFuncRunning = true;
				//INIT EXPORE SCENE
				//GENERATE REVERB
				if (!this.userMobile) {
					this.fxDecay = 4.5;
					this.fxConvolver.decay = this.fxDecay;
					this.fxConvolver.preDelay = 0.4;
					this.fxConvolver.generate();
				}

				this.ambience1Boolean = false;
				this.ambience1Player.stop();
				this.ambience1Vol = -10;

				this.ambience2Boolean = false;
				this.ambience2Player.stop();
				this.ambience2Vol = -30;

				this.ambience3Boolean = false;
				this.ambience3Player.stop();
				this.ambience3Vol = -30;

				this.ambience4Boolean = false;
				this.ambience4Player.stop();
				this.ambience4Vol = -10;

				this.ambience5Boolean = false;
				this.ambience5Player.stop();
				this.ambience5Vol = -14;

				this.ambience6Boolean = false;
				this.ambience6Player.stop();
				this.ambience6Vol = -14;

				if (!this.didWeAdventure) {
					this.exploreSound1 = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
						"playbackRate": 1,
						"loop": false,
						"volume": -6
					}).toMaster();

					//LOADING FOR BROWSER TYPE
					if (this.isChrome === true || this.isOpera === true || this.isFirefox === true || this.isBlink === true) {

						this.exploreSound1.load("../src/assets/sounds/modules/ocean/hiogg/exporeSound1Ocean.ogg", function () {
							runExplore();
						});
					} else if (this.AndroidMobile === true) {
						this.exploreSound1.load("../src/assets/sounds/modules/ocean/lowogg/exporeSound1Ocean.ogg", function () {
							runExplore();
						});
					} else if (this.isSafari === true || this.isEdge === true || this.isIE === true) {
						this.exploreSound1.load("../src/assets/sounds/modules/ocean/320/exporeSound1Ocean.m4a", function () {
							runExplore();
						});
					} else if (this.iOS === true) {
						this.exploreSound1.load("../src/assets/sounds/modules/ocean/192/exporeSound1Ocean.m4a", function () {
							runExplore();
						});
					}
					//CLEANS UP AND DISPOSES THESE PLAYERS WHEN GOING HOME
					this.didWeAdventure = true;
				} else if (this.didWeAdventure) {
					runExplore();
					this.exploreTxt = "Exploring!";
				}
			} else {}
		},
		stopExplore: function stopExplore() {
			this.exploreTxt = "Explore!";
			this.exploreSound1.stop();
			this.isExploreFuncRunning = false;
			clearInterval(this.exploreTimeout1);
			clearInterval(this.exploreTimeout2);
			clearInterval(this.exploreTimeout3);
			clearInterval(this.exploreTimeout4);
			clearInterval(this.exploreTimeout5);
			clearInterval(this.exploreTimeout6);
			clearInterval(this.exploreTimeout7);
			clearInterval(this.exploreTimeout8);
			clearInterval(this.exploreTimeout9);
			clearInterval(this.exploreTimeout10);
			clearInterval(this.exploreTimeout11);
			clearInterval(this.exploreTimeout12);
			clearInterval(this.exploreTimeout13);
			clearInterval(this.exploreTimeout14);
		},

		//MASTER METERING
		masterMetering: function masterMetering() {
			this.masterLevel = this.masterMeter.getLevel();
		},

		//MAIN SHOW AND HIDE
		goToHelp: function goToHelp() {
			var _this9 = this;

			this.showHelpOverlay = !this.showHelpOverlay;
			this.helpTrigger = !this.helpTrigger;

			if (this.showHelpOverlay === true) {

				setTimeout(function () {
					_this9.showNavBar = false;
					if (_this9.$store.state.allowSpeechControl) {
						_this9.showSpeechBtns = false;
					}
				}, 100);

				setTimeout(function () {
					_this9.showAllControls = false;
				}, 250);

				setTimeout(function () {
					_this9.showAboutPage = true;
				}, 1000);
			} else if (this.showHelpOverlay === false) {

				this.showAboutPage = false;

				setTimeout(function () {
					_this9.showAllControls = true;
				}, 800);

				setTimeout(function () {
					_this9.showNavBar = true;
					if (_this9.$store.state.allowSpeechControl) {
						_this9.showSpeechBtns = true;
					}
				}, 850);
			}
		},

		//MASTER DRAGGIE LOGGING & LOADING
		ogScreenSize: function ogScreenSize() {
			this.ogWidth = window.innerWidth;
		},
		screenSizing: function screenSizing() {
			this.screenHeight = window.innerHeight;
			this.screenWidth = window.innerWidth;

			var currentWidth = window.innerWidth;

			if (currentWidth === this.ogWidth) {} else if (currentWidth != this.ogWidth) {
				this.sliderRangeSet();
				// this.mobileCheck();
				this.ogWidth = currentWidth;
			}
		},

		//ENTER FUNC
		enterFunc: function enterFunc() {
			var _this10 = this;

			if (this.startAudioBoolean) {
				this.startAudio();
				this.startAudioBoolean = false;
			}

			this.showEnterBtn = false;

			setTimeout(function () {
				_this10.showEnterContainer = false;
			}, 1000);

			this.plungeFX.start();

			var changeTiming = 50;

			setTimeout(function () {
				_this10.plungeDepth = 1;
			}, changeTiming * 1);

			setTimeout(function () {
				_this10.plungeDepth = 2;
			}, changeTiming * 2);

			setTimeout(function () {
				_this10.plungeDepth = 3;
			}, changeTiming * 3);

			setTimeout(function () {
				_this10.plungeDepth = 4;
			}, changeTiming * 4);

			setTimeout(function () {
				_this10.plungeDepth = 5;
			}, changeTiming * 5);

			setTimeout(function () {
				_this10.plungeDepth = 6;
			}, changeTiming * 6);

			setTimeout(function () {
				_this10.plungeDepth = 7;
			}, changeTiming * 7);

			setTimeout(function () {
				_this10.plungeDepth = 8;
			}, changeTiming * 8);

			setTimeout(function () {
				_this10.plungeDepth = 9;
			}, changeTiming * 8);

			setTimeout(function () {
				_this10.plungeDepth = 10;
			}, changeTiming * 10);

			setTimeout(function () {
				_this10.showAllControls = true;
			}, 1000);

			setTimeout(function () {
				_this10.showNavBar = true;
			}, 1200);

			setTimeout(function () {
				_this10.showMicRecording = true;
			}, 1000);

			setTimeout(function () {
				_this10.showSpeechBtns = true;
			}, 1100);

			setTimeout(function () {
				_this10.ambience2Boolean = true;

				_this10.ambience3Boolean = true;

				_this10.ambience5Boolean = true;
			}, 1000);

			setTimeout(function () {
				if (_this10.userMobile === false) {
					_this10.activeSun = true;
				}
			}, 1000);

			setTimeout(function () {
				_this10.ambience2Vol = -28;
				_this10.ambience3Vol = -28;
				_this10.ambience5Vol = -28;
			}, 1100);

			setTimeout(function () {
				_this10.ambience2Vol = -26;
				_this10.ambience3Vol = -26;
				_this10.ambience5Vol = -26;
			}, 1150);

			setTimeout(function () {
				_this10.ambience2Vol = -24;
				_this10.ambience3Vol = -24;
				_this10.ambience5Vol = -24;
			}, 1200);

			setTimeout(function () {
				_this10.ambience2Vol = -22;
				_this10.ambience3Vol = -22;
				_this10.ambience5Vol = -22;
			}, 1250);

			setTimeout(function () {
				_this10.ambience2Vol = -20;
				_this10.ambience3Vol = -20;
				_this10.ambience5Vol = -20;
			}, 1300);

			setTimeout(function () {
				_this10.ambience2Vol = -18;
				_this10.ambience3Vol = -18;
				_this10.ambience5Vol = -18;
			}, 1350);

			setTimeout(function () {
				_this10.ambience2Vol = -16;
				_this10.ambience3Vol = -16;
				_this10.ambience5Vol = -16;
			}, 1400);

			setTimeout(function () {
				_this10.ambience2Vol = -14;
				_this10.ambience3Vol = -14;
				_this10.ambience5Vol = -14;
			}, 1450);

			setTimeout(function () {
				_this10.ambience2Vol = -12;
				_this10.ambience3Vol = -12;
				_this10.ambience5Vol = -12;
			}, 1500);

			setTimeout(function () {
				_this10.ambience2Vol = -10;
				_this10.ambience3Vol = -10;
				_this10.ambience5Vol = -10;
			}, 1550);
		},

		//BUFFER LOADING
		bufferLoading: function bufferLoading() {
			var _this11 = this;

			// Tone.Buffer.on('progress', ()=>{
			// });
			__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Buffer.on('load', function () {
				//HIDE LOADING ITEMS
				_this11.showLoading = false;
				//SHOW ENTER BUTTON
				setTimeout(function () {
					_this11.showEnterBtn = true;
				}, 1000);
				//AUTO OPEN MODULE IF VOICE CONTROLLED & DO NOT REPLAY WHEN EXPLORE AUDIO LOADS 
				//ADDITIONALLY DO NOT REPLAY IF USER MIC HAS BEEN ACTIVATED FOR RECORDING
				if (_this11.isVoiceControl) {
					if (!_this11.didWeAdventure) {
						setTimeout(_this11.enterFunc, 2000);
					}
				}
				//IF VOICE CONTROL IS ACTIVE GLOBALLY ACTIVATE IN THIS MODULE
				if (_this11.isVoiceControl === true) {
					_this11.speechFunc();
				}
			});
		},

		//AUDIO ROUTING
		audioRouting: function audioRouting() {
			if (this.isChrome === true || this.AndroidMobile === true || this.isOpera === true || this.isFirefox === true || this.isBlink === true) {
				if (this.userMobile === false) {

					this.fxConvolver = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Reverb({
						"decay": 1.5,
						"preDelay": 0.01
					});
					this.fxConvolver.decay = 2.5;
					this.fxConvolver.generate();
					this.fxAutoFilter = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Filter({
						"type": "lowpass",
						"frequency": 20000,
						"rolloff": -24,
						"Q": 1,
						"gain": 0
					});
					this.fxDelay = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.PingPongDelay(0.8, 0.45);
					this.fxChorus = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Chorus({
						"frequency": 2,
						"delayTime": 10,
						"depth": 0.85,
						"type": "sine",
						"spread": 180
					});
					this.masterMeter = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Meter({
						"smoothing": .4
					});
					this.ambience1Player.connect(this.masterVolumeSub);
					this.ambience2Player.connect(this.masterVolumeSub);
					this.ambience3Player.connect(this.masterVolumeSub);
					this.ambience4Player.connect(this.masterVolumeSub);
					this.ambience5Player.chain(this.ambience5Panner, this.masterVolumeSub);
					this.ambience6Player.chain(this.ambience6Panner, this.masterVolumeSub);

					this.masterVolumeSub.chain(this.fxAutoFilter, this.fxConvolver, this.fxDelay, this.fxChorus, this.masterMeter, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master);
					console.log('Chrome/Opera/FireFox Desktop');
					setInterval(this.masterMetering, 60);
				} else if (this.userMobile === true) {
					this.ambience1Player.connect(this.masterVolumeSub);
					this.ambience2Player.connect(this.masterVolumeSub);
					this.ambience3Player.connect(this.masterVolumeSub);
					this.ambience4Player.connect(this.masterVolumeSub);
					this.ambience5Player.chain(this.ambience5Panner, this.masterVolumeSub);
					this.ambience6Player.chain(this.ambience6Panner, this.masterVolumeSub);

					this.masterVolumeSub.connect(__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master);

					console.log('Chrome/Opera/FireFox Mobile');
				}
			} else if (this.isSafari === true || this.iOS === true || this.isEdge === true || this.isIE === true) {
				if (this.userMobile === false) {
					this.fxConvolver = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Reverb({
						"decay": 1.5,
						"preDelay": 0.01
					});
					this.fxAutoFilter = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Filter({
						"type": "lowpass",
						"frequency": 20000,
						"rolloff": -24,
						"Q": 1,
						"gain": 0
					});
					this.fxDelay = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.PingPongDelay(0.8, 0.45);
					this.fxChorus = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Chorus({
						"frequency": 2,
						"delayTime": 10,
						"depth": 0.85,
						"type": "sine",
						"spread": 180
					});
					this.masterMeter = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Meter({
						"smoothing": .4
					});
					this.ambience1Player.connect(this.masterVolumeSub);
					this.ambience2Player.connect(this.masterVolumeSub);
					this.ambience3Player.connect(this.masterVolumeSub);
					this.ambience4Player.connect(this.masterVolumeSub);
					this.ambience5Player.chain(this.ambience5Panner, this.masterVolumeSub);
					this.ambience6Player.chain(this.ambience6Panner, this.masterVolumeSub);

					this.masterVolumeSub.chain(this.fxAutoFilter, this.fxConvolver, this.fxDelay, this.fxChorus, this.masterMeter, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master);
					console.log('Safari/Edge/iOS Desktop');
					setInterval(this.masterMetering, 60);
				} else if (this.userMobile === true) {
					this.ambience1Player.connect(this.masterVolumeSub);
					this.ambience2Player.connect(this.masterVolumeSub);
					this.ambience3Player.connect(this.masterVolumeSub);
					this.ambience4Player.connect(this.masterVolumeSub);
					this.ambience5Player.chain(this.ambience5Panner, this.masterVolumeSub);
					this.ambience6Player.chain(this.ambience6Panner, this.masterVolumeSub);

					this.masterVolumeSub.connect(__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master);
					console.log('Safari/Edge/iOS Mobile');
				}
			} else {}
		},

		//AUDIO LOADING
		firstAudioLoadFunc: function firstAudioLoadFunc() {
			var _this12 = this;

			if (this.isChrome === true || this.isOpera === true || this.isFirefox === true || this.isBlink === true) {
				this.changeFX.load("../src/assets/sounds/blinks/change.ogg", function () {
					_this12.whatIsLoading = "Rogue Wave";
				});

				this.plungeFX.load("../src/assets/sounds/modules/ocean/hiogg/plungeFX.ogg", function () {
					_this12.whatIsLoading = "Salt Water";
				});

				//CORAL REEF
				this.ambience1Player.load("../src/assets/sounds/modules/ocean/hiogg/reef.ogg", function () {
					_this12.whatIsLoading = "Coral Reef";
				});

				//CURRENT
				this.ambience2Player.load("../src/assets/sounds/modules/ocean/hiogg/deepsea.ogg", function () {
					_this12.whatIsLoading = "Currents";
				});

				//DEEP SEA
				this.ambience3Player.load("../src/assets/sounds/modules/ocean/hiogg/pressure.ogg", function () {
					_this12.whatIsLoading = "Pressure";
				});

				//PLUNGE
				this.ambience4Player.load("../src/assets/sounds/modules/ocean/hiogg/plunge.ogg", function () {
					_this12.whatIsLoading = "Plunge";
				});

				//WHALE POD 1
				this.ambience5Player.load("../src/assets/sounds/modules/ocean/hiogg/whales.ogg", function () {
					_this12.whatIsLoading = "Humpbacks";
				});

				//WHALE POD 2
				this.ambience6Player.load("../src/assets/sounds/modules/ocean/hiogg/whales2.ogg", function () {
					_this12.whatIsLoading = "Humpbacks";
				});
			} else if (this.AndroidMobile === true) {
				this.changeFX.load("../src/assets/sounds/blinks/change.ogg", function () {
					_this12.whatIsLoading = "Rogue Wave";
				});

				this.plungeFX.load("../src/assets/sounds/modules/ocean/lowogg/plungeFX.ogg", function () {
					_this12.whatIsLoading = "Salt Water";
				});

				//CORAL REEF
				this.ambience1Player.load("../src/assets/sounds/modules/ocean/lowogg/reef.ogg", function () {
					_this12.whatIsLoading = "Coral Reef";
				});

				//CURRENT
				this.ambience2Player.load("../src/assets/sounds/modules/ocean/lowogg/deepsea.ogg", function () {
					_this12.whatIsLoading = "Currents";
				});

				//DEEP SEA
				this.ambience3Player.load("../src/assets/sounds/modules/ocean/lowogg/pressure.ogg", function () {
					_this12.whatIsLoading = "Pressure";
				});

				//PLUNGE
				this.ambience4Player.load("../src/assets/sounds/modules/ocean/lowogg/plunge.ogg", function () {
					_this12.whatIsLoading = "Plunge";
				});

				//WHALE POD 1
				this.ambience5Player.load("../src/assets/sounds/modules/ocean/lowogg/whales.ogg", function () {
					_this12.whatIsLoading = "Humpbacks";
				});

				//WHALE POD 2
				this.ambience6Player.load("../src/assets/sounds/modules/ocean/lowogg/whales2.ogg", function () {
					_this12.whatIsLoading = "Humpbacks";
				});
			} else if (this.isSafari === true || this.isEdge === true || this.isIE === true) {
				this.changeFX.load("../src/assets/sounds/blinks/change.m4a", function () {
					_this12.whatIsLoading = "Rogue Wave";
				});

				this.plungeFX.load("../src/assets/sounds/modules/ocean/320/plungeFX.m4a", function () {
					_this12.whatIsLoading = "Salt Water";
				});

				//CORAL REEF
				this.ambience1Player.load("../src/assets/sounds/modules/ocean/320/reef.m4a", function () {
					_this12.whatIsLoading = "Coral Reef";
				});

				//CURRENT
				this.ambience2Player.load("../src/assets/sounds/modules/ocean/320/deepsea.m4a", function () {
					_this12.whatIsLoading = "Currents";
				});

				//DEEP SEA
				this.ambience3Player.load("../src/assets/sounds/modules/ocean/320/pressure.m4a", function () {
					_this12.whatIsLoading = "Pressure";
				});

				//PLUNGE
				this.ambience4Player.load("../src/assets/sounds/modules/ocean/320/plunge.m4a", function () {
					_this12.whatIsLoading = "Plunge";
				});

				//WHALE POD 1
				this.ambience5Player.load("../src/assets/sounds/modules/ocean/320/whales.m4a", function () {
					_this12.whatIsLoading = "Humpbacks";
				});

				//WHALE POD 2
				this.ambience6Player.load("../src/assets/sounds/modules/ocean/320/whales2.m4a", function () {
					_this12.whatIsLoading = "Humpbacks";
				});
			} else if (this.iOS === true) {
				this.changeFX.load("../src/assets/sounds/blinks/change.m4a", function () {
					_this12.whatIsLoading = "Rogue Wave";
				});

				this.plungeFX.load("../src/assets/sounds/modules/ocean/192/plungeFX.m4a", function () {
					_this12.whatIsLoading = "Salt Water";
				});

				//CORAL REEF
				this.ambience1Player.load("../src/assets/sounds/modules/ocean/192/reef.m4a", function () {
					_this12.whatIsLoading = "Coral Reef";
				});

				//CURRENT
				this.ambience2Player.load("../src/assets/sounds/modules/ocean/192/deepsea.m4a", function () {
					_this12.whatIsLoading = "Currents";
				});

				//DEEP SEA
				this.ambience3Player.load("../src/assets/sounds/modules/ocean/192/pressure.m4a", function () {
					_this12.whatIsLoading = "Pressure";
				});

				//PLUNGE
				this.ambience4Player.load("../src/assets/sounds/modules/ocean/192/plunge.m4a", function () {
					_this12.whatIsLoading = "Plunge";
				});

				//WHALE POD 1
				this.ambience5Player.load("../src/assets/sounds/modules/ocean/192/whales.m4a", function () {
					_this12.whatIsLoading = "Humpbacks";
				});

				//WHALE POD 2
				this.ambience6Player.load("../src/assets/sounds/modules/ocean/192/whales2.m4a", function () {
					_this12.whatIsLoading = "Humpbacks";
				});
			}
		},

		//GO HOME
		goHome: function goHome() {
			var _this13 = this;

			this.changeFX.start();

			//IF USER ENGAGES VOICE CONTROL BUT GOES HOME VIA 
			//MOUSE BUTTON THIS TRIGGERS MODULE SPEECH DISPOSE
			if (this.goingHomeNotViaVoiceCommand && !this.initSpeech) {
				this.stopModuleSpeech = true;
				this.recognitionOcean.stop();
				this.recognitionOcean.abort();
				this.recognitionOcean = undefined;
			};

			if (this.didWeAdventure === true) {
				this.exploreSound1.disconnect();
				// this.exploreSound2.disconnect();
				// this.exploreSound3.disconnect();
			}

			setTimeout(function () {
				__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.2);
			}, 400);

			setTimeout(function () {
				_this13.ambience1Player.disconnect();
				_this13.ambience2Player.disconnect();
				_this13.ambience3Player.disconnect();
				_this13.ambience4Player.disconnect();
				_this13.ambience5Player.disconnect();
				_this13.ambience6Player.disconnect();
				_this13.plungeFX.disconnect();
				_this13.changeFX.disconnect();
				_this13.masterVolumeSub.disconnect();
				if (_this13.userMobile === false) {
					_this13.fxConvolver.disconnect();
					_this13.fxAutoFilter.disconnect();
					_this13.fxDelay.disconnect();
					_this13.fxChorus.disconnect();
					_this13.masterMeter.disconnect();
				}
			}, 1000);

			setTimeout(function () {
				document.body.className = 'default';
				_this13.$router.push('/');
				__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master.volume.value = 0;
			}, 1100);
		}
	}
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_startaudiocontext_StartAudioContext_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_startaudiocontext_StartAudioContext_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_startaudiocontext_StartAudioContext_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var XRegExp = __webpack_require__(5);
/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			//RANDOMIZE BOOLEANS
			randomizeBoolean: false,
			showFlask1: true,
			showFlask2: false,
			showFlask3: false,
			showFlask4: false,
			showFlask5: false,
			showFlask6: false,
			//CONTROLS
			reverbChecker: undefined,
			loadingBoolean: true,
			userMobile: Boolean,
			mailingListBtn: false,
			textTiming: 500,
			//BACKGROUND COLORS
			plungeDepth: 1,
			backgroundColor1: true,
			backgroundColor2: false,
			backgroundColor3: false,
			backgroundColor4: false,
			backgroundColor5: false,
			backgroundColor6: false,
			backgroundColor7: false,
			backgroundColor8: false,
			backgroundColor9: false,
			backgroundColor10: false,
			//REACTIVE SUN
			sunReactiveColor1: true,
			sunReactiveColor2: false,
			sunReactiveColor3: false,
			sunReactiveColor4: false,
			sunReactiveColor5: false,
			sunReactiveColor6: false,
			sunReactiveColor7: false,
			sunReactiveColor8: false,
			sunReactiveColor9: false,
			sunReactiveColor10: false,
			//SHOW AND HIDE
			helpTrigger: false,
			showHelpOverlay: false,
			showAboutPage: false,

			bellBoolean: false,
			//PLAY SUN DRAGGIE
			activeSun: false,
			//V-SHOWS
			showEnterContainer: true,
			showLoading: true,
			showEnterBtn: false,
			showNavBar: false,
			showAllControls: false,
			showSpeechBtns: false,
			//AMBIENCE BOOLEANS
			ambience1Boolean: false,
			ambience2Boolean: false,
			ambience3Boolean: false,
			ambience4Boolean: false,
			ambience5Boolean: false,
			ambience6Boolean: false,
			//AMBIENCE DATA
			whatIsLoading: "Great Plains",
			plainsFX: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": false,
				"volume": 2
			}).toMaster(),
			changeFX: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": false,
				"volume": -6
			}).toMaster(),
			ambience1Vol: -20,
			ambience2Vol: -10,
			ambience3Vol: -20,
			ambience4Vol: -10,
			ambience5Vol: -20,
			ambience6Vol: -10,
			ambience1Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": 0
			}),
			ambience2Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": 0
			}),
			ambience3Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": 0
			}),
			ambience4Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": 0
			}),
			ambience5Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": 0
			}),
			ambience6Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": 0
			}),
			//AUDIO ROUTING & EFFECTS
			playBackSpeed: 1,
			fxDecay: 2.5,
			// masterVolume:     		0,
			loadingSoundID: undefined,
			audioLoading: undefined,
			fxConvolverAmt: 0,
			fxChorusAmt: 0,
			fxDelayAmt: 0,
			fxAutoFilterAmt: 3500,
			mattChill: false,
			fxConvolver: undefined,
			fxChorus: undefined,
			fxDistort: undefined,
			fxDelay: undefined,
			fxAutoFilter: undefined,

			speedToggle: true,
			fxDelayToggle: true,
			fxConvolverToggle: true,
			fxChorusToggle: true,
			fxFilterToggle: false,

			masterMeter: undefined,
			masterLevel: 0,
			masterVolumeSub: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Volume(0),
			//SPEECH
			//FOR SPEECH FORM INPUT
			submitSpeechTxttoVoice: false,
			userVoiceToText: "",
			//GLOBAL COMMAND TRIGGERING VOICE COMMANDS ON AND OFF
			isVoiceControl: false,
			//COMMAND FOR CSS CONTROL WHEN VOICE IS ACTIVE OR NOT
			recognizing: undefined,
			recognitionPlains: undefined,
			//HOLDS ALL OF SPEECHRECONGNITION JSON
			voiceCommandArray: undefined,
			speechRecognitionList: undefined,
			voiceCommandConfidence: undefined,
			//STRING LINE TO TEST FOR VOICE COMMAND ACTIONS
			testObjectVUI: "",
			//BUTTON SWITCHING & TEXT
			initSpeech: true,
			speechBtnTxt: "Say A Command",
			speechStartTopBtnTrigger: true,
			//SHOWS LIST OF COMMANDS
			showVoiceCommandList: false,
			//DISABLE WHILE RECORDING
			isDisableListening: false,
			//TRUE WHEN STOPPING ALL SPEECH FUNCTIONS TO GO HOME
			stopModuleSpeech: false,
			//IF USER ENGAGES VOICE CONTROL BUT GOES HOME VIA MOUSE BUTTON THIS TRIGGERS MODULE SPEECH DISPOSE
			//EXPLORE
			isExploreFuncRunning: false,
			didWeAdventure: false,
			exploreSound1: undefined,
			exploreBtnBoolean: false,
			//WHAT DEVICE
			isChrome: Boolean,
			isFirefox: Boolean,
			isSafari: Boolean,
			isOpera: Boolean,
			isIE: Boolean,
			isEdge: Boolean,
			isBlink: Boolean,
			iOS: Boolean,
			AndroidMobile: Boolean,
			//EXPLORE TIMES OUTS
			exploreTxt: "Explore!",
			exploreTimeout1: undefined,
			exploreTimeout2: undefined,
			exploreTimeout3: undefined,
			exploreTimeout4: undefined,
			exploreTimeout5: undefined,
			exploreTimeout6: undefined,
			exploreTimeout7: undefined,
			exploreTimeout8: undefined,
			exploreTimeout9: undefined,
			exploreTimeout10: undefined,
			exploreTimeout11: undefined,
			exploreTimeout12: undefined,
			exploreTimeout13: undefined,
			exploreTimeout14: undefined,
			exploreTimeout15: undefined,
			exploreTimeout16: undefined,
			exploreTimeout17: undefined,
			exploreTimeout18: undefined,
			exploreTimeout19: undefined,
			exploreTimeout20: undefined,
			exploreTimeout21: undefined,
			//START AUDIO CONTEXT BOOLEAN
			startAudioBoolean: true,
			//LOCAL STORAGE
			isCacheSaved: false,
			firstLoad: false,
			saveTrigger: false,
			loadTrigger: false
		};
	},
	created: function created() {
		var _this = this;

		this.isVoiceControl = this.$store.state.isVoiceControlled;
		if (this.isVoiceControl) {
			this.$store.state.doNotAddress = true;
		}

		window.onpopstate = function () {
			document.body.className = 'default';
			_this.goHome();
		};
		var ua = window.navigator.userAgent;
		this.isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
		this.isFirefox = typeof InstallTrigger !== 'undefined';
		this.isSafari = /constructor/i.test(window.HTMLElement) || function (p) {
			return p.toString() === "[object SafariRemoteNotification]";
		}(!window['safari'] || safari.pushNotification);
		this.isOpera = !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
		this.isIE = /*@cc_on!@*/false || !!document.documentMode;
		this.isEdge = !this.isIE && !!window.StyleMedia;
		this.isBlink = (this.isChrome || this.isOpera) && !!window.CSS, this.iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
		this.AndroidMobile = /Android/i.test(navigator.userAgent);
		//CHROME ALLOWS SPEECH AND MEDIA RECORDING
		if (this.isChrome === true) {
			this.userMobile = false;
			//FIREFOX ONLY ALLOWS MEDIA RECORDING
		} else if (this.isFirefox === true) {
			this.userMobile = false;
			//NO SPEECH AND NO MEDIA RECORDING FOR THE FOLLOWING
		} else if (this.AndroidMobile === true || this.iOS) {
			this.userMobile = true;
		} else if (this.isSafari === true || this.isOpera === true || this.isBlink === true || this.isEdge === true || this.isIE === true) {
			this.userMobile = false;
		}
		this.firstAudioLoadFunc();
		this.bufferLoading();
		this.audioRouting();
	},

	computed: {
		//THE PLUNGE BACKGROUND CHANGE
		plungeClass: function plungeClass() {
			if (this.activeSun === false) {
				if (this.plungeDepth === 1) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = true;
				} else if (this.plungeDepth === 2) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = true;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 3) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = true;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 4) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = true;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 5) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = true;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 6) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = true;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 7) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = true;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 8) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = true;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 9) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = true;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 10) {
					this.backgroundColor10 = true;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				}
				return {
					"backgroundColorPlains10": this.backgroundColor10,
					"backgroundColorPlains9": this.backgroundColor9,
					"backgroundColorPlains8": this.backgroundColor8,
					"backgroundColorPlains7": this.backgroundColor7,
					"backgroundColorPlains6": this.backgroundColor6,
					"backgroundColorPlains5": this.backgroundColor5,
					"backgroundColorPlains4": this.backgroundColor4,
					"backgroundColorPlains3": this.backgroundColor3,
					"backgroundColorPlains2": this.backgroundColor2,
					"backgroundColorPlains1": this.backgroundColor1
				};
			} else if (this.activeSun === true) {
				if (this.masterLevel < -42) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = true;
				} else if (this.masterLevel < -38) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = true;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -34) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = true;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -30) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = true;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -26) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = true;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -24) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = true;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -20) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = true;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -16) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = true;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -12) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = true;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel > -8) {
					this.sunReactiveColor10 = true;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				}
				return {
					"sunReactiveColorClassPlains10": this.sunReactiveColor10,
					"sunReactiveColorClassPlains9": this.sunReactiveColor9,
					"sunReactiveColorClassPlains8": this.sunReactiveColor8,
					"sunReactiveColorClassPlains7": this.sunReactiveColor7,
					"sunReactiveColorClassPlains6": this.sunReactiveColor6,
					"sunReactiveColorClassPlains5": this.sunReactiveColor5,
					"sunReactiveColorClassPlains4": this.sunReactiveColor4,
					"sunReactiveColorClassPlains3": this.sunReactiveColor3,
					"sunReactiveColorClassPlains2": this.sunReactiveColor2,
					"sunReactiveColorClassPlains1": this.sunReactiveColor1
				};
			}
		},

		//SHOW AND HIDE CLASS CHANGES
		helpClass: function helpClass() {
			return {
				"btn btn-helpBtn1Plains": this.helpTrigger,
				"btn btn-helpBtn2Plains": !this.helpTrigger
			};
		},
		mailingListBtnClass: function mailingListBtnClass() {
			return {
				"btn btn-transparent": this.mailingListBtn,
				"btn btn-info": !this.mailingListBtn
			};
		},

		//AMBIENCE CLASS CHANGES
		ambience1Class: function ambience1Class() {
			return {
				"btn btn-playPlains": this.ambience1Boolean,
				"btn btn-stopPlains": !this.ambience1Boolean
			};
		},
		ambience2Class: function ambience2Class() {
			return {
				"btn btn-playPlains": this.ambience2Boolean,
				"btn btn-stopPlains": !this.ambience2Boolean
			};
		},
		ambience3Class: function ambience3Class() {
			return {
				"btn btn-playPlains": this.ambience3Boolean,
				"btn btn-stopPlains": !this.ambience3Boolean
			};
		},
		ambience4Class: function ambience4Class() {
			return {
				"btn btn-playPlains": this.ambience4Boolean,
				"btn btn-stopPlains": !this.ambience4Boolean
			};
		},
		ambience5Class: function ambience5Class() {
			return {
				"btn btn-playPlains": this.ambience5Boolean,
				"btn btn-stopPlains": !this.ambience5Boolean
			};
		},
		ambience6Class: function ambience6Class() {
			return {
				"btn btn-playPlains": this.ambience6Boolean,
				"btn btn-stopPlains": !this.ambience6Boolean
			};
		},
		mattChillClass: function mattChillClass() {
			return {
				"btn btn-mattChillOn": this.mattChill,
				"btn btn-mattChillOff": !this.mattChill
			};
		},

		//AMBIENCE ICON CSS
		ambience1Icon: function ambience1Icon() {
			return {
				"fal fa-times-circle": !this.ambience1Boolean,
				"fal fa-check-circle": this.ambience1Boolean
			};
		},
		ambience2Icon: function ambience2Icon() {
			return {
				"fal fa-times-circle": !this.ambience2Boolean,
				"fal fa-check-circle": this.ambience2Boolean
			};
		},
		ambience3Icon: function ambience3Icon() {
			return {
				"fal fa-times-circle": !this.ambience3Boolean,
				"fal fa-check-circle": this.ambience3Boolean
			};
		},
		ambience4Icon: function ambience4Icon() {
			return {
				"fal fa-times-circle": !this.ambience4Boolean,
				"fal fa-check-circle": this.ambience4Boolean
			};
		},
		ambience5Icon: function ambience5Icon() {
			return {
				"fal fa-times-circle": !this.ambience5Boolean,
				"fal fa-check-circle": this.ambience5Boolean
			};
		},
		ambience6Icon: function ambience6Icon() {
			return {
				"fal fa-times-circle": !this.ambience6Boolean,
				"fal fa-check-circle": this.ambience6Boolean
			};
		},

		//AMBIANCE CLASS CHANGES
		ambiance1RangerClass: function ambiance1RangerClass() {
			return {
				"ambianceRangerPlayPlains": this.ambience1Boolean,
				"ambianceRangerStopPlains": !this.ambience1Boolean
			};
		},
		ambiance2RangerClass: function ambiance2RangerClass() {
			return {
				"ambianceRangerPlayPlains": this.ambience2Boolean,
				"ambianceRangerStopPlains": !this.ambience2Boolean
			};
		},
		ambiance3RangerClass: function ambiance3RangerClass() {
			return {
				"ambianceRangerPlayPlains": this.ambience3Boolean,
				"ambianceRangerStopPlains": !this.ambience3Boolean
			};
		},
		ambiance4RangerClass: function ambiance4RangerClass() {
			return {
				"ambianceRangerPlayPlains": this.ambience4Boolean,
				"ambianceRangerStopPlains": !this.ambience4Boolean
			};
		},
		ambiance5RangerClass: function ambiance5RangerClass() {
			return {
				"ambianceRangerPlayPlains": this.ambience5Boolean,
				"ambianceRangerStopPlains": !this.ambience5Boolean
			};
		},
		ambiance6RangerClass: function ambiance6RangerClass() {
			return {
				"ambianceRangerPlayPlains": this.ambience6Boolean,
				"ambianceRangerStopPlains": !this.ambience6Boolean
			};
		},

		//AUDIO MIXING
		adjustInputVolume: function adjustInputVolume() {
			this.userMic.volume.value = this.userMicInputLevel;
		},
		fxConvolverMix: function fxConvolverMix() {
			if (this.userMobile === false) {
				if (this.fxConvolverToggle === true) {
					this.fxConvolver.wet.setTargetAtTime(this.fxConvolverAmt / 100, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				} else if (this.fxConvolverToggle === false) {
					this.fxConvolver.wet.setTargetAtTime(0, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				}
			}
		},
		fxDelayMix: function fxDelayMix() {
			if (this.userMobile === false) {
				if (this.fxDelayToggle === true) {
					this.fxDelay.wet.setTargetAtTime(this.fxDelayAmt / 100, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +1);
				} else if (this.fxDelayToggle === false) {
					this.fxDelay.wet.setTargetAtTime(0, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +1);
				}
			}
		},
		fxChorusMix: function fxChorusMix() {
			if (this.userMobile === false) {
				if (this.fxChorusToggle === true) {
					this.fxChorus.wet.setTargetAtTime(this.fxChorusAmt / 100, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				} else if (this.fxChorusToggle === false) {
					this.fxChorus.wet.setTargetAtTime(0, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				}
			}
		},
		fxAutoFilterMix: function fxAutoFilterMix() {
			if (this.userMobile === false) {
				if (this.fxFilterToggle === true) {
					this.fxAutoFilter.frequency.setTargetAtTime(this.fxAutoFilterAmt, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				} else if (this.fxFilterToggle === false) {
					this.fxAutoFilter.frequency.setTargetAtTime(20000, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				}
			}
		},
		playbackSpeedFunc: function playbackSpeedFunc() {
			if (this.speedToggle === true) {
				this.ambience1Player.playbackRate = this.playBackSpeed;
				this.ambience2Player.playbackRate = this.playBackSpeed;
				this.ambience3Player.playbackRate = this.playBackSpeed;
				this.ambience4Player.playbackRate = this.playBackSpeed;
				this.ambience5Player.playbackRate = this.playBackSpeed;
				this.ambience6Player.playbackRate = this.playBackSpeed;
			} else if (this.speedToggle === false) {
				this.ambience1Player.playbackRate = 1;
				this.ambience2Player.playbackRate = 1;
				this.ambience3Player.playbackRate = 1;
				this.ambience4Player.playbackRate = 1;
				this.ambience5Player.playbackRate = 1;
				this.ambience6Player.playbackRate = 1;
			}
		},

		//SPEECH
		speechStartStopClass: function speechStartStopClass() {
			return {
				"recordingClassEngagedPlains": this.recognizing,
				"recordingClassDisengagedPlains": !this.recognizing
			};
		},
		speechIconClass: function speechIconClass() {
			return {
				"fa fa-microphone-alt fa-spin": this.recognizing,
				"fa fa-microphone-alt": !this.recognizing
			};
		},
		speechShowListClass: function speechShowListClass() {
			return {
				"recordingClassEngagedPlains": this.showVoiceCommandList,
				"recordingClassDisengagedPlains": !this.showVoiceCommandList
			};
		},
		speechSubmitClass: function speechSubmitClass() {
			return {
				"btn btn-speechSubmitOn mb-2": this.submitSpeechTxttoVoice,
				"btn btn-speechSubmitOff mb-2": !this.submitSpeechTxttoVoice
			};
		},

		//EXPLORE
		exploreFuncClass: function exploreFuncClass() {
			return {
				"recordingClassDisengagedPlains": !this.isExploreFuncRunning,
				"recordingClassEngagedPlains": this.isExploreFuncRunning
			};
		},
		exploreIconClass: function exploreIconClass() {
			return {
				"fab fa-wpexplorer": !this.isExploreFuncRunning,
				"fab fa-wpexplorer fa-spin": this.isExploreFuncRunning
			};
		},

		//AMBIENCE PLAY AND STOPS
		ambience1Func: function ambience1Func() {
			if (this.ambience1Boolean === true) {
				this.ambience1Player.volume.value = this.ambience1Vol;
			} else if (this.ambience1Boolean === false) {
				this.ambience1Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},
		ambience2Func: function ambience2Func() {
			if (this.ambience2Boolean === true) {
				this.ambience2Player.volume.value = this.ambience2Vol;
			} else if (this.ambience2Boolean === false) {
				this.ambience2Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},
		ambience3Func: function ambience3Func() {
			if (this.ambience3Boolean === true) {
				this.ambience3Player.volume.value = this.ambience3Vol;
			} else if (this.ambience3Boolean === false) {
				this.ambience3Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},
		ambience4Func: function ambience4Func() {
			if (this.ambience4Boolean === true) {
				this.ambience4Player.volume.value = this.ambience4Vol;
			} else if (this.ambience4Boolean === false) {
				this.ambience4Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},
		ambience5Func: function ambience5Func() {
			if (this.ambience5Boolean === true) {
				this.ambience5Player.volume.value = this.ambience5Vol;
			} else if (this.ambience5Boolean === false) {
				this.ambience5Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},
		ambience6Func: function ambience6Func() {
			if (this.ambience6Boolean === true) {
				this.ambience6Player.volume.value = this.ambience6Vol;
			} else if (this.ambience6Boolean === false) {
				this.ambience6Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},

		//LOCAL STORAGE
		saveClass: function saveClass() {
			return { "btn btn-playPlains": this.saveTrigger,
				"btn btn-stopPlains": !this.saveTrigger };
		},
		loadClass: function loadClass() {
			return { "btn btn-playPlains": this.loadTrigger,
				"btn btn-stopPlains": !this.loadTrigger };
		}
	},
	methods: {
		//LOCAL STORAGE
		setLocalStorage: function setLocalStorage() {
			var _this2 = this;

			this.saveTrigger = true;
			setTimeout(function () {
				_this2.saveTrigger = false;
			}, 250);

			this.removeLocalStorage();

			localStorage.setItem('isCacheSavedPlains', JSON.stringify(true));

			localStorage.setItem('ambience1VolPlains', JSON.stringify(this.ambience1Vol));
			localStorage.setItem('ambience2VolPlains', JSON.stringify(this.ambience2Vol));
			localStorage.setItem('ambience3VolPlains', JSON.stringify(this.ambience3Vol));
			localStorage.setItem('ambience4VolPlains', JSON.stringify(this.ambience4Vol));
			localStorage.setItem('ambience5VolPlains', JSON.stringify(this.ambience5Vol));
			localStorage.setItem('ambience6VolPlains', JSON.stringify(this.ambience6Vol));

			localStorage.setItem('ambience1BooleanPlains', JSON.stringify(this.ambience1Boolean));
			localStorage.setItem('ambience2BooleanPlains', JSON.stringify(this.ambience2Boolean));
			localStorage.setItem('ambience3BooleanPlains', JSON.stringify(this.ambience3Boolean));
			localStorage.setItem('ambience4BooleanPlains', JSON.stringify(this.ambience4Boolean));
			localStorage.setItem('ambience5BooleanPlains', JSON.stringify(this.ambience5Boolean));
			localStorage.setItem('ambience6BooleanPlains', JSON.stringify(this.ambience6Boolean));

			localStorage.setItem('speedTogglePlains', JSON.stringify(this.speedToggle));
			localStorage.setItem('fxDelayTogglePlains', JSON.stringify(this.fxDelayToggle));
			localStorage.setItem('fxConvolverTogglePlains', JSON.stringify(this.fxConvolverToggle));
			localStorage.setItem('fxChorusTogglePlains', JSON.stringify(this.fxChorusToggle));
			localStorage.setItem('fxFilterTogglePlains', JSON.stringify(this.fxFilterToggle));

			localStorage.setItem('playBackSpeed', JSON.stringify(this.playBackSpeed));
			localStorage.setItem('fxConvolverAmtPlains', JSON.stringify(this.fxConvolverAmt));
			localStorage.setItem('fxChorusAmtPlains', JSON.stringify(this.fxChorusAmt));
			localStorage.setItem('fxDelayAmtPlains', JSON.stringify(this.fxDelayAmt));
			localStorage.setItem('fxAutoFilterAmtPlains', JSON.stringify(this.fxAutoFilterAmt));
		},
		getLocalStorage: function getLocalStorage() {
			var _this3 = this;

			this.isCacheSaved = JSON.parse(localStorage.getItem('isCacheSavedPlains'));
			if (this.isCacheSaved) {
				this.loadTrigger = true;
				setTimeout(function () {
					_this3.loadTrigger = false;
				}, 250);

				this.ambience1Vol = JSON.parse(localStorage.getItem('ambience1VolPlains'));
				this.ambience2Vol = JSON.parse(localStorage.getItem('ambience2VolPlains'));
				this.ambience3Vol = JSON.parse(localStorage.getItem('ambience3VolPlains'));
				this.ambience4Vol = JSON.parse(localStorage.getItem('ambience4VolPlains'));
				this.ambience5Vol = JSON.parse(localStorage.getItem('ambience5VolPlains'));
				this.ambience6Vol = JSON.parse(localStorage.getItem('ambience6VolPlains'));

				this.ambience1Boolean = JSON.parse(localStorage.getItem('ambience1BooleanPlains'));
				this.ambience2Boolean = JSON.parse(localStorage.getItem('ambience2BooleanPlains'));
				this.ambience3Boolean = JSON.parse(localStorage.getItem('ambience3BooleanPlains'));
				this.ambience4Boolean = JSON.parse(localStorage.getItem('ambience4BooleanPlains'));
				this.ambience5Boolean = JSON.parse(localStorage.getItem('ambience5BooleanPlains'));
				this.ambience6Boolean = JSON.parse(localStorage.getItem('ambience6BooleanPlains'));

				this.speedToggle = JSON.parse(localStorage.getItem('speedTogglePlains'));
				this.fxDelayToggle = JSON.parse(localStorage.getItem('fxDelayTogglePlains'));
				this.fxConvolverToggle = JSON.parse(localStorage.getItem('fxConvolverTogglePlains'));
				this.fxChorusToggle = JSON.parse(localStorage.getItem('fxChorusTogglePlains'));
				this.fxFilterToggle = JSON.parse(localStorage.getItem('fxFilterTogglePlains'));

				this.playBackSpeed = JSON.parse(localStorage.getItem('playBackSpeed'));;
				this.fxConvolverAmt = JSON.parse(localStorage.getItem('fxConvolverAmtPlains'));
				this.fxChorusAmt = JSON.parse(localStorage.getItem('fxChorusAmtPlains'));
				this.fxDelayAmt = JSON.parse(localStorage.getItem('fxDelayAmtPlains'));
				this.fxAutoFilterAmt = JSON.parse(localStorage.getItem('fxAutoFilterAmtPlains'));
			}
		},
		removeLocalStorage: function removeLocalStorage() {
			localStorage.removeItem('isCacheSavedPlains');

			localStorage.removeItem('ambience1VolPlains');
			localStorage.removeItem('ambience2VolPlains');
			localStorage.removeItem('ambience3VolPlains');
			localStorage.removeItem('ambience4VolPlains');
			localStorage.removeItem('ambience5VolPlains');
			localStorage.removeItem('ambience6VolPlains');

			localStorage.removeItem('ambience1BooleanPlains');
			localStorage.removeItem('ambience2BooleanPlains');
			localStorage.removeItem('ambience3BooleanPlains');
			localStorage.removeItem('ambience4BooleanPlains');
			localStorage.removeItem('ambience5BooleanPlains');
			localStorage.removeItem('ambience6BooleanPlains');

			localStorage.removeItem('speedTogglePlains');
			localStorage.removeItem('fxDelayTogglePlains');
			localStorage.removeItem('fxConvolverTogglePlains');
			localStorage.removeItem('fxChorusTogglePlains');
			localStorage.removeItem('fxFilterTogglePlains');

			localStorage.removeItem('playBackSpeedPlains');
			localStorage.removeItem('fxConvolverAmtPlains');
			localStorage.removeItem('fxChorusAmtPlains');
			localStorage.removeItem('fxDelayAmtPlains');
			localStorage.removeItem('fxAutoFilterAmtPlains');
		},

		//START AUDIO
		startAudio: function startAudio() {
			if (this.firstLoad) {
				this.firstLoad = false;
				__WEBPACK_IMPORTED_MODULE_0__node_modules_startaudiocontext_StartAudioContext_js___default()(__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.context, "#enterFuncBtn");
				this.$store.state.hasAudioContextTriggered = true;
			};

			this.ambience1Player.volume.value = -100;
			this.ambience2Player.volume.value = -100;
			this.ambience3Player.volume.value = -100;
			this.ambience4Player.volume.value = -100;
			this.ambience5Player.volume.value = -100;
			this.ambience6Player.volume.value = -100;

			this.ambience1Player.start();
			this.ambience2Player.start();
			this.ambience3Player.start();
			this.ambience4Player.start();
			this.ambience5Player.start();
			this.ambience6Player.start();
		},
		stopAudio: function stopAudio() {
			this.ambience1Player.stop();
			this.ambience2Player.stop();
			this.ambience3Player.stop();
			this.ambience4Player.stop();
			this.ambience5Player.stop();
			this.ambience6Player.stop();
		},

		//SPEECH
		userVoiceToTextFunc: function userVoiceToTextFunc() {
			var _this4 = this;

			this.submitSpeechTxttoVoice = true;
			this.testObjectVUI = this.userVoiceToText;
			console.log(this.testObjectVUI);
			this.sourceSortingVUI();
			setTimeout(function () {
				_this4.submitSpeechTxttoVoice = false;
			}, 250);
		},
		speechFunc: function speechFunc() {
			var _this5 = this;

			if (this.initSpeech === true) {
				this.recognitionPlains = new webkitSpeechRecognition();
				this.recognizing;
				this.recognitionPlains.continuous = false;
				this.recognitionPlains.interimResults = true;

				this.recognitionPlains.onresult = function (event) {
					for (var i = event.resultIndex; i < event.results.length; ++i) {
						if (event.results[i].isFinal) {
							if (!_this5.isDisableListening) {
								_this5.testObjectVUI += event.results[i][0].transcript;
								console.log('Speech String Command: ' + event.results[i][0].transcript);
								_this5.sourceSortingVUI();
							}
						}
					}
				};
				this.recognitionPlains.onspeechend = function () {
					console.log('%c Plains Module SPEECH Ended', 'background: red; color: black');
					// setTimeout(this.sourceSortingVUI, 500);
					_this5.recognizing = false;
					_this5.speechBtnTxt = "Say A Command";
					__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master.volume.setTargetAtTime(0, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.context.currentTime, +0.5);
				};
				this.recognitionPlains.onspeechstart = function () {
					console.log('%c Plains Module SPEECH Began', 'background: green; color: white');
					_this5.recognizing = true;
					_this5.speechBtnTxt = "Listening For Command";
					__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master.volume.setTargetAtTime(-10, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.context.currentTime, +1);
				};
				this.recognitionPlains.onsoundstart = function () {
					console.log('%c Plains Module LISTENING Began', 'background: green; color: white');
				};
				this.recognitionPlains.onaudioend = function () {
					console.log('%c Plains Module LISTENING Ended', 'background: green; color: white');
					// setTimeout(this.sourceSortingVUI, 500);
					_this5.recognizing = false;
					_this5.speechBtnTxt = "Say A Command";
				};
				this.recognitionPlains.onend = function () {
					console.log('%c Plains Module SPEECH SESSION ENDED', 'background: green; color: white');
					if (_this5.stopModuleSpeech === false) {
						_this5.recognitionPlains.start();
					}
				};
				this.recognizing = true;
				//MAKE SURE SPEECH IS NOT RE-ENGAGED
				this.initSpeech = false;
				//GLOBAL VOICE COMMAND IS SET TO TRUE
				this.$store.state.isVoiceControlled = true;
				this.recognitionPlains.start();
				//IF USER ENGAGES VOICE CONTROL BUT GOES HOME VIA MOUSE BUTTON THIS TRIGGERS MODULE SPEECH DISPOSE
				this.goingHomeNotViaVoiceCommand = true;
				//CONTROLS recognition.onend TO RESTART LISTENING
				this.stopModuleSpeech = false;
				//TURN LISTENING BACK ON
				this.isDisableListening = false;
				//IF BEING VOICE CONTROLLED DON'T PLAY THE NICE, TELL ME WHERE YOU WANT TO GO PROMPT ON WELCOME PAGE
				this.$store.state.doNotAddress = true;
			} else if (this.initSpeech === false) {}
		},
		resetFunc: function resetFunc() {
			this.recognizing = false;
		},
		speechStartStopFunc: function speechStartStopFunc() {
			this.speechStartTopBtnTrigger = !this.speechStartTopBtnTrigger;

			if (this.speechStartTopBtnTrigger === true) {
				this.speechFunc();
			} else if (this.speechStartTopBtnTrigger === false) {
				this.initSpeech = true;
				this.stopModuleSpeech = true;
				this.recognizing = false;
				this.recognitionPlains.stop();
				this.$store.state.isVoiceControlled = false;
			}
		},
		sourceSortingVUI: function sourceSortingVUI() {
			//FOR VISUAL REFERENCE
			this.userVoiceToText = this.testObjectVUI;

			var source1RegEx = XRegExp.build('(?x) {{source1Name}} | {{label1Name}}', {
				source1Name: XRegExp.build('{{source1Name1}} | {{source1Name2}}', {
					source1Name1: /source\sone/,
					source1Name2: /source\s1/
				}),
				label1Name: XRegExp.build('{{label1Name1}} | {{label1Name2}}', {
					label1Name1: /american/,
					label1Name2: /robin/
				})
			}, 'xgi');

			var source2RegEx = XRegExp.build('(?x) {{source2Name}} | {{label2Name}}', {
				source2Name: XRegExp.build('{{source2Name1}} | {{source2Name2}}', {
					source2Name1: /source\stw?o?o/,
					source2Name2: /source\s2/
				}),
				label2Name: XRegExp.build('{{label2Name1}} | {{label2Name2}}', {
					label2Name1: /yellowthroat/,
					label2Name2: /common/
				})
			}, 'xgi');

			var source3RegEx = XRegExp.build('(?x) {{source3Name}} | {{label3Name}}', {
				source3Name: XRegExp.build('{{source3Name1}} | {{source3Name2}}', {
					source3Name1: /source\sthree/,
					source3Name2: /source\s3/
				}),
				label3Name: XRegExp.build('{{label3Name1}} | {{label3Name2}}', {
					label3Name1: /long/,
					label3Name2: /grass|weeds?|winds?/
				})
			}, 'xgi');

			var source4RegEx = XRegExp.build('(?x) {{source4Name}} | {{label4Name}}', {
				source4Name: XRegExp.build('{{source4Name1}} | {{source4Name2}}', {
					source4Name1: /source\sfou?re?/,
					source4Name2: /source\s4/
				}),
				label4Name: XRegExp.build('{{label4Name1}} | {{label4Name2}}', {
					label4Name1: /buffalo/,
					label4Name2: /bison/
				})
			}, 'xgi');

			var source5RegEx = XRegExp.build('(?x) {{source5Name}} | {{label5Name}}', {
				source5Name: XRegExp.build('{{source5Name1}} | {{source5Name2}}', {
					source5Name1: /source\sfive/,
					source5Name2: /source\s5/
				}),
				label5Name: XRegExp.build('{{label5Name1}} | {{label5Name2}}', {
					label5Name1: /in\s?se[cx]ts?/,
					label5Name2: /bugs/
				})
			}, 'xgi');

			var source6RegEx = XRegExp.build('(?x) {{source6Name}} | {{label6Name}}', {
				source6Name: XRegExp.build('{{source6Name1}} | {{source6Name2}}', {
					source6Name1: /source\ss[ei]x/,
					source6Name2: /source\s6/
				}),
				label6Name: XRegExp.build('{{label6Name1}} | {{label6Name2}}', {
					label6Name1: /thunderstorm|rain|thunder|storm/,
					label6Name2: /weather/
				})
			}, 'xgi');
			//ALL SOUNDS
			var allSoundRegEx = XRegExp.build('(?x) {{allSoundName}}', {
				allSoundName: XRegExp.build('{{allSoundName1}} | {{allSoundName2}}', {
					allSoundName1: /all\ssounds?/,
					allSoundName2: /all\saudios?/
				})
			}, 'xgi');
			//SPEED
			var speedRegEx = XRegExp.build('(?x) {{speedName}}', {
				speedName: XRegExp.build('{{speedName1}} | {{speedName2}}', {
					speedName1: /speeds?/,
					speedName2: /slow|faster/
				})
			}, 'xgi');
			//DELAY
			var delayRegEx = XRegExp.build('(?x) {{delayName}}', {
				delayName: XRegExp.build('{{delayName1}} | {{delayName2}}', {
					delayName1: /delay/,
					delayName2: /lay/
				})
			}, 'xgi');
			//CHORUS
			var chorusRegEx = XRegExp.build('(?x) {{chorusName}}', {
				chorusName: XRegExp.build('{{chorusName1}} | {{chorusName2}}', {
					chorusName1: /chorus?/,
					chorusName2: /course/
				})
			}, 'xgi');
			//FILTER
			var filterRegEx = XRegExp.build('(?x) {{filterName}}', {
				filterName: XRegExp.build('{{filterName1}} | {{filterName2}}', {
					filterName1: /filter/,
					filterName2: /filter/
				})
			}, 'xgi');
			//REVERB
			var reverbRegEx = XRegExp.build('(?x) {{reverbName}}', {
				reverbName: XRegExp.build('{{reverbName1}} | {{reverbName2}}', {
					reverbName1: /verb/,
					reverbName2: /reverb/
				})
			}, 'xgi');
			//SHOW
			var infoRegEx = XRegExp.build('(?x) {{showName}}', {
				showName: XRegExp.build('{{showName1}} | {{showName2}}', {
					showName1: /info/,
					showName2: /information/
				})
			}, 'xgi');
			// console.log(infoRegEx);
			//HIDE
			var listRegEx = XRegExp.build('(?x) {{hideName}}', {
				hideName: XRegExp.build('{{hideName1}} | {{hideName2}}', {
					hideName1: /lists?/,
					hideName2: /menu/
				})
			}, 'xgi');
			// console.log(listRegEx);			

			var source1Boolean = source1RegEx.test(this.testObjectVUI);
			var source2Boolean = source2RegEx.test(this.testObjectVUI);
			var source3Boolean = source3RegEx.test(this.testObjectVUI);
			var source4Boolean = source4RegEx.test(this.testObjectVUI);
			var source5Boolean = source5RegEx.test(this.testObjectVUI);
			var source6Boolean = source6RegEx.test(this.testObjectVUI);
			var allSoundBoolean = allSoundRegEx.test(this.testObjectVUI);
			var speedBoolean = speedRegEx.test(this.testObjectVUI);
			var delayBoolean = delayRegEx.test(this.testObjectVUI);
			var chorusBoolean = chorusRegEx.test(this.testObjectVUI);
			var filterBoolean = filterRegEx.test(this.testObjectVUI);
			var reverbBoolean = reverbRegEx.test(this.testObjectVUI);
			var infoBoolean = infoRegEx.test(this.testObjectVUI);
			var listBoolean = listRegEx.test(this.testObjectVUI);

			if (source1Boolean) {
				this.source1VUI();
			} else if (source2Boolean) {
				this.source2VUI();
			} else if (source3Boolean) {
				this.source3VUI();
			} else if (source4Boolean) {
				this.source4VUI();
			} else if (source5Boolean) {
				this.source5VUI();
			} else if (source6Boolean) {
				this.source6VUI();
			} else if (allSoundBoolean) {
				this.allSoundVUI();
			} else if (speedBoolean) {
				this.speedVUI();
			} else if (delayBoolean) {
				this.delayVUI();
			} else if (chorusBoolean) {
				this.chorusVUI();
			} else if (filterBoolean) {
				this.filterVUI();
			} else if (reverbBoolean) {
				this.reverbVUI();
			} else if (infoBoolean) {
				this.infoVUI();
			} else if (listBoolean) {
				this.listVUI();
			} else {
				this.miscVUI();
			}
		},
		source1VUI: function source1VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience1Player.start();
				this.ambience1Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience1Player.stop();
				this.ambience1Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience1Vol < 0) {
						this.ambience1Vol += 12;
					}
				} else {
					if (this.ambience1Vol < 0) {
						this.ambience1Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience1Vol > -30) {
						this.ambience1Vol -= 12;
					}
				} else {
					if (this.ambience1Vol > -30) {
						this.ambience1Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		source2VUI: function source2VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience2Player.start();
				this.ambience2Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience2Player.stop();
				this.ambience2Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience2Vol < 0) {
						this.ambience2Vol += 12;
					}
				} else {
					if (this.ambience2Vol < 0) {
						this.ambience2Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience2Vol > -30) {
						this.ambience2Vol -= 12;
					}
				} else {
					if (this.ambience2Vol > -30) {
						this.ambience2Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		source3VUI: function source3VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience3Player.start();
				this.ambience3Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience3Player.stop();
				this.ambience3Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience3Vol < 0) {
						this.ambience3Vol += 12;
					}
				} else {
					if (this.ambience3Vol < 0) {
						this.ambience3Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience3Vol > -30) {
						this.ambience3Vol -= 12;
					}
				} else {
					if (this.ambience3Vol > -30) {
						this.ambience3Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		source4VUI: function source4VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience4Player.start();
				this.ambience4Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience4Player.stop();
				this.ambience4Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience4Vol < 0) {
						this.ambience4Vol += 12;
					}
				} else {
					if (this.ambience4Vol < 0) {
						this.ambience4Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience4Vol > -30) {
						this.ambience4Vol -= 12;
					}
				} else {
					if (this.ambience4Vol > -30) {
						this.ambience4Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		source5VUI: function source5VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience5Player.start();
				this.ambience5Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience5Player.stop();
				this.ambience5Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience5Vol < 0) {
						this.ambience5Vol += 12;
					}
				} else {
					if (this.ambience5Vol < 0) {
						this.ambience5Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience5Vol > -30) {
						this.ambience5Vol -= 12;
					}
				} else {
					if (this.ambience5Vol > -30) {
						this.ambience5Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		source6VUI: function source6VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience6Player.start();
				this.ambience6Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience6Player.stop();
				this.ambience6Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience6Vol < 0) {
						this.ambience6Vol += 12;
					}
				} else {
					if (this.ambience6Vol < 0) {
						this.ambience6Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience6Vol > -30) {
						this.ambience6Vol -= 12;
					}
				} else {
					if (this.ambience6Vol > -30) {
						this.ambience6Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		allSoundVUI: function allSoundVUI() {
			//STOP ALL 
			if (RegExp(/stop/gi).test(this.testObjectVUI)) {
				this.ambience1Player.stop();
				this.ambience1Boolean = false;
				this.ambience2Player.stop();
				this.ambience2Boolean = false;
				this.ambience3Player.stop();
				this.ambience3Boolean = false;
				this.ambience4Player.stop();
				this.ambience4Boolean = false;
				this.ambience5Player.stop();
				this.ambience5Boolean = false;
				this.ambience6Player.stop();
				this.ambience6Boolean = false;
				if (this.didWeAdventure) {
					this.exploreSound1.stop();
					this.isExploreFuncRunning = false;
				}
			} else if (RegExp(/play/gi).test(this.testObjectVUI)) {
				this.ambience1Player.start();
				this.ambience1Boolean = true;
				this.ambience2Player.start();
				this.ambience2Boolean = true;
				this.ambience3Player.start();
				this.ambience3Boolean = true;
				this.ambience4Player.start();
				this.ambience4Boolean = true;
				this.ambience5Player.start();
				this.ambience5Boolean = true;
				this.ambience6Player.start();
				this.ambience6Boolean = true;
			}
			this.testObjectVUI = "";
		},
		speedVUI: function speedVUI() {
			if (RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI)) {
				this.speedToggle = true;
			} else if (RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI)) {
				this.speedToggle = false;
			}
			if (RegExp(/\bfaste?r?\b|up/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.playBackSpeed <= 1.6) {
						this.playBackSpeed += 0.4;
					}
				} else {
					if (this.playBackSpeed <= 1.8) {
						this.playBackSpeed += 0.2;
					}
				}
			} else if (RegExp(/slowe?r?|down/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.playBackSpeed >= 0.5) {
						this.playBackSpeed -= 0.4;
					}
				} else {
					if (this.playBackSpeed >= 0.2) {
						this.playBackSpeed -= 0.2;
					}
				}
			}
			this.testObjectVUI = "";
		},
		delayVUI: function delayVUI() {
			if (RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI)) {
				this.fxDelayToggle = true;
			} else if (RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI)) {
				this.fxDelayToggle = false;
			}
			if (RegExp(/\bmore\b|\bup\b|loude?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxDelayAmt <= 80) {
						this.fxDelayAmt += 10;
					}
				} else {
					if (this.fxDelayAmt <= 95) {
						this.fxDelayAmt += 5;
					}
				}
			} else if (RegExp(/less|\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxDelayAmt >= 20) {
						this.fxDelayAmt -= 10;
					} else if (this.fxDelayAmt >= 5) {
						this.fxDelayAmt -= 5;
					}
				} else {
					if (this.fxDelayAmt >= 5) {
						this.fxDelayAmt -= 5;
					} else if (this.fxDelayAmt >= 15) {
						this.fxDelayAmt -= 2;
					}
				}
			}
			this.testObjectVUI = "";
		},
		chorusVUI: function chorusVUI() {
			if (RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI)) {
				this.fxChorusToggle = true;
			} else if (RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI)) {
				this.fxChorusToggle = false;
			}
			if (RegExp(/\bmore\b|\bup\b|loude?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxChorusAmt <= 80) {
						this.fxChorusAmt += 10;
					}
				} else {
					if (this.fxChorusAmt <= 95) {
						this.fxChorusAmt += 5;
					}
				}
			} else if (RegExp(/less|\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxChorusAmt >= 20) {
						this.fxChorusAmt -= 10;
					} else if (this.fxChorusAmt >= 5) {
						this.fxChorusAmt -= 5;
					}
				} else {
					if (this.fxChorusAmt >= 5) {
						this.fxChorusAmt -= 5;
					} else if (this.fxChorusAmt >= 15) {
						this.fxChorusAmt -= 2;
					}
				}
			}
			this.testObjectVUI = "";
		},
		reverbVUI: function reverbVUI() {
			if (RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI)) {
				this.fxConvolverToggle = true;
			} else if (RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI)) {
				this.fxConvolverToggle = false;
			}
			if (RegExp(/\bmore\b|\bup\b|loude?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxConvolverAmt <= 45) {
						this.fxConvolverAmt += 5;
					}
				} else {
					if (this.fxConvolverAmt <= 48) {
						this.fxConvolverAmt += 2;
					}
				}
			} else if (RegExp(/less|\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxConvolverAmt >= 10) {
						this.fxConvolverAmt -= 5;
					} else if (this.fxConvolverAmt >= 2) {
						this.fxConvolverAmt -= 1;
					}
				} else {
					if (this.fxConvolverAmt >= 10) {
						this.fxConvolverAmt -= 2;
					} else if (this.fxConvolverAmt >= 2) {
						this.fxConvolverAmt -= 1;
					}
				}
			}
			this.testObjectVUI = "";
		},
		filterVUI: function filterVUI() {
			if (RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI)) {
				this.fxFilterToggle = true;
			} else if (RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI)) {
				this.fxFilterToggle = false;
			}
			if (RegExp(/\bmore\b|\blower\b/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxAutoFilterAmt > 1500) {
						this.fxAutoFilterAmt -= 1500;
					} else if (this.fxAutoFilterAmt >= 300) {
						this.fxAutoFilterAmt -= 200;
					}
				} else {
					if (this.fxAutoFilterAmt >= 500) {
						this.fxAutoFilterAmt -= 250;
					} else if (this.fxAutoFilterAmt >= 100) {
						this.fxAutoFilterAmt -= 100;
					}
				}
			} else if (RegExp(/less|higher|hire/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxAutoFilterAmt <= 10000) {
						this.fxAutoFilterAmt += 1500;
					} else if (this.fxAutoFilterAmt <= 1000) {
						this.fxAutoFilterAmt += 200;
					}
				} else {
					if (this.fxAutoFilterAmt <= 10000) {
						this.fxAutoFilterAmt += 250;
					} else if (this.fxAutoFilterAmt <= 1000) {
						this.fxAutoFilterAmt += 100;
					}
				}
			}
			this.testObjectVUI = "";
		},
		infoVUI: function infoVUI() {
			var _this6 = this;

			if (RegExp(/show|display/gi).test(this.testObjectVUI)) {
				this.showHelpOverlay = true;
				setTimeout(function () {
					_this6.showNavBar = false;
					if (_this6.$store.state.allowSpeechControl) {
						_this6.showSpeechBtns = false;
					}
				}, 0);
				setTimeout(function () {
					_this6.showAllControls = false;
				}, 500);
				setTimeout(function () {
					_this6.showAboutPage = true;
				}, 1500);
				console.log('SHOW INFO');
			} else if (RegExp(/hide|minimize/gi).test(this.testObjectVUI)) {
				this.showHelpOverlay = false;
				this.showAboutPage = false;
				setTimeout(function () {
					_this6.showAllControls = true;
				}, 800);
				setTimeout(function () {
					_this6.showNavBar = true;
					if (_this6.$store.state.allowSpeechControl) {
						_this6.showSpeechBtns = true;
					}
				}, 850);
				console.log('HIDE INFO');
			}
			this.testObjectVUI = "";
			setTimeout(function () {
				_this6.userVoiceToText = "";
			}, 3000);
		},
		listVUI: function listVUI() {
			var _this7 = this;

			if (RegExp(/show|display/gi).test(this.testObjectVUI)) {
				this.showVoiceCommandList = true;
				setTimeout(function () {
					document.getElementById('voiceControlListTxt').scrollIntoView({ behavior: "smooth" });
				}, 250);
				console.log('SHOW LIST');
			} else if (RegExp(/hide|minimize/gi).test(this.testObjectVUI)) {
				this.showVoiceCommandList = false;
				setTimeout(function () {
					document.getElementById('controlsContainer').scrollIntoView({ behavior: "smooth" });
				}, 250);
				console.log('HIDE LIST');
			}
			this.testObjectVUI = "";
			setTimeout(function () {
				_this7.userVoiceToText = "";
			}, 3000);
		},
		miscVUI: function miscVUI() {
			//RANDOMIZE
			if (RegExp(/new\s?scenes?|randomi?z?e?|shift\s?soundscapes?/gi).test(this.testObjectVUI)) {
				this.mattChillMethod();
				//EXPLORE
			} else if (RegExp(/\bexplorer?\b|\badventure\b/gi).test(this.testObjectVUI)) {
				if (RegExp(/stop/gi).test(this.testObjectVUI)) {
					this.stopExplore();
				} else {
					this.exploreFunc();
				}
				//STOP VOICE COMMANDS & GO HOME FUNCTIONS
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) && RegExp(/voice\s?controls?/gi).test(this.testObjectVUI) || RegExp(/stop/gi).test(this.testObjectVUI) && RegExp(/voice\s?commands?/gi).test(this.testObjectVUI)) {
				//DISABLES LISTENING IMMEDITATLY
				this.initSpeech = true;
				this.stopModuleSpeech = true;
				this.recognizing = false;
				this.recognitionPlains.stop();
				this.$store.state.isVoiceControlled = false;
			} else if (RegExp(/home/gi).test(this.testObjectVUI)) {
				this.goingHomeNotViaVoiceCommand = false;
				this.stopModuleSpeech = true;
				this.recognitionPlains.abort();
				this.recognitionPlains = undefined;
				setTimeout(this.goHome, 50);
			}
			this.testObjectVUI = "";
		},
		voiceCommandListFunc: function voiceCommandListFunc() {
			this.showVoiceCommandList = !this.showVoiceCommandList;
			if (this.showVoiceCommandList) {
				setTimeout(function () {
					document.getElementById('voiceControlListTxt').scrollIntoView({ behavior: "smooth" });
				}, 250);
			} else if (!this.showVoiceCommandList) {
				document.getElementById('controlsContainer').scrollIntoView({ behavior: "smooth" });
			}
		},

		//ENTER FUNC
		enterFunc: function enterFunc() {
			var _this8 = this;

			if (this.startAudioBoolean) {
				this.startAudio();
				this.startAudioBoolean = false;
			}

			this.showEnterBtn = false;

			setTimeout(function () {
				_this8.showEnterContainer = false;
			}, 1000);

			this.plainsFX.start();

			var changeTiming = 100;

			setTimeout(function () {
				_this8.plungeDepth = 1;
			}, changeTiming * 1);

			setTimeout(function () {
				_this8.plungeDepth = 2;
			}, changeTiming * 2);

			setTimeout(function () {
				_this8.plungeDepth = 3;
			}, changeTiming * 3);

			setTimeout(function () {
				_this8.plungeDepth = 4;
			}, changeTiming * 4);

			setTimeout(function () {
				_this8.plungeDepth = 5;
			}, changeTiming * 5);

			setTimeout(function () {
				_this8.plungeDepth = 6;
			}, changeTiming * 6);

			setTimeout(function () {
				_this8.plungeDepth = 7;
			}, changeTiming * 7);

			setTimeout(function () {
				_this8.plungeDepth = 8;
			}, changeTiming * 8);

			setTimeout(function () {
				_this8.plungeDepth = 9;
			}, changeTiming * 8);

			setTimeout(function () {
				_this8.plungeDepth = 10;
			}, changeTiming * 10);

			setTimeout(function () {
				_this8.ambience1Boolean = true;
				// this.ambience3Player.start();
				// this.ambience3Boolean = true;
				_this8.ambience5Boolean = true;
			}, 750);

			setTimeout(function () {
				_this8.showAllControls = true;
			}, 1050);

			setTimeout(function () {
				_this8.showNavBar = true;
			}, 1300);

			setTimeout(function () {
				_this8.showMicRecording = true;
			}, 1100);

			setTimeout(function () {
				_this8.showSpeechBtns = true;
			}, 1200);

			setTimeout(function () {
				if (_this8.userMobile === false) {
					_this8.activeSun = true;
				}
			}, 1510);

			setTimeout(function () {
				_this8.ambience3Vol = -48;
				_this8.ambience5Vol = -38;
			}, 750);

			setTimeout(function () {
				_this8.ambience3Vol = -46;
				_this8.ambience5Vol = -36;
			}, 800);

			setTimeout(function () {
				_this8.ambience3Vol = -44;
				_this8.ambience5Vol = -34;
			}, 850);

			setTimeout(function () {
				_this8.ambience3Vol = -42;
				_this8.ambience5Vol = -32;
			}, 900);

			setTimeout(function () {
				_this8.ambience3Vol = -40;
				_this8.ambience5Vol = -28;
			}, 950);

			setTimeout(function () {
				_this8.ambience3Vol = -38;
				_this8.ambience5Vol = -25;
			}, 1000);

			setTimeout(function () {
				_this8.ambience3Vol = -36;
				_this8.ambience5Vol = -23;
			}, 1050);

			setTimeout(function () {
				_this8.ambience3Vol = -34;
				_this8.ambience5Vol = -20;
			}, 1100);

			setTimeout(function () {
				_this8.ambience3Vol = -32;
				_this8.ambience5Vol = -18;
			}, 1150);

			setTimeout(function () {
				_this8.ambience3Vol = -30;
				_this8.ambience5Vol = -16;
			}, 1200);
		},

		//RANDOMIZE (MATT CHILL) PRESET
		mattChillMethod: function mattChillMethod() {
			if (this.didWeAdventure) {
				this.stopExplore();
			}
			// Tone.Master.volume.setTargetAtTime(-70, Tone.Context.currentTime, +0.1);
			// setTimeout(()=>{
			// 	Tone.Master.volume.setTargetAtTime(0, Tone.Context.currentTime, +0.05);
			// }, 150);

			if (this.randomizeBoolean === false) {
				this.randomizeBoolean = true;
			}

			this.mattChill = !this.mattChill;

			this.ambience1Vol = Math.floor(Math.random() * 10 - 15);
			this.ambience2Vol = Math.floor(Math.random() * 10 - 15);
			this.ambience3Vol = Math.floor(Math.random() * 20 - 30);
			this.ambience4Vol = Math.floor(Math.random() * 20 - 20);
			this.ambience5Vol = Math.floor(Math.random() * 5 - 25);
			this.ambience6Vol = Math.floor(Math.random() * 25 - 25);

			// let fx1boolean 		= Math.random() >= 0.5,
			// 	fx2boolean 		= Math.random() >= 0.5,
			// 	fx3boolean 		= Math.random() >= 0.5,
			// 	fx4boolean 		= Math.random() >= 0.5,
			// 	fx5boolean 		= Math.random() >= 0.5;

			var amb1boolean = Math.random() >= 0.5,
			    amb2boolean = Math.random() >= 0.5,
			    amb3boolean = Math.random() >= 0.75,
			    amb4boolean = Math.random() >= 0.95,
			    amb5boolean = Math.random() >= 0.5,
			    amb6boolean = Math.random() >= 0.85;

			// if (this.mattChill === true){
			//DON'T CALCULATE ON MOBILE
			if (this.userMobile === false) {
				var
				// randomVerb 		= Math.floor((Math.random() * 20) + 0),
				randomDelay = Math.floor(Math.random() * 10 + 0),
				    randomChorus = Math.floor(Math.random() * 15 + 0),
				    randomFilter = Math.floor(Math.random() * 10000 + 3500);

				// this.fxConvolverAmt 	= randomVerb;
				this.fxDelayAmt = randomDelay;
				this.fxChorusAmt = randomChorus;
				this.fxAutoFilterAmt = randomFilter;

				this.fxDecay = Math.random() * 10 + 1.5;
				var fxPreDelay = Math.random() * 0.1 + 0.03;
				this.fxConvolver.decay = this.fxDecay;
				this.fxConvolver.preDelay = fxPreDelay;
				this.fxConvolver.generate();

				// console.log("Verb Decay: " + this.fxDecay);
				// console.log("Verb PreDelay: " + fxPreDelay);
			}
			//CALCULATE ON MOBILE & DESKTOP
			var randomSpeed = Math.random() * (1.15 - 0.85) + 0.85;
			this.playBackSpeed = randomSpeed;

			if (amb1boolean === true) {
				this.ambience1Boolean = true;
				this.showFlask1 = true;
			} else {
				this.ambience1Boolean = false;
				this.showFlask1 = false;
			}

			if (amb2boolean === true) {
				this.ambience2Boolean = true;
				this.showFlask2 = true;
			} else {
				this.ambience2Boolean = false;
				this.showFlask2 = false;
			}

			if (amb3boolean === true) {
				this.ambience3Boolean = true;
				this.showFlask3 = true;
			} else {
				this.ambience3Boolean = false;
				this.showFlask3 = false;
			}

			if (amb4boolean === true) {
				this.ambience4Boolean = true;
				this.showFlask4 = true;
			} else {
				this.ambience4Boolean = false;
				this.showFlask4 = false;
			}

			if (amb5boolean === true) {
				this.ambience5Boolean = true;
				this.showFlask5 = true;
			} else {
				this.ambience5Boolean = false;
				this.showFlask5 = false;
			}
			//IF THUNDERSTORM NO BIRDS OR INSECTS
			if (amb6boolean === true) {
				this.ambience6Boolean = true;
				this.showFlask6 = true;

				this.ambience4Vol = Math.floor(Math.random() * 5 - 15);

				this.ambience5Boolean = false;
				this.showFlask5 = false;

				this.ambience1Boolean = false;
				this.showFlask1 = false;

				this.ambience2Boolean = false;
				this.showFlask2 = false;
			} else {
				this.ambience6Boolean = false;
				this.showFlask6 = false;
			}

			if (amb1boolean === false && amb2boolean === false && amb3boolean === false && amb4boolean === false && amb5boolean === false && amb6boolean === false) {
				this.ambience6Boolean = true;
				this.showFlask6 = true;
			}

			// } else if (this.mattChill === false){
			// this.fxDelayToggle = false;
			// this.fxConvolverToggle = false;
			// this.fxChorusToggle = false;
			// this.fxFilterToggle = false;
			// this.speedToggle = false;
			// } 
		},

		//EXPLORE 
		exploreBtnFunc: function exploreBtnFunc() {
			this.exploreBtnBoolean = !this.exploreBtnBoolean;
			if (this.exploreBtnBoolean) {
				this.exploreFunc();
			} else if (!this.exploreBtnBoolean) {
				this.stopExplore();
			}
		},
		exploreFunc: function exploreFunc() {
			var _this9 = this;

			//AUDIO MIXING FUNCTION
			var int = 1250;
			var runExplore = function runExplore() {
				_this9.exploreSound1.start();
				_this9.exploreTxt = "Exploring";
				_this9.exploreTimeout1 = setTimeout(function () {
					_this9.ambience1Vol = -14;
					_this9.ambience3Vol = -20;
					_this9.ambience4Vol = -30;
					_this9.ambience5Vol = -20;
				}, int * 1);
				_this9.exploreTimeout2 = setTimeout(function () {
					// this.ambience1Vol = -14;
					_this9.ambience3Vol = -18;
					_this9.ambience4Vol = -30;
					_this9.ambience5Vol = -19;
				}, int * 2);
				_this9.exploreTimeout3 = setTimeout(function () {
					// this.ambience1Vol = -14;
					_this9.ambience3Vol = -16;
					_this9.ambience4Vol = -28;
					_this9.ambience5Vol = -18;
				}, int * 3);
				_this9.exploreTimeout4 = setTimeout(function () {
					// this.ambience1Vol = -14;
					_this9.ambience3Vol = -18;
					_this9.ambience4Vol = -26;
					_this9.ambience5Vol = -17;
				}, int * 4);
				_this9.exploreTimeout5 = setTimeout(function () {
					// this.ambience1Vol = -14;
					_this9.ambience3Vol = -20;
					_this9.ambience4Vol = -24;
					_this9.ambience5Vol = -16;
				}, int * 5);
				_this9.exploreTimeout6 = setTimeout(function () {
					// this.ambience1Vol = -14;
					_this9.ambience3Vol = -18;
					_this9.ambience4Vol = -22;
					_this9.ambience5Vol = -15;
				}, int * 6);
				_this9.exploreTimeout7 = setTimeout(function () {
					_this9.ambience3Vol = -17;
					_this9.ambience4Vol = -20;
				}, int * 7);
				_this9.exploreTimeout8 = setTimeout(function () {
					_this9.ambience3Vol = -20;
					_this9.ambience4Vol = -18;
				}, int * 8);
				_this9.exploreTimeout9 = setTimeout(function () {
					_this9.ambience4Vol = -17;
				}, int * 8.5);
				_this9.exploreTimeout10 = setTimeout(function () {
					_this9.ambience3Vol = -22;
					_this9.ambience4Vol = -16;
				}, int * 9);
				_this9.exploreTimeout11 = setTimeout(function () {
					_this9.ambience4Vol = -15;
				}, int * 9.5);
				_this9.exploreTimeout12 = setTimeout(function () {
					_this9.ambience3Vol = -23;
					_this9.ambience4Vol = -14;
				}, int * 10);
				_this9.exploreTimeout13 = setTimeout(function () {
					_this9.ambience4Vol = -13;
				}, int * 10.5);
				_this9.exploreTimeout14 = setTimeout(function () {
					_this9.ambience3Vol = -24;
					_this9.ambience4Vol = -12;
				}, int * 11);
				_this9.exploreTimeout15 = setTimeout(function () {
					_this9.ambience4Vol = -11;
				}, int * 11.5);
				_this9.exploreTimeout16 = setTimeout(function () {
					_this9.ambience3Vol = -25;
					_this9.ambience4Vol = -10;
				}, int * 12);
				_this9.exploreTimeout17 = setTimeout(function () {
					_this9.ambience4Vol = -9;
				}, int * 12.5);
				_this9.exploreTimeout18 = setTimeout(function () {
					_this9.ambience3Vol = -25;
					_this9.ambience4Vol = -8;
				}, int * 13);
				_this9.exploreTimeout19 = setTimeout(function () {
					_this9.ambience4Vol = -7;
				}, int * 13.5);
				_this9.exploreTimeout20 = setTimeout(function () {
					_this9.ambience3Vol = -25;
					_this9.ambience4Vol = -6;
				}, int * 14);
				_this9.exploreTimeout21 = setTimeout(function () {
					_this9.ambience4Vol = -5;
					_this9.isExploreFuncRunning = false;
				}, int * 14.5);
			};
			if (this.isExploreFuncRunning === false) {
				this.isExploreFuncRunning = true;
				//INIT EXPORE SCENE
				//GENERATE REVERB
				if (!this.userMobile) {
					this.fxDecay = 4.5;
					this.fxConvolver.decay = this.fxDecay;
					this.fxConvolver.preDelay = 0.4;
					this.fxConvolver.generate();
				}

				this.ambience1Boolean = true;
				this.ambience1Vol = -14;

				this.ambience2Boolean = false;
				this.ambience2Vol = -30;

				this.ambience3Boolean = true;
				this.ambience3Vol = -20;

				this.ambience4Boolean = true;
				this.ambience4Vol = -30;

				this.ambience5Boolean = true;
				this.ambience5Vol = -20;

				this.ambience6Boolean = false;
				this.ambience6Vol = -30;

				if (!this.didWeAdventure) {
					this.exploreSound1 = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
						"playbackRate": 1,
						"loop": false,
						"volume": 0
					}).connect(this.masterVolumeSub);

					//LOADING FOR BROWSER TYPE
					if (this.isChrome === true || this.isOpera === true || this.isFirefox === true || this.isBlink === true) {

						this.exploreSound1.load("../src/assets/sounds/modules/plains/hiogg/exporeSound1Plains.ogg", function () {
							runExplore();
						});
					} else if (this.AndroidMobile === true) {
						this.exploreSound1.load("../src/assets/sounds/modules/plains/lowogg/exporeSound1Plains.ogg", function () {
							runExplore();
						});
					} else if (this.isSafari === true || this.isEdge === true || this.isIE === true) {
						this.exploreSound1.load("../src/assets/sounds/modules/plains/320/exporeSound1Plains.m4a", function () {
							runExplore();
						});
					} else if (this.iOS === true) {
						this.exploreSound1.load("../src/assets/sounds/modules/plains/192/exporeSound1Plains.m4a", function () {
							runExplore();
						});
					}
					//CLEANS UP AND DISPOSES THESE PLAYERS WHEN GOING HOME
					this.didWeAdventure = true;
				} else if (this.didWeAdventure) {
					runExplore();
				}
			} else {}
		},
		stopExplore: function stopExplore() {
			this.exploreTxt = "Explore!";
			this.exploreSound1.stop();
			this.isExploreFuncRunning = false;
			clearInterval(this.exploreTimeout1);
			clearInterval(this.exploreTimeout2);
			clearInterval(this.exploreTimeout3);
			clearInterval(this.exploreTimeout4);
			clearInterval(this.exploreTimeout5);
			clearInterval(this.exploreTimeout6);
			clearInterval(this.exploreTimeout7);
			clearInterval(this.exploreTimeout8);
			clearInterval(this.exploreTimeout9);
			clearInterval(this.exploreTimeout10);
			clearInterval(this.exploreTimeout11);
			clearInterval(this.exploreTimeout12);
			clearInterval(this.exploreTimeout13);
			clearInterval(this.exploreTimeout14);
			clearInterval(this.exploreTimeout15);
			clearInterval(this.exploreTimeout16);
			clearInterval(this.exploreTimeout17);
			clearInterval(this.exploreTimeout18);
			clearInterval(this.exploreTimeout19);
			clearInterval(this.exploreTimeout20);
			clearInterval(this.exploreTimeout21);
		},

		//MASTER METERING
		masterMetering: function masterMetering() {
			this.masterLevel = this.masterMeter.getLevel();
		},

		//MAIN SHOW AND HIDE
		goToHelp: function goToHelp() {
			var _this10 = this;

			this.showHelpOverlay = !this.showHelpOverlay;
			this.helpTrigger = !this.helpTrigger;

			if (this.showHelpOverlay === true) {

				setTimeout(function () {
					_this10.showNavBar = false;
					if (_this10.$store.state.allowSpeechControl) {
						_this10.showSpeechBtns = false;
					}
				}, 100);

				setTimeout(function () {
					_this10.showAllControls = false;
				}, 250);

				setTimeout(function () {
					_this10.showAboutPage = true;
				}, 1000);
			} else if (this.showHelpOverlay === false) {

				this.showAboutPage = false;

				setTimeout(function () {
					_this10.showAllControls = true;
				}, 800);

				setTimeout(function () {
					_this10.showNavBar = true;
					if (_this10.$store.state.allowSpeechControl) {
						_this10.showSpeechBtns = true;
					}
				}, 850);
			}
		},

		//MASTER DRAGGIE LOGGING & LOADING
		ogScreenSize: function ogScreenSize() {
			this.ogWidth = window.innerWidth;
		},
		screenSizing: function screenSizing() {
			this.screenHeight = window.innerHeight;
			this.screenWidth = window.innerWidth;

			var currentWidth = window.innerWidth;

			if (currentWidth === this.ogWidth) {} else if (currentWidth != this.ogWidth) {
				this.sliderRangeSet();
				// this.mobileCheck();
				this.ogWidth = currentWidth;
			}
		},

		//BUFFER LOADING
		bufferLoading: function bufferLoading() {
			var _this11 = this;

			// Tone.Buffer.on('progress', ()=>{
			// });
			__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Buffer.on('load', function () {
				//HIDE LOADING ITEMS
				_this11.showLoading = false;
				//SHOW ENTER BUTTON
				setTimeout(function () {
					_this11.showEnterBtn = true;
				}, 1000);
				//AUTO OPEN MODULE IF VOICE CONTROLLED & DO NOT REPLAY WHEN EXPLORE AUDIO LOADS 
				//ADDITIONALLY DO NOT REPLAY IF USER MIC HAS BEEN ACTIVATED FOR RECORDING
				if (_this11.isVoiceControl) {
					if (!_this11.didWeAdventure) {
						setTimeout(_this11.enterFunc, 2000);
					}
				}
				//IF VOICE CONTROL IS ACTIVE GLOBALLY ACTIVATE IN THIS MODULE
				if (_this11.isVoiceControl === true) {
					_this11.speechFunc();
				}
			});
		},

		//AUDIO ROUTING
		audioRouting: function audioRouting() {
			if (this.isChrome === true || this.AndroidMobile === true || this.isOpera === true || this.isFirefox === true || this.isBlink === true) {
				if (this.userMobile === false) {

					// this.fxConvolver = new Tone.Convolver("../src/assets/cookieverb.wav");
					this.fxConvolver = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Reverb({
						"decay": 1.5,
						"preDelay": 0.01
					});
					this.fxConvolver.decay = 2.5;
					this.fxConvolver.generate();
					this.fxAutoFilter = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Filter({
						"type": "lowpass",
						"frequency": 20000,
						"rolloff": -24,
						"Q": 1,
						"gain": 0
					});
					this.fxDelay = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.PingPongDelay(0.7, 0.25);
					this.fxChorus = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Chorus({
						"frequency": 5,
						"delayTime": 10,
						"depth": 0.85,
						"type": "sine",
						"spread": 180
					});
					this.masterMeter = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Meter({
						"smoothing": .4
					});
					this.ambience1Player.connect(this.masterVolumeSub);
					this.ambience2Player.connect(this.masterVolumeSub);
					this.ambience3Player.connect(this.masterVolumeSub);
					this.ambience4Player.connect(this.masterVolumeSub);
					this.ambience5Player.connect(this.masterVolumeSub);
					this.ambience6Player.connect(this.masterVolumeSub);

					this.masterVolumeSub.chain(this.fxAutoFilter, this.fxConvolver, this.fxDelay, this.fxChorus, this.masterMeter, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master);
					console.log('Chrome/Opera/FireFox Desktop');
					setInterval(this.masterMetering, 60);
				} else if (this.userMobile === true) {
					this.ambience1Player.connect(this.masterVolumeSub);
					this.ambience2Player.connect(this.masterVolumeSub);
					this.ambience3Player.connect(this.masterVolumeSub);
					this.ambience4Player.connect(this.masterVolumeSub);
					this.ambience5Player.connect(this.masterVolumeSub);
					this.ambience6Player.connect(this.masterVolumeSub);

					this.masterVolumeSub.connect(__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master);

					console.log('Chrome/Opera/FireFox Mobile');
				}
			} else if (this.isSafari === true || this.iOS === true || this.isEdge === true || this.isIE === true) {
				if (this.userMobile === false) {
					// this.fxConvolver = new Tone.Convolver("../src/assets/cookieverb.wav");
					this.fxConvolver = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Reverb({
						"decay": 1.5,
						"preDelay": 0.01
					});
					this.fxConvolver.decay = 2.5;
					this.fxConvolver.generate();
					this.fxAutoFilter = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Filter({
						"type": "lowpass",
						"frequency": 20000,
						"rolloff": -24,
						"Q": 1,
						"gain": 0
					});
					this.fxDelay = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.PingPongDelay(0.7, 0.25);
					this.fxChorus = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Chorus({
						"frequency": 5,
						"delayTime": 10,
						"depth": 0.85,
						"type": "sine",
						"spread": 180
					});
					this.masterMeter = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Meter({
						"smoothing": .4
					});
					this.ambience1Player.connect(this.masterVolumeSub);
					this.ambience2Player.connect(this.masterVolumeSub);
					this.ambience3Player.connect(this.masterVolumeSub);
					this.ambience4Player.connect(this.masterVolumeSub);
					this.ambience5Player.connect(this.masterVolumeSub);
					this.ambience6Player.connect(this.masterVolumeSub);

					this.masterVolumeSub.chain(this.fxAutoFilter, this.fxConvolver, this.fxDelay, this.fxChorus, this.masterMeter, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master);
					console.log('Safari/Edge/iOS Desktop');
					setInterval(this.masterMetering, 60);
				} else if (this.userMobile === true) {
					this.ambience1Player.connect(this.masterVolumeSub);
					this.ambience2Player.connect(this.masterVolumeSub);
					this.ambience3Player.connect(this.masterVolumeSub);
					this.ambience4Player.connect(this.masterVolumeSub);
					this.ambience5Player.connect(this.masterVolumeSub);
					this.ambience6Player.connect(this.masterVolumeSub);

					this.masterVolumeSub.connect(__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master);
					console.log('Safari/Edge/iOS Mobile');
				}
			} else {}
		},

		//AUDIO LOADING
		firstAudioLoadFunc: function firstAudioLoadFunc() {
			var _this12 = this;

			// this.changeFX.load("../src/assets/sounds/blinks/change.wav", 
			// 	()=>{
			// 	this.whatIsLoading = "Fauna";
			// });

			// this.plainsFX.load("../src/assets/sounds/modules/plains/plainsFX.wav", 
			// 	()=>{
			// 	this.whatIsLoading = "Dirt";
			// });

			// this.ambience1Player.load("../src/assets/sounds/modules/plains/birds.wav", 
			// 	()=>{
			// 	this.whatIsLoading = "Birds";
			// });

			// this.ambience2Player.load("../src/assets/sounds/modules/plains/winds.wav", 
			// 	()=>{
			// 	this.whatIsLoading = "Winds";
			// });

			// this.ambience3Player.load("../src/assets/sounds/modules/plains/longgrass.wav", 
			// 	()=>{
			// 	this.whatIsLoading = "Long Grass";
			// });

			// this.ambience4Player.load("../src/assets/sounds/modules/plains/buffalo.wav", 
			// 	()=>{
			// 	this.whatIsLoading = "Buffalo";
			// });

			// this.ambience5Player.load("../src/assets/sounds/modules/plains/insects.wav", 
			// 	()=>{
			// 	this.whatIsLoading = "Insects";
			// });

			// this.ambience6Player.load("../src/assets/sounds/modules/plains/walk.wav", 
			// 	()=>{
			// 	this.whatIsLoading = "Walkabout";
			// });

			var ua = window.navigator.userAgent;

			var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor),
			    isFirefox = typeof InstallTrigger !== 'undefined',
			    isSafari = /constructor/i.test(window.HTMLElement) || function (p) {
				return p.toString() === "[object SafariRemoteNotification]";
			}(!window['safari'] || safari.pushNotification),
			    isOpera = !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0,
			    isIE = /*@cc_on!@*/false || !!document.documentMode,
			    isEdge = !isIE && !!window.StyleMedia,
			    isBlink = (isChrome || isOpera) && !!window.CSS,
			    iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i),
			    AndroidMobile = /Android/i.test(navigator.userAgent);

			if (isChrome === true || isOpera === true || isFirefox === true || isBlink === true) {

				this.changeFX.load("../src/assets/sounds/blinks/change.ogg", function () {
					_this12.whatIsLoading = "Fauna";
				});

				this.plainsFX.load("../src/assets/sounds/modules/plains/hiogg/plainsFX.ogg", function () {
					_this12.whatIsLoading = "Soil";
				});

				this.ambience1Player.load("../src/assets/sounds/modules/plains/hiogg/birds.ogg", function () {
					_this12.whatIsLoading = "Birds";
				});

				this.ambience2Player.load("../src/assets/sounds/modules/plains/hiogg/birds2.ogg", function () {
					_this12.whatIsLoading = "Winds";
				});

				this.ambience3Player.load("../src/assets/sounds/modules/plains/hiogg/longgrass.ogg", function () {
					_this12.whatIsLoading = "Long Grass";
				});

				this.ambience4Player.load("../src/assets/sounds/modules/plains/hiogg/buffalo.ogg", function () {
					_this12.whatIsLoading = "Bison";
				});

				this.ambience5Player.load("../src/assets/sounds/modules/plains/hiogg/insects.ogg", function () {
					_this12.whatIsLoading = "Insects";
				});

				this.ambience6Player.load("../src/assets/sounds/modules/plains/hiogg/thunder.ogg", function () {
					_this12.whatIsLoading = "Thunderstorm";
				});
			} else if (AndroidMobile === true) {
				this.changeFX.load("../src/assets/sounds/blinks/change.ogg", function () {
					_this12.whatIsLoading = "Fauna";
				});

				this.plainsFX.load("../src/assets/sounds/modules/plains/lowogg/plainsFX.ogg", function () {
					_this12.whatIsLoading = "Soil";
				});

				this.ambience1Player.load("../src/assets/sounds/modules/plains/lowogg/birds.ogg", function () {
					_this12.whatIsLoading = "Birds";
				});

				this.ambience2Player.load("../src/assets/sounds/modules/plains/lowogg/birds2.ogg", function () {
					_this12.whatIsLoading = "Winds";
				});

				this.ambience3Player.load("../src/assets/sounds/modules/plains/lowogg/longgrass.ogg", function () {
					_this12.whatIsLoading = "Long Grass";
				});

				this.ambience4Player.load("../src/assets/sounds/modules/plains/lowogg/buffalo.ogg", function () {
					_this12.whatIsLoading = "Bison";
				});

				this.ambience5Player.load("../src/assets/sounds/modules/plains/lowogg/insects.ogg", function () {
					_this12.whatIsLoading = "Insects";
				});

				this.ambience6Player.load("../src/assets/sounds/modules/plains/lowogg/thunder.ogg", function () {
					_this12.whatIsLoading = "Thunderstorm";
				});
			} else if (isSafari === true || isEdge === true || isIE === true) {

				this.changeFX.load("../src/assets/sounds/blinks/change.m4a", function () {
					_this12.whatIsLoading = "Fauna";
				});

				this.plainsFX.load("../src/assets/sounds/modules/plains/320/plainsFX.m4a", function () {
					_this12.whatIsLoading = "Soil";
				});

				this.ambience1Player.load("../src/assets/sounds/modules/plains/320/birds.m4a", function () {
					_this12.whatIsLoading = "Birds";
				});

				this.ambience2Player.load("../src/assets/sounds/modules/plains/320/birds2.m4a", function () {
					_this12.whatIsLoading = "Winds";
				});

				this.ambience3Player.load("../src/assets/sounds/modules/plains/320/longgrass.m4a", function () {
					_this12.whatIsLoading = "Long Grass";
				});

				this.ambience4Player.load("../src/assets/sounds/modules/plains/320/buffalo.m4a", function () {
					_this12.whatIsLoading = "Bison";
				});

				this.ambience5Player.load("../src/assets/sounds/modules/plains/320/insects.m4a", function () {
					_this12.whatIsLoading = "Insects";
				});

				this.ambience6Player.load("../src/assets/sounds/modules/plains/320/thunder.m4a", function () {
					_this12.whatIsLoading = "Thunderstorm";
				});
			} else if (iOS === true) {
				this.changeFX.load("../src/assets/sounds/blinks/change.m4a", function () {
					_this12.whatIsLoading = "Fauna";
				});

				this.plainsFX.load("../src/assets/sounds/modules/plains/192/plainsFX.m4a", function () {
					_this12.whatIsLoading = "Soil";
				});

				this.ambience1Player.load("../src/assets/sounds/modules/plains/192/birds.m4a", function () {
					_this12.whatIsLoading = "Birds";
				});

				this.ambience2Player.load("../src/assets/sounds/modules/plains/192/birds2.m4a", function () {
					_this12.whatIsLoading = "Winds";
				});

				this.ambience3Player.load("../src/assets/sounds/modules/plains/192/longgrass.m4a", function () {
					_this12.whatIsLoading = "Long Grass";
				});

				this.ambience4Player.load("../src/assets/sounds/modules/plains/192/buffalo.m4a", function () {
					_this12.whatIsLoading = "Bison";
				});

				this.ambience5Player.load("../src/assets/sounds/modules/plains/192/insects.m4a", function () {
					_this12.whatIsLoading = "Insects";
				});

				this.ambience6Player.load("../src/assets/sounds/modules/plains/192/thunder.m4a", function () {
					_this12.whatIsLoading = "Thunderstorm";
				});
			}
		},

		//GO HOME
		goHome: function goHome() {
			var _this13 = this;

			this.changeFX.start();

			//IF USER ENGAGES VOICE CONTROL BUT GOES HOME VIA 
			//MOUSE BUTTON THIS TRIGGERS MODULE SPEECH DISPOSE
			if (this.goingHomeNotViaVoiceCommand && !this.initSpeech) {
				this.stopModuleSpeech = true;
				this.recognitionPlains.stop();
				this.recognitionPlains.abort();
				this.recognitionPlains = undefined;
			};

			if (this.didWeAdventure === true) {
				this.exploreSound1.disconnect();
				// this.exploreSound2.disconnect();
				// this.exploreSound3.disconnect();
			}

			setTimeout(function () {
				__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.2);
			}, 400);

			setTimeout(function () {
				_this13.ambience1Player.disconnect();
				_this13.ambience2Player.disconnect();
				_this13.ambience3Player.disconnect();
				_this13.ambience4Player.disconnect();
				_this13.ambience5Player.disconnect();
				_this13.ambience6Player.disconnect();
				_this13.plainsFX.disconnect();
				_this13.changeFX.disconnect();
				_this13.masterVolumeSub.disconnect();
				if (_this13.userMobile === false) {
					_this13.fxConvolver.disconnect();
					_this13.fxAutoFilter.disconnect();
					_this13.fxDelay.disconnect();
					_this13.fxChorus.disconnect();
					_this13.masterMeter.disconnect();
				}
			}, 1000);

			setTimeout(function () {
				document.body.className = 'default';
				_this13.$router.push('/');
				__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master.volume.value = 0;
			}, 1100);
		}
	}
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_startaudiocontext_StartAudioContext_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_startaudiocontext_StartAudioContext_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_startaudiocontext_StartAudioContext_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var XRegExp = __webpack_require__(5);
/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			//RANDOMIZE BOOLEANS
			randomizeBoolean: false,
			showFlask1: true,
			showFlask2: false,
			showFlask3: false,
			showFlask4: false,
			showFlask5: false,
			showFlask6: false,
			//CONTROLS
			reverbChecker: undefined,
			loadingBoolean: true,
			userMobile: Boolean,
			mailingListBtn: false,
			textTiming: 500,
			startStopTrigger: true,
			playColor: "#F0CB50",
			stopColor: "#1E9BFC",
			//SCREEN DIMENSIONS
			screenHeight: undefined,
			screenWidth: undefined,
			ogWidth: undefined,
			//BACKGROUND COLORS
			plungeDepth: 1,
			backgroundColor1: true,
			backgroundColor2: false,
			backgroundColor3: false,
			backgroundColor4: false,
			backgroundColor5: false,
			backgroundColor6: false,
			backgroundColor7: false,
			backgroundColor8: false,
			backgroundColor9: false,
			backgroundColor10: false,
			//REACTIVE SUN
			sunReactiveColor1: true,
			sunReactiveColor2: false,
			sunReactiveColor3: false,
			sunReactiveColor4: false,
			sunReactiveColor5: false,
			sunReactiveColor6: false,
			sunReactiveColor7: false,
			sunReactiveColor8: false,
			sunReactiveColor9: false,
			sunReactiveColor10: false,
			//SHOW AND HIDE
			helpTrigger: false,
			showHelpOverlay: false,
			showAboutPage: false,

			bellBoolean: false,
			//PLAY SUN DRAGGIE
			activeSun: false,
			//V-SHOWS
			showEnterContainer: true,
			showLoading: true,
			showEnterBtn: false,
			showNavBar: false,
			showAllControls: false,
			showSpeechBtns: false,
			//AMBIENCE BOOLEANS
			ambience1Boolean: false,
			ambience2Boolean: false,
			ambience3Boolean: false,
			ambience4Boolean: false,
			ambience5Boolean: false,
			ambience6Boolean: false,
			//AMBIENCE DATA
			whatIsLoading: "Small Town",
			ruralFX: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": false,
				"volume": 2
			}).toMaster(),
			changeFX: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": false,
				"volume": -6
			}).toMaster(),
			ambience1Vol: -10,
			ambience2Vol: -10,
			ambience3Vol: -10,
			ambience4Vol: -10,
			ambience5Vol: -10,
			ambience6Vol: -10,
			ambience1Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": 0
			}),
			ambience2Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": 0
			}),
			ambience3Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": 0
			}),
			ambience4Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": 0
			}),
			ambience5Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": 0
			}),
			ambience6Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": 0
			}),
			//AUDIO ROUTING & EFFECTS
			playBackSpeed: 1,
			fxDecay: 6,
			// masterVolume:     		0,
			loadingSoundID: undefined,
			audioLoading: undefined,
			fxConvolverAmt: 0,
			fxChorusAmt: 0,
			fxDelayAmt: 0,
			fxAutoFilterAmt: 3500,
			mattChill: false,
			fxConvolver: undefined,
			fxChorus: undefined,
			fxDistort: undefined,
			fxDelay: undefined,
			fxAutoFilter: undefined,

			speedToggle: true,
			fxDelayToggle: true,
			fxConvolverToggle: true,
			fxChorusToggle: true,
			fxFilterToggle: false,

			masterMeter: undefined,
			masterLevel: 0,
			masterVolumeSub: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Volume(0),
			//SPEECH
			//FOR SPEECH FORM INPUT
			submitSpeechTxttoVoice: false,
			userVoiceToText: "",
			//IF SPEECH IS ALLOWED SHOW SPEECH ACTIVATE BUTTON (SET VIA APP.js)
			allowSpeechControl: false,
			//GLOBAL COMMAND TRIGGERING VOICE COMMANDS ON AND OFF
			isVoiceControl: false,
			//COMMAND FOR CSS CONTROL WHEN VOICE IS ACTIVE OR NOT
			recognizing: undefined,
			recognitionRural: undefined,
			//HOLDS ALL OF SPEECHRECONGNITION JSON
			voiceCommandArray: undefined,
			speechRecognitionList: undefined,
			voiceCommandConfidence: undefined,
			//STRING LINE TO TEST FOR VOICE COMMAND ACTIONS
			testObjectVUI: "",
			//BUTTON SWITCHING & TEXT
			initSpeech: true,
			speechBtnTxt: "Say A Command",
			speechStartTopBtnTrigger: true,
			//SHOWS LIST OF COMMANDS
			showVoiceCommandList: false,
			//DISABLE WHILE RECORDING
			isDisableListening: false,
			//TRUE WHEN STOPPING ALL SPEECH FUNCTIONS TO GO HOME
			stopModuleSpeech: false,
			//IF USER ENGAGES VOICE CONTROL BUT GOES HOME VIA MOUSE BUTTON THIS TRIGGERS MODULE SPEECH DISPOSE
			//EXPLORE
			isExploreFuncRunning: false,
			didWeAdventure: false,
			exploreSound1: undefined,
			exploreBtnBoolean: false,
			//WHAT DEVICE
			isChrome: Boolean,
			isFirefox: Boolean,
			isSafari: Boolean,
			isOpera: Boolean,
			isIE: Boolean,
			isEdge: Boolean,
			isBlink: Boolean,
			iOS: Boolean,
			AndroidMobile: Boolean,
			//EXPLORE TIMES OUTS
			exploreTxt: "Explore!",
			exploreTimeout1: undefined,
			exploreTimeout2: undefined,
			//START AUDIO CONTEXT BOOLEAN
			startAudioBoolean: true,
			//LOCAL STORAGE
			isCacheSaved: false,
			firstLoad: false,
			saveTrigger: false,
			loadTrigger: false
		};
	},
	created: function created() {
		var _this = this;

		this.isVoiceControl = this.$store.state.isVoiceControlled;
		if (this.isVoiceControl) {
			this.$store.state.doNotAddress = true;
		}
		window.onpopstate = function () {
			document.body.className = 'default';
			_this.goHome();
		};
		var ua = window.navigator.userAgent;
		this.isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
		this.isFirefox = typeof InstallTrigger !== 'undefined';
		this.isSafari = /constructor/i.test(window.HTMLElement) || function (p) {
			return p.toString() === "[object SafariRemoteNotification]";
		}(!window['safari'] || safari.pushNotification);
		this.isOpera = !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
		this.isIE = /*@cc_on!@*/false || !!document.documentMode;
		this.isEdge = !this.isIE && !!window.StyleMedia;
		this.isBlink = (this.isChrome || this.isOpera) && !!window.CSS, this.iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
		this.AndroidMobile = /Android/i.test(navigator.userAgent);
		//CHROME ALLOWS SPEECH AND MEDIA RECORDING
		if (this.isChrome === true) {
			this.userMobile = false;
			//FIREFOX ONLY ALLOWS MEDIA RECORDING
		} else if (this.isFirefox === true) {
			this.userMobile = false;
			//NO SPEECH AND NO MEDIA RECORDING FOR THE FOLLOWING
		} else if (this.AndroidMobile === true || this.iOS) {
			this.userMobile = true;
		} else if (this.isSafari === true || this.isOpera === true || this.isBlink === true || this.isEdge === true || this.isIE === true) {
			this.userMobile = false;
		}
		this.firstAudioLoadFunc();
		this.bufferLoading();
		this.audioRouting();
	},

	computed: {
		//THE PLUNGE BACKGROUND CHANGE
		plungeClass: function plungeClass() {
			if (this.activeSun === false) {
				if (this.plungeDepth === 1) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = true;
				} else if (this.plungeDepth === 2) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = true;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 3) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = true;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 4) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = true;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 5) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = true;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 6) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = true;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 7) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = true;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 8) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = true;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 9) {
					this.backgroundColor10 = false;
					this.backgroundColor9 = true;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 10) {
					this.backgroundColor10 = true;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				}
				return {
					"backgroundColorRural10": this.backgroundColor10,
					"backgroundColorRural9": this.backgroundColor9,
					"backgroundColorRural8": this.backgroundColor8,
					"backgroundColorRural7": this.backgroundColor7,
					"backgroundColorRural6": this.backgroundColor6,
					"backgroundColorRural5": this.backgroundColor5,
					"backgroundColorRural4": this.backgroundColor4,
					"backgroundColorRural3": this.backgroundColor3,
					"backgroundColorRural2": this.backgroundColor2,
					"backgroundColorRural1": this.backgroundColor1
				};
			} else if (this.activeSun === true) {
				if (this.masterLevel < -36) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = true;
				} else if (this.masterLevel < -32) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = true;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -30) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = true;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -28) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = true;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -26) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = true;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -24) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = true;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -22) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = true;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -20) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = true;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel < -18) {
					this.sunReactiveColor10 = false;
					this.sunReactiveColor9 = true;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				} else if (this.masterLevel > -16) {
					this.sunReactiveColor10 = true;
					this.sunReactiveColor9 = false;
					this.sunReactiveColor8 = false;
					this.sunReactiveColor7 = false;
					this.sunReactiveColor6 = false;
					this.sunReactiveColor5 = false;
					this.sunReactiveColor4 = false;
					this.sunReactiveColor3 = false;
					this.sunReactiveColor2 = false;
					this.sunReactiveColor1 = false;
				}
				return {
					"sunReactiveColorClassRural10": this.sunReactiveColor10,
					"sunReactiveColorClassRural9": this.sunReactiveColor9,
					"sunReactiveColorClassRural8": this.sunReactiveColor8,
					"sunReactiveColorClassRural7": this.sunReactiveColor7,
					"sunReactiveColorClassRural6": this.sunReactiveColor6,
					"sunReactiveColorClassRural5": this.sunReactiveColor5,
					"sunReactiveColorClassRural4": this.sunReactiveColor4,
					"sunReactiveColorClassRural3": this.sunReactiveColor3,
					"sunReactiveColorClassRural2": this.sunReactiveColor2,
					"sunReactiveColorClassRural1": this.sunReactiveColor1
				};
			}
		},

		//SHOW AND HIDE CLASS CHANGES
		helpClass: function helpClass() {
			return {
				"btn btn-helpBtn1Rural": this.helpTrigger,
				"btn btn-helpBtn2Rural": !this.helpTrigger
			};
		},
		mailingListBtnClass: function mailingListBtnClass() {
			return {
				"btn btn-transparent": this.mailingListBtn,
				"btn btn-info": !this.mailingListBtn
			};
		},

		//AMBIENCE CLASS CHANGES
		ambience1Class: function ambience1Class() {
			return {
				"btn btn-playRural": this.ambience1Boolean,
				"btn btn-stopRural": !this.ambience1Boolean
			};
		},
		ambience2Class: function ambience2Class() {
			return {
				"btn btn-playRural": this.ambience2Boolean,
				"btn btn-stopRural": !this.ambience2Boolean
			};
		},
		ambience3Class: function ambience3Class() {
			return {
				"btn btn-playRural": this.ambience3Boolean,
				"btn btn-stopRural": !this.ambience3Boolean
			};
		},
		ambience4Class: function ambience4Class() {
			return {
				"btn btn-playRural": this.ambience4Boolean,
				"btn btn-stopRural": !this.ambience4Boolean
			};
		},
		ambience5Class: function ambience5Class() {
			return {
				"btn btn-playRural": this.ambience5Boolean,
				"btn btn-stopRural": !this.ambience5Boolean
			};
		},
		ambience6Class: function ambience6Class() {
			return {
				"btn btn-playRural": this.ambience6Boolean,
				"btn btn-stopRural": !this.ambience6Boolean
			};
		},
		mattChillClass: function mattChillClass() {
			return {
				"btn btn-mattChillOnRural": this.mattChill,
				"btn btn-mattChillOffRural": !this.mattChill
			};
		},

		//AMBIENCE ICON CSS
		ambience1Icon: function ambience1Icon() {
			return {
				"fal fa-times-circle": !this.ambience1Boolean,
				"fal fa-check-circle": this.ambience1Boolean
			};
		},
		ambience2Icon: function ambience2Icon() {
			return {
				"fal fa-times-circle": !this.ambience2Boolean,
				"fal fa-check-circle": this.ambience2Boolean
			};
		},
		ambience3Icon: function ambience3Icon() {
			return {
				"fal fa-times-circle": !this.ambience3Boolean,
				"fal fa-check-circle": this.ambience3Boolean
			};
		},
		ambience4Icon: function ambience4Icon() {
			return {
				"fal fa-times-circle": !this.ambience4Boolean,
				"fal fa-check-circle": this.ambience4Boolean
			};
		},
		ambience5Icon: function ambience5Icon() {
			return {
				"fal fa-times-circle": !this.ambience5Boolean,
				"fal fa-check-circle": this.ambience5Boolean
			};
		},
		ambience6Icon: function ambience6Icon() {
			return {
				"fal fa-times-circle": !this.ambience6Boolean,
				"fal fa-check-circle": this.ambience6Boolean
			};
		},

		//AMBIANCE CLASS CHANGES
		ambiance1RangerClass: function ambiance1RangerClass() {
			return {
				"ambianceRangerPlayRural": this.ambience1Boolean,
				"ambianceRangerStopRural": !this.ambience1Boolean
			};
		},
		ambiance2RangerClass: function ambiance2RangerClass() {
			return {
				"ambianceRangerPlayRural": this.ambience2Boolean,
				"ambianceRangerStopRural": !this.ambience2Boolean
			};
		},
		ambiance3RangerClass: function ambiance3RangerClass() {
			return {
				"ambianceRangerPlayRural": this.ambience3Boolean,
				"ambianceRangerStopRural": !this.ambience3Boolean
			};
		},
		ambiance4RangerClass: function ambiance4RangerClass() {
			return {
				"ambianceRangerPlayRural": this.ambience4Boolean,
				"ambianceRangerStopRural": !this.ambience4Boolean
			};
		},
		ambiance5RangerClass: function ambiance5RangerClass() {
			return {
				"ambianceRangerPlayRural": this.ambience5Boolean,
				"ambianceRangerStopRural": !this.ambience5Boolean
			};
		},
		ambiance6RangerClass: function ambiance6RangerClass() {
			return {
				"ambianceRangerPlayRural": this.ambience6Boolean,
				"ambianceRangerStopRural": !this.ambience6Boolean
			};
		},

		//AUDIO MIXING
		adjustInputVolume: function adjustInputVolume() {
			this.userMic.volume.value = this.userMicInputLevel;
		},
		fxConvolverMix: function fxConvolverMix() {
			if (this.userMobile === false) {
				if (this.fxConvolverToggle === true) {
					this.fxConvolver.wet.setTargetAtTime(this.fxConvolverAmt / 100, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				} else if (this.fxConvolverToggle === false) {
					this.fxConvolver.wet.setTargetAtTime(0, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				}
			}
		},
		fxDelayMix: function fxDelayMix() {
			if (this.userMobile === false) {
				if (this.fxDelayToggle === true) {
					this.fxDelay.wet.setTargetAtTime(this.fxDelayAmt / 100, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +1);
				} else if (this.fxDelayToggle === false) {
					this.fxDelay.wet.setTargetAtTime(0, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +1);
				}
			}
		},
		fxChorusMix: function fxChorusMix() {
			if (this.userMobile === false) {
				if (this.fxChorusToggle === true) {
					this.fxChorus.wet.setTargetAtTime(this.fxChorusAmt / 100, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				} else if (this.fxChorusToggle === false) {
					this.fxChorus.wet.setTargetAtTime(0, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				}
			}
		},
		fxAutoFilterMix: function fxAutoFilterMix() {
			if (this.userMobile === false) {
				if (this.fxFilterToggle === true) {
					this.fxAutoFilter.frequency.setTargetAtTime(this.fxAutoFilterAmt, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				} else if (this.fxFilterToggle === false) {
					this.fxAutoFilter.frequency.setTargetAtTime(20000, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				}
			}
		},
		playbackSpeedFunc: function playbackSpeedFunc() {
			if (this.speedToggle === true) {
				this.ambience1Player.playbackRate = this.playBackSpeed;
				this.ambience2Player.playbackRate = this.playBackSpeed;
				this.ambience3Player.playbackRate = this.playBackSpeed;
				this.ambience4Player.playbackRate = this.playBackSpeed;
				this.ambience5Player.playbackRate = this.playBackSpeed;
				this.ambience6Player.playbackRate = this.playBackSpeed;
			} else if (this.speedToggle === false) {
				this.ambience1Player.playbackRate = 1;
				this.ambience2Player.playbackRate = 1;
				this.ambience3Player.playbackRate = 1;
				this.ambience4Player.playbackRate = 1;
				this.ambience5Player.playbackRate = 1;
				this.ambience6Player.playbackRate = 1;
			}
		},

		//SPEECH
		speechStartStopClass: function speechStartStopClass() {
			return {
				"recordingClassEngagedRural": this.recognizing,
				"recordingClassDisengagedRural": !this.recognizing
			};
		},
		speechIconClass: function speechIconClass() {
			return {
				"fa fa-microphone-alt fa-spin": this.recognizing,
				"fa fa-microphone-alt": !this.recognizing
			};
		},
		speechShowListClass: function speechShowListClass() {
			return {
				"recordingClassEngagedRural": this.showVoiceCommandList,
				"recordingClassDisengagedRural": !this.showVoiceCommandList
			};
		},
		speechSubmitClass: function speechSubmitClass() {
			return {
				"btn btn-speechSubmitOn mb-2": this.submitSpeechTxttoVoice,
				"btn btn-speechSubmitOff mb-2": !this.submitSpeechTxttoVoice
			};
		},

		//EXPLORE
		exploreFuncClass: function exploreFuncClass() {
			return {
				"recordingClassDisengagedRural": !this.isExploreFuncRunning,
				"recordingClassEngagedRural": this.isExploreFuncRunning
			};
		},
		exploreIconClass: function exploreIconClass() {
			return {
				"fab fa-wpexplorer": !this.isExploreFuncRunning,
				"fab fa-wpexplorer fa-spin": this.isExploreFuncRunning
			};
		},

		//AMBIENCE PLAY AND STOPS
		ambience1Func: function ambience1Func() {
			if (this.ambience1Boolean === true) {
				this.ambience1Player.volume.value = this.ambience1Vol;
			} else if (this.ambience1Boolean === false) {
				this.ambience1Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},
		ambience2Func: function ambience2Func() {
			if (this.ambience2Boolean === true) {
				this.ambience2Player.volume.value = this.ambience2Vol;
			} else if (this.ambience2Boolean === false) {
				this.ambience2Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},
		ambience3Func: function ambience3Func() {
			if (this.ambience3Boolean === true) {
				this.ambience3Player.volume.value = this.ambience3Vol;
			} else if (this.ambience3Boolean === false) {
				this.ambience3Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},
		ambience4Func: function ambience4Func() {
			if (this.ambience4Boolean === true) {
				this.ambience4Player.volume.value = this.ambience4Vol;
			} else if (this.ambience4Boolean === false) {
				this.ambience4Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},
		ambience5Func: function ambience5Func() {
			if (this.ambience5Boolean === true) {
				this.ambience5Player.volume.value = this.ambience5Vol;
			} else if (this.ambience5Boolean === false) {
				this.ambience5Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},
		ambience6Func: function ambience6Func() {
			if (this.ambience6Boolean === true) {
				this.ambience6Player.volume.value = this.ambience6Vol;
			} else if (this.ambience6Boolean === false) {
				this.ambience6Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
			}
		},

		//LOCAL STORAGE
		saveClass: function saveClass() {
			return { "btn btn-playRural": this.saveTrigger,
				"btn btn-stopRural": !this.saveTrigger };
		},
		loadClass: function loadClass() {
			return { "btn btn-playRural": this.loadTrigger,
				"btn btn-stopRural": !this.loadTrigger };
		}
	},
	methods: {
		//LOCAL STORAGE
		setLocalStorage: function setLocalStorage() {
			var _this2 = this;

			this.saveTrigger = true;
			setTimeout(function () {
				_this2.saveTrigger = false;
			}, 250);

			this.removeLocalStorage();

			localStorage.setItem('isCacheSavedRural', JSON.stringify(true));

			localStorage.setItem('ambience1VolRural', JSON.stringify(this.ambience1Vol));
			localStorage.setItem('ambience2VolRural', JSON.stringify(this.ambience2Vol));
			localStorage.setItem('ambience3VolRural', JSON.stringify(this.ambience3Vol));
			localStorage.setItem('ambience4VolRural', JSON.stringify(this.ambience4Vol));
			localStorage.setItem('ambience5VolRural', JSON.stringify(this.ambience5Vol));
			localStorage.setItem('ambience6VolRural', JSON.stringify(this.ambience6Vol));

			localStorage.setItem('ambience1BooleanRural', JSON.stringify(this.ambience1Boolean));
			localStorage.setItem('ambience2BooleanRural', JSON.stringify(this.ambience2Boolean));
			localStorage.setItem('ambience3BooleanRural', JSON.stringify(this.ambience3Boolean));
			localStorage.setItem('ambience4BooleanRural', JSON.stringify(this.ambience4Boolean));
			localStorage.setItem('ambience5BooleanRural', JSON.stringify(this.ambience5Boolean));
			localStorage.setItem('ambience6BooleanRural', JSON.stringify(this.ambience6Boolean));

			localStorage.setItem('speedToggleRural', JSON.stringify(this.speedToggle));
			localStorage.setItem('fxDelayToggleRural', JSON.stringify(this.fxDelayToggle));
			localStorage.setItem('fxConvolverToggleRural', JSON.stringify(this.fxConvolverToggle));
			localStorage.setItem('fxChorusToggleRural', JSON.stringify(this.fxChorusToggle));
			localStorage.setItem('fxFilterToggleRural', JSON.stringify(this.fxFilterToggle));

			localStorage.setItem('playBackSpeed', JSON.stringify(this.playBackSpeed));
			localStorage.setItem('fxConvolverAmtRural', JSON.stringify(this.fxConvolverAmt));
			localStorage.setItem('fxChorusAmtRural', JSON.stringify(this.fxChorusAmt));
			localStorage.setItem('fxDelayAmtRural', JSON.stringify(this.fxDelayAmt));
			localStorage.setItem('fxAutoFilterAmtRural', JSON.stringify(this.fxAutoFilterAmt));
		},
		getLocalStorage: function getLocalStorage() {
			var _this3 = this;

			this.isCacheSaved = JSON.parse(localStorage.getItem('isCacheSavedRural'));
			if (this.isCacheSaved) {
				this.loadTrigger = true;
				setTimeout(function () {
					_this3.loadTrigger = false;
				}, 250);

				this.ambience1Vol = JSON.parse(localStorage.getItem('ambience1VolRural'));
				this.ambience2Vol = JSON.parse(localStorage.getItem('ambience2VolRural'));
				this.ambience3Vol = JSON.parse(localStorage.getItem('ambience3VolRural'));
				this.ambience4Vol = JSON.parse(localStorage.getItem('ambience4VolRural'));
				this.ambience5Vol = JSON.parse(localStorage.getItem('ambience5VolRural'));
				this.ambience6Vol = JSON.parse(localStorage.getItem('ambience6VolRural'));

				this.ambience1Boolean = JSON.parse(localStorage.getItem('ambience1BooleanRural'));
				this.ambience2Boolean = JSON.parse(localStorage.getItem('ambience2BooleanRural'));
				this.ambience3Boolean = JSON.parse(localStorage.getItem('ambience3BooleanRural'));
				this.ambience4Boolean = JSON.parse(localStorage.getItem('ambience4BooleanRural'));
				this.ambience5Boolean = JSON.parse(localStorage.getItem('ambience5BooleanRural'));
				this.ambience6Boolean = JSON.parse(localStorage.getItem('ambience6BooleanRural'));

				this.speedToggle = JSON.parse(localStorage.getItem('speedToggleRural'));
				this.fxDelayToggle = JSON.parse(localStorage.getItem('fxDelayToggleRural'));
				this.fxConvolverToggle = JSON.parse(localStorage.getItem('fxConvolverToggleRural'));
				this.fxChorusToggle = JSON.parse(localStorage.getItem('fxChorusToggleRural'));
				this.fxFilterToggle = JSON.parse(localStorage.getItem('fxFilterToggleRural'));

				this.playBackSpeed = JSON.parse(localStorage.getItem('playBackSpeed'));;
				this.fxConvolverAmt = JSON.parse(localStorage.getItem('fxConvolverAmtRural'));
				this.fxChorusAmt = JSON.parse(localStorage.getItem('fxChorusAmtRural'));
				this.fxDelayAmt = JSON.parse(localStorage.getItem('fxDelayAmtRural'));
				this.fxAutoFilterAmt = JSON.parse(localStorage.getItem('fxAutoFilterAmtRural'));
			}
		},
		removeLocalStorage: function removeLocalStorage() {
			localStorage.removeItem('isCacheSavedRural');

			localStorage.removeItem('ambience1VolRural');
			localStorage.removeItem('ambience2VolRural');
			localStorage.removeItem('ambience3VolRural');
			localStorage.removeItem('ambience4VolRural');
			localStorage.removeItem('ambience5VolRural');
			localStorage.removeItem('ambience6VolRural');

			localStorage.removeItem('ambience1BooleanRural');
			localStorage.removeItem('ambience2BooleanRural');
			localStorage.removeItem('ambience3BooleanRural');
			localStorage.removeItem('ambience4BooleanRural');
			localStorage.removeItem('ambience5BooleanRural');
			localStorage.removeItem('ambience6BooleanRural');

			localStorage.removeItem('speedToggleRural');
			localStorage.removeItem('fxDelayToggleRural');
			localStorage.removeItem('fxConvolverToggleRural');
			localStorage.removeItem('fxChorusToggleRural');
			localStorage.removeItem('fxFilterToggleRural');

			localStorage.removeItem('playBackSpeedRural');
			localStorage.removeItem('fxConvolverAmtRural');
			localStorage.removeItem('fxChorusAmtRural');
			localStorage.removeItem('fxDelayAmtRural');
			localStorage.removeItem('fxAutoFilterAmtRural');
		},

		//START AUDIO
		startAudio: function startAudio() {
			if (this.firstLoad) {
				this.firstLoad = false;
				__WEBPACK_IMPORTED_MODULE_0__node_modules_startaudiocontext_StartAudioContext_js___default()(__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.context, "#enterFuncBtn");
				this.$store.state.hasAudioContextTriggered = true;
			}
			this.ambience1Player.volume.value = -100;
			this.ambience2Player.volume.value = -100;
			this.ambience3Player.volume.value = -100;
			this.ambience4Player.volume.value = -100;
			this.ambience5Player.volume.value = -100;
			this.ambience6Player.volume.value = -100;

			this.ambience1Player.start();
			this.ambience2Player.start();
			this.ambience3Player.start();
			this.ambience4Player.start();
			this.ambience5Player.start();
			this.ambience6Player.start();
		},
		stopAudio: function stopAudio() {
			this.ambience1Player.stop();
			this.ambience2Player.stop();
			this.ambience3Player.stop();
			this.ambience4Player.stop();
			this.ambience5Player.stop();
			this.ambience6Player.stop();
		},

		//SPEECH
		userVoiceToTextFunc: function userVoiceToTextFunc() {
			var _this4 = this;

			this.submitSpeechTxttoVoice = true;
			this.testObjectVUI = this.userVoiceToText;
			console.log(this.testObjectVUI);
			this.sourceSortingVUI();
			setTimeout(function () {
				_this4.submitSpeechTxttoVoice = false;
			}, 250);
		},
		speechFunc: function speechFunc() {
			var _this5 = this;

			if (this.initSpeech === true) {
				this.recognitionRural = new webkitSpeechRecognition();
				this.recognizing;
				this.recognitionRural.continuous = false;
				this.recognitionRural.interimResults = true;

				this.recognitionRural.onresult = function (event) {
					for (var i = event.resultIndex; i < event.results.length; ++i) {
						if (event.results[i].isFinal) {
							if (!_this5.isDisableListening) {
								_this5.testObjectVUI += event.results[i][0].transcript;
								console.log('Speech String Command: ' + event.results[i][0].transcript);
								_this5.sourceSortingVUI();
							}
						}
					}
				};
				this.recognitionRural.onspeechend = function () {
					console.log('%c Rural Module SPEECH Ended', 'background: red; color: black');
					// setTimeout(this.sourceSortingVUI, 500);
					_this5.recognizing = false;
					_this5.speechBtnTxt = "Say A Command";
					__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master.volume.setTargetAtTime(0, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.context.currentTime, +0.5);
				};
				this.recognitionRural.onspeechstart = function () {
					console.log('%c Rural Module SPEECH Began', 'background: green; color: white');
					_this5.recognizing = true;
					_this5.speechBtnTxt = "Listening For Command";
					__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master.volume.setTargetAtTime(-10, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.context.currentTime, +1);
				};
				this.recognitionRural.onsoundstart = function () {
					console.log('%c Rural Module LISTENING Began', 'background: green; color: white');
				};
				this.recognitionRural.onaudioend = function () {
					console.log('%c Rural Module LISTENING Ended', 'background: green; color: white');
					// setTimeout(this.sourceSortingVUI, 500);
					_this5.recognizing = false;
					_this5.speechBtnTxt = "Say A Command";
				};
				this.recognitionRural.onend = function () {
					console.log('%c Rural Module SPEECH SESSION ENDED', 'background: green; color: white');
					if (_this5.stopModuleSpeech === false) {
						_this5.recognitionRural.start();
					}
				};
				this.recognizing = true;
				//MAKE SURE SPEECH IS NOT RE-ENGAGED
				this.initSpeech = false;
				//GLOBAL VOICE COMMAND IS SET TO TRUE
				this.$store.state.isVoiceControlled = true;
				this.recognitionRural.start();
				//IF USER ENGAGES VOICE CONTROL BUT GOES HOME VIA MOUSE BUTTON THIS TRIGGERS MODULE SPEECH DISPOSE
				this.goingHomeNotViaVoiceCommand = true;
				//CONTROLS recognition.onend TO RESTART LISTENING
				this.stopModuleSpeech = false;
				//TURN LISTENING BACK ON
				this.isDisableListening = false;
				//IF BEING VOICE CONTROLLED DON'T PLAY THE NICE, TELL ME WHERE YOU WANT TO GO PROMPT ON WELCOME PAGE
				this.$store.state.doNotAddress = true;
			} else if (this.initSpeech === false) {}
		},
		resetFunc: function resetFunc() {
			this.recognizing = false;
		},
		speechStartStopFunc: function speechStartStopFunc() {
			this.speechStartTopBtnTrigger = !this.speechStartTopBtnTrigger;

			if (this.speechStartTopBtnTrigger === true) {
				this.speechFunc();
			} else if (this.speechStartTopBtnTrigger === false) {
				this.initSpeech = true;
				this.stopModuleSpeech = true;
				this.recognizing = false;
				this.recognitionRural.stop();
				this.$store.state.isVoiceControlled = false;
			}
		},
		sourceSortingVUI: function sourceSortingVUI() {
			//FOR VISUAL REFERENCE
			this.userVoiceToText = this.testObjectVUI;

			var source1RegEx = XRegExp.build('(?x) {{source1Name}} | {{label1Name}}', {
				source1Name: XRegExp.build('{{source1Name1}} | {{source1Name2}}', {
					source1Name1: /source\sone/,
					source1Name2: /source\s1/
				}),
				label1Name: XRegExp.build('{{label1Name1}} | {{label1Name2}}', {
					label1Name1: /hillsides?/,
					label1Name2: /hills?/
				})
			}, 'xgi');

			var source2RegEx = XRegExp.build('(?x) {{source2Name}} | {{label2Name}}', {
				source2Name: XRegExp.build('{{source2Name1}} | {{source2Name2}}', {
					source2Name1: /source\stw?o?o/,
					source2Name2: /source\s2/
				}),
				label2Name: XRegExp.build('{{label2Name1}} | {{label2Name2}}', {
					label2Name1: /highways?|interstate|freeway/,
					label2Name2: /cars?/
				})
			}, 'xgi');

			var source3RegEx = XRegExp.build('(?x) {{source3Name}} | {{label3Name}}', {
				source3Name: XRegExp.build('{{source3Name1}} | {{source3Name2}}', {
					source3Name1: /source\sthree/,
					source3Name2: /source\s3/
				}),
				label3Name: XRegExp.build('{{label3Name1}} | {{label3Name2}}', {
					label3Name1: /mowers?/,
					label3Name2: /mowing/
				})
			}, 'xgi');

			var source4RegEx = XRegExp.build('(?x) {{source4Name}} | {{label4Name}}', {
				source4Name: XRegExp.build('{{source4Name1}} | {{source4Name2}}', {
					source4Name1: /source\sfou?re?/,
					source4Name2: /source\s4/
				}),
				label4Name: XRegExp.build('{{label4Name1}}', {
					label4Name1: /field|peacef?u?l?|piece/
				})
			}, 'xgi');

			var source5RegEx = XRegExp.build('(?x) {{source5Name}} | {{label5Name}}', {
				source5Name: XRegExp.build('{{source5Name1}} | {{source5Name2}}', {
					source5Name1: /source\sfive/,
					source5Name2: /source\s5/
				}),
				label5Name: XRegExp.build('{{label5Name1}} | {{label5Name2}}', {
					label5Name1: /trains?|horns?/,
					label5Name2: /locomotives?/
				})
			}, 'xgi');

			var source6RegEx = XRegExp.build('(?x) {{source6Name}} | {{label6Name}}', {
				source6Name: XRegExp.build('{{source6Name1}} | {{source6Name2}}', {
					source6Name1: /source\ss[ei]x/,
					source6Name2: /source\s6/
				}),
				label6Name: XRegExp.build('{{label6Name1}} | {{label6Name2}}', {
					label6Name1: /churche?s?/,
					label6Name2: /bells?|bell\stower/
				})
			}, 'xgi');
			//ALL SOUNDS
			var allSoundRegEx = XRegExp.build('(?x) {{allSoundName}}', {
				allSoundName: XRegExp.build('{{allSoundName1}} | {{allSoundName2}}', {
					allSoundName1: /all\ssounds?/,
					allSoundName2: /all\saudios?/
				})
			}, 'xgi');
			//SPEED
			var speedRegEx = XRegExp.build('(?x) {{speedName}}', {
				speedName: XRegExp.build('{{speedName1}} | {{speedName2}}', {
					speedName1: /speeds?/,
					speedName2: /slow|faster/
				})
			}, 'xgi');
			//DELAY
			var delayRegEx = XRegExp.build('(?x) {{delayName}}', {
				delayName: XRegExp.build('{{delayName1}} | {{delayName2}}', {
					delayName1: /delay/,
					delayName2: /lay/
				})
			}, 'xgi');
			//CHORUS
			var chorusRegEx = XRegExp.build('(?x) {{chorusName}}', {
				chorusName: XRegExp.build('{{chorusName1}} | {{chorusName2}}', {
					chorusName1: /chorus?/,
					chorusName2: /course/
				})
			}, 'xgi');
			//FILTER
			var filterRegEx = XRegExp.build('(?x) {{filterName}}', {
				filterName: XRegExp.build('{{filterName1}} | {{filterName2}}', {
					filterName1: /filter/,
					filterName2: /filter/
				})
			}, 'xgi');
			//REVERB
			var reverbRegEx = XRegExp.build('(?x) {{reverbName}}', {
				reverbName: XRegExp.build('{{reverbName1}} | {{reverbName2}}', {
					reverbName1: /verb/,
					reverbName2: /reverb/
				})
			}, 'xgi');
			//SHOW
			var infoRegEx = XRegExp.build('(?x) {{showName}}', {
				showName: XRegExp.build('{{showName1}} | {{showName2}}', {
					showName1: /info/,
					showName2: /information/
				})
			}, 'xgi');
			// console.log(infoRegEx);
			//HIDE
			var listRegEx = XRegExp.build('(?x) {{hideName}}', {
				hideName: XRegExp.build('{{hideName1}} | {{hideName2}}', {
					hideName1: /lists?/,
					hideName2: /menu/
				})
			}, 'xgi');
			// console.log(listRegEx);			

			var source1Boolean = source1RegEx.test(this.testObjectVUI);
			var source2Boolean = source2RegEx.test(this.testObjectVUI);
			var source3Boolean = source3RegEx.test(this.testObjectVUI);
			var source4Boolean = source4RegEx.test(this.testObjectVUI);
			var source5Boolean = source5RegEx.test(this.testObjectVUI);
			var source6Boolean = source6RegEx.test(this.testObjectVUI);
			var allSoundBoolean = allSoundRegEx.test(this.testObjectVUI);
			var speedBoolean = speedRegEx.test(this.testObjectVUI);
			var delayBoolean = delayRegEx.test(this.testObjectVUI);
			var chorusBoolean = chorusRegEx.test(this.testObjectVUI);
			var filterBoolean = filterRegEx.test(this.testObjectVUI);
			var reverbBoolean = reverbRegEx.test(this.testObjectVUI);
			var infoBoolean = infoRegEx.test(this.testObjectVUI);
			var listBoolean = listRegEx.test(this.testObjectVUI);

			if (source1Boolean) {
				this.source1VUI();
			} else if (source2Boolean) {
				this.source2VUI();
			} else if (source3Boolean) {
				this.source3VUI();
			} else if (source4Boolean) {
				this.source4VUI();
			} else if (source5Boolean) {
				this.source5VUI();
			} else if (source6Boolean) {
				this.source6VUI();
			} else if (allSoundBoolean) {
				this.allSoundVUI();
			} else if (speedBoolean) {
				this.speedVUI();
			} else if (delayBoolean) {
				this.delayVUI();
			} else if (chorusBoolean) {
				this.chorusVUI();
			} else if (filterBoolean) {
				this.filterVUI();
			} else if (reverbBoolean) {
				this.reverbVUI();
			} else if (infoBoolean) {
				this.infoVUI();
			} else if (listBoolean) {
				this.listVUI();
			} else {
				this.miscVUI();
			}
		},
		source1VUI: function source1VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience1Player.start();
				this.ambience1Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience1Player.stop();
				this.ambience1Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience1Vol < 0) {
						this.ambience1Vol += 12;
					}
				} else {
					if (this.ambience1Vol < 0) {
						this.ambience1Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience1Vol > -30) {
						this.ambience1Vol -= 12;
					}
				} else {
					if (this.ambience1Vol > -30) {
						this.ambience1Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		source2VUI: function source2VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience2Player.start();
				this.ambience2Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience2Player.stop();
				this.ambience2Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience2Vol < 0) {
						this.ambience2Vol += 12;
					}
				} else {
					if (this.ambience2Vol < 0) {
						this.ambience2Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience2Vol > -30) {
						this.ambience2Vol -= 12;
					}
				} else {
					if (this.ambience2Vol > -30) {
						this.ambience2Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		source3VUI: function source3VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience3Player.start();
				this.ambience3Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience3Player.stop();
				this.ambience3Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience3Vol < 0) {
						this.ambience3Vol += 12;
					}
				} else {
					if (this.ambience3Vol < 0) {
						this.ambience3Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience3Vol > -30) {
						this.ambience3Vol -= 12;
					}
				} else {
					if (this.ambience3Vol > -30) {
						this.ambience3Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		source4VUI: function source4VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience4Player.start();
				this.ambience4Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience4Player.stop();
				this.ambience4Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience4Vol < 0) {
						this.ambience4Vol += 12;
					}
				} else {
					if (this.ambience4Vol < 0) {
						this.ambience4Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience4Vol > -30) {
						this.ambience4Vol -= 12;
					}
				} else {
					if (this.ambience4Vol > -30) {
						this.ambience4Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		source5VUI: function source5VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience5Player.start();
				this.ambience5Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience5Player.stop();
				this.ambience5Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience5Vol < 0) {
						this.ambience5Vol += 12;
					}
				} else {
					if (this.ambience5Vol < 0) {
						this.ambience5Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience5Vol > -30) {
						this.ambience5Vol -= 12;
					}
				} else {
					if (this.ambience5Vol > -30) {
						this.ambience5Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		source6VUI: function source6VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience6Player.start();
				this.ambience6Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience6Player.stop();
				this.ambience6Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience6Vol < 0) {
						this.ambience6Vol += 12;
					}
				} else {
					if (this.ambience6Vol < 0) {
						this.ambience6Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience6Vol > -30) {
						this.ambience6Vol -= 12;
					}
				} else {
					if (this.ambience6Vol > -30) {
						this.ambience6Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		allSoundVUI: function allSoundVUI() {
			//STOP ALL 
			if (RegExp(/stop/gi).test(this.testObjectVUI)) {
				this.ambience1Player.stop();
				this.ambience1Boolean = false;
				this.ambience2Player.stop();
				this.ambience2Boolean = false;
				this.ambience3Player.stop();
				this.ambience3Boolean = false;
				this.ambience4Player.stop();
				this.ambience4Boolean = false;
				this.ambience5Player.stop();
				this.ambience5Boolean = false;
				this.ambience6Player.stop();
				this.ambience6Boolean = false;
				if (this.didWeAdventure) {
					this.exploreSound1.stop();
					this.isExploreFuncRunning = false;
				}
			} else if (RegExp(/play/gi).test(this.testObjectVUI)) {
				this.ambience1Player.start();
				this.ambience1Boolean = true;
				this.ambience2Player.start();
				this.ambience2Boolean = true;
				this.ambience3Player.start();
				this.ambience3Boolean = true;
				this.ambience4Player.start();
				this.ambience4Boolean = true;
				this.ambience5Player.start();
				this.ambience5Boolean = true;
				this.ambience6Player.start();
				this.ambience6Boolean = true;
			}
			this.testObjectVUI = "";
		},
		speedVUI: function speedVUI() {
			if (RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI)) {
				this.speedToggle = true;
			} else if (RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI)) {
				this.speedToggle = false;
			}
			if (RegExp(/\bfaste?r?\b|up/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.playBackSpeed <= 1.6) {
						this.playBackSpeed += 0.4;
					}
				} else {
					if (this.playBackSpeed <= 1.8) {
						this.playBackSpeed += 0.2;
					}
				}
			} else if (RegExp(/slowe?r?|down/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.playBackSpeed >= 0.5) {
						this.playBackSpeed -= 0.4;
					}
				} else {
					if (this.playBackSpeed >= 0.2) {
						this.playBackSpeed -= 0.2;
					}
				}
			}
			this.testObjectVUI = "";
		},
		delayVUI: function delayVUI() {
			if (RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI)) {
				this.fxDelayToggle = true;
			} else if (RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI)) {
				this.fxDelayToggle = false;
			}
			if (RegExp(/\bmore\b|\bup\b|loude?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxDelayAmt <= 80) {
						this.fxDelayAmt += 10;
					}
				} else {
					if (this.fxDelayAmt <= 95) {
						this.fxDelayAmt += 5;
					}
				}
			} else if (RegExp(/less|\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxDelayAmt >= 20) {
						this.fxDelayAmt -= 10;
					} else if (this.fxDelayAmt >= 5) {
						this.fxDelayAmt -= 5;
					}
				} else {
					if (this.fxDelayAmt >= 5) {
						this.fxDelayAmt -= 5;
					} else if (this.fxDelayAmt >= 15) {
						this.fxDelayAmt -= 2;
					}
				}
			}
			this.testObjectVUI = "";
		},
		chorusVUI: function chorusVUI() {
			if (RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI)) {
				this.fxChorusToggle = true;
			} else if (RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI)) {
				this.fxChorusToggle = false;
			}
			if (RegExp(/\bmore\b|\bup\b|loude?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxChorusAmt <= 80) {
						this.fxChorusAmt += 10;
					}
				} else {
					if (this.fxChorusAmt <= 95) {
						this.fxChorusAmt += 5;
					}
				}
			} else if (RegExp(/less|\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxChorusAmt >= 20) {
						this.fxChorusAmt -= 10;
					} else if (this.fxChorusAmt >= 5) {
						this.fxChorusAmt -= 5;
					}
				} else {
					if (this.fxChorusAmt >= 5) {
						this.fxChorusAmt -= 5;
					} else if (this.fxChorusAmt >= 15) {
						this.fxChorusAmt -= 2;
					}
				}
			}
			this.testObjectVUI = "";
		},
		reverbVUI: function reverbVUI() {
			if (RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI)) {
				this.fxConvolverToggle = true;
			} else if (RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI)) {
				this.fxConvolverToggle = false;
			}
			if (RegExp(/\bmore\b|\bup\b|loude?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxConvolverAmt <= 45) {
						this.fxConvolverAmt += 5;
					}
				} else {
					if (this.fxConvolverAmt <= 48) {
						this.fxConvolverAmt += 2;
					}
				}
			} else if (RegExp(/less|\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxConvolverAmt >= 10) {
						this.fxConvolverAmt -= 5;
					} else if (this.fxConvolverAmt >= 2) {
						this.fxConvolverAmt -= 1;
					}
				} else {
					if (this.fxConvolverAmt >= 10) {
						this.fxConvolverAmt -= 2;
					} else if (this.fxConvolverAmt >= 2) {
						this.fxConvolverAmt -= 1;
					}
				}
			}
			this.testObjectVUI = "";
		},
		filterVUI: function filterVUI() {
			if (RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI)) {
				this.fxFilterToggle = true;
			} else if (RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI)) {
				this.fxFilterToggle = false;
			}
			if (RegExp(/\bmore\b|\blower\b/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxAutoFilterAmt > 1500) {
						this.fxAutoFilterAmt -= 1500;
					} else if (this.fxAutoFilterAmt >= 300) {
						this.fxAutoFilterAmt -= 200;
					}
				} else {
					if (this.fxAutoFilterAmt >= 500) {
						this.fxAutoFilterAmt -= 250;
					} else if (this.fxAutoFilterAmt >= 100) {
						this.fxAutoFilterAmt -= 100;
					}
				}
			} else if (RegExp(/less|higher|hire/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxAutoFilterAmt <= 10000) {
						this.fxAutoFilterAmt += 1500;
					} else if (this.fxAutoFilterAmt <= 1000) {
						this.fxAutoFilterAmt += 200;
					}
				} else {
					if (this.fxAutoFilterAmt <= 10000) {
						this.fxAutoFilterAmt += 250;
					} else if (this.fxAutoFilterAmt <= 1000) {
						this.fxAutoFilterAmt += 100;
					}
				}
			}
			this.testObjectVUI = "";
		},
		infoVUI: function infoVUI() {
			var _this6 = this;

			if (RegExp(/show|display/gi).test(this.testObjectVUI)) {
				this.showHelpOverlay = true;
				setTimeout(function () {
					_this6.showNavBar = false;
					if (_this6.$store.state.allowSpeechControl) {
						_this6.showSpeechBtns = false;
					}
				}, 0);
				setTimeout(function () {
					_this6.showAllControls = false;
				}, 500);
				setTimeout(function () {
					_this6.showAboutPage = true;
				}, 1500);
				console.log('SHOW INFO');
			} else if (RegExp(/hide|minimize/gi).test(this.testObjectVUI)) {
				this.showHelpOverlay = false;
				this.showAboutPage = false;
				setTimeout(function () {
					_this6.showAllControls = true;
				}, 800);
				setTimeout(function () {
					_this6.showNavBar = true;
					if (_this6.$store.state.allowSpeechControl) {
						_this6.showSpeechBtns = true;
					}
				}, 850);
				console.log('HIDE INFO');
			}
			this.testObjectVUI = "";
			setTimeout(function () {
				_this6.userVoiceToText = "";
			}, 3000);
		},
		listVUI: function listVUI() {
			var _this7 = this;

			if (RegExp(/show|display/gi).test(this.testObjectVUI)) {
				this.showVoiceCommandList = true;
				setTimeout(function () {
					document.getElementById('voiceControlListTxt').scrollIntoView({ behavior: "smooth" });
				}, 250);
				console.log('SHOW LIST');
			} else if (RegExp(/hide|minimize/gi).test(this.testObjectVUI)) {
				this.showVoiceCommandList = false;
				setTimeout(function () {
					document.getElementById('controlsContainer').scrollIntoView({ behavior: "smooth" });
				}, 250);
				console.log('HIDE LIST');
			}
			this.testObjectVUI = "";
			setTimeout(function () {
				_this7.userVoiceToText = "";
			}, 3000);
		},
		miscVUI: function miscVUI() {
			//RANDOMIZE
			if (RegExp(/new\s?scenes?|randomi?z?e?|shift\s?soundscapes?/gi).test(this.testObjectVUI)) {
				this.mattChillMethod();
				//EXPLORE
			} else if (RegExp(/\bexplorer?\b|\badventure\b/gi).test(this.testObjectVUI)) {
				if (RegExp(/stop/gi).test(this.testObjectVUI)) {
					this.stopExplore();
				} else {
					this.exploreFunc();
				}
				//STOP VOICE COMMANDS & GO HOME FUNCTIONS
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) && RegExp(/voice\s?controls?/gi).test(this.testObjectVUI) || RegExp(/stop/gi).test(this.testObjectVUI) && RegExp(/voice\s?commands?/gi).test(this.testObjectVUI)) {
				//DISABLES LISTENING IMMEDITATLY
				this.initSpeech = true;
				this.stopModuleSpeech = true;
				this.recognizing = false;
				this.recognitionRural.stop();
				this.$store.state.isVoiceControlled = false;
			} else if (RegExp(/home/gi).test(this.testObjectVUI)) {
				this.goingHomeNotViaVoiceCommand = false;
				this.stopModuleSpeech = true;
				this.recognitionRural.abort();
				this.recognitionRural = undefined;
				setTimeout(this.goHome, 50);
			}
			this.testObjectVUI = "";
		},

		//ENTER FUNC
		enterFunc: function enterFunc() {
			var _this8 = this;

			if (this.startAudioBoolean) {
				this.startAudio();
				this.startAudioBoolean = false;
			}

			this.showMutePrompt = false;
			this.showEnterBtn = false;

			setTimeout(function () {
				_this8.showEnterContainer = false;
			}, 1000);

			this.ruralFX.start();

			var changeTiming = 50;

			setTimeout(function () {
				_this8.plungeDepth = 1;
			}, changeTiming * 1);

			setTimeout(function () {
				_this8.plungeDepth = 2;
			}, changeTiming * 2);

			setTimeout(function () {
				_this8.plungeDepth = 3;
			}, changeTiming * 3);

			setTimeout(function () {
				_this8.plungeDepth = 4;
			}, changeTiming * 4);

			setTimeout(function () {
				_this8.plungeDepth = 5;
			}, changeTiming * 5);

			setTimeout(function () {
				_this8.plungeDepth = 6;
			}, changeTiming * 6);

			setTimeout(function () {
				_this8.plungeDepth = 7;
			}, changeTiming * 7);

			setTimeout(function () {
				_this8.plungeDepth = 8;
			}, changeTiming * 8);

			setTimeout(function () {
				_this8.plungeDepth = 9;
			}, changeTiming * 8);

			setTimeout(function () {
				_this8.plungeDepth = 10;
			}, changeTiming * 10);

			setTimeout(function () {
				_this8.showAllControls = true;
			}, 1000);

			setTimeout(function () {
				_this8.showNavBar = true;
			}, 1100);

			setTimeout(function () {
				_this8.showSpeechBtns = true;
			}, 1200);

			setTimeout(function () {
				_this8.ambience1Boolean = true;
			}, 3253);

			setTimeout(function () {
				if (_this8.userMobile === false) {
					_this8.activeSun = true;
				}
			}, 800);

			// setTimeout(()=>{ 
			// 	this.ambience1Vol = -30;
			// }, 1100);

			// setTimeout(()=>{ 
			// 	this.ambience1Vol = -26;
			// }, 1200);

			// setTimeout(()=>{ 
			// 	this.ambience1Vol = -23;
			// }, 1300);

			// setTimeout(()=>{ 
			// 	this.ambience1Vol = -20;
			// }, 1400);

			// setTimeout(()=>{ 
			// 	this.ambience1Vol = -15;
			// }, 1490);

			// setTimeout(()=>{ 
			// 	this.ambience1Vol = -12;
			// }, 1550);

			// setTimeout(()=>{ 
			// 	this.ambience1Vol = -10;
			// }, 1600);

			// setTimeout(()=>{ 
			// 	this.ambience1Vol = -8;
			// }, 1650);

			// setTimeout(()=>{ 
			// 	this.ambience1Vol = -6;
			// }, 1700);

			// setTimeout(()=>{ 
			// 	this.ambience1Vol = -4;
			// }, 1750);
		},

		//RANDOMIZE (MATT CHILL) PRESET
		mattChillMethod: function mattChillMethod() {
			if (this.didWeAdventure) {
				this.stopExplore();
			}

			if (this.randomizeBoolean === false) {
				this.randomizeBoolean = true;
			}

			this.mattChill = !this.mattChill;

			this.ambience1Vol = Math.floor(Math.random() * 30 - 30);
			this.ambience2Vol = Math.floor(Math.random() * 30 - 30);
			this.ambience3Vol = Math.floor(Math.random() * 30 - 30);
			this.ambience4Vol = Math.floor(Math.random() * 30 - 30);
			this.ambience5Vol = Math.floor(Math.random() * 30 - 30);
			this.ambience6Vol = Math.floor(Math.random() * 30 - 30);

			var fx1boolean = Math.random() >= 0.5,
			    fx2boolean = Math.random() >= 0.5,
			    fx3boolean = Math.random() >= 0.5,
			    fx4boolean = Math.random() >= 0.5,
			    fx5boolean = Math.random() >= 0.5;

			var amb1boolean = Math.random() >= 0.5,
			    amb2boolean = Math.random() >= 0.5,
			    amb3boolean = Math.random() >= 0.5,
			    amb4boolean = Math.random() >= 0.5,
			    amb5boolean = Math.random() >= 0.5,
			    amb6boolean = Math.random() >= 0.5;

			// if (this.mattChill === true){
			//DON'T CALCULATE ON MOBILE
			if (this.userMobile === false) {
				var
				// randomVerb 		= Math.floor((Math.random() * 30) + 0),
				randomDelay = Math.floor(Math.random() * 20 + 0),
				    randomChorus = Math.floor(Math.random() * 20 + 0),
				    randomFilter = Math.floor(Math.random() * 20000 + 500);

				// this.fxConvolverAmt 	= randomVerb;
				this.fxDelayAmt = randomDelay;
				this.fxChorusAmt = randomChorus;
				this.fxAutoFilterAmt = randomFilter;

				this.fxDecay = Math.random() * 10 + 1.5;
				var fxPreDelay = Math.random() * 0.1 + 0.03;
				this.fxConvolver.decay = this.fxDecay;
				this.fxConvolver.preDelay = fxPreDelay;
				this.fxConvolver.generate();

				// console.log("Verb Decay: " + this.fxDecay);
				// console.log("Verb PreDelay: " + fxPreDelay);
			}
			//CALCULATE ON MOBILE & DESKTOP
			var randomSpeed = Math.random() * (1.20 - 0.8) + 0.8;
			this.playBackSpeed = randomSpeed;

			if (amb1boolean === true) {
				this.ambience1Boolean = true;
				this.showFlask1 = true;
			} else {
				this.ambience1Boolean = false;
				this.showFlask1 = false;
			}

			if (amb2boolean === true) {
				this.ambience2Boolean = true;
				this.showFlask2 = true;
			} else {
				this.ambience2Boolean = false;
				this.showFlask2 = false;
			}

			if (amb3boolean === true) {
				this.ambience3Boolean = true;
				this.showFlask3 = true;
			} else {
				this.ambience3Boolean = false;
				this.showFlask3 = false;
			}

			if (amb4boolean === true) {
				this.ambience4Boolean = true;
				this.showFlask4 = true;
			} else {
				this.ambience4Boolean = false;
				this.showFlask4 = false;
			}

			if (amb5boolean === true) {
				this.ambience5Boolean = true;
				this.showFlask5 = true;
			} else {
				this.ambience5Boolean = false;
				this.showFlask5 = false;
			}

			if (amb6boolean === true) {
				this.ambience6Boolean = true;
				this.showFlask6 = true;
			} else {
				this.ambience6Boolean = false;
				this.showFlask6 = false;
			}

			if (amb1boolean === false && amb2boolean === false && amb3boolean === false && amb4boolean === false && amb5boolean === false && amb6boolean === false) {
				this.ambience6Boolean = true;
				this.showFlask6 = true;
			}
		},

		//EXPLORE 
		exploreBtnFunc: function exploreBtnFunc() {
			this.exploreBtnBoolean = !this.exploreBtnBoolean;
			if (this.exploreBtnBoolean) {
				this.exploreFunc();
			} else if (!this.exploreBtnBoolean) {
				this.stopExplore();
			}
		},
		exploreFunc: function exploreFunc() {
			var _this9 = this;

			//AUDIO MIXING FUNCTION
			var runExplore = function runExplore() {
				_this9.exploreTxt = "Exploring";
				_this9.exploreTimeout1 = setTimeout(function () {
					_this9.exploreSound1.start();
				}, 2500);

				_this9.exploreTimeout2 = setTimeout(function () {
					_this9.isExploreFuncRunning = false;
					_this9.exploreTxt = "Explore!";
				}, 4000);
			};
			if (this.isExploreFuncRunning === false) {
				this.isExploreFuncRunning = true;
				//INIT EXPORE SCENE
				//GENERATE REVERB
				if (!this.userMobile) {
					this.fxDecay = 4.5;
					this.fxConvolver.decay = this.fxDecay;
					this.fxConvolver.preDelay = 0.4;
					this.fxConvolver.generate();
				}

				this.ambience1Boolean = false;
				this.ambience1Vol = -10;

				this.ambience2Boolean = false;
				this.ambience2Vol = -30;

				this.ambience3Boolean = false;
				this.ambience3Vol = -30;

				this.ambience4Boolean = true;
				this.ambience4Vol = -8;

				this.ambience5Boolean = false;
				this.ambience5Vol = -30;

				this.ambience6Boolean = false;
				this.ambience6Vol = -15;

				if (!this.didWeAdventure) {
					this.exploreSound1 = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
						"playbackRate": 1,
						"loop": false,
						"volume": -6
					}).toMaster();
					//LOADING FOR BROWSER TYPE
					if (this.isChrome === true || this.isOpera === true || this.isFirefox === true || this.isBlink === true) {

						this.exploreSound1.load("../src/assets/sounds/modules/rural/hiogg/exporeSound1Rural.ogg", function () {
							runExplore();
						});
					} else if (this.AndroidMobile === true) {
						this.exploreSound1.load("../src/assets/sounds/modules/rural/lowogg/exporeSound1Rural.ogg", function () {
							runExplore();
						});
					} else if (this.isSafari === true || this.isEdge === true || this.isIE === true) {
						this.exploreSound1.load("../src/assets/sounds/modules/rural/320/exporeSound1Rural.m4a", function () {
							runExplore();
						});
					} else if (this.iOS === true) {
						this.exploreSound1.load("../src/assets/sounds/modules/rural/192/exporeSound1Rural.m4a", function () {
							runExplore();
						});
					}
					//CLEANS UP AND DISPOSES THESE PLAYERS WHEN GOING HOME
					this.didWeAdventure = true;
				} else if (this.didWeAdventure) {
					runExplore();
				}
			} else {}
		},
		stopExplore: function stopExplore() {
			this.exploreTxt = "Explore!";
			this.exploreSound1.stop();
			this.isExploreFuncRunning = false;
			clearInterval(this.exploreTimeout1);
			clearInterval(this.exploreTimeout2);
		},

		//MASTER METERING
		masterMetering: function masterMetering() {
			this.masterLevel = this.masterMeter.getLevel();
		},

		//MAIN SHOW AND HIDE
		goToHelp: function goToHelp() {
			var _this10 = this;

			this.showHelpOverlay = !this.showHelpOverlay;
			this.helpTrigger = !this.helpTrigger;

			if (this.showHelpOverlay === true) {

				setTimeout(function () {
					_this10.showNavBar = false;
					if (_this10.$store.state.allowSpeechControl) {
						_this10.showSpeechBtns = false;
					}
				}, 100);

				setTimeout(function () {
					_this10.showAllControls = false;
				}, 250);

				setTimeout(function () {
					_this10.showAboutPage = true;
				}, 1000);
			} else if (this.showHelpOverlay === false) {

				this.showAboutPage = false;

				setTimeout(function () {
					_this10.showAllControls = true;
				}, 800);

				setTimeout(function () {
					_this10.showNavBar = true;
					if (_this10.$store.state.allowSpeechControl) {
						_this10.showSpeechBtns = true;
					}
				}, 850);
			}
		},
		voiceCommandListFunc: function voiceCommandListFunc() {
			this.showVoiceCommandList = !this.showVoiceCommandList;
			if (this.showVoiceCommandList) {
				setTimeout(function () {
					document.getElementById('voiceListAnchor').scrollIntoView({ behavior: "smooth" });
				}, 250);
			} else if (!this.showVoiceCommandList) {
				document.getElementById('controlsContainer').scrollIntoView({ behavior: "smooth" });
			}
		},

		//MASTER DRAGGIE LOGGING & LOADING
		ogScreenSize: function ogScreenSize() {
			this.ogWidth = window.innerWidth;
		},
		screenSizing: function screenSizing() {
			this.screenHeight = window.innerHeight;
			this.screenWidth = window.innerWidth;

			var currentWidth = window.innerWidth;

			if (currentWidth === this.ogWidth) {} else if (currentWidth != this.ogWidth) {
				this.sliderRangeSet();
				// this.mobileCheck();
				this.ogWidth = currentWidth;
			}
		},

		//BUFFER LOADING
		bufferLoading: function bufferLoading() {
			var _this11 = this;

			// Tone.Buffer.on('progress', ()=>{
			// });
			__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Buffer.on('load', function () {
				//HIDE LOADING ITEMS
				_this11.showLoading = false;
				//SHOW ENTER BUTTON
				setTimeout(function () {
					_this11.showEnterBtn = true;
				}, 1000);
				//AUTO OPEN MODULE IF VOICE CONTROLLED & DO NOT REPLAY WHEN EXPLORE AUDIO LOADS 
				//ADDITIONALLY DO NOT REPLAY IF USER MIC HAS BEEN ACTIVATED FOR RECORDING
				if (_this11.isVoiceControl) {
					if (!_this11.didWeAdventure) {
						setTimeout(_this11.enterFunc, 2000);
					}
				}
				//IF VOICE CONTROL IS ACTIVE GLOBALLY ACTIVATE IN THIS MODULE
				if (_this11.isVoiceControl === true) {
					_this11.speechFunc();
				}
			});
		},

		//AUDIO ROUTING
		audioRouting: function audioRouting() {
			if (this.isChrome === true || this.AndroidMobile === true || this.isOpera === true || this.isFirefox === true || this.isBlink === true) {
				if (this.userMobile === false) {
					// this.fxConvolver = new Tone.Convolver("../src/assets/cookieverb.wav");
					this.fxConvolver = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Reverb({
						"decay": 6,
						"preDelay": 0.01
					});
					this.fxConvolver.decay = 6;
					this.fxConvolver.generate();
					this.fxAutoFilter = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Filter({
						"type": "lowpass",
						"frequency": 20000,
						"rolloff": -24,
						"Q": 1,
						"gain": 0
					});
					this.fxDelay = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.PingPongDelay(0.8, 0.3);
					this.fxChorus = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Chorus({
						"frequency": 6,
						"delayTime": 2,
						"depth": 0.85,
						"type": "sine",
						"spread": 180
					});
					this.masterMeter = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Meter({
						"smoothing": .4
					});
					this.ambience1Player.connect(this.masterVolumeSub);
					this.ambience2Player.connect(this.masterVolumeSub);
					this.ambience3Player.connect(this.masterVolumeSub);
					this.ambience4Player.connect(this.masterVolumeSub);
					this.ambience5Player.connect(this.masterVolumeSub);
					this.ambience6Player.connect(this.masterVolumeSub);

					this.masterVolumeSub.chain(this.fxAutoFilter, this.fxConvolver, this.fxDelay, this.fxChorus, this.masterMeter, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master);
					console.log('Chrome/Opera/FireFox Desktop');
					setInterval(this.masterMetering, 60);
				} else if (this.userMobile === true) {
					this.ambience1Player.connect(this.masterVolumeSub);
					this.ambience2Player.connect(this.masterVolumeSub);
					this.ambience3Player.connect(this.masterVolumeSub);
					this.ambience4Player.connect(this.masterVolumeSub);
					this.ambience5Player.connect(this.masterVolumeSub);
					this.ambience6Player.connect(this.masterVolumeSub);

					this.masterVolumeSub.connect(__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master);

					console.log('Chrome/Opera/FireFox Mobile');
				}
			} else if (this.isSafari === true || this.iOS === true || this.isEdge === true || this.isIE === true) {
				if (this.userMobile === false) {
					this.fxConvolver = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Reverb({
						"decay": 6,
						"preDelay": 0.01
					});
					this.fxConvolver.decay = 6;
					this.fxConvolver.generate();
					this.fxAutoFilter = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Filter({
						"type": "lowpass",
						"frequency": 20000,
						"rolloff": -24,
						"Q": 1,
						"gain": 0
					});
					this.fxDelay = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.PingPongDelay(0.8, 0.3);
					this.fxChorus = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Chorus({
						"frequency": 6,
						"delayTime": 2,
						"depth": 0.85,
						"type": "sine",
						"spread": 180
					});
					this.masterMeter = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Meter({
						"smoothing": .4
					});
					this.ambience1Player.connect(this.masterVolumeSub);
					this.ambience2Player.connect(this.masterVolumeSub);
					this.ambience3Player.connect(this.masterVolumeSub);
					this.ambience4Player.connect(this.masterVolumeSub);
					this.ambience5Player.connect(this.masterVolumeSub);
					this.ambience6Player.connect(this.masterVolumeSub);

					this.masterVolumeSub.chain(this.fxAutoFilter, this.fxConvolver, this.fxDelay, this.fxChorus, this.masterMeter, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master);
					console.log('Safari/Edge/iOS Desktop');
					setInterval(this.masterMetering, 60);
				} else if (this.userMobile === true) {
					this.ambience1Player.connect(this.masterVolumeSub);
					this.ambience2Player.connect(this.masterVolumeSub);
					this.ambience3Player.connect(this.masterVolumeSub);
					this.ambience4Player.connect(this.masterVolumeSub);
					this.ambience5Player.connect(this.masterVolumeSub);
					this.ambience6Player.connect(this.masterVolumeSub);

					this.masterVolumeSub.connect(__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master);
					console.log('Safari/Edge/iOS Mobile');
				}
			} else {}
		},

		//AUDIO LOADING
		firstAudioLoadFunc: function firstAudioLoadFunc() {
			var _this12 = this;

			// this.changeFX.load("../src/assets/sounds/blinks/change.wav", ()=>{
			// 	this.whatIsLoading = "Roads";
			// });

			// this.ruralFX.load("../src/assets/sounds/modules/rural/ruralFX.wav", ()=>{
			// 	this.whatIsLoading = "Fields";
			// });

			// this.ambience1Player.load("../src/assets/sounds/modules/rural/hillside.wav", ()=>{
			// 	this.whatIsLoading = "Hillside";
			// });

			// this.ambience2Player.load("../src/assets/sounds/modules/rural/highway.wav", ()=>{
			// 	this.whatIsLoading = "Highway";
			// });

			// this.ambience3Player.load("../src/assets/sounds/modules/rural/mower.wav", ()=>{
			// 	this.whatIsLoading = "Mower";
			// });

			// this.ambience4Player.load("../src/assets/sounds/modules/rural/ruralFX.wav", ()=>{
			// 	this.whatIsLoading = "Weedwacker";
			// });

			// this.ambience5Player.load("../src/assets/sounds/modules/rural/train.wav", ()=>{
			// 	this.whatIsLoading = "Locomotive";
			// });

			// this.ambience6Player.load("../src/assets/sounds/modules/rural/lapping.wav", ()=>{
			// 	this.whatIsLoading = "Lakes";
			// });

			if (this.isChrome === true || this.isOpera === true || this.isFirefox === true || this.isBlink === true) {

				this.changeFX.load("../src/assets/sounds/blinks/change.ogg", function () {
					_this12.whatIsLoading = "Roads";
				});

				this.ruralFX.load("../src/assets/sounds/modules/rural/hiogg/ruralFX.ogg", function () {
					_this12.whatIsLoading = "Fields";
				});

				this.ambience1Player.load("../src/assets/sounds/modules/rural/hiogg/hillside.ogg", function () {
					_this12.whatIsLoading = "Hillsides";
				});

				this.ambience2Player.load("../src/assets/sounds/modules/rural/hiogg/highway.ogg", function () {
					_this12.whatIsLoading = "Highways";
				});

				this.ambience3Player.load("../src/assets/sounds/modules/rural/hiogg/mower.ogg", function () {
					_this12.whatIsLoading = "Mower";
				});

				this.ambience4Player.load("../src/assets/sounds/modules/rural/hiogg/field.ogg", function () {
					_this12.whatIsLoading = "Weedwacker";
				});

				this.ambience5Player.load("../src/assets/sounds/modules/rural/hiogg/train.ogg", function () {
					_this12.whatIsLoading = "Locomotive";
				});

				this.ambience6Player.load("../src/assets/sounds/modules/rural/hiogg/bell.ogg", function () {
					_this12.whatIsLoading = "Bells";
				});
			} else if (this.AndroidMobile === true) {
				this.changeFX.load("../src/assets/sounds/blinks/change.ogg", function () {
					_this12.whatIsLoading = "Roads";
				});

				this.ruralFX.load("../src/assets/sounds/modules/rural/lowogg/ruralFX.ogg", function () {
					_this12.whatIsLoading = "Fields";
				});

				this.ambience1Player.load("../src/assets/sounds/modules/rural/lowogg/hillside.ogg", function () {
					_this12.whatIsLoading = "Hillsides";
				});

				this.ambience2Player.load("../src/assets/sounds/modules/rural/lowogg/highway.ogg", function () {
					_this12.whatIsLoading = "Highways";
				});

				this.ambience3Player.load("../src/assets/sounds/modules/rural/lowogg/mower.ogg", function () {
					_this12.whatIsLoading = "Mower";
				});

				this.ambience4Player.load("../src/assets/sounds/modules/rural/lowogg/field.ogg", function () {
					_this12.whatIsLoading = "Weedwacker";
				});

				this.ambience5Player.load("../src/assets/sounds/modules/rural/lowogg/train.ogg", function () {
					_this12.whatIsLoading = "Locomotive";
				});

				this.ambience6Player.load("../src/assets/sounds/modules/rural/lowogg/bell.ogg", function () {
					_this12.whatIsLoading = "Bells";
				});
			} else if (this.isSafari === true || this.isEdge === true || this.isIE === true) {

				this.changeFX.load("../src/assets/sounds/blinks/change.m4a", function () {
					_this12.whatIsLoading = "Roads";
				});

				this.ruralFX.load("../src/assets/sounds/modules/rural/320/ruralFX.m4a", function () {
					_this12.whatIsLoading = "Fields";
				});

				this.ambience1Player.load("../src/assets/sounds/modules/rural/320/hillside.m4a", function () {
					_this12.whatIsLoading = "Hillsides";
				});

				this.ambience2Player.load("../src/assets/sounds/modules/rural/320/highway.m4a", function () {
					_this12.whatIsLoading = "Highways";
				});

				this.ambience3Player.load("../src/assets/sounds/modules/rural/320/mower.m4a", function () {
					_this12.whatIsLoading = "Mower";
				});

				this.ambience4Player.load("../src/assets/sounds/modules/rural/320/field.m4a", function () {
					_this12.whatIsLoading = "Weedwacker";
				});

				this.ambience5Player.load("../src/assets/sounds/modules/rural/320/train.m4a", function () {
					_this12.whatIsLoading = "Locomotive";
				});

				this.ambience6Player.load("../src/assets/sounds/modules/rural/320/bell.m4a", function () {
					_this12.whatIsLoading = "Bells";
				});
			} else if (this.iOS === true) {

				this.changeFX.load("../src/assets/sounds/blinks/change.m4a", function () {
					_this12.whatIsLoading = "Roads";
				});

				this.ruralFX.load("../src/assets/sounds/modules/rural/192/ruralFX.m4a", function () {
					_this12.whatIsLoading = "Fields";
				});

				this.ambience1Player.load("../src/assets/sounds/modules/rural/192/hillside.m4a", function () {
					_this12.whatIsLoading = "Hillsides";
				});

				this.ambience2Player.load("../src/assets/sounds/modules/rural/192/highway.m4a", function () {
					_this12.whatIsLoading = "Highways";
				});

				this.ambience3Player.load("../src/assets/sounds/modules/rural/192/mower.m4a", function () {
					_this12.whatIsLoading = "Mower";
				});

				this.ambience4Player.load("../src/assets/sounds/modules/rural/192/field.m4a", function () {
					_this12.whatIsLoading = "Weedwacker";
				});

				this.ambience5Player.load("../src/assets/sounds/modules/rural/192/train.m4a", function () {
					_this12.whatIsLoading = "Locomotive";
				});

				this.ambience6Player.load("../src/assets/sounds/modules/rural/192/bell.m4a", function () {
					_this12.whatIsLoading = "Bells";
				});
			}
		},

		//GO HOME
		goHome: function goHome() {
			var _this13 = this;

			this.changeFX.start();

			//IF USER ENGAGES VOICE CONTROL BUT GOES HOME VIA 
			//MOUSE BUTTON THIS TRIGGERS MODULE SPEECH DISPOSE
			if (this.goingHomeNotViaVoiceCommand && !this.initSpeech) {
				this.stopModuleSpeech = true;
				this.recognitionRural.stop();
				this.recognitionRural.abort();
				this.recognitionRural = undefined;
			};

			if (this.didWeAdventure === true) {
				this.exploreSound1.disconnect();
				// this.exploreSound2.disconnect();
				// this.exploreSound3.disconnect();
			}

			setTimeout(function () {
				__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.2);
			}, 400);

			setTimeout(function () {
				_this13.ambience1Player.disconnect();
				_this13.ambience2Player.disconnect();
				_this13.ambience3Player.disconnect();
				_this13.ambience4Player.disconnect();
				_this13.ambience5Player.disconnect();
				_this13.ambience6Player.disconnect();
				_this13.ruralFX.disconnect();
				_this13.changeFX.disconnect();
				_this13.masterVolumeSub.disconnect();
				if (_this13.userMobile === false) {
					_this13.fxConvolver.disconnect();
					_this13.fxAutoFilter.disconnect();
					_this13.fxDelay.disconnect();
					_this13.fxChorus.disconnect();
					_this13.masterMeter.disconnect();
				}
			}, 1000);

			setTimeout(function () {
				document.body.className = 'default';
				_this13.$router.push('/');
				__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master.volume.value = 0;
			}, 1100);
		}
	}
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_startaudiocontext_StartAudioContext_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_startaudiocontext_StartAudioContext_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_startaudiocontext_StartAudioContext_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js__);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var XRegExp = __webpack_require__(5);
/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		var _ref;

		return _ref = {
			// testVar1: 1,
			// testVar2: 1,
			// testVar3: 1,
			// testVar4: 1,
			// testVar5: 0.25,
			welcomePrompt: "CLICK TO ENTER",
			//RANDOMIZE BOOLEANS
			randomizeBoolean: false,
			showFlask1: true,
			showFlask2: false,
			showFlask3: false,
			showFlask4: false,
			showFlask5: false,
			showFlask6: false,
			//CONTROLS
			reverbChecker: undefined,
			loadingBoolean: true,
			userMobile: Boolean,
			mailingListBtn: false,
			textTiming: 500,
			startStopTrigger: true,
			playColor: "#F0CB50",
			stopColor: "#1E9BFC",
			//SCREEN DIMENSIONS
			screenHeight: undefined,
			screenWidth: undefined,
			ogWidth: undefined,
			//BACKGROUND COLORS
			plungeDepth: 1,
			backgroundColor1: true,
			backgroundColor2: false,
			backgroundColor3: false,
			backgroundColor4: false,
			backgroundColor5: false,
			backgroundColor6: false,
			backgroundColor7: false,
			backgroundColor8: false,
			backgroundColor9: false,
			backgroundColor10: false,
			//REACTIVE SUN
			sunReactiveColor1: true,
			sunReactiveColor2: false,
			sunReactiveColor3: false,
			sunReactiveColor4: false,
			sunReactiveColor5: false,
			sunReactiveColor6: false,
			sunReactiveColor7: false,
			sunReactiveColor8: false,
			sunReactiveColor9: false,
			sunReactiveColor10: false,
			//SHOW AND HIDE
			helpTrigger: false,
			showHelpOverlay: false,
			showAboutPage: false,

			bellBoolean: false,
			//PLAY SUN DRAGGIE
			activeSun: false,
			//V-SHOWS
			showEnterContainer: true,
			showLoading: true,
			showEnterBtn: false,
			showNavBar: false,
			showAllControls: false,
			showSpeechBtns: false,
			//TUTORIAL BOOLEANS
			//WILL NOT ALLOW VOICE COMMANDS TO BE PROCESED WHEN VOICE OVER IS ACTIVE
			istutorialVOActive: false,

			ambience1Boolean: false,
			ambience2Boolean: false,
			ambience3Boolean: false,
			ambience4Boolean: false,
			ambience5Boolean: false,
			ambience6Boolean: false,
			soundSourceVOBoolean: false,
			soundFXVOBoolean: false,
			randomizeVOBoolean: false,
			voiceVOBoolean: false,
			exploreVOBoolean: false,

			exploreMasterTimer1: undefined,
			exploreInterval: undefined,
			exploreTimeout1: undefined,
			exploreTimeout2: undefined,
			exploreControlTrigger: false,

			ambience1BooleanTrigger: false,
			ambience2BooleanTrigger: false,
			ambience3BooleanTrigger: false,
			ambience4BooleanTrigger: false,
			ambience5BooleanTrigger: false,
			ambience6BooleanTrigger: false,

			soundSourceInterval: undefined,
			soundSourceTimeout1: undefined,
			soundSourceTimeout2: undefined,
			soundSourceTimeout3: undefined,
			soundSourceTimeout4: undefined,
			soundSourceTimeout5: undefined,
			soundSourceTimeout6: undefined,

			inst1BooleanTrigger: false,
			inst2BooleanTrigger: false,
			inst3BooleanTrigger: false,
			inst4BooleanTrigger: false,
			inst5BooleanTrigger: false,

			instInterval: undefined,
			instTimeout1: undefined,
			instTimeout2: undefined,
			instTimeout3: undefined,
			instTimeout4: undefined,
			instTimeout5: undefined,

			randomBooleanTrigger: false,
			randomInterval: undefined,
			randomTimeout1: undefined,
			randomTimeout2: undefined,

			voiceControlTrigger: undefined,
			micRecordingTrigger: undefined,
			voiceInterval: undefined,
			voiceTimeout1: undefined,
			voiceTimeout2: undefined,
			voiceListInterval: undefined,
			voiceListTimeout1: undefined,
			voiceListTimeout2: undefined,
			voiceListControlTrigger: undefined,
			recordInterval: undefined,
			recordTimeout1: undefined,
			recordTimeout2: undefined,
			voiceControlMasterTimer1: undefined,
			voiceControlMasterTimer2: undefined,
			voiceControlMasterTimer3: undefined,
			//AMBIENCE DATA
			whatIsLoading: "Tutorial",
			TutorialFX: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": false,
				"volume": -6
			}).toMaster(),
			changeFX: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": false,
				"volume": -6
			}).toMaster(),
			ambience1Vol: -10,
			ambience2Vol: -10,
			ambience3Vol: -10,
			ambience4Vol: -10,
			ambience5Vol: -10,
			ambience6Vol: -10,
			soundSourceVOVol: -10,
			soundFXVOVol: -10,
			randomizeVOVol: -10,
			voiceVOVol: -10,
			exploreVol: -6,
			ambience1Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true
			}),
			ambience2Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true
			}),
			ambience3Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true
			}),
			ambience4Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true
			}),
			ambience5Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true
			}),
			ambience6Player: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true
			}),
			soundSourceVOPlayer: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": -10
			}),
			soundFXVOPlayer: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": -10
			}),
			randomizeVOPlayer: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": -10
			}),
			voiceControlVO: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": -10
			}),
			exploreVO: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": true,
				"volume": -6
			}),
			//AUDIO ROUTING & EFFECTS
			playBackSpeed: 1,
			fxDecay: 2.5,
			// masterVolume:     		0,
			loadingSoundID: undefined,
			audioLoading: undefined,
			fxConvolverAmt: 0,
			fxChorusAmt: 0,
			fxDelayAmt: 0,
			fxAutoFilterAmt: 3500,
			mattChill: false,
			fxConvolver: undefined,
			fxChorus: undefined,
			fxDistort: undefined,
			fxDelay: undefined,
			fxAutoFilter: undefined,

			speedToggle: true,
			fxDelayToggle: true,
			fxConvolverToggle: true,
			fxChorusToggle: true,
			fxFilterToggle: false,

			masterMeter: undefined,
			masterLevel: 0,
			masterVolumeSub: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Volume(0),
			//SPEECH
			//VISUAL VOICE COMMAND VIEWING
			userVoiceToText: "",
			//IF SPEECH IS ALLOWED SHOW SPEECH ACTIVATE BUTTON (SET VIA APP.js)
			allowSpeechControl: false,
			//GLOBAL COMMAND TRIGGERING VOICE COMMANDS ON AND OFF
			isVoiceControl: false,
			//COMMAND FOR CSS CONTROL WHEN VOICE IS ACTIVE OR NOT
			recognizing: undefined,
			recognitionTutorial: undefined,
			//HOLDS ALL OF SPEECHRECONGNITION JSON
			voiceCommandArray: undefined,
			speechRecognitionList: undefined,
			voiceCommandConfidence: undefined,
			//STRING LINE TO TEST FOR VOICE COMMAND ACTIONS
			testObjectVUI: "",
			//BUTTON SWITCHING & TEXT
			initSpeech: true,
			speechBtnTxt: "Say A Command",
			speechStartTopBtnTrigger: true,
			//SHOWS LIST OF COMMANDS
			showVoiceCommandList: false,
			//DISABLE WHILE RECORDING
			isDisableListening: true,
			//TRUE WHEN STOPPING ALL SPEECH FUNCTIONS TO GO HOME
			stopModuleSpeech: false,
			//IF USER ENGAGES VOICE CONTROL BUT GOES HOME VIA MOUSE BUTTON THIS TRIGGERS MODULE SPEECH DISPOSE
			//EXPLORE
			isExploreFuncRunning: false,
			didWeAdventure: false,
			exploreSound1: undefined,
			exploreBtnBoolean: false,
			//WHAT DEVICE
			isChrome: Boolean,
			isFirefox: Boolean,
			isSafari: Boolean,
			isOpera: Boolean,
			isIE: Boolean,
			isEdge: Boolean,
			isBlink: Boolean,
			iOS: Boolean,
			AndroidMobile: Boolean,
			//EXPLORE TIMES OUTS
			exploreTxt: "Explore!"
		}, _defineProperty(_ref, 'exploreTimeout1', undefined), _defineProperty(_ref, 'exploreTimeout2', undefined), _defineProperty(_ref, 'exploreTimeout3', undefined), _defineProperty(_ref, 'startAudioBoolean', true), _ref;
	},
	created: function created() {
		var _this = this;

		this.isVoiceControl = this.$store.state.isVoiceControlled;
		if (this.isVoiceControl) {
			this.$store.state.doNotAddress = true;
		}

		window.onpopstate = function () {
			document.body.className = 'default';
			_this.goHome();
		};
		var ua = window.navigator.userAgent;
		this.isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
		this.isFirefox = typeof InstallTrigger !== 'undefined';
		this.isSafari = /constructor/i.test(window.HTMLElement) || function (p) {
			return p.toString() === "[object SafariRemoteNotification]";
		}(!window['safari'] || safari.pushNotification);
		this.isOpera = !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
		this.isIE = /*@cc_on!@*/false || !!document.documentMode;
		this.isEdge = !this.isIE && !!window.StyleMedia;
		this.isBlink = (this.isChrome || this.isOpera) && !!window.CSS, this.iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
		this.AndroidMobile = /Android/i.test(navigator.userAgent);
		//CHROME ALLOWS SPEECH AND MEDIA RECORDING
		if (this.isChrome === true) {
			this.userMobile = false;
			//FIREFOX ONLY ALLOWS MEDIA RECORDING
		} else if (this.isFirefox === true) {
			this.userMobile = false;
			//NO SPEECH AND NO MEDIA RECORDING FOR THE FOLLOWING
		} else if (this.AndroidMobile === true || this.iOS) {
			this.userMobile = true;
		} else if (this.isSafari === true || this.isOpera === true || this.isBlink === true || this.isEdge === true || this.isIE === true) {
			this.userMobile = false;
		}
		this.firstAudioLoadFunc();
		this.bufferLoading();
		this.audioRouting();
	},

	computed: {
		//THE PLUNGE BACKGROUND CHANGE
		plungeClass: function plungeClass() {
			// if (this.activeSun === false){
			if (this.plungeDepth === 1) {
				this.backgroundColor10 = false;
				this.backgroundColor9 = false;
				this.backgroundColor8 = false;
				this.backgroundColor7 = false;
				this.backgroundColor6 = false;
				this.backgroundColor5 = false;
				this.backgroundColor4 = false;
				this.backgroundColor3 = false;
				this.backgroundColor2 = false;
				this.backgroundColor1 = true;
			} else if (this.plungeDepth === 2) {
				this.backgroundColor10 = false;
				this.backgroundColor9 = false;
				this.backgroundColor8 = false;
				this.backgroundColor7 = false;
				this.backgroundColor6 = false;
				this.backgroundColor5 = false;
				this.backgroundColor4 = false;
				this.backgroundColor3 = false;
				this.backgroundColor2 = true;
				this.backgroundColor1 = false;
			} else if (this.plungeDepth === 3) {
				this.backgroundColor10 = false;
				this.backgroundColor9 = false;
				this.backgroundColor8 = false;
				this.backgroundColor7 = false;
				this.backgroundColor6 = false;
				this.backgroundColor5 = false;
				this.backgroundColor4 = false;
				this.backgroundColor3 = true;
				this.backgroundColor2 = false;
				this.backgroundColor1 = false;
			} else if (this.plungeDepth === 4) {
				this.backgroundColor10 = false;
				this.backgroundColor9 = false;
				this.backgroundColor8 = false;
				this.backgroundColor7 = false;
				this.backgroundColor6 = false;
				this.backgroundColor5 = false;
				this.backgroundColor4 = true;
				this.backgroundColor3 = false;
				this.backgroundColor2 = false;
				this.backgroundColor1 = false;
			} else if (this.plungeDepth === 5) {
				this.backgroundColor10 = false;
				this.backgroundColor9 = false;
				this.backgroundColor8 = false;
				this.backgroundColor7 = false;
				this.backgroundColor6 = false;
				this.backgroundColor5 = true;
				this.backgroundColor4 = false;
				this.backgroundColor3 = false;
				this.backgroundColor2 = false;
				this.backgroundColor1 = false;
			} else if (this.plungeDepth === 6) {
				this.backgroundColor10 = false;
				this.backgroundColor9 = false;
				this.backgroundColor8 = false;
				this.backgroundColor7 = false;
				this.backgroundColor6 = true;
				this.backgroundColor5 = false;
				this.backgroundColor4 = false;
				this.backgroundColor3 = false;
				this.backgroundColor2 = false;
				this.backgroundColor1 = false;
			} else if (this.plungeDepth === 7) {
				this.backgroundColor10 = false;
				this.backgroundColor9 = false;
				this.backgroundColor8 = false;
				this.backgroundColor7 = true;
				this.backgroundColor6 = false;
				this.backgroundColor5 = false;
				this.backgroundColor4 = false;
				this.backgroundColor3 = false;
				this.backgroundColor2 = false;
				this.backgroundColor1 = false;
			} else if (this.plungeDepth === 8) {
				this.backgroundColor10 = false;
				this.backgroundColor9 = false;
				this.backgroundColor8 = true;
				this.backgroundColor7 = false;
				this.backgroundColor6 = false;
				this.backgroundColor5 = false;
				this.backgroundColor4 = false;
				this.backgroundColor3 = false;
				this.backgroundColor2 = false;
				this.backgroundColor1 = false;
			} else if (this.plungeDepth === 9) {
				this.backgroundColor10 = false;
				this.backgroundColor9 = true;
				this.backgroundColor8 = false;
				this.backgroundColor7 = false;
				this.backgroundColor6 = false;
				this.backgroundColor5 = false;
				this.backgroundColor4 = false;
				this.backgroundColor3 = false;
				this.backgroundColor2 = false;
				this.backgroundColor1 = false;
			} else if (this.plungeDepth === 10) {
				this.backgroundColor10 = true;
				this.backgroundColor9 = false;
				this.backgroundColor8 = false;
				this.backgroundColor7 = false;
				this.backgroundColor6 = false;
				this.backgroundColor5 = false;
				this.backgroundColor4 = false;
				this.backgroundColor3 = false;
				this.backgroundColor2 = false;
				this.backgroundColor1 = false;
			}
			return {
				"backgroundColorTutorial10": this.backgroundColor10,
				"backgroundColorTutorial9": this.backgroundColor9,
				"backgroundColorTutorial8": this.backgroundColor8,
				"backgroundColorTutorial7": this.backgroundColor7,
				"backgroundColorTutorial6": this.backgroundColor6,
				"backgroundColorTutorial5": this.backgroundColor5,
				"backgroundColorTutorial4": this.backgroundColor4,
				"backgroundColorTutorial3": this.backgroundColor3,
				"backgroundColorTutorial2": this.backgroundColor2,
				"backgroundColorTutorial1": this.backgroundColor1
				// } else if (this.activeSun === true){
				// 	if (this.masterLevel < -36){
				// 		this.sunReactiveColor10 = false;
				// 		this.sunReactiveColor9 = false;
				// 		this.sunReactiveColor8 = false;
				// 		this.sunReactiveColor7 = false;
				// 		this.sunReactiveColor6 = false;
				// 		this.sunReactiveColor5 = false;
				// 		this.sunReactiveColor4 = false;
				// 		this.sunReactiveColor3 = false;
				// 		this.sunReactiveColor2 = false;
				// 		this.sunReactiveColor1 = true;
				// 	} else if (this.masterLevel < -32){
				// 		this.sunReactiveColor10 = false;
				// 		this.sunReactiveColor9 = false;
				// 		this.sunReactiveColor8 = false;
				// 		this.sunReactiveColor7 = false;
				// 		this.sunReactiveColor6 = false;
				// 		this.sunReactiveColor5 = false;
				// 		this.sunReactiveColor4 = false;
				// 		this.sunReactiveColor3 = false;
				// 		this.sunReactiveColor2 = true;
				// 		this.sunReactiveColor1 = false;
				// } else if (this.masterLevel < -30){
				// 	this.sunReactiveColor10 = false;
				// 	this.sunReactiveColor9 = false;
				// 	this.sunReactiveColor8 = false;
				// 	this.sunReactiveColor7 = false;
				// 	this.sunReactiveColor6 = false;
				// 	this.sunReactiveColor5 = false;
				// 	this.sunReactiveColor4 = false;
				// 	this.sunReactiveColor3 = true;
				// 	this.sunReactiveColor2 = false;
				// 	this.sunReactiveColor1 = false;
				// } else if (this.masterLevel < -28){
				// 	this.sunReactiveColor10 = false;
				// 	this.sunReactiveColor9 = false;
				// 	this.sunReactiveColor8 = false;
				// 	this.sunReactiveColor7 = false;
				// 	this.sunReactiveColor6 = false;
				// 	this.sunReactiveColor5 = false;
				// 	this.sunReactiveColor4 = true;
				// 	this.sunReactiveColor3 = false;
				// 	this.sunReactiveColor2 = false;
				// 	this.sunReactiveColor1 = false;
				// } else if (this.masterLevel < -26){
				// 	this.sunReactiveColor10 = false;
				// 	this.sunReactiveColor9 = false;
				// 	this.sunReactiveColor8 = false;
				// 	this.sunReactiveColor7 = false;
				// 	this.sunReactiveColor6 = false;
				// 	this.sunReactiveColor5 = true;
				// 	this.sunReactiveColor4 = false;
				// 	this.sunReactiveColor3 = false;
				// 	this.sunReactiveColor2 = false;
				// 	this.sunReactiveColor1 = false;
				// } else if (this.masterLevel < -24){
				// 	this.sunReactiveColor10 = false;
				// 	this.sunReactiveColor9 = false;
				// 	this.sunReactiveColor8 = false;
				// 	this.sunReactiveColor7 = false;
				// 	this.sunReactiveColor6 = true;
				// 	this.sunReactiveColor5 = false;
				// 	this.sunReactiveColor4 = false;
				// 	this.sunReactiveColor3 = false;
				// 	this.sunReactiveColor2 = false;
				// 	this.sunReactiveColor1 = false;
				// } else if (this.masterLevel < -22){
				// 	this.sunReactiveColor10 = false;
				// 	this.sunReactiveColor9 = false;
				// 	this.sunReactiveColor8 = false;
				// 	this.sunReactiveColor7 = true;
				// 	this.sunReactiveColor6 = false;
				// 	this.sunReactiveColor5 = false;
				// 	this.sunReactiveColor4 = false;
				// 	this.sunReactiveColor3 = false;
				// 	this.sunReactiveColor2 = false;
				// 	this.sunReactiveColor1 = false;
				// } else if (this.masterLevel < -20){
				// 	this.sunReactiveColor10 = false;
				// 	this.sunReactiveColor9 = false;
				// 	this.sunReactiveColor8 = true;
				// 	this.sunReactiveColor7 = false;
				// 	this.sunReactiveColor6 = false;
				// 	this.sunReactiveColor5 = false;
				// 	this.sunReactiveColor4 = false;
				// 	this.sunReactiveColor3 = false;
				// 	this.sunReactiveColor2 = false;
				// 	this.sunReactiveColor1 = false;
				// } else if (this.masterLevel < -18){
				// 	this.sunReactiveColor10 = false;
				// 	this.sunReactiveColor9 = true;
				// 	this.sunReactiveColor8 = false;
				// 	this.sunReactiveColor7 = false;
				// 	this.sunReactiveColor6 = false;
				// 	this.sunReactiveColor5 = false;
				// 	this.sunReactiveColor4 = false;
				// 	this.sunReactiveColor3 = false;
				// 	this.sunReactiveColor2 = false;
				// 	this.sunReactiveColor1 = false;
				// } else if (this.masterLevel > -16){
				// 	this.sunReactiveColor10 = true;
				// 	this.sunReactiveColor9 = false;
				// 	this.sunReactiveColor8 = false;
				// 	this.sunReactiveColor7 = false;
				// 	this.sunReactiveColor6 = false;
				// 	this.sunReactiveColor5 = false;
				// 	this.sunReactiveColor4 = false;
				// 	this.sunReactiveColor3 = false;
				// 	this.sunReactiveColor2 = false;
				// 	this.sunReactiveColor1 = false;
				// } 
				// return{
				// 			"sunReactiveColorClassTutorial10": this.sunReactiveColor10,
				// 			"sunReactiveColorClassTutorial9": this.sunReactiveColor9,
				// 			"sunReactiveColorClassTutorial8": this.sunReactiveColor8,
				// 			"sunReactiveColorClassTutorial7": this.sunReactiveColor7,
				// 			"sunReactiveColorClassTutorial6": this.sunReactiveColor6,
				// 			"sunReactiveColorClassTutorial5": this.sunReactiveColor5,
				// 			"sunReactiveColorClassTutorial4": this.sunReactiveColor4,
				// 			"sunReactiveColorClassTutorial3": this.sunReactiveColor3,
				// 			"sunReactiveColorClassTutorial2": this.sunReactiveColor2,
				// 			"sunReactiveColorClassTutorial1": this.sunReactiveColor1
				// }
				// }
			};
		},

		//SHOW AND HIDE CLASS CHANGES
		helpClass: function helpClass() {
			return {
				"btn btn-helpBtn1Tutorial": this.helpTrigger,
				"btn btn-helpBtn2Tutorial": !this.helpTrigger
			};
		},
		mailingListBtnClass: function mailingListBtnClass() {
			return {
				"btn btn-transparent": this.mailingListBtn,
				"btn btn-info": !this.mailingListBtn
			};
		},

		//AMBIENCE CLASS CHANGES
		ambience1Class: function ambience1Class() {
			return {
				"btn btn-playTutorial": this.ambience1Boolean,
				"btn btn-stopTutorial": !this.ambience1Boolean,
				"btn sectionHighlight": this.ambience1BooleanTrigger
			};
		},
		ambience2Class: function ambience2Class() {
			return {
				"btn btn-playTutorial": this.ambience2Boolean,
				"btn btn-stopTutorial": !this.ambience2Boolean,
				"btn sectionHighlight": this.ambience2BooleanTrigger
			};
		},
		ambience3Class: function ambience3Class() {
			return {
				"btn btn-playTutorial": this.ambience3Boolean,
				"btn btn-stopTutorial": !this.ambience3Boolean,
				"btn sectionHighlight": this.ambience3BooleanTrigger
			};
		},
		ambience4Class: function ambience4Class() {
			return {
				"btn btn-playTutorial": this.ambience4Boolean,
				"btn btn-stopTutorial": !this.ambience4Boolean,
				"btn sectionHighlight": this.ambience4BooleanTrigger
			};
		},
		ambience5Class: function ambience5Class() {
			return {
				"btn btn-playTutorial": this.ambience5Boolean,
				"btn btn-stopTutorial": !this.ambience5Boolean,
				"btn sectionHighlight": this.ambience5BooleanTrigger
			};
		},
		ambience6Class: function ambience6Class() {
			return {
				"btn btn-playTutorial": this.ambience6Boolean,
				"btn btn-stopTutorial": !this.ambience6Boolean,
				"btn sectionHighlight": this.ambience6BooleanTrigger
			};
		},
		soundSourceVOClass: function soundSourceVOClass() {
			return {
				"btn btn-playTutorial": this.soundSourceVOBoolean,
				"btn btn-stopTutorial": !this.soundSourceVOBoolean
				// "btn sectionHighlight" : this.soundSourceVOBooleanTrigger,
			};
		},
		soundFXVOClass: function soundFXVOClass() {
			return {
				"btn btn-playTutorial": this.soundFXVOBoolean,
				"btn btn-stopTutorial": !this.soundFXVOBoolean
				// "btn sectionHighlight" : this.soundFXVOBooleanTrigger,
			};
		},
		randomizeVOClass: function randomizeVOClass() {
			return {
				"btn btn-playTutorial": this.randomizeVOBoolean,
				"btn btn-stopTutorial": !this.randomizeVOBoolean
				// "btn sectionHighlight" : this.randomizeVOBooleanTrigger,
			};
		},
		voiceVOClass: function voiceVOClass() {
			return {
				"btn btn-playTutorial": this.voiceVOBoolean,
				"btn btn-stopTutorial": !this.voiceVOBoolean
				// "btn sectionHighlight" : this.voiceVOBooleanTrigger,
			};
		},
		exploreVOClass: function exploreVOClass() {
			return {
				"btn btn-playTutorial": this.exploreVOBoolean,
				"btn btn-stopTutorial": !this.exploreVOBoolean
			};
		},
		mattChillClass: function mattChillClass() {
			return {
				"btn btn-mattChillOnTutorial": this.mattChill,
				"btn btn-mattChillOffTutorial": !this.mattChill,
				"btn sectionHighlight": this.randomBooleanTrigger
			};
		},

		//AMBIENCE ICON CSS
		//AMBIENCE ICON CSS
		ambience1Icon: function ambience1Icon() {
			return {
				"fal fa-times-circle": !this.ambience1Boolean,
				"fal fa-check-circle": this.ambience1Boolean
			};
		},
		ambience2Icon: function ambience2Icon() {
			return {
				"fal fa-times-circle": !this.ambience2Boolean,
				"fal fa-check-circle": this.ambience2Boolean
			};
		},
		ambience3Icon: function ambience3Icon() {
			return {
				"fal fa-times-circle": !this.ambience3Boolean,
				"fal fa-check-circle": this.ambience3Boolean
			};
		},
		ambience4Icon: function ambience4Icon() {
			return {
				"fal fa-times-circle": !this.ambience4Boolean,
				"fal fa-check-circle": this.ambience4Boolean
			};
		},
		ambience5Icon: function ambience5Icon() {
			return {
				"fal fa-times-circle": !this.ambience5Boolean,
				"fal fa-check-circle": this.ambience5Boolean
			};
		},
		ambience6Icon: function ambience6Icon() {
			return {
				"fal fa-times-circle": !this.ambience6Boolean,
				"fal fa-check-circle": this.ambience6Boolean
			};
		},
		soundSourceVOIcon: function soundSourceVOIcon() {
			return {
				"fal fa-times-circle": !this.soundSourceVOBoolean,
				"fal fa-check-circle": this.soundSourceVOBoolean
			};
		},
		soundFXVOIcon: function soundFXVOIcon() {
			return {
				"fal fa-times-circle": !this.soundFXVOBoolean,
				"fal fa-check-circle": this.soundFXVOBoolean
			};
		},
		randomizeVOIcon: function randomizeVOIcon() {
			return {
				"fal fa-times-circle": !this.randomizeVOBoolean,
				"fal fa-check-circle": this.randomizeVOBoolean
			};
		},
		voiceVOIcon: function voiceVOIcon() {
			return {
				"fal fa-times-circle": !this.voiceVOBoolean,
				"fal fa-check-circle": this.voiceVOBoolean
			};
		},
		exploreVOIcon: function exploreVOIcon() {
			return {
				"fal fa-times-circle": !this.exploreVOBoolean,
				"fal fa-check-circle": this.exploreVOBoolean
			};
		},

		//RANGER CLASS CHANGES
		ambiance1RangerClass: function ambiance1RangerClass() {
			if (this.ambience1Boolean === true && this.ambience1BooleanTrigger === false) {
				return {
					"ambianceRangerPlayTutorial": this.ambience1Boolean
				};
			} else if (this.ambience1Boolean === false && this.ambience1BooleanTrigger === false) {
				return {
					"ambianceRangerStopTutorial": !this.ambience1Boolean
				};
			} else if (this.ambience1BooleanTrigger === true) {
				return {
					"sectionHighlightSlider": this.ambience1BooleanTrigger
				};
			}
		},
		ambiance2RangerClass: function ambiance2RangerClass() {
			if (this.ambience2Boolean === true && this.ambience2BooleanTrigger === false) {
				return {
					"ambianceRangerPlayTutorial": this.ambience2Boolean
				};
			} else if (this.ambience2Boolean === false && this.ambience2BooleanTrigger === false) {
				return {
					"ambianceRangerStopTutorial": !this.ambience2Boolean
				};
			} else if (this.ambience2BooleanTrigger === true) {
				return {
					"sectionHighlightSlider": this.ambience2BooleanTrigger
				};
			}
		},
		ambiance3RangerClass: function ambiance3RangerClass() {
			if (this.ambience3Boolean === true && this.ambience3BooleanTrigger === false) {
				return {
					"ambianceRangerPlayTutorial": this.ambience3Boolean
				};
			} else if (this.ambience3Boolean === false && this.ambience3BooleanTrigger === false) {
				return {
					"ambianceRangerStopTutorial": !this.ambience3Boolean
				};
			} else if (this.ambience3BooleanTrigger === true) {
				return {
					"sectionHighlightSlider": this.ambience3BooleanTrigger
				};
			}
		},
		ambiance4RangerClass: function ambiance4RangerClass() {
			if (this.ambience4Boolean === true && this.ambience4BooleanTrigger === false) {
				return {
					"ambianceRangerPlayTutorial": this.ambience4Boolean
				};
			} else if (this.ambience4Boolean === false && this.ambience4BooleanTrigger === false) {
				return {
					"ambianceRangerStopTutorial": !this.ambience4Boolean
				};
			} else if (this.ambience4BooleanTrigger === true) {
				return {
					"sectionHighlightSlider": this.ambience4BooleanTrigger
				};
			}
		},
		ambiance5RangerClass: function ambiance5RangerClass() {
			if (this.ambience5Boolean === true && this.ambience5BooleanTrigger === false) {
				return {
					"ambianceRangerPlayTutorial": this.ambience5Boolean
				};
			} else if (this.ambience5Boolean === false && this.ambience5BooleanTrigger === false) {
				return {
					"ambianceRangerStopTutorial": !this.ambience5Boolean
				};
			} else if (this.ambience5BooleanTrigger === true) {
				return {
					"sectionHighlightSlider": this.ambience5BooleanTrigger
				};
			}
		},
		ambiance6RangerClass: function ambiance6RangerClass() {
			if (this.ambience6Boolean === true && this.ambience6BooleanTrigger === false) {
				return {
					"ambianceRangerPlayTutorial": this.ambience6Boolean
				};
			} else if (this.ambience6Boolean === false && this.ambience6BooleanTrigger === false) {
				return {
					"ambianceRangerStopTutorial": !this.ambience6Boolean
				};
			} else if (this.ambience6BooleanTrigger === true) {
				return {
					"sectionHighlightSlider": this.ambience6BooleanTrigger
				};
			}
		},
		instrumentRanger1: function instrumentRanger1() {
			return {
				"instrumentRangerTutorial": !this.inst1BooleanTrigger,
				"sectionHighlightSlider": this.inst1BooleanTrigger
			};
		},
		instrumentRanger2: function instrumentRanger2() {
			return {
				"instrumentRangerTutorial": !this.inst2BooleanTrigger,
				"sectionHighlightSlider": this.inst2BooleanTrigger
			};
		},
		instrumentRanger3: function instrumentRanger3() {
			return {
				"instrumentRangerTutorial": !this.inst3BooleanTrigger,
				"sectionHighlightSlider": this.inst3BooleanTrigger
			};
		},
		instrumentRanger4: function instrumentRanger4() {
			return {
				"instrumentRangerTutorial": !this.inst4BooleanTrigger,
				"sectionHighlightSlider": this.inst4BooleanTrigger
			};
		},
		instrumentRanger5: function instrumentRanger5() {
			return {
				"instrumentRangerTutorial": !this.inst5BooleanTrigger,
				"sectionHighlightSlider": this.inst5BooleanTrigger
			};
		},
		highlightSlider1: function highlightSlider1() {
			return {
				"voiceBadgeTutorial": !this.inst1BooleanTrigger,
				"sectionHighlight": this.inst1BooleanTrigger
			};
		},
		highlightSlider2: function highlightSlider2() {
			return {
				"voiceBadgeTutorial": !this.inst2BooleanTrigger,
				"sectionHighlight": this.inst2BooleanTrigger
			};
		},
		highlightSlider3: function highlightSlider3() {
			return {
				"voiceBadgeTutorial": !this.inst3BooleanTrigger,
				"sectionHighlight": this.inst3BooleanTrigger
			};
		},
		highlightSlider4: function highlightSlider4() {
			return {
				"voiceBadgeTutorial": !this.inst4BooleanTrigger,
				"sectionHighlight": this.inst4BooleanTrigger
			};
		},
		highlightSlider5: function highlightSlider5() {
			return {
				"voiceBadgeTutorial": !this.inst5BooleanTrigger,
				"sectionHighlight": this.inst5BooleanTrigger
			};
		},

		//AUDIO MIXING
		ambienceMixing: function ambienceMixing() {
			this.ambience1Player.volume.value = this.ambience1Vol;
			this.ambience2Player.volume.value = this.ambience2Vol;
			this.ambience3Player.volume.value = this.ambience3Vol;
			this.ambience4Player.volume.value = this.ambience4Vol;
			this.ambience5Player.volume.value = this.ambience5Vol;
			this.ambience6Player.volume.value = this.ambience6Vol;
		},
		adjustInputVolume: function adjustInputVolume() {
			this.userMic.volume.value = this.userMicInputLevel;
		},
		fxConvolverMix: function fxConvolverMix() {
			if (this.userMobile === false) {
				if (this.fxConvolverToggle === true) {
					this.fxConvolver.wet.setTargetAtTime(this.fxConvolverAmt / 100, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				} else if (this.fxConvolverToggle === false) {
					this.fxConvolver.wet.setTargetAtTime(0, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				}
			}
		},
		fxDelayMix: function fxDelayMix() {
			if (this.userMobile === false) {
				if (this.fxDelayToggle === true) {
					this.fxDelay.wet.setTargetAtTime(this.fxDelayAmt / 100, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +1);
				} else if (this.fxDelayToggle === false) {
					this.fxDelay.wet.setTargetAtTime(0, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +1);
				}
			}
		},
		fxChorusMix: function fxChorusMix() {
			if (this.userMobile === false) {
				if (this.fxChorusToggle === true) {
					this.fxChorus.wet.setTargetAtTime(this.fxChorusAmt / 100, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				} else if (this.fxChorusToggle === false) {
					this.fxChorus.wet.setTargetAtTime(0, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				}
			}
		},
		fxAutoFilterMix: function fxAutoFilterMix() {
			if (this.userMobile === false) {
				if (this.fxFilterToggle === true) {
					this.fxAutoFilter.frequency.setTargetAtTime(this.fxAutoFilterAmt, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				} else if (this.fxFilterToggle === false) {
					this.fxAutoFilter.frequency.setTargetAtTime(20000, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.1);
				}
			}
		},
		playbackSpeedFunc: function playbackSpeedFunc() {
			if (this.speedToggle === true) {
				this.ambience1Player.playbackRate = this.playBackSpeed;
				this.ambience2Player.playbackRate = this.playBackSpeed;
				this.ambience3Player.playbackRate = this.playBackSpeed;
				this.ambience4Player.playbackRate = this.playBackSpeed;
				this.ambience5Player.playbackRate = this.playBackSpeed;
				this.ambience6Player.playbackRate = this.playBackSpeed;
				this.soundSourceVOPlayer.playbackRate = this.playBackSpeed;
				this.soundFXVOPlayer.playbackRate = this.playBackSpeed;
				this.randomizeVOPlayer.playbackRate = this.playBackSpeed;
			} else if (this.speedToggle === false) {
				this.ambience1Player.playbackRate = 1;
				this.ambience2Player.playbackRate = 1;
				this.ambience3Player.playbackRate = 1;
				this.ambience4Player.playbackRate = 1;
				this.ambience5Player.playbackRate = 1;
				this.ambience6Player.playbackRate = 1;
				this.soundSourceVOPlayer.playbackRate = 1;
				this.soundFXVOPlayer.playbackRate = 1;
				this.randomizeVOPlayer.playbackRate = 1;
				// this.voiceControlVO.playbackRate 		= 1;
			}
		},

		//SPEECH
		speechStartStopClass: function speechStartStopClass() {
			return {
				"recordingClassEngagedTutorial": this.recognizing,
				"recordingClassDisengagedTutorial": !this.recognizing,
				"sectionHighlightVoiceBtn": this.voiceControlTrigger
			};
		},
		speechIconClass: function speechIconClass() {
			return {
				"fa fa-microphone-alt fa-spin": this.recognizing,
				"fa fa-microphone-alt": !this.recognizing
			};
		},
		speechShowListClass: function speechShowListClass() {
			return {
				"recordingClassEngagedTutorial": this.showVoiceCommandList,
				"recordingClassDisengagedTutorial": !this.showVoiceCommandList,
				"sectionHighlightVoiceBtn": this.voiceListControlTrigger
			};
		},
		speechSubmitClass: function speechSubmitClass() {
			return {
				"btn btn-speechSubmitOn mb-2": this.submitSpeechTxttoVoice,
				"btn btn-speechSubmitOff mb-2": !this.submitSpeechTxttoVoice
			};
		},

		//EXPLORE
		exploreFuncClass: function exploreFuncClass() {
			return {
				"recordingClassDisengagedTutorial": !this.isExploreFuncRunning,
				"recordingClassEngagedTutorial": this.isExploreFuncRunning,
				"sectionHighlightVoiceBtn": this.exploreControlTrigger
			};
		},
		exploreIconClass: function exploreIconClass() {
			return {
				"fab fa-wpexplorer": !this.isExploreFuncRunning,
				"fab fa-wpexplorer fa-spin": this.isExploreFuncRunning
			};
		}
	},
	methods: {
		//START AUDIO	
		startAudio: function startAudio() {
			__WEBPACK_IMPORTED_MODULE_0__node_modules_startaudiocontext_StartAudioContext_js___default()(__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.context, "#enterFuncBtn");
			this.$store.state.hasAudioContextTriggered = true;
		},

		//SPEECH
		userVoiceToTextFunc: function userVoiceToTextFunc() {
			var _this2 = this;

			this.submitSpeechTxttoVoice = true;
			this.testObjectVUI = this.userVoiceToText;
			console.log(this.testObjectVUI);
			this.sourceSortingVUI();
			setTimeout(function () {
				_this2.submitSpeechTxttoVoice = false;
			}, 250);
		},
		speechFunc: function speechFunc() {
			var _this3 = this;

			if (this.initSpeech === true) {
				this.recognitionTutorial = new webkitSpeechRecognition();
				this.recognizing;
				this.recognitionTutorial.continuous = false;
				this.recognitionTutorial.interimResults = true;

				this.recognitionTutorial.onresult = function (event) {
					for (var i = event.resultIndex; i < event.results.length; ++i) {
						if (event.results[i].isFinal) {
							if (!_this3.isDisableListening) {
								_this3.testObjectVUI += event.results[i][0].transcript;
								console.log('Speech String Command: ' + event.results[i][0].transcript);
								_this3.sourceSortingVUI();
							}
						}
					}
				};
				this.recognitionTutorial.onspeechend = function () {
					console.log('%c Tutorial Module SPEECH Ended', 'background: red; color: black');
					// setTimeout(this.sourceSortingVUI, 500);
					_this3.recognizing = false;
					_this3.speechBtnTxt = "Say A Command";
					__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master.volume.setTargetAtTime(0, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.context.currentTime, +0.5);
				};
				this.recognitionTutorial.onspeechstart = function () {
					console.log('%c Tutorial Module SPEECH Began', 'background: green; color: white');
					_this3.recognizing = true;
					_this3.speechBtnTxt = "Listening For Command";
					__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master.volume.setTargetAtTime(-10, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.context.currentTime, +1);
				};
				this.recognitionTutorial.onsoundstart = function () {
					console.log('%c Tutorial Module LISTENING Began', 'background: green; color: white');
				};
				this.recognitionTutorial.onaudioend = function () {
					console.log('%c Tutorial Module LISTENING Ended', 'background: green; color: white');
					// setTimeout(this.sourceSortingVUI, 500);
					_this3.recognizing = false;
					_this3.speechBtnTxt = "Say A Command";
				};
				this.recognitionTutorial.onend = function () {
					console.log('%c Tutorial Module SPEECH SESSION ENDED', 'background: green; color: white');
					if (_this3.stopModuleSpeech === false) {
						_this3.recognitionTutorial.start();
					}
				};
				this.recognizing = true;
				//MAKE SURE SPEECH IS NOT RE-ENGAGED
				this.initSpeech = false;
				//GLOBAL VOICE COMMAND IS SET TO TRUE
				this.$store.state.isVoiceControlled = true;
				this.recognitionTutorial.start();
				//IF USER ENGAGES VOICE CONTROL BUT GOES HOME VIA MOUSE BUTTON THIS TRIGGERS MODULE SPEECH DISPOSE
				this.goingHomeNotViaVoiceCommand = true;
				//CONTROLS recognition.onend TO RESTART LISTENING
				this.stopModuleSpeech = false;
				//TURN LISTENING BACK ON
				this.isDisableListening = false;
				//IF BEING VOICE CONTROLLED DON'T PLAY THE NICE, TELL ME WHERE YOU WANT TO GO PROMPT ON WELCOME PAGE
				this.$store.state.doNotAddress = true;
			} else if (this.initSpeech === false) {}
		},
		resetFunc: function resetFunc() {
			this.recognizing = false;
		},
		speechStartStopFunc: function speechStartStopFunc() {
			this.speechStartTopBtnTrigger = !this.speechStartTopBtnTrigger;

			if (this.speechStartTopBtnTrigger === true) {
				this.speechFunc();
			} else if (this.speechStartTopBtnTrigger === false) {
				this.initSpeech = true;
				this.stopModuleSpeech = true;
				this.recognizing = false;
				this.recognitionTutorial.stop();
				this.$store.state.isVoiceControlled = false;
			}
		},
		sourceSortingVUI: function sourceSortingVUI() {
			//FOR VISUAL REFERENCE
			this.userVoiceToText = this.testObjectVUI;

			var source1RegEx = XRegExp.build('(?x) {{source1Name}} | {{label1Name}}', {
				source1Name: XRegExp.build('{{source1Name1}} | {{source1Name2}}', {
					source1Name1: /source\sone/,
					source1Name2: /source\s1/
				}),
				label1Name: XRegExp.build('{{label1Name1}}', {
					label1Name1: /serene\s?beach|serene|beach/
				})
			}, 'xgi');

			var source2RegEx = XRegExp.build('(?x) {{source2Name}} | {{label2Name}}', {
				source2Name: XRegExp.build('{{source2Name1}} | {{source2Name2}}', {
					source2Name1: /source\stw?o?o/,
					source2Name2: /source\s2/
				}),
				label2Name: XRegExp.build('{{label2Name1}}', {
					label2Name1: /forest|wood\s?lands?/
				})
			}, 'xgi');

			var source3RegEx = XRegExp.build('(?x) {{source3Name}} | {{label3Name}}', {
				source3Name: XRegExp.build('{{source3Name1}} | {{source3Name2}}', {
					source3Name1: /source\sthree/,
					source3Name2: /source\s3/
				}),
				label3Name: XRegExp.build('{{label3Name1}}', {
					label3Name1: /Tutorial|deep\s?sea/
				})
			}, 'xgi');

			var source4RegEx = XRegExp.build('(?x) {{source4Name}} | {{label4Name}}', {
				source4Name: XRegExp.build('{{source4Name1}} | {{source4Name2}}', {
					source4Name1: /source\sfou?re?/,
					source4Name2: /source\s4/
				}),
				label4Name: XRegExp.build('{{label4Name1}}', {
					label4Name1: /subway\s?stations?|subway|station/
				})
			}, 'xgi');

			var source5RegEx = XRegExp.build('(?x) {{source5Name}} | {{label5Name}}', {
				source5Name: XRegExp.build('{{source5Name1}} | {{source5Name2}}', {
					source5Name1: /source\sfive/,
					source5Name2: /source\s5/
				}),
				label5Name: XRegExp.build('{{label5Name1}}', {
					label5Name1: /longgrass|grass|wind|long/
				})
			}, 'xgi');

			var source6RegEx = XRegExp.build('(?x) {{source6Name}} | {{label6Name}}', {
				source6Name: XRegExp.build('{{source6Name1}} | {{source6Name2}}', {
					source6Name1: /source\ss[ei]x/,
					source6Name2: /source\s6/
				}),
				label6Name: XRegExp.build('{{label6Name1}}', {
					label6Name1: /stream|water/
				})
			}, 'xgi');
			//ALL SOUNDS
			var allSoundRegEx = XRegExp.build('(?x) {{allSoundName}}', {
				allSoundName: XRegExp.build('{{allSoundName1}} | {{allSoundName2}}', {
					allSoundName1: /all\ssounds?/,
					allSoundName2: /all\saudios?/
				})
			}, 'xgi');
			//SPEED
			var speedRegEx = XRegExp.build('(?x) {{speedName}}', {
				speedName: XRegExp.build('{{speedName1}} | {{speedName2}}', {
					speedName1: /speeds?/,
					speedName2: /slow|faster/
				})
			}, 'xgi');
			//DELAY
			var delayRegEx = XRegExp.build('(?x) {{delayName}}', {
				delayName: XRegExp.build('{{delayName1}} | {{delayName2}}', {
					delayName1: /delay/,
					delayName2: /lay/
				})
			}, 'xgi');
			//CHORUS
			var chorusRegEx = XRegExp.build('(?x) {{chorusName}}', {
				chorusName: XRegExp.build('{{chorusName1}} | {{chorusName2}}', {
					chorusName1: /chorus?/,
					chorusName2: /course/
				})
			}, 'xgi');
			//FILTER
			var filterRegEx = XRegExp.build('(?x) {{filterName}}', {
				filterName: XRegExp.build('{{filterName1}} | {{filterName2}}', {
					filterName1: /filter/,
					filterName2: /filter/
				})
			}, 'xgi');
			//REVERB
			var reverbRegEx = XRegExp.build('(?x) {{reverbName}}', {
				reverbName: XRegExp.build('{{reverbName1}} | {{reverbName2}}', {
					reverbName1: /verb/,
					reverbName2: /reverb/
				})
			}, 'xgi');
			//SHOW
			var infoRegEx = XRegExp.build('(?x) {{showName}}', {
				showName: XRegExp.build('{{showName1}} | {{showName2}}', {
					showName1: /info/,
					showName2: /information/
				})
			}, 'xgi');
			// console.log(infoRegEx);
			//HIDE
			var listRegEx = XRegExp.build('(?x) {{hideName}}', {
				hideName: XRegExp.build('{{hideName1}} | {{hideName2}}', {
					hideName1: /lists?/,
					hideName2: /menu/
				})
			}, 'xgi');
			// console.log(listRegEx);			

			var source1Boolean = source1RegEx.test(this.testObjectVUI);
			var source2Boolean = source2RegEx.test(this.testObjectVUI);
			var source3Boolean = source3RegEx.test(this.testObjectVUI);
			var source4Boolean = source4RegEx.test(this.testObjectVUI);
			var source5Boolean = source5RegEx.test(this.testObjectVUI);
			var source6Boolean = source6RegEx.test(this.testObjectVUI);
			var allSoundBoolean = allSoundRegEx.test(this.testObjectVUI);
			var speedBoolean = speedRegEx.test(this.testObjectVUI);
			var delayBoolean = delayRegEx.test(this.testObjectVUI);
			var chorusBoolean = chorusRegEx.test(this.testObjectVUI);
			var filterBoolean = filterRegEx.test(this.testObjectVUI);
			var reverbBoolean = reverbRegEx.test(this.testObjectVUI);
			var infoBoolean = infoRegEx.test(this.testObjectVUI);
			var listBoolean = listRegEx.test(this.testObjectVUI);

			if (source1Boolean) {
				this.source1VUI();
			} else if (source2Boolean) {
				this.source2VUI();
			} else if (source3Boolean) {
				this.source3VUI();
			} else if (source4Boolean) {
				this.source4VUI();
			} else if (source5Boolean) {
				this.source5VUI();
			} else if (source6Boolean) {
				this.source6VUI();
			} else if (allSoundBoolean) {
				this.allSoundVUI();
			} else if (speedBoolean) {
				this.speedVUI();
			} else if (delayBoolean) {
				this.delayVUI();
			} else if (chorusBoolean) {
				this.chorusVUI();
			} else if (filterBoolean) {
				this.filterVUI();
			} else if (reverbBoolean) {
				this.reverbVUI();
			} else if (infoBoolean) {
				this.infoVUI();
			} else if (listBoolean) {
				this.listVUI();
			} else {
				this.miscVUI();
			}
		},
		source1VUI: function source1VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience1Player.start();
				this.ambience1Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience1Player.stop();
				this.ambience1Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience1Vol < 0) {
						this.ambience1Vol += 12;
					}
				} else {
					if (this.ambience1Vol < 0) {
						this.ambience1Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience1Vol > -30) {
						this.ambience1Vol -= 12;
					}
				} else {
					if (this.ambience1Vol > -30) {
						this.ambience1Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		source2VUI: function source2VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience2Player.start();
				this.ambience2Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience2Player.stop();
				this.ambience2Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience2Vol < 0) {
						this.ambience2Vol += 12;
					}
				} else {
					if (this.ambience2Vol < 0) {
						this.ambience2Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience2Vol > -30) {
						this.ambience2Vol -= 12;
					}
				} else {
					if (this.ambience2Vol > -30) {
						this.ambience2Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		source3VUI: function source3VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience3Player.start();
				this.ambience3Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience3Player.stop();
				this.ambience3Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience3Vol < 0) {
						this.ambience3Vol += 12;
					}
				} else {
					if (this.ambience3Vol < 0) {
						this.ambience3Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience3Vol > -30) {
						this.ambience3Vol -= 12;
					}
				} else {
					if (this.ambience3Vol > -30) {
						this.ambience3Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		source4VUI: function source4VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience4Player.start();
				this.ambience4Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience4Player.stop();
				this.ambience4Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience4Vol < 0) {
						this.ambience4Vol += 12;
					}
				} else {
					if (this.ambience4Vol < 0) {
						this.ambience4Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience4Vol > -30) {
						this.ambience4Vol -= 12;
					}
				} else {
					if (this.ambience4Vol > -30) {
						this.ambience4Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		source5VUI: function source5VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience5Player.start();
				this.ambience5Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience5Player.stop();
				this.ambience5Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience5Vol < 0) {
						this.ambience5Vol += 12;
					}
				} else {
					if (this.ambience5Vol < 0) {
						this.ambience5Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience5Vol > -30) {
						this.ambience5Vol -= 12;
					}
				} else {
					if (this.ambience5Vol > -30) {
						this.ambience5Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		source6VUI: function source6VUI() {
			if (RegExp(/un\s?mute|play/gi).test(this.testObjectVUI) || RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI) || RegExp(/\bon\b/gi).test(this.testObjectVUI)) {

				this.ambience6Player.start();
				this.ambience6Boolean = true;
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) || RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI) || RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI) || RegExp(/\bmute\b/gi).test(this.testObjectVUI)) {

				this.ambience6Player.stop();
				this.ambience6Boolean = false;
			} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience6Vol < 0) {
						this.ambience6Vol += 12;
					}
				} else {
					if (this.ambience6Vol < 0) {
						this.ambience6Vol += 6;
					}
				}
			} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.ambience6Vol > -30) {
						this.ambience6Vol -= 12;
					}
				} else {
					if (this.ambience6Vol > -30) {
						this.ambience6Vol -= 6;
					}
				}
			}
			this.testObjectVUI = "";
		},
		allSoundVUI: function allSoundVUI() {
			//STOP ALL 
			if (RegExp(/stop/gi).test(this.testObjectVUI)) {
				this.ambience1Player.stop();
				this.ambience1Boolean = false;
				this.ambience2Player.stop();
				this.ambience2Boolean = false;
				this.ambience3Player.stop();
				this.ambience3Boolean = false;
				this.ambience4Player.stop();
				this.ambience4Boolean = false;
				this.ambience5Player.stop();
				this.ambience5Boolean = false;
				this.ambience6Player.stop();
				this.ambience6Boolean = false;
				if (this.didWeAdventure) {
					this.exploreSound1.stop();
					this.isExploreFuncRunning = false;
				}
			} else if (RegExp(/play/gi).test(this.testObjectVUI)) {
				this.ambience1Player.start();
				this.ambience1Boolean = true;
				this.ambience2Player.start();
				this.ambience2Boolean = true;
				this.ambience3Player.start();
				this.ambience3Boolean = true;
				this.ambience4Player.start();
				this.ambience4Boolean = true;
				this.ambience5Player.start();
				this.ambience5Boolean = true;
				this.ambience6Player.start();
				this.ambience6Boolean = true;
			}
			this.testObjectVUI = "";
		},
		speedVUI: function speedVUI() {
			if (RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI)) {
				this.speedToggle = true;
			} else if (RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI)) {
				this.speedToggle = false;
			}
			if (RegExp(/\bfaste?r?\b|up/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)) {
					if (this.playBackSpeed <= 1.6) {
						this.playBackSpeed += 0.4;
					}
				} else {
					if (this.playBackSpeed <= 1.8) {
						this.playBackSpeed += 0.2;
					}
				}
			} else if (RegExp(/slowe?r?|down/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.playBackSpeed >= 0.5) {
						this.playBackSpeed -= 0.4;
					}
				} else {
					if (this.playBackSpeed >= 0.2) {
						this.playBackSpeed -= 0.2;
					}
				}
			}
			this.testObjectVUI = "";
		},
		delayVUI: function delayVUI() {
			if (RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI)) {
				this.fxDelayToggle = true;
			} else if (RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI)) {
				this.fxDelayToggle = false;
			}
			if (RegExp(/\bmore\b|\bup\b|loude?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxDelayAmt <= 80) {
						this.fxDelayAmt += 10;
					}
				} else {
					if (this.fxDelayAmt <= 95) {
						this.fxDelayAmt += 5;
					}
				}
			} else if (RegExp(/less|\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxDelayAmt >= 20) {
						this.fxDelayAmt -= 10;
					} else if (this.fxDelayAmt >= 5) {
						this.fxDelayAmt -= 5;
					}
				} else {
					if (this.fxDelayAmt >= 5) {
						this.fxDelayAmt -= 5;
					} else if (this.fxDelayAmt >= 15) {
						this.fxDelayAmt -= 2;
					}
				}
			}
			this.testObjectVUI = "";
		},
		chorusVUI: function chorusVUI() {
			if (RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI)) {
				this.fxChorusToggle = true;
			} else if (RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI)) {
				this.fxChorusToggle = false;
			}
			if (RegExp(/\bmore\b|\bup\b|loude?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxChorusAmt <= 80) {
						this.fxChorusAmt += 10;
					}
				} else {
					if (this.fxChorusAmt <= 95) {
						this.fxChorusAmt += 5;
					}
				}
			} else if (RegExp(/less|\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxChorusAmt >= 20) {
						this.fxChorusAmt -= 10;
					} else if (this.fxChorusAmt >= 5) {
						this.fxChorusAmt -= 5;
					}
				} else {
					if (this.fxChorusAmt >= 5) {
						this.fxChorusAmt -= 5;
					} else if (this.fxChorusAmt >= 15) {
						this.fxChorusAmt -= 2;
					}
				}
			}
			this.testObjectVUI = "";
		},
		reverbVUI: function reverbVUI() {
			if (RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI)) {
				this.fxConvolverToggle = true;
			} else if (RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI)) {
				this.fxConvolverToggle = false;
			}
			if (RegExp(/\bmore\b|\bup\b|loude?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxConvolverAmt <= 45) {
						this.fxConvolverAmt += 5;
					}
				} else {
					if (this.fxConvolverAmt <= 48) {
						this.fxConvolverAmt += 2;
					}
				}
			} else if (RegExp(/less|\bdown\b|softe?r?/gi).test(this.testObjectVUI)) {
				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxConvolverAmt >= 10) {
						this.fxConvolverAmt -= 5;
					} else if (this.fxConvolverAmt >= 2) {
						this.fxConvolverAmt -= 1;
					}
				} else {
					if (this.fxConvolverAmt >= 10) {
						this.fxConvolverAmt -= 2;
					} else if (this.fxConvolverAmt >= 2) {
						this.fxConvolverAmt -= 1;
					}
				}
			}
			this.testObjectVUI = "";
		},
		filterVUI: function filterVUI() {
			if (RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI)) {
				this.fxFilterToggle = true;
			} else if (RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI)) {
				this.fxFilterToggle = false;
			}
			if (RegExp(/\bmore\b|\blower\b/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxAutoFilterAmt > 1500) {
						this.fxAutoFilterAmt -= 1500;
					} else if (this.fxAutoFilterAmt >= 300) {
						this.fxAutoFilterAmt -= 200;
					}
				} else {
					if (this.fxAutoFilterAmt >= 500) {
						this.fxAutoFilterAmt -= 250;
					} else if (this.fxAutoFilterAmt >= 100) {
						this.fxAutoFilterAmt -= 100;
					}
				}
			} else if (RegExp(/less|higher|hire/gi).test(this.testObjectVUI)) {

				if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)) {
					if (this.fxAutoFilterAmt <= 10000) {
						this.fxAutoFilterAmt += 1500;
					} else if (this.fxAutoFilterAmt <= 1000) {
						this.fxAutoFilterAmt += 200;
					}
				} else {
					if (this.fxAutoFilterAmt <= 10000) {
						this.fxAutoFilterAmt += 250;
					} else if (this.fxAutoFilterAmt <= 1000) {
						this.fxAutoFilterAmt += 100;
					}
				}
			}
			this.testObjectVUI = "";
		},
		infoVUI: function infoVUI() {
			var _this4 = this;

			if (RegExp(/show|display/gi).test(this.testObjectVUI)) {
				this.showHelpOverlay = true;
				setTimeout(function () {
					_this4.showNavBar = false;
					if (_this4.allowSpeechControl) {
						_this4.showSpeechBtns = false;
					}
				}, 0);
				setTimeout(function () {
					_this4.showAllControls = false;
				}, 500);
				setTimeout(function () {
					_this4.showAboutPage = true;
				}, 1500);
				console.log('SHOW INFO');
			} else if (RegExp(/hide|minimize/gi).test(this.testObjectVUI)) {
				this.showHelpOverlay = false;
				this.showAboutPage = false;
				setTimeout(function () {
					_this4.showAllControls = true;
				}, 800);
				setTimeout(function () {
					_this4.showNavBar = true;
					if (_this4.allowSpeechControl) {
						_this4.showSpeechBtns = true;
					}
				}, 850);
				console.log('HIDE INFO');
			}
			this.testObjectVUI = "";
			setTimeout(function () {
				_this4.userVoiceToText = "";
			}, 3000);
		},
		listVUI: function listVUI() {
			var _this5 = this;

			if (RegExp(/show|display/gi).test(this.testObjectVUI)) {
				this.showVoiceCommandList = true;
				setTimeout(function () {
					document.getElementById('voiceControlListTxt').scrollIntoView({ behavior: "smooth" });
				}, 250);
				console.log('SHOW LIST');
			} else if (RegExp(/hide|minimize/gi).test(this.testObjectVUI)) {
				this.showVoiceCommandList = false;
				setTimeout(function () {
					document.getElementById('controlsContainer').scrollIntoView({ behavior: "smooth" });
				}, 250);
				console.log('HIDE LIST');
			}
			this.testObjectVUI = "";
			setTimeout(function () {
				_this5.userVoiceToText = "";
			}, 3000);
		},
		miscVUI: function miscVUI() {
			//RANDOMIZE
			if (RegExp(/new\s?scenes?|randomi?z?e?|shift\s?soundscapes?/gi).test(this.testObjectVUI)) {
				this.mattChillMethod();
				//EXPLORE
			} else if (RegExp(/\bexplorer?\b|\badventure\b/gi).test(this.testObjectVUI)) {
				if (RegExp(/stop/gi).test(this.testObjectVUI)) {
					this.stopExplore();
				} else {
					this.exploreFunc();
				}
				//STOP VOICE COMMANDS & GO HOME FUNCTIONS
			} else if (RegExp(/stop/gi).test(this.testObjectVUI) && RegExp(/voice\s?controls?/gi).test(this.testObjectVUI) || RegExp(/stop/gi).test(this.testObjectVUI) && RegExp(/voice\s?commands?/gi).test(this.testObjectVUI)) {
				//DISABLES LISTENING IMMEDITATLY
				this.initSpeech = true;
				this.stopModuleSpeech = true;
				this.recognizing = false;
				this.recognitionTutorial.stop();
				this.$store.state.isVoiceControlled = false;
			} else if (RegExp(/home/gi).test(this.testObjectVUI)) {
				this.goingHomeNotViaVoiceCommand = false;
				this.stopModuleSpeech = true;
				this.recognitionTutorial.abort();
				this.recognitionTutorial = undefined;
				setTimeout(this.goHome, 50);
			}
			this.testObjectVUI = "";
		},

		//ENTER FUNC
		enterFunc: function enterFunc() {
			var _this6 = this;

			if (this.startAudioBoolean) {
				this.startAudio();
				this.startAudioBoolean = false;
			}

			this.welcomePrompt = "HERE WE GO";

			setTimeout(function () {
				_this6.showMutePrompt = false;
				_this6.showEnterBtn = false;
			}, 100);

			setTimeout(function () {
				_this6.showEnterContainer = false;
			}, 1500);

			setTimeout(function () {
				_this6.showAllControls = true;
			}, 1600);

			setTimeout(function () {
				_this6.showNavBar = true;
			}, 1700);

			setTimeout(function () {
				_this6.showSpeechBtns = true;
			}, 1800);

			this.TutorialFX.start();

			var changeTiming = 150;

			setTimeout(function () {
				_this6.plungeDepth = 1;
			}, changeTiming * 1);

			setTimeout(function () {
				_this6.plungeDepth = 2;
			}, changeTiming * 2);

			setTimeout(function () {
				_this6.plungeDepth = 3;
			}, changeTiming * 3);

			setTimeout(function () {
				_this6.plungeDepth = 4;
			}, changeTiming * 4);

			setTimeout(function () {
				_this6.plungeDepth = 5;
			}, changeTiming * 5);

			setTimeout(function () {
				_this6.plungeDepth = 6;
			}, changeTiming * 6);

			setTimeout(function () {
				_this6.plungeDepth = 7;
			}, changeTiming * 7);

			setTimeout(function () {
				_this6.plungeDepth = 8;
			}, changeTiming * 8);

			setTimeout(function () {
				_this6.plungeDepth = 9;
			}, changeTiming * 8);

			setTimeout(function () {
				_this6.plungeDepth = 10;
			}, changeTiming * 10);

			setTimeout(function () {
				if (_this6.userMobile === false) {
					_this6.activeSun = true;
				}
			}, changeTiming * 11);
		},

		//RANDOMIZE (MATT CHILL) PRESET
		mattChillMethod: function mattChillMethod() {
			if (this.didWeAdventure) {
				this.stopExplore();
			}

			if (this.randomizeBoolean === false) {
				this.randomizeBoolean = true;
			}

			this.mattChill = !this.mattChill;

			this.ambience1Vol = Math.floor(Math.random() * 30 - 30);
			this.ambience2Vol = Math.floor(Math.random() * 30 - 30);
			this.ambience3Vol = Math.floor(Math.random() * 30 - 30);
			this.ambience4Vol = Math.floor(Math.random() * 20 - 20);
			this.ambience5Vol = Math.floor(Math.random() * 10 - 10);
			this.ambience6Vol = Math.floor(Math.random() * 30 - 30);

			// let fx1boolean 		= Math.random() >= 0.5,
			// 	fx2boolean 		= Math.random() >= 0.5,
			// 	fx3boolean 		= Math.random() >= 0.5,
			// 	fx4boolean 		= Math.random() >= 0.5,
			// 	fx5boolean 		= Math.random() >= 0.5;

			var amb1boolean = Math.random() >= 0.5,
			    amb2boolean = Math.random() >= 0.5,
			    amb3boolean = Math.random() >= 0.5,
			    amb4boolean = Math.random() >= 0.5,
			    amb5boolean = Math.random() >= 0.5,
			    amb6boolean = Math.random() >= 0.5;

			// if (this.mattChill === true){
			//DON'T CALCULATE ON MOBILE
			if (this.userMobile === false) {
				var
				// randomVerb 		= Math.floor((Math.random() * 40) + 0),
				randomDelay = Math.floor(Math.random() * 20 + 0),
				    randomChorus = Math.floor(Math.random() * 20 + 0),
				    randomFilter = Math.floor(Math.random() * 20000 + 1500);

				// this.fxConvolverAmt 	= randomVerb;
				this.fxDelayAmt = randomDelay;
				this.fxChorusAmt = randomChorus;
				this.fxAutoFilterAmt = randomFilter;

				this.fxDecay = Math.random() * 10 + 1.5;
				var fxPreDelay = Math.random() * 0.1 + 0.03;
				this.fxConvolver.decay = this.fxDecay;
				this.fxConvolver.preDelay = fxPreDelay;
				this.fxConvolver.generate();

				// console.log("Verb Decay: " + this.fxDecay);
				// console.log("Verb PreDelay: " + fxPreDelay);
			};
			//CALCULATE ON MOBILE & DESKTOP
			var randomSpeed = Math.random() * (1.25 - 0.75) + 0.75;
			this.playBackSpeed = randomSpeed;

			if (amb1boolean === true) {
				this.ambience1Player.start();
				this.ambience1Boolean = true;
				this.showFlask1 = true;
			} else {
				this.ambience1Player.stop();
				this.ambience1Boolean = false;
				this.showFlask1 = false;
			}

			if (amb2boolean === true) {
				this.ambience2Player.start();
				this.ambience2Boolean = true;
				this.showFlask2 = true;
			} else {
				this.ambience2Player.stop();
				this.ambience2Boolean = false;
				this.showFlask2 = false;
			}

			if (amb3boolean === true) {
				this.ambience3Player.start();
				this.ambience3Boolean = true;
				this.showFlask3 = true;
			} else {
				this.ambience3Player.stop();
				this.ambience3Boolean = false;
				this.showFlask3 = false;
			}

			if (amb4boolean === true) {
				this.ambience4Player.start();
				this.ambience4Boolean = true;
				this.showFlask4 = true;
			} else {
				this.ambience4Player.stop();
				this.ambience4Boolean = false;
				this.showFlask4 = false;
			}

			if (amb5boolean === true) {
				this.ambience5Player.start();
				this.ambience5Boolean = true;
				this.showFlask5 = true;
			} else {
				this.ambience5Player.stop();
				this.ambience5Boolean = false;
				this.showFlask5 = false;
			}

			if (amb6boolean === true) {
				this.ambience6Player.start();
				this.ambience6Boolean = true;
				this.showFlask6 = true;
			} else {
				this.ambience6Player.stop();
				this.ambience6Boolean = false;
				this.showFlask6 = false;
			}

			if (amb1boolean === false && amb2boolean === false && amb3boolean === false && amb4boolean === false && amb5boolean === false && amb6boolean === false) {
				this.ambience6Player.start();
				this.ambience6Boolean = true;
				this.showFlask6 = true;
			}

			// } else if (this.mattChill === false){
			// this.fxDelayToggle = false;
			// this.fxConvolverToggle = false;
			// this.fxChorusToggle = false;
			// this.fxFilterToggle = false;
			// this.speedToggle = false;
			// } 
		},

		//EXPLORE 
		exploreBtnFunc: function exploreBtnFunc() {
			this.exploreBtnBoolean = !this.exploreBtnBoolean;
			if (this.exploreBtnBoolean) {
				this.exploreFunc();
				//STOP SOUND SOURCE VO
				this.soundSourceVOPlayer.stop();
				this.soundSourceVOBoolean = false;
				clearInterval(this.soundSourceInterval);
				clearInterval(this.soundSourceTimeout1);
				clearInterval(this.soundSourceTimeout2);
				clearInterval(this.soundSourceTimeout3);
				clearInterval(this.soundSourceTimeout4);
				clearInterval(this.soundSourceTimeout5);
				clearInterval(this.soundSourceTimeout6);
				this.ambience1BooleanTrigger = false;
				this.ambience2BooleanTrigger = false;
				this.ambience3BooleanTrigger = false;
				this.ambience4BooleanTrigger = false;
				this.ambience5BooleanTrigger = false;
				this.ambience6BooleanTrigger = false;

				//STOP SOUND EFFECTS VO
				this.soundFXVOPlayer.stop();
				this.soundFXVOBoolean = false;
				this.inst1BooleanTrigger = false;
				this.inst2BooleanTrigger = false;
				this.inst3BooleanTrigger = false;
				this.inst4BooleanTrigger = false;
				this.inst5BooleanTrigger = false;
				clearInterval(this.instInterval);
				clearInterval(this.instTimeout1);
				clearInterval(this.instTimeout2);
				clearInterval(this.instTimeout3);
				clearInterval(this.instTimeout4);
				clearInterval(this.instTimeout5);

				//STOP RANDOMIZE VO
				this.randomizeVOPlayer.stop();
				this.randomizeVOBoolean = false;
				this.randomBooleanTrigger = false;
				clearInterval(this.instInterval);
				clearInterval(this.instTimeout1);
				clearInterval(this.instTimeout2);

				//STOP ABOUT VO
				this.voiceControlVO.stop();
				this.voiceVOBoolean = false;
				//STOP VOICE CONTROL AND MIC RECORD VO
				this.voiceControlTrigger = false;
				this.voiceListControlTrigger = false;
				this.micRecordingTrigger = false;
				clearInterval(this.voiceInterval);
				clearInterval(this.voiceTimeout1);
				clearInterval(this.voiceTimeout2);
				clearInterval(this.voiceListInterval);
				clearInterval(this.voiceListTimeout1);
				clearInterval(this.voiceListTimeout2);
				clearInterval(this.recordInterval);
				clearInterval(this.recordTimeout1);
				clearInterval(this.recordTimeout2);
				clearInterval(this.voiceControlMasterTimer1);
				clearInterval(this.voiceControlMasterTimer2);
				clearInterval(this.voiceControlMasterTimer3);

				//STOP EXPLORE VO
				this.exploreVO.stop();
				this.exploreBoolean = false;
				this.exploreVOBoolean = false;
				//STOP EXPLORE CONTROL AND MIC RECORD VO
				this.exploreControlTrigger = false;
				clearInterval(this.exploreMasterTimer1);
				clearInterval(this.exploreInterval);
				clearInterval(this.exploreTimeout1);
				clearInterval(this.exploreTimeout2);
			} else if (!this.exploreBtnBoolean) {
				this.stopExplore();
			}
		},
		exploreFunc: function exploreFunc() {
			var _this7 = this;

			//AUDIO MIXING FUNCTION
			var runExplore = function runExplore() {
				_this7.exploreSound1.start();
				_this7.exploreTxt = "Exploring";
				_this7.exploreTimeout12 = setTimeout(function () {

					_this7.isExploreFuncRunning = false;
					_this7.exploreTxt = "Explore!";
				}, 27000);
			};
			if (this.isExploreFuncRunning === false) {
				this.isExploreFuncRunning = true;
				//INIT EXPORE SCENE
				//GENERATE REVERB
				if (!this.userMobile) {
					this.fxDecay = 4.5;
					this.fxConvolver.decay = this.fxDecay;
					this.fxConvolver.preDelay = 0.4;
					this.fxConvolver.generate();
				}
				if (this.ambience1Player.state === "started") {
					this.ambience1Player.stop();
					this.ambience1Boolean = false;
					// this.ambience1Vol = -14;
				} else {
						// this.ambience1Vol = -14;
					}

				if (this.ambience2Player.state === "stopped") {
					this.ambience2Player.start();
					this.ambience2Boolean = true;
					this.ambience2Vol = -15;
				} else {
					this.ambience2Vol = -15;
				}

				if (this.ambience3Player.state === "started") {
					this.ambience3Player.stop();
					this.ambience3Boolean = false;
					// this.ambience3Vol = -20;
				} else {
						// this.ambience3Vol = -20;
					}

				if (this.ambience4Player.state === "started") {
					this.ambience4Player.stop();
					this.ambience4Boolean = false;
					// this.ambience4Vol = -30;
				} else {
						// this.ambience4Vol = -30;
					}

				if (this.ambience5Player.state === "stopped") {
					this.ambience5Player.start();
					this.ambience5Boolean = true;
					this.ambience5Vol = -10;
				} else {
					this.ambience5Vol = -10;
				}

				if (this.ambience6Player.state === "stopped") {
					this.ambience6Player.start();
					this.ambience6Boolean = true;
					this.ambience6Vol = -4;
				} else {
					this.ambience6Vol = -4;
				}
				if (!this.didWeAdventure) {
					this.exploreSound1 = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
						"playbackRate": 1,
						"loop": false,
						"volume": -8
					}).connect(this.masterVolumeSub);

					//LOADING FOR BROWSER TYPE
					if (this.isChrome === true || this.isOpera === true || this.isFirefox === true || this.isBlink === true) {

						this.exploreSound1.load("../src/assets/sounds/modules/tutorial/hiogg/generativeVO.ogg", function () {
							runExplore();
						});
					} else if (this.AndroidMobile === true) {
						this.exploreSound1.load("../src/assets/sounds/modules/tutorial/lowogg/generativeVO.ogg", function () {
							runExplore();
						});
					} else if (this.isSafari === true || this.isEdge === true || this.isIE === true) {
						this.exploreSound1.load("../src/assets/sounds/modules/tutorial/320/generativeVO.m4a", function () {
							runExplore();
						});
					} else if (this.iOS === true) {
						this.exploreSound1.load("../src/assets/sounds/modules/tutorial/192/generativeVO.m4a", function () {
							runExplore();
						});
					}
					//CLEANS UP AND DISPOSES THESE PLAYERS WHEN GOING HOME
					this.didWeAdventure = true;
				} else if (this.didWeAdventure) {
					runExplore();
				}
			} else {}
		},
		stopExplore: function stopExplore() {
			this.exploreTxt = "Explore!";
			this.exploreSound1.stop();
			this.isExploreFuncRunning = false;
		},

		//MASTER METERING
		masterMetering: function masterMetering() {
			this.masterLevel = this.masterMeter.getLevel();
		},

		//MAIN SHOW AND HIDE
		goToHelp: function goToHelp() {
			var _this8 = this;

			this.showHelpOverlay = !this.showHelpOverlay;
			this.helpTrigger = !this.helpTrigger;

			if (this.showHelpOverlay === true) {

				setTimeout(function () {
					_this8.showNavBar = false;
					if (_this8.$store.state.allowSpeechControl) {
						_this8.showSpeechBtns = false;
					}
				}, 100);

				setTimeout(function () {
					_this8.showAllControls = false;
				}, 250);

				setTimeout(function () {
					_this8.showAboutPage = true;
				}, 1000);
			} else if (this.showHelpOverlay === false) {

				this.showAboutPage = false;

				setTimeout(function () {
					_this8.showAllControls = true;
				}, 800);

				setTimeout(function () {
					_this8.showNavBar = true;
					if (_this8.$store.state.allowSpeechControl) {
						_this8.showSpeechBtns = true;
					}
				}, 850);
			}
		},
		voiceCommandListFunc: function voiceCommandListFunc() {
			this.showVoiceCommandList = !this.showVoiceCommandList;
			if (this.showVoiceCommandList) {
				setTimeout(function () {
					document.getElementById('voiceListAnchor').scrollIntoView({ behavior: "smooth" });
				}, 250);
			} else if (!this.showVoiceCommandList) {
				document.getElementById('controlsContainer').scrollIntoView({ behavior: "smooth" });
			}
		},

		//MASTER DRAGGIE LOGGING & LOADING
		ogScreenSize: function ogScreenSize() {
			this.ogWidth = window.innerWidth;
		},
		screenSizing: function screenSizing() {
			this.screenHeight = window.innerHeight;
			this.screenWidth = window.innerWidth;

			var currentWidth = window.innerWidth;

			if (currentWidth === this.ogWidth) {} else if (currentWidth != this.ogWidth) {
				this.sliderRangeSet();
				// this.mobileCheck();
				this.ogWidth = currentWidth;
			}
		},

		//BUFFER LOADING
		bufferLoading: function bufferLoading() {
			var _this9 = this;

			// Tone.Buffer.on('progress', ()=>{
			// });
			__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Buffer.on('load', function () {
				//HIDE LOADING ITEMS
				_this9.showLoading = false;
				//SHOW ENTER BUTTON
				setTimeout(function () {
					_this9.showEnterBtn = true;
				}, 1000);
				//AUTO OPEN MODULE IF VOICE CONTROLLED & DO NOT REPLAY WHEN EXPLORE AUDIO LOADS 
				//ADDITIONALLY DO NOT REPLAY IF USER MIC HAS BEEN ACTIVATED FOR RECORDING
				if (_this9.isVoiceControl) {
					if (!_this9.didWeAdventure) {
						setTimeout(_this9.enterFunc, 2000);
					}
				}
				//IF VOICE CONTROL IS ACTIVE GLOBALLY ACTIVATE IN THIS MODULE
				if (_this9.isVoiceControl === true) {
					_this9.speechFunc();
				}
			});
		},

		//AUDIO ROUTING
		audioRouting: function audioRouting() {
			if (this.isChrome === true || this.AndroidMobile === true || this.isOpera === true || this.isFirefox === true || this.isBlink === true) {
				if (this.userMobile === false) {

					this.fxConvolver = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Reverb({
						"decay": 1.5,
						"preDelay": 0.01
					});
					this.fxConvolver.decay = 2.5;
					this.fxConvolver.generate();
					this.fxAutoFilter = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Filter({
						"type": "lowpass",
						"frequency": 20000,
						"rolloff": -24,
						"Q": 1,
						"gain": 0
					});
					this.fxDelay = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.PingPongDelay(0.8, 0.3);
					this.fxChorus = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Chorus(4.5, 4.5, 0.55);
					this.masterMeter = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Meter({
						"smoothing": .8
					});
					this.ambience1Player.connect(this.masterVolumeSub);
					this.ambience2Player.connect(this.masterVolumeSub);
					this.ambience3Player.connect(this.masterVolumeSub);
					this.ambience4Player.connect(this.masterVolumeSub);
					this.ambience5Player.connect(this.masterVolumeSub);
					this.ambience6Player.connect(this.masterVolumeSub);
					this.soundSourceVOPlayer.connect(this.masterVolumeSub);
					this.soundFXVOPlayer.connect(this.masterVolumeSub);
					this.randomizeVOPlayer.connect(this.masterVolumeSub);
					this.voiceControlVO.connect(this.masterVolumeSub);
					this.exploreVO.connect(this.masterVolumeSub);
					this.masterVolumeSub.chain(this.fxAutoFilter, this.fxConvolver, this.fxDelay, this.fxChorus, this.masterMeter, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master);
					console.log('Chrome/Opera/FireFox Desktop');
					// setInterval(this.masterMetering, 60);
				} else if (this.userMobile === true) {
					this.ambience1Player.connect(this.masterVolumeSub);
					this.ambience2Player.connect(this.masterVolumeSub);
					this.ambience3Player.connect(this.masterVolumeSub);
					this.ambience4Player.connect(this.masterVolumeSub);
					this.ambience5Player.connect(this.masterVolumeSub);
					this.ambience6Player.connect(this.masterVolumeSub);
					this.soundSourceVOPlayer.connect(this.masterVolumeSub);
					this.soundFXVOPlayer.connect(this.masterVolumeSub);
					this.randomizeVOPlayer.connect(this.masterVolumeSub);
					this.voiceControlVO.connect(this.masterVolumeSub);
					this.exploreVO.connect(this.masterVolumeSub);

					this.masterVolumeSub.connect(__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master);

					console.log('Chrome/Opera/FireFox Mobile');
				}
			} else if (this.isSafari === true || this.iOS === true || this.isEdge === true || this.isIE === true) {
				if (this.userMobile === false) {
					this.fxConvolver = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Reverb({
						"decay": 1.5,
						"preDelay": 0.01
					});
					this.fxAutoFilter = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Filter({
						"type": "lowpass",
						"frequency": 20000,
						"rolloff": -24,
						"Q": 1,
						"gain": 0
					});
					this.fxDelay = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.PingPongDelay(0.8, 0.3);
					this.fxChorus = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Chorus(4.5, 4.5, 0.55);
					this.masterMeter = new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Meter({
						"smoothing": .8
					});
					this.ambience1Player.connect(this.masterVolumeSub);
					this.ambience2Player.connect(this.masterVolumeSub);
					this.ambience3Player.connect(this.masterVolumeSub);
					this.ambience4Player.connect(this.masterVolumeSub);
					this.ambience5Player.connect(this.masterVolumeSub);
					this.ambience6Player.connect(this.masterVolumeSub);
					this.soundSourceVOPlayer.connect(this.masterVolumeSub);
					this.soundFXVOPlayer.connect(this.masterVolumeSub);
					this.randomizeVOPlayer.connect(this.masterVolumeSub);
					this.voiceControlVO.connect(this.masterVolumeSub);
					this.exploreVO.connect(this.masterVolumeSub);

					this.masterVolumeSub.chain(this.fxAutoFilter, this.fxConvolver, this.fxDelay, this.fxChorus, this.masterMeter, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master);
					console.log('Safari/Edge/iOS Desktop');
					// setInterval(this.masterMetering, 60);
				} else if (this.userMobile === true) {
					this.ambience1Player.connect(this.masterVolumeSub);
					this.ambience2Player.connect(this.masterVolumeSub);
					this.ambience3Player.connect(this.masterVolumeSub);
					this.ambience4Player.connect(this.masterVolumeSub);
					this.ambience5Player.connect(this.masterVolumeSub);
					this.ambience6Player.connect(this.masterVolumeSub);
					this.soundSourceVOPlayer.connect(this.masterVolumeSub);
					this.soundFXVOPlayer.connect(this.masterVolumeSub);
					this.randomizeVOPlayer.connect(this.masterVolumeSub);
					this.voiceControlVO.connect(this.masterVolumeSub);
					this.exploreVO.connect(this.masterVolumeSub);

					this.masterVolumeSub.connect(__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master);
					console.log('Safari/Edge/iOS Mobile');
				}
			} else {}

			// this.soundSourceVOPlayer.volume.setTargetAtTime(this.soundSourceVOVol, Tone.Context.currentTime, +0.05);
			// this.soundFXVOPlayer.volume.setTargetAtTime(this.soundFXVOVol, Tone.Context.currentTime, +0.05);
			// this.randomizeVOPlayer.volume.setTargetAtTime(this.randomizeVOVol, Tone.Context.currentTime, +0.05);
			// this.voiceControlVO.volume.setTargetAtTime(this.voiceVOVol, Tone.Context.currentTime, +0.05);
		},

		//AUDIO LOADING
		firstAudioLoadFunc: function firstAudioLoadFunc() {
			var _this10 = this;

			if (this.isChrome === true || this.isOpera === true || this.isFirefox === true || this.isBlink === true) {

				this.exploreVO.load("../src/assets/sounds/modules/tutorial/hiogg/exploreVO.ogg", function () {
					_this10.whatIsLoading = "Effects";
				});

				this.soundFXVOPlayer.load("../src/assets/sounds/modules/tutorial/hiogg/soundeffectVO.ogg", function () {
					_this10.whatIsLoading = "Effects";
				});

				this.randomizeVOPlayer.load("../src/assets/sounds/modules/tutorial/hiogg/randomVO.ogg", function () {
					_this10.whatIsLoading = "Randomize";
				});

				this.changeFX.load("../src/assets/sounds/blinks/change.ogg", function () {
					_this10.whatIsLoading = "Roads";
				});

				this.soundSourceVOPlayer.load("../src/assets/sounds/modules/tutorial/hiogg/soundsourceVO.ogg", function () {
					_this10.whatIsLoading = "Sources";
				});

				this.voiceControlVO.load("../src/assets/sounds/modules/tutorial/hiogg/voiceControlVO.ogg", function () {
					_this10.whatIsLoading = "About";
				});

				this.TutorialFX.load("../src/assets/sounds/modules/tutorial/hiogg/wormhole.ogg", function () {
					_this10.whatIsLoading = "Tutorial";
				});

				this.ambience1Player.load("../src/assets/sounds/modules/beach/hiogg/serenebeach.ogg", function () {
					_this10.whatIsLoading = "Beach";
				});

				this.ambience2Player.load("../src/assets/sounds/modules/forest/hiogg/summer.ogg", function () {
					_this10.whatIsLoading = "Tutorial";
				});

				this.ambience3Player.load("../src/assets/sounds/modules/ocean/hiogg/deepsea.ogg", function () {
					_this10.whatIsLoading = "Deep Sea";
				});

				this.ambience4Player.load("../src/assets/sounds/modules/metro/hiogg/subwaystation.ogg", function () {
					_this10.whatIsLoading = "Subway";
				});

				this.ambience5Player.load("../src/assets/sounds/modules/plains/hiogg/longgrass.ogg", function () {
					_this10.whatIsLoading = "Longgrass";
				});

				this.ambience6Player.load("../src/assets/sounds/modules/forest/hiogg/stream.ogg", function () {
					_this10.whatIsLoading = "Brook";
				});
			} else if (this.AndroidMobile === true) {

				this.exploreVO.load("../src/assets/sounds/modules/tutorial/lowogg/exploreVO.ogg", function () {
					_this10.whatIsLoading = "Effects";
				});

				this.soundFXVOPlayer.load("../src/assets/sounds/modules/tutorial/lowogg/soundeffectMOBILE.ogg", function () {
					_this10.whatIsLoading = "Effects";
				});

				this.randomizeVOPlayer.load("../src/assets/sounds/modules/tutorial/lowogg/randomMOBILE.ogg", function () {
					_this10.whatIsLoading = "Randomize";
				});

				this.changeFX.load("../src/assets/sounds/blinks/change.ogg", function () {
					_this10.whatIsLoading = "Roads";
				});

				this.soundSourceVOPlayer.load("../src/assets/sounds/modules/tutorial/lowogg/soundsourceVO.ogg", function () {
					_this10.whatIsLoading = "Sources";
				});

				this.voiceControlVO.load("../src/assets/sounds/modules/tutorial/lowogg/voiceControlVO.ogg", function () {
					_this10.whatIsLoading = "About";
				});

				this.TutorialFX.load("../src/assets/sounds/modules/tutorial/lowogg/wormhole.ogg", function () {
					_this10.whatIsLoading = "Tutorial";
				});

				this.ambience1Player.load("../src/assets/sounds/modules/beach/lowogg/serenebeach.ogg", function () {
					_this10.whatIsLoading = "Beach";
				});

				this.ambience2Player.load("../src/assets/sounds/modules/forest/lowogg/summer.ogg", function () {
					_this10.whatIsLoading = "Tutorial";
				});

				this.ambience3Player.load("../src/assets/sounds/modules/ocean/lowogg/deepsea.ogg", function () {
					_this10.whatIsLoading = "Deep Sea";
				});

				this.ambience4Player.load("../src/assets/sounds/modules/metro/lowogg/subwaystation.ogg", function () {
					_this10.whatIsLoading = "Subway";
				});

				this.ambience5Player.load("../src/assets/sounds/modules/plains/lowogg/longgrass.ogg", function () {
					_this10.whatIsLoading = "Longgrass";
				});

				this.ambience6Player.load("../src/assets/sounds/modules/forest/lowogg/stream.ogg", function () {
					_this10.whatIsLoading = "Brook";
				});
			} else if (this.isSafari === true || this.isEdge === true || this.isIE === true) {

				this.exploreVO.load("../src/assets/sounds/modules/tutorial/320/exploreVO.m4a", function () {
					_this10.whatIsLoading = "Effects";
				});

				this.soundFXVOPlayer.load("../src/assets/sounds/modules/tutorial/320/soundeffectVO.m4a", function () {
					_this10.whatIsLoading = "Effects";
				});

				this.randomizeVOPlayer.load("../src/assets/sounds/modules/tutorial/320/randomVO.m4a", function () {
					_this10.whatIsLoading = "Randomize";
				});

				this.changeFX.load("../src/assets/sounds/blinks/change.m4a", function () {
					_this10.whatIsLoading = "Roads";
				});

				this.soundSourceVOPlayer.load("../src/assets/sounds/modules/tutorial/320/soundsourceVO.m4a", function () {
					_this10.whatIsLoading = "Sources";
				});

				this.voiceControlVO.load("../src/assets/sounds/modules/tutorial/320/voiceControlVO.m4a", function () {
					_this10.whatIsLoading = "About";
				});

				this.TutorialFX.load("../src/assets/sounds/modules/tutorial/320/wormhole.m4a", function () {
					_this10.whatIsLoading = "Tutorial";
				});

				this.ambience1Player.load("../src/assets/sounds/modules/beach/320/serenebeach.m4a", function () {
					_this10.whatIsLoading = "Beach";
				});

				this.ambience2Player.load("../src/assets/sounds/modules/forest/320/summer.m4a", function () {
					_this10.whatIsLoading = "Tutorial";
				});

				this.ambience3Player.load("../src/assets/sounds/modules/ocean/320/deepsea.m4a", function () {
					_this10.whatIsLoading = "Deep Sea";
				});

				this.ambience4Player.load("../src/assets/sounds/modules/metro/320/subwaystation.m4a", function () {
					_this10.whatIsLoading = "Subway";
				});

				this.ambience5Player.load("../src/assets/sounds/modules/plains/320/longgrass.m4a", function () {
					_this10.whatIsLoading = "Longgrass";
				});

				this.ambience6Player.load("../src/assets/sounds/modules/forest/320/stream.wav", function () {
					_this10.whatIsLoading = "Brook";
				});
			} else if (this.iOS === true) {

				this.exploreVO.load("../src/assets/sounds/modules/tutorial/192/exploreVO.m4a", function () {
					_this10.whatIsLoading = "Effects";
				});

				this.soundFXVOPlayer.load("../src/assets/sounds/modules/tutorial/192/soundeffectMOBILE.m4a", function () {
					_this10.whatIsLoading = "Effects";
				});

				this.randomizeVOPlayer.load("../src/assets/sounds/modules/tutorial/192/randomMOBILE.m4a", function () {
					_this10.whatIsLoading = "Randomize";
				});

				this.changeFX.load("../src/assets/sounds/blinks/change.m4a", function () {
					_this10.whatIsLoading = "Roads";
				});

				this.soundSourceVOPlayer.load("../src/assets/sounds/modules/tutorial/192/soundsourceVO.m4a", function () {
					_this10.whatIsLoading = "Sources";
				});

				this.voiceControlVO.load("../src/assets/sounds/modules/tutorial/192/voiceControlVO.m4a", function () {
					_this10.whatIsLoading = "About";
				});

				this.TutorialFX.load("../src/assets/sounds/modules/tutorial/192/wormhole.m4a", function () {
					_this10.whatIsLoading = "Tutorial";
				});

				this.ambience1Player.load("../src/assets/sounds/modules/beach/192/serenebeach.m4a", function () {
					_this10.whatIsLoading = "Beach";
				});

				this.ambience2Player.load("../src/assets/sounds/modules/forest/192/summer.m4a", function () {
					_this10.whatIsLoading = "Tutorial";
				});

				this.ambience3Player.load("../src/assets/sounds/modules/ocean/192/deepsea.m4a", function () {
					_this10.whatIsLoading = "Deep Sea";
				});

				this.ambience4Player.load("../src/assets/sounds/modules/metro/192/subwaystation.m4a", function () {
					_this10.whatIsLoading = "Subway";
				});

				this.ambience5Player.load("../src/assets/sounds/modules/plains/192/longgrass.m4a", function () {
					_this10.whatIsLoading = "Longgrass";
				});

				this.ambience6Player.load("../src/assets/sounds/modules/forest/192/stream.m4a", function () {
					_this10.whatIsLoading = "Brook";
				});
			}
		},

		//AMBIENCE PLAY STOPS
		soundSourceVOFunc: function soundSourceVOFunc() {
			var _this11 = this;

			var intervalDuration = 500;

			//WHILE VO IS GOING ON DISABLE VOICE CONTROL
			this.istutorialVOActive = true;
			this.isDisableListening = true;

			this.soundSourceVOBoolean = !this.soundSourceVOBoolean;
			if (this.soundSourceVOBoolean === true) {
				this.soundSourceVOPlayer.start();

				//STOP SOUND SOURCE VO
				// this.soundSourceVOPlayer.stop();
				// this.soundSourceVOBoolean = false;
				// clearInterval(this.soundSourceInterval);
				// clearInterval(this.soundSourceTimeout1);
				// clearInterval(this.soundSourceTimeout2);
				// clearInterval(this.soundSourceTimeout3);
				// clearInterval(this.soundSourceTimeout4);
				// clearInterval(this.soundSourceTimeout5);
				// clearInterval(this.soundSourceTimeout6);
				// this.ambience1BooleanTrigger =   false;
				// this.ambience2BooleanTrigger =   false;
				// this.ambience3BooleanTrigger =   false;
				// this.ambience4BooleanTrigger =   false;
				// this.ambience5BooleanTrigger =   false;
				// this.ambience6BooleanTrigger =   false;

				//STOP SOUND EFFECTS VO
				this.soundFXVOPlayer.stop();
				this.soundFXVOBoolean = false;
				this.inst1BooleanTrigger = false;
				this.inst2BooleanTrigger = false;
				this.inst3BooleanTrigger = false;
				this.inst4BooleanTrigger = false;
				this.inst5BooleanTrigger = false;
				clearInterval(this.instInterval);
				clearInterval(this.instTimeout1);
				clearInterval(this.instTimeout2);
				clearInterval(this.instTimeout3);
				clearInterval(this.instTimeout4);
				clearInterval(this.instTimeout5);

				//STOP RANDOMIZE VO
				this.randomizeVOPlayer.stop();
				this.randomizeVOBoolean = false;
				this.randomBooleanTrigger = false;
				clearInterval(this.instInterval);
				clearInterval(this.instTimeout1);
				clearInterval(this.instTimeout2);

				//STOP ABOUT VO
				this.voiceControlVO.stop();
				this.voiceVOBoolean = false;
				//STOP VOICE CONTROL AND MIC RECORD VO
				this.voiceControlTrigger = false;
				this.voiceListControlTrigger = false;
				this.micRecordingTrigger = false;
				clearInterval(this.voiceInterval);
				clearInterval(this.voiceTimeout1);
				clearInterval(this.voiceTimeout2);
				clearInterval(this.voiceListInterval);
				clearInterval(this.voiceListTimeout1);
				clearInterval(this.voiceListTimeout2);
				clearInterval(this.recordInterval);
				clearInterval(this.recordTimeout1);
				clearInterval(this.recordTimeout2);
				clearInterval(this.voiceControlMasterTimer1);
				clearInterval(this.voiceControlMasterTimer2);
				clearInterval(this.voiceControlMasterTimer3);

				//STOP EXPLORE VO
				this.exploreVO.stop();
				this.exploreBoolean = false;
				this.exploreVOBoolean = false;
				//STOP EXPLORE CONTROL AND MIC RECORD VO
				this.exploreControlTrigger = false;
				clearInterval(this.exploreMasterTimer1);
				clearInterval(this.exploreInterval);
				clearInterval(this.exploreTimeout1);
				clearInterval(this.exploreTimeout2);

				this.soundSourceInterval = setInterval(function () {
					_this11.soundSourceTimeout1 = setTimeout(function () {
						_this11.ambience1BooleanTrigger = true;
						_this11.ambience2BooleanTrigger = false;
						_this11.ambience3BooleanTrigger = false;
						_this11.ambience4BooleanTrigger = false;
						_this11.ambience5BooleanTrigger = false;
						_this11.ambience6BooleanTrigger = false;
					}, intervalDuration);

					_this11.soundSourceTimeout2 = setTimeout(function () {
						_this11.ambience1BooleanTrigger = false;
						_this11.ambience2BooleanTrigger = true;
						_this11.ambience3BooleanTrigger = false;
						_this11.ambience4BooleanTrigger = false;
						_this11.ambience5BooleanTrigger = false;
						_this11.ambience6BooleanTrigger = false;
					}, intervalDuration * 2);

					_this11.soundSourceTimeout3 = setTimeout(function () {
						_this11.ambience1BooleanTrigger = false;
						_this11.ambience2BooleanTrigger = false;
						_this11.ambience3BooleanTrigger = true;
						_this11.ambience4BooleanTrigger = false;
						_this11.ambience5BooleanTrigger = false;
						_this11.ambience6BooleanTrigger = false;
					}, intervalDuration * 3);

					_this11.soundSourceTimeout4 = setTimeout(function () {
						_this11.ambience1BooleanTrigger = false;
						_this11.ambience2BooleanTrigger = false;
						_this11.ambience3BooleanTrigger = false;
						_this11.ambience4BooleanTrigger = true;
						_this11.ambience5BooleanTrigger = false;
						_this11.ambience6BooleanTrigger = false;
					}, intervalDuration * 4);

					_this11.soundSourceTimeout5 = setTimeout(function () {
						_this11.ambience1BooleanTrigger = false;
						_this11.ambience2BooleanTrigger = false;
						_this11.ambience3BooleanTrigger = false;
						_this11.ambience4BooleanTrigger = false;
						_this11.ambience5BooleanTrigger = true;
						_this11.ambience6BooleanTrigger = false;
					}, intervalDuration * 5);

					_this11.soundSourceTimeout6 = setTimeout(function () {
						_this11.ambience1BooleanTrigger = false;
						_this11.ambience2BooleanTrigger = false;
						_this11.ambience3BooleanTrigger = false;
						_this11.ambience4BooleanTrigger = false;
						_this11.ambience5BooleanTrigger = false;
						_this11.ambience6BooleanTrigger = true;
					}, intervalDuration * 6);
				}, 3500);
			} else if (this.soundSourceVOBoolean === false) {

				this.soundSourceVOPlayer.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
				clearInterval(this.soundSourceInterval);
				clearInterval(this.soundSourceTimeout1);
				clearInterval(this.soundSourceTimeout2);
				clearInterval(this.soundSourceTimeout3);
				clearInterval(this.soundSourceTimeout4);
				clearInterval(this.soundSourceTimeout5);
				clearInterval(this.soundSourceTimeout6);
				this.ambience1BooleanTrigger = false;
				this.ambience2BooleanTrigger = false;
				this.ambience3BooleanTrigger = false;
				this.ambience4BooleanTrigger = false;
				this.ambience5BooleanTrigger = false;
				this.ambience6BooleanTrigger = false;

				//WHILE VO IS GOING ON DISABLE VOICE CONTROL
				this.istutorialVOActive = false;
				this.isDisableListening = false;

				setTimeout(function () {
					_this11.soundSourceVOPlayer.stop();
					_this11.soundSourceVOPlayer.volume.setTargetAtTime(_this11.soundSourceVOVol, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
				}, 250);
			}
		},
		soundFXVOFunc: function soundFXVOFunc() {
			var _this12 = this;

			var intervalDuration = 500;

			//WHILE VO IS GOING ON DISABLE VOICE CONTROL
			this.istutorialVOActive = true;
			this.isDisableListening = true;

			this.soundFXVOBoolean = !this.soundFXVOBoolean;
			if (this.soundFXVOBoolean === true) {
				this.soundFXVOPlayer.start();

				// //STOP SOUND SOURCE VO
				this.soundSourceVOPlayer.stop();
				this.soundSourceVOBoolean = false;
				clearInterval(this.soundSourceInterval);
				clearInterval(this.soundSourceTimeout1);
				clearInterval(this.soundSourceTimeout2);
				clearInterval(this.soundSourceTimeout3);
				clearInterval(this.soundSourceTimeout4);
				clearInterval(this.soundSourceTimeout5);
				clearInterval(this.soundSourceTimeout6);
				this.ambience1BooleanTrigger = false;
				this.ambience2BooleanTrigger = false;
				this.ambience3BooleanTrigger = false;
				this.ambience4BooleanTrigger = false;
				this.ambience5BooleanTrigger = false;
				this.ambience6BooleanTrigger = false;

				//STOP SOUND EFFECTS VO
				// this.soundFXVOPlayer.stop();
				// this.soundFXVOBoolean = false;
				// this.inst1BooleanTrigger = false;
				// this.inst2BooleanTrigger = false;
				// this.inst3BooleanTrigger = false;
				// this.inst4BooleanTrigger = false;
				// this.inst5BooleanTrigger = false;
				// clearInterval(this.instInterval);
				// clearInterval(this.instTimeout1);
				// clearInterval(this.instTimeout2);
				// clearInterval(this.instTimeout3);
				// clearInterval(this.instTimeout4);
				// clearInterval(this.instTimeout5);

				//STOP RANDOMIZE VO
				this.randomizeVOPlayer.stop();
				this.randomizeVOBoolean = false;
				this.randomBooleanTrigger = false;
				clearInterval(this.instInterval);
				clearInterval(this.instTimeout1);
				clearInterval(this.instTimeout2);

				//STOP ABOUT VO
				this.voiceControlVO.stop();
				this.voiceVOBoolean = false;
				//STOP VOICE CONTROL AND MIC RECORD VO
				this.voiceControlTrigger = false;
				this.voiceListControlTrigger = false;
				this.micRecordingTrigger = false;
				clearInterval(this.voiceInterval);
				clearInterval(this.voiceTimeout1);
				clearInterval(this.voiceTimeout2);
				clearInterval(this.voiceListInterval);
				clearInterval(this.voiceListTimeout1);
				clearInterval(this.voiceListTimeout2);
				clearInterval(this.recordInterval);
				clearInterval(this.recordTimeout1);
				clearInterval(this.recordTimeout2);
				clearInterval(this.voiceControlMasterTimer1);
				clearInterval(this.voiceControlMasterTimer2);
				clearInterval(this.voiceControlMasterTimer3);

				//STOP EXPLORE VO
				this.exploreVO.stop();
				this.exploreBoolean = false;
				this.exploreVOBoolean = false;
				//STOP EXPLORE CONTROL AND MIC RECORD VO
				this.exploreControlTrigger = false;
				clearInterval(this.exploreMasterTimer1);
				clearInterval(this.exploreInterval);
				clearInterval(this.exploreTimeout1);
				clearInterval(this.exploreTimeout2);

				if (this.userMobile === false) {
					this.instInterval = setInterval(function () {
						_this12.instTimeout1 = setTimeout(function () {
							_this12.inst1BooleanTrigger = true;
							_this12.inst2BooleanTrigger = false;
							_this12.inst3BooleanTrigger = false;
							_this12.inst4BooleanTrigger = false;
							_this12.inst5BooleanTrigger = false;
						}, intervalDuration);

						_this12.instTimeout2 = setTimeout(function () {
							_this12.inst1BooleanTrigger = false;
							_this12.inst2BooleanTrigger = true;
							_this12.inst3BooleanTrigger = false;
							_this12.inst4BooleanTrigger = false;
							_this12.inst5BooleanTrigger = false;
						}, intervalDuration * 2);

						_this12.instTimeout3 = setTimeout(function () {
							_this12.inst1BooleanTrigger = false;
							_this12.inst2BooleanTrigger = false;
							_this12.inst3BooleanTrigger = true;
							_this12.inst4BooleanTrigger = false;
							_this12.inst5BooleanTrigger = false;
						}, intervalDuration * 3);

						_this12.instTimeout4 = setTimeout(function () {
							_this12.inst1BooleanTrigger = false;
							_this12.inst2BooleanTrigger = false;
							_this12.inst3BooleanTrigger = false;
							_this12.inst4BooleanTrigger = true;
							_this12.inst5BooleanTrigger = false;
						}, intervalDuration * 4);

						_this12.instTimeout5 = setTimeout(function () {
							_this12.inst1BooleanTrigger = false;
							_this12.inst2BooleanTrigger = false;
							_this12.inst3BooleanTrigger = false;
							_this12.inst4BooleanTrigger = false;
							_this12.inst5BooleanTrigger = true;
						}, intervalDuration * 5);
					}, 3000);
				} else if (this.userMobile === true) {
					this.instInterval = setInterval(function () {
						_this12.instTimeout1 = setTimeout(function () {
							_this12.inst1BooleanTrigger = true;
						}, 0);

						_this12.instTimeout2 = setTimeout(function () {
							_this12.inst1BooleanTrigger = false;
						}, 500);
					}, 1000);
				}
			} else if (this.soundFXVOBoolean === false) {
				this.soundFXVOPlayer.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
				setTimeout(function () {
					_this12.soundFXVOPlayer.stop();
					_this12.soundFXVOPlayer.volume.setTargetAtTime(_this12.soundFXVOVol, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
				}, 250);

				//WHILE VO IS GOING ON DISABLE VOICE CONTROL
				this.istutorialVOActive = false;
				this.isDisableListening = false;

				this.inst1BooleanTrigger = false;
				this.inst2BooleanTrigger = false;
				this.inst3BooleanTrigger = false;
				this.inst4BooleanTrigger = false;
				this.inst5BooleanTrigger = false;
				clearInterval(this.instInterval);
				clearInterval(this.instTimeout1);
				clearInterval(this.instTimeout2);
				clearInterval(this.instTimeout3);
				clearInterval(this.instTimeout4);
				clearInterval(this.instTimeout5);
			}
		},
		randomizeVOFunc: function randomizeVOFunc() {
			var _this13 = this;

			var intervalDuration = 250;

			//WHILE VO IS GOING ON DISABLE VOICE CONTROL
			this.istutorialVOActive = true;
			this.isDisableListening = true;

			this.randomizeVOBoolean = !this.randomizeVOBoolean;
			if (this.randomizeVOBoolean === true) {
				this.randomizeVOPlayer.start();

				//STOP SOUND SOURCE VO
				this.soundSourceVOPlayer.stop();
				this.soundSourceVOBoolean = false;
				clearInterval(this.soundSourceInterval);
				clearInterval(this.soundSourceTimeout1);
				clearInterval(this.soundSourceTimeout2);
				clearInterval(this.soundSourceTimeout3);
				clearInterval(this.soundSourceTimeout4);
				clearInterval(this.soundSourceTimeout5);
				clearInterval(this.soundSourceTimeout6);
				this.ambience1BooleanTrigger = false;
				this.ambience2BooleanTrigger = false;
				this.ambience3BooleanTrigger = false;
				this.ambience4BooleanTrigger = false;
				this.ambience5BooleanTrigger = false;
				this.ambience6BooleanTrigger = false;

				//STOP SOUND EFFECTS VO
				this.soundFXVOPlayer.stop();
				this.soundFXVOBoolean = false;
				this.inst1BooleanTrigger = false;
				this.inst2BooleanTrigger = false;
				this.inst3BooleanTrigger = false;
				this.inst4BooleanTrigger = false;
				this.inst5BooleanTrigger = false;
				clearInterval(this.instInterval);
				clearInterval(this.instTimeout1);
				clearInterval(this.instTimeout2);
				clearInterval(this.instTimeout3);
				clearInterval(this.instTimeout4);
				clearInterval(this.instTimeout5);

				//STOP RANDOMIZE VO
				// this.randomizeVOPlayer.stop();
				// this.randomizeVOBoolean = false;
				// this.randomBooleanTrigger = false;
				// clearInterval(this.instInterval);
				// clearInterval(this.instTimeout1);
				// clearInterval(this.instTimeout2);

				//STOP ABOUT VO
				this.voiceControlVO.stop();
				this.voiceVOBoolean = false;
				//STOP VOICE CONTROL AND MIC RECORD VO
				this.voiceControlTrigger = false;
				this.voiceListControlTrigger = false;
				this.micRecordingTrigger = false;
				clearInterval(this.voiceInterval);
				clearInterval(this.voiceTimeout1);
				clearInterval(this.voiceTimeout2);
				clearInterval(this.voiceListInterval);
				clearInterval(this.voiceListTimeout1);
				clearInterval(this.voiceListTimeout2);
				clearInterval(this.recordInterval);
				clearInterval(this.recordTimeout1);
				clearInterval(this.recordTimeout2);
				clearInterval(this.voiceControlMasterTimer1);
				clearInterval(this.voiceControlMasterTimer2);
				clearInterval(this.voiceControlMasterTimer3);

				//STOP EXPLORE VO
				this.exploreVO.stop();
				this.exploreBoolean = false;
				this.exploreVOBoolean = false;
				//STOP EXPLORE CONTROL AND MIC RECORD VO
				this.exploreControlTrigger = false;
				clearInterval(this.exploreMasterTimer1);
				clearInterval(this.exploreInterval);
				clearInterval(this.exploreTimeout1);
				clearInterval(this.exploreTimeout2);

				this.instInterval = setInterval(function () {
					_this13.instTimeout1 = setTimeout(function () {
						_this13.randomBooleanTrigger = true;
					}, intervalDuration);

					_this13.instTimeout2 = setTimeout(function () {
						_this13.randomBooleanTrigger = false;
					}, intervalDuration * 2);
				}, intervalDuration * 3);
			} else if (this.randomizeVOBoolean === false) {
				this.randomizeVOPlayer.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
				setTimeout(function () {
					_this13.randomizeVOPlayer.stop();
					_this13.randomizeVOPlayer.volume.setTargetAtTime(_this13.randomizeVOVol, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
				}, 250);

				//WHILE VO IS GOING ON DISABLE VOICE CONTROL
				this.istutorialVOActive = false;
				this.isDisableListening = false;

				this.randomBooleanTrigger = false;
				clearInterval(this.instInterval);
				clearInterval(this.instTimeout1);
				clearInterval(this.instTimeout2);
			}
		},
		voiceVOFunc: function voiceVOFunc() {
			var _this14 = this;

			this.voiceVOBoolean = !this.voiceVOBoolean;
			if (this.voiceVOBoolean === true) {
				this.voiceControlVO.start();

				//WHILE VO IS GOING ON DISABLE VOICE CONTROL
				this.istutorialVOActive = true;
				this.isDisableListening = true;

				var intervalDuration = 250;
				// this.voiceControlMasterTimer1 = setTimeout(()=>{
				// 	this.voiceInterval = setInterval(()=>{
				// 		this.voiceTimeout1 = setTimeout(()=>{									
				// 			this.voiceControlTrigger = true;
				// 		}, intervalDuration);

				// 		this.voiceTimeout2 = setTimeout(()=>{									
				// 			this.voiceControlTrigger = false;
				// 		}, intervalDuration * 2);
				// 	}, intervalDuration * 3);
				// }, 6277);

				this.voiceControlMasterTimer2 = setTimeout(function () {
					_this14.voiceControlTrigger = false;
					// clearInterval(this.voiceInterval);
					// clearInterval(this.voiceTimeout1);
					// clearInterval(this.voiceTimeout2);
					_this14.voiceListInterval = setInterval(function () {
						_this14.voiceListTimeout1 = setTimeout(function () {
							_this14.voiceListControlTrigger = true;
						}, intervalDuration);

						_this14.voiceListTimeout2 = setTimeout(function () {
							_this14.voiceListControlTrigger = false;
						}, intervalDuration * 2);
					}, intervalDuration * 3);
				}, 14849);

				// this.voiceControlMasterTimer3 = setTimeout(()=>{
				// 	this.voiceControlTrigger = false;
				// 	this.voiceListControlTrigger = false;
				// 	clearInterval(this.voiceInterval);
				// 	clearInterval(this.voiceTimeout1);
				// 	clearInterval(this.voiceTimeout2);
				// 	clearInterval(this.voiceListInterval);
				// 	clearInterval(this.voiceListTimeout1);
				// 	clearInterval(this.voiceListTimeout2);
				// 	this.recordInterval = setInterval(()=>{
				// 		this.recordTimeout1 = setTimeout(()=>{									
				// 			this.micRecordingTrigger = true;
				// 		}, intervalDuration);

				// 		this.recordTimeout2 = setTimeout(()=>{									
				// 			this.micRecordingTrigger = false;
				// 		}, intervalDuration * 2);
				// 	}, intervalDuration * 3);
				// }, 22300);	

				// //STOP ALL AFTER 28 SECONDS - NO LOOPING
				// setTimeout(()=>{
				// 	//STOP ABOUT VO
				// 	this.voiceControlVO.stop();
				// 	this.voiceVOBoolean = false;
				// 	//STOP VOICE CONTROL AND MIC RECORD VO
				// 	this.voiceControlTrigger = false;
				// 	this.voiceListControlTrigger = false;
				// 	this.micRecordingTrigger = false;
				// 	clearInterval(this.voiceInterval);
				// 	clearInterval(this.voiceTimeout1);
				// 	clearInterval(this.voiceTimeout2);
				// 	clearInterval(this.voiceListInterval);
				// 	clearInterval(this.voiceListTimeout1);
				// 	clearInterval(this.voiceListTimeout2);
				// 	clearInterval(this.recordInterval);
				// 	clearInterval(this.recordTimeout1);
				// 	clearInterval(this.recordTimeout2);	
				// }, 28000);	

				//STOP SOUND SOURCE VO
				this.soundSourceVOPlayer.stop();
				this.soundSourceVOBoolean = false;
				clearInterval(this.soundSourceInterval);
				clearInterval(this.soundSourceTimeout1);
				clearInterval(this.soundSourceTimeout2);
				clearInterval(this.soundSourceTimeout3);
				clearInterval(this.soundSourceTimeout4);
				clearInterval(this.soundSourceTimeout5);
				clearInterval(this.soundSourceTimeout6);
				this.ambience1BooleanTrigger = false;
				this.ambience2BooleanTrigger = false;
				this.ambience3BooleanTrigger = false;
				this.ambience4BooleanTrigger = false;
				this.ambience5BooleanTrigger = false;
				this.ambience6BooleanTrigger = false;

				//STOP SOUND EFFECTS VO
				this.soundFXVOPlayer.stop();
				this.soundFXVOBoolean = false;
				this.inst1BooleanTrigger = false;
				this.inst2BooleanTrigger = false;
				this.inst3BooleanTrigger = false;
				this.inst4BooleanTrigger = false;
				this.inst5BooleanTrigger = false;
				clearInterval(this.instInterval);
				clearInterval(this.instTimeout1);
				clearInterval(this.instTimeout2);
				clearInterval(this.instTimeout3);
				clearInterval(this.instTimeout4);
				clearInterval(this.instTimeout5);

				//STOP RANDOMIZE VO
				this.randomizeVOPlayer.stop();
				this.randomizeVOBoolean = false;
				this.randomBooleanTrigger = false;
				clearInterval(this.instInterval);
				clearInterval(this.instTimeout1);
				clearInterval(this.instTimeout2);

				//STOP EXPLORE VO
				this.exploreVO.stop();
				this.exploreBoolean = false;
				this.exploreVOBoolean = false;
				//STOP EXPLORE CONTROL AND MIC RECORD VO
				this.exploreControlTrigger = false;
				clearInterval(this.exploreMasterTimer1);
				clearInterval(this.exploreInterval);
				clearInterval(this.exploreTimeout1);
				clearInterval(this.exploreTimeout2);
			} else if (this.voiceVOBoolean === false) {
				this.voiceControlVO.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
				//STOP VOICE VO
				this.voiceControlVO.stop();
				this.voiceVOBoolean = false;
				//STOP VOICE CONTROL AND MIC RECORD VO
				this.voiceControlTrigger = false;
				this.voiceListControlTrigger = false;
				this.micRecordingTrigger = false;
				clearInterval(this.voiceInterval);
				clearInterval(this.voiceTimeout1);
				clearInterval(this.voiceTimeout2);
				clearInterval(this.voiceListInterval);
				clearInterval(this.voiceListTimeout1);
				clearInterval(this.voiceListTimeout2);
				clearInterval(this.recordInterval);
				clearInterval(this.recordTimeout1);
				clearInterval(this.recordTimeout2);
				clearInterval(this.voiceControlMasterTimer1);
				clearInterval(this.voiceControlMasterTimer2);
				clearInterval(this.voiceControlMasterTimer3);

				//WHILE VO IS GOING ON DISABLE VOICE CONTROL
				this.istutorialVOActive = false;
				this.isDisableListening = false;

				setTimeout(function () {
					_this14.voiceControlVO.stop();
					_this14.voiceControlVO.volume.setTargetAtTime(_this14.voiceVOVol, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
				}, 250);
			}
		},
		exploreVOFunc: function exploreVOFunc() {
			var _this15 = this;

			this.exploreVOBoolean = !this.exploreVOBoolean;
			if (this.exploreVOBoolean === true) {
				this.exploreVO.start();
				//WHILE VO IS GOING ON DISABLE VOICE CONTROL
				this.istutorialVOActive = true;
				this.isDisableListening = true;

				var intervalDuration = 250;

				this.exploreMasterTimer1 = setTimeout(function () {
					_this15.exploreInterval = setInterval(function () {
						_this15.exploreTimeout1 = setTimeout(function () {
							_this15.exploreControlTrigger = true;
						}, intervalDuration);

						_this15.exploreTimeout2 = setTimeout(function () {
							_this15.exploreControlTrigger = false;
						}, intervalDuration * 2);
					}, intervalDuration * 3);
				}, 4000);

				//STOP SOUND SOURCE VO
				this.soundSourceVOPlayer.stop();
				this.soundSourceVOBoolean = false;
				clearInterval(this.soundSourceInterval);
				clearInterval(this.soundSourceTimeout1);
				clearInterval(this.soundSourceTimeout2);
				clearInterval(this.soundSourceTimeout3);
				clearInterval(this.soundSourceTimeout4);
				clearInterval(this.soundSourceTimeout5);
				clearInterval(this.soundSourceTimeout6);
				this.ambience1BooleanTrigger = false;
				this.ambience2BooleanTrigger = false;
				this.ambience3BooleanTrigger = false;
				this.ambience4BooleanTrigger = false;
				this.ambience5BooleanTrigger = false;
				this.ambience6BooleanTrigger = false;

				//STOP SOUND EFFECTS VO
				this.soundFXVOPlayer.stop();
				this.soundFXVOBoolean = false;
				this.inst1BooleanTrigger = false;
				this.inst2BooleanTrigger = false;
				this.inst3BooleanTrigger = false;
				this.inst4BooleanTrigger = false;
				this.inst5BooleanTrigger = false;
				clearInterval(this.instInterval);
				clearInterval(this.instTimeout1);
				clearInterval(this.instTimeout2);
				clearInterval(this.instTimeout3);
				clearInterval(this.instTimeout4);
				clearInterval(this.instTimeout5);

				//STOP RANDOMIZE VO
				this.randomizeVOPlayer.stop();
				this.randomizeVOBoolean = false;
				this.randomBooleanTrigger = false;
				clearInterval(this.instInterval);
				clearInterval(this.instTimeout1);
				clearInterval(this.instTimeout2);

				//STOP VOICE VO
				this.voiceControlVO.stop();
				this.voiceVOBoolean = false;
				//STOP VOICE CONTROL AND MIC RECORD VO
				this.voiceControlTrigger = false;
				this.voiceListControlTrigger = false;
				this.micRecordingTrigger = false;
				clearInterval(this.voiceInterval);
				clearInterval(this.voiceTimeout1);
				clearInterval(this.voiceTimeout2);
				clearInterval(this.voiceListInterval);
				clearInterval(this.voiceListTimeout1);
				clearInterval(this.voiceListTimeout2);
				clearInterval(this.recordInterval);
				clearInterval(this.recordTimeout1);
				clearInterval(this.recordTimeout2);
				clearInterval(this.voiceControlMasterTimer1);
				clearInterval(this.voiceControlMasterTimer2);
				clearInterval(this.voiceControlMasterTimer3);
			} else if (this.exploreVOBoolean === false) {
				this.exploreVO.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
				//STOP EXPLORE VO
				this.exploreVO.stop();
				this.exploreBoolean = false;
				//STOP EXPLORE CONTROL AND MIC RECORD VO
				this.exploreControlTrigger = false;
				clearInterval(this.exploreMasterTimer1);
				clearInterval(this.exploreInterval);
				clearInterval(this.exploreTimeout1);
				clearInterval(this.exploreTimeout2);

				//WHILE VO IS GOING ON DISABLE VOICE CONTROL
				this.istutorialVOActive = false;
				this.isDisableListening = false;

				setTimeout(function () {
					_this15.exploreVO.stop();
					_this15.exploreVO.volume.setTargetAtTime(_this15.exploreVol, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
				}, 250);
			}
		},
		ambience1Func: function ambience1Func() {
			var _this16 = this;

			this.randomizeBoolean = false;

			this.ambience1Boolean = !this.ambience1Boolean;
			if (this.ambience1Boolean === true) {
				this.ambience1Player.volume.value = this.ambience1Vol;
				this.ambience1Player.start();
				this.ambience1BooleanPlay = true;
				this.ambience1BooleanStop = false;
			} else if (this.ambience1Boolean === false) {
				this.ambience1Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
				this.ambience1BooleanPlay = false;
				this.ambience1BooleanStop = true;
				setTimeout(function () {
					_this16.ambience1Player.stop();
				}, 250);
			}
		},
		ambience2Func: function ambience2Func() {
			var _this17 = this;

			this.randomizeBoolean = false;

			this.ambience2Boolean = !this.ambience2Boolean;
			if (this.ambience2Boolean === true) {
				this.ambience2Player.volume.value = this.ambience2Vol;
				this.ambience2Player.start();
				this.ambience2BooleanPlay = true;
				this.ambience2BooleanStop = false;
			} else if (this.ambience2Boolean === false) {
				this.ambience2Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
				this.ambience2BooleanPlay = false;
				this.ambience2BooleanStop = true;
				setTimeout(function () {
					_this17.ambience2Player.stop();
				}, 250);
			}
		},
		ambience3Func: function ambience3Func() {
			var _this18 = this;

			this.randomizeBoolean = false;

			this.ambience3Boolean = !this.ambience3Boolean;
			if (this.ambience3Boolean === true) {
				this.ambience3Player.volume.value = this.ambience3Vol;
				this.ambience3Player.start();
				this.ambience3BooleanPlay = true;
				this.ambience3BooleanStop = false;
			} else if (this.ambience3Boolean === false) {
				this.ambience3Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
				this.ambience3BooleanPlay = false;
				this.ambience3BooleanStop = true;
				setTimeout(function () {
					_this18.ambience3Player.stop();
				}, 250);
			}
		},
		ambience4Func: function ambience4Func() {
			var _this19 = this;

			this.randomizeBoolean = false;

			this.ambience4Boolean = !this.ambience4Boolean;
			if (this.ambience4Boolean === true) {
				this.ambience4Player.volume.value = this.ambience4Vol;
				this.ambience4Player.start();
				this.ambience4BooleanPlay = true;
				this.ambience4BooleanStop = false;
			} else if (this.ambience4Boolean === false) {
				this.ambience4Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
				this.ambience4BooleanPlay = false;
				this.ambience4BooleanStop = true;
				setTimeout(function () {
					_this19.ambience4Player.stop();
				}, 250);
			}
		},
		ambience5Func: function ambience5Func() {
			var _this20 = this;

			this.randomizeBoolean = false;

			this.ambience5Boolean = !this.ambience5Boolean;
			if (this.ambience5Boolean === true) {
				this.ambience5Player.volume.value = this.ambience5Vol;
				this.ambience5Player.start();
				this.ambience5BooleanPlay = true;
				this.ambience5BooleanStop = false;
			} else if (this.ambience5Boolean === false) {
				this.ambience5Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
				this.ambience5BooleanPlay = false;
				this.ambience5BooleanStop = true;
				setTimeout(function () {
					_this20.ambience5Player.stop();
				}, 250);
			}
		},
		ambience6Func: function ambience6Func() {
			var _this21 = this;

			this.randomizeBoolean = false;

			this.ambience6Boolean = !this.ambience6Boolean;
			if (this.ambience6Boolean === true) {
				this.ambience6Player.volume.value = this.ambience6Vol;
				this.ambience6Player.start();
				this.ambience6BooleanPlay = true;
				this.ambience6BooleanStop = false;
			} else if (this.ambience6Boolean === false) {
				this.ambience6Player.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
				this.ambience6BooleanPlay = false;
				this.ambience6BooleanStop = true;
				setTimeout(function () {
					_this21.ambience6Player.stop();
				}, 250);
			}
		},

		//GO HOME
		goHome: function goHome() {
			var _this22 = this;

			this.changeFX.start();

			//IF USER ENGAGES VOICE CONTROL BUT GOES HOME VIA 
			//MOUSE BUTTON THIS TRIGGERS MODULE SPEECH DISPOSE
			if (this.goingHomeNotViaVoiceCommand && !this.initSpeech) {
				this.stopModuleSpeech = true;
				this.recognitionTutorial.stop();
				this.recognitionTutorial.abort();
				this.recognitionTutorial = undefined;
			};

			if (this.didWeAdventure === true) {
				this.exploreSound1.disconnect();
				// this.exploreSound2.disconnect();
				// this.exploreSound3.disconnect();
			}

			setTimeout(function () {
				__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.2);
			}, 400);

			setTimeout(function () {
				_this22.ambience1Player.disconnect();
				_this22.ambience2Player.disconnect();
				_this22.ambience3Player.disconnect();
				_this22.ambience4Player.disconnect();
				_this22.ambience5Player.disconnect();
				_this22.ambience6Player.disconnect();
				_this22.TutorialFX.disconnect();
				_this22.changeFX.disconnect();
				_this22.masterVolumeSub.disconnect();
				if (_this22.userMobile === false) {
					_this22.fxConvolver.disconnect();
					_this22.fxAutoFilter.disconnect();
					_this22.fxDelay.disconnect();
					_this22.fxChorus.disconnect();
					_this22.masterMeter.disconnect();
				}
			}, 1000);

			setTimeout(function () {
				document.body.className = 'default';
				_this22.$router.push('/');
				__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Master.volume.value = 0;
			}, 600);
		}
	}
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_startaudiocontext_StartAudioContext_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_startaudiocontext_StartAudioContext_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_startaudiocontext_StartAudioContext_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js__);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import { eventBus } from '../main';

/* harmony default export */ __webpack_exports__["default"] = ({

	data: function data() {
		var _ref;

		return _ref = {
			// isVoiceControl: false,
			//BOOLEANS
			greatPlainsBoolean: false,
			oceanBoolean: false,
			amazonBoolean: false,
			forestBoolean: false,
			desertBoolean: false,
			beachBoolean: false,
			nycBoolean: false,
			ruralBoolean: false,
			iceBoolean: false,
			fireBoolean: false,
			aboutBoolean: false,
			tutBoolean: false,

			greatPlainsBooleanTrigger: false,
			oceanBooleanTrigger: false,
			amazonBooleanTrigger: false,
			forestBooleanTrigger: false,
			desertBooleanTrigger: false,
			beachBooleanTrigger: false,
			nycBooleanTrigger: false,
			ruralBooleanTrigger: false,
			iceBooleanTrigger: false,
			fireBooleanTrigger: false,
			aboutBooleanTrigger: false,
			tutBooleanTrigger: false,

			dontRepeat: false,
			showWelcomePage: true,
			showAboutPage: false,
			oneTimeAbout: true,
			aboutVOBoolean: false,

			// showPlains:         true,
			// showOcean: 			true,
			// showAmazon:			true,
			// showForest:			true,
			// showDesert:         true,
			// showBeach:          true,
			// showNYC: 			true,
			// showRural:			true,
			// showIce: 			true,
			// showFire:			true,
			// showAbout:          true,
			// showTut:          	true,
			//TEXTS
			plainsTxt: "Grasslands",
			oceanTxt: "Pacific Ocean",
			amazonTxt: "Amazon Rainforest",
			forestTxt: "Woodland Forest",
			desertTxt: "Mojave Desert",
			beachTxt: "Seaside",
			nycTxt: "New York City",
			ruralTxt: "Small Town",
			iceTxt: "Subzero Sounds",
			fireTxt: "Sizzling Sounds",
			aboutTxt: "Soundscape.cloud",
			tutTxt: "Tutorial Soundscape",
			aboutHideTxtGen: false,
			titleGenTimeout1: undefined,
			titleGenTimeout2: undefined,
			titleGenTimeout3: undefined,
			titleGenTimeout4: undefined,
			//PLAYERS
			welcomeBlink: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": false,
				"volume": -14
			}).toMaster(),
			aboutBlink: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": false,
				"volume": -8
			}).toMaster(),
			plainsBlink: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": false,
				"volume": -15
			}).toMaster(),
			oceanBlink: new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
				"playbackRate": 1,
				"loop": false,
				"volume": -15
			}).toMaster()
		}, _defineProperty(_ref, 'oceanBlink', new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
			"playbackRate": 1,
			"loop": false,
			"volume": -15
		}).toMaster()), _defineProperty(_ref, 'amazonBlink', new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
			"playbackRate": 1,
			"loop": false,
			"volume": -15
		}).toMaster()), _defineProperty(_ref, 'forestBlink', new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
			"playbackRate": 1,
			"loop": false,
			"volume": -15
		}).toMaster()), _defineProperty(_ref, 'desertBlink', new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
			"playbackRate": 1,
			"loop": false,
			"volume": -15
		}).toMaster()), _defineProperty(_ref, 'beachBlink', new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
			"playbackRate": 1,
			"loop": false,
			"volume": -15
		}).toMaster()), _defineProperty(_ref, 'metroBlink', new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
			"playbackRate": 1,
			"loop": false,
			"volume": -15
		}).toMaster()), _defineProperty(_ref, 'ruralBlink', new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
			"playbackRate": 1,
			"loop": false,
			"volume": -15
		}).toMaster()), _defineProperty(_ref, 'iceBlink', new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
			"playbackRate": 1,
			"loop": false,
			"volume": -15
		}).toMaster()), _defineProperty(_ref, 'fireBlink', new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
			"playbackRate": 1,
			"loop": false,
			"volume": -15
		}).toMaster()), _defineProperty(_ref, 'tutBlink', new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
			"playbackRate": 1,
			"loop": false,
			"volume": -15
		}).toMaster()), _defineProperty(_ref, 'aboutVOPlayer', new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
			"playbackRate": 1,
			"loop": false,
			"volume": -6
		}).toMaster()), _defineProperty(_ref, 'letsTalkVOPlayer', new __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Player({
			"playbackRate": 1,
			"loop": false,
			"volume": -16
		}).toMaster()), _defineProperty(_ref, 'aboutVOTimer', undefined), _defineProperty(_ref, 'allowSpeechControl', false), _defineProperty(_ref, 'isVoiceControl', false), _defineProperty(_ref, 'recognizing', undefined), _defineProperty(_ref, 'welcomeRecognition', undefined), _defineProperty(_ref, 'voiceCommandArray', undefined), _defineProperty(_ref, 'speechRecognitionList', undefined), _defineProperty(_ref, 'voiceCommandConfidence', undefined), _defineProperty(_ref, 'testObjectVUI', ""), _defineProperty(_ref, 'initSpeech', true), _defineProperty(_ref, 'speechBtnTxt', "Please Allow Microphone Access To Use This Feature"), _defineProperty(_ref, 'speechCSSTrigger', false), _defineProperty(_ref, 'isDisableListening', true), _defineProperty(_ref, 'stopModuleSpeech', false), _defineProperty(_ref, 'isChrome', Boolean), _defineProperty(_ref, 'isFirefox', Boolean), _defineProperty(_ref, 'isSafari', Boolean), _defineProperty(_ref, 'isOpera', Boolean), _defineProperty(_ref, 'isIE', Boolean), _defineProperty(_ref, 'isEdge', Boolean), _defineProperty(_ref, 'isBlink', Boolean), _defineProperty(_ref, 'iOS', Boolean), _defineProperty(_ref, 'AndroidMobile', Boolean), _defineProperty(_ref, 'userMobile', Boolean), _defineProperty(_ref, 'onlyPlayVOSpeechOnce', true), _defineProperty(_ref, 'voiceActivateVOInterval', undefined), _defineProperty(_ref, 'startAudioBoolean', true), _ref;
	},
	beforeCreate: function beforeCreate() {
		window.onbeforeunload = function () {
			window.scrollTo(0, 0);
		};
	},
	created: function created() {

		this.isVoiceControl = this.$store.state.isVoiceControlled;
		this.allowSpeechControl = this.$store.state.allowSpeechControl;
		if (this.$store.state.isVoiceControlled) {
			this.speechBtnTxt = "Where Do You Want To Go?";
		}
		var ua = window.navigator.userAgent;
		this.isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
		this.isFirefox = typeof InstallTrigger !== 'undefined';
		this.isSafari = /constructor/i.test(window.HTMLElement) || function (p) {
			return p.toString() === "[object SafariRemoteNotification]";
		}(!window['safari'] || safari.pushNotification);
		this.isOpera = !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
		this.isIE = /*@cc_on!@*/false || !!document.documentMode;
		this.isEdge = !this.isIE && !!window.StyleMedia;
		this.isBlink = (this.isChrome || this.isOpera) && !!window.CSS, this.iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
		this.AndroidMobile = /Android/i.test(navigator.userAgent);
		//CHROME ALLOWS SPEECH AND MEDIA RECORDING
		if (this.isChrome === true) {
			this.userMobile = false;
			//FIREFOX ONLY ALLOWS MEDIA RECORDING
		} else if (this.isFirefox === true) {
			this.userMobile = false;
			//NO SPEECH AND NO MEDIA RECORDING FOR THE FOLLOWING
		} else if (this.AndroidMobile === true || this.iOS) {
			this.userMobile = true;
		} else if (this.isSafari === true || this.isOpera === true || this.isBlink === true || this.isEdge === true || this.isIE === true) {
			this.userMobile = false;
		}
		document.body.className = 'default';
		this.bufferInitLoading();
		this.loadingAudio();
		this.titleGeneration();
	},

	computed: {
		aboutVOClass: function aboutVOClass() {
			return {
				"btn btn-playAbout": this.aboutVOBoolean,
				"btn btn-stopAbout": !this.aboutVOBoolean
			};
		},
		aboutVOIcon: function aboutVOIcon() {
			return {
				"fal fa-times-circle": !this.aboutVOBoolean,
				"fal fa-check-circle": this.aboutVOBoolean
			};
		},
		aboutBtnClass: function aboutBtnClass() {
			return {
				"btn welcomeBtnShadow": !this.aboutBoolean,
				"btn welcomeBtnNoTxt": this.aboutBoolean
			};
		},
		speechStartStop: function speechStartStop() {
			return {
				"btn welcomeBtnShadow": !this.speechCSSTrigger,
				"btn welcomeBtnNoTxt": this.speechCSSTrigger,
				"btn voiceCommandAddShadow": this.recognizing
			};
		},
		speechIconClass: function speechIconClass() {
			return {
				"fa fa-microphone-alt fa-spin": this.recognizing,
				"fa fa-microphone-alt": !this.recognizing
			};
		},
		btnOcean: function btnOcean() {
			return {
				"btn welcomeBtnShadow": !this.oceanBoolean,
				"btn welcomeBtnNoTxt": this.oceanBoolean,
				"backgroundOcean": this.oceanBoolean
			};
		},
		btnPlains: function btnPlains() {
			return {
				"btn welcomeBtnShadow": !this.greatPlainsBoolean,
				"btn welcomeBtnNoTxt": this.greatPlainsBoolean,
				"backgroundGreatPlains": this.greatPlainsBoolean
			};
		},
		btnAmazon: function btnAmazon() {
			return {
				"btn welcomeBtnShadow": !this.amazonBoolean,
				"btn welcomeBtnNoTxt": this.amazonBoolean,
				"backgroundAmazon": this.amazonBoolean
			};
		},
		btnForest: function btnForest() {
			return {
				"btn welcomeBtnShadow": !this.forestBoolean,
				"btn welcomeBtnNoTxt": this.forestBoolean,
				"backgroundForest": this.forestBoolean
			};
		},
		btnDesert: function btnDesert() {
			return {
				"btn welcomeBtnShadow": !this.desertBoolean,
				"btn welcomeBtnNoTxt": this.desertBoolean,
				"backgroundDesert": this.desertBoolean
			};
		},
		btnBeach: function btnBeach() {
			return {
				"btn welcomeBtnShadow": !this.beachBoolean,
				"btn welcomeBtnNoTxt": this.beachBoolean,
				"backgroundBeach": this.beachBoolean
			};
		},
		btnMetro: function btnMetro() {
			return {
				"btn welcomeBtnShadow": !this.nycBoolean,
				"btn welcomeBtnNoTxt": this.nycBoolean,
				"backgroundNYC": this.nycBoolean
			};
		},
		btnRural: function btnRural() {
			return {
				"btn welcomeBtnShadow": !this.ruralBoolean,
				"btn welcomeBtnNoTxt": this.ruralBoolean,
				"backgroundRural": this.ruralBoolean
			};
		},
		btnFire: function btnFire() {
			return {
				"btn welcomeBtnShadow": !this.fireBoolean,
				"btn welcomeBtnNoTxt": this.fireBoolean,
				"backgroundfire": this.fireBoolean
			};
		},
		btnIce: function btnIce() {
			return {
				"btn welcomeBtnShadow": !this.iceBoolean,
				"btn welcomeBtnNoTxt": this.iceBoolean,
				"backgroundice": this.iceBoolean
			};
		},
		btnTut: function btnTut() {
			return {
				"btn welcomeBtnShadow": !this.tutBoolean,
				"btn welcomeBtnNoTxt": this.tutBoolean,
				"backgroundTutorial": this.tutBoolean
			};
		},
		helpClass: function helpClass() {
			return {
				"btn btn-homeHelpBtn1": this.helpTrigger,
				"btn btn-homeHelpBtn2": !this.helpTrigger
			};
		},
		backgroundTransitionHome: function backgroundTransitionHome() {
			return {
				"backgroundGreatPlains": this.greatPlainsBooleanTrigger,
				"backgroundOcean": this.oceanBooleanTrigger,
				"backgroundAmazon": this.amazonBooleanTrigger,
				"backgroundForest": this.forestBooleanTrigger,
				"backgroundDesert": this.desertBooleanTrigger,
				"backgroundBeach": this.beachBooleanTrigger,
				"backgroundNYC": this.nycBooleanTrigger,
				"backgroundRural": this.ruralBooleanTrigger,
				"backgroundice": this.iceBooleanTrigger,
				"backgroundfire": this.fireBooleanTrigger,
				"backgroundTutorial": this.tutBooleanTrigger
			};
		}
	},
	methods: {
		//START AUDIO	
		startAudio: function startAudio() {
			__WEBPACK_IMPORTED_MODULE_0__node_modules_startaudiocontext_StartAudioContext_js___default()(__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.context, "#welcomeBtnAbout");
			this.$store.state.hasAudioContextTriggered = true;
			// UnmuteButton({
			// 	//the parent element of the mute button
			// 	//can pass in "none" to create the element, but not add it to the DOM
			// 	container : document.querySelector('#welcomeBtnAbout'),
			// 	//the title which appears on the iOS lock screen
			// 	title : 'Web Audio',
			// 	//force it to start muted, even when the AudioContext is running
			// 	mute : false,
			// 	//AudioContext
			// 	// context : new Aidio,
			// });
		},

		//SPEECH
		welcomeModuleSpeechStart: function welcomeModuleSpeechStart() {
			// this.speechBtnTxt = "Where Do You Want To Go?";
			// this.letsTalkVOPlayer.start();
			// this.onlyPlayVOSpeechOnce = false;

			// this.voiceActivateVOInterval = setInterval(()=>{

			// 	if (this.letsTalkVOPlayer.state === "stopped"){

			// 		// this.welcomeRecognition.start();
			// 		clearInterval(this.voiceActivateVOInterval);
			// 	}
			// }, 60);
		},
		speechFunc: function speechFunc() {
			var _this = this;

			if (this.startAudioBoolean) {
				this.startAudio();
				this.startAudioBoolean = false;
			}
			if (this.initSpeech === true) {
				this.welcomeRecognition = new webkitSpeechRecognition();
				// console.log(this.welcomeRecognition);
				this.recognizing;
				this.welcomeRecognition.continuous = false;
				this.welcomeRecognition.interimResults = true;

				this.welcomeRecognition.onstart = function () {
					if (_this.onlyPlayVOSpeechOnce) {
						if (!_this.$store.state.doNotAddress) {
							console.log('%c Welcome Module SPEECH Start Up', 'background: black; color: gold');
							_this.speechBtnTxt = "Where Do You Want To Go?";
							_this.letsTalkVOPlayer.start();
							_this.onlyPlayVOSpeechOnce = false;
						}
					}
				};
				this.welcomeRecognition.onresult = function (event) {
					for (var i = event.resultIndex; i < event.results.length; ++i) {
						if (event.results[i].isFinal) {
							if (!_this.isDisableListening) {
								_this.testObject += event.results[i][0].transcript;
								// .toUpperCase();
								_this.voiceCommandArray = event;
								// console.log('I Am Running Inside On Result');
							}
						}
					}
				};
				this.welcomeRecognition.onspeechend = function () {
					console.log('%c Welcome Module SPEECH Ended', 'background: red; color: black');
					setTimeout(_this.voiceCommandAction, 500);
					_this.recognizing = false;
					_this.speechCSSTrigger = false;
					// if (!this.initSpeech){
					_this.speechBtnTxt = "Where Do You Want To Go?";
					// } else if (this.initSpeech){
					// this.speechBtnTxt = "Please Allow Microphone Access To Use This Feature";
					// }
				};
				this.welcomeRecognition.onspeechstart = function () {
					console.log('%c Welcome Module SPEECH Began', 'background: green; color: white');
					_this.recognizing = true;
					_this.speechCSSTrigger = true;
					_this.speechBtnTxt = "Listening For Command";
				};
				this.welcomeRecognition.onsoundstart = function () {
					console.log('%c Welcome Module LISTENING Began', 'background: green; color: white');
				};
				this.welcomeRecognition.onaudioend = function () {
					console.log('%c Welcome Module LISTENING Ended', 'background: green; color: white');
					setTimeout(_this.voiceCommandAction, 500);
				};
				this.welcomeRecognition.onend = function () {
					console.log('%c Welcome Module SPEECH SESSION ENDED', 'background: green; color: white');
					if (_this.stopModuleSpeech === false) {
						_this.welcomeRecognition.start();
					}
				};
				//STARTS OUTPUT FLOW OF THE SPEECH RECOGNITION
				this.isDisableListening = false;
				this.$store.state.isVoiceControlled = true;
				this.$store.state.allowSpeechControl = true;
				//STOPS RESTARTING OF THE SPEECH RECOGNITION
				this.stopModuleSpeech = false;
				this.initSpeech = false;
				this.welcomeRecognition.start();

				//KILLS ALL SPEECH FUNCTIONS IF USER DENIES ACCESS OR THERE IS AN ERROR
				this.welcomeRecognition.onerror = function (event) {
					console.error(event);
					// this.stopModuleSpeech = true;
					// this.$store.state.isVoiceControlled = false;
					// this.$store.state.allowSpeechControl = false;
				};
			} else if (this.initSpeech === false) {}
		},
		resetFunc: function resetFunc() {
			this.recognizing = false;
		},
		stopSpeech: function stopSpeech() {
			//STOP FROM RE_ENTERING SPEECH RECOGNITION LOOP 
			this.stopModuleSpeech = true;
			//DISABLES LISTENING IMMEDITATLY
			this.isDisableListening = true;
			this.$store.state.isVoiceControlled = false;
			//TURNS TRUE SO IF SPEECH IS RE-ENABLED IT WILL RESET PROPERLY
			this.initSpeech = true;
			//CSS SWITCH
			this.recognizing = false;
			//STOP ABORT AND UNDEFINE THE RECOGNITION SERVICE
			this.welcomeRecognition.stop();
			this.welcomeRecognition.abort();
			this.welcomeRecognition = undefined;
		},
		voiceCommandAction: function voiceCommandAction() {
			if (!this.isDisableListening) {
				var voiceCommandAction = this.testObject;
				console.log('Speech String Command: ' + this.testObject);

				if (RegExp(/grasslands?|plains|prairie/gi).test(this.testObject)) {
					this.goToPlains();
				} else if (RegExp(/oceans?|pacific/gi).test(this.testObject)) {
					this.goToOcean();
				} else if (RegExp(/amazons?/gi).test(this.testObject) || RegExp(/rainforest/gi).test(this.testObject)) {
					this.goToAmazon();
				} else if (RegExp(/forest/gi).test(this.testObject) || RegExp(/woodlands?|wood/gi).test(this.testObject)) {
					this.goToForest();
				} else if (RegExp(/des?sert|sands?/gi).test(this.testObject) || RegExp(/mojave/gi).test(this.testObject)) {
					this.goToDesert();
				} else if (RegExp(/beachs?|sunn?y?/gi).test(this.testObject) || RegExp(/sea[side]/gi).test(this.testObject)) {
					this.goToBeach();
				} else if (RegExp(/nyc/gi).test(this.testObject) || RegExp(/new\s?york\s?[city]?/gi).test(this.testObject)) {
					this.goToNYC();
				} else if (RegExp(/small\s?town/gi).test(this.testObject)) {
					this.goToRural();
				} else if (RegExp(/combustion|flames|fire|heat/gi).test(this.testObject)) {
					this.goTofire();
				} else if (RegExp(/sub\s?-?zero/gi).test(this.testObject)) {
					this.goToice();
				} else if (RegExp(/tutorial|help/gi).test(this.testObject)) {
					this.goToTut();
				} else if (RegExp(/about/gi).test(this.testObject)) {
					this.goToAbout();
				} else if (RegExp(/home/gi).test(this.testObject)) {
					this.goHome();
				} else if (RegExp(/stop/gi).test(this.testObject) && RegExp(/voice\s?controls?/gi).test(this.testObject) || RegExp(/stop/gi).test(this.testObject) && RegExp(/voice\s?commands?/gi).test(this.testObject)) {
					//STOP FROM RE_ENTERING SPEECH RECOGNITION LOOP 
					this.stopModuleSpeech = true;
					//DISABLES LISTENING IMMEDITATLY
					this.isDisableListening = true;
					this.$store.state.isVoiceControlled = false;
					//TURNS TRUE SO IF SPEECH IS RE-ENABLED IT WILL RESET PROPERLY
					this.initSpeech = true;
					//CSS SWITCH
					this.recognizing = false;
					//STOP ABORT AND UNDEFINE THE RECOGNITION SERVICE
					this.welcomeRecognition.stop();
					this.welcomeRecognition.abort();
					this.welcomeRecognition = undefined;
				} else {
					this.testObject = "";
				}
				this.testObject = "";
			}
		},

		// isUnderVoiceControl(){
		// 	eventBus.$emit('isVoiceControl', this.isVoiceControl)
		// },
		//TITLE GENERATORS
		titleGeneration: function titleGeneration() {
			this.titleGenTimeout1 = setTimeout(this.genTextSwitcher1, 2000);
			this.titleGenTimeout2 = setTimeout(this.genTextSwitcher2, 6000);
			// this.titleGenTimeout3 = setTimeout(this.genTextSwitcher1, 4500);
			// this.titleGenTimeout4 = setTimeout(this.genTextSwitcher3, 6000);
			// this.genTxtInterval = setInterval(()=>{
			// 	this.genTextSwitcherBack();
			// 	this.genTxtInterval2 = setTimeout(this.genTextSwitcher, 2500);
			// }, 5000);

			// setTimeout(()=>{
			// 	clearInterval(this.genTxtInterval);
			// 	clearInterval(this.genTxtInterval2);
			// 	setTimeout(()=>{this.aboutTxt = "About This Experiment"}, 250);
			// }, 5000)
		},
		genTextSwitcher1: function genTextSwitcher1() {
			var _this2 = this;

			var interval = 25;

			setTimeout(function () {
				_this2.aboutTxt = "Soundscape.cloud";
			}, interval * 2);
			setTimeout(function () {
				_this2.aboutTxt = "Soundscape.clou";
			}, interval * 3);
			setTimeout(function () {
				_this2.aboutTxt = "Soundscape.clo";
			}, interval * 4);
			setTimeout(function () {
				_this2.aboutTxt = "Soundscape.cl";
			}, interval * 5);
			setTimeout(function () {
				_this2.aboutTxt = "Soundscape.c";
			}, interval * 6);
			setTimeout(function () {
				_this2.aboutTxt = "Soundscape.";
			}, interval * 7);
			setTimeout(function () {
				_this2.aboutTxt = "Soundscape";
			}, interval * 8);
			setTimeout(function () {
				_this2.aboutTxt = "Soundscap";
			}, interval * 9);
			setTimeout(function () {
				_this2.aboutTxt = "Soundsca";
			}, interval * 10);
			setTimeout(function () {
				_this2.aboutTxt = "Soundsc";
			}, interval * 11);
			setTimeout(function () {
				_this2.aboutTxt = "Sounds";
			}, interval * 12);
			setTimeout(function () {
				_this2.aboutTxt = "Sound";
			}, interval * 13);
			setTimeout(function () {
				_this2.aboutTxt = "Soun";
			}, interval * 14);
			setTimeout(function () {
				_this2.aboutTxt = "Sou";
			}, interval * 15);
			setTimeout(function () {
				_this2.aboutTxt = "So";
			}, interval * 16);
			setTimeout(function () {
				_this2.aboutTxt = "S";
			}, interval * 17);
			setTimeout(function () {
				_this2.aboutTxt = "C";
			}, interval * 18);
			setTimeout(function () {
				_this2.aboutTxt = "Ch";
			}, interval * 19);
			setTimeout(function () {
				_this2.aboutTxt = "Cho";
			}, interval * 20);
			setTimeout(function () {
				_this2.aboutTxt = "Choo";
			}, interval * 21);
			setTimeout(function () {
				_this2.aboutTxt = "Choos";
			}, interval * 22);
			setTimeout(function () {
				_this2.aboutTxt = "Choose";
			}, interval * 23);
			setTimeout(function () {
				_this2.aboutTxt = "Choose A";
			}, interval * 24);
			setTimeout(function () {
				_this2.aboutTxt = "Choose A S";
			}, interval * 25);
			setTimeout(function () {
				_this2.aboutTxt = "Choose A So";
			}, interval * 26);
			setTimeout(function () {
				_this2.aboutTxt = "Choose A Sou";
			}, interval * 27);
			setTimeout(function () {
				_this2.aboutTxt = "Choose A Soun";
			}, interval * 28);
			setTimeout(function () {
				_this2.aboutTxt = "Choose A Sound";
			}, interval * 29);
			setTimeout(function () {
				_this2.aboutTxt = "Choose A Sounds";
			}, interval * 30);
			setTimeout(function () {
				_this2.aboutTxt = "Choose A Soundsc";
			}, interval * 31);
			setTimeout(function () {
				_this2.aboutTxt = "Choose A Soundsca";
			}, interval * 32);
			setTimeout(function () {
				_this2.aboutTxt = "Choose A Soundscap";
			}, interval * 33);
			setTimeout(function () {
				_this2.aboutTxt = "Choose A Soundscape";
			}, interval * 34);
		},

		// genTextSwitcher1(){
		// 	let interval = 25;

		// 	setTimeout(()=>{
		// 		this.aboutTxt = "Sound Voyage";
		// 	}, interval * 2);
		// 	setTimeout(()=>{
		// 		this.aboutTxt = "Soun Voyage";
		// 	}, interval * 3);
		// 	setTimeout(()=>{
		// 		this.aboutTxt = "Sou Voyage";
		// 	}, interval * 4);
		// 	setTimeout(()=>{
		// 		this.aboutTxt = "So Voyage";
		// 	}, interval * 5);
		// 	setTimeout(()=>{
		// 		this.aboutTxt = "S Voyage";
		// 	}, interval * 6);
		// 	setTimeout(()=>{
		// 		this.aboutTxt = "C Voyage";
		// 	}, interval * 7);
		// 	setTimeout(()=>{
		// 		this.aboutTxt = "Ch Voyage";
		// 	}, interval * 8);
		// 	setTimeout(()=>{
		// 		this.aboutTxt = "Cho Voyage";
		// 	}, interval * 9);
		// 	setTimeout(()=>{
		// 		this.aboutTxt = "Choo Voyage";
		// 	}, interval * 10);
		// 	setTimeout(()=>{
		// 		this.aboutTxt = "Choos Voyage";
		// 	}, interval * 11);
		// 	setTimeout(()=>{
		// 		this.aboutTxt = "Choose Voyage";
		// 	}, interval * 12);
		// 	setTimeout(()=>{
		// 		this.aboutTxt = "Choose A Voyage";
		// 	}, interval * 13);
		// },
		genTextSwitcher2: function genTextSwitcher2() {
			var _this3 = this;

			var interval = 15;

			setTimeout(function () {
				_this3.aboutTxt = "Choose A Soundscape";
			}, interval * 1);
			setTimeout(function () {
				_this3.aboutTxt = "Choose A Soundscap";
			}, interval * 2);
			setTimeout(function () {
				_this3.aboutTxt = "Choose A Soundsca";
			}, interval * 3);
			setTimeout(function () {
				_this3.aboutTxt = "Choose A Soundsc";
			}, interval * 4);
			setTimeout(function () {
				_this3.aboutTxt = "Choose A Sounds";
			}, interval * 5);
			setTimeout(function () {
				_this3.aboutTxt = "Choose A Sound";
			}, interval * 6);
			setTimeout(function () {
				_this3.aboutTxt = "Choose A Soun";
			}, interval * 7);
			setTimeout(function () {
				_this3.aboutTxt = "Choose A Sou";
			}, interval * 8);
			setTimeout(function () {
				_this3.aboutTxt = "Choose A So";
			}, interval * 9);
			setTimeout(function () {
				_this3.aboutTxt = "Choose A S";
			}, interval * 10);
			setTimeout(function () {
				_this3.aboutTxt = "Choose A";
			}, interval * 11);
			setTimeout(function () {
				_this3.aboutTxt = "Choose";
			}, interval * 12);
			setTimeout(function () {
				_this3.aboutTxt = "Choos";
			}, interval * 13);
			setTimeout(function () {
				_this3.aboutTxt = "Choo";
			}, interval * 14);
			setTimeout(function () {
				_this3.aboutTxt = "Cho";
			}, interval * 15);
			setTimeout(function () {
				_this3.aboutTxt = "Ch";
			}, interval * 16);
			setTimeout(function () {
				_this3.aboutTxt = "C";
			}, interval * 17);
			setTimeout(function () {
				_this3.aboutTxt = "A";
			}, interval * 18);
			setTimeout(function () {
				_this3.aboutTxt = "Ab";
			}, interval * 19);
			setTimeout(function () {
				_this3.aboutTxt = "Abo";
			}, interval * 20);
			setTimeout(function () {
				_this3.aboutTxt = "Abou";
			}, interval * 21);
			setTimeout(function () {
				_this3.aboutTxt = "About";
			}, interval * 22);
			setTimeout(function () {
				_this3.aboutTxt = "About T";
			}, interval * 23);
			setTimeout(function () {
				_this3.aboutTxt = "About Th";
			}, interval * 24);
			setTimeout(function () {
				_this3.aboutTxt = "About Thi";
			}, interval * 25);
			setTimeout(function () {
				_this3.aboutTxt = "About This";
			}, interval * 26);
			setTimeout(function () {
				_this3.aboutTxt = "About This E";
			}, interval * 27);
			setTimeout(function () {
				_this3.aboutTxt = "About This Ex";
			}, interval * 28);
			setTimeout(function () {
				_this3.aboutTxt = "About This Exp";
			}, interval * 29);
			setTimeout(function () {
				_this3.aboutTxt = "About This Expe";
			}, interval * 30);
			setTimeout(function () {
				_this3.aboutTxt = "About This Exper";
			}, interval * 31);
			setTimeout(function () {
				_this3.aboutTxt = "About This Experi";
			}, interval * 32);
			setTimeout(function () {
				_this3.aboutTxt = "About This Experim";
			}, interval * 33);
			setTimeout(function () {
				_this3.aboutTxt = "About This Experime";
			}, interval * 34);
			setTimeout(function () {
				_this3.aboutTxt = "About This Experimen";
			}, interval * 35);
			setTimeout(function () {
				_this3.aboutTxt = "About This Experiment";
			}, interval * 36);
		},

		// genTextSwitcher3(){

		// 	let interval = 25;

		// 	setTimeout(()=>{
		// 		this.aboutTxt = "Choose A Soundscape";
		// 	}, interval * 1);
		// 	setTimeout(()=>{
		// 		this.aboutTxt = "Choose A Soundscap";
		// 	}, interval * 2);
		// 	setTimeout(()=>{
		// 		this.aboutTxt = "Choose A Soundsca";
		// 	}, interval * 3);
		// 	setTimeout(()=>{
		// 		this.aboutTxt = "Choose A Soundsc";
		// 	}, interval * 4);
		// 	setTimeout(()=>{
		// 		this.aboutTxt = "Choose A Sounds";
		// 	}, interval * 5);
		// 	setTimeout(()=>{
		// 		this.aboutTxt = "Choose A Sound";
		// 	}, interval * 6);
		// 	setTimeout(()=>{
		// 		this.aboutTxt = "Choose A Soun";
		// 	}, interval * 7);
		// 	setTimeout(()=>{
		// 		this.aboutTxt = "Choose A Sou";
		// 	}, interval * 8);
		// 	setTimeout(()=>{
		// 		this.aboutTxt = "Choose A So";
		// 	}, interval * 9);
		// 	setTimeout(()=>{
		// 		this.aboutTxt = "Choose A S";
		// 	}, interval * 10);
		// 	setTimeout(()=>{
		// 		this.aboutTxt = "Choose A";
		// 	}, interval * 11);
		// 	setTimeout(()=>{
		// 		this.aboutTxt = "Choose";
		// 	}, interval * 12);
		// 	setTimeout(()=>{
		// 		this.aboutTxt = "Choos";
		// 	}, interval * 13);
		// 	setTimeout(()=>{
		// 		this.aboutTxt = "Choo";
		// 	}, interval * 14);
		// 	setTimeout(()=>{
		// 		this.aboutTxt = "Cho";
		// 	}, interval * 15);
		// 	setTimeout(()=>{
		// 		this.aboutTxt = "Ch";
		// 	}, interval * 16);
		// 	setTimeout(()=>{
		// 		this.aboutTxt = "C";
		// 	}, interval * 17);
		// 	setTimeout(()=>{
		// 		this.aboutTxt = "A";
		// 	}, interval * 18);
		// 	setTimeout(()=>{
		// 		this.aboutTxt = "Ab";
		// 	}, interval * 19);
		// 	setTimeout(()=>{
		// 		this.aboutTxt = "Abo";
		// 	}, interval * 20);
		// 	setTimeout(()=>{
		// 		this.aboutTxt = "Abou";
		// 	}, interval * 21);
		// 	setTimeout(()=>{
		// 		this.aboutTxt = "About";
		// 	}, interval * 22);
		// 	setTimeout(()=>{
		// 		this.aboutTxt = "About T";
		// 	}, interval * 23);
		// 	setTimeout(()=>{
		// 		this.aboutTxt = "About Th";
		// 	}, interval * 24);
		// 	setTimeout(()=>{
		// 		this.aboutTxt = "About Thi";
		// 	}, interval * 25);
		// 	setTimeout(()=>{
		// 		this.aboutTxt = "About This";
		// 	}, interval * 26);
		// 	setTimeout(()=>{
		// 		this.aboutTxt = "About This E";
		// 	}, interval * 27);
		// 	setTimeout(()=>{
		// 		this.aboutTxt = "About This Ex";
		// 	}, interval * 28);
		// 	setTimeout(()=>{
		// 		this.aboutTxt = "About This Exp";
		// 	}, interval * 29);
		// 	setTimeout(()=>{
		// 		this.aboutTxt = "About This Expe";
		// 	}, interval * 30);
		// 	setTimeout(()=>{
		// 		this.aboutTxt = "About This Exper";
		// 	}, interval * 31);
		// 	setTimeout(()=>{
		// 		this.aboutTxt = "About This Experi";
		// 	}, interval * 32);
		// 	setTimeout(()=>{
		// 		this.aboutTxt = "About This Experim";
		// 	}, interval * 33);
		// 	setTimeout(()=>{
		// 		this.aboutTxt = "About This Experime";
		// 	}, interval * 34);
		// 	setTimeout(()=>{
		// 		this.aboutTxt = "About This Experimen";
		// 	}, interval * 35);
		// 	setTimeout(()=>{
		// 		this.aboutTxt = "About This Experiment";
		// 	}, interval * 36);

		// },
		//TUTORIAL
		goToTut: function goToTut() {
			var _this4 = this;

			if (this.startAudioBoolean) {
				this.startAudio();
				this.startAudioBoolean = false;
			}
			this.tutBoolean = true;
			this.tutBooleanTrigger = true;
			this.plainsTxt = "";
			this.oceanTxt = "";
			this.amazonTxt = "";
			this.forestTxt = "";
			this.desertTxt = "";
			this.beachTxt = "";
			this.nycTxt = "";
			this.ruralTxt = "";
			this.iceTxt = "";
			this.fireTxt = "";
			this.aboutTxt = "";
			// this.tutTxt = "";


			this.greatPlainsBoolean = true;
			this.oceanBoolean = true;
			this.amazonBoolean = true;
			this.forestBoolean = true;
			this.desertBoolean = true;
			this.beachBoolean = true;
			this.nycBoolean = true;
			this.ruralBoolean = true;
			this.iceBoolean = true;
			this.fireBoolean = true;
			this.aboutBoolean = true;
			// this.tutBoolean 		= 	true;
			this.speechCSSTrigger = true;

			setTimeout(function () {
				_this4.showWelcomePage = false;
			}, 425);

			setTimeout(function () {
				document.body.className = 'tutorial';
				_this4.$router.push('/tutorial');
			}, 1000);

			setTimeout(function () {
				_this4.disconnectWelcomeAudio();
			}, 2000);

			this.tutBlink.start();
		},

		//ABOUT FUNC
		goToAbout: function goToAbout() {
			var _this5 = this;

			if (this.startAudioBoolean) {
				this.startAudio();
				this.startAudioBoolean = false;
			}
			window.scrollTo(0, 0);
			if (this.oneTimeAbout === true) {
				this.oneTimeAbout = false;

				var textTime = 22;

				this.aboutBlink.start();

				setTimeout(function () {
					_this5.tutTxt = "";
				}, textTime);

				setTimeout(function () {
					_this5.plainsTxt = "";
				}, textTime * 10);

				setTimeout(function () {
					_this5.oceanTxt = "";
				}, textTime * 9);

				setTimeout(function () {
					_this5.amazonTxt = "";
				}, textTime * 8);

				setTimeout(function () {
					_this5.forestTxt = "";
				}, textTime * 7);

				setTimeout(function () {
					_this5.desertTxt = "";
				}, textTime * 6);

				setTimeout(function () {
					_this5.beachTxt = "";
				}, textTime * 5);

				setTimeout(function () {
					_this5.nycTxt = "";
				}, textTime * 4);

				setTimeout(function () {
					_this5.ruralTxt = "";
				}, textTime * 3);

				setTimeout(function () {
					_this5.fireTxt = "";
				}, textTime * 2);

				setTimeout(function () {
					_this5.iceTxt = "";
				}, textTime * 1);

				setTimeout(function () {
					_this5.aboutTxt = "";
					_this5.aboutHideTxtGen = true;
				}, textTime * 11);

				setTimeout(function () {
					_this5.showWelcomePage = false;
				}, textTime * 2);

				setTimeout(function () {
					_this5.showAboutPage = true;
				}, textTime * 42);

				clearInterval(this.titleGenTimeout1);
				clearInterval(this.titleGenTimeout2);
				clearInterval(this.titleGenTimeout3);
				clearInterval(this.titleGenTimeout4);
			} else if (this.oneTimeAbout === false) {}
		},
		goHome: function goHome() {
			var _this6 = this;

			this.aboutHideTxtGen = false;
			window.scrollTo(0, 0);

			this.oneTimeAbout = true;

			this.plainsTxt = "Grasslands";
			this.oceanTxt = "Pacific Ocean";
			this.amazonTxt = "Amazon Rainforest";
			this.forestTxt = "Woodland Forest";
			this.desertTxt = "Mojave Desert";
			this.beachTxt = "Seaside";
			this.nycTxt = "New York City";
			this.ruralTxt = "Small Town";
			this.iceTxt = "Subzero Sounds";
			this.fireTxt = "Sizzling Sounds";
			this.aboutTxt = "Sound Voyage";
			this.tutTxt = "Tutorial Soundscape";

			this.showAboutPage = false;
			this.aboutVOPlayer.stop();
			this.aboutVOBoolean = false;
			clearInterval(this.aboutVOTimer);
			setTimeout(function () {
				_this6.showWelcomePage = true;
				_this6.welcomeBlink.start();
			}, 600);

			this.titleGeneration();
		},

		//ENTER FUNC MODULES
		goToPlains: function goToPlains() {
			var _this7 = this;

			if (this.startAudioBoolean) {
				this.startAudio();
				this.startAudioBoolean = false;
			}
			clearInterval(this.genTxtInterval);
			this.aboutHideTxtGen = true;
			this.greatPlainsBoolean = true;
			this.greatPlainsBooleanTrigger = true;
			// this.plainsTxt = "";
			this.oceanTxt = "";
			this.amazonTxt = "";
			this.forestTxt = "";
			this.desertTxt = "";
			this.beachTxt = "";
			this.nycTxt = "";
			this.ruralTxt = "";
			this.iceTxt = "";
			this.fireTxt = "";
			this.aboutTxt = "";
			this.tutTxt = "";

			// this.greatPlainsBoolean =	false;
			this.oceanBoolean = true;
			this.amazonBoolean = true;
			this.forestBoolean = true;
			this.desertBoolean = true;
			this.beachBoolean = true;
			this.nycBoolean = true;
			this.ruralBoolean = true;
			this.iceBoolean = true;
			this.fireBoolean = true;
			this.aboutBoolean = true;
			this.tutBoolean = true;
			this.speechCSSTrigger = true;

			setTimeout(function () {
				_this7.showWelcomePage = false;
			}, 425);

			setTimeout(function () {
				_this7.$router.push('/grasslands');
				document.body.className = 'plains';
				_this7.disconnectWelcomeAudio();
			}, 1000);

			if (this.$store.state.isVoiceControlled === true) {
				this.stopModuleSpeech = true;
				this.welcomeRecognition.abort();
				this.welcomeRecognition = undefined;
			}

			this.plainsBlink.start();
		},
		goToOcean: function goToOcean() {
			var _this8 = this;

			if (this.startAudioBoolean) {
				this.startAudio();
				this.startAudioBoolean = false;
			}
			clearInterval(this.genTxtInterval);
			this.aboutHideTxtGen = true;
			this.oceanBoolean = true;
			this.oceanBooleanTrigger = true;
			this.plainsTxt = "";
			// this.oceanTxt = "";
			this.amazonTxt = "";
			this.forestTxt = "";
			this.desertTxt = "";
			this.beachTxt = "";
			this.nycTxt = "";
			this.ruralTxt = "";
			this.iceTxt = "";
			this.fireTxt = "";
			this.aboutTxt = "";
			this.tutTxt = "";

			this.greatPlainsBoolean = true;
			// this.oceanBoolean 		= 	true;
			this.amazonBoolean = true;
			this.forestBoolean = true;
			this.desertBoolean = true;
			this.beachBoolean = true;
			this.nycBoolean = true;
			this.ruralBoolean = true;
			this.iceBoolean = true;
			this.fireBoolean = true;
			this.aboutBoolean = true;
			this.tutBoolean = true;
			this.speechCSSTrigger = true;

			setTimeout(function () {
				_this8.showWelcomePage = false;
			}, 425);

			setTimeout(function () {
				_this8.showWelcomePage = false;
				_this8.$router.push('/ocean');
				document.body.className = 'ocean';
				_this8.disconnectWelcomeAudio();
			}, 1000);

			if (this.$store.state.isVoiceControlled === true) {
				this.stopModuleSpeech = true;
				this.welcomeRecognition.abort();
				this.welcomeRecognition = undefined;
			}

			this.oceanBlink.start();
		},
		goToAmazon: function goToAmazon() {
			var _this9 = this;

			if (this.startAudioBoolean) {
				this.startAudio();
				this.startAudioBoolean = false;
			}
			clearInterval(this.genTxtInterval);
			this.aboutHideTxtGen = true;
			this.amazonBoolean = true;
			this.amazonBooleanTrigger = true;
			this.plainsTxt = "";
			this.oceanTxt = "";
			// this.amazonTxt = "";
			this.forestTxt = "";
			this.desertTxt = "";
			this.beachTxt = "";
			this.nycTxt = "";
			this.ruralTxt = "";
			this.iceTxt = "";
			this.fireTxt = "";
			this.aboutTxt = "";
			this.tutTxt = "";

			this.greatPlainsBoolean = true;
			this.oceanBoolean = true;
			// this.amazonBoolean 		= 	true;
			this.forestBoolean = true;
			this.desertBoolean = true;
			this.beachBoolean = true;
			this.nycBoolean = true;
			this.ruralBoolean = true;
			this.iceBoolean = true;
			this.fireBoolean = true;
			this.aboutBoolean = true;
			this.tutBoolean = true;
			this.speechCSSTrigger = true;

			setTimeout(function () {
				_this9.showWelcomePage = false;
			}, 425);

			setTimeout(function () {
				_this9.showWelcomePage = false;
				_this9.$router.push('/amazon');
				document.body.className = 'amazon';
				_this9.disconnectWelcomeAudio();
			}, 1000);

			if (this.$store.state.isVoiceControlled === true) {
				this.stopModuleSpeech = true;
				this.welcomeRecognition.abort();
				this.welcomeRecognition = undefined;
			}

			this.amazonBlink.start();
		},
		goToForest: function goToForest() {
			var _this10 = this;

			if (this.startAudioBoolean) {
				this.startAudio();
				this.startAudioBoolean = false;
			}
			clearInterval(this.genTxtInterval);
			this.aboutHideTxtGen = true;
			this.forestBoolean = true;
			this.forestBooleanTrigger = true;
			this.plainsTxt = "";
			this.oceanTxt = "";
			this.amazonTxt = "";
			// this.forestTxt = "";
			this.desertTxt = "";
			this.beachTxt = "";
			this.nycTxt = "";
			this.ruralTxt = "";
			this.iceTxt = "";
			this.fireTxt = "";
			this.aboutTxt = "";
			this.tutTxt = "";

			this.greatPlainsBoolean = true;
			this.oceanBoolean = true;
			this.amazonBoolean = true;
			// this.forestBoolean 		= 	true;
			this.desertBoolean = true;
			this.beachBoolean = true;
			this.nycBoolean = true;
			this.ruralBoolean = true;
			this.iceBoolean = true;
			this.fireBoolean = true;
			this.aboutBoolean = true;
			this.tutBoolean = true;
			this.speechCSSTrigger = true;

			setTimeout(function () {
				_this10.showWelcomePage = false;
			}, 425);

			setTimeout(function () {
				_this10.showWelcomePage = false;
				_this10.$router.push('/woodlands');
				document.body.className = 'forest';
				_this10.disconnectWelcomeAudio();
			}, 1000);

			if (this.$store.state.isVoiceControlled === true) {
				this.stopModuleSpeech = true;
				this.welcomeRecognition.abort();
				this.welcomeRecognition = undefined;
			}

			this.forestBlink.start();
		},
		goToDesert: function goToDesert() {
			var _this11 = this;

			if (this.startAudioBoolean) {
				this.startAudio();
				this.startAudioBoolean = false;
			}
			clearInterval(this.genTxtInterval);
			this.aboutHideTxtGen = true;
			this.desertBoolean = true;
			this.desertBooleanTrigger = true;
			this.plainsTxt = "";
			this.oceanTxt = "";
			this.amazonTxt = "";
			this.forestTxt = "";
			// this.desertTxt = "";
			this.beachTxt = "";
			this.nycTxt = "";
			this.ruralTxt = "";
			this.iceTxt = "";
			this.fireTxt = "";
			this.aboutTxt = "";
			this.tutTxt = "";

			this.greatPlainsBoolean = true;
			this.oceanBoolean = true;
			this.amazonBoolean = true;
			this.forestBoolean = true;
			// this.desertBoolean 		=   true;
			this.beachBoolean = true;
			this.nycBoolean = true;
			this.ruralBoolean = true;
			this.iceBoolean = true;
			this.fireBoolean = true;
			this.aboutBoolean = true;
			this.tutBoolean = true;
			this.speechCSSTrigger = true;

			setTimeout(function () {
				_this11.showWelcomePage = false;
			}, 425);

			setTimeout(function () {
				_this11.showWelcomePage = false;
				_this11.$router.push('/desert');
				document.body.className = 'desert';
				_this11.disconnectWelcomeAudio();
			}, 1000);

			if (this.$store.state.isVoiceControlled === true) {
				this.stopModuleSpeech = true;
				this.welcomeRecognition.abort();
				this.welcomeRecognition = undefined;
			}

			this.desertBlink.start();
		},
		goToBeach: function goToBeach() {
			var _this12 = this;

			if (this.startAudioBoolean) {
				this.startAudio();
				this.startAudioBoolean = false;
			}
			clearInterval(this.genTxtInterval);
			this.aboutHideTxtGen = true;
			this.beachBoolean = true;
			this.beachBooleanTrigger = true;
			this.plainsTxt = "";
			this.oceanTxt = "";
			this.amazonTxt = "";
			this.forestTxt = "";
			this.desertTxt = "";
			// this.beachTxt = "";
			this.nycTxt = "";
			this.ruralTxt = "";
			this.iceTxt = "";
			this.fireTxt = "";
			this.aboutTxt = "";
			this.tutTxt = "";

			this.greatPlainsBoolean = true;
			this.oceanBoolean = true;
			this.amazonBoolean = true;
			this.forestBoolean = true;
			this.desertBoolean = true;
			// this.beachBoolean 		=   true;
			this.nycBoolean = true;
			this.ruralBoolean = true;
			this.iceBoolean = true;
			this.fireBoolean = true;
			this.aboutBoolean = true;
			this.tutBoolean = true;
			this.speechCSSTrigger = true;

			setTimeout(function () {
				_this12.showWelcomePage = false;
			}, 425);

			setTimeout(function () {
				_this12.showWelcomePage = false;
				_this12.$router.push('/seaside');
				document.body.className = 'beach';
				_this12.disconnectWelcomeAudio();
			}, 1000);

			if (this.$store.state.isVoiceControlled === true) {
				this.stopModuleSpeech = true;
				this.welcomeRecognition.abort();
				this.welcomeRecognition = undefined;
			}

			this.beachBlink.start();
		},
		goToNYC: function goToNYC() {
			var _this13 = this;

			if (this.startAudioBoolean) {
				this.startAudio();
				this.startAudioBoolean = false;
			}
			clearInterval(this.genTxtInterval);
			this.aboutHideTxtGen = true;
			this.nycBoolean = true;
			this.nycBooleanTrigger = true;
			this.plainsTxt = "";
			this.oceanTxt = "";
			this.amazonTxt = "";
			this.forestTxt = "";
			this.desertTxt = "";
			this.beachTxt = "";
			// this.nycTxt = "";
			this.ruralTxt = "";
			this.iceTxt = "";
			this.fireTxt = "";
			this.aboutTxt = "";
			this.tutTxt = "";

			this.greatPlainsBoolean = true;
			this.oceanBoolean = true;
			this.amazonBoolean = true;
			this.forestBoolean = true;
			this.desertBoolean = true;
			this.beachBoolean = true;
			// this.nycBoolean 		= 	true;
			this.ruralBoolean = true;
			this.iceBoolean = true;
			this.fireBoolean = true;
			this.aboutBoolean = true;
			this.tutBoolean = true;
			this.speechCSSTrigger = true;

			setTimeout(function () {
				_this13.showWelcomePage = false;
			}, 425);

			setTimeout(function () {
				_this13.showWelcomePage = false;
				_this13.$router.push('/nyc');
				document.body.className = 'nyc';
				_this13.disconnectWelcomeAudio();
			}, 1000);

			if (this.$store.state.isVoiceControlled === true) {
				this.stopModuleSpeech = true;
				this.welcomeRecognition.abort();
				this.welcomeRecognition = undefined;
			}

			this.metroBlink.start();
		},
		goToRural: function goToRural() {
			var _this14 = this;

			if (this.startAudioBoolean) {
				this.startAudio();
				this.startAudioBoolean = false;
			}
			clearInterval(this.genTxtInterval);
			this.aboutHideTxtGen = true;
			this.ruralBoolean = true;
			this.ruralBooleanTrigger = true;
			this.plainsTxt = "";
			this.oceanTxt = "";
			this.amazonTxt = "";
			this.forestTxt = "";
			this.desertTxt = "";
			this.beachTxt = "";
			this.nycTxt = "";
			// this.ruralTxt = "";
			this.iceTxt = "";
			this.fireTxt = "";
			this.aboutTxt = "";
			this.tutTxt = "";

			this.greatPlainsBoolean = true;
			this.oceanBoolean = true;
			this.amazonBoolean = true;
			this.forestBoolean = true;
			this.desertBoolean = true;
			this.beachBoolean = true;
			this.nycBoolean = true;
			// this.ruralBoolean 		= 	true;
			this.iceBoolean = true;
			this.fireBoolean = true;
			this.aboutBoolean = true;
			this.tutBoolean = true;
			this.speechCSSTrigger = true;

			setTimeout(function () {
				_this14.showWelcomePage = false;
			}, 425);

			setTimeout(function () {
				_this14.showWelcomePage = false;
				_this14.$router.push('/smalltown');
				document.body.className = 'rural';
				_this14.disconnectWelcomeAudio();
			}, 1000);

			if (this.$store.state.isVoiceControlled === true) {
				this.stopModuleSpeech = true;
				this.welcomeRecognition.abort();
				this.welcomeRecognition = undefined;
			}

			this.ruralBlink.start();
		},
		goToice: function goToice() {
			var _this15 = this;

			if (this.startAudioBoolean) {
				this.startAudio();
				this.startAudioBoolean = false;
			}
			clearInterval(this.genTxtInterval);
			this.aboutHideTxtGen = true;
			this.iceBoolean = true;
			this.iceBooleanTrigger = true;
			this.plainsTxt = "";
			this.oceanTxt = "";
			this.amazonTxt = "";
			this.forestTxt = "";
			this.desertTxt = "";
			this.beachTxt = "";
			this.nycTxt = "";
			this.ruralTxt = "";
			// this.iceTxt = "";
			this.fireTxt = "";
			this.aboutTxt = "";
			this.tutTxt = "";

			this.greatPlainsBoolean = true;
			this.oceanBoolean = true;
			this.amazonBoolean = true;
			this.forestBoolean = true;
			this.desertBoolean = true;
			this.beachBoolean = true;
			this.nycBoolean = true;
			this.ruralBoolean = true;
			// this.iceBoolean 		= 	true;
			this.fireBoolean = true;
			this.aboutBoolean = true;
			this.tutBoolean = true;
			this.speechCSSTrigger = true;

			setTimeout(function () {
				_this15.showWelcomePage = false;
			}, 425);

			setTimeout(function () {
				_this15.showWelcomePage = false;
				_this15.$router.push('/ice');
				document.body.className = 'ice';
				_this15.disconnectWelcomeAudio();
			}, 1000);

			if (this.$store.state.isVoiceControlled === true) {
				this.stopModuleSpeech = true;
				this.welcomeRecognition.abort();
				this.welcomeRecognition = undefined;
			}

			this.iceBlink.start();
		},
		goTofire: function goTofire() {
			var _this16 = this;

			if (this.startAudioBoolean) {
				this.startAudio();
				this.startAudioBoolean = false;
			}
			clearInterval(this.genTxtInterval);
			this.aboutHideTxtGen = true;
			this.fireBoolean = true;
			this.fireBooleanTrigger = true;
			this.plainsTxt = "";
			this.oceanTxt = "";
			this.amazonTxt = "";
			this.forestTxt = "";
			this.desertTxt = "";
			this.beachTxt = "";
			this.nycTxt = "";
			this.ruralTxt = "";
			this.iceTxt = "";
			// this.fireTxt = "";
			this.aboutTxt = "";
			this.tutTxt = "";

			this.greatPlainsBoolean = true;
			this.oceanBoolean = true;
			this.amazonBoolean = true;
			this.forestBoolean = true;
			this.desertBoolean = true;
			this.beachBoolean = true;
			this.nycBoolean = true;
			this.ruralBoolean = true;
			this.iceBoolean = true;
			// this.fireBoolean 		= 	true;
			this.aboutBoolean = true;
			this.tutBoolean = true;
			this.speechCSSTrigger = true;

			setTimeout(function () {
				_this16.showWelcomePage = false;
			}, 425);

			setTimeout(function () {
				_this16.showWelcomePage = false;
				_this16.$router.push('/fire');
				document.body.className = 'fire';
				_this16.disconnectWelcomeAudio();
			}, 1000);

			if (this.$store.state.isVoiceControlled === true) {
				this.stopModuleSpeech = true;
				this.welcomeRecognition.abort();
				this.welcomeRecognition = undefined;
			}

			this.fireBlink.start();
		},

		//LOADING AUDIO
		// loadWelcomeTone(){

		// },
		loadingAudio: function loadingAudio() {
			var ua = window.navigator.userAgent;

			if (this.isChrome === true || this.AndroidMobile === true || this.isOpera === true || this.isFirefox === true || this.isBlink === true) {

				this.aboutBlink.load("../src/assets/sounds/blinks/aboutBlink.ogg");
				this.welcomeBlink.load("../src/assets/sounds/blinks/welcomeBlink.ogg");
				this.plainsBlink.load("../src/assets/sounds/blinks/plainsBlink.ogg");
				this.oceanBlink.load("../src/assets/sounds/blinks/oceanBlink.ogg");
				this.amazonBlink.load("../src/assets/sounds/blinks/amazonBlink.ogg");
				this.forestBlink.load("../src/assets/sounds/blinks/forestBlink.ogg");
				this.desertBlink.load("../src/assets/sounds/blinks/desertBlink.ogg");
				this.beachBlink.load("../src/assets/sounds/blinks/beachBlink.ogg");
				this.metroBlink.load("../src/assets/sounds/blinks/metroBlink.ogg");
				this.ruralBlink.load("../src/assets/sounds/blinks/ruralBlink.ogg");
				this.iceBlink.load("../src/assets/sounds/blinks/iceBlink.ogg");
				this.fireBlink.load("../src/assets/sounds/blinks/fireBlink.ogg");
				this.tutBlink.load("../src/assets/sounds/blinks/tutBlink.ogg");
				this.aboutVOPlayer.load("../src/assets/sounds/modules/tutorial/hiogg/generativeVO.ogg");
				// this.whereToPlayer.load("../src/assets/sounds/modules/tutorial/hiogg/whereToVO.ogg");
				this.letsTalkVOPlayer.load("../src/assets/sounds/modules/tutorial/hiogg/niceLetsTalkVO.ogg");
			} else if (this.isSafari === true || this.iOS === true || this.isEdge === true || this.isIE === true) {

				this.aboutBlink.load("../src/assets/sounds/blinks/aboutBlink.m4a");
				this.welcomeBlink.load("../src/assets/sounds/blinks/welcomeBlink.m4a");
				this.plainsBlink.load("../src/assets/sounds/blinks/plainsBlink.m4a");
				this.oceanBlink.load("../src/assets/sounds/blinks/oceanBlink.m4a");
				this.amazonBlink.load("../src/assets/sounds/blinks/amazonBlink.m4a");
				this.forestBlink.load("../src/assets/sounds/blinks/forestBlink.m4a");
				this.desertBlink.load("../src/assets/sounds/blinks/desertBlink.m4a");
				this.beachBlink.load("../src/assets/sounds/blinks/beachBlink.m4a");
				this.metroBlink.load("../src/assets/sounds/blinks/metroBlink.m4a");
				this.ruralBlink.load("../src/assets/sounds/blinks/ruralBlink.m4a");
				this.iceBlink.load("../src/assets/sounds/blinks/iceBlink.m4a");
				this.fireBlink.load("../src/assets/sounds/blinks/fireBlink.m4a");
				this.tutBlink.load("../src/assets/sounds/blinks/tutBlink.m4a");
				this.aboutVOPlayer.load("../src/assets/sounds/modules/tutorial/320/generativeVO.m4a");
			}
		},
		disconnectWelcomeAudio: function disconnectWelcomeAudio() {
			this.aboutBlink.disconnect();
			this.welcomeBlink.disconnect();
			this.plainsBlink.disconnect();
			this.oceanBlink.disconnect();
			this.amazonBlink.disconnect();
			this.forestBlink.disconnect();
			this.desertBlink.disconnect();
			this.beachBlink.disconnect();
			this.metroBlink.disconnect();
			this.ruralBlink.disconnect();
			this.iceBlink.disconnect();
			this.fireBlink.disconnect();
			this.aboutVOPlayer.disconnect();
			// this.whereToPlayer.disconnect();
			this.letsTalkVOPlayer.disconnect();
		},

		//BUFFER LOADING
		bufferInitLoading: function bufferInitLoading() {
			var _this17 = this;

			__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Buffer.on('progress', function () {});
			__WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Buffer.on('load', function () {
				if (_this17.$store.state.hasAudioContextTriggered) {
					_this17.playWelcomeTone();
				};
				if (_this17.isVoiceControl === true) {
					_this17.speechFunc();
				}
			});
		},

		//PLAY WELCOME
		playWelcomeTone: function playWelcomeTone() {
			// this.welcomeBlink.start();
			if (this.userMobile === false) {
				this.showWelcomePage = true;
				if (this.dontRepeat === false) {
					this.welcomeBlink.start();
					// if (!this.$store.state.isFirstLoad){
					// if(!this.$store.state.allowSpeechControl){
					// setTimeout( () => {this.whereToPlayer.start();}, 50);
					// 	}
					// }
					this.dontRepeat = true;
					this.$store.state.isFirstLoad = false;
				} else if (this.dontRepeat === true) {}
			}
		},
		aboutVOFunc: function aboutVOFunc() {
			var _this18 = this;

			this.aboutVOBoolean = !this.aboutVOBoolean;
			if (this.aboutVOBoolean === true) {
				this.aboutVOPlayer.volume.setTargetAtTime(-13, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);
				this.aboutVOPlayer.start();

				this.aboutVOTimer = setTimeout(function () {
					_this18.aboutVOPlayer.stop();
					_this18.aboutVOBoolean = false;
				}, 27000);
			} else if (this.aboutVOBoolean === false) {

				this.aboutVOPlayer.volume.setTargetAtTime(-70, __WEBPACK_IMPORTED_MODULE_1__node_modules_Tone_build_Tone_min_js___default.a.Context.currentTime, +0.05);

				setTimeout(function () {
					_this18.aboutVOPlayer.stop();
				}, 250);

				clearInterval(this.aboutVOTimer);
			}
		}
	}
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routes_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_store_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_mobile_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_mobile_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_mobile_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_welcome_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_welcome_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_welcome_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_plains_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_plains_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_plains_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ocean_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ocean_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_ocean_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_amazon_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_amazon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_amazon_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_forest_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_forest_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_forest_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_desert_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_desert_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_desert_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_beach_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_beach_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_beach_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_nyc_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_nyc_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_nyc_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_rural_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_rural_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_rural_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_ice_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_ice_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_ice_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_fire_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_fire_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_fire_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_tutorial_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_tutorial_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_tutorial_vue__);





















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('Mobile', __WEBPACK_IMPORTED_MODULE_5__components_mobile_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('Welcome', __WEBPACK_IMPORTED_MODULE_6__components_welcome_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('Plains', __WEBPACK_IMPORTED_MODULE_7__components_plains_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('Ocean', __WEBPACK_IMPORTED_MODULE_8__components_ocean_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('Amazon', __WEBPACK_IMPORTED_MODULE_9__components_amazon_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('Forest', __WEBPACK_IMPORTED_MODULE_10__components_forest_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('Desert', __WEBPACK_IMPORTED_MODULE_11__components_desert_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('Beach', __WEBPACK_IMPORTED_MODULE_12__components_beach_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('NYC', __WEBPACK_IMPORTED_MODULE_13__components_nyc_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('Rural', __WEBPACK_IMPORTED_MODULE_14__components_rural_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('Ice', __WEBPACK_IMPORTED_MODULE_15__components_ice_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('Fire', __WEBPACK_IMPORTED_MODULE_16__components_fire_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('Tutorial', __WEBPACK_IMPORTED_MODULE_17__components_tutorial_vue___default.a);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
	routes: __WEBPACK_IMPORTED_MODULE_3__routes_js__["a" /* routes */],
	mode: 'history'
});

router.beforeEach(function (to, from, next) {
	document.title = to.meta.title;
	window.scrollTo(0, 0);
	next();
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
	el: '#app',
	router: router,
	store: __WEBPACK_IMPORTED_MODULE_4__store_store_js__["a" /* store */],
	render: function render(h) {
		return h(__WEBPACK_IMPORTED_MODULE_1__App_vue___default.a);
	}
});

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)();
// imports


// module
exports.push([module.i, ":root{--main-fxBadgesPlains-color:#cac08b!important;--main-startPlains-color:#196539!important;--main-stopPlains-color:#ae6330!important;--main-border-color:4px solid transparent}.backgroundColorPlains1{background-color:#e0a01f;transition:background .1s linear}.backgroundColorPlains2{background-color:#e1a227;transition:background .1s linear}.backgroundColorPlains3{background-color:#e3a935;transition:background .1s linear}.backgroundColorPlains4{background-color:#e7b34b;transition:background .1s linear}.backgroundColorPlains5{background-color:#eabc62;transition:background .1s linear}.backgroundColorPlains6{background-color:#edc678;transition:background .1s linear}.backgroundColorPlains7{background-color:#f0cf8f;transition:background .1s linear}.backgroundColorPlains8{background-color:#f3d9a5;transition:background .1s linear}.backgroundColorPlains9{background-color:#f6e2bc;transition:background .1s linear}.backgroundColorPlains10{background-color:#f9ecd2;transition:background .1s linear}.sunReactiveColorClassPlains1{background-color:#f9ecd2;transition:background .25s linear}.sunReactiveColorClassPlains2{background-color:#f6e2bc;transition:background .25s linear}.sunReactiveColorClassPlains3{background-color:#f3d9a5;transition:background .25s linear}.sunReactiveColorClassPlains4{background-color:#f0cf8f;transition:background .25s linear}.sunReactiveColorClassPlains5{background-color:#edc678;transition:background .25s linear}.sunReactiveColorClassPlains6{background-color:#eabc62;transition:background .25s linear}.sunReactiveColorClassPlains7{background-color:#e7b34b;transition:background .25s linear}.sunReactiveColorClassPlains8{background-color:#e3a935;transition:background .25s linear}.sunReactiveColorClassPlains9{background-color:#e1a227;transition:background .25s linear}.sunReactiveColorClassPlains10{background-color:#e0a01f;transition:background .25s linear}.btn-mattChillOff,.btn-mattChillOff.active,.btn-mattChillOff:active,.btn-mattChillOff:active:focus,.btn-mattChillOff:focus,.open>.dropdown-toggle.btn-mattChillOff{color:#000;background-color:var(--main-stopPlains-color);border-width:2px;border-color:transparent}.btn-mattChillOff:active:hover,.btn-mattChillOff:hover,.btn-mattChillOn,.btn-mattChillOn.active,.btn-mattChillOn:active,.btn-mattChillOn:active:focus,.btn-mattChillOn:focus,.open>.dropdown-toggle.btn-mattChillOn{color:#fff;background-color:var(--main-startPlains-color);border-width:2px;border-color:transparent}.btn-mattChillOn:active:hover,.btn-mattChillOn:hover{color:#fff;background-color:var(--main-stopPlains-color);border-width:2px;border-color:transparent}.btn-helpBtn1Plains,.btn-helpBtn1Plains:active,.btn-helpBtn1Plains:active:focus,.btn-helpBtn1Plains:focus,.open>.dropdown-toggle.btn-helpBtn1Plains{color:#000;background-color:transparent;border-color:transparent;border-width:2px}.btn-helpBtn1Plains:active:hover,.btn-helpBtn1Plains:hover{color:var(--main-startPlains-color);background-color:transparent;border-color:var(--main-startPlains-color);border-width:2px}.btn-helpBtn2Plains,.btn-helpBtn2Plains:active,.btn-helpBtn2Plains:active:focus,.btn-helpBtn2Plains:active:hover,.btn-helpBtn2Plains:focus,.btn-helpBtn2Plains:hover,.open>.dropdown-toggle.btn-helpBtn2Plains{background:var(--main-fxBadgesPlains-color);color:var(--main-startPlains-color);border-color:transparent;box-shadow:0 4px 4px 1px rgba(0,0,0,.4);text-shadow:0 1px 2px rgba(0,0,0,.4)}.btn-playPlains,.btn-playPlains:active,.btn-playPlains:active:focus,.btn-playPlains:active:hover,.btn-playPlains:focus,.btn-playPlains:hover,.open>.dropdown-toggle.btn-playPlains{color:#fff;background-color:var(--main-startPlains-color);border-color:var(--main-startPlains-color);border-width:2px;box-shadow:0 4px 4px 1px rgba(0,0,0,.2);text-shadow:0 1px 2px rgba(0,0,0,.4)}.btn-stopPlains,.btn-stopPlains:active,.btn-stopPlains:active:focus,.btn-stopPlains:active:hover,.btn-stopPlains:focus,.btn-stopPlains:hover,.open>.dropdown-toggle.btn-stopPlains{color:#000;background-color:var(--main-stopPlains-color);border-color:var(--main-stopPlains-color);border-width:2px;box-shadow:0 4px 4px 1px rgba(0,0,0,.4);text-shadow:0 1px 2px rgba(0,0,0,.4)}input[class=instrumentRangerPlains]{background:var(--main-fxBadgesPlains-color)}input[class=instrumentRangerPlains]::-moz-range-track{background:var(--main-fxBadgesPlains-color)}input[class=instrumentRangerPlains]::-webkit-slider-thumb{background:var(--main-fxBadgesPlains-color)}input[class=instrumentRangerPlains]::-moz-range-thumb{background:var(--main-fxBadgesPlains-color)}input[class=instrumentRangerPlains]::-ms-thumb{background:#cac08b}input[class=instrumentRangerPlains]::-ms-fill-upper{background:#ae6330}input[class=instrumentRangerPlains]::-ms-fill-lower{background:#196539}input[class=ambianceRangerStopPlains]{background-color:var(--main-stopPlains-color)}input[class=ambianceRangerStopPlains]::-webkit-slider-thumb{background:var(--main-stopPlains-color)}input[class=ambianceRangerStopPlains]::-moz-range-track{background-color:var(--main-stopPlains-color)}input[class=ambianceRangerStopPlains]::-moz-range-thumb{background:var(--main-stopPlains-color)}input[class=ambianceRangerStopPlains]::-ms-thumb{background:#cac08b}input[class=ambianceRangerStopPlains]::-ms-fill-upper{background:#ae6330}input[class=ambianceRangerStopPlains]::-ms-fill-lower{background:#196539}input[class=ambianceRangerPlayPlains]{background-color:var(--main-startPlains-color)}input[class=ambianceRangerPlayPlains]::-webkit-slider-thumb{background:var(--main-startPlains-color)}input[class=ambianceRangerPlayPlains]::-moz-range-track{background-color:var(--main-startPlains-color)}input[class=ambianceRangerPlayPlains]::-moz-range-thumb{background:var(--main-startPlains-color)}input[class=ambianceRangerPlayPlains]::-ms-thumb{background:#cac08b}input[class=ambianceRangerPlayPlains]::-ms-fill-upper{background:#ae6330}input[class=ambianceRangerPlayPlains]::-ms-fill-lower{background:#196539}.recordingClassDisengagedPlains{background:var(--main-fxBadgesPlains-color);color:var(--main-startPlains-color);box-shadow:0 4px 4px 1px rgba(0,0,0,.4)}.recordingClassDisengagedPlains,.recordingClassEngagedPlains{border-color:transparent;text-shadow:0 1px 2px rgba(0,0,0,.4)}.recordingClassEngagedPlains{background:var(--main-startPlains-color);color:var(--main-fxBadgesPlains-color);box-shadow:0 4px 4px 1px rgba(0,0,0,.2)}input[id=inlineFormInputGroupUsername2]::-webkit-input-placeholder{color:var(--main-startPlains-color)}#voiceCommandListID{color:#000;background-color:var(--main-fxBadgesPlains-color)}.voiceBadgePlains{background:var(--main-fxBadgesPlains-color);color:#fff}", ""]);

// exports


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)();
// imports


// module
exports.push([module.i, ":root{--main-fxBadgesDesert-color:#b6b180!important;--main-startDesert-color:#4188cd!important;--main-stopDesert-color:#66401e!important;--main-border-color:4px solid transparent}.backgroundColorDesert1{background-color:#9a6d32;transition:background .1s linear}.backgroundColorDesert2{background-color:#ad7b38;transition:background .1s linear}.backgroundColorDesert3{background-color:#c1883e;transition:background .1s linear}.backgroundColorDesert4{background-color:#c79452;transition:background .1s linear}.backgroundColorDesert5{background-color:#cda065;transition:background .1s linear}.backgroundColorDesert6{background-color:#d3ac78;transition:background .1s linear}.backgroundColorDesert7{background-color:#d7b385;transition:background .1s linear}.backgroundColorDesert8{background-color:#dab88b;transition:background .1s linear}.backgroundColorDesert9{background-color:#e0c49f;transition:background .1s linear}.backgroundColorDesert10{background-color:#e6cfb2;transition:background .1s linear}.sunReactiveColorClassDesert1{background-color:#ecdbc5;transition:background .25s linear}.sunReactiveColorClassDesert2{background-color:#e6cfb2;transition:background .25s linear}.sunReactiveColorClassDesert3{background-color:#e0c49f;transition:background .25s linear}.sunReactiveColorClassDesert4{background-color:#dab88b;transition:background .25s linear}.sunReactiveColorClassDesert5{background-color:#d7b385;transition:background .25s linear}.sunReactiveColorClassDesert6{background-color:#d3ac78;transition:background .25s linear}.sunReactiveColorClassDesert7{background-color:#cda065;transition:background .25s linear}.sunReactiveColorClassDesert8{background-color:#c79452;transition:background .25s linear}.sunReactiveColorClassDesert9{background-color:#c1883e;transition:background .25s linear}.sunReactiveColorClassDesert10{background-color:#ad7b38;transition:background .25s linear}.btn-mattChillOffDesert,.btn-mattChillOffDesert.active,.btn-mattChillOffDesert:active,.btn-mattChillOffDesert:active:focus,.btn-mattChillOffDesert:focus,.open>.dropdown-toggle.btn-mattChillOffDesert{color:#fff;background-color:var(--main-stopDesert-color);border-width:2px;border-color:transparent}.btn-mattChillOffDesert:active:hover,.btn-mattChillOffDesert:hover,.btn-mattChillOnDesert,.btn-mattChillOnDesert.active,.btn-mattChillOnDesert:active,.btn-mattChillOnDesert:active:focus,.btn-mattChillOnDesert:focus,.open>.dropdown-toggle.btn-mattChillOnDesert{color:#fff;background-color:var(--main-startDesert-color);border-width:2px;border-color:transparent}.btn-mattChillOnDesert:active:hover,.btn-mattChillOnDesert:hover{color:#fff;background-color:var(--main-stopDesert-color);border-width:2px;border-color:transparent}.btn-helpBtn1Desert,.btn-helpBtn1Desert:active,.btn-helpBtn1Desert:active:focus,.btn-helpBtn1Desert:focus,.open>.dropdown-toggle.btn-helpBtn1Desert{color:#000;background-color:transparent;border-color:transparent;border-width:2px}.btn-helpBtn1Desert:active:hover,.btn-helpBtn1Desert:hover{color:var(--main-stopDesert-color);background-color:transparent;border-color:var(--main-stopDesert-color);border-width:2px}.btn-helpBtn2Desert,.btn-helpBtn2Desert:active,.btn-helpBtn2Desert:active:focus,.btn-helpBtn2Desert:active:hover,.btn-helpBtn2Desert:focus,.btn-helpBtn2Desert:hover,.open>.dropdown-toggle.btn-helpBtn2Desert{background:var(--main-fxBadgesDesert-color);color:#000;border-color:transparent;box-shadow:0 4px 4px 1px rgba(0,0,0,.4);text-shadow:0 1px 2px rgba(0,0,0,.4)}.btn-playDesert,.btn-playDesert:active,.btn-playDesert:active:focus,.btn-playDesert:active:hover,.btn-playDesert:focus,.btn-playDesert:hover,.open>.dropdown-toggle.btn-playDesert{color:#fff;background-color:var(--main-startDesert-color);border-color:var(--main-startDesert-color);border-width:2px;box-shadow:0 4px 4px 1px rgba(0,0,0,.2);text-shadow:0 1px 2px rgba(0,0,0,.4)}.btn-stopDesert,.btn-stopDesert:active,.btn-stopDesert:active:focus,.btn-stopDesert:active:hover,.btn-stopDesert:focus,.btn-stopDesert:hover,.open>.dropdown-toggle.btn-stopDesert{color:#fff;background-color:var(--main-stopDesert-color);border-color:var(--main-stopDesert-color);border-width:2px;box-shadow:0 4px 4px 1px rgba(0,0,0,.4);text-shadow:0 1px 2px rgba(0,0,0,.4)}input[class=instrumentRangerDesert]{background:var(--main-fxBadgesDesert-color)}input[class=instrumentRangerDesert]::-moz-range-track{background:var(--main-fxBadgesDesert-color)}input[class=instrumentRangerDesert]::-webkit-slider-thumb{background:var(--main-fxBadgesDesert-color)}input[class=instrumentRangerDesert]::-moz-range-thumb{background:var(--main-fxBadgesDesert-color)}input[class=instrumentRangerDesert]::-ms-thumb{background:#b6b180}input[class=instrumentRangerDesert]::-ms-fill-upper{background:#66401e}input[class=instrumentRangerDesert]::-ms-fill-lower{background:#4188cd}input[class=ambianceRangerStopDesert]{background-color:var(--main-stopDesert-color)}input[class=ambianceRangerStopDesert]::-webkit-slider-thumb{background:var(--main-stopDesert-color)}input[class=ambianceRangerStopDesert]::-moz-range-track{background-color:var(--main-stopDesert-color)}input[class=ambianceRangerStopDesert]::-moz-range-thumb{background:var(--main-stopDesert-color)}input[class=ambianceRangerStopDesert]::-ms-thumb{background:#b6b180}input[class=ambianceRangerStopDesert]::-ms-fill-upper{background:#66401e}input[class=ambianceRangerStopDesert]::-ms-fill-lower{background:#4188cd}input[class=ambianceRangerPlayDesert]{background-color:var(--main-startDesert-color)}input[class=ambianceRangerPlayDesert]::-webkit-slider-thumb{background:var(--main-startDesert-color)}input[class=ambianceRangerPlayDesert]::-moz-range-track{background-color:var(--main-startDesert-color)}input[class=ambianceRangerPlayDesert]::-moz-range-thumb{background:var(--main-startDesert-color)}input[class=ambianceRangerPlayDesert]::-ms-thumb{background:#b6b180}input[class=ambianceRangerPlayDesert]::-ms-fill-upper{background:#66401e}input[class=ambianceRangerPlayDesert]::-ms-fill-lower{background:#4188cd}.recordingClassDisengagedDesert{background:var(--main-fxBadgesDesert-color);color:#000;box-shadow:0 4px 4px 1px rgba(0,0,0,.4)}.recordingClassDisengagedDesert,.recordingClassEngagedDesert{border-color:transparent;text-shadow:0 1px 2px rgba(0,0,0,.4)}.recordingClassEngagedDesert{background:var(--main-startDesert-color);color:#fff;box-shadow:0 4px 4px 1px rgba(0,0,0,.2)}input[id=inlineFormInputGroupUsername2]::-webkit-input-placeholder{color:var(--main-startDesert-color)}#voiceCommandListID{color:#000;background-color:var(--main-fxBadgesDesert-color)}.voiceBadgeDesert{background:var(--main-fxBadgesDesert-color);color:#000}.animated.zoomOutUp{-webkit-animation-duration:2.2s;animation-duration:2.2s}", ""]);

// exports


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)();
// imports


// module
exports.push([module.i, ":root{--main-fxBadgesFire-color:#f2a413!important;--main-startFire-color:#5b1201!important;--main-stopFire-color:#f27405!important;--main-border-color:4px solid transparent}.backgroundColorFire1{background-color:red;transition:background .1s linear}.backgroundColorFire2{background-color:#e62e00;transition:background .1s linear}.backgroundColorFire3{background-color:#f30;transition:background .1s linear}.backgroundColorFire4{background-color:#ff471a;transition:background .1s linear}.backgroundColorFire5{background-color:#ff5c33;transition:background .1s linear}.backgroundColorFire6{background-color:#f90;transition:background .1s linear}.backgroundColorFire7{background-color:#ffa31a;transition:background .1s linear}.backgroundColorFire8{background-color:#ffd11a;transition:background .1s linear}.backgroundColorFire9{background-color:#ffd633;transition:background .1s linear}.backgroundColorFire10{background-color:#ffdb4d;transition:background .1s linear}.sunReactiveColorClassFire1{background-color:#ffdb4d;transition:background .25s linear}.sunReactiveColorClassFire2{background-color:#ffd633;transition:background .25s linear}.sunReactiveColorClassFire3{background-color:#ffd11a;transition:background .25s linear}.sunReactiveColorClassFire4{background-color:#ffa31a;transition:background .25s linear}.sunReactiveColorClassFire5{background-color:#f90;transition:background .25s linear}.sunReactiveColorClassFire6{background-color:#ff5c33;transition:background .25s linear}.sunReactiveColorClassFire7{background-color:#ff471a;transition:background .25s linear}.sunReactiveColorClassFire8{background-color:#f30;transition:background .25s linear}.sunReactiveColorClassFire9{background-color:#e62e00;transition:background .25s linear}.sunReactiveColorClassFire10{background-color:red;transition:background .25s linear}.btn-mattChillOffFire,.btn-mattChillOffFire.active,.btn-mattChillOffFire:active,.btn-mattChillOffFire:active:focus,.btn-mattChillOffFire:focus,.open>.dropdown-toggle.btn-mattChillOffFire{color:#000;background-color:var(--main-stopFire-color);border-width:2px;border-color:transparent}.btn-mattChillOffFire:active:hover,.btn-mattChillOffFire:hover,.btn-mattChillOnFire,.btn-mattChillOnFire.active,.btn-mattChillOnFire:active,.btn-mattChillOnFire:active:focus,.btn-mattChillOnFire:focus,.open>.dropdown-toggle.btn-mattChillOnFire{color:#fff;background-color:var(--main-startFire-color);border-width:2px;border-color:transparent}.btn-mattChillOnFire:active:hover,.btn-mattChillOnFire:hover{color:#fff;background-color:var(--main-stopFire-color);border-width:2px;border-color:transparent}.btn-helpBtn1Fire,.btn-helpBtn1Fire:active,.btn-helpBtn1Fire:active:focus,.btn-helpBtn1Fire:focus,.open>.dropdown-toggle.btn-helpBtn1Fire{color:#000;background-color:transparent;border-color:transparent;border-width:2px}.btn-helpBtn1Fire:active:hover,.btn-helpBtn1Fire:hover{color:#000;background-color:transparent;border-color:var(--main-stopFire-color);border-width:2px}.btn-helpBtn2Fire,.btn-helpBtn2Fire:active,.btn-helpBtn2Fire:active:focus,.btn-helpBtn2Fire:active:hover,.btn-helpBtn2Fire:focus,.btn-helpBtn2Fire:hover,.open>.dropdown-toggle.btn-helpBtn2Fire{background:var(--main-fxBadgesFire-color);color:#000;border-color:transparent;box-shadow:0 4px 4px 1px rgba(0,0,0,.4);text-shadow:0 1px 2px rgba(0,0,0,.4)}.btn-playFire,.btn-playFire:active,.btn-playFire:active:focus,.btn-playFire:active:hover,.btn-playFire:focus,.btn-playFire:hover,.open>.dropdown-toggle.btn-playFire{color:#fff;background-color:var(--main-startFire-color);border-color:var(--main-startFire-color);border-width:2px;box-shadow:0 4px 4px 1px rgba(0,0,0,.2);text-shadow:0 1px 2px rgba(0,0,0,.4)}.btn-stopFire,.btn-stopFire:active,.btn-stopFire:active:focus,.btn-stopFire:active:hover,.btn-stopFire:focus,.btn-stopFire:hover,.open>.dropdown-toggle.btn-stopFire{color:#000;background-color:var(--main-stopFire-color);border-color:var(--main-stopFire-color);border-width:2px;box-shadow:0 4px 4px 1px rgba(0,0,0,.4);text-shadow:0 1px 2px rgba(0,0,0,.4)}input[class=instrumentRangerFire]{background:var(--main-fxBadgesFire-color)}input[class=instrumentRangerFire]::-moz-range-track{background:var(--main-fxBadgesFire-color)}input[class=instrumentRangerFire]::-webkit-slider-thumb{background:var(--main-fxBadgesFire-color)}input[class=instrumentRangerFire]::-moz-range-thumb{background:var(--main-fxBadgesFire-color)}input[class=instrumentRangerFire]::-ms-thumb{background:#f2a413}input[class=instrumentRangerFire]::-ms-fill-upper{background:#f27405}input[class=instrumentRangerFire]::-ms-fill-lower{background:#5b1201}input[class=ambianceRangerStopFire]{background-color:var(--main-stopFire-color)}input[class=ambianceRangerStopFire]::-webkit-slider-thumb{background:var(--main-stopFire-color)}input[class=ambianceRangerStopFire]::-moz-range-track{background-color:var(--main-stopFire-color)}input[class=ambianceRangerStopFire]::-moz-range-thumb{background:var(--main-stopFire-color)}input[class=ambianceRangerStopFire]::-ms-thumb{background:#f2a413}input[class=ambianceRangerStopFire]::-ms-fill-upper{background:#f27405}input[class=ambianceRangerStopFire]::-ms-fill-lower{background:#5b1201}input[class=ambianceRangerPlayFire]{background-color:var(--main-startFire-color)}input[class=ambianceRangerPlayFire]::-webkit-slider-thumb{background:var(--main-startFire-color)}input[class=ambianceRangerPlayFire]::-moz-range-track{background-color:var(--main-startFire-color)}input[class=ambianceRangerPlayFire]::-moz-range-thumb{background:var(--main-startFire-color)}input[class=ambianceRangerPlayFire]::-ms-thumb{background:#f2a413}input[class=ambianceRangerPlayFire]::-ms-fill-upper{background:#f27405}input[class=ambianceRangerPlayFire]::-ms-fill-lower{background:#5b1201}.recordingClassDisengagedFire{background:var(--main-fxBadgesFire-color);color:var(--main-startFire-color);box-shadow:0 4px 4px 1px rgba(0,0,0,.4)}.recordingClassDisengagedFire,.recordingClassEngagedFire{border-color:transparent;text-shadow:0 1px 2px rgba(0,0,0,.4)}.recordingClassEngagedFire{background:var(--main-startFire-color);color:var(--main-fxBadgesFire-color);box-shadow:0 4px 4px 1px rgba(0,0,0,.2)}input[id=inlineFormInputGroupUsername2]::-webkit-input-placeholder{color:var(--main-startFire-color)}#voiceCommandListID{color:var(--main-startFire-color);background-color:var(--main-fxBadgesFire-color)}.voiceBadgeFire{background:var(--main-fxBadgesFire-color);color:#000}", ""]);

// exports


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)();
// imports


// module
exports.push([module.i, ":root{--main-fxBadgesBeach-color:#d99559!important;--main-startBeach-color:#f2e6d8!important;--main-stopBeach-color:#448aa6!important;--main-border-color:4px solid transparent}.backgroundColorBeach1{background-color:#e4c39a;transition:background .1s linear}.backgroundColorBeach2{background-color:#eacfae;transition:background .1s linear}.backgroundColorBeach3{background-color:#efdbc3;transition:background .1s linear}.backgroundColorBeach4{background-color:#f4e7d7;transition:background .1s linear}.backgroundColorBeach5{background-color:#faf3eb;transition:background .1s linear}.backgroundColorBeach6{background-color:#e6fcff;transition:background .1s linear}.backgroundColorBeach7{background-color:#cdf9fe;transition:background .1s linear}.backgroundColorBeach8{background-color:#b3f5fe;transition:background .1s linear}.backgroundColorBeach9{background-color:#9af2fe;transition:background .1s linear}.backgroundColorBeach10{background-color:#81effe;transition:background .1s linear}.sunReactiveColorClassBeach1{background-color:#81effe;transition:background .25s linear}.sunReactiveColorClassBeach2{background-color:#9af2fe;transition:background .25s linear}.sunReactiveColorClassBeach3{background-color:#b3f5fe;transition:background .25s linear}.sunReactiveColorClassBeach4{background-color:#cdf9fe;transition:background .25s linear}.sunReactiveColorClassBeach5{background-color:#e6fcff;transition:background .25s linear}.sunReactiveColorClassBeach6{background-color:#faf3eb;transition:background .25s linear}.sunReactiveColorClassBeach7{background-color:#f4e7d7;transition:background .25s linear}.sunReactiveColorClassBeach8{background-color:#efdbc3;transition:background .25s linear}.sunReactiveColorClassBeach9{background-color:#eacfae;transition:background .25s linear}.sunReactiveColorClassBeach10{background-color:#e4c39a;transition:background .25s linear}.btn-mattChillOffBeach,.btn-mattChillOffBeach.active,.btn-mattChillOffBeach:active,.btn-mattChillOffBeach:active:focus,.btn-mattChillOffBeach:focus,.open>.dropdown-toggle.btn-mattChillOffBeach{color:#000;background-color:var(--main-stopBeach-color);border-width:2px;border-color:transparent}.btn-mattChillOffBeach:active:hover,.btn-mattChillOffBeach:hover,.btn-mattChillOnBeach,.btn-mattChillOnBeach.active,.btn-mattChillOnBeach:active,.btn-mattChillOnBeach:active:focus,.btn-mattChillOnBeach:focus,.open>.dropdown-toggle.btn-mattChillOnBeach{color:#000;background-color:var(--main-startBeach-color);border-width:2px;border-color:transparent}.btn-mattChillOnBeach:active:hover,.btn-mattChillOnBeach:hover{color:#fff;background-color:var(--main-stopBeach-color);border-width:2px;border-color:transparent}.btn-helpBtn1Beach,.btn-helpBtn1Beach:active,.btn-helpBtn1Beach:active:focus,.btn-helpBtn1Beach:focus,.open>.dropdown-toggle.btn-helpBtn1Beach{color:#000;background-color:transparent;border-color:transparent;border-width:2px}.btn-helpBtn1Beach:active:hover,.btn-helpBtn1Beach:hover{color:var(--main-stopBeach-color);background-color:transparent;border-color:var(--main-stopBeach-color);border-width:2px}.btn-helpBtn2Beach,.btn-helpBtn2Beach:active,.btn-helpBtn2Beach:active:focus,.btn-helpBtn2Beach:active:hover,.btn-helpBtn2Beach:focus,.btn-helpBtn2Beach:hover,.open>.dropdown-toggle.btn-helpBtn2Beach{background:var(--main-fxBadgesBeach-color);color:#000;border-color:transparent;box-shadow:0 4px 4px 1px rgba(0,0,0,.4);text-shadow:0 1px 2px rgba(0,0,0,.4)}.btn-playBeach,.btn-playBeach:active,.btn-playBeach:active:focus,.btn-playBeach:active:hover,.btn-playBeach:focus,.btn-playBeach:hover,.open>.dropdown-toggle.btn-playBeach{color:#000;background-color:var(--main-startBeach-color);border-color:var(--main-startBeach-color);border-width:2px;box-shadow:0 4px 4px 1px rgba(0,0,0,.2);text-shadow:0 1px 2px rgba(0,0,0,.4)}.btn-stopBeach,.btn-stopBeach:active,.btn-stopBeach:active:focus,.btn-stopBeach:active:hover,.btn-stopBeach:focus,.btn-stopBeach:hover,.open>.dropdown-toggle.btn-stopBeach{color:#fff;background-color:var(--main-stopBeach-color);border-color:var(--main-stopBeach-color);border-width:2px;box-shadow:0 4px 4px 1px rgba(0,0,0,.4);text-shadow:0 1px 2px rgba(0,0,0,.4)}input[class=instrumentRangerBeach]{background:var(--main-fxBadgesBeach-color)}input[class=instrumentRangerBeach]::-moz-range-track{background:var(--main-fxBadgesBeach-color)}input[class=instrumentRangerBeach]::-webkit-slider-thumb{background:var(--main-fxBadgesBeach-color)}input[class=instrumentRangerBeach]::-moz-range-thumb{background:var(--main-fxBadgesBeach-color)}input[class=instrumentRangerBeach]::-ms-thumb{background:#d99559}input[class=instrumentRangerBeach]::-ms-fill-upper{background:#448aa6}input[class=instrumentRangerBeach]::-ms-fill-lower{background:#f2e6d8}input[class=ambianceRangerStopBeach]{background-color:var(--main-stopBeach-color)}input[class=ambianceRangerStopBeach]::-webkit-slider-thumb{background:var(--main-stopBeach-color)}input[class=ambianceRangerStopBeach]::-moz-range-track{background-color:var(--main-stopBeach-color)}input[class=ambianceRangerStopBeach]::-moz-range-thumb{background:var(--main-stopBeach-color)}input[class=ambianceRangerStopBeach]::-ms-thumb{background:#d99559}input[class=ambianceRangerStopBeach]::-ms-fill-upper{background:#448aa6}input[class=ambianceRangerStopBeach]::-ms-fill-lower{background:#f2e6d8}input[class=ambianceRangerPlayBeach]{background-color:var(--main-startBeach-color)}input[class=ambianceRangerPlayBeach]::-webkit-slider-thumb{background:var(--main-startBeach-color)}input[class=ambianceRangerPlayBeach]::-moz-range-track{background-color:var(--main-startBeach-color)}input[class=ambianceRangerPlayBeach]::-moz-range-thumb{background:var(--main-startBeach-color)}input[class=ambianceRangerPlayBeach]::-ms-thumb{background:#d99559}input[class=ambianceRangerPlayBeach]::-ms-fill-upper{background:#448aa6}input[class=ambianceRangerPlayBeach]::-ms-fill-lower{background:#f2e6d8}.recordingClassDisengagedBeach{background:var(--main-fxBadgesBeach-color);color:#000;box-shadow:0 4px 4px 1px rgba(0,0,0,.4)}.recordingClassDisengagedBeach,.recordingClassEngagedBeach{border-color:transparent;text-shadow:0 1px 2px rgba(0,0,0,.4)}.recordingClassEngagedBeach{background:var(--main-startBeach-color);color:var(--main-fxBadgesBeach-color);box-shadow:0 4px 4px 1px rgba(0,0,0,.2)}input[id=inlineFormInputGroupUsername2]::-webkit-input-placeholder{color:var(--main-stopBeach-color)}#voiceCommandListID{color:#000;background-color:var(--main-fxBadgesBeach-color)}.voiceBadgeBeach{background:var(--main-fxBadgesBeach-color);color:#fff!important}", ""]);

// exports


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)();
// imports


// module
exports.push([module.i, ":root{--main-fxBadgesTutorial-color:#565759!important;--main-startTutorial-color:#3498db!important;--main-stopTutorial-color:#e74c3c!important;--main-border-color:4px solid transparent;--main-highlight-background-color:#efe712}.backgroundColorTutorial10{background-color:#e6e6e6;transition:background .1s linear}.backgroundColorTutorial9{background-color:#ccc;transition:background .1s linear}.backgroundColorTutorial8{background-color:#b3b3b3;transition:background .1s linear}.backgroundColorTutorial7{background-color:#999;transition:background .1s linear}.backgroundColorTutorial6{background-color:gray;transition:background .1s linear}.backgroundColorTutorial5{background-color:#666;transition:background .1s linear}.backgroundColorTutorial4{background-color:#4d4d4d;transition:background .1s linear}.backgroundColorTutorial3{background-color:#333;transition:background .1s linear}.backgroundColorTutorial2{background-color:#1a1a1a;transition:background .1s linear}.backgroundColorTutorial1{background-color:#000;transition:background .1s linear}.sunReactiveColorClassTutorial1{background-color:#ccc;transition:background .25s linear}.sunReactiveColorClassTutorial2{background-color:#b3b3b3;transition:background .25s linear}.sunReactiveColorClassTutorial3{background-color:#999;transition:background .25s linear}.sunReactiveColorClassTutorial4{background-color:gray;transition:background .25s linear}.sunReactiveColorClassTutorial5,.sunReactiveColorClassTutorial6{background-color:#666;transition:background .25s linear}.sunReactiveColorClassTutorial7{background-color:#4d4d4d;transition:background .25s linear}.sunReactiveColorClassTutorial8{background-color:#333;transition:background .25s linear}.sunReactiveColorClassTutorial9{background-color:#1a1a1a;transition:background .25s linear}.sunReactiveColorClassTutorial10{background-color:#000;transition:background .25s linear}.btn-mattChillOffTutorial,.btn-mattChillOffTutorial.active,.btn-mattChillOffTutorial:active,.btn-mattChillOffTutorial:active:focus,.btn-mattChillOffTutorial:focus,.open>.dropdown-toggle.btn-mattChillOffTutorial{color:#000;background-color:var(--main-stopTutorial-color);border-width:2px;border-color:transparent}.btn-mattChillOffTutorial:active:hover,.btn-mattChillOffTutorial:hover,.btn-mattChillOnTutorial,.btn-mattChillOnTutorial.active,.btn-mattChillOnTutorial:active,.btn-mattChillOnTutorial:active:focus,.btn-mattChillOnTutorial:focus,.open>.dropdown-toggle.btn-mattChillOnTutorial{color:#fff;background-color:var(--main-startTutorial-color);border-width:2px;border-color:transparent}.btn-mattChillOnTutorial:active:hover,.btn-mattChillOnTutorial:hover{color:#fff;background-color:var(--main-stopTutorial-color);border-width:2px;border-color:transparent}.btn-helpBtn1Tutorial,.btn-helpBtn1Tutorial:active,.btn-helpBtn1Tutorial:active:focus,.btn-helpBtn1Tutorial:focus,.open>.dropdown-toggle.btn-helpBtn1Tutorial{color:#000;background-color:transparent;border-color:transparent;border-width:2px}.btn-helpBtn1Tutorial:active:hover,.btn-helpBtn1Tutorial:hover{color:#000;background-color:transparent;border-color:#000;border-width:2px}.btn-helpBtn2Tutorial,.btn-helpBtn2Tutorial:active,.btn-helpBtn2Tutorial:active:focus,.btn-helpBtn2Tutorial:active:hover,.btn-helpBtn2Tutorial:focus,.btn-helpBtn2Tutorial:hover,.open>.dropdown-toggle.btn-helpBtn2Tutorial{background:var(--main-fxBadgesTutorial-color);color:#fff;border-color:transparent;box-shadow:0 4px 4px 1px rgba(0,0,0,.4);text-shadow:0 1px 2px rgba(0,0,0,.4)}.btn-playTutorial,.btn-playTutorial:active,.btn-playTutorial:active:focus,.btn-playTutorial:active:hover,.btn-playTutorial:focus,.btn-playTutorial:hover,.open>.dropdown-toggle.btn-playTutorial{color:#fff;background-color:var(--main-startTutorial-color);border-color:var(--main-startTutorial-color);border-width:2px;box-shadow:0 4px 4px 1px rgba(0,0,0,.2);text-shadow:0 1px 2px rgba(0,0,0,.4)}.btn-stopTutorial,.btn-stopTutorial:active,.btn-stopTutorial:active:focus,.btn-stopTutorial:active:hover,.btn-stopTutorial:focus,.btn-stopTutorial:hover,.open>.dropdown-toggle.btn-stopTutorial{color:#000;background-color:var(--main-stopTutorial-color);border-color:var(--main-stopTutorial-color);border-width:2px;box-shadow:0 4px 4px 1px rgba(0,0,0,.4);text-shadow:0 1px 2px rgba(0,0,0,.4)}input[class=instrumentRangerTutorial]{background:var(--main-fxBadgesTutorial-color)}input[class=instrumentRangerTutorial]::-moz-range-track{background:var(--main-fxBadgesTutorial-color)}input[class=instrumentRangerTutorial]::-webkit-slider-thumb{background:var(--main-fxBadgesTutorial-color)}input[class=instrumentRangerTutorial]::-moz-range-thumb{background:var(--main-fxBadgesTutorial-color)}input[class=instrumentRangerTutorial]::-ms-thumb{background:#565759}input[class=instrumentRangerTutorial]::-ms-fill-upper{background:#e74c3c}input[class=instrumentRangerTutorial]::-ms-fill-lower{background:#3498db}input[class=ambianceRangerStopTutorial]{background-color:var(--main-stopTutorial-color)}input[class=ambianceRangerStopTutorial]::-webkit-slider-thumb{background-color:var(--main-stopTutorial-color)}input[class=ambianceRangerStopTutorial]::-moz-range-thumb,input[class=ambianceRangerStopTutorial]::-moz-range-track{background-color:var(--main-stopTutorial-color)}input[class=ambianceRangerStopTutorial]::-ms-thumb{background:#565759}input[class=ambianceRangerStopTutorial]::-ms-fill-upper{background:#e74c3c}input[class=ambianceRangerStopTutorial]::-ms-fill-lower{background:#3498db}input[class=ambianceRangerPlayTutorial]{background-color:var(--main-startTutorial-color)}input[class=ambianceRangerPlayTutorial]::-webkit-slider-thumb{background-color:var(--main-startTutorial-color)}input[class=ambianceRangerPlayTutorial]::-moz-range-thumb,input[class=ambianceRangerPlayTutorial]::-moz-range-track{background-color:var(--main-startTutorial-color)}input[class=ambianceRangerPlayTutorial]::-ms-thumb{background:#565759}input[class=ambianceRangerPlayTutorial]::-ms-fill-upper{background:#e74c3c}input[class=ambianceRangerPlayTutorial]::-ms-fill-lower{background:#3498db}input[class=sectionHighlightSlider]{background-color:var(--main-highlight-background-color)!important}input[class=sectionHighlightSlider]::-webkit-slider-thumb{background-color:var(--main-highlight-background-color)!important}input[class=sectionHighlightSlider]::-moz-range-thumb,input[class=sectionHighlightSlider]::-moz-range-track{background-color:var(--main-highlight-background-color)!important}input[class=sectionHighlightSlider]::-ms-fill-upper,input[class=sectionHighlightSlider]::-ms-thumb{background:#efe712}input[class=sectionHighlightSlider]::-ms-fill-lower{background:#efe712}.recordingClassDisengagedTutorial{background:var(--main-fxBadgesTutorial-color);box-shadow:0 4px 4px 1px rgba(0,0,0,.4)}.recordingClassDisengagedTutorial,.recordingClassEngagedTutorial{color:#fff;border-color:transparent;text-shadow:0 1px 2px rgba(0,0,0,.4)}.recordingClassEngagedTutorial{background:var(--main-startTutorial-color);box-shadow:0 4px 4px 1px rgba(0,0,0,.2)}audio::-webkit-media-controls-panel,input[id=inlineFormInputGroupUsername2]::-webkit-input-placeholder{color:var(--main-fxBadgesTutorial-color)}audio::-webkit-media-controls-panel{background-color:var(--main-fxBadgesTutorial-color);border-radius:6px}audio::-webkit-media-controls-play-button{font-color:var(--main-startTutorial-color)}audio::-webkit-media-controls-current-time-display,audio::-webkit-media-controls-time-remaining-display{font-size:20px}#voiceCommandListID{color:#fff;background-color:var(--main-fxBadgesTutorial-color)}.sectionHighlight{border-width:2px!important}.sectionHighlight,.sectionHighlightVoiceBtn{color:#000!important;border-color:transparent!important;background-color:var(--main-highlight-background-color)!important}.sectionHighlightVoiceBtn{border-width:0!important}.voiceBadgeTutorial{background:var(--main-fxBadgesTutorial-color);color:#fff}", ""]);

// exports


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)();
// imports
exports.push([module.i, "@import url(https://fonts.googleapis.com/css?family=Quicksand);", ""]);

// module
exports.push([module.i, "body,html{width:100%;height:100%}#app,body,html{margin:0;padding:0}#app{font-family:Avenir,Quicksand;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-align:center}button:focus,input:focus{outline:none!important}.container-fluid{padding-right:0;padding-left:0}input[type=range]{pointer-events:none}input[type=range]::-webkit-slider-thumb{pointer-events:auto}body.default{background-color:#fff}body.plains{background-color:#e0a01f}body.ocean{background-color:#fff}body.amazon{background-color:#4f601f}body.forest{background-color:#8fd471}body.desert{background-color:#9a6d32}body.beach{background-color:#e4c39a}body.nyc{background-color:#f1f3f3}body.rural{background-color:#699}body.ice{background-color:#13c4ec}body.fire{background-color:red}body.tutorial{background-color:#000}@media (min-width:0px) and (max-width:349px){#mainDiv{padding-right:0;padding-left:0;max-width:400px;height:800px}#optionsBucket{margin-top:5px}#enterContainer{margin-top:30px}#mobileBtn{margin-top:150px;border-width:2px;font-size:24px}#mobileBtn,#welcomeMobileText{font-weight:300;text-shadow:0 1px 2px rgba(0,0,0,.3)}#welcomeMobileText{margin-top:20px;color:#000;font-size:16px}#bell{color:var(--main-v1-color)}#enterFuncBtn{font-size:22px;height:200px;width:200px;border-radius:300px;margin-top:100px;text-shadow:0 1px 2px rgba(0,0,0,.3)}#welcomeBtn{margin-left:0}#welcomeBtn,#welcomeBtnAbout{height:40px;width:250px;margin-top:4px;font-size:18px;border-color:#000;border-width:2px;border-radius:4px;background-color:transparent}#welcomeBtnAbout{margin-left:-2px}#helpContainer{margin-top:0}#helpContainerTutorial{max-width:144px;margin-top:15px;margin-left:74px}#aboutBtnID,#localStorageBtnID{margin-top:0;width:70px;font-size:11px;padding:6px 0;font-weight:700}#aboutBtnID,#aboutBtnID2,#localStorageBtnID{border-radius:6px;text-shadow:0 2px 4px rgba(0,0,0,.4)}#aboutBtnID2{margin-top:-12px;padding:5px 8px;font-weight:300}#aboutTxt{max-width:320px;margin:auto;margin-top:18px;font-size:13px;text-align:left;color:#fff;text-shadow:0 1px 1px rgba(0,0,0,.2)}#shoutOut{font-size:12px}#disclaimerTxt{margin-top:10px;font-size:10px;text-shadow:0 1px 1px rgba(0,0,0,.2)}#aboutSectionVO{margin-top:-10px;margin-bottom:-6px;width:180px;border-radius:4px;font-size:15px;font-weight:400;box-shadow:0 8px 10px 1px rgba(0,0,0,.4);text-shadow:0 1px 2px rgba(0,0,0,.3);margin-left:-1px}#fxTitle{font-size:20px;margin-top:4px;margin-bottom:0;text-shadow:0 1px 3px rgba(0,0,0,.5)}#fxTitle,#fxTitle2{font-weight:300;color:#fff}#fxTitle2{font-size:12px;margin-top:280px;margin-bottom:-20px}#fxTutorialTitle{font-size:22px;margin-top:8px}#fxTutorialTitle,#fxTutorialTitle2{font-weight:300;color:#fff;margin-bottom:10px}#fxTutorialTitle2{font-size:20px;margin-top:20px}#fxTutorialTitle3{font-weight:300;font-size:12px;color:#fff;margin-top:290px;margin-bottom:-20px}#controlsContainer{max-width:400px;margin:auto;margin-top:0;margin-bottom:-40px}#masterControlDiv{margin-top:180px;margin-left:0;margin-bottom:0;max-width:1500px}#masterControlBadges,#masterControlBadgesSFX{margin-top:-16px;border-radius:6px;padding:8px;font-size:14px;font-weight:700;width:150px;border:2px solid transparent;box-shadow:0 8px 10px 1px rgba(0,0,0,.4);text-shadow:0 1px 2px rgba(0,0,0,.3)}#masterControlBadgesSFX{margin-bottom:0}#voice1SliderDiv,#voice6SliderDiv{width:100%;margin-top:40px}#sliders1,#sliders2,#sliders3,#sliders4,#sliders5{margin-top:20px}#sliders6{height:10px;width:250px;margin-top:16px}#ambienceBtnLocation{max-width:400px;margin:auto;margin-top:0;margin-bottom:0;margin-left:-6px}#ambienceBtns{width:140px;border-radius:4px;font-size:14px;font-weight:700;box-shadow:0 8px 10px 1px rgba(0,0,0,.4);text-shadow:0 1px 2px rgba(0,0,0,.3);margin-left:-1px}#tutorialContainer{max-width:500px;margin:auto;margin-top:10px;margin-bottom:10px;margin-left:-5px}#helpBtn1Div,#helpBtn2Div{width:50%;margin-top:0;margin-bottom:6px}#helpBtn3Div,#helpBtn4Div{width:50%;margin-top:6px}#ambienceBtn1Div,#ambienceBtn2Div{width:50%;margin-bottom:30px}#ambienceBtn3Div,#ambienceBtn4Div{width:50%;content:\"\\A\"}#ambienceBtn5Div,#ambienceBtn6Div{width:50%;margin-top:30px}#ambienceSlider{margin-top:18px}#ambienceBadges{font-size:22px;background-color:var(--main-time-color);color:#000}#exploreBtnId{margin-top:15px;height:40px;width:140px;border-radius:5px;font-size:18px;font-weight:700}input[type=range]{-webkit-appearance:none;height:6px;width:120px;border-radius:20px;margin:auto;border:0 dotted transparent;box-shadow:0 8px 10px 1px rgba(0,0,0,.2)}input[type=range]::-moz-range-track{-webkit-appearance:none;height:6px;width:120px;border-radius:20px;margin:auto;border:0 dotted transparent;box-shadow:0 8px 10px 1px rgba(0,0,0,.2)}input[type=range]::-webkit-slider-thumb{-webkit-appearance:none;position:relative;top:0;z-index:1;width:35px;height:35px;cursor:pointer;box-shadow:0 8px 10px 1px rgba(0,0,0,.6);border-radius:40px;border:0 dotted transparent}input[type=range]::-moz-range-thumb{position:relative;top:0;z-index:1;width:35px;height:35px;cursor:pointer;box-shadow:0 8px 10px 1px rgba(0,0,0,.6);border-radius:40px;border:0 dotted transparent}#mailingListText{margin:auto;max-width:300px;margin-top:10px;margin-bottom:6px;font-size:14px}#mce-EMAIL{font-size:12px;padding:4px 10px;margin-top:0;width:160px}#mc-embedded-subscribe,#mce-EMAIL{border-width:1px;border-radius:4px;background-color:transparent;border-color:#000}#mc-embedded-subscribe{width:100px;font-size:14px;padding:2px 10px;margin-top:8px;margin-bottom:-20px}}@media (min-width:350px) and (max-width:600px){#mainDiv{padding-right:0;padding-left:0;max-width:2000px;height:1000px}#optionsBucket{margin-top:5%}#enterContainer{margin-top:30px}#mobileBtn{margin-top:150px;border-width:2px;font-size:26px}#mobileBtn,#welcomeMobileText{font-weight:300;text-shadow:0 1px 2px rgba(0,0,0,.3)}#welcomeMobileText{margin-top:20px;color:#000;font-size:18px}#bell{color:var(--main-v1-color)}#enterFuncBtn{font-size:23px;height:200px;width:200px;border-radius:300px;margin-top:100px;text-shadow:0 1px 2px rgba(0,0,0,.3)}#welcomeBtn,#welcomeBtnAbout{height:50px;width:300px;margin-top:4px;margin-left:0;font-size:24px;border-color:#000;border-width:2px;border-radius:4px;background-color:transparent}#helpContainer,#helpContainerTutorial{max-width:235px;margin-top:20px}#aboutBtnID{font-size:14px}#aboutBtnID,#localStorageBtnID{width:80px;margin-top:0;border-radius:6px;font-weight:700;text-shadow:0 2px 4px rgba(0,0,0,.4)}#localStorageBtnID{font-size:16px}#aboutBtnID2{margin-top:-10px;border-radius:6px;padding:5px 8px;font-weight:300;text-shadow:0 2px 4px rgba(0,0,0,.4)}#aboutTxt{margin:auto;margin-top:32px;font-size:16px;text-align:left;color:#fff;text-shadow:0 2px 2px rgba(0,0,0,.2)}#shoutOut{font-size:14px}#disclaimerTxt{margin-top:20px;font-size:12px;text-shadow:0 2px 2px rgba(0,0,0,.2)}#aboutSectionVO{margin-top:-15px;margin-bottom:-20px;width:200px;border-radius:4px;font-size:18px;padding:5px 4px;box-shadow:0 8px 10px 1px rgba(0,0,0,.4);text-shadow:0 1px 2px rgba(0,0,0,.3)}#fxTitle{font-size:26px;margin-top:6px;margin-bottom:6px;text-shadow:0 1px 3px rgba(0,0,0,.5)}#fxTitle,#fxTitle2{font-weight:300;color:#fff}#fxTitle2{font-size:14px;margin-top:330px;margin-bottom:-30px}#fxTutorialTitle{font-size:22px;margin-top:8px}#fxTutorialTitle,#fxTutorialTitle2{font-weight:300;color:#fff;margin-bottom:10px}#fxTutorialTitle2{font-size:20px;margin-top:20px}#fxTutorialTitle3{font-weight:300;font-size:15px;color:#fff;margin-top:360px;margin-bottom:-30px}#controlsContainer{max-width:400px;margin:auto;margin-top:4px;margin-bottom:-50px}#masterControlDiv{margin-top:0;margin-bottom:0;max-width:1500px}#masterControlBadges{font-size:18px;font-weight:700;width:175px}#masterControlBadges,#masterControlBadgesSFX{border-radius:6px;padding:8px;border:2px solid transparent;box-shadow:0 8px 10px 1px rgba(0,0,0,.4);text-shadow:0 1px 2px rgba(0,0,0,.3)}#masterControlBadgesSFX{margin-top:-5px;font-size:22px;font-weight:500;width:200px}#voice1SliderDiv,#voice6SliderDiv{width:100%;margin-top:40px}#sliders1,#sliders2,#sliders3,#sliders4,#sliders5{margin-top:20px}#sliders6{height:10px;width:250px;margin-top:30px}#ambienceBtnLocation{max-width:400px;margin:auto;margin-top:0;margin-bottom:0;margin-left:-2px}#ambienceBtns{width:165px;border-radius:4px;font-size:18px;font-weight:700;margin-bottom:5px;margin-left:-2.5px;padding:8px 0;box-shadow:0 8px 10px 1px rgba(0,0,0,.4);text-shadow:0 1px 2px rgba(0,0,0,.3);text-align:center}#tutorialContainer{max-width:600px;margin:auto;margin-top:0;margin-bottom:0;margin-left:-2px}#helpBtn1Div,#helpBtn2Div{width:50%;margin-top:0;margin-bottom:10px}#helpBtn3Div,#helpBtn4Div{width:50%;margin-top:4px}#ambienceBtn1Div,#ambienceBtn2Div{margin-bottom:30px}#ambienceBtn1Div,#ambienceBtn2Div,#ambienceBtn3Div,#ambienceBtn4Div{width:50%;content:\"\\A\";white-space:pre}#ambienceBtn5Div,#ambienceBtn6Div{width:50%;content:\"\\A\";white-space:pre;margin-top:30px}#ambienceSlider{margin-top:20px;margin-left:5px}#ambienceBadges{font-size:22px;background-color:var(--main-time-color);color:#000}#exploreBtnId{margin-top:20px;height:40px;width:200px;border-radius:5px;font-size:22px;font-weight:500}input[type=range]{-webkit-appearance:none;height:10px;width:145px;border-radius:20px;margin:auto;border:0 dotted transparent;box-shadow:0 8px 10px 1px rgba(0,0,0,.2)}input[type=range]::-moz-range-track{-webkit-appearance:none;height:10px;width:145px;border-radius:20px;margin:auto;border:0 dotted transparent;box-shadow:0 8px 10px 1px rgba(0,0,0,.2)}input[type=range]::-webkit-slider-thumb{-webkit-appearance:none;position:relative;top:0;z-index:1;width:45px;height:45px;cursor:pointer;box-shadow:0 8px 10px 1px rgba(0,0,0,.6);border-radius:40px;border:0 dotted transparent}input[type=range]::-moz-range-thumb{position:relative;top:0;z-index:1;width:45px;height:45px;cursor:pointer;box-shadow:0 8px 10px 1px rgba(0,0,0,.6);border-radius:40px;border:0 dotted transparent}#mailingListText{margin:auto;max-width:300px;margin-top:10px;margin-bottom:6px;font-size:14px}#mce-EMAIL{margin-top:0;width:190px}#mc-embedded-subscribe,#mce-EMAIL{font-size:14px;padding:4px 10px;border-width:1px;border-radius:4px;background-color:transparent;border-color:#000}#mc-embedded-subscribe{width:120px;margin-top:8px;margin-bottom:-20px}}@media (min-width:601px) and (max-width:800px){#mainDiv{padding-right:0;padding-left:0;max-width:2000px;height:2000px}#optionsBucket{margin-top:15%}#enterContainer{margin-top:30px}#mobileBtn{margin-top:250px;border-width:2px;font-size:36px}#mobileBtn,#welcomeMobileText{font-weight:300;text-shadow:0 1px 2px rgba(0,0,0,.3)}#welcomeMobileText{max-width:500px;margin:auto;margin-top:20px;color:#000;font-size:26px}#bell{color:var(--main-v1-color)}#enterFuncBtn{font-size:35px;height:300px;width:300px;border-radius:300px;margin-top:180px;text-shadow:0 1px 2px rgba(0,0,0,.3)}#welcomeBtn{width:350px;margin-left:0;font-size:33px}#welcomeBtn,#welcomeBtnAbout{height:80px;margin-top:10px;border-color:#000;border-width:2px;border-radius:4px;background-color:transparent}#welcomeBtnAbout{width:704px;margin-left:-2px;font-size:40px}#helpContainer,#helpContainerTutorial{max-width:260px;margin-top:0}#aboutBtnID{font-size:16px}#aboutBtnID,#localStorageBtnID{height:50px;width:90px;margin-top:20px;border-radius:6px;font-weight:700;text-shadow:0 2px 4px rgba(0,0,0,.2)}#localStorageBtnID{font-size:18px}#aboutBtnID2{padding:5px 8px;font-weight:300;text-shadow:0 2px 4px rgba(0,0,0,.2)}#aboutPageID{margin-top:20%}#aboutTxt{max-width:720px;margin:auto;font-size:18px;text-align:left;color:#fff}#shoutOut{font-size:16px}#disclaimerTxt{margin-top:30px;font-size:14px}#aboutSectionVO{margin-top:-10px;margin-bottom:20px;width:220px;border-radius:6px;font-size:20px;font-weight:400;box-shadow:0 8px 10px 1px rgba(0,0,0,.4);text-shadow:0 1px 2px rgba(0,0,0,.3)}#fxTitle{font-size:45px;margin-top:80px;margin-bottom:4px;text-shadow:0 1px 3px rgba(0,0,0,.5)}#fxTitle,#fxTitle2{font-weight:300;color:#fff}#fxTitle2{font-size:14px;margin-top:330px;margin-bottom:-30px}#fxTutorialTitle{margin-top:20px;margin-bottom:0}#fxTutorialTitle,#fxTutorialTitle2{font-weight:300;font-size:35px;color:#fff}#fxTutorialTitle2{margin-top:30px;margin-bottom:10px}#fxTutorialTitle3{font-weight:300;font-size:25px;color:#fff;margin-top:320px;margin-bottom:-80px}#controlsContainer{max-width:1000px;margin:auto;margin-top:0;margin-bottom:50px}#masterControlDiv{margin-top:0;margin-left:0;margin-bottom:0}#masterControlBadges{margin-top:-10px;font-size:22px;font-weight:700}#masterControlBadges,#masterControlBadgesSFX{padding:8px 5px;width:220px;border:2px solid transparent;border-radius:5px;box-shadow:0 8px 10px 1px rgba(0,0,0,.4);text-shadow:0 1px 2px rgba(0,0,0,.3)}#masterControlBadgesSFX{margin-top:30px;margin-bottom:-14px;font-size:26px;font-weight:500}#masterTimingBadges{padding:8px;font-size:17px;font-weight:700;background-color:var(--main-time-color);color:#000;width:150px;border:2px solid transparent;border-radius:5px}#voice1SliderDiv{margin-top:100px;width:100%}#voice6SliderDiv{width:100%;margin-top:40px}#sliders6{margin-top:30px;width:220px}#ambienceBtnLocation{max-width:1000px;margin:auto;margin-top:0;margin-bottom:0}#ambienceBtns{width:220px;border-radius:6px;font-size:22px;font-weight:700;margin-top:20px;box-shadow:0 8px 10px 1px rgba(0,0,0,.4);text-shadow:0 1px 2px rgba(0,0,0,.3)}#tutorialContainer{max-width:500px;margin:auto;margin-top:0;margin-bottom:-80px}#helpBtn1Div,#helpBtn2Div,#helpBtn3Div,#helpBtn4Div{width:50%;margin-top:0}#ambienceBtn1Div,#ambienceBtn2Div,#ambienceBtn3Div{width:33%}#ambienceBtn4Div,#ambienceBtn5Div,#ambienceBtn6Div{width:33%;content:\"\\A\";white-space:pre;margin-top:30px}#ambienceSlider{margin-top:30px}#ambienceBadges{font-size:22px;background-color:var(--main-time-color);color:#000}#exploreBtnId{margin-top:32px;height:50px;width:220px;border-radius:5px;font-size:22px;font-weight:700}input[type=range]{-webkit-appearance:none;height:10px;width:180px;border-radius:20px;margin:auto;border:0 dotted transparent;box-shadow:0 8px 10px 1px rgba(0,0,0,.2)}input[type=range]::-moz-range-track{-webkit-appearance:none;height:10px;width:180px;border-radius:20px;margin:auto;border:0 dotted transparent;box-shadow:0 8px 10px 1px rgba(0,0,0,.2)}input[type=range]::-webkit-slider-thumb{-webkit-appearance:none;position:relative;top:0;z-index:1;width:50px;height:50px;cursor:pointer;box-shadow:0 8px 10px 1px rgba(0,0,0,.6);border-radius:40px;border:0 dotted transparent}input[type=range]::-moz-range-thumb{position:relative;top:0;z-index:1;width:50px;height:50px;cursor:pointer;box-shadow:0 8px 10px 1px rgba(0,0,0,.6);border-radius:40px;border:0 dotted transparent}#mailingListText{margin-top:20px;margin-bottom:0;font-size:18px}#mce-EMAIL{margin-top:0;width:250px}#mc-embedded-subscribe,#mce-EMAIL{font-size:16px;padding:4px 10px;border-width:1px;border-radius:6px;background-color:transparent;border-color:#000}#mc-embedded-subscribe{margin-top:6px}}@media (min-width:801px) and (max-width:1024px){#mainDiv{padding-right:0;padding-left:0;max-width:2000px;height:1500px}#optionsBucket{margin-top:15%}#enterContainer{margin-top:30px}#mobileBtn{margin-top:250px;border-width:2px;font-size:36px}#mobileBtn,#welcomeMobileText{font-weight:300;text-shadow:0 1px 2px rgba(0,0,0,.3)}#welcomeMobileText{max-width:500px;margin:auto;margin-top:20px;color:#000;font-size:26px}#bell{color:var(--main-v1-color)}#enterFuncBtn{font-size:50px;height:400px;width:400px;border-radius:400px;margin-top:230px;text-shadow:0 1px 2px rgba(0,0,0,.3)}#welcomeBtn{width:450px;margin-left:0}#welcomeBtn,#welcomeBtnAbout{height:100px;margin-top:10px;font-size:45px;border-color:#000;border-width:2px;border-radius:4px;background-color:transparent}#welcomeBtnAbout{width:904px;margin-left:-2px}#helpContainer{max-width:368px;margin-top:0}#helpContainerTutorial{max-width:366px;margin-top:0}#aboutBtnID{font-size:22px}#aboutBtnID,#localStorageBtnID{height:60px;width:115px;margin-top:25px;border-radius:6px;font-weight:700;text-shadow:0 2px 4px rgba(0,0,0,.2)}#localStorageBtnID{font-size:24px}#aboutBtnID2{padding:5px 8px;font-weight:300;text-shadow:0 2px 4px rgba(0,0,0,.2)}#aboutPageID{margin-top:20%}#aboutTxt{max-width:720px;margin:auto;font-size:18px;text-align:left;color:#fff}#shoutOut{font-size:16px}#disclaimerTxt{margin-top:30px;font-size:14px}#aboutSectionVO{margin-top:-10px;margin-bottom:20px;width:220px;border-radius:6px;font-size:20px;font-weight:400;box-shadow:0 8px 10px 1px rgba(0,0,0,.4);text-shadow:0 1px 2px rgba(0,0,0,.3)}#fxTitle{font-size:55px;margin-top:160px;margin-bottom:4px;text-shadow:0 1px 3px rgba(0,0,0,.5)}#fxTitle,#fxTitle2{font-weight:300;color:#fff}#fxTitle2{font-size:14px;margin-top:330px;margin-bottom:-30px}#fxTutorialTitle{margin-top:20px;margin-bottom:0}#fxTutorialTitle,#fxTutorialTitle2{font-weight:300;font-size:35px;color:#fff}#fxTutorialTitle2{margin-top:30px;margin-bottom:10px}#fxTutorialTitle3{font-weight:300;font-size:30px;color:#fff;margin-top:380px;margin-bottom:-60px}#controlsContainer{max-width:1000px;margin:auto;margin-top:0;margin-bottom:50px}#masterControlDiv{margin-top:0;margin-left:0;margin-bottom:0}#masterControlBadges{margin-top:-20px;font-size:26px;font-weight:700}#masterControlBadges,#masterControlBadgesSFX{padding:8px 5px;width:300px;border:2px solid transparent;border-radius:5px;box-shadow:0 8px 10px 1px rgba(0,0,0,.4);text-shadow:0 1px 2px rgba(0,0,0,.3)}#masterControlBadgesSFX{margin-top:30px;margin-bottom:-14px;font-size:32px;font-weight:500}#masterTimingBadges{padding:8px;font-size:17px;font-weight:700;background-color:var(--main-time-color);color:#000;width:150px;border:2px solid transparent;border-radius:5px}#voice1SliderDiv{margin-top:100px;width:100%}#voice6SliderDiv{width:100%;margin-top:40px}#sliders6{margin-top:30px;width:300px}#ambienceBtnLocation{max-width:1000px;margin:auto;margin-top:0;margin-bottom:0}#ambienceBtns{width:300px;height:70px;border-radius:6px;font-size:30px;font-weight:700;margin-top:20px;box-shadow:0 8px 10px 1px rgba(0,0,0,.4);text-shadow:0 1px 2px rgba(0,0,0,.3)}#tutorialContainer{max-width:700px;margin:auto;margin-top:0;margin-bottom:-80px}#helpBtn1Div,#helpBtn2Div,#helpBtn3Div,#helpBtn4Div{width:50%;margin-top:0}#ambienceBtn1Div,#ambienceBtn2Div,#ambienceBtn3Div{width:33%}#ambienceBtn4Div,#ambienceBtn5Div,#ambienceBtn6Div{width:33%;content:\"\\A\";white-space:pre;margin-top:50px}#ambienceSlider{margin-top:30px}#ambienceBadges{font-size:22px;background-color:var(--main-time-color);color:#000}#exploreBtnId{margin-top:40px;height:60px;width:300px;border-radius:5px;font-size:26px;font-weight:700}input[type=range]{-webkit-appearance:none;height:10px;width:180px;border-radius:20px;margin:auto;border:0 dotted transparent;box-shadow:0 8px 10px 1px rgba(0,0,0,.2)}input[type=range]::-moz-range-track{-webkit-appearance:none;height:10px;width:180px;border-radius:20px;margin:auto;border:0 dotted transparent;box-shadow:0 8px 10px 1px rgba(0,0,0,.2)}input[type=range]::-webkit-slider-thumb{-webkit-appearance:none;position:relative;top:0;z-index:1;width:50px;height:50px;cursor:pointer;box-shadow:0 8px 10px 1px rgba(0,0,0,.6);border-radius:40px;border:0 dotted transparent}input[type=range]::-moz-range-thumb{position:relative;top:0;z-index:1;width:50px;height:50px;cursor:pointer;box-shadow:0 8px 10px 1px rgba(0,0,0,.6);border-radius:40px;border:0 dotted transparent}#mailingListText{margin-top:20px;margin-bottom:0;font-size:18px}#mce-EMAIL{margin-top:0;width:250px}#mc-embedded-subscribe,#mce-EMAIL{font-size:16px;padding:4px 10px;border-width:1px;border-radius:6px;background-color:transparent;border-color:#000}#mc-embedded-subscribe{margin-top:6px}}@media (min-width:1025px) and (max-width:1369px){#mainDiv{padding-right:0;padding-left:0;max-width:4000px;height:2500px}#controlsContainer{max-width:1400px;margin-top:6%}#visualToggleContainer{margin-top:20px}#visualToggle{font-size:20px}@media (max-height:549px){#optionsBucket{margin-top:.25%}#enterContainer{margin-top:140px}#controlsContainerTutorial{max-width:1400px;margin-top:-10px}#fxTitleTutorial{font-weight:700;font-size:32px;color:#fff;margin-top:30px}#aboutPageID{margin-top:30px}#welcomeBtnVoice{height:45px;width:807px;margin-top:15px;margin-left:-4px;font-size:22px;border-color:#000;border-width:2px;border-radius:4px;background-color:transparent}#welcomeBtn{width:400px;margin-left:3px}#welcomeBtn,#welcomeBtnAbout{height:65px;margin-top:8px;font-size:34px;border-color:#000;border-width:2px;border-radius:4px;background-color:transparent}#welcomeBtnAbout{width:807px;margin-left:-1px}}@media (min-height:550px) and (max-height:600px){#optionsBucket{margin-top:.25%}#enterContainer{margin-top:160px}#controlsContainerTutorial{max-width:1400px;margin-top:-10px}#fxTitleTutorial{font-weight:700;font-size:32px;color:#fff;margin-top:30px}#aboutPageID{margin-top:30px}#welcomeBtnVoice{height:45px;width:807px;margin-top:15px;margin-left:-4px;font-size:22px;border-color:#000;border-width:2px;border-radius:4px;background-color:transparent}#welcomeBtn{width:400px;margin-left:3px}#welcomeBtn,#welcomeBtnAbout{height:70px;margin-top:8px;font-size:38px;border-color:#000;border-width:2px;border-radius:4px;background-color:transparent}#welcomeBtnAbout{width:807px;margin-left:-1px}}@media (min-height:601px) and (max-height:649px){#optionsBucket{margin-top:0}#enterContainer{margin-top:180px}#controlsContainerTutorial{max-width:1400px;margin-top:-10px}#fxTitleTutorial{font-weight:700;font-size:32px;color:#fff;margin-top:30px}#aboutPageID{margin-top:30px}#welcomeBtnVoice{height:50px;width:908px;margin-top:15px;margin-left:-4px;font-size:26px;border-color:#000;border-width:2px;border-radius:4px;background-color:transparent}#welcomeBtn{width:450px;margin-left:3px}#welcomeBtn,#welcomeBtnAbout{height:80px;margin-top:8px;font-size:42px;border-color:#000;border-width:2px;border-radius:4px;background-color:transparent}#welcomeBtnAbout{width:907px;margin-left:0}}@media (min-height:650px) and (max-height:700px){#optionsBucket{margin-top:.5%}#enterContainer{margin-top:200px}#controlsContainerTutorial{max-width:1400px;margin-top:-10px}#fxTitleTutorial{font-weight:700;font-size:32px;color:#fff;margin-top:30px}#aboutPageID{margin-top:30px}#welcomeBtnVoice{height:50px;width:908px;margin-top:15px;margin-left:-4px;font-size:24px;border-color:#000;border-width:2px;border-radius:4px;background-color:transparent}#welcomeBtn{width:450px;margin-left:4px}#welcomeBtn,#welcomeBtnAbout{height:75px;margin-top:8px;font-size:38px;border-color:#000;border-width:2px;border-radius:4px;background-color:transparent}#welcomeBtnAbout{width:908px;margin-left:0}}@media (min-height:701px) and (max-height:749px){#optionsBucket{margin-top:.75%}#enterContainer{margin-top:220px}#controlsContainerTutorial{max-width:1400px;margin-top:-10px}#fxTitleTutorial{font-weight:700;font-size:32px;color:#fff;margin-top:30px}#aboutPageID{margin-top:50px}#welcomeBtnVoice{height:50px;width:908px;margin-top:15px;margin-left:-4px;font-size:26px;border-color:#000;border-width:2px;border-radius:4px;background-color:transparent}#welcomeBtn{width:450px;margin-left:4px}#welcomeBtn,#welcomeBtnAbout{height:90px;margin-top:8px;font-size:42px;border-color:#000;border-width:2px;border-radius:4px;background-color:transparent}#welcomeBtnAbout{width:908px;margin-left:0}}@media (min-height:750px) and (max-height:800px){#optionsBucket{margin-top:1.75%}#enterContainer{margin-top:240px}#controlsContainerTutorial{max-width:1400px;margin-top:-10px}#fxTitleTutorial{margin-top:20px}#aboutPageID{margin-top:70px}#welcomeBtnVoice{height:50px;width:908px;margin-top:15px;margin-left:-4px;font-size:26px;border-color:#000;border-width:2px;border-radius:4px;background-color:transparent}#welcomeBtn{width:450px;margin-left:4px}#welcomeBtn,#welcomeBtnAbout{height:90px;margin-top:8px;font-size:42px;border-color:#000;border-width:2px;border-radius:4px;background-color:transparent}#welcomeBtnAbout{width:908px;margin-left:0}}@media (min-height:801px) and (max-height:849px){#optionsBucket{margin-top:3%}#enterContainer{margin-top:240px}#controlsContainerTutorial{max-width:1400px;margin-top:-10px}#fxTitleTutorial{font-weight:700;font-size:32px;color:#fff;margin-top:30px}#aboutPageID{margin-top:90px}#welcomeBtnVoice{height:50px;width:908px;margin-top:15px;margin-left:-4px;font-size:26px;border-color:#000;border-width:2px;border-radius:4px;background-color:transparent}#welcomeBtn{width:450px;margin-left:4px}#welcomeBtn,#welcomeBtnAbout{height:90px;margin-top:8px;font-size:42px;border-color:#000;border-width:2px;border-radius:4px;background-color:transparent}#welcomeBtnAbout{width:908px;margin-left:0}}@media (min-height:850px) and (max-height:900px){#optionsBucket{margin-top:1.5%}#enterContainer{margin-top:300px}#controlsContainerTutorial{max-width:1400px;margin-top:-50px}#fxTitleTutorial{font-weight:700;font-size:32px;color:#fff;margin-top:70px}#aboutPageID{margin-top:120px}#welcomeBtnVoice{height:50px;width:1014px;margin-top:15px;margin-left:8px;font-size:26px;border-color:#000;border-width:2px;border-radius:4px;background-color:transparent}#welcomeBtn{width:500px;margin-left:10px}#welcomeBtn,#welcomeBtnAbout{height:100px;margin-top:15px;font-size:45px;border-color:#000;border-width:2px;border-radius:4px;background-color:transparent}#welcomeBtnAbout{width:1014px;margin-left:8px}}@media (min-height:901px) and (max-height:949px){#optionsBucket{margin-top:2%}#enterContainer{margin-top:300px}#controlsContainerTutorial{max-width:1400px;margin-top:-80px}#fxTitleTutorial{margin-top:30px}#aboutPageID{margin-top:140px}#welcomeBtnVoice{height:50px;width:1014px;margin-top:15px;margin-left:8px;font-size:26px;border-color:#000;border-width:2px;border-radius:4px;background-color:transparent}#welcomeBtn{width:500px;margin-left:10px}#welcomeBtn,#welcomeBtnAbout{height:100px;margin-top:15px;font-size:45px;border-color:#000;border-width:2px;border-radius:4px;background-color:transparent}#welcomeBtnAbout{width:1014px;margin-left:8px}}@media (min-height:950px) and (max-height:1000px){#optionsBucket{margin-top:4%}#enterContainer{margin-top:300px}#controlsContainerTutorial{max-width:1400px;margin-top:-100px}#fxTitleTutorial{font-weight:700;font-size:32px;color:#fff;margin-top:120px}#aboutPageID{margin-top:200px}#welcomeBtnVoice{height:50px;width:1014px;margin-top:15px;margin-left:8px;font-size:26px;border-color:#000;border-width:2px;border-radius:4px;background-color:transparent}#welcomeBtn{width:500px;margin-left:10px}#welcomeBtn,#welcomeBtnAbout{height:100px;margin-top:15px;font-size:45px;border-color:#000;border-width:2px;border-radius:4px;background-color:transparent}#welcomeBtnAbout{width:1014px;margin-left:8px}}@media (min-height:1001px) and (max-height:1100px){#optionsBucket{margin-top:5%}#enterContainer{margin-top:320px}#controlsContainerTutorial{max-width:1400px;margin-top:-120px}#fxTitleTutorial{font-weight:700;font-size:32px;color:#fff;margin-top:160px}#aboutPageID{margin-top:15%}#welcomeBtnVoice{height:50px;width:1014px;margin-top:15px;margin-left:8px;font-size:26px;border-color:#000;border-width:2px;border-radius:4px;background-color:transparent}#welcomeBtn{width:500px;margin-left:10px}#welcomeBtn,#welcomeBtnAbout{height:100px;margin-top:15px;font-size:45px;border-color:#000;border-width:2px;border-radius:4px;background-color:transparent}#welcomeBtnAbout{width:1014px;margin-left:8px}}@media (min-height:1101px){#optionsBucket{margin-top:5%}#enterContainer{margin-top:320px}#controlsContainerTutorial{max-width:1400px;margin-top:-120px}#fxTitleTutorial{font-weight:700;font-size:32px;color:#fff;margin-top:160px}#aboutPageID{margin-top:15%}#welcomeBtnVoice{height:50px;width:1014px;margin-top:15px;margin-left:8px;font-size:26px;border-color:#000;border-width:2px;border-radius:4px;background-color:transparent}#welcomeBtn{width:500px;margin-left:10px}#welcomeBtn,#welcomeBtnAbout{height:100px;margin-top:15px;font-size:45px;border-color:#000;border-width:2px;border-radius:4px;background-color:transparent}#welcomeBtnAbout{width:1014px;margin-left:8px}}#welcomeInfoText{margin-top:50px;font-size:30px;color:#000;font-weight:700}#welcomeMobileText{color:#000;font-size:18px;font-weight:700}#bell{color:var(--main-v1-color)}#enterFuncBtn{font-size:48px;height:350px;width:350px;border-radius:300px;text-shadow:0 1px 2px rgba(0,0,0,.3)}#helpContainer,#helpContainerTutorial{max-width:350px;margin-top:30px}#aboutBtnID,#localStorageBtnID{height:45px;width:125px;border-radius:5px;font-size:22px;font-weight:400}#aboutBtnID2{margin-top:20px;padding:2px 5px;font-weight:300;text-shadow:0 2px 4px rgba(0,0,0,.4)}#aboutTxt{max-width:1050px;margin:auto;font-size:22px;text-align:left;color:#fff;text-shadow:0 .5px .5px rgba(0,0,0,.2)}#shoutOut{font-size:20px}#disclaimerTxt{margin-top:30px;font-size:16px;text-shadow:0 .5px .5px rgba(0,0,0,.1)}#aboutSectionVO{margin-top:20px;margin-bottom:26px;width:260px;border-radius:4px;font-size:22px;font-weight:400;box-shadow:0 8px 10px 1px rgba(0,0,0,.4);text-shadow:0 1px 2px rgba(0,0,0,.4)}#fxTitle{font-weight:300;font-size:46px;color:#fff;margin-top:40px;margin-bottom:20px;text-shadow:0 1px 5px rgba(0,0,0,.4)}#soundscapeTitleBreak{white-space:pre;content:\"\\A\"}#fxTitle2{font-size:38px;margin-top:300px;margin-bottom:10px}#fxTitle2,#fxTutorialTitle{font-weight:300;color:#fff;text-shadow:0 1px 5px rgba(0,0,0,.4)}#fxTutorialTitle{font-size:40px;margin-top:0;margin-bottom:0}#fxTutorialTitle2{font-size:38px;margin-top:140px}#fxTutorialTitle2,#fxTutorialTitle3{font-weight:300;color:#fff;margin-bottom:20px;text-shadow:0 1px 5px rgba(0,0,0,.4)}#fxTutorialTitle3{font-size:30px;margin-top:280px}#masterControlDiv{max-width:1000px;margin:auto;margin-top:0;margin-bottom:0}#masterControlBadges{border-radius:4px;border:2px solid transparent}#masterControlBadges,#masterControlBadgesSFX{padding:8px 4px;font-size:24px;font-weight:400;width:300px;box-shadow:0 8px 10px 1px rgba(0,0,0,.4);text-shadow:0 1px 1px rgba(0,0,0,.2)}#masterControlBadgesSFX{border-radius:4px;margin-top:0}#voice1SliderDiv,#voice2SliderDiv,#voice3SliderDiv{margin-top:10px;width:33%}#voice4SliderDiv,#voice5SliderDiv,#voice6SliderDiv{width:33%;margin-top:30px}#voice6SliderDiv{white-space:pre;content:\"\\A\"}#sliders1,#sliders2,#sliders3,#sliders4,#sliders5,#sliders6{margin-top:30px}#ambienceBtnLocation{max-width:1000px;margin:auto;margin-top:0;margin-bottom:0}#ambienceBtns{width:300px;border-radius:4px;font-size:26px;font-weight:400;box-shadow:0 8px 10px 1px rgba(0,0,0,.4);text-shadow:0 1px 2px rgba(0,0,0,.4)}#tutorialContainer{max-width:1000px;margin:auto;margin-top:10px;margin-bottom:-60px}#helpBtn1Div,#helpBtn2Div{width:50%;content:\"\\A\";white-space:pre}#helpBtn3Div,#helpBtn4Div{width:50%;content:\"\\A\";white-space:pre;margin-top:20px}#ambienceBtn1Div,#ambienceBtn2Div,#ambienceBtn3Div{width:33%;content:\"\\A\"}#ambienceBtn4Div,#ambienceBtn5Div,#ambienceBtn6Div{width:33%;content:\"\\A\";white-space:pre;margin-top:40px}#ambienceSlider{margin-top:30px}#ambienceBadges{font-size:22px;background-color:var(--main-time-color);color:#000}#exploreBtnId{height:45px}#exploreBtnId,#speechList{margin-top:80px;width:300px;border-radius:5px;font-size:22px;font-weight:400}#speechList{height:40px;padding:0}#voiceCommandListID{max-width:750px;margin:auto;border-radius:10px;margin-top:20px;box-shadow:0 8px 10px 1px rgba(0,0,0,.4)}#voiceControlListTitle{padding-top:5px;font-size:30px;text-shadow:0 2px 4px rgba(0,0,0,.4)}#voiceControlListTxt{font-size:20px;text-shadow:0 1px 2px rgba(0,0,0,.4);padding-bottom:10px}#speechEngage{margin-top:15px;margin-left:60px;font-size:60px}#speechEngageActivated{margin-top:15px;margin-left:68px;font-size:60px}#VUIformInputDivID{max-width:650px;margin:center;margin-bottom:-75px}#inlineFormInputGroupUsername2{margin:auto;margin-top:20px;margin-left:80px;text-align:center;font-size:25px;width:500px;height:50px;border-radius:20px;box-shadow:0 8px 10px 1px rgba(0,0,0,.3);text-shadow:0 1px 2px rgba(0,0,0,.2)}input[type=range]{-webkit-appearance:none;height:10px;width:180px;border-radius:20px;margin:auto;border:0 dotted transparent;box-shadow:0 4px 10px 1px rgba(0,0,0,.3)}input[type=range]::-moz-range-track{-webkit-appearance:none;height:10px;width:180px;border-radius:20px;margin:auto;border:0 dotted transparent;box-shadow:0 4px 10px 1px rgba(0,0,0,.3)}input[type=range]::-webkit-slider-thumb{-webkit-appearance:none;position:relative;top:0;z-index:1;width:40px;height:40px;cursor:pointer;box-shadow:0 8px 10px 1px rgba(0,0,0,.6);border-radius:40px;border:0 dotted transparent}input[type=range]::-moz-range-thumb{position:relative;top:0;z-index:1;width:40px;height:40px;cursor:pointer;box-shadow:0 8px 10px 1px rgba(0,0,0,.6);border-radius:40px;border:0 dotted transparent}#mailingListText{margin:auto;margin-top:30px;margin-bottom:0;font-size:20px}#mc_embed_signup{background:#fff;font-size:16px;width:100%;border-color:#000;background-color:transparent;text-shadow:0 .5px .5px rgba(0,0,0,.2)}#mce-EMAIL{margin-top:0;width:250px}#mc-embedded-subscribe,#mce-EMAIL{font-size:18px;padding:4px 10px;border-width:1px;border-radius:6px;background-color:transparent;border-color:#000;text-shadow:0 .5px .5px rgba(0,0,0,.2)}#mc-embedded-subscribe{margin-top:4px}}@media (min-width:1370px){#mainDiv{padding-right:0;padding-left:0;max-width:4000px;height:2200px}#lineBreak{white-space:pre;content:\"/A\"}#visualToggleContainer{margin-top:20px}#visualToggle{font-size:20px}@media (max-height:549px){#optionsBucket{margin-top:.25%}#enterContainer{margin-top:80px}#controlsContainer{max-width:1400px;margin-top:70px}#controlsContainerTutorial{max-width:1400px;margin-top:-10px}#fxTitleTutorial{margin-top:20px;margin-bottom:40px}#aboutPageID{margin-top:10px}#welcomeBtnVoice{height:45px;width:807px;margin-top:15px;margin-left:-2px;font-size:22px;border-color:#000;border-width:2px;border-radius:4px;background-color:transparent}#welcomeBtn{width:400px;margin-left:3px}#welcomeBtn,#welcomeBtnAbout{height:65px;margin-top:8px;font-size:34px;border-color:#000;border-width:2px;border-radius:4px;background-color:transparent}#welcomeBtnAbout{width:807px;margin-left:-1px}}@media (min-height:550px) and (max-height:600px){#optionsBucket{margin-top:.25%}#enterContainer{margin-top:120px}#controlsContainer{max-width:1400px;margin-top:80px}#controlsContainerTutorial{max-width:1400px;margin-top:-10px}#fxTitleTutorial{margin-top:20px;margin-bottom:40px}#aboutPageID{margin-top:10px}#welcomeBtnVoice{height:45px;width:807px;margin-top:15px;margin-left:-2px;font-size:22px;border-color:#000;border-width:2px;border-radius:4px;background-color:transparent}#welcomeBtn{width:400px;margin-left:3px}#welcomeBtn,#welcomeBtnAbout{height:70px;margin-top:8px;font-size:38px;border-color:#000;border-width:2px;border-radius:4px;background-color:transparent}#welcomeBtnAbout{width:807px;margin-left:-1px}}@media (min-height:601px) and (max-height:649px){#optionsBucket{margin-top:0}#enterContainer{margin-top:140px}#controlsContainer{max-width:1400px;margin-top:90px;margin-bottom:0}#controlsContainerTutorial{max-width:1400px;margin-top:-30px}#fxTitleTutorial{margin-top:20px;margin-bottom:60px}#aboutPageID{margin-top:10px}#welcomeBtnVoice{height:45px;width:907px;margin-top:15px;margin-left:-4px;font-size:22px;border-color:#000;border-width:2px;border-radius:4px;background-color:transparent}#welcomeBtn{width:450px;margin-left:3px}#welcomeBtn,#welcomeBtnAbout{height:80px;margin-top:8px;font-size:42px;border-color:#000;border-width:2px;border-radius:4px;background-color:transparent}#welcomeBtnAbout{width:907px;margin-left:0}}@media (min-height:650px) and (max-height:700px){#optionsBucket{margin-top:0}#enterContainer{margin-top:160px}#controlsContainer{max-width:1400px;margin-top:100px}#controlsContainerTutorial{max-width:1400px;margin-top:-50px}#fxTitleTutorial{margin-top:20px;margin-bottom:80px}#aboutPageID{margin-top:10px}#welcomeBtnVoice{height:50px;width:908px;margin-top:15px;margin-left:-4px;font-size:26px;border-color:#000;border-width:2px;border-radius:4px;background-color:transparent}#welcomeBtn{width:450px;margin-left:4px}#welcomeBtn,#welcomeBtnAbout{height:90px;margin-top:8px;font-size:42px;border-color:#000;border-width:2px;border-radius:4px;background-color:transparent}#welcomeBtnAbout{width:908px;margin-left:0}}@media (min-height:701px) and (max-height:749px){#optionsBucket{margin-top:.75%}#enterContainer{margin-top:200px}#controlsContainer{max-width:1400px;margin-top:120px}#controlsContainerTutorial{max-width:1400px;margin-top:-70px}#fxTitleTutorial{margin-top:20px;margin-bottom:100px}#aboutPageID{margin-top:40px}#welcomeBtnVoice{height:50px;width:908px;margin-top:15px;margin-left:-4px;font-size:26px;border-color:#000;border-width:2px;border-radius:4px;background-color:transparent}#welcomeBtn{width:450px;margin-left:4px}#welcomeBtn,#welcomeBtnAbout{height:90px;margin-top:8px;font-size:42px;border-color:#000;border-width:2px;border-radius:4px;background-color:transparent}#welcomeBtnAbout{width:908px;margin-left:0}}@media (min-height:750px) and (max-height:800px){#optionsBucket{margin-top:.5%}#enterContainer{margin-top:220px}#controlsContainer{max-width:1500px;margin-top:140px}#controlsContainerTutorial{max-width:1400px;margin-top:-80px}#fxTitleTutorial{margin-top:20px;margin-bottom:120px}#aboutPageID{margin-top:8%}#welcomeBtnVoice{height:50px;width:908px;margin-top:15px;margin-left:-4px;font-size:26px;border-color:#000;border-width:2px;border-radius:4px;background-color:transparent}#welcomeBtn{width:450px;margin-left:4px}#welcomeBtn,#welcomeBtnAbout{height:90px;margin-top:8px;font-size:42px;border-color:#000;border-width:2px;border-radius:4px;background-color:transparent}#welcomeBtnAbout{width:908px;margin-left:0}}@media (min-height:801px) and (max-height:849px){#optionsBucket{margin-top:3%}#enterContainer{margin-top:240px}#controlsContainer{max-width:1400px;margin-top:160px}#controlsContainerTutorial{max-width:1400px;margin-top:-80px}#fxTitleTutorial{margin-top:20px;margin-bottom:130px}#aboutPageID{margin-top:80px}#welcomeBtnVoice{height:50px;width:908px;margin-top:15px;margin-left:-4px;font-size:26px;border-color:#000;border-width:2px;border-radius:4px;background-color:transparent}#welcomeBtn{width:450px;margin-left:4px}#welcomeBtn,#welcomeBtnAbout{height:90px;margin-top:8px;font-size:42px;border-color:#000;border-width:2px;border-radius:4px;background-color:transparent}#welcomeBtnAbout{width:908px;margin-left:0}}@media (min-height:850px) and (max-height:900px){#optionsBucket{margin-top:1%}#enterContainer{margin-top:260px}#controlsContainer{max-width:1400px;margin-top:190px}#controlsContainerTutorial{max-width:1400px;margin-top:-100px}#fxTitleTutorial{margin-top:20px;margin-bottom:130px}#aboutPageID{margin-top:120px}#welcomeBtnVoice{height:50px;width:1014px;margin-top:15px;margin-left:8px;font-size:26px;border-color:#000;border-width:2px;border-radius:4px;background-color:transparent}#welcomeBtn{width:500px;margin-left:10px}#welcomeBtn,#welcomeBtnAbout{height:100px;margin-top:15px;font-size:45px;border-color:#000;border-width:2px;border-radius:4px;background-color:transparent}#welcomeBtnAbout{width:1014px;margin-left:8px}}@media (min-height:901px) and (max-height:949px){#optionsBucket{margin-top:1%}#enterContainer{margin-top:280px}#controlsContainer{max-width:1600px;margin-top:200px}#controlsContainerTutorial{max-width:1400px;margin-top:0}#fxTitleTutorial{margin-top:40px;margin-bottom:50px}#aboutPageID{margin-top:10%}#welcomeBtnVoice{height:50px;width:1014px;margin-top:15px;margin-left:8px;font-size:26px;border-color:#000;border-width:2px;border-radius:4px;background-color:transparent}#welcomeBtn{width:500px;margin-left:10px}#welcomeBtn,#welcomeBtnAbout{height:100px;margin-top:15px;font-size:45px;border-color:#000;border-width:2px;border-radius:4px;background-color:transparent}#welcomeBtnAbout{width:1014px;margin-left:8px}}@media (min-height:950px) and (max-height:1000px){#optionsBucket{margin-top:4%}#enterContainer{margin-top:300px}#controlsContainer{max-width:1400px;margin-top:250px}#controlsContainerTutorial{max-width:1400px;margin-top:0}#fxTitleTutorial{margin-top:80px;margin-bottom:50px}#helpContainer{margin-top:0}#aboutPageID{margin-top:12%}#welcomeBtnVoice{height:50px;width:1014px;margin-top:15px;margin-left:8px;font-size:26px;border-color:#000;border-width:2px;border-radius:4px;background-color:transparent}#welcomeBtn{width:500px;margin-left:10px}#welcomeBtn,#welcomeBtnAbout{height:100px;margin-top:15px;font-size:45px;border-color:#000;border-width:2px;border-radius:4px;background-color:transparent}#welcomeBtnAbout{width:1014px;margin-left:8px}}@media (min-height:1001px) and (max-height:1100px){#optionsBucket{margin-top:4%}#enterContainer{margin-top:320px}#controlsContainer{max-width:1400px;margin-top:260px}#controlsContainerTutorial{max-width:1400px;margin-top:100px}#fxTitleTutorial{margin-top:140px;margin-bottom:50px}#helpContainer{margin-top:0}#aboutPageID{margin-top:13%}#welcomeBtnVoice{height:50px;width:1014px;margin-top:15px;margin-left:8px;font-size:26px;border-color:#000;border-width:2px;border-radius:4px;background-color:transparent}#welcomeBtn{width:500px;margin-left:10px}#welcomeBtn,#welcomeBtnAbout{height:100px;margin-top:15px;font-size:45px;border-color:#000;border-width:2px;border-radius:4px;background-color:transparent}#welcomeBtnAbout{width:1014px;margin-left:8px}}@media (min-height:1101px){#optionsBucket{margin-top:6%}#enterContainer{margin-top:340px}#controlsContainer{max-width:1400px;margin-top:270px}#controlsContainerTutorial{max-width:1400px;margin-top:0}#fxTitleTutorial{margin-top:20px;margin-bottom:50px}#helpContainer{margin-top:0}#aboutPageID{margin-top:13%}#welcomeBtnVoice{height:50px;width:1014px;margin-top:15px;margin-left:8px;font-size:26px;border-color:#000;border-width:2px;border-radius:4px;background-color:transparent}#welcomeBtn{width:500px;margin-left:10px}#welcomeBtn,#welcomeBtnAbout{height:100px;margin-top:15px;font-size:45px;border-color:#000;border-width:2px;border-radius:4px;background-color:transparent}#welcomeBtnAbout{width:1014px;margin-left:8px}}#welcomeInfoText{margin-top:50px;font-size:30px;color:#000;font-weight:700}#welcomeMobileText{color:#000;font-size:18px;font-weight:700}#bell{color:var(--main-v1-color)}#enterFuncBtn{font-size:45px;height:350px;width:350px;border-radius:300px;text-shadow:0 1px 2px rgba(0,0,0,.3)}#helpContainer{max-width:350px;margin-top:30px}#helpContainerTutorial{max-width:360px;margin-top:30px}#aboutBtnID,#localStorageBtnID{height:45px;width:125px;border-radius:5px;font-size:22px;font-weight:400;padding:4px}#aboutBtnID2{margin-top:20px;padding:2px 5px;font-weight:300;text-shadow:0 2px 4px rgba(0,0,0,.4)}#aboutTxt{max-width:1050px;margin:auto;font-size:22px;text-align:left;color:#fff;text-shadow:0 .5px .5px rgba(0,0,0,.2)}#shoutOut{font-size:20px}#disclaimerTxt{margin-top:30px;font-size:16px;text-shadow:0 .5px .5px rgba(0,0,0,.1)}#aboutSectionVO{margin-top:20px;margin-bottom:28px;width:260px;border-radius:5px;font-size:22px;font-weight:400;box-shadow:0 8px 10px 1px rgba(0,0,0,.4);text-shadow:0 1px 2px rgba(0,0,0,.4)}@media (max-height:800px){#fxTitle{font-weight:300;font-size:40px;color:#fff;margin-top:0;margin-bottom:20px;text-shadow:0 1px 5px rgba(0,0,0,.4)}}@media (min-height:801px){#fxTitle{font-weight:300;font-size:40px;color:#fff;margin-top:0;margin-bottom:20px;text-shadow:0 1px 5px rgba(0,0,0,.4)}}#fxTitle2{font-weight:300;font-size:38px;color:#fff;margin-top:0;margin-bottom:20px;text-shadow:0 1px 5px rgba(0,0,0,.4)}#fxTutorialTitle{margin-bottom:0}#fxTutorialTitle,#fxTutorialTitle2{font-weight:300;font-size:44px;color:#fff;margin-top:0;text-shadow:0 1px 5px rgba(0,0,0,.4)}#fxTutorialTitle2{margin-bottom:20px}#fxTutorialTitle3{font-weight:300;font-size:36px;color:#fff;margin-top:160px;margin-bottom:20px;text-shadow:0 1px 5px rgba(0,0,0,.4)}#fxTitleTutorial{font-weight:300;font-size:40px;color:#fff;text-shadow:0 1px 5px hsla(0,0%,100%,.4)}#masterControlDiv{margin-top:140px;margin-bottom:0}#masterControlBadges{border:2px solid transparent;border-radius:5px}#masterControlBadges,#masterControlBadgesSFX{padding:8px;font-size:20px;font-weight:400;width:220px;box-shadow:0 8px 10px 1px rgba(0,0,0,.4);text-shadow:0 1px 1px rgba(0,0,0,.2)}#masterControlBadgesSFX{border-radius:5px;margin-top:0}#sliders1,#sliders2,#sliders3,#sliders4,#sliders5,#sliders6{margin-top:30px}#ambienceBtnLocation{margin:auto;margin-top:0;margin-bottom:0}#ambienceBtns{width:220px;border-radius:5px;font-size:24px;font-weight:400}#tutorialContainer{font-weight:400;max-width:1000px;margin:auto;margin-top:0}#helpBtn1Div,#helpBtn2Div,#helpBtn3Div,#helpBtn4Div{width:25%}#ambienceSlider{margin-top:25px}#exploreBtnId,#speechList{margin-top:80px;height:45px;width:300px;border-radius:5px;font-size:22px;font-weight:400}#voiceCommandListID{max-width:750px;margin:auto;border-radius:10px;margin-top:40px;box-shadow:0 8px 10px 1px rgba(0,0,0,.4)}#voiceControlListTitle{padding-top:5px;font-size:30px;text-shadow:0 2px 4px rgba(0,0,0,.4)}#voiceControlListTxt{font-size:20px;text-shadow:0 1px 2px rgba(0,0,0,.4);padding-bottom:10px}#speechEngage{margin-top:15px;margin-left:60px;font-size:60px}#speechEngageActivated{margin-top:15px;margin-left:68px;font-size:60px}#VUIformInputDivID{max-width:650px;margin:center;margin-bottom:-75px}#inlineFormInputGroupUsername2{margin:auto;margin-top:20px;margin-left:80px;text-align:center;font-size:25px;width:500px;height:50px;border-radius:20px;box-shadow:0 8px 10px 1px rgba(0,0,0,.3);text-shadow:0 1px 2px rgba(0,0,0,.2)}input[type=range]{-webkit-appearance:none;height:10px;width:180px;border-radius:20px;margin:auto;border:0 dotted transparent;box-shadow:0 4px 10px 1px rgba(0,0,0,.3)}input[type=range]::-moz-range-track{-webkit-appearance:none;height:10px;width:180px;border-radius:20px;margin:auto;border:0 dotted transparent;box-shadow:0 4px 10px 1px rgba(0,0,0,.3)}input[type=range]::-ms-track{background:transparent;border-color:transparent;color:transparent;-webkit-appearance:none;position:relative;z-index:2;min-height:10px;width:180px;border-radius:20px;margin:auto;border:0 dotted transparent;box-shadow:0 4px 10px 1px rgba(0,0,0,.3)}input[type=range]::-webkit-slider-thumb{-webkit-appearance:none;position:relative;top:0;z-index:1;width:40px;height:40px;cursor:pointer;box-shadow:0 8px 10px 1px rgba(0,0,0,.6);border-radius:40px;border:0 dotted transparent}input[type=range]::-moz-range-thumb{position:relative;top:0;z-index:1;width:40px;height:40px;cursor:pointer;box-shadow:0 8px 10px 1px rgba(0,0,0,.6);border-radius:40px;border:0 dotted transparent}input[type=range]::-ms-thumb{border:none;height:40px;width:50px;border-radius:50%}#mailingListText{margin:auto;margin-top:30px;margin-bottom:0;font-size:20px}#mc_embed_signup{background:#fff;font-size:16px;width:100%;border-color:#000;background-color:transparent;text-shadow:0 .5px .5px rgba(0,0,0,.2)}#mce-EMAIL{margin-top:0;width:250px}#mc-embedded-subscribe,#mce-EMAIL{font-size:18px;padding:4px 10px;border-width:1px;border-radius:6px;background-color:transparent;border-color:#000;text-shadow:0 .5px .5px rgba(0,0,0,.2)}#mc-embedded-subscribe{margin-top:4px}}@media (min-width:1670px){#controlsContainer,#controlsContainerTutorial{max-width:1600px}#ambienceBtns{width:240px;font-size:26px;font-weight:400}#masterControlBadges,#masterControlBadgesSFX{width:240px;font-size:22px;font-weight:400}}#welcomeBtn,#welcomeBtnAbout,#welcomeBtnVoice{color:#000;border-color:#000}#aboutTxt,#mailingListTxt{color:#000!important}.btn-loading,.btn-loading.active,.btn-loading:active,.btn-loading:active:focus,.btn-loading:active:hover,.btn-loading:focus,.btn-loading:hover,.open>.dropdown-toggle.btn-loading{color:#000;background-color:transparent;border-width:2px;border-color:transparent}.btn-info,.btn-info:active,.btn-info:active:focus,.btn-info:active:hover,.btn-info:focus,.btn-info:hover,.open>.dropdown-toggle.btn-info{color:#000;background-color:#22c0f7;border-width:2px;border-color:transparent}.btn-success,.btn-success:active,.btn-success:active:focus,.btn-success:active:hover,.btn-success:focus,.btn-success:hover,.open>.dropdown-toggle.btn-success{color:#fff;background-color:var(--main-start-color);border-color:var(--main-start-color);border-width:2px}.btn-danger,.btn-danger:active,.btn-danger:active:focus,.btn-danger:active:hover,.btn-danger:focus,.btn-danger:hover,.open>.dropdown-toggle.btn-danger{color:#000;background-color:var(--main-stop-color);border-color:var(--main-stop-color);border-width:2px}.btn-blackwhite,.btn-blackwhite.active,.btn-blackwhite:active,.btn-blackwhite:active:focus .open>.dropdown-toggle.btn-blackwhite,.btn-blackwhite:focus,.btn-blackwhite:hover{color:#fff;background-color:var(--main-fxBadges-color)}.btn-blackwhiteneg,.btn-blackwhiteneg.active,.btn-blackwhiteneg:active,.btn-blackwhiteneg:active:focus .open>.dropdown-toggle.btn-blackwhiteneg,.btn-blackwhiteneg:focus,.btn-blackwhiteneg:hover{color:#000;background-color:transparent}.btn-transparent,.btn-transparent.active,.btn-transparent:active,.btn-transparent:active:focus .open>.dropdown-toggle.btn-transparent,.btn-transparent:focus,.btn-transparent:hover{color:#fff;background-color:transparent;border-color:#fff;border-width:2px}.animated.rubberBand{-webkit-animation-duration:1.75s;animation-duration:1.75s}.animated.rollOut{-webkit-animation-duration:.75s;animation-duration:.75s}.animated.pulse{-webkit-animation-duration:.5s;animation-duration:.5s}.animated.zoomOutLeft{-webkit-animation-duration:1.5s;animation-duration:1.5s}.animated.zoomOutUp{-webkit-animation-duration:1.4s;animation-duration:1.4s}.animated.fadeOut{-webkit-animation-duration:.6s;animation-duration:.6s}.animated.fadeIn{-webkit-animation-duration:1.5s;animation-duration:1.5s}.animated.hinge{-webkit-animation-duration:1s;animation-duration:1s}.animated.zoomIn{-webkit-animation-duration:.75s;animation-duration:.75s}.fade-enter{opacity:0}.fade-enter-active{transition:opacity .5s}.fade-leave-active{transition:opacity .5s;opacity:0}.slow-spin{-webkit-animation:spin-counter 6s infinite linear;animation:spin-counter 6s infinite linear}.fa-counter-spin{-webkit-animation:spin-counter 1.5s infinite linear;animation:spin-counter 1.5s infinite linear}.fa-map-spin{-webkit-animation:fa-spin 1s infinite linear;animation:fa-spin 1s infinite linear}@-webkit-keyframes spin-counter{0%{-webkit-transform:rotate(359deg)}to{-webkit-transform:rotate(0deg)}}@keyframes spin-counter{0%{transform:rotate(359deg)}to{transform:rotate(0deg)}}", ""]);

// exports


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)();
// imports


// module
exports.push([module.i, ":root{--main-fxBadgesRural-color:#000!important;--main-startRural-color:#00a388!important;--main-stopRural-color:#ff6138!important;--main-border-color:4px solid transparent}.backgroundColorRural1{background-color:#699;transition:background .1s linear}.backgroundColorRural2{background-color:#75a3a3;transition:background .1s linear}.backgroundColorRural3{background-color:#85adad;transition:background .1s linear}.backgroundColorRural4{background-color:#94b8b8;transition:background .1s linear}.backgroundColorRural5{background-color:#a3c2c2;transition:background .1s linear}.backgroundColorRural6{background-color:#b3cccc;transition:background .1s linear}.backgroundColorRural7{background-color:#c2d6d6;transition:background .1s linear}.backgroundColorRural8{background-color:#d1e0e0;transition:background .1s linear}.backgroundColorRural9{background-color:#e0ebeb;transition:background .1s linear}.backgroundColorRural10{background-color:#f0f5f5;transition:background .1s linear}.sunReactiveColorClassRural1{background-color:#f0f5f5;transition:background .25s linear}.sunReactiveColorClassRural2{background-color:#e0ebeb;transition:background .25s linear}.sunReactiveColorClassRural3{background-color:#d1e0e0;transition:background .25s linear}.sunReactiveColorClassRural4{background-color:#c2d6d6;transition:background .25s linear}.sunReactiveColorClassRural5{background-color:#b3cccc;transition:background .25s linear}.sunReactiveColorClassRural6{background-color:#a3c2c2;transition:background .25s linear}.sunReactiveColorClassRural7{background-color:#94b8b8;transition:background .25s linear}.sunReactiveColorClassRural8{background-color:#85adad;transition:background .25s linear}.sunReactiveColorClassRural9{background-color:#75a3a3;transition:background .25s linear}.sunReactiveColorClassRural10{background-color:#699;transition:background .25s linear}.btn-mattChillOffRural,.btn-mattChillOffRural.active,.btn-mattChillOffRural:active,.btn-mattChillOffRural:active:focus,.btn-mattChillOffRural:focus,.open>.dropdown-toggle.btn-mattChillOffRural{color:#000;background-color:var(--main-stopRural-color);border-width:2px;border-color:transparent}.btn-mattChillOffRural:active:hover,.btn-mattChillOffRural:hover,.btn-mattChillOnRural,.btn-mattChillOnRural.active,.btn-mattChillOnRural:active,.btn-mattChillOnRural:active:focus,.btn-mattChillOnRural:focus,.open>.dropdown-toggle.btn-mattChillOnRural{color:#fff;background-color:var(--main-startRural-color);border-width:2px;border-color:transparent}.btn-mattChillOnRural:active:hover,.btn-mattChillOnRural:hover{color:#fff;background-color:var(--main-stopRural-color);border-width:2px;border-color:transparent}.btn-helpBtn1Rural,.btn-helpBtn1Rural:active,.btn-helpBtn1Rural:active:focus,.btn-helpBtn1Rural:focus,.open>.dropdown-toggle.btn-helpBtn1Rural{color:#000;background-color:transparent;border-color:transparent;border-width:2px}.btn-helpBtn1Rural:active:hover,.btn-helpBtn1Rural:hover{color:var(--main-stopRural-color);background-color:transparent;border-color:var(--main-stopRural-color);border-width:2px}.btn-helpBtn2Rural,.btn-helpBtn2Rural:active,.btn-helpBtn2Rural:active:focus,.btn-helpBtn2Rural:active:hover,.btn-helpBtn2Rural:focus,.btn-helpBtn2Rural:hover,.open>.dropdown-toggle.btn-helpBtn2Rural{background:var(--main-fxBadgesRural-color);color:#fff;border-color:transparent;box-shadow:0 4px 4px 1px rgba(0,0,0,.4);text-shadow:0 1px 2px rgba(0,0,0,.4)}.btn-playRural,.btn-playRural:active,.btn-playRural:active:focus,.btn-playRural:active:hover,.btn-playRural:focus,.btn-playRural:hover,.open>.dropdown-toggle.btn-playRural{color:#fff;background-color:var(--main-startRural-color);border-color:var(--main-startRural-color);border-width:2px;box-shadow:0 4px 4px 1px rgba(0,0,0,.2);text-shadow:0 1px 2px rgba(0,0,0,.4)}.btn-stopRural,.btn-stopRural:active,.btn-stopRural:active:focus,.btn-stopRural:active:hover,.btn-stopRural:focus,.btn-stopRural:hover,.open>.dropdown-toggle.btn-stopRural{color:#000;background-color:var(--main-stopRural-color);border-color:var(--main-stopRural-color);border-width:2px;box-shadow:0 4px 4px 1px rgba(0,0,0,.4);text-shadow:0 1px 2px rgba(0,0,0,.4)}input[class=instrumentRangerRural]{background:var(--main-fxBadgesRural-color)}input[class=instrumentRangerRural]::-moz-range-track{background:var(--main-fxBadgesRural-color)}input[class=instrumentRangerRural]::-webkit-slider-thumb{background:var(--main-fxBadgesRural-color)}input[class=instrumentRangerRural]::-moz-range-thumb{background:var(--main-fxBadgesRural-color)}input[class=ambianceRangerStopRural]{background-color:var(--main-stopRural-color)}input[class=ambianceRangerStopRural]::-webkit-slider-thumb{background:var(--main-stopRural-color)}input[class=ambianceRangerStopRural]::-moz-range-track{background-color:var(--main-stopRural-color)}input[class=ambianceRangerStopRural]::-moz-range-thumb{background:var(--main-stopRural-color)}input[class=ambianceRangerPlayRural]{background-color:var(--main-startRural-color)}input[class=ambianceRangerPlayRural]::-webkit-slider-thumb{background:var(--main-startRural-color)}input[class=ambianceRangerPlayRural]::-moz-range-track{background-color:var(--main-startRural-color)}input[class=ambianceRangerPlayRural]::-moz-range-thumb{background:var(--main-startRural-color)}.recordingClassDisengagedRural{background:var(--main-fxBadgesRural-color);color:#fff;box-shadow:0 4px 4px 1px rgba(0,0,0,.4)}.recordingClassDisengagedRural,.recordingClassEngagedRural{border-color:transparent;text-shadow:0 1px 2px rgba(0,0,0,.4)}.recordingClassEngagedRural{background:var(--main-startRural-color);color:var(--main-fxBadgesRural-color);box-shadow:0 4px 4px 1px rgba(0,0,0,.2)}input[id=inlineFormInputGroupUsername2]::-webkit-input-placeholder{color:var(--main-startRural-color)}#voiceCommandListID{color:#fff;background-color:var(--main-fxBadgesRural-color)}.voiceBadgeRural{background:var(--main-fxBadgesRural-color);color:#000}", ""]);

// exports


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)();
// imports


// module
exports.push([module.i, ".greenBell{color:gold}body,html{background:#fff}.btn-helpBtn1,.btn-helpBtn1:active,.btn-helpBtn1:active:focus,.btn-helpBtn1:active:hover,.btn-helpBtn1:focus,.btn-helpBtn1:hover,.open>.dropdown-toggle.btn-helpBtn1{color:#000;background-color:transparent;border-color:#000;border-width:2px;text-shadow:0 1px 4px rgba(0,0,0,.6);box-shadow:0 8px 20px 1px rgba(0,0,0,.3)}.btn-helpBtn2,.btn-helpBtn2:active,.btn-helpBtn2:active:focus,.btn-helpBtn2:active:hover,.btn-helpBtn2:focus,.btn-helpBtn2:hover,.open>.dropdown-toggle.btn-helpBtn2{color:#000;background-color:transparent;border-color:#000;border-width:2px}.backgroundGreatPlains{color:#fff!important;background-color:#e0a01f}.backgroundGreatPlains,.backgroundOcean{transition:background .5s linear;border-color:transparent!important}.backgroundOcean{color:#000!important;background-color:#fff}.backgroundAmazon{background-color:#4f601f}.backgroundAmazon,.backgroundForest{color:#fff!important;transition:background .5s linear;border-color:transparent!important}.backgroundForest{background-color:#8fd471}.backgroundDesert{background-color:#9a6d32}.backgroundBeach,.backgroundDesert{color:#fff!important;transition:background .5s linear;border-color:transparent!important}.backgroundBeach{background-color:#e4c39a}.backgroundNYC{color:#000!important;background-color:#f1f3f3;transition:background .5s linear;border-color:transparent!important}.backgroundRural{background-color:#699}.backgroundice,.backgroundRural{color:#fff!important;transition:background .5s linear;border-color:transparent!important}.backgroundice{background-color:#baf4f8}.backgroundfire{color:#fff!important;background-color:red;transition:background .5s linear;border-color:transparent!important}", ""]);

// exports


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)();
// imports


// module
exports.push([module.i, ":root{--main-fxBadgesForest-color:#f7da60!important;--main-startForest-color:#4470c7!important;--main-stopForest-color:#9e6e2c!important;--main-border-color:4px solid transparent}.backgroundColorForest1{background-color:#8fd471;transition:background .1s linear}.backgroundColorForest2{background-color:#83d062;transition:background .1s linear}.backgroundColorForest3{background-color:#73ca4e;transition:background .1s linear}.backgroundColorForest4{background-color:#64c43b;transition:background .1s linear}.backgroundColorForest5{background-color:#5ab135;transition:background .1s linear}.backgroundColorForest6{background-color:#509d2f;transition:background .1s linear}.backgroundColorForest7{background-color:#468929;transition:background .1s linear}.backgroundColorForest8{background-color:#3c7623;transition:background .1s linear}.backgroundColorForest9{background-color:#32621d;transition:background .1s linear}.backgroundColorForest10{background-color:#284f17;transition:background .1s linear}.sunReactiveColorClassForest1{background-color:#284f17;transition:background .25s linear}.sunReactiveColorClassForest2{background-color:#32621d;transition:background .25s linear}.sunReactiveColorClassForest3{background-color:#3c7623;transition:background .25s linear}.sunReactiveColorClassForest4{background-color:#468929;transition:background .25s linear}.sunReactiveColorClassForest5{background-color:#509d2f;transition:background .25s linear}.sunReactiveColorClassForest6{background-color:#5ab135;transition:background .25s linear}.sunReactiveColorClassForest7{background-color:#64c43b;transition:background .25s linear}.sunReactiveColorClassForest8{background-color:#73ca4e;transition:background .25s linear}.sunReactiveColorClassForest9{background-color:#83d062;transition:background .25s linear}.sunReactiveColorClassForest10{background-color:#8fd471;transition:background .25s linear}.btn-mattChillOffForest,.btn-mattChillOffForest.active,.btn-mattChillOffForest:active,.btn-mattChillOffForest:active:focus,.btn-mattChillOffForest:focus,.open>.dropdown-toggle.btn-mattChillOffForest{color:#000;background-color:var(--main-stopForest-color);border-width:2px;border-color:transparent}.btn-mattChillOffForest:active:hover,.btn-mattChillOffForest:hover,.btn-mattChillOnForest,.btn-mattChillOnForest.active,.btn-mattChillOnForest:active,.btn-mattChillOnForest:active:focus,.btn-mattChillOnForest:focus,.open>.dropdown-toggle.btn-mattChillOnForest{color:#fff;background-color:var(--main-startForest-color);border-width:2px;border-color:transparent}.btn-mattChillOnForest:active:hover,.btn-mattChillOnForest:hover{color:#fff;background-color:var(--main-stopForest-color);border-width:2px;border-color:transparent}.btn-helpBtn1Forest,.btn-helpBtn1Forest:active,.btn-helpBtn1Forest:active:focus,.btn-helpBtn1Forest:focus,.open>.dropdown-toggle.btn-helpBtn1Forest{color:#fff;background-color:transparent;border-color:transparent;border-width:2px}.btn-helpBtn1Forest:active:hover,.btn-helpBtn1Forest:hover{color:var(--main-fxBadgesForest-color);background-color:transparent;border-color:var(--main-fxBadgesForest-color);border-width:2px}.btn-helpBtn2Forest,.btn-helpBtn2Forest:active,.btn-helpBtn2Forest:active:focus,.btn-helpBtn2Forest:active:hover,.btn-helpBtn2Forest:focus,.btn-helpBtn2Forest:hover,.open>.dropdown-toggle.btn-helpBtn2Forest{background:var(--main-fxBadgesForest-color);color:var(--main-startForest-color);border-color:transparent;box-shadow:0 4px 4px 1px rgba(0,0,0,.4);text-shadow:0 1px 2px rgba(0,0,0,.4)}.btn-playForest,.btn-playForest:active,.btn-playForest:active:focus,.btn-playForest:active:hover,.btn-playForest:focus,.btn-playForest:hover,.open>.dropdown-toggle.btn-playForest{color:#fff;background-color:var(--main-startForest-color);border-color:var(--main-startForest-color);border-width:2px;box-shadow:0 4px 4px 1px rgba(0,0,0,.2);text-shadow:0 2px 8px rgba(0,0,0,.8)}.btn-fetchUnpressedForest,.btn-fetchUnpressedForest:active,.btn-fetchUnpressedForest:active:focus,.btn-fetchUnpressedForest:active:hover,.btn-fetchUnpressedForest:focus,.btn-fetchUnpressedForest:hover,.btn-stopForest,.btn-stopForest:active,.btn-stopForest:active:focus,.btn-stopForest:active:hover,.btn-stopForest:focus,.btn-stopForest:hover,.open>.dropdown-toggle.btn-fetchUnpressedForest,.open>.dropdown-toggle.btn-stopForest{color:#000;background-color:var(--main-stopForest-color);border-color:var(--main-stopForest-color);border-width:2px;box-shadow:0 8px 10px 1px rgba(0,0,0,.4);text-shadow:0 1px 2px rgba(0,0,0,.4)}.btn-fetchDepressedForest,.btn-fetchDepressedForest:active,.btn-fetchDepressedForest:active:focus,.btn-fetchDepressedForest:active:hover,.btn-fetchDepressedForest:focus,.btn-fetchDepressedForest:hover,.open>.dropdown-toggle.btn-fetchDepressedForest{color:#fff;background-color:var(--main-startForest-color);border-color:var(--main-startForest-color);border-width:2px;box-shadow:0 4px 4px 1px rgba(0,0,0,.2);text-shadow:0 2px 8px rgba(0,0,0,.8)}input[class=instrumentRangerForest]{background:var(--main-fxBadgesForest-color)}input[class=instrumentRangerForest]::-moz-range-track{background:var(--main-fxBadgesForest-color)}input[class=instrumentRangerForest]::-webkit-slider-thumb{background:var(--main-fxBadgesForest-color)}input[class=instrumentRangerForest]::-moz-range-thumb{background:var(--main-fxBadgesForest-color)}input[class=instrumentRangerForest]::-ms-thumb{background:#f7da60}input[class=instrumentRangerForest]::-ms-fill-upper{background:#9e6e2c}input[class=instrumentRangerForest]::-ms-fill-lower{background:#4470c7}input[class=ambianceRangerStopForest]{background-color:var(--main-stopForest-color)}input[class=ambianceRangerStopForest]::-webkit-slider-thumb{background:var(--main-stopForest-color)}input[class=ambianceRangerStopForest]::-moz-range-track{background-color:var(--main-stopForest-color)}input[class=ambianceRangerStopForest]::-moz-range-thumb{background:var(--main-stopForest-color)}input[class=ambianceRangerStopForest]::-ms-thumb{background:#f7da60}input[class=ambianceRangerStopForest]::-ms-fill-upper{background:#9e6e2c}input[class=ambianceRangerStopForest]::-ms-fill-lower{background:#4470c7}input[class=ambianceRangerPlayForest]{background-color:var(--main-startForest-color)}input[class=ambianceRangerPlayForest]::-webkit-slider-thumb{background:var(--main-startForest-color)}input[class=ambianceRangerPlayForest]::-moz-range-track{background-color:var(--main-startForest-color)}input[class=ambianceRangerPlayForest]::-moz-range-thumb{background:var(--main-startForest-color)}input[class=ambianceRangerPlayForest]::-ms-thumb{background:#f7da60}input[class=ambianceRangerPlayForest]::-ms-fill-upper{background:#9e6e2c}input[class=ambianceRangerPlayForest]::-ms-fill-lower{background:#4470c7}.recordingClassDisengagedForest{background:var(--main-fxBadgesForest-color);color:var(--main-startForest-color);box-shadow:0 4px 4px 1px rgba(0,0,0,.4)}.recordingClassDisengagedForest,.recordingClassEngagedForest{border-color:transparent;text-shadow:0 1px 2px rgba(0,0,0,.4)}.recordingClassEngagedForest{background:var(--main-startForest-color);color:var(--main-fxBadgesForest-color);box-shadow:0 4px 4px 1px rgba(0,0,0,.2)}input[id=inlineFormInputGroupUsername2]::-webkit-input-placeholder{color:var(--main-fxBadgesForest-color)}#voiceCommandListID{color:#000;background-color:var(--main-fxBadgesForest-color)}.voiceBadgeForest{background:var(--main-fxBadgesForest-color);color:#000}.animated.flipOutX{-webkit-animation-duration:1.35s;animation-duration:1.35s}.sectionHighlight{color:#000!important;border-color:transparent!important;background-color:#efe712!important;border-width:2px!important}", ""]);

// exports


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)();
// imports


// module
exports.push([module.i, ":root{--main-fxBadgesIce-color:#838bc5!important;--main-startIce-color:#65c8d0!important;--main-stopIce-color:#ba9bc9!important;--main-border-color:4px solid transparent}.backgroundColorIce1{background-color:#13c4ec;transition:background .1s linear}.backgroundColorIce2{background-color:#2bcaee;transition:background .1s linear}.backgroundColorIce3{background-color:#42d0f0;transition:background .1s linear}.backgroundColorIce4{background-color:#5cd7f2;transition:background .1s linear}.backgroundColorIce5{background-color:#71dcf4;transition:background .1s linear}.backgroundColorIce6{background-color:#89e2f5;transition:background .1s linear}.backgroundColorIce7{background-color:#a1e7f7;transition:background .1s linear}.backgroundColorIce8{background-color:#b8edf9;transition:background .1s linear}.backgroundColorIce9{background-color:#d0f3fb;transition:background .1s linear}.backgroundColorIce10{background-color:#e7f9fd;transition:background .1s linear}.sunReactiveColorClassIce1{background-color:#e7f9fd;transition:background .25s linear}.sunReactiveColorClassIce2{background-color:#d0f3fb;transition:background .25s linear}.sunReactiveColorClassIce3{background-color:#b8edf9;transition:background .25s linear}.sunReactiveColorClassIce4{background-color:#a1e7f7;transition:background .25s linear}.sunReactiveColorClassIce5{background-color:#89e2f5;transition:background .25s linear}.sunReactiveColorClassIce6{background-color:#71dcf4;transition:background .25s linear}.sunReactiveColorClassIce7{background-color:#5cd7f2;transition:background .25s linear}.sunReactiveColorClassIce8{background-color:#42d0f0;transition:background .25s linear}.sunReactiveColorClassIce9{background-color:#2bcaee;transition:background .25s linear}.sunReactiveColorClassIce10{background-color:#13c4ec;transition:background .25s linear}.btn-mattChillOffIce,.btn-mattChillOffIce.active,.btn-mattChillOffIce:active,.btn-mattChillOffIce:active:focus,.btn-mattChillOffIce:focus,.open>.dropdown-toggle.btn-mattChillOffIce{color:#000;background-color:var(--main-stopIce-color);border-width:2px;border-color:transparent}.btn-mattChillOffIce:active:hover,.btn-mattChillOffIce:hover,.btn-mattChillOnIce,.btn-mattChillOnIce.active,.btn-mattChillOnIce:active,.btn-mattChillOnIce:active:focus,.btn-mattChillOnIce:focus,.open>.dropdown-toggle.btn-mattChillOnIce{color:#fff;background-color:var(--main-startIce-color);border-width:2px;border-color:transparent}.btn-mattChillOnIce:active:hover,.btn-mattChillOnIce:hover{color:#fff;background-color:var(--main-stopIce-color);border-width:2px;border-color:transparent}.btn-helpBtn1Ice,.btn-helpBtn1Ice:active,.btn-helpBtn1Ice:active:focus,.btn-helpBtn1Ice:focus,.open>.dropdown-toggle.btn-helpBtn1Ice{color:#000;background-color:transparent;border-color:transparent;border-width:2px}.btn-helpBtn1Ice:active:hover,.btn-helpBtn1Ice:hover{color:var(--main-stopIce-color);background-color:transparent;border-color:var(--main-stopIce-color);border-width:2px}.btn-helpBtn2Ice,.btn-helpBtn2Ice:active,.btn-helpBtn2Ice:active:focus,.btn-helpBtn2Ice:active:hover,.btn-helpBtn2Ice:focus,.btn-helpBtn2Ice:hover,.open>.dropdown-toggle.btn-helpBtn2Ice{background:var(--main-fxBadgesIce-color);color:#fff;border-color:transparent;box-shadow:0 4px 4px 1px rgba(0,0,0,.4);text-shadow:0 1px 2px rgba(0,0,0,.4)}.btn-playIce,.btn-playIce:active,.btn-playIce:active:focus,.btn-playIce:active:hover,.btn-playIce:focus,.btn-playIce:hover,.open>.dropdown-toggle.btn-playIce{color:#fff;background-color:var(--main-startIce-color);border-color:var(--main-startIce-color);border-width:2px;box-shadow:0 4px 4px 1px rgba(0,0,0,.2);text-shadow:0 1px 2px rgba(0,0,0,.4)}.btn-stopIce,.btn-stopIce:active,.btn-stopIce:active:focus,.btn-stopIce:active:hover,.btn-stopIce:focus,.btn-stopIce:hover,.open>.dropdown-toggle.btn-stopIce{color:#000;background-color:var(--main-stopIce-color);border-color:var(--main-stopIce-color);border-width:2px;box-shadow:0 4px 4px 1px rgba(0,0,0,.4);text-shadow:0 1px 2px rgba(0,0,0,.4)}input[class=instrumentRangerIce]{background:var(--main-fxBadgesIce-color)}input[class=instrumentRangerIce]::-moz-range-track{background:var(--main-fxBadgesIce-color)}input[class=instrumentRangerIce]::-webkit-slider-thumb{background:var(--main-fxBadgesIce-color)}input[class=instrumentRangerIce]::-moz-range-thumb{background:var(--main-fxBadgesIce-color)}input[class=instrumentRangerIce]::-ms-thumb{background:#838bc5}input[class=instrumentRangerIce]::-ms-fill-upper{background:#ba9bc9}input[class=instrumentRangerIce]::-ms-fill-lower{background:#65c8d0}input[class=ambianceRangerStopIce]{background-color:var(--main-stopIce-color)}input[class=ambianceRangerStopIce]::-webkit-slider-thumb{background:var(--main-stopIce-color)}input[class=ambianceRangerStopIce]::-moz-range-track{background-color:var(--main-stopIce-color)}input[class=ambianceRangerStopIce]::-moz-range-thumb{background:var(--main-stopIce-color)}input[class=ambianceRangerStopIce]::-ms-thumb{background:#838bc5}input[class=ambianceRangerStopIce]::-ms-fill-upper{background:#ba9bc9}input[class=ambianceRangerStopIce]::-ms-fill-lower{background:#65c8d0}input[class=ambianceRangerPlayIce]{background-color:var(--main-startIce-color)}input[class=ambianceRangerPlayIce]::-webkit-slider-thumb{background:var(--main-startIce-color)}input[class=ambianceRangerPlayIce]::-moz-range-track{background-color:var(--main-startIce-color)}input[class=ambianceRangerPlayIce]::-moz-range-thumb{background:var(--main-startIce-color)}input[class=ambianceRangerPlayIce]::-ms-thumb{background:#838bc5}input[class=ambianceRangerPlayIce]::-ms-fill-upper{background:#ba9bc9}input[class=ambianceRangerPlayIce]::-ms-fill-lower{background:#65c8d0}.recordingClassDisengagedIce{background:var(--main-fxBadgesIce-color);box-shadow:0 4px 4px 1px rgba(0,0,0,.4)}.recordingClassDisengagedIce,.recordingClassEngagedIce{color:#fff;border-color:transparent;text-shadow:0 1px 2px rgba(0,0,0,.4)}.recordingClassEngagedIce{background:var(--main-startIce-color);box-shadow:0 4px 4px 1px rgba(0,0,0,.2)}input[id=inlineFormInputGroupUsername2]::-webkit-input-placeholder{color:#fff}#voiceCommandListID{color:#fff;background-color:var(--main-fxBadgesIce-color)}.voiceBadgeIce{background:var(--main-fxBadgesIce-color);color:#fff}", ""]);

// exports


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)();
// imports


// module
exports.push([module.i, ":root{--main-fxBadgesOcean-color:#114162!important;--main-startOcean-color:#ecf0f1!important;--main-stopOcean-color:#3498db!important;--main-border-color:4px solid transparent}.backgroundColorOcean1{background-color:#fff;transition:background .1s linear}.backgroundColorOcean2{background-color:#e6f8fe;transition:background .1s linear}.backgroundColorOcean3{background-color:#cef1fd;transition:background .1s linear}.backgroundColorOcean4{background-color:#b5ebfc;transition:background .1s linear}.backgroundColorOcean5{background-color:#9de4fb;transition:background .1s linear}.backgroundColorOcean6{background-color:#84ddfb;transition:background .1s linear}.backgroundColorOcean7{background-color:#6bd6fa;transition:background .1s linear}.backgroundColorOcean8{background-color:#53cff9;transition:background .1s linear}.backgroundColorOcean9{background-color:#3ac8f8;transition:background .1s linear}.backgroundColorOcean10{background-color:#22c0f7;transition:background .1s linear}.sunReactiveColorClassOcean1{background-color:#22c0f7;transition:background .25s linear}.sunReactiveColorClassOcean2{background-color:#09bbf6;transition:background .25s linear}.sunReactiveColorClassOcean3{background-color:#08a8dd;transition:background .25s linear}.sunReactiveColorClassOcean4{background-color:#0795c5;transition:background .25s linear}.sunReactiveColorClassOcean5,.sunReactiveColorClassOcean6{background-color:#0683ac;transition:background .25s linear}.sunReactiveColorClassOcean7{background-color:#057094;transition:background .25s linear}.sunReactiveColorClassOcean8{background-color:#045d7b;transition:background .25s linear}.sunReactiveColorClassOcean9{background-color:#044b62;transition:background .25s linear}.sunReactiveColorClassOcean10{background-color:#03384a;transition:background .25s linear}.btn-mattChillOffOcean,.btn-mattChillOffOcean.active,.btn-mattChillOffOcean:active,.btn-mattChillOffOcean:active:focus,.btn-mattChillOffOcean:focus,.open>.dropdown-toggle.btn-mattChillOffOcean{color:#fff;background-color:var(--main-stopOcean-color);border-width:2px;border-color:transparent}.btn-mattChillOffOcean:active:hover,.btn-mattChillOffOcean:hover,.btn-mattChillOnOcean,.btn-mattChillOnOcean.active,.btn-mattChillOnOcean:active,.btn-mattChillOnOcean:active:focus,.btn-mattChillOnOcean:focus,.open>.dropdown-toggle.btn-mattChillOnOcean{color:#000;background-color:var(--main-startOcean-color);border-width:2px;border-color:transparent}.btn-mattChillOnOcean:active:hover,.btn-mattChillOnOcean:hover{color:#fff;background-color:var(--main-stopOcean-color);border-width:2px;border-color:transparent}.btn-helpBtn1Ocean,.btn-helpBtn1Ocean:active,.btn-helpBtn1Ocean:active:focus,.btn-helpBtn1Ocean:focus,.open>.dropdown-toggle.btn-helpBtn1Ocean{color:#fff;background-color:transparent;border-color:transparent;border-width:2px}.btn-helpBtn1Ocean:active:hover,.btn-helpBtn1Ocean:hover{color:#000;background-color:transparent;border-color:#000;border-width:2px}.btn-helpBtn2Ocean,.btn-helpBtn2Ocean:active,.btn-helpBtn2Ocean:active:focus,.btn-helpBtn2Ocean:active:hover,.btn-helpBtn2Ocean:focus,.btn-helpBtn2Ocean:hover,.open>.dropdown-toggle.btn-helpBtn2Ocean{background:var(--main-fxBadgesOcean-color);color:#fff;border-color:transparent;box-shadow:0 4px 4px 1px rgba(0,0,0,.4);text-shadow:0 1px 2px rgba(0,0,0,.4)}.btn-playOcean,.btn-playOcean:active,.btn-playOcean:active:focus,.btn-playOcean:active:hover,.btn-playOcean:focus,.btn-playOcean:hover,.open>.dropdown-toggle.btn-playOcean{color:#000;background-color:var(--main-startOcean-color);border-color:var(--main-startOcean-color);border-width:2px;box-shadow:0 4px 4px 1px rgba(0,0,0,.2);text-shadow:0 1px 2px rgba(0,0,0,.4)}.btn-stopOcean,.btn-stopOcean:active,.btn-stopOcean:active:focus,.btn-stopOcean:active:hover,.btn-stopOcean:focus,.btn-stopOcean:hover,.open>.dropdown-toggle.btn-stopOcean{color:#fff;background-color:var(--main-stopOcean-color);border-color:var(--main-stopOcean-color);border-width:2px;box-shadow:0 4px 4px 1px rgba(0,0,0,.4);text-shadow:0 1px 2px rgba(0,0,0,.4)}input[class=instrumentRangerOcean]{background:var(--main-fxBadgesOcean-color)}input[class=instrumentRangerOcean]::-moz-range-track{background:var(--main-fxBadgesOcean-color)}input[class=instrumentRangerOcean]::-webkit-slider-thumb{background:var(--main-fxBadgesOcean-color)}input[class=instrumentRangerOcean]::-moz-range-thumb{background:var(--main-fxBadgesOcean-color)}input[class=instrumentRangerOcean]::-ms-thumb{background:#114162}input[class=instrumentRangerOcean]::-ms-fill-upper{background:#3498db}input[class=instrumentRangerOcean]::-ms-fill-lower{background:#ecf0f1}input[class=ambianceRangerStopOcean]{background-color:var(--main-stopOcean-color)}input[class=ambianceRangerStopOcean]::-webkit-slider-thumb{background:var(--main-stopOcean-color)}input[class=ambianceRangerStopOcean]::-moz-range-track{background-color:var(--main-stopOcean-color)}input[class=ambianceRangerStopOcean]::-moz-range-thumb{background:var(--main-stopOcean-color)}input[class=ambianceRangerStopOcean]::-ms-thumb{background:#114162}input[class=ambianceRangerStopOcean]::-ms-fill-upper{background:#3498db}input[class=ambianceRangerStopOcean]::-ms-fill-lower{background:#ecf0f1}input[class=ambianceRangerPlayOcean]{background-color:var(--main-startOcean-color)}input[class=ambianceRangerPlayOcean]::-webkit-slider-thumb{background:var(--main-startOcean-color)}input[class=ambianceRangerPlayOcean]::-moz-range-track{background-color:var(--main-startOcean-color)}input[class=ambianceRangerPlayOcean]::-moz-range-thumb{background:var(--main-startOcean-color)}input[class=ambianceRangerPlayOcean]::-ms-thumb{background:#114162}input[class=ambianceRangerPlayOcean]::-ms-fill-upper{background:#3498db}input[class=ambianceRangerPlayOcean]::-ms-fill-lower{background:#ecf0f1}.recordingClassDisengagedOcean{background:var(--main-fxBadgesOcean-color);color:var(--main-startOcean-color);box-shadow:0 4px 4px 1px rgba(0,0,0,.4)}.recordingClassDisengagedOcean,.recordingClassEngagedOcean{border-color:transparent;text-shadow:0 1px 2px rgba(0,0,0,.4)}.recordingClassEngagedOcean{background:var(--main-startOcean-color);color:var(--main-fxBadgesOcean-color);box-shadow:0 4px 4px 1px rgba(0,0,0,.2)}input[id=inlineFormInputGroupUsername2]::-webkit-input-placeholder{color:var(--main-startOcean-color)}#voiceCommandListID{color:var(--main-startOcean-color);background-color:var(--main-fxBadgesOcean-color)}.voiceBadgeOcean{background:var(--main-fxBadgesOcean-color);color:#fff}", ""]);

// exports


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)();
// imports


// module
exports.push([module.i, ":root{--main-fxBadgesAmazon-color:#f7da60!important;--main-startAmazon-color:#4470c7!important;--main-stopAmazon-color:#9e6e2c!important;--main-border-color:4px solid transparent}.backgroundColorAmazon1{background-color:#4f601f;transition:background .1s linear}.backgroundColorAmazon2{background-color:#5f7425;transition:background .1s linear}.backgroundColorAmazon3{background-color:#3c7623;transition:background .1s linear}.backgroundColorAmazon4{background-color:#6e872c;transition:background .1s linear}.backgroundColorAmazon5{background-color:#7e9a32;transition:background .1s linear}.backgroundColorAmazon6{background-color:#8ead38;transition:background .1s linear}.backgroundColorAmazon7{background-color:#9ec13e;transition:background .1s linear}.backgroundColorAmazon8{background-color:#a8c752;transition:background .1s linear}.backgroundColorAmazon9{background-color:#b1cd65;transition:background .1s linear}.backgroundColorAmazon10{background-color:#b2ce68;transition:background .1s linear}.sunReactiveColorClassAmazon1{background-color:#b2ce68;transition:background .25s linear}.sunReactiveColorClassAmazon2{background-color:#b1cd65;transition:background .25s linear}.sunReactiveColorClassAmazon3{background-color:#a8c752;transition:background .25s linear}.sunReactiveColorClassAmazon4{background-color:#9ec13e;transition:background .25s linear}.sunReactiveColorClassAmazon5{background-color:#8ead38;transition:background .25s linear}.sunReactiveColorClassAmazon6{background-color:#7e9a32;transition:background .25s linear}.sunReactiveColorClassAmazon7{background-color:#6e872c;transition:background .25s linear}.sunReactiveColorClassAmazon8{background-color:#3c7623;transition:background .25s linear}.sunReactiveColorClassAmazon9{background-color:#5f7425;transition:background .25s linear}.sunReactiveColorClassAmazon10{background-color:#4f601f;transition:background .25s linear}.btn-mattChillOffAmazon,.btn-mattChillOffAmazon.active,.btn-mattChillOffAmazon:active,.btn-mattChillOffAmazon:active:focus,.btn-mattChillOffAmazon:focus,.open>.dropdown-toggle.btn-mattChillOffAmazon{color:#000;background-color:var(--main-stopAmazon-color);border-width:2px;border-color:transparent}.btn-mattChillOffAmazon:active:hover,.btn-mattChillOffAmazon:hover,.btn-mattChillOnAmazon,.btn-mattChillOnAmazon.active,.btn-mattChillOnAmazon:active,.btn-mattChillOnAmazon:active:focus,.btn-mattChillOnAmazon:focus,.open>.dropdown-toggle.btn-mattChillOnAmazon{color:#fff;background-color:var(--main-startAmazon-color);border-width:2px;border-color:transparent}.btn-mattChillOnAmazon:active:hover,.btn-mattChillOnAmazon:hover{color:#fff;background-color:var(--main-stopAmazon-color);border-width:2px;border-color:transparent}.btn-helpBtn1Amazon,.btn-helpBtn1Amazon:active,.btn-helpBtn1Amazon:active:focus,.btn-helpBtn1Amazon:focus,.open>.dropdown-toggle.btn-helpBtn1Amazon{color:#000;background-color:transparent;border-color:transparent;border-width:2px}.btn-helpBtn1Amazon:active:hover,.btn-helpBtn1Amazon:hover{color:var(--main-startAmazon-color);background-color:transparent;border-color:var(--main-startAmazon-color);border-width:2px}.btn-helpBtn2Amazon,.btn-helpBtn2Amazon:active,.btn-helpBtn2Amazon:active:focus,.btn-helpBtn2Amazon:active:hover,.btn-helpBtn2Amazon:focus,.btn-helpBtn2Amazon:hover,.open>.dropdown-toggle.btn-helpBtn2Amazon{background:var(--main-fxBadgesAmazon-color);color:var(--main-startAmazon-color);border-color:transparent;box-shadow:0 4px 4px 1px rgba(0,0,0,.4);text-shadow:0 1px 2px rgba(0,0,0,.4)}.btn-playAmazon,.btn-playAmazon:active,.btn-playAmazon:active:focus,.btn-playAmazon:active:hover,.btn-playAmazon:focus,.btn-playAmazon:hover,.open>.dropdown-toggle.btn-playAmazon{color:#fff;background-color:var(--main-startAmazon-color);border-color:var(--main-startAmazon-color);border-width:2px;box-shadow:0 4px 4px 1px rgba(0,0,0,.2);text-shadow:0 1px 2px rgba(0,0,0,.4)}.btn-stopAmazon,.btn-stopAmazon:active,.btn-stopAmazon:active:focus,.btn-stopAmazon:active:hover,.btn-stopAmazon:focus,.btn-stopAmazon:hover,.open>.dropdown-toggle.btn-stopAmazon{color:#000;background-color:var(--main-stopAmazon-color);border-color:var(--main-stopAmazon-color);border-width:2px;box-shadow:0 4px 4px 1px rgba(0,0,0,.4);text-shadow:0 1px 2px rgba(0,0,0,.4)}input[class=instrumentRangerAmazon]{background:var(--main-fxBadgesAmazon-color)}input[class=instrumentRangerAmazon]::-moz-range-track{background:var(--main-fxBadgesAmazon-color)}input[class=instrumentRangerAmazon]::-webkit-slider-thumb{background:var(--main-fxBadgesAmazon-color)}input[class=instrumentRangerAmazon]::-moz-range-thumb{background:var(--main-fxBadgesAmazon-color)}input[class=instrumentRangerAmazon]::-ms-thumb{background:#f7da60}input[class=instrumentRangerAmazon]::-ms-fill-upper{background:#9e6e2c}input[class=instrumentRangerAmazon]::-ms-fill-lower{background:#4470c7}input[class=ambianceRangerStopAmazon]{background-color:var(--main-stopAmazon-color)}input[class=ambianceRangerStopAmazon]::-webkit-slider-thumb{background:var(--main-stopAmazon-color)}input[class=ambianceRangerStopAmazon]::-moz-range-track{background-color:var(--main-stopAmazon-color)}input[class=ambianceRangerStopAmazon]::-moz-range-thumb{background:var(--main-stopAmazon-color)}input[class=ambianceRangerStopAmazon]::-ms-thumb{background:#f7da60}input[class=ambianceRangerStopAmazon]::-ms-fill-upper{background:#9e6e2c}input[class=ambianceRangerStopAmazon]::-ms-fill-lower{background:#4470c7}input[class=ambianceRangerPlayAmazon]{background-color:var(--main-startAmazon-color)}input[class=ambianceRangerPlayAmazon]::-webkit-slider-thumb{background:var(--main-startAmazon-color)}input[class=ambianceRangerPlayAmazon]::-moz-range-track{background-color:var(--main-startAmazon-color)}input[class=ambianceRangerPlayAmazon]::-moz-range-thumb{background:var(--main-startAmazon-color)}input[class=ambianceRangerPlayAmazon]::-ms-thumb{background:#f7da60}input[class=ambianceRangerPlayAmazon]::-ms-fill-upper{background:#9e6e2c}input[class=ambianceRangerPlayAmazon]::-ms-fill-lower{background:#4470c7}.recordingClassDisengagedAmazon{background:var(--main-fxBadgesAmazon-color);color:var(--main-startAmazon-color);box-shadow:0 4px 4px 1px rgba(0,0,0,.4)}.recordingClassDisengagedAmazon,.recordingClassEngagedAmazon{border-color:transparent;text-shadow:0 1px 2px rgba(0,0,0,.4)}.recordingClassEngagedAmazon{background:var(--main-startAmazon-color);color:var(--main-fxBadgesAmazon-color);box-shadow:0 4px 4px 1px rgba(0,0,0,.2)}input[id=inlineFormInputGroupUsername2]::-webkit-input-placeholder{color:var(--main-startAmazon-color)}#voiceCommandListID{color:var(--main-startAmazon-color);background-color:var(--main-fxBadgesAmazon-color)}.voiceBadgeAmazon{background:var(--main-fxBadgesAmazon-color);color:#000}.animated.swing{-webkit-animation-duration:1s;animation-duration:1s}", ""]);

// exports


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)();
// imports


// module
exports.push([module.i, ":root{--main-moduleTransition-transition:background .55s ease-out}.backgroundColor1,.backgroundColor2,.backgroundColor3,.backgroundColor4,.backgroundColor5,.backgroundColor6,.backgroundColor7,.backgroundColor8,.backgroundColor9,.backgroundColor10,.sunReactiveColorClass1,.sunReactiveColorClass2,.sunReactiveColorClass3,.sunReactiveColorClass4,.sunReactiveColorClass5,.sunReactiveColorClass6,.sunReactiveColorClass7,.sunReactiveColorClass8,.sunReactiveColorClass9,.sunReactiveColorClass10{background-color:transparent}.backgroundGreatPlains{color:#fff!important;background-color:#e0a01f}.backgroundGreatPlains,.backgroundOcean{transition:var(--main-moduleTransition-transition);border-color:transparent!important}.backgroundOcean{color:#000!important;background-color:#fff}.backgroundAmazon{background-color:#4f601f}.backgroundAmazon,.backgroundForest{color:#fff!important;transition:var(--main-moduleTransition-transition);border-color:transparent!important}.backgroundForest{background-color:#8fd471}.backgroundDesert{background-color:#9a6d32}.backgroundBeach,.backgroundDesert{color:#fff!important;transition:var(--main-moduleTransition-transition);border-color:transparent!important}.backgroundBeach{background-color:#e4c39a}.backgroundNYC{color:#000!important;background-color:#f1f3f3;transition:var(--main-moduleTransition-transition);border-color:transparent!important}.backgroundRural{background-color:#699}.backgroundice,.backgroundRural{color:#fff!important;transition:var(--main-moduleTransition-transition);border-color:transparent!important}.backgroundice{background-color:#13c4ec}.backgroundfire{background-color:red;transition:var(--main-moduleTransition-transition)}.backgroundfire,.backgroundTutorial{color:#fff!important;border-color:transparent!important}.backgroundTutorial{background-color:#000;transition:background 1s ease-out}.welcomeBtnShadow:active:focus,.welcomeBtnShadow:active:hover{box-shadow:inset 0 4px 30px rgba(0,0,0,.41)!important;text-shadow:0 4px 4px rgba(0,0,0,.4)}.welcomeBtnNoTxt,.welcomeBtnNoTxt:active,.welcomeBtnNoTxt:active:focus,.welcomeBtnNoTxt:active:hover .open>.dropdown-toggle.welcomeBtnNoTxt,.welcomeBtnNoTxt:focus,.welcomeBtnNoTxt:hover{color:#000;background-color:transparent!important;border-color:transparent!important;border-width:0}.voiceCommandAddShadow,.voiceCommandAddShadow:active,.voiceCommandAddShadow:active:focus,.voiceCommandAddShadow:active:hover .open>.dropdown-toggle.voiceCommandAddShadow,.voiceCommandAddShadow:focus,.voiceCommandAddShadow:hover{color:#000;background-color:transparent!important;border-color:#000!important;border-width:0;box-shadow:inset 0 4px 30px rgba(0,0,0,.41)!important;text-shadow:0 4px 4px rgba(0,0,0,.4)}.btn-homeHelpBtn1,.btn-homeHelpBtn1:active,.btn-homeHelpBtn1:active:focus,.btn-homeHelpBtn1:active:hover,.btn-homeHelpBtn1:focus,.btn-homeHelpBtn1:hover,.open>.dropdown-toggle.btn-homeHelpBtn1{color:#fff;background-color:#fff;border-color:#fff}.btn-homeHelpBtn2,.btn-homeHelpBtn2:active,.btn-homeHelpBtn2:active:focus,.btn-homeHelpBtn2:focus,.open>.dropdown-toggle.btn-homeHelpBtn2{color:#000;background-color:#fff;border-color:#fff}.btn-homeHelpBtn2:active:hover,.btn-homeHelpBtn2:hover{color:#fff;background-color:#000;border-color:transparent}.btn-playAbout,.btn-playAbout:active,.btn-playAbout:active:focus,.btn-playAbout:active:hover,.btn-playAbout:focus,.btn-playAbout:hover,.open>.dropdown-toggle.btn-playAbout{color:#fff;background-color:green;border-color:transparent;border-width:2px}.btn-stopAbout,.btn-stopAbout:active,.btn-stopAbout:active:focus,.btn-stopAbout:active:hover,.btn-stopAbout:focus,.btn-stopAbout:hover,.open>.dropdown-toggle.btn-stopAbout{color:#000;background-color:red;border-color:transparent;border-width:2px}", ""]);

// exports


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)();
// imports


// module
exports.push([module.i, ":root{--main-fxBadgesNYC-color:#000!important;--main-startNYC-color:gold!important;--main-stopNYC-color:#2e5bce!important;--main-border-color:4px solid transparent}.backgroundColorNYC1{background-color:#f1f3f3;transition:background .1s linear}.backgroundColorNYC2{background-color:#e4e6e7;transition:background .1s linear}.backgroundColorNYC3{background-color:#d6dadb;transition:background .1s linear}.backgroundColorNYC4{background-color:#c9cecf;transition:background .1s linear}.backgroundColorNYC5{background-color:#bbc1c3;transition:background .1s linear}.backgroundColorNYC6{background-color:#aeb5b7;transition:background .1s linear}.backgroundColorNYC7{background-color:#a0a9ab;transition:background .1s linear}.backgroundColorNYC8{background-color:#939c9f;transition:background .1s linear}.backgroundColorNYC9{background-color:#859093;transition:background .1s linear}.backgroundColorNYC10{background-color:#788487;transition:background .1s linear}.sunReactiveColorClassNYC1{background-color:#788487;transition:background .25s linear}.sunReactiveColorClassNYC2{background-color:#859093;transition:background .25s linear}.sunReactiveColorClassNYC3{background-color:#939c9f;transition:background .25s linear}.sunReactiveColorClassNYC4{background-color:#a0a9ab;transition:background .25s linear}.sunReactiveColorClassNYC5{background-color:#aeb5b7;transition:background .25s linear}.sunReactiveColorClassNYC6{background-color:#bbc1c3;transition:background .25s linear}.sunReactiveColorClassNYC7{background-color:#c9cecf;transition:background .25s linear}.sunReactiveColorClassNYC8{background-color:#d6dadb;transition:background .25s linear}.sunReactiveColorClassNYC9{background-color:#e4e6e7;transition:background .25s linear}.sunReactiveColorClassNYC10{background-color:#fff;transition:background .25s linear}.btn-mattChillOffNYC,.btn-mattChillOffNYC.active,.btn-mattChillOffNYC:active,.btn-mattChillOffNYC:active:focus,.btn-mattChillOffNYC:focus,.open>.dropdown-toggle.btn-mattChillOffNYC{color:#fff;background-color:var(--main-stopNYC-color);border-width:2px;border-color:transparent}.btn-mattChillOffNYC:active:hover,.btn-mattChillOffNYC:hover,.btn-mattChillOnNYC,.btn-mattChillOnNYC.active,.btn-mattChillOnNYC:active,.btn-mattChillOnNYC:active:focus,.btn-mattChillOnNYC:focus,.open>.dropdown-toggle.btn-mattChillOnNYC{color:#000;background-color:var(--main-startNYC-color);border-width:2px;border-color:transparent}.btn-mattChillOnNYC:active:hover,.btn-mattChillOnNYC:hover{color:#fff;background-color:var(--main-stopNYC-color);border-width:2px;border-color:transparent}.btn-helpBtn1NYC,.btn-helpBtn1NYC:active,.btn-helpBtn1NYC:active:focus,.btn-helpBtn1NYC:focus,.open>.dropdown-toggle.btn-helpBtn1NYC{color:#000;background-color:transparent;border-color:transparent;border-width:2px}.btn-helpBtn1NYC:active:hover,.btn-helpBtn1NYC:hover{color:gold;background-color:transparent;border-color:gold;border-width:2px}.btn-helpBtn2NYC,.btn-helpBtn2NYC:active,.btn-helpBtn2NYC:active:focus,.btn-helpBtn2NYC:active:hover,.btn-helpBtn2NYC:focus,.btn-helpBtn2NYC:hover,.open>.dropdown-toggle.btn-helpBtn2NYC{background:var(--main-fxBadgesNYC-color);color:gold;border-color:transparent;box-shadow:0 4px 4px 1px rgba(0,0,0,.4);text-shadow:0 1px 2px rgba(0,0,0,.4)}.btn-playNYC,.btn-playNYC:active,.btn-playNYC:active:focus,.btn-playNYC:active:hover,.btn-playNYC:focus,.btn-playNYC:hover,.open>.dropdown-toggle.btn-playNYC{color:#000;background-color:var(--main-startNYC-color);border-color:var(--main-startNYC-color);border-width:2px;box-shadow:0 4px 4px 1px rgba(0,0,0,.2);text-shadow:0 1px 2px rgba(0,0,0,.4)}.btn-stopNYC,.btn-stopNYC:active,.btn-stopNYC:active:focus,.btn-stopNYC:active:hover,.btn-stopNYC:focus,.btn-stopNYC:hover,.open>.dropdown-toggle.btn-stopNYC{color:#fff;background-color:var(--main-stopNYC-color);border-color:var(--main-stopNYC-color);border-width:2px;box-shadow:0 4px 4px 1px rgba(0,0,0,.4);text-shadow:0 1px 2px rgba(0,0,0,.4)}.btn-micOpenBtnNYC,.btn-micOpenBtnNYC:active,.btn-micOpenBtnNYC:active:focus,.btn-micOpenBtnNYC:active:hover .open>.dropdown-toggle.btn-micOpenBtnNYC,.btn-micOpenBtnNYC:focus,.btn-micOpenBtnNYC:hover{color:#fff;background-color:var(--main-stopNYC-color);border-color:transparent;border-width:2px}.btn-micClosedBtnNYC,.btn-micClosedBtnNYC:active,.btn-micClosedBtnNYC:active:focus,.btn-micClosedBtnNYC:active:hover .Closed>.dropdown-toggle.btn-micClosedBtnNYC,.btn-micClosedBtnNYC:focus,.btn-micClosedBtnNYC:hover{color:#000;background-color:var(--main-startNYC-color);border-color:transparent;border-width:2px}input[class=instrumentRangerNYC]{background:var(--main-fxBadgesNYC-color)}input[class=instrumentRangerNYC]::-moz-range-track{background:var(--main-fxBadgesNYC-color)}input[class=instrumentRangerNYC]::-webkit-slider-thumb{background:var(--main-fxBadgesNYC-color)}input[class=instrumentRangerNYC]::-moz-range-thumb{background:var(--main-fxBadgesNYC-color)}input[class=instrumentRangerNYC]::-ms-thumb{background:#000}input[class=instrumentRangerNYC]::-ms-fill-upper{background:#2e5bce}input[class=instrumentRangerNYC]::-ms-fill-lower{background:gold}input[class=ambianceRangerStopNYC]{background-color:var(--main-stopNYC-color)}input[class=ambianceRangerStopNYC]::-webkit-slider-thumb{background:var(--main-stopNYC-color)}input[class=ambianceRangerStopNYC]::-moz-range-track{background-color:var(--main-stopNYC-color)}input[class=ambianceRangerStopNYC]::-moz-range-thumb{background:var(--main-stopNYC-color)}input[class=ambianceRangerStopNYC]::-ms-thumb{background:#000}input[class=ambianceRangerStopNYC]::-ms-fill-upper{background:#2e5bce}input[class=ambianceRangerStopNYC]::-ms-fill-lower{background:gold}input[class=ambianceRangerPlayNYC]{background-color:var(--main-startNYC-color)}input[class=ambianceRangerPlayNYC]::-webkit-slider-thumb{background:var(--main-startNYC-color)}input[class=ambianceRangerPlayNYC]::-moz-range-track{background-color:var(--main-startNYC-color)}input[class=ambianceRangerPlayNYC]::-moz-range-thumb{background:var(--main-startNYC-color)}input[class=ambianceRangerPlayNYC]::-ms-thumb{background:#838bc5}input[class=ambianceRangerPlayNYC]::-ms-fill-upper{background:#ba9bc9}input[class=ambianceRangerPlayNYC]::-ms-fill-lower{background:#65c8d0}.recordingClassDisengagedNYC{background:var(--main-fxBadgesNYC-color);color:var(--main-startNYC-color);box-shadow:0 4px 4px 1px rgba(0,0,0,.4)}.recordingClassDisengagedNYC,.recordingClassEngagedNYC{border-color:transparent;text-shadow:0 1px 2px rgba(0,0,0,.4)}.recordingClassEngagedNYC{background:var(--main-startNYC-color);color:var(--main-fxBadgesNYC-color);box-shadow:0 4px 4px 1px rgba(0,0,0,.2)}.btn-speechSubmitOff,.btn-speechSubmitOff:active,.btn-speechSubmitOff:active:focus,.btn-speechSubmitOff:active:hover,.btn-speechSubmitOff:focus,.btn-speechSubmitOff:hover,.open>.dropdown-toggle.btn-speechSubmitOff{color:var(--main-startNYC-color);background-color:var(--main-fxBadgesNYC-color);border-color:var(--main-fxBadgesNYC-color);border-width:2px;box-shadow:0 4px 4px 1px rgba(0,0,0,.4);text-shadow:0 1px 2px rgba(0,0,0,.4)}.btn-speechSubmitOn,.btn-speechSubmitOn:active,.btn-speechSubmitOn:active:focus,.btn-speechSubmitOn:active:hover,.btn-speechSubmitOn:focus,.btn-speechSubmitOn:hover,.open>.dropdown-toggle.btn-speechSubmitOn{color:#fff;background-color:var(--main-startNYC-color);border-color:var(--main-startNYC-color);border-width:2px;box-shadow:0 4px 4px 1px transparent;text-shadow:0 6px 2px rgba(0,0,0,.4)}#voiceCommandListID{color:var(--main-startNYC-color);background-color:var(--main-fxBadgesNYC-color)}.voiceBadgeNYC{background:var(--main-fxBadgesNYC-color);color:#000}", ""]);

// exports


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*global define:false */
/**
 * Copyright 2012-2017 Craig Campbell
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Mousetrap is a simple keyboard shortcut library for Javascript with
 * no external dependencies
 *
 * @version 1.6.1
 * @url craig.is/killing/mice
 */
(function(window, document, undefined) {

    // Check if mousetrap is used inside browser, if not, return
    if (!window) {
        return;
    }

    /**
     * mapping of special keycodes to their corresponding keys
     *
     * everything in this dictionary cannot use keypress events
     * so it has to be here to map to the correct keycodes for
     * keyup/keydown events
     *
     * @type {Object}
     */
    var _MAP = {
        8: 'backspace',
        9: 'tab',
        13: 'enter',
        16: 'shift',
        17: 'ctrl',
        18: 'alt',
        20: 'capslock',
        27: 'esc',
        32: 'space',
        33: 'pageup',
        34: 'pagedown',
        35: 'end',
        36: 'home',
        37: 'left',
        38: 'up',
        39: 'right',
        40: 'down',
        45: 'ins',
        46: 'del',
        91: 'meta',
        93: 'meta',
        224: 'meta'
    };

    /**
     * mapping for special characters so they can support
     *
     * this dictionary is only used incase you want to bind a
     * keyup or keydown event to one of these keys
     *
     * @type {Object}
     */
    var _KEYCODE_MAP = {
        106: '*',
        107: '+',
        109: '-',
        110: '.',
        111 : '/',
        186: ';',
        187: '=',
        188: ',',
        189: '-',
        190: '.',
        191: '/',
        192: '`',
        219: '[',
        220: '\\',
        221: ']',
        222: '\''
    };

    /**
     * this is a mapping of keys that require shift on a US keypad
     * back to the non shift equivelents
     *
     * this is so you can use keyup events with these keys
     *
     * note that this will only work reliably on US keyboards
     *
     * @type {Object}
     */
    var _SHIFT_MAP = {
        '~': '`',
        '!': '1',
        '@': '2',
        '#': '3',
        '$': '4',
        '%': '5',
        '^': '6',
        '&': '7',
        '*': '8',
        '(': '9',
        ')': '0',
        '_': '-',
        '+': '=',
        ':': ';',
        '\"': '\'',
        '<': ',',
        '>': '.',
        '?': '/',
        '|': '\\'
    };

    /**
     * this is a list of special strings you can use to map
     * to modifier keys when you specify your keyboard shortcuts
     *
     * @type {Object}
     */
    var _SPECIAL_ALIASES = {
        'option': 'alt',
        'command': 'meta',
        'return': 'enter',
        'escape': 'esc',
        'plus': '+',
        'mod': /Mac|iPod|iPhone|iPad/.test(navigator.platform) ? 'meta' : 'ctrl'
    };

    /**
     * variable to store the flipped version of _MAP from above
     * needed to check if we should use keypress or not when no action
     * is specified
     *
     * @type {Object|undefined}
     */
    var _REVERSE_MAP;

    /**
     * loop through the f keys, f1 to f19 and add them to the map
     * programatically
     */
    for (var i = 1; i < 20; ++i) {
        _MAP[111 + i] = 'f' + i;
    }

    /**
     * loop through to map numbers on the numeric keypad
     */
    for (i = 0; i <= 9; ++i) {

        // This needs to use a string cause otherwise since 0 is falsey
        // mousetrap will never fire for numpad 0 pressed as part of a keydown
        // event.
        //
        // @see https://github.com/ccampbell/mousetrap/pull/258
        _MAP[i + 96] = i.toString();
    }

    /**
     * cross browser add event method
     *
     * @param {Element|HTMLDocument} object
     * @param {string} type
     * @param {Function} callback
     * @returns void
     */
    function _addEvent(object, type, callback) {
        if (object.addEventListener) {
            object.addEventListener(type, callback, false);
            return;
        }

        object.attachEvent('on' + type, callback);
    }

    /**
     * takes the event and returns the key character
     *
     * @param {Event} e
     * @return {string}
     */
    function _characterFromEvent(e) {

        // for keypress events we should return the character as is
        if (e.type == 'keypress') {
            var character = String.fromCharCode(e.which);

            // if the shift key is not pressed then it is safe to assume
            // that we want the character to be lowercase.  this means if
            // you accidentally have caps lock on then your key bindings
            // will continue to work
            //
            // the only side effect that might not be desired is if you
            // bind something like 'A' cause you want to trigger an
            // event when capital A is pressed caps lock will no longer
            // trigger the event.  shift+a will though.
            if (!e.shiftKey) {
                character = character.toLowerCase();
            }

            return character;
        }

        // for non keypress events the special maps are needed
        if (_MAP[e.which]) {
            return _MAP[e.which];
        }

        if (_KEYCODE_MAP[e.which]) {
            return _KEYCODE_MAP[e.which];
        }

        // if it is not in the special map

        // with keydown and keyup events the character seems to always
        // come in as an uppercase character whether you are pressing shift
        // or not.  we should make sure it is always lowercase for comparisons
        return String.fromCharCode(e.which).toLowerCase();
    }

    /**
     * checks if two arrays are equal
     *
     * @param {Array} modifiers1
     * @param {Array} modifiers2
     * @returns {boolean}
     */
    function _modifiersMatch(modifiers1, modifiers2) {
        return modifiers1.sort().join(',') === modifiers2.sort().join(',');
    }

    /**
     * takes a key event and figures out what the modifiers are
     *
     * @param {Event} e
     * @returns {Array}
     */
    function _eventModifiers(e) {
        var modifiers = [];

        if (e.shiftKey) {
            modifiers.push('shift');
        }

        if (e.altKey) {
            modifiers.push('alt');
        }

        if (e.ctrlKey) {
            modifiers.push('ctrl');
        }

        if (e.metaKey) {
            modifiers.push('meta');
        }

        return modifiers;
    }

    /**
     * prevents default for this event
     *
     * @param {Event} e
     * @returns void
     */
    function _preventDefault(e) {
        if (e.preventDefault) {
            e.preventDefault();
            return;
        }

        e.returnValue = false;
    }

    /**
     * stops propogation for this event
     *
     * @param {Event} e
     * @returns void
     */
    function _stopPropagation(e) {
        if (e.stopPropagation) {
            e.stopPropagation();
            return;
        }

        e.cancelBubble = true;
    }

    /**
     * determines if the keycode specified is a modifier key or not
     *
     * @param {string} key
     * @returns {boolean}
     */
    function _isModifier(key) {
        return key == 'shift' || key == 'ctrl' || key == 'alt' || key == 'meta';
    }

    /**
     * reverses the map lookup so that we can look for specific keys
     * to see what can and can't use keypress
     *
     * @return {Object}
     */
    function _getReverseMap() {
        if (!_REVERSE_MAP) {
            _REVERSE_MAP = {};
            for (var key in _MAP) {

                // pull out the numeric keypad from here cause keypress should
                // be able to detect the keys from the character
                if (key > 95 && key < 112) {
                    continue;
                }

                if (_MAP.hasOwnProperty(key)) {
                    _REVERSE_MAP[_MAP[key]] = key;
                }
            }
        }
        return _REVERSE_MAP;
    }

    /**
     * picks the best action based on the key combination
     *
     * @param {string} key - character for key
     * @param {Array} modifiers
     * @param {string=} action passed in
     */
    function _pickBestAction(key, modifiers, action) {

        // if no action was picked in we should try to pick the one
        // that we think would work best for this key
        if (!action) {
            action = _getReverseMap()[key] ? 'keydown' : 'keypress';
        }

        // modifier keys don't work as expected with keypress,
        // switch to keydown
        if (action == 'keypress' && modifiers.length) {
            action = 'keydown';
        }

        return action;
    }

    /**
     * Converts from a string key combination to an array
     *
     * @param  {string} combination like "command+shift+l"
     * @return {Array}
     */
    function _keysFromString(combination) {
        if (combination === '+') {
            return ['+'];
        }

        combination = combination.replace(/\+{2}/g, '+plus');
        return combination.split('+');
    }

    /**
     * Gets info for a specific key combination
     *
     * @param  {string} combination key combination ("command+s" or "a" or "*")
     * @param  {string=} action
     * @returns {Object}
     */
    function _getKeyInfo(combination, action) {
        var keys;
        var key;
        var i;
        var modifiers = [];

        // take the keys from this pattern and figure out what the actual
        // pattern is all about
        keys = _keysFromString(combination);

        for (i = 0; i < keys.length; ++i) {
            key = keys[i];

            // normalize key names
            if (_SPECIAL_ALIASES[key]) {
                key = _SPECIAL_ALIASES[key];
            }

            // if this is not a keypress event then we should
            // be smart about using shift keys
            // this will only work for US keyboards however
            if (action && action != 'keypress' && _SHIFT_MAP[key]) {
                key = _SHIFT_MAP[key];
                modifiers.push('shift');
            }

            // if this key is a modifier then add it to the list of modifiers
            if (_isModifier(key)) {
                modifiers.push(key);
            }
        }

        // depending on what the key combination is
        // we will try to pick the best event for it
        action = _pickBestAction(key, modifiers, action);

        return {
            key: key,
            modifiers: modifiers,
            action: action
        };
    }

    function _belongsTo(element, ancestor) {
        if (element === null || element === document) {
            return false;
        }

        if (element === ancestor) {
            return true;
        }

        return _belongsTo(element.parentNode, ancestor);
    }

    function Mousetrap(targetElement) {
        var self = this;

        targetElement = targetElement || document;

        if (!(self instanceof Mousetrap)) {
            return new Mousetrap(targetElement);
        }

        /**
         * element to attach key events to
         *
         * @type {Element}
         */
        self.target = targetElement;

        /**
         * a list of all the callbacks setup via Mousetrap.bind()
         *
         * @type {Object}
         */
        self._callbacks = {};

        /**
         * direct map of string combinations to callbacks used for trigger()
         *
         * @type {Object}
         */
        self._directMap = {};

        /**
         * keeps track of what level each sequence is at since multiple
         * sequences can start out with the same sequence
         *
         * @type {Object}
         */
        var _sequenceLevels = {};

        /**
         * variable to store the setTimeout call
         *
         * @type {null|number}
         */
        var _resetTimer;

        /**
         * temporary state where we will ignore the next keyup
         *
         * @type {boolean|string}
         */
        var _ignoreNextKeyup = false;

        /**
         * temporary state where we will ignore the next keypress
         *
         * @type {boolean}
         */
        var _ignoreNextKeypress = false;

        /**
         * are we currently inside of a sequence?
         * type of action ("keyup" or "keydown" or "keypress") or false
         *
         * @type {boolean|string}
         */
        var _nextExpectedAction = false;

        /**
         * resets all sequence counters except for the ones passed in
         *
         * @param {Object} doNotReset
         * @returns void
         */
        function _resetSequences(doNotReset) {
            doNotReset = doNotReset || {};

            var activeSequences = false,
                key;

            for (key in _sequenceLevels) {
                if (doNotReset[key]) {
                    activeSequences = true;
                    continue;
                }
                _sequenceLevels[key] = 0;
            }

            if (!activeSequences) {
                _nextExpectedAction = false;
            }
        }

        /**
         * finds all callbacks that match based on the keycode, modifiers,
         * and action
         *
         * @param {string} character
         * @param {Array} modifiers
         * @param {Event|Object} e
         * @param {string=} sequenceName - name of the sequence we are looking for
         * @param {string=} combination
         * @param {number=} level
         * @returns {Array}
         */
        function _getMatches(character, modifiers, e, sequenceName, combination, level) {
            var i;
            var callback;
            var matches = [];
            var action = e.type;

            // if there are no events related to this keycode
            if (!self._callbacks[character]) {
                return [];
            }

            // if a modifier key is coming up on its own we should allow it
            if (action == 'keyup' && _isModifier(character)) {
                modifiers = [character];
            }

            // loop through all callbacks for the key that was pressed
            // and see if any of them match
            for (i = 0; i < self._callbacks[character].length; ++i) {
                callback = self._callbacks[character][i];

                // if a sequence name is not specified, but this is a sequence at
                // the wrong level then move onto the next match
                if (!sequenceName && callback.seq && _sequenceLevels[callback.seq] != callback.level) {
                    continue;
                }

                // if the action we are looking for doesn't match the action we got
                // then we should keep going
                if (action != callback.action) {
                    continue;
                }

                // if this is a keypress event and the meta key and control key
                // are not pressed that means that we need to only look at the
                // character, otherwise check the modifiers as well
                //
                // chrome will not fire a keypress if meta or control is down
                // safari will fire a keypress if meta or meta+shift is down
                // firefox will fire a keypress if meta or control is down
                if ((action == 'keypress' && !e.metaKey && !e.ctrlKey) || _modifiersMatch(modifiers, callback.modifiers)) {

                    // when you bind a combination or sequence a second time it
                    // should overwrite the first one.  if a sequenceName or
                    // combination is specified in this call it does just that
                    //
                    // @todo make deleting its own method?
                    var deleteCombo = !sequenceName && callback.combo == combination;
                    var deleteSequence = sequenceName && callback.seq == sequenceName && callback.level == level;
                    if (deleteCombo || deleteSequence) {
                        self._callbacks[character].splice(i, 1);
                    }

                    matches.push(callback);
                }
            }

            return matches;
        }

        /**
         * actually calls the callback function
         *
         * if your callback function returns false this will use the jquery
         * convention - prevent default and stop propogation on the event
         *
         * @param {Function} callback
         * @param {Event} e
         * @returns void
         */
        function _fireCallback(callback, e, combo, sequence) {

            // if this event should not happen stop here
            if (self.stopCallback(e, e.target || e.srcElement, combo, sequence)) {
                return;
            }

            if (callback(e, combo) === false) {
                _preventDefault(e);
                _stopPropagation(e);
            }
        }

        /**
         * handles a character key event
         *
         * @param {string} character
         * @param {Array} modifiers
         * @param {Event} e
         * @returns void
         */
        self._handleKey = function(character, modifiers, e) {
            var callbacks = _getMatches(character, modifiers, e);
            var i;
            var doNotReset = {};
            var maxLevel = 0;
            var processedSequenceCallback = false;

            // Calculate the maxLevel for sequences so we can only execute the longest callback sequence
            for (i = 0; i < callbacks.length; ++i) {
                if (callbacks[i].seq) {
                    maxLevel = Math.max(maxLevel, callbacks[i].level);
                }
            }

            // loop through matching callbacks for this key event
            for (i = 0; i < callbacks.length; ++i) {

                // fire for all sequence callbacks
                // this is because if for example you have multiple sequences
                // bound such as "g i" and "g t" they both need to fire the
                // callback for matching g cause otherwise you can only ever
                // match the first one
                if (callbacks[i].seq) {

                    // only fire callbacks for the maxLevel to prevent
                    // subsequences from also firing
                    //
                    // for example 'a option b' should not cause 'option b' to fire
                    // even though 'option b' is part of the other sequence
                    //
                    // any sequences that do not match here will be discarded
                    // below by the _resetSequences call
                    if (callbacks[i].level != maxLevel) {
                        continue;
                    }

                    processedSequenceCallback = true;

                    // keep a list of which sequences were matches for later
                    doNotReset[callbacks[i].seq] = 1;
                    _fireCallback(callbacks[i].callback, e, callbacks[i].combo, callbacks[i].seq);
                    continue;
                }

                // if there were no sequence matches but we are still here
                // that means this is a regular match so we should fire that
                if (!processedSequenceCallback) {
                    _fireCallback(callbacks[i].callback, e, callbacks[i].combo);
                }
            }

            // if the key you pressed matches the type of sequence without
            // being a modifier (ie "keyup" or "keypress") then we should
            // reset all sequences that were not matched by this event
            //
            // this is so, for example, if you have the sequence "h a t" and you
            // type "h e a r t" it does not match.  in this case the "e" will
            // cause the sequence to reset
            //
            // modifier keys are ignored because you can have a sequence
            // that contains modifiers such as "enter ctrl+space" and in most
            // cases the modifier key will be pressed before the next key
            //
            // also if you have a sequence such as "ctrl+b a" then pressing the
            // "b" key will trigger a "keypress" and a "keydown"
            //
            // the "keydown" is expected when there is a modifier, but the
            // "keypress" ends up matching the _nextExpectedAction since it occurs
            // after and that causes the sequence to reset
            //
            // we ignore keypresses in a sequence that directly follow a keydown
            // for the same character
            var ignoreThisKeypress = e.type == 'keypress' && _ignoreNextKeypress;
            if (e.type == _nextExpectedAction && !_isModifier(character) && !ignoreThisKeypress) {
                _resetSequences(doNotReset);
            }

            _ignoreNextKeypress = processedSequenceCallback && e.type == 'keydown';
        };

        /**
         * handles a keydown event
         *
         * @param {Event} e
         * @returns void
         */
        function _handleKeyEvent(e) {

            // normalize e.which for key events
            // @see http://stackoverflow.com/questions/4285627/javascript-keycode-vs-charcode-utter-confusion
            if (typeof e.which !== 'number') {
                e.which = e.keyCode;
            }

            var character = _characterFromEvent(e);

            // no character found then stop
            if (!character) {
                return;
            }

            // need to use === for the character check because the character can be 0
            if (e.type == 'keyup' && _ignoreNextKeyup === character) {
                _ignoreNextKeyup = false;
                return;
            }

            self.handleKey(character, _eventModifiers(e), e);
        }

        /**
         * called to set a 1 second timeout on the specified sequence
         *
         * this is so after each key press in the sequence you have 1 second
         * to press the next key before you have to start over
         *
         * @returns void
         */
        function _resetSequenceTimer() {
            clearTimeout(_resetTimer);
            _resetTimer = setTimeout(_resetSequences, 1000);
        }

        /**
         * binds a key sequence to an event
         *
         * @param {string} combo - combo specified in bind call
         * @param {Array} keys
         * @param {Function} callback
         * @param {string=} action
         * @returns void
         */
        function _bindSequence(combo, keys, callback, action) {

            // start off by adding a sequence level record for this combination
            // and setting the level to 0
            _sequenceLevels[combo] = 0;

            /**
             * callback to increase the sequence level for this sequence and reset
             * all other sequences that were active
             *
             * @param {string} nextAction
             * @returns {Function}
             */
            function _increaseSequence(nextAction) {
                return function() {
                    _nextExpectedAction = nextAction;
                    ++_sequenceLevels[combo];
                    _resetSequenceTimer();
                };
            }

            /**
             * wraps the specified callback inside of another function in order
             * to reset all sequence counters as soon as this sequence is done
             *
             * @param {Event} e
             * @returns void
             */
            function _callbackAndReset(e) {
                _fireCallback(callback, e, combo);

                // we should ignore the next key up if the action is key down
                // or keypress.  this is so if you finish a sequence and
                // release the key the final key will not trigger a keyup
                if (action !== 'keyup') {
                    _ignoreNextKeyup = _characterFromEvent(e);
                }

                // weird race condition if a sequence ends with the key
                // another sequence begins with
                setTimeout(_resetSequences, 10);
            }

            // loop through keys one at a time and bind the appropriate callback
            // function.  for any key leading up to the final one it should
            // increase the sequence. after the final, it should reset all sequences
            //
            // if an action is specified in the original bind call then that will
            // be used throughout.  otherwise we will pass the action that the
            // next key in the sequence should match.  this allows a sequence
            // to mix and match keypress and keydown events depending on which
            // ones are better suited to the key provided
            for (var i = 0; i < keys.length; ++i) {
                var isFinal = i + 1 === keys.length;
                var wrappedCallback = isFinal ? _callbackAndReset : _increaseSequence(action || _getKeyInfo(keys[i + 1]).action);
                _bindSingle(keys[i], wrappedCallback, action, combo, i);
            }
        }

        /**
         * binds a single keyboard combination
         *
         * @param {string} combination
         * @param {Function} callback
         * @param {string=} action
         * @param {string=} sequenceName - name of sequence if part of sequence
         * @param {number=} level - what part of the sequence the command is
         * @returns void
         */
        function _bindSingle(combination, callback, action, sequenceName, level) {

            // store a direct mapped reference for use with Mousetrap.trigger
            self._directMap[combination + ':' + action] = callback;

            // make sure multiple spaces in a row become a single space
            combination = combination.replace(/\s+/g, ' ');

            var sequence = combination.split(' ');
            var info;

            // if this pattern is a sequence of keys then run through this method
            // to reprocess each pattern one key at a time
            if (sequence.length > 1) {
                _bindSequence(combination, sequence, callback, action);
                return;
            }

            info = _getKeyInfo(combination, action);

            // make sure to initialize array if this is the first time
            // a callback is added for this key
            self._callbacks[info.key] = self._callbacks[info.key] || [];

            // remove an existing match if there is one
            _getMatches(info.key, info.modifiers, {type: info.action}, sequenceName, combination, level);

            // add this call back to the array
            // if it is a sequence put it at the beginning
            // if not put it at the end
            //
            // this is important because the way these are processed expects
            // the sequence ones to come first
            self._callbacks[info.key][sequenceName ? 'unshift' : 'push']({
                callback: callback,
                modifiers: info.modifiers,
                action: info.action,
                seq: sequenceName,
                level: level,
                combo: combination
            });
        }

        /**
         * binds multiple combinations to the same callback
         *
         * @param {Array} combinations
         * @param {Function} callback
         * @param {string|undefined} action
         * @returns void
         */
        self._bindMultiple = function(combinations, callback, action) {
            for (var i = 0; i < combinations.length; ++i) {
                _bindSingle(combinations[i], callback, action);
            }
        };

        // start!
        _addEvent(targetElement, 'keypress', _handleKeyEvent);
        _addEvent(targetElement, 'keydown', _handleKeyEvent);
        _addEvent(targetElement, 'keyup', _handleKeyEvent);
    }

    /**
     * binds an event to mousetrap
     *
     * can be a single key, a combination of keys separated with +,
     * an array of keys, or a sequence of keys separated by spaces
     *
     * be sure to list the modifier keys first to make sure that the
     * correct key ends up getting bound (the last key in the pattern)
     *
     * @param {string|Array} keys
     * @param {Function} callback
     * @param {string=} action - 'keypress', 'keydown', or 'keyup'
     * @returns void
     */
    Mousetrap.prototype.bind = function(keys, callback, action) {
        var self = this;
        keys = keys instanceof Array ? keys : [keys];
        self._bindMultiple.call(self, keys, callback, action);
        return self;
    };

    /**
     * unbinds an event to mousetrap
     *
     * the unbinding sets the callback function of the specified key combo
     * to an empty function and deletes the corresponding key in the
     * _directMap dict.
     *
     * TODO: actually remove this from the _callbacks dictionary instead
     * of binding an empty function
     *
     * the keycombo+action has to be exactly the same as
     * it was defined in the bind method
     *
     * @param {string|Array} keys
     * @param {string} action
     * @returns void
     */
    Mousetrap.prototype.unbind = function(keys, action) {
        var self = this;
        return self.bind.call(self, keys, function() {}, action);
    };

    /**
     * triggers an event that has already been bound
     *
     * @param {string} keys
     * @param {string=} action
     * @returns void
     */
    Mousetrap.prototype.trigger = function(keys, action) {
        var self = this;
        if (self._directMap[keys + ':' + action]) {
            self._directMap[keys + ':' + action]({}, keys);
        }
        return self;
    };

    /**
     * resets the library back to its initial state.  this is useful
     * if you want to clear out the current keyboard shortcuts and bind
     * new ones - for example if you switch to another page
     *
     * @returns void
     */
    Mousetrap.prototype.reset = function() {
        var self = this;
        self._callbacks = {};
        self._directMap = {};
        return self;
    };

    /**
     * should we stop this event before firing off callbacks
     *
     * @param {Event} e
     * @param {Element} element
     * @return {boolean}
     */
    Mousetrap.prototype.stopCallback = function(e, element) {
        var self = this;

        // if the element has the class "mousetrap" then no need to stop
        if ((' ' + element.className + ' ').indexOf(' mousetrap ') > -1) {
            return false;
        }

        if (_belongsTo(element, self.target)) {
            return false;
        }

        // stop for input, select, and textarea
        return element.tagName == 'INPUT' || element.tagName == 'SELECT' || element.tagName == 'TEXTAREA' || element.isContentEditable;
    };

    /**
     * exposes _handleKey publicly so it can be overwritten by extensions
     */
    Mousetrap.prototype.handleKey = function() {
        var self = this;
        return self._handleKey.apply(self, arguments);
    };

    /**
     * allow custom key mappings
     */
    Mousetrap.addKeycodes = function(object) {
        for (var key in object) {
            if (object.hasOwnProperty(key)) {
                _MAP[key] = object[key];
            }
        }
        _REVERSE_MAP = null;
    };

    /**
     * Init the global mousetrap functions
     *
     * This method is needed to allow the global mousetrap functions to work
     * now that mousetrap is a constructor function.
     */
    Mousetrap.init = function() {
        var documentMousetrap = Mousetrap(document);
        for (var method in documentMousetrap) {
            if (method.charAt(0) !== '_') {
                Mousetrap[method] = (function(method) {
                    return function() {
                        return documentMousetrap[method].apply(documentMousetrap, arguments);
                    };
                } (method));
            }
        }
    };

    Mousetrap.init();

    // expose mousetrap to the global object
    window.Mousetrap = Mousetrap;

    // expose as a common js module
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = Mousetrap;
    }

    // expose mousetrap as an AMD module
    if (true) {
        !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
            return Mousetrap;
        }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }
}) (typeof window !== 'undefined' ? window : null, typeof  window !== 'undefined' ? document : null);


/***/ }),
/* 55 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(20), __webpack_require__(55)))

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(56);
exports.setImmediate = setImmediate;
exports.clearImmediate = clearImmediate;


/***/ }),
/* 58 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    class: _vm.plungeClass,
    attrs: {
      "id": "mainDiv"
    }
  }, [(this.$store.state.allowSpeechControl) ? _c('div', [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated pulse",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAllControls),
      expression: "showAllControls"
    }],
    staticClass: "container-fluid",
    attrs: {
      "id": "VUIformInputDivID"
    }
  }, [_c('div', {
    staticClass: "col-xs-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userVoiceToText),
      expression: "userVoiceToText"
    }],
    staticClass: "form-control",
    class: _vm.plungeClass,
    staticStyle: {
      "color": "white !important",
      "border-width": "0px"
    },
    attrs: {
      "type": "text",
      "id": "inlineFormInputGroupUsername2",
      "placeholder": "View & Type Voice Commands Here"
    },
    domProps: {
      "value": (_vm.userVoiceToText)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.userVoiceToTextFunc($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userVoiceToText = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  }, [(_vm.initSpeech) ? _c('span', {
    on: {
      "click": _vm.speechFunc
    }
  }, [_c('i', {
    staticClass: "fal fa-microphone-slash",
    attrs: {
      "id": "speechEngage"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.initSpeech) ? _c('span', {
    on: {
      "click": _vm.speechStartStopFunc
    }
  }, [_c('i', {
    staticClass: "fa fa-microphone-alt",
    style: ({
      'color': _vm.recognizing ? 'red' : 'black'
    }),
    attrs: {
      "id": "speechEngageActivated"
    }
  })]) : _vm._e()])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showEnterContainer),
      expression: "showEnterContainer"
    }],
    staticClass: "container-fluid",
    attrs: {
      "id": "enterContainer"
    }
  }, [_c('transition', {
    attrs: {
      "appear": "",
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated zoomOutLeft",
      "mode": "out-in"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showEnterBtn),
      expression: "showEnterBtn"
    }],
    staticClass: "btn-info",
    staticStyle: {
      "color": "black",
      "background-color": "#fdfbe7"
    },
    attrs: {
      "id": "enterFuncBtn"
    },
    on: {
      "~click": function($event) {
        return _vm.enterFunc($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tWALKABOUT\n\t\t\t\t\t")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLoading),
      expression: "showLoading"
    }],
    staticStyle: {
      "color": "white",
      "border-color": "transparent",
      "background": "transparent"
    },
    attrs: {
      "id": "enterFuncBtn"
    }
  }, [_vm._v(" \t\n\t\t\t\t\t\t\tLoading... \n\t\t\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\t\t\t " + _vm._s(_vm.whatIsLoading) + "\n\t\t\t\t\t")])])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAllControls),
      expression: "showAllControls"
    }],
    staticClass: "container-fluid",
    attrs: {
      "id": "controlsContainer"
    }
  }, [_c('div', {
    attrs: {
      "id": "ambienceBtnLocation"
    }
  }, [(!_vm.userMobile) ? _c('p', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "fxTitle"
    }
  }, [_vm._v(" \n\t\t\t\t\t\t\tAdd "), _c('i', {
    staticClass: "fal fa-check-circle"
  }), _vm._v(" or Remove "), _c('i', {
    staticClass: "fal fa-times-circle"
  }), _vm._v(" Sounds From Your "), _c('span', {
    attrs: {
      "id": "soundscapeTitleBreak"
    }
  }, [_vm._v("Grasslands Soundscape")])]) : (_vm.userMobile) ? _c('p', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "fxTitle"
    }
  }, [_vm._v(" \n\t\t\t\t\t\t\tSounds of the Grasslands")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn1Div"
    }
  }, [_c('button', {
    class: _vm.ambience1Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience1Func
    },
    on: {
      "click": function($event) {
        _vm.ambience1Boolean = !_vm.ambience1Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience1Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tAmerican Robin\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ambience1Vol),
      expression: "ambience1Vol"
    }],
    class: _vm.ambiance1RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience1Func,
      "max": "2",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience1Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience1Vol = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn2Div"
    }
  }, [_c('button', {
    class: _vm.ambience2Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience2Func
    },
    on: {
      "click": function($event) {
        _vm.ambience2Boolean = !_vm.ambience2Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience2Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tC. Yellowthroat\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ambience2Vol),
      expression: "ambience2Vol"
    }],
    class: _vm.ambiance2RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience2Func,
      "max": "5",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience2Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience2Vol = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn3Div"
    }
  }, [_c('button', {
    class: _vm.ambience3Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience3Func
    },
    on: {
      "click": function($event) {
        _vm.ambience3Boolean = !_vm.ambience3Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience3Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tLong Grass\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ambience3Vol),
      expression: "ambience3Vol"
    }],
    class: _vm.ambiance3RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience3Func,
      "max": "5",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience3Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience3Vol = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn4Div"
    }
  }, [_c('button', {
    class: _vm.ambience4Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience4Func
    },
    on: {
      "click": function($event) {
        _vm.ambience4Boolean = !_vm.ambience4Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience4Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tBison\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ambience4Vol),
      expression: "ambience4Vol"
    }],
    class: _vm.ambiance4RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience4Func,
      "max": "0",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience4Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience4Vol = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn5Div"
    }
  }, [_c('button', {
    class: _vm.ambience5Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience5Func
    },
    on: {
      "click": function($event) {
        _vm.ambience5Boolean = !_vm.ambience5Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience5Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tInsects\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ambience5Vol),
      expression: "ambience5Vol"
    }],
    class: _vm.ambiance5RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience5Func,
      "max": "5",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience5Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience5Vol = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn6Div"
    }
  }, [_c('button', {
    class: _vm.ambience6Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience6Func
    },
    on: {
      "click": function($event) {
        _vm.ambience6Boolean = !_vm.ambience6Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience6Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tThunderstorm\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ambience6Vol),
      expression: "ambience6Vol"
    }],
    class: _vm.ambiance6RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience6Func,
      "max": "6",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience6Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience6Vol = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "masterControlDiv"
    }
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "fxTitle2"
    }
  }, [_vm._v(" \n\t\t\tProcess Soundscape With Digital Audio Processing\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice1SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voiceBadgePlains",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.speedToggle = !_vm.speedToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.speedToggle),
      expression: "speedToggle"
    }],
    staticStyle: {
      "color": "var(--main-startPlains-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tSpeed " + _vm._s(((_vm.playBackSpeed).toPrecision(3))) + "x\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.speedToggle),
      expression: "!speedToggle"
    }],
    staticStyle: {
      "color": "var(--main-stopPlains-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tSpeed " + _vm._s(((_vm.playBackSpeed).toPrecision(3))) + "x\n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.playBackSpeed),
      expression: "playBackSpeed",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "instrumentRangerPlains",
    attrs: {
      "id": "sliders6",
      "type": "range",
      "step": "0.01",
      "max": "2",
      "min": "0.1",
      "": _vm.playbackSpeedFunc
    },
    domProps: {
      "value": (_vm.playBackSpeed)
    },
    on: {
      "__r": function($event) {
        _vm.playBackSpeed = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice2SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voiceBadgePlains",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.fxDelayToggle = !_vm.fxDelayToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fxDelayToggle),
      expression: "fxDelayToggle"
    }],
    staticStyle: {
      "color": "var(--main-startPlains-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tDelay " + _vm._s(_vm.fxDelayAmt) + "% \n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fxDelayToggle),
      expression: "!fxDelayToggle"
    }],
    staticStyle: {
      "color": "var(--main-stopPlains-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tDelay " + _vm._s(_vm.fxDelayAmt) + "% \n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fxDelayAmt),
      expression: "fxDelayAmt"
    }],
    staticClass: "instrumentRangerPlains",
    attrs: {
      "id": "sliders2",
      "type": "range",
      "step": "1",
      "max": "100",
      "min": "0",
      "": _vm.fxDelayMix
    },
    domProps: {
      "value": (_vm.fxDelayAmt)
    },
    on: {
      "__r": function($event) {
        _vm.fxDelayAmt = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice3SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voiceBadgePlains",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.fxChorusToggle = !_vm.fxChorusToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fxChorusToggle),
      expression: "fxChorusToggle"
    }],
    staticStyle: {
      "color": "var(--main-startPlains-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tChorus " + _vm._s(_vm.fxChorusAmt) + "% \n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fxChorusToggle),
      expression: "!fxChorusToggle"
    }],
    staticStyle: {
      "color": "var(--main-stopPlains-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tChorus " + _vm._s(_vm.fxChorusAmt) + "% \n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fxChorusAmt),
      expression: "fxChorusAmt"
    }],
    staticClass: "instrumentRangerPlains",
    attrs: {
      "id": "sliders3",
      "type": "range",
      "step": "1",
      "max": "100",
      "min": "0",
      "": _vm.fxChorusMix
    },
    domProps: {
      "value": (_vm.fxChorusAmt)
    },
    on: {
      "__r": function($event) {
        _vm.fxChorusAmt = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice4SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voiceBadgePlains",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.fxFilterToggle = !_vm.fxFilterToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fxFilterToggle),
      expression: "fxFilterToggle"
    }],
    staticStyle: {
      "color": "var(--main-startPlains-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tFilter " + _vm._s(_vm.fxAutoFilterAmt) + "Hz\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fxFilterToggle),
      expression: "!fxFilterToggle"
    }],
    staticStyle: {
      "color": "var(--main-stopPlains-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tFilter " + _vm._s(_vm.fxAutoFilterAmt) + "Hz\n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fxAutoFilterAmt),
      expression: "fxAutoFilterAmt"
    }],
    staticClass: "instrumentRangerPlains",
    attrs: {
      "id": "sliders4",
      "type": "range",
      "step": "1",
      "max": "10000",
      "min": "80",
      "": _vm.fxAutoFilterMix
    },
    domProps: {
      "value": (_vm.fxAutoFilterAmt)
    },
    on: {
      "__r": function($event) {
        _vm.fxAutoFilterAmt = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice5SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voiceBadgePlains",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.fxConvolverToggle = !_vm.fxConvolverToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fxConvolverToggle),
      expression: "fxConvolverToggle"
    }],
    staticStyle: {
      "color": "var(--main-startPlains-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tReverb (" + _vm._s(((_vm.fxDecay).toPrecision(2))) + "s) " + _vm._s((_vm.fxConvolverAmt * 2)) + "%\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fxConvolverToggle),
      expression: "!fxConvolverToggle"
    }],
    staticStyle: {
      "color": "var(--main-stopPlains-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tReverb (" + _vm._s(((_vm.fxDecay).toPrecision(2))) + "s) " + _vm._s((_vm.fxConvolverAmt * 2)) + "%\n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fxConvolverAmt),
      expression: "fxConvolverAmt"
    }],
    staticClass: "instrumentRangerPlains",
    attrs: {
      "id": "sliders1",
      "type": "range",
      "step": "1",
      "max": "50",
      "min": "0",
      "": _vm.fxConvolverMix
    },
    domProps: {
      "value": (_vm.fxConvolverAmt)
    },
    on: {
      "__r": function($event) {
        _vm.fxConvolverAmt = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice6SliderDiv"
    }
  }, [_c('button', {
    class: _vm.mattChillClass,
    attrs: {
      "id": "masterControlBadgesSFX"
    },
    on: {
      "click": _vm.mattChillMethod
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.randomizeBoolean),
      expression: "!randomizeBoolean"
    }]
  }, [_c('i', {
    staticClass: "fa fa-flask"
  }), _vm._v(" Randomize "), _c('i', {
    staticClass: "fa fa-flask"
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.randomizeBoolean),
      expression: "randomizeBoolean"
    }]
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask5),
      expression: "showFlask5"
    }],
    staticClass: "fa fa-flask fa-counter-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask3),
      expression: "showFlask3"
    }],
    staticClass: "fa fa-flask fa-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask1),
      expression: "showFlask1"
    }],
    staticClass: "fa fa-flask slow-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask2),
      expression: "showFlask2"
    }],
    staticClass: "fa fa-flask slow-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask4),
      expression: "showFlask4"
    }],
    staticClass: "fa fa-flask fa-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask6),
      expression: "showFlask6"
    }],
    staticClass: "fa fa-flask fa-counter-spin"
  })])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAboutPage),
      expression: "showAboutPage"
    }],
    staticClass: "col-xs-12",
    attrs: {
      "id": "aboutPageID"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "aboutTxt"
    }
  }, [_c('br'), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t\tThe Grasslands of America are an open expanse, but don’t let its flat exposure fool you. This place is beaming with life. Sounds here are dynamic. They range from the soft winds passing through long grass to the immensely powerful roar of the bison. These recordings are from in and around Yellowstone National Park, North Dakota, and Western Wisconsin. \n\t\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t\tThe most intense aspect of this soundscape was gathering the bison roar. It all happened by chance, as I saw him on my way to a geyser in Yellowstone. He was having a stand off with three other male bison. I was able to steer clear of their gaze and get a microphone in position near one of the a male bison. The result is stunning, these animals are truly majestic.\n\t\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "disclaimerTxt"
    }
  }, [_vm._v("\n\t\t\t\t\t\tSound Design & Recordings Copyright © 2018 "), _c('a', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "href": "https://www.mattmccorkle.com",
      "target": "_blank"
    }
  }, [_vm._v("Matt McCorkle")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v(" These sounds are presented here for personal entertainment use only. ")]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t\tFor commercial sound licensing email hi@mattmccorkle.com\n\t\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    class: _vm.helpClass,
    attrs: {
      "id": "aboutBtnID2"
    },
    on: {
      "click": _vm.goToHelp
    }
  }, [_c('strong', [_c('i', {
    staticClass: "fa fa-window-close fa-3x"
  })])])])]), _vm._v(" "), (this.$store.state.allowSpeechControl) ? _c('div') : _vm._e(), _vm._v(" "), (this.$store.state.allowSpeechControl) ? _c('div', [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated pulse",
      "mode": "out-in"
    }
  }, [(_vm.showSpeechBtns) ? _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "speechContainer"
    }
  }, [_c('button', {
    class: _vm.speechShowListClass,
    attrs: {
      "id": "speechList"
    },
    on: {
      "click": _vm.voiceCommandListFunc
    }
  }, [_c('i', {
    staticClass: "fal fa-clipboard-list"
  }), _vm._v(" List of Voice Commands\n\t\t\t\t")]), _vm._v(" "), (_vm.showVoiceCommandList) ? _c('div', {
    attrs: {
      "id": "voiceCommandListID"
    }
  }, [_c('p', {
    attrs: {
      "id": "voiceControlListTitle"
    }
  }, [_c('strong', [_vm._v(" Voice Control This Immersive Experience")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "voiceControlListTxt"
    }
  }, [_c('strong', [_vm._v("Allow Google Chrome Microphone Access To Use This Feature")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "fal fa-headphones"
  }), _vm._v(" Voice Control Works "), _c('strong', [_c('u', [_vm._v("Great")])]), _vm._v(" With Headphones "), _c('i', {
    staticClass: "fal fa-headphones"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("OK! Now Use That Beautiful Voice, Say Something!\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('u', [_vm._v("Exploration:")]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\tLet's Explore!\n\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\tRandomize, Shift Soundscape,")]), _vm._v(" or "), _c('strong', [_vm._v("New Scene")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_c('u', [_vm._v("Creating A Soundscape:")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("American Robin")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Common Yellowthroat")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Long Grass")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Bison")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Insects or Bugs")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Thunderstorm")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Stop ")]), _vm._v(" or "), _c('strong', [_vm._v("Take Out ")]), _vm._v("[Sound Source Name] \n\t\t\t\t\t"), _c('br'), _c('span', {
    attrs: {
      "id": "voiceListAnchor"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Volume Up")]), _vm._v(" or "), _c('strong', [_vm._v("Louder")]), _vm._v(" [Sound Source Name]\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Volume Down")]), _vm._v(" or "), _c('strong', [_vm._v("Softer ")]), _vm._v("[Sound Source Name]\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_c('u', [_vm._v("Digital Audio Effects:")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Speed Up ")]), _vm._v("or "), _c('strong', [_vm._v("Faster")]), _vm._v(" & "), _c('strong', [_vm._v("Speed Down ")]), _vm._v("or "), _c('strong', [_vm._v("Slower")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Delay On")]), _vm._v(" or "), _c('strong', [_vm._v("Off ")]), _vm._v(" & "), _c('strong', [_vm._v("More ")]), _vm._v("or "), _c('strong', [_vm._v("Less")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Chorus On")]), _vm._v(" or "), _c('strong', [_vm._v("Off ")]), _vm._v(" & "), _c('strong', [_vm._v("More ")]), _vm._v("or "), _c('strong', [_vm._v("Less")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Filter On")]), _vm._v(" or "), _c('strong', [_vm._v("Off ")]), _vm._v(" & "), _c('strong', [_vm._v("More ")]), _vm._v("or "), _c('strong', [_vm._v("Less")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Reverb On")]), _vm._v(" or "), _c('strong', [_vm._v("Off ")]), _vm._v(" & "), _c('strong', [_vm._v("More ")]), _vm._v("or "), _c('strong', [_vm._v("Less")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('i', [_vm._v("Add the word "), _c('strong', [_vm._v("a lot")]), _vm._v(" to move in greater increments.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_c('u', [_vm._v("Housekeeping:")]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\tStop All Sounds \n\t\t\t\t\t"), _c('br'), _vm._v(" \n\t\t\t\t\tPlay All Sounds\n\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\tStop Voice Commands \n\t\t\t\t\t"), _c('br'), _vm._v(" \n\t\t\t\t\tGo Home\n\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\tShow")]), _vm._v(" or "), _c('strong', [_vm._v("Hide Soundscape Info\n\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\tShow")]), _vm._v(" or "), _c('strong', [_vm._v("Hide Voice Command List")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_c('u', [_vm._v("Additional Mentions:")])]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t1.) It might take a few tries, try saying your command quickly and in a direct manner.\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t2.) Each Sound Source can always be addressed as \"Sound Source 1-6\"\n\t\t\t\t")])]) : _vm._e()]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (!this.$store.state.allowSpeechControl) ? _c('div', [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNavBar),
      expression: "showNavBar"
    }],
    staticClass: "container-fluid"
  }, [_c('button', {
    class: _vm.exploreFuncClass,
    attrs: {
      "id": "exploreBtnId"
    },
    on: {
      "click": _vm.exploreBtnFunc
    }
  }, [_c('i', {
    class: _vm.exploreIconClass
  }), _vm._v(" " + _vm._s(_vm.exploreTxt) + "\n\t\t\t\t")])])])], 1) : _vm._e(), _vm._v(" "), _c('transition-group', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNavBar),
      expression: "showNavBar"
    }],
    key: "localStorageBtnsKey",
    staticClass: "container-fluid",
    attrs: {
      "id": "helpContainer"
    }
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    class: _vm.saveClass,
    attrs: {
      "id": "localStorageBtnID"
    },
    on: {
      "click": _vm.setLocalStorage
    }
  }, [_c('i', {
    staticClass: "fal fa-sliders-h"
  }), _vm._v(" Save\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    class: _vm.loadClass,
    attrs: {
      "id": "localStorageBtnID"
    },
    on: {
      "click": _vm.getLocalStorage
    }
  }, [_c('i', {
    staticClass: "fal fa-sliders-h"
  }), _vm._v(" Load\n\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNavBar),
      expression: "showNavBar"
    }],
    key: "helpBtnsKeys",
    staticClass: "container-fluid",
    attrs: {
      "id": "helpContainer"
    }
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    class: _vm.helpClass,
    attrs: {
      "id": "aboutBtnID"
    },
    on: {
      "click": _vm.goToHelp
    }
  }, [_c('i', {
    staticClass: "fal fa-info-circle"
  }), _vm._v(" Info\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    class: _vm.helpClass,
    attrs: {
      "id": "aboutBtnID"
    },
    on: {
      "click": _vm.goHome
    }
  }, [_c('i', {
    staticClass: "fas fa-home"
  }), _vm._v(" Home\n\t\t\t\t\t")])])])]), _vm._v(" "), (!_vm.userMobile) ? _c('div', [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNavBar),
      expression: "showNavBar"
    }],
    staticClass: "container-fluid",
    attrs: {
      "id": "visualToggleContainer"
    }
  }, [(_vm.activeSun) ? _c('span', {
    attrs: {
      "id": "visualToggle"
    },
    on: {
      "click": function($event) {
        _vm.activeSun = !_vm.activeSun
      }
    }
  }, [_vm._v(" \n\t\t\t\t\t\tReactive Background\n\t\t\t\t\t\t"), _c('i', {
    staticClass: "fal fa-toggle-on"
  })]) : (!_vm.activeSun) ? _c('span', {
    attrs: {
      "id": "visualToggle"
    },
    on: {
      "click": function($event) {
        _vm.activeSun = !_vm.activeSun
      }
    }
  }, [_vm._v(" \n\t\t\t\t\t\tReactive Background\n\t\t\t\t\t\t"), _c('i', {
    staticClass: "fal fa-toggle-off"
  })]) : _vm._e()])])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 59 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    class: _vm.plungeClass,
    attrs: {
      "id": "mainDiv"
    }
  }, [(this.$store.state.allowSpeechControl) ? _c('div', [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated pulse",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAllControls),
      expression: "showAllControls"
    }],
    staticClass: "container-fluid",
    attrs: {
      "id": "VUIformInputDivID"
    }
  }, [_c('div', {
    staticClass: "col-xs-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userVoiceToText),
      expression: "userVoiceToText"
    }],
    staticClass: "form-control",
    class: _vm.plungeClass,
    staticStyle: {
      "color": "white !important",
      "border-width": "0px"
    },
    attrs: {
      "type": "text",
      "id": "inlineFormInputGroupUsername2",
      "placeholder": "View & Type Voice Commands Here"
    },
    domProps: {
      "value": (_vm.userVoiceToText)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.userVoiceToTextFunc($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userVoiceToText = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  }, [(_vm.initSpeech) ? _c('span', {
    on: {
      "click": _vm.speechFunc
    }
  }, [_c('i', {
    staticClass: "fal fa-microphone-slash",
    attrs: {
      "id": "speechEngage"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.initSpeech) ? _c('span', {
    on: {
      "click": _vm.speechStartStopFunc
    }
  }, [_c('i', {
    staticClass: "fa fa-microphone-alt",
    style: ({
      'color': _vm.recognizing ? 'red' : 'black'
    }),
    attrs: {
      "id": "speechEngageActivated"
    }
  })]) : _vm._e()])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showEnterContainer),
      expression: "showEnterContainer"
    }],
    staticClass: "container-fluid",
    attrs: {
      "id": "enterContainer"
    }
  }, [_c('transition', {
    attrs: {
      "appear": "",
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated zoomOutUp",
      "mode": "out-in"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showEnterBtn),
      expression: "showEnterBtn"
    }],
    staticClass: "btn-info",
    staticStyle: {
      "color": "black",
      "background-color": "#ecdbc5"
    },
    attrs: {
      "id": "enterFuncBtn"
    },
    on: {
      "~click": function($event) {
        return _vm.enterFunc($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tARID TONALITY\n\t\t\t\t\t")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLoading),
      expression: "showLoading"
    }],
    staticStyle: {
      "color": "white",
      "border-color": "transparent",
      "background": "transparent"
    },
    attrs: {
      "id": "enterFuncBtn"
    }
  }, [_vm._v(" \t\n\t\t\t\t\t\t\tLoading... \n\t\t\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.whatIsLoading) + "\n\t\t\t\t\t")])])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAllControls),
      expression: "showAllControls"
    }],
    staticClass: "container-fluid",
    attrs: {
      "id": "controlsContainer"
    }
  }, [_c('div', {
    attrs: {
      "id": "ambienceBtnLocation"
    }
  }, [(!_vm.userMobile) ? _c('p', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "fxTitle"
    }
  }, [_vm._v(" \n\t\t\t\t\t\t\tAdd "), _c('i', {
    staticClass: "fal fa-check-circle"
  }), _vm._v(" or Remove "), _c('i', {
    staticClass: "fal fa-times-circle"
  }), _vm._v(" Sounds From Your "), _c('span', {
    attrs: {
      "id": "soundscapeTitleBreak"
    }
  }, [_vm._v("Mojave Desert Soundscape")])]) : (_vm.userMobile) ? _c('p', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "fxTitle"
    }
  }, [_vm._v(" \n\t\t\t\t\t\t\tSounds of the Mojave Desert")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn1Div"
    }
  }, [_c('button', {
    class: _vm.ambience1Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience1Func
    },
    on: {
      "click": function($event) {
        _vm.ambience1Boolean = !_vm.ambience1Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience1Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tOasis\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience1Vol),
      expression: "ambience1Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance1RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience1Func,
      "max": "6",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience1Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience1Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn2Div"
    }
  }, [_c('button', {
    class: _vm.ambience2Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience2Func
    },
    on: {
      "click": function($event) {
        _vm.ambience2Boolean = !_vm.ambience2Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience2Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tCarcass\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience2Vol),
      expression: "ambience2Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance2RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience2Func,
      "max": "6",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience2Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience2Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn3Div"
    }
  }, [_c('button', {
    class: _vm.ambience3Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience3Func
    },
    on: {
      "click": function($event) {
        _vm.ambience3Boolean = !_vm.ambience3Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience3Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tCoyotes\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience3Vol),
      expression: "ambience3Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance3RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience3Func,
      "max": "2",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience3Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience3Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn4Div"
    }
  }, [_c('button', {
    class: _vm.ambience4Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience4Func
    },
    on: {
      "click": function($event) {
        _vm.ambience4Boolean = !_vm.ambience4Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience4Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tDesert Winds\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience4Vol),
      expression: "ambience4Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance4RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience4Func,
      "max": "8",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience4Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience4Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn5Div"
    }
  }, [_c('button', {
    class: _vm.ambience5Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience5Func
    },
    on: {
      "click": function($event) {
        _vm.ambience5Boolean = !_vm.ambience5Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience5Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tAirplane\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience5Vol),
      expression: "ambience5Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance5RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience5Func,
      "max": "6",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience5Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience5Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn6Div"
    }
  }, [_c('button', {
    class: _vm.ambience6Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience6Func
    },
    on: {
      "click": function($event) {
        _vm.ambience6Boolean = !_vm.ambience6Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience6Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tDesert Walk\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience6Vol),
      expression: "ambience6Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance6RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience6Func,
      "max": "0",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience6Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience6Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "masterControlDiv"
    }
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "fxTitle2"
    }
  }, [_vm._v(" \n\t\t\tProcess Soundscape With Digital Audio Processing\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice1SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voiceBadgeDesert",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.speedToggle = !_vm.speedToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.speedToggle),
      expression: "speedToggle"
    }],
    staticStyle: {
      "color": "black"
    }
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tSpeed " + _vm._s(((_vm.playBackSpeed).toFixed(3))) + "x \n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.speedToggle),
      expression: "!speedToggle"
    }],
    staticStyle: {
      "color": "var(--main-stopDesert-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tSpeed " + _vm._s(((_vm.playBackSpeed).toFixed(3))) + "x \n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.playBackSpeed),
      expression: "playBackSpeed",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "instrumentRangerDesert",
    attrs: {
      "id": "sliders6",
      "type": "range",
      "step": "0.01",
      "max": "2",
      "min": "0.1",
      "": _vm.playbackSpeedFunc
    },
    domProps: {
      "value": (_vm.playBackSpeed)
    },
    on: {
      "__r": function($event) {
        _vm.playBackSpeed = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice2SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voiceBadgeDesert",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.fxDelayToggle = !_vm.fxDelayToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fxDelayToggle),
      expression: "fxDelayToggle"
    }],
    staticStyle: {
      "color": "black"
    }
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tDelay " + _vm._s(_vm.fxDelayAmt) + "% \n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fxDelayToggle),
      expression: "!fxDelayToggle"
    }],
    staticStyle: {
      "color": "var(--main-stopDesert-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tDelay " + _vm._s(_vm.fxDelayAmt) + "% \n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.fxDelayAmt),
      expression: "fxDelayAmt",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "instrumentRangerDesert",
    attrs: {
      "id": "sliders2",
      "type": "range",
      "step": "1",
      "max": "100",
      "min": "0",
      "": _vm.fxDelayMix
    },
    domProps: {
      "value": (_vm.fxDelayAmt)
    },
    on: {
      "__r": function($event) {
        _vm.fxDelayAmt = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice3SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voiceBadgeDesert",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.fxChorusToggle = !_vm.fxChorusToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fxChorusToggle),
      expression: "fxChorusToggle"
    }],
    staticStyle: {
      "color": "black"
    }
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tChorus " + _vm._s(_vm.fxChorusAmt) + "% \n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fxChorusToggle),
      expression: "!fxChorusToggle"
    }],
    staticStyle: {
      "color": "var(--main-stopDesert-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tChorus " + _vm._s(_vm.fxChorusAmt) + "% \n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.fxChorusAmt),
      expression: "fxChorusAmt",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "instrumentRangerDesert",
    attrs: {
      "id": "sliders3",
      "type": "range",
      "step": "1",
      "max": "100",
      "min": "0",
      "": _vm.fxChorusMix
    },
    domProps: {
      "value": (_vm.fxChorusAmt)
    },
    on: {
      "__r": function($event) {
        _vm.fxChorusAmt = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice4SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voiceBadgeDesert",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.fxFilterToggle = !_vm.fxFilterToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fxFilterToggle),
      expression: "fxFilterToggle"
    }],
    staticStyle: {
      "color": "black"
    }
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tFilter " + _vm._s(_vm.fxAutoFilterAmt) + "Hz\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fxFilterToggle),
      expression: "!fxFilterToggle"
    }],
    staticStyle: {
      "color": "var(--main-stopDesert-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tFilter " + _vm._s(_vm.fxAutoFilterAmt) + "Hz\n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.fxAutoFilterAmt),
      expression: "fxAutoFilterAmt",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "instrumentRangerDesert",
    attrs: {
      "id": "sliders4",
      "type": "range",
      "step": "1",
      "max": "10000",
      "min": "80",
      "": _vm.fxAutoFilterMix
    },
    domProps: {
      "value": (_vm.fxAutoFilterAmt)
    },
    on: {
      "__r": function($event) {
        _vm.fxAutoFilterAmt = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice5SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voiceBadgeDesert",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.fxConvolverToggle = !_vm.fxConvolverToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fxConvolverToggle),
      expression: "fxConvolverToggle"
    }],
    staticStyle: {
      "color": "black"
    }
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tReverb (" + _vm._s(((_vm.fxDecay).toPrecision(2))) + "s) " + _vm._s((_vm.fxConvolverAmt * 2)) + "%\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fxConvolverToggle),
      expression: "!fxConvolverToggle"
    }],
    staticStyle: {
      "color": "var(--main-stopDesert-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tReverb (" + _vm._s(((_vm.fxDecay).toPrecision(2))) + "s) " + _vm._s((_vm.fxConvolverAmt * 2)) + "%\n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.fxConvolverAmt),
      expression: "fxConvolverAmt",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "instrumentRangerDesert",
    attrs: {
      "id": "sliders1",
      "type": "range",
      "step": "1",
      "max": "50",
      "min": "0",
      "": _vm.fxConvolverMix
    },
    domProps: {
      "value": (_vm.fxConvolverAmt)
    },
    on: {
      "__r": function($event) {
        _vm.fxConvolverAmt = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice6SliderDiv"
    }
  }, [_c('button', {
    class: _vm.mattChillClass,
    attrs: {
      "id": "masterControlBadgesSFX"
    },
    on: {
      "click": _vm.mattChillMethod
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.randomizeBoolean),
      expression: "!randomizeBoolean"
    }]
  }, [_c('i', {
    staticClass: "fa fa-flask"
  }), _vm._v(" Randomize "), _c('i', {
    staticClass: "fa fa-flask"
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.randomizeBoolean),
      expression: "randomizeBoolean"
    }]
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask5),
      expression: "showFlask5"
    }],
    staticClass: "fa fa-flask fa-counter-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask3),
      expression: "showFlask3"
    }],
    staticClass: "fa fa-flask fa-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask1),
      expression: "showFlask1"
    }],
    staticClass: "fa fa-flask slow-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask2),
      expression: "showFlask2"
    }],
    staticClass: "fa fa-flask slow-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask4),
      expression: "showFlask4"
    }],
    staticClass: "fa fa-flask fa-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask6),
      expression: "showFlask6"
    }],
    staticClass: "fa fa-flask fa-counter-spin"
  })])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAboutPage),
      expression: "showAboutPage"
    }],
    staticClass: "col-xs-12",
    attrs: {
      "id": "aboutPageID"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "aboutTxt"
    }
  }, [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t\tJoshua Tree is an absolutely mesmerizing landscape, and not only because of the beautifully strange Yucca trees. It is here that two deserts converge, the Colorado Desert and the Mojave Desert. In Joshua Tree these two deserts twist together and form a unique landscape with an equally unique soundscape. \n\t\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t\tDuring the day you will hear the delightful song birds, with a good concentration of them in the region's oases. However, the soundscape evolves once twilight sets into the horizon. In the evening, coyote’s make their calls heard throughout the soundscape. Their distinct calls and songs bounce off huge boulders and rock faces, creating beautiful echos.\n\t\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "disclaimerTxt"
    }
  }, [_vm._v("\n\t\t\t\t\t\tSound Design & Recordings Copyright © 2018 "), _c('a', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "href": "https://www.mattmccorkle.com",
      "target": "_blank"
    }
  }, [_vm._v("Matt McCorkle")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v(" These sounds are presented here for personal entertainment use only. ")]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t\tFor commercial sound licensing email hi@mattmccorkle.com\n\t\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    class: _vm.helpClass,
    attrs: {
      "id": "aboutBtnID2"
    },
    on: {
      "click": _vm.goToHelp
    }
  }, [_c('strong', [_c('i', {
    staticClass: "fa fa-window-close fa-3x"
  })])])])]), _vm._v(" "), (this.$store.state.allowSpeechControl) ? _c('div') : _vm._e(), _vm._v(" "), (this.$store.state.allowSpeechControl) ? _c('div', [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated pulse",
      "mode": "out-in"
    }
  }, [(_vm.showSpeechBtns) ? _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "speechContainer"
    }
  }, [_c('button', {
    class: _vm.speechShowListClass,
    attrs: {
      "id": "speechList"
    },
    on: {
      "click": _vm.voiceCommandListFunc
    }
  }, [_c('i', {
    staticClass: "fal fa-clipboard-list"
  }), _vm._v(" List of Voice Commands\n\t\t\t\t")]), _vm._v(" "), (_vm.showVoiceCommandList) ? _c('div', {
    attrs: {
      "id": "voiceCommandListID"
    }
  }, [_c('p', {
    attrs: {
      "id": "voiceControlListTitle"
    }
  }, [_c('strong', [_vm._v(" Voice Control This Immersive Experience")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "voiceControlListTxt"
    }
  }, [_c('strong', [_vm._v("Allow Google Chrome Microphone Access To Use This Feature")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "fal fa-headphones"
  }), _vm._v(" Voice Control Works "), _c('strong', [_c('u', [_vm._v("Great")])]), _vm._v(" With Headphones "), _c('i', {
    staticClass: "fal fa-headphones"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("OK! Now Use That Beautiful Voice, Say Something!\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('u', [_vm._v("Exploration:")]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\tLet's Explore!\n\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\tRandomize, Shift Soundscape,")]), _vm._v(" or "), _c('strong', [_vm._v("New Scene")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_c('u', [_vm._v("Creating A Soundscape:")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Oasis")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Carcass")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Coyotes")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Desert Winds")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Airplane")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Desert Walk")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Stop ")]), _vm._v(" or "), _c('strong', [_vm._v("Take Out ")]), _vm._v("[Sound Source Name] \n\t\t\t\t\t"), _c('br'), _c('span', {
    attrs: {
      "id": "voiceListAnchor"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Volume Up")]), _vm._v(" or "), _c('strong', [_vm._v("Louder")]), _vm._v(" [Sound Source Name]\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Volume Down")]), _vm._v(" or "), _c('strong', [_vm._v("Softer ")]), _vm._v("[Sound Source Name]\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_c('u', [_vm._v("Digital Audio Effects:")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Speed Up ")]), _vm._v("or "), _c('strong', [_vm._v("Faster")]), _vm._v(" & "), _c('strong', [_vm._v("Speed Down ")]), _vm._v("or "), _c('strong', [_vm._v("Slower")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Delay On")]), _vm._v(" or "), _c('strong', [_vm._v("Off ")]), _vm._v(" & "), _c('strong', [_vm._v("More ")]), _vm._v("or "), _c('strong', [_vm._v("Less")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Chorus On")]), _vm._v(" or "), _c('strong', [_vm._v("Off ")]), _vm._v(" & "), _c('strong', [_vm._v("More ")]), _vm._v("or "), _c('strong', [_vm._v("Less")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Filter On")]), _vm._v(" or "), _c('strong', [_vm._v("Off ")]), _vm._v(" & "), _c('strong', [_vm._v("More ")]), _vm._v("or "), _c('strong', [_vm._v("Less")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Reverb On")]), _vm._v(" or "), _c('strong', [_vm._v("Off ")]), _vm._v(" & "), _c('strong', [_vm._v("More ")]), _vm._v("or "), _c('strong', [_vm._v("Less")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('i', [_vm._v("Add the word "), _c('strong', [_vm._v("a lot")]), _vm._v(" to move in greater increments.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_c('u', [_vm._v("Housekeeping:")]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\tStop All Sounds \n\t\t\t\t\t"), _c('br'), _vm._v(" \n\t\t\t\t\tPlay All Sounds\n\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\tStop Voice Commands \n\t\t\t\t\t"), _c('br'), _vm._v(" \n\t\t\t\t\tGo Home\n\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\tShow")]), _vm._v(" or "), _c('strong', [_vm._v("Hide Soundscape Info\n\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\tShow")]), _vm._v(" or "), _c('strong', [_vm._v("Hide Voice Command List")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_c('u', [_vm._v("Additional Mentions:")])]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t1.) It might take a few tries, try saying your command quickly and in a direct manner.\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t2.) Each Sound Source can always be addressed as \"Sound Source 1-6\"\n\t\t\t\t")])]) : _vm._e()]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (!this.$store.state.allowSpeechControl) ? _c('div', [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNavBar),
      expression: "showNavBar"
    }],
    staticClass: "container-fluid"
  }, [_c('button', {
    class: _vm.exploreFuncClass,
    attrs: {
      "id": "exploreBtnId"
    },
    on: {
      "click": _vm.exploreBtnFunc
    }
  }, [_c('i', {
    class: _vm.exploreIconClass
  }), _vm._v(" " + _vm._s(_vm.exploreTxt) + "\n\t\t\t\t")])])])], 1) : _vm._e(), _vm._v(" "), _c('transition-group', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNavBar),
      expression: "showNavBar"
    }],
    key: "localStorageBtnsKey",
    staticClass: "container-fluid",
    attrs: {
      "id": "helpContainer"
    }
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    class: _vm.saveClass,
    attrs: {
      "id": "localStorageBtnID"
    },
    on: {
      "click": _vm.setLocalStorage
    }
  }, [_c('i', {
    staticClass: "fal fa-sliders-h"
  }), _vm._v(" Save\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    class: _vm.loadClass,
    attrs: {
      "id": "localStorageBtnID"
    },
    on: {
      "click": _vm.getLocalStorage
    }
  }, [_c('i', {
    staticClass: "fal fa-sliders-h"
  }), _vm._v(" Load\n\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNavBar),
      expression: "showNavBar"
    }],
    key: "helpBtnsKeys",
    staticClass: "container-fluid",
    attrs: {
      "id": "helpContainer"
    }
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    class: _vm.helpClass,
    attrs: {
      "id": "aboutBtnID"
    },
    on: {
      "click": _vm.goToHelp
    }
  }, [_c('i', {
    staticClass: "fal fa-info-circle"
  }), _vm._v(" Info\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    class: _vm.helpClass,
    attrs: {
      "id": "aboutBtnID"
    },
    on: {
      "click": _vm.goHome
    }
  }, [_c('i', {
    staticClass: "fas fa-home"
  }), _vm._v(" Home\n\t\t\t\t\t")])])])]), _vm._v(" "), (!_vm.userMobile) ? _c('div', [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNavBar),
      expression: "showNavBar"
    }],
    staticClass: "container-fluid",
    attrs: {
      "id": "visualToggleContainer"
    }
  }, [(_vm.activeSun) ? _c('span', {
    attrs: {
      "id": "visualToggle"
    },
    on: {
      "click": function($event) {
        _vm.activeSun = !_vm.activeSun
      }
    }
  }, [_vm._v(" \n\t\t\t\t\t\tReactive Background\n\t\t\t\t\t\t"), _c('i', {
    staticClass: "fal fa-toggle-on"
  })]) : (!_vm.activeSun) ? _c('span', {
    attrs: {
      "id": "visualToggle"
    },
    on: {
      "click": function($event) {
        _vm.activeSun = !_vm.activeSun
      }
    }
  }, [_vm._v(" \n\t\t\t\t\t\tReactive Background\n\t\t\t\t\t\t"), _c('i', {
    staticClass: "fal fa-toggle-off"
  })]) : _vm._e()])])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    class: _vm.plungeClass,
    attrs: {
      "id": "mainDiv"
    }
  }, [(this.$store.state.allowSpeechControl) ? _c('div', [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated pulse",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAllControls),
      expression: "showAllControls"
    }],
    staticClass: "container-fluid",
    attrs: {
      "id": "VUIformInputDivID"
    }
  }, [_c('div', {
    staticClass: "col-xs-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userVoiceToText),
      expression: "userVoiceToText"
    }],
    staticClass: "form-control",
    class: _vm.plungeClass,
    staticStyle: {
      "color": "white !important",
      "border-width": "0px"
    },
    attrs: {
      "type": "text",
      "id": "inlineFormInputGroupUsername2",
      "placeholder": "View & Type Voice Commands Here"
    },
    domProps: {
      "value": (_vm.userVoiceToText)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.userVoiceToTextFunc($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userVoiceToText = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  }, [(_vm.initSpeech) ? _c('span', {
    on: {
      "click": _vm.speechFunc
    }
  }, [_c('i', {
    staticClass: "fal fa-microphone-slash",
    attrs: {
      "id": "speechEngage"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.initSpeech) ? _c('span', {
    on: {
      "click": _vm.speechStartStopFunc
    }
  }, [_c('i', {
    staticClass: "fa fa-microphone-alt",
    style: ({
      'color': _vm.recognizing ? 'red' : 'black'
    }),
    attrs: {
      "id": "speechEngageActivated"
    }
  })]) : _vm._e()])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showEnterContainer),
      expression: "showEnterContainer"
    }],
    staticClass: "container-fluid",
    attrs: {
      "id": "enterContainer"
    }
  }, [_c('transition', {
    attrs: {
      "appear": "",
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated flash",
      "mode": "out-in"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showEnterBtn),
      expression: "showEnterBtn"
    }],
    staticClass: "btn-info",
    staticStyle: {
      "color": "black",
      "background-color": "#ffdb4d",
      "text-shadow": "0px 1px 4px rgba(0, 0, 0, 0.5)"
    },
    attrs: {
      "id": "enterFuncBtn"
    },
    on: {
      "~click": function($event) {
        return _vm.enterFunc($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tLIGHT IT UP\n\t\t\t\t\t")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLoading),
      expression: "showLoading"
    }],
    staticStyle: {
      "border-color": "transparent",
      "background": "transparent",
      "color": "white"
    },
    attrs: {
      "id": "enterFuncBtn"
    }
  }, [_vm._v(" \t\n\t\t\t\t\t\t\tLoading... \n\t\t\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.whatIsLoading) + "\n\t\t\t\t\t")])])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAllControls),
      expression: "showAllControls"
    }],
    staticClass: "container-fluid",
    attrs: {
      "id": "controlsContainer"
    }
  }, [_c('div', {
    attrs: {
      "id": "ambienceBtnLocation"
    }
  }, [(!_vm.userMobile) ? _c('p', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "fxTitle"
    }
  }, [_vm._v(" \n\t\t\t\t\t\t\tAdd "), _c('i', {
    staticClass: "fal fa-check-circle"
  }), _vm._v(" or Remove "), _c('i', {
    staticClass: "fal fa-times-circle"
  }), _vm._v(" Sounds From Your "), _c('span', {
    attrs: {
      "id": "soundscapeTitleBreak"
    }
  }, [_vm._v("Firey Soundscape")])]) : (_vm.userMobile) ? _c('p', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "fxTitle"
    }
  }, [_vm._v(" \n\t\t\t\t\t\t\tFirey Soundscape\n\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn1Div"
    }
  }, [_c('button', {
    class: _vm.ambience5Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience5Func
    },
    on: {
      "click": function($event) {
        _vm.ambience5Boolean = !_vm.ambience5Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience5Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tEmbers\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience5Vol),
      expression: "ambience5Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance5RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience5Func,
      "max": "8",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience5Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience5Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn2Div"
    }
  }, [_c('button', {
    class: _vm.ambience1Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience1Func
    },
    on: {
      "click": function($event) {
        _vm.ambience1Boolean = !_vm.ambience1Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience1Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tCampfire\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience1Vol),
      expression: "ambience1Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance1RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience1Func,
      "max": "6",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience1Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience1Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn3Div"
    }
  }, [_c('button', {
    class: _vm.ambience3Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience3Func
    },
    on: {
      "click": function($event) {
        _vm.ambience3Boolean = !_vm.ambience3Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience3Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tFireplace\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience3Vol),
      expression: "ambience3Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance3RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience3Func,
      "max": "8",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience3Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience3Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn4Div"
    }
  }, [_c('button', {
    class: _vm.ambience2Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience2Func
    },
    on: {
      "click": function($event) {
        _vm.ambience2Boolean = !_vm.ambience2Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience2Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tField Fire\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience2Vol),
      expression: "ambience2Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance2RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience2Func,
      "max": "8",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience2Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience2Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn5Div"
    }
  }, [_c('button', {
    class: _vm.ambience6Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience6Func
    },
    on: {
      "click": function($event) {
        _vm.ambience6Boolean = !_vm.ambience6Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience6Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tFireworks\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience6Vol),
      expression: "ambience6Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance6RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience6Func,
      "max": "2",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience6Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience6Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn6Div"
    }
  }, [_c('button', {
    class: _vm.ambience4Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience4Func
    },
    on: {
      "click": function($event) {
        _vm.ambience4Boolean = !_vm.ambience4Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience4Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tMatch Lite\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience4Vol),
      expression: "ambience4Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance4RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience4Func,
      "max": "6",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience4Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience4Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "masterControlDiv"
    }
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "fxTitle2"
    }
  }, [_vm._v(" \n\t\t\tProcess Soundscape With Digital Audio Processing\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice1SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voiceBadgeFire",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.speedToggle = !_vm.speedToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.speedToggle),
      expression: "speedToggle"
    }],
    staticStyle: {
      "color": "var(--main-startFire-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tSpeed " + _vm._s(((_vm.playBackSpeed).toFixed(3))) + "x \n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.speedToggle),
      expression: "!speedToggle"
    }],
    staticStyle: {
      "color": "var(--main-stopFire-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tSpeed " + _vm._s(((_vm.playBackSpeed).toFixed(3))) + "x \n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.playBackSpeed),
      expression: "playBackSpeed",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "instrumentRangerFire",
    attrs: {
      "id": "sliders6",
      "type": "range",
      "step": "0.01",
      "max": "2",
      "min": "0.1",
      "": _vm.playbackSpeedFunc
    },
    domProps: {
      "value": (_vm.playBackSpeed)
    },
    on: {
      "__r": function($event) {
        _vm.playBackSpeed = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice2SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voiceBadgeFire",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.fxDelayToggle = !_vm.fxDelayToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fxDelayToggle),
      expression: "fxDelayToggle"
    }],
    staticStyle: {
      "color": "var(--main-startFire-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tDelay " + _vm._s(_vm.fxDelayAmt) + "% \n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fxDelayToggle),
      expression: "!fxDelayToggle"
    }],
    staticStyle: {
      "color": "var(--main-stopFire-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tDelay " + _vm._s(_vm.fxDelayAmt) + "% \n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.fxDelayAmt),
      expression: "fxDelayAmt",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "instrumentRangerFire",
    attrs: {
      "id": "sliders2",
      "type": "range",
      "step": "1",
      "max": "100",
      "min": "0",
      "": _vm.fxDelayMix
    },
    domProps: {
      "value": (_vm.fxDelayAmt)
    },
    on: {
      "__r": function($event) {
        _vm.fxDelayAmt = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice3SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voiceBadgeFire",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.fxChorusToggle = !_vm.fxChorusToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fxChorusToggle),
      expression: "fxChorusToggle"
    }],
    staticStyle: {
      "color": "var(--main-startFire-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tChorus " + _vm._s(_vm.fxChorusAmt) + "% \n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fxChorusToggle),
      expression: "!fxChorusToggle"
    }],
    staticStyle: {
      "color": "var(--main-stopFire-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tChorus " + _vm._s(_vm.fxChorusAmt) + "% \n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.fxChorusAmt),
      expression: "fxChorusAmt",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "instrumentRangerFire",
    attrs: {
      "id": "sliders3",
      "type": "range",
      "step": "1",
      "max": "100",
      "min": "0",
      "": _vm.fxChorusMix
    },
    domProps: {
      "value": (_vm.fxChorusAmt)
    },
    on: {
      "__r": function($event) {
        _vm.fxChorusAmt = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice4SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voiceBadgeFire",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.fxFilterToggle = !_vm.fxFilterToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fxFilterToggle),
      expression: "fxFilterToggle"
    }],
    staticStyle: {
      "color": "var(--main-startFire-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tFilter " + _vm._s(_vm.fxAutoFilterAmt) + "Hz\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fxFilterToggle),
      expression: "!fxFilterToggle"
    }],
    staticStyle: {
      "color": "var(--main-stopFire-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tFilter " + _vm._s(_vm.fxAutoFilterAmt) + "Hz\n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.fxAutoFilterAmt),
      expression: "fxAutoFilterAmt",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "instrumentRangerFire",
    attrs: {
      "id": "sliders4",
      "type": "range",
      "step": "1",
      "max": "10000",
      "min": "80",
      "": _vm.fxAutoFilterMix
    },
    domProps: {
      "value": (_vm.fxAutoFilterAmt)
    },
    on: {
      "__r": function($event) {
        _vm.fxAutoFilterAmt = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice5SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voiceBadgeFire",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.fxConvolverToggle = !_vm.fxConvolverToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fxConvolverToggle),
      expression: "fxConvolverToggle"
    }],
    staticStyle: {
      "color": "var(--main-startFire-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tReverb (" + _vm._s(((_vm.fxDecay).toPrecision(2))) + "s) " + _vm._s((_vm.fxConvolverAmt * 2)) + "%\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fxConvolverToggle),
      expression: "!fxConvolverToggle"
    }],
    staticStyle: {
      "color": "var(--main-stopFire-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tReverb (" + _vm._s(((_vm.fxDecay).toPrecision(2))) + "s) " + _vm._s((_vm.fxConvolverAmt * 2)) + "%\n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.fxConvolverAmt),
      expression: "fxConvolverAmt",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "instrumentRangerFire",
    attrs: {
      "id": "sliders1",
      "type": "range",
      "step": "1",
      "max": "50",
      "min": "0",
      "": _vm.fxConvolverMix
    },
    domProps: {
      "value": (_vm.fxConvolverAmt)
    },
    on: {
      "__r": function($event) {
        _vm.fxConvolverAmt = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice6SliderDiv"
    }
  }, [_c('button', {
    class: _vm.mattChillClass,
    attrs: {
      "id": "masterControlBadgesSFX"
    },
    on: {
      "click": _vm.mattChillMethod
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.randomizeBoolean),
      expression: "!randomizeBoolean"
    }]
  }, [_c('i', {
    staticClass: "fa fa-flask"
  }), _vm._v(" Randomize "), _c('i', {
    staticClass: "fa fa-flask"
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.randomizeBoolean),
      expression: "randomizeBoolean"
    }]
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask5),
      expression: "showFlask5"
    }],
    staticClass: "fa fa-flask fa-counter-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask3),
      expression: "showFlask3"
    }],
    staticClass: "fa fa-flask fa-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask1),
      expression: "showFlask1"
    }],
    staticClass: "fa fa-flask slow-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask2),
      expression: "showFlask2"
    }],
    staticClass: "fa fa-flask slow-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask4),
      expression: "showFlask4"
    }],
    staticClass: "fa fa-flask fa-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask6),
      expression: "showFlask6"
    }],
    staticClass: "fa fa-flask fa-counter-spin"
  })])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAboutPage),
      expression: "showAboutPage"
    }],
    staticClass: "col-xs-12",
    attrs: {
      "id": "aboutPageID"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "aboutTxt"
    }
  }, [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t\tFire. There are many ways to create and control it. Controlling fire was a turning point in human evolution. Fire provided warmth, the exploration of cooked food, and allowed humans to carry on with their activities after the sun had set. Manipulating fire allowed humans to explore new methods of creating tools and weapons.\n\t\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t\tIn Charles Darwin’s “The Descent of Man” he regarded controlled fire as likely the greatest discovery by humanity, excepting only to language. Controlling fire is just as important today as it was when it first discovered. \n\t\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "disclaimerTxt"
    }
  }, [_vm._v("\n\t\t\t\t\t\tSound Design & Recordings Copyright © 2018 "), _c('a', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "href": "https://www.mattmccorkle.com",
      "target": "_blank"
    }
  }, [_vm._v("Matt McCorkle")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v(" These sounds are presented here for personal entertainment use only. ")]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t\tFor commercial sound licensing email hi@mattmccorkle.com\n\t\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    class: _vm.helpClass,
    attrs: {
      "id": "aboutBtnID2"
    },
    on: {
      "click": _vm.goToHelp
    }
  }, [_c('strong', [_c('i', {
    staticClass: "fa fa-window-close fa-3x"
  })])])])]), _vm._v(" "), (this.$store.state.allowSpeechControl) ? _c('div') : _vm._e(), _vm._v(" "), (this.$store.state.allowSpeechControl) ? _c('div', [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated pulse",
      "mode": "out-in"
    }
  }, [(_vm.showSpeechBtns) ? _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "speechContainer"
    }
  }, [_c('button', {
    class: _vm.speechShowListClass,
    attrs: {
      "id": "speechList"
    },
    on: {
      "click": _vm.voiceCommandListFunc
    }
  }, [_c('i', {
    staticClass: "fal fa-clipboard-list"
  }), _vm._v(" List of Voice Commands\n\t\t\t\t")]), _vm._v(" "), (_vm.showVoiceCommandList) ? _c('div', {
    attrs: {
      "id": "voiceCommandListID"
    }
  }, [_c('p', {
    attrs: {
      "id": "voiceControlListTitle"
    }
  }, [_c('strong', [_vm._v(" Voice Control This Immersive Experience")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "voiceControlListTxt"
    }
  }, [_c('strong', [_vm._v("Allow Google Chrome Microphone Access To Use This Feature")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "fal fa-headphones"
  }), _vm._v(" Voice Control Works "), _c('strong', [_c('u', [_vm._v("Great")])]), _vm._v(" With Headphones "), _c('i', {
    staticClass: "fal fa-headphones"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("OK! Now Use That Beautiful Voice, Say Something!\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('u', [_vm._v("Exploration:")]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\tLet's Explore!\n\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\tRandomize, Shift Soundscape,")]), _vm._v(" or "), _c('strong', [_vm._v("New Scene")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_c('u', [_vm._v("Creating A Soundscape:")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Embers")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Campfire")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Fireplace")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Field Fire")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Fireworks")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Match Lite")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Stop ")]), _vm._v(" or "), _c('strong', [_vm._v("Take Out ")]), _vm._v("[Sound Source Name] \n\t\t\t\t\t"), _c('br'), _c('span', {
    attrs: {
      "id": "voiceListAnchor"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Volume Up")]), _vm._v(" or "), _c('strong', [_vm._v("Louder")]), _vm._v(" [Sound Source Name]\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Volume Down")]), _vm._v(" or "), _c('strong', [_vm._v("Softer ")]), _vm._v("[Sound Source Name]\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_c('u', [_vm._v("Digital Audio Effects:")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Speed Up ")]), _vm._v("or "), _c('strong', [_vm._v("Faster")]), _vm._v(" & "), _c('strong', [_vm._v("Speed Down ")]), _vm._v("or "), _c('strong', [_vm._v("Slower")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Delay On")]), _vm._v(" or "), _c('strong', [_vm._v("Off ")]), _vm._v(" & "), _c('strong', [_vm._v("More ")]), _vm._v("or "), _c('strong', [_vm._v("Less")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Chorus On")]), _vm._v(" or "), _c('strong', [_vm._v("Off ")]), _vm._v(" & "), _c('strong', [_vm._v("More ")]), _vm._v("or "), _c('strong', [_vm._v("Less")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Filter On")]), _vm._v(" or "), _c('strong', [_vm._v("Off ")]), _vm._v(" & "), _c('strong', [_vm._v("More ")]), _vm._v("or "), _c('strong', [_vm._v("Less")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Reverb On")]), _vm._v(" or "), _c('strong', [_vm._v("Off ")]), _vm._v(" & "), _c('strong', [_vm._v("More ")]), _vm._v("or "), _c('strong', [_vm._v("Less")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('i', [_vm._v("Add the word "), _c('strong', [_vm._v("a lot")]), _vm._v(" to move in greater increments.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_c('u', [_vm._v("Housekeeping:")]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\tStop All Sounds \n\t\t\t\t\t"), _c('br'), _vm._v(" \n\t\t\t\t\tPlay All Sounds\n\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\tStop Voice Commands \n\t\t\t\t\t"), _c('br'), _vm._v(" \n\t\t\t\t\tGo Home\n\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\tShow")]), _vm._v(" or "), _c('strong', [_vm._v("Hide Soundscape Info\n\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\tShow")]), _vm._v(" or "), _c('strong', [_vm._v("Hide Voice Command List")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_c('u', [_vm._v("Additional Mentions:")])]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t1.) It might take a few tries, try saying your command quickly and in a direct manner.\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t2.) Each Sound Source can always be addressed as \"Sound Source 1-6\"\n\t\t\t\t")])]) : _vm._e()]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (!this.$store.state.allowSpeechControl) ? _c('div', [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNavBar),
      expression: "showNavBar"
    }],
    staticClass: "container-fluid"
  }, [_c('button', {
    class: _vm.exploreFuncClass,
    attrs: {
      "id": "exploreBtnId"
    },
    on: {
      "click": _vm.exploreBtnFunc
    }
  }, [_c('i', {
    class: _vm.exploreIconClass
  }), _vm._v(" " + _vm._s(_vm.exploreTxt) + "\n\t\t\t\t")])])])], 1) : _vm._e(), _vm._v(" "), _c('transition-group', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNavBar),
      expression: "showNavBar"
    }],
    key: "localStorageBtnsKey",
    staticClass: "container-fluid",
    attrs: {
      "id": "helpContainer"
    }
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    class: _vm.saveClass,
    attrs: {
      "id": "localStorageBtnID"
    },
    on: {
      "click": _vm.setLocalStorage
    }
  }, [_c('i', {
    staticClass: "fal fa-sliders-h"
  }), _vm._v(" Save\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    class: _vm.loadClass,
    attrs: {
      "id": "localStorageBtnID"
    },
    on: {
      "click": _vm.getLocalStorage
    }
  }, [_c('i', {
    staticClass: "fal fa-sliders-h"
  }), _vm._v(" Load\n\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNavBar),
      expression: "showNavBar"
    }],
    key: "helpBtnsKeys",
    staticClass: "container-fluid",
    attrs: {
      "id": "helpContainer"
    }
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    class: _vm.helpClass,
    attrs: {
      "id": "aboutBtnID"
    },
    on: {
      "click": _vm.goToHelp
    }
  }, [_c('i', {
    staticClass: "fal fa-info-circle"
  }), _vm._v(" Info\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    class: _vm.helpClass,
    attrs: {
      "id": "aboutBtnID"
    },
    on: {
      "click": _vm.goHome
    }
  }, [_c('i', {
    staticClass: "fas fa-home"
  }), _vm._v(" Home\n\t\t\t\t\t")])])])]), _vm._v(" "), (!_vm.userMobile) ? _c('div', [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNavBar),
      expression: "showNavBar"
    }],
    staticClass: "container-fluid",
    attrs: {
      "id": "visualToggleContainer"
    }
  }, [(_vm.activeSun) ? _c('span', {
    attrs: {
      "id": "visualToggle"
    },
    on: {
      "click": function($event) {
        _vm.activeSun = !_vm.activeSun
      }
    }
  }, [_vm._v(" \n\t\t\t\t\t\tReactive Background\n\t\t\t\t\t\t"), _c('i', {
    staticClass: "fal fa-toggle-on"
  })]) : (!_vm.activeSun) ? _c('span', {
    attrs: {
      "id": "visualToggle"
    },
    on: {
      "click": function($event) {
        _vm.activeSun = !_vm.activeSun
      }
    }
  }, [_vm._v(" \n\t\t\t\t\t\tReactive Background\n\t\t\t\t\t\t"), _c('i', {
    staticClass: "fal fa-toggle-off"
  })]) : _vm._e()])])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 61 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    class: _vm.plungeClass,
    attrs: {
      "id": "mainDiv"
    }
  }, [(this.$store.state.allowSpeechControl) ? _c('div', [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated pulse",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAllControls),
      expression: "showAllControls"
    }],
    staticClass: "container-fluid",
    attrs: {
      "id": "VUIformInputDivID"
    }
  }, [_c('div', {
    staticClass: "col-xs-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userVoiceToText),
      expression: "userVoiceToText"
    }],
    staticClass: "form-control",
    class: _vm.plungeClass,
    staticStyle: {
      "color": "white !important",
      "border-width": "0px"
    },
    attrs: {
      "type": "text",
      "id": "inlineFormInputGroupUsername2",
      "placeholder": "View & Type Voice Commands Here"
    },
    domProps: {
      "value": (_vm.userVoiceToText)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.userVoiceToTextFunc($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userVoiceToText = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  }, [(_vm.initSpeech) ? _c('span', {
    on: {
      "click": _vm.speechFunc
    }
  }, [_c('i', {
    staticClass: "fal fa-microphone-slash",
    attrs: {
      "id": "speechEngage"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.initSpeech) ? _c('span', {
    on: {
      "click": _vm.speechStartStopFunc
    }
  }, [_c('i', {
    staticClass: "fa fa-microphone-alt",
    style: ({
      'color': _vm.recognizing ? 'red' : 'black'
    }),
    attrs: {
      "id": "speechEngageActivated"
    }
  })]) : _vm._e()])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showEnterContainer),
      expression: "showEnterContainer"
    }],
    staticClass: "container-fluid",
    attrs: {
      "id": "enterContainer"
    }
  }, [_c('transition', {
    attrs: {
      "appear": "",
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated rubberBand",
      "mode": "out-in"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showEnterBtn),
      expression: "showEnterBtn"
    }],
    staticClass: "btn-info",
    staticStyle: {
      "color": "white",
      "background-color": "#81effe"
    },
    attrs: {
      "id": "enterFuncBtn"
    },
    on: {
      "~click": function($event) {
        return _vm.enterFunc($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tBEACH VIBES\n\t\t\t\t\t")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLoading),
      expression: "showLoading"
    }],
    staticStyle: {
      "color": "black",
      "border-color": "transparent",
      "background": "transparent"
    },
    attrs: {
      "id": "enterFuncBtn"
    }
  }, [_vm._v(" \t\n\t\t\t\t\t\t\tLoading... \n\t\t\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.whatIsLoading) + "\n\t\t\t\t\t")])])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAllControls),
      expression: "showAllControls"
    }],
    staticClass: "container-fluid",
    attrs: {
      "id": "controlsContainer"
    }
  }, [_c('div', {
    attrs: {
      "id": "ambienceBtnLocation"
    }
  }, [(!_vm.userMobile) ? _c('p', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "fxTitle"
    }
  }, [_vm._v(" \n\t\t\t\t\t\t\tAdd "), _c('i', {
    staticClass: "fal fa-check-circle"
  }), _vm._v(" or Remove "), _c('i', {
    staticClass: "fal fa-times-circle"
  }), _vm._v(" Sounds From Your "), _c('span', {
    attrs: {
      "id": "soundscapeTitleBreak"
    }
  }, [_vm._v("Seaside Soundscape")])]) : (_vm.userMobile) ? _c('p', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "fxTitle"
    }
  }, [_vm._v(" \n\t\t\t\t\t\t\tSeaside Soundscapes")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn1Div"
    }
  }, [_c('button', {
    class: _vm.ambience1Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience1Func
    },
    on: {
      "click": function($event) {
        _vm.ambience1Boolean = !_vm.ambience1Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience1Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tStormy Beach\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience1Vol),
      expression: "ambience1Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance1RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience1Func,
      "max": "6",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience1Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience1Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn2Div"
    }
  }, [_c('button', {
    class: _vm.ambience2Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience2Func
    },
    on: {
      "click": function($event) {
        _vm.ambience2Boolean = !_vm.ambience2Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience2Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tCliffside\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience2Vol),
      expression: "ambience2Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance2RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience2Func,
      "max": "6",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience2Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience2Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn3Div"
    }
  }, [_c('button', {
    class: _vm.ambience3Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience3Func
    },
    on: {
      "click": function($event) {
        _vm.ambience3Boolean = !_vm.ambience3Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience3Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tVenice Beach\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience3Vol),
      expression: "ambience3Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance3RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience3Func,
      "max": "6",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience3Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience3Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn4Div"
    }
  }, [_c('button', {
    class: _vm.ambience4Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience4Func
    },
    on: {
      "click": function($event) {
        _vm.ambience4Boolean = !_vm.ambience4Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience4Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tLava Beach\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience4Vol),
      expression: "ambience4Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance4RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience4Func,
      "max": "6",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience4Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience4Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn5Div"
    }
  }, [_c('button', {
    class: _vm.ambience5Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience5Func
    },
    on: {
      "click": function($event) {
        _vm.ambience5Boolean = !_vm.ambience5Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience5Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tConey Island\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience5Vol),
      expression: "ambience5Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance5RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience5Func,
      "max": "6",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience5Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience5Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn6Div"
    }
  }, [_c('button', {
    class: _vm.ambience6Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience6Func
    },
    on: {
      "click": function($event) {
        _vm.ambience6Boolean = !_vm.ambience6Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience6Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tSerene Beach\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience6Vol),
      expression: "ambience6Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance6RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience6Func,
      "max": "6",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience6Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience6Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "masterControlDiv"
    }
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "fxTitle2"
    }
  }, [_vm._v(" \n\t\t\tProcess Soundscape With Digital Audio Processing\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice1SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voiceBadgeBeach",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.speedToggle = !_vm.speedToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.speedToggle),
      expression: "speedToggle"
    }],
    staticStyle: {
      "color": "black"
    }
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tSpeed " + _vm._s(((_vm.playBackSpeed).toFixed(3))) + "x\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.speedToggle),
      expression: "!speedToggle"
    }],
    staticStyle: {
      "color": "var(--main-stopBeach-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tSpeed " + _vm._s(((_vm.playBackSpeed).toFixed(3))) + "x\n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.playBackSpeed),
      expression: "playBackSpeed",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "instrumentRangerBeach",
    attrs: {
      "id": "sliders6",
      "type": "range",
      "step": "0.01",
      "max": "2",
      "min": "0.1",
      "": _vm.playbackSpeedFunc
    },
    domProps: {
      "value": (_vm.playBackSpeed)
    },
    on: {
      "__r": function($event) {
        _vm.playBackSpeed = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice2SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voiceBadgeBeach",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.fxDelayToggle = !_vm.fxDelayToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fxDelayToggle),
      expression: "fxDelayToggle"
    }],
    staticStyle: {
      "color": "black"
    }
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tDelay " + _vm._s(_vm.fxDelayAmt) + "% \n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fxDelayToggle),
      expression: "!fxDelayToggle"
    }],
    staticStyle: {
      "color": "var(--main-stopBeach-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tDelay " + _vm._s(_vm.fxDelayAmt) + "% \n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.fxDelayAmt),
      expression: "fxDelayAmt",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "instrumentRangerBeach",
    attrs: {
      "id": "sliders2",
      "type": "range",
      "step": "1",
      "max": "100",
      "min": "0",
      "": _vm.fxDelayMix
    },
    domProps: {
      "value": (_vm.fxDelayAmt)
    },
    on: {
      "__r": function($event) {
        _vm.fxDelayAmt = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice3SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voiceBadgeBeach",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.fxChorusToggle = !_vm.fxChorusToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fxChorusToggle),
      expression: "fxChorusToggle"
    }],
    staticStyle: {
      "color": "black"
    }
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tChorus " + _vm._s(_vm.fxChorusAmt) + "% \n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fxChorusToggle),
      expression: "!fxChorusToggle"
    }],
    staticStyle: {
      "color": "var(--main-stopBeach-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tChorus " + _vm._s(_vm.fxChorusAmt) + "% \n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.fxChorusAmt),
      expression: "fxChorusAmt",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "instrumentRangerBeach",
    attrs: {
      "id": "sliders3",
      "type": "range",
      "step": "1",
      "max": "100",
      "min": "0",
      "": _vm.fxChorusMix
    },
    domProps: {
      "value": (_vm.fxChorusAmt)
    },
    on: {
      "__r": function($event) {
        _vm.fxChorusAmt = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice4SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voiceBadgeBeach",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.fxFilterToggle = !_vm.fxFilterToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fxFilterToggle),
      expression: "fxFilterToggle"
    }],
    staticStyle: {
      "color": "black"
    }
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tFilter " + _vm._s(_vm.fxAutoFilterAmt) + "Hz\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fxFilterToggle),
      expression: "!fxFilterToggle"
    }],
    staticStyle: {
      "color": "var(--main-stopBeach-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tFilter " + _vm._s(_vm.fxAutoFilterAmt) + "Hz\n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.fxAutoFilterAmt),
      expression: "fxAutoFilterAmt",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "instrumentRangerBeach",
    attrs: {
      "id": "sliders4",
      "type": "range",
      "step": "1",
      "max": "10000",
      "min": "80",
      "": _vm.fxAutoFilterMix
    },
    domProps: {
      "value": (_vm.fxAutoFilterAmt)
    },
    on: {
      "__r": function($event) {
        _vm.fxAutoFilterAmt = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice5SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voiceBadgeBeach",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.fxConvolverToggle = !_vm.fxConvolverToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fxConvolverToggle),
      expression: "fxConvolverToggle"
    }],
    staticStyle: {
      "color": "black"
    }
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tReverb (" + _vm._s(((_vm.fxDecay).toPrecision(2))) + "s) " + _vm._s((_vm.fxConvolverAmt * 2)) + "%\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fxConvolverToggle),
      expression: "!fxConvolverToggle"
    }],
    staticStyle: {
      "color": "var(--main-stopBeach-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tReverb (" + _vm._s(((_vm.fxDecay).toPrecision(2))) + "s) " + _vm._s((_vm.fxConvolverAmt * 2)) + "%\n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.fxConvolverAmt),
      expression: "fxConvolverAmt",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "instrumentRangerBeach",
    attrs: {
      "id": "sliders1",
      "type": "range",
      "step": "1",
      "max": "50",
      "min": "0",
      "": _vm.fxConvolverMix
    },
    domProps: {
      "value": (_vm.fxConvolverAmt)
    },
    on: {
      "__r": function($event) {
        _vm.fxConvolverAmt = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice6SliderDiv"
    }
  }, [_c('button', {
    class: _vm.mattChillClass,
    attrs: {
      "id": "masterControlBadgesSFX"
    },
    on: {
      "click": _vm.mattChillMethod
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.randomizeBoolean),
      expression: "!randomizeBoolean"
    }]
  }, [_c('i', {
    staticClass: "fa fa-flask"
  }), _vm._v(" Randomize "), _c('i', {
    staticClass: "fa fa-flask"
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.randomizeBoolean),
      expression: "randomizeBoolean"
    }]
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask5),
      expression: "showFlask5"
    }],
    staticClass: "fa fa-flask fa-counter-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask3),
      expression: "showFlask3"
    }],
    staticClass: "fa fa-flask fa-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask1),
      expression: "showFlask1"
    }],
    staticClass: "fa fa-flask slow-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask2),
      expression: "showFlask2"
    }],
    staticClass: "fa fa-flask slow-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask4),
      expression: "showFlask4"
    }],
    staticClass: "fa fa-flask fa-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask6),
      expression: "showFlask6"
    }],
    staticClass: "fa fa-flask fa-counter-spin"
  })])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAboutPage),
      expression: "showAboutPage"
    }],
    staticClass: "col-xs-12",
    attrs: {
      "id": "aboutPageID"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "aboutTxt"
    }
  }, [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t\tConsidering most of our planet is covered in water, it only makes sense that a sizeable portion of its land is dedicated to a meeting point. Seaside’s come in all shapes, sizes, and forms. Each creating its own unique soundscape. From a lava sand beach in Hawaii to a cliff side off the coast of Maine. Our earth's varying seasides operate on a scale from calm to chaos.\n\t\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t\tThe craziest part of this soundscape recording was hanging off a cliff side in Maine capturing the thrashing waves below. I tend to think it was worth it, but you can be the judge.\n\t\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "disclaimerTxt"
    }
  }, [_vm._v("\n\t\t\t\t\t\tSound Design & Recordings Copyright © 2018 "), _c('a', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "href": "https://www.mattmccorkle.com",
      "target": "_blank"
    }
  }, [_vm._v("Matt McCorkle")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v(" These sounds are presented here for personal entertainment use only. ")]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t\tFor commercial sound licensing email hi@mattmccorkle.com\n\t\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    class: _vm.helpClass,
    attrs: {
      "id": "aboutBtnID2"
    },
    on: {
      "click": _vm.goToHelp
    }
  }, [_c('strong', [_c('i', {
    staticClass: "fa fa-window-close fa-3x"
  })])])])]), _vm._v(" "), (this.$store.state.allowSpeechControl) ? _c('div') : _vm._e(), _vm._v(" "), (this.$store.state.allowSpeechControl) ? _c('div', [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated pulse",
      "mode": "out-in"
    }
  }, [(_vm.showSpeechBtns) ? _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "speechContainer"
    }
  }, [_c('button', {
    class: _vm.speechShowListClass,
    attrs: {
      "id": "speechList"
    },
    on: {
      "click": _vm.voiceCommandListFunc
    }
  }, [_c('i', {
    staticClass: "fal fa-clipboard-list"
  }), _vm._v(" List of Voice Commands\n\t\t\t\t")]), _vm._v(" "), (_vm.showVoiceCommandList) ? _c('div', {
    attrs: {
      "id": "voiceCommandListID"
    }
  }, [_c('p', {
    attrs: {
      "id": "voiceControlListTitle"
    }
  }, [_c('strong', [_vm._v(" Voice Control This Immersive Experience")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "voiceControlListTxt"
    }
  }, [_c('strong', [_vm._v("Allow Google Chrome Microphone Access To Use This Feature")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "fal fa-headphones"
  }), _vm._v(" Voice Control Works "), _c('strong', [_c('u', [_vm._v("Great")])]), _vm._v(" With Headphones "), _c('i', {
    staticClass: "fal fa-headphones"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("OK! Now Use That Beautiful Voice, Say Something!\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('u', [_vm._v("Exploration:")]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\tLet's Explore!\n\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\tRandomize, Shift Soundscape,")]), _vm._v(" or "), _c('strong', [_vm._v("New Scene")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_c('u', [_vm._v("Creating A Soundscape:")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Stormy Beach")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Cliffside")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Venice Beach")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Lava Beach")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Coney Island")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Serene Beach")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Stop ")]), _vm._v(" or "), _c('strong', [_vm._v("Take Out ")]), _vm._v("[Sound Source Name] \n\t\t\t\t\t"), _c('br'), _c('span', {
    attrs: {
      "id": "voiceListAnchor"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Volume Up")]), _vm._v(" or "), _c('strong', [_vm._v("Louder")]), _vm._v(" [Sound Source Name]\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Volume Down")]), _vm._v(" or "), _c('strong', [_vm._v("Softer ")]), _vm._v("[Sound Source Name]\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_c('u', [_vm._v("Digital Audio Effects:")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Speed Up ")]), _vm._v("or "), _c('strong', [_vm._v("Faster")]), _vm._v(" & "), _c('strong', [_vm._v("Speed Down ")]), _vm._v("or "), _c('strong', [_vm._v("Slower")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Delay On")]), _vm._v(" or "), _c('strong', [_vm._v("Off ")]), _vm._v(" & "), _c('strong', [_vm._v("More ")]), _vm._v("or "), _c('strong', [_vm._v("Less")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Chorus On")]), _vm._v(" or "), _c('strong', [_vm._v("Off ")]), _vm._v(" & "), _c('strong', [_vm._v("More ")]), _vm._v("or "), _c('strong', [_vm._v("Less")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Filter On")]), _vm._v(" or "), _c('strong', [_vm._v("Off ")]), _vm._v(" & "), _c('strong', [_vm._v("More ")]), _vm._v("or "), _c('strong', [_vm._v("Less")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Reverb On")]), _vm._v(" or "), _c('strong', [_vm._v("Off ")]), _vm._v(" & "), _c('strong', [_vm._v("More ")]), _vm._v("or "), _c('strong', [_vm._v("Less")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('i', [_vm._v("Add the word "), _c('strong', [_vm._v("a lot")]), _vm._v(" to move in greater increments.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_c('u', [_vm._v("Housekeeping:")]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\tStop All Sounds \n\t\t\t\t\t"), _c('br'), _vm._v(" \n\t\t\t\t\tPlay All Sounds\n\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\tStop Voice Commands \n\t\t\t\t\t"), _c('br'), _vm._v(" \n\t\t\t\t\tGo Home\n\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\tShow")]), _vm._v(" or "), _c('strong', [_vm._v("Hide Soundscape Info\n\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\tShow")]), _vm._v(" or "), _c('strong', [_vm._v("Hide Voice Command List")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_c('u', [_vm._v("Additional Mentions:")])]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t1.) It might take a few tries, try saying your command quickly and in a direct manner.\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t2.) Each Sound Source can always be addressed as \"Sound Source 1-6\"\n\t\t\t\t")])]) : _vm._e()]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (!this.$store.state.allowSpeechControl) ? _c('div', [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNavBar),
      expression: "showNavBar"
    }],
    staticClass: "container-fluid"
  }, [_c('button', {
    class: _vm.exploreFuncClass,
    attrs: {
      "id": "exploreBtnId"
    },
    on: {
      "click": _vm.exploreBtnFunc
    }
  }, [_c('i', {
    class: _vm.exploreIconClass
  }), _vm._v(" " + _vm._s(_vm.exploreTxt) + "\n\t\t\t\t")])])])], 1) : _vm._e(), _vm._v(" "), _c('transition-group', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNavBar),
      expression: "showNavBar"
    }],
    key: "localStorageBtnsKey",
    staticClass: "container-fluid",
    attrs: {
      "id": "helpContainer"
    }
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    class: _vm.saveClass,
    attrs: {
      "id": "localStorageBtnID"
    },
    on: {
      "click": _vm.setLocalStorage
    }
  }, [_c('i', {
    staticClass: "fal fa-sliders-h"
  }), _vm._v(" Save\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    class: _vm.loadClass,
    attrs: {
      "id": "localStorageBtnID"
    },
    on: {
      "click": _vm.getLocalStorage
    }
  }, [_c('i', {
    staticClass: "fal fa-sliders-h"
  }), _vm._v(" Load\n\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNavBar),
      expression: "showNavBar"
    }],
    key: "helpBtnsKeys",
    staticClass: "container-fluid",
    attrs: {
      "id": "helpContainer"
    }
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    class: _vm.helpClass,
    attrs: {
      "id": "aboutBtnID"
    },
    on: {
      "click": _vm.goToHelp
    }
  }, [_c('i', {
    staticClass: "fal fa-info-circle"
  }), _vm._v(" Info\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    class: _vm.helpClass,
    attrs: {
      "id": "aboutBtnID"
    },
    on: {
      "click": _vm.goHome
    }
  }, [_c('i', {
    staticClass: "fas fa-home"
  }), _vm._v(" Home\n\t\t\t\t\t")])])])]), _vm._v(" "), (!_vm.userMobile) ? _c('div', [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNavBar),
      expression: "showNavBar"
    }],
    staticClass: "container-fluid",
    attrs: {
      "id": "visualToggleContainer"
    }
  }, [(_vm.activeSun) ? _c('span', {
    attrs: {
      "id": "visualToggle"
    },
    on: {
      "click": function($event) {
        _vm.activeSun = !_vm.activeSun
      }
    }
  }, [_vm._v(" \n\t\t\t\t\t\tReactive Background\n\t\t\t\t\t\t"), _c('i', {
    staticClass: "fal fa-toggle-on"
  })]) : (!_vm.activeSun) ? _c('span', {
    attrs: {
      "id": "visualToggle"
    },
    on: {
      "click": function($event) {
        _vm.activeSun = !_vm.activeSun
      }
    }
  }, [_vm._v(" \n\t\t\t\t\t\tReactive Background\n\t\t\t\t\t\t"), _c('i', {
    staticClass: "fal fa-toggle-off"
  })]) : _vm._e()])])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 62 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    class: _vm.plungeClass,
    attrs: {
      "id": "mainDiv"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showEnterContainer),
      expression: "showEnterContainer"
    }],
    staticClass: "container-fluid",
    attrs: {
      "id": "enterContainer"
    }
  }, [_c('transition', {
    attrs: {
      "appear": "",
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated zoomOutUp",
      "mode": "out-in"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showEnterBtn),
      expression: "showEnterBtn"
    }],
    staticClass: "btn-info",
    staticStyle: {
      "color": "white",
      "background-color": "var(--main-fxBadgesTutorial-color)"
    },
    attrs: {
      "id": "enterFuncBtn"
    },
    on: {
      "~click": function($event) {
        return _vm.enterFunc($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.welcomePrompt) + "\n\t\t\t\t\t")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLoading),
      expression: "showLoading"
    }],
    staticStyle: {
      "color": "white",
      "border-color": "transparent",
      "background": "transparent"
    },
    attrs: {
      "id": "enterFuncBtn"
    }
  }, [_vm._v(" \t\n\t\t\t\t\t\t\tLoading... \n\t\t\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.whatIsLoading) + "\n\t\t\t\t\t")])])], 1), _vm._v(" "), (this.$store.state.allowSpeechControl) ? _c('div', [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated pulse",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAllControls),
      expression: "showAllControls"
    }],
    staticClass: "container-fluid",
    attrs: {
      "id": "VUIformInputDivID"
    }
  }, [_c('div', {
    staticClass: "col-xs-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userVoiceToText),
      expression: "userVoiceToText"
    }],
    staticClass: "form-control",
    class: _vm.plungeClass,
    staticStyle: {
      "color": "black !important",
      "border-width": "0px"
    },
    attrs: {
      "type": "text",
      "id": "inlineFormInputGroupUsername2",
      "placeholder": "View & Type Voice Commands Here"
    },
    domProps: {
      "value": (_vm.userVoiceToText)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.userVoiceToTextFunc($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userVoiceToText = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  }, [(_vm.initSpeech) ? _c('span', {
    on: {
      "click": _vm.speechFunc
    }
  }, [_c('i', {
    staticClass: "fal fa-microphone-slash",
    attrs: {
      "id": "speechEngage"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.initSpeech) ? _c('span', {
    on: {
      "click": _vm.speechStartStopFunc
    }
  }, [_c('i', {
    staticClass: "fa fa-microphone-alt",
    style: ({
      'color': _vm.recognizing ? 'red' : 'black'
    }),
    attrs: {
      "id": "speechEngageActivated"
    }
  })]) : _vm._e()])])])], 1) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAllControls),
      expression: "showAllControls"
    }],
    staticClass: "container-fluid",
    attrs: {
      "id": "fxTitleTutorial"
    }
  }, [(!_vm.userMobile) ? _c('p', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "fxTutorialTitle"
    }
  }, [_vm._v(" \n\t\t\t\t\tClick An Audio Clip Below To Learn More About App Features\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.userMobile) ? _c('p', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "fxTutorialTitle"
    }
  }, [_vm._v(" \n\t\t\t\t\tClick A Clip To Learn More\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "tutorialContainer"
    }
  }, [_c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "helpBtn1Div"
    }
  }, [_c('button', {
    class: _vm.soundSourceVOClass,
    attrs: {
      "id": "ambienceBtns"
    },
    on: {
      "click": _vm.soundSourceVOFunc
    }
  }, [_c('i', {
    class: _vm.soundSourceVOIcon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tSound Sources\n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "helpBtn2Div"
    }
  }, [_c('button', {
    class: _vm.soundFXVOClass,
    attrs: {
      "id": "ambienceBtns"
    },
    on: {
      "click": _vm.soundFXVOFunc
    }
  }, [_c('i', {
    class: _vm.soundFXVOIcon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tSound Effects\n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "helpBtn3Div"
    }
  }, [_c('button', {
    class: _vm.randomizeVOClass,
    attrs: {
      "id": "ambienceBtns"
    },
    on: {
      "click": _vm.randomizeVOFunc
    }
  }, [_c('i', {
    class: _vm.randomizeVOIcon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tRandomize\n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "helpBtn4Div"
    }
  }, [(this.$store.state.allowSpeechControl) ? _c('button', {
    class: _vm.voiceVOClass,
    attrs: {
      "id": "ambienceBtns"
    },
    on: {
      "click": _vm.voiceVOFunc
    }
  }, [_c('i', {
    class: _vm.voiceVOIcon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tVoice Control\n\t\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (!this.$store.state.allowSpeechControl) ? _c('button', {
    class: _vm.exploreVOClass,
    attrs: {
      "id": "ambienceBtns"
    },
    on: {
      "click": _vm.exploreVOFunc
    }
  }, [_c('i', {
    class: _vm.exploreVOIcon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tExplore!\n\t\t\t\t\t\t\t\t\t")]) : _vm._e()])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAllControls),
      expression: "showAllControls"
    }],
    staticClass: "container-fluid",
    attrs: {
      "id": "controlsContainerTutorial"
    }
  }, [_c('div', {
    attrs: {
      "id": "ambienceBtnLocation"
    }
  }, [(!_vm.userMobile) ? _c('p', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "fxTutorialTitle2"
    }
  }, [_vm._v(" \n\t\t\t\t\t\t\t\tAdd "), _c('i', {
    staticClass: "fal fa-check-circle"
  }), _vm._v(" or Remove "), _c('i', {
    staticClass: "fal fa-times-circle"
  }), _vm._v(" Sound Sources For Each "), _c('span', {
    attrs: {
      "id": "soundscapeTitleBreak"
    }
  }, [_vm._v("Soundscape Module")])]) : (_vm.userMobile) ? _c('p', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "fxTutorialTitle2"
    }
  }, [_vm._v(" \n\t\t\t\t\t\t\t\tSoundscape Sound Sources Below\n\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn1Div"
    }
  }, [_c('button', {
    class: _vm.ambience1Class,
    attrs: {
      "id": "ambienceBtns"
    },
    on: {
      "click": _vm.ambience1Func
    }
  }, [_c('i', {
    class: _vm.ambience1Icon
  }), _vm._v(" "), _vm._v("\n\t\t\t\t\t\t\t\t\t\tSerene Beach\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience1Vol),
      expression: "ambience1Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance1RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambienceMixing,
      "max": "0",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience1Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience1Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn2Div"
    }
  }, [_c('button', {
    class: _vm.ambience2Class,
    attrs: {
      "id": "ambienceBtns"
    },
    on: {
      "click": _vm.ambience2Func
    }
  }, [_c('i', {
    class: _vm.ambience2Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tForest\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience2Vol),
      expression: "ambience2Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance2RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambienceMixing,
      "max": "0",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience2Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience2Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn3Div"
    }
  }, [_c('button', {
    class: _vm.ambience3Class,
    attrs: {
      "id": "ambienceBtns"
    },
    on: {
      "click": _vm.ambience3Func
    }
  }, [_c('i', {
    class: _vm.ambience3Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tDeep Sea\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience3Vol),
      expression: "ambience3Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance3RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambienceMixing,
      "max": "0",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience3Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience3Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn4Div"
    }
  }, [_c('button', {
    class: _vm.ambience4Class,
    attrs: {
      "id": "ambienceBtns"
    },
    on: {
      "click": _vm.ambience4Func
    }
  }, [_c('i', {
    class: _vm.ambience4Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tSubway Station\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience4Vol),
      expression: "ambience4Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance4RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambienceMixing,
      "max": "0",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience4Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience4Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn5Div"
    }
  }, [_c('button', {
    class: _vm.ambience5Class,
    attrs: {
      "id": "ambienceBtns"
    },
    on: {
      "click": _vm.ambience5Func
    }
  }, [_c('i', {
    class: _vm.ambience5Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tLonggrass\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience5Vol),
      expression: "ambience5Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance5RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambienceMixing,
      "max": "0",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience5Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience5Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn6Div"
    }
  }, [_c('button', {
    class: _vm.ambience6Class,
    attrs: {
      "id": "ambienceBtns"
    },
    on: {
      "click": _vm.ambience6Func
    }
  }, [_c('i', {
    class: _vm.ambience6Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tStream\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience6Vol),
      expression: "ambience6Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance6RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambienceMixing,
      "max": "0",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience6Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience6Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "masterControlDiv"
    }
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "fxTutorialTitle3"
    }
  }, [_vm._v(" \n\t\t\t\tProcess Your Soundscapes With These Digital Audio Processing Effects\n\t\t\t\t")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userMobile),
      expression: "userMobile"
    }],
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "fxTutorialTitle3"
    }
  }, [_vm._v(" \n\t\t\t\tAccess This App On Your Computer For More Effects\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice1SliderDiv"
    }
  }, [_c('button', {
    class: _vm.highlightSlider1,
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.speedToggle = !_vm.speedToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.speedToggle),
      expression: "speedToggle"
    }]
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tSpeed " + _vm._s(((_vm.playBackSpeed).toFixed(3))) + "x \n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.speedToggle),
      expression: "!speedToggle"
    }],
    staticStyle: {
      "color": "var(--main-stopTutorial-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tSpeed " + _vm._s(((_vm.playBackSpeed).toFixed(3))) + "x \n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.playBackSpeed),
      expression: "playBackSpeed",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.instrumentRanger1,
    attrs: {
      "id": "sliders6",
      "type": "range",
      "step": "0.01",
      "max": "2",
      "min": "0.1",
      "": _vm.playbackSpeedFunc
    },
    domProps: {
      "value": (_vm.playBackSpeed)
    },
    on: {
      "__r": function($event) {
        _vm.playBackSpeed = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice2SliderDiv"
    }
  }, [_c('button', {
    class: _vm.highlightSlider2,
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.fxDelayToggle = !_vm.fxDelayToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fxDelayToggle),
      expression: "fxDelayToggle"
    }]
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tDelay " + _vm._s(_vm.fxDelayAmt) + "% \n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fxDelayToggle),
      expression: "!fxDelayToggle"
    }],
    staticStyle: {
      "color": "var(--main-stopTutorial-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tDelay " + _vm._s(_vm.fxDelayAmt) + "% \n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.fxDelayAmt),
      expression: "fxDelayAmt",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.instrumentRanger2,
    attrs: {
      "id": "sliders2",
      "type": "range",
      "step": "1",
      "max": "100",
      "min": "0",
      "": _vm.fxDelayMix
    },
    domProps: {
      "value": (_vm.fxDelayAmt)
    },
    on: {
      "__r": function($event) {
        _vm.fxDelayAmt = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice3SliderDiv"
    }
  }, [_c('button', {
    class: _vm.highlightSlider3,
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.fxChorusToggle = !_vm.fxChorusToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fxChorusToggle),
      expression: "fxChorusToggle"
    }]
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tChorus " + _vm._s(_vm.fxChorusAmt) + "% \n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fxChorusToggle),
      expression: "!fxChorusToggle"
    }],
    staticStyle: {
      "color": "var(--main-stopTutorial-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tChorus " + _vm._s(_vm.fxChorusAmt) + "% \n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.fxChorusAmt),
      expression: "fxChorusAmt",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.instrumentRanger3,
    attrs: {
      "id": "sliders3",
      "type": "range",
      "step": "1",
      "max": "100",
      "min": "0",
      "": _vm.fxChorusMix
    },
    domProps: {
      "value": (_vm.fxChorusAmt)
    },
    on: {
      "__r": function($event) {
        _vm.fxChorusAmt = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice4SliderDiv"
    }
  }, [_c('button', {
    class: _vm.highlightSlider4,
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.fxFilterToggle = !_vm.fxFilterToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fxFilterToggle),
      expression: "fxFilterToggle"
    }]
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tFilter " + _vm._s(_vm.fxAutoFilterAmt) + "Hz\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fxFilterToggle),
      expression: "!fxFilterToggle"
    }],
    staticStyle: {
      "color": "var(--main-stopTutorial-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tFilter " + _vm._s(_vm.fxAutoFilterAmt) + "Hz\n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.fxAutoFilterAmt),
      expression: "fxAutoFilterAmt",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.instrumentRanger4,
    attrs: {
      "id": "sliders4",
      "type": "range",
      "step": "1",
      "max": "10000",
      "min": "80",
      "": _vm.fxAutoFilterMix
    },
    domProps: {
      "value": (_vm.fxAutoFilterAmt)
    },
    on: {
      "__r": function($event) {
        _vm.fxAutoFilterAmt = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice5SliderDiv"
    }
  }, [_c('button', {
    class: _vm.highlightSlider5,
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.fxConvolverToggle = !_vm.fxConvolverToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fxConvolverToggle),
      expression: "fxConvolverToggle"
    }]
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tReverb (" + _vm._s(((_vm.fxDecay).toPrecision(2))) + "s) " + _vm._s((_vm.fxConvolverAmt * 2)) + "%\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fxConvolverToggle),
      expression: "!fxConvolverToggle"
    }],
    staticStyle: {
      "color": "var(--main-stopTutorial-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tReverb (" + _vm._s(((_vm.fxDecay).toPrecision(2))) + "s) " + _vm._s((_vm.fxConvolverAmt * 2)) + "%\n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.fxConvolverAmt),
      expression: "fxConvolverAmt",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.instrumentRanger5,
    attrs: {
      "id": "sliders1",
      "type": "range",
      "step": "1",
      "max": "50",
      "min": "0",
      "": _vm.fxConvolverMix
    },
    domProps: {
      "value": (_vm.fxConvolverAmt)
    },
    on: {
      "__r": function($event) {
        _vm.fxConvolverAmt = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice6SliderDiv"
    }
  }, [_c('button', {
    class: _vm.mattChillClass,
    attrs: {
      "id": "masterControlBadgesSFX"
    },
    on: {
      "click": _vm.mattChillMethod
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.randomizeBoolean),
      expression: "!randomizeBoolean"
    }]
  }, [_c('i', {
    staticClass: "fa fa-flask"
  }), _vm._v(" Randomize "), _c('i', {
    staticClass: "fa fa-flask"
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.randomizeBoolean),
      expression: "randomizeBoolean"
    }]
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask5),
      expression: "showFlask5"
    }],
    staticClass: "fa fa-flask fa-counter-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask3),
      expression: "showFlask3"
    }],
    staticClass: "fa fa-flask fa-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask1),
      expression: "showFlask1"
    }],
    staticClass: "fa fa-flask slow-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask2),
      expression: "showFlask2"
    }],
    staticClass: "fa fa-flask slow-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask4),
      expression: "showFlask4"
    }],
    staticClass: "fa fa-flask fa-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask6),
      expression: "showFlask6"
    }],
    staticClass: "fa fa-flask fa-counter-spin"
  })])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAboutPage),
      expression: "showAboutPage"
    }],
    staticClass: "col-xs-12",
    attrs: {
      "id": "aboutPageID"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "aboutTxt"
    }
  }, [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t\tSoundscapes are everywhere you go. But each time you visit them, they never sound exactly the same. This app sets out out to explore soundscapes from different geographical locations. \n\t\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t\tEnter this immersive audio experience using your browser and explore unique soundscapes from around the world. Within each soundscape, control individual sounds to create the whole of a greater soundscape. Utilizing five powerful digital audio effects, you can shape your soundscapes even further by twisting and transforming their sound waves.\n\t\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "disclaimerTxt"
    }
  }, [_vm._v("\n\t\t\t\t\t\tSound Design & Recordings Copyright © 2018 "), _c('a', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "href": "https://www.mattmccorkle.com",
      "target": "_blank"
    }
  }, [_vm._v("Matt McCorkle")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v(" These sounds are presented here for personal entertainment use only. ")]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t\tFor commercial sound licensing email hi@mattmccorkle.com\n\t\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    class: _vm.helpClass,
    attrs: {
      "id": "aboutBtnID2"
    },
    on: {
      "click": _vm.goToHelp
    }
  }, [_c('strong', [_c('i', {
    staticClass: "fa fa-window-close fa-3x"
  })])])])]), _vm._v(" "), (this.$store.state.allowSpeechControl) ? _c('div') : _vm._e(), _vm._v(" "), (this.$store.state.allowSpeechControl) ? _c('div', [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated pulse",
      "mode": "out-in"
    }
  }, [(_vm.showSpeechBtns) ? _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "speechContainer"
    }
  }, [_c('button', {
    class: _vm.speechShowListClass,
    attrs: {
      "id": "speechList"
    },
    on: {
      "click": _vm.voiceCommandListFunc
    }
  }, [_c('i', {
    staticClass: "fal fa-clipboard-list"
  }), _vm._v(" List of Voice Commands\n\t\t\t\t")]), _vm._v(" "), (_vm.showVoiceCommandList) ? _c('div', {
    attrs: {
      "id": "voiceCommandListID"
    }
  }, [_c('p', {
    attrs: {
      "id": "voiceControlListTitle"
    }
  }, [_c('strong', [_vm._v(" Voice Control This Immersive Experience")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "voiceControlListTxt"
    }
  }, [_c('strong', [_vm._v("Allow Google Chrome Microphone Access To Use This Feature")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "fal fa-headphones"
  }), _vm._v(" Voice Control Works "), _c('strong', [_c('u', [_vm._v("Great")])]), _vm._v(" With Headphones "), _c('i', {
    staticClass: "fal fa-headphones"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("OK! Now Use That Beautiful Voice, Say Something!\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('u', [_vm._v("Exploration:")]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\tLet's Explore!\n\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\tRandomize, Shift Soundscape, or New Scene")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_c('u', [_vm._v("Creating A Soundscape:")]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\tPlay ")]), _c('i', [_vm._v("[Sound Source]")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Add In ")]), _vm._v("[Sound Source]\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Stop ")]), _vm._v("[Sound Source] \n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Take Out ")]), _vm._v("[Sound Source]\n\t\t\t\t\t"), _c('br'), _c('span', {
    attrs: {
      "id": "voiceListAnchor"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Volume Up or Louder ")]), _vm._v("[Sound Source]\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Volume Down or Softer ")]), _vm._v("[Sound Source]\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('i', [_vm._v("You Can Also Refer To Each Sound Source as \"Sound Source 1-6\"")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_c('u', [_vm._v("Digital Audio Effect:")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Turn ")]), _c('i', [_vm._v("[Sound Effect]")]), _c('strong', [_vm._v(" On or Off \n\t\t\t\t\t"), _c('br'), _vm._v(" \n\t\t\t\t\tMore or Less ")]), _c('i', [_vm._v("[Sound Effect]")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_c('u', [_vm._v("Housekeeping:")]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\tStop All Sounds \n\t\t\t\t\t"), _c('br'), _vm._v(" \n\t\t\t\t\tPlay All Sounds\n\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\tStop Voice Commands \n\t\t\t\t\t"), _c('br'), _vm._v(" \n\t\t\t\t\tGo Home\n\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\tShow")]), _vm._v(" or "), _c('strong', [_vm._v("Hide Soundscape Info\n\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\tShow")]), _vm._v(" or "), _c('strong', [_vm._v("Hide Voice Command List")]), _vm._v(" "), _c('br')])]) : _vm._e()]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (!this.$store.state.allowSpeechControl) ? _c('div', [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNavBar),
      expression: "showNavBar"
    }],
    staticClass: "container-fluid"
  }, [_c('button', {
    class: _vm.exploreFuncClass,
    attrs: {
      "id": "exploreBtnId"
    },
    on: {
      "click": _vm.exploreBtnFunc
    }
  }, [_c('i', {
    class: _vm.exploreIconClass
  }), _vm._v(" " + _vm._s(_vm.exploreTxt) + "\n\t\t\t\t")])])])], 1) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNavBar),
      expression: "showNavBar"
    }],
    staticClass: "container-fluid",
    attrs: {
      "id": "helpContainerTutorial"
    }
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    class: _vm.helpClass,
    attrs: {
      "id": "aboutBtnID"
    },
    on: {
      "click": _vm.goToHelp
    }
  }, [_c('i', {
    staticClass: "fal fa-info-circle"
  }), _vm._v(" Info\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    class: _vm.helpClass,
    attrs: {
      "id": "aboutBtnID"
    },
    on: {
      "click": _vm.goHome
    }
  }, [_c('i', {
    staticClass: "fas fa-home"
  }), _vm._v(" Home\n\t\t\t\t\t")])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view', [_c('span', {
    attrs: {
      "": _vm.keyboardTriggering
    }
  })])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 64 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    class: _vm.plungeClass,
    attrs: {
      "id": "mainDiv"
    }
  }, [(this.$store.state.allowSpeechControl) ? _c('div', [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated pulse",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAllControls),
      expression: "showAllControls"
    }],
    staticClass: "container-fluid",
    attrs: {
      "id": "VUIformInputDivID"
    }
  }, [_c('div', {
    staticClass: "col-xs-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userVoiceToText),
      expression: "userVoiceToText"
    }],
    staticClass: "form-control",
    class: _vm.plungeClass,
    staticStyle: {
      "color": "white !important",
      "border-width": "0px"
    },
    attrs: {
      "type": "text",
      "id": "inlineFormInputGroupUsername2",
      "placeholder": "View & Type Voice Commands Here"
    },
    domProps: {
      "value": (_vm.userVoiceToText)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.userVoiceToTextFunc($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userVoiceToText = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  }, [(_vm.initSpeech) ? _c('span', {
    on: {
      "click": _vm.speechFunc
    }
  }, [_c('i', {
    staticClass: "fal fa-microphone-slash",
    attrs: {
      "id": "speechEngage"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.initSpeech) ? _c('span', {
    on: {
      "click": _vm.speechStartStopFunc
    }
  }, [_c('i', {
    staticClass: "fa fa-microphone-alt",
    style: ({
      'color': _vm.recognizing ? 'red' : 'black'
    }),
    attrs: {
      "id": "speechEngageActivated"
    }
  })]) : _vm._e()])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showEnterContainer),
      expression: "showEnterContainer"
    }],
    staticClass: "container-fluid",
    attrs: {
      "id": "enterContainer"
    }
  }, [_c('transition', {
    attrs: {
      "appear": "",
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated zoomOutDown",
      "mode": "out-in"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showEnterBtn),
      expression: "showEnterBtn"
    }],
    staticClass: "btn-info",
    staticStyle: {
      "color": "black",
      "background-color": "#f0f5f5"
    },
    attrs: {
      "id": "enterFuncBtn"
    },
    on: {
      "~click": function($event) {
        return _vm.enterFunc($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tHELLO THERE!\n\t\t\t\t\t")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLoading),
      expression: "showLoading"
    }],
    staticStyle: {
      "color": "white",
      "border-color": "transparent",
      "background": "transparent"
    },
    attrs: {
      "id": "enterFuncBtn"
    }
  }, [_vm._v(" \t\n\t\t\t\t\t\t\tLoading... \n\t\t\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.whatIsLoading) + "\n\t\t\t\t\t")])])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAllControls),
      expression: "showAllControls"
    }],
    staticClass: "container-fluid",
    attrs: {
      "id": "controlsContainer"
    }
  }, [_c('div', {
    attrs: {
      "id": "ambienceBtnLocation"
    }
  }, [(!_vm.userMobile) ? _c('p', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "fxTitle"
    }
  }, [_vm._v(" \n\t\t\t\t\t\t\tAdd "), _c('i', {
    staticClass: "fal fa-check-circle"
  }), _vm._v(" or Remove "), _c('i', {
    staticClass: "fal fa-times-circle"
  }), _vm._v(" Sounds From Your "), _c('span', {
    attrs: {
      "id": "soundscapeTitleBreak"
    }
  }, [_vm._v(" Small Town Soundscape")])]) : (_vm.userMobile) ? _c('p', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "fxTitle"
    }
  }, [_vm._v(" \n\t\t\t\t\t\t\tSmall Town Soundscape")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn1Div"
    }
  }, [_c('button', {
    class: _vm.ambience1Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience1Func
    },
    on: {
      "click": function($event) {
        _vm.ambience1Boolean = !_vm.ambience1Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience1Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tHillside\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience1Vol),
      expression: "ambience1Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance1RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience1Func,
      "max": "10",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience1Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience1Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn2Div"
    }
  }, [_c('button', {
    class: _vm.ambience2Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience2Func
    },
    on: {
      "click": function($event) {
        _vm.ambience2Boolean = !_vm.ambience2Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience2Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tHighway\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience2Vol),
      expression: "ambience2Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance2RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience2Func,
      "max": "6",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience2Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience2Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn3Div"
    }
  }, [_c('button', {
    class: _vm.ambience3Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience3Func
    },
    on: {
      "click": function($event) {
        _vm.ambience3Boolean = !_vm.ambience3Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience3Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tMower\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience3Vol),
      expression: "ambience3Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance3RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience3Func,
      "max": "6",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience3Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience3Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn4Div"
    }
  }, [_c('button', {
    class: _vm.ambience4Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience4Func
    },
    on: {
      "click": function($event) {
        _vm.ambience4Boolean = !_vm.ambience4Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience4Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tPeaceful Field\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience4Vol),
      expression: "ambience4Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance4RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience4Func,
      "max": "0",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience4Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience4Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn5Div"
    }
  }, [_c('button', {
    class: _vm.ambience5Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience5Func
    },
    on: {
      "click": function($event) {
        _vm.ambience5Boolean = !_vm.ambience5Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience5Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tLocomotive\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience5Vol),
      expression: "ambience5Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance5RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience5Func,
      "max": "2",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience5Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience5Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn6Div"
    }
  }, [_c('button', {
    class: _vm.ambience6Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience6Func
    },
    on: {
      "click": function($event) {
        _vm.ambience6Boolean = !_vm.ambience6Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience6Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tBells\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience6Vol),
      expression: "ambience6Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance6RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience6Func,
      "max": "6",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience6Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience6Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "masterControlDiv"
    }
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "fxTitle2"
    }
  }, [_vm._v(" \n\t\t\t\tProcess Soundscape With Digital Audio Processing\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice1SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voiceBadgeRural",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.speedToggle = !_vm.speedToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.speedToggle),
      expression: "speedToggle"
    }],
    staticStyle: {
      "color": "white"
    }
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tSpeed " + _vm._s(((_vm.playBackSpeed).toFixed(3))) + "x\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.speedToggle),
      expression: "!speedToggle"
    }],
    staticStyle: {
      "color": "var(--main-stopRural-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tSpeed " + _vm._s(((_vm.playBackSpeed).toFixed(3))) + "x\n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.playBackSpeed),
      expression: "playBackSpeed",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "instrumentRangerRural",
    attrs: {
      "id": "sliders6",
      "type": "range",
      "step": "0.01",
      "max": "2",
      "min": "0.1",
      "": _vm.playbackSpeedFunc
    },
    domProps: {
      "value": (_vm.playBackSpeed)
    },
    on: {
      "__r": function($event) {
        _vm.playBackSpeed = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice2SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voiceBadgeRural",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.fxDelayToggle = !_vm.fxDelayToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fxDelayToggle),
      expression: "fxDelayToggle"
    }],
    staticStyle: {
      "color": "white"
    }
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tDelay " + _vm._s(_vm.fxDelayAmt) + "% \n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fxDelayToggle),
      expression: "!fxDelayToggle"
    }],
    staticStyle: {
      "color": "var(--main-stopRural-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tDelay " + _vm._s(_vm.fxDelayAmt) + "% \n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.fxDelayAmt),
      expression: "fxDelayAmt",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "instrumentRangerRural",
    attrs: {
      "id": "sliders2",
      "type": "range",
      "step": "1",
      "max": "100",
      "min": "0",
      "": _vm.fxDelayMix
    },
    domProps: {
      "value": (_vm.fxDelayAmt)
    },
    on: {
      "__r": function($event) {
        _vm.fxDelayAmt = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice3SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voiceBadgeRural",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.fxChorusToggle = !_vm.fxChorusToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fxChorusToggle),
      expression: "fxChorusToggle"
    }],
    staticStyle: {
      "color": "white"
    }
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tChorus " + _vm._s(_vm.fxChorusAmt) + "% \n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fxChorusToggle),
      expression: "!fxChorusToggle"
    }],
    staticStyle: {
      "color": "var(--main-stopRural-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tChorus " + _vm._s(_vm.fxChorusAmt) + "% \n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.fxChorusAmt),
      expression: "fxChorusAmt",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "instrumentRangerRural",
    attrs: {
      "id": "sliders3",
      "type": "range",
      "step": "1",
      "max": "100",
      "min": "0",
      "": _vm.fxChorusMix
    },
    domProps: {
      "value": (_vm.fxChorusAmt)
    },
    on: {
      "__r": function($event) {
        _vm.fxChorusAmt = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice4SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voiceBadgeRural",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.fxFilterToggle = !_vm.fxFilterToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fxFilterToggle),
      expression: "fxFilterToggle"
    }],
    staticStyle: {
      "color": "white"
    }
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tFilter " + _vm._s(_vm.fxAutoFilterAmt) + "Hz\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fxFilterToggle),
      expression: "!fxFilterToggle"
    }],
    staticStyle: {
      "color": "var(--main-stopRural-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tFilter " + _vm._s(_vm.fxAutoFilterAmt) + "Hz\n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.fxAutoFilterAmt),
      expression: "fxAutoFilterAmt",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "instrumentRangerRural",
    attrs: {
      "id": "sliders4",
      "type": "range",
      "step": "1",
      "max": "10000",
      "min": "80",
      "": _vm.fxAutoFilterMix
    },
    domProps: {
      "value": (_vm.fxAutoFilterAmt)
    },
    on: {
      "__r": function($event) {
        _vm.fxAutoFilterAmt = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice5SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voiceBadgeRural",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.fxConvolverToggle = !_vm.fxConvolverToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fxConvolverToggle),
      expression: "fxConvolverToggle"
    }],
    staticStyle: {
      "color": "white"
    }
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tReverb (" + _vm._s(((_vm.fxDecay).toPrecision(2))) + "s) " + _vm._s((_vm.fxConvolverAmt * 2)) + "%\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fxConvolverToggle),
      expression: "!fxConvolverToggle"
    }],
    staticStyle: {
      "color": "var(--main-stopRural-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tReverb (" + _vm._s(((_vm.fxDecay).toPrecision(2))) + "s) " + _vm._s((_vm.fxConvolverAmt * 2)) + "%\n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.fxConvolverAmt),
      expression: "fxConvolverAmt",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "instrumentRangerRural",
    attrs: {
      "id": "sliders1",
      "type": "range",
      "step": "1",
      "max": "50",
      "min": "0",
      "": _vm.fxConvolverMix
    },
    domProps: {
      "value": (_vm.fxConvolverAmt)
    },
    on: {
      "__r": function($event) {
        _vm.fxConvolverAmt = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice6SliderDiv"
    }
  }, [_c('button', {
    class: _vm.mattChillClass,
    attrs: {
      "id": "masterControlBadgesSFX"
    },
    on: {
      "click": _vm.mattChillMethod
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.randomizeBoolean),
      expression: "!randomizeBoolean"
    }]
  }, [_c('i', {
    staticClass: "fa fa-flask"
  }), _vm._v(" Randomize "), _c('i', {
    staticClass: "fa fa-flask"
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.randomizeBoolean),
      expression: "randomizeBoolean"
    }]
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask5),
      expression: "showFlask5"
    }],
    staticClass: "fa fa-flask fa-counter-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask3),
      expression: "showFlask3"
    }],
    staticClass: "fa fa-flask fa-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask1),
      expression: "showFlask1"
    }],
    staticClass: "fa fa-flask slow-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask2),
      expression: "showFlask2"
    }],
    staticClass: "fa fa-flask slow-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask4),
      expression: "showFlask4"
    }],
    staticClass: "fa fa-flask fa-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask6),
      expression: "showFlask6"
    }],
    staticClass: "fa fa-flask fa-counter-spin"
  })])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAboutPage),
      expression: "showAboutPage"
    }],
    staticClass: "col-xs-12",
    attrs: {
      "id": "aboutPageID"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "aboutTxt"
    }
  }, [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t\tTrains and highways criss-cross almost every country. They emit their steady soundscape upon each area they inhabit. Small towns each have their own distinct soundscapes and rhythms. I have always noticed a few consistencies between most small town soundscapes though. Having grown up in one I find the sound of a lawn mower to be strangely comforting, at it is usually a mark of Spring. \n\t\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t\tThese sounds were recorded in my hometown of Onalaska, Wi. Except for the church bells, which were recorded in Salzburg, Austria.\n\t\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "disclaimerTxt"
    }
  }, [_vm._v("\n\t\t\t\t\t\tSound Design & Recordings Copyright © 2018 "), _c('a', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "href": "https://www.mattmccorkle.com",
      "target": "_blank"
    }
  }, [_vm._v("Matt McCorkle")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v(" These sounds are presented here for personal entertainment use only. ")]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t\tFor commercial sound licensing email hi@mattmccorkle.com\n\t\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    class: _vm.helpClass,
    attrs: {
      "id": "aboutBtnID2"
    },
    on: {
      "click": _vm.goToHelp
    }
  }, [_c('strong', [_c('i', {
    staticClass: "fa fa-window-close fa-3x"
  })])])])]), _vm._v(" "), (this.$store.state.allowSpeechControl) ? _c('div') : _vm._e(), _vm._v(" "), (this.$store.state.allowSpeechControl) ? _c('div', [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated pulse",
      "mode": "out-in"
    }
  }, [(_vm.showSpeechBtns) ? _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "speechContainer"
    }
  }, [_c('button', {
    class: _vm.speechShowListClass,
    attrs: {
      "id": "speechList"
    },
    on: {
      "click": _vm.voiceCommandListFunc
    }
  }, [_c('i', {
    staticClass: "fal fa-clipboard-list"
  }), _vm._v(" List of Voice Commands\n\t\t\t\t")]), _vm._v(" "), (_vm.showVoiceCommandList) ? _c('div', {
    attrs: {
      "id": "voiceCommandListID"
    }
  }, [_c('p', {
    attrs: {
      "id": "voiceControlListTitle"
    }
  }, [_c('strong', [_vm._v(" Voice Control This Immersive Experience")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "voiceControlListTxt"
    }
  }, [_c('strong', [_vm._v("Allow Google Chrome Microphone Access To Use This Feature")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "fal fa-headphones"
  }), _vm._v(" Voice Control Works "), _c('strong', [_c('u', [_vm._v("Great")])]), _vm._v(" With Headphones "), _c('i', {
    staticClass: "fal fa-headphones"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("OK! Now Use That Beautiful Voice, Say Something!\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('u', [_vm._v("Exploration:")]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\tLet's Explore!\n\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\tRandomize, Shift Soundscape,")]), _vm._v(" or "), _c('strong', [_vm._v("New Scene")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_c('u', [_vm._v("Creating A Soundscape:")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Hillside")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Highway")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Mower")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Peaceful Field")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Locomotive")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Bells")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Stop ")]), _vm._v(" or "), _c('strong', [_vm._v("Take Out ")]), _vm._v("[Sound Source Name] \n\t\t\t\t\t"), _c('br'), _c('span', {
    attrs: {
      "id": "voiceListAnchor"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Volume Up")]), _vm._v(" or "), _c('strong', [_vm._v("Louder")]), _vm._v(" [Sound Source Name]\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Volume Down")]), _vm._v(" or "), _c('strong', [_vm._v("Softer ")]), _vm._v("[Sound Source Name]\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_c('u', [_vm._v("Digital Audio Effects:")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Speed Up ")]), _vm._v("or "), _c('strong', [_vm._v("Faster")]), _vm._v(" & "), _c('strong', [_vm._v("Speed Down ")]), _vm._v("or "), _c('strong', [_vm._v("Slower")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Delay On")]), _vm._v(" or "), _c('strong', [_vm._v("Off ")]), _vm._v(" & "), _c('strong', [_vm._v("More ")]), _vm._v("or "), _c('strong', [_vm._v("Less")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Chorus On")]), _vm._v(" or "), _c('strong', [_vm._v("Off ")]), _vm._v(" & "), _c('strong', [_vm._v("More ")]), _vm._v("or "), _c('strong', [_vm._v("Less")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Filter On")]), _vm._v(" or "), _c('strong', [_vm._v("Off ")]), _vm._v(" & "), _c('strong', [_vm._v("More ")]), _vm._v("or "), _c('strong', [_vm._v("Less")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Reverb On")]), _vm._v(" or "), _c('strong', [_vm._v("Off ")]), _vm._v(" & "), _c('strong', [_vm._v("More ")]), _vm._v("or "), _c('strong', [_vm._v("Less")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('i', [_vm._v("Add the word "), _c('strong', [_vm._v("a lot")]), _vm._v(" to move in greater increments.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_c('u', [_vm._v("Housekeeping:")]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\tStop All Sounds \n\t\t\t\t\t"), _c('br'), _vm._v(" \n\t\t\t\t\tPlay All Sounds\n\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\tStop Voice Commands \n\t\t\t\t\t"), _c('br'), _vm._v(" \n\t\t\t\t\tGo Home\n\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\tShow")]), _vm._v(" or "), _c('strong', [_vm._v("Hide Soundscape Info\n\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\tShow")]), _vm._v(" or "), _c('strong', [_vm._v("Hide Voice Command List")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_c('u', [_vm._v("Additional Mentions:")])]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t1.) It might take a few tries, try saying your command quickly and in a direct manner.\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t2.) Each Sound Source can always be addressed as \"Sound Source 1-6\"\n\t\t\t\t")])]) : _vm._e()]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (!this.$store.state.allowSpeechControl) ? _c('div', [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNavBar),
      expression: "showNavBar"
    }],
    staticClass: "container-fluid"
  }, [_c('button', {
    class: _vm.exploreFuncClass,
    attrs: {
      "id": "exploreBtnId"
    },
    on: {
      "click": _vm.exploreBtnFunc
    }
  }, [_c('i', {
    class: _vm.exploreIconClass
  }), _vm._v(" " + _vm._s(_vm.exploreTxt) + "\n\t\t\t\t")])])])], 1) : _vm._e(), _vm._v(" "), _c('transition-group', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNavBar),
      expression: "showNavBar"
    }],
    key: "localStorageBtnsKey",
    staticClass: "container-fluid",
    attrs: {
      "id": "helpContainer"
    }
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    class: _vm.saveClass,
    attrs: {
      "id": "localStorageBtnID"
    },
    on: {
      "click": _vm.setLocalStorage
    }
  }, [_c('i', {
    staticClass: "fal fa-sliders-h"
  }), _vm._v(" Save\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    class: _vm.loadClass,
    attrs: {
      "id": "localStorageBtnID"
    },
    on: {
      "click": _vm.getLocalStorage
    }
  }, [_c('i', {
    staticClass: "fal fa-sliders-h"
  }), _vm._v(" Load\n\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNavBar),
      expression: "showNavBar"
    }],
    key: "helpBtnsKeys",
    staticClass: "container-fluid",
    attrs: {
      "id": "helpContainer"
    }
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    class: _vm.helpClass,
    attrs: {
      "id": "aboutBtnID"
    },
    on: {
      "click": _vm.goToHelp
    }
  }, [_c('i', {
    staticClass: "fal fa-info-circle"
  }), _vm._v(" Info\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    class: _vm.helpClass,
    attrs: {
      "id": "aboutBtnID"
    },
    on: {
      "click": _vm.goHome
    }
  }, [_c('i', {
    staticClass: "fas fa-home"
  }), _vm._v(" Home\n\t\t\t\t\t")])])])]), _vm._v(" "), (!_vm.userMobile) ? _c('div', [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNavBar),
      expression: "showNavBar"
    }],
    staticClass: "container-fluid",
    attrs: {
      "id": "visualToggleContainer"
    }
  }, [(_vm.activeSun) ? _c('span', {
    attrs: {
      "id": "visualToggle"
    },
    on: {
      "click": function($event) {
        _vm.activeSun = !_vm.activeSun
      }
    }
  }, [_vm._v(" \n\t\t\t\t\t\tReactive Background\n\t\t\t\t\t\t"), _c('i', {
    staticClass: "fal fa-toggle-on"
  })]) : (!_vm.activeSun) ? _c('span', {
    attrs: {
      "id": "visualToggle"
    },
    on: {
      "click": function($event) {
        _vm.activeSun = !_vm.activeSun
      }
    }
  }, [_vm._v(" \n\t\t\t\t\t\tReactive Background\n\t\t\t\t\t\t"), _c('i', {
    staticClass: "fal fa-toggle-off"
  })]) : _vm._e()])])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 65 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "mainDiv"
    }
  }, [_c('transition-group', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    key: "navBar",
    staticClass: "col-xs-12 text-center"
  }, [_c('button', {
    class: _vm.audioEngageClass,
    attrs: {
      "id": "mobileBtn"
    },
    on: {
      "~click": function($event) {
        return _vm.mobileEngage($event)
      }
    }
  }, [_vm._v("\t\n\t\t \t\t" + _vm._s(_vm.mobileTxt) + "\n\t\t \t\t")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMobileText),
      expression: "showMobileText"
    }],
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "welcomeMobileText"
    }
  }, [_vm._v(" \n\t\t \t\t\tAccess this app on your computer for extra effects and reactive backgrounds.\n\t\t \t\t"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('i', {
    class: _vm.bellSlash
  }), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t    \tPlease make sure your "), _c('strong', [_vm._v(" mute button is off ")]), _vm._v(" and volume is engaged.\n\t\t \t")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    class: _vm.plungeClass,
    attrs: {
      "id": "mainDiv"
    }
  }, [(this.$store.state.allowSpeechControl) ? _c('div', [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated pulse",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAllControls),
      expression: "showAllControls"
    }],
    staticClass: "container-fluid",
    attrs: {
      "id": "VUIformInputDivID"
    }
  }, [_c('div', {
    staticClass: "col-xs-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userVoiceToText),
      expression: "userVoiceToText"
    }],
    staticClass: "form-control",
    class: _vm.plungeClass,
    staticStyle: {
      "color": "white !important",
      "border-width": "0px"
    },
    attrs: {
      "type": "text",
      "id": "inlineFormInputGroupUsername2",
      "placeholder": "View & Type Voice Commands Here"
    },
    domProps: {
      "value": (_vm.userVoiceToText)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.userVoiceToTextFunc($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userVoiceToText = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  }, [(_vm.initSpeech) ? _c('span', {
    on: {
      "click": _vm.speechFunc
    }
  }, [_c('i', {
    staticClass: "fal fa-microphone-slash",
    attrs: {
      "id": "speechEngage"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.initSpeech) ? _c('span', {
    on: {
      "click": _vm.speechStartStopFunc
    }
  }, [_c('i', {
    staticClass: "fa fa-microphone-alt",
    style: ({
      'color': _vm.recognizing ? 'red' : 'black'
    }),
    attrs: {
      "id": "speechEngageActivated"
    }
  })]) : _vm._e()])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showEnterContainer),
      expression: "showEnterContainer"
    }],
    staticClass: "container-fluid",
    attrs: {
      "id": "enterContainer"
    }
  }, [_c('transition', {
    attrs: {
      "appear": "",
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated flipOutX",
      "mode": "out-in"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showEnterBtn),
      expression: "showEnterBtn"
    }],
    staticClass: "btn-info",
    staticStyle: {
      "color": "white",
      "background-color": "#284f17"
    },
    attrs: {
      "id": "enterFuncBtn"
    },
    on: {
      "~click": function($event) {
        return _vm.enterFunc($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tWOODLANDS\n\t\t\t\t\t")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLoading),
      expression: "showLoading"
    }],
    staticStyle: {
      "color": "black",
      "border-color": "transparent",
      "background": "transparent"
    },
    attrs: {
      "id": "enterFuncBtn"
    }
  }, [_vm._v(" \t\n\t\t\t\t\t\t\tLoading... \n\t\t\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.whatIsLoading) + "\n\t\t\t\t\t")])])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAllControls),
      expression: "showAllControls"
    }],
    staticClass: "container-fluid",
    attrs: {
      "id": "controlsContainer"
    }
  }, [_c('div', {
    attrs: {
      "id": "ambienceBtnLocation"
    }
  }, [(!_vm.userMobile) ? _c('p', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "id": "fxTitle"
    }
  }, [_vm._v(" \n\t\t\t\t\t\t\tAdd "), _c('i', {
    staticClass: "fal fa-check-circle"
  }), _vm._v(" or Remove "), _c('i', {
    staticClass: "fal fa-times-circle"
  }), _vm._v(" Sound Sources For Your "), _c('span', {
    attrs: {
      "id": "soundscapeTitleBreak"
    }
  }, [_vm._v("Woodland Forest Soundscape")])]) : (_vm.userMobile) ? _c('p', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "id": "fxTitle"
    }
  }, [_vm._v(" \n\t\t\t\t\t\t\tSounds of the Woodlands")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn1Div"
    }
  }, [_c('button', {
    class: _vm.ambience1Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience1Func
    },
    on: {
      "click": function($event) {
        _vm.ambience1Boolean = !_vm.ambience1Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience1Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tInsects\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience1Vol),
      expression: "ambience1Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance1RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience5Func,
      "max": "6",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience1Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience1Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn2Div"
    }
  }, [_c('button', {
    class: _vm.ambience2Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience2Func
    },
    on: {
      "click": function($event) {
        _vm.ambience2Boolean = !_vm.ambience2Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience2Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tSummer Birds\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience2Vol),
      expression: "ambience2Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance2RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience5Func,
      "max": "8",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience2Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience2Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn3Div"
    }
  }, [_c('button', {
    class: _vm.ambience3Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience3Func
    },
    on: {
      "click": function($event) {
        _vm.ambience3Boolean = !_vm.ambience3Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience3Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tWinter Birds\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience3Vol),
      expression: "ambience3Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance3RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience5Func,
      "max": "8",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience3Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience3Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn4Div"
    }
  }, [_c('button', {
    class: _vm.ambience4Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience4Func
    },
    on: {
      "click": function($event) {
        _vm.ambience4Boolean = !_vm.ambience4Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience4Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tMarshland\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience4Vol),
      expression: "ambience4Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance4RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience5Func,
      "max": "0",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience4Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience4Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn5Div"
    }
  }, [_c('button', {
    class: _vm.ambience5Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience5Func
    },
    on: {
      "click": function($event) {
        _vm.ambience5Boolean = !_vm.ambience5Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience5Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tLoons\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience5Vol),
      expression: "ambience5Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance5RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience5Func,
      "max": "0",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience5Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience5Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn6Div"
    }
  }, [_c('button', {
    class: _vm.ambience6Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience6Func
    },
    on: {
      "click": function($event) {
        _vm.ambience6Boolean = !_vm.ambience6Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience6Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tStream\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience6Vol),
      expression: "ambience6Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance6RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience6Func,
      "max": "6",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience6Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience6Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "masterControlDiv"
    }
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "id": "fxTitle2"
    }
  }, [_vm._v(" \n\t\t\tProcess Soundscape With Digital Audio Processing\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice1SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voiceBadgeForest",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.speedToggle = !_vm.speedToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.speedToggle),
      expression: "speedToggle"
    }],
    staticStyle: {
      "color": "var(--main-startForest-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tSpeed " + _vm._s(((_vm.playBackSpeed).toPrecision(3))) + "x\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.speedToggle),
      expression: "!speedToggle"
    }],
    staticStyle: {
      "color": "var(--main-stopForest-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tSpeed " + _vm._s(((_vm.playBackSpeed).toPrecision(3))) + "x\n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.playBackSpeed),
      expression: "playBackSpeed",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "instrumentRangerForest",
    attrs: {
      "id": "sliders6",
      "type": "range",
      "step": "0.01",
      "max": "2",
      "min": "0.1",
      "": _vm.playbackSpeedFunc
    },
    domProps: {
      "value": (_vm.playBackSpeed)
    },
    on: {
      "__r": function($event) {
        _vm.playBackSpeed = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice2SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voiceBadgeForest",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.fxDelayToggle = !_vm.fxDelayToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fxDelayToggle),
      expression: "fxDelayToggle"
    }],
    staticStyle: {
      "color": "var(--main-startForest-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tDelay " + _vm._s(_vm.fxDelayAmt) + "% \n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fxDelayToggle),
      expression: "!fxDelayToggle"
    }],
    staticStyle: {
      "color": "var(--main-stopForest-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tDelay " + _vm._s(_vm.fxDelayAmt) + "% \n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.fxDelayAmt),
      expression: "fxDelayAmt",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "instrumentRangerForest",
    attrs: {
      "id": "sliders2",
      "type": "range",
      "step": "1",
      "max": "100",
      "min": "0",
      "": _vm.fxDelayMix
    },
    domProps: {
      "value": (_vm.fxDelayAmt)
    },
    on: {
      "__r": function($event) {
        _vm.fxDelayAmt = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice3SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voiceBadgeForest",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.fxChorusToggle = !_vm.fxChorusToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fxChorusToggle),
      expression: "fxChorusToggle"
    }],
    staticStyle: {
      "color": "var(--main-startForest-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tChorus " + _vm._s(_vm.fxChorusAmt) + "% \n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fxChorusToggle),
      expression: "!fxChorusToggle"
    }],
    staticStyle: {
      "color": "var(--main-stopForest-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tChorus " + _vm._s(_vm.fxChorusAmt) + "% \n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.fxChorusAmt),
      expression: "fxChorusAmt",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "instrumentRangerForest",
    attrs: {
      "id": "sliders3",
      "type": "range",
      "step": "1",
      "max": "100",
      "min": "0",
      "": _vm.fxChorusMix
    },
    domProps: {
      "value": (_vm.fxChorusAmt)
    },
    on: {
      "__r": function($event) {
        _vm.fxChorusAmt = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice4SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voiceBadgeForest",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.fxFilterToggle = !_vm.fxFilterToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fxFilterToggle),
      expression: "fxFilterToggle"
    }],
    staticStyle: {
      "color": "var(--main-startForest-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tFilter " + _vm._s(_vm.fxAutoFilterAmt) + "Hz\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fxFilterToggle),
      expression: "!fxFilterToggle"
    }],
    staticStyle: {
      "color": "var(--main-stopForest-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tFilter " + _vm._s(_vm.fxAutoFilterAmt) + "Hz\n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.fxAutoFilterAmt),
      expression: "fxAutoFilterAmt",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "instrumentRangerForest",
    attrs: {
      "id": "sliders4",
      "type": "range",
      "step": "1",
      "max": "10000",
      "min": "80",
      "": _vm.fxAutoFilterMix
    },
    domProps: {
      "value": (_vm.fxAutoFilterAmt)
    },
    on: {
      "__r": function($event) {
        _vm.fxAutoFilterAmt = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice5SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voiceBadgeForest",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.fxConvolverToggle = !_vm.fxConvolverToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fxConvolverToggle),
      expression: "fxConvolverToggle"
    }],
    staticStyle: {
      "color": "var(--main-startForest-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tReverb (" + _vm._s(((_vm.fxDecay).toPrecision(2))) + "s) " + _vm._s((_vm.fxConvolverAmt * 2)) + "%\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fxConvolverToggle),
      expression: "!fxConvolverToggle"
    }],
    staticStyle: {
      "color": "var(--main-stopForest-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tReverb (" + _vm._s(((_vm.fxDecay).toPrecision(2))) + "s) " + _vm._s((_vm.fxConvolverAmt * 2)) + "%\n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.fxConvolverAmt),
      expression: "fxConvolverAmt",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "instrumentRangerForest",
    attrs: {
      "id": "sliders1",
      "type": "range",
      "step": "1",
      "max": "50",
      "min": "0",
      "": _vm.fxConvolverMix
    },
    domProps: {
      "value": (_vm.fxConvolverAmt)
    },
    on: {
      "__r": function($event) {
        _vm.fxConvolverAmt = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice6SliderDiv"
    }
  }, [_c('button', {
    class: _vm.mattChillClass,
    attrs: {
      "id": "masterControlBadgesSFX"
    },
    on: {
      "click": _vm.mattChillMethod
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.randomizeBoolean),
      expression: "!randomizeBoolean"
    }]
  }, [_c('i', {
    staticClass: "fa fa-flask"
  }), _vm._v(" Randomize "), _c('i', {
    staticClass: "fa fa-flask"
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.randomizeBoolean),
      expression: "randomizeBoolean"
    }]
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask5),
      expression: "showFlask5"
    }],
    staticClass: "fa fa-flask fa-counter-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask3),
      expression: "showFlask3"
    }],
    staticClass: "fa fa-flask fa-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask1),
      expression: "showFlask1"
    }],
    staticClass: "fa fa-flask slow-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask2),
      expression: "showFlask2"
    }],
    staticClass: "fa fa-flask slow-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask4),
      expression: "showFlask4"
    }],
    staticClass: "fa fa-flask fa-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask6),
      expression: "showFlask6"
    }],
    staticClass: "fa fa-flask fa-counter-spin"
  })])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAboutPage),
      expression: "showAboutPage"
    }],
    staticClass: "col-xs-12",
    attrs: {
      "id": "aboutPageID"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "id": "aboutTxt"
    }
  }, [_c('br'), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t\tDeciduous woodland forests are beautiful expressions of life. Covering all four seasons, these landscapes have evolved to be ready for nearly anything. The fluctuations between seasons creates a constantly altered sonic environment. The way the wind rustles a tree in summertime is so fluid and smooth. But in the frigid depths of winter, the sound of a rustling tree becomes forced and brittle.\n\t\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t\tThese recordings are from in and around Wisconsin, Minnesota, and New York State. One of my favorite recordings is the loons yodel. It was captured in the Boundary Waters region of Minnesota. The Boundary Waters area emcompasses thousands of lakes. Each of these lakes are usually home to a single loon family. The calls of a male loon are beautiful and haunting, for good reason. A male loons’ yodel is a territory marker to warn other loons about his presence. \n\t\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "id": "disclaimerTxt"
    }
  }, [_vm._v("\n\t\t\t\t\t\tSound Design & Recordings Copyright © 2018 "), _c('a', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "href": "https://www.mattmccorkle.com",
      "target": "_blank"
    }
  }, [_vm._v("Matt McCorkle")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v(" These sounds are presented here for personal entertainment use only. ")]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t\tFor commercial sound licensing email hi@mattmccorkle.com\n\t\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    class: _vm.helpClass,
    attrs: {
      "id": "aboutBtnID2"
    },
    on: {
      "click": _vm.goToHelp
    }
  }, [_c('strong', [_c('i', {
    staticClass: "fa fa-window-close fa-3x"
  })])])])]), _vm._v(" "), (this.$store.state.allowSpeechControl) ? _c('div') : _vm._e(), _vm._v(" "), (this.$store.state.allowSpeechControl) ? _c('div', [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated pulse",
      "mode": "out-in"
    }
  }, [(_vm.showSpeechBtns) ? _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "speechContainer"
    }
  }, [_c('button', {
    class: _vm.speechShowListClass,
    attrs: {
      "id": "speechList"
    },
    on: {
      "click": _vm.voiceCommandListFunc
    }
  }, [_c('i', {
    staticClass: "fal fa-clipboard-list"
  }), _vm._v(" List of Voice Commands\n\t\t\t\t")]), _vm._v(" "), (_vm.showVoiceCommandList) ? _c('div', {
    attrs: {
      "id": "voiceCommandListID"
    }
  }, [_c('p', {
    attrs: {
      "id": "voiceControlListTitle"
    }
  }, [_c('strong', [_vm._v(" Voice Control This Immersive Experience")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "voiceControlListTxt"
    }
  }, [_c('strong', [_vm._v("Allow Google Chrome Microphone Access To Use This Feature")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "fal fa-headphones"
  }), _vm._v(" Voice Control Works "), _c('strong', [_c('u', [_vm._v("Great")])]), _vm._v(" With Headphones "), _c('i', {
    staticClass: "fal fa-headphones"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("OK! Now Use That Beautiful Voice, Say Something!\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('u', [_vm._v("Exploration:")]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\tLet's Explore!\n\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\tRandomize, Shift Soundscape,")]), _vm._v(" or "), _c('strong', [_vm._v("New Scene")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_c('u', [_vm._v("Creating A Soundscape:")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Insects or Bugs")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Summer Birds")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Winter Birds")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Marshland")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Loons")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Stream or Water")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Stop ")]), _vm._v(" or "), _c('strong', [_vm._v("Take Out ")]), _vm._v("[Sound Source Name] \n\t\t\t\t\t"), _c('br'), _c('span', {
    attrs: {
      "id": "voiceListAnchor"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Volume Up")]), _vm._v(" or "), _c('strong', [_vm._v("Louder")]), _vm._v(" [Sound Source Name]\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Volume Down")]), _vm._v(" or "), _c('strong', [_vm._v("Softer ")]), _vm._v("[Sound Source Name]\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_c('u', [_vm._v("Digital Audio Effects:")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Speed Up ")]), _vm._v("or "), _c('strong', [_vm._v("Faster")]), _vm._v(" & "), _c('strong', [_vm._v("Speed Down ")]), _vm._v("or "), _c('strong', [_vm._v("Slower")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Delay On")]), _vm._v(" or "), _c('strong', [_vm._v("Off ")]), _vm._v(" & "), _c('strong', [_vm._v("More ")]), _vm._v("or "), _c('strong', [_vm._v("Less")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Chorus On")]), _vm._v(" or "), _c('strong', [_vm._v("Off ")]), _vm._v(" & "), _c('strong', [_vm._v("More ")]), _vm._v("or "), _c('strong', [_vm._v("Less")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Filter On")]), _vm._v(" or "), _c('strong', [_vm._v("Off ")]), _vm._v(" & "), _c('strong', [_vm._v("More ")]), _vm._v("or "), _c('strong', [_vm._v("Less")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Reverb On")]), _vm._v(" or "), _c('strong', [_vm._v("Off ")]), _vm._v(" & "), _c('strong', [_vm._v("More ")]), _vm._v("or "), _c('strong', [_vm._v("Less")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('i', [_vm._v("Add the word "), _c('strong', [_vm._v("a lot")]), _vm._v(" to move in greater increments.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_c('u', [_vm._v("Housekeeping:")]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\tStop All Sounds \n\t\t\t\t\t"), _c('br'), _vm._v(" \n\t\t\t\t\tPlay All Sounds\n\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\tStop Voice Commands \n\t\t\t\t\t"), _c('br'), _vm._v(" \n\t\t\t\t\tGo Home\n\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\tShow")]), _vm._v(" or "), _c('strong', [_vm._v("Hide Soundscape Info\n\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\tShow")]), _vm._v(" or "), _c('strong', [_vm._v("Hide Voice Command List")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_c('u', [_vm._v("Additional Mentions:")])]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t1.) It might take a few tries, try saying your command quickly and in a direct manner.\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t2.) Each Sound Source can always be addressed as \"Sound Source 1-6\"\n\t\t\t\t")])]) : _vm._e()]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (!this.$store.state.allowSpeechControl) ? _c('div', [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNavBar),
      expression: "showNavBar"
    }],
    staticClass: "container-fluid"
  }, [_c('button', {
    class: _vm.exploreFuncClass,
    attrs: {
      "id": "exploreBtnId"
    },
    on: {
      "click": _vm.exploreBtnFunc
    }
  }, [_c('i', {
    class: _vm.exploreIconClass
  }), _vm._v(" " + _vm._s(_vm.exploreTxt) + "\n\t\t\t\t")])])])], 1) : _vm._e(), _vm._v(" "), _c('transition-group', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNavBar),
      expression: "showNavBar"
    }],
    key: "localStorageBtnsKey",
    staticClass: "container-fluid",
    attrs: {
      "id": "helpContainer"
    }
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    class: _vm.saveClass,
    attrs: {
      "id": "localStorageBtnID"
    },
    on: {
      "click": _vm.setLocalStorage
    }
  }, [_c('i', {
    staticClass: "fal fa-sliders-h"
  }), _vm._v(" Save\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    class: _vm.loadClass,
    attrs: {
      "id": "localStorageBtnID"
    },
    on: {
      "click": _vm.getLocalStorage
    }
  }, [_c('i', {
    staticClass: "fal fa-sliders-h"
  }), _vm._v(" Load\n\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNavBar),
      expression: "showNavBar"
    }],
    key: "helpBtnsKeys",
    staticClass: "container-fluid",
    attrs: {
      "id": "helpContainer"
    }
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    class: _vm.helpClass,
    attrs: {
      "id": "aboutBtnID"
    },
    on: {
      "click": _vm.goToHelp
    }
  }, [_c('i', {
    staticClass: "fal fa-info-circle"
  }), _vm._v(" Info\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    class: _vm.helpClass,
    attrs: {
      "id": "aboutBtnID"
    },
    on: {
      "click": _vm.goHome
    }
  }, [_c('i', {
    staticClass: "fas fa-home"
  }), _vm._v(" Home\n\t\t\t\t\t")])])])]), _vm._v(" "), (!_vm.userMobile) ? _c('div', [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNavBar),
      expression: "showNavBar"
    }],
    staticClass: "container-fluid",
    attrs: {
      "id": "visualToggleContainer"
    }
  }, [(_vm.activeSun) ? _c('span', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "id": "visualToggle"
    },
    on: {
      "click": function($event) {
        _vm.activeSun = !_vm.activeSun
      }
    }
  }, [_vm._v(" \n\t\t\t\t\t\tReactive Background\n\t\t\t\t\t\t"), _c('i', {
    staticClass: "fal fa-toggle-on"
  })]) : (!_vm.activeSun) ? _c('span', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "id": "visualToggle"
    },
    on: {
      "click": function($event) {
        _vm.activeSun = !_vm.activeSun
      }
    }
  }, [_vm._v(" \n\t\t\t\t\t\tReactive Background\n\t\t\t\t\t\t"), _c('i', {
    staticClass: "fal fa-toggle-off"
  })]) : _vm._e()])])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 67 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    class: _vm.plungeClass,
    attrs: {
      "id": "mainDiv"
    }
  }, [(this.$store.state.allowSpeechControl) ? _c('div', [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated pulse",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAllControls),
      expression: "showAllControls"
    }],
    staticClass: "container-fluid",
    attrs: {
      "id": "VUIformInputDivID"
    }
  }, [_c('div', {
    staticClass: "col-xs-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userVoiceToText),
      expression: "userVoiceToText"
    }],
    staticClass: "form-control",
    class: _vm.plungeClass,
    staticStyle: {
      "color": "white !important",
      "border-width": "0px"
    },
    attrs: {
      "type": "text",
      "id": "inlineFormInputGroupUsername2",
      "placeholder": "View & Type Voice Commands Here"
    },
    domProps: {
      "value": (_vm.userVoiceToText)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.userVoiceToTextFunc($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userVoiceToText = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  }, [(_vm.initSpeech) ? _c('span', {
    on: {
      "click": _vm.speechFunc
    }
  }, [_c('i', {
    staticClass: "fal fa-microphone-slash",
    attrs: {
      "id": "speechEngage"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.initSpeech) ? _c('span', {
    on: {
      "click": _vm.speechStartStopFunc
    }
  }, [_c('i', {
    staticClass: "fa fa-microphone-alt",
    style: ({
      'color': _vm.recognizing ? 'red' : 'black'
    }),
    attrs: {
      "id": "speechEngageActivated"
    }
  })]) : _vm._e()])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showEnterContainer),
      expression: "showEnterContainer"
    }],
    staticClass: "container-fluid",
    attrs: {
      "id": "enterContainer"
    }
  }, [_c('transition', {
    attrs: {
      "appear": "",
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated hinge",
      "mode": "out-in"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showEnterBtn),
      expression: "showEnterBtn"
    }],
    staticClass: "btn-info",
    staticStyle: {
      "background-color": "#29DBE8",
      "color": "white"
    },
    attrs: {
      "id": "enterFuncBtn"
    },
    on: {
      "~click": function($event) {
        return _vm.enterFunc($event)
      }
    }
  }, [_c('strong', [_vm._v("FREEZE")])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLoading),
      expression: "showLoading"
    }],
    staticStyle: {
      "border-color": "transparent",
      "background": "transparent",
      "color": "white"
    },
    attrs: {
      "id": "enterFuncBtn"
    }
  }, [_vm._v(" \t\n\t\t\t\t\t\t\tLoading... \n\t\t\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.whatIsLoading) + "\n\t\t\t\t\t")])])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAllControls),
      expression: "showAllControls"
    }],
    staticClass: "container-fluid",
    attrs: {
      "id": "controlsContainer"
    }
  }, [_c('div', {
    attrs: {
      "id": "ambienceBtnLocation"
    }
  }, [(!_vm.userMobile) ? _c('p', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "fxTitle"
    }
  }, [_vm._v(" \n\t\t\t\t\t\t\tAdd "), _c('i', {
    staticClass: "fal fa-check-circle"
  }), _vm._v(" or Remove "), _c('i', {
    staticClass: "fal fa-times-circle"
  }), _vm._v(" Sounds From Your "), _c('span', {
    attrs: {
      "id": "soundscapeTitleBreak"
    }
  }, [_vm._v("Subzero Soundscape")])]) : (_vm.userMobile) ? _c('p', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "fxTitle"
    }
  }, [_vm._v(" \n\t\t\t\t\t\t\tSubzero Soundscape")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn1Div"
    }
  }, [_c('button', {
    class: _vm.ambience1Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience1Func
    },
    on: {
      "click": function($event) {
        _vm.ambience1Boolean = !_vm.ambience1Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience1Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tIcy Lake\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience1Vol),
      expression: "ambience1Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance1RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience1Func,
      "max": "6",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience1Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience1Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn2Div"
    }
  }, [_c('button', {
    class: _vm.ambience2Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience2Func
    },
    on: {
      "click": function($event) {
        _vm.ambience2Boolean = !_vm.ambience2Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience2Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tIce Creeks\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience2Vol),
      expression: "ambience2Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance2RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience2Func,
      "max": "6",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience2Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience2Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn3Div"
    }
  }, [_c('button', {
    class: _vm.ambience3Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience3Func
    },
    on: {
      "click": function($event) {
        _vm.ambience3Boolean = !_vm.ambience3Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience3Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tFrozen Steps\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience3Vol),
      expression: "ambience3Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance3RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience3Func,
      "max": "2",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience3Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience3Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn4Div"
    }
  }, [_c('button', {
    class: _vm.ambience4Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience4Func
    },
    on: {
      "click": function($event) {
        _vm.ambience4Boolean = !_vm.ambience4Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience4Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tIce Breaking\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience4Vol),
      expression: "ambience4Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance4RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience4Func,
      "max": "0",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience4Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience4Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn5Div"
    }
  }, [_c('button', {
    class: _vm.ambience5Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience5Func
    },
    on: {
      "click": function($event) {
        _vm.ambience5Boolean = !_vm.ambience5Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience5Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tSkis\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience5Vol),
      expression: "ambience5Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance5RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience5Func,
      "max": "0",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience5Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience5Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn6Div"
    }
  }, [_c('button', {
    class: _vm.ambience6Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience6Func
    },
    on: {
      "click": function($event) {
        _vm.ambience6Boolean = !_vm.ambience6Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience6Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tFrozen Winds\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience6Vol),
      expression: "ambience6Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance6RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience6Func,
      "max": "6",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience6Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience6Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "masterControlDiv"
    }
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "fxTitle2"
    }
  }, [_vm._v(" \n\t\t\tProcess Soundscape With Digital Audio Processing\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice1SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voiceBadgeIce",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.speedToggle = !_vm.speedToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.speedToggle),
      expression: "speedToggle"
    }],
    staticStyle: {
      "color": "white"
    }
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tSpeed " + _vm._s(((_vm.playBackSpeed).toFixed(3))) + "x\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.speedToggle),
      expression: "!speedToggle"
    }],
    staticStyle: {
      "color": "var(--main-startIce-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tSpeed " + _vm._s(((_vm.playBackSpeed).toFixed(3))) + "x\n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.playBackSpeed),
      expression: "playBackSpeed",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "instrumentRangerIce",
    attrs: {
      "id": "sliders6",
      "type": "range",
      "step": "0.01",
      "max": "2",
      "min": "0.1",
      "": _vm.playbackSpeedFunc
    },
    domProps: {
      "value": (_vm.playBackSpeed)
    },
    on: {
      "__r": function($event) {
        _vm.playBackSpeed = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice2SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voiceBadgeIce",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.fxDelayToggle = !_vm.fxDelayToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fxDelayToggle),
      expression: "fxDelayToggle"
    }],
    staticStyle: {
      "color": "white"
    }
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tDelay " + _vm._s(_vm.fxDelayAmt) + "% \n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fxDelayToggle),
      expression: "!fxDelayToggle"
    }],
    staticStyle: {
      "color": "var(--main-startIce-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tDelay " + _vm._s(_vm.fxDelayAmt) + "% \n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.fxDelayAmt),
      expression: "fxDelayAmt",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "instrumentRangerIce",
    attrs: {
      "id": "sliders2",
      "type": "range",
      "step": "1",
      "max": "100",
      "min": "0",
      "": _vm.fxDelayMix
    },
    domProps: {
      "value": (_vm.fxDelayAmt)
    },
    on: {
      "__r": function($event) {
        _vm.fxDelayAmt = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice3SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voiceBadgeIce",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.fxChorusToggle = !_vm.fxChorusToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fxChorusToggle),
      expression: "fxChorusToggle"
    }],
    staticStyle: {
      "color": "white"
    }
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tChorus " + _vm._s(_vm.fxChorusAmt) + "% \n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fxChorusToggle),
      expression: "!fxChorusToggle"
    }],
    staticStyle: {
      "color": "var(--main-startIce-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tChorus " + _vm._s(_vm.fxChorusAmt) + "% \n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.fxChorusAmt),
      expression: "fxChorusAmt",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "instrumentRangerIce",
    attrs: {
      "id": "sliders3",
      "type": "range",
      "step": "1",
      "max": "100",
      "min": "0",
      "": _vm.fxChorusMix
    },
    domProps: {
      "value": (_vm.fxChorusAmt)
    },
    on: {
      "__r": function($event) {
        _vm.fxChorusAmt = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice4SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voiceBadgeIce",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.fxFilterToggle = !_vm.fxFilterToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fxFilterToggle),
      expression: "fxFilterToggle"
    }],
    staticStyle: {
      "color": "white"
    }
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tFilter " + _vm._s(_vm.fxAutoFilterAmt) + "Hz\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fxFilterToggle),
      expression: "!fxFilterToggle"
    }],
    staticStyle: {
      "color": "var(--main-startIce-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tFilter " + _vm._s(_vm.fxAutoFilterAmt) + "Hz\n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.fxAutoFilterAmt),
      expression: "fxAutoFilterAmt",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "instrumentRangerIce",
    attrs: {
      "id": "sliders4",
      "type": "range",
      "step": "1",
      "max": "10000",
      "min": "80",
      "": _vm.fxAutoFilterMix
    },
    domProps: {
      "value": (_vm.fxAutoFilterAmt)
    },
    on: {
      "__r": function($event) {
        _vm.fxAutoFilterAmt = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice5SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voiceBadgeIce",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.fxConvolverToggle = !_vm.fxConvolverToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fxConvolverToggle),
      expression: "fxConvolverToggle"
    }],
    staticStyle: {
      "color": "white"
    }
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tReverb (" + _vm._s(((_vm.fxDecay).toPrecision(2))) + "s) " + _vm._s((_vm.fxConvolverAmt * 2)) + "%\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fxConvolverToggle),
      expression: "!fxConvolverToggle"
    }],
    staticStyle: {
      "color": "var(--main-startIce-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tReverb (" + _vm._s(((_vm.fxDecay).toPrecision(2))) + "s) " + _vm._s((_vm.fxConvolverAmt * 2)) + "%\n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.fxConvolverAmt),
      expression: "fxConvolverAmt",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "instrumentRangerIce",
    attrs: {
      "id": "sliders1",
      "type": "range",
      "step": "1",
      "max": "50",
      "min": "0",
      "": _vm.fxConvolverMix
    },
    domProps: {
      "value": (_vm.fxConvolverAmt)
    },
    on: {
      "__r": function($event) {
        _vm.fxConvolverAmt = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice6SliderDiv"
    }
  }, [_c('button', {
    class: _vm.mattChillClass,
    attrs: {
      "id": "masterControlBadgesSFX"
    },
    on: {
      "click": _vm.mattChillMethod
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.randomizeBoolean),
      expression: "!randomizeBoolean"
    }]
  }, [_c('i', {
    staticClass: "fa fa-flask"
  }), _vm._v(" Randomize "), _c('i', {
    staticClass: "fa fa-flask"
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.randomizeBoolean),
      expression: "randomizeBoolean"
    }]
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask5),
      expression: "showFlask5"
    }],
    staticClass: "fa fa-flask fa-counter-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask3),
      expression: "showFlask3"
    }],
    staticClass: "fa fa-flask fa-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask1),
      expression: "showFlask1"
    }],
    staticClass: "fa fa-flask slow-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask2),
      expression: "showFlask2"
    }],
    staticClass: "fa fa-flask slow-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask4),
      expression: "showFlask4"
    }],
    staticClass: "fa fa-flask fa-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask6),
      expression: "showFlask6"
    }],
    staticClass: "fa fa-flask fa-counter-spin"
  })])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAboutPage),
      expression: "showAboutPage"
    }],
    staticClass: "col-xs-12",
    attrs: {
      "id": "aboutPageID"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "aboutTxt"
    }
  }, [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t\tOnce the temperature drops, your surroundings start to sound almost like a still life photograph. I’ve always been fascinated by the sounds of winter. The sound of a rushing river under a few feet of ice creates a remarkably unique soundscape. The sound of crunching snow underneath your feet can invoke an array of feelings. Frozen winter winds, even when played back in the comfort of your home can still bring chills.\n\t\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t\tThe sound of winter’s silence is something that I find very fascinating. The sound of winter’s silence is also something incredibly difficult to reproduce. As the snow covers the land and silence takes over, it's something you must be apart of to fully experience.\n\t\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "disclaimerTxt"
    }
  }, [_vm._v("\n\t\t\t\t\t\tSound Design & Recordings Copyright © 2018 "), _c('a', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "href": "https://www.mattmccorkle.com",
      "target": "_blank"
    }
  }, [_vm._v("Matt McCorkle")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v(" These sounds are presented here for personal entertainment use only. ")]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t\tFor commercial sound licensing email hi@mattmccorkle.com\n\t\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    class: _vm.helpClass,
    attrs: {
      "id": "aboutBtnID2"
    },
    on: {
      "click": _vm.goToHelp
    }
  }, [_c('strong', [_c('i', {
    staticClass: "fa fa-window-close fa-3x"
  })])])])]), _vm._v(" "), (this.$store.state.allowSpeechControl) ? _c('div') : _vm._e(), _vm._v(" "), (this.$store.state.allowSpeechControl) ? _c('div', [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated pulse",
      "mode": "out-in"
    }
  }, [(_vm.showSpeechBtns) ? _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "speechContainer"
    }
  }, [_c('button', {
    class: _vm.speechShowListClass,
    attrs: {
      "id": "speechList"
    },
    on: {
      "click": _vm.voiceCommandListFunc
    }
  }, [_c('i', {
    staticClass: "fal fa-clipboard-list"
  }), _vm._v(" List of Voice Commands\n\t\t\t\t")]), _vm._v(" "), (_vm.showVoiceCommandList) ? _c('div', {
    attrs: {
      "id": "voiceCommandListID"
    }
  }, [_c('p', {
    attrs: {
      "id": "voiceControlListTitle"
    }
  }, [_c('strong', [_vm._v(" Voice Control This Immersive Experience")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "voiceControlListTxt"
    }
  }, [_c('strong', [_vm._v("Allow Google Chrome Microphone Access To Use This Feature")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "fal fa-headphones"
  }), _vm._v(" Voice Control Works "), _c('strong', [_c('u', [_vm._v("Great")])]), _vm._v(" With Headphones "), _c('i', {
    staticClass: "fal fa-headphones"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("OK! Now Use That Beautiful Voice, Say Something!\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('u', [_vm._v("Exploration:")]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\tLet's Explore!\n\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\tRandomize, Shift Soundscape,")]), _vm._v(" or "), _c('strong', [_vm._v("New Scene")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_c('u', [_vm._v("Creating A Soundscape:")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Icy Lake")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Ice Creeks")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Frozen Steps")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Ice Breaking")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Skis")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Frozen Winds")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Stop ")]), _vm._v(" or "), _c('strong', [_vm._v("Take Out ")]), _vm._v("[Sound Source Name] \n\t\t\t\t\t"), _c('br'), _c('span', {
    attrs: {
      "id": "voiceListAnchor"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Volume Up")]), _vm._v(" or "), _c('strong', [_vm._v("Louder")]), _vm._v(" [Sound Source Name]\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Volume Down")]), _vm._v(" or "), _c('strong', [_vm._v("Softer ")]), _vm._v("[Sound Source Name]\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_c('u', [_vm._v("Digital Audio Effects:")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Speed Up ")]), _vm._v("or "), _c('strong', [_vm._v("Faster")]), _vm._v(" & "), _c('strong', [_vm._v("Speed Down ")]), _vm._v("or "), _c('strong', [_vm._v("Slower")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Delay On")]), _vm._v(" or "), _c('strong', [_vm._v("Off ")]), _vm._v(" & "), _c('strong', [_vm._v("More ")]), _vm._v("or "), _c('strong', [_vm._v("Less")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Chorus On")]), _vm._v(" or "), _c('strong', [_vm._v("Off ")]), _vm._v(" & "), _c('strong', [_vm._v("More ")]), _vm._v("or "), _c('strong', [_vm._v("Less")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Filter On")]), _vm._v(" or "), _c('strong', [_vm._v("Off ")]), _vm._v(" & "), _c('strong', [_vm._v("More ")]), _vm._v("or "), _c('strong', [_vm._v("Less")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Reverb On")]), _vm._v(" or "), _c('strong', [_vm._v("Off ")]), _vm._v(" & "), _c('strong', [_vm._v("More ")]), _vm._v("or "), _c('strong', [_vm._v("Less")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('i', [_vm._v("Add the word "), _c('strong', [_vm._v("a lot")]), _vm._v(" to move in greater increments.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_c('u', [_vm._v("Housekeeping:")]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\tStop All Sounds \n\t\t\t\t\t"), _c('br'), _vm._v(" \n\t\t\t\t\tPlay All Sounds\n\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\tStop Voice Commands \n\t\t\t\t\t"), _c('br'), _vm._v(" \n\t\t\t\t\tGo Home\n\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\tShow")]), _vm._v(" or "), _c('strong', [_vm._v("Hide Soundscape Info\n\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\tShow")]), _vm._v(" or "), _c('strong', [_vm._v("Hide Voice Command List")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_c('u', [_vm._v("Additional Mentions:")])]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t1.) It might take a few tries, try saying your command quickly and in a direct manner.\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t2.) Each Sound Source can always be addressed as \"Sound Source 1-6\"\n\t\t\t\t")])]) : _vm._e()]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (!this.$store.state.allowSpeechControl) ? _c('div', [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNavBar),
      expression: "showNavBar"
    }],
    staticClass: "container-fluid"
  }, [_c('button', {
    class: _vm.exploreFuncClass,
    attrs: {
      "id": "exploreBtnId"
    },
    on: {
      "click": _vm.exploreBtnFunc
    }
  }, [_c('i', {
    class: _vm.exploreIconClass
  }), _vm._v(" " + _vm._s(_vm.exploreTxt) + "\n\t\t\t\t")])])])], 1) : _vm._e(), _vm._v(" "), _c('transition-group', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNavBar),
      expression: "showNavBar"
    }],
    key: "localStorageBtnsKey",
    staticClass: "container-fluid",
    attrs: {
      "id": "helpContainer"
    }
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    class: _vm.saveClass,
    attrs: {
      "id": "localStorageBtnID"
    },
    on: {
      "click": _vm.setLocalStorage
    }
  }, [_c('i', {
    staticClass: "fal fa-sliders-h"
  }), _vm._v(" Save\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    class: _vm.loadClass,
    attrs: {
      "id": "localStorageBtnID"
    },
    on: {
      "click": _vm.getLocalStorage
    }
  }, [_c('i', {
    staticClass: "fal fa-sliders-h"
  }), _vm._v(" Load\n\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNavBar),
      expression: "showNavBar"
    }],
    key: "helpBtnsKeys",
    staticClass: "container-fluid",
    attrs: {
      "id": "helpContainer"
    }
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    class: _vm.helpClass,
    attrs: {
      "id": "aboutBtnID"
    },
    on: {
      "click": _vm.goToHelp
    }
  }, [_c('i', {
    staticClass: "fal fa-info-circle"
  }), _vm._v(" Info\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    class: _vm.helpClass,
    attrs: {
      "id": "aboutBtnID"
    },
    on: {
      "click": _vm.goHome
    }
  }, [_c('i', {
    staticClass: "fas fa-home"
  }), _vm._v(" Home\n\t\t\t\t\t")])])])]), _vm._v(" "), (!_vm.userMobile) ? _c('div', [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNavBar),
      expression: "showNavBar"
    }],
    staticClass: "container-fluid",
    attrs: {
      "id": "visualToggleContainer"
    }
  }, [(_vm.activeSun) ? _c('span', {
    attrs: {
      "id": "visualToggle"
    },
    on: {
      "click": function($event) {
        _vm.activeSun = !_vm.activeSun
      }
    }
  }, [_vm._v(" \n\t\t\t\t\t\tReactive Background\n\t\t\t\t\t\t"), _c('i', {
    staticClass: "fal fa-toggle-on"
  })]) : (!_vm.activeSun) ? _c('span', {
    attrs: {
      "id": "visualToggle"
    },
    on: {
      "click": function($event) {
        _vm.activeSun = !_vm.activeSun
      }
    }
  }, [_vm._v(" \n\t\t\t\t\t\tReactive Background\n\t\t\t\t\t\t"), _c('i', {
    staticClass: "fal fa-toggle-off"
  })]) : _vm._e()])])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 68 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    class: _vm.plungeClass,
    attrs: {
      "id": "mainDiv"
    }
  }, [(this.$store.state.allowSpeechControl) ? _c('div', [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated pulse",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAllControls),
      expression: "showAllControls"
    }],
    staticClass: "container-fluid",
    attrs: {
      "id": "VUIformInputDivID"
    }
  }, [_c('div', {
    staticClass: "col-xs-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userVoiceToText),
      expression: "userVoiceToText"
    }],
    staticClass: "form-control",
    class: _vm.plungeClass,
    staticStyle: {
      "color": "white !important",
      "border-width": "0px"
    },
    attrs: {
      "type": "text",
      "id": "inlineFormInputGroupUsername2",
      "placeholder": "View & Type Voice Commands Here"
    },
    domProps: {
      "value": (_vm.userVoiceToText)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.userVoiceToTextFunc($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userVoiceToText = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  }, [(_vm.initSpeech) ? _c('span', {
    on: {
      "click": _vm.speechFunc
    }
  }, [_c('i', {
    staticClass: "fal fa-microphone-slash",
    attrs: {
      "id": "speechEngage"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.initSpeech) ? _c('span', {
    on: {
      "click": _vm.speechStartStopFunc
    }
  }, [_c('i', {
    staticClass: "fa fa-microphone-alt",
    style: ({
      'color': _vm.recognizing ? 'red' : 'black'
    }),
    attrs: {
      "id": "speechEngageActivated"
    }
  })]) : _vm._e()])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showEnterContainer),
      expression: "showEnterContainer"
    }],
    staticClass: "container-fluid",
    attrs: {
      "id": "enterContainer"
    }
  }, [_c('transition', {
    attrs: {
      "appear": "",
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOutDown",
      "mode": "out-in"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showEnterBtn),
      expression: "showEnterBtn"
    }],
    staticClass: "btn-info",
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "id": "enterFuncBtn"
    },
    on: {
      "~click": function($event) {
        return _vm.enterFunc($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tPLUNGE\n\t\t\t\t\t")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLoading),
      expression: "showLoading"
    }],
    staticStyle: {
      "border-color": "transparent",
      "background": "transparent"
    },
    attrs: {
      "id": "enterFuncBtn"
    }
  }, [_vm._v(" \t\n\t\t\t\t\t\t\tLoading... "), _c('br'), _vm._v(" " + _vm._s(_vm.whatIsLoading) + "\n\t\t\t\t\t")])])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAllControls),
      expression: "showAllControls"
    }],
    staticClass: "container-fluid",
    attrs: {
      "id": "controlsContainer"
    }
  }, [_c('div', {
    attrs: {
      "id": "ambienceBtnLocation"
    }
  }, [(!_vm.userMobile) ? _c('p', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "fxTitle"
    }
  }, [_vm._v(" \n\t\t\t\t\t\t\tAdd "), _c('i', {
    staticClass: "fal fa-check-circle"
  }), _vm._v(" or Remove "), _c('i', {
    staticClass: "fal fa-times-circle"
  }), _vm._v(" Sounds From Your "), _c('span', {
    attrs: {
      "id": "soundscapeTitleBreak"
    }
  }, [_vm._v("Pacific Ocean Soundscape")])]) : (_vm.userMobile) ? _c('p', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "fxTitle"
    }
  }, [_vm._v(" \n\t\t\t\t\t\t\tSounds of the Pacific Ocean")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn1Div"
    }
  }, [_c('button', {
    class: _vm.ambience1Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience1Func
    },
    on: {
      "click": function($event) {
        _vm.ambience1Boolean = !_vm.ambience1Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience1Icon
  }), _vm._v(" "), _c('span', {
    attrs: {
      "id": "ambienceTxtID"
    }
  }, [_vm._v("Coral Reef")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience1Vol),
      expression: "ambience1Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance1RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience1Func,
      "max": "0",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience1Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience1Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn2Div"
    }
  }, [_c('button', {
    class: _vm.ambience2Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience2Func
    },
    on: {
      "click": function($event) {
        _vm.ambience2Boolean = !_vm.ambience2Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience2Icon
  }), _vm._v(" "), _c('span', {
    attrs: {
      "id": "ambienceTxtID"
    }
  }, [_vm._v("Current")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience2Vol),
      expression: "ambience2Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance2RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience2Func,
      "max": "0",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience2Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience2Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn3Div"
    }
  }, [_c('button', {
    class: _vm.ambience3Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience3Func
    },
    on: {
      "click": function($event) {
        _vm.ambience3Boolean = !_vm.ambience3Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience3Icon
  }), _vm._v(" "), _c('span', {
    attrs: {
      "id": "ambienceTxtID"
    }
  }, [_vm._v("Pressure")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience3Vol),
      expression: "ambience3Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance3RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience3Func,
      "max": "10",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience3Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience3Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn4Div"
    }
  }, [_c('button', {
    class: _vm.ambience4Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience4Func
    },
    on: {
      "click": function($event) {
        _vm.ambience4Boolean = !_vm.ambience4Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience4Icon
  }), _vm._v(" "), _c('span', {
    attrs: {
      "id": "ambienceTxtID"
    }
  }, [_vm._v("Plunge")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience4Vol),
      expression: "ambience4Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance4RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience4Func,
      "max": "0",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience4Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience4Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn5Div"
    }
  }, [_c('button', {
    class: _vm.ambience5Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience5Func
    },
    on: {
      "click": function($event) {
        _vm.ambience5Boolean = !_vm.ambience5Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience5Icon
  }), _vm._v(" "), _c('span', {
    attrs: {
      "id": "ambienceTxtID"
    }
  }, [_vm._v("Humpbacks")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience5Vol),
      expression: "ambience5Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance5RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience5Func,
      "max": "6",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience5Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience5Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn6Div"
    }
  }, [_c('button', {
    class: _vm.ambience6Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience6Func
    },
    on: {
      "click": function($event) {
        _vm.ambience6Boolean = !_vm.ambience6Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience6Icon
  }), _vm._v(" "), _c('span', {
    attrs: {
      "id": "ambienceTxtID"
    }
  }, [_vm._v("Whale Family")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience6Vol),
      expression: "ambience6Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance6RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience6Func,
      "max": "6",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience6Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience6Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "masterControlDiv"
    }
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "fxTitle2"
    }
  }, [_vm._v(" \n\t\t\tProcess Soundscape With Digital Audio Processing\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice1SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voiceBadgeOcean",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.speedToggle = !_vm.speedToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.speedToggle),
      expression: "speedToggle"
    }],
    staticStyle: {
      "color": "var(--main-startOcean-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tSpeed " + _vm._s(((_vm.playBackSpeed).toFixed(3))) + "x \n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.speedToggle),
      expression: "!speedToggle"
    }],
    staticStyle: {
      "color": "var(--main-stopOcean-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tSpeed " + _vm._s(((_vm.playBackSpeed).toFixed(3))) + "x\n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.playBackSpeed),
      expression: "playBackSpeed",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "instrumentRangerOcean",
    attrs: {
      "id": "sliders6",
      "type": "range",
      "step": "0.01",
      "max": "2",
      "min": "0.1",
      "": _vm.playbackSpeedFunc
    },
    domProps: {
      "value": (_vm.playBackSpeed)
    },
    on: {
      "__r": function($event) {
        _vm.playBackSpeed = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice2SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voiceBadgeOcean",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.fxDelayToggle = !_vm.fxDelayToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fxDelayToggle),
      expression: "fxDelayToggle"
    }],
    staticStyle: {
      "color": "var(--main-startOcean-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tDelay " + _vm._s(_vm.fxDelayAmt) + "% \n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fxDelayToggle),
      expression: "!fxDelayToggle"
    }],
    staticStyle: {
      "color": "var(--main-stopOcean-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tDelay " + _vm._s(_vm.fxDelayAmt) + "% \n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.fxDelayAmt),
      expression: "fxDelayAmt",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "instrumentRangerOcean",
    attrs: {
      "id": "sliders2",
      "type": "range",
      "step": "1",
      "max": "100",
      "min": "0",
      "": _vm.fxDelayMix
    },
    domProps: {
      "value": (_vm.fxDelayAmt)
    },
    on: {
      "__r": function($event) {
        _vm.fxDelayAmt = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice3SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voiceBadgeOcean",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.fxChorusToggle = !_vm.fxChorusToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fxChorusToggle),
      expression: "fxChorusToggle"
    }],
    staticStyle: {
      "color": "var(--main-startOcean-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tChorus " + _vm._s(_vm.fxChorusAmt) + "% \n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fxChorusToggle),
      expression: "!fxChorusToggle"
    }],
    staticStyle: {
      "color": "var(--main-stopOcean-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tChorus " + _vm._s(_vm.fxChorusAmt) + "% \n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.fxChorusAmt),
      expression: "fxChorusAmt",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "instrumentRangerOcean",
    attrs: {
      "id": "sliders3",
      "type": "range",
      "step": "1",
      "max": "100",
      "min": "0",
      "": _vm.fxChorusMix
    },
    domProps: {
      "value": (_vm.fxChorusAmt)
    },
    on: {
      "__r": function($event) {
        _vm.fxChorusAmt = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice4SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voiceBadgeOcean",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.fxFilterToggle = !_vm.fxFilterToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fxFilterToggle),
      expression: "fxFilterToggle"
    }],
    staticStyle: {
      "color": "var(--main-startOcean-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tFilter " + _vm._s(_vm.fxAutoFilterAmt) + "Hz\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fxFilterToggle),
      expression: "!fxFilterToggle"
    }],
    staticStyle: {
      "color": "var(--main-stopOcean-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tFilter " + _vm._s(_vm.fxAutoFilterAmt) + "Hz\n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.fxAutoFilterAmt),
      expression: "fxAutoFilterAmt",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "instrumentRangerOcean",
    attrs: {
      "id": "sliders4",
      "type": "range",
      "step": "1",
      "max": "3500",
      "min": "80",
      "": _vm.fxAutoFilterMix
    },
    domProps: {
      "value": (_vm.fxAutoFilterAmt)
    },
    on: {
      "__r": function($event) {
        _vm.fxAutoFilterAmt = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice5SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voiceBadgeOcean",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.fxConvolverToggle = !_vm.fxConvolverToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fxConvolverToggle),
      expression: "fxConvolverToggle"
    }],
    staticStyle: {
      "color": "var(--main-startOcean-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tReverb (" + _vm._s(((_vm.fxDecay).toPrecision(2))) + "s) " + _vm._s((_vm.fxConvolverAmt * 2)) + "%\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fxConvolverToggle),
      expression: "!fxConvolverToggle"
    }],
    staticStyle: {
      "color": "var(--main-stopOcean-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tReverb (" + _vm._s(((_vm.fxDecay).toPrecision(2))) + "s) " + _vm._s((_vm.fxConvolverAmt * 2)) + "%\n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.fxConvolverAmt),
      expression: "fxConvolverAmt",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "instrumentRangerOcean",
    attrs: {
      "id": "sliders1",
      "type": "range",
      "step": "1",
      "max": "50",
      "min": "0",
      "": _vm.fxConvolverMix
    },
    domProps: {
      "value": (_vm.fxConvolverAmt)
    },
    on: {
      "__r": function($event) {
        _vm.fxConvolverAmt = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice6SliderDiv"
    }
  }, [_c('button', {
    class: _vm.mattChillClass,
    attrs: {
      "id": "masterControlBadgesSFX"
    },
    on: {
      "click": _vm.mattChillMethod
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.randomizeBoolean),
      expression: "!randomizeBoolean"
    }]
  }, [_c('i', {
    staticClass: "fa fa-flask"
  }), _vm._v(" Randomize "), _c('i', {
    staticClass: "fa fa-flask"
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.randomizeBoolean),
      expression: "randomizeBoolean"
    }]
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask5),
      expression: "showFlask5"
    }],
    staticClass: "fa fa-flask fa-counter-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask3),
      expression: "showFlask3"
    }],
    staticClass: "fa fa-flask fa-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask1),
      expression: "showFlask1"
    }],
    staticClass: "fa fa-flask slow-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask2),
      expression: "showFlask2"
    }],
    staticClass: "fa fa-flask slow-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask4),
      expression: "showFlask4"
    }],
    staticClass: "fa fa-flask fa-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask6),
      expression: "showFlask6"
    }],
    staticClass: "fa fa-flask fa-counter-spin"
  })])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAboutPage),
      expression: "showAboutPage"
    }],
    staticClass: "col-xs-12",
    attrs: {
      "id": "aboutPageID"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "id": "aboutTxt"
    }
  }, [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t\tOur oceans have such amazingly complex soundscapes. One part of the Pacific Ocean has a winter population that happens to create a very chatty soundscape. The Hawaiian Islands are the peaks of a giant undersea mountain range. The Humpback Whale National Marine Sanctuary off the coast of Maui is a relatively shallow body of water within this undersea mountain range. It is protected from the open ocean. This protection makes the perfect breeding ground for humpback whale families. \n\t\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t\tDuring an early winter morning, as the clouds cleared from a Kona storm the night prior, I paddled a sea kayak into the open ocean sanctuary. Repelling a hydrophone thirty feet into the water immediately plunged me into a breathtaking soundscape.\n\t\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "id": "disclaimerTxt"
    }
  }, [_vm._v("\n\t\t\t\t\t\tSound Design & Recordings Copyright © 2018 "), _c('a', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "href": "https://www.mattmccorkle.com",
      "target": "_blank"
    }
  }, [_vm._v("Matt McCorkle")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v(" These sounds are presented here for personal entertainment use only. ")]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t\tFor commercial sound licensing email hi@mattmccorkle.com\n\t\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    class: _vm.helpClass,
    attrs: {
      "id": "aboutBtnID2"
    },
    on: {
      "click": _vm.goToHelp
    }
  }, [_c('strong', [_c('i', {
    staticClass: "fa fa-window-close fa-3x"
  })])])])]), _vm._v(" "), (this.$store.state.allowSpeechControl) ? _c('div') : _vm._e(), _vm._v(" "), (this.$store.state.allowSpeechControl) ? _c('div', [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated pulse",
      "mode": "out-in"
    }
  }, [(_vm.showSpeechBtns) ? _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "speechContainer"
    }
  }, [_c('button', {
    class: _vm.speechShowListClass,
    attrs: {
      "id": "speechList"
    },
    on: {
      "click": _vm.voiceCommandListFunc
    }
  }, [_c('i', {
    staticClass: "fal fa-clipboard-list"
  }), _vm._v(" List of Voice Commands\n\t\t\t\t")]), _vm._v(" "), (_vm.showVoiceCommandList) ? _c('div', {
    attrs: {
      "id": "voiceCommandListID"
    }
  }, [_c('p', {
    attrs: {
      "id": "voiceControlListTitle"
    }
  }, [_c('strong', [_vm._v(" Voice Control This Immersive Experience")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "voiceControlListTxt"
    }
  }, [_c('strong', [_vm._v("Allow Google Chrome Microphone Access To Use This Feature")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "fal fa-headphones"
  }), _vm._v(" Voice Control Works "), _c('strong', [_c('u', [_vm._v("Great")])]), _vm._v(" With Headphones "), _c('i', {
    staticClass: "fal fa-headphones"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("OK! Now Use That Beautiful Voice, Say Something!\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('u', [_vm._v("Exploration:")]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\tLet's Explore!\n\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\tRandomize, Shift Soundscape,")]), _vm._v(" or "), _c('strong', [_vm._v("New Scene")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_c('u', [_vm._v("Creating A Soundscape:")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Coral Reef")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Current")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Pressure")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Plunge")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Humpbacks")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Whale Family")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Stop ")]), _vm._v(" or "), _c('strong', [_vm._v("Take Out ")]), _vm._v("[Sound Source Name] \n\t\t\t\t\t"), _c('br'), _c('span', {
    attrs: {
      "id": "voiceListAnchor"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Volume Up")]), _vm._v(" or "), _c('strong', [_vm._v("Louder")]), _vm._v(" [Sound Source Name]\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Volume Down")]), _vm._v(" or "), _c('strong', [_vm._v("Softer ")]), _vm._v("[Sound Source Name]\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_c('u', [_vm._v("Digital Audio Effects:")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Speed Up ")]), _vm._v("or "), _c('strong', [_vm._v("Faster")]), _vm._v(" & "), _c('strong', [_vm._v("Speed Down ")]), _vm._v("or "), _c('strong', [_vm._v("Slower")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Delay On")]), _vm._v(" or "), _c('strong', [_vm._v("Off ")]), _vm._v(" & "), _c('strong', [_vm._v("More ")]), _vm._v("or "), _c('strong', [_vm._v("Less")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Chorus On")]), _vm._v(" or "), _c('strong', [_vm._v("Off ")]), _vm._v(" & "), _c('strong', [_vm._v("More ")]), _vm._v("or "), _c('strong', [_vm._v("Less")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Filter On")]), _vm._v(" or "), _c('strong', [_vm._v("Off ")]), _vm._v(" & "), _c('strong', [_vm._v("More ")]), _vm._v("or "), _c('strong', [_vm._v("Less")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Reverb On")]), _vm._v(" or "), _c('strong', [_vm._v("Off ")]), _vm._v(" & "), _c('strong', [_vm._v("More ")]), _vm._v("or "), _c('strong', [_vm._v("Less")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('i', [_vm._v("Add the word "), _c('strong', [_vm._v("a lot")]), _vm._v(" to move in greater increments.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_c('u', [_vm._v("Housekeeping:")]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\tStop All Sounds \n\t\t\t\t\t"), _c('br'), _vm._v(" \n\t\t\t\t\tPlay All Sounds\n\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\tStop Voice Commands \n\t\t\t\t\t"), _c('br'), _vm._v(" \n\t\t\t\t\tGo Home\n\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\tShow")]), _vm._v(" or "), _c('strong', [_vm._v("Hide Soundscape Info\n\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\tShow")]), _vm._v(" or "), _c('strong', [_vm._v("Hide Voice Command List")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_c('u', [_vm._v("Additional Mentions:")])]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t1.) It might take a few tries, try saying your command quickly and in a direct manner.\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t2.) Each Sound Source can always be addressed as \"Sound Source 1-6\"\n\t\t\t\t")])]) : _vm._e()]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (!this.$store.state.allowSpeechControl) ? _c('div', [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNavBar),
      expression: "showNavBar"
    }],
    staticClass: "container-fluid"
  }, [_c('button', {
    class: _vm.exploreFuncClass,
    attrs: {
      "id": "exploreBtnId"
    },
    on: {
      "click": _vm.exploreBtnFunc
    }
  }, [_c('i', {
    class: _vm.exploreIconClass
  }), _vm._v(" " + _vm._s(_vm.exploreTxt) + "\n\t\t\t\t")])])])], 1) : _vm._e(), _vm._v(" "), _c('transition-group', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNavBar),
      expression: "showNavBar"
    }],
    key: "localStorageBtnsKey",
    staticClass: "container-fluid",
    attrs: {
      "id": "helpContainer"
    }
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    class: _vm.saveClass,
    attrs: {
      "id": "localStorageBtnID"
    },
    on: {
      "click": _vm.setLocalStorage
    }
  }, [_c('i', {
    staticClass: "fal fa-sliders-h"
  }), _vm._v(" Save\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    class: _vm.loadClass,
    attrs: {
      "id": "localStorageBtnID"
    },
    on: {
      "click": _vm.getLocalStorage
    }
  }, [_c('i', {
    staticClass: "fal fa-sliders-h"
  }), _vm._v(" Load\n\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNavBar),
      expression: "showNavBar"
    }],
    key: "helpBtnsKeys",
    staticClass: "container-fluid",
    attrs: {
      "id": "helpContainer"
    }
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    class: _vm.helpClass,
    attrs: {
      "id": "aboutBtnID"
    },
    on: {
      "click": _vm.goToHelp
    }
  }, [_c('i', {
    staticClass: "fal fa-info-circle"
  }), _vm._v(" Info\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    class: _vm.helpClass,
    attrs: {
      "id": "aboutBtnID"
    },
    on: {
      "click": _vm.goHome
    }
  }, [_c('i', {
    staticClass: "fas fa-home"
  }), _vm._v(" Home\n\t\t\t\t\t")])])])]), _vm._v(" "), (!_vm.userMobile) ? _c('div', [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNavBar),
      expression: "showNavBar"
    }],
    staticClass: "container-fluid",
    attrs: {
      "id": "visualToggleContainer"
    }
  }, [(_vm.activeSun) ? _c('span', {
    attrs: {
      "id": "visualToggle"
    },
    on: {
      "click": function($event) {
        _vm.activeSun = !_vm.activeSun
      }
    }
  }, [_vm._v(" \n\t\t\t\t\t\tReactive Background\n\t\t\t\t\t\t"), _c('i', {
    staticClass: "fal fa-toggle-on"
  })]) : (!_vm.activeSun) ? _c('span', {
    attrs: {
      "id": "visualToggle"
    },
    on: {
      "click": function($event) {
        _vm.activeSun = !_vm.activeSun
      }
    }
  }, [_vm._v(" \n\t\t\t\t\t\tReactive Background\n\t\t\t\t\t\t"), _c('i', {
    staticClass: "fal fa-toggle-off"
  })]) : _vm._e()])])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    class: _vm.plungeClass,
    attrs: {
      "id": "mainDiv"
    }
  }, [(this.$store.state.allowSpeechControl) ? _c('div', [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated pulse",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAllControls),
      expression: "showAllControls"
    }],
    staticClass: "container-fluid",
    attrs: {
      "id": "VUIformInputDivID"
    }
  }, [_c('div', {
    staticClass: "col-xs-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userVoiceToText),
      expression: "userVoiceToText"
    }],
    staticClass: "form-control",
    class: _vm.plungeClass,
    staticStyle: {
      "color": "white !important",
      "border-width": "0px"
    },
    attrs: {
      "type": "text",
      "id": "inlineFormInputGroupUsername2",
      "placeholder": "View & Type Voice Commands Here"
    },
    domProps: {
      "value": (_vm.userVoiceToText)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.userVoiceToTextFunc($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userVoiceToText = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  }, [(_vm.initSpeech) ? _c('span', {
    on: {
      "click": _vm.speechFunc
    }
  }, [_c('i', {
    staticClass: "fal fa-microphone-slash",
    attrs: {
      "id": "speechEngage"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.initSpeech) ? _c('span', {
    on: {
      "click": _vm.speechStartStopFunc
    }
  }, [_c('i', {
    staticClass: "fa fa-microphone-alt",
    style: ({
      'color': _vm.recognizing ? 'red' : 'black'
    }),
    attrs: {
      "id": "speechEngageActivated"
    }
  })]) : _vm._e()])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showEnterContainer),
      expression: "showEnterContainer"
    }],
    staticClass: "container-fluid",
    attrs: {
      "id": "enterContainer"
    }
  }, [_c('transition', {
    attrs: {
      "appear": "",
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated swing",
      "mode": "out-in"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showEnterBtn),
      expression: "showEnterBtn"
    }],
    staticClass: "btn-info",
    staticStyle: {
      "color": "black",
      "background-color": "#b2ce68"
    },
    attrs: {
      "id": "enterFuncBtn"
    },
    on: {
      "~click": function($event) {
        return _vm.enterFunc($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tAMAZONIA\n\t\t\t\t\t")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLoading),
      expression: "showLoading"
    }],
    staticStyle: {
      "color": "white",
      "border-color": "transparent",
      "background": "transparent"
    },
    attrs: {
      "id": "enterFuncBtn"
    }
  }, [_vm._v(" \t\n\t\t\t\t\t\t\tLoading... \n\t\t\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.whatIsLoading) + "\n\t\t\t\t\t")])])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAllControls),
      expression: "showAllControls"
    }],
    staticClass: "container-fluid",
    attrs: {
      "id": "controlsContainer"
    }
  }, [_c('div', {
    attrs: {
      "id": "ambienceBtnLocation"
    }
  }, [(!_vm.userMobile) ? _c('p', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "fxTitle"
    }
  }, [_vm._v(" \n\t\t\t\t\t\t\tAdd "), _c('i', {
    staticClass: "fal fa-check-circle"
  }), _vm._v(" or Remove "), _c('i', {
    staticClass: "fal fa-times-circle"
  }), _vm._v(" Sounds From Your "), _c('span', {
    attrs: {
      "id": "soundscapeTitleBreak"
    }
  }, [_vm._v("Amazon Rainforest Soundscape")])]) : (_vm.userMobile) ? _c('p', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "fxTitle"
    }
  }, [_vm._v(" \n\t\t\t\t\t\t\tSounds of the Amazon")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn1Div"
    }
  }, [_c('button', {
    class: _vm.ambience1Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience1Func
    },
    on: {
      "click": function($event) {
        _vm.ambience1Boolean = !_vm.ambience1Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience1Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tForest Floor\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience1Vol),
      expression: "ambience1Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance1RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience1Func,
      "max": "6",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience1Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience1Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn2Div"
    }
  }, [_c('button', {
    class: _vm.ambience2Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience2Func
    },
    on: {
      "click": function($event) {
        _vm.ambience2Boolean = !_vm.ambience2Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience2Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tIn The Trees\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience2Vol),
      expression: "ambience2Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance2RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience2Func,
      "max": "6",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience2Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience2Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn3Div"
    }
  }, [_c('button', {
    class: _vm.ambience3Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience3Func
    },
    on: {
      "click": function($event) {
        _vm.ambience3Boolean = !_vm.ambience3Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience3Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tCanopy\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience3Vol),
      expression: "ambience3Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance3RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience3Func,
      "max": "6",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience3Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience3Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn4Div"
    }
  }, [_c('button', {
    class: _vm.ambience4Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience4Func
    },
    on: {
      "click": function($event) {
        _vm.ambience4Boolean = !_vm.ambience4Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience4Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tPeccary\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience4Vol),
      expression: "ambience4Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance4RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience4Func,
      "max": "10",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience4Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience4Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn5Div"
    }
  }, [_c('button', {
    class: _vm.ambience5Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience5Func
    },
    on: {
      "click": function($event) {
        _vm.ambience5Boolean = !_vm.ambience5Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience5Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tMonsoon\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience5Vol),
      expression: "ambience5Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance5RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience5Func,
      "max": "6",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience5Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience5Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn6Div"
    }
  }, [_c('button', {
    class: _vm.ambience6Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience6Func
    },
    on: {
      "click": function($event) {
        _vm.ambience6Boolean = !_vm.ambience6Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience6Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tNight Frogs\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience6Vol),
      expression: "ambience6Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance6RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience6Func,
      "max": "6",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience6Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience6Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "masterControlDiv"
    }
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "fxTitle2"
    }
  }, [_vm._v(" \n\t\t\t\tProcess Soundscape With Digital Audio Processing\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice1SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voiceBadgeAmazon",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.speedToggle = !_vm.speedToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.speedToggle),
      expression: "speedToggle"
    }],
    staticStyle: {
      "color": "var(--main-startAmazon-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tSpeed " + _vm._s(((_vm.playBackSpeed).toFixed(3))) + "x \n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.speedToggle),
      expression: "!speedToggle"
    }],
    staticStyle: {
      "color": "var(--main-stopAmazon-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tSpeed " + _vm._s(((_vm.playBackSpeed).toFixed(3))) + "x \n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.playBackSpeed),
      expression: "playBackSpeed",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "instrumentRangerAmazon",
    attrs: {
      "id": "sliders6",
      "type": "range",
      "step": "0.01",
      "max": "2",
      "min": "0.1",
      "": _vm.playbackSpeedFunc
    },
    domProps: {
      "value": (_vm.playBackSpeed)
    },
    on: {
      "__r": function($event) {
        _vm.playBackSpeed = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice2SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voiceBadgeAmazon",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.fxDelayToggle = !_vm.fxDelayToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fxDelayToggle),
      expression: "fxDelayToggle"
    }],
    staticStyle: {
      "color": "var(--main-startAmazon-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tDelay " + _vm._s(_vm.fxDelayAmt) + "% \n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fxDelayToggle),
      expression: "!fxDelayToggle"
    }],
    staticStyle: {
      "color": "var(--main-stopAmazon-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tDelay " + _vm._s(_vm.fxDelayAmt) + "% \n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.fxDelayAmt),
      expression: "fxDelayAmt",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "instrumentRangerAmazon",
    attrs: {
      "id": "sliders2",
      "type": "range",
      "step": "1",
      "max": "100",
      "min": "0",
      "": _vm.fxDelayMix
    },
    domProps: {
      "value": (_vm.fxDelayAmt)
    },
    on: {
      "__r": function($event) {
        _vm.fxDelayAmt = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice3SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voiceBadgeAmazon",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.fxChorusToggle = !_vm.fxChorusToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fxChorusToggle),
      expression: "fxChorusToggle"
    }],
    staticStyle: {
      "color": "var(--main-startAmazon-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tChorus " + _vm._s(_vm.fxChorusAmt) + "% \n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fxChorusToggle),
      expression: "!fxChorusToggle"
    }],
    staticStyle: {
      "color": "var(--main-stopAmazon-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tChorus " + _vm._s(_vm.fxChorusAmt) + "% \n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.fxChorusAmt),
      expression: "fxChorusAmt",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "instrumentRangerAmazon",
    attrs: {
      "id": "sliders3",
      "type": "range",
      "step": "1",
      "max": "100",
      "min": "0",
      "": _vm.fxChorusMix
    },
    domProps: {
      "value": (_vm.fxChorusAmt)
    },
    on: {
      "__r": function($event) {
        _vm.fxChorusAmt = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice4SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voiceBadgeAmazon",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.fxFilterToggle = !_vm.fxFilterToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fxFilterToggle),
      expression: "fxFilterToggle"
    }],
    staticStyle: {
      "color": "var(--main-startAmazon-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tFilter " + _vm._s(_vm.fxAutoFilterAmt) + "Hz\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fxFilterToggle),
      expression: "!fxFilterToggle"
    }],
    staticStyle: {
      "color": "var(--main-stopAmazon-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tFilter " + _vm._s(_vm.fxAutoFilterAmt) + "Hz\n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.fxAutoFilterAmt),
      expression: "fxAutoFilterAmt",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "instrumentRangerAmazon",
    attrs: {
      "id": "sliders4",
      "type": "range",
      "step": "1",
      "max": "10000",
      "min": "80",
      "": _vm.fxAutoFilterMix
    },
    domProps: {
      "value": (_vm.fxAutoFilterAmt)
    },
    on: {
      "__r": function($event) {
        _vm.fxAutoFilterAmt = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice5SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voiceBadgeAmazon",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.fxConvolverToggle = !_vm.fxConvolverToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fxConvolverToggle),
      expression: "fxConvolverToggle"
    }],
    staticStyle: {
      "color": "var(--main-startAmazon-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tReverb (" + _vm._s(((_vm.fxDecay).toPrecision(2))) + "s) " + _vm._s((_vm.fxConvolverAmt * 2)) + "%\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fxConvolverToggle),
      expression: "!fxConvolverToggle"
    }],
    staticStyle: {
      "color": "var(--main-stopAmazon-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tReverb (" + _vm._s(((_vm.fxDecay).toPrecision(2))) + "s) " + _vm._s((_vm.fxConvolverAmt * 2)) + "%\n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.fxConvolverAmt),
      expression: "fxConvolverAmt",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "instrumentRangerAmazon",
    attrs: {
      "id": "sliders1",
      "type": "range",
      "step": "1",
      "max": "50",
      "min": "0",
      "": _vm.fxConvolverMix
    },
    domProps: {
      "value": (_vm.fxConvolverAmt)
    },
    on: {
      "__r": function($event) {
        _vm.fxConvolverAmt = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice6SliderDiv"
    }
  }, [_c('button', {
    class: _vm.mattChillClass,
    attrs: {
      "id": "masterControlBadgesSFX"
    },
    on: {
      "click": _vm.mattChillMethod
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.randomizeBoolean),
      expression: "!randomizeBoolean"
    }]
  }, [_c('i', {
    staticClass: "fa fa-flask"
  }), _vm._v(" Randomize "), _c('i', {
    staticClass: "fa fa-flask"
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.randomizeBoolean),
      expression: "randomizeBoolean"
    }]
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask5),
      expression: "showFlask5"
    }],
    staticClass: "fa fa-flask fa-counter-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask3),
      expression: "showFlask3"
    }],
    staticClass: "fa fa-flask fa-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask1),
      expression: "showFlask1"
    }],
    staticClass: "fa fa-flask slow-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask2),
      expression: "showFlask2"
    }],
    staticClass: "fa fa-flask slow-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask4),
      expression: "showFlask4"
    }],
    staticClass: "fa fa-flask fa-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask6),
      expression: "showFlask6"
    }],
    staticClass: "fa fa-flask fa-counter-spin"
  })])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAboutPage),
      expression: "showAboutPage"
    }],
    staticClass: "col-xs-12",
    attrs: {
      "id": "aboutPageID"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "aboutTxt"
    }
  }, [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t\tThe Tambopata National Reserve lies deep within the Peruvian borders of the Amazon Rainforest. It is here that you can peek into a thriving world of sound. This is the chorus of life, a reminder of just how much it can flourish when undisturbed. \n\t\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\t\t\t\t\t\t\n\t\t\t\t\t\tThese sounds were recorded over a weeks stay in the Tambopata National Reserve. One of the most intense recordings was capturing the peccary as they rummaged in the mud for food. These aggressive and territorial pigs can become, well, very aggressive and territorial. Being flanked by a group of peccary while collecting my microphones was nerve racking. I was warned never to turn my back on these crazy pigs, noted. \n\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "disclaimerTxt"
    }
  }, [_vm._v("\n\t\t\t\t\t\tSound Design & Recordings Copyright © 2018 "), _c('a', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "href": "https://www.mattmccorkle.com",
      "target": "_blank"
    }
  }, [_vm._v("Matt McCorkle")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v(" These sounds are presented here for personal entertainment use only. ")]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t\tFor commercial sound licensing email hi@mattmccorkle.com\n\t\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    class: _vm.helpClass,
    attrs: {
      "id": "aboutBtnID2"
    },
    on: {
      "click": _vm.goToHelp
    }
  }, [_c('strong', [_c('i', {
    staticClass: "fa fa-window-close fa-3x"
  })])])])]), _vm._v(" "), (this.$store.state.allowSpeechControl) ? _c('div') : _vm._e(), _vm._v(" "), (this.$store.state.allowSpeechControl) ? _c('div', [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated pulse",
      "mode": "out-in"
    }
  }, [(_vm.showSpeechBtns) ? _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "speechContainer"
    }
  }, [_c('button', {
    class: _vm.speechShowListClass,
    attrs: {
      "id": "speechList"
    },
    on: {
      "click": _vm.voiceCommandListFunc
    }
  }, [_c('i', {
    staticClass: "fal fa-clipboard-list"
  }), _vm._v(" List of Voice Commands\n\t\t\t\t")]), _vm._v(" "), (_vm.showVoiceCommandList) ? _c('div', {
    attrs: {
      "id": "voiceCommandListID"
    }
  }, [_c('p', {
    attrs: {
      "id": "voiceControlListTitle"
    }
  }, [_c('strong', [_vm._v(" Voice Control This Immersive Experience")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "voiceControlListTxt"
    }
  }, [_c('strong', [_vm._v("Allow Google Chrome Microphone Access To Use This Feature")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "fal fa-headphones"
  }), _vm._v(" Voice Control Works "), _c('strong', [_c('u', [_vm._v("Great")])]), _vm._v(" With Headphones "), _c('i', {
    staticClass: "fal fa-headphones"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("OK! Now Use That Beautiful Voice, Say Something!\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('u', [_vm._v("Exploration:")]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\tLet's Explore!\n\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\tRandomize, Shift Soundscape,")]), _vm._v(" or "), _c('strong', [_vm._v("New Scene")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_c('u', [_vm._v("Creating A Soundscape:")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Amazon Floor")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("In The Trees")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Canopy")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Peccary")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Monsoon")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Night Frogs")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Stop ")]), _vm._v(" or "), _c('strong', [_vm._v("Take Out ")]), _vm._v("[Sound Source Name] \n\t\t\t\t\t"), _c('br'), _c('span', {
    attrs: {
      "id": "voiceListAnchor"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Volume Up")]), _vm._v(" or "), _c('strong', [_vm._v("Louder")]), _vm._v(" [Sound Source Name]\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Volume Down")]), _vm._v(" or "), _c('strong', [_vm._v("Softer ")]), _vm._v("[Sound Source Name]\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_c('u', [_vm._v("Digital Audio Effects:")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Speed Up ")]), _vm._v("or "), _c('strong', [_vm._v("Faster")]), _vm._v(" & "), _c('strong', [_vm._v("Speed Down ")]), _vm._v("or "), _c('strong', [_vm._v("Slower")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Delay On")]), _vm._v(" or "), _c('strong', [_vm._v("Off ")]), _vm._v(" & "), _c('strong', [_vm._v("More ")]), _vm._v("or "), _c('strong', [_vm._v("Less")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Chorus On")]), _vm._v(" or "), _c('strong', [_vm._v("Off ")]), _vm._v(" & "), _c('strong', [_vm._v("More ")]), _vm._v("or "), _c('strong', [_vm._v("Less")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Filter On")]), _vm._v(" or "), _c('strong', [_vm._v("Off ")]), _vm._v(" & "), _c('strong', [_vm._v("More ")]), _vm._v("or "), _c('strong', [_vm._v("Less")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Reverb On")]), _vm._v(" or "), _c('strong', [_vm._v("Off ")]), _vm._v(" & "), _c('strong', [_vm._v("More ")]), _vm._v("or "), _c('strong', [_vm._v("Less")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('i', [_vm._v("Add the word "), _c('strong', [_vm._v("a lot")]), _vm._v(" to move in greater increments.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_c('u', [_vm._v("Housekeeping:")]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\tStop All Sounds \n\t\t\t\t\t"), _c('br'), _vm._v(" \n\t\t\t\t\tPlay All Sounds\n\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\tStop Voice Commands \n\t\t\t\t\t"), _c('br'), _vm._v(" \n\t\t\t\t\tGo Home\n\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\tShow")]), _vm._v(" or "), _c('strong', [_vm._v("Hide Soundscape Info\n\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\tShow")]), _vm._v(" or "), _c('strong', [_vm._v("Hide Voice Command List")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_c('u', [_vm._v("Additional Mentions:")])]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t1.) It might take a few tries, try saying your command quickly and in a direct manner.\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t2.) Each Sound Source can always be addressed as \"Sound Source 1-6\"\n\t\t\t\t")])]) : _vm._e()]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (!this.$store.state.allowSpeechControl) ? _c('div', [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNavBar),
      expression: "showNavBar"
    }],
    staticClass: "container-fluid"
  }, [_c('button', {
    class: _vm.exploreFuncClass,
    attrs: {
      "id": "exploreBtnId"
    },
    on: {
      "click": _vm.exploreBtnFunc
    }
  }, [_c('i', {
    class: _vm.exploreIconClass
  }), _vm._v(" " + _vm._s(_vm.exploreTxt) + "\n\t\t\t\t")])])])], 1) : _vm._e(), _vm._v(" "), _c('transition-group', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNavBar),
      expression: "showNavBar"
    }],
    key: "localStorageBtnsKey",
    staticClass: "container-fluid",
    attrs: {
      "id": "helpContainer"
    }
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    class: _vm.saveClass,
    attrs: {
      "id": "localStorageBtnID"
    },
    on: {
      "click": _vm.setLocalStorage
    }
  }, [_c('i', {
    staticClass: "fal fa-sliders-h"
  }), _vm._v(" Save\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    class: _vm.loadClass,
    attrs: {
      "id": "localStorageBtnID"
    },
    on: {
      "click": _vm.getLocalStorage
    }
  }, [_c('i', {
    staticClass: "fal fa-sliders-h"
  }), _vm._v(" Load\n\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNavBar),
      expression: "showNavBar"
    }],
    key: "helpBtnsKeys",
    staticClass: "container-fluid",
    attrs: {
      "id": "helpContainer"
    }
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    class: _vm.helpClass,
    attrs: {
      "id": "aboutBtnID"
    },
    on: {
      "click": _vm.goToHelp
    }
  }, [_c('i', {
    staticClass: "fal fa-info-circle"
  }), _vm._v(" Info\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    class: _vm.helpClass,
    attrs: {
      "id": "aboutBtnID"
    },
    on: {
      "click": _vm.goHome
    }
  }, [_c('i', {
    staticClass: "fas fa-home"
  }), _vm._v(" Home\n\t\t\t\t\t")])])])]), _vm._v(" "), (!_vm.userMobile) ? _c('div', [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNavBar),
      expression: "showNavBar"
    }],
    staticClass: "container-fluid",
    attrs: {
      "id": "visualToggleContainer"
    }
  }, [(_vm.activeSun) ? _c('span', {
    attrs: {
      "id": "visualToggle"
    },
    on: {
      "click": function($event) {
        _vm.activeSun = !_vm.activeSun
      }
    }
  }, [_vm._v(" \n\t\t\t\t\t\tReactive Background\n\t\t\t\t\t\t"), _c('i', {
    staticClass: "fal fa-toggle-on"
  })]) : (!_vm.activeSun) ? _c('span', {
    attrs: {
      "id": "visualToggle"
    },
    on: {
      "click": function($event) {
        _vm.activeSun = !_vm.activeSun
      }
    }
  }, [_vm._v(" \n\t\t\t\t\t\tReactive Background\n\t\t\t\t\t\t"), _c('i', {
    staticClass: "fal fa-toggle-off"
  })]) : _vm._e()])])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 70 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    class: _vm.backgroundTransitionHome,
    attrs: {
      "id": "mainDiv"
    }
  }, [_c('transition', {
    attrs: {
      "appear": "",
      "enter-active-class": "animated pulse",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showWelcomePage),
      expression: "showWelcomePage"
    }],
    key: "navBar",
    staticClass: "col-xs-12 text-center",
    attrs: {
      "id": "optionsBucket"
    }
  }, [(this.$store.state.allowSpeechControl) ? _c('span', [(_vm.initSpeech) ? _c('button', {
    class: _vm.speechStartStop,
    attrs: {
      "id": "welcomeBtnVoice"
    },
    on: {
      "click": _vm.speechFunc
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.aboutHideTxtGen),
      expression: "!aboutHideTxtGen"
    }],
    attrs: {
      "id": "clickedAbout"
    }
  }, [_vm._v(" Click To Use Voice Commands ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.aboutHideTxtGen),
      expression: "aboutHideTxtGen"
    }]
  })]) : _vm._e(), _vm._v(" "), (!_vm.initSpeech) ? _c('button', {
    class: _vm.speechStartStop,
    attrs: {
      "id": "welcomeBtnVoice"
    },
    on: {
      "click": _vm.stopSpeech
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.aboutHideTxtGen),
      expression: "!aboutHideTxtGen"
    }],
    attrs: {
      "id": "clickedAbout"
    }
  }, [_c('i', {
    class: _vm.speechIconClass
  }), _vm._v(" " + _vm._s(_vm.speechBtnTxt) + " ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.aboutHideTxtGen),
      expression: "aboutHideTxtGen"
    }]
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    class: _vm.aboutBtnClass,
    attrs: {
      "id": "welcomeBtnAbout"
    },
    on: {
      "click": _vm.goToAbout
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.aboutHideTxtGen),
      expression: "!aboutHideTxtGen"
    }],
    attrs: {
      "id": "clickedAbout"
    }
  }, [_vm._v(" " + _vm._s(_vm.aboutTxt) + " ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.aboutHideTxtGen),
      expression: "aboutHideTxtGen"
    }]
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    class: _vm.btnPlains,
    attrs: {
      "id": "welcomeBtn"
    },
    on: {
      "click": _vm.goToPlains
    }
  }, [_c('span', {
    attrs: {
      "id": "clickedPlains"
    }
  }, [_vm._v(_vm._s(_vm.plainsTxt))])]), _vm._v(" "), _c('button', {
    class: _vm.btnOcean,
    attrs: {
      "id": "welcomeBtn"
    },
    on: {
      "click": _vm.goToOcean
    }
  }, [_c('span', {
    attrs: {
      "id": "clickedOcean"
    }
  }, [_vm._v(_vm._s(_vm.oceanTxt))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    class: _vm.btnAmazon,
    attrs: {
      "id": "welcomeBtn"
    },
    on: {
      "click": _vm.goToAmazon
    }
  }, [_c('span', {
    attrs: {
      "id": "clickedAmazon"
    }
  }, [_vm._v(_vm._s(_vm.amazonTxt))])]), _vm._v(" "), _c('button', {
    class: _vm.btnForest,
    attrs: {
      "id": "welcomeBtn"
    },
    on: {
      "click": _vm.goToForest
    }
  }, [_c('span', {
    attrs: {
      "id": "clickedForest"
    }
  }, [_vm._v(_vm._s(_vm.forestTxt))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    class: _vm.btnDesert,
    attrs: {
      "id": "welcomeBtn"
    },
    on: {
      "click": _vm.goToDesert
    }
  }, [_c('span', {
    attrs: {
      "id": "clickedDesert"
    }
  }, [_vm._v(_vm._s(_vm.desertTxt))])]), _vm._v(" "), _c('button', {
    class: _vm.btnBeach,
    attrs: {
      "id": "welcomeBtn"
    },
    on: {
      "click": _vm.goToBeach
    }
  }, [_c('span', {
    attrs: {
      "id": "clickedBeach"
    }
  }, [_vm._v(_vm._s(_vm.beachTxt))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    class: _vm.btnMetro,
    attrs: {
      "id": "welcomeBtn"
    },
    on: {
      "click": _vm.goToNYC
    }
  }, [_c('span', {
    attrs: {
      "id": "clickedNYC"
    }
  }, [_vm._v(_vm._s(_vm.nycTxt))])]), _vm._v(" "), _c('button', {
    class: _vm.btnRural,
    attrs: {
      "id": "welcomeBtn"
    },
    on: {
      "click": _vm.goToRural
    }
  }, [_c('span', {
    attrs: {
      "id": "clickedRural"
    }
  }, [_vm._v(_vm._s(_vm.ruralTxt))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    class: _vm.btnFire,
    attrs: {
      "id": "welcomeBtn"
    },
    on: {
      "click": _vm.goTofire
    }
  }, [_c('span', {
    attrs: {
      "id": "clickedFire"
    }
  }, [_vm._v(_vm._s(_vm.fireTxt))])]), _vm._v(" "), _c('button', {
    class: _vm.btnIce,
    attrs: {
      "id": "welcomeBtn"
    },
    on: {
      "click": _vm.goToice
    }
  }, [_c('span', {
    attrs: {
      "id": "clickedIce"
    }
  }, [_vm._v(_vm._s(_vm.iceTxt))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    class: _vm.btnTut,
    attrs: {
      "id": "welcomeBtnAbout"
    },
    on: {
      "click": _vm.goToTut
    }
  }, [_c('span', {
    attrs: {
      "id": "clickedTut"
    }
  }, [_vm._v(_vm._s(_vm.tutTxt))])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAboutPage),
      expression: "showAboutPage"
    }],
    staticClass: "col-xs-12 text-center",
    attrs: {
      "id": "aboutPageID"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "aboutTxt"
    }
  }, [_c('strong', [_c('i', {
    staticClass: "far fa-headphones"
  }), _vm._v(" \n\t\t\t\t\t\t\tHeadphones Recommended \n\t\t\t\t\t\t\t"), _c('i', {
    staticClass: "far fa-headphones"
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._v("  \n\n\t\t\t\t\t\tEnter this immersive audio experience and explore unique soundscapes from around the world. "), _c('span', {
    attrs: {
      "id": "lineBreak"
    }
  }, [_vm._v("Within each soundscape, control individual sounds to create the sonic shape of a greater soundscape.")]), _vm._v(" "), _c('span', {
    attrs: {
      "id": "lineBreak"
    }
  }, [_vm._v("Use digital audio effects to shape your soundscapes further by twisting and transforming their sound waves.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }]
  }, [_vm._v(" \n\t\t\t\t\t\t\tEars never blink, we're always listening.\n\t\t\t\t\t\t\t"), _c('br')])]), _vm._v(" "), _c('button', {
    class: _vm.aboutVOClass,
    attrs: {
      "id": "aboutSectionVO"
    },
    on: {
      "click": _vm.aboutVOFunc
    }
  }, [_c('i', {
    class: _vm.aboutVOIcon
  }), _vm._v("\n\t\t\t\t\t\t\tAbout This Project\n\t\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "aboutTxt"
    }
  }, [_c('strong', [_vm._v("\n\t\t\t\t\t\tCreated & Built by  \n\t\t\t\t\t\t\t"), _c('a', {
    style: ({
      'color': _vm.aboutVOBoolean ? 'green' : 'red'
    }),
    attrs: {
      "href": "https://www.mattmccorkle.com",
      "target": "_blank"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tMatt McCorkle\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    attrs: {
      "id": "shoutOut"
    }
  }, [_vm._v("\n\t\t\t\t\t\tUtilizing the \n\t\t\t\t\t\t\t"), _c('strong', [_c('a', {
    style: ({
      'color': _vm.aboutVOBoolean ? 'green' : 'red'
    }),
    attrs: {
      "href": "https://tonejs.github.io/",
      "target": "_blank"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tTone.js\n\t\t\t\t\t\t\t\t")])]), _vm._v("\n\t\t\t\t\t\t\tWeb Audio Framework\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "mailingListText"
    }
  }, [_vm._v(" \n\t\t\t\t\t\tStay in touch for new soundscape releases! \n\t\t\t\t\t\t"), _c('br')]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "mc_embed_signup"
    }
  }, [_c('form', {
    staticClass: "validate",
    attrs: {
      "action": "https://space.us12.list-manage.com/subscribe/post?u=cc407290614bbaa2daa32fe9e&id=219d3ce36c",
      "method": "post",
      "id": "mc-embedded-subscribe-form",
      "name": "mc-embedded-subscribe-form",
      "target": "_blank",
      "novalidate": ""
    }
  }, [_c('div', {
    attrs: {
      "id": "mc_embed_signup_scroll"
    }
  }, [_c('input', {
    staticClass: "email",
    staticStyle: {
      "border-color": "black",
      "color": "black"
    },
    attrs: {
      "type": "email",
      "value": "",
      "name": "EMAIL",
      "id": "mce-EMAIL",
      "placeholder": "email address",
      "required": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "left": "-5000px",
      "color": "black"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('input', {
    attrs: {
      "type": "text",
      "name": "b_cc407290614bbaa2daa32fe9e_219d3ce36c",
      "tabindex": "-1",
      "value": ""
    }
  })]), _vm._v(" "), _c('input', {
    staticStyle: {
      "border-color": "black",
      "color": "black"
    },
    attrs: {
      "type": "submit",
      "value": "Subscribe!",
      "name": "subscribe",
      "id": "mc-embedded-subscribe"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "disclaimerTxt"
    }
  }, [_vm._v("\n\t\t\t\t\t\tSound Design & Recordings Copyright © 2018 Matt McCorkle\n\t\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('strong', [_vm._v(" These sounds are presented here for personal entertainment use only. ")]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t\tFor commercial sound licensing email hi@mattmccorkle.com\n\t\t\t\t\t\t"), _c('br')]), _vm._v(" "), _c('button', {
    class: _vm.helpClass,
    attrs: {
      "id": "aboutBtnID2"
    },
    on: {
      "click": _vm.goHome
    }
  }, [_c('i', {
    staticClass: "fa fa-window-close fa-3x",
    attrs: {
      "aria": "true"
    }
  })])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 71 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    class: _vm.plungeClass,
    attrs: {
      "id": "mainDiv"
    }
  }, [(this.$store.state.allowSpeechControl) ? _c('div', [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated pulse",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAllControls),
      expression: "showAllControls"
    }],
    staticClass: "container-fluid",
    attrs: {
      "id": "VUIformInputDivID"
    }
  }, [_c('div', {
    staticClass: "col-xs-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userVoiceToText),
      expression: "userVoiceToText"
    }],
    staticClass: "form-control",
    class: _vm.plungeClass,
    staticStyle: {
      "color": "white !important",
      "border-width": "0px"
    },
    attrs: {
      "type": "text",
      "id": "inlineFormInputGroupUsername2",
      "placeholder": "View & Type Voice Commands Here"
    },
    domProps: {
      "value": (_vm.userVoiceToText)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.userVoiceToTextFunc($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userVoiceToText = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  }, [(_vm.initSpeech) ? _c('span', {
    on: {
      "click": _vm.speechFunc
    }
  }, [_c('i', {
    staticClass: "fal fa-microphone-slash",
    attrs: {
      "id": "speechEngage"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.initSpeech) ? _c('span', {
    on: {
      "click": _vm.speechStartStopFunc
    }
  }, [_c('i', {
    staticClass: "fa fa-microphone-alt",
    style: ({
      'color': _vm.recognizing ? 'red' : 'black'
    }),
    attrs: {
      "id": "speechEngageActivated"
    }
  })]) : _vm._e()])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showEnterContainer),
      expression: "showEnterContainer"
    }],
    staticClass: "container-fluid",
    attrs: {
      "id": "enterContainer"
    }
  }, [_c('transition', {
    attrs: {
      "appear": "",
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated tada",
      "mode": "out-in"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showEnterBtn),
      expression: "showEnterBtn"
    }],
    staticClass: "btn-info",
    staticStyle: {
      "color": "gold",
      "background-color": "#788487"
    },
    attrs: {
      "id": "enterFuncBtn"
    },
    on: {
      "~click": function($event) {
        return _vm.enterFunc($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tNew York City\n\t\t\t\t\t")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLoading),
      expression: "showLoading"
    }],
    staticStyle: {
      "border-color": "transparent",
      "background": "transparent"
    },
    attrs: {
      "id": "enterFuncBtn"
    }
  }, [_vm._v(" \t\n\t\t\t\t\t\t\tLoading... \n\t\t\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.whatIsLoading) + "\n\t\t\t\t\t")])])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAllControls),
      expression: "showAllControls"
    }],
    staticClass: "container-fluid",
    attrs: {
      "id": "controlsContainer"
    }
  }, [_c('div', {
    attrs: {
      "id": "ambienceBtnLocation"
    }
  }, [(!_vm.userMobile) ? _c('p', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "fxTitle"
    }
  }, [_vm._v(" \n\t\t\t\t\t\t\tAdd "), _c('i', {
    staticClass: "fal fa-check-circle"
  }), _vm._v(" or Remove "), _c('i', {
    staticClass: "fal fa-times-circle"
  }), _vm._v(" Sounds From Your "), _c('span', {
    attrs: {
      "id": "soundscapeTitleBreak"
    }
  }, [_vm._v("New York City Soundscape")])]) : (_vm.userMobile) ? _c('p', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "id": "fxTitle"
    }
  }, [_vm._v(" \n\t\t\t\t\t\t\tThe Sounds of New York City\n\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn1Div"
    }
  }, [_c('button', {
    class: _vm.ambience2Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience2Func
    },
    on: {
      "click": function($event) {
        _vm.ambience2Boolean = !_vm.ambience2Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience2Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tHumans\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience2Vol),
      expression: "ambience2Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance2RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience2Func,
      "max": "0",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience2Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience2Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn2Div"
    }
  }, [_c('button', {
    class: _vm.ambience3Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience3Func
    },
    on: {
      "click": function($event) {
        _vm.ambience3Boolean = !_vm.ambience3Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience3Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tSubway Station\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience3Vol),
      expression: "ambience3Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance3RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience3Func,
      "max": "0",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience3Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience3Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn3Div"
    }
  }, [_c('button', {
    class: _vm.ambience4Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience4Func
    },
    on: {
      "click": function($event) {
        _vm.ambience4Boolean = !_vm.ambience4Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience4Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tSubway Car\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience4Vol),
      expression: "ambience4Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance4RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience4Func,
      "max": "4",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience4Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience4Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn4Div"
    }
  }, [_c('button', {
    class: _vm.ambience1Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience1Func
    },
    on: {
      "click": function($event) {
        _vm.ambience1Boolean = !_vm.ambience1Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience1Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tStreet\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience1Vol),
      expression: "ambience1Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance1RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience1Func,
      "max": "6",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience1Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience1Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn5Div"
    }
  }, [_c('button', {
    class: _vm.ambience5Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience5Func
    },
    on: {
      "click": function($event) {
        _vm.ambience5Boolean = !_vm.ambience5Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience5Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t8th Floor\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience5Vol),
      expression: "ambience5Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance5RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience5Func,
      "max": "6",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience5Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience5Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn6Div"
    }
  }, [_c('button', {
    class: _vm.ambience6Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience6Func
    },
    on: {
      "click": function($event) {
        _vm.ambience6Boolean = !_vm.ambience6Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience6Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tPenthouse\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience6Vol),
      expression: "ambience6Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance6RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience6Func,
      "max": "10",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience6Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience6Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "masterControlDiv"
    }
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "fxTitle2"
    }
  }, [_vm._v(" \n\t\t\tProcess Soundscape With Digital Audio Processing\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice1SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voiceBadgeNYC",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.speedToggle = !_vm.speedToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.speedToggle),
      expression: "speedToggle"
    }],
    staticStyle: {
      "color": "var(--main-startNYC-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tSpeed " + _vm._s(((_vm.playBackSpeed).toFixed(3))) + "x\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.speedToggle),
      expression: "!speedToggle"
    }],
    staticStyle: {
      "color": "var(--main-stopNYC-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tSpeed " + _vm._s(((_vm.playBackSpeed).toFixed(3))) + "x\n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.playBackSpeed),
      expression: "playBackSpeed",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "instrumentRangerNYC",
    attrs: {
      "id": "sliders6",
      "type": "range",
      "step": "0.01",
      "max": "2",
      "min": "0.1",
      "": _vm.playbackSpeedFunc
    },
    domProps: {
      "value": (_vm.playBackSpeed)
    },
    on: {
      "__r": function($event) {
        _vm.playBackSpeed = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice2SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voiceBadgeNYC",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.fxDelayToggle = !_vm.fxDelayToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fxDelayToggle),
      expression: "fxDelayToggle"
    }],
    staticStyle: {
      "color": "var(--main-startNYC-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tDelay " + _vm._s(_vm.fxDelayAmt) + "% \n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fxDelayToggle),
      expression: "!fxDelayToggle"
    }],
    staticStyle: {
      "color": "var(--main-stopNYC-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tDelay " + _vm._s(_vm.fxDelayAmt) + "% \n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.fxDelayAmt),
      expression: "fxDelayAmt",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "instrumentRangerNYC",
    attrs: {
      "id": "sliders2",
      "type": "range",
      "step": "1",
      "max": "100",
      "min": "0",
      "": _vm.fxDelayMix
    },
    domProps: {
      "value": (_vm.fxDelayAmt)
    },
    on: {
      "__r": function($event) {
        _vm.fxDelayAmt = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice3SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voiceBadgeNYC",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.fxChorusToggle = !_vm.fxChorusToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fxChorusToggle),
      expression: "fxChorusToggle"
    }],
    staticStyle: {
      "color": "var(--main-startNYC-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tChorus " + _vm._s(_vm.fxChorusAmt) + "% \n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fxChorusToggle),
      expression: "!fxChorusToggle"
    }],
    staticStyle: {
      "color": "var(--main-stopNYC-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tChorus " + _vm._s(_vm.fxChorusAmt) + "% \n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.fxChorusAmt),
      expression: "fxChorusAmt",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "instrumentRangerNYC",
    attrs: {
      "id": "sliders3",
      "type": "range",
      "step": "1",
      "max": "100",
      "min": "0",
      "": _vm.fxChorusMix
    },
    domProps: {
      "value": (_vm.fxChorusAmt)
    },
    on: {
      "__r": function($event) {
        _vm.fxChorusAmt = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice4SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voiceBadgeNYC",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.fxFilterToggle = !_vm.fxFilterToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fxFilterToggle),
      expression: "fxFilterToggle"
    }],
    staticStyle: {
      "color": "var(--main-startNYC-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tFilter " + _vm._s(_vm.fxAutoFilterAmt) + "Hz\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fxFilterToggle),
      expression: "!fxFilterToggle"
    }],
    staticStyle: {
      "color": "var(--main-stopNYC-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tFilter " + _vm._s(_vm.fxAutoFilterAmt) + "Hz\n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.fxAutoFilterAmt),
      expression: "fxAutoFilterAmt",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "instrumentRangerNYC",
    attrs: {
      "id": "sliders4",
      "type": "range",
      "step": "1",
      "max": "10000",
      "min": "80",
      "": _vm.fxAutoFilterMix
    },
    domProps: {
      "value": (_vm.fxAutoFilterAmt)
    },
    on: {
      "__r": function($event) {
        _vm.fxAutoFilterAmt = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice5SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voiceBadgeNYC",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.fxConvolverToggle = !_vm.fxConvolverToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fxConvolverToggle),
      expression: "fxConvolverToggle"
    }],
    staticStyle: {
      "color": "var(--main-startNYC-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tReverb (" + _vm._s(((_vm.fxDecay).toPrecision(2))) + "s) " + _vm._s((_vm.fxConvolverAmt * 2)) + "%\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fxConvolverToggle),
      expression: "!fxConvolverToggle"
    }],
    staticStyle: {
      "color": "var(--main-stopNYC-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tReverb (" + _vm._s(((_vm.fxDecay).toPrecision(2))) + "s) " + _vm._s((_vm.fxConvolverAmt * 2)) + "%\n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.fxConvolverAmt),
      expression: "fxConvolverAmt",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "instrumentRangerNYC",
    attrs: {
      "id": "sliders1",
      "type": "range",
      "step": "1",
      "max": "50",
      "min": "0",
      "": _vm.fxConvolverMix
    },
    domProps: {
      "value": (_vm.fxConvolverAmt)
    },
    on: {
      "__r": function($event) {
        _vm.fxConvolverAmt = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice6SliderDiv"
    }
  }, [_c('button', {
    class: _vm.mattChillClass,
    attrs: {
      "id": "masterControlBadgesSFX"
    },
    on: {
      "click": _vm.mattChillMethod
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.randomizeBoolean),
      expression: "!randomizeBoolean"
    }]
  }, [_c('i', {
    staticClass: "fa fa-flask"
  }), _vm._v(" Randomize "), _c('i', {
    staticClass: "fa fa-flask"
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.randomizeBoolean),
      expression: "randomizeBoolean"
    }]
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask5),
      expression: "showFlask5"
    }],
    staticClass: "fa fa-flask fa-counter-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask3),
      expression: "showFlask3"
    }],
    staticClass: "fa fa-flask fa-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask1),
      expression: "showFlask1"
    }],
    staticClass: "fa fa-flask slow-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask2),
      expression: "showFlask2"
    }],
    staticClass: "fa fa-flask slow-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask4),
      expression: "showFlask4"
    }],
    staticClass: "fa fa-flask fa-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask6),
      expression: "showFlask6"
    }],
    staticClass: "fa fa-flask fa-counter-spin"
  })])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAboutPage),
      expression: "showAboutPage"
    }],
    staticClass: "col-xs-12",
    attrs: {
      "id": "aboutPageID"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "aboutTxt"
    }
  }, [_c('br'), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t\tNew York City is a sonic cake. So many layers of sound all compete, contrast, and distort one another. "), _c('strong', [_vm._v("Humans")]), _vm._v(" make up the majority of sound sources in this soundscape.\n\t\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t\tDeep underground is a maze of "), _c('strong', [_vm._v("subway stations")]), _vm._v(", each with a unique sonic signature. Low end rumbles resonate through the tunnels competing with high pitched screeches. \n\t\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t\tGoing up a the subway's stairs, you find yourself "), _c('strong', [_vm._v("street level")]), _vm._v(". Much like a forest floor, the street level is a constant source of sound. \n\t\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t\tRising up one more level, you may find yourself on the "), _c('strong', [_vm._v("8th floor")]), _vm._v(" above the street. Up here you will still hear the street noise, but it is much less direct and often muffled. Akin to being in the trees of a NYC. \n\t\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t\tRising to the very top of a skyscraper, you may find yourself in a "), _c('strong', [_vm._v("penthouse")]), _vm._v(". This gives you a unique sonic perspective, a respite from the chaos.  \n\t\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "disclaimerTxt"
    }
  }, [_vm._v("\n\t\t\t\t\t\tSound Design & Recordings Copyright © 2018 "), _c('a', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "href": "https://www.mattmccorkle.com",
      "target": "_blank"
    }
  }, [_vm._v("Matt McCorkle")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v(" These sounds are presented here for personal entertainment use only. ")]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t\tFor commercial sound licensing email hi@mattmccorkle.com\n\t\t\t\t\t\t")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    class: _vm.helpClass,
    attrs: {
      "id": "aboutBtnID2"
    },
    on: {
      "click": _vm.goToHelp
    }
  }, [_c('strong', [_c('i', {
    staticClass: "fa fa-window-close fa-3x"
  })])])])]), _vm._v(" "), (this.$store.state.allowSpeechControl) ? _c('div') : _vm._e(), _vm._v(" "), (this.$store.state.allowSpeechControl) ? _c('div', [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated pulse",
      "mode": "out-in"
    }
  }, [(_vm.showSpeechBtns) ? _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "speechContainer"
    }
  }, [_c('button', {
    class: _vm.speechShowListClass,
    attrs: {
      "id": "speechList"
    },
    on: {
      "click": _vm.voiceCommandListFunc
    }
  }, [_c('i', {
    staticClass: "fal fa-clipboard-list"
  }), _vm._v(" List of Voice Commands\n\t\t\t\t")]), _vm._v(" "), (_vm.showVoiceCommandList) ? _c('div', {
    attrs: {
      "id": "voiceCommandListID"
    }
  }, [_c('p', {
    attrs: {
      "id": "voiceControlListTitle"
    }
  }, [_c('strong', [_vm._v(" Voice Control This Immersive Experience")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "voiceControlListTxt"
    }
  }, [_c('strong', [_vm._v("Allow Google Chrome Microphone Access To Use This Feature")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "fal fa-headphones"
  }), _vm._v(" Voice Control Works "), _c('strong', [_c('u', [_vm._v("Great")])]), _vm._v(" With Headphones "), _c('i', {
    staticClass: "fal fa-headphones"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("OK! Now Use That Beautiful Voice, Say Something!\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('u', [_vm._v("Exploration:")]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\tLet's Explore!\n\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\tRandomize, Shift Soundscape,")]), _vm._v(" or "), _c('strong', [_vm._v("New Scene")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_c('u', [_vm._v("Creating A Soundscape:")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Humans")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Subway Station")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Subway Car")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Street")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("8th Floor")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Penthouse")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Stop ")]), _vm._v(" or "), _c('strong', [_vm._v("Take Out ")]), _vm._v("[Sound Source Name] \n\t\t\t\t\t"), _c('br'), _c('span', {
    attrs: {
      "id": "voiceListAnchor"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Volume Up")]), _vm._v(" or "), _c('strong', [_vm._v("Louder")]), _vm._v(" [Sound Source Name]\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Volume Down")]), _vm._v(" or "), _c('strong', [_vm._v("Softer ")]), _vm._v("[Sound Source Name]\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_c('u', [_vm._v("Digital Audio Effects:")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Speed Up ")]), _vm._v("or "), _c('strong', [_vm._v("Faster")]), _vm._v(" & "), _c('strong', [_vm._v("Speed Down ")]), _vm._v("or "), _c('strong', [_vm._v("Slower")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Delay On")]), _vm._v(" or "), _c('strong', [_vm._v("Off ")]), _vm._v(" & "), _c('strong', [_vm._v("More ")]), _vm._v("or "), _c('strong', [_vm._v("Less")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Chorus On")]), _vm._v(" or "), _c('strong', [_vm._v("Off ")]), _vm._v(" & "), _c('strong', [_vm._v("More ")]), _vm._v("or "), _c('strong', [_vm._v("Less")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Filter On")]), _vm._v(" or "), _c('strong', [_vm._v("Off ")]), _vm._v(" & "), _c('strong', [_vm._v("More ")]), _vm._v("or "), _c('strong', [_vm._v("Less")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Reverb On")]), _vm._v(" or "), _c('strong', [_vm._v("Off ")]), _vm._v(" & "), _c('strong', [_vm._v("More ")]), _vm._v("or "), _c('strong', [_vm._v("Less")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('i', [_vm._v("Add the word "), _c('strong', [_vm._v("a lot")]), _vm._v(" to move in greater increments.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_c('u', [_vm._v("Housekeeping:")]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\tStop All Sounds \n\t\t\t\t\t"), _c('br'), _vm._v(" \n\t\t\t\t\tPlay All Sounds\n\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\tStop Voice Commands \n\t\t\t\t\t"), _c('br'), _vm._v(" \n\t\t\t\t\tGo Home\n\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\tShow")]), _vm._v(" or "), _c('strong', [_vm._v("Hide Soundscape Info\n\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\tShow")]), _vm._v(" or "), _c('strong', [_vm._v("Hide Voice Command List")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_c('u', [_vm._v("Additional Mentions:")])]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t1.) It might take a few tries, try saying your command quickly and in a direct manner.\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t2.) Each Sound Source can always be addressed as \"Sound Source 1-6\"\n\t\t\t\t")])]) : _vm._e()]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (!this.$store.state.allowSpeechControl) ? _c('div', [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNavBar),
      expression: "showNavBar"
    }],
    staticClass: "container-fluid"
  }, [_c('button', {
    class: _vm.exploreFuncClass,
    attrs: {
      "id": "exploreBtnId"
    },
    on: {
      "click": _vm.exploreBtnFunc
    }
  }, [_c('i', {
    class: _vm.exploreIconClass
  }), _vm._v(" " + _vm._s(_vm.exploreTxt) + "\n\t\t\t\t")])])])], 1) : _vm._e(), _vm._v(" "), _c('transition-group', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNavBar),
      expression: "showNavBar"
    }],
    key: "localStorageBtnsKey",
    staticClass: "container-fluid",
    attrs: {
      "id": "helpContainer"
    }
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    class: _vm.saveClass,
    attrs: {
      "id": "localStorageBtnID"
    },
    on: {
      "click": _vm.setLocalStorage
    }
  }, [_c('i', {
    staticClass: "fal fa-sliders-h"
  }), _vm._v(" Save\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    class: _vm.loadClass,
    attrs: {
      "id": "localStorageBtnID"
    },
    on: {
      "click": _vm.getLocalStorage
    }
  }, [_c('i', {
    staticClass: "fal fa-sliders-h"
  }), _vm._v(" Load\n\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNavBar),
      expression: "showNavBar"
    }],
    key: "helpBtnsKeys",
    staticClass: "container-fluid",
    attrs: {
      "id": "helpContainer"
    }
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    class: _vm.helpClass,
    attrs: {
      "id": "aboutBtnID"
    },
    on: {
      "click": _vm.goToHelp
    }
  }, [_c('i', {
    staticClass: "fal fa-info-circle"
  }), _vm._v(" Info\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    class: _vm.helpClass,
    attrs: {
      "id": "aboutBtnID"
    },
    on: {
      "click": _vm.goHome
    }
  }, [_c('i', {
    staticClass: "fas fa-home"
  }), _vm._v(" Home\n\t\t\t\t\t")])])])]), _vm._v(" "), (!_vm.userMobile) ? _c('div', [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNavBar),
      expression: "showNavBar"
    }],
    staticClass: "container-fluid",
    attrs: {
      "id": "visualToggleContainer"
    }
  }, [(_vm.activeSun) ? _c('span', {
    attrs: {
      "id": "visualToggle"
    },
    on: {
      "click": function($event) {
        _vm.activeSun = !_vm.activeSun
      }
    }
  }, [_vm._v(" \n\t\t\t\t\t\tReactive Background\n\t\t\t\t\t\t"), _c('i', {
    staticClass: "fal fa-toggle-on"
  })]) : (!_vm.activeSun) ? _c('span', {
    attrs: {
      "id": "visualToggle"
    },
    on: {
      "click": function($event) {
        _vm.activeSun = !_vm.activeSun
      }
    }
  }, [_vm._v(" \n\t\t\t\t\t\tReactive Background\n\t\t\t\t\t\t"), _c('i', {
    staticClass: "fal fa-toggle-off"
  })]) : _vm._e()])])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(40);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("eebcf2de", content, true);

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(41);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("0b0ed66e", content, true);

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(42);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("29b2c546", content, true);

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(43);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("109b5f98", content, true);

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(44);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("6c47f442", content, true);

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(45);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("51fccdd3", content, true);

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(46);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("810131ce", content, true);

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(47);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("89350bb4", content, true);

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(48);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("379466b5", content, true);

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(49);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("6999cf22", content, true);

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(50);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("6a9a9aaf", content, true);

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(51);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("487c6925", content, true);

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(52);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("610e3362", content, true);

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(53);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("54c3b2ca", content, true);

/***/ }),
/* 86 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Store */
/* unused harmony export install */
/* unused harmony export mapState */
/* unused harmony export mapMutations */
/* unused harmony export mapGetters */
/* unused harmony export mapActions */
/* unused harmony export createNamespacedHelpers */
/**
 * vuex v3.0.1
 * (c) 2017 Evan You
 * @license MIT
 */
var applyMixin = function (Vue) {
  var version = Number(Vue.version.split('.')[0]);

  if (version >= 2) {
    Vue.mixin({ beforeCreate: vuexInit });
  } else {
    // override init and inject vuex init procedure
    // for 1.x backwards compatibility.
    var _init = Vue.prototype._init;
    Vue.prototype._init = function (options) {
      if ( options === void 0 ) options = {};

      options.init = options.init
        ? [vuexInit].concat(options.init)
        : vuexInit;
      _init.call(this, options);
    };
  }

  /**
   * Vuex init hook, injected into each instances init hooks list.
   */

  function vuexInit () {
    var options = this.$options;
    // store injection
    if (options.store) {
      this.$store = typeof options.store === 'function'
        ? options.store()
        : options.store;
    } else if (options.parent && options.parent.$store) {
      this.$store = options.parent.$store;
    }
  }
};

var devtoolHook =
  typeof window !== 'undefined' &&
  window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

function devtoolPlugin (store) {
  if (!devtoolHook) { return }

  store._devtoolHook = devtoolHook;

  devtoolHook.emit('vuex:init', store);

  devtoolHook.on('vuex:travel-to-state', function (targetState) {
    store.replaceState(targetState);
  });

  store.subscribe(function (mutation, state) {
    devtoolHook.emit('vuex:mutation', mutation, state);
  });
}

/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */
/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */


/**
 * forEach for object
 */
function forEachValue (obj, fn) {
  Object.keys(obj).forEach(function (key) { return fn(obj[key], key); });
}

function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

function isPromise (val) {
  return val && typeof val.then === 'function'
}

function assert (condition, msg) {
  if (!condition) { throw new Error(("[vuex] " + msg)) }
}

var Module = function Module (rawModule, runtime) {
  this.runtime = runtime;
  this._children = Object.create(null);
  this._rawModule = rawModule;
  var rawState = rawModule.state;
  this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
};

var prototypeAccessors$1 = { namespaced: { configurable: true } };

prototypeAccessors$1.namespaced.get = function () {
  return !!this._rawModule.namespaced
};

Module.prototype.addChild = function addChild (key, module) {
  this._children[key] = module;
};

Module.prototype.removeChild = function removeChild (key) {
  delete this._children[key];
};

Module.prototype.getChild = function getChild (key) {
  return this._children[key]
};

Module.prototype.update = function update (rawModule) {
  this._rawModule.namespaced = rawModule.namespaced;
  if (rawModule.actions) {
    this._rawModule.actions = rawModule.actions;
  }
  if (rawModule.mutations) {
    this._rawModule.mutations = rawModule.mutations;
  }
  if (rawModule.getters) {
    this._rawModule.getters = rawModule.getters;
  }
};

Module.prototype.forEachChild = function forEachChild (fn) {
  forEachValue(this._children, fn);
};

Module.prototype.forEachGetter = function forEachGetter (fn) {
  if (this._rawModule.getters) {
    forEachValue(this._rawModule.getters, fn);
  }
};

Module.prototype.forEachAction = function forEachAction (fn) {
  if (this._rawModule.actions) {
    forEachValue(this._rawModule.actions, fn);
  }
};

Module.prototype.forEachMutation = function forEachMutation (fn) {
  if (this._rawModule.mutations) {
    forEachValue(this._rawModule.mutations, fn);
  }
};

Object.defineProperties( Module.prototype, prototypeAccessors$1 );

var ModuleCollection = function ModuleCollection (rawRootModule) {
  // register root module (Vuex.Store options)
  this.register([], rawRootModule, false);
};

ModuleCollection.prototype.get = function get (path) {
  return path.reduce(function (module, key) {
    return module.getChild(key)
  }, this.root)
};

ModuleCollection.prototype.getNamespace = function getNamespace (path) {
  var module = this.root;
  return path.reduce(function (namespace, key) {
    module = module.getChild(key);
    return namespace + (module.namespaced ? key + '/' : '')
  }, '')
};

ModuleCollection.prototype.update = function update$1 (rawRootModule) {
  update([], this.root, rawRootModule);
};

ModuleCollection.prototype.register = function register (path, rawModule, runtime) {
    var this$1 = this;
    if ( runtime === void 0 ) runtime = true;

  if (false) {
    assertRawModule(path, rawModule);
  }

  var newModule = new Module(rawModule, runtime);
  if (path.length === 0) {
    this.root = newModule;
  } else {
    var parent = this.get(path.slice(0, -1));
    parent.addChild(path[path.length - 1], newModule);
  }

  // register nested modules
  if (rawModule.modules) {
    forEachValue(rawModule.modules, function (rawChildModule, key) {
      this$1.register(path.concat(key), rawChildModule, runtime);
    });
  }
};

ModuleCollection.prototype.unregister = function unregister (path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];
  if (!parent.getChild(key).runtime) { return }

  parent.removeChild(key);
};

function update (path, targetModule, newModule) {
  if (false) {
    assertRawModule(path, newModule);
  }

  // update target module
  targetModule.update(newModule);

  // update nested modules
  if (newModule.modules) {
    for (var key in newModule.modules) {
      if (!targetModule.getChild(key)) {
        if (false) {
          console.warn(
            "[vuex] trying to add a new module '" + key + "' on hot reloading, " +
            'manual reload is needed'
          );
        }
        return
      }
      update(
        path.concat(key),
        targetModule.getChild(key),
        newModule.modules[key]
      );
    }
  }
}

var functionAssert = {
  assert: function (value) { return typeof value === 'function'; },
  expected: 'function'
};

var objectAssert = {
  assert: function (value) { return typeof value === 'function' ||
    (typeof value === 'object' && typeof value.handler === 'function'); },
  expected: 'function or object with "handler" function'
};

var assertTypes = {
  getters: functionAssert,
  mutations: functionAssert,
  actions: objectAssert
};

function assertRawModule (path, rawModule) {
  Object.keys(assertTypes).forEach(function (key) {
    if (!rawModule[key]) { return }

    var assertOptions = assertTypes[key];

    forEachValue(rawModule[key], function (value, type) {
      assert(
        assertOptions.assert(value),
        makeAssertionMessage(path, key, type, value, assertOptions.expected)
      );
    });
  });
}

function makeAssertionMessage (path, key, type, value, expected) {
  var buf = key + " should be " + expected + " but \"" + key + "." + type + "\"";
  if (path.length > 0) {
    buf += " in module \"" + (path.join('.')) + "\"";
  }
  buf += " is " + (JSON.stringify(value)) + ".";
  return buf
}

var Vue; // bind on install

var Store = function Store (options) {
  var this$1 = this;
  if ( options === void 0 ) options = {};

  // Auto install if it is not done yet and `window` has `Vue`.
  // To allow users to avoid auto-installation in some cases,
  // this code should be placed here. See #731
  if (!Vue && typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
  }

  if (false) {
    assert(Vue, "must call Vue.use(Vuex) before creating a store instance.");
    assert(typeof Promise !== 'undefined', "vuex requires a Promise polyfill in this browser.");
    assert(this instanceof Store, "Store must be called with the new operator.");
  }

  var plugins = options.plugins; if ( plugins === void 0 ) plugins = [];
  var strict = options.strict; if ( strict === void 0 ) strict = false;

  var state = options.state; if ( state === void 0 ) state = {};
  if (typeof state === 'function') {
    state = state() || {};
  }

  // store internal state
  this._committing = false;
  this._actions = Object.create(null);
  this._actionSubscribers = [];
  this._mutations = Object.create(null);
  this._wrappedGetters = Object.create(null);
  this._modules = new ModuleCollection(options);
  this._modulesNamespaceMap = Object.create(null);
  this._subscribers = [];
  this._watcherVM = new Vue();

  // bind commit and dispatch to self
  var store = this;
  var ref = this;
  var dispatch = ref.dispatch;
  var commit = ref.commit;
  this.dispatch = function boundDispatch (type, payload) {
    return dispatch.call(store, type, payload)
  };
  this.commit = function boundCommit (type, payload, options) {
    return commit.call(store, type, payload, options)
  };

  // strict mode
  this.strict = strict;

  // init root module.
  // this also recursively registers all sub-modules
  // and collects all module getters inside this._wrappedGetters
  installModule(this, state, [], this._modules.root);

  // initialize the store vm, which is responsible for the reactivity
  // (also registers _wrappedGetters as computed properties)
  resetStoreVM(this, state);

  // apply plugins
  plugins.forEach(function (plugin) { return plugin(this$1); });

  if (Vue.config.devtools) {
    devtoolPlugin(this);
  }
};

var prototypeAccessors = { state: { configurable: true } };

prototypeAccessors.state.get = function () {
  return this._vm._data.$$state
};

prototypeAccessors.state.set = function (v) {
  if (false) {
    assert(false, "Use store.replaceState() to explicit replace store state.");
  }
};

Store.prototype.commit = function commit (_type, _payload, _options) {
    var this$1 = this;

  // check object-style commit
  var ref = unifyObjectStyle(_type, _payload, _options);
    var type = ref.type;
    var payload = ref.payload;
    var options = ref.options;

  var mutation = { type: type, payload: payload };
  var entry = this._mutations[type];
  if (!entry) {
    if (false) {
      console.error(("[vuex] unknown mutation type: " + type));
    }
    return
  }
  this._withCommit(function () {
    entry.forEach(function commitIterator (handler) {
      handler(payload);
    });
  });
  this._subscribers.forEach(function (sub) { return sub(mutation, this$1.state); });

  if (
    false
  ) {
    console.warn(
      "[vuex] mutation type: " + type + ". Silent option has been removed. " +
      'Use the filter functionality in the vue-devtools'
    );
  }
};

Store.prototype.dispatch = function dispatch (_type, _payload) {
    var this$1 = this;

  // check object-style dispatch
  var ref = unifyObjectStyle(_type, _payload);
    var type = ref.type;
    var payload = ref.payload;

  var action = { type: type, payload: payload };
  var entry = this._actions[type];
  if (!entry) {
    if (false) {
      console.error(("[vuex] unknown action type: " + type));
    }
    return
  }

  this._actionSubscribers.forEach(function (sub) { return sub(action, this$1.state); });

  return entry.length > 1
    ? Promise.all(entry.map(function (handler) { return handler(payload); }))
    : entry[0](payload)
};

Store.prototype.subscribe = function subscribe (fn) {
  return genericSubscribe(fn, this._subscribers)
};

Store.prototype.subscribeAction = function subscribeAction (fn) {
  return genericSubscribe(fn, this._actionSubscribers)
};

Store.prototype.watch = function watch (getter, cb, options) {
    var this$1 = this;

  if (false) {
    assert(typeof getter === 'function', "store.watch only accepts a function.");
  }
  return this._watcherVM.$watch(function () { return getter(this$1.state, this$1.getters); }, cb, options)
};

Store.prototype.replaceState = function replaceState (state) {
    var this$1 = this;

  this._withCommit(function () {
    this$1._vm._data.$$state = state;
  });
};

Store.prototype.registerModule = function registerModule (path, rawModule, options) {
    if ( options === void 0 ) options = {};

  if (typeof path === 'string') { path = [path]; }

  if (false) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
    assert(path.length > 0, 'cannot register the root module by using registerModule.');
  }

  this._modules.register(path, rawModule);
  installModule(this, this.state, path, this._modules.get(path), options.preserveState);
  // reset store to update getters...
  resetStoreVM(this, this.state);
};

Store.prototype.unregisterModule = function unregisterModule (path) {
    var this$1 = this;

  if (typeof path === 'string') { path = [path]; }

  if (false) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
  }

  this._modules.unregister(path);
  this._withCommit(function () {
    var parentState = getNestedState(this$1.state, path.slice(0, -1));
    Vue.delete(parentState, path[path.length - 1]);
  });
  resetStore(this);
};

Store.prototype.hotUpdate = function hotUpdate (newOptions) {
  this._modules.update(newOptions);
  resetStore(this, true);
};

Store.prototype._withCommit = function _withCommit (fn) {
  var committing = this._committing;
  this._committing = true;
  fn();
  this._committing = committing;
};

Object.defineProperties( Store.prototype, prototypeAccessors );

function genericSubscribe (fn, subs) {
  if (subs.indexOf(fn) < 0) {
    subs.push(fn);
  }
  return function () {
    var i = subs.indexOf(fn);
    if (i > -1) {
      subs.splice(i, 1);
    }
  }
}

function resetStore (store, hot) {
  store._actions = Object.create(null);
  store._mutations = Object.create(null);
  store._wrappedGetters = Object.create(null);
  store._modulesNamespaceMap = Object.create(null);
  var state = store.state;
  // init all modules
  installModule(store, state, [], store._modules.root, true);
  // reset vm
  resetStoreVM(store, state, hot);
}

function resetStoreVM (store, state, hot) {
  var oldVm = store._vm;

  // bind store public getters
  store.getters = {};
  var wrappedGetters = store._wrappedGetters;
  var computed = {};
  forEachValue(wrappedGetters, function (fn, key) {
    // use computed to leverage its lazy-caching mechanism
    computed[key] = function () { return fn(store); };
    Object.defineProperty(store.getters, key, {
      get: function () { return store._vm[key]; },
      enumerable: true // for local getters
    });
  });

  // use a Vue instance to store the state tree
  // suppress warnings just in case the user has added
  // some funky global mixins
  var silent = Vue.config.silent;
  Vue.config.silent = true;
  store._vm = new Vue({
    data: {
      $$state: state
    },
    computed: computed
  });
  Vue.config.silent = silent;

  // enable strict mode for new vm
  if (store.strict) {
    enableStrictMode(store);
  }

  if (oldVm) {
    if (hot) {
      // dispatch changes in all subscribed watchers
      // to force getter re-evaluation for hot reloading.
      store._withCommit(function () {
        oldVm._data.$$state = null;
      });
    }
    Vue.nextTick(function () { return oldVm.$destroy(); });
  }
}

function installModule (store, rootState, path, module, hot) {
  var isRoot = !path.length;
  var namespace = store._modules.getNamespace(path);

  // register in namespace map
  if (module.namespaced) {
    store._modulesNamespaceMap[namespace] = module;
  }

  // set state
  if (!isRoot && !hot) {
    var parentState = getNestedState(rootState, path.slice(0, -1));
    var moduleName = path[path.length - 1];
    store._withCommit(function () {
      Vue.set(parentState, moduleName, module.state);
    });
  }

  var local = module.context = makeLocalContext(store, namespace, path);

  module.forEachMutation(function (mutation, key) {
    var namespacedType = namespace + key;
    registerMutation(store, namespacedType, mutation, local);
  });

  module.forEachAction(function (action, key) {
    var type = action.root ? key : namespace + key;
    var handler = action.handler || action;
    registerAction(store, type, handler, local);
  });

  module.forEachGetter(function (getter, key) {
    var namespacedType = namespace + key;
    registerGetter(store, namespacedType, getter, local);
  });

  module.forEachChild(function (child, key) {
    installModule(store, rootState, path.concat(key), child, hot);
  });
}

/**
 * make localized dispatch, commit, getters and state
 * if there is no namespace, just use root ones
 */
function makeLocalContext (store, namespace, path) {
  var noNamespace = namespace === '';

  var local = {
    dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error(("[vuex] unknown local action type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      return store.dispatch(type, payload)
    },

    commit: noNamespace ? store.commit : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error(("[vuex] unknown local mutation type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      store.commit(type, payload, options);
    }
  };

  // getters and state object must be gotten lazily
  // because they will be changed by vm update
  Object.defineProperties(local, {
    getters: {
      get: noNamespace
        ? function () { return store.getters; }
        : function () { return makeLocalGetters(store, namespace); }
    },
    state: {
      get: function () { return getNestedState(store.state, path); }
    }
  });

  return local
}

function makeLocalGetters (store, namespace) {
  var gettersProxy = {};

  var splitPos = namespace.length;
  Object.keys(store.getters).forEach(function (type) {
    // skip if the target getter is not match this namespace
    if (type.slice(0, splitPos) !== namespace) { return }

    // extract local getter type
    var localType = type.slice(splitPos);

    // Add a port to the getters proxy.
    // Define as getter property because
    // we do not want to evaluate the getters in this time.
    Object.defineProperty(gettersProxy, localType, {
      get: function () { return store.getters[type]; },
      enumerable: true
    });
  });

  return gettersProxy
}

function registerMutation (store, type, handler, local) {
  var entry = store._mutations[type] || (store._mutations[type] = []);
  entry.push(function wrappedMutationHandler (payload) {
    handler.call(store, local.state, payload);
  });
}

function registerAction (store, type, handler, local) {
  var entry = store._actions[type] || (store._actions[type] = []);
  entry.push(function wrappedActionHandler (payload, cb) {
    var res = handler.call(store, {
      dispatch: local.dispatch,
      commit: local.commit,
      getters: local.getters,
      state: local.state,
      rootGetters: store.getters,
      rootState: store.state
    }, payload, cb);
    if (!isPromise(res)) {
      res = Promise.resolve(res);
    }
    if (store._devtoolHook) {
      return res.catch(function (err) {
        store._devtoolHook.emit('vuex:error', err);
        throw err
      })
    } else {
      return res
    }
  });
}

function registerGetter (store, type, rawGetter, local) {
  if (store._wrappedGetters[type]) {
    if (false) {
      console.error(("[vuex] duplicate getter key: " + type));
    }
    return
  }
  store._wrappedGetters[type] = function wrappedGetter (store) {
    return rawGetter(
      local.state, // local state
      local.getters, // local getters
      store.state, // root state
      store.getters // root getters
    )
  };
}

function enableStrictMode (store) {
  store._vm.$watch(function () { return this._data.$$state }, function () {
    if (false) {
      assert(store._committing, "Do not mutate vuex store state outside mutation handlers.");
    }
  }, { deep: true, sync: true });
}

function getNestedState (state, path) {
  return path.length
    ? path.reduce(function (state, key) { return state[key]; }, state)
    : state
}

function unifyObjectStyle (type, payload, options) {
  if (isObject(type) && type.type) {
    options = payload;
    payload = type;
    type = type.type;
  }

  if (false) {
    assert(typeof type === 'string', ("Expects string as the type, but found " + (typeof type) + "."));
  }

  return { type: type, payload: payload, options: options }
}

function install (_Vue) {
  if (Vue && _Vue === Vue) {
    if (false) {
      console.error(
        '[vuex] already installed. Vue.use(Vuex) should be called only once.'
      );
    }
    return
  }
  Vue = _Vue;
  applyMixin(Vue);
}

var mapState = normalizeNamespace(function (namespace, states) {
  var res = {};
  normalizeMap(states).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedState () {
      var state = this.$store.state;
      var getters = this.$store.getters;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapState', namespace);
        if (!module) {
          return
        }
        state = module.context.state;
        getters = module.context.getters;
      }
      return typeof val === 'function'
        ? val.call(this, state, getters)
        : state[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

var mapMutations = normalizeNamespace(function (namespace, mutations) {
  var res = {};
  normalizeMap(mutations).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedMutation () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      var commit = this.$store.commit;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapMutations', namespace);
        if (!module) {
          return
        }
        commit = module.context.commit;
      }
      return typeof val === 'function'
        ? val.apply(this, [commit].concat(args))
        : commit.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

var mapGetters = normalizeNamespace(function (namespace, getters) {
  var res = {};
  normalizeMap(getters).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    val = namespace + val;
    res[key] = function mappedGetter () {
      if (namespace && !getModuleByNamespace(this.$store, 'mapGetters', namespace)) {
        return
      }
      if (false) {
        console.error(("[vuex] unknown getter: " + val));
        return
      }
      return this.$store.getters[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

var mapActions = normalizeNamespace(function (namespace, actions) {
  var res = {};
  normalizeMap(actions).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedAction () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      var dispatch = this.$store.dispatch;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapActions', namespace);
        if (!module) {
          return
        }
        dispatch = module.context.dispatch;
      }
      return typeof val === 'function'
        ? val.apply(this, [dispatch].concat(args))
        : dispatch.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

var createNamespacedHelpers = function (namespace) { return ({
  mapState: mapState.bind(null, namespace),
  mapGetters: mapGetters.bind(null, namespace),
  mapMutations: mapMutations.bind(null, namespace),
  mapActions: mapActions.bind(null, namespace)
}); };

function normalizeMap (map) {
  return Array.isArray(map)
    ? map.map(function (key) { return ({ key: key, val: key }); })
    : Object.keys(map).map(function (key) { return ({ key: key, val: map[key] }); })
}

function normalizeNamespace (fn) {
  return function (namespace, map) {
    if (typeof namespace !== 'string') {
      map = namespace;
      namespace = '';
    } else if (namespace.charAt(namespace.length - 1) !== '/') {
      namespace += '/';
    }
    return fn(namespace, map)
  }
}

function getModuleByNamespace (store, helper, namespace) {
  var module = store._modulesNamespaceMap[namespace];
  if (false) {
    console.error(("[vuex] module namespace not found in " + helper + "(): " + namespace));
  }
  return module
}

var index_esm = {
  Store: Store,
  install: install,
  version: '3.0.1',
  mapState: mapState,
  mapMutations: mapMutations,
  mapGetters: mapGetters,
  mapActions: mapActions,
  createNamespacedHelpers: createNamespacedHelpers
};


/* harmony default export */ __webpack_exports__["a"] = (index_esm);


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

/*!
 * XRegExp.build 4.1.1
 * <xregexp.com>
 * Steven Levithan (c) 2012-present MIT License
 */

exports.default = function (XRegExp) {
    var REGEX_DATA = 'xregexp';
    var subParts = /(\()(?!\?)|\\([1-9]\d*)|\\[\s\S]|\[(?:[^\\\]]|\\[\s\S])*\]/g;
    var parts = XRegExp.union([/\({{([\w$]+)}}\)|{{([\w$]+)}}/, subParts], 'g', {
        conjunction: 'or'
    });

    /**
     * Strips a leading `^` and trailing unescaped `$`, if both are present.
     *
     * @private
     * @param {String} pattern Pattern to process.
     * @returns {String} Pattern with edge anchors removed.
     */
    function deanchor(pattern) {
        // Allow any number of empty noncapturing groups before/after anchors, because regexes
        // built/generated by XRegExp sometimes include them
        var leadingAnchor = /^(?:\(\?:\))*\^/;
        var trailingAnchor = /\$(?:\(\?:\))*$/;

        if (leadingAnchor.test(pattern) && trailingAnchor.test(pattern) &&
        // Ensure that the trailing `$` isn't escaped
        trailingAnchor.test(pattern.replace(/\\[\s\S]/g, ''))) {
            return pattern.replace(leadingAnchor, '').replace(trailingAnchor, '');
        }

        return pattern;
    }

    /**
     * Converts the provided value to an XRegExp. Native RegExp flags are not preserved.
     *
     * @private
     * @param {String|RegExp} value Value to convert.
     * @param {Boolean} [addFlagX] Whether to apply the `x` flag in cases when `value` is not
     *   already a regex generated by XRegExp
     * @returns {RegExp} XRegExp object with XRegExp syntax applied.
     */
    function asXRegExp(value, addFlagX) {
        var flags = addFlagX ? 'x' : '';
        return XRegExp.isRegExp(value) ? value[REGEX_DATA] && value[REGEX_DATA].captureNames ?
        // Don't recompile, to preserve capture names
        value :
        // Recompile as XRegExp
        XRegExp(value.source, flags) :
        // Compile string as XRegExp
        XRegExp(value, flags);
    }

    function interpolate(substitution) {
        return substitution instanceof RegExp ? substitution : XRegExp.escape(substitution);
    }

    function reduceToSubpatternsObject(subpatterns, interpolated, subpatternIndex) {
        subpatterns['subpattern' + subpatternIndex] = interpolated;
        return subpatterns;
    }

    function embedSubpatternAfter(raw, subpatternIndex, rawLiterals) {
        var hasSubpattern = subpatternIndex < rawLiterals.length - 1;
        return raw + (hasSubpattern ? '{{subpattern' + subpatternIndex + '}}' : '');
    }

    /**
     * Provides tagged template literals that create regexes with XRegExp syntax and flags. The
     * provided pattern is handled as a raw string, so backslashes don't need to be escaped.
     *
     * Interpolation of strings and regexes shares the features of `XRegExp.build`. Interpolated
     * patterns are treated as atomic units when quantified, interpolated strings have their special
     * characters escaped, a leading `^` and trailing unescaped `$` are stripped from interpolated
     * regexes if both are present, and any backreferences within an interpolated regex are
     * rewritten to work within the overall pattern.
     *
     * @memberOf XRegExp
     * @param {String} [flags] Any combination of XRegExp flags.
     * @returns {Function} Handler for template literals that construct regexes with XRegExp syntax.
     * @example
     *
     * const h12 = /1[0-2]|0?[1-9]/;
     * const h24 = /2[0-3]|[01][0-9]/;
     * const hours = XRegExp.tag('x')`${h12} : | ${h24}`;
     * const minutes = /^[0-5][0-9]$/;
     * // Note that explicitly naming the 'minutes' group is required for named backreferences
     * const time = XRegExp.tag('x')`^ ${hours} (?<minutes>${minutes}) $`;
     * time.test('10:59'); // -> true
     * XRegExp.exec('10:59', time).minutes; // -> '59'
     */
    XRegExp.tag = function (flags) {
        return function (literals) {
            for (var _len = arguments.length, substitutions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                substitutions[_key - 1] = arguments[_key];
            }

            var subpatterns = substitutions.map(interpolate).reduce(reduceToSubpatternsObject, {});
            var pattern = literals.raw.map(embedSubpatternAfter).join('');
            return XRegExp.build(pattern, subpatterns, flags);
        };
    };

    /**
     * Builds regexes using named subpatterns, for readability and pattern reuse. Backreferences in
     * the outer pattern and provided subpatterns are automatically renumbered to work correctly.
     * Native flags used by provided subpatterns are ignored in favor of the `flags` argument.
     *
     * @memberOf XRegExp
     * @param {String} pattern XRegExp pattern using `{{name}}` for embedded subpatterns. Allows
     *   `({{name}})` as shorthand for `(?<name>{{name}})`. Patterns cannot be embedded within
     *   character classes.
     * @param {Object} subs Lookup object for named subpatterns. Values can be strings or regexes. A
     *   leading `^` and trailing unescaped `$` are stripped from subpatterns, if both are present.
     * @param {String} [flags] Any combination of XRegExp flags.
     * @returns {RegExp} Regex with interpolated subpatterns.
     * @example
     *
     * const time = XRegExp.build('(?x)^ {{hours}} ({{minutes}}) $', {
     *   hours: XRegExp.build('{{h12}} : | {{h24}}', {
     *     h12: /1[0-2]|0?[1-9]/,
     *     h24: /2[0-3]|[01][0-9]/
     *   }, 'x'),
     *   minutes: /^[0-5][0-9]$/
     * });
     * time.test('10:59'); // -> true
     * XRegExp.exec('10:59', time).minutes; // -> '59'
     */
    XRegExp.build = function (pattern, subs, flags) {
        flags = flags || '';
        // Used with `asXRegExp` calls for `pattern` and subpatterns in `subs`, to work around how
        // some browsers convert `RegExp('\n')` to a regex that contains the literal characters `\`
        // and `n`. See more details at <https://github.com/slevithan/xregexp/pull/163>.
        var addFlagX = flags.indexOf('x') !== -1;
        var inlineFlags = /^\(\?([\w$]+)\)/.exec(pattern);
        // Add flags within a leading mode modifier to the overall pattern's flags
        if (inlineFlags) {
            flags = XRegExp._clipDuplicates(flags + inlineFlags[1]);
        }

        var data = {};
        for (var p in subs) {
            if (subs.hasOwnProperty(p)) {
                // Passing to XRegExp enables extended syntax and ensures independent validity,
                // lest an unescaped `(`, `)`, `[`, or trailing `\` breaks the `(?:)` wrapper. For
                // subpatterns provided as native regexes, it dies on octals and adds the property
                // used to hold extended regex instance data, for simplicity.
                var sub = asXRegExp(subs[p], addFlagX);
                data[p] = {
                    // Deanchoring allows embedding independently useful anchored regexes. If you
                    // really need to keep your anchors, double them (i.e., `^^...$$`).
                    pattern: deanchor(sub.source),
                    names: sub[REGEX_DATA].captureNames || []
                };
            }
        }

        // Passing to XRegExp dies on octals and ensures the outer pattern is independently valid;
        // helps keep this simple. Named captures will be put back.
        var patternAsRegex = asXRegExp(pattern, addFlagX);

        // 'Caps' is short for 'captures'
        var numCaps = 0;
        var numPriorCaps = void 0;
        var numOuterCaps = 0;
        var outerCapsMap = [0];
        var outerCapNames = patternAsRegex[REGEX_DATA].captureNames || [];
        var output = patternAsRegex.source.replace(parts, function ($0, $1, $2, $3, $4) {
            var subName = $1 || $2;
            var capName = void 0;
            var intro = void 0;
            var localCapIndex = void 0;
            // Named subpattern
            if (subName) {
                if (!data.hasOwnProperty(subName)) {
                    throw new ReferenceError('Undefined property ' + $0);
                }
                // Named subpattern was wrapped in a capturing group
                if ($1) {
                    capName = outerCapNames[numOuterCaps];
                    outerCapsMap[++numOuterCaps] = ++numCaps;
                    // If it's a named group, preserve the name. Otherwise, use the subpattern name
                    // as the capture name
                    intro = '(?<' + (capName || subName) + '>';
                } else {
                    intro = '(?:';
                }
                numPriorCaps = numCaps;
                var rewrittenSubpattern = data[subName].pattern.replace(subParts, function (match, paren, backref) {
                    // Capturing group
                    if (paren) {
                        capName = data[subName].names[numCaps - numPriorCaps];
                        ++numCaps;
                        // If the current capture has a name, preserve the name
                        if (capName) {
                            return '(?<' + capName + '>';
                        }
                        // Backreference
                    } else if (backref) {
                        localCapIndex = +backref - 1;
                        // Rewrite the backreference
                        return data[subName].names[localCapIndex] ?
                        // Need to preserve the backreference name in case using flag `n`
                        '\\k<' + data[subName].names[localCapIndex] + '>' : '\\' + (+backref + numPriorCaps);
                    }
                    return match;
                });
                return '' + intro + rewrittenSubpattern + ')';
            }
            // Capturing group
            if ($3) {
                capName = outerCapNames[numOuterCaps];
                outerCapsMap[++numOuterCaps] = ++numCaps;
                // If the current capture has a name, preserve the name
                if (capName) {
                    return '(?<' + capName + '>';
                }
                // Backreference
            } else if ($4) {
                localCapIndex = +$4 - 1;
                // Rewrite the backreference
                return outerCapNames[localCapIndex] ?
                // Need to preserve the backreference name in case using flag `n`
                '\\k<' + outerCapNames[localCapIndex] + '>' : '\\' + outerCapsMap[+$4];
            }
            return $0;
        });

        return XRegExp(output, flags);
    };
};

module.exports = exports['default'];

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

/*!
 * XRegExp.matchRecursive 4.1.1
 * <xregexp.com>
 * Steven Levithan (c) 2009-present MIT License
 */

exports.default = function (XRegExp) {

    /**
     * Returns a match detail object composed of the provided values.
     *
     * @private
     */
    function row(name, value, start, end) {
        return {
            name: name,
            value: value,
            start: start,
            end: end
        };
    }

    /**
     * Returns an array of match strings between outermost left and right delimiters, or an array of
     * objects with detailed match parts and position data. An error is thrown if delimiters are
     * unbalanced within the data.
     *
     * @memberOf XRegExp
     * @param {String} str String to search.
     * @param {String} left Left delimiter as an XRegExp pattern.
     * @param {String} right Right delimiter as an XRegExp pattern.
     * @param {String} [flags] Any native or XRegExp flags, used for the left and right delimiters.
     * @param {Object} [options] Lets you specify `valueNames` and `escapeChar` options.
     * @returns {Array} Array of matches, or an empty array.
     * @example
     *
     * // Basic usage
     * let str = '(t((e))s)t()(ing)';
     * XRegExp.matchRecursive(str, '\\(', '\\)', 'g');
     * // -> ['t((e))s', '', 'ing']
     *
     * // Extended information mode with valueNames
     * str = 'Here is <div> <div>an</div></div> example';
     * XRegExp.matchRecursive(str, '<div\\s*>', '</div>', 'gi', {
     *   valueNames: ['between', 'left', 'match', 'right']
     * });
     * // -> [
     * // {name: 'between', value: 'Here is ',       start: 0,  end: 8},
     * // {name: 'left',    value: '<div>',          start: 8,  end: 13},
     * // {name: 'match',   value: ' <div>an</div>', start: 13, end: 27},
     * // {name: 'right',   value: '</div>',         start: 27, end: 33},
     * // {name: 'between', value: ' example',       start: 33, end: 41}
     * // ]
     *
     * // Omitting unneeded parts with null valueNames, and using escapeChar
     * str = '...{1}.\\{{function(x,y){return {y:x}}}';
     * XRegExp.matchRecursive(str, '{', '}', 'g', {
     *   valueNames: ['literal', null, 'value', null],
     *   escapeChar: '\\'
     * });
     * // -> [
     * // {name: 'literal', value: '...',  start: 0, end: 3},
     * // {name: 'value',   value: '1',    start: 4, end: 5},
     * // {name: 'literal', value: '.\\{', start: 6, end: 9},
     * // {name: 'value',   value: 'function(x,y){return {y:x}}', start: 10, end: 37}
     * // ]
     *
     * // Sticky mode via flag y
     * str = '<1><<<2>>><3>4<5>';
     * XRegExp.matchRecursive(str, '<', '>', 'gy');
     * // -> ['1', '<<2>>', '3']
     */
    XRegExp.matchRecursive = function (str, left, right, flags, options) {
        flags = flags || '';
        options = options || {};
        var global = flags.indexOf('g') !== -1;
        var sticky = flags.indexOf('y') !== -1;
        // Flag `y` is controlled internally
        var basicFlags = flags.replace(/y/g, '');
        var escapeChar = options.escapeChar;
        var vN = options.valueNames;
        var output = [];
        var openTokens = 0;
        var delimStart = 0;
        var delimEnd = 0;
        var lastOuterEnd = 0;
        var outerStart = void 0;
        var innerStart = void 0;
        var leftMatch = void 0;
        var rightMatch = void 0;
        var esc = void 0;
        left = XRegExp(left, basicFlags);
        right = XRegExp(right, basicFlags);

        if (escapeChar) {
            if (escapeChar.length > 1) {
                throw new Error('Cannot use more than one escape character');
            }
            escapeChar = XRegExp.escape(escapeChar);
            // Example of concatenated `esc` regex:
            // `escapeChar`: '%'
            // `left`: '<'
            // `right`: '>'
            // Regex is: /(?:%[\S\s]|(?:(?!<|>)[^%])+)+/
            esc = new RegExp('(?:' + escapeChar + '[\\S\\s]|(?:(?!' +
            // Using `XRegExp.union` safely rewrites backreferences in `left` and `right`.
            // Intentionally not passing `basicFlags` to `XRegExp.union` since any syntax
            // transformation resulting from those flags was already applied to `left` and
            // `right` when they were passed through the XRegExp constructor above.
            XRegExp.union([left, right], '', { conjunction: 'or' }).source + ')[^' + escapeChar + '])+)+',
            // Flags `gy` not needed here
            flags.replace(/[^imu]+/g, ''));
        }

        while (true) {
            // If using an escape character, advance to the delimiter's next starting position,
            // skipping any escaped characters in between
            if (escapeChar) {
                delimEnd += (XRegExp.exec(str, esc, delimEnd, 'sticky') || [''])[0].length;
            }
            leftMatch = XRegExp.exec(str, left, delimEnd);
            rightMatch = XRegExp.exec(str, right, delimEnd);
            // Keep the leftmost match only
            if (leftMatch && rightMatch) {
                if (leftMatch.index <= rightMatch.index) {
                    rightMatch = null;
                } else {
                    leftMatch = null;
                }
            }
            // Paths (LM: leftMatch, RM: rightMatch, OT: openTokens):
            // LM | RM | OT | Result
            // 1  | 0  | 1  | loop
            // 1  | 0  | 0  | loop
            // 0  | 1  | 1  | loop
            // 0  | 1  | 0  | throw
            // 0  | 0  | 1  | throw
            // 0  | 0  | 0  | break
            // The paths above don't include the sticky mode special case. The loop ends after the
            // first completed match if not `global`.
            if (leftMatch || rightMatch) {
                delimStart = (leftMatch || rightMatch).index;
                delimEnd = delimStart + (leftMatch || rightMatch)[0].length;
            } else if (!openTokens) {
                break;
            }
            if (sticky && !openTokens && delimStart > lastOuterEnd) {
                break;
            }
            if (leftMatch) {
                if (!openTokens) {
                    outerStart = delimStart;
                    innerStart = delimEnd;
                }
                ++openTokens;
            } else if (rightMatch && openTokens) {
                if (! --openTokens) {
                    if (vN) {
                        if (vN[0] && outerStart > lastOuterEnd) {
                            output.push(row(vN[0], str.slice(lastOuterEnd, outerStart), lastOuterEnd, outerStart));
                        }
                        if (vN[1]) {
                            output.push(row(vN[1], str.slice(outerStart, innerStart), outerStart, innerStart));
                        }
                        if (vN[2]) {
                            output.push(row(vN[2], str.slice(innerStart, delimStart), innerStart, delimStart));
                        }
                        if (vN[3]) {
                            output.push(row(vN[3], str.slice(delimStart, delimEnd), delimStart, delimEnd));
                        }
                    } else {
                        output.push(str.slice(innerStart, delimStart));
                    }
                    lastOuterEnd = delimEnd;
                    if (!global) {
                        break;
                    }
                }
            } else {
                throw new Error('Unbalanced delimiter found in string');
            }
            // If the delimiter matched an empty string, avoid an infinite loop
            if (delimStart === delimEnd) {
                ++delimEnd;
            }
        }

        if (global && !sticky && vN && vN[0] && str.length > lastOuterEnd) {
            output.push(row(vN[0], str.slice(lastOuterEnd), lastOuterEnd, str.length));
        }

        return output;
    };
};

module.exports = exports['default'];

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

/*!
 * XRegExp Unicode Base 4.1.1
 * <xregexp.com>
 * Steven Levithan (c) 2008-present MIT License
 */

exports.default = function (XRegExp) {

    /**
     * Adds base support for Unicode matching:
     * - Adds syntax `\p{..}` for matching Unicode tokens. Tokens can be inverted using `\P{..}` or
     *   `\p{^..}`. Token names ignore case, spaces, hyphens, and underscores. You can omit the
     *   braces for token names that are a single letter (e.g. `\pL` or `PL`).
     * - Adds flag A (astral), which enables 21-bit Unicode support.
     * - Adds the `XRegExp.addUnicodeData` method used by other addons to provide character data.
     *
     * Unicode Base relies on externally provided Unicode character data. Official addons are
     * available to provide data for Unicode categories, scripts, blocks, and properties.
     *
     * @requires XRegExp
     */

    // ==--------------------------==
    // Private stuff
    // ==--------------------------==

    // Storage for Unicode data
    var unicode = {};

    // Reuse utils
    var dec = XRegExp._dec;
    var hex = XRegExp._hex;
    var pad4 = XRegExp._pad4;

    // Generates a token lookup name: lowercase, with hyphens, spaces, and underscores removed
    function normalize(name) {
        return name.replace(/[- _]+/g, '').toLowerCase();
    }

    // Gets the decimal code of a literal code unit, \xHH, \uHHHH, or a backslash-escaped literal
    function charCode(chr) {
        var esc = /^\\[xu](.+)/.exec(chr);
        return esc ? dec(esc[1]) : chr.charCodeAt(chr[0] === '\\' ? 1 : 0);
    }

    // Inverts a list of ordered BMP characters and ranges
    function invertBmp(range) {
        var output = '';
        var lastEnd = -1;

        XRegExp.forEach(range, /(\\x..|\\u....|\\?[\s\S])(?:-(\\x..|\\u....|\\?[\s\S]))?/, function (m) {
            var start = charCode(m[1]);
            if (start > lastEnd + 1) {
                output += '\\u' + pad4(hex(lastEnd + 1));
                if (start > lastEnd + 2) {
                    output += '-\\u' + pad4(hex(start - 1));
                }
            }
            lastEnd = charCode(m[2] || m[1]);
        });

        if (lastEnd < 0xFFFF) {
            output += '\\u' + pad4(hex(lastEnd + 1));
            if (lastEnd < 0xFFFE) {
                output += '-\\uFFFF';
            }
        }

        return output;
    }

    // Generates an inverted BMP range on first use
    function cacheInvertedBmp(slug) {
        var prop = 'b!';
        return unicode[slug][prop] || (unicode[slug][prop] = invertBmp(unicode[slug].bmp));
    }

    // Combines and optionally negates BMP and astral data
    function buildAstral(slug, isNegated) {
        var item = unicode[slug];
        var combined = '';

        if (item.bmp && !item.isBmpLast) {
            combined = '[' + item.bmp + ']' + (item.astral ? '|' : '');
        }
        if (item.astral) {
            combined += item.astral;
        }
        if (item.isBmpLast && item.bmp) {
            combined += (item.astral ? '|' : '') + '[' + item.bmp + ']';
        }

        // Astral Unicode tokens always match a code point, never a code unit
        return isNegated ? '(?:(?!' + combined + ')(?:[\uD800-\uDBFF][\uDC00-\uDFFF]|[\0-\uFFFF]))' : '(?:' + combined + ')';
    }

    // Builds a complete astral pattern on first use
    function cacheAstral(slug, isNegated) {
        var prop = isNegated ? 'a!' : 'a=';
        return unicode[slug][prop] || (unicode[slug][prop] = buildAstral(slug, isNegated));
    }

    // ==--------------------------==
    // Core functionality
    // ==--------------------------==

    /*
     * Add astral mode (flag A) and Unicode token syntax: `\p{..}`, `\P{..}`, `\p{^..}`, `\pC`.
     */
    XRegExp.addToken(
    // Use `*` instead of `+` to avoid capturing `^` as the token name in `\p{^}`
    /\\([pP])(?:{(\^?)([^}]*)}|([A-Za-z]))/, function (match, scope, flags) {
        var ERR_DOUBLE_NEG = 'Invalid double negation ';
        var ERR_UNKNOWN_NAME = 'Unknown Unicode token ';
        var ERR_UNKNOWN_REF = 'Unicode token missing data ';
        var ERR_ASTRAL_ONLY = 'Astral mode required for Unicode token ';
        var ERR_ASTRAL_IN_CLASS = 'Astral mode does not support Unicode tokens within character classes';
        // Negated via \P{..} or \p{^..}
        var isNegated = match[1] === 'P' || !!match[2];
        // Switch from BMP (0-FFFF) to astral (0-10FFFF) mode via flag A
        var isAstralMode = flags.indexOf('A') !== -1;
        // Token lookup name. Check `[4]` first to avoid passing `undefined` via `\p{}`
        var slug = normalize(match[4] || match[3]);
        // Token data object
        var item = unicode[slug];

        if (match[1] === 'P' && match[2]) {
            throw new SyntaxError(ERR_DOUBLE_NEG + match[0]);
        }
        if (!unicode.hasOwnProperty(slug)) {
            throw new SyntaxError(ERR_UNKNOWN_NAME + match[0]);
        }

        // Switch to the negated form of the referenced Unicode token
        if (item.inverseOf) {
            slug = normalize(item.inverseOf);
            if (!unicode.hasOwnProperty(slug)) {
                throw new ReferenceError(ERR_UNKNOWN_REF + match[0] + ' -> ' + item.inverseOf);
            }
            item = unicode[slug];
            isNegated = !isNegated;
        }

        if (!(item.bmp || isAstralMode)) {
            throw new SyntaxError(ERR_ASTRAL_ONLY + match[0]);
        }
        if (isAstralMode) {
            if (scope === 'class') {
                throw new SyntaxError(ERR_ASTRAL_IN_CLASS);
            }

            return cacheAstral(slug, isNegated);
        }

        return scope === 'class' ? isNegated ? cacheInvertedBmp(slug) : item.bmp : (isNegated ? '[^' : '[') + item.bmp + ']';
    }, {
        scope: 'all',
        optionalFlags: 'A',
        leadChar: '\\'
    });

    /**
     * Adds to the list of Unicode tokens that XRegExp regexes can match via `\p` or `\P`.
     *
     * @memberOf XRegExp
     * @param {Array} data Objects with named character ranges. Each object may have properties
     *   `name`, `alias`, `isBmpLast`, `inverseOf`, `bmp`, and `astral`. All but `name` are
     *   optional, although one of `bmp` or `astral` is required (unless `inverseOf` is set). If
     *   `astral` is absent, the `bmp` data is used for BMP and astral modes. If `bmp` is absent,
     *   the name errors in BMP mode but works in astral mode. If both `bmp` and `astral` are
     *   provided, the `bmp` data only is used in BMP mode, and the combination of `bmp` and
     *   `astral` data is used in astral mode. `isBmpLast` is needed when a token matches orphan
     *   high surrogates *and* uses surrogate pairs to match astral code points. The `bmp` and
     *   `astral` data should be a combination of literal characters and `\xHH` or `\uHHHH` escape
     *   sequences, with hyphens to create ranges. Any regex metacharacters in the data should be
     *   escaped, apart from range-creating hyphens. The `astral` data can additionally use
     *   character classes and alternation, and should use surrogate pairs to represent astral code
     *   points. `inverseOf` can be used to avoid duplicating character data if a Unicode token is
     *   defined as the exact inverse of another token.
     * @example
     *
     * // Basic use
     * XRegExp.addUnicodeData([{
     *   name: 'XDigit',
     *   alias: 'Hexadecimal',
     *   bmp: '0-9A-Fa-f'
     * }]);
     * XRegExp('\\p{XDigit}:\\p{Hexadecimal}+').test('0:3D'); // -> true
     */
    XRegExp.addUnicodeData = function (data) {
        var ERR_NO_NAME = 'Unicode token requires name';
        var ERR_NO_DATA = 'Unicode token has no character data ';
        var item = void 0;

        for (var i = 0; i < data.length; ++i) {
            item = data[i];
            if (!item.name) {
                throw new Error(ERR_NO_NAME);
            }
            if (!(item.inverseOf || item.bmp || item.astral)) {
                throw new Error(ERR_NO_DATA + item.name);
            }
            unicode[normalize(item.name)] = item;
            if (item.alias) {
                unicode[normalize(item.alias)] = item;
            }
        }

        // Reset the pattern cache used by the `XRegExp` constructor, since the same pattern and
        // flags might now produce different results
        XRegExp.cache.flush('patterns');
    };

    /**
     * @ignore
     *
     * Return a reference to the internal Unicode definition structure for the given Unicode
     * Property if the given name is a legal Unicode Property for use in XRegExp `\p` or `\P` regex
     * constructs.
     *
     * @memberOf XRegExp
     * @param {String} name Name by which the Unicode Property may be recognized (case-insensitive),
     *   e.g. `'N'` or `'Number'`. The given name is matched against all registered Unicode
     *   Properties and Property Aliases.
     * @returns {Object} Reference to definition structure when the name matches a Unicode Property.
     *
     * @note
     * For more info on Unicode Properties, see also http://unicode.org/reports/tr18/#Categories.
     *
     * @note
     * This method is *not* part of the officially documented API and may change or be removed in
     * the future. It is meant for userland code that wishes to reuse the (large) internal Unicode
     * structures set up by XRegExp.
     */
    XRegExp._getUnicodeProperty = function (name) {
        var slug = normalize(name);
        return unicode[slug];
    };
};

module.exports = exports['default'];

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _blocks = __webpack_require__(96);

var _blocks2 = _interopRequireDefault(_blocks);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (XRegExp) {

  /**
   * Adds support for all Unicode blocks. Block names use the prefix 'In'. E.g.,
   * `\p{InBasicLatin}`. Token names are case insensitive, and any spaces, hyphens, and
   * underscores are ignored.
   *
   * Uses Unicode 10.0.0.
   *
   * @requires XRegExp, Unicode Base
   */

  if (!XRegExp.addUnicodeData) {
    throw new ReferenceError('Unicode Base must be loaded before Unicode Blocks');
  }

  XRegExp.addUnicodeData(_blocks2.default);
}; /*!
    * XRegExp Unicode Blocks 4.1.1
    * <xregexp.com>
    * Steven Levithan (c) 2010-present MIT License
    * Unicode data by Mathias Bynens <mathiasbynens.be>
    */

module.exports = exports['default'];

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _categories = __webpack_require__(97);

var _categories2 = _interopRequireDefault(_categories);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (XRegExp) {

  /**
   * Adds support for Unicode's general categories. E.g., `\p{Lu}` or `\p{Uppercase Letter}`. See
   * category descriptions in UAX #44 <http://unicode.org/reports/tr44/#GC_Values_Table>. Token
   * names are case insensitive, and any spaces, hyphens, and underscores are ignored.
   *
   * Uses Unicode 10.0.0.
   *
   * @requires XRegExp, Unicode Base
   */

  if (!XRegExp.addUnicodeData) {
    throw new ReferenceError('Unicode Base must be loaded before Unicode Categories');
  }

  XRegExp.addUnicodeData(_categories2.default);
}; /*!
    * XRegExp Unicode Categories 4.1.1
    * <xregexp.com>
    * Steven Levithan (c) 2010-present MIT License
    * Unicode data by Mathias Bynens <mathiasbynens.be>
    */

module.exports = exports['default'];

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _properties = __webpack_require__(98);

var _properties2 = _interopRequireDefault(_properties);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (XRegExp) {

    /**
     * Adds properties to meet the UTS #18 Level 1 RL1.2 requirements for Unicode regex support. See
     * <http://unicode.org/reports/tr18/#RL1.2>. Following are definitions of these properties from
     * UAX #44 <http://unicode.org/reports/tr44/>:
     *
     * - Alphabetic
     *   Characters with the Alphabetic property. Generated from: Lowercase + Uppercase + Lt + Lm +
     *   Lo + Nl + Other_Alphabetic.
     *
     * - Default_Ignorable_Code_Point
     *   For programmatic determination of default ignorable code points. New characters that should
     *   be ignored in rendering (unless explicitly supported) will be assigned in these ranges,
     *   permitting programs to correctly handle the default rendering of such characters when not
     *   otherwise supported.
     *
     * - Lowercase
     *   Characters with the Lowercase property. Generated from: Ll + Other_Lowercase.
     *
     * - Noncharacter_Code_Point
     *   Code points permanently reserved for internal use.
     *
     * - Uppercase
     *   Characters with the Uppercase property. Generated from: Lu + Other_Uppercase.
     *
     * - White_Space
     *   Spaces, separator characters and other control characters which should be treated by
     *   programming languages as "white space" for the purpose of parsing elements.
     *
     * The properties ASCII, Any, and Assigned are also included but are not defined in UAX #44. UTS
     * #18 RL1.2 additionally requires support for Unicode scripts and general categories. These are
     * included in XRegExp's Unicode Categories and Unicode Scripts addons.
     *
     * Token names are case insensitive, and any spaces, hyphens, and underscores are ignored.
     *
     * Uses Unicode 10.0.0.
     *
     * @requires XRegExp, Unicode Base
     */

    if (!XRegExp.addUnicodeData) {
        throw new ReferenceError('Unicode Base must be loaded before Unicode Properties');
    }

    var unicodeData = _properties2.default;

    // Add non-generated data
    unicodeData.push({
        name: 'Assigned',
        // Since this is defined as the inverse of Unicode category Cn (Unassigned), the Unicode
        // Categories addon is required to use this property
        inverseOf: 'Cn'
    });

    XRegExp.addUnicodeData(unicodeData);
}; /*!
    * XRegExp Unicode Properties 4.1.1
    * <xregexp.com>
    * Steven Levithan (c) 2012-present MIT License
    * Unicode data by Mathias Bynens <mathiasbynens.be>
    */

module.exports = exports['default'];

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _scripts = __webpack_require__(99);

var _scripts2 = _interopRequireDefault(_scripts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (XRegExp) {

  /**
   * Adds support for all Unicode scripts. E.g., `\p{Latin}`. Token names are case insensitive,
   * and any spaces, hyphens, and underscores are ignored.
   *
   * Uses Unicode 10.0.0.
   *
   * @requires XRegExp, Unicode Base
   */

  if (!XRegExp.addUnicodeData) {
    throw new ReferenceError('Unicode Base must be loaded before Unicode Scripts');
  }

  XRegExp.addUnicodeData(_scripts2.default);
}; /*!
    * XRegExp Unicode Scripts 4.1.1
    * <xregexp.com>
    * Steven Levithan (c) 2010-present MIT License
    * Unicode data by Mathias Bynens <mathiasbynens.be>
    */

module.exports = exports['default'];

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/*!
 * XRegExp 4.1.1
 * <xregexp.com>
 * Steven Levithan (c) 2007-present MIT License
 */

/**
 * XRegExp provides augmented, extensible regular expressions. You get additional regex syntax and
 * flags, beyond what browsers support natively. XRegExp is also a regex utility belt with tools to
 * make your client-side grepping simpler and more powerful, while freeing you from related
 * cross-browser inconsistencies.
 */

// ==--------------------------==
// Private stuff
// ==--------------------------==

// Property name used for extended regex instance data
var REGEX_DATA = 'xregexp';
// Optional features that can be installed and uninstalled
var features = {
    astral: false,
    namespacing: false
};
// Native methods to use and restore ('native' is an ES3 reserved keyword)
var nativ = {
    exec: RegExp.prototype.exec,
    test: RegExp.prototype.test,
    match: String.prototype.match,
    replace: String.prototype.replace,
    split: String.prototype.split
};
// Storage for fixed/extended native methods
var fixed = {};
// Storage for regexes cached by `XRegExp.cache`
var regexCache = {};
// Storage for pattern details cached by the `XRegExp` constructor
var patternCache = {};
// Storage for regex syntax tokens added internally or by `XRegExp.addToken`
var tokens = [];
// Token scopes
var defaultScope = 'default';
var classScope = 'class';
// Regexes that match native regex syntax, including octals
var nativeTokens = {
    // Any native multicharacter token in default scope, or any single character
    'default': /\\(?:0(?:[0-3][0-7]{0,2}|[4-7][0-7]?)?|[1-9]\d*|x[\dA-Fa-f]{2}|u(?:[\dA-Fa-f]{4}|{[\dA-Fa-f]+})|c[A-Za-z]|[\s\S])|\(\?(?:[:=!]|<[=!])|[?*+]\?|{\d+(?:,\d*)?}\??|[\s\S]/,
    // Any native multicharacter token in character class scope, or any single character
    'class': /\\(?:[0-3][0-7]{0,2}|[4-7][0-7]?|x[\dA-Fa-f]{2}|u(?:[\dA-Fa-f]{4}|{[\dA-Fa-f]+})|c[A-Za-z]|[\s\S])|[\s\S]/
};
// Any backreference or dollar-prefixed character in replacement strings
var replacementToken = /\$(?:{([\w$]+)}|<([\w$]+)>|(\d\d?|[\s\S]))/g;
// Check for correct `exec` handling of nonparticipating capturing groups
var correctExecNpcg = nativ.exec.call(/()??/, '')[1] === undefined;
// Check for ES6 `flags` prop support
var hasFlagsProp = /x/.flags !== undefined;
// Shortcut to `Object.prototype.toString`
var toString = {}.toString;

function hasNativeFlag(flag) {
    // Can't check based on the presence of properties/getters since browsers might support such
    // properties even when they don't support the corresponding flag in regex construction (tested
    // in Chrome 48, where `'unicode' in /x/` is true but trying to construct a regex with flag `u`
    // throws an error)
    var isSupported = true;
    try {
        // Can't use regex literals for testing even in a `try` because regex literals with
        // unsupported flags cause a compilation error in IE
        new RegExp('', flag);
    } catch (exception) {
        isSupported = false;
    }
    return isSupported;
}
// Check for ES6 `u` flag support
var hasNativeU = hasNativeFlag('u');
// Check for ES6 `y` flag support
var hasNativeY = hasNativeFlag('y');
// Tracker for known flags, including addon flags
var registeredFlags = {
    g: true,
    i: true,
    m: true,
    u: hasNativeU,
    y: hasNativeY
};

/**
 * Attaches extended data and `XRegExp.prototype` properties to a regex object.
 *
 * @private
 * @param {RegExp} regex Regex to augment.
 * @param {Array} captureNames Array with capture names, or `null`.
 * @param {String} xSource XRegExp pattern used to generate `regex`, or `null` if N/A.
 * @param {String} xFlags XRegExp flags used to generate `regex`, or `null` if N/A.
 * @param {Boolean} [isInternalOnly=false] Whether the regex will be used only for internal
 *   operations, and never exposed to users. For internal-only regexes, we can improve perf by
 *   skipping some operations like attaching `XRegExp.prototype` properties.
 * @returns {RegExp} Augmented regex.
 */
function augment(regex, captureNames, xSource, xFlags, isInternalOnly) {
    var p = void 0;

    regex[REGEX_DATA] = {
        captureNames: captureNames
    };

    if (isInternalOnly) {
        return regex;
    }

    // Can't auto-inherit these since the XRegExp constructor returns a nonprimitive value
    if (regex.__proto__) {
        regex.__proto__ = XRegExp.prototype;
    } else {
        for (p in XRegExp.prototype) {
            // An `XRegExp.prototype.hasOwnProperty(p)` check wouldn't be worth it here, since this
            // is performance sensitive, and enumerable `Object.prototype` or `RegExp.prototype`
            // extensions exist on `regex.prototype` anyway
            regex[p] = XRegExp.prototype[p];
        }
    }

    regex[REGEX_DATA].source = xSource;
    // Emulate the ES6 `flags` prop by ensuring flags are in alphabetical order
    regex[REGEX_DATA].flags = xFlags ? xFlags.split('').sort().join('') : xFlags;

    return regex;
}

/**
 * Removes any duplicate characters from the provided string.
 *
 * @private
 * @param {String} str String to remove duplicate characters from.
 * @returns {String} String with any duplicate characters removed.
 */
function clipDuplicates(str) {
    return nativ.replace.call(str, /([\s\S])(?=[\s\S]*\1)/g, '');
}

/**
 * Copies a regex object while preserving extended data and augmenting with `XRegExp.prototype`
 * properties. The copy has a fresh `lastIndex` property (set to zero). Allows adding and removing
 * flags g and y while copying the regex.
 *
 * @private
 * @param {RegExp} regex Regex to copy.
 * @param {Object} [options] Options object with optional properties:
 *   - `addG` {Boolean} Add flag g while copying the regex.
 *   - `addY` {Boolean} Add flag y while copying the regex.
 *   - `removeG` {Boolean} Remove flag g while copying the regex.
 *   - `removeY` {Boolean} Remove flag y while copying the regex.
 *   - `isInternalOnly` {Boolean} Whether the copied regex will be used only for internal
 *     operations, and never exposed to users. For internal-only regexes, we can improve perf by
 *     skipping some operations like attaching `XRegExp.prototype` properties.
 *   - `source` {String} Overrides `<regex>.source`, for special cases.
 * @returns {RegExp} Copy of the provided regex, possibly with modified flags.
 */
function copyRegex(regex, options) {
    if (!XRegExp.isRegExp(regex)) {
        throw new TypeError('Type RegExp expected');
    }

    var xData = regex[REGEX_DATA] || {};
    var flags = getNativeFlags(regex);
    var flagsToAdd = '';
    var flagsToRemove = '';
    var xregexpSource = null;
    var xregexpFlags = null;

    options = options || {};

    if (options.removeG) {
        flagsToRemove += 'g';
    }
    if (options.removeY) {
        flagsToRemove += 'y';
    }
    if (flagsToRemove) {
        flags = nativ.replace.call(flags, new RegExp('[' + flagsToRemove + ']+', 'g'), '');
    }

    if (options.addG) {
        flagsToAdd += 'g';
    }
    if (options.addY) {
        flagsToAdd += 'y';
    }
    if (flagsToAdd) {
        flags = clipDuplicates(flags + flagsToAdd);
    }

    if (!options.isInternalOnly) {
        if (xData.source !== undefined) {
            xregexpSource = xData.source;
        }
        // null or undefined; don't want to add to `flags` if the previous value was null, since
        // that indicates we're not tracking original precompilation flags
        if (xData.flags != null) {
            // Flags are only added for non-internal regexes by `XRegExp.globalize`. Flags are never
            // removed for non-internal regexes, so don't need to handle it
            xregexpFlags = flagsToAdd ? clipDuplicates(xData.flags + flagsToAdd) : xData.flags;
        }
    }

    // Augment with `XRegExp.prototype` properties, but use the native `RegExp` constructor to avoid
    // searching for special tokens. That would be wrong for regexes constructed by `RegExp`, and
    // unnecessary for regexes constructed by `XRegExp` because the regex has already undergone the
    // translation to native regex syntax
    regex = augment(new RegExp(options.source || regex.source, flags), hasNamedCapture(regex) ? xData.captureNames.slice(0) : null, xregexpSource, xregexpFlags, options.isInternalOnly);

    return regex;
}

/**
 * Converts hexadecimal to decimal.
 *
 * @private
 * @param {String} hex
 * @returns {Number}
 */
function dec(hex) {
    return parseInt(hex, 16);
}

/**
 * Returns a pattern that can be used in a native RegExp in place of an ignorable token such as an
 * inline comment or whitespace with flag x. This is used directly as a token handler function
 * passed to `XRegExp.addToken`.
 *
 * @private
 * @param {String} match Match arg of `XRegExp.addToken` handler
 * @param {String} scope Scope arg of `XRegExp.addToken` handler
 * @param {String} flags Flags arg of `XRegExp.addToken` handler
 * @returns {String} Either '' or '(?:)', depending on which is needed in the context of the match.
 */
function getContextualTokenSeparator(match, scope, flags) {
    if (
    // No need to separate tokens if at the beginning or end of a group
    match.input[match.index - 1] === '(' || match.input[match.index + match[0].length] === ')' ||

    // No need to separate tokens if before or after a `|`
    match.input[match.index - 1] === '|' || match.input[match.index + match[0].length] === '|' ||

    // No need to separate tokens if at the beginning or end of the pattern
    match.index < 1 || match.index + match[0].length >= match.input.length ||

    // No need to separate tokens if at the beginning of a noncapturing group or lookahead.
    // The way this is written relies on:
    // - The search regex matching only 3-char strings.
    // - Although `substr` gives chars from the end of the string if given a negative index,
    //   the resulting substring will be too short to match. Ex: `'abcd'.substr(-1, 3) === 'd'`
    nativ.test.call(/^\(\?[:=!]/, match.input.substr(match.index - 3, 3)) ||

    // Avoid separating tokens when the following token is a quantifier
    isQuantifierNext(match.input, match.index + match[0].length, flags)) {
        return '';
    }
    // Keep tokens separated. This avoids e.g. inadvertedly changing `\1 1` or `\1(?#)1` to `\11`.
    // This also ensures all tokens remain as discrete atoms, e.g. it avoids converting the syntax
    // error `(? :` into `(?:`.
    return '(?:)';
}

/**
 * Returns native `RegExp` flags used by a regex object.
 *
 * @private
 * @param {RegExp} regex Regex to check.
 * @returns {String} Native flags in use.
 */
function getNativeFlags(regex) {
    return hasFlagsProp ? regex.flags :
    // Explicitly using `RegExp.prototype.toString` (rather than e.g. `String` or concatenation
    // with an empty string) allows this to continue working predictably when
    // `XRegExp.proptotype.toString` is overridden
    nativ.exec.call(/\/([a-z]*)$/i, RegExp.prototype.toString.call(regex))[1];
}

/**
 * Determines whether a regex has extended instance data used to track capture names.
 *
 * @private
 * @param {RegExp} regex Regex to check.
 * @returns {Boolean} Whether the regex uses named capture.
 */
function hasNamedCapture(regex) {
    return !!(regex[REGEX_DATA] && regex[REGEX_DATA].captureNames);
}

/**
 * Converts decimal to hexadecimal.
 *
 * @private
 * @param {Number|String} dec
 * @returns {String}
 */
function hex(dec) {
    return parseInt(dec, 10).toString(16);
}

/**
 * Checks whether the next nonignorable token after the specified position is a quantifier.
 *
 * @private
 * @param {String} pattern Pattern to search within.
 * @param {Number} pos Index in `pattern` to search at.
 * @param {String} flags Flags used by the pattern.
 * @returns {Boolean} Whether the next nonignorable token is a quantifier.
 */
function isQuantifierNext(pattern, pos, flags) {
    var inlineCommentPattern = '\\(\\?#[^)]*\\)';
    var lineCommentPattern = '#[^#\\n]*';
    var quantifierPattern = '[?*+]|{\\d+(?:,\\d*)?}';
    return nativ.test.call(flags.indexOf('x') !== -1 ?
    // Ignore any leading whitespace, line comments, and inline comments
    /^(?:\s|#[^#\n]*|\(\?#[^)]*\))*(?:[?*+]|{\d+(?:,\d*)?})/ :
    // Ignore any leading inline comments
    /^(?:\(\?#[^)]*\))*(?:[?*+]|{\d+(?:,\d*)?})/, pattern.slice(pos));
}

/**
 * Determines whether a value is of the specified type, by resolving its internal [[Class]].
 *
 * @private
 * @param {*} value Object to check.
 * @param {String} type Type to check for, in TitleCase.
 * @returns {Boolean} Whether the object matches the type.
 */
function isType(value, type) {
    return toString.call(value) === '[object ' + type + ']';
}

/**
 * Adds leading zeros if shorter than four characters. Used for fixed-length hexadecimal values.
 *
 * @private
 * @param {String} str
 * @returns {String}
 */
function pad4(str) {
    while (str.length < 4) {
        str = '0' + str;
    }
    return str;
}

/**
 * Checks for flag-related errors, and strips/applies flags in a leading mode modifier. Offloads
 * the flag preparation logic from the `XRegExp` constructor.
 *
 * @private
 * @param {String} pattern Regex pattern, possibly with a leading mode modifier.
 * @param {String} flags Any combination of flags.
 * @returns {Object} Object with properties `pattern` and `flags`.
 */
function prepareFlags(pattern, flags) {
    var i = void 0;

    // Recent browsers throw on duplicate flags, so copy this behavior for nonnative flags
    if (clipDuplicates(flags) !== flags) {
        throw new SyntaxError('Invalid duplicate regex flag ' + flags);
    }

    // Strip and apply a leading mode modifier with any combination of flags except g or y
    pattern = nativ.replace.call(pattern, /^\(\?([\w$]+)\)/, function ($0, $1) {
        if (nativ.test.call(/[gy]/, $1)) {
            throw new SyntaxError('Cannot use flag g or y in mode modifier ' + $0);
        }
        // Allow duplicate flags within the mode modifier
        flags = clipDuplicates(flags + $1);
        return '';
    });

    // Throw on unknown native or nonnative flags
    for (i = 0; i < flags.length; ++i) {
        if (!registeredFlags[flags[i]]) {
            throw new SyntaxError('Unknown regex flag ' + flags[i]);
        }
    }

    return {
        pattern: pattern,
        flags: flags
    };
}

/**
 * Prepares an options object from the given value.
 *
 * @private
 * @param {String|Object} value Value to convert to an options object.
 * @returns {Object} Options object.
 */
function prepareOptions(value) {
    var options = {};

    if (isType(value, 'String')) {
        XRegExp.forEach(value, /[^\s,]+/, function (match) {
            options[match] = true;
        });

        return options;
    }

    return value;
}

/**
 * Registers a flag so it doesn't throw an 'unknown flag' error.
 *
 * @private
 * @param {String} flag Single-character flag to register.
 */
function registerFlag(flag) {
    if (!/^[\w$]$/.test(flag)) {
        throw new Error('Flag must be a single character A-Za-z0-9_$');
    }

    registeredFlags[flag] = true;
}

/**
 * Runs built-in and custom regex syntax tokens in reverse insertion order at the specified
 * position, until a match is found.
 *
 * @private
 * @param {String} pattern Original pattern from which an XRegExp object is being built.
 * @param {String} flags Flags being used to construct the regex.
 * @param {Number} pos Position to search for tokens within `pattern`.
 * @param {Number} scope Regex scope to apply: 'default' or 'class'.
 * @param {Object} context Context object to use for token handler functions.
 * @returns {Object} Object with properties `matchLength`, `output`, and `reparse`; or `null`.
 */
function runTokens(pattern, flags, pos, scope, context) {
    var i = tokens.length;
    var leadChar = pattern[pos];
    var result = null;
    var match = void 0;
    var t = void 0;

    // Run in reverse insertion order
    while (i--) {
        t = tokens[i];
        if (t.leadChar && t.leadChar !== leadChar || t.scope !== scope && t.scope !== 'all' || t.flag && !(flags.indexOf(t.flag) !== -1)) {
            continue;
        }

        match = XRegExp.exec(pattern, t.regex, pos, 'sticky');
        if (match) {
            result = {
                matchLength: match[0].length,
                output: t.handler.call(context, match, scope, flags),
                reparse: t.reparse
            };
            // Finished with token tests
            break;
        }
    }

    return result;
}

/**
 * Enables or disables implicit astral mode opt-in. When enabled, flag A is automatically added to
 * all new regexes created by XRegExp. This causes an error to be thrown when creating regexes if
 * the Unicode Base addon is not available, since flag A is registered by that addon.
 *
 * @private
 * @param {Boolean} on `true` to enable; `false` to disable.
 */
function setAstral(on) {
    features.astral = on;
}

/**
 * Adds named capture groups to the `groups` property of match arrays. See here for details:
 * https://github.com/tc39/proposal-regexp-named-groups
 *
 * @private
 * @param {Boolean} on `true` to enable; `false` to disable.
 */
function setNamespacing(on) {
    features.namespacing = on;
}

/**
 * Returns the object, or throws an error if it is `null` or `undefined`. This is used to follow
 * the ES5 abstract operation `ToObject`.
 *
 * @private
 * @param {*} value Object to check and return.
 * @returns {*} The provided object.
 */
function toObject(value) {
    // null or undefined
    if (value == null) {
        throw new TypeError('Cannot convert null or undefined to object');
    }

    return value;
}

// ==--------------------------==
// Constructor
// ==--------------------------==

/**
 * Creates an extended regular expression object for matching text with a pattern. Differs from a
 * native regular expression in that additional syntax and flags are supported. The returned object
 * is in fact a native `RegExp` and works with all native methods.
 *
 * @class XRegExp
 * @constructor
 * @param {String|RegExp} pattern Regex pattern string, or an existing regex object to copy.
 * @param {String} [flags] Any combination of flags.
 *   Native flags:
 *     - `g` - global
 *     - `i` - ignore case
 *     - `m` - multiline anchors
 *     - `u` - unicode (ES6)
 *     - `y` - sticky (Firefox 3+, ES6)
 *   Additional XRegExp flags:
 *     - `n` - explicit capture
 *     - `s` - dot matches all (aka singleline)
 *     - `x` - free-spacing and line comments (aka extended)
 *     - `A` - astral (requires the Unicode Base addon)
 *   Flags cannot be provided when constructing one `RegExp` from another.
 * @returns {RegExp} Extended regular expression object.
 * @example
 *
 * // With named capture and flag x
 * XRegExp(`(?<year>  [0-9]{4} ) -?  # year
 *          (?<month> [0-9]{2} ) -?  # month
 *          (?<day>   [0-9]{2} )     # day`, 'x');
 *
 * // Providing a regex object copies it. Native regexes are recompiled using native (not XRegExp)
 * // syntax. Copies maintain extended data, are augmented with `XRegExp.prototype` properties, and
 * // have fresh `lastIndex` properties (set to zero).
 * XRegExp(/regex/);
 */
function XRegExp(pattern, flags) {
    if (XRegExp.isRegExp(pattern)) {
        if (flags !== undefined) {
            throw new TypeError('Cannot supply flags when copying a RegExp');
        }
        return copyRegex(pattern);
    }

    // Copy the argument behavior of `RegExp`
    pattern = pattern === undefined ? '' : String(pattern);
    flags = flags === undefined ? '' : String(flags);

    if (XRegExp.isInstalled('astral') && !(flags.indexOf('A') !== -1)) {
        // This causes an error to be thrown if the Unicode Base addon is not available
        flags += 'A';
    }

    if (!patternCache[pattern]) {
        patternCache[pattern] = {};
    }

    if (!patternCache[pattern][flags]) {
        var context = {
            hasNamedCapture: false,
            captureNames: []
        };
        var scope = defaultScope;
        var output = '';
        var pos = 0;
        var result = void 0;

        // Check for flag-related errors, and strip/apply flags in a leading mode modifier
        var applied = prepareFlags(pattern, flags);
        var appliedPattern = applied.pattern;
        var appliedFlags = applied.flags;

        // Use XRegExp's tokens to translate the pattern to a native regex pattern.
        // `appliedPattern.length` may change on each iteration if tokens use `reparse`
        while (pos < appliedPattern.length) {
            do {
                // Check for custom tokens at the current position
                result = runTokens(appliedPattern, appliedFlags, pos, scope, context);
                // If the matched token used the `reparse` option, splice its output into the
                // pattern before running tokens again at the same position
                if (result && result.reparse) {
                    appliedPattern = appliedPattern.slice(0, pos) + result.output + appliedPattern.slice(pos + result.matchLength);
                }
            } while (result && result.reparse);

            if (result) {
                output += result.output;
                pos += result.matchLength || 1;
            } else {
                // Get the native token at the current position
                var token = XRegExp.exec(appliedPattern, nativeTokens[scope], pos, 'sticky')[0];
                output += token;
                pos += token.length;
                if (token === '[' && scope === defaultScope) {
                    scope = classScope;
                } else if (token === ']' && scope === classScope) {
                    scope = defaultScope;
                }
            }
        }

        patternCache[pattern][flags] = {
            // Use basic cleanup to collapse repeated empty groups like `(?:)(?:)` to `(?:)`. Empty
            // groups are sometimes inserted during regex transpilation in order to keep tokens
            // separated. However, more than one empty group in a row is never needed.
            pattern: nativ.replace.call(output, /(?:\(\?:\))+/g, '(?:)'),
            // Strip all but native flags
            flags: nativ.replace.call(appliedFlags, /[^gimuy]+/g, ''),
            // `context.captureNames` has an item for each capturing group, even if unnamed
            captures: context.hasNamedCapture ? context.captureNames : null
        };
    }

    var generated = patternCache[pattern][flags];
    return augment(new RegExp(generated.pattern, generated.flags), generated.captures, pattern, flags);
}

// Add `RegExp.prototype` to the prototype chain
XRegExp.prototype = /(?:)/;

// ==--------------------------==
// Public properties
// ==--------------------------==

/**
 * The XRegExp version number as a string containing three dot-separated parts. For example,
 * '2.0.0-beta-3'.
 *
 * @static
 * @memberOf XRegExp
 * @type String
 */
XRegExp.version = '4.1.1';

// ==--------------------------==
// Public methods
// ==--------------------------==

// Intentionally undocumented; used in tests and addons
XRegExp._clipDuplicates = clipDuplicates;
XRegExp._hasNativeFlag = hasNativeFlag;
XRegExp._dec = dec;
XRegExp._hex = hex;
XRegExp._pad4 = pad4;

/**
 * Extends XRegExp syntax and allows custom flags. This is used internally and can be used to
 * create XRegExp addons. If more than one token can match the same string, the last added wins.
 *
 * @memberOf XRegExp
 * @param {RegExp} regex Regex object that matches the new token.
 * @param {Function} handler Function that returns a new pattern string (using native regex syntax)
 *   to replace the matched token within all future XRegExp regexes. Has access to persistent
 *   properties of the regex being built, through `this`. Invoked with three arguments:
 *   - The match array, with named backreference properties.
 *   - The regex scope where the match was found: 'default' or 'class'.
 *   - The flags used by the regex, including any flags in a leading mode modifier.
 *   The handler function becomes part of the XRegExp construction process, so be careful not to
 *   construct XRegExps within the function or you will trigger infinite recursion.
 * @param {Object} [options] Options object with optional properties:
 *   - `scope` {String} Scope where the token applies: 'default', 'class', or 'all'.
 *   - `flag` {String} Single-character flag that triggers the token. This also registers the
 *     flag, which prevents XRegExp from throwing an 'unknown flag' error when the flag is used.
 *   - `optionalFlags` {String} Any custom flags checked for within the token `handler` that are
 *     not required to trigger the token. This registers the flags, to prevent XRegExp from
 *     throwing an 'unknown flag' error when any of the flags are used.
 *   - `reparse` {Boolean} Whether the `handler` function's output should not be treated as
 *     final, and instead be reparseable by other tokens (including the current token). Allows
 *     token chaining or deferring.
 *   - `leadChar` {String} Single character that occurs at the beginning of any successful match
 *     of the token (not always applicable). This doesn't change the behavior of the token unless
 *     you provide an erroneous value. However, providing it can increase the token's performance
 *     since the token can be skipped at any positions where this character doesn't appear.
 * @example
 *
 * // Basic usage: Add \a for the ALERT control code
 * XRegExp.addToken(
 *   /\\a/,
 *   () => '\\x07',
 *   {scope: 'all'}
 * );
 * XRegExp('\\a[\\a-\\n]+').test('\x07\n\x07'); // -> true
 *
 * // Add the U (ungreedy) flag from PCRE and RE2, which reverses greedy and lazy quantifiers.
 * // Since `scope` is not specified, it uses 'default' (i.e., transformations apply outside of
 * // character classes only)
 * XRegExp.addToken(
 *   /([?*+]|{\d+(?:,\d*)?})(\??)/,
 *   (match) => `${match[1]}${match[2] ? '' : '?'}`,
 *   {flag: 'U'}
 * );
 * XRegExp('a+', 'U').exec('aaa')[0]; // -> 'a'
 * XRegExp('a+?', 'U').exec('aaa')[0]; // -> 'aaa'
 */
XRegExp.addToken = function (regex, handler, options) {
    options = options || {};
    var optionalFlags = options.optionalFlags;
    var i = void 0;

    if (options.flag) {
        registerFlag(options.flag);
    }

    if (optionalFlags) {
        optionalFlags = nativ.split.call(optionalFlags, '');
        for (i = 0; i < optionalFlags.length; ++i) {
            registerFlag(optionalFlags[i]);
        }
    }

    // Add to the private list of syntax tokens
    tokens.push({
        regex: copyRegex(regex, {
            addG: true,
            addY: hasNativeY,
            isInternalOnly: true
        }),
        handler: handler,
        scope: options.scope || defaultScope,
        flag: options.flag,
        reparse: options.reparse,
        leadChar: options.leadChar
    });

    // Reset the pattern cache used by the `XRegExp` constructor, since the same pattern and flags
    // might now produce different results
    XRegExp.cache.flush('patterns');
};

/**
 * Caches and returns the result of calling `XRegExp(pattern, flags)`. On any subsequent call with
 * the same pattern and flag combination, the cached copy of the regex is returned.
 *
 * @memberOf XRegExp
 * @param {String} pattern Regex pattern string.
 * @param {String} [flags] Any combination of XRegExp flags.
 * @returns {RegExp} Cached XRegExp object.
 * @example
 *
 * while (match = XRegExp.cache('.', 'gs').exec(str)) {
 *   // The regex is compiled once only
 * }
 */
XRegExp.cache = function (pattern, flags) {
    if (!regexCache[pattern]) {
        regexCache[pattern] = {};
    }
    return regexCache[pattern][flags] || (regexCache[pattern][flags] = XRegExp(pattern, flags));
};

// Intentionally undocumented; used in tests
XRegExp.cache.flush = function (cacheName) {
    if (cacheName === 'patterns') {
        // Flush the pattern cache used by the `XRegExp` constructor
        patternCache = {};
    } else {
        // Flush the regex cache populated by `XRegExp.cache`
        regexCache = {};
    }
};

/**
 * Escapes any regular expression metacharacters, for use when matching literal strings. The result
 * can safely be used at any point within a regex that uses any flags.
 *
 * @memberOf XRegExp
 * @param {String} str String to escape.
 * @returns {String} String with regex metacharacters escaped.
 * @example
 *
 * XRegExp.escape('Escaped? <.>');
 * // -> 'Escaped\?\ <\.>'
 */
XRegExp.escape = function (str) {
    return nativ.replace.call(toObject(str), /[-\[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
};

/**
 * Executes a regex search in a specified string. Returns a match array or `null`. If the provided
 * regex uses named capture, named backreference properties are included on the match array.
 * Optional `pos` and `sticky` arguments specify the search start position, and whether the match
 * must start at the specified position only. The `lastIndex` property of the provided regex is not
 * used, but is updated for compatibility. Also fixes browser bugs compared to the native
 * `RegExp.prototype.exec` and can be used reliably cross-browser.
 *
 * @memberOf XRegExp
 * @param {String} str String to search.
 * @param {RegExp} regex Regex to search with.
 * @param {Number} [pos=0] Zero-based index at which to start the search.
 * @param {Boolean|String} [sticky=false] Whether the match must start at the specified position
 *   only. The string `'sticky'` is accepted as an alternative to `true`.
 * @returns {Array} Match array with named backreference properties, or `null`.
 * @example
 *
 * // Basic use, with named backreference
 * let match = XRegExp.exec('U+2620', XRegExp('U\\+(?<hex>[0-9A-F]{4})'));
 * match.hex; // -> '2620'
 *
 * // With pos and sticky, in a loop
 * let pos = 2, result = [], match;
 * while (match = XRegExp.exec('<1><2><3><4>5<6>', /<(\d)>/, pos, 'sticky')) {
 *   result.push(match[1]);
 *   pos = match.index + match[0].length;
 * }
 * // result -> ['2', '3', '4']
 */
XRegExp.exec = function (str, regex, pos, sticky) {
    var cacheKey = 'g';
    var addY = false;
    var fakeY = false;
    var match = void 0;

    addY = hasNativeY && !!(sticky || regex.sticky && sticky !== false);
    if (addY) {
        cacheKey += 'y';
    } else if (sticky) {
        // Simulate sticky matching by appending an empty capture to the original regex. The
        // resulting regex will succeed no matter what at the current index (set with `lastIndex`),
        // and will not search the rest of the subject string. We'll know that the original regex
        // has failed if that last capture is `''` rather than `undefined` (i.e., if that last
        // capture participated in the match).
        fakeY = true;
        cacheKey += 'FakeY';
    }

    regex[REGEX_DATA] = regex[REGEX_DATA] || {};

    // Shares cached copies with `XRegExp.match`/`replace`
    var r2 = regex[REGEX_DATA][cacheKey] || (regex[REGEX_DATA][cacheKey] = copyRegex(regex, {
        addG: true,
        addY: addY,
        source: fakeY ? regex.source + '|()' : undefined,
        removeY: sticky === false,
        isInternalOnly: true
    }));

    pos = pos || 0;
    r2.lastIndex = pos;

    // Fixed `exec` required for `lastIndex` fix, named backreferences, etc.
    match = fixed.exec.call(r2, str);

    // Get rid of the capture added by the pseudo-sticky matcher if needed. An empty string means
    // the original regexp failed (see above).
    if (fakeY && match && match.pop() === '') {
        match = null;
    }

    if (regex.global) {
        regex.lastIndex = match ? r2.lastIndex : 0;
    }

    return match;
};

/**
 * Executes a provided function once per regex match. Searches always start at the beginning of the
 * string and continue until the end, regardless of the state of the regex's `global` property and
 * initial `lastIndex`.
 *
 * @memberOf XRegExp
 * @param {String} str String to search.
 * @param {RegExp} regex Regex to search with.
 * @param {Function} callback Function to execute for each match. Invoked with four arguments:
 *   - The match array, with named backreference properties.
 *   - The zero-based match index.
 *   - The string being traversed.
 *   - The regex object being used to traverse the string.
 * @example
 *
 * // Extracts every other digit from a string
 * const evens = [];
 * XRegExp.forEach('1a2345', /\d/, (match, i) => {
 *   if (i % 2) evens.push(+match[0]);
 * });
 * // evens -> [2, 4]
 */
XRegExp.forEach = function (str, regex, callback) {
    var pos = 0;
    var i = -1;
    var match = void 0;

    while (match = XRegExp.exec(str, regex, pos)) {
        // Because `regex` is provided to `callback`, the function could use the deprecated/
        // nonstandard `RegExp.prototype.compile` to mutate the regex. However, since `XRegExp.exec`
        // doesn't use `lastIndex` to set the search position, this can't lead to an infinite loop,
        // at least. Actually, because of the way `XRegExp.exec` caches globalized versions of
        // regexes, mutating the regex will not have any effect on the iteration or matched strings,
        // which is a nice side effect that brings extra safety.
        callback(match, ++i, str, regex);

        pos = match.index + (match[0].length || 1);
    }
};

/**
 * Copies a regex object and adds flag `g`. The copy maintains extended data, is augmented with
 * `XRegExp.prototype` properties, and has a fresh `lastIndex` property (set to zero). Native
 * regexes are not recompiled using XRegExp syntax.
 *
 * @memberOf XRegExp
 * @param {RegExp} regex Regex to globalize.
 * @returns {RegExp} Copy of the provided regex with flag `g` added.
 * @example
 *
 * const globalCopy = XRegExp.globalize(/regex/);
 * globalCopy.global; // -> true
 */
XRegExp.globalize = function (regex) {
    return copyRegex(regex, { addG: true });
};

/**
 * Installs optional features according to the specified options. Can be undone using
 * `XRegExp.uninstall`.
 *
 * @memberOf XRegExp
 * @param {Object|String} options Options object or string.
 * @example
 *
 * // With an options object
 * XRegExp.install({
 *   // Enables support for astral code points in Unicode addons (implicitly sets flag A)
 *   astral: true,
 *
 *   // Adds named capture groups to the `groups` property of matches
 *   namespacing: true
 * });
 *
 * // With an options string
 * XRegExp.install('astral namespacing');
 */
XRegExp.install = function (options) {
    options = prepareOptions(options);

    if (!features.astral && options.astral) {
        setAstral(true);
    }

    if (!features.namespacing && options.namespacing) {
        setNamespacing(true);
    }
};

/**
 * Checks whether an individual optional feature is installed.
 *
 * @memberOf XRegExp
 * @param {String} feature Name of the feature to check. One of:
 *   - `astral`
 *   - `namespacing`
 * @returns {Boolean} Whether the feature is installed.
 * @example
 *
 * XRegExp.isInstalled('astral');
 */
XRegExp.isInstalled = function (feature) {
    return !!features[feature];
};

/**
 * Returns `true` if an object is a regex; `false` if it isn't. This works correctly for regexes
 * created in another frame, when `instanceof` and `constructor` checks would fail.
 *
 * @memberOf XRegExp
 * @param {*} value Object to check.
 * @returns {Boolean} Whether the object is a `RegExp` object.
 * @example
 *
 * XRegExp.isRegExp('string'); // -> false
 * XRegExp.isRegExp(/regex/i); // -> true
 * XRegExp.isRegExp(RegExp('^', 'm')); // -> true
 * XRegExp.isRegExp(XRegExp('(?s).')); // -> true
 */
XRegExp.isRegExp = function (value) {
    return toString.call(value) === '[object RegExp]';
}; // isType(value, 'RegExp');

/**
 * Returns the first matched string, or in global mode, an array containing all matched strings.
 * This is essentially a more convenient re-implementation of `String.prototype.match` that gives
 * the result types you actually want (string instead of `exec`-style array in match-first mode,
 * and an empty array instead of `null` when no matches are found in match-all mode). It also lets
 * you override flag g and ignore `lastIndex`, and fixes browser bugs.
 *
 * @memberOf XRegExp
 * @param {String} str String to search.
 * @param {RegExp} regex Regex to search with.
 * @param {String} [scope='one'] Use 'one' to return the first match as a string. Use 'all' to
 *   return an array of all matched strings. If not explicitly specified and `regex` uses flag g,
 *   `scope` is 'all'.
 * @returns {String|Array} In match-first mode: First match as a string, or `null`. In match-all
 *   mode: Array of all matched strings, or an empty array.
 * @example
 *
 * // Match first
 * XRegExp.match('abc', /\w/); // -> 'a'
 * XRegExp.match('abc', /\w/g, 'one'); // -> 'a'
 * XRegExp.match('abc', /x/g, 'one'); // -> null
 *
 * // Match all
 * XRegExp.match('abc', /\w/g); // -> ['a', 'b', 'c']
 * XRegExp.match('abc', /\w/, 'all'); // -> ['a', 'b', 'c']
 * XRegExp.match('abc', /x/, 'all'); // -> []
 */
XRegExp.match = function (str, regex, scope) {
    var global = regex.global && scope !== 'one' || scope === 'all';
    var cacheKey = (global ? 'g' : '') + (regex.sticky ? 'y' : '') || 'noGY';

    regex[REGEX_DATA] = regex[REGEX_DATA] || {};

    // Shares cached copies with `XRegExp.exec`/`replace`
    var r2 = regex[REGEX_DATA][cacheKey] || (regex[REGEX_DATA][cacheKey] = copyRegex(regex, {
        addG: !!global,
        removeG: scope === 'one',
        isInternalOnly: true
    }));

    var result = nativ.match.call(toObject(str), r2);

    if (regex.global) {
        regex.lastIndex = scope === 'one' && result ?
        // Can't use `r2.lastIndex` since `r2` is nonglobal in this case
        result.index + result[0].length : 0;
    }

    return global ? result || [] : result && result[0];
};

/**
 * Retrieves the matches from searching a string using a chain of regexes that successively search
 * within previous matches. The provided `chain` array can contain regexes and or objects with
 * `regex` and `backref` properties. When a backreference is specified, the named or numbered
 * backreference is passed forward to the next regex or returned.
 *
 * @memberOf XRegExp
 * @param {String} str String to search.
 * @param {Array} chain Regexes that each search for matches within preceding results.
 * @returns {Array} Matches by the last regex in the chain, or an empty array.
 * @example
 *
 * // Basic usage; matches numbers within <b> tags
 * XRegExp.matchChain('1 <b>2</b> 3 <b>4 a 56</b>', [
 *   XRegExp('(?is)<b>.*?</b>'),
 *   /\d+/
 * ]);
 * // -> ['2', '4', '56']
 *
 * // Passing forward and returning specific backreferences
 * html = '<a href="http://xregexp.com/api/">XRegExp</a>\
 *         <a href="http://www.google.com/">Google</a>';
 * XRegExp.matchChain(html, [
 *   {regex: /<a href="([^"]+)">/i, backref: 1},
 *   {regex: XRegExp('(?i)^https?://(?<domain>[^/?#]+)'), backref: 'domain'}
 * ]);
 * // -> ['xregexp.com', 'www.google.com']
 */
XRegExp.matchChain = function (str, chain) {
    return function recurseChain(values, level) {
        var item = chain[level].regex ? chain[level] : { regex: chain[level] };
        var matches = [];

        function addMatch(match) {
            if (item.backref) {
                var ERR_UNDEFINED_GROUP = 'Backreference to undefined group: ' + item.backref;
                var isNamedBackref = isNaN(item.backref);

                if (isNamedBackref && XRegExp.isInstalled('namespacing')) {
                    // `groups` has `null` as prototype, so using `in` instead of `hasOwnProperty`
                    if (!(item.backref in match.groups)) {
                        throw new ReferenceError(ERR_UNDEFINED_GROUP);
                    }
                } else if (!match.hasOwnProperty(item.backref)) {
                    throw new ReferenceError(ERR_UNDEFINED_GROUP);
                }

                var backrefValue = isNamedBackref && XRegExp.isInstalled('namespacing') ? match.groups[item.backref] : match[item.backref];

                matches.push(backrefValue || '');
            } else {
                matches.push(match[0]);
            }
        }

        for (var i = 0; i < values.length; ++i) {
            XRegExp.forEach(values[i], item.regex, addMatch);
        }

        return level === chain.length - 1 || !matches.length ? matches : recurseChain(matches, level + 1);
    }([str], 0);
};

/**
 * Returns a new string with one or all matches of a pattern replaced. The pattern can be a string
 * or regex, and the replacement can be a string or a function to be called for each match. To
 * perform a global search and replace, use the optional `scope` argument or include flag g if using
 * a regex. Replacement strings can use `${n}` or `$<n>` for named and numbered backreferences.
 * Replacement functions can use named backreferences via `arguments[0].name`. Also fixes browser
 * bugs compared to the native `String.prototype.replace` and can be used reliably cross-browser.
 *
 * @memberOf XRegExp
 * @param {String} str String to search.
 * @param {RegExp|String} search Search pattern to be replaced.
 * @param {String|Function} replacement Replacement string or a function invoked to create it.
 *   Replacement strings can include special replacement syntax:
 *     - $$ - Inserts a literal $ character.
 *     - $&, $0 - Inserts the matched substring.
 *     - $` - Inserts the string that precedes the matched substring (left context).
 *     - $' - Inserts the string that follows the matched substring (right context).
 *     - $n, $nn - Where n/nn are digits referencing an existent capturing group, inserts
 *       backreference n/nn.
 *     - ${n}, $<n> - Where n is a name or any number of digits that reference an existent capturing
 *       group, inserts backreference n.
 *   Replacement functions are invoked with three or more arguments:
 *     - The matched substring (corresponds to $& above). Named backreferences are accessible as
 *       properties of this first argument.
 *     - 0..n arguments, one for each backreference (corresponding to $1, $2, etc. above).
 *     - The zero-based index of the match within the total search string.
 *     - The total string being searched.
 * @param {String} [scope='one'] Use 'one' to replace the first match only, or 'all'. If not
 *   explicitly specified and using a regex with flag g, `scope` is 'all'.
 * @returns {String} New string with one or all matches replaced.
 * @example
 *
 * // Regex search, using named backreferences in replacement string
 * const name = XRegExp('(?<first>\\w+) (?<last>\\w+)');
 * XRegExp.replace('John Smith', name, '$<last>, $<first>');
 * // -> 'Smith, John'
 *
 * // Regex search, using named backreferences in replacement function
 * XRegExp.replace('John Smith', name, (match) => `${match.last}, ${match.first}`);
 * // -> 'Smith, John'
 *
 * // String search, with replace-all
 * XRegExp.replace('RegExp builds RegExps', 'RegExp', 'XRegExp', 'all');
 * // -> 'XRegExp builds XRegExps'
 */
XRegExp.replace = function (str, search, replacement, scope) {
    var isRegex = XRegExp.isRegExp(search);
    var global = search.global && scope !== 'one' || scope === 'all';
    var cacheKey = (global ? 'g' : '') + (search.sticky ? 'y' : '') || 'noGY';
    var s2 = search;

    if (isRegex) {
        search[REGEX_DATA] = search[REGEX_DATA] || {};

        // Shares cached copies with `XRegExp.exec`/`match`. Since a copy is used, `search`'s
        // `lastIndex` isn't updated *during* replacement iterations
        s2 = search[REGEX_DATA][cacheKey] || (search[REGEX_DATA][cacheKey] = copyRegex(search, {
            addG: !!global,
            removeG: scope === 'one',
            isInternalOnly: true
        }));
    } else if (global) {
        s2 = new RegExp(XRegExp.escape(String(search)), 'g');
    }

    // Fixed `replace` required for named backreferences, etc.
    var result = fixed.replace.call(toObject(str), s2, replacement);

    if (isRegex && search.global) {
        // Fixes IE, Safari bug (last tested IE 9, Safari 5.1)
        search.lastIndex = 0;
    }

    return result;
};

/**
 * Performs batch processing of string replacements. Used like `XRegExp.replace`, but accepts an
 * array of replacement details. Later replacements operate on the output of earlier replacements.
 * Replacement details are accepted as an array with a regex or string to search for, the
 * replacement string or function, and an optional scope of 'one' or 'all'. Uses the XRegExp
 * replacement text syntax, which supports named backreference properties via `${name}` or
 * `$<name>`.
 *
 * @memberOf XRegExp
 * @param {String} str String to search.
 * @param {Array} replacements Array of replacement detail arrays.
 * @returns {String} New string with all replacements.
 * @example
 *
 * str = XRegExp.replaceEach(str, [
 *   [XRegExp('(?<name>a)'), 'z${name}'],
 *   [/b/gi, 'y'],
 *   [/c/g, 'x', 'one'], // scope 'one' overrides /g
 *   [/d/, 'w', 'all'],  // scope 'all' overrides lack of /g
 *   ['e', 'v', 'all'],  // scope 'all' allows replace-all for strings
 *   [/f/g, ($0) => $0.toUpperCase()]
 * ]);
 */
XRegExp.replaceEach = function (str, replacements) {
    var i = void 0;
    var r = void 0;

    for (i = 0; i < replacements.length; ++i) {
        r = replacements[i];
        str = XRegExp.replace(str, r[0], r[1], r[2]);
    }

    return str;
};

/**
 * Splits a string into an array of strings using a regex or string separator. Matches of the
 * separator are not included in the result array. However, if `separator` is a regex that contains
 * capturing groups, backreferences are spliced into the result each time `separator` is matched.
 * Fixes browser bugs compared to the native `String.prototype.split` and can be used reliably
 * cross-browser.
 *
 * @memberOf XRegExp
 * @param {String} str String to split.
 * @param {RegExp|String} separator Regex or string to use for separating the string.
 * @param {Number} [limit] Maximum number of items to include in the result array.
 * @returns {Array} Array of substrings.
 * @example
 *
 * // Basic use
 * XRegExp.split('a b c', ' ');
 * // -> ['a', 'b', 'c']
 *
 * // With limit
 * XRegExp.split('a b c', ' ', 2);
 * // -> ['a', 'b']
 *
 * // Backreferences in result array
 * XRegExp.split('..word1..', /([a-z]+)(\d+)/i);
 * // -> ['..', 'word', '1', '..']
 */
XRegExp.split = function (str, separator, limit) {
    return fixed.split.call(toObject(str), separator, limit);
};

/**
 * Executes a regex search in a specified string. Returns `true` or `false`. Optional `pos` and
 * `sticky` arguments specify the search start position, and whether the match must start at the
 * specified position only. The `lastIndex` property of the provided regex is not used, but is
 * updated for compatibility. Also fixes browser bugs compared to the native
 * `RegExp.prototype.test` and can be used reliably cross-browser.
 *
 * @memberOf XRegExp
 * @param {String} str String to search.
 * @param {RegExp} regex Regex to search with.
 * @param {Number} [pos=0] Zero-based index at which to start the search.
 * @param {Boolean|String} [sticky=false] Whether the match must start at the specified position
 *   only. The string `'sticky'` is accepted as an alternative to `true`.
 * @returns {Boolean} Whether the regex matched the provided value.
 * @example
 *
 * // Basic use
 * XRegExp.test('abc', /c/); // -> true
 *
 * // With pos and sticky
 * XRegExp.test('abc', /c/, 0, 'sticky'); // -> false
 * XRegExp.test('abc', /c/, 2, 'sticky'); // -> true
 */
// Do this the easy way :-)
XRegExp.test = function (str, regex, pos, sticky) {
    return !!XRegExp.exec(str, regex, pos, sticky);
};

/**
 * Uninstalls optional features according to the specified options. All optional features start out
 * uninstalled, so this is used to undo the actions of `XRegExp.install`.
 *
 * @memberOf XRegExp
 * @param {Object|String} options Options object or string.
 * @example
 *
 * // With an options object
 * XRegExp.uninstall({
 *   // Disables support for astral code points in Unicode addons
 *   astral: true,
 *
 *   // Don't add named capture groups to the `groups` property of matches
 *   namespacing: true
 * });
 *
 * // With an options string
 * XRegExp.uninstall('astral namespacing');
 */
XRegExp.uninstall = function (options) {
    options = prepareOptions(options);

    if (features.astral && options.astral) {
        setAstral(false);
    }

    if (features.namespacing && options.namespacing) {
        setNamespacing(false);
    }
};

/**
 * Returns an XRegExp object that is the union of the given patterns. Patterns can be provided as
 * regex objects or strings. Metacharacters are escaped in patterns provided as strings.
 * Backreferences in provided regex objects are automatically renumbered to work correctly within
 * the larger combined pattern. Native flags used by provided regexes are ignored in favor of the
 * `flags` argument.
 *
 * @memberOf XRegExp
 * @param {Array} patterns Regexes and strings to combine.
 * @param {String} [flags] Any combination of XRegExp flags.
 * @param {Object} [options] Options object with optional properties:
 *   - `conjunction` {String} Type of conjunction to use: 'or' (default) or 'none'.
 * @returns {RegExp} Union of the provided regexes and strings.
 * @example
 *
 * XRegExp.union(['a+b*c', /(dogs)\1/, /(cats)\1/], 'i');
 * // -> /a\+b\*c|(dogs)\1|(cats)\2/i
 *
 * XRegExp.union([/man/, /bear/, /pig/], 'i', {conjunction: 'none'});
 * // -> /manbearpig/i
 */
XRegExp.union = function (patterns, flags, options) {
    options = options || {};
    var conjunction = options.conjunction || 'or';
    var numCaptures = 0;
    var numPriorCaptures = void 0;
    var captureNames = void 0;

    function rewrite(match, paren, backref) {
        var name = captureNames[numCaptures - numPriorCaptures];

        // Capturing group
        if (paren) {
            ++numCaptures;
            // If the current capture has a name, preserve the name
            if (name) {
                return '(?<' + name + '>';
            }
            // Backreference
        } else if (backref) {
            // Rewrite the backreference
            return '\\' + (+backref + numPriorCaptures);
        }

        return match;
    }

    if (!(isType(patterns, 'Array') && patterns.length)) {
        throw new TypeError('Must provide a nonempty array of patterns to merge');
    }

    var parts = /(\()(?!\?)|\\([1-9]\d*)|\\[\s\S]|\[(?:[^\\\]]|\\[\s\S])*\]/g;
    var output = [];
    var pattern = void 0;
    for (var i = 0; i < patterns.length; ++i) {
        pattern = patterns[i];

        if (XRegExp.isRegExp(pattern)) {
            numPriorCaptures = numCaptures;
            captureNames = pattern[REGEX_DATA] && pattern[REGEX_DATA].captureNames || [];

            // Rewrite backreferences. Passing to XRegExp dies on octals and ensures patterns are
            // independently valid; helps keep this simple. Named captures are put back
            output.push(nativ.replace.call(XRegExp(pattern.source).source, parts, rewrite));
        } else {
            output.push(XRegExp.escape(pattern));
        }
    }

    var separator = conjunction === 'none' ? '' : '|';
    return XRegExp(output.join(separator), flags);
};

// ==--------------------------==
// Fixed/extended native methods
// ==--------------------------==

/**
 * Adds named capture support (with backreferences returned as `result.name`), and fixes browser
 * bugs in the native `RegExp.prototype.exec`. Use via `XRegExp.exec`.
 *
 * @memberOf RegExp
 * @param {String} str String to search.
 * @returns {Array} Match array with named backreference properties, or `null`.
 */
fixed.exec = function (str) {
    var origLastIndex = this.lastIndex;
    var match = nativ.exec.apply(this, arguments);

    if (match) {
        // Fix browsers whose `exec` methods don't return `undefined` for nonparticipating capturing
        // groups. This fixes IE 5.5-8, but not IE 9's quirks mode or emulation of older IEs. IE 9
        // in standards mode follows the spec.
        if (!correctExecNpcg && match.length > 1 && match.indexOf('') !== -1) {
            var r2 = copyRegex(this, {
                removeG: true,
                isInternalOnly: true
            });
            // Using `str.slice(match.index)` rather than `match[0]` in case lookahead allowed
            // matching due to characters outside the match
            nativ.replace.call(String(str).slice(match.index), r2, function () {
                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                }

                var len = args.length;
                // Skip index 0 and the last 2
                for (var i = 1; i < len - 2; ++i) {
                    if (args[i] === undefined) {
                        match[i] = undefined;
                    }
                }
            });
        }

        // Attach named capture properties
        var groupsObject = match;
        if (XRegExp.isInstalled('namespacing')) {
            // https://tc39.github.io/proposal-regexp-named-groups/#sec-regexpbuiltinexec
            match.groups = Object.create(null);
            groupsObject = match.groups;
        }
        if (this[REGEX_DATA] && this[REGEX_DATA].captureNames) {
            // Skip index 0
            for (var i = 1; i < match.length; ++i) {
                var name = this[REGEX_DATA].captureNames[i - 1];
                if (name) {
                    groupsObject[name] = match[i];
                }
            }
        }

        // Fix browsers that increment `lastIndex` after zero-length matches
        if (this.global && !match[0].length && this.lastIndex > match.index) {
            this.lastIndex = match.index;
        }
    }

    if (!this.global) {
        // Fixes IE, Opera bug (last tested IE 9, Opera 11.6)
        this.lastIndex = origLastIndex;
    }

    return match;
};

/**
 * Fixes browser bugs in the native `RegExp.prototype.test`.
 *
 * @memberOf RegExp
 * @param {String} str String to search.
 * @returns {Boolean} Whether the regex matched the provided value.
 */
fixed.test = function (str) {
    // Do this the easy way :-)
    return !!fixed.exec.call(this, str);
};

/**
 * Adds named capture support (with backreferences returned as `result.name`), and fixes browser
 * bugs in the native `String.prototype.match`.
 *
 * @memberOf String
 * @param {RegExp|*} regex Regex to search with. If not a regex object, it is passed to `RegExp`.
 * @returns {Array} If `regex` uses flag g, an array of match strings or `null`. Without flag g,
 *   the result of calling `regex.exec(this)`.
 */
fixed.match = function (regex) {
    if (!XRegExp.isRegExp(regex)) {
        // Use the native `RegExp` rather than `XRegExp`
        regex = new RegExp(regex);
    } else if (regex.global) {
        var result = nativ.match.apply(this, arguments);
        // Fixes IE bug
        regex.lastIndex = 0;

        return result;
    }

    return fixed.exec.call(regex, toObject(this));
};

/**
 * Adds support for `${n}` (or `$<n>`) tokens for named and numbered backreferences in replacement
 * text, and provides named backreferences to replacement functions as `arguments[0].name`. Also
 * fixes browser bugs in replacement text syntax when performing a replacement using a nonregex
 * search value, and the value of a replacement regex's `lastIndex` property during replacement
 * iterations and upon completion. Note that this doesn't support SpiderMonkey's proprietary third
 * (`flags`) argument. Use via `XRegExp.replace`.
 *
 * @memberOf String
 * @param {RegExp|String} search Search pattern to be replaced.
 * @param {String|Function} replacement Replacement string or a function invoked to create it.
 * @returns {String} New string with one or all matches replaced.
 */
fixed.replace = function (search, replacement) {
    var isRegex = XRegExp.isRegExp(search);
    var origLastIndex = void 0;
    var captureNames = void 0;
    var result = void 0;

    if (isRegex) {
        if (search[REGEX_DATA]) {
            captureNames = search[REGEX_DATA].captureNames;
        }
        // Only needed if `search` is nonglobal
        origLastIndex = search.lastIndex;
    } else {
        search += ''; // Type-convert
    }

    // Don't use `typeof`; some older browsers return 'function' for regex objects
    if (isType(replacement, 'Function')) {
        // Stringifying `this` fixes a bug in IE < 9 where the last argument in replacement
        // functions isn't type-converted to a string
        result = nativ.replace.call(String(this), search, function () {
            for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                args[_key2] = arguments[_key2];
            }

            if (captureNames) {
                var groupsObject = void 0;

                if (XRegExp.isInstalled('namespacing')) {
                    // https://tc39.github.io/proposal-regexp-named-groups/#sec-regexpbuiltinexec
                    groupsObject = Object.create(null);
                    args.push(groupsObject);
                } else {
                    // Change the `args[0]` string primitive to a `String` object that can store
                    // properties. This really does need to use `String` as a constructor
                    args[0] = new String(args[0]);
                    groupsObject = args[0];
                }

                // Store named backreferences
                for (var i = 0; i < captureNames.length; ++i) {
                    if (captureNames[i]) {
                        groupsObject[captureNames[i]] = args[i + 1];
                    }
                }
            }
            // Update `lastIndex` before calling `replacement`. Fixes IE, Chrome, Firefox, Safari
            // bug (last tested IE 9, Chrome 17, Firefox 11, Safari 5.1)
            if (isRegex && search.global) {
                search.lastIndex = args[args.length - 2] + args[0].length;
            }
            // ES6 specs the context for replacement functions as `undefined`
            return replacement.apply(undefined, args);
        });
    } else {
        // Ensure that the last value of `args` will be a string when given nonstring `this`,
        // while still throwing on null or undefined context
        result = nativ.replace.call(this == null ? this : String(this), search, function () {
            for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                args[_key3] = arguments[_key3];
            }

            return nativ.replace.call(String(replacement), replacementToken, replacer);

            function replacer($0, bracketed, angled, dollarToken) {
                bracketed = bracketed || angled;
                // Named or numbered backreference with curly or angled braces
                if (bracketed) {
                    // XRegExp behavior for `${n}` or `$<n>`:
                    // 1. Backreference to numbered capture, if `n` is an integer. Use `0` for the
                    //    entire match. Any number of leading zeros may be used.
                    // 2. Backreference to named capture `n`, if it exists and is not an integer
                    //    overridden by numbered capture. In practice, this does not overlap with
                    //    numbered capture since XRegExp does not allow named capture to use a bare
                    //    integer as the name.
                    // 3. If the name or number does not refer to an existing capturing group, it's
                    //    an error.
                    var n = +bracketed; // Type-convert; drop leading zeros
                    if (n <= args.length - 3) {
                        return args[n] || '';
                    }
                    // Groups with the same name is an error, else would need `lastIndexOf`
                    n = captureNames ? captureNames.indexOf(bracketed) : -1;
                    if (n < 0) {
                        throw new SyntaxError('Backreference to undefined group ' + $0);
                    }
                    return args[n + 1] || '';
                }
                // Else, special variable or numbered backreference without curly braces
                if (dollarToken === '$') {
                    // $$
                    return '$';
                }
                if (dollarToken === '&' || +dollarToken === 0) {
                    // $&, $0 (not followed by 1-9), $00
                    return args[0];
                }
                if (dollarToken === '`') {
                    // $` (left context)
                    return args[args.length - 1].slice(0, args[args.length - 2]);
                }
                if (dollarToken === "'") {
                    // $' (right context)
                    return args[args.length - 1].slice(args[args.length - 2] + args[0].length);
                }
                // Else, numbered backreference without braces
                dollarToken = +dollarToken; // Type-convert; drop leading zero
                // XRegExp behavior for `$n` and `$nn`:
                // - Backrefs end after 1 or 2 digits. Use `${..}` or `$<..>` for more digits.
                // - `$1` is an error if no capturing groups.
                // - `$10` is an error if less than 10 capturing groups. Use `${1}0` or `$<1>0`
                //   instead.
                // - `$01` is `$1` if at least one capturing group, else it's an error.
                // - `$0` (not followed by 1-9) and `$00` are the entire match.
                // Native behavior, for comparison:
                // - Backrefs end after 1 or 2 digits. Cannot reference capturing group 100+.
                // - `$1` is a literal `$1` if no capturing groups.
                // - `$10` is `$1` followed by a literal `0` if less than 10 capturing groups.
                // - `$01` is `$1` if at least one capturing group, else it's a literal `$01`.
                // - `$0` is a literal `$0`.
                if (!isNaN(dollarToken)) {
                    if (dollarToken > args.length - 3) {
                        throw new SyntaxError('Backreference to undefined group ' + $0);
                    }
                    return args[dollarToken] || '';
                }
                // `$` followed by an unsupported char is an error, unlike native JS
                throw new SyntaxError('Invalid token ' + $0);
            }
        });
    }

    if (isRegex) {
        if (search.global) {
            // Fixes IE, Safari bug (last tested IE 9, Safari 5.1)
            search.lastIndex = 0;
        } else {
            // Fixes IE, Opera bug (last tested IE 9, Opera 11.6)
            search.lastIndex = origLastIndex;
        }
    }

    return result;
};

/**
 * Fixes browser bugs in the native `String.prototype.split`. Use via `XRegExp.split`.
 *
 * @memberOf String
 * @param {RegExp|String} separator Regex or string to use for separating the string.
 * @param {Number} [limit] Maximum number of items to include in the result array.
 * @returns {Array} Array of substrings.
 */
fixed.split = function (separator, limit) {
    if (!XRegExp.isRegExp(separator)) {
        // Browsers handle nonregex split correctly, so use the faster native method
        return nativ.split.apply(this, arguments);
    }

    var str = String(this);
    var output = [];
    var origLastIndex = separator.lastIndex;
    var lastLastIndex = 0;
    var lastLength = void 0;

    // Values for `limit`, per the spec:
    // If undefined: pow(2,32) - 1
    // If 0, Infinity, or NaN: 0
    // If positive number: limit = floor(limit); if (limit >= pow(2,32)) limit -= pow(2,32);
    // If negative number: pow(2,32) - floor(abs(limit))
    // If other: Type-convert, then use the above rules
    // This line fails in very strange ways for some values of `limit` in Opera 10.5-10.63, unless
    // Opera Dragonfly is open (go figure). It works in at least Opera 9.5-10.1 and 11+
    limit = (limit === undefined ? -1 : limit) >>> 0;

    XRegExp.forEach(str, separator, function (match) {
        // This condition is not the same as `if (match[0].length)`
        if (match.index + match[0].length > lastLastIndex) {
            output.push(str.slice(lastLastIndex, match.index));
            if (match.length > 1 && match.index < str.length) {
                Array.prototype.push.apply(output, match.slice(1));
            }
            lastLength = match[0].length;
            lastLastIndex = match.index + lastLength;
        }
    });

    if (lastLastIndex === str.length) {
        if (!nativ.test.call(separator, '') || lastLength) {
            output.push('');
        }
    } else {
        output.push(str.slice(lastLastIndex));
    }

    separator.lastIndex = origLastIndex;
    return output.length > limit ? output.slice(0, limit) : output;
};

// ==--------------------------==
// Built-in syntax/flag tokens
// ==--------------------------==

/*
 * Letter escapes that natively match literal characters: `\a`, `\A`, etc. These should be
 * SyntaxErrors but are allowed in web reality. XRegExp makes them errors for cross-browser
 * consistency and to reserve their syntax, but lets them be superseded by addons.
 */
XRegExp.addToken(/\\([ABCE-RTUVXYZaeg-mopqyz]|c(?![A-Za-z])|u(?![\dA-Fa-f]{4}|{[\dA-Fa-f]+})|x(?![\dA-Fa-f]{2}))/, function (match, scope) {
    // \B is allowed in default scope only
    if (match[1] === 'B' && scope === defaultScope) {
        return match[0];
    }
    throw new SyntaxError('Invalid escape ' + match[0]);
}, {
    scope: 'all',
    leadChar: '\\'
});

/*
 * Unicode code point escape with curly braces: `\u{N..}`. `N..` is any one or more digit
 * hexadecimal number from 0-10FFFF, and can include leading zeros. Requires the native ES6 `u` flag
 * to support code points greater than U+FFFF. Avoids converting code points above U+FFFF to
 * surrogate pairs (which could be done without flag `u`), since that could lead to broken behavior
 * if you follow a `\u{N..}` token that references a code point above U+FFFF with a quantifier, or
 * if you use the same in a character class.
 */
XRegExp.addToken(/\\u{([\dA-Fa-f]+)}/, function (match, scope, flags) {
    var code = dec(match[1]);
    if (code > 0x10FFFF) {
        throw new SyntaxError('Invalid Unicode code point ' + match[0]);
    }
    if (code <= 0xFFFF) {
        // Converting to \uNNNN avoids needing to escape the literal character and keep it
        // separate from preceding tokens
        return '\\u' + pad4(hex(code));
    }
    // If `code` is between 0xFFFF and 0x10FFFF, require and defer to native handling
    if (hasNativeU && flags.indexOf('u') !== -1) {
        return match[0];
    }
    throw new SyntaxError('Cannot use Unicode code point above \\u{FFFF} without flag u');
}, {
    scope: 'all',
    leadChar: '\\'
});

/*
 * Empty character class: `[]` or `[^]`. This fixes a critical cross-browser syntax inconsistency.
 * Unless this is standardized (per the ES spec), regex syntax can't be accurately parsed because
 * character class endings can't be determined.
 */
XRegExp.addToken(/\[(\^?)\]/,
// For cross-browser compatibility with ES3, convert [] to \b\B and [^] to [\s\S].
// (?!) should work like \b\B, but is unreliable in some versions of Firefox
/* eslint-disable no-confusing-arrow */
function (match) {
    return match[1] ? '[\\s\\S]' : '\\b\\B';
},
/* eslint-enable no-confusing-arrow */
{ leadChar: '[' });

/*
 * Comment pattern: `(?# )`. Inline comments are an alternative to the line comments allowed in
 * free-spacing mode (flag x).
 */
XRegExp.addToken(/\(\?#[^)]*\)/, getContextualTokenSeparator, { leadChar: '(' });

/*
 * Whitespace and line comments, in free-spacing mode (aka extended mode, flag x) only.
 */
XRegExp.addToken(/\s+|#[^\n]*\n?/, getContextualTokenSeparator, { flag: 'x' });

/*
 * Dot, in dotall mode (aka singleline mode, flag s) only.
 */
XRegExp.addToken(/\./, function () {
    return '[\\s\\S]';
}, {
    flag: 's',
    leadChar: '.'
});

/*
 * Named backreference: `\k<name>`. Backreference names can use the characters A-Z, a-z, 0-9, _,
 * and $ only. Also allows numbered backreferences as `\k<n>`.
 */
XRegExp.addToken(/\\k<([\w$]+)>/, function (match) {
    // Groups with the same name is an error, else would need `lastIndexOf`
    var index = isNaN(match[1]) ? this.captureNames.indexOf(match[1]) + 1 : +match[1];
    var endIndex = match.index + match[0].length;
    if (!index || index > this.captureNames.length) {
        throw new SyntaxError('Backreference to undefined group ' + match[0]);
    }
    // Keep backreferences separate from subsequent literal numbers. This avoids e.g.
    // inadvertedly changing `(?<n>)\k<n>1` to `()\11`.
    return '\\' + index + (endIndex === match.input.length || isNaN(match.input[endIndex]) ? '' : '(?:)');
}, { leadChar: '\\' });

/*
 * Numbered backreference or octal, plus any following digits: `\0`, `\11`, etc. Octals except `\0`
 * not followed by 0-9 and backreferences to unopened capture groups throw an error. Other matches
 * are returned unaltered. IE < 9 doesn't support backreferences above `\99` in regex syntax.
 */
XRegExp.addToken(/\\(\d+)/, function (match, scope) {
    if (!(scope === defaultScope && /^[1-9]/.test(match[1]) && +match[1] <= this.captureNames.length) && match[1] !== '0') {
        throw new SyntaxError('Cannot use octal escape or backreference to undefined group ' + match[0]);
    }
    return match[0];
}, {
    scope: 'all',
    leadChar: '\\'
});

/*
 * Named capturing group; match the opening delimiter only: `(?<name>`. Capture names can use the
 * characters A-Z, a-z, 0-9, _, and $ only. Names can't be integers. Supports Python-style
 * `(?P<name>` as an alternate syntax to avoid issues in some older versions of Opera which natively
 * supported the Python-style syntax. Otherwise, XRegExp might treat numbered backreferences to
 * Python-style named capture as octals.
 */
XRegExp.addToken(/\(\?P?<([\w$]+)>/, function (match) {
    // Disallow bare integers as names because named backreferences are added to match arrays
    // and therefore numeric properties may lead to incorrect lookups
    if (!isNaN(match[1])) {
        throw new SyntaxError('Cannot use integer as capture name ' + match[0]);
    }
    if (!XRegExp.isInstalled('namespacing') && (match[1] === 'length' || match[1] === '__proto__')) {
        throw new SyntaxError('Cannot use reserved word as capture name ' + match[0]);
    }
    if (this.captureNames.indexOf(match[1]) !== -1) {
        throw new SyntaxError('Cannot use same name for multiple groups ' + match[0]);
    }
    this.captureNames.push(match[1]);
    this.hasNamedCapture = true;
    return '(';
}, { leadChar: '(' });

/*
 * Capturing group; match the opening parenthesis only. Required for support of named capturing
 * groups. Also adds explicit capture mode (flag n).
 */
XRegExp.addToken(/\((?!\?)/, function (match, scope, flags) {
    if (flags.indexOf('n') !== -1) {
        return '(?:';
    }
    this.captureNames.push(null);
    return '(';
}, {
    optionalFlags: 'n',
    leadChar: '('
});

exports.default = XRegExp;
module.exports = exports['default'];

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports = [
    {
        'name': 'InAdlam',
        'astral': '\uD83A[\uDD00-\uDD5F]'
    },
    {
        'name': 'InAegean_Numbers',
        'astral': '\uD800[\uDD00-\uDD3F]'
    },
    {
        'name': 'InAhom',
        'astral': '\uD805[\uDF00-\uDF3F]'
    },
    {
        'name': 'InAlchemical_Symbols',
        'astral': '\uD83D[\uDF00-\uDF7F]'
    },
    {
        'name': 'InAlphabetic_Presentation_Forms',
        'bmp': '\uFB00-\uFB4F'
    },
    {
        'name': 'InAnatolian_Hieroglyphs',
        'astral': '\uD811[\uDC00-\uDE7F]'
    },
    {
        'name': 'InAncient_Greek_Musical_Notation',
        'astral': '\uD834[\uDE00-\uDE4F]'
    },
    {
        'name': 'InAncient_Greek_Numbers',
        'astral': '\uD800[\uDD40-\uDD8F]'
    },
    {
        'name': 'InAncient_Symbols',
        'astral': '\uD800[\uDD90-\uDDCF]'
    },
    {
        'name': 'InArabic',
        'bmp': '\u0600-\u06FF'
    },
    {
        'name': 'InArabic_Extended_A',
        'bmp': '\u08A0-\u08FF'
    },
    {
        'name': 'InArabic_Mathematical_Alphabetic_Symbols',
        'astral': '\uD83B[\uDE00-\uDEFF]'
    },
    {
        'name': 'InArabic_Presentation_Forms_A',
        'bmp': '\uFB50-\uFDFF'
    },
    {
        'name': 'InArabic_Presentation_Forms_B',
        'bmp': '\uFE70-\uFEFF'
    },
    {
        'name': 'InArabic_Supplement',
        'bmp': '\u0750-\u077F'
    },
    {
        'name': 'InArmenian',
        'bmp': '\u0530-\u058F'
    },
    {
        'name': 'InArrows',
        'bmp': '\u2190-\u21FF'
    },
    {
        'name': 'InAvestan',
        'astral': '\uD802[\uDF00-\uDF3F]'
    },
    {
        'name': 'InBalinese',
        'bmp': '\u1B00-\u1B7F'
    },
    {
        'name': 'InBamum',
        'bmp': '\uA6A0-\uA6FF'
    },
    {
        'name': 'InBamum_Supplement',
        'astral': '\uD81A[\uDC00-\uDE3F]'
    },
    {
        'name': 'InBasic_Latin',
        'bmp': '\0-\x7F'
    },
    {
        'name': 'InBassa_Vah',
        'astral': '\uD81A[\uDED0-\uDEFF]'
    },
    {
        'name': 'InBatak',
        'bmp': '\u1BC0-\u1BFF'
    },
    {
        'name': 'InBengali',
        'bmp': '\u0980-\u09FF'
    },
    {
        'name': 'InBhaiksuki',
        'astral': '\uD807[\uDC00-\uDC6F]'
    },
    {
        'name': 'InBlock_Elements',
        'bmp': '\u2580-\u259F'
    },
    {
        'name': 'InBopomofo',
        'bmp': '\u3100-\u312F'
    },
    {
        'name': 'InBopomofo_Extended',
        'bmp': '\u31A0-\u31BF'
    },
    {
        'name': 'InBox_Drawing',
        'bmp': '\u2500-\u257F'
    },
    {
        'name': 'InBrahmi',
        'astral': '\uD804[\uDC00-\uDC7F]'
    },
    {
        'name': 'InBraille_Patterns',
        'bmp': '\u2800-\u28FF'
    },
    {
        'name': 'InBuginese',
        'bmp': '\u1A00-\u1A1F'
    },
    {
        'name': 'InBuhid',
        'bmp': '\u1740-\u175F'
    },
    {
        'name': 'InByzantine_Musical_Symbols',
        'astral': '\uD834[\uDC00-\uDCFF]'
    },
    {
        'name': 'InCJK_Compatibility',
        'bmp': '\u3300-\u33FF'
    },
    {
        'name': 'InCJK_Compatibility_Forms',
        'bmp': '\uFE30-\uFE4F'
    },
    {
        'name': 'InCJK_Compatibility_Ideographs',
        'bmp': '\uF900-\uFAFF'
    },
    {
        'name': 'InCJK_Compatibility_Ideographs_Supplement',
        'astral': '\uD87E[\uDC00-\uDE1F]'
    },
    {
        'name': 'InCJK_Radicals_Supplement',
        'bmp': '\u2E80-\u2EFF'
    },
    {
        'name': 'InCJK_Strokes',
        'bmp': '\u31C0-\u31EF'
    },
    {
        'name': 'InCJK_Symbols_And_Punctuation',
        'bmp': '\u3000-\u303F'
    },
    {
        'name': 'InCJK_Unified_Ideographs',
        'bmp': '\u4E00-\u9FFF'
    },
    {
        'name': 'InCJK_Unified_Ideographs_Extension_A',
        'bmp': '\u3400-\u4DBF'
    },
    {
        'name': 'InCJK_Unified_Ideographs_Extension_B',
        'astral': '[\uD840-\uD868][\uDC00-\uDFFF]|\uD869[\uDC00-\uDEDF]'
    },
    {
        'name': 'InCJK_Unified_Ideographs_Extension_C',
        'astral': '\uD869[\uDF00-\uDFFF]|[\uD86A-\uD86C][\uDC00-\uDFFF]|\uD86D[\uDC00-\uDF3F]'
    },
    {
        'name': 'InCJK_Unified_Ideographs_Extension_D',
        'astral': '\uD86D[\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1F]'
    },
    {
        'name': 'InCJK_Unified_Ideographs_Extension_E',
        'astral': '\uD86E[\uDC20-\uDFFF]|[\uD86F-\uD872][\uDC00-\uDFFF]|\uD873[\uDC00-\uDEAF]'
    },
    {
        'name': 'InCJK_Unified_Ideographs_Extension_F',
        'astral': '\uD873[\uDEB0-\uDFFF]|[\uD874-\uD879][\uDC00-\uDFFF]|\uD87A[\uDC00-\uDFEF]'
    },
    {
        'name': 'InCarian',
        'astral': '\uD800[\uDEA0-\uDEDF]'
    },
    {
        'name': 'InCaucasian_Albanian',
        'astral': '\uD801[\uDD30-\uDD6F]'
    },
    {
        'name': 'InChakma',
        'astral': '\uD804[\uDD00-\uDD4F]'
    },
    {
        'name': 'InCham',
        'bmp': '\uAA00-\uAA5F'
    },
    {
        'name': 'InCherokee',
        'bmp': '\u13A0-\u13FF'
    },
    {
        'name': 'InCherokee_Supplement',
        'bmp': '\uAB70-\uABBF'
    },
    {
        'name': 'InCombining_Diacritical_Marks',
        'bmp': '\u0300-\u036F'
    },
    {
        'name': 'InCombining_Diacritical_Marks_Extended',
        'bmp': '\u1AB0-\u1AFF'
    },
    {
        'name': 'InCombining_Diacritical_Marks_For_Symbols',
        'bmp': '\u20D0-\u20FF'
    },
    {
        'name': 'InCombining_Diacritical_Marks_Supplement',
        'bmp': '\u1DC0-\u1DFF'
    },
    {
        'name': 'InCombining_Half_Marks',
        'bmp': '\uFE20-\uFE2F'
    },
    {
        'name': 'InCommon_Indic_Number_Forms',
        'bmp': '\uA830-\uA83F'
    },
    {
        'name': 'InControl_Pictures',
        'bmp': '\u2400-\u243F'
    },
    {
        'name': 'InCoptic',
        'bmp': '\u2C80-\u2CFF'
    },
    {
        'name': 'InCoptic_Epact_Numbers',
        'astral': '\uD800[\uDEE0-\uDEFF]'
    },
    {
        'name': 'InCounting_Rod_Numerals',
        'astral': '\uD834[\uDF60-\uDF7F]'
    },
    {
        'name': 'InCuneiform',
        'astral': '\uD808[\uDC00-\uDFFF]'
    },
    {
        'name': 'InCuneiform_Numbers_And_Punctuation',
        'astral': '\uD809[\uDC00-\uDC7F]'
    },
    {
        'name': 'InCurrency_Symbols',
        'bmp': '\u20A0-\u20CF'
    },
    {
        'name': 'InCypriot_Syllabary',
        'astral': '\uD802[\uDC00-\uDC3F]'
    },
    {
        'name': 'InCyrillic',
        'bmp': '\u0400-\u04FF'
    },
    {
        'name': 'InCyrillic_Extended_A',
        'bmp': '\u2DE0-\u2DFF'
    },
    {
        'name': 'InCyrillic_Extended_B',
        'bmp': '\uA640-\uA69F'
    },
    {
        'name': 'InCyrillic_Extended_C',
        'bmp': '\u1C80-\u1C8F'
    },
    {
        'name': 'InCyrillic_Supplement',
        'bmp': '\u0500-\u052F'
    },
    {
        'name': 'InDeseret',
        'astral': '\uD801[\uDC00-\uDC4F]'
    },
    {
        'name': 'InDevanagari',
        'bmp': '\u0900-\u097F'
    },
    {
        'name': 'InDevanagari_Extended',
        'bmp': '\uA8E0-\uA8FF'
    },
    {
        'name': 'InDingbats',
        'bmp': '\u2700-\u27BF'
    },
    {
        'name': 'InDomino_Tiles',
        'astral': '\uD83C[\uDC30-\uDC9F]'
    },
    {
        'name': 'InDuployan',
        'astral': '\uD82F[\uDC00-\uDC9F]'
    },
    {
        'name': 'InEarly_Dynastic_Cuneiform',
        'astral': '\uD809[\uDC80-\uDD4F]'
    },
    {
        'name': 'InEgyptian_Hieroglyphs',
        'astral': '\uD80C[\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2F]'
    },
    {
        'name': 'InElbasan',
        'astral': '\uD801[\uDD00-\uDD2F]'
    },
    {
        'name': 'InEmoticons',
        'astral': '\uD83D[\uDE00-\uDE4F]'
    },
    {
        'name': 'InEnclosed_Alphanumeric_Supplement',
        'astral': '\uD83C[\uDD00-\uDDFF]'
    },
    {
        'name': 'InEnclosed_Alphanumerics',
        'bmp': '\u2460-\u24FF'
    },
    {
        'name': 'InEnclosed_CJK_Letters_And_Months',
        'bmp': '\u3200-\u32FF'
    },
    {
        'name': 'InEnclosed_Ideographic_Supplement',
        'astral': '\uD83C[\uDE00-\uDEFF]'
    },
    {
        'name': 'InEthiopic',
        'bmp': '\u1200-\u137F'
    },
    {
        'name': 'InEthiopic_Extended',
        'bmp': '\u2D80-\u2DDF'
    },
    {
        'name': 'InEthiopic_Extended_A',
        'bmp': '\uAB00-\uAB2F'
    },
    {
        'name': 'InEthiopic_Supplement',
        'bmp': '\u1380-\u139F'
    },
    {
        'name': 'InGeneral_Punctuation',
        'bmp': '\u2000-\u206F'
    },
    {
        'name': 'InGeometric_Shapes',
        'bmp': '\u25A0-\u25FF'
    },
    {
        'name': 'InGeometric_Shapes_Extended',
        'astral': '\uD83D[\uDF80-\uDFFF]'
    },
    {
        'name': 'InGeorgian',
        'bmp': '\u10A0-\u10FF'
    },
    {
        'name': 'InGeorgian_Supplement',
        'bmp': '\u2D00-\u2D2F'
    },
    {
        'name': 'InGlagolitic',
        'bmp': '\u2C00-\u2C5F'
    },
    {
        'name': 'InGlagolitic_Supplement',
        'astral': '\uD838[\uDC00-\uDC2F]'
    },
    {
        'name': 'InGothic',
        'astral': '\uD800[\uDF30-\uDF4F]'
    },
    {
        'name': 'InGrantha',
        'astral': '\uD804[\uDF00-\uDF7F]'
    },
    {
        'name': 'InGreek_And_Coptic',
        'bmp': '\u0370-\u03FF'
    },
    {
        'name': 'InGreek_Extended',
        'bmp': '\u1F00-\u1FFF'
    },
    {
        'name': 'InGujarati',
        'bmp': '\u0A80-\u0AFF'
    },
    {
        'name': 'InGurmukhi',
        'bmp': '\u0A00-\u0A7F'
    },
    {
        'name': 'InHalfwidth_And_Fullwidth_Forms',
        'bmp': '\uFF00-\uFFEF'
    },
    {
        'name': 'InHangul_Compatibility_Jamo',
        'bmp': '\u3130-\u318F'
    },
    {
        'name': 'InHangul_Jamo',
        'bmp': '\u1100-\u11FF'
    },
    {
        'name': 'InHangul_Jamo_Extended_A',
        'bmp': '\uA960-\uA97F'
    },
    {
        'name': 'InHangul_Jamo_Extended_B',
        'bmp': '\uD7B0-\uD7FF'
    },
    {
        'name': 'InHangul_Syllables',
        'bmp': '\uAC00-\uD7AF'
    },
    {
        'name': 'InHanunoo',
        'bmp': '\u1720-\u173F'
    },
    {
        'name': 'InHatran',
        'astral': '\uD802[\uDCE0-\uDCFF]'
    },
    {
        'name': 'InHebrew',
        'bmp': '\u0590-\u05FF'
    },
    {
        'name': 'InHigh_Private_Use_Surrogates',
        'bmp': '\uDB80-\uDBFF'
    },
    {
        'name': 'InHigh_Surrogates',
        'bmp': '\uD800-\uDB7F'
    },
    {
        'name': 'InHiragana',
        'bmp': '\u3040-\u309F'
    },
    {
        'name': 'InIPA_Extensions',
        'bmp': '\u0250-\u02AF'
    },
    {
        'name': 'InIdeographic_Description_Characters',
        'bmp': '\u2FF0-\u2FFF'
    },
    {
        'name': 'InIdeographic_Symbols_And_Punctuation',
        'astral': '\uD81B[\uDFE0-\uDFFF]'
    },
    {
        'name': 'InImperial_Aramaic',
        'astral': '\uD802[\uDC40-\uDC5F]'
    },
    {
        'name': 'InInscriptional_Pahlavi',
        'astral': '\uD802[\uDF60-\uDF7F]'
    },
    {
        'name': 'InInscriptional_Parthian',
        'astral': '\uD802[\uDF40-\uDF5F]'
    },
    {
        'name': 'InJavanese',
        'bmp': '\uA980-\uA9DF'
    },
    {
        'name': 'InKaithi',
        'astral': '\uD804[\uDC80-\uDCCF]'
    },
    {
        'name': 'InKana_Extended_A',
        'astral': '\uD82C[\uDD00-\uDD2F]'
    },
    {
        'name': 'InKana_Supplement',
        'astral': '\uD82C[\uDC00-\uDCFF]'
    },
    {
        'name': 'InKanbun',
        'bmp': '\u3190-\u319F'
    },
    {
        'name': 'InKangxi_Radicals',
        'bmp': '\u2F00-\u2FDF'
    },
    {
        'name': 'InKannada',
        'bmp': '\u0C80-\u0CFF'
    },
    {
        'name': 'InKatakana',
        'bmp': '\u30A0-\u30FF'
    },
    {
        'name': 'InKatakana_Phonetic_Extensions',
        'bmp': '\u31F0-\u31FF'
    },
    {
        'name': 'InKayah_Li',
        'bmp': '\uA900-\uA92F'
    },
    {
        'name': 'InKharoshthi',
        'astral': '\uD802[\uDE00-\uDE5F]'
    },
    {
        'name': 'InKhmer',
        'bmp': '\u1780-\u17FF'
    },
    {
        'name': 'InKhmer_Symbols',
        'bmp': '\u19E0-\u19FF'
    },
    {
        'name': 'InKhojki',
        'astral': '\uD804[\uDE00-\uDE4F]'
    },
    {
        'name': 'InKhudawadi',
        'astral': '\uD804[\uDEB0-\uDEFF]'
    },
    {
        'name': 'InLao',
        'bmp': '\u0E80-\u0EFF'
    },
    {
        'name': 'InLatin_1_Supplement',
        'bmp': '\x80-\xFF'
    },
    {
        'name': 'InLatin_Extended_A',
        'bmp': '\u0100-\u017F'
    },
    {
        'name': 'InLatin_Extended_Additional',
        'bmp': '\u1E00-\u1EFF'
    },
    {
        'name': 'InLatin_Extended_B',
        'bmp': '\u0180-\u024F'
    },
    {
        'name': 'InLatin_Extended_C',
        'bmp': '\u2C60-\u2C7F'
    },
    {
        'name': 'InLatin_Extended_D',
        'bmp': '\uA720-\uA7FF'
    },
    {
        'name': 'InLatin_Extended_E',
        'bmp': '\uAB30-\uAB6F'
    },
    {
        'name': 'InLepcha',
        'bmp': '\u1C00-\u1C4F'
    },
    {
        'name': 'InLetterlike_Symbols',
        'bmp': '\u2100-\u214F'
    },
    {
        'name': 'InLimbu',
        'bmp': '\u1900-\u194F'
    },
    {
        'name': 'InLinear_A',
        'astral': '\uD801[\uDE00-\uDF7F]'
    },
    {
        'name': 'InLinear_B_Ideograms',
        'astral': '\uD800[\uDC80-\uDCFF]'
    },
    {
        'name': 'InLinear_B_Syllabary',
        'astral': '\uD800[\uDC00-\uDC7F]'
    },
    {
        'name': 'InLisu',
        'bmp': '\uA4D0-\uA4FF'
    },
    {
        'name': 'InLow_Surrogates',
        'bmp': '\uDC00-\uDFFF'
    },
    {
        'name': 'InLycian',
        'astral': '\uD800[\uDE80-\uDE9F]'
    },
    {
        'name': 'InLydian',
        'astral': '\uD802[\uDD20-\uDD3F]'
    },
    {
        'name': 'InMahajani',
        'astral': '\uD804[\uDD50-\uDD7F]'
    },
    {
        'name': 'InMahjong_Tiles',
        'astral': '\uD83C[\uDC00-\uDC2F]'
    },
    {
        'name': 'InMalayalam',
        'bmp': '\u0D00-\u0D7F'
    },
    {
        'name': 'InMandaic',
        'bmp': '\u0840-\u085F'
    },
    {
        'name': 'InManichaean',
        'astral': '\uD802[\uDEC0-\uDEFF]'
    },
    {
        'name': 'InMarchen',
        'astral': '\uD807[\uDC70-\uDCBF]'
    },
    {
        'name': 'InMasaram_Gondi',
        'astral': '\uD807[\uDD00-\uDD5F]'
    },
    {
        'name': 'InMathematical_Alphanumeric_Symbols',
        'astral': '\uD835[\uDC00-\uDFFF]'
    },
    {
        'name': 'InMathematical_Operators',
        'bmp': '\u2200-\u22FF'
    },
    {
        'name': 'InMeetei_Mayek',
        'bmp': '\uABC0-\uABFF'
    },
    {
        'name': 'InMeetei_Mayek_Extensions',
        'bmp': '\uAAE0-\uAAFF'
    },
    {
        'name': 'InMende_Kikakui',
        'astral': '\uD83A[\uDC00-\uDCDF]'
    },
    {
        'name': 'InMeroitic_Cursive',
        'astral': '\uD802[\uDDA0-\uDDFF]'
    },
    {
        'name': 'InMeroitic_Hieroglyphs',
        'astral': '\uD802[\uDD80-\uDD9F]'
    },
    {
        'name': 'InMiao',
        'astral': '\uD81B[\uDF00-\uDF9F]'
    },
    {
        'name': 'InMiscellaneous_Mathematical_Symbols_A',
        'bmp': '\u27C0-\u27EF'
    },
    {
        'name': 'InMiscellaneous_Mathematical_Symbols_B',
        'bmp': '\u2980-\u29FF'
    },
    {
        'name': 'InMiscellaneous_Symbols',
        'bmp': '\u2600-\u26FF'
    },
    {
        'name': 'InMiscellaneous_Symbols_And_Arrows',
        'bmp': '\u2B00-\u2BFF'
    },
    {
        'name': 'InMiscellaneous_Symbols_And_Pictographs',
        'astral': '\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDDFF]'
    },
    {
        'name': 'InMiscellaneous_Technical',
        'bmp': '\u2300-\u23FF'
    },
    {
        'name': 'InModi',
        'astral': '\uD805[\uDE00-\uDE5F]'
    },
    {
        'name': 'InModifier_Tone_Letters',
        'bmp': '\uA700-\uA71F'
    },
    {
        'name': 'InMongolian',
        'bmp': '\u1800-\u18AF'
    },
    {
        'name': 'InMongolian_Supplement',
        'astral': '\uD805[\uDE60-\uDE7F]'
    },
    {
        'name': 'InMro',
        'astral': '\uD81A[\uDE40-\uDE6F]'
    },
    {
        'name': 'InMultani',
        'astral': '\uD804[\uDE80-\uDEAF]'
    },
    {
        'name': 'InMusical_Symbols',
        'astral': '\uD834[\uDD00-\uDDFF]'
    },
    {
        'name': 'InMyanmar',
        'bmp': '\u1000-\u109F'
    },
    {
        'name': 'InMyanmar_Extended_A',
        'bmp': '\uAA60-\uAA7F'
    },
    {
        'name': 'InMyanmar_Extended_B',
        'bmp': '\uA9E0-\uA9FF'
    },
    {
        'name': 'InNKo',
        'bmp': '\u07C0-\u07FF'
    },
    {
        'name': 'InNabataean',
        'astral': '\uD802[\uDC80-\uDCAF]'
    },
    {
        'name': 'InNew_Tai_Lue',
        'bmp': '\u1980-\u19DF'
    },
    {
        'name': 'InNewa',
        'astral': '\uD805[\uDC00-\uDC7F]'
    },
    {
        'name': 'InNumber_Forms',
        'bmp': '\u2150-\u218F'
    },
    {
        'name': 'InNushu',
        'astral': '\uD82C[\uDD70-\uDEFF]'
    },
    {
        'name': 'InOgham',
        'bmp': '\u1680-\u169F'
    },
    {
        'name': 'InOl_Chiki',
        'bmp': '\u1C50-\u1C7F'
    },
    {
        'name': 'InOld_Hungarian',
        'astral': '\uD803[\uDC80-\uDCFF]'
    },
    {
        'name': 'InOld_Italic',
        'astral': '\uD800[\uDF00-\uDF2F]'
    },
    {
        'name': 'InOld_North_Arabian',
        'astral': '\uD802[\uDE80-\uDE9F]'
    },
    {
        'name': 'InOld_Permic',
        'astral': '\uD800[\uDF50-\uDF7F]'
    },
    {
        'name': 'InOld_Persian',
        'astral': '\uD800[\uDFA0-\uDFDF]'
    },
    {
        'name': 'InOld_South_Arabian',
        'astral': '\uD802[\uDE60-\uDE7F]'
    },
    {
        'name': 'InOld_Turkic',
        'astral': '\uD803[\uDC00-\uDC4F]'
    },
    {
        'name': 'InOptical_Character_Recognition',
        'bmp': '\u2440-\u245F'
    },
    {
        'name': 'InOriya',
        'bmp': '\u0B00-\u0B7F'
    },
    {
        'name': 'InOrnamental_Dingbats',
        'astral': '\uD83D[\uDE50-\uDE7F]'
    },
    {
        'name': 'InOsage',
        'astral': '\uD801[\uDCB0-\uDCFF]'
    },
    {
        'name': 'InOsmanya',
        'astral': '\uD801[\uDC80-\uDCAF]'
    },
    {
        'name': 'InPahawh_Hmong',
        'astral': '\uD81A[\uDF00-\uDF8F]'
    },
    {
        'name': 'InPalmyrene',
        'astral': '\uD802[\uDC60-\uDC7F]'
    },
    {
        'name': 'InPau_Cin_Hau',
        'astral': '\uD806[\uDEC0-\uDEFF]'
    },
    {
        'name': 'InPhags_Pa',
        'bmp': '\uA840-\uA87F'
    },
    {
        'name': 'InPhaistos_Disc',
        'astral': '\uD800[\uDDD0-\uDDFF]'
    },
    {
        'name': 'InPhoenician',
        'astral': '\uD802[\uDD00-\uDD1F]'
    },
    {
        'name': 'InPhonetic_Extensions',
        'bmp': '\u1D00-\u1D7F'
    },
    {
        'name': 'InPhonetic_Extensions_Supplement',
        'bmp': '\u1D80-\u1DBF'
    },
    {
        'name': 'InPlaying_Cards',
        'astral': '\uD83C[\uDCA0-\uDCFF]'
    },
    {
        'name': 'InPrivate_Use_Area',
        'bmp': '\uE000-\uF8FF'
    },
    {
        'name': 'InPsalter_Pahlavi',
        'astral': '\uD802[\uDF80-\uDFAF]'
    },
    {
        'name': 'InRejang',
        'bmp': '\uA930-\uA95F'
    },
    {
        'name': 'InRumi_Numeral_Symbols',
        'astral': '\uD803[\uDE60-\uDE7F]'
    },
    {
        'name': 'InRunic',
        'bmp': '\u16A0-\u16FF'
    },
    {
        'name': 'InSamaritan',
        'bmp': '\u0800-\u083F'
    },
    {
        'name': 'InSaurashtra',
        'bmp': '\uA880-\uA8DF'
    },
    {
        'name': 'InSharada',
        'astral': '\uD804[\uDD80-\uDDDF]'
    },
    {
        'name': 'InShavian',
        'astral': '\uD801[\uDC50-\uDC7F]'
    },
    {
        'name': 'InShorthand_Format_Controls',
        'astral': '\uD82F[\uDCA0-\uDCAF]'
    },
    {
        'name': 'InSiddham',
        'astral': '\uD805[\uDD80-\uDDFF]'
    },
    {
        'name': 'InSinhala',
        'bmp': '\u0D80-\u0DFF'
    },
    {
        'name': 'InSinhala_Archaic_Numbers',
        'astral': '\uD804[\uDDE0-\uDDFF]'
    },
    {
        'name': 'InSmall_Form_Variants',
        'bmp': '\uFE50-\uFE6F'
    },
    {
        'name': 'InSora_Sompeng',
        'astral': '\uD804[\uDCD0-\uDCFF]'
    },
    {
        'name': 'InSoyombo',
        'astral': '\uD806[\uDE50-\uDEAF]'
    },
    {
        'name': 'InSpacing_Modifier_Letters',
        'bmp': '\u02B0-\u02FF'
    },
    {
        'name': 'InSpecials',
        'bmp': '\uFFF0-\uFFFF'
    },
    {
        'name': 'InSundanese',
        'bmp': '\u1B80-\u1BBF'
    },
    {
        'name': 'InSundanese_Supplement',
        'bmp': '\u1CC0-\u1CCF'
    },
    {
        'name': 'InSuperscripts_And_Subscripts',
        'bmp': '\u2070-\u209F'
    },
    {
        'name': 'InSupplemental_Arrows_A',
        'bmp': '\u27F0-\u27FF'
    },
    {
        'name': 'InSupplemental_Arrows_B',
        'bmp': '\u2900-\u297F'
    },
    {
        'name': 'InSupplemental_Arrows_C',
        'astral': '\uD83E[\uDC00-\uDCFF]'
    },
    {
        'name': 'InSupplemental_Mathematical_Operators',
        'bmp': '\u2A00-\u2AFF'
    },
    {
        'name': 'InSupplemental_Punctuation',
        'bmp': '\u2E00-\u2E7F'
    },
    {
        'name': 'InSupplemental_Symbols_And_Pictographs',
        'astral': '\uD83E[\uDD00-\uDDFF]'
    },
    {
        'name': 'InSupplementary_Private_Use_Area_A',
        'astral': '[\uDB80-\uDBBF][\uDC00-\uDFFF]'
    },
    {
        'name': 'InSupplementary_Private_Use_Area_B',
        'astral': '[\uDBC0-\uDBFF][\uDC00-\uDFFF]'
    },
    {
        'name': 'InSutton_SignWriting',
        'astral': '\uD836[\uDC00-\uDEAF]'
    },
    {
        'name': 'InSyloti_Nagri',
        'bmp': '\uA800-\uA82F'
    },
    {
        'name': 'InSyriac',
        'bmp': '\u0700-\u074F'
    },
    {
        'name': 'InSyriac_Supplement',
        'bmp': '\u0860-\u086F'
    },
    {
        'name': 'InTagalog',
        'bmp': '\u1700-\u171F'
    },
    {
        'name': 'InTagbanwa',
        'bmp': '\u1760-\u177F'
    },
    {
        'name': 'InTags',
        'astral': '\uDB40[\uDC00-\uDC7F]'
    },
    {
        'name': 'InTai_Le',
        'bmp': '\u1950-\u197F'
    },
    {
        'name': 'InTai_Tham',
        'bmp': '\u1A20-\u1AAF'
    },
    {
        'name': 'InTai_Viet',
        'bmp': '\uAA80-\uAADF'
    },
    {
        'name': 'InTai_Xuan_Jing_Symbols',
        'astral': '\uD834[\uDF00-\uDF5F]'
    },
    {
        'name': 'InTakri',
        'astral': '\uD805[\uDE80-\uDECF]'
    },
    {
        'name': 'InTamil',
        'bmp': '\u0B80-\u0BFF'
    },
    {
        'name': 'InTangut',
        'astral': '[\uD81C-\uD821][\uDC00-\uDFFF]'
    },
    {
        'name': 'InTangut_Components',
        'astral': '\uD822[\uDC00-\uDEFF]'
    },
    {
        'name': 'InTelugu',
        'bmp': '\u0C00-\u0C7F'
    },
    {
        'name': 'InThaana',
        'bmp': '\u0780-\u07BF'
    },
    {
        'name': 'InThai',
        'bmp': '\u0E00-\u0E7F'
    },
    {
        'name': 'InTibetan',
        'bmp': '\u0F00-\u0FFF'
    },
    {
        'name': 'InTifinagh',
        'bmp': '\u2D30-\u2D7F'
    },
    {
        'name': 'InTirhuta',
        'astral': '\uD805[\uDC80-\uDCDF]'
    },
    {
        'name': 'InTransport_And_Map_Symbols',
        'astral': '\uD83D[\uDE80-\uDEFF]'
    },
    {
        'name': 'InUgaritic',
        'astral': '\uD800[\uDF80-\uDF9F]'
    },
    {
        'name': 'InUnified_Canadian_Aboriginal_Syllabics',
        'bmp': '\u1400-\u167F'
    },
    {
        'name': 'InUnified_Canadian_Aboriginal_Syllabics_Extended',
        'bmp': '\u18B0-\u18FF'
    },
    {
        'name': 'InVai',
        'bmp': '\uA500-\uA63F'
    },
    {
        'name': 'InVariation_Selectors',
        'bmp': '\uFE00-\uFE0F'
    },
    {
        'name': 'InVariation_Selectors_Supplement',
        'astral': '\uDB40[\uDD00-\uDDEF]'
    },
    {
        'name': 'InVedic_Extensions',
        'bmp': '\u1CD0-\u1CFF'
    },
    {
        'name': 'InVertical_Forms',
        'bmp': '\uFE10-\uFE1F'
    },
    {
        'name': 'InWarang_Citi',
        'astral': '\uD806[\uDCA0-\uDCFF]'
    },
    {
        'name': 'InYi_Radicals',
        'bmp': '\uA490-\uA4CF'
    },
    {
        'name': 'InYi_Syllables',
        'bmp': '\uA000-\uA48F'
    },
    {
        'name': 'InYijing_Hexagram_Symbols',
        'bmp': '\u4DC0-\u4DFF'
    },
    {
        'name': 'InZanabazar_Square',
        'astral': '\uD806[\uDE00-\uDE4F]'
    }
];


/***/ }),
/* 97 */
/***/ (function(module, exports) {

module.exports = [
    {
        'name': 'C',
        'alias': 'Other',
        'isBmpLast': true,
        'bmp': '\0-\x1F\x7F-\x9F\xAD\u0378\u0379\u0380-\u0383\u038B\u038D\u03A2\u0530\u0557\u0558\u0560\u0588\u058B\u058C\u0590\u05C8-\u05CF\u05EB-\u05EF\u05F5-\u0605\u061C\u061D\u06DD\u070E\u070F\u074B\u074C\u07B2-\u07BF\u07FB-\u07FF\u082E\u082F\u083F\u085C\u085D\u085F\u086B-\u089F\u08B5\u08BE-\u08D3\u08E2\u0984\u098D\u098E\u0991\u0992\u09A9\u09B1\u09B3-\u09B5\u09BA\u09BB\u09C5\u09C6\u09C9\u09CA\u09CF-\u09D6\u09D8-\u09DB\u09DE\u09E4\u09E5\u09FE-\u0A00\u0A04\u0A0B-\u0A0E\u0A11\u0A12\u0A29\u0A31\u0A34\u0A37\u0A3A\u0A3B\u0A3D\u0A43-\u0A46\u0A49\u0A4A\u0A4E-\u0A50\u0A52-\u0A58\u0A5D\u0A5F-\u0A65\u0A76-\u0A80\u0A84\u0A8E\u0A92\u0AA9\u0AB1\u0AB4\u0ABA\u0ABB\u0AC6\u0ACA\u0ACE\u0ACF\u0AD1-\u0ADF\u0AE4\u0AE5\u0AF2-\u0AF8\u0B00\u0B04\u0B0D\u0B0E\u0B11\u0B12\u0B29\u0B31\u0B34\u0B3A\u0B3B\u0B45\u0B46\u0B49\u0B4A\u0B4E-\u0B55\u0B58-\u0B5B\u0B5E\u0B64\u0B65\u0B78-\u0B81\u0B84\u0B8B-\u0B8D\u0B91\u0B96-\u0B98\u0B9B\u0B9D\u0BA0-\u0BA2\u0BA5-\u0BA7\u0BAB-\u0BAD\u0BBA-\u0BBD\u0BC3-\u0BC5\u0BC9\u0BCE\u0BCF\u0BD1-\u0BD6\u0BD8-\u0BE5\u0BFB-\u0BFF\u0C04\u0C0D\u0C11\u0C29\u0C3A-\u0C3C\u0C45\u0C49\u0C4E-\u0C54\u0C57\u0C5B-\u0C5F\u0C64\u0C65\u0C70-\u0C77\u0C84\u0C8D\u0C91\u0CA9\u0CB4\u0CBA\u0CBB\u0CC5\u0CC9\u0CCE-\u0CD4\u0CD7-\u0CDD\u0CDF\u0CE4\u0CE5\u0CF0\u0CF3-\u0CFF\u0D04\u0D0D\u0D11\u0D45\u0D49\u0D50-\u0D53\u0D64\u0D65\u0D80\u0D81\u0D84\u0D97-\u0D99\u0DB2\u0DBC\u0DBE\u0DBF\u0DC7-\u0DC9\u0DCB-\u0DCE\u0DD5\u0DD7\u0DE0-\u0DE5\u0DF0\u0DF1\u0DF5-\u0E00\u0E3B-\u0E3E\u0E5C-\u0E80\u0E83\u0E85\u0E86\u0E89\u0E8B\u0E8C\u0E8E-\u0E93\u0E98\u0EA0\u0EA4\u0EA6\u0EA8\u0EA9\u0EAC\u0EBA\u0EBE\u0EBF\u0EC5\u0EC7\u0ECE\u0ECF\u0EDA\u0EDB\u0EE0-\u0EFF\u0F48\u0F6D-\u0F70\u0F98\u0FBD\u0FCD\u0FDB-\u0FFF\u10C6\u10C8-\u10CC\u10CE\u10CF\u1249\u124E\u124F\u1257\u1259\u125E\u125F\u1289\u128E\u128F\u12B1\u12B6\u12B7\u12BF\u12C1\u12C6\u12C7\u12D7\u1311\u1316\u1317\u135B\u135C\u137D-\u137F\u139A-\u139F\u13F6\u13F7\u13FE\u13FF\u169D-\u169F\u16F9-\u16FF\u170D\u1715-\u171F\u1737-\u173F\u1754-\u175F\u176D\u1771\u1774-\u177F\u17DE\u17DF\u17EA-\u17EF\u17FA-\u17FF\u180E\u180F\u181A-\u181F\u1878-\u187F\u18AB-\u18AF\u18F6-\u18FF\u191F\u192C-\u192F\u193C-\u193F\u1941-\u1943\u196E\u196F\u1975-\u197F\u19AC-\u19AF\u19CA-\u19CF\u19DB-\u19DD\u1A1C\u1A1D\u1A5F\u1A7D\u1A7E\u1A8A-\u1A8F\u1A9A-\u1A9F\u1AAE\u1AAF\u1ABF-\u1AFF\u1B4C-\u1B4F\u1B7D-\u1B7F\u1BF4-\u1BFB\u1C38-\u1C3A\u1C4A-\u1C4C\u1C89-\u1CBF\u1CC8-\u1CCF\u1CFA-\u1CFF\u1DFA\u1F16\u1F17\u1F1E\u1F1F\u1F46\u1F47\u1F4E\u1F4F\u1F58\u1F5A\u1F5C\u1F5E\u1F7E\u1F7F\u1FB5\u1FC5\u1FD4\u1FD5\u1FDC\u1FF0\u1FF1\u1FF5\u1FFF\u200B-\u200F\u202A-\u202E\u2060-\u206F\u2072\u2073\u208F\u209D-\u209F\u20C0-\u20CF\u20F1-\u20FF\u218C-\u218F\u2427-\u243F\u244B-\u245F\u2B74\u2B75\u2B96\u2B97\u2BBA-\u2BBC\u2BC9\u2BD3-\u2BEB\u2BF0-\u2BFF\u2C2F\u2C5F\u2CF4-\u2CF8\u2D26\u2D28-\u2D2C\u2D2E\u2D2F\u2D68-\u2D6E\u2D71-\u2D7E\u2D97-\u2D9F\u2DA7\u2DAF\u2DB7\u2DBF\u2DC7\u2DCF\u2DD7\u2DDF\u2E4A-\u2E7F\u2E9A\u2EF4-\u2EFF\u2FD6-\u2FEF\u2FFC-\u2FFF\u3040\u3097\u3098\u3100-\u3104\u312F\u3130\u318F\u31BB-\u31BF\u31E4-\u31EF\u321F\u32FF\u4DB6-\u4DBF\u9FEB-\u9FFF\uA48D-\uA48F\uA4C7-\uA4CF\uA62C-\uA63F\uA6F8-\uA6FF\uA7AF\uA7B8-\uA7F6\uA82C-\uA82F\uA83A-\uA83F\uA878-\uA87F\uA8C6-\uA8CD\uA8DA-\uA8DF\uA8FE\uA8FF\uA954-\uA95E\uA97D-\uA97F\uA9CE\uA9DA-\uA9DD\uA9FF\uAA37-\uAA3F\uAA4E\uAA4F\uAA5A\uAA5B\uAAC3-\uAADA\uAAF7-\uAB00\uAB07\uAB08\uAB0F\uAB10\uAB17-\uAB1F\uAB27\uAB2F\uAB66-\uAB6F\uABEE\uABEF\uABFA-\uABFF\uD7A4-\uD7AF\uD7C7-\uD7CA\uD7FC-\uF8FF\uFA6E\uFA6F\uFADA-\uFAFF\uFB07-\uFB12\uFB18-\uFB1C\uFB37\uFB3D\uFB3F\uFB42\uFB45\uFBC2-\uFBD2\uFD40-\uFD4F\uFD90\uFD91\uFDC8-\uFDEF\uFDFE\uFDFF\uFE1A-\uFE1F\uFE53\uFE67\uFE6C-\uFE6F\uFE75\uFEFD-\uFF00\uFFBF-\uFFC1\uFFC8\uFFC9\uFFD0\uFFD1\uFFD8\uFFD9\uFFDD-\uFFDF\uFFE7\uFFEF-\uFFFB\uFFFE\uFFFF',
        'astral': '\uD800[\uDC0C\uDC27\uDC3B\uDC3E\uDC4E\uDC4F\uDC5E-\uDC7F\uDCFB-\uDCFF\uDD03-\uDD06\uDD34-\uDD36\uDD8F\uDD9C-\uDD9F\uDDA1-\uDDCF\uDDFE-\uDE7F\uDE9D-\uDE9F\uDED1-\uDEDF\uDEFC-\uDEFF\uDF24-\uDF2C\uDF4B-\uDF4F\uDF7B-\uDF7F\uDF9E\uDFC4-\uDFC7\uDFD6-\uDFFF]|\uD801[\uDC9E\uDC9F\uDCAA-\uDCAF\uDCD4-\uDCD7\uDCFC-\uDCFF\uDD28-\uDD2F\uDD64-\uDD6E\uDD70-\uDDFF\uDF37-\uDF3F\uDF56-\uDF5F\uDF68-\uDFFF]|\uD802[\uDC06\uDC07\uDC09\uDC36\uDC39-\uDC3B\uDC3D\uDC3E\uDC56\uDC9F-\uDCA6\uDCB0-\uDCDF\uDCF3\uDCF6-\uDCFA\uDD1C-\uDD1E\uDD3A-\uDD3E\uDD40-\uDD7F\uDDB8-\uDDBB\uDDD0\uDDD1\uDE04\uDE07-\uDE0B\uDE14\uDE18\uDE34-\uDE37\uDE3B-\uDE3E\uDE48-\uDE4F\uDE59-\uDE5F\uDEA0-\uDEBF\uDEE7-\uDEEA\uDEF7-\uDEFF\uDF36-\uDF38\uDF56\uDF57\uDF73-\uDF77\uDF92-\uDF98\uDF9D-\uDFA8\uDFB0-\uDFFF]|\uD803[\uDC49-\uDC7F\uDCB3-\uDCBF\uDCF3-\uDCF9\uDD00-\uDE5F\uDE7F-\uDFFF]|\uD804[\uDC4E-\uDC51\uDC70-\uDC7E\uDCBD\uDCC2-\uDCCF\uDCE9-\uDCEF\uDCFA-\uDCFF\uDD35\uDD44-\uDD4F\uDD77-\uDD7F\uDDCE\uDDCF\uDDE0\uDDF5-\uDDFF\uDE12\uDE3F-\uDE7F\uDE87\uDE89\uDE8E\uDE9E\uDEAA-\uDEAF\uDEEB-\uDEEF\uDEFA-\uDEFF\uDF04\uDF0D\uDF0E\uDF11\uDF12\uDF29\uDF31\uDF34\uDF3A\uDF3B\uDF45\uDF46\uDF49\uDF4A\uDF4E\uDF4F\uDF51-\uDF56\uDF58-\uDF5C\uDF64\uDF65\uDF6D-\uDF6F\uDF75-\uDFFF]|\uD805[\uDC5A\uDC5C\uDC5E-\uDC7F\uDCC8-\uDCCF\uDCDA-\uDD7F\uDDB6\uDDB7\uDDDE-\uDDFF\uDE45-\uDE4F\uDE5A-\uDE5F\uDE6D-\uDE7F\uDEB8-\uDEBF\uDECA-\uDEFF\uDF1A-\uDF1C\uDF2C-\uDF2F\uDF40-\uDFFF]|\uD806[\uDC00-\uDC9F\uDCF3-\uDCFE\uDD00-\uDDFF\uDE48-\uDE4F\uDE84\uDE85\uDE9D\uDEA3-\uDEBF\uDEF9-\uDFFF]|\uD807[\uDC09\uDC37\uDC46-\uDC4F\uDC6D-\uDC6F\uDC90\uDC91\uDCA8\uDCB7-\uDCFF\uDD07\uDD0A\uDD37-\uDD39\uDD3B\uDD3E\uDD48-\uDD4F\uDD5A-\uDFFF]|\uD808[\uDF9A-\uDFFF]|\uD809[\uDC6F\uDC75-\uDC7F\uDD44-\uDFFF]|[\uD80A\uD80B\uD80E-\uD810\uD812-\uD819\uD823-\uD82B\uD82D\uD82E\uD830-\uD833\uD837\uD839\uD83F\uD87B-\uD87D\uD87F-\uDB3F\uDB41-\uDBFF][\uDC00-\uDFFF]|\uD80D[\uDC2F-\uDFFF]|\uD811[\uDE47-\uDFFF]|\uD81A[\uDE39-\uDE3F\uDE5F\uDE6A-\uDE6D\uDE70-\uDECF\uDEEE\uDEEF\uDEF6-\uDEFF\uDF46-\uDF4F\uDF5A\uDF62\uDF78-\uDF7C\uDF90-\uDFFF]|\uD81B[\uDC00-\uDEFF\uDF45-\uDF4F\uDF7F-\uDF8E\uDFA0-\uDFDF\uDFE2-\uDFFF]|\uD821[\uDFED-\uDFFF]|\uD822[\uDEF3-\uDFFF]|\uD82C[\uDD1F-\uDD6F\uDEFC-\uDFFF]|\uD82F[\uDC6B-\uDC6F\uDC7D-\uDC7F\uDC89-\uDC8F\uDC9A\uDC9B\uDCA0-\uDFFF]|\uD834[\uDCF6-\uDCFF\uDD27\uDD28\uDD73-\uDD7A\uDDE9-\uDDFF\uDE46-\uDEFF\uDF57-\uDF5F\uDF72-\uDFFF]|\uD835[\uDC55\uDC9D\uDCA0\uDCA1\uDCA3\uDCA4\uDCA7\uDCA8\uDCAD\uDCBA\uDCBC\uDCC4\uDD06\uDD0B\uDD0C\uDD15\uDD1D\uDD3A\uDD3F\uDD45\uDD47-\uDD49\uDD51\uDEA6\uDEA7\uDFCC\uDFCD]|\uD836[\uDE8C-\uDE9A\uDEA0\uDEB0-\uDFFF]|\uD838[\uDC07\uDC19\uDC1A\uDC22\uDC25\uDC2B-\uDFFF]|\uD83A[\uDCC5\uDCC6\uDCD7-\uDCFF\uDD4B-\uDD4F\uDD5A-\uDD5D\uDD60-\uDFFF]|\uD83B[\uDC00-\uDDFF\uDE04\uDE20\uDE23\uDE25\uDE26\uDE28\uDE33\uDE38\uDE3A\uDE3C-\uDE41\uDE43-\uDE46\uDE48\uDE4A\uDE4C\uDE50\uDE53\uDE55\uDE56\uDE58\uDE5A\uDE5C\uDE5E\uDE60\uDE63\uDE65\uDE66\uDE6B\uDE73\uDE78\uDE7D\uDE7F\uDE8A\uDE9C-\uDEA0\uDEA4\uDEAA\uDEBC-\uDEEF\uDEF2-\uDFFF]|\uD83C[\uDC2C-\uDC2F\uDC94-\uDC9F\uDCAF\uDCB0\uDCC0\uDCD0\uDCF6-\uDCFF\uDD0D-\uDD0F\uDD2F\uDD6C-\uDD6F\uDDAD-\uDDE5\uDE03-\uDE0F\uDE3C-\uDE3F\uDE49-\uDE4F\uDE52-\uDE5F\uDE66-\uDEFF]|\uD83D[\uDED5-\uDEDF\uDEED-\uDEEF\uDEF9-\uDEFF\uDF74-\uDF7F\uDFD5-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDCFF\uDD0C-\uDD0F\uDD3F\uDD4D-\uDD4F\uDD6C-\uDD7F\uDD98-\uDDBF\uDDC1-\uDDCF\uDDE7-\uDFFF]|\uD869[\uDED7-\uDEFF]|\uD86D[\uDF35-\uDF3F]|\uD86E[\uDC1E\uDC1F]|\uD873[\uDEA2-\uDEAF]|\uD87A[\uDFE1-\uDFFF]|\uD87E[\uDE1E-\uDFFF]|\uDB40[\uDC00-\uDCFF\uDDF0-\uDFFF]'
    },
    {
        'name': 'Cc',
        'alias': 'Control',
        'bmp': '\0-\x1F\x7F-\x9F'
    },
    {
        'name': 'Cf',
        'alias': 'Format',
        'bmp': '\xAD\u0600-\u0605\u061C\u06DD\u070F\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB',
        'astral': '\uD804\uDCBD|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]'
    },
    {
        'name': 'Cn',
        'alias': 'Unassigned',
        'bmp': '\u0378\u0379\u0380-\u0383\u038B\u038D\u03A2\u0530\u0557\u0558\u0560\u0588\u058B\u058C\u0590\u05C8-\u05CF\u05EB-\u05EF\u05F5-\u05FF\u061D\u070E\u074B\u074C\u07B2-\u07BF\u07FB-\u07FF\u082E\u082F\u083F\u085C\u085D\u085F\u086B-\u089F\u08B5\u08BE-\u08D3\u0984\u098D\u098E\u0991\u0992\u09A9\u09B1\u09B3-\u09B5\u09BA\u09BB\u09C5\u09C6\u09C9\u09CA\u09CF-\u09D6\u09D8-\u09DB\u09DE\u09E4\u09E5\u09FE-\u0A00\u0A04\u0A0B-\u0A0E\u0A11\u0A12\u0A29\u0A31\u0A34\u0A37\u0A3A\u0A3B\u0A3D\u0A43-\u0A46\u0A49\u0A4A\u0A4E-\u0A50\u0A52-\u0A58\u0A5D\u0A5F-\u0A65\u0A76-\u0A80\u0A84\u0A8E\u0A92\u0AA9\u0AB1\u0AB4\u0ABA\u0ABB\u0AC6\u0ACA\u0ACE\u0ACF\u0AD1-\u0ADF\u0AE4\u0AE5\u0AF2-\u0AF8\u0B00\u0B04\u0B0D\u0B0E\u0B11\u0B12\u0B29\u0B31\u0B34\u0B3A\u0B3B\u0B45\u0B46\u0B49\u0B4A\u0B4E-\u0B55\u0B58-\u0B5B\u0B5E\u0B64\u0B65\u0B78-\u0B81\u0B84\u0B8B-\u0B8D\u0B91\u0B96-\u0B98\u0B9B\u0B9D\u0BA0-\u0BA2\u0BA5-\u0BA7\u0BAB-\u0BAD\u0BBA-\u0BBD\u0BC3-\u0BC5\u0BC9\u0BCE\u0BCF\u0BD1-\u0BD6\u0BD8-\u0BE5\u0BFB-\u0BFF\u0C04\u0C0D\u0C11\u0C29\u0C3A-\u0C3C\u0C45\u0C49\u0C4E-\u0C54\u0C57\u0C5B-\u0C5F\u0C64\u0C65\u0C70-\u0C77\u0C84\u0C8D\u0C91\u0CA9\u0CB4\u0CBA\u0CBB\u0CC5\u0CC9\u0CCE-\u0CD4\u0CD7-\u0CDD\u0CDF\u0CE4\u0CE5\u0CF0\u0CF3-\u0CFF\u0D04\u0D0D\u0D11\u0D45\u0D49\u0D50-\u0D53\u0D64\u0D65\u0D80\u0D81\u0D84\u0D97-\u0D99\u0DB2\u0DBC\u0DBE\u0DBF\u0DC7-\u0DC9\u0DCB-\u0DCE\u0DD5\u0DD7\u0DE0-\u0DE5\u0DF0\u0DF1\u0DF5-\u0E00\u0E3B-\u0E3E\u0E5C-\u0E80\u0E83\u0E85\u0E86\u0E89\u0E8B\u0E8C\u0E8E-\u0E93\u0E98\u0EA0\u0EA4\u0EA6\u0EA8\u0EA9\u0EAC\u0EBA\u0EBE\u0EBF\u0EC5\u0EC7\u0ECE\u0ECF\u0EDA\u0EDB\u0EE0-\u0EFF\u0F48\u0F6D-\u0F70\u0F98\u0FBD\u0FCD\u0FDB-\u0FFF\u10C6\u10C8-\u10CC\u10CE\u10CF\u1249\u124E\u124F\u1257\u1259\u125E\u125F\u1289\u128E\u128F\u12B1\u12B6\u12B7\u12BF\u12C1\u12C6\u12C7\u12D7\u1311\u1316\u1317\u135B\u135C\u137D-\u137F\u139A-\u139F\u13F6\u13F7\u13FE\u13FF\u169D-\u169F\u16F9-\u16FF\u170D\u1715-\u171F\u1737-\u173F\u1754-\u175F\u176D\u1771\u1774-\u177F\u17DE\u17DF\u17EA-\u17EF\u17FA-\u17FF\u180F\u181A-\u181F\u1878-\u187F\u18AB-\u18AF\u18F6-\u18FF\u191F\u192C-\u192F\u193C-\u193F\u1941-\u1943\u196E\u196F\u1975-\u197F\u19AC-\u19AF\u19CA-\u19CF\u19DB-\u19DD\u1A1C\u1A1D\u1A5F\u1A7D\u1A7E\u1A8A-\u1A8F\u1A9A-\u1A9F\u1AAE\u1AAF\u1ABF-\u1AFF\u1B4C-\u1B4F\u1B7D-\u1B7F\u1BF4-\u1BFB\u1C38-\u1C3A\u1C4A-\u1C4C\u1C89-\u1CBF\u1CC8-\u1CCF\u1CFA-\u1CFF\u1DFA\u1F16\u1F17\u1F1E\u1F1F\u1F46\u1F47\u1F4E\u1F4F\u1F58\u1F5A\u1F5C\u1F5E\u1F7E\u1F7F\u1FB5\u1FC5\u1FD4\u1FD5\u1FDC\u1FF0\u1FF1\u1FF5\u1FFF\u2065\u2072\u2073\u208F\u209D-\u209F\u20C0-\u20CF\u20F1-\u20FF\u218C-\u218F\u2427-\u243F\u244B-\u245F\u2B74\u2B75\u2B96\u2B97\u2BBA-\u2BBC\u2BC9\u2BD3-\u2BEB\u2BF0-\u2BFF\u2C2F\u2C5F\u2CF4-\u2CF8\u2D26\u2D28-\u2D2C\u2D2E\u2D2F\u2D68-\u2D6E\u2D71-\u2D7E\u2D97-\u2D9F\u2DA7\u2DAF\u2DB7\u2DBF\u2DC7\u2DCF\u2DD7\u2DDF\u2E4A-\u2E7F\u2E9A\u2EF4-\u2EFF\u2FD6-\u2FEF\u2FFC-\u2FFF\u3040\u3097\u3098\u3100-\u3104\u312F\u3130\u318F\u31BB-\u31BF\u31E4-\u31EF\u321F\u32FF\u4DB6-\u4DBF\u9FEB-\u9FFF\uA48D-\uA48F\uA4C7-\uA4CF\uA62C-\uA63F\uA6F8-\uA6FF\uA7AF\uA7B8-\uA7F6\uA82C-\uA82F\uA83A-\uA83F\uA878-\uA87F\uA8C6-\uA8CD\uA8DA-\uA8DF\uA8FE\uA8FF\uA954-\uA95E\uA97D-\uA97F\uA9CE\uA9DA-\uA9DD\uA9FF\uAA37-\uAA3F\uAA4E\uAA4F\uAA5A\uAA5B\uAAC3-\uAADA\uAAF7-\uAB00\uAB07\uAB08\uAB0F\uAB10\uAB17-\uAB1F\uAB27\uAB2F\uAB66-\uAB6F\uABEE\uABEF\uABFA-\uABFF\uD7A4-\uD7AF\uD7C7-\uD7CA\uD7FC-\uD7FF\uFA6E\uFA6F\uFADA-\uFAFF\uFB07-\uFB12\uFB18-\uFB1C\uFB37\uFB3D\uFB3F\uFB42\uFB45\uFBC2-\uFBD2\uFD40-\uFD4F\uFD90\uFD91\uFDC8-\uFDEF\uFDFE\uFDFF\uFE1A-\uFE1F\uFE53\uFE67\uFE6C-\uFE6F\uFE75\uFEFD\uFEFE\uFF00\uFFBF-\uFFC1\uFFC8\uFFC9\uFFD0\uFFD1\uFFD8\uFFD9\uFFDD-\uFFDF\uFFE7\uFFEF-\uFFF8\uFFFE\uFFFF',
        'astral': '\uD800[\uDC0C\uDC27\uDC3B\uDC3E\uDC4E\uDC4F\uDC5E-\uDC7F\uDCFB-\uDCFF\uDD03-\uDD06\uDD34-\uDD36\uDD8F\uDD9C-\uDD9F\uDDA1-\uDDCF\uDDFE-\uDE7F\uDE9D-\uDE9F\uDED1-\uDEDF\uDEFC-\uDEFF\uDF24-\uDF2C\uDF4B-\uDF4F\uDF7B-\uDF7F\uDF9E\uDFC4-\uDFC7\uDFD6-\uDFFF]|\uD801[\uDC9E\uDC9F\uDCAA-\uDCAF\uDCD4-\uDCD7\uDCFC-\uDCFF\uDD28-\uDD2F\uDD64-\uDD6E\uDD70-\uDDFF\uDF37-\uDF3F\uDF56-\uDF5F\uDF68-\uDFFF]|\uD802[\uDC06\uDC07\uDC09\uDC36\uDC39-\uDC3B\uDC3D\uDC3E\uDC56\uDC9F-\uDCA6\uDCB0-\uDCDF\uDCF3\uDCF6-\uDCFA\uDD1C-\uDD1E\uDD3A-\uDD3E\uDD40-\uDD7F\uDDB8-\uDDBB\uDDD0\uDDD1\uDE04\uDE07-\uDE0B\uDE14\uDE18\uDE34-\uDE37\uDE3B-\uDE3E\uDE48-\uDE4F\uDE59-\uDE5F\uDEA0-\uDEBF\uDEE7-\uDEEA\uDEF7-\uDEFF\uDF36-\uDF38\uDF56\uDF57\uDF73-\uDF77\uDF92-\uDF98\uDF9D-\uDFA8\uDFB0-\uDFFF]|\uD803[\uDC49-\uDC7F\uDCB3-\uDCBF\uDCF3-\uDCF9\uDD00-\uDE5F\uDE7F-\uDFFF]|\uD804[\uDC4E-\uDC51\uDC70-\uDC7E\uDCC2-\uDCCF\uDCE9-\uDCEF\uDCFA-\uDCFF\uDD35\uDD44-\uDD4F\uDD77-\uDD7F\uDDCE\uDDCF\uDDE0\uDDF5-\uDDFF\uDE12\uDE3F-\uDE7F\uDE87\uDE89\uDE8E\uDE9E\uDEAA-\uDEAF\uDEEB-\uDEEF\uDEFA-\uDEFF\uDF04\uDF0D\uDF0E\uDF11\uDF12\uDF29\uDF31\uDF34\uDF3A\uDF3B\uDF45\uDF46\uDF49\uDF4A\uDF4E\uDF4F\uDF51-\uDF56\uDF58-\uDF5C\uDF64\uDF65\uDF6D-\uDF6F\uDF75-\uDFFF]|\uD805[\uDC5A\uDC5C\uDC5E-\uDC7F\uDCC8-\uDCCF\uDCDA-\uDD7F\uDDB6\uDDB7\uDDDE-\uDDFF\uDE45-\uDE4F\uDE5A-\uDE5F\uDE6D-\uDE7F\uDEB8-\uDEBF\uDECA-\uDEFF\uDF1A-\uDF1C\uDF2C-\uDF2F\uDF40-\uDFFF]|\uD806[\uDC00-\uDC9F\uDCF3-\uDCFE\uDD00-\uDDFF\uDE48-\uDE4F\uDE84\uDE85\uDE9D\uDEA3-\uDEBF\uDEF9-\uDFFF]|\uD807[\uDC09\uDC37\uDC46-\uDC4F\uDC6D-\uDC6F\uDC90\uDC91\uDCA8\uDCB7-\uDCFF\uDD07\uDD0A\uDD37-\uDD39\uDD3B\uDD3E\uDD48-\uDD4F\uDD5A-\uDFFF]|\uD808[\uDF9A-\uDFFF]|\uD809[\uDC6F\uDC75-\uDC7F\uDD44-\uDFFF]|[\uD80A\uD80B\uD80E-\uD810\uD812-\uD819\uD823-\uD82B\uD82D\uD82E\uD830-\uD833\uD837\uD839\uD83F\uD87B-\uD87D\uD87F-\uDB3F\uDB41-\uDB7F][\uDC00-\uDFFF]|\uD80D[\uDC2F-\uDFFF]|\uD811[\uDE47-\uDFFF]|\uD81A[\uDE39-\uDE3F\uDE5F\uDE6A-\uDE6D\uDE70-\uDECF\uDEEE\uDEEF\uDEF6-\uDEFF\uDF46-\uDF4F\uDF5A\uDF62\uDF78-\uDF7C\uDF90-\uDFFF]|\uD81B[\uDC00-\uDEFF\uDF45-\uDF4F\uDF7F-\uDF8E\uDFA0-\uDFDF\uDFE2-\uDFFF]|\uD821[\uDFED-\uDFFF]|\uD822[\uDEF3-\uDFFF]|\uD82C[\uDD1F-\uDD6F\uDEFC-\uDFFF]|\uD82F[\uDC6B-\uDC6F\uDC7D-\uDC7F\uDC89-\uDC8F\uDC9A\uDC9B\uDCA4-\uDFFF]|\uD834[\uDCF6-\uDCFF\uDD27\uDD28\uDDE9-\uDDFF\uDE46-\uDEFF\uDF57-\uDF5F\uDF72-\uDFFF]|\uD835[\uDC55\uDC9D\uDCA0\uDCA1\uDCA3\uDCA4\uDCA7\uDCA8\uDCAD\uDCBA\uDCBC\uDCC4\uDD06\uDD0B\uDD0C\uDD15\uDD1D\uDD3A\uDD3F\uDD45\uDD47-\uDD49\uDD51\uDEA6\uDEA7\uDFCC\uDFCD]|\uD836[\uDE8C-\uDE9A\uDEA0\uDEB0-\uDFFF]|\uD838[\uDC07\uDC19\uDC1A\uDC22\uDC25\uDC2B-\uDFFF]|\uD83A[\uDCC5\uDCC6\uDCD7-\uDCFF\uDD4B-\uDD4F\uDD5A-\uDD5D\uDD60-\uDFFF]|\uD83B[\uDC00-\uDDFF\uDE04\uDE20\uDE23\uDE25\uDE26\uDE28\uDE33\uDE38\uDE3A\uDE3C-\uDE41\uDE43-\uDE46\uDE48\uDE4A\uDE4C\uDE50\uDE53\uDE55\uDE56\uDE58\uDE5A\uDE5C\uDE5E\uDE60\uDE63\uDE65\uDE66\uDE6B\uDE73\uDE78\uDE7D\uDE7F\uDE8A\uDE9C-\uDEA0\uDEA4\uDEAA\uDEBC-\uDEEF\uDEF2-\uDFFF]|\uD83C[\uDC2C-\uDC2F\uDC94-\uDC9F\uDCAF\uDCB0\uDCC0\uDCD0\uDCF6-\uDCFF\uDD0D-\uDD0F\uDD2F\uDD6C-\uDD6F\uDDAD-\uDDE5\uDE03-\uDE0F\uDE3C-\uDE3F\uDE49-\uDE4F\uDE52-\uDE5F\uDE66-\uDEFF]|\uD83D[\uDED5-\uDEDF\uDEED-\uDEEF\uDEF9-\uDEFF\uDF74-\uDF7F\uDFD5-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDCFF\uDD0C-\uDD0F\uDD3F\uDD4D-\uDD4F\uDD6C-\uDD7F\uDD98-\uDDBF\uDDC1-\uDDCF\uDDE7-\uDFFF]|\uD869[\uDED7-\uDEFF]|\uD86D[\uDF35-\uDF3F]|\uD86E[\uDC1E\uDC1F]|\uD873[\uDEA2-\uDEAF]|\uD87A[\uDFE1-\uDFFF]|\uD87E[\uDE1E-\uDFFF]|\uDB40[\uDC00\uDC02-\uDC1F\uDC80-\uDCFF\uDDF0-\uDFFF]|[\uDBBF\uDBFF][\uDFFE\uDFFF]'
    },
    {
        'name': 'Co',
        'alias': 'Private_Use',
        'bmp': '\uE000-\uF8FF',
        'astral': '[\uDB80-\uDBBE\uDBC0-\uDBFE][\uDC00-\uDFFF]|[\uDBBF\uDBFF][\uDC00-\uDFFD]'
    },
    {
        'name': 'Cs',
        'alias': 'Surrogate',
        'bmp': '\uD800-\uDFFF'
    },
    {
        'name': 'L',
        'alias': 'Letter',
        'bmp': 'A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312E\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEA\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC',
        'astral': '\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDF00-\uDF19]|\uD806[\uDCA0-\uDCDF\uDCFF\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE83\uDE86-\uDE89\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50\uDF93-\uDF9F\uDFE0\uDFE1]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00-\uDD1E\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]'
    },
    {
        'name': 'LC',
        'alias': 'Cased_Letter',
        'bmp': 'A-Za-z\xB5\xC0-\xD6\xD8-\xF6\xF8-\u01BA\u01BC-\u01BF\u01C4-\u0293\u0295-\u02AF\u0370-\u0373\u0376\u0377\u037B-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0561-\u0587\u10A0-\u10C5\u10C7\u10CD\u13A0-\u13F5\u13F8-\u13FD\u1C80-\u1C88\u1D00-\u1D2B\u1D6B-\u1D77\u1D79-\u1D9A\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2134\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2C7B\u2C7E-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\uA640-\uA66D\uA680-\uA69B\uA722-\uA76F\uA771-\uA787\uA78B-\uA78E\uA790-\uA7AE\uA7B0-\uA7B7\uA7FA\uAB30-\uAB5A\uAB60-\uAB65\uAB70-\uABBF\uFB00-\uFB06\uFB13-\uFB17\uFF21-\uFF3A\uFF41-\uFF5A',
        'astral': '\uD801[\uDC00-\uDC4F\uDCB0-\uDCD3\uDCD8-\uDCFB]|\uD803[\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD806[\uDCA0-\uDCDF]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD83A[\uDD00-\uDD43]'
    },
    {
        'name': 'Ll',
        'alias': 'Lowercase_Letter',
        'bmp': 'a-z\xB5\xDF-\xF6\xF8-\xFF\u0101\u0103\u0105\u0107\u0109\u010B\u010D\u010F\u0111\u0113\u0115\u0117\u0119\u011B\u011D\u011F\u0121\u0123\u0125\u0127\u0129\u012B\u012D\u012F\u0131\u0133\u0135\u0137\u0138\u013A\u013C\u013E\u0140\u0142\u0144\u0146\u0148\u0149\u014B\u014D\u014F\u0151\u0153\u0155\u0157\u0159\u015B\u015D\u015F\u0161\u0163\u0165\u0167\u0169\u016B\u016D\u016F\u0171\u0173\u0175\u0177\u017A\u017C\u017E-\u0180\u0183\u0185\u0188\u018C\u018D\u0192\u0195\u0199-\u019B\u019E\u01A1\u01A3\u01A5\u01A8\u01AA\u01AB\u01AD\u01B0\u01B4\u01B6\u01B9\u01BA\u01BD-\u01BF\u01C6\u01C9\u01CC\u01CE\u01D0\u01D2\u01D4\u01D6\u01D8\u01DA\u01DC\u01DD\u01DF\u01E1\u01E3\u01E5\u01E7\u01E9\u01EB\u01ED\u01EF\u01F0\u01F3\u01F5\u01F9\u01FB\u01FD\u01FF\u0201\u0203\u0205\u0207\u0209\u020B\u020D\u020F\u0211\u0213\u0215\u0217\u0219\u021B\u021D\u021F\u0221\u0223\u0225\u0227\u0229\u022B\u022D\u022F\u0231\u0233-\u0239\u023C\u023F\u0240\u0242\u0247\u0249\u024B\u024D\u024F-\u0293\u0295-\u02AF\u0371\u0373\u0377\u037B-\u037D\u0390\u03AC-\u03CE\u03D0\u03D1\u03D5-\u03D7\u03D9\u03DB\u03DD\u03DF\u03E1\u03E3\u03E5\u03E7\u03E9\u03EB\u03ED\u03EF-\u03F3\u03F5\u03F8\u03FB\u03FC\u0430-\u045F\u0461\u0463\u0465\u0467\u0469\u046B\u046D\u046F\u0471\u0473\u0475\u0477\u0479\u047B\u047D\u047F\u0481\u048B\u048D\u048F\u0491\u0493\u0495\u0497\u0499\u049B\u049D\u049F\u04A1\u04A3\u04A5\u04A7\u04A9\u04AB\u04AD\u04AF\u04B1\u04B3\u04B5\u04B7\u04B9\u04BB\u04BD\u04BF\u04C2\u04C4\u04C6\u04C8\u04CA\u04CC\u04CE\u04CF\u04D1\u04D3\u04D5\u04D7\u04D9\u04DB\u04DD\u04DF\u04E1\u04E3\u04E5\u04E7\u04E9\u04EB\u04ED\u04EF\u04F1\u04F3\u04F5\u04F7\u04F9\u04FB\u04FD\u04FF\u0501\u0503\u0505\u0507\u0509\u050B\u050D\u050F\u0511\u0513\u0515\u0517\u0519\u051B\u051D\u051F\u0521\u0523\u0525\u0527\u0529\u052B\u052D\u052F\u0561-\u0587\u13F8-\u13FD\u1C80-\u1C88\u1D00-\u1D2B\u1D6B-\u1D77\u1D79-\u1D9A\u1E01\u1E03\u1E05\u1E07\u1E09\u1E0B\u1E0D\u1E0F\u1E11\u1E13\u1E15\u1E17\u1E19\u1E1B\u1E1D\u1E1F\u1E21\u1E23\u1E25\u1E27\u1E29\u1E2B\u1E2D\u1E2F\u1E31\u1E33\u1E35\u1E37\u1E39\u1E3B\u1E3D\u1E3F\u1E41\u1E43\u1E45\u1E47\u1E49\u1E4B\u1E4D\u1E4F\u1E51\u1E53\u1E55\u1E57\u1E59\u1E5B\u1E5D\u1E5F\u1E61\u1E63\u1E65\u1E67\u1E69\u1E6B\u1E6D\u1E6F\u1E71\u1E73\u1E75\u1E77\u1E79\u1E7B\u1E7D\u1E7F\u1E81\u1E83\u1E85\u1E87\u1E89\u1E8B\u1E8D\u1E8F\u1E91\u1E93\u1E95-\u1E9D\u1E9F\u1EA1\u1EA3\u1EA5\u1EA7\u1EA9\u1EAB\u1EAD\u1EAF\u1EB1\u1EB3\u1EB5\u1EB7\u1EB9\u1EBB\u1EBD\u1EBF\u1EC1\u1EC3\u1EC5\u1EC7\u1EC9\u1ECB\u1ECD\u1ECF\u1ED1\u1ED3\u1ED5\u1ED7\u1ED9\u1EDB\u1EDD\u1EDF\u1EE1\u1EE3\u1EE5\u1EE7\u1EE9\u1EEB\u1EED\u1EEF\u1EF1\u1EF3\u1EF5\u1EF7\u1EF9\u1EFB\u1EFD\u1EFF-\u1F07\u1F10-\u1F15\u1F20-\u1F27\u1F30-\u1F37\u1F40-\u1F45\u1F50-\u1F57\u1F60-\u1F67\u1F70-\u1F7D\u1F80-\u1F87\u1F90-\u1F97\u1FA0-\u1FA7\u1FB0-\u1FB4\u1FB6\u1FB7\u1FBE\u1FC2-\u1FC4\u1FC6\u1FC7\u1FD0-\u1FD3\u1FD6\u1FD7\u1FE0-\u1FE7\u1FF2-\u1FF4\u1FF6\u1FF7\u210A\u210E\u210F\u2113\u212F\u2134\u2139\u213C\u213D\u2146-\u2149\u214E\u2184\u2C30-\u2C5E\u2C61\u2C65\u2C66\u2C68\u2C6A\u2C6C\u2C71\u2C73\u2C74\u2C76-\u2C7B\u2C81\u2C83\u2C85\u2C87\u2C89\u2C8B\u2C8D\u2C8F\u2C91\u2C93\u2C95\u2C97\u2C99\u2C9B\u2C9D\u2C9F\u2CA1\u2CA3\u2CA5\u2CA7\u2CA9\u2CAB\u2CAD\u2CAF\u2CB1\u2CB3\u2CB5\u2CB7\u2CB9\u2CBB\u2CBD\u2CBF\u2CC1\u2CC3\u2CC5\u2CC7\u2CC9\u2CCB\u2CCD\u2CCF\u2CD1\u2CD3\u2CD5\u2CD7\u2CD9\u2CDB\u2CDD\u2CDF\u2CE1\u2CE3\u2CE4\u2CEC\u2CEE\u2CF3\u2D00-\u2D25\u2D27\u2D2D\uA641\uA643\uA645\uA647\uA649\uA64B\uA64D\uA64F\uA651\uA653\uA655\uA657\uA659\uA65B\uA65D\uA65F\uA661\uA663\uA665\uA667\uA669\uA66B\uA66D\uA681\uA683\uA685\uA687\uA689\uA68B\uA68D\uA68F\uA691\uA693\uA695\uA697\uA699\uA69B\uA723\uA725\uA727\uA729\uA72B\uA72D\uA72F-\uA731\uA733\uA735\uA737\uA739\uA73B\uA73D\uA73F\uA741\uA743\uA745\uA747\uA749\uA74B\uA74D\uA74F\uA751\uA753\uA755\uA757\uA759\uA75B\uA75D\uA75F\uA761\uA763\uA765\uA767\uA769\uA76B\uA76D\uA76F\uA771-\uA778\uA77A\uA77C\uA77F\uA781\uA783\uA785\uA787\uA78C\uA78E\uA791\uA793-\uA795\uA797\uA799\uA79B\uA79D\uA79F\uA7A1\uA7A3\uA7A5\uA7A7\uA7A9\uA7B5\uA7B7\uA7FA\uAB30-\uAB5A\uAB60-\uAB65\uAB70-\uABBF\uFB00-\uFB06\uFB13-\uFB17\uFF41-\uFF5A',
        'astral': '\uD801[\uDC28-\uDC4F\uDCD8-\uDCFB]|\uD803[\uDCC0-\uDCF2]|\uD806[\uDCC0-\uDCDF]|\uD835[\uDC1A-\uDC33\uDC4E-\uDC54\uDC56-\uDC67\uDC82-\uDC9B\uDCB6-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDCCF\uDCEA-\uDD03\uDD1E-\uDD37\uDD52-\uDD6B\uDD86-\uDD9F\uDDBA-\uDDD3\uDDEE-\uDE07\uDE22-\uDE3B\uDE56-\uDE6F\uDE8A-\uDEA5\uDEC2-\uDEDA\uDEDC-\uDEE1\uDEFC-\uDF14\uDF16-\uDF1B\uDF36-\uDF4E\uDF50-\uDF55\uDF70-\uDF88\uDF8A-\uDF8F\uDFAA-\uDFC2\uDFC4-\uDFC9\uDFCB]|\uD83A[\uDD22-\uDD43]'
    },
    {
        'name': 'Lm',
        'alias': 'Modifier_Letter',
        'bmp': '\u02B0-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0374\u037A\u0559\u0640\u06E5\u06E6\u07F4\u07F5\u07FA\u081A\u0824\u0828\u0971\u0E46\u0EC6\u10FC\u17D7\u1843\u1AA7\u1C78-\u1C7D\u1D2C-\u1D6A\u1D78\u1D9B-\u1DBF\u2071\u207F\u2090-\u209C\u2C7C\u2C7D\u2D6F\u2E2F\u3005\u3031-\u3035\u303B\u309D\u309E\u30FC-\u30FE\uA015\uA4F8-\uA4FD\uA60C\uA67F\uA69C\uA69D\uA717-\uA71F\uA770\uA788\uA7F8\uA7F9\uA9CF\uA9E6\uAA70\uAADD\uAAF3\uAAF4\uAB5C-\uAB5F\uFF70\uFF9E\uFF9F',
        'astral': '\uD81A[\uDF40-\uDF43]|\uD81B[\uDF93-\uDF9F\uDFE0\uDFE1]'
    },
    {
        'name': 'Lo',
        'alias': 'Other_Letter',
        'bmp': '\xAA\xBA\u01BB\u01C0-\u01C3\u0294\u05D0-\u05EA\u05F0-\u05F2\u0620-\u063F\u0641-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u0800-\u0815\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0972-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E45\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10D0-\u10FA\u10FD-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17DC\u1820-\u1842\u1844-\u1877\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C77\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u2135-\u2138\u2D30-\u2D67\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3006\u303C\u3041-\u3096\u309F\u30A1-\u30FA\u30FF\u3105-\u312E\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEA\uA000-\uA014\uA016-\uA48C\uA4D0-\uA4F7\uA500-\uA60B\uA610-\uA61F\uA62A\uA62B\uA66E\uA6A0-\uA6E5\uA78F\uA7F7\uA7FB-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9E0-\uA9E4\uA9E7-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA6F\uAA71-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB\uAADC\uAAE0-\uAAEA\uAAF2\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF66-\uFF6F\uFF71-\uFF9D\uFFA0-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC',
        'astral': '\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC50-\uDC9D\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDF00-\uDF19]|\uD806[\uDCFF\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE83\uDE86-\uDE89\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00-\uDD1E\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD83A[\uDC00-\uDCC4]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]'
    },
    {
        'name': 'Lt',
        'alias': 'Titlecase_Letter',
        'bmp': '\u01C5\u01C8\u01CB\u01F2\u1F88-\u1F8F\u1F98-\u1F9F\u1FA8-\u1FAF\u1FBC\u1FCC\u1FFC'
    },
    {
        'name': 'Lu',
        'alias': 'Uppercase_Letter',
        'bmp': 'A-Z\xC0-\xD6\xD8-\xDE\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C7\u01CA\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0370\u0372\u0376\u037F\u0386\u0388-\u038A\u038C\u038E\u038F\u0391-\u03A1\u03A3-\u03AB\u03CF\u03D2-\u03D4\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F4\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0528\u052A\u052C\u052E\u0531-\u0556\u10A0-\u10C5\u10C7\u10CD\u13A0-\u13F5\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1FB8-\u1FBB\u1FC8-\u1FCB\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF8-\u1FFB\u2102\u2107\u210B-\u210D\u2110-\u2112\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u2130-\u2133\u213E\u213F\u2145\u2183\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA698\uA69A\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA796\uA798\uA79A\uA79C\uA79E\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA-\uA7AE\uA7B0-\uA7B4\uA7B6\uFF21-\uFF3A',
        'astral': '\uD801[\uDC00-\uDC27\uDCB0-\uDCD3]|\uD803[\uDC80-\uDCB2]|\uD806[\uDCA0-\uDCBF]|\uD835[\uDC00-\uDC19\uDC34-\uDC4D\uDC68-\uDC81\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB5\uDCD0-\uDCE9\uDD04\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD38\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD6C-\uDD85\uDDA0-\uDDB9\uDDD4-\uDDED\uDE08-\uDE21\uDE3C-\uDE55\uDE70-\uDE89\uDEA8-\uDEC0\uDEE2-\uDEFA\uDF1C-\uDF34\uDF56-\uDF6E\uDF90-\uDFA8\uDFCA]|\uD83A[\uDD00-\uDD21]'
    },
    {
        'name': 'M',
        'alias': 'Mark',
        'bmp': '\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D4-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B62\u0B63\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0C00-\u0C03\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D00-\u0D03\u0D3B\u0D3C\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D82\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F\u109A-\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u192B\u1930-\u193B\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F\u1AB0-\u1ABE\u1B00-\u1B04\u1B34-\u1B44\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BE6-\u1BF3\u1C24-\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF2-\u1CF4\u1CF7-\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA880\uA881\uA8B4-\uA8C5\uA8E0-\uA8F1\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9E5\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F',
        'astral': '\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD804[\uDC00-\uDC02\uDC38-\uDC46\uDC7F-\uDC82\uDCB0-\uDCBA\uDD00-\uDD02\uDD27-\uDD34\uDD73\uDD80-\uDD82\uDDB3-\uDDC0\uDDCA-\uDDCC\uDE2C-\uDE37\uDE3E\uDEDF-\uDEEA\uDF00-\uDF03\uDF3C\uDF3E-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF57\uDF62\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC35-\uDC46\uDCB0-\uDCC3\uDDAF-\uDDB5\uDDB8-\uDDC0\uDDDC\uDDDD\uDE30-\uDE40\uDEAB-\uDEB7\uDF1D-\uDF2B]|\uD806[\uDE01-\uDE0A\uDE33-\uDE39\uDE3B-\uDE3E\uDE47\uDE51-\uDE5B\uDE8A-\uDE99]|\uD807[\uDC2F-\uDC36\uDC38-\uDC3F\uDC92-\uDCA7\uDCA9-\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF51-\uDF7E\uDF8F-\uDF92]|\uD82F[\uDC9D\uDC9E]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uDB40[\uDD00-\uDDEF]'
    },
    {
        'name': 'Mc',
        'alias': 'Spacing_Mark',
        'bmp': '\u0903\u093B\u093E-\u0940\u0949-\u094C\u094E\u094F\u0982\u0983\u09BE-\u09C0\u09C7\u09C8\u09CB\u09CC\u09D7\u0A03\u0A3E-\u0A40\u0A83\u0ABE-\u0AC0\u0AC9\u0ACB\u0ACC\u0B02\u0B03\u0B3E\u0B40\u0B47\u0B48\u0B4B\u0B4C\u0B57\u0BBE\u0BBF\u0BC1\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0BD7\u0C01-\u0C03\u0C41-\u0C44\u0C82\u0C83\u0CBE\u0CC0-\u0CC4\u0CC7\u0CC8\u0CCA\u0CCB\u0CD5\u0CD6\u0D02\u0D03\u0D3E-\u0D40\u0D46-\u0D48\u0D4A-\u0D4C\u0D57\u0D82\u0D83\u0DCF-\u0DD1\u0DD8-\u0DDF\u0DF2\u0DF3\u0F3E\u0F3F\u0F7F\u102B\u102C\u1031\u1038\u103B\u103C\u1056\u1057\u1062-\u1064\u1067-\u106D\u1083\u1084\u1087-\u108C\u108F\u109A-\u109C\u17B6\u17BE-\u17C5\u17C7\u17C8\u1923-\u1926\u1929-\u192B\u1930\u1931\u1933-\u1938\u1A19\u1A1A\u1A55\u1A57\u1A61\u1A63\u1A64\u1A6D-\u1A72\u1B04\u1B35\u1B3B\u1B3D-\u1B41\u1B43\u1B44\u1B82\u1BA1\u1BA6\u1BA7\u1BAA\u1BE7\u1BEA-\u1BEC\u1BEE\u1BF2\u1BF3\u1C24-\u1C2B\u1C34\u1C35\u1CE1\u1CF2\u1CF3\u1CF7\u302E\u302F\uA823\uA824\uA827\uA880\uA881\uA8B4-\uA8C3\uA952\uA953\uA983\uA9B4\uA9B5\uA9BA\uA9BB\uA9BD-\uA9C0\uAA2F\uAA30\uAA33\uAA34\uAA4D\uAA7B\uAA7D\uAAEB\uAAEE\uAAEF\uAAF5\uABE3\uABE4\uABE6\uABE7\uABE9\uABEA\uABEC',
        'astral': '\uD804[\uDC00\uDC02\uDC82\uDCB0-\uDCB2\uDCB7\uDCB8\uDD2C\uDD82\uDDB3-\uDDB5\uDDBF\uDDC0\uDE2C-\uDE2E\uDE32\uDE33\uDE35\uDEE0-\uDEE2\uDF02\uDF03\uDF3E\uDF3F\uDF41-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF57\uDF62\uDF63]|\uD805[\uDC35-\uDC37\uDC40\uDC41\uDC45\uDCB0-\uDCB2\uDCB9\uDCBB-\uDCBE\uDCC1\uDDAF-\uDDB1\uDDB8-\uDDBB\uDDBE\uDE30-\uDE32\uDE3B\uDE3C\uDE3E\uDEAC\uDEAE\uDEAF\uDEB6\uDF20\uDF21\uDF26]|\uD806[\uDE07\uDE08\uDE39\uDE57\uDE58\uDE97]|\uD807[\uDC2F\uDC3E\uDCA9\uDCB1\uDCB4]|\uD81B[\uDF51-\uDF7E]|\uD834[\uDD65\uDD66\uDD6D-\uDD72]'
    },
    {
        'name': 'Me',
        'alias': 'Enclosing_Mark',
        'bmp': '\u0488\u0489\u1ABE\u20DD-\u20E0\u20E2-\u20E4\uA670-\uA672'
    },
    {
        'name': 'Mn',
        'alias': 'Nonspacing_Mark',
        'bmp': '\u0300-\u036F\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D4-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09C1-\u09C4\u09CD\u09E2\u09E3\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3F\u0B41-\u0B44\u0B4D\u0B56\u0B62\u0B63\u0B82\u0BC0\u0BCD\u0C00\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC6\u0CCC\u0CCD\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D41-\u0D44\u0D4D\u0D62\u0D63\u0DCA\u0DD2-\u0DD4\u0DD6\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1ABD\u1B00-\u1B03\u1B34\u1B36-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302D\u3099\u309A\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA8C4\uA8C5\uA8E0-\uA8F1\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F',
        'astral': '\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD804[\uDC01\uDC38-\uDC46\uDC7F-\uDC81\uDCB3-\uDCB6\uDCB9\uDCBA\uDD00-\uDD02\uDD27-\uDD2B\uDD2D-\uDD34\uDD73\uDD80\uDD81\uDDB6-\uDDBE\uDDCA-\uDDCC\uDE2F-\uDE31\uDE34\uDE36\uDE37\uDE3E\uDEDF\uDEE3-\uDEEA\uDF00\uDF01\uDF3C\uDF40\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC38-\uDC3F\uDC42-\uDC44\uDC46\uDCB3-\uDCB8\uDCBA\uDCBF\uDCC0\uDCC2\uDCC3\uDDB2-\uDDB5\uDDBC\uDDBD\uDDBF\uDDC0\uDDDC\uDDDD\uDE33-\uDE3A\uDE3D\uDE3F\uDE40\uDEAB\uDEAD\uDEB0-\uDEB5\uDEB7\uDF1D-\uDF1F\uDF22-\uDF25\uDF27-\uDF2B]|\uD806[\uDE01-\uDE06\uDE09\uDE0A\uDE33-\uDE38\uDE3B-\uDE3E\uDE47\uDE51-\uDE56\uDE59-\uDE5B\uDE8A-\uDE96\uDE98\uDE99]|\uD807[\uDC30-\uDC36\uDC38-\uDC3D\uDC3F\uDC92-\uDCA7\uDCAA-\uDCB0\uDCB2\uDCB3\uDCB5\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF8F-\uDF92]|\uD82F[\uDC9D\uDC9E]|\uD834[\uDD67-\uDD69\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uDB40[\uDD00-\uDDEF]'
    },
    {
        'name': 'N',
        'alias': 'Number',
        'bmp': '0-9\xB2\xB3\xB9\xBC-\xBE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D58-\u0D5E\u0D66-\u0D78\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19',
        'astral': '\uD800[\uDD07-\uDD33\uDD40-\uDD78\uDD8A\uDD8B\uDEE1-\uDEFB\uDF20-\uDF23\uDF41\uDF4A\uDFD1-\uDFD5]|\uD801[\uDCA0-\uDCA9]|\uD802[\uDC58-\uDC5F\uDC79-\uDC7F\uDCA7-\uDCAF\uDCFB-\uDCFF\uDD16-\uDD1B\uDDBC\uDDBD\uDDC0-\uDDCF\uDDD2-\uDDFF\uDE40-\uDE47\uDE7D\uDE7E\uDE9D-\uDE9F\uDEEB-\uDEEF\uDF58-\uDF5F\uDF78-\uDF7F\uDFA9-\uDFAF]|\uD803[\uDCFA-\uDCFF\uDE60-\uDE7E]|\uD804[\uDC52-\uDC6F\uDCF0-\uDCF9\uDD36-\uDD3F\uDDD0-\uDDD9\uDDE1-\uDDF4\uDEF0-\uDEF9]|\uD805[\uDC50-\uDC59\uDCD0-\uDCD9\uDE50-\uDE59\uDEC0-\uDEC9\uDF30-\uDF3B]|\uD806[\uDCE0-\uDCF2]|\uD807[\uDC50-\uDC6C\uDD50-\uDD59]|\uD809[\uDC00-\uDC6E]|\uD81A[\uDE60-\uDE69\uDF50-\uDF59\uDF5B-\uDF61]|\uD834[\uDF60-\uDF71]|\uD835[\uDFCE-\uDFFF]|\uD83A[\uDCC7-\uDCCF\uDD50-\uDD59]|\uD83C[\uDD00-\uDD0C]'
    },
    {
        'name': 'Nd',
        'alias': 'Decimal_Number',
        'bmp': '0-9\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0BE6-\u0BEF\u0C66-\u0C6F\u0CE6-\u0CEF\u0D66-\u0D6F\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F29\u1040-\u1049\u1090-\u1099\u17E0-\u17E9\u1810-\u1819\u1946-\u194F\u19D0-\u19D9\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\uA620-\uA629\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19',
        'astral': '\uD801[\uDCA0-\uDCA9]|\uD804[\uDC66-\uDC6F\uDCF0-\uDCF9\uDD36-\uDD3F\uDDD0-\uDDD9\uDEF0-\uDEF9]|\uD805[\uDC50-\uDC59\uDCD0-\uDCD9\uDE50-\uDE59\uDEC0-\uDEC9\uDF30-\uDF39]|\uD806[\uDCE0-\uDCE9]|\uD807[\uDC50-\uDC59\uDD50-\uDD59]|\uD81A[\uDE60-\uDE69\uDF50-\uDF59]|\uD835[\uDFCE-\uDFFF]|\uD83A[\uDD50-\uDD59]'
    },
    {
        'name': 'Nl',
        'alias': 'Letter_Number',
        'bmp': '\u16EE-\u16F0\u2160-\u2182\u2185-\u2188\u3007\u3021-\u3029\u3038-\u303A\uA6E6-\uA6EF',
        'astral': '\uD800[\uDD40-\uDD74\uDF41\uDF4A\uDFD1-\uDFD5]|\uD809[\uDC00-\uDC6E]'
    },
    {
        'name': 'No',
        'alias': 'Other_Number',
        'bmp': '\xB2\xB3\xB9\xBC-\xBE\u09F4-\u09F9\u0B72-\u0B77\u0BF0-\u0BF2\u0C78-\u0C7E\u0D58-\u0D5E\u0D70-\u0D78\u0F2A-\u0F33\u1369-\u137C\u17F0-\u17F9\u19DA\u2070\u2074-\u2079\u2080-\u2089\u2150-\u215F\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA830-\uA835',
        'astral': '\uD800[\uDD07-\uDD33\uDD75-\uDD78\uDD8A\uDD8B\uDEE1-\uDEFB\uDF20-\uDF23]|\uD802[\uDC58-\uDC5F\uDC79-\uDC7F\uDCA7-\uDCAF\uDCFB-\uDCFF\uDD16-\uDD1B\uDDBC\uDDBD\uDDC0-\uDDCF\uDDD2-\uDDFF\uDE40-\uDE47\uDE7D\uDE7E\uDE9D-\uDE9F\uDEEB-\uDEEF\uDF58-\uDF5F\uDF78-\uDF7F\uDFA9-\uDFAF]|\uD803[\uDCFA-\uDCFF\uDE60-\uDE7E]|\uD804[\uDC52-\uDC65\uDDE1-\uDDF4]|\uD805[\uDF3A\uDF3B]|\uD806[\uDCEA-\uDCF2]|\uD807[\uDC5A-\uDC6C]|\uD81A[\uDF5B-\uDF61]|\uD834[\uDF60-\uDF71]|\uD83A[\uDCC7-\uDCCF]|\uD83C[\uDD00-\uDD0C]'
    },
    {
        'name': 'P',
        'alias': 'Punctuation',
        'bmp': '!-#%-\\*,-\\/:;\\?@\\[-\\]_\\{\\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E49\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65',
        'astral': '\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC9\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]'
    },
    {
        'name': 'Pc',
        'alias': 'Connector_Punctuation',
        'bmp': '_\u203F\u2040\u2054\uFE33\uFE34\uFE4D-\uFE4F\uFF3F'
    },
    {
        'name': 'Pd',
        'alias': 'Dash_Punctuation',
        'bmp': '\\-\u058A\u05BE\u1400\u1806\u2010-\u2015\u2E17\u2E1A\u2E3A\u2E3B\u2E40\u301C\u3030\u30A0\uFE31\uFE32\uFE58\uFE63\uFF0D'
    },
    {
        'name': 'Pe',
        'alias': 'Close_Punctuation',
        'bmp': '\\)\\]\\}\u0F3B\u0F3D\u169C\u2046\u207E\u208E\u2309\u230B\u232A\u2769\u276B\u276D\u276F\u2771\u2773\u2775\u27C6\u27E7\u27E9\u27EB\u27ED\u27EF\u2984\u2986\u2988\u298A\u298C\u298E\u2990\u2992\u2994\u2996\u2998\u29D9\u29DB\u29FD\u2E23\u2E25\u2E27\u2E29\u3009\u300B\u300D\u300F\u3011\u3015\u3017\u3019\u301B\u301E\u301F\uFD3E\uFE18\uFE36\uFE38\uFE3A\uFE3C\uFE3E\uFE40\uFE42\uFE44\uFE48\uFE5A\uFE5C\uFE5E\uFF09\uFF3D\uFF5D\uFF60\uFF63'
    },
    {
        'name': 'Pf',
        'alias': 'Final_Punctuation',
        'bmp': '\xBB\u2019\u201D\u203A\u2E03\u2E05\u2E0A\u2E0D\u2E1D\u2E21'
    },
    {
        'name': 'Pi',
        'alias': 'Initial_Punctuation',
        'bmp': '\xAB\u2018\u201B\u201C\u201F\u2039\u2E02\u2E04\u2E09\u2E0C\u2E1C\u2E20'
    },
    {
        'name': 'Po',
        'alias': 'Other_Punctuation',
        'bmp': '!-#%-\'\\*,\\.\\/:;\\?@\\\xA1\xA7\xB6\xB7\xBF\u037E\u0387\u055A-\u055F\u0589\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u166D\u166E\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u1805\u1807-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2016\u2017\u2020-\u2027\u2030-\u2038\u203B-\u203E\u2041-\u2043\u2047-\u2051\u2053\u2055-\u205E\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00\u2E01\u2E06-\u2E08\u2E0B\u2E0E-\u2E16\u2E18\u2E19\u2E1B\u2E1E\u2E1F\u2E2A-\u2E2E\u2E30-\u2E39\u2E3C-\u2E3F\u2E41\u2E43-\u2E49\u3001-\u3003\u303D\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFE10-\uFE16\uFE19\uFE30\uFE45\uFE46\uFE49-\uFE4C\uFE50-\uFE52\uFE54-\uFE57\uFE5F-\uFE61\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF07\uFF0A\uFF0C\uFF0E\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3C\uFF61\uFF64\uFF65',
        'astral': '\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC9\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]'
    },
    {
        'name': 'Ps',
        'alias': 'Open_Punctuation',
        'bmp': '\\(\\[\\{\u0F3A\u0F3C\u169B\u201A\u201E\u2045\u207D\u208D\u2308\u230A\u2329\u2768\u276A\u276C\u276E\u2770\u2772\u2774\u27C5\u27E6\u27E8\u27EA\u27EC\u27EE\u2983\u2985\u2987\u2989\u298B\u298D\u298F\u2991\u2993\u2995\u2997\u29D8\u29DA\u29FC\u2E22\u2E24\u2E26\u2E28\u2E42\u3008\u300A\u300C\u300E\u3010\u3014\u3016\u3018\u301A\u301D\uFD3F\uFE17\uFE35\uFE37\uFE39\uFE3B\uFE3D\uFE3F\uFE41\uFE43\uFE47\uFE59\uFE5B\uFE5D\uFF08\uFF3B\uFF5B\uFF5F\uFF62'
    },
    {
        'name': 'S',
        'alias': 'Symbol',
        'bmp': '\\$\\+<->\\^`\\|~\xA2-\xA6\xA8\xA9\xAC\xAE-\xB1\xB4\xB8\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0384\u0385\u03F6\u0482\u058D-\u058F\u0606-\u0608\u060B\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u09F2\u09F3\u09FA\u09FB\u0AF1\u0B70\u0BF3-\u0BFA\u0C7F\u0D4F\u0D79\u0E3F\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u17DB\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2044\u2052\u207A-\u207C\u208A-\u208C\u20A0-\u20BF\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A\u218B\u2190-\u2307\u230C-\u2328\u232B-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u2767\u2794-\u27C4\u27C7-\u27E5\u27F0-\u2982\u2999-\u29D7\u29DC-\u29FB\u29FE-\u2B73\u2B76-\u2B95\u2B98-\u2BB9\u2BBD-\u2BC8\u2BCA-\u2BD2\u2BEC-\u2BEF\u2CE5-\u2CEA\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFB\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u309B\u309C\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u32FE\u3300-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA700-\uA716\uA720\uA721\uA789\uA78A\uA828-\uA82B\uA836-\uA839\uAA77-\uAA79\uAB5B\uFB29\uFBB2-\uFBC1\uFDFC\uFDFD\uFE62\uFE64-\uFE66\uFE69\uFF04\uFF0B\uFF1C-\uFF1E\uFF3E\uFF40\uFF5C\uFF5E\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFFC\uFFFD',
        'astral': '\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9B\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|\uD805\uDF3F|\uD81A[\uDF3C-\uDF3F\uDF45]|\uD82F\uDC9C|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDE8\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD83B[\uDEF0\uDEF1]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD10-\uDD2E\uDD30-\uDD6B\uDD70-\uDDAC\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED4\uDEE0-\uDEEC\uDEF0-\uDEF8\uDF00-\uDF73\uDF80-\uDFD4]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDD00-\uDD0B\uDD10-\uDD3E\uDD40-\uDD4C\uDD50-\uDD6B\uDD80-\uDD97\uDDC0\uDDD0-\uDDE6]'
    },
    {
        'name': 'Sc',
        'alias': 'Currency_Symbol',
        'bmp': '\\$\xA2-\xA5\u058F\u060B\u09F2\u09F3\u09FB\u0AF1\u0BF9\u0E3F\u17DB\u20A0-\u20BF\uA838\uFDFC\uFE69\uFF04\uFFE0\uFFE1\uFFE5\uFFE6'
    },
    {
        'name': 'Sk',
        'alias': 'Modifier_Symbol',
        'bmp': '\\^`\xA8\xAF\xB4\xB8\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0384\u0385\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u309B\u309C\uA700-\uA716\uA720\uA721\uA789\uA78A\uAB5B\uFBB2-\uFBC1\uFF3E\uFF40\uFFE3',
        'astral': '\uD83C[\uDFFB-\uDFFF]'
    },
    {
        'name': 'Sm',
        'alias': 'Math_Symbol',
        'bmp': '\\+<->\\|~\xAC\xB1\xD7\xF7\u03F6\u0606-\u0608\u2044\u2052\u207A-\u207C\u208A-\u208C\u2118\u2140-\u2144\u214B\u2190-\u2194\u219A\u219B\u21A0\u21A3\u21A6\u21AE\u21CE\u21CF\u21D2\u21D4\u21F4-\u22FF\u2320\u2321\u237C\u239B-\u23B3\u23DC-\u23E1\u25B7\u25C1\u25F8-\u25FF\u266F\u27C0-\u27C4\u27C7-\u27E5\u27F0-\u27FF\u2900-\u2982\u2999-\u29D7\u29DC-\u29FB\u29FE-\u2AFF\u2B30-\u2B44\u2B47-\u2B4C\uFB29\uFE62\uFE64-\uFE66\uFF0B\uFF1C-\uFF1E\uFF5C\uFF5E\uFFE2\uFFE9-\uFFEC',
        'astral': '\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD83B[\uDEF0\uDEF1]'
    },
    {
        'name': 'So',
        'alias': 'Other_Symbol',
        'bmp': '\xA6\xA9\xAE\xB0\u0482\u058D\u058E\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u09FA\u0B70\u0BF3-\u0BF8\u0BFA\u0C7F\u0D4F\u0D79\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116\u2117\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u214A\u214C\u214D\u214F\u218A\u218B\u2195-\u2199\u219C-\u219F\u21A1\u21A2\u21A4\u21A5\u21A7-\u21AD\u21AF-\u21CD\u21D0\u21D1\u21D3\u21D5-\u21F3\u2300-\u2307\u230C-\u231F\u2322-\u2328\u232B-\u237B\u237D-\u239A\u23B4-\u23DB\u23E2-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u25B6\u25B8-\u25C0\u25C2-\u25F7\u2600-\u266E\u2670-\u2767\u2794-\u27BF\u2800-\u28FF\u2B00-\u2B2F\u2B45\u2B46\u2B4D-\u2B73\u2B76-\u2B95\u2B98-\u2BB9\u2BBD-\u2BC8\u2BCA-\u2BD2\u2BEC-\u2BEF\u2CE5-\u2CEA\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFB\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u32FE\u3300-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA828-\uA82B\uA836\uA837\uA839\uAA77-\uAA79\uFDFD\uFFE4\uFFE8\uFFED\uFFEE\uFFFC\uFFFD',
        'astral': '\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9B\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|\uD805\uDF3F|\uD81A[\uDF3C-\uDF3F\uDF45]|\uD82F\uDC9C|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDE8\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD10-\uDD2E\uDD30-\uDD6B\uDD70-\uDDAC\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFA]|\uD83D[\uDC00-\uDED4\uDEE0-\uDEEC\uDEF0-\uDEF8\uDF00-\uDF73\uDF80-\uDFD4]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDD00-\uDD0B\uDD10-\uDD3E\uDD40-\uDD4C\uDD50-\uDD6B\uDD80-\uDD97\uDDC0\uDDD0-\uDDE6]'
    },
    {
        'name': 'Z',
        'alias': 'Separator',
        'bmp': ' \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000'
    },
    {
        'name': 'Zl',
        'alias': 'Line_Separator',
        'bmp': '\u2028'
    },
    {
        'name': 'Zp',
        'alias': 'Paragraph_Separator',
        'bmp': '\u2029'
    },
    {
        'name': 'Zs',
        'alias': 'Space_Separator',
        'bmp': ' \xA0\u1680\u2000-\u200A\u202F\u205F\u3000'
    }
];


/***/ }),
/* 98 */
/***/ (function(module, exports) {

module.exports = [
    {
        'name': 'ASCII',
        'bmp': '\0-\x7F'
    },
    {
        'name': 'Alphabetic',
        'bmp': 'A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0345\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05B0-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0657\u0659-\u065F\u066E-\u06D3\u06D5-\u06DC\u06E1-\u06E8\u06ED-\u06EF\u06FA-\u06FC\u06FF\u0710-\u073F\u074D-\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0817\u081A-\u082C\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u08D4-\u08DF\u08E3-\u08E9\u08F0-\u093B\u093D-\u094C\u094E-\u0950\u0955-\u0963\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD-\u09C4\u09C7\u09C8\u09CB\u09CC\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09F0\u09F1\u09FC\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3E-\u0A42\u0A47\u0A48\u0A4B\u0A4C\u0A51\u0A59-\u0A5C\u0A5E\u0A70-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD-\u0AC5\u0AC7-\u0AC9\u0ACB\u0ACC\u0AD0\u0AE0-\u0AE3\u0AF9-\u0AFC\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D-\u0B44\u0B47\u0B48\u0B4B\u0B4C\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0BD0\u0BD7\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4C\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCC\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CF1\u0CF2\u0D00-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4C\u0D4E\u0D54-\u0D57\u0D5F-\u0D63\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E46\u0E4D\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0ECD\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F71-\u0F81\u0F88-\u0F97\u0F99-\u0FBC\u1000-\u1036\u1038\u103B-\u103F\u1050-\u1062\u1065-\u1068\u106E-\u1086\u108E\u109C\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135F\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1713\u1720-\u1733\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17B3\u17B6-\u17C8\u17D7\u17DC\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u1938\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A1B\u1A20-\u1A5E\u1A61-\u1A74\u1AA7\u1B00-\u1B33\u1B35-\u1B43\u1B45-\u1B4B\u1B80-\u1BA9\u1BAC-\u1BAF\u1BBA-\u1BE5\u1BE7-\u1BF1\u1C00-\u1C35\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1D00-\u1DBF\u1DE7-\u1DF4\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u24B6-\u24E9\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312E\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEA\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA674-\uA67B\uA67F-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA827\uA840-\uA873\uA880-\uA8C3\uA8C5\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA92A\uA930-\uA952\uA960-\uA97C\uA980-\uA9B2\uA9B4-\uA9BF\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA60-\uAA76\uAA7A\uAA7E-\uAABE\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF5\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC',
        'astral': '\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF4A\uDF50-\uDF7A\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC00-\uDC45\uDC82-\uDCB8\uDCD0-\uDCE8\uDD00-\uDD32\uDD50-\uDD72\uDD76\uDD80-\uDDBF\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE34\uDE37\uDE3E\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEE8\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D-\uDF44\uDF47\uDF48\uDF4B\uDF4C\uDF50\uDF57\uDF5D-\uDF63]|\uD805[\uDC00-\uDC41\uDC43-\uDC45\uDC47-\uDC4A\uDC80-\uDCC1\uDCC4\uDCC5\uDCC7\uDD80-\uDDB5\uDDB8-\uDDBE\uDDD8-\uDDDD\uDE00-\uDE3E\uDE40\uDE44\uDE80-\uDEB5\uDF00-\uDF19\uDF1D-\uDF2A]|\uD806[\uDCA0-\uDCDF\uDCFF\uDE00-\uDE32\uDE35-\uDE3E\uDE50-\uDE83\uDE86-\uDE97\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC36\uDC38-\uDC3E\uDC40\uDC72-\uDC8F\uDC92-\uDCA7\uDCA9-\uDCB6\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD41\uDD43\uDD46\uDD47]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF36\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50-\uDF7E\uDF93-\uDF9F\uDFE0\uDFE1]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00-\uDD1E\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9E]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD47]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD83C[\uDD30-\uDD49\uDD50-\uDD69\uDD70-\uDD89]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]'
    },
    {
        'name': 'Any',
        'isBmpLast': true,
        'bmp': '\0-\uFFFF',
        'astral': '[\uD800-\uDBFF][\uDC00-\uDFFF]'
    },
    {
        'name': 'Default_Ignorable_Code_Point',
        'bmp': '\xAD\u034F\u061C\u115F\u1160\u17B4\u17B5\u180B-\u180E\u200B-\u200F\u202A-\u202E\u2060-\u206F\u3164\uFE00-\uFE0F\uFEFF\uFFA0\uFFF0-\uFFF8',
        'astral': '\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|[\uDB40-\uDB43][\uDC00-\uDFFF]'
    },
    {
        'name': 'Lowercase',
        'bmp': 'a-z\xAA\xB5\xBA\xDF-\xF6\xF8-\xFF\u0101\u0103\u0105\u0107\u0109\u010B\u010D\u010F\u0111\u0113\u0115\u0117\u0119\u011B\u011D\u011F\u0121\u0123\u0125\u0127\u0129\u012B\u012D\u012F\u0131\u0133\u0135\u0137\u0138\u013A\u013C\u013E\u0140\u0142\u0144\u0146\u0148\u0149\u014B\u014D\u014F\u0151\u0153\u0155\u0157\u0159\u015B\u015D\u015F\u0161\u0163\u0165\u0167\u0169\u016B\u016D\u016F\u0171\u0173\u0175\u0177\u017A\u017C\u017E-\u0180\u0183\u0185\u0188\u018C\u018D\u0192\u0195\u0199-\u019B\u019E\u01A1\u01A3\u01A5\u01A8\u01AA\u01AB\u01AD\u01B0\u01B4\u01B6\u01B9\u01BA\u01BD-\u01BF\u01C6\u01C9\u01CC\u01CE\u01D0\u01D2\u01D4\u01D6\u01D8\u01DA\u01DC\u01DD\u01DF\u01E1\u01E3\u01E5\u01E7\u01E9\u01EB\u01ED\u01EF\u01F0\u01F3\u01F5\u01F9\u01FB\u01FD\u01FF\u0201\u0203\u0205\u0207\u0209\u020B\u020D\u020F\u0211\u0213\u0215\u0217\u0219\u021B\u021D\u021F\u0221\u0223\u0225\u0227\u0229\u022B\u022D\u022F\u0231\u0233-\u0239\u023C\u023F\u0240\u0242\u0247\u0249\u024B\u024D\u024F-\u0293\u0295-\u02B8\u02C0\u02C1\u02E0-\u02E4\u0345\u0371\u0373\u0377\u037A-\u037D\u0390\u03AC-\u03CE\u03D0\u03D1\u03D5-\u03D7\u03D9\u03DB\u03DD\u03DF\u03E1\u03E3\u03E5\u03E7\u03E9\u03EB\u03ED\u03EF-\u03F3\u03F5\u03F8\u03FB\u03FC\u0430-\u045F\u0461\u0463\u0465\u0467\u0469\u046B\u046D\u046F\u0471\u0473\u0475\u0477\u0479\u047B\u047D\u047F\u0481\u048B\u048D\u048F\u0491\u0493\u0495\u0497\u0499\u049B\u049D\u049F\u04A1\u04A3\u04A5\u04A7\u04A9\u04AB\u04AD\u04AF\u04B1\u04B3\u04B5\u04B7\u04B9\u04BB\u04BD\u04BF\u04C2\u04C4\u04C6\u04C8\u04CA\u04CC\u04CE\u04CF\u04D1\u04D3\u04D5\u04D7\u04D9\u04DB\u04DD\u04DF\u04E1\u04E3\u04E5\u04E7\u04E9\u04EB\u04ED\u04EF\u04F1\u04F3\u04F5\u04F7\u04F9\u04FB\u04FD\u04FF\u0501\u0503\u0505\u0507\u0509\u050B\u050D\u050F\u0511\u0513\u0515\u0517\u0519\u051B\u051D\u051F\u0521\u0523\u0525\u0527\u0529\u052B\u052D\u052F\u0561-\u0587\u13F8-\u13FD\u1C80-\u1C88\u1D00-\u1DBF\u1E01\u1E03\u1E05\u1E07\u1E09\u1E0B\u1E0D\u1E0F\u1E11\u1E13\u1E15\u1E17\u1E19\u1E1B\u1E1D\u1E1F\u1E21\u1E23\u1E25\u1E27\u1E29\u1E2B\u1E2D\u1E2F\u1E31\u1E33\u1E35\u1E37\u1E39\u1E3B\u1E3D\u1E3F\u1E41\u1E43\u1E45\u1E47\u1E49\u1E4B\u1E4D\u1E4F\u1E51\u1E53\u1E55\u1E57\u1E59\u1E5B\u1E5D\u1E5F\u1E61\u1E63\u1E65\u1E67\u1E69\u1E6B\u1E6D\u1E6F\u1E71\u1E73\u1E75\u1E77\u1E79\u1E7B\u1E7D\u1E7F\u1E81\u1E83\u1E85\u1E87\u1E89\u1E8B\u1E8D\u1E8F\u1E91\u1E93\u1E95-\u1E9D\u1E9F\u1EA1\u1EA3\u1EA5\u1EA7\u1EA9\u1EAB\u1EAD\u1EAF\u1EB1\u1EB3\u1EB5\u1EB7\u1EB9\u1EBB\u1EBD\u1EBF\u1EC1\u1EC3\u1EC5\u1EC7\u1EC9\u1ECB\u1ECD\u1ECF\u1ED1\u1ED3\u1ED5\u1ED7\u1ED9\u1EDB\u1EDD\u1EDF\u1EE1\u1EE3\u1EE5\u1EE7\u1EE9\u1EEB\u1EED\u1EEF\u1EF1\u1EF3\u1EF5\u1EF7\u1EF9\u1EFB\u1EFD\u1EFF-\u1F07\u1F10-\u1F15\u1F20-\u1F27\u1F30-\u1F37\u1F40-\u1F45\u1F50-\u1F57\u1F60-\u1F67\u1F70-\u1F7D\u1F80-\u1F87\u1F90-\u1F97\u1FA0-\u1FA7\u1FB0-\u1FB4\u1FB6\u1FB7\u1FBE\u1FC2-\u1FC4\u1FC6\u1FC7\u1FD0-\u1FD3\u1FD6\u1FD7\u1FE0-\u1FE7\u1FF2-\u1FF4\u1FF6\u1FF7\u2071\u207F\u2090-\u209C\u210A\u210E\u210F\u2113\u212F\u2134\u2139\u213C\u213D\u2146-\u2149\u214E\u2170-\u217F\u2184\u24D0-\u24E9\u2C30-\u2C5E\u2C61\u2C65\u2C66\u2C68\u2C6A\u2C6C\u2C71\u2C73\u2C74\u2C76-\u2C7D\u2C81\u2C83\u2C85\u2C87\u2C89\u2C8B\u2C8D\u2C8F\u2C91\u2C93\u2C95\u2C97\u2C99\u2C9B\u2C9D\u2C9F\u2CA1\u2CA3\u2CA5\u2CA7\u2CA9\u2CAB\u2CAD\u2CAF\u2CB1\u2CB3\u2CB5\u2CB7\u2CB9\u2CBB\u2CBD\u2CBF\u2CC1\u2CC3\u2CC5\u2CC7\u2CC9\u2CCB\u2CCD\u2CCF\u2CD1\u2CD3\u2CD5\u2CD7\u2CD9\u2CDB\u2CDD\u2CDF\u2CE1\u2CE3\u2CE4\u2CEC\u2CEE\u2CF3\u2D00-\u2D25\u2D27\u2D2D\uA641\uA643\uA645\uA647\uA649\uA64B\uA64D\uA64F\uA651\uA653\uA655\uA657\uA659\uA65B\uA65D\uA65F\uA661\uA663\uA665\uA667\uA669\uA66B\uA66D\uA681\uA683\uA685\uA687\uA689\uA68B\uA68D\uA68F\uA691\uA693\uA695\uA697\uA699\uA69B-\uA69D\uA723\uA725\uA727\uA729\uA72B\uA72D\uA72F-\uA731\uA733\uA735\uA737\uA739\uA73B\uA73D\uA73F\uA741\uA743\uA745\uA747\uA749\uA74B\uA74D\uA74F\uA751\uA753\uA755\uA757\uA759\uA75B\uA75D\uA75F\uA761\uA763\uA765\uA767\uA769\uA76B\uA76D\uA76F-\uA778\uA77A\uA77C\uA77F\uA781\uA783\uA785\uA787\uA78C\uA78E\uA791\uA793-\uA795\uA797\uA799\uA79B\uA79D\uA79F\uA7A1\uA7A3\uA7A5\uA7A7\uA7A9\uA7B5\uA7B7\uA7F8-\uA7FA\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABBF\uFB00-\uFB06\uFB13-\uFB17\uFF41-\uFF5A',
        'astral': '\uD801[\uDC28-\uDC4F\uDCD8-\uDCFB]|\uD803[\uDCC0-\uDCF2]|\uD806[\uDCC0-\uDCDF]|\uD835[\uDC1A-\uDC33\uDC4E-\uDC54\uDC56-\uDC67\uDC82-\uDC9B\uDCB6-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDCCF\uDCEA-\uDD03\uDD1E-\uDD37\uDD52-\uDD6B\uDD86-\uDD9F\uDDBA-\uDDD3\uDDEE-\uDE07\uDE22-\uDE3B\uDE56-\uDE6F\uDE8A-\uDEA5\uDEC2-\uDEDA\uDEDC-\uDEE1\uDEFC-\uDF14\uDF16-\uDF1B\uDF36-\uDF4E\uDF50-\uDF55\uDF70-\uDF88\uDF8A-\uDF8F\uDFAA-\uDFC2\uDFC4-\uDFC9\uDFCB]|\uD83A[\uDD22-\uDD43]'
    },
    {
        'name': 'Noncharacter_Code_Point',
        'bmp': '\uFDD0-\uFDEF\uFFFE\uFFFF',
        'astral': '[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F\uDBBF\uDBFF][\uDFFE\uDFFF]'
    },
    {
        'name': 'Uppercase',
        'bmp': 'A-Z\xC0-\xD6\xD8-\xDE\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C7\u01CA\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0370\u0372\u0376\u037F\u0386\u0388-\u038A\u038C\u038E\u038F\u0391-\u03A1\u03A3-\u03AB\u03CF\u03D2-\u03D4\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F4\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0528\u052A\u052C\u052E\u0531-\u0556\u10A0-\u10C5\u10C7\u10CD\u13A0-\u13F5\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1FB8-\u1FBB\u1FC8-\u1FCB\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF8-\u1FFB\u2102\u2107\u210B-\u210D\u2110-\u2112\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u2130-\u2133\u213E\u213F\u2145\u2160-\u216F\u2183\u24B6-\u24CF\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA698\uA69A\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA796\uA798\uA79A\uA79C\uA79E\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA-\uA7AE\uA7B0-\uA7B4\uA7B6\uFF21-\uFF3A',
        'astral': '\uD801[\uDC00-\uDC27\uDCB0-\uDCD3]|\uD803[\uDC80-\uDCB2]|\uD806[\uDCA0-\uDCBF]|\uD835[\uDC00-\uDC19\uDC34-\uDC4D\uDC68-\uDC81\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB5\uDCD0-\uDCE9\uDD04\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD38\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD6C-\uDD85\uDDA0-\uDDB9\uDDD4-\uDDED\uDE08-\uDE21\uDE3C-\uDE55\uDE70-\uDE89\uDEA8-\uDEC0\uDEE2-\uDEFA\uDF1C-\uDF34\uDF56-\uDF6E\uDF90-\uDFA8\uDFCA]|\uD83A[\uDD00-\uDD21]|\uD83C[\uDD30-\uDD49\uDD50-\uDD69\uDD70-\uDD89]'
    },
    {
        'name': 'White_Space',
        'bmp': '\t-\r \x85\xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000'
    }
];


/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports = [
    {
        'name': 'Adlam',
        'astral': '\uD83A[\uDD00-\uDD4A\uDD50-\uDD59\uDD5E\uDD5F]'
    },
    {
        'name': 'Ahom',
        'astral': '\uD805[\uDF00-\uDF19\uDF1D-\uDF2B\uDF30-\uDF3F]'
    },
    {
        'name': 'Anatolian_Hieroglyphs',
        'astral': '\uD811[\uDC00-\uDE46]'
    },
    {
        'name': 'Arabic',
        'bmp': '\u0600-\u0604\u0606-\u060B\u060D-\u061A\u061C\u061E\u0620-\u063F\u0641-\u064A\u0656-\u066F\u0671-\u06DC\u06DE-\u06FF\u0750-\u077F\u08A0-\u08B4\u08B6-\u08BD\u08D4-\u08E1\u08E3-\u08FF\uFB50-\uFBC1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFD\uFE70-\uFE74\uFE76-\uFEFC',
        'astral': '\uD803[\uDE60-\uDE7E]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB\uDEF0\uDEF1]'
    },
    {
        'name': 'Armenian',
        'bmp': '\u0531-\u0556\u0559-\u055F\u0561-\u0587\u058A\u058D-\u058F\uFB13-\uFB17'
    },
    {
        'name': 'Avestan',
        'astral': '\uD802[\uDF00-\uDF35\uDF39-\uDF3F]'
    },
    {
        'name': 'Balinese',
        'bmp': '\u1B00-\u1B4B\u1B50-\u1B7C'
    },
    {
        'name': 'Bamum',
        'bmp': '\uA6A0-\uA6F7',
        'astral': '\uD81A[\uDC00-\uDE38]'
    },
    {
        'name': 'Bassa_Vah',
        'astral': '\uD81A[\uDED0-\uDEED\uDEF0-\uDEF5]'
    },
    {
        'name': 'Batak',
        'bmp': '\u1BC0-\u1BF3\u1BFC-\u1BFF'
    },
    {
        'name': 'Bengali',
        'bmp': '\u0980-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09FD'
    },
    {
        'name': 'Bhaiksuki',
        'astral': '\uD807[\uDC00-\uDC08\uDC0A-\uDC36\uDC38-\uDC45\uDC50-\uDC6C]'
    },
    {
        'name': 'Bopomofo',
        'bmp': '\u02EA\u02EB\u3105-\u312E\u31A0-\u31BA'
    },
    {
        'name': 'Brahmi',
        'astral': '\uD804[\uDC00-\uDC4D\uDC52-\uDC6F\uDC7F]'
    },
    {
        'name': 'Braille',
        'bmp': '\u2800-\u28FF'
    },
    {
        'name': 'Buginese',
        'bmp': '\u1A00-\u1A1B\u1A1E\u1A1F'
    },
    {
        'name': 'Buhid',
        'bmp': '\u1740-\u1753'
    },
    {
        'name': 'Canadian_Aboriginal',
        'bmp': '\u1400-\u167F\u18B0-\u18F5'
    },
    {
        'name': 'Carian',
        'astral': '\uD800[\uDEA0-\uDED0]'
    },
    {
        'name': 'Caucasian_Albanian',
        'astral': '\uD801[\uDD30-\uDD63\uDD6F]'
    },
    {
        'name': 'Chakma',
        'astral': '\uD804[\uDD00-\uDD34\uDD36-\uDD43]'
    },
    {
        'name': 'Cham',
        'bmp': '\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA5C-\uAA5F'
    },
    {
        'name': 'Cherokee',
        'bmp': '\u13A0-\u13F5\u13F8-\u13FD\uAB70-\uABBF'
    },
    {
        'name': 'Common',
        'bmp': '\0-@\\[-`\\{-\xA9\xAB-\xB9\xBB-\xBF\xD7\xF7\u02B9-\u02DF\u02E5-\u02E9\u02EC-\u02FF\u0374\u037E\u0385\u0387\u0589\u0605\u060C\u061B\u061F\u0640\u06DD\u08E2\u0964\u0965\u0E3F\u0FD5-\u0FD8\u10FB\u16EB-\u16ED\u1735\u1736\u1802\u1803\u1805\u1CD3\u1CE1\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5-\u1CF7\u2000-\u200B\u200E-\u2064\u2066-\u2070\u2074-\u207E\u2080-\u208E\u20A0-\u20BF\u2100-\u2125\u2127-\u2129\u212C-\u2131\u2133-\u214D\u214F-\u215F\u2189-\u218B\u2190-\u2426\u2440-\u244A\u2460-\u27FF\u2900-\u2B73\u2B76-\u2B95\u2B98-\u2BB9\u2BBD-\u2BC8\u2BCA-\u2BD2\u2BEC-\u2BEF\u2E00-\u2E49\u2FF0-\u2FFB\u3000-\u3004\u3006\u3008-\u3020\u3030-\u3037\u303C-\u303F\u309B\u309C\u30A0\u30FB\u30FC\u3190-\u319F\u31C0-\u31E3\u3220-\u325F\u327F-\u32CF\u3358-\u33FF\u4DC0-\u4DFF\uA700-\uA721\uA788-\uA78A\uA830-\uA839\uA92E\uA9CF\uAB5B\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE66\uFE68-\uFE6B\uFEFF\uFF01-\uFF20\uFF3B-\uFF40\uFF5B-\uFF65\uFF70\uFF9E\uFF9F\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFF9-\uFFFD',
        'astral': '\uD800[\uDD00-\uDD02\uDD07-\uDD33\uDD37-\uDD3F\uDD90-\uDD9B\uDDD0-\uDDFC\uDEE1-\uDEFB]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD66\uDD6A-\uDD7A\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDE8\uDF00-\uDF56\uDF60-\uDF71]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDFCB\uDFCE-\uDFFF]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD00-\uDD0C\uDD10-\uDD2E\uDD30-\uDD6B\uDD70-\uDDAC\uDDE6-\uDDFF\uDE01\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED4\uDEE0-\uDEEC\uDEF0-\uDEF8\uDF00-\uDF73\uDF80-\uDFD4]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDD00-\uDD0B\uDD10-\uDD3E\uDD40-\uDD4C\uDD50-\uDD6B\uDD80-\uDD97\uDDC0\uDDD0-\uDDE6]|\uDB40[\uDC01\uDC20-\uDC7F]'
    },
    {
        'name': 'Coptic',
        'bmp': '\u03E2-\u03EF\u2C80-\u2CF3\u2CF9-\u2CFF'
    },
    {
        'name': 'Cuneiform',
        'astral': '\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC70-\uDC74\uDC80-\uDD43]'
    },
    {
        'name': 'Cypriot',
        'astral': '\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F]'
    },
    {
        'name': 'Cyrillic',
        'bmp': '\u0400-\u0484\u0487-\u052F\u1C80-\u1C88\u1D2B\u1D78\u2DE0-\u2DFF\uA640-\uA69F\uFE2E\uFE2F'
    },
    {
        'name': 'Deseret',
        'astral': '\uD801[\uDC00-\uDC4F]'
    },
    {
        'name': 'Devanagari',
        'bmp': '\u0900-\u0950\u0953-\u0963\u0966-\u097F\uA8E0-\uA8FD'
    },
    {
        'name': 'Duployan',
        'astral': '\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9C-\uDC9F]'
    },
    {
        'name': 'Egyptian_Hieroglyphs',
        'astral': '\uD80C[\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]'
    },
    {
        'name': 'Elbasan',
        'astral': '\uD801[\uDD00-\uDD27]'
    },
    {
        'name': 'Ethiopic',
        'bmp': '\u1200-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u137C\u1380-\u1399\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E'
    },
    {
        'name': 'Georgian',
        'bmp': '\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u10FF\u2D00-\u2D25\u2D27\u2D2D'
    },
    {
        'name': 'Glagolitic',
        'bmp': '\u2C00-\u2C2E\u2C30-\u2C5E',
        'astral': '\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A]'
    },
    {
        'name': 'Gothic',
        'astral': '\uD800[\uDF30-\uDF4A]'
    },
    {
        'name': 'Grantha',
        'astral': '\uD804[\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3C-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF50\uDF57\uDF5D-\uDF63\uDF66-\uDF6C\uDF70-\uDF74]'
    },
    {
        'name': 'Greek',
        'bmp': '\u0370-\u0373\u0375-\u0377\u037A-\u037D\u037F\u0384\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03E1\u03F0-\u03FF\u1D26-\u1D2A\u1D5D-\u1D61\u1D66-\u1D6A\u1DBF\u1F00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FC4\u1FC6-\u1FD3\u1FD6-\u1FDB\u1FDD-\u1FEF\u1FF2-\u1FF4\u1FF6-\u1FFE\u2126\uAB65',
        'astral': '\uD800[\uDD40-\uDD8E\uDDA0]|\uD834[\uDE00-\uDE45]'
    },
    {
        'name': 'Gujarati',
        'bmp': '\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AF1\u0AF9-\u0AFF'
    },
    {
        'name': 'Gurmukhi',
        'bmp': '\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75'
    },
    {
        'name': 'Han',
        'bmp': '\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u3005\u3007\u3021-\u3029\u3038-\u303B\u3400-\u4DB5\u4E00-\u9FEA\uF900-\uFA6D\uFA70-\uFAD9',
        'astral': '[\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879][\uDC00-\uDFFF]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]'
    },
    {
        'name': 'Hangul',
        'bmp': '\u1100-\u11FF\u302E\u302F\u3131-\u318E\u3200-\u321E\u3260-\u327E\uA960-\uA97C\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uFFA0-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC'
    },
    {
        'name': 'Hanunoo',
        'bmp': '\u1720-\u1734'
    },
    {
        'name': 'Hatran',
        'astral': '\uD802[\uDCE0-\uDCF2\uDCF4\uDCF5\uDCFB-\uDCFF]'
    },
    {
        'name': 'Hebrew',
        'bmp': '\u0591-\u05C7\u05D0-\u05EA\u05F0-\u05F4\uFB1D-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFB4F'
    },
    {
        'name': 'Hiragana',
        'bmp': '\u3041-\u3096\u309D-\u309F',
        'astral': '\uD82C[\uDC01-\uDD1E]|\uD83C\uDE00'
    },
    {
        'name': 'Imperial_Aramaic',
        'astral': '\uD802[\uDC40-\uDC55\uDC57-\uDC5F]'
    },
    {
        'name': 'Inherited',
        'bmp': '\u0300-\u036F\u0485\u0486\u064B-\u0655\u0670\u0951\u0952\u1AB0-\u1ABE\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u200C\u200D\u20D0-\u20F0\u302A-\u302D\u3099\u309A\uFE00-\uFE0F\uFE20-\uFE2D',
        'astral': '\uD800[\uDDFD\uDEE0]|\uD834[\uDD67-\uDD69\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD]|\uDB40[\uDD00-\uDDEF]'
    },
    {
        'name': 'Inscriptional_Pahlavi',
        'astral': '\uD802[\uDF60-\uDF72\uDF78-\uDF7F]'
    },
    {
        'name': 'Inscriptional_Parthian',
        'astral': '\uD802[\uDF40-\uDF55\uDF58-\uDF5F]'
    },
    {
        'name': 'Javanese',
        'bmp': '\uA980-\uA9CD\uA9D0-\uA9D9\uA9DE\uA9DF'
    },
    {
        'name': 'Kaithi',
        'astral': '\uD804[\uDC80-\uDCC1]'
    },
    {
        'name': 'Kannada',
        'bmp': '\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2'
    },
    {
        'name': 'Katakana',
        'bmp': '\u30A1-\u30FA\u30FD-\u30FF\u31F0-\u31FF\u32D0-\u32FE\u3300-\u3357\uFF66-\uFF6F\uFF71-\uFF9D',
        'astral': '\uD82C\uDC00'
    },
    {
        'name': 'Kayah_Li',
        'bmp': '\uA900-\uA92D\uA92F'
    },
    {
        'name': 'Kharoshthi',
        'astral': '\uD802[\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE38-\uDE3A\uDE3F-\uDE47\uDE50-\uDE58]'
    },
    {
        'name': 'Khmer',
        'bmp': '\u1780-\u17DD\u17E0-\u17E9\u17F0-\u17F9\u19E0-\u19FF'
    },
    {
        'name': 'Khojki',
        'astral': '\uD804[\uDE00-\uDE11\uDE13-\uDE3E]'
    },
    {
        'name': 'Khudawadi',
        'astral': '\uD804[\uDEB0-\uDEEA\uDEF0-\uDEF9]'
    },
    {
        'name': 'Lao',
        'bmp': '\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF'
    },
    {
        'name': 'Latin',
        'bmp': 'A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A'
    },
    {
        'name': 'Lepcha',
        'bmp': '\u1C00-\u1C37\u1C3B-\u1C49\u1C4D-\u1C4F'
    },
    {
        'name': 'Limbu',
        'bmp': '\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1940\u1944-\u194F'
    },
    {
        'name': 'Linear_A',
        'astral': '\uD801[\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]'
    },
    {
        'name': 'Linear_B',
        'astral': '\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA]'
    },
    {
        'name': 'Lisu',
        'bmp': '\uA4D0-\uA4FF'
    },
    {
        'name': 'Lycian',
        'astral': '\uD800[\uDE80-\uDE9C]'
    },
    {
        'name': 'Lydian',
        'astral': '\uD802[\uDD20-\uDD39\uDD3F]'
    },
    {
        'name': 'Mahajani',
        'astral': '\uD804[\uDD50-\uDD76]'
    },
    {
        'name': 'Malayalam',
        'bmp': '\u0D00-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D44\u0D46-\u0D48\u0D4A-\u0D4F\u0D54-\u0D63\u0D66-\u0D7F'
    },
    {
        'name': 'Mandaic',
        'bmp': '\u0840-\u085B\u085E'
    },
    {
        'name': 'Manichaean',
        'astral': '\uD802[\uDEC0-\uDEE6\uDEEB-\uDEF6]'
    },
    {
        'name': 'Marchen',
        'astral': '\uD807[\uDC70-\uDC8F\uDC92-\uDCA7\uDCA9-\uDCB6]'
    },
    {
        'name': 'Masaram_Gondi',
        'astral': '\uD807[\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD47\uDD50-\uDD59]'
    },
    {
        'name': 'Meetei_Mayek',
        'bmp': '\uAAE0-\uAAF6\uABC0-\uABED\uABF0-\uABF9'
    },
    {
        'name': 'Mende_Kikakui',
        'astral': '\uD83A[\uDC00-\uDCC4\uDCC7-\uDCD6]'
    },
    {
        'name': 'Meroitic_Cursive',
        'astral': '\uD802[\uDDA0-\uDDB7\uDDBC-\uDDCF\uDDD2-\uDDFF]'
    },
    {
        'name': 'Meroitic_Hieroglyphs',
        'astral': '\uD802[\uDD80-\uDD9F]'
    },
    {
        'name': 'Miao',
        'astral': '\uD81B[\uDF00-\uDF44\uDF50-\uDF7E\uDF8F-\uDF9F]'
    },
    {
        'name': 'Modi',
        'astral': '\uD805[\uDE00-\uDE44\uDE50-\uDE59]'
    },
    {
        'name': 'Mongolian',
        'bmp': '\u1800\u1801\u1804\u1806-\u180E\u1810-\u1819\u1820-\u1877\u1880-\u18AA',
        'astral': '\uD805[\uDE60-\uDE6C]'
    },
    {
        'name': 'Mro',
        'astral': '\uD81A[\uDE40-\uDE5E\uDE60-\uDE69\uDE6E\uDE6F]'
    },
    {
        'name': 'Multani',
        'astral': '\uD804[\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA9]'
    },
    {
        'name': 'Myanmar',
        'bmp': '\u1000-\u109F\uA9E0-\uA9FE\uAA60-\uAA7F'
    },
    {
        'name': 'Nabataean',
        'astral': '\uD802[\uDC80-\uDC9E\uDCA7-\uDCAF]'
    },
    {
        'name': 'New_Tai_Lue',
        'bmp': '\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u19DE\u19DF'
    },
    {
        'name': 'Newa',
        'astral': '\uD805[\uDC00-\uDC59\uDC5B\uDC5D]'
    },
    {
        'name': 'Nko',
        'bmp': '\u07C0-\u07FA'
    },
    {
        'name': 'Nushu',
        'astral': '\uD81B\uDFE1|\uD82C[\uDD70-\uDEFB]'
    },
    {
        'name': 'Ogham',
        'bmp': '\u1680-\u169C'
    },
    {
        'name': 'Ol_Chiki',
        'bmp': '\u1C50-\u1C7F'
    },
    {
        'name': 'Old_Hungarian',
        'astral': '\uD803[\uDC80-\uDCB2\uDCC0-\uDCF2\uDCFA-\uDCFF]'
    },
    {
        'name': 'Old_Italic',
        'astral': '\uD800[\uDF00-\uDF23\uDF2D-\uDF2F]'
    },
    {
        'name': 'Old_North_Arabian',
        'astral': '\uD802[\uDE80-\uDE9F]'
    },
    {
        'name': 'Old_Permic',
        'astral': '\uD800[\uDF50-\uDF7A]'
    },
    {
        'name': 'Old_Persian',
        'astral': '\uD800[\uDFA0-\uDFC3\uDFC8-\uDFD5]'
    },
    {
        'name': 'Old_South_Arabian',
        'astral': '\uD802[\uDE60-\uDE7F]'
    },
    {
        'name': 'Old_Turkic',
        'astral': '\uD803[\uDC00-\uDC48]'
    },
    {
        'name': 'Oriya',
        'bmp': '\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B77'
    },
    {
        'name': 'Osage',
        'astral': '\uD801[\uDCB0-\uDCD3\uDCD8-\uDCFB]'
    },
    {
        'name': 'Osmanya',
        'astral': '\uD801[\uDC80-\uDC9D\uDCA0-\uDCA9]'
    },
    {
        'name': 'Pahawh_Hmong',
        'astral': '\uD81A[\uDF00-\uDF45\uDF50-\uDF59\uDF5B-\uDF61\uDF63-\uDF77\uDF7D-\uDF8F]'
    },
    {
        'name': 'Palmyrene',
        'astral': '\uD802[\uDC60-\uDC7F]'
    },
    {
        'name': 'Pau_Cin_Hau',
        'astral': '\uD806[\uDEC0-\uDEF8]'
    },
    {
        'name': 'Phags_Pa',
        'bmp': '\uA840-\uA877'
    },
    {
        'name': 'Phoenician',
        'astral': '\uD802[\uDD00-\uDD1B\uDD1F]'
    },
    {
        'name': 'Psalter_Pahlavi',
        'astral': '\uD802[\uDF80-\uDF91\uDF99-\uDF9C\uDFA9-\uDFAF]'
    },
    {
        'name': 'Rejang',
        'bmp': '\uA930-\uA953\uA95F'
    },
    {
        'name': 'Runic',
        'bmp': '\u16A0-\u16EA\u16EE-\u16F8'
    },
    {
        'name': 'Samaritan',
        'bmp': '\u0800-\u082D\u0830-\u083E'
    },
    {
        'name': 'Saurashtra',
        'bmp': '\uA880-\uA8C5\uA8CE-\uA8D9'
    },
    {
        'name': 'Sharada',
        'astral': '\uD804[\uDD80-\uDDCD\uDDD0-\uDDDF]'
    },
    {
        'name': 'Shavian',
        'astral': '\uD801[\uDC50-\uDC7F]'
    },
    {
        'name': 'Siddham',
        'astral': '\uD805[\uDD80-\uDDB5\uDDB8-\uDDDD]'
    },
    {
        'name': 'SignWriting',
        'astral': '\uD836[\uDC00-\uDE8B\uDE9B-\uDE9F\uDEA1-\uDEAF]'
    },
    {
        'name': 'Sinhala',
        'bmp': '\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2-\u0DF4',
        'astral': '\uD804[\uDDE1-\uDDF4]'
    },
    {
        'name': 'Sora_Sompeng',
        'astral': '\uD804[\uDCD0-\uDCE8\uDCF0-\uDCF9]'
    },
    {
        'name': 'Soyombo',
        'astral': '\uD806[\uDE50-\uDE83\uDE86-\uDE9C\uDE9E-\uDEA2]'
    },
    {
        'name': 'Sundanese',
        'bmp': '\u1B80-\u1BBF\u1CC0-\u1CC7'
    },
    {
        'name': 'Syloti_Nagri',
        'bmp': '\uA800-\uA82B'
    },
    {
        'name': 'Syriac',
        'bmp': '\u0700-\u070D\u070F-\u074A\u074D-\u074F\u0860-\u086A'
    },
    {
        'name': 'Tagalog',
        'bmp': '\u1700-\u170C\u170E-\u1714'
    },
    {
        'name': 'Tagbanwa',
        'bmp': '\u1760-\u176C\u176E-\u1770\u1772\u1773'
    },
    {
        'name': 'Tai_Le',
        'bmp': '\u1950-\u196D\u1970-\u1974'
    },
    {
        'name': 'Tai_Tham',
        'bmp': '\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA0-\u1AAD'
    },
    {
        'name': 'Tai_Viet',
        'bmp': '\uAA80-\uAAC2\uAADB-\uAADF'
    },
    {
        'name': 'Takri',
        'astral': '\uD805[\uDE80-\uDEB7\uDEC0-\uDEC9]'
    },
    {
        'name': 'Tamil',
        'bmp': '\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BFA'
    },
    {
        'name': 'Tangut',
        'astral': '\uD81B\uDFE0|[\uD81C-\uD820][\uDC00-\uDFFF]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]'
    },
    {
        'name': 'Telugu',
        'bmp': '\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C78-\u0C7F'
    },
    {
        'name': 'Thaana',
        'bmp': '\u0780-\u07B1'
    },
    {
        'name': 'Thai',
        'bmp': '\u0E01-\u0E3A\u0E40-\u0E5B'
    },
    {
        'name': 'Tibetan',
        'bmp': '\u0F00-\u0F47\u0F49-\u0F6C\u0F71-\u0F97\u0F99-\u0FBC\u0FBE-\u0FCC\u0FCE-\u0FD4\u0FD9\u0FDA'
    },
    {
        'name': 'Tifinagh',
        'bmp': '\u2D30-\u2D67\u2D6F\u2D70\u2D7F'
    },
    {
        'name': 'Tirhuta',
        'astral': '\uD805[\uDC80-\uDCC7\uDCD0-\uDCD9]'
    },
    {
        'name': 'Ugaritic',
        'astral': '\uD800[\uDF80-\uDF9D\uDF9F]'
    },
    {
        'name': 'Vai',
        'bmp': '\uA500-\uA62B'
    },
    {
        'name': 'Warang_Citi',
        'astral': '\uD806[\uDCA0-\uDCF2\uDCFF]'
    },
    {
        'name': 'Yi',
        'bmp': '\uA000-\uA48C\uA490-\uA4C6'
    },
    {
        'name': 'Zanabazar_Square',
        'astral': '\uD806[\uDE00-\uDE47]'
    }
];


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build.js